webpackJsonp([3],[
/* 0 */,
/* 1 */,
/* 2 */,
/* 3 */,
/* 4 */,
/* 5 */,
/* 6 */,
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactStyleable = __webpack_require__(6);

var _reactStyleable2 = _interopRequireDefault(_reactStyleable);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _PulseLoader = __webpack_require__(60);

var _PulseLoader2 = _interopRequireDefault(_PulseLoader);

__webpack_require__(26);

var _index = __webpack_require__(1681);

var _index2 = _interopRequireDefault(_index);

var _box = __webpack_require__(1680);

var _box2 = _interopRequireDefault(_box);

var _circleWithIcon = __webpack_require__(1682);

var _circleWithIcon2 = _interopRequireDefault(_circleWithIcon);

var _svgIcon = __webpack_require__(21);

var _svgIcon2 = _interopRequireDefault(_svgIcon);

var _variants = __webpack_require__(9);

var variants = _interopRequireWildcard(_variants);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * The 3p school-roll button.
 *
 * @version 1.0.1
 * @author Voyager
 */
var Button = function Button(_ref) {
    var children = _ref.children,
        _ref$containerClassNa = _ref.containerClassName,
        containerClassName = _ref$containerClassNa === undefined ? '' : _ref$containerClassNa,
        _ref$icon = _ref.icon,
        icon = _ref$icon === undefined ? '' : _ref$icon,
        _ref$iconClassName = _ref.iconClassName,
        iconClassName = _ref$iconClassName === undefined ? '' : _ref$iconClassName,
        _ref$label = _ref.label,
        label = _ref$label === undefined ? '' : _ref$label,
        disabled = _ref.disabled,
        hidden = _ref.hidden,
        loading = _ref.loading,
        loadingLabel = _ref.loadingLabel,
        handleOnClick = _ref.handleOnClick,
        handleOnKeyPress = _ref.handleOnKeyPress,
        _ref$buttonContainer = _ref.buttonContainer,
        buttonContainer = _ref$buttonContainer === undefined ? '' : _ref$buttonContainer,
        _ref$buttonContainerD = _ref.buttonContainerDisabled,
        buttonContainerDisabled = _ref$buttonContainerD === undefined ? '' : _ref$buttonContainerD,
        _ref$variant = _ref.variant,
        variant = _ref$variant === undefined ? '' : _ref$variant;

    var variantType = '';
    switch (variant) {
        case variants.ICON_ONLY:
            {
                variantType = _index2.default[variants.ICON_ONLY];
                iconClassName = _index2.default.iconOnlySvg;
                label = '';
                break;
            }
        case variants.CIRCLE_SUCCESS:
            {
                variantType = _index2.default[variants.CIRCLE_SUCCESS];
                iconClassName = _index2.default.circleIconSvg;
                label = '';
                break;
            }
        case variants.CIRCLE_DANGER:
            {
                variantType = _index2.default[variants.CIRCLE_DANGER];
                iconClassName = _index2.default.circleIconSvg;
                label = '';
                break;
            }
        case variants.DARK:
            {
                variantType = _index2.default[variants.DARK];
                iconClassName = _index2.default.darkIcon;
                break;
            }
        case variants.LIGHT:
            {
                variantType = _index2.default[variants.LIGHT];
                iconClassName = _index2.default.lightIcon;
                break;
            }
        case variants.DENIM:
            {
                variantType = _index2.default[variants.DENIM];
                iconClassName = _index2.default.lightIcon;
                break;
            }
        case variants.BOX_LIGHT:
            {
                variantType = _box2.default.BOX_LIGHT;
                iconClassName = _box2.default.icon;
                buttonContainer = _box2.default.wrapper;
                containerClassName = _box2.default.container;
                break;
            }
        case variants.CIRCLE_ICON:
            {
                iconClassName = _circleWithIcon2.default.icon;
                variantType = _circleWithIcon2.default.circleWithIcon;
                break;
            }
        default:
            {
                variantType = '';
            }
    }

    var iconElement = icon === '' ? null : _react2.default.createElement(
        'div',
        { className: iconClassName },
        _react2.default.createElement(_svgIcon2.default, { icon: icon })
    );

    var textElement = label === '' ? null : _react2.default.createElement(
        'span',
        null,
        label
    );

    var buttonContent = children || textElement;

    var buttonContainerStyle = buttonContainer === '' ? _index2.default.buttonContainer : buttonContainer;

    var buttonContainerDisabledStyle = buttonContainerDisabled === '' ? _index2.default.buttonContainerDisabled : buttonContainerDisabled;

    var buttonStyle = disabled ? _index2.default.buttonContainerDisabled : buttonContainerStyle;

    var componentContainerDisabled = disabled ? '' + _index2.default.componentDisabled : '';

    var buttonElement = loading ? _react2.default.createElement(
        'div',
        { className: buttonContainerDisabledStyle },
        iconElement,
        _react2.default.createElement(
            'span',
            null,
            loadingLabel
        ),
        _react2.default.createElement(_PulseLoader2.default, { size: '5px' })
    ) : _react2.default.createElement(
        'div',
        {
            className: buttonStyle,
            hidden: hidden,
            onClick: handleOnClick,
            onKeyPress: handleOnKeyPress,
            role: 'button',
            tabIndex: 0 },
        iconElement,
        buttonContent
    );

    var cointanerClasses = [containerClassName, variantType, componentContainerDisabled].join(' ');

    var finalView = _react2.default.createElement(
        'div',
        { className: cointanerClasses },
        buttonElement
    );

    if (hidden) {
        finalView = _react2.default.createElement('div', null);
    }

    return finalView;
};

Button.propTypes = {
    label: _propTypes2.default.string,
    children: _propTypes2.default.node,
    containerClassName: _propTypes2.default.string,
    icon: _propTypes2.default.string,
    iconClassName: _propTypes2.default.string,
    loadingLabel: _propTypes2.default.string,
    buttonContainer: _propTypes2.default.string,
    buttonContainerDisabled: _propTypes2.default.string,
    disabled: _propTypes2.default.bool,
    hidden: _propTypes2.default.bool,
    loading: _propTypes2.default.bool,
    handleOnClick: _propTypes2.default.func,
    handleOnKeyPress: _propTypes2.default.func,
    variant: _propTypes2.default.string
};
exports.default = (0, _reactStyleable2.default)(_index2.default)(Button);

/***/ }),
/* 8 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.EmailVerified = exports.EmailValid = exports.EmailSent = exports.EmailInvalid = exports.Unsent = exports.Sent = exports.Warning2 = exports.Guide = exports.Forward = exports.View = exports.Upload = exports.Profile = exports.SolidLeft = exports.SolidRight = exports.PrintSignIn = exports.Empty = exports.StudentManagement = exports.Search = exports.Cross = exports.Edit = exports.Tick = exports.Warning = exports.Plus = exports.Download = undefined;

var _icon_download = __webpack_require__(1777);

var _icon_download2 = _interopRequireDefault(_icon_download);

var _icon_plus = __webpack_require__(1783);

var _icon_plus2 = _interopRequireDefault(_icon_plus);

var _icon_warning = __webpack_require__(1792);

var _icon_warning2 = _interopRequireDefault(_icon_warning);

var _icon_tick = __webpack_require__(1789);

var _icon_tick2 = _interopRequireDefault(_icon_tick);

var _icon_edit = __webpack_require__(1778);

var _icon_edit2 = _interopRequireDefault(_icon_edit);

var _icon_cross = __webpack_require__(1776);

var _icon_cross2 = _interopRequireDefault(_icon_cross);

var _icon_search = __webpack_require__(1787);

var _icon_search2 = _interopRequireDefault(_icon_search);

var _icon_studentManagement = __webpack_require__(1788);

var _icon_studentManagement2 = _interopRequireDefault(_icon_studentManagement);

var _icon_empty = __webpack_require__(1779);

var _icon_empty2 = _interopRequireDefault(_icon_empty);

var _icon_printSignin = __webpack_require__(1784);

var _icon_printSignin2 = _interopRequireDefault(_icon_printSignin);

var _icon_right_solid = __webpack_require__(1786);

var _icon_right_solid2 = _interopRequireDefault(_icon_right_solid);

var _icon_left_solid = __webpack_require__(1782);

var _icon_left_solid2 = _interopRequireDefault(_icon_left_solid);

var _icon_profile = __webpack_require__(1785);

var _icon_profile2 = _interopRequireDefault(_icon_profile);

var _icon_upload = __webpack_require__(1790);

var _icon_upload2 = _interopRequireDefault(_icon_upload);

var _icon_view = __webpack_require__(1791);

var _icon_view2 = _interopRequireDefault(_icon_view);

var _icon_forward = __webpack_require__(1780);

var _icon_forward2 = _interopRequireDefault(_icon_forward);

var _icon_guide = __webpack_require__(1781);

var _icon_guide2 = _interopRequireDefault(_icon_guide);

var _ico_warning = __webpack_require__(1774);

var _ico_warning2 = _interopRequireDefault(_ico_warning);

var _ico_sent = __webpack_require__(1772);

var _ico_sent2 = _interopRequireDefault(_ico_sent);

var _ico_unsent = __webpack_require__(1773);

var _ico_unsent2 = _interopRequireDefault(_ico_unsent);

var _ico_email_invalid = __webpack_require__(1768);

var _ico_email_invalid2 = _interopRequireDefault(_ico_email_invalid);

var _ico_email_sent = __webpack_require__(1769);

var _ico_email_sent2 = _interopRequireDefault(_ico_email_sent);

var _ico_email_valid = __webpack_require__(1770);

var _ico_email_valid2 = _interopRequireDefault(_ico_email_valid);

var _ico_email_verified = __webpack_require__(1771);

var _ico_email_verified2 = _interopRequireDefault(_ico_email_verified);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.Download = _icon_download2.default;
exports.Plus = _icon_plus2.default;
exports.Warning = _icon_warning2.default;
exports.Tick = _icon_tick2.default;
exports.Edit = _icon_edit2.default;
exports.Cross = _icon_cross2.default;
exports.Search = _icon_search2.default;
exports.StudentManagement = _icon_studentManagement2.default;
exports.Empty = _icon_empty2.default;
exports.PrintSignIn = _icon_printSignin2.default;
exports.SolidRight = _icon_right_solid2.default;
exports.SolidLeft = _icon_left_solid2.default;
exports.Profile = _icon_profile2.default;
exports.Upload = _icon_upload2.default;
exports.View = _icon_view2.default;
exports.Forward = _icon_forward2.default;
exports.Guide = _icon_guide2.default;
exports.Warning2 = _ico_warning2.default;
exports.Sent = _ico_sent2.default;
exports.Unsent = _ico_unsent2.default;
exports.EmailInvalid = _ico_email_invalid2.default;
exports.EmailSent = _ico_email_sent2.default;
exports.EmailValid = _ico_email_valid2.default;
exports.EmailVerified = _ico_email_verified2.default;

/***/ }),
/* 9 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var DENIM = exports.DENIM = 'denim';
var DARK = exports.DARK = 'dark';
var LIGHT = exports.LIGHT = 'light';
var CIRCLE_SUCCESS = exports.CIRCLE_SUCCESS = 'circleSuccess';
var CIRCLE_DANGER = exports.CIRCLE_DANGER = 'circleDanger';
var CIRCLE_ICON = exports.CIRCLE_ICON = 'circleWithIcon';
var ICON_ONLY = exports.ICON_ONLY = 'iconOnly';
var BOX_LIGHT = exports.BOX_LIGHT = 'boxLight';

/***/ }),
/* 10 */,
/* 11 */,
/* 12 */,
/* 13 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.moveFlaggedToFront = exports.showDefaultCourseAtTop = exports.getNewCoursesTitle = exports.newCoursesAvailable = exports.displayNewCourses = exports.PARTIAL_ROLLOVER = exports.getJWTToken = exports.validateStudentDeletion = exports.customDefaultCourses = exports.nonEmptyClassroom = exports.refreshLicenseCount = exports.filterClassroomByIds = exports.getAssignedStudentList = exports.filterStudents = exports.assignClassroomFilter = exports.generateClassroomAssignList = exports.getClassroomTeacherMapping = exports.generateStudentTeacherAssignList = undefined;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.getAppConfig = getAppConfig;
exports.handleDefaults = handleDefaults;
exports.getAlphaNumericCharacters = getAlphaNumericCharacters;
exports.getClassroomList = getClassroomList;
exports.invalidCharaters = invalidCharaters;
exports.invalidEmailCharaters = invalidEmailCharaters;
exports.isValidEmail = isValidEmail;
exports.validatePassword = validatePassword;
exports.truncateCharacters = truncateCharacters;
exports.updateYearGroups = updateYearGroups;
exports.updateTeachers = updateTeachers;
exports.updateClassroomList = updateClassroomList;
exports.filterProductCountries = filterProductCountries;
exports.filterProductTeachers = filterProductTeachers;
exports.filterProductCourses = filterProductCourses;
exports.filterYearGroups = filterYearGroups;

var _cloneDeep = __webpack_require__(54);

var _cloneDeep2 = _interopRequireDefault(_cloneDeep);

var _filter = __webpack_require__(137);

var _filter2 = _interopRequireDefault(_filter);

var _forEach = __webpack_require__(333);

var _forEach2 = _interopRequireDefault(_forEach);

var _includes = __webpack_require__(232);

var _includes2 = _interopRequireDefault(_includes);

var _map = __webpack_require__(139);

var _map2 = _interopRequireDefault(_map);

var _startsWith = __webpack_require__(514);

var _startsWith2 = _interopRequireDefault(_startsWith);

var _queryString = __webpack_require__(177);

var _queryString2 = _interopRequireDefault(_queryString);

var _messages = __webpack_require__(381);

var _messages2 = _interopRequireDefault(_messages);

var _gridUtil = __webpack_require__(86);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function getAppConfig() {
    // eslint-disable-next-line no-underscore-dangle
    return window._env_ || window.pppAppConfig || undefined;
}

function handleDefaults(defaultObj, dynamicObj) {
    for (var key in dynamicObj) {
        defaultObj[key] = dynamicObj[key];
    }
    return defaultObj;
}

function getAlphaNumericCharacters() {
    return 'ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789';
}

function getClassroomList(classroomsInfo) {
    var classrooms = classroomsInfo.map(function (item) {
        return { key: item.classroomId, value: item.name };
    });
    return classrooms;
}

function invalidCharaters() {
    return '^[^!@#$%^&+={}/?<>]+$';
}

function invalidEmailCharaters() {
    return '^[^()<>,;:\\/"{}]+$';
}

function isValidEmail(emailAddress) {
    var re = /[A-Z0-9._%+-]+@[A-Z0-9.-]+.[A-Z]{2,4}/igm;
    return re.test(emailAddress);
}

function validatePassword() {
    return '^(?=.*?[0-9])(?=.*?[A-z])[A-z0-9!@#$%&*]+$';
}

function truncateCharacters(type, val) {
    var length = void 0;
    switch (type) {
        case 'teacher':
        case 'studentClassroom':
            length = 20;
            break;

        case 'group':
        case 'teacherClassroom':
        case 'course':
            length = 40;
            break;

        case 'assignTeacherToClassroom':
            length = 65;
            break;

        case 'teacherFirstName':
            length = 10;
            break;

        default:
            length = 20;
    }

    return val.length > length ? val.substring(0, length) + '...' : val;
}

function updateYearGroups(currentOptions, yearGroups) {
    var countryYearGroups = yearGroups.map(function (item) {
        return {
            key: item.yearGroupEnum.toString(),
            value: item.shortName,
            selected: false
        };
    });
    var updatedYearGroups = currentOptions.yearGroups.concat(countryYearGroups);
    return _extends({}, currentOptions, { yearGroups: updatedYearGroups });
}

function updateTeachers(currentOptions, allTeachers) {
    var teachers = [];
    var currentlySelectedItem = currentOptions.teachers.find(function (item) {
        return item.selected === true;
    });
    teachers.push(currentOptions.teachers[0]);
    (0, _forEach2.default)(allTeachers, function (item) {
        var lastName = truncateCharacters('teacher', item.lastName);
        var firstName = truncateCharacters('teacherFirstName', item.firstName);
        var selected = false;
        if (currentlySelectedItem.data !== undefined && currentlySelectedItem.data.userProfileId === item.userProfileId) {
            selected = true;
        }
        teachers.push({ key: item.userProfileId.toString(), value: lastName + ', ' + firstName, selected: selected, data: item });
    });

    return _extends({}, currentOptions, { teachers: teachers });
}

function updateClassroomList(currentOptions, allClassrooms) {
    var classes = [];
    var currentlySelectedItem = currentOptions.classrooms.find(function (item) {
        return item.selected === true;
    });
    classes = currentOptions.classrooms.filter(function (classroom) {
        return classroom.classroomId === undefined;
    });
    (0, _forEach2.default)(allClassrooms, function (item) {
        var selected = false;
        if (currentlySelectedItem !== undefined && currentlySelectedItem.classroomId === item.classroomId) {
            selected = true;
        }
        classes.push({ key: item.name, value: item.name, classroomId: item.classroomId, selected: selected });
    });

    return _extends({}, currentOptions, { classrooms: classes });
}

function filterProductCountries(productCountries) {
    var updatedProductCountries = productCountries.map(function (item) {
        return {
            key: item.code,
            value: item.name,
            selected: false,
            data: item
        };
    });

    return updatedProductCountries;
}

function filterProductTeachers(productTeachers) {
    var clonedTeachers = (0, _gridUtil.sort)(_extends({}, productTeachers), 'lastName', 'asc');
    var updatedProductTeachers = clonedTeachers.map(function (item) {
        return {
            key: item.userProfileId,
            value: item.displayTitle + ' ' + item.firstName + ' ' + item.lastName,
            selected: false,
            data: item
        };
    });

    return updatedProductTeachers;
}

function filterProductCourses(productCourses) {
    var updatedProductTeachers = productCourses.map(function (item) {
        return {
            key: String(item.id),
            value: item.name,
            selected: false,
            data: item
        };
    });

    return updatedProductTeachers;
}

var searchUnassignedClasses = function searchUnassignedClasses(unassignedClassrooms, selectedYearGroup) {
    var filteredClassrooms = (0, _filter2.default)(unassignedClassrooms, function (classroom) {
        if (Number(classroom.yearGroup) === Number(selectedYearGroup) || Number(selectedYearGroup) === -1) {
            return true;
        }
        return false;
    });
    filteredClassrooms = filteredClassrooms.filter(Boolean);
    if (filteredClassrooms.length > 0) {
        return true;
    }
    return false;
};

var generateStudentTeacherAssignList = exports.generateStudentTeacherAssignList = function generateStudentTeacherAssignList(assignedList, unassignedList, selectedYearGroup, type, listObject) {
    var additionalInfo = [];
    var elementId = null;
    var name = null;
    var yearStyle = null;
    var isUnAssignedListEmpty = false;
    var assignData = [];
    var unassignData = [];

    if (type === 'student') {
        isUnAssignedListEmpty = unassignedList.length > 0;
    } else {
        isUnAssignedListEmpty = !!(unassignedList.length > 0 && searchUnassignedClasses(unassignedList, selectedYearGroup));
    }

    if (isUnAssignedListEmpty) {
        var filteredClassroomsByYearGroup = [];
        if (type === 'student') {
            if (Number(selectedYearGroup) === -1) {
                filteredClassroomsByYearGroup = unassignedList;
            } else {
                filteredClassroomsByYearGroup = unassignedList.filter(function (val) {
                    return val.yearGroup === parseInt(selectedYearGroup, 10);
                });
            }
        } else if (Number(selectedYearGroup) === -1) {
            filteredClassroomsByYearGroup = unassignedList;
        } else {
            filteredClassroomsByYearGroup = unassignedList.filter(function (val) {
                return val.yearGroup === Number(selectedYearGroup);
            });
        }

        unassignData = filteredClassroomsByYearGroup.map(function (classroom) {
            yearStyle = 'yg' + classroom.yearGroup.toString();
            elementId = 'class-' + classroom.id + '-assign';
            name = type === 'teacher' ? truncateCharacters('teacherClassroom', classroom.name) : truncateCharacters('studentClassroom', classroom.name);
            if (type === 'student') {
                additionalInfo = classroom.assignedTeachersName;
            }

            return _extends({}, listObject, {
                listItemId: classroom.id,
                elementId: elementId,
                groups: classroom.groups,
                name: name,
                info: {
                    additionalInfo: additionalInfo,
                    badgeContent: classroom.yearGroupName,
                    badgeStyle: yearStyle
                },
                child: {
                    data: classroom.groups,
                    isMultiSelect: true
                },
                isExpandable: type === 'student'
            });
        });
    }

    if (assignedList.length > 0) {
        var clonedAssignedClassrooms = (0, _cloneDeep2.default)(assignedList);
        assignData = clonedAssignedClassrooms.map(function (classroom) {
            yearStyle = 'yg' + classroom.yearGroup.toString();
            elementId = 'class-' + classroom.id + '-unassign';
            name = type === 'teacher' ? truncateCharacters('teacherClassroom', classroom.name) : truncateCharacters('studentClassroom', classroom.name);
            if (type === 'student') {
                additionalInfo = classroom.assignedTeachersName;
            }
            var assignedGroup = classroom.groups.find(function (item) {
                return item.isAssigned;
            });
            if (assignedGroup) {
                classroom.groups = [];
                classroom.groups.push(assignedGroup);
            }

            return _extends({}, listObject, {
                listItemId: classroom.id,
                elementId: elementId,
                groups: classroom.groups,
                name: name,
                info: {
                    additionalInfo: additionalInfo,
                    badgeContent: classroom.yearGroupName,
                    badgeStyle: yearStyle
                },
                child: {
                    data: classroom.groups,
                    isMultiSelect: false
                },
                isExpandable: type === 'student'
            });
        });
    }

    return {
        assignData: assignData, unassignData: unassignData
    };
};

var getClassroomTeacherMapping = exports.getClassroomTeacherMapping = function getClassroomTeacherMapping(teachers, classroomId) {
    var searchQuery = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
    var assignedIds = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : [];
    var existingAssinedTeachers = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : [];
    var loadOnce = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : true;

    var classroomTeacherMapping = [];
    var _iteratorNormalCompletion = true;
    var _didIteratorError = false;
    var _iteratorError = undefined;

    try {
        for (var _iterator = teachers[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
            var teacher = _step.value;

            if (teacher.assignedClassrooms.some(function (val) {
                return val.id === classroomId;
            }) && !loadOnce) {
                existingAssinedTeachers.push(teacher.userProfileId);
            }
            classroomTeacherMapping.push({
                id: teacher.userProfileId,
                name: teacher.displayTitle + ' ' + teacher.firstName + ' ' + teacher.lastName,
                isAssigned: !loadOnce ? teacher.assignedClassrooms.some(function (val) {
                    return val.id === classroomId;
                }) : assignedIds.indexOf(teacher.userProfileId) !== -1
            });
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally {
        try {
            if (!_iteratorNormalCompletion && _iterator.return) {
                _iterator.return();
            }
        } finally {
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }

    if (searchQuery !== '' || assignedIds.length > 0) {
        var unassignedList = classroomTeacherMapping.filter(function (row) {
            return row.name.toLowerCase().indexOf(searchQuery) !== -1 && !row.isAssigned;
        });

        var filteredTeachers = (0, _filter2.default)(classroomTeacherMapping, function (val) {
            if (assignedIds.indexOf(val.id) !== -1) {
                return true;
            }
            return false;
        });

        var assignedList = filteredTeachers.map(function (val) {
            val.isAssigned = true;
            return val;
        });
        classroomTeacherMapping = [].concat(_toConsumableArray(new Set([].concat(_toConsumableArray(assignedList), _toConsumableArray(unassignedList)))));
    }

    return classroomTeacherMapping;
};

var generateClassroomAssignList = exports.generateClassroomAssignList = function generateClassroomAssignList(classroomTeacherMapping, listObject) {
    var assignData = [];
    var unassignData = [];

    var _iteratorNormalCompletion2 = true;
    var _didIteratorError2 = false;
    var _iteratorError2 = undefined;

    try {
        for (var _iterator2 = classroomTeacherMapping[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
            var teacher = _step2.value;

            if (teacher.isAssigned) {
                assignData.push(_extends({}, listObject, {
                    listItemId: teacher.id,
                    elementId: 'teacher-' + teacher.id + '-unassign',
                    name: truncateCharacters('assignTeacherToClassroom', teacher.name)
                }));
            } else {
                unassignData.push(_extends({}, listObject, {
                    listItemId: teacher.id,
                    elementId: 'teacher-' + teacher.id + '-assign',
                    name: truncateCharacters('assignTeacherToClassroom', teacher.name)
                }));
            }
        }
    } catch (err) {
        _didIteratorError2 = true;
        _iteratorError2 = err;
    } finally {
        try {
            if (!_iteratorNormalCompletion2 && _iterator2.return) {
                _iterator2.return();
            }
        } finally {
            if (_didIteratorError2) {
                throw _iteratorError2;
            }
        }
    }

    return {
        assignData: assignData, unassignData: unassignData
    };
};

var assignClassroomFilter = exports.assignClassroomFilter = function assignClassroomFilter() {
    var studentClassrooms = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
    var searchCriteria = arguments[1];

    var unassignedClassrooms = studentClassrooms.filter(function (val) {
        return !val.isAssigned;
    });
    var assignedClassrooms = studentClassrooms.filter(function (val) {
        return val.isAssigned;
    });
    var classrooms = (0, _filter2.default)(unassignedClassrooms, function (classroom) {
        var result = [];
        if (Number(classroom.yearGroup) === Number(searchCriteria.selectedYearGroup) || Number(searchCriteria.selectedYearGroup) === -1) {
            result.push(classroom);
        }
        return result;
    });
    var searchResult = classrooms.concat(assignedClassrooms);

    // handle on search box
    if (searchCriteria.query !== '') {
        unassignedClassrooms = searchResult.filter(function (val) {
            return !val.isAssigned;
        });
        assignedClassrooms = searchResult.filter(function (val) {
            return val.isAssigned;
        });
        var filteredClassrooms = (0, _map2.default)(unassignedClassrooms, function (item) {
            var _ref;

            var foundItem = false;
            var assignedTeachersName = (_ref = []).concat.apply(_ref, _toConsumableArray(item.assignedTeachersName));

            var searchItems = [item.name].concat(_toConsumableArray(assignedTeachersName));
            if (item.groups.length > 0) {
                var _ref2;

                var groups = (0, _map2.default)(item.groups, function (group) {
                    return [group.name, group.courseName];
                });
                searchItems = [item.name].concat(_toConsumableArray(assignedTeachersName), _toConsumableArray((_ref2 = []).concat.apply(_ref2, _toConsumableArray(groups))));
            }

            (0, _map2.default)(searchItems, function (element) {
                if (element.toLowerCase().indexOf(searchCriteria.query) !== -1) {
                    foundItem = true;
                }
                return false;
            });
            if (foundItem) return item;
            return false;
        });
        filteredClassrooms = filteredClassrooms.filter(Boolean);
        searchResult = filteredClassrooms.concat(assignedClassrooms);
    }

    return searchResult;
};

function filterYearGroups(yearGroups) {
    var updatedYearGroups = yearGroups.map(function (item) {
        return {
            key: item.yearGroupEnum.toString(),
            value: item.longName,
            selected: false,
            data: item
        };
    });

    return updatedYearGroups;
}

var filterStudents = exports.filterStudents = function filterStudents(students, filterCriteria, listObject, selectedClassroomId) {
    var unassignStudents = [];
    var filteredData = students || [];
    var name = null;
    var additionalInfo = [];
    var elementId = null;
    var yearStyle = null;
    var yearGroup = parseInt(filterCriteria.yearGroup, 10);
    var classroomId = parseInt(filterCriteria.classroom, 10);
    if (students.length > 0) {
        if (filterCriteria.lastName !== '-1') {
            filteredData = filteredData.filter(function (item) {
                if ((0, _startsWith2.default)(item.lastName.toLowerCase(), filterCriteria.lastName.toLowerCase())) {
                    return true;
                }
                return false;
            });
        }

        if (yearGroup !== -1) {
            filteredData = filteredData.filter(function (item) {
                if (item.yearGroupEnum === yearGroup) {
                    return true;
                }
                return false;
            });
        }

        filteredData = filteredData.filter(function (item) {
            if (item.assignedClassrooms.length === 0 && classroomId === -1) {
                return true;
            }
            var assignedClassIds = item.assignedClassrooms.map(function (classroom) {
                return classroom.classId;
            });
            return (0, _includes2.default)(assignedClassIds, classroomId);
        });
    }

    if (filteredData.length > 0) {
        unassignStudents = filteredData.map(function (student) {
            elementId = 'student-' + student.userProfileId + '-unassign';
            name = truncateCharacters('teacherClassroom', student.firstName + ' ' + student.lastName);
            yearStyle = 'yg' + student.yearGroupEnum.toString();
            var assignedClassIds = student.assignedClassrooms.map(function (classroom) {
                return classroom.classId;
            });

            return _extends({}, listObject, {
                listItemId: student.userProfileId,
                elementId: elementId,
                name: name,
                info: {
                    additionalInfo: additionalInfo,
                    badgeContent: student.yearGroup,
                    badgeStyle: yearStyle
                },
                disabled: (0, _includes2.default)(assignedClassIds, selectedClassroomId)
            });
        });
    }

    return unassignStudents;
};

var getAssignedStudentList = exports.getAssignedStudentList = function getAssignedStudentList(students, listObject) {
    var assignStudents = [];
    var additionalInfo = [];
    var elementId = null;
    var yearStyle = null;
    var name = '';

    if (students.length > 0) {
        assignStudents = students.map(function (student) {
            elementId = 'student-' + student.userProfileId + '-assign';
            name = truncateCharacters('teacherClassroom', student.firstName + ' ' + student.lastName);
            yearStyle = 'yg' + student.yearGroupEnum.toString();

            return _extends({}, listObject, {
                listItemId: student.userProfileId,
                elementId: elementId,
                name: name,
                info: {
                    additionalInfo: additionalInfo,
                    badgeContent: student.yearGroup,
                    badgeStyle: yearStyle,
                    selected: student.selected
                }
            });
        });
    }
    return assignStudents;
};

var filterClassroomByIds = exports.filterClassroomByIds = function filterClassroomByIds(classrooms, classroomIds) {
    var filterdClassooms = classrooms.filter(function (classroom) {
        if (classroomIds.includes(classroom.classroomId)) {
            return true;
        }

        return false;
    });
    return filterdClassooms;
};

var refreshLicenseCount = exports.refreshLicenseCount = function refreshLicenseCount(students, unassignedStudentIds) {
    var unassignedStudents = (0, _filter2.default)(students, function (val) {
        if (unassignedStudentIds.indexOf(val.userProfileId) !== -1) {
            return true;
        }
        return false;
    });

    var _iteratorNormalCompletion3 = true;
    var _didIteratorError3 = false;
    var _iteratorError3 = undefined;

    try {
        for (var _iterator3 = unassignedStudents[Symbol.iterator](), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
            var student = _step3.value;

            if (student.assignedClassrooms.length === 1) {
                return true;
            }
        }
    } catch (err) {
        _didIteratorError3 = true;
        _iteratorError3 = err;
    } finally {
        try {
            if (!_iteratorNormalCompletion3 && _iterator3.return) {
                _iterator3.return();
            }
        } finally {
            if (_didIteratorError3) {
                throw _iteratorError3;
            }
        }
    }

    return false;
};

var nonEmptyClassroom = exports.nonEmptyClassroom = function nonEmptyClassroom(classroom) {
    return classroom.studentsCount > 0;
};

var customDefaultCourses = exports.customDefaultCourses = function customDefaultCourses(courses) {
    if (courses) {
        return courses.map(function (item) {
            return {
                courseId: item.courseId,
                courseName: item.courseName,
                yearGroupId: item.yearGroupEnum,
                yearGroupName: item.yearGroupShortName,
                newCourseId: 0,
                newCourseName: '',
                isSelected: false
            };
        });
    }
    return {};
};

var validateStudentDeletion = exports.validateStudentDeletion = function validateStudentDeletion(payload) {
    var noOfStudents = payload.length;
    var result = {
        isPartialDelete: false,
        noOfStudentsDeleted: 0
    };

    // number of students deleted without any error
    var deletedStudents = payload.filter(function (val) {
        return !val.hasError;
    }).length;

    if (deletedStudents > 0) {
        // check if some of the students were deleted
        result.isPartialDelete = noOfStudents !== deletedStudents;

        result.noOfStudentsDeleted = noOfStudents - deletedStudents === 0 ? deletedStudents : noOfStudents - deletedStudents;
    }
    return result;
};

var getJWTToken = exports.getJWTToken = function getJWTToken() {
    var _queryString$parse = _queryString2.default.parse(location.search),
        jwt = _queryString$parse.jwt;

    return jwt === undefined ? '' : 'Bearer ' + jwt;
};

var PARTIAL_ROLLOVER = exports.PARTIAL_ROLLOVER = 'PartialRollover';

var displayNewCourses = exports.displayNewCourses = function displayNewCourses() {
    var config = getAppConfig();

    if (!config) return false;

    var queryParams = _queryString2.default.parse(location.search);
    var countryCode = queryParams.countryCode || '';
    var newCoursesVisibilityCriteria = {};
    if (config.newCoursesVisibilityCriteria) {
        newCoursesVisibilityCriteria = config.newCoursesVisibilityCriteria;
    }

    var countryCodes = newCoursesVisibilityCriteria.countryCodes || [];
    return countryCodes.includes(countryCode);
};

var getUserCountryCode = function getUserCountryCode() {
    var _queryString$parse2 = _queryString2.default.parse(location.search),
        countryCode = _queryString$parse2.countryCode;

    return countryCode ? countryCode.toUpperCase() : '';
};

/**
 * Determines if the 'New Courses' courses are available for the selected Year (Grade) and Country
 * Part of COY-9034 to limit to Australian schools years 3-6 at the time of initial release.
 * @returns {boolean}
 */
var newCoursesAvailable = exports.newCoursesAvailable = function newCoursesAvailable() {
    var yearGroup = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
    var countryId = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';

    var config = getAppConfig();
    var userCountryCode = countryId || getUserCountryCode();

    if (!config || Object.keys(config).length === 0 || !config.newCoursesAvailability) return false;

    var _ref3 = config.newCoursesAvailability[userCountryCode] || {},
        _ref3$yearGroups = _ref3.yearGroups,
        yearGroups = _ref3$yearGroups === undefined ? [] : _ref3$yearGroups;

    return yearGroups.includes(parseInt(yearGroup, 10));
};

var getNewCoursesTitle = exports.getNewCoursesTitle = function getNewCoursesTitle(yearGroup, isNewCourseAssigned, conquestCourseTitle, intl) {
    if (isNewCourseAssigned) return conquestCourseTitle;

    var config = getAppConfig();
    var userCountryCode = getUserCountryCode();
    var availabilityMap = config && config.newCoursesAvailabilityForStudents;
    var availability = availabilityMap && availabilityMap[userCountryCode];
    var isAvailable = availability && Array.isArray(availability.yearGroups) && availability.yearGroups.includes(parseInt(yearGroup, 10));

    return intl.formatMessage(isAvailable ? _messages2.default.noCourseAssigned : _messages2.default.noCoursesFound);
};

var showDefaultCourseAtTop = exports.showDefaultCourseAtTop = function showDefaultCourseAtTop(courseList, useAdminSelection) {
    if (courseList.length > 0) {
        var defaultCourse = [{
            id: 0,
            key: 0,
            name: useAdminSelection
        }].concat(_toConsumableArray(courseList));

        var defaultCourseIndex = defaultCourse.findIndex(function (course) {
            return course.isDefault;
        });

        if (defaultCourseIndex !== -1) {
            var defaultCourseAtTop = defaultCourse.splice(defaultCourseIndex, 1);
            defaultCourse.splice(1, 0, defaultCourseAtTop[0]);
        }

        return defaultCourse;
    }

    return courseList;
};

var moveFlaggedToFront = exports.moveFlaggedToFront = function moveFlaggedToFront(arr, prop) {
    var index = arr.findIndex(function (item) {
        return item && (typeof item === 'undefined' ? 'undefined' : _typeof(item)) === 'object' && item[prop] === true;
    });

    if (index > 0) {
        var flaggedItem = arr.splice(index, 1)[0];
        arr.unshift(flaggedItem);
    }

    return arr;
};

/***/ }),
/* 14 */,
/* 15 */,
/* 16 */,
/* 17 */,
/* 18 */,
/* 19 */,
/* 20 */,
/* 21 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactStyleable = __webpack_require__(6);

var _reactStyleable2 = _interopRequireDefault(_reactStyleable);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactInlinesvg = __webpack_require__(1590);

var _reactInlinesvg2 = _interopRequireDefault(_reactInlinesvg);

__webpack_require__(26);

var _svgIcon = __webpack_require__(1742);

var _svgIcon2 = _interopRequireDefault(_svgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SvgIcon = function SvgIcon(_ref) {
    var _ref$icon = _ref.icon,
        icon = _ref$icon === undefined ? '' : _ref$icon;

    var svg = icon ? _react2.default.createElement(_reactInlinesvg2.default, { src: icon }) : '';
    return _react2.default.createElement(
        'div',
        { className: _svgIcon2.default.svgIconComponent },
        svg
    );
};

SvgIcon.propTypes = {
    icon: _propTypes2.default.string
};

exports.default = (0, _reactStyleable2.default)(_svgIcon2.default)(SvgIcon);

/***/ }),
/* 22 */,
/* 23 */,
/* 24 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _index = __webpack_require__(1718);

var _index2 = _interopRequireDefault(_index);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Modal = function Modal(props) {
    var backdropClass = _index2.default.modalBackdrop;
    var modalClass = _index2.default.modal;

    if (props.smallMode) {
        backdropClass = _index2.default.modalBackdropSmall;
        modalClass = _index2.default.modalSmall;
    }

    var modalElement = props.show ? _react2.default.createElement(
        'div',
        { className: backdropClass },
        _react2.default.createElement(
            'div',
            { className: modalClass },
            props.children
        )
    ) : null;

    return modalElement;
};

Modal.propTypes = {
    show: _propTypes2.default.bool,
    smallMode: _propTypes2.default.bool,
    children: _propTypes2.default.node
};

exports.default = Modal;

/***/ }),
/* 25 */,
/* 26 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1220);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(5)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../node_modules/css-loader/index.js?modules=false!../../node_modules/postcss-loader/lib/index.js!../../node_modules/sass-loader/index.js!./core.scss", function() {
			var newContent = require("!!../../node_modules/css-loader/index.js?modules=false!../../node_modules/postcss-loader/lib/index.js!../../node_modules/sass-loader/index.js!./core.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 27 */,
/* 28 */,
/* 29 */,
/* 30 */,
/* 31 */,
/* 32 */,
/* 33 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.getConquestFilteredCourses = exports.getFilteredCourses = exports.sendVerificationEmails = exports.sendVerificationEmail = exports.sendTeacherPassword = exports.getTeacherAuthToken = exports.assignCourses = exports.checkCommonTasks = exports.saveSchoolDefaultCourses = exports.getCourse = exports.downloadCertificates = exports.getCertificatesSummary = exports.getAcademicYear = exports.getDefaultCourses = exports.extendResults = exports.extendingResultsStatus = exports.performRollover = exports.downloadSchoolRollData = exports.verifyRollover = exports.changeCourseCarryOver = exports.deleteClassrooms = exports.moveStudents = exports.getClassroomGroups = exports.addGroup = exports.getStudentsByClassroomId = exports.changeClassroomCourse = exports.deleteClassroomGroup = exports.classroomUserRelation = exports.updateClass = exports.getClassroomById = exports.updateClassroomGroup = exports.addClass = exports.postClassesPriorDownload = exports.getSchoolCourses = exports.getProductCourses = exports.getConquestCourseCountries = exports.getUpfCourseCountries = exports.getCourseCountries = exports.deleteTeachers = exports.deleteStudents = exports.assignTeacherClassrooms = exports.assignStudentClassrooms = exports.getTeacherClassroomsRelation = exports.getStudentClassroomsRelation = exports.downloadClassroomsStudentsSignInCards = exports.downloadClassroomStudentsSignInCards = exports.editTeacher = exports.editStudent = exports.getTeacherByUserProfileId = exports.addTeacher = exports.downloadTeachersSignInCards = exports.unAssignTeachers = exports.postTeachersPriorDownload = exports.getTeachersByProduct = exports.getStudentByUserProfileId = exports.addStudent = exports.downloadStudentsSignInCards = exports.bulkPasswordChangeTeachers = exports.bulkPasswordChangeStudents = exports.unAssignStudents = exports.getClassrooms = exports.quickUpload = exports.downloadTemplateFile = exports.postStudentsPriorDownload = exports.getCountryYearGroups = exports.getYearGroups = exports.getStudentsByProduct = exports.getLicenceSummaryByProduct = undefined;

var _resources = __webpack_require__(270);

var _resources2 = _interopRequireDefault(_resources);

var _i18n = __webpack_require__(129);

var _utils = __webpack_require__(13);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var getLicenceSummaryByProduct = exports.getLicenceSummaryByProduct = function getLicenceSummaryByProduct(productId) {
    return _resources2.default.productLicenses.get().headers({ Locale: (0, _i18n.getLocale)() }).withParams({ productId: productId }).send();
};

var getStudentsByProduct = exports.getStudentsByProduct = function getStudentsByProduct(productId) {
    return _resources2.default.students.get().headers({ Locale: (0, _i18n.getLocale)() }).withParams({ productId: productId }).send();
};

var getYearGroups = exports.getYearGroups = function getYearGroups() {
    return _resources2.default.yearGroups.get().headers({ Locale: (0, _i18n.getLocale)() }).send();
};

var getCountryYearGroups = exports.getCountryYearGroups = function getCountryYearGroups(_ref) {
    var countryCode = _ref.countryCode;
    return _resources2.default.countryYearGroups.get().headers({ Locale: (0, _i18n.getLocale)() }).withParams({ countryCode: countryCode }).send();
};

var postStudentsPriorDownload = exports.postStudentsPriorDownload = function postStudentsPriorDownload(_ref2) {
    var students = _ref2.students;
    return _resources2.default.studentsCsv.post().headers({ Locale: (0, _i18n.getLocale)() }).withBody(students).send();
};

var downloadTemplateFile = exports.downloadTemplateFile = function downloadTemplateFile(templateType) {
    return _resources2.default.downloadTemplateFile.get(templateType).headers({ Locale: (0, _i18n.getLocale)() }).send();
};

var quickUpload = exports.quickUpload = function quickUpload(_ref3) {
    var productId = _ref3.productId,
        fileContent = _ref3.fileContent;
    return _resources2.default.quickUpload.post({ productId: productId }).headers({ Locale: (0, _i18n.getLocale)() }).withBody(fileContent).send();
};

var getClassrooms = exports.getClassrooms = function getClassrooms(productId) {
    return _resources2.default.classrooms.get({ productId: productId }).headers({ Locale: (0, _i18n.getLocale)() }).send();
};

var unAssignStudents = exports.unAssignStudents = function unAssignStudents(userRelationship) {
    return _resources2.default.unassignStudents.put().headers({ Locale: (0, _i18n.getLocale)() }).withBody(userRelationship).send();
};

var bulkPasswordChangeStudents = exports.bulkPasswordChangeStudents = function bulkPasswordChangeStudents(bulkPasswordChange) {
    return _resources2.default.bulkPasswordChangeStudents.put().headers({ Locale: (0, _i18n.getLocale)() }).withBody(bulkPasswordChange).send();
};

var bulkPasswordChangeTeachers = exports.bulkPasswordChangeTeachers = function bulkPasswordChangeTeachers(bulkPasswordChange) {
    return _resources2.default.bulkPasswordChangeTeachers.put().headers({ Locale: (0, _i18n.getLocale)() }).withBody(bulkPasswordChange).send();
};

var downloadStudentsSignInCards = exports.downloadStudentsSignInCards = function downloadStudentsSignInCards(productId, studentSignInCardsData) {
    return _resources2.default.classStudentsSignInCards.post({ productId: productId }).headers({ Locale: (0, _i18n.getLocale)() }).withBody(studentSignInCardsData).send();
};

var addStudent = exports.addStudent = function addStudent(student) {
    return _resources2.default.students.post().headers({ Locale: (0, _i18n.getLocale)() }).withBody(student).send();
};

var getStudentByUserProfileId = exports.getStudentByUserProfileId = function getStudentByUserProfileId(productId, userProfileId) {
    return _resources2.default.getStudents.get({ userProfileId: userProfileId }).headers({ Locale: (0, _i18n.getLocale)() }).withParams({ productId: productId }).send();
};

var getTeachersByProduct = exports.getTeachersByProduct = function getTeachersByProduct(productId) {
    return _resources2.default.teachers.get().headers({ Locale: (0, _i18n.getLocale)() }).withParams({ productId: productId }).send();
};

var postTeachersPriorDownload = exports.postTeachersPriorDownload = function postTeachersPriorDownload(_ref4) {
    var teachers = _ref4.teachers;
    return _resources2.default.teachersCsv.post().headers({ Locale: (0, _i18n.getLocale)() }).withBody(teachers).send();
};

var unAssignTeachers = exports.unAssignTeachers = function unAssignTeachers(userRelationship) {
    return _resources2.default.unassignTeachers.put().headers({ Locale: (0, _i18n.getLocale)() }).withBody(userRelationship).send();
};

var downloadTeachersSignInCards = exports.downloadTeachersSignInCards = function downloadTeachersSignInCards(productId, teacherSignInCardsData) {
    return _resources2.default.teachersSignInCards.post({ productId: productId }).headers({ Locale: (0, _i18n.getLocale)() }).withBody(teacherSignInCardsData).send();
};

var addTeacher = exports.addTeacher = function addTeacher(_ref5) {
    var teacher = _ref5.teacher;
    return _resources2.default.addTeacher.post().headers({ Locale: (0, _i18n.getLocale)() }).withBody(teacher).send();
};

var getTeacherByUserProfileId = exports.getTeacherByUserProfileId = function getTeacherByUserProfileId(productId, userProfileId) {
    return _resources2.default.getTeachers.get({ userProfileId: userProfileId }).headers({ Locale: (0, _i18n.getLocale)() }).withParams({ productId: productId }).send();
};
var editStudent = exports.editStudent = function editStudent(student) {
    return _resources2.default.students.put().headers({ Locale: (0, _i18n.getLocale)() }).withBody(student).send();
};

var editTeacher = exports.editTeacher = function editTeacher(teacher) {
    return _resources2.default.teachers.put().headers({ Locale: (0, _i18n.getLocale)() }).withBody(teacher).send();
};

var downloadClassroomStudentsSignInCards = exports.downloadClassroomStudentsSignInCards = function downloadClassroomStudentsSignInCards(_ref6) {
    var productId = _ref6.productId,
        classroomId = _ref6.classroomId,
        SignInCardPageSizeType = _ref6.SignInCardPageSizeType;
    return _resources2.default.classStudentsSignInCards.post({ productId: productId }).headers({ Locale: (0, _i18n.getLocale)() }).withBody({ classroomId: classroomId, SignInCardPageSizeType: SignInCardPageSizeType }).send();
};

var downloadClassroomsStudentsSignInCards = exports.downloadClassroomsStudentsSignInCards = function downloadClassroomsStudentsSignInCards(_ref7) {
    var productId = _ref7.productId,
        studentSignInCardsData = _ref7.studentSignInCardsData;
    return _resources2.default.classroomsStudentsSignInCards.post({ productId: productId }).headers({ Locale: (0, _i18n.getLocale)() }).withBody(studentSignInCardsData).send();
};

var getStudentClassroomsRelation = exports.getStudentClassroomsRelation = function getStudentClassroomsRelation(userProfileId, productId) {
    return _resources2.default.studentClassroomsRelation.get({ userProfileId: userProfileId, productId: productId }).headers({ Locale: (0, _i18n.getLocale)() }).send();
};

var getTeacherClassroomsRelation = exports.getTeacherClassroomsRelation = function getTeacherClassroomsRelation(userProfileId, productId) {
    return _resources2.default.teacherClassroomsRelation.get({ userProfileId: userProfileId, productId: productId }).headers({ Locale: (0, _i18n.getLocale)() }).send();
};

var assignStudentClassrooms = exports.assignStudentClassrooms = function assignStudentClassrooms(assignedClassrooms, userProfileId, productId) {
    return _resources2.default.studentClassroomsRelation.put({ userProfileId: userProfileId, productId: productId }).headers({ Locale: (0, _i18n.getLocale)() }).withBody(assignedClassrooms).send();
};

var assignTeacherClassrooms = exports.assignTeacherClassrooms = function assignTeacherClassrooms(assignedClassrooms, userProfileId, productId) {
    return _resources2.default.teacherClassroomsRelation.put({ userProfileId: userProfileId, productId: productId }).headers({ Locale: (0, _i18n.getLocale)() }).withBody(assignedClassrooms).send();
};

var deleteStudents = exports.deleteStudents = function deleteStudents(userProfileIds) {
    return _resources2.default.deleteStudents.delete().headers({ Locale: (0, _i18n.getLocale)() }).withBody(userProfileIds).send();
};

var deleteTeachers = exports.deleteTeachers = function deleteTeachers(userProfileIds) {
    return _resources2.default.deleteTeachers.delete().headers({ Locale: (0, _i18n.getLocale)() }).withBody(userProfileIds).send();
};

var getCourseCountries = exports.getCourseCountries = function getCourseCountries(productId) {
    return _resources2.default.getCourseCountries.get({ productId: productId }).headers({ Locale: (0, _i18n.getLocale)() }).withBody(productId).send();
};

var getUpfCourseCountries = exports.getUpfCourseCountries = function getUpfCourseCountries(productId, countryCourseType) {
    return _resources2.default.getCourseCountries.get({ productId: productId, countryCourseType: countryCourseType }).headers({ Locale: (0, _i18n.getLocale)() }).withBody(productId).send();
};

var getConquestCourseCountries = exports.getConquestCourseCountries = function getConquestCourseCountries(productId, countryCourseType) {
    return _resources2.default.getCourseCountries.get({ productId: productId, countryCourseType: countryCourseType }).headers({ Locale: (0, _i18n.getLocale)() }).withBody(productId).send();
};

var getProductCourses = exports.getProductCourses = function getProductCourses(countryCode, productId, yearGroup) {
    return _resources2.default.getProductCourses.get({ countryCode: countryCode, productId: productId, yearGroup: yearGroup }).headers({ Locale: (0, _i18n.getLocale)() }).withBody(countryCode, productId, yearGroup).send();
};

var getSchoolCourses = exports.getSchoolCourses = function getSchoolCourses(yearGroup) {
    return _resources2.default.getSchoolCourses.get({ yearGroup: yearGroup }).headers({ Locale: (0, _i18n.getLocale)() }).withBody(yearGroup).send();
};

var postClassesPriorDownload = exports.postClassesPriorDownload = function postClassesPriorDownload(classInfo) {
    return _resources2.default.classesCsv.post().headers({ Locale: (0, _i18n.getLocale)() }).withBody(classInfo).send();
};

var addClass = exports.addClass = function addClass(_ref8) {
    var name = _ref8.name,
        productId = _ref8.productId,
        courseId = _ref8.courseId,
        teacherProfileIds = _ref8.teacherProfileIds,
        yearGroupEnum = _ref8.yearGroupEnum,
        upfCourseId = _ref8.upfCourseId,
        conquestCourseId = _ref8.conquestCourseId,
        useUpfSchoolDefault = _ref8.useUpfSchoolDefault;
    return _resources2.default.addClass.post().headers({ Locale: (0, _i18n.getLocale)() }).withBody({ name: name, productId: productId, courseId: courseId, teacherProfileIds: teacherProfileIds, yearGroupEnum: yearGroupEnum, upfCourseId: upfCourseId, conquestCourseId: conquestCourseId, useUpfSchoolDefault: useUpfSchoolDefault }).send();
};

var updateClassroomGroup = exports.updateClassroomGroup = function updateClassroomGroup(newGroupName, classroomId, groupId) {
    return _resources2.default.updateClassroomGroup.put({ classroomId: classroomId, groupId: groupId }).headers({ Locale: (0, _i18n.getLocale)() }).withBody({ newGroupName: newGroupName }).send();
};

var getClassroomById = exports.getClassroomById = function getClassroomById(classroomId) {
    return _resources2.default.getClassById.get({ classroomId: classroomId }).headers({ Locale: (0, _i18n.getLocale)() }).withParams().send();
};

var updateClass = exports.updateClass = function updateClass(_ref9) {
    var classroomId = _ref9.classroomId,
        newClassroomName = _ref9.newClassroomName,
        newYearGroup = _ref9.newYearGroup;
    return _resources2.default.updateClass.put({ classroomId: classroomId }).headers({ Locale: (0, _i18n.getLocale)() }).withBody({ newClassroomName: newClassroomName, newYearGroup: newYearGroup }).send();
};

var classroomUserRelation = exports.classroomUserRelation = function classroomUserRelation(teacherClassroomMapping) {
    return _resources2.default.classroomUserRelation.put().headers({ Locale: (0, _i18n.getLocale)() }).withBody(teacherClassroomMapping).send();
};

var deleteClassroomGroup = exports.deleteClassroomGroup = function deleteClassroomGroup(classroomId, groupId) {
    return _resources2.default.deleteClassroomGroup.delete({ classroomId: classroomId, groupId: groupId }).headers({ Locale: (0, _i18n.getLocale)() }).send();
};

var changeClassroomCourse = exports.changeClassroomCourse = function changeClassroomCourse(classroomId, groupId, newCourseId, newUpfCourseId, newConquestCourseId) {
    var useUpfSchoolDefault = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : false;
    return _resources2.default.changeClassroomCourse.put({ classroomId: classroomId, groupId: groupId }).headers({ Locale: (0, _i18n.getLocale)() }).withBody({}).withParams({ newCourseId: newCourseId, newUpfCourseId: newUpfCourseId, newConquestCourseId: newConquestCourseId, useUpfSchoolDefault: useUpfSchoolDefault }).send();
};

var getStudentsByClassroomId = exports.getStudentsByClassroomId = function getStudentsByClassroomId(classroomId) {
    return _resources2.default.getStudentsByClassroomId.get({ classroomId: classroomId }).headers({ Locale: (0, _i18n.getLocale)() }).send();
};

var addGroup = exports.addGroup = function addGroup(classroomId, name) {
    return _resources2.default.addGroup.post({ classroomId: classroomId }).headers({ Locale: (0, _i18n.getLocale)() }).withBody({}).withParams({ name: name }).send();
};

var getClassroomGroups = exports.getClassroomGroups = function getClassroomGroups(classroomId) {
    return _resources2.default.getClassroomGroups.get({ classroomId: classroomId }).headers({ Locale: (0, _i18n.getLocale)() }).withBody({}).send();
};

var moveStudents = exports.moveStudents = function moveStudents(moveStudentsCommand, classroomId) {
    return _resources2.default.moveStudents.put({ classroomId: classroomId }).headers({ Locale: (0, _i18n.getLocale)() }).withBody(moveStudentsCommand).send();
};

var deleteClassrooms = exports.deleteClassrooms = function deleteClassrooms(classroomIds) {
    return _resources2.default.deleteClassrooms.delete().headers({ Locale: (0, _i18n.getLocale)() }).withBody(classroomIds).send();
};

var changeCourseCarryOver = exports.changeCourseCarryOver = function changeCourseCarryOver(classroomId, groupId, newCourseId, newUpfCourseId, taskActionType, courses, newConquestCourseId) {
    return _resources2.default.changeCourseCarryOver.put({ classroomId: classroomId, groupId: groupId }).headers({ Locale: (0, _i18n.getLocale)() }).withBody(courses).withParams({ newCourseId: newCourseId, newUpfCourseId: newUpfCourseId, taskActionType: taskActionType, newConquestCourseId: newConquestCourseId }).raw().send();
};

var verifyRollover = exports.verifyRollover = function verifyRollover(productId, content) {
    return _resources2.default.verifyRollOver.post({ productId: productId }).headers({ Locale: (0, _i18n.getLocale)() }).withBody(content).send();
};

var downloadSchoolRollData = exports.downloadSchoolRollData = function downloadSchoolRollData(productId, includeUnassignedStudents, includeBulkTransfer) {
    return _resources2.default.downloadSchoolRollData.get({ productId: productId }).headers({ Locale: (0, _i18n.getLocale)() }).withParams({ includeUnassignedStudents: includeUnassignedStudents, includeBulkTransfer: includeBulkTransfer }).send();
};

var performRollover = exports.performRollover = function performRollover(productId, schoolRollover) {
    return _resources2.default.performRollover.post({ productId: productId }).headers({ Locale: (0, _i18n.getLocale)() }).withBody(schoolRollover).send();
};

var extendingResultsStatus = exports.extendingResultsStatus = function extendingResultsStatus(productId) {
    return _resources2.default.extendingResultsStatus.get(productId).headers({ Locale: (0, _i18n.getLocale)() }).withBody().send();
};

var extendResults = exports.extendResults = function extendResults(productId, yeargroups) {
    return _resources2.default.extendResults.post({ productId: productId }).headers({ Locale: (0, _i18n.getLocale)() }).withBody(yeargroups).send();
};

var getDefaultCourses = exports.getDefaultCourses = function getDefaultCourses(productId) {
    return _resources2.default.getDefaultCourses.get(productId).headers({ Locale: (0, _i18n.getLocale)() }).send();
};

var getAcademicYear = exports.getAcademicYear = function getAcademicYear() {
    return _resources2.default.getAcademicYear.get().headers({ Locale: (0, _i18n.getLocale)() }).send();
};

var getCertificatesSummary = exports.getCertificatesSummary = function getCertificatesSummary(request) {
    return _resources2.default.getCertificatesSummary.get().headers({ Locale: (0, _i18n.getLocale)() }).withBody(request).send();
};

var downloadCertificates = exports.downloadCertificates = function downloadCertificates(request) {
    return _resources2.default.downloadCertificates.post().headers({ Locale: (0, _i18n.getLocale)() }).withBody(request).send();
};

var getCourse = exports.getCourse = function getCourse(courseId) {
    return _resources2.default.getCourse.get(courseId).headers({ Locale: (0, _i18n.getLocale)() }).send();
};

var saveSchoolDefaultCourses = exports.saveSchoolDefaultCourses = function saveSchoolDefaultCourses(productId, yearGroupCourses) {
    return _resources2.default.saveSchoolDefaultCourses.post({ productId: productId }).headers({ Locale: (0, _i18n.getLocale)() }).withBody(yearGroupCourses).raw().send();
};

var checkCommonTasks = exports.checkCommonTasks = function checkCommonTasks(_ref10) {
    var classroomId = _ref10.classroomId,
        groupId = _ref10.groupId,
        courseId = _ref10.courseId;
    return _resources2.default.checkCommonTasks.get({ classroomId: classroomId, groupId: groupId }).headers({ Locale: (0, _i18n.getLocale)() }).withParams({ courseId: courseId }).send();
};

var assignCourses = exports.assignCourses = function assignCourses(changeCourseRequests) {
    return _resources2.default.assignCourses.put().headers({ Locale: (0, _i18n.getLocale)() }).withBody(changeCourseRequests).raw().send();
};

var getTeacherAuthToken = exports.getTeacherAuthToken = function getTeacherAuthToken(userProfileType, userProfileId) {
    return _resources2.default.getTeacherAuthToken.get({ userProfileType: userProfileType, userProfileId: userProfileId }).headers({
        Locale: (0, _i18n.getLocale)(),
        Authorization: (0, _utils.getJWTToken)()
    }).send();
};

var sendTeacherPassword = exports.sendTeacherPassword = function sendTeacherPassword(request) {
    return _resources2.default.sendTeacherPassword.post().headers({ Locale: (0, _i18n.getLocale)() }).withBody(request).send();
};

var sendVerificationEmail = exports.sendVerificationEmail = function sendVerificationEmail(request) {
    return _resources2.default.sendVerificationEmail.post().headers({ Locale: (0, _i18n.getLocale)() }).withBody(request).send();
};

var sendVerificationEmails = exports.sendVerificationEmails = function sendVerificationEmails(request) {
    return _resources2.default.sendVerificationEmails.post().headers({ Locale: (0, _i18n.getLocale)() }).withBody(request).send();
};

var getFilteredCourses = exports.getFilteredCourses = function getFilteredCourses(countryCode, productId, yearGroup, selectGenericCourses, includeGlobalCourses) {
    return _resources2.default.getFilteredCourses.post().headers({ Locale: (0, _i18n.getLocale)() }).withBody(countryCode, productId, yearGroup, selectGenericCourses, includeGlobalCourses).send();
};

var getConquestFilteredCourses = exports.getConquestFilteredCourses = function getConquestFilteredCourses(_ref11) {
    var productId = _ref11.productId,
        countryCode = _ref11.countryCode,
        yearGroup = _ref11.yearGroup;
    return _resources2.default.getConquestFilteredCourses.get().headers({ Locale: (0, _i18n.getLocale)() }).withParams({ productId: productId, countryCode: countryCode, yearGroup: yearGroup }).send();
};

/***/ }),
/* 34 */,
/* 35 */,
/* 36 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactIntl = __webpack_require__(2);

var _index = __webpack_require__(1695);

var _index2 = _interopRequireDefault(_index);

var _svgIcon = __webpack_require__(21);

var _svgIcon2 = _interopRequireDefault(_svgIcon);

var _messages = __webpack_require__(680);

var _messages2 = _interopRequireDefault(_messages);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ConfirmationMessage = function ConfirmationMessage(props) {
    return _react2.default.createElement(
        'div',
        { className: _index2.default.confirmationMessageContainer },
        _react2.default.createElement(
            'div',
            { className: _index2.default.icon },
            _react2.default.createElement(_svgIcon2.default, { icon: props.icon })
        ),
        _react2.default.createElement(
            'div',
            { className: _index2.default.success },
            props.title
        ),
        _react2.default.createElement(
            'div',
            { className: _index2.default.recordsMessage },
            props.children
        ),
        _react2.default.createElement(
            'button',
            {
                className: _index2.default.okButton,
                onClick: props.handleOnCloseModal
            },
            props.intl.formatMessage(_messages2.default.ok)
        )
    );
};

ConfirmationMessage.propTypes = {
    handleOnCloseModal: _propTypes2.default.func,
    icon: _propTypes2.default.string,
    children: _propTypes2.default.node,
    title: _propTypes2.default.string,
    intl: _reactIntl.intlShape.isRequired
};

exports.default = (0, _reactIntl.injectIntl)(ConfirmationMessage);

/***/ }),
/* 37 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactStyleable = __webpack_require__(6);

var _reactStyleable2 = _interopRequireDefault(_reactStyleable);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _truncate = __webpack_require__(1463);

var _truncate2 = _interopRequireDefault(_truncate);

var _index = __webpack_require__(1701);

var _index2 = _interopRequireDefault(_index);

var _constant = __webpack_require__(151);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var DropdownList = function (_PureComponent) {
    _inherits(DropdownList, _PureComponent);

    function DropdownList() {
        _classCallCheck(this, DropdownList);

        return _possibleConstructorReturn(this, (DropdownList.__proto__ || Object.getPrototypeOf(DropdownList)).apply(this, arguments));
    }

    _createClass(DropdownList, [{
        key: 'render',
        value: function render() {
            var _this2 = this;

            var index = 1;
            var keyAttr = !this.props.optionKey ? 'key' : this.props.optionKey;
            var stringAttr = !this.props.optionText ? 'value' : this.props.optionText;

            // Custom label generator that uses function to use current item's properties
            var customLabelFn = this.props.customLabelFn;

            var customItemLabelGenerator = customLabelFn || function () {};

            var listOptions = this.props.options ? this.props.options.map(function (option) {
                var text = customLabelFn ? customItemLabelGenerator(option) : option[stringAttr];
                text = (0, _truncate2.default)(text, { length: _this2.props.optionLength > 0 ? _this2.props.optionLength : 50 });
                index += 1;
                var disabled = option.disabled ? { disabled: 'disabled' } : {};
                return _react2.default.createElement(
                    'option',
                    _extends({}, disabled, { key: option[keyAttr] + '_' + index, value: option[keyAttr] }),
                    text
                );
            }) : '';
            var placeholderText = '';

            if (this.props.isLoading) {
                placeholderText = this.props.loadingPlaceholder ? this.props.loadingPlaceholder : this.props.placeholder + ' ...';
            } else {
                placeholderText = this.props.placeholder;
            }
            var placeholderOption = this.props.placeholder ? _react2.default.createElement(
                'option',
                { key: '-1', value: '-1' },
                ' ',
                placeholderText,
                ' '
            ) : '';

            var isDropdownDisabled = this.props.disabled ? { disabled: 'disabled' } : {};

            var containerClasses = [_constant.COMPONENT_ID, this.props.css[_constant.DEFAULT_VARIANT]];

            // Append variant styling
            var variant = this.props.variant;

            if (_index2.default[variant]) {
                containerClasses.push(_index2.default[variant]);
            }

            return _react2.default.createElement(
                'div',
                { className: containerClasses.join(' ').trim() },
                _react2.default.createElement(
                    'select',
                    _extends({}, isDropdownDisabled, {
                        name: this.props.name,
                        onChange: function onChange(e) {
                            return _this2.props.onChange(e.currentTarget.name, e.currentTarget.value);
                        },
                        value: this.props.value }),
                    placeholderOption,
                    listOptions
                )
            );
        }
    }]);

    return DropdownList;
}(_react.PureComponent);

DropdownList.propTypes = {
    css: _propTypes2.default.object,
    customLabelFn: _propTypes2.default.func,
    disabled: _propTypes2.default.bool,
    isLoading: _propTypes2.default.bool,
    loadingPlaceholder: _propTypes2.default.string,
    name: _propTypes2.default.string,
    onChange: _propTypes2.default.func,
    options: _propTypes2.default.array,
    optionLength: _propTypes2.default.number,
    optionKey: _propTypes2.default.string,
    optionText: _propTypes2.default.string,
    placeholder: _propTypes2.default.string,
    value: _propTypes2.default.string,
    variant: _propTypes2.default.string
};

exports.default = (0, _reactStyleable2.default)(_index2.default)(DropdownList);

/***/ }),
/* 38 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.openAddClassModal = openAddClassModal;
exports.closeAddClassModal = closeAddClassModal;
exports.closeAddClassValidationModal = closeAddClassValidationModal;
var GET_CLASSROOMS_REQUEST = exports.GET_CLASSROOMS_REQUEST = 'GET_CLASSROOMS_REQUEST';
var GET_CLASSROOMS_SUCCESS = exports.GET_CLASSROOMS_SUCCESS = 'GET_CLASSROOMS_SUCCESS';
var GET_CLASSROOMS_FAILURE = exports.GET_CLASSROOMS_FAILURE = 'GET_CLASSROOMS_FAILURE';

var getProductClassrooms = exports.getProductClassrooms = function getProductClassrooms(productId) {
    return { type: GET_CLASSROOMS_REQUEST, productId: productId, isClassroomDataLoaded: false };
};

var getProductClassroomsSuccess = exports.getProductClassroomsSuccess = function getProductClassroomsSuccess(_ref, productId) {
    var data = _ref.data;
    return { type: GET_CLASSROOMS_SUCCESS, data: data, productId: productId, isClassroomDataLoaded: true };
};

var getProductClassroomsFailure = exports.getProductClassroomsFailure = function getProductClassroomsFailure(productId) {
    return { type: GET_CLASSROOMS_FAILURE, data: [], productId: productId, isClassroomDataLoaded: true };
};

var CLASS_FILTER_VALUE_CLEARED = exports.CLASS_FILTER_VALUE_CLEARED = 'CLASS_FILTER_VALUE_CLEARED';
var CLASS_FILTER_VALUE_CHANGED = exports.CLASS_FILTER_VALUE_CHANGED = 'CLASS_FILTER_VALUE_CHANGED';
var CLASS_UPDATE_SEARCH_TERM = exports.CLASS_UPDATE_SEARCH_TERM = 'CLASS_UPDATE_SEARCH_TERM';

var clearFilterValue = exports.clearFilterValue = function clearFilterValue() {
    return { type: CLASS_FILTER_VALUE_CLEARED };
};

var changeFilterValue = exports.changeFilterValue = function changeFilterValue(collectionName, key) {
    return { type: CLASS_FILTER_VALUE_CHANGED, collectionName: collectionName, key: key };
};

var updateSearchTerm = exports.updateSearchTerm = function updateSearchTerm(searchTerm) {
    return { type: CLASS_UPDATE_SEARCH_TERM, searchTerm: searchTerm };
};

var PRINT_STUDENTS_SIGN_IN_CARD_REQUEST = exports.PRINT_STUDENTS_SIGN_IN_CARD_REQUEST = 'PRINT_STUDENTS_SIGN_IN_CARD_REQUEST';
var PRINT_STUDENTS_SIGN_IN_CARD_SUCCESS = exports.PRINT_STUDENTS_SIGN_IN_CARD_SUCCESS = 'PRINT_STUDENTS_SIGN_IN_CARD_SUCCESS';
var PRINT_STUDENTS_SIGN_IN_CARD_FAILURE = exports.PRINT_STUDENTS_SIGN_IN_CARD_FAILURE = 'PRINT_STUDENTS_SIGN_IN_CARD_FAILURE';

var printStudentsSignInCard = exports.printStudentsSignInCard = function printStudentsSignInCard(selectedProductId, studentSignInCardsData) {
    return { type: PRINT_STUDENTS_SIGN_IN_CARD_REQUEST, selectedProductId: selectedProductId, studentSignInCardsData: studentSignInCardsData, isStudentsSignInCardDownloaded: false };
};

var printStudentsSignInCardSuccess = exports.printStudentsSignInCardSuccess = function printStudentsSignInCardSuccess(downloadUrl) {
    return { type: PRINT_STUDENTS_SIGN_IN_CARD_SUCCESS, downloadUrl: downloadUrl, isStudentsSignInCardDownloaded: true };
};

var printStudentsSignInCardFailure = exports.printStudentsSignInCardFailure = function printStudentsSignInCardFailure() {
    return { type: PRINT_STUDENTS_SIGN_IN_CARD_FAILURE, isStudentsSignInCardDownloaded: true };
};
var SORT_CLASS_LIST = exports.SORT_CLASS_LIST = 'SORT_CLASS_LIST';
var sortClassList = exports.sortClassList = function sortClassList(columnToSort) {
    return { type: SORT_CLASS_LIST, columnToSort: columnToSort };
};

var RETRIEVE_SELECTED_CLASSES = exports.RETRIEVE_SELECTED_CLASSES = 'RETRIEVE_SELECTED_CLASSES';
var retrieveSelectedClasses = exports.retrieveSelectedClasses = function retrieveSelectedClasses(selectedClassesId) {
    return { type: RETRIEVE_SELECTED_CLASSES, selectedClasses: selectedClassesId };
};

var ADD_CLASS_OPEN_MODAL_REQUEST = exports.ADD_CLASS_OPEN_MODAL_REQUEST = 'ADD_CLASS_OPEN_MODAL_REQUEST';
var ADD_CLASS_CLOSE_MODAL_REQUEST = exports.ADD_CLASS_CLOSE_MODAL_REQUEST = 'ADD_CLASS_CLOSE_MODAL_REQUEST';

function openAddClassModal() {
    return {
        type: ADD_CLASS_OPEN_MODAL_REQUEST,
        showAddClassModal: true,
        showAddClassConfirmationModal: false,
        refreshList: false
    };
}

function closeAddClassModal() {
    return {
        type: ADD_CLASS_CLOSE_MODAL_REQUEST,
        showAddClassModal: false,
        showAddClassConfirmationModal: false
    };
}

var ADD_CLASS_REQUEST = exports.ADD_CLASS_REQUEST = 'ADD_CLASS_REQUEST';
var ADD_CLASS_SUCCESS = exports.ADD_CLASS_SUCCESS = 'ADD_CLASS_SUCCESS';
var ADD_CLASS_FAILURE = exports.ADD_CLASS_FAILURE = 'ADD_CLASS_FAILURE';

var addClass = exports.addClass = function addClass(ClassModel) {
    return { type: ADD_CLASS_REQUEST, ClassModel: ClassModel, isSaveInProgress: true };
};

var AddClassSuccess = exports.AddClassSuccess = function AddClassSuccess() {
    return {
        type: ADD_CLASS_SUCCESS,
        isSaveInProgress: false,
        showAddClassModal: false,
        showAddClassConfirmationModal: true,
        refreshList: true
    };
};

var AddClassFailure = exports.AddClassFailure = function AddClassFailure(failureFlag, errorMessage) {
    return { type: ADD_CLASS_FAILURE, isSaveInProgress: false, errorMessage: errorMessage, showAddClassModal: true, showAddClassValidationModal: true };
};

var CLEAR_PRODUCT_COURSES = exports.CLEAR_PRODUCT_COURSES = 'CLEAR_PRODUCT_COURSES';

var clearProductCourses = exports.clearProductCourses = function clearProductCourses() {
    return { type: CLEAR_PRODUCT_COURSES };
};

var GET_PRODUCT_COURSES_REQUEST = exports.GET_PRODUCT_COURSES_REQUEST = 'GET_PRODUCT_COURSES_REQUEST';
var GET_PRODUCT_COURSES_SUCCESS = exports.GET_PRODUCT_COURSES_SUCCESS = 'GET_PRODUCT_COURSES_SUCCESS';
var GET_PRODUCT_COURSES_FAILURE = exports.GET_PRODUCT_COURSES_FAILURE = 'GET_PRODUCT_COURSES_FAILURE';

var getProductCourses = exports.getProductCourses = function getProductCourses(countryCode, productId, yearGroup) {
    return { type: GET_PRODUCT_COURSES_REQUEST, countryCode: countryCode, productId: productId, yearGroup: yearGroup, isProductCoursesLoaded: false, isProductCoursesFetching: true };
};

var getProductCoursesSuccess = exports.getProductCoursesSuccess = function getProductCoursesSuccess(data) {
    return { type: GET_PRODUCT_COURSES_SUCCESS, data: data, isProductCoursesLoaded: true, isProductCoursesFetching: false };
};

var getProductCoursesFailure = exports.getProductCoursesFailure = function getProductCoursesFailure() {
    return { type: GET_PRODUCT_COURSES_FAILURE, isProductCoursesLoaded: true, isProductCoursesFetching: false };
};

var DOWNLOAD_CLASS_ROLL_REQUEST = exports.DOWNLOAD_CLASS_ROLL_REQUEST = 'DOWNLOAD_CLASS_ROLL_REQUEST';
var DOWNLOAD_CLASS_ROLL_SUCCESS = exports.DOWNLOAD_CLASS_ROLL_SUCCESS = 'DOWNLOAD_CLASS_ROLL_SUCCESS';
var DOWNLOAD_CLASS_ROLL_FAILURE = exports.DOWNLOAD_CLASS_ROLL_FAILURE = 'DOWNLOAD_CLASS_ROLL_FAILURE';

var downloadClassRoll = exports.downloadClassRoll = function downloadClassRoll(classrooms, isClassRollDownloaded) {
    return { type: DOWNLOAD_CLASS_ROLL_REQUEST, classrooms: classrooms, isClassRollDownloaded: isClassRollDownloaded };
};

var downloadClassRollSuccess = exports.downloadClassRollSuccess = function downloadClassRollSuccess(downloadUrl, isClassRollDownloaded) {
    window.location.href = downloadUrl;
    return { type: DOWNLOAD_CLASS_ROLL_SUCCESS, isClassRollDownloaded: isClassRollDownloaded };
};

var downloadClassRollFailure = exports.downloadClassRollFailure = function downloadClassRollFailure(isClassRollDownloaded) {
    return { type: DOWNLOAD_CLASS_ROLL_FAILURE, isClassRollDownloaded: isClassRollDownloaded };
};

var CLOSE_ADD_CLASS_VALIDATION_MODAL = exports.CLOSE_ADD_CLASS_VALIDATION_MODAL = 'CLOSE_ADD_CLASS_VALIDATION_MODAL';

function closeAddClassValidationModal() {
    return {
        type: CLOSE_ADD_CLASS_VALIDATION_MODAL,
        showAddClassValidationModal: false
    };
}

var GET_SCHOOL_COURSES_REQUEST = exports.GET_SCHOOL_COURSES_REQUEST = 'GET_SCHOOL_COURSES_REQUEST';
var GET_SCHOOL_COURSES_SUCCESS = exports.GET_SCHOOL_COURSES_SUCCESS = 'GET_SCHOOL_COURSES_SUCCESS';
var GET_SCHOOL_COURSES_FAILURE = exports.GET_SCHOOL_COURSES_FAILURE = 'GET_SCHOOL_COURSES_FAILURE';

var getSchoolCourses = exports.getSchoolCourses = function getSchoolCourses(yearGroup) {
    return { type: GET_SCHOOL_COURSES_REQUEST, yearGroup: yearGroup };
};

var getSchoolCoursesSuccess = exports.getSchoolCoursesSuccess = function getSchoolCoursesSuccess(data) {
    return { type: GET_SCHOOL_COURSES_SUCCESS, data: data };
};

var getSchoolCoursesFailure = exports.getSchoolCoursesFailure = function getSchoolCoursesFailure() {
    return { type: GET_SCHOOL_COURSES_FAILURE };
};

var DELETE_CLASSROOMS_REQUEST = exports.DELETE_CLASSROOMS_REQUEST = 'DELETE_CLASSROOMS_REQUEST';
var DELETE_CLASSROOMS_SUCCESS = exports.DELETE_CLASSROOMS_SUCCESS = 'DELETE_CLASSROOMS_SUCCESS';
var DELETE_CLASSROOMS_FAILURE = exports.DELETE_CLASSROOMS_FAILURE = 'DELETE_CLASSROOMS_FAILURE';

var deleteClassrooms = exports.deleteClassrooms = function deleteClassrooms(selectedClassroomIds) {
    return {
        type: DELETE_CLASSROOMS_REQUEST,
        selectedClassroomIds: selectedClassroomIds,
        deletingClassrooms: true,
        refreshList: false
    };
};

var deleteClassroomsSuccess = exports.deleteClassroomsSuccess = function deleteClassroomsSuccess() {
    return {
        type: DELETE_CLASSROOMS_SUCCESS,
        deletingClassrooms: false
    };
};

var deleteClassroomsFailure = exports.deleteClassroomsFailure = function deleteClassroomsFailure() {
    return {
        type: DELETE_CLASSROOMS_FAILURE,
        deletingClassrooms: false
    };
};
var SHOW_DELETE_CLASSROOMS_CONFIRMATION = exports.SHOW_DELETE_CLASSROOMS_CONFIRMATION = 'SHOW_DELETE_CLASSROOMS_CONFIRMATION';
var openDeleteClassroomsConfirmation = exports.openDeleteClassroomsConfirmation = function openDeleteClassroomsConfirmation(deletingEmptyClassrooms) {
    return {
        type: SHOW_DELETE_CLASSROOMS_CONFIRMATION,
        showDeleteClassroomsConfirmation: true,
        deletingEmptyClassrooms: deletingEmptyClassrooms

    };
};

var CLOSE_DELETE_CLASSROOMS_CONFIRMATION = exports.CLOSE_DELETE_CLASSROOMS_CONFIRMATION = 'CLOSE_DELETE_CLASSROOMS_CONFIRMATION';
var closeDeleteClassroomsConfirmation = exports.closeDeleteClassroomsConfirmation = function closeDeleteClassroomsConfirmation() {
    var isConfirm = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
    return {
        type: CLOSE_DELETE_CLASSROOMS_CONFIRMATION,
        showDeleteClassroomsConfirmation: false,
        deletingEmptyClassrooms: isConfirm
    };
};

var SHOW_DELETE_CLASSROOMS_SUCCESS = exports.SHOW_DELETE_CLASSROOMS_SUCCESS = 'SHOW_DELETE_CLASSROOMS_SUCCESS';
var openDeleteClassroomsSuccess = exports.openDeleteClassroomsSuccess = function openDeleteClassroomsSuccess() {
    return {
        type: SHOW_DELETE_CLASSROOMS_SUCCESS,
        showDeleteClassroomsSuccess: true

    };
};

var CLOSE_DELETE_CLASSROOMS_SUCCESS = exports.CLOSE_DELETE_CLASSROOMS_SUCCESS = 'CLOSE_DELETE_CLASSROOMS_SUCCESS';
var closeDeleteClassroomsSuccess = exports.closeDeleteClassroomsSuccess = function closeDeleteClassroomsSuccess(deletedClassesCount) {
    return {
        type: CLOSE_DELETE_CLASSROOMS_SUCCESS,
        showDeleteClassroomsSuccess: false,
        refreshList: true,
        deletedClassesCount: deletedClassesCount
    };
};

var GET_STUDENTS_BY_CLASSROOM_REQUEST = exports.GET_STUDENTS_BY_CLASSROOM_REQUEST = 'GET_STUDENTS_BY_CLASSROOM_REQUEST';
var GET_STUDENTS_BY_CLASSROOM_SUCCESS = exports.GET_STUDENTS_BY_CLASSROOM_SUCCESS = 'GET_STUDENTS_BY_CLASSROOM_SUCCESS';
var GET_STUDENTS_BY_CLASSROOM_FAILURE = exports.GET_STUDENTS_BY_CLASSROOM_FAILURE = 'GET_STUDENTS_BY_CLASSROOM_FAILURE';

var getStudentByClassroomIdRequest = exports.getStudentByClassroomIdRequest = function getStudentByClassroomIdRequest(classroomId) {
    return { type: GET_STUDENTS_BY_CLASSROOM_REQUEST, classroomId: classroomId, isStudentDataLoaded: false };
};

var getStudentByClassroomIdSuccess = exports.getStudentByClassroomIdSuccess = function getStudentByClassroomIdSuccess(students) {
    return { type: GET_STUDENTS_BY_CLASSROOM_SUCCESS, students: students, isStudentDataLoaded: true };
};

var getStudentByClassroomIdFailure = exports.getStudentByClassroomIdFailure = function getStudentByClassroomIdFailure() {
    return { type: GET_STUDENTS_BY_CLASSROOM_FAILURE, isStudentDataLoaded: true };
};

var SHOW_HIDE_SIGNIN_CARD_MODAL = exports.SHOW_HIDE_SIGNIN_CARD_MODAL = 'SHOW_HIDE_SIGNIN_CARD_MODAL';

var showHideSignInCardModalRequest = exports.showHideSignInCardModalRequest = function showHideSignInCardModalRequest(status) {
    return { type: SHOW_HIDE_SIGNIN_CARD_MODAL, showHideSignInCardModal: status };
};

var CLEAR_UPF_COURSES = exports.CLEAR_UPF_COURSES = 'CLEAR_UPF_COURSES';

var clearUPFCourses = exports.clearUPFCourses = function clearUPFCourses() {
    return { type: CLEAR_UPF_COURSES };
};

var GET_UPF_COURSES = exports.GET_UPF_COURSES = 'GET_UPF_COURSES';
var GET_UPF_COURSES_SUCCESS = exports.GET_UPF_COURSES_SUCCESS = 'GET_UPF_COURSES_SUCCESS';
var GET_UPF_COURSES_FAILURE = exports.GET_UPF_COURSES_FAILURE = 'GET_UPF_COURSES_FAILURE';

var getUPFCourses = exports.getUPFCourses = function getUPFCourses(countryCode, productId, yearGroup) {
    return {
        type: GET_UPF_COURSES,
        countryCode: countryCode,
        productId: productId,
        yearGroup: yearGroup,
        isProductCoursesLoaded: false,
        isUPFCoursesFetching: true,
        selectGenericCourses: true,
        includeGlobalCourses: true
    };
};

var GET_NEW_COURSES_REQUEST = exports.GET_NEW_COURSES_REQUEST = 'GET_NEW_COURSES_REQUEST';
var GET_NEW_COURSES_SUCCESS = exports.GET_NEW_COURSES_SUCCESS = 'GET_NEW_COURSES_SUCCESS';
var GET_NEW_COURSES_FAILURE = exports.GET_NEW_COURSES_FAILURE = 'GET_NEW_COURSES_FAILURE';

var getNewCourses = exports.getNewCourses = function getNewCourses(_ref2) {
    var productId = _ref2.productId,
        countryCode = _ref2.countryCode,
        yearGroup = _ref2.yearGroup;
    return {
        type: GET_NEW_COURSES_REQUEST,
        productId: productId,
        countryCode: countryCode,
        yearGroup: yearGroup,
        isProductCoursesLoaded: false,
        isNewCoursesFetching: true
    };
};

/***/ }),
/* 39 */,
/* 40 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var appName = 'SchoolRollHost';
var teacherUserTypeId = exports.teacherUserTypeId = 2;
exports.default = appName;
var DEFAULT_COURSE_ID = exports.DEFAULT_COURSE_ID = 0;

var ROLLOVER_INFO_MODAL_OPTOUT = exports.ROLLOVER_INFO_MODAL_OPTOUT = 'ROLLOVER_INFO_MODAL_OPTOUT';

var DEFAULT_UPF_COURSE_ID = exports.DEFAULT_UPF_COURSE_ID = '0';
var DEFAULT_LEGACY_COURSE_ID = exports.DEFAULT_LEGACY_COURSE_ID = '-1';
var DEFAULT_NEW_COURSE_ID = exports.DEFAULT_NEW_COURSE_ID = '00000000-0000-0000-0000-000000000000';

var DEFAULT_COUNTRY_ID = exports.DEFAULT_COUNTRY_ID = '-1';
var DEFAULT_YEAR_GROUP = exports.DEFAULT_YEAR_GROUP = '-1';
var DEFAULT_TEACHER_ID = exports.DEFAULT_TEACHER_ID = '-1';
var DEFAULT_CLASSROOM_ID = exports.DEFAULT_CLASSROOM_ID = '-1';

var DROPDOWN_OPTION_LENGTH = exports.DROPDOWN_OPTION_LENGTH = 60;

var AUSTRALIA_REGION_ID = exports.AUSTRALIA_REGION_ID = 8;

var MAX_CLASSNAME_LENGTH = exports.MAX_CLASSNAME_LENGTH = 200;

var COUNTRY_COURSE_TYPE = exports.COUNTRY_COURSE_TYPE = {
    ALL: 0,
    DEFAULT: 1,
    UPF: 2,
    CONQUEST: 3
};

/***/ }),
/* 41 */,
/* 42 */,
/* 43 */,
/* 44 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var GET_LICENCE_CAP_SUMMARY_REQUEST = exports.GET_LICENCE_CAP_SUMMARY_REQUEST = 'GET_LICENCE_CAP_SUMMARY_REQUEST';
var GET_LICENCE_CAP_SUMMARY_SUCCESS = exports.GET_LICENCE_CAP_SUMMARY_SUCCESS = 'GET_LICENCE_CAP_SUMMARY_SUCCESS';
var GET_LICENCE_CAP_SUMMARY_FAILURE = exports.GET_LICENCE_CAP_SUMMARY_FAILURE = 'GET_LICENCE_CAP_SUMMARY_FAILURE';

var getLicenceCapSummary = exports.getLicenceCapSummary = function getLicenceCapSummary(productId) {
    return { type: GET_LICENCE_CAP_SUMMARY_REQUEST, productId: productId };
};

var getLicenceCapSummarySuccess = exports.getLicenceCapSummarySuccess = function getLicenceCapSummarySuccess(_ref) {
    var data = _ref.data;
    return { type: GET_LICENCE_CAP_SUMMARY_SUCCESS, data: data };
};

var getLicenceCapSummaryFailure = exports.getLicenceCapSummaryFailure = function getLicenceCapSummaryFailure() {
    return { type: GET_LICENCE_CAP_SUMMARY_FAILURE };
};

var GET_COUNTRIES_REQUEST = exports.GET_COUNTRIES_REQUEST = 'GET_COUNTRIES_REQUEST';
var GET_COUNTRIES_SUCCESS = exports.GET_COUNTRIES_SUCCESS = 'GET_COUNTRIES_SUCCESS';
var GET_COUNTRIES_FAILURE = exports.GET_COUNTRIES_FAILURE = 'GET_COUNTRIES_FAILURE';

var getCourseCountries = exports.getCourseCountries = function getCourseCountries(selectedProductId) {
    return { type: GET_COUNTRIES_REQUEST, selectedProductId: selectedProductId };
};

var getCourseCountriesSuccess = exports.getCourseCountriesSuccess = function getCourseCountriesSuccess(data) {
    return { type: GET_COUNTRIES_SUCCESS, data: data };
};

var getCourseCountriesFailure = exports.getCourseCountriesFailure = function getCourseCountriesFailure() {
    return { type: GET_COUNTRIES_FAILURE };
};

var GET_UPF_COUNTRIES_REQUEST = exports.GET_UPF_COUNTRIES_REQUEST = 'GET_UPF_COUNTRIES_REQUEST';
var GET_UPF_COUNTRIES_SUCCESS = exports.GET_UPF_COUNTRIES_SUCCESS = 'GET_UPF_COUNTRIES_SUCCESS';
var GET_UPF_COUNTRIES_FAILURE = exports.GET_UPF_COUNTRIES_FAILURE = 'GET_UPF_COUNTRIES_FAILURE';

var getUpfCourseCountries = exports.getUpfCourseCountries = function getUpfCourseCountries(selectedProductId) {
    return { type: GET_UPF_COUNTRIES_REQUEST, selectedProductId: selectedProductId };
};

var getUpfCourseCountriesSuccess = exports.getUpfCourseCountriesSuccess = function getUpfCourseCountriesSuccess(data) {
    return { type: GET_UPF_COUNTRIES_SUCCESS, data: data };
};

var getUpfCourseCountriesFailure = exports.getUpfCourseCountriesFailure = function getUpfCourseCountriesFailure() {
    return { type: GET_UPF_COUNTRIES_FAILURE };
};

var GET_YEAR_GROUPS_REQUEST = exports.GET_YEAR_GROUPS_REQUEST = 'GET_YEAR_GROUPS_REQUEST';
var GET_YEAR_GROUPS_SUCCESS = exports.GET_YEAR_GROUPS_SUCCESS = 'GET_YEAR_GROUPS_SUCCESS';
var GET_YEAR_GROUPS_FAILURE = exports.GET_YEAR_GROUPS_FAILURE = 'GET_YEAR_GROUPS_FAILURE';

var getYearGroups = exports.getYearGroups = function getYearGroups() {
    return { type: GET_YEAR_GROUPS_REQUEST };
};

var getYearGroupsSuccess = exports.getYearGroupsSuccess = function getYearGroupsSuccess(_ref2) {
    var data = _ref2.data;
    return { type: GET_YEAR_GROUPS_SUCCESS, data: data };
};

var getYearGroupsFailure = exports.getYearGroupsFailure = function getYearGroupsFailure() {
    return { type: GET_YEAR_GROUPS_FAILURE };
};

/***/ }),
/* 45 */,
/* 46 */,
/* 47 */,
/* 48 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactStyleable = __webpack_require__(6);

var _reactStyleable2 = _interopRequireDefault(_reactStyleable);

__webpack_require__(1221);

var _index = __webpack_require__(1756);

var _index2 = _interopRequireDefault(_index);

var _button = __webpack_require__(7);

var _button2 = _interopRequireDefault(_button);

var _iconDictionary = __webpack_require__(8);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /* global CustomEvent */


var TextInput = function (_PureComponent) {
    _inherits(TextInput, _PureComponent);

    function TextInput(props) {
        _classCallCheck(this, TextInput);

        var _this = _possibleConstructorReturn(this, (TextInput.__proto__ || Object.getPrototypeOf(TextInput)).call(this, props));

        _this.handleClearText = _this.handleClearText.bind(_this);
        return _this;
    }

    _createClass(TextInput, [{
        key: 'handleClearText',
        value: function handleClearText() {
            var _props = this.props,
                clearText = _props.clearText,
                handleOnChange = _props.handleOnChange;

            if (clearText && this.inputEl.value !== '') {
                this.inputEl.value = '';
                var event = new CustomEvent('input', { bubbles: true });
                this.inputEl.dispatchEvent(event);
                handleOnChange(event);
            }
        }
    }, {
        key: 'render',
        value: function render() {
            var _this2 = this;

            var _props2 = this.props,
                clearText = _props2.clearText,
                handleOnChange = _props2.handleOnChange,
                handleOnBlur = _props2.handleOnBlur,
                handleOnKeyPress = _props2.handleOnKeyPress;


            var inputProps = {};
            var clearEl = '';
            var hasClearText = '';

            // Add ref to the input component if clear text mode is enabled
            if (clearText) {
                hasClearText = this.props.css.hasClearText;
                inputProps = { ref: function ref(el) {
                        _this2.inputEl = el;
                    } };
                clearEl = _react2.default.createElement(_button2.default, {
                    containerClassName: this.props.css.clearButtonContainer,
                    disabled: this.props.disabled,
                    handleOnClick: this.handleClearText,
                    icon: _iconDictionary.Cross,
                    iconClassName: this.props.css.clearButtonIcon });
            }

            return _react2.default.createElement(
                'div',
                { className: this.props.css.inputTextComponent + ' ' + hasClearText },
                _react2.default.createElement('input', _extends({
                    className: this.props.css.inputText,
                    disabled: this.props.disabled,
                    maxLength: this.props.maxLength,
                    name: this.props.name,
                    onBlur: handleOnBlur,
                    onChange: handleOnChange,
                    onKeyPress: handleOnKeyPress,
                    placeholder: this.props.placeholder,
                    type: this.props.type,
                    value: this.props.value
                }, inputProps)),
                clearEl
            );
        }
    }]);

    return TextInput;
}(_react.PureComponent);

TextInput.defaultProps = {
    type: 'text'
};

TextInput.propTypes = {
    name: _propTypes2.default.string,
    value: _propTypes2.default.string,
    maxLength: _propTypes2.default.number,
    placeholder: _propTypes2.default.string,
    css: _propTypes2.default.object,
    handleOnChange: _propTypes2.default.func,
    disabled: _propTypes2.default.bool,
    // Enable clear text mode and display a clear button
    clearText: _propTypes2.default.bool,
    type: _propTypes2.default.string,
    handleOnBlur: _propTypes2.default.func,
    handleOnKeyPress: _propTypes2.default.func
};

exports.default = (0, _reactStyleable2.default)(_index2.default)(TextInput);

/***/ }),
/* 49 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _index = __webpack_require__(24);

var _index2 = _interopRequireDefault(_index);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var withModal = function withModal(visibilityProp) {
    return function (WrappedComponent) {
        return function (_Component) {
            _inherits(_class, _Component);

            function _class(props) {
                _classCallCheck(this, _class);

                var _this = _possibleConstructorReturn(this, (_class.__proto__ || Object.getPrototypeOf(_class)).call(this, props));

                _this.close = _this.close.bind(_this);
                _this.isVisible = _this.isVisible.bind(_this);
                _this.state = {
                    isVisible: false
                };
                return _this;
            }

            _createClass(_class, [{
                key: 'isVisible',
                value: function isVisible() {
                    var props = this.props;

                    return props[visibilityProp] !== null && props[visibilityProp] !== undefined && props[visibilityProp] === true;
                }
            }, {
                key: 'close',
                value: function close(closeCallback) {
                    this.setState({
                        isVisible: false
                    });
                    closeCallback();
                }
            }, {
                key: 'render',
                value: function render() {
                    var modalProps = {
                        close: this.close
                    };

                    var modalContent = this.isVisible() ? _react2.default.createElement(WrappedComponent, _extends({}, this.props, this.state, {
                        modal: modalProps
                    })) : '';
                    return _react2.default.createElement(
                        _index2.default,
                        { show: this.isVisible() },
                        _react2.default.createElement(
                            'div',
                            { className: 'is-a-modal' },
                            modalContent
                        )
                    );
                }
            }]);

            return _class;
        }(_react.Component);
    };
};

exports.default = withModal;

/***/ }),
/* 50 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.openAddTeacherModal = openAddTeacherModal;
exports.addAnotherTeacherModal = addAnotherTeacherModal;
exports.closeAddTeacherModal = closeAddTeacherModal;
exports.addTeacherSuccess = addTeacherSuccess;
exports.addTeacherFailure = addTeacherFailure;
exports.closeAddTeacherValidationModal = closeAddTeacherValidationModal;
var GET_PRODUCT_TEACHERS_REQUEST = exports.GET_PRODUCT_TEACHERS_REQUEST = 'GET_PRODUCT_TEACHERS_REQUEST';
var GET_PRODUCT_TEACHERS_SUCCESS = exports.GET_PRODUCT_TEACHERS_SUCCESS = 'GET_PRODUCT_TEACHERS_SUCCESS';
var GET_PRODUCT_TEACHERS_FAILURE = exports.GET_PRODUCT_TEACHERS_FAILURE = 'GET_PRODUCT_TEACHERS_FAILURE';

var getProductTeachers = exports.getProductTeachers = function getProductTeachers(productId) {
    return { type: GET_PRODUCT_TEACHERS_REQUEST, productId: productId };
};

var getProductTeachersSuccess = exports.getProductTeachersSuccess = function getProductTeachersSuccess(_ref) {
    var data = _ref.data;
    return { type: GET_PRODUCT_TEACHERS_SUCCESS, data: data };
};

var getProductTeachersFailure = exports.getProductTeachersFailure = function getProductTeachersFailure() {
    return { type: GET_PRODUCT_TEACHERS_FAILURE };
};

var DOWNLOAD_TEACHER_ROLL_REQUEST = exports.DOWNLOAD_TEACHER_ROLL_REQUEST = 'DOWNLOAD_TEACHER_ROLL_REQUEST';
var DOWNLOAD_TEACHER_ROLL_SUCCESS = exports.DOWNLOAD_TEACHER_ROLL_SUCCESS = 'DOWNLOAD_TEACHER_ROLL_SUCCESS';
var DOWNLOAD_TEACHER_ROLL_FAILURE = exports.DOWNLOAD_TEACHER_ROLL_FAILURE = 'DOWNLOAD_TEACHER_ROLL_FAILURE';

var downloadTeacherRoll = exports.downloadTeacherRoll = function downloadTeacherRoll(teachers, isTeacherRollDownloaded) {
    return { type: DOWNLOAD_TEACHER_ROLL_REQUEST, teachers: teachers, isTeacherRollDownloaded: isTeacherRollDownloaded };
};

var downloadTeacherRollSuccess = exports.downloadTeacherRollSuccess = function downloadTeacherRollSuccess(downloadUrl, isTeacherRollDownloaded) {
    window.location.href = downloadUrl;
    return { type: DOWNLOAD_TEACHER_ROLL_SUCCESS, isTeacherRollDownloaded: isTeacherRollDownloaded };
};

var downloadTeacherRollFailure = exports.downloadTeacherRollFailure = function downloadTeacherRollFailure() {
    return { type: DOWNLOAD_TEACHER_ROLL_FAILURE };
};

var TEACHER_FILTER_VALUE_CLEARED = exports.TEACHER_FILTER_VALUE_CLEARED = 'TEACHER_FILTER_VALUE_CLEARED';
var TEACHER_FILTER_VALUE_CHANGED = exports.TEACHER_FILTER_VALUE_CHANGED = 'TEACHER_FILTER_VALUE_CHANGED';
var UPDATE_TEACHER_SEARCH_TERM = exports.UPDATE_TEACHER_SEARCH_TERM = 'UPDATE_TEACHER_SEARCH_TERM';
var SORT_TEACHER_LIST = exports.SORT_TEACHER_LIST = 'SORT_TEACHER_LIST';
var RETRIEVE_SELECTED_TEACHER = exports.RETRIEVE_SELECTED_TEACHER = 'RETRIEVE_SELECTED_TEACHER';

var clearFilterValue = exports.clearFilterValue = function clearFilterValue() {
    return { type: TEACHER_FILTER_VALUE_CLEARED };
};

var changeFilterValue = exports.changeFilterValue = function changeFilterValue(collectionName, key) {
    return { type: TEACHER_FILTER_VALUE_CHANGED, collectionName: collectionName, key: key };
};

var updateSearchTerm = exports.updateSearchTerm = function updateSearchTerm(searchTerm) {
    return { type: UPDATE_TEACHER_SEARCH_TERM, searchTerm: searchTerm };
};

var sortTeacherList = exports.sortTeacherList = function sortTeacherList(columnToSort) {
    return { type: SORT_TEACHER_LIST, columnToSort: columnToSort };
};

var retrieveSelectedTeachers = exports.retrieveSelectedTeachers = function retrieveSelectedTeachers(selectedTeachersProfileId) {
    return {
        type: RETRIEVE_SELECTED_TEACHER,
        selectedTeachers: selectedTeachersProfileId
    };
};

var UNASSIGN_TEACHERS_REQUEST = exports.UNASSIGN_TEACHERS_REQUEST = 'UNASSIGN_TEACHERS_REQUEST';
var UNASSIGN_TEACHERS_SUCCESS = exports.UNASSIGN_TEACHERS_SUCCESS = 'UNASSIGN_TEACHERS_SUCCESS';
var UNASSIGN_TEACHERS_FAILURE = exports.UNASSIGN_TEACHERS_FAILURE = 'UNASSIGN_TEACHERS_FAILURE';

var unassignTeachers = exports.unassignTeachers = function unassignTeachers(selectedTeachers, productId) {
    return { type: UNASSIGN_TEACHERS_REQUEST, selectedTeachers: selectedTeachers, productId: productId, disableConfirmationButtons: true };
};

var unassignTeachersSuccess = exports.unassignTeachersSuccess = function unassignTeachersSuccess() {
    return { type: UNASSIGN_TEACHERS_SUCCESS, isUserOperationModalOpen: false, disableConfirmationButtons: false };
};

var unassignTeachersFailure = exports.unassignTeachersFailure = function unassignTeachersFailure() {
    return { type: UNASSIGN_TEACHERS_FAILURE, disableConfirmationButtons: false };
};

var OPEN_UNASSIGN_TEACHERS_MODAL = exports.OPEN_UNASSIGN_TEACHERS_MODAL = 'OPEN_UNASSIGN_TEACHERS_MODAL';
var CLOSE_TEACHERS_OPERATION_CONFIRMATION_MODAL = exports.CLOSE_TEACHERS_OPERATION_CONFIRMATION_MODAL = 'CLOSE_TEACHERS_OPERATION_CONFIRMATION_MODAL';

var openUnAssignTeachersModal = exports.openUnAssignTeachersModal = function openUnAssignTeachersModal() {
    return { type: OPEN_UNASSIGN_TEACHERS_MODAL, isUserOperationModalOpen: true, operationType: 'unassignTeacher' };
};

var closeTeachersOperationConfirmationModal = exports.closeTeachersOperationConfirmationModal = function closeTeachersOperationConfirmationModal() {
    return { type: CLOSE_TEACHERS_OPERATION_CONFIRMATION_MODAL, deleteSuccess: false, refreshTeacherList: true, selectedTeachers: [] };
};

var PRINT_TEACHER_SIGN_IN_CARD_REQUEST = exports.PRINT_TEACHER_SIGN_IN_CARD_REQUEST = 'PRINT_TEACHER_SIGN_IN_CARD_REQUEST';
var PRINT_TEACHER_SIGN_IN_CARD_SUCCESS = exports.PRINT_TEACHER_SIGN_IN_CARD_SUCCESS = 'PRINT_TEACHER_SIGN_IN_CARD_SUCCESS';
var PRINT_TEACHER_SIGN_IN_CARD_FAILURE = exports.PRINT_TEACHER_SIGN_IN_CARD_FAILURE = 'PRINT_TEACHER_SIGN_IN_CARD_FAILURE';

var printTeacherSignInCard = exports.printTeacherSignInCard = function printTeacherSignInCard(productId, teacherSignInCardsData) {
    return { type: PRINT_TEACHER_SIGN_IN_CARD_REQUEST, isSignInCardDownloaded: false, teacherSignInCardsData: teacherSignInCardsData, productId: productId };
};

var printTeacherSignInCardSuccess = exports.printTeacherSignInCardSuccess = function printTeacherSignInCardSuccess(downloadUrl, isSignInCardDownloaded) {
    window.location.href = downloadUrl;
    return { type: PRINT_TEACHER_SIGN_IN_CARD_SUCCESS, downloadUrl: downloadUrl, isSignInCardDownloaded: isSignInCardDownloaded };
};

var printTeacherSignInCardFailure = exports.printTeacherSignInCardFailure = function printTeacherSignInCardFailure(isSignInCardDownloaded) {
    return { type: PRINT_TEACHER_SIGN_IN_CARD_FAILURE, isSignInCardDownloaded: isSignInCardDownloaded };
};

var ADD_TEACHER_OPEN_MODAL_REQUEST = exports.ADD_TEACHER_OPEN_MODAL_REQUEST = 'ADD_TEACHER_OPEN_MODAL_REQUEST';
var ADD_TEACHER_CLOSE_MODAL_REQUEST = exports.ADD_TEACHER_CLOSE_MODAL_REQUEST = 'ADD_TEACHER_CLOSE_MODAL_REQUEST';
var ADD_ANOTHER_TEACHER_OPEN_MODAL_REQUEST = exports.ADD_ANOTHER_TEACHER_OPEN_MODAL_REQUEST = 'ADD_ANOTHER_TEACHER_OPEN_MODAL_REQUEST';

function openAddTeacherModal() {
    return {
        type: ADD_TEACHER_OPEN_MODAL_REQUEST,
        showModal: true,
        showAddTeacherConfirmationModal: false
    };
}

function addAnotherTeacherModal() {
    return {
        type: ADD_ANOTHER_TEACHER_OPEN_MODAL_REQUEST,
        showModal: true,
        showAddTeacherConfirmationModal: false
    };
}

function closeAddTeacherModal() {
    return {
        type: ADD_TEACHER_CLOSE_MODAL_REQUEST,
        showModal: false
    };
}

var ADD_TEACHER_REQUEST = exports.ADD_TEACHER_REQUEST = 'ADD_TEACHER_REQUEST';
var ADD_TEACHER_SUCCESS = exports.ADD_TEACHER_SUCCESS = 'ADD_TEACHER_SUCCESS';
var ADD_TEACHER_FAILURE = exports.ADD_TEACHER_FAILURE = 'ADD_TEACHER_FAILURE';

var addTeacher = exports.addTeacher = function addTeacher(teacher) {
    return { type: ADD_TEACHER_REQUEST, teacher: teacher, isSaveInProgress: true };
};

function addTeacherSuccess(userProfileId) {
    return {
        type: ADD_TEACHER_SUCCESS,
        userProfileId: userProfileId,
        isSaveInProgress: false,
        showAddTeacherConfirmationModal: true
    };
}

function addTeacherFailure(isServerError, addTeacherValidationMessage) {
    return {
        type: ADD_TEACHER_FAILURE,
        addTeacherValidationMessage: addTeacherValidationMessage,
        showAddTeacherValidationModal: true,
        isSaveInProgress: false,
        isServerError: isServerError
    };
}

var CLOSE_ADD_TEACHER_VALIDATION_MODAL = exports.CLOSE_ADD_TEACHER_VALIDATION_MODAL = 'CLOSE_ADD_TEACHER_VALIDATION_MODAL';

function closeAddTeacherValidationModal() {
    return {
        type: CLOSE_ADD_TEACHER_VALIDATION_MODAL,
        showAddTeacherValidationModal: false
    };
}

var OPEN_DELETE_TEACHER_MODAL = exports.OPEN_DELETE_TEACHER_MODAL = 'OPEN_DELETE_TEACHER_MODAL';

var openDeleteTeacherModal = exports.openDeleteTeacherModal = function openDeleteTeacherModal() {
    return { type: OPEN_DELETE_TEACHER_MODAL, isUserOperationModalOpen: true, operationType: 'deleteTeacher', selectedTeachers: [], notDeletedTeachers: [], deleteSuccess: false };
};

var DELETE_TEACHER_REQUEST = exports.DELETE_TEACHER_REQUEST = 'DELETE_TEACHER_REQUEST';
var DELETE_TEACHER_SUCCESS = exports.DELETE_TEACHER_SUCCESS = 'DELETE_TEACHER_SUCCESS';
var DELETE_TEACHER_FAILURE = exports.DELETE_TEACHER_FAILURE = 'DELETE_TEACHER_FAILURE';

var deleteTeacherRequest = exports.deleteTeacherRequest = function deleteTeacherRequest(userProfileIds) {
    return { type: DELETE_TEACHER_REQUEST, deletingTeacher: true, deleteSuccess: false, disableConfirmationButtons: true, userProfileIds: userProfileIds, operationType: 'deleteTeacher' };
};

var deleteTeacherSuccess = exports.deleteTeacherSuccess = function deleteTeacherSuccess(notDeletedTeachers) {
    return {
        type: DELETE_TEACHER_SUCCESS,
        deletingTeacher: false,
        deleteSuccess: true,
        refreshTeacherList: true,
        isUserOperationModalOpen: false,
        disableConfirmationButtons: false,
        notDeletedTeachers: notDeletedTeachers,
        selectedTeachers: []
    };
};

var deleteTeacherFailure = exports.deleteTeacherFailure = function deleteTeacherFailure() {
    return { type: DELETE_TEACHER_FAILURE, deletingTeacher: false, deleteSuccess: false, disableConfirmationButtons: false };
};

var SEND_VERIFICATION_EMAIL_REQUEST = exports.SEND_VERIFICATION_EMAIL_REQUEST = 'SEND_VERIFICATION_EMAIL_REQUEST';
var SEND_VERIFICATION_EMAIL_SUCCESS = exports.SEND_VERIFICATION_EMAIL_SUCCESS = 'SEND_VERIFICATION_EMAIL_SUCCESS';
var SEND_VERIFICATION_EMAIL_FAILURE = exports.SEND_VERIFICATION_EMAIL_FAILURE = 'SEND_VERIFICATION_EMAIL_FAILURE';

var sendVerificationEmailRequest = exports.sendVerificationEmailRequest = function sendVerificationEmailRequest(userProfileIds) {
    return { type: SEND_VERIFICATION_EMAIL_REQUEST, userProfileIds: userProfileIds };
};

var sendVerificationEmailSuccess = exports.sendVerificationEmailSuccess = function sendVerificationEmailSuccess(result) {
    return {
        type: SEND_VERIFICATION_EMAIL_SUCCESS,
        results: {
            totalRequests: result.totalRequests,
            successfulSending: result.successfulRequests,
            alreadyVerifiedEmails: result.alreadyVerifiedEmails,
            duplicateEmails: result.duplicateEmails,
            invalidRequests: result.invalidRequests
        }
    };
};

var sendVerificationEmailFailure = exports.sendVerificationEmailFailure = function sendVerificationEmailFailure(message) {
    return { type: SEND_VERIFICATION_EMAIL_FAILURE, message: message };
};

var CLOSE_EMAIL_VERIFICATION_MODAL = exports.CLOSE_EMAIL_VERIFICATION_MODAL = 'CLOSE_EMAIL_VERIFICATION_MODAL';

var closeVerificationModal = exports.closeVerificationModal = function closeVerificationModal() {
    return { type: CLOSE_EMAIL_VERIFICATION_MODAL };
};

/***/ }),
/* 51 */,
/* 52 */,
/* 53 */,
/* 54 */,
/* 55 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _queryString = __webpack_require__(177);

var _queryString2 = _interopRequireDefault(_queryString);

var _portalCommunication = __webpack_require__(879);

var _portalCommunication2 = _interopRequireDefault(_portalCommunication);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var PortalCommunication = function () {
    function PortalCommunication() {
        _classCallCheck(this, PortalCommunication);
    }

    _createClass(PortalCommunication, null, [{
        key: 'Configure',
        value: function Configure() {
            _portalCommunication2.default.requestLoadingSpinner(false);
        }

        // invoke this method to let the 3p-portal know
        // that we want to navigate to current module landing screen

    }, {
        key: 'navigateToLandingScreen',
        value: function navigateToLandingScreen() {
            var moduleName = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';

            _portalCommunication2.default.requestNavigateToLanding(moduleName);
        }

        // invoke this method to let the 3p-portal know
        // to make a api call

    }, {
        key: 'informMakeAPICall',
        value: function informMakeAPICall(param) {
            _portalCommunication2.default.informMakeAPICall(param);
        }
    }, {
        key: 'serverError',
        value: function serverError(error) {
            _portalCommunication2.default.requestServerError(error);
        }
    }, {
        key: 'requestModuleChange',
        value: function requestModuleChange(_ref) {
            var moduleId = _ref.moduleId,
                classId = _ref.classId,
                classroomName = _ref.classroomName,
                groupId = _ref.groupId,
                sourceModuleId = _ref.sourceModuleId;

            var queryParams = _queryString2.default.parse(location.search);
            var lang = queryParams.lang;
            var backUrl = encodeURIComponent(window.location.href);
            _portalCommunication2.default.requestModuleChange(moduleId, { lang: lang, classId: classId, classroomName: classroomName, groupId: groupId, backUrl: backUrl, sourceModuleId: sourceModuleId });
        }
    }]);

    return PortalCommunication;
}();

exports.default = PortalCommunication;

/***/ }),
/* 56 */,
/* 57 */,
/* 58 */,
/* 59 */,
/* 60 */,
/* 61 */,
/* 62 */,
/* 63 */,
/* 64 */,
/* 65 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var SHOW_TOAST = exports.SHOW_TOAST = 'SHOW_TOAST';
var showToast = exports.showToast = function showToast(message, messageType) {
    return { type: SHOW_TOAST, isToastVisible: true, message: message, messageType: messageType };
};

var HIDE_TOAST = exports.HIDE_TOAST = 'HIDE_TOAST';
var hideToast = exports.hideToast = function hideToast() {
    return { type: HIDE_TOAST, isToastVisible: false };
};

/***/ }),
/* 66 */,
/* 67 */,
/* 68 */,
/* 69 */,
/* 70 */,
/* 71 */,
/* 72 */,
/* 73 */,
/* 74 */,
/* 75 */,
/* 76 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactStyleable = __webpack_require__(6);

var _reactStyleable2 = _interopRequireDefault(_reactStyleable);

var _reactIntl = __webpack_require__(2);

var _svgIcon = __webpack_require__(21);

var _svgIcon2 = _interopRequireDefault(_svgIcon);

var _iconDictionary = __webpack_require__(8);

var _index = __webpack_require__(1706);

var _index2 = _interopRequireDefault(_index);

var _messages = __webpack_require__(708);

var _messages2 = _interopRequireDefault(_messages);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var EmptyState = function EmptyState(_ref) {
    var _ref$message = _ref.message,
        message = _ref$message === undefined ? '' : _ref$message,
        _ref$iconName = _ref.iconName,
        iconName = _ref$iconName === undefined ? '' : _ref$iconName,
        intl = _ref.intl;

    var messageToRender = message === '' ? intl.formatMessage(_messages2.default.noResultFound) : message;
    var iconToShow = iconName === '' ? _iconDictionary.Empty : iconName;

    return _react2.default.createElement(
        'div',
        { className: _index2.default.emptyContainer },
        _react2.default.createElement(
            'div',
            { className: _index2.default.emptyNotice },
            _react2.default.createElement(
                'div',
                { className: _index2.default.emptyState },
                _react2.default.createElement(
                    'div',
                    { className: _index2.default.emptyIconContainer },
                    _react2.default.createElement(_svgIcon2.default, { icon: iconToShow })
                )
            ),
            _react2.default.createElement(
                'div',
                { className: _index2.default.noResult },
                messageToRender
            )
        )
    );
};

EmptyState.propTypes = {
    iconName: _propTypes2.default.string,
    message: _propTypes2.default.string,
    intl: _reactIntl.intlShape.isRequired
};

exports.default = (0, _reactIntl.injectIntl)((0, _reactStyleable2.default)(_index2.default)(EmptyState));

/***/ }),
/* 77 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var productEnum = function productEnum() {
    _classCallCheck(this, productEnum);
};

productEnum.MATHLETICS = { id: 1, name: 'Mathletics' };
productEnum.SPELLODROME = { id: 3, name: 'Spellodrome' };
productEnum.INTOSICENCE = { id: 6, name: 'Intoscience' };
productEnum.PHONICS = { id: 8, name: 'Phonics' };
productEnum.MATLETICA = { id: 9, name: 'Mathletics Play' };
productEnum.READIWRITERSPELLING = { id: 10, name: 'Readiwriter Spelling' };
productEnum.READIWRITERWRITING = { id: 11, name: 'Readiwriter Writing' };
exports.default = productEnum;

/***/ }),
/* 78 */,
/* 79 */,
/* 80 */,
/* 81 */,
/* 82 */,
/* 83 */,
/* 84 */,
/* 85 */,
/* 86 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.isListDifferent = exports.createRows = exports.createRolloverSummaryRows = exports.createRolloverRows = exports.createTeacherRows = exports.createClassRows = exports.filterClasses = exports.filterTeachers = exports.filterStudents = exports.sort = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _orderBy = __webpack_require__(173);

var _orderBy2 = _interopRequireDefault(_orderBy);

var _startsWith = __webpack_require__(514);

var _startsWith2 = _interopRequireDefault(_startsWith);

var _includes = __webpack_require__(232);

var _includes2 = _interopRequireDefault(_includes);

var _classCourses = __webpack_require__(252);

var _classCourses2 = _interopRequireDefault(_classCourses);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var isEmpty = function isEmpty(str) {
    return !str || str.length === 0;
};

var retrieveFilterCriteria = function retrieveFilterCriteria(dataFilterOptions) {
    var lastName = dataFilterOptions.lastNames.find(function (item) {
        return item.selected;
    }).key;
    var year = dataFilterOptions.yearGroups.find(function (item) {
        return item.selected;
    }).key;
    var classroom = dataFilterOptions.classrooms.find(function (item) {
        return item.selected;
    }).key;

    return { lastName: lastName, year: year, classroom: classroom, searchTerm: dataFilterOptions.searchTerm };
};

var retrieveTeacherFilterCriteria = function retrieveTeacherFilterCriteria(dataFilterOptions) {
    var lastName = dataFilterOptions.lastNames.find(function (item) {
        return item.selected;
    }).key;
    var classroom = dataFilterOptions.classrooms.find(function (item) {
        return item.selected;
    }).key;

    return { lastName: lastName, classroom: classroom, searchTerm: dataFilterOptions.searchTerm };
};

var retrieveClassroomFilterCriteria = function retrieveClassroomFilterCriteria(dataFilterOptions) {
    var year = dataFilterOptions.yearGroups.find(function (item) {
        return item.selected;
    }).key;
    var teacher = dataFilterOptions.teachers.find(function (item) {
        return item.selected;
    }).data;

    return { year: year, teacher: teacher, searchTerm: dataFilterOptions.searchTerm };
};

var foundInTeachers = function foundInTeachers(teachersName, term) {
    return teachersName.filter(function (name) {
        return name.toLowerCase().indexOf(term) !== -1;
    }).length > 0;
};

var foundInClassroom = function foundInClassroom(classList, term) {
    if (classList.length === 0) {
        return false;
    }

    var filteredClasses = classList.filter(function (classroom) {
        return classroom.name.toLowerCase().indexOf(term) !== -1 || classroom.groupName.toLowerCase().indexOf(term) !== -1 || foundInTeachers(classroom.teachersName, term);
    });

    return filteredClasses.length > 0;
};

var foundInTeacherClassrooms = function foundInTeacherClassrooms(classList, term) {
    if (classList.length === 0) {
        return false;
    }

    var filteredClasses = classList.filter(function (classroom) {
        return classroom.name.toLowerCase().indexOf(term) !== -1;
    });

    return filteredClasses.length > 0;
};

var searchForClassroomTeachers = function searchForClassroomTeachers(teachers, term) {
    if (teachers.length === 0) {
        return false;
    }

    var filteredClasses = teachers.filter(function (teacher) {
        return teacher.name.toLowerCase().indexOf(term) !== -1;
    });

    return filteredClasses.length > 0;
};

var filterRows = function filterRows(rows, term) {
    var filterRowsData = rows.filter(function (row) {
        return row.firstName.toLowerCase().indexOf(term) !== -1 || row.lastName.toLowerCase().indexOf(term) !== -1 || row.password.toLowerCase().indexOf(term) !== -1 || row.userName.toLowerCase().indexOf(term) !== -1 || row.yearGroup.toLowerCase().indexOf(term) !== -1 || foundInClassroom(row.assignedClassrooms, term);
    });
    return filterRowsData;
};

var filterTeacherRows = function filterTeacherRows(rows, term) {
    var filterRowsData = rows.filter(function (row) {
        return row.title.toLowerCase().indexOf(term) !== -1 || row.firstName.toLowerCase().indexOf(term) !== -1 || row.lastName.toLowerCase().indexOf(term) !== -1 || row.userName.toLowerCase().indexOf(term) !== -1 || row.emailAddress.toLowerCase().indexOf(term) !== -1 || foundInTeacherClassrooms(row.assignedClassrooms, term);
    });
    return filterRowsData;
};

var filterClassRows = function filterClassRows(rows, term) {
    var filterRowsData = rows.filter(function (row) {
        return row.name.toLowerCase().indexOf(term) !== -1 || row.courseTitle.toLowerCase().indexOf(term) !== -1 || row.yearGroupShortName.toLowerCase().indexOf(term) !== -1 || searchForClassroomTeachers(row.teachers, term);
    });
    return filterRowsData;
};

var sort = exports.sort = function sort(list, propertyName, sortDirection) {
    return (0, _orderBy2.default)(list, function (item) {
        return isNaN(item[propertyName]) ? item[propertyName].toLowerCase() : item[propertyName];
    }, sortDirection);
};

var filterStudents = exports.filterStudents = function filterStudents(data, dataFilterOptions) {
    var filterCriteria = retrieveFilterCriteria(dataFilterOptions);
    var filteredData = data || [];
    if (data.length > 0 && filterCriteria) {
        if (!isEmpty(filterCriteria.lastName) && filterCriteria.lastName !== '-1') {
            filteredData = filteredData.filter(function (item) {
                if ((0, _startsWith2.default)(item.lastName.toLowerCase(), filterCriteria.lastName.toLowerCase())) {
                    return true;
                }
                return false;
            });
        }

        var selectedYearGroup = parseInt(filterCriteria.year, 10);
        if (selectedYearGroup !== -1) {
            filteredData = filteredData.filter(function (item) {
                if (item.yearGroupEnum === selectedYearGroup) {
                    return true;
                }
                return false;
            });
        }

        if (!isEmpty(filterCriteria.classroom) && filterCriteria.classroom !== '-1') {
            filteredData = filteredData.filter(function (item) {
                if (item.assignedClassrooms.length === 0 && filterCriteria.classroom === 'classes') {
                    return true;
                }
                var classes = item.assignedClassrooms.map(function (classroom) {
                    return classroom.name;
                });
                if (item.assignedClassrooms.length > 0 && filterCriteria.classroom === 'assignedStudents') {
                    return true;
                }
                return (0, _includes2.default)(classes, filterCriteria.classroom);
            });
        }

        if (!isEmpty(filterCriteria.searchTerm)) {
            var term = filterCriteria.searchTerm.toLowerCase();
            filteredData = filterRows(filteredData, term);
        }
    }

    return sort(filteredData, dataFilterOptions.sortColumn, dataFilterOptions.sortDirection);
};

var filterTeachers = exports.filterTeachers = function filterTeachers(data, dataFilterOptions) {
    var filterCriteria = retrieveTeacherFilterCriteria(dataFilterOptions);
    var filteredData = data || [];
    if (data.length > 0 && filterCriteria) {
        if (!isEmpty(filterCriteria.lastName) && filterCriteria.lastName !== '-1') {
            filteredData = filteredData.filter(function (item) {
                if ((0, _startsWith2.default)(item.lastName.toLowerCase(), filterCriteria.lastName.toLowerCase())) {
                    return true;
                }
                return false;
            });
        }

        if (!isEmpty(filterCriteria.classroom) && filterCriteria.classroom !== '-1') {
            filteredData = filteredData.filter(function (item) {
                if (item.assignedClassrooms.length === 0 && filterCriteria.classroom === 'classes') {
                    return true;
                }
                var classes = item.assignedClassrooms.map(function (classroom) {
                    return classroom.name;
                });
                return (0, _includes2.default)(classes, filterCriteria.classroom);
            });
        }

        if (!isEmpty(filterCriteria.searchTerm)) {
            var term = filterCriteria.searchTerm.toLowerCase();
            filteredData = filterTeacherRows(filteredData, term);
        }
    }

    return sort(filteredData, dataFilterOptions.sortColumn, dataFilterOptions.sortDirection);
};

var filterClasses = exports.filterClasses = function filterClasses(data, dataFilterOptions) {
    var filterCriteria = retrieveClassroomFilterCriteria(dataFilterOptions);
    var filteredData = data || [];
    if (data.length > 0 && filterCriteria) {
        var selectedYearGroup = parseInt(filterCriteria.year, 10);
        if (selectedYearGroup !== -1) {
            filteredData = filteredData.filter(function (item) {
                if (item.yearGroupEnum === selectedYearGroup) {
                    return true;
                }
                return false;
            });
        }
        if (!isEmpty(filterCriteria.teacher) && filterCriteria.teacher !== '-1') {
            var selectedTeacherProfileId = filterCriteria.teacher.userProfileId;
            filteredData = filteredData.filter(function (item) {
                if (item.teachers.length > 0) {
                    var teacherProfileIds = item.teachers.map(function (teacher) {
                        return teacher.userProfileId;
                    });
                    if (teacherProfileIds.indexOf(selectedTeacherProfileId) !== -1) {
                        return true;
                    }
                }

                return false;
            });
        }

        if (!isEmpty(filterCriteria.searchTerm)) {
            var term = filterCriteria.searchTerm.toLowerCase();
            filteredData = filterClassRows(filteredData, term);
        }
    }

    return sort(filteredData, dataFilterOptions.sortColumn, dataFilterOptions.sortDirection);
};

var renderClassCourses = function renderClassCourses(classroom, intl) {
    var currentGroup = classroom.classroomGroups.find(function (classGroup) {
        return classGroup.classroomId === classroom.classroomId;
    });

    var isOptedOut = currentGroup && currentGroup.isOptedOut || false;
    return (0, _classCourses2.default)(_extends({}, classroom, { yearGroup: classroom.yearGroupEnum, intl: intl, isOptedOut: isOptedOut }));
};

var createClassRows = exports.createClassRows = function createClassRows(classes, intl) {
    return classes.map(function (classroom) {
        return {
            classroomId: classroom.classroomId,
            name: classroom.name,
            yearGroupEnum: classroom.yearGroupEnum.toString(),
            year: classroom.yearGroupShortName.toString(),
            courseTitle: classroom.courseTitle,
            upfCourseTitle: classroom.upfCourseTitle,
            conquestCourseTitle: classroom.conquestCourseTitle,
            courses: renderClassCourses(classroom, intl),
            teachers: classroom.teachers.map(function (teacher) {
                return teacher.name;
            }),
            teachersCount: classroom.teachers.length,
            studentsCount: classroom.studentsProfileId.length
        };
    });
};

var createTeacherRows = exports.createTeacherRows = function createTeacherRows(teachers) {
    var rows = [];
    teachers.forEach(function (teacher) {
        var info = {
            userProfileId: teacher.userProfileId,
            title: teacher.title,
            firstName: teacher.firstName,
            lastName: teacher.lastName,
            emailAddress: teacher.emailAddress,
            emailStatus: teacher.emailStatus,
            userName: teacher.userName,
            password: teacher.password,
            displayTitle: teacher.displayTitle
        };

        var teacherDetail = info;
        var classesCount = teacher.assignedClassrooms.length;
        if (teacher.assignedClassrooms.length > 0) {
            var classes = teacher.assignedClassrooms.map(function (classroom) {
                return classroom.name;
            });
            teacherDetail = _extends({}, info, { class: classes, classesCount: classesCount });
        } else {
            teacherDetail = _extends({}, info, { class: '', classesCount: classesCount });
        }

        rows.push(teacherDetail);
    });

    return rows;
};

var createRolloverRows = exports.createRolloverRows = function createRolloverRows(rolloverItems) {
    var rows = [];

    rolloverItems.forEach(function (rowItem) {
        var info = {
            index: rowItem.index,
            studentFirstName: rowItem.studentFirstName,
            studentLastName: rowItem.studentLastName,
            previousUsername: rowItem.previousUsername,
            year: rowItem.studentYearGroup,
            className: rowItem.classroomName,
            courseTitle: rowItem.courseTitle,
            teacherEmail: rowItem.teacherEmail,
            title: rowItem.teacherTitle,
            teacherFirstName: rowItem.teacherFirstName,
            teacherLastName: rowItem.teacherLastName
        };
        rows.push(info);
    });

    return rows;
};

var createRolloverSummaryRows = exports.createRolloverSummaryRows = function createRolloverSummaryRows(rolloverSummary) {
    var filterType = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'newStudents';

    var rows = [];

    switch (filterType) {
        case 'newStudents':
            rolloverSummary.newStudents.forEach(function (rowItem) {
                var info = {
                    id: rowItem.id,
                    firstName: rowItem.firstName,
                    surname: rowItem.surname,
                    yearGroup: rowItem.yearGroup,
                    classroomName: rowItem.classroomName,
                    username: rowItem.username,
                    password: rowItem.password
                };
                rows.push(info);
            });
            break;

        case 'updatedStudents':
            rolloverSummary.updatedStudents.forEach(function (rowItem) {
                var info = {
                    id: rowItem.id,
                    firstName: rowItem.firstName,
                    surname: rowItem.surname,
                    yearGroup: rowItem.yearGroup,
                    classroomName: rowItem.classroomName,
                    username: rowItem.username,
                    password: rowItem.password
                };
                rows.push(info);
            });
            break;

        case 'unassignedStudents':
            rolloverSummary.unassignedStudents.forEach(function (rowItem) {
                var info = {
                    id: rowItem.id,
                    firstName: rowItem.firstName,
                    surname: rowItem.surname,
                    username: rowItem.username,
                    password: rowItem.password
                };
                rows.push(info);
            });
            break;

        case 'transferredStudents':
            rolloverSummary.transferredStudents.forEach(function (rowItem) {
                var info = {
                    id: rowItem.id,
                    firstName: rowItem.firstName,
                    surname: rowItem.surname,
                    yearGroup: rowItem.yearGroup,
                    classroomName: rowItem.classroomName,
                    username: rowItem.username,
                    password: rowItem.password
                };
                rows.push(info);
            });

            break;

        case 'newTeachers':
            rolloverSummary.newTeachers.forEach(function (rowItem) {
                var info = {
                    id: rowItem.id,
                    firstName: rowItem.firstName,
                    surname: rowItem.surname,
                    title: rowItem.title,
                    email: rowItem.email,
                    username: rowItem.username
                };
                rows.push(info);
            });
            break;

        case 'updatedTeachers':
            rolloverSummary.updatedTeachers.forEach(function (rowItem) {
                var info = {
                    id: rowItem.id,
                    firstName: rowItem.firstName,
                    surname: rowItem.surname,
                    title: rowItem.title,
                    email: rowItem.email,
                    username: rowItem.username
                };
                rows.push(info);
            });
            break;

        case 'newClassrooms':
            rolloverSummary.newClassrooms.forEach(function (rowItem) {
                var info = {
                    id: rowItem.id,
                    classroomName: rowItem.classroomName,
                    teacherName: rowItem.teacherName,
                    yearGroup: rowItem.yearGroup,
                    assignedStudents: rowItem.assignedStudents
                };
                rows.push(info);
            });
            break;

        case 'updatedClassrooms':
            rolloverSummary.updatedClassrooms.forEach(function (rowItem) {
                var info = {
                    id: rowItem.id,
                    classroomName: rowItem.classroomName,
                    teacherName: rowItem.teacherName,
                    yearGroup: rowItem.yearGroup,
                    assignedStudents: rowItem.assignedStudents
                };
                rows.push(info);
            });
            break;

        default:
            rows = [];
            break;
    }

    return rows;
};

var createRows = exports.createRows = function createRows(students) {
    var rows = [];
    students.forEach(function (student) {
        var info = {
            userProfileId: student.userProfileId,
            firstName: student.firstName,
            lastName: student.lastName,
            yearGroupEnum: student.yearGroupEnum,
            year: student.yearGroup,
            userName: student.userName,
            password: student.password
        };

        var teachers = '';
        var studentDetail = info;
        var classesCount = student.assignedClassrooms.length;
        if (student.assignedClassrooms.length > 0) {
            var teachersName = [];
            var classes = student.assignedClassrooms.map(function (data) {
                return data.name;
            });
            var groups = student.assignedClassrooms.map(function (data) {
                return data.groupName;
            });
            student.assignedClassrooms.forEach(function (classroom) {
                if (classroom.teachersName.length === 0) {
                    teachersName.push('-');
                } else {
                    teachersName.push(classroom.teachersName.join(', '));
                }
            });
            teachers = teachersName;
            studentDetail = _extends({}, info, { class: classes, group: groups, teachers: teachers, classesCount: classesCount });
        } else {
            studentDetail = _extends({}, info, { class: '', group: '', teachers: teachers, classesCount: classesCount });
        }

        rows.push(studentDetail);
    });

    return rows;
};

var isListDifferent = exports.isListDifferent = function isListDifferent(newList, oldList, key) {
    var idInNewList = [];
    var idInOldLIst = [];

    if (!newList) {
        idInNewList = newList.map(key);
    }

    if (!oldList) {
        idInOldLIst = oldList.map(key);
    }

    if (idInNewList.length !== idInOldLIst.length) {
        return true;
    }

    var nonMatchingIds = idInNewList.filter(function (id) {
        return idInOldLIst.indexOf(id) === -1;
    });
    return nonMatchingIds.length !== 0;
};

/***/ }),
/* 87 */,
/* 88 */,
/* 89 */,
/* 90 */,
/* 91 */,
/* 92 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1177);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(5)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../node_modules/css-loader/index.js?modules&localIdentName=[local]---[hash:base64:5]!../../../node_modules/postcss-loader/lib/index.js!../../../node_modules/sass-loader/index.js!./index.scss", function() {
			var newContent = require("!!../../../node_modules/css-loader/index.js?modules&localIdentName=[local]---[hash:base64:5]!../../../node_modules/postcss-loader/lib/index.js!../../../node_modules/sass-loader/index.js!./index.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 93 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _reactIntl = __webpack_require__(2);

exports.default = (0, _reactIntl.defineMessages)({
    downloadTemplate: {
        id: 'roll-over.components.downloadStudentRoll',
        defaultMessage: 'Download template'
    },
    download: {
        id: 'roll-over.components.download',
        defaultMessage: 'Download'
    },
    downloading: {
        id: 'roll-over.components.downloading',
        defaultMessage: 'Downloading'
    },
    header: {
        id: 'roll-over.components.header',
        defaultMessage: 'Rollover'
    },
    schoolRoll: {
        id: 'roll-over.components.schoolRoll',
        defaultMessage: 'school roll'
    },
    initialTitle: {
        id: 'roll-over.components.initialTitle',
        defaultMessage: 'Follow these steps to complete a rollover for {productName}'
    },
    initialDownloadTemplate: {
        id: 'roll-over.components.initialDownloadTemplate',
        defaultMessage: 'Click icon to download your {productName} school roll'
    },
    initialUpdateSpreadsheet: {
        id: 'roll-over.components.initialUpdateSpreadsheet',
        defaultMessage: 'Update downloaded spreadsheet'
    },
    contentLabel: {
        id: 'roll-over.components.contentLabel',
        defaultMessage: 'Use the template below to upload new students into'
    },
    uploadMessage: {
        id: 'roll-over.components.uploadMessage',
        defaultMessage: 'Upload your excel (xlsx format) file to rollover then select \'Confirm\' to proceed'
    },
    uploadFile: {
        id: 'roll-over.components.uploadFile',
        defaultMessage: 'Upload file'
    },
    studentFirstName: {
        id: 'roll-over.components.studentFirstName',
        defaultMessage: 'STUDENT FIRST NAME'
    },
    studentSurname: {
        id: 'roll-over.components.studentSurname',
        defaultMessage: 'STUDENT SURNAME'
    },
    previousUsername: {
        id: 'roll-over.components.previousUsername',
        defaultMessage: 'Previous Username'
    },
    year: {
        id: 'roll-over.components.year',
        defaultMessage: 'YEAR'
    },
    className: {
        id: 'roll-over.components.className',
        defaultMessage: 'CLASS NAME'
    },
    title: {
        id: 'roll-over.components.title',
        defaultMessage: 'TITLE'
    },
    teacherName: {
        id: 'roll-over.components.teacherName',
        defaultMessage: 'TEACHER NAME'
    },
    teacherFirstName: {
        id: 'roll-over.components.teacherFirstName',
        defaultMessage: 'TEACHER FIRST NAME'
    },
    teacherSurname: {
        id: 'roll-over.components.teacherSurname',
        defaultMessage: 'TEACHER SURNAME'
    },
    teacherEmail: {
        id: 'roll-over.components.teacherEmail',
        defaultMessage: 'TEACHER EMAIL'
    },
    back: {
        id: 'roll-over.components.back',
        defaultMessage: 'Back'
    },
    confirm: {
        id: 'roll-over.components.confirm',
        defaultMessage: 'Confirm'
    },
    selectionTitle: {
        id: 'roll-over.components.selectionTitle',
        defaultMessage: 'Select the type of rollover you wish to perform'
    },
    fileFormatValidationMessage: {
        id: 'roll-over.components.fileFormatValidationMessage',
        defaultMessage: 'Incorrect file format'
    },
    fileSizeMessage: {
        id: 'roll-over.components.fileSizeMessage',
        defaultMessage: 'File size exceeds 1MB'
    },
    somethingWentWrong: {
        id: 'roll-over.components.somethingWentWrong',
        defaultMessage: 'Oops, something went wrong'
    },
    pleaseTryUploadingAgain: {
        id: 'roll-over.components.pleaseTryUploadingAgain',
        defaultMessage: 'Please try uploading your file again.'
    },
    partialRolloverTitle: {
        id: 'roll-over.components.partialRolloverTitle',
        defaultMessage: 'Partial rollover'
    },
    partialRolloverDesc1: {
        id: 'roll-over.components.partialRolloverDesc1',
        defaultMessage: 'This will only update or add the {productName} students listed in your upload.'
    },
    partialRolloverDesc2: {
        id: 'roll-over.components.partialRolloverDesc2',
        defaultMessage: 'No other students or products will be affected.'
    },
    fullRolloverTitle: {
        id: 'roll-over.components.fullRolloverTitle',
        defaultMessage: 'Full rollover'
    },
    fullRolloverDesc1: {
        id: 'roll-over.components.fullRolloverDesc1',
        defaultMessage: 'This will update ALL {productName} students on your school list.'
    },
    fullRolloverDesc2: {
        id: 'roll-over.components.fullRolloverDesc2',
        defaultMessage: 'Current {productName} students not listed in this rollover will be unassigned and unable to access the resource (unless reassigned).'
    },
    closeButton: {
        id: 'roll-over.components.closeButton',
        defaultMessage: 'Close'
    },
    nextButton: {
        id: 'roll-over.components.nextButton',
        defaultMessage: 'Next'
    },
    backButton: {
        id: 'roll-over.components.backButton',
        defaultMessage: 'Back'
    },
    downloadSchoolDataBtn: {
        id: 'roll-over.components.downloadSchoolDataBtn',
        defaultMessage: 'Download current school list'
    },
    downloadTemplateBtn: {
        id: 'roll-over.components.downloadTemplateBtn',
        defaultMessage: 'Download template'
    },
    buttonIcon: {
        id: 'roll-over.components.buttonIcon',
        defaultMessage: '?'
    },
    verifying: {
        id: 'roll-over.components.verifying',
        defaultMessage: 'verifying'
    },
    errorsInYourFile: {
        id: 'roll-over.components.errorsInYourFile',
        defaultMessage: 'Oops, there are errors in your file'
    },
    row: {
        id: 'roll-over.components.row',
        defaultMessage: 'Row'
    },
    aboutToProceed: {
        id: 'roll-over.components.aboutToProceed',
        defaultMessage: 'You are about to proceed with a'
    },
    areYouSure: {
        id: 'roll-over.components.areYouSure',
        defaultMessage: 'Are you sure you want to continue?'
    },
    cancel: {
        id: 'roll-over.components.cancel',
        defaultMessage: 'Cancel'
    },
    proceed: {
        id: 'roll-over.components.proceed',
        defaultMessage: 'Proceed'
    },
    fullRollOver: {
        id: 'roll-over.components.fullRollOver',
        defaultMessage: 'full rollover.'
    },
    partialRollOver: {
        id: 'roll-over.components.partialRollOver',
        defaultMessage: 'partial rollover.'
    },
    rolloverComplete: {
        id: 'roll-over.components.rolloverComplete',
        defaultMessage: 'Rollover complete'
    },
    rollOverHasCompleted: {
        id: 'roll-over.components.rollOverHasCompleted',
        defaultMessage: 'Rollover has been completed. Below is the results summary of this rollover'
    },
    newStudent: {
        id: 'roll-over.components.newStudent',
        defaultMessage: 'New student'
    },
    updatedStudent: {
        id: 'roll-over.components.updatedStudent',
        defaultMessage: 'Updated student'
    },
    unassignedStudent: {
        id: 'roll-over.components.unassignedStudent',
        defaultMessage: 'Unassigned student'
    },
    transferredStudent: {
        id: 'roll-over.components.transferredStudent',
        defaultMessage: 'Transferred student'
    },
    assignedStudent: {
        id: 'roll-over.components.assignedStudent',
        defaultMessage: 'ASSIGNED STUDENT'
    },
    newTeacher: {
        id: 'roll-over.components.newTeacher',
        defaultMessage: 'New teacher'
    },
    updatedTeacher: {
        id: 'roll-over.components.upatedTeacher',
        defaultMessage: 'Updated teacher'
    },
    newStudents: {
        id: 'roll-over.components.newStudents',
        defaultMessage: 'New students'
    },
    updatedStudents: {
        id: 'roll-over.components.updatedStudents',
        defaultMessage: 'Updated students'
    },
    unassignedStudents: {
        id: 'roll-over.components.unassignedStudents',
        defaultMessage: 'Unassigned students'
    },
    assignedStudents: {
        id: 'roll-over.components.assignedStudents',
        defaultMessage: 'ASSIGNED STUDENTS'
    },
    transferredStudents: {
        id: 'roll-over.components.transferredStudents',
        defaultMessage: 'Transferred students'
    },
    newTeachers: {
        id: 'roll-over.components.newTeachers',
        defaultMessage: 'New teachers'
    },
    unassignedTeachers: {
        id: 'roll-over.components.unassignedTeachers',
        defaultMessage: 'Unassigned Teachers'
    },
    updatedTeachers: {
        id: 'roll-over.components.updatedTeachers',
        defaultMessage: 'Updated teachers'
    },
    newClasses: {
        id: 'roll-over.components.newClasses',
        defaultMessage: 'New classes'
    },
    updatedClasses: {
        id: 'roll-over.components.updatedClasses',
        defaultMessage: 'Updated classes'
    },
    summary: {
        id: 'roll-over.components.summary',
        defaultMessage: 'Summary'
    },
    firstName: {
        id: 'roll-over.components.firstName',
        defaultMessage: 'FIRST NAME'
    },
    lastName: {
        id: 'roll-over.components.lastName',
        defaultMessage: 'LAST NAME'
    },
    username: {
        id: 'roll-over.components.username',
        defaultMessage: 'USERNAME'
    },
    password: {
        id: 'roll-over.components.password',
        defaultMessage: 'PASSWORD'
    },
    surname: {
        id: 'roll-over.components.surname',
        defaultMessage: 'SURNAME'
    },
    done: {
        id: 'roll-over.components.done',
        defaultMessage: 'Done'
    },
    print: {
        id: 'roll-over.components.print',
        defaultMessage: 'Print'
    },
    signInCards: {
        id: 'roll-over.components.signInCards',
        defaultMessage: 'sign in cards'
    },
    exportSummary: {
        id: 'roll-over.components.exportSummary',
        defaultMessage: 'Export summary'
    },
    includeUnassigned: {
        id: 'roll-over.components.includeUnassigned',
        defaultMessage: 'Include unassigned students in this download'
    },
    includeBulkTransfer: {
        id: 'roll-over.components.includeBulkTransfer',
        defaultMessage: 'Include students username for Bulk Transfer'
    },
    somethingWrongOnOurSide: {
        id: 'roll-over.components.somethingWrongOnOurSide',
        defaultMessage: 'Something went wrong on our side and we are working on it.'
    },
    pleaseTryAgain: {
        id: 'roll-over.components.pleaseTryAgain',
        defaultMessage: 'Please try again later or contact Tech Support'
    },
    theNewStudent: {
        id: 'roll-over.components.theNewStudent',
        defaultMessage: 'new student sign in cards'
    },
    theUpdatedStudent: {
        id: 'roll-over.components.theUpdatedStudent',
        defaultMessage: 'updated student sign in cards'
    },
    theUnassignedStudent: {
        id: 'roll-over.components.theUnassignedStudent',
        defaultMessage: 'unassigned student sign in cards'
    },
    theTransferredStudent: {
        id: 'roll-over.components.theTransferredStudent',
        defaultMessage: 'transferred student sign in cards'
    },
    theNewTeacher: {
        id: 'roll-over.components.theNewTeacher',
        defaultMessage: 'new teacher sign in cards'
    },
    theUpdatedTeacher: {
        id: 'roll-over.components.theUpatedTeacher',
        defaultMessage: 'updated teacher sign in cards'
    },
    theUnassignedTeacher: {
        id: 'roll-over.components.theUnassignedTeacher',
        defaultMessage: 'unassigned teacher sign in cards'
    },
    theNewClasses: {
        id: 'roll-over.components.theNewClasses',
        defaultMessage: 'new classes sign in cards'
    },
    theUpdatedClasses: {
        id: 'roll-over.components.theUpdatedClasses',
        defaultMessage: 'updated classes sign in cards'
    },
    newStudentsFile: {
        id: 'roll-over.components.newStudentsFile',
        defaultMessage: 'newStudents.xlsx'
    },
    updatedStudentsFile: {
        id: 'roll-over.components.updatedStudentsFile',
        defaultMessage: 'updatedStudents.xlsx'
    },
    unassignedStudentsFile: {
        id: 'roll-over.components.unassignedStudentsFile',
        defaultMessage: 'unassignedStudents.xlsx'
    },
    transferredStudentsFile: {
        id: 'roll-over.components.transferredStudentsFile',
        defaultMessage: 'transferredStudents.xlsx'
    },
    newTeachersFile: {
        id: 'roll-over.components.newTeachersFile',
        defaultMessage: 'newTeachers.xlsx'
    },
    updatedTeachersFile: {
        id: 'roll-over.components.updatedTeachersFile',
        defaultMessage: 'updatedTeachers.xlsx'
    },
    newClassroomsFile: {
        id: 'roll-over.components.newClassroomsFile',
        defaultMessage: 'newClassrooms.xlsx'
    },
    updatedClassroomsFile: {
        id: 'roll-over.components.updatedClassroomsFile',
        defaultMessage: 'updatedClassrooms.xlsx'
    }
});

/***/ }),
/* 94 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _index = __webpack_require__(1729);

var _index2 = _interopRequireDefault(_index);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Spinner = function Spinner() {
    return _react2.default.createElement(
        'div',
        { className: _index2.default.loadingContainer },
        _react2.default.createElement(
            'div',
            { className: _index2.default.loadingIcon },
            _react2.default.createElement('div', { className: _index2.default.loader + ' ' + _index2.default.loaderSpeed })
        )
    );
};

exports.default = Spinner;

/***/ }),
/* 95 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var UPDATE_SELECTED_YEAR_GROUP = exports.UPDATE_SELECTED_YEAR_GROUP = 'UPDATE_SELECTED_YEAR_GROUP';

var updateSelectedYearGroup = exports.updateSelectedYearGroup = function updateSelectedYearGroup(selectedYearGroup) {
    return { type: UPDATE_SELECTED_YEAR_GROUP, selectedYearGroup: selectedYearGroup };
};

var UPDATE_ASSIGN_STUDENT_SEARCH_TERM = exports.UPDATE_ASSIGN_STUDENT_SEARCH_TERM = 'UPDATE_ASSIGN_STUDENT_SEARCH_TERM';

var updateSearchTerm = exports.updateSearchTerm = function updateSearchTerm(searchTerm) {
    return { type: UPDATE_ASSIGN_STUDENT_SEARCH_TERM, searchTerm: searchTerm };
};

var GET_STUDENT_CLASSROOMS_RELATION_REQUEST = exports.GET_STUDENT_CLASSROOMS_RELATION_REQUEST = 'GET_STUDENT_CLASSROOMS_RELATION_REQUEST';
var GET_STUDENT_CLASSROOMS_RELATION_SUCCESS = exports.GET_STUDENT_CLASSROOMS_RELATION_SUCCESS = 'GET_STUDENT_CLASSROOMS_RELATION_SUCCESS';
var GET_STUDENT_CLASSROOMS_RELATION_FAILURE = exports.GET_STUDENT_CLASSROOMS_RELATION_FAILURE = 'GET_STUDENT_CLASSROOMS_RELATION_FAILURE';

var getStudentClassroomsRelationRequest = exports.getStudentClassroomsRelationRequest = function getStudentClassroomsRelationRequest(userProfileId, productId) {
    return { type: GET_STUDENT_CLASSROOMS_RELATION_REQUEST, userProfileId: userProfileId, productId: productId };
};

var getStudentClassroomsRelationSuccess = exports.getStudentClassroomsRelationSuccess = function getStudentClassroomsRelationSuccess(classrooms) {
    return { type: GET_STUDENT_CLASSROOMS_RELATION_SUCCESS, classrooms: classrooms };
};

var getStudentClassroomsRelationFailure = exports.getStudentClassroomsRelationFailure = function getStudentClassroomsRelationFailure() {
    return { type: GET_STUDENT_CLASSROOMS_RELATION_FAILURE };
};

var ASSIGN_STUDENT_REQUEST = exports.ASSIGN_STUDENT_REQUEST = 'ASSIGN_STUDENT_REQUEST';
var ASSIGN_STUDENT_SUCCESS = exports.ASSIGN_STUDENT_SUCCESS = 'ASSIGN_STUDENT_SUCCESS';
var ASSIGN_STUDENT_FAILURE = exports.ASSIGN_STUDENT_FAILURE = 'ASSIGN_STUDENT_FAILURE';

var assignStudentRequest = exports.assignStudentRequest = function assignStudentRequest(assignedClassrooms, userProfileId, productId) {
    return { type: ASSIGN_STUDENT_REQUEST, assignedClassrooms: assignedClassrooms, userProfileId: userProfileId, productId: productId, isSaveInProgress: true };
};

var assignStudentSuccess = exports.assignStudentSuccess = function assignStudentSuccess() {
    return { type: ASSIGN_STUDENT_SUCCESS, isSaveInProgress: false };
};

var assignStudentFailure = exports.assignStudentFailure = function assignStudentFailure() {
    return { type: ASSIGN_STUDENT_FAILURE, isSaveInProgress: false };
};

var UPDATE_CLASSROOM_REQUEST = exports.UPDATE_CLASSROOM_REQUEST = 'UPDATE_CLASSROOM_REQUEST';

var updateClassrooms = exports.updateClassrooms = function updateClassrooms() {
    return { type: UPDATE_CLASSROOM_REQUEST };
};

var CLOSE_ASSIGN_CONFIRMATION_MODAL_REQUEST = exports.CLOSE_ASSIGN_CONFIRMATION_MODAL_REQUEST = 'CLOSE_ASSIGN_CONFIRMATION_MODAL_REQUEST';

var closeAssignConfirmationModal = exports.closeAssignConfirmationModal = function closeAssignConfirmationModal() {
    return { type: CLOSE_ASSIGN_CONFIRMATION_MODAL_REQUEST };
};

var CANCEL_USER_ASSIGN_REQUEST = exports.CANCEL_USER_ASSIGN_REQUEST = 'CANCEL_USER_ASSIGN_REQUEST';

var cancelUserAssign = exports.cancelUserAssign = function cancelUserAssign() {
    return { type: CANCEL_USER_ASSIGN_REQUEST };
};

var RESET_USER_CLASSROOM_RELATION = exports.RESET_USER_CLASSROOM_RELATION = 'RESET_USER_CLASSROOM_RELATION';

var resetUserClassroomRelation = exports.resetUserClassroomRelation = function resetUserClassroomRelation() {
    return { type: RESET_USER_CLASSROOM_RELATION };
};

var GET_TEACHER_CLASSROOMS_RELATION_REQUEST = exports.GET_TEACHER_CLASSROOMS_RELATION_REQUEST = 'GET_TEACHER_CLASSROOMS_RELATION_REQUEST';
var GET_TEACHER_CLASSROOMS_RELATION_SUCCESS = exports.GET_TEACHER_CLASSROOMS_RELATION_SUCCESS = 'GET_TEACHER_CLASSROOMS_RELATION_SUCCESS';
var GET_TEACHER_CLASSROOMS_RELATION_FAILURE = exports.GET_TEACHER_CLASSROOMS_RELATION_FAILURE = 'GET_TEACHER_CLASSROOMS_RELATION_FAILURE';

var getTeacherClassroomsRelationRequest = exports.getTeacherClassroomsRelationRequest = function getTeacherClassroomsRelationRequest(userProfileId, productId) {
    return { type: GET_TEACHER_CLASSROOMS_RELATION_REQUEST, userProfileId: userProfileId, productId: productId };
};

var getTeacherClassroomsRelationSuccess = exports.getTeacherClassroomsRelationSuccess = function getTeacherClassroomsRelationSuccess(classrooms) {
    return { type: GET_TEACHER_CLASSROOMS_RELATION_SUCCESS, classrooms: classrooms };
};

var getTeacherClassroomsRelationFailure = exports.getTeacherClassroomsRelationFailure = function getTeacherClassroomsRelationFailure() {
    return { type: GET_TEACHER_CLASSROOMS_RELATION_FAILURE };
};

var ASSIGN_TEACHER_REQUEST = exports.ASSIGN_TEACHER_REQUEST = 'ASSIGN_TEACHER_REQUEST';
var ASSIGN_TEACHER_SUCCESS = exports.ASSIGN_TEACHER_SUCCESS = 'ASSIGN_TEACHER_SUCCESS';
var ASSIGN_TEACHER_FAILURE = exports.ASSIGN_TEACHER_FAILURE = 'ASSIGN_TEACHER_FAILURE';

var assignTeacherRequest = exports.assignTeacherRequest = function assignTeacherRequest(assignedClassrooms, userProfileId, productId) {
    return { type: ASSIGN_TEACHER_REQUEST, assignedClassrooms: assignedClassrooms, userProfileId: userProfileId, productId: productId, isSaveInProgress: true };
};

var assignTeacherSuccess = exports.assignTeacherSuccess = function assignTeacherSuccess() {
    return { type: ASSIGN_TEACHER_SUCCESS, isSaveInProgress: false };
};

var assignTeacherFailure = exports.assignTeacherFailure = function assignTeacherFailure() {
    return { type: ASSIGN_TEACHER_FAILURE, isSaveInProgress: false };
};

var CLASSROOM_TEACHER_MAPPING_SUCCESS = exports.CLASSROOM_TEACHER_MAPPING_SUCCESS = 'CLASSROOM_TEACHER_MAPPING_SUCCESS';

var classroomTeacherMappingSuccess = exports.classroomTeacherMappingSuccess = function classroomTeacherMappingSuccess() {
    return { type: CLASSROOM_TEACHER_MAPPING_SUCCESS };
};

var ASSIGN_TEACHER_TO_CLASSROOM_REQUEST = exports.ASSIGN_TEACHER_TO_CLASSROOM_REQUEST = 'ASSIGN_TEACHER_TO_CLASSROOM_REQUEST';
var ASSIGN_TEACHER_TO_CLASSROOM_SUCCESS = exports.ASSIGN_TEACHER_TO_CLASSROOM_SUCCESS = 'ASSIGN_TEACHER_TO_CLASSROOM_SUCCESS';
var ASSIGN_TEACHER_TO_CLASSROOM_FAILURE = exports.ASSIGN_TEACHER_TO_CLASSROOM_FAILURE = 'ASSIGN_TEACHER_TO_CLASSROOM_FAILURE';

var assignTeacherToClassroomRequest = exports.assignTeacherToClassroomRequest = function assignTeacherToClassroomRequest(teacherClassroomMapping, context) {
    return { type: ASSIGN_TEACHER_TO_CLASSROOM_REQUEST, teacherClassroomMapping: teacherClassroomMapping, context: context, isSaveInProgress: true };
};

var assignTeacherToClassroomSuccess = exports.assignTeacherToClassroomSuccess = function assignTeacherToClassroomSuccess(context) {
    context.history.push('/teachers');
    return { type: ASSIGN_TEACHER_TO_CLASSROOM_SUCCESS, isSaveInProgress: false };
};

var assignTeacherToClassroomFailure = exports.assignTeacherToClassroomFailure = function assignTeacherToClassroomFailure() {
    return { type: ASSIGN_TEACHER_TO_CLASSROOM_FAILURE, isSaveInProgress: false };
};

/***/ }),
/* 96 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var classEnum = function classEnum() {
    _classCallCheck(this, classEnum);
};

classEnum.SCHOOL_COURSES = 'schoolcourses';
classEnum.FALLBACK_ID = -1;
exports.default = classEnum;

/***/ }),
/* 97 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var CHECK_COMMON_TASKS_REQUEST = exports.CHECK_COMMON_TASKS_REQUEST = 'CHECK_COMMON_TASKS_REQUEST';
var CHECK_COMMON_TASKS_SUCCESS = exports.CHECK_COMMON_TASKS_SUCCESS = 'CHECK_COMMON_TASKS_SUCCESS';
var CHECK_COMMON_TASKS_FAILURE = exports.CHECK_COMMON_TASKS_FAILURE = 'CHECK_COMMON_TASKS_FAILURE';
var CANCEL_ASSIGN_REQUEST = exports.CANCEL_ASSIGN_REQUEST = 'CANCEL_ASSIGN_REQUEST';
var ACTIVATE_MODAL_REQUEST = exports.ACTIVATE_MODAL_REQUEST = 'ACTIVATE_MODAL_REQUEST';
var DEACTIVATE_MODAL_REQUEST = exports.DEACTIVATE_MODAL_REQUEST = 'DEACTIVATE_MODAL_REQUEST';
var ASSIGN_COURSES_REQUEST = exports.ASSIGN_COURSES_REQUEST = 'ASSIGN_COURSES_REQUEST';
var ASSIGN_COURSES_SUCCESS = exports.ASSIGN_COURSES_SUCCESS = 'ASSIGN_COURSES_SUCCESS';
var ASSIGN_COURSES_FAILURE = exports.ASSIGN_COURSES_FAILURE = 'ASSIGN_COURSES_FAILURE';
var SHOW_COURSE_DETAILS = exports.SHOW_COURSE_DETAILS = 'SHOW_COURSE_DETAILS';
var HIDE_COURSE_DETAILS = exports.HIDE_COURSE_DETAILS = 'HIDE_COURSE_DETAILS';
var FETCH_COURSE_DETAILS_REQUEST = exports.FETCH_COURSE_DETAILS_REQUEST = 'FETCH_COURSE_DETAILS_REQUEST';
var FETCH_COURSE_DETAILS_SUCCESS = exports.FETCH_COURSE_DETAILS_SUCCESS = 'FETCH_COURSE_DETAILS_SUCCESS';
var FETCH_COURSE_DETAILS_FAILURE = exports.FETCH_COURSE_DETAILS_FAILURE = 'FETCH_COURSE_DETAILS_FAILURE';
var GET_YEAR_GROUPS_REQUEST = exports.GET_YEAR_GROUPS_REQUEST = 'GET_YEAR_GROUPS_REQUEST';
var GET_CLASSROOMS_REQUEST = exports.GET_CLASSROOMS_REQUEST = 'GET_CLASSROOMS_REQUEST';
var SET_ASSIGN_UPF_COURSE = exports.SET_ASSIGN_UPF_COURSE = 'SET_ASSIGN_UPF_COURSE';
var SET_ASSIGN_NEW_COURSE = exports.SET_ASSIGN_NEW_COURSE = 'SET_ASSIGN_NEW_COURSE';
var RESET_TOASTER_STATE = exports.RESET_TOASTER_STATE = 'RESET_TOASTER_STATE';

var GET_ADMIN_DEFAULT_COURSE_REQUEST = exports.GET_ADMIN_DEFAULT_COURSE_REQUEST = 'GET_ADMIN_DEFAULT_COURSE_REQUEST';
var GET_ADMIN_DEFAULT_COURSE_SUCCESS = exports.GET_ADMIN_DEFAULT_COURSE_SUCCESS = 'GET_ADMIN_DEFAULT_COURSE_SUCCESS';
var GET_ADMIN_DEFAULT_COURSE_FAILURE = exports.GET_ADMIN_DEFAULT_COURSE_FAILURE = 'GET_ADMIN_DEFAULT_COURSE_FAILURE';

/***/ }),
/* 98 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.openAddStudentModal = openAddStudentModal;
exports.addAnotherStudentModal = addAnotherStudentModal;
exports.closeAddStudentModal = closeAddStudentModal;
exports.addStudentSuccess = addStudentSuccess;
exports.addStudentFailure = addStudentFailure;
exports.closeAddStudentValidationModal = closeAddStudentValidationModal;
var GET_PRODUCT_STUDENTS_REQUEST = exports.GET_PRODUCT_STUDENTS_REQUEST = 'GET_PRODUCT_STUDENTS_REQUEST';
var GET_PRODUCT_STUDENTS_SUCCESS = exports.GET_PRODUCT_STUDENTS_SUCCESS = 'GET_PRODUCT_STUDENTS_SUCCESS';
var GET_PRODUCT_STUDENTS_FAILURE = exports.GET_PRODUCT_STUDENTS_FAILURE = 'GET_PRODUCT_STUDENTS_FAILURE';

var getProductStudents = exports.getProductStudents = function getProductStudents(productId) {
    return { type: GET_PRODUCT_STUDENTS_REQUEST, productId: productId };
};

var getProductStudentsSuccess = exports.getProductStudentsSuccess = function getProductStudentsSuccess(data) {
    return { type: GET_PRODUCT_STUDENTS_SUCCESS, data: data };
};

var getProductStudentsFailure = exports.getProductStudentsFailure = function getProductStudentsFailure() {
    return { type: GET_PRODUCT_STUDENTS_FAILURE };
};

var DOWNLOAD_STUDENT_ROLL_REQUEST = exports.DOWNLOAD_STUDENT_ROLL_REQUEST = 'DOWNLOAD_STUDENT_ROLL_REQUEST';
var DOWNLOAD_STUDENT_ROLL_SUCCESS = exports.DOWNLOAD_STUDENT_ROLL_SUCCESS = 'DOWNLOAD_STUDENT_ROLL_SUCCESS';
var DOWNLOAD_STUDENT_ROLL_FAILURE = exports.DOWNLOAD_STUDENT_ROLL_FAILURE = 'DOWNLOAD_STUDENT_ROLL_FAILURE';

var downloadStudentRoll = exports.downloadStudentRoll = function downloadStudentRoll(students, isStudentRollDownloaded) {
    return { type: DOWNLOAD_STUDENT_ROLL_REQUEST, students: students, isStudentRollDownloaded: isStudentRollDownloaded };
};

var downloadStudentRollSuccess = exports.downloadStudentRollSuccess = function downloadStudentRollSuccess(downloadUrl, isStudentRollDownloaded) {
    window.location.href = downloadUrl;
    return { type: DOWNLOAD_STUDENT_ROLL_SUCCESS, isStudentRollDownloaded: isStudentRollDownloaded };
};

var downloadStudentRollFailure = exports.downloadStudentRollFailure = function downloadStudentRollFailure() {
    return { type: DOWNLOAD_STUDENT_ROLL_FAILURE };
};

var FILTER_VALUE_CLEARED = exports.FILTER_VALUE_CLEARED = 'FILTER_VALUE_CLEARED';
var FILTER_VALUE_CHANGED = exports.FILTER_VALUE_CHANGED = 'FILTER_VALUE_CHANGED';
var UPDATE_SEARCH_TERM = exports.UPDATE_SEARCH_TERM = 'UPDATE_SEARCH_TERM';
var SORT_STUDENT_LIST = exports.SORT_STUDENT_LIST = 'SORT_STUDENT_LIST';
var RETRIEVE_SELECTED_STUDENT = exports.RETRIEVE_SELECTED_STUDENT = 'RETRIEVE_SELECTED_STUDENT';

var clearFilterValue = exports.clearFilterValue = function clearFilterValue() {
    return { type: FILTER_VALUE_CLEARED };
};

var changeFilterValue = exports.changeFilterValue = function changeFilterValue(collectionName, key) {
    return { type: FILTER_VALUE_CHANGED, collectionName: collectionName, key: key };
};

var updateSearchTerm = exports.updateSearchTerm = function updateSearchTerm(searchTerm) {
    return { type: UPDATE_SEARCH_TERM, searchTerm: searchTerm };
};

var sortStudentList = exports.sortStudentList = function sortStudentList(columnToSort) {
    return { type: SORT_STUDENT_LIST, columnToSort: columnToSort };
};

var retrieveSelectedStudents = exports.retrieveSelectedStudents = function retrieveSelectedStudents(selectedStudentsProfileId) {
    return {
        type: RETRIEVE_SELECTED_STUDENT,
        selectedStudents: selectedStudentsProfileId
    };
};

var PRINT_SIGN_IN_CARD_REQUEST = exports.PRINT_SIGN_IN_CARD_REQUEST = 'PRINT_SIGN_IN_CARD_REQUEST';
var PRINT_SIGN_IN_CARD_SUCCESS = exports.PRINT_SIGN_IN_CARD_SUCCESS = 'PRINT_SIGN_IN_CARD_SUCCESS';
var PRINT_SIGN_IN_CARD_FAILURE = exports.PRINT_SIGN_IN_CARD_FAILURE = 'PRINT_SIGN_IN_CARD_FAILURE';

var printSignInCard = exports.printSignInCard = function printSignInCard(productId, studentSignInCardsData) {
    return { type: PRINT_SIGN_IN_CARD_REQUEST, isSignInCardDownloaded: false, productId: productId, studentSignInCardsData: studentSignInCardsData };
};

var printSignInCardSuccess = exports.printSignInCardSuccess = function printSignInCardSuccess(downloadUrl, isSignInCardDownloaded) {
    window.location.href = downloadUrl;
    return { type: PRINT_SIGN_IN_CARD_SUCCESS, downloadUrl: downloadUrl, isSignInCardDownloaded: isSignInCardDownloaded };
};

var printSignInCardFailure = exports.printSignInCardFailure = function printSignInCardFailure(isSignInCardDownloaded) {
    return { type: PRINT_SIGN_IN_CARD_FAILURE, isSignInCardDownloaded: isSignInCardDownloaded };
};

var ADD_STUDENT_OPEN_MODAL_REQUEST = exports.ADD_STUDENT_OPEN_MODAL_REQUEST = 'ADD_STUDENT_OPEN_MODAL_REQUEST';
var ADD_STUDENT_CLOSE_MODAL_REQUEST = exports.ADD_STUDENT_CLOSE_MODAL_REQUEST = 'ADD_STUDENT_CLOSE_MODAL_REQUEST';
var ADD_ANOTHER_STUDENT_OPEN_MODAL_REQUEST = exports.ADD_ANOTHER_STUDENT_OPEN_MODAL_REQUEST = 'ADD_ANOTHER_STUDENT_OPEN_MODAL_REQUEST';

function openAddStudentModal() {
    return {
        type: ADD_STUDENT_OPEN_MODAL_REQUEST,
        showModal: true,
        showAddStudentConfirmationModal: false
    };
}

function addAnotherStudentModal() {
    return {
        type: ADD_ANOTHER_STUDENT_OPEN_MODAL_REQUEST,
        showModal: true,
        showAddStudentConfirmationModal: false
    };
}

function closeAddStudentModal() {
    return {
        type: ADD_STUDENT_CLOSE_MODAL_REQUEST,
        showModal: false
    };
}

var ADD_STUDENT_REQUEST = exports.ADD_STUDENT_REQUEST = 'ADD_STUDENT_REQUEST';
var ADD_STUDENT_SUCCESS = exports.ADD_STUDENT_SUCCESS = 'ADD_STUDENT_SUCCESS';
var ADD_STUDENT_FAILURE = exports.ADD_STUDENT_FAILURE = 'ADD_STUDENT_FAILURE';

var addStudent = exports.addStudent = function addStudent(student) {
    return { type: ADD_STUDENT_REQUEST, student: student, isSaveInProgress: true };
};

function addStudentSuccess(userProfileId) {
    return {
        type: ADD_STUDENT_SUCCESS,
        userProfileId: userProfileId,
        isSaveInProgress: false,
        showAddStudentConfirmationModal: true
    };
}

function addStudentFailure(isServerError, addStudentValidationMessage) {
    var showAddStudentValidationModal = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

    return {
        type: ADD_STUDENT_FAILURE,
        addStudentValidationMessage: addStudentValidationMessage,
        showAddStudentValidationModal: showAddStudentValidationModal,
        isSaveInProgress: false,
        isServerError: isServerError
    };
}

var CLOSE_ADD_STUDENT_VALIDATION_MODAL = exports.CLOSE_ADD_STUDENT_VALIDATION_MODAL = 'CLOSE_ADD_STUDENT_VALIDATION_MODAL';

function closeAddStudentValidationModal() {
    return {
        type: CLOSE_ADD_STUDENT_VALIDATION_MODAL,
        showAddStudentValidationModal: false
    };
}

var ADD_STUDENT_GET_GROUPS_REQUEST = exports.ADD_STUDENT_GET_GROUPS_REQUEST = 'ADD_STUDENT_GET_GROUPS_REQUEST';
var ADD_STUDENT_GET_GROUPS_SUCCESS = exports.ADD_STUDENT_GET_GROUPS_SUCCESS = 'ADD_STUDENT_GET_GROUPS_SUCCESS';
var ADD_STUDENT_GET_GROUPS_FAILURE = exports.ADD_STUDENT_GET_GROUPS_FAILURE = 'ADD_STUDENT_GET_GROUPS_FAILURE';

var getClassroomGroups = exports.getClassroomGroups = function getClassroomGroups(classroomId) {
    return { type: ADD_STUDENT_GET_GROUPS_REQUEST, classroomId: classroomId, isFetchingGroupsAddStudent: true, fetchedGroupsAddStudent: false };
};

var getClassroomGroupsSuccess = exports.getClassroomGroupsSuccess = function getClassroomGroupsSuccess(classroomGroups) {
    return { type: ADD_STUDENT_GET_GROUPS_SUCCESS, classroomGroups: classroomGroups, isFetchingGroupsAddStudent: false, fetchedGroupsAddStudent: true };
};

var getClassroomGroupsFailure = exports.getClassroomGroupsFailure = function getClassroomGroupsFailure() {
    return { type: ADD_STUDENT_GET_GROUPS_FAILURE, isFetchingGroupsAddStudent: false, fetchedGroupsAddStudent: false };
};

var BULK_PASSWORD_CHANGE_STUDENTS_REQUEST = exports.BULK_PASSWORD_CHANGE_STUDENTS_REQUEST = 'BULK_PASSWORD_CHANGE_STUDENTS_REQUEST';
var BULK_PASSWORD_CHANGE_STUDENTS_SUCCESS = exports.BULK_PASSWORD_CHANGE_STUDENTS_SUCCESS = 'BULK_PASSWORD_CHANGE_STUDENTS_SUCCESS';
var BULK_PASSWORD_CHANGE_STUDENTS_FAILURE = exports.BULK_PASSWORD_CHANGE_STUDENTS_FAILURE = 'BULK_PASSWORD_CHANGE_STUDENTS_FAILURE';

var bulkPasswordChangeStudents = exports.bulkPasswordChangeStudents = function bulkPasswordChangeStudents(selectedStudents, newPassword) {
    return { type: BULK_PASSWORD_CHANGE_STUDENTS_REQUEST, selectedStudents: selectedStudents, newPassword: newPassword, disableConfirmationButton: true };
};

var bulkPasswordChangeStudentsSuccess = exports.bulkPasswordChangeStudentsSuccess = function bulkPasswordChangeStudentsSuccess() {
    return { type: BULK_PASSWORD_CHANGE_STUDENTS_SUCCESS, isBulkPasswordChangeModalOpen: false, disableConfirmationButton: false, bulkPasswordValue: '' };
};

var bulkPasswordChangeStudentsFailure = exports.bulkPasswordChangeStudentsFailure = function bulkPasswordChangeStudentsFailure() {
    return { type: BULK_PASSWORD_CHANGE_STUDENTS_FAILURE, disableConfirmationButton: false, bulkPasswordValue: '' };
};

var BULK_PASSWORD_CHANGE_STUDENTS_SET_VALUE = exports.BULK_PASSWORD_CHANGE_STUDENTS_SET_VALUE = 'BULK_PASSWORD_CHANGE_STUDENTS_SET_VALUE';

var bulkPasswordChangeStudentsSetValue = exports.bulkPasswordChangeStudentsSetValue = function bulkPasswordChangeStudentsSetValue(newPassword) {
    return { type: BULK_PASSWORD_CHANGE_STUDENTS_SET_VALUE, bulkPasswordValue: newPassword };
};

var OPEN_BULK_PASSWORD_CHANGE_STUDENTS_MODAL = exports.OPEN_BULK_PASSWORD_CHANGE_STUDENTS_MODAL = 'OPEN_BULK_PASSWORD_CHANGE_STUDENTS_MODAL';

var openBulkPasswordChangeStudentsModal = exports.openBulkPasswordChangeStudentsModal = function openBulkPasswordChangeStudentsModal() {
    return { type: OPEN_BULK_PASSWORD_CHANGE_STUDENTS_MODAL, isUserOperationModalOpen: true, disableConfirmationButton: false, bulkPasswordValue: '', operationType: 'bulkPasswordChange' };
};

var UNASSIGN_STUDENTS_REQUEST = exports.UNASSIGN_STUDENTS_REQUEST = 'UNASSIGN_STUDENTS_REQUEST';
var UNASSIGN_STUDENTS_SUCCESS = exports.UNASSIGN_STUDENTS_SUCCESS = 'UNASSIGN_STUDENTS_SUCCESS';
var UNASSIGN_STUDENTS_FAILURE = exports.UNASSIGN_STUDENTS_FAILURE = 'UNASSIGN_STUDENTS_FAILURE';

var unassignStudents = exports.unassignStudents = function unassignStudents(selectedStudents, productId) {
    return { type: UNASSIGN_STUDENTS_REQUEST, selectedStudents: selectedStudents, productId: productId, disableConfirmationButton: true };
};

var unassignStudentsSuccess = exports.unassignStudentsSuccess = function unassignStudentsSuccess() {
    return { type: UNASSIGN_STUDENTS_SUCCESS, isUserOperationModalOpen: false, disableConfirmationButton: false };
};

var unassignStudentsFailure = exports.unassignStudentsFailure = function unassignStudentsFailure() {
    return { type: UNASSIGN_STUDENTS_SUCCESS, disableConfirmationButton: false };
};

var OPEN_UNASSIGN_STUDENTS_MODAL = exports.OPEN_UNASSIGN_STUDENTS_MODAL = 'OPEN_UNASSIGN_STUDENTS_MODAL';
var CLOSE_STUDENTS_OPERATION_CONFIRMATION_MODAL = exports.CLOSE_STUDENTS_OPERATION_CONFIRMATION_MODAL = 'CLOSE_STUDENTS_OPERATION_CONFIRMATION_MODAL';

var openUnAssignStudentsModal = exports.openUnAssignStudentsModal = function openUnAssignStudentsModal() {
    return { type: OPEN_UNASSIGN_STUDENTS_MODAL, isUserOperationModalOpen: true, operationType: 'unassignUser' };
};

var closeStudentsOperationConfirmationModal = exports.closeStudentsOperationConfirmationModal = function closeStudentsOperationConfirmationModal() {
    return { type: CLOSE_STUDENTS_OPERATION_CONFIRMATION_MODAL, refreshStudentList: true, selectedStudents: [], operationType: '' };
};

var OPEN_DELETE_USER_MODAL = exports.OPEN_DELETE_USER_MODAL = 'OPEN_DELETE_USER_MODAL';

var openDeleteUserConfirmation = exports.openDeleteUserConfirmation = function openDeleteUserConfirmation() {
    return { type: OPEN_DELETE_USER_MODAL, isUserOperationModalOpen: true, operationType: 'deleteUser' };
};

var DELETE_STUDENT_REQUEST = exports.DELETE_STUDENT_REQUEST = 'DELETE_STUDENT_REQUEST';
var DELETE_STUDENT_SUCCESS = exports.DELETE_STUDENT_SUCCESS = 'DELETE_STUDENT_SUCCESS';
var DELETE_STUDENT_FAILURE = exports.DELETE_STUDENT_FAILURE = 'DELETE_STUDENT_FAILURE';

var deleteStudentRequest = exports.deleteStudentRequest = function deleteStudentRequest(userProfileIds, productId) {
    return { type: DELETE_STUDENT_REQUEST, disableConfirmationButton: true, userProfileIds: userProfileIds, productId: productId, operationType: 'deleteUser' };
};

var deleteStudentSuccess = exports.deleteStudentSuccess = function deleteStudentSuccess(response) {
    return { type: DELETE_STUDENT_SUCCESS,
        isUserOperationModalOpen: false,
        disableConfirmationButton: false,
        isPartialDelete: response.isPartialDelete,
        deletedStudentsCount: response.noOfStudentsDeleted,
        selectedStudents: []
    };
};

var deleteStudentFailure = exports.deleteStudentFailure = function deleteStudentFailure() {
    return { type: DELETE_STUDENT_FAILURE, disableConfirmationButton: false };
};

var CLEAR_OPERATION_TYPE = exports.CLEAR_OPERATION_TYPE = 'CLEAR_OPERATION_TYPE';

var clearOperationTypeRequest = exports.clearOperationTypeRequest = function clearOperationTypeRequest() {
    return { type: CLEAR_OPERATION_TYPE };
};

var DOWNLOAD_STUDENTS_SIGN_IN_CARD = exports.DOWNLOAD_STUDENTS_SIGN_IN_CARD = 'DOWNLOAD_STUDENTS_SIGN_IN_CARD';

var downloadStudentsSignInCards = exports.downloadStudentsSignInCards = function downloadStudentsSignInCards() {
    return { type: DOWNLOAD_STUDENTS_SIGN_IN_CARD, isUserOperationModalOpen: true, operationType: 'downloadSignInCard' };
};

var SHOW_HIDE_SIGNIN_CARD_MODAL = exports.SHOW_HIDE_SIGNIN_CARD_MODAL = 'SHOW_HIDE_SIGNIN_CARD_MODAL';

var showHideSignInCardModalRequest = exports.showHideSignInCardModalRequest = function showHideSignInCardModalRequest(status) {
    return { type: SHOW_HIDE_SIGNIN_CARD_MODAL, showHideSignInCardModal: status };
};

/***/ }),
/* 99 */,
/* 100 */,
/* 101 */,
/* 102 */,
/* 103 */,
/* 104 */,
/* 105 */,
/* 106 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.printClassroomTeacherSignInCard = printClassroomTeacherSignInCard;
exports.openChangeCourse = openChangeCourse;
exports.closeChangeCourse = closeChangeCourse;
exports.backToChangeCourse = backToChangeCourse;
var GET_CLASS_REQUEST = exports.GET_CLASS_REQUEST = 'GET_CLASS_REQUEST';
var GET_CLASS_SUCCESS = exports.GET_CLASS_SUCCESS = 'GET_CLASS_SUCCESS';
var GET_CLASS_FAILURE = exports.GET_CLASS_FAILURE = 'GET_CLASS_FAILURE';

var getClassByClassroomId = exports.getClassByClassroomId = function getClassByClassroomId(productId, classroomId) {
    return { type: GET_CLASS_REQUEST, productId: productId, classroomId: classroomId, isLoadingEditClassDetail: true };
};

var getClassSuccess = exports.getClassSuccess = function getClassSuccess(_ref) {
    var data = _ref.data;
    return { type: GET_CLASS_SUCCESS, data: data, isLoadingEditClassDetail: false };
};

var getClassFailure = exports.getClassFailure = function getClassFailure() {
    return { type: GET_CLASS_FAILURE, isLoadingEditStudentDetail: false };
};

var RENAME_GROUP_REQUEST = exports.RENAME_GROUP_REQUEST = 'RENAME_GROUP_REQUEST';
var RENAME_GROUP_SUCCESS = exports.RENAME_GROUP_SUCCESS = 'RENAME_GROUP_SUCCESS';
var RENAME_GROUP_FAILURE = exports.RENAME_GROUP_FAILURE = 'RENAME_GROUP_FAILURE';

var renameClassroomGroup = exports.renameClassroomGroup = function renameClassroomGroup(classroomId, groupId, newGroupName) {
    return { type: RENAME_GROUP_REQUEST, classroomId: classroomId, groupId: groupId, newGroupName: newGroupName, isRenameGroupInProgress: true };
};

var renameClassroomGroupSuccess = exports.renameClassroomGroupSuccess = function renameClassroomGroupSuccess() {
    return {
        type: RENAME_GROUP_SUCCESS,
        showRenameGroupConfirmationModal: true,
        showRenameGroupConfirmationBeforeSubmit: false,
        isRenameGroupInProgress: false
    };
};

var renameClassroomGroupFailure = exports.renameClassroomGroupFailure = function renameClassroomGroupFailure() {
    return {
        type: RENAME_GROUP_FAILURE,
        isRenameGroupInProgress: false,
        showRenameGroupConfirmationBeforeSubmit: false
    };
};

var DOWNLOAD_STUDENT_SIGN_IN_CARDS_REQUEST = exports.DOWNLOAD_STUDENT_SIGN_IN_CARDS_REQUEST = 'DOWNLOAD_STUDENT_SIGN_IN_CARDS_REQUEST';
var DOWNLOAD_STUDENT_SIGN_IN_CARDS_SUCCESS = exports.DOWNLOAD_STUDENT_SIGN_IN_CARDS_SUCCESS = 'DOWNLOAD_STUDENT_SIGN_IN_CARDS_SUCCESS';
var DOWNLOAD_STUDENT_SIGN_IN_CARDS_FAILURE = exports.DOWNLOAD_STUDENT_SIGN_IN_CARDS_FAILURE = 'DOWNLOAD_STUDENT_SIGN_IN_CARDS_FAILURE';

var downloadStudentSignInCardsRequest = exports.downloadStudentSignInCardsRequest = function downloadStudentSignInCardsRequest(productId, classroomId, SignInCardPageSizeType) {
    return { type: DOWNLOAD_STUDENT_SIGN_IN_CARDS_REQUEST, productId: productId, classroomId: classroomId, SignInCardPageSizeType: SignInCardPageSizeType, isDownloadingSignInCards: true };
};

var downloadStudentSignInCardsSuccess = exports.downloadStudentSignInCardsSuccess = function downloadStudentSignInCardsSuccess(downloadUrl) {
    window.location.href = downloadUrl;
    return { type: DOWNLOAD_STUDENT_SIGN_IN_CARDS_SUCCESS, isDownloadingSignInCards: false };
};

var downloadStudentSignInCardsFailure = exports.downloadStudentSignInCardsFailure = function downloadStudentSignInCardsFailure() {
    return { type: DOWNLOAD_STUDENT_SIGN_IN_CARDS_FAILURE, isDownloadingSignInCards: false };
};

var SHOW_EDIT_CLASS_GROUP = exports.SHOW_EDIT_CLASS_GROUP = 'SHOW_EDIT_CLASS_GROUP';
var HIDE_EDIT_CLASS_GROUP = exports.HIDE_EDIT_CLASS_GROUP = 'HIDE_EDIT_CLASS_GROUP';

var showEditClassGroup = exports.showEditClassGroup = function showEditClassGroup(selectedGroup) {
    return { type: SHOW_EDIT_CLASS_GROUP, selectedGroup: selectedGroup };
};
var hideEditClassGroup = exports.hideEditClassGroup = function hideEditClassGroup() {
    return { type: HIDE_EDIT_CLASS_GROUP };
};

var SHOW_RENAME_GROUP_MODAL = exports.SHOW_RENAME_GROUP_MODAL = 'SHOW_RENAME_GROUP_MODAL';
var HIDE_RENAME_GROUP_MODAL = exports.HIDE_RENAME_GROUP_MODAL = 'HIDE_RENAME_GROUP_MODAL';

var showRenameGroup = exports.showRenameGroup = function showRenameGroup() {
    return { type: SHOW_RENAME_GROUP_MODAL, showRenameGroupModal: true };
};
var hideRenameGroup = exports.hideRenameGroup = function hideRenameGroup() {
    return { type: HIDE_RENAME_GROUP_MODAL, showRenameGroupModal: false };
};

var OPEN_RENAME_GROUP_CONFIRMATION_BEFORE_SUBMIT = exports.OPEN_RENAME_GROUP_CONFIRMATION_BEFORE_SUBMIT = 'OPEN_RENAME_GROUP_CONFIRMATION_BEFORE_SUBMIT';
var CLOSE_RENAME_GROUP_CONFIRMATION_BEFORE_SUBMIT = exports.CLOSE_RENAME_GROUP_CONFIRMATION_BEFORE_SUBMIT = 'CLOSE_RENAME_GROUP_CONFIRMATION_BEFORE_SUBMIT';

var openRenameGroupConfirmationBeforeSubmit = exports.openRenameGroupConfirmationBeforeSubmit = function openRenameGroupConfirmationBeforeSubmit() {
    return {
        type: OPEN_RENAME_GROUP_CONFIRMATION_BEFORE_SUBMIT,
        showRenameGroupConfirmationBeforeSubmit: true,
        refreshEditClass: false
    };
};

var closeRenameGroupConfirmationBeforeSubmit = exports.closeRenameGroupConfirmationBeforeSubmit = function closeRenameGroupConfirmationBeforeSubmit() {
    return {
        type: CLOSE_RENAME_GROUP_CONFIRMATION_BEFORE_SUBMIT,
        showRenameGroupConfirmationBeforeSubmit: false
    };
};

var CLOSE_RENAME_GROUP_CONFIRMATION = exports.CLOSE_RENAME_GROUP_CONFIRMATION = 'CLOSE_RENAME_GROUP_CONFIRMATION';
var closeRenameGroupConfirmation = exports.closeRenameGroupConfirmation = function closeRenameGroupConfirmation() {
    return {
        type: CLOSE_RENAME_GROUP_CONFIRMATION,
        showRenameGroupConfirmationModal: false,
        showRenameGroupModal: false,
        editClassGroupIsVisible: false,
        refreshEditClass: true,
        selectedGroup: null
    };
};

var MODIFIED_CLASS_SAVE_REQUEST = exports.MODIFIED_CLASS_SAVE_REQUEST = 'MODIFIED_CLASS_SAVE_REQUEST';
var MODIFIED_CLASS_SAVE_SUCCESS = exports.MODIFIED_CLASS_SAVE_SUCCESS = 'MODIFIED_CLASS_SAVE_SUCCESS';
var MODIFIED_CLASS_SAVE_FAILURE = exports.MODIFIED_CLASS_SAVE_FAILURE = 'MODIFIED_CLASS_SAVE_FAILURE';

var saveModifiedClass = exports.saveModifiedClass = function saveModifiedClass(classroomId, newClassroomName, newYearGroup) {
    return {
        type: MODIFIED_CLASS_SAVE_REQUEST,
        classroomId: classroomId,
        newClassroomName: newClassroomName,
        newYearGroup: newYearGroup,
        isSavingClass: true,
        isUpdateSuccessful: false
    };
};

var saveModifiedClassSuccess = exports.saveModifiedClassSuccess = function saveModifiedClassSuccess() {
    return {
        type: MODIFIED_CLASS_SAVE_SUCCESS,
        isSavingClass: false,
        isUpdateSuccessful: true
    };
};

var saveModifiedClassFailure = exports.saveModifiedClassFailure = function saveModifiedClassFailure(editClassValidationMessage) {
    return {
        type: MODIFIED_CLASS_SAVE_FAILURE,
        editClassValidationMessage: editClassValidationMessage,
        isUpdateSuccessful: false,
        isSavingClass: false
    };
};

var CLOSE_CLASS_VALIDATION_MODAL = exports.CLOSE_CLASS_VALIDATION_MODAL = 'CLOSE_CLASS_VALIDATION_MODAL';

var handleOnCloseValidationModal = exports.handleOnCloseValidationModal = function handleOnCloseValidationModal() {
    return {
        type: CLOSE_CLASS_VALIDATION_MODAL,
        isUpdateSuccessful: true
    };
};

var DOWNLOAD_TEACHER_SIGN_IN_CARD_REQUEST = exports.DOWNLOAD_TEACHER_SIGN_IN_CARD_REQUEST = 'DOWNLOAD_TEACHER_SIGN_IN_CARD_REQUEST';
var DOWNLOAD_TEACHER_SIGN_IN_CARD_SUCCESS = exports.DOWNLOAD_TEACHER_SIGN_IN_CARD_SUCCESS = 'DOWNLOAD_TEACHER_SIGN_IN_CARD_SUCCESS';
var DOWNLOAD_TEACHER_SIGN_IN_CARD_FAILURE = exports.DOWNLOAD_TEACHER_SIGN_IN_CARD_FAILURE = 'DOWNLOAD_TEACHER_SIGN_IN_CARD_FAILURE';

var printTeacherSignInCard = exports.printTeacherSignInCard = function printTeacherSignInCard(selectedProductId, teacherId) {
    return { type: DOWNLOAD_TEACHER_SIGN_IN_CARD_REQUEST, isSignInCardDownloaded: false, teacherId: teacherId, selectedProductId: selectedProductId };
};

var printTeacherSignInCardSuccess = exports.printTeacherSignInCardSuccess = function printTeacherSignInCardSuccess(downloadUrl, isSignInCardDownloaded) {
    window.location.href = downloadUrl;
    return { type: DOWNLOAD_TEACHER_SIGN_IN_CARD_SUCCESS, downloadUrl: downloadUrl, isSignInCardDownloaded: isSignInCardDownloaded };
};

var printTeacherSignInCardFailure = exports.printTeacherSignInCardFailure = function printTeacherSignInCardFailure(isSignInCardDownloaded) {
    return { type: DOWNLOAD_TEACHER_SIGN_IN_CARD_FAILURE, isSignInCardDownloaded: isSignInCardDownloaded };
};

var OPEN_UNASSIGN_TEACHERS_MODAL = exports.OPEN_UNASSIGN_TEACHERS_MODAL = 'OPEN_UNASSIGN_TEACHERS_MODAL';
var CLOSE_TEACHERS_OPERATION_CONFIRMATION_MODAL = exports.CLOSE_TEACHERS_OPERATION_CONFIRMATION_MODAL = 'CLOSE_TEACHERS_OPERATION_CONFIRMATION_MODAL';

var openUnAssignTeachersModal = exports.openUnAssignTeachersModal = function openUnAssignTeachersModal() {
    return { type: OPEN_UNASSIGN_TEACHERS_MODAL, isUserOperationModalOpen: true };
};

var closeTeachersOperationConfirmationModal = exports.closeTeachersOperationConfirmationModal = function closeTeachersOperationConfirmationModal() {
    return { type: CLOSE_TEACHERS_OPERATION_CONFIRMATION_MODAL, deleteSuccess: false, refreshTeacherList: true, selectedTeachers: [], notDeletedTeachers: [] };
};

var UNASSIGN_TEACHER_REQUEST = exports.UNASSIGN_TEACHER_REQUEST = 'UNASSIGN_TEACHER_REQUEST';
var UNASSIGN_TEACHER_SUCCESS = exports.UNASSIGN_TEACHER_SUCCESS = 'UNASSIGN_TEACHER_SUCCESS';
var UNASSIGN_TEACHER_FAILURE = exports.UNASSIGN_TEACHER_FAILURE = 'UNASSIGN_TEACHER_FAILURE';

var unassignTeachers = exports.unassignTeachers = function unassignTeachers(classroomId, selectedTeachers, productId) {
    return { type: UNASSIGN_TEACHER_REQUEST, classroomId: classroomId, selectedTeachers: selectedTeachers, productId: productId, disableConfirmationButtons: true };
};

var unassignTeachersSuccess = exports.unassignTeachersSuccess = function unassignTeachersSuccess() {
    return { type: UNASSIGN_TEACHER_SUCCESS, isUserOperationModalOpen: false, disableConfirmationButtons: false };
};

var unassignTeachersFailure = exports.unassignTeachersFailure = function unassignTeachersFailure() {
    return { type: UNASSIGN_TEACHER_FAILURE, disableConfirmationButtons: false };
};

var PRINT_CLASSROOM_TEACHERS_SIGN_IN_CARD_REQUEST = exports.PRINT_CLASSROOM_TEACHERS_SIGN_IN_CARD_REQUEST = 'PRINT_CLASSROOM_TEACHERS_SIGN_IN_CARD_REQUEST';
var PRINT_CLASSROOM_TEACHERS_SIGN_IN_CARD_SUCCESS = exports.PRINT_CLASSROOM_TEACHERS_SIGN_IN_CARD_SUCCESS = 'PRINT_CLASSROOM_TEACHERS_SIGN_IN_CARD_SUCCESS';
var PRINT_CLASSROOM_TEACHERS_SIGN_IN_CARD_FAILURE = exports.PRINT_CLASSROOM_TEACHERS_SIGN_IN_CARD_FAILURE = 'PRINT_CLASSROOM_TEACHERS_SIGN_IN_CARD_FAILURE';

function printClassroomTeacherSignInCard(teacherId, productId, downloadingTeachersIds, format) {
    return { type: PRINT_CLASSROOM_TEACHERS_SIGN_IN_CARD_REQUEST, teacherId: teacherId, productId: productId, downloadingTeachersIds: downloadingTeachersIds, format: format };
}

var printClassroomTeacherSignInCardSuccess = exports.printClassroomTeacherSignInCardSuccess = function printClassroomTeacherSignInCardSuccess(teacherId, downloadUrl, downloadingTeachersIds) {
    window.location.href = downloadUrl;
    downloadingTeachersIds.delete(teacherId);
    return { type: PRINT_CLASSROOM_TEACHERS_SIGN_IN_CARD_SUCCESS, teacherId: teacherId, downloadUrl: downloadUrl, downloadingTeachersIds: downloadingTeachersIds };
};

var printClassroomTeacherSignInCardFailure = exports.printClassroomTeacherSignInCardFailure = function printClassroomTeacherSignInCardFailure(teacherId, downloadingTeachersIds) {
    downloadingTeachersIds.delete(teacherId);
    return { type: PRINT_CLASSROOM_TEACHERS_SIGN_IN_CARD_FAILURE, teacherId: teacherId, downloadingTeachersIds: downloadingTeachersIds };
};

var DELETE_GROUP_REQUEST = exports.DELETE_GROUP_REQUEST = 'DELETE_GROUP_REQUEST';
var DELETE_GROUP_SUCCESS = exports.DELETE_GROUP_SUCCESS = 'DELETE_GROUP_SUCCESS';
var DELETE_GROUP_FAILURE = exports.DELETE_GROUP_FAILURE = 'DELETE_GROUP_FAILURE';

var deleteGroup = exports.deleteGroup = function deleteGroup(classroomId, groupId) {
    return { type: DELETE_GROUP_REQUEST, classroomId: classroomId, groupId: groupId, isDeletingGroupInProgress: true, refreshEditClass: false };
};

var deleteGroupSuccess = exports.deleteGroupSuccess = function deleteGroupSuccess() {
    return {
        type: DELETE_GROUP_SUCCESS,
        isDeletingGroupInProgress: false,
        showDeleteGroupConfirmationBeforeSubmit: false,
        showDeleteGroupConfirmation: true
    };
};

var deleteGroupFailure = exports.deleteGroupFailure = function deleteGroupFailure() {
    return {
        type: DELETE_GROUP_FAILURE,
        isDeletingGroupInProgress: false,
        refreshEditClass: false,
        showDeleteGroupConfirmationBeforeSubmit: false
    };
};

var OPEN_DELETE_NON_EMPTY_GROUP_CONFIRMATION = exports.OPEN_DELETE_NON_EMPTY_GROUP_CONFIRMATION = 'OPEN_DELETE_NON_EMPTY_GROUP_CONFIRMATION';
var CLOSE_DELETE_NON_EMPTY_GROUP_CONFIRMATION = exports.CLOSE_DELETE_NON_EMPTY_GROUP_CONFIRMATION = 'CLOSE_DELETE_NON_EMPTY_GROUP_CONFIRMATION';

var openDeleteNonEmptyGroupConfirmation = exports.openDeleteNonEmptyGroupConfirmation = function openDeleteNonEmptyGroupConfirmation() {
    return {
        type: OPEN_DELETE_NON_EMPTY_GROUP_CONFIRMATION,
        showDeleteNonEmptyGroupConfirmationModal: true
    };
};

var closeDeleteNonEmptyGroupConfirmation = exports.closeDeleteNonEmptyGroupConfirmation = function closeDeleteNonEmptyGroupConfirmation() {
    return {
        type: CLOSE_DELETE_NON_EMPTY_GROUP_CONFIRMATION,
        showDeleteNonEmptyGroupConfirmationModal: false
    };
};

var CLOSE_DELETE_GROUP_CONFIRMATION = exports.CLOSE_DELETE_GROUP_CONFIRMATION = 'CLOSE_DELETE_GROUP_CONFIRMATION';

var closeDeleteGroupConfirmation = exports.closeDeleteGroupConfirmation = function closeDeleteGroupConfirmation() {
    return {
        type: CLOSE_DELETE_GROUP_CONFIRMATION,
        refreshEditClass: true,
        editClassGroupIsVisible: false,
        showDeleteGroupConfirmation: false
    };
};

var OPEN_CHANGE_COURSE = exports.OPEN_CHANGE_COURSE = 'OPEN_CHANGE_COURSE';
var CLOSE_CHANGE_COURSE = exports.CLOSE_CHANGE_COURSE = 'CLOSE_CHANGE_COURSE';
var BACK_TO_CHANGE_COURSE = exports.BACK_TO_CHANGE_COURSE = 'BACK_TO_CHANGE_COURSE';

function openChangeCourse(classroomId, groupId) {
    return { type: OPEN_CHANGE_COURSE, classroomId: classroomId, groupId: groupId };
}

function closeChangeCourse() {
    return { type: CLOSE_CHANGE_COURSE };
}

function backToChangeCourse() {
    return { type: BACK_TO_CHANGE_COURSE };
}

var CHANGE_COURSE_REQUEST = exports.CHANGE_COURSE_REQUEST = 'CHANGE_COURSE_REQUEST';
var CHANGE_COURSE_SUCCESS = exports.CHANGE_COURSE_SUCCESS = 'CHANGE_COURSE_SUCCESS';
var CHANGE_COURSE_FAILURE = exports.CHANGE_COURSE_FAILURE = 'CHANGE_COURSE_FAILURE';

var CARRY_OVER_TASK_TYPE = exports.CARRY_OVER_TASK_TYPE = 'CarryOver';
var CANCEL_TASK_TYPE = exports.CANCEL_TASK_TYPE = 'CancelTask';

var changeCourse = exports.changeCourse = function changeCourse(_ref2) {
    var classroomId = _ref2.classroomId,
        groupId = _ref2.groupId,
        courseId = _ref2.courseId,
        submittedFields = _ref2.submittedFields,
        _ref2$upfCourseId = _ref2.upfCourseId,
        upfCourseId = _ref2$upfCourseId === undefined ? '0' : _ref2$upfCourseId,
        newCourseId = _ref2.newCourseId,
        useUpfSchoolDefault = _ref2.useUpfSchoolDefault;
    return {
        type: CHANGE_COURSE_REQUEST,
        classroomId: classroomId,
        groupId: groupId,
        courseId: courseId,
        submittedFields: submittedFields,
        upfCourseId: upfCourseId,
        newCourseId: newCourseId,
        useUpfSchoolDefault: useUpfSchoolDefault
    };
};

var changeCourseSuccess = exports.changeCourseSuccess = function changeCourseSuccess(classroomId, groupId, assignedCourseId, submittedFields, assignedUpfCourseId, assignedNewCourseId, useUpfSchoolDefault, _ref3) {
    var data = _ref3.data;
    return { type: CHANGE_COURSE_SUCCESS, classroomId: classroomId, groupId: groupId, assignedCourseId: assignedCourseId, submittedFields: submittedFields, assignedUpfCourseId: assignedUpfCourseId, assignedNewCourseId: assignedNewCourseId, useUpfSchoolDefault: useUpfSchoolDefault, data: data };
};

var changeCourseFailure = exports.changeCourseFailure = function changeCourseFailure() {
    return { type: CHANGE_COURSE_FAILURE, isChangingCourseInProgress: false, refreshEditClass: false };
};

var CHANGE_COURSE_CARRY_OVER_REQUEST = exports.CHANGE_COURSE_CARRY_OVER_REQUEST = 'CHANGE_COURSE_CARRY_OVER_REQUEST';
var CHANGE_COURSE_CARRY_OVER_SUCCESS = exports.CHANGE_COURSE_CARRY_OVER_SUCCESS = 'CHANGE_COURSE_CARRY_OVER_SUCCESS';
var CHANGE_COURSE_CARRY_OVER_FAILURE = exports.CHANGE_COURSE_CARRY_OVER_FAILURE = 'CHANGE_COURSE_CARRY_OVER_FAILURE';

var changeCourseCarryOver = exports.changeCourseCarryOver = function changeCourseCarryOver(_ref4) {
    var changeCourseClassroomId = _ref4.changeCourseClassroomId,
        changeCourseGroupId = _ref4.changeCourseGroupId,
        assignedCourseId = _ref4.assignedCourseId,
        assignedUpfCourseId = _ref4.assignedUpfCourseId,
        isCarryOver = _ref4.isCarryOver,
        changeCourseAssignedTasks = _ref4.changeCourseAssignedTasks,
        assignedNewCourseId = _ref4.assignedNewCourseId;

    var taskActionType = isCarryOver ? CARRY_OVER_TASK_TYPE : CANCEL_TASK_TYPE;
    return {
        type: CHANGE_COURSE_CARRY_OVER_REQUEST,
        classroomId: changeCourseClassroomId,
        groupId: changeCourseGroupId,
        newCourseId: assignedCourseId,
        newUpfCourseId: assignedUpfCourseId,
        newConquestCourseId: assignedNewCourseId,
        taskActionType: taskActionType,
        courses: changeCourseAssignedTasks };
};

var changeCourseCarryOverSuccess = exports.changeCourseCarryOverSuccess = function changeCourseCarryOverSuccess() {
    return { type: CHANGE_COURSE_CARRY_OVER_SUCCESS };
};

var changeCourseCarryOverFailure = exports.changeCourseCarryOverFailure = function changeCourseCarryOverFailure() {
    return { type: CHANGE_COURSE_CARRY_OVER_FAILURE, isChangingCourseInProgress: false, refreshEditClass: false };
};

var OPEN_DELETE_GROUP_CONFIRMATION_BEFORE_SUBMIT = exports.OPEN_DELETE_GROUP_CONFIRMATION_BEFORE_SUBMIT = 'OPEN_DELETE_GROUP_CONFIRMATION_BEFORE_SUBMIT';
var CLOSE_DELETE_GROUP_CONFIRMATION_BEFORE_SUBMIT = exports.CLOSE_DELETE_GROUP_CONFIRMATION_BEFORE_SUBMIT = 'CLOSE_DELETE_GROUP_CONFIRMATION_BEFORE_SUBMIT';

var openDeleteGroupConfirmationBeforeSubmit = exports.openDeleteGroupConfirmationBeforeSubmit = function openDeleteGroupConfirmationBeforeSubmit() {
    return {
        type: OPEN_DELETE_GROUP_CONFIRMATION_BEFORE_SUBMIT,
        showDeleteGroupConfirmationBeforeSubmit: true
    };
};

var closeDeleteGroupConfirmationBeforeSubmit = exports.closeDeleteGroupConfirmationBeforeSubmit = function closeDeleteGroupConfirmationBeforeSubmit() {
    return {
        type: CLOSE_DELETE_GROUP_CONFIRMATION_BEFORE_SUBMIT,
        showDeleteGroupConfirmationBeforeSubmit: false
    };
};

var CLOSE_EDIT_CLASS = exports.CLOSE_EDIT_CLASS = 'CLOSE_EDIT_CLASS';

var closeEditClass = exports.closeEditClass = function closeEditClass() {
    return { type: CLOSE_EDIT_CLASS };
};

var CLOSE_EDIT_GROUP = exports.CLOSE_EDIT_GROUP = 'CLOSE_EDIT_GROUP';

var closeEditGroup = exports.closeEditGroup = function closeEditGroup() {
    return { type: CLOSE_EDIT_GROUP };
};

var OPEN_ADD_GROUP = exports.OPEN_ADD_GROUP = 'OPEN_ADD_GROUP';
var CLOSE_ADD_GROUP = exports.CLOSE_ADD_GROUP = 'CLOSE_ADD_GROUP';
var ADD_GROUP_REQUEST = exports.ADD_GROUP_REQUEST = 'ADD_GROUP_REQUEST';
var ADD_GROUP_SUCCESS = exports.ADD_GROUP_SUCCESS = 'ADD_GROUP_SUCCESS';
var ADD_GROUP_FAILURE = exports.ADD_GROUP_FAILURE = 'ADD_GROUP_FAILURE';

var openAddGroup = exports.openAddGroup = function openAddGroup() {
    return {
        type: OPEN_ADD_GROUP,
        addGroupIsActive: true
    };
};

var closeAddGroup = exports.closeAddGroup = function closeAddGroup() {
    return {
        type: CLOSE_ADD_GROUP,
        addGroupIsActive: false
    };
};

var addGroup = exports.addGroup = function addGroup(classroomId, name) {
    return {
        type: ADD_GROUP_REQUEST,
        classroomId: classroomId,
        name: name
    };
};

var addGroupSuccess = exports.addGroupSuccess = function addGroupSuccess(_ref5) {
    var data = _ref5.data;
    return {
        type: ADD_GROUP_SUCCESS,
        data: data
    };
};

var addGroupFailure = exports.addGroupFailure = function addGroupFailure(_ref6) {
    var code = _ref6.code;
    return {
        type: ADD_GROUP_FAILURE,
        addGroupErrorCode: code
    };
};

var HANDLE_COUNTRY_DROPDOWN_CHANGES = exports.HANDLE_COUNTRY_DROPDOWN_CHANGES = 'HANDLE_COUNTRY_DROPDOWN_CHANGES';
var handleCountryDropdownChanges = exports.handleCountryDropdownChanges = function handleCountryDropdownChanges(field, value) {
    return {
        type: HANDLE_COUNTRY_DROPDOWN_CHANGES,
        field: field,
        value: value
    };
};

var GET_YEARGROUPS_BY_COUNTRY_SUCCESS = exports.GET_YEARGROUPS_BY_COUNTRY_SUCCESS = 'GET_YEARGROUPS_BY_COUNTRY_SUCCESS';
var getYearGroupsByCountrySuccess = exports.getYearGroupsByCountrySuccess = function getYearGroupsByCountrySuccess(data) {
    return {
        type: GET_YEARGROUPS_BY_COUNTRY_SUCCESS,
        data: data
    };
};

var GET_YEARGROUPS_BY_COUNTRY_FAILURE = exports.GET_YEARGROUPS_BY_COUNTRY_FAILURE = 'GET_YEARGROUPS_BY_COUNTRY_FAILURE';
var getYearGroupsByCountryFailure = exports.getYearGroupsByCountryFailure = function getYearGroupsByCountryFailure() {
    return {
        type: GET_YEARGROUPS_BY_COUNTRY_FAILURE
    };
};

/***/ }),
/* 107 */,
/* 108 */,
/* 109 */,
/* 110 */,
/* 111 */,
/* 112 */,
/* 113 */,
/* 114 */,
/* 115 */,
/* 116 */,
/* 117 */,
/* 118 */,
/* 119 */,
/* 120 */,
/* 121 */,
/* 122 */,
/* 123 */,
/* 124 */,
/* 125 */,
/* 126 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactIntl = __webpack_require__(2);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactStyleable = __webpack_require__(6);

var _reactStyleable2 = _interopRequireDefault(_reactStyleable);

var _forEach = __webpack_require__(333);

var _forEach2 = _interopRequireDefault(_forEach);

var _index = __webpack_require__(1727);

var _index2 = _interopRequireDefault(_index);

var _variants = __webpack_require__(9);

var _button = __webpack_require__(7);

var _button2 = _interopRequireDefault(_button);

var _messages = __webpack_require__(756);

var _messages2 = _interopRequireDefault(_messages);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var SignInCardsFormats = function (_Component) {
    _inherits(SignInCardsFormats, _Component);

    function SignInCardsFormats(props) {
        _classCallCheck(this, SignInCardsFormats);

        var _this = _possibleConstructorReturn(this, (SignInCardsFormats.__proto__ || Object.getPrototypeOf(SignInCardsFormats)).call(this, props));

        _this.signInCardsFormat = [{
            id: 'QR_3X3',
            name: _this.props.intl.formatMessage(_messages2.default.qr3x3),
            isDefault: true
        }, {
            id: 'QR',
            name: _this.props.intl.formatMessage(_messages2.default.qr2x2),
            isDefault: false
        }, {
            id: '_2X5',
            name: _this.props.intl.formatMessage(_messages2.default.f2x5),
            isDefault: false
        }, {
            id: '_2X7',
            name: _this.props.intl.formatMessage(_messages2.default.f2x7),
            isDefault: false
        }, {
            id: '_3X8',
            name: _this.props.intl.formatMessage(_messages2.default.f3x8),
            isDefault: false
        }];

        _this.onFormatSelection = function (element) {
            var formatId = element.target.id;
            (0, _forEach2.default)(_this.signInCardsFormat, function (item) {
                if (item.id === formatId) {
                    item.isDefault = true;
                } else {
                    item.isDefault = false;
                }
            });

            _this.setState({ format: formatId });
        };

        _this.download = function () {
            _this.props.handleOnDownloadSignInCards(_this.state.format);
        };

        _this.renderRadioButtons = function () {
            return _this.signInCardsFormat.map(function (val) {
                return _react2.default.createElement(
                    'div',
                    { className: _index2.default.formatContainer, key: val.id },
                    ' ',
                    _react2.default.createElement(
                        'div',
                        null,
                        ' ',
                        _react2.default.createElement('input', {
                            checked: val.isDefault,
                            className: _index2.default.group,
                            id: val.id,
                            name: 'format',
                            onChange: _this.onFormatSelection,
                            type: 'radio',
                            value: val.id
                        }),
                        _react2.default.createElement('label', { htmlFor: val.id }),
                        ' '
                    ),
                    ' ',
                    _react2.default.createElement(
                        'div',
                        { className: _index2.default.formatName },
                        ' ',
                        val.name,
                        ' '
                    )
                );
            });
        };

        _this.state = {
            format: 'QR_3X3'
        };
        return _this;
    }

    _createClass(SignInCardsFormats, [{
        key: 'render',
        value: function render() {
            return _react2.default.createElement(
                'div',
                { className: _index2.default.modalContent },
                _react2.default.createElement(
                    'div',
                    { className: _index2.default.modalHeader },
                    _react2.default.createElement(
                        'div',
                        { className: _index2.default.modalHeaderText },
                        this.props.intl.formatMessage(_messages2.default.header)
                    ),
                    _react2.default.createElement(
                        'div',
                        { className: _index2.default.close, onClick: this.props.handleOnCancel, role: 'button', tabIndex: 0 },
                        '\xD7'
                    )
                ),
                _react2.default.createElement(
                    'div',
                    { className: _index2.default.modalBody },
                    _react2.default.createElement(
                        'div',
                        { className: _index2.default.radio },
                        this.renderRadioButtons()
                    )
                ),
                _react2.default.createElement(
                    'div',
                    { className: _index2.default.modalFooter },
                    _react2.default.createElement(
                        'div',
                        { className: _index2.default.buttonContainer },
                        _react2.default.createElement(_button2.default, {
                            handleOnClick: this.download,
                            label: this.props.intl.formatMessage(_messages2.default.download),
                            loading: !this.props.isSignInCardDownloaded,
                            loadingLabel: this.props.intl.formatMessage(_messages2.default.downloading),
                            variant: _variants.DARK,
                            visible: true
                        })
                    )
                )
            );
        }
    }]);

    return SignInCardsFormats;
}(_react.Component);

SignInCardsFormats.propTypes = {
    intl: _reactIntl.intlShape.isRequired,
    isSignInCardDownloaded: _propTypes2.default.bool,
    handleOnCancel: _propTypes2.default.func,
    handleOnDownloadSignInCards: _propTypes2.default.func
};

exports.default = (0, _reactIntl.injectIntl)((0, _reactStyleable2.default)(_index2.default)(SignInCardsFormats));

/***/ }),
/* 127 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.editStudent = editStudent;
exports.editStudentSuccess = editStudentSuccess;
exports.editStudentFailure = editStudentFailure;
exports.closeEditStudentValidationModal = closeEditStudentValidationModal;
exports.refreshStudentListOnCancel = refreshStudentListOnCancel;
exports.showHideModal = showHideModal;
var GET_STUDENTS_REQUEST = exports.GET_STUDENTS_REQUEST = 'GET_STUDENTS_REQUEST';
var GET_STUDENTS_SUCCESS = exports.GET_STUDENTS_SUCCESS = 'GET_STUDENTS_SUCCESS';
var GET_STUDENTS_FAILURE = exports.GET_STUDENTS_FAILURE = 'GET_STUDENTS_FAILURE';

var getStudentsByUserId = exports.getStudentsByUserId = function getStudentsByUserId(productId, userProfileId) {
    return { type: GET_STUDENTS_REQUEST, productId: productId, userProfileId: userProfileId, isLoadingEditStudentDetail: true };
};

var getStudentsSuccess = exports.getStudentsSuccess = function getStudentsSuccess(_ref) {
    var data = _ref.data;
    return { type: GET_STUDENTS_SUCCESS, data: data, isLoadingEditStudentDetail: false };
};

var getStudentsFailure = exports.getStudentsFailure = function getStudentsFailure() {
    return { type: GET_STUDENTS_FAILURE, isLoadingEditStudentDetail: false };
};

var OPEN_UNASSIGN_STUDENTS_MODAL = exports.OPEN_UNASSIGN_STUDENTS_MODAL = 'OPEN_UNASSIGN_STUDENTS_MODAL';
var CLOSE_UNASSIGN_STUDENTS_MODAL_CONFIRMATION = exports.CLOSE_UNASSIGN_STUDENTS_MODAL_CONFIRMATION = 'CLOSE_UNASSIGN_STUDENTS_MODAL_CONFIRMATION';

var openUnAssignStudentsModal = exports.openUnAssignStudentsModal = function openUnAssignStudentsModal() {
    return { type: OPEN_UNASSIGN_STUDENTS_MODAL, isUnassignedModalOpen: true };
};

var closeUnAssignStudentsModalConfirmation = exports.closeUnAssignStudentsModalConfirmation = function closeUnAssignStudentsModalConfirmation() {
    return { type: CLOSE_UNASSIGN_STUDENTS_MODAL_CONFIRMATION, refreshStudentsAfterUnAssign: false };
};

var UNASSIGN_STUDENTS_USING_CLASSID_REQUEST = exports.UNASSIGN_STUDENTS_USING_CLASSID_REQUEST = 'UNASSIGN_STUDENTS_USING_CLASSID_REQUEST';
var UNASSIGN_STUDENTS_USING_CLASSID_SUCCESS = exports.UNASSIGN_STUDENTS_USING_CLASSID_SUCCESS = 'UNASSIGN_STUDENTS_USING_CLASSID_SUCCESS';
var UNASSIGN_STUDENTS_USING_CLASSID_FAILURE = exports.UNASSIGN_STUDENTS_USING_CLASSID_FAILURE = 'UNASSIGN_STUDENTS_USING_CLASSID_FAILURE';

var unassignStudentsUsingClassId = exports.unassignStudentsUsingClassId = function unassignStudentsUsingClassId(userProfileId, classId) {
    return { type: UNASSIGN_STUDENTS_USING_CLASSID_REQUEST, userProfileId: userProfileId, isUnassignedModalOpen: true, classId: classId, unassignDisableButton: true };
};

var unassignStudentsByClassIdSuccess = exports.unassignStudentsByClassIdSuccess = function unassignStudentsByClassIdSuccess() {
    return { type: UNASSIGN_STUDENTS_USING_CLASSID_SUCCESS, isUnassignedModalOpen: false, unassignDisableButton: false };
};

var unassignStudentsByClassIdFailure = exports.unassignStudentsByClassIdFailure = function unassignStudentsByClassIdFailure() {
    return { type: UNASSIGN_STUDENTS_USING_CLASSID_FAILURE, unassignDisableButton: false };
};

var EDIT_STUDENT_REQUEST = exports.EDIT_STUDENT_REQUEST = 'EDIT_STUDENT_REQUEST';
var EDIT_STUDENT_SUCCESS_REQUEST = exports.EDIT_STUDENT_SUCCESS_REQUEST = 'EDIT_STUDENT_SUCCESS_REQUEST';
var EDIT_STUDENT_FAILURE_REQUEST = exports.EDIT_STUDENT_FAILURE_REQUEST = 'EDIT_STUDENT_FAILURE_REQUEST';

function editStudent(student, updatingStudent, context) {
    return {
        type: EDIT_STUDENT_REQUEST,
        student: student,
        updatingStudent: updatingStudent,
        context: context
    };
}

function editStudentSuccess(context) {
    context.router.history.push('/students');
    return {
        type: EDIT_STUDENT_SUCCESS_REQUEST,
        updatingStudent: false
    };
}

function editStudentFailure(isServerError, editStudentValidationMessage) {
    var showEditStudentValidationModal = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

    return {
        type: EDIT_STUDENT_FAILURE_REQUEST,
        editStudentValidationMessage: editStudentValidationMessage,
        showEditStudentValidationModal: showEditStudentValidationModal,
        updatingStudent: false,
        isServerError: isServerError
    };
}

var CLOSE_EDIT_STUDENT_VALIDATION_MODAL = exports.CLOSE_EDIT_STUDENT_VALIDATION_MODAL = 'CLOSE_EDIT_STUDENT_VALIDATION_MODAL';

function closeEditStudentValidationModal() {
    return {
        type: CLOSE_EDIT_STUDENT_VALIDATION_MODAL,
        showEditStudentValidationModal: false
    };
}

var REFRESH_STUDENT_LIST_ON_CANCEL_REQUEST = exports.REFRESH_STUDENT_LIST_ON_CANCEL_REQUEST = 'REFRESH_STUDENT_LIST_ON_CANCEL_REQUEST';

function refreshStudentListOnCancel() {
    return { type: REFRESH_STUDENT_LIST_ON_CANCEL_REQUEST, refreshStudentList: true };
}

var SHOW_HIDE_MODAL = exports.SHOW_HIDE_MODAL = 'SHOW_HIDE_MODAL';

function showHideModal(status) {
    return { type: SHOW_HIDE_MODAL, showModal: status };
}

/***/ }),
/* 128 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.editTeacher = editTeacher;
exports.editTeacherSuccess = editTeacherSuccess;
exports.editTeacherFailure = editTeacherFailure;
exports.closeEditTeacherValidationModal = closeEditTeacherValidationModal;
exports.refreshTeacherListOnCancel = refreshTeacherListOnCancel;
exports.printClassroomStudentsSignInCard = printClassroomStudentsSignInCard;
exports.sendPasswordLinkRequest = sendPasswordLinkRequest;
exports.sendPasswordLinkSuccess = sendPasswordLinkSuccess;
exports.sendPasswordLinkFailure = sendPasswordLinkFailure;
exports.resetPasswordParams = resetPasswordParams;
exports.sendVerificationEmailLinkRequest = sendVerificationEmailLinkRequest;
exports.sendVerificationEmailLinkSuccess = sendVerificationEmailLinkSuccess;
exports.sendVerificationEmailLinkFailure = sendVerificationEmailLinkFailure;
exports.resetValidationErrorModal = resetValidationErrorModal;
var GET_TEACHER_REQUEST = exports.GET_TEACHER_REQUEST = 'GET_TEACHER_REQUEST';
var GET_TEACHER_SUCCESS = exports.GET_TEACHER_SUCCESS = 'GET_TEACHER_SUCCESS';
var GET_TEACHER_FAILURE = exports.GET_TEACHER_FAILURE = 'GET_TEACHER_FAILURE';

var getTeacherByUserId = exports.getTeacherByUserId = function getTeacherByUserId(productId, userProfileId) {
    return { type: GET_TEACHER_REQUEST, productId: productId, userProfileId: userProfileId, isLoadingEditTeacherDetail: true };
};

var getTeacherSuccess = exports.getTeacherSuccess = function getTeacherSuccess(_ref) {
    var data = _ref.data;
    return { type: GET_TEACHER_SUCCESS, data: data, isLoadingEditTeacherDetail: false, downloadingClassroomIds: new Set() };
};

var getTeacherFailure = exports.getTeacherFailure = function getTeacherFailure() {
    return { type: GET_TEACHER_FAILURE, isLoadingEditTeacherDetail: false };
};

var OPEN_UNASSIGN_TEACHERS_MODAL = exports.OPEN_UNASSIGN_TEACHERS_MODAL = 'OPEN_UNASSIGN_TEACHERS_MODAL';
var CLOSE_UNASSIGN_TEACHERS_MODAL_CONFIRMATION = exports.CLOSE_UNASSIGN_TEACHERS_MODAL_CONFIRMATION = 'CLOSE_UNASSIGN_TEACHERS_MODAL_CONFIRMATION';

var openUnAssignTeachersModal = exports.openUnAssignTeachersModal = function openUnAssignTeachersModal() {
    return { type: OPEN_UNASSIGN_TEACHERS_MODAL, isUnassignedModalOpen: true };
};

var closeUnAssignTeachersModalConfirmation = exports.closeUnAssignTeachersModalConfirmation = function closeUnAssignTeachersModalConfirmation() {
    return { type: CLOSE_UNASSIGN_TEACHERS_MODAL_CONFIRMATION, refreshTeachersAfterUnAssign: false };
};

var UNASSIGN_TEACHERS_USING_CLASSID_REQUEST = exports.UNASSIGN_TEACHERS_USING_CLASSID_REQUEST = 'UNASSIGN_TEACHERS_USING_CLASSID_REQUEST';
var UNASSIGN_TEACHERS_USING_CLASSID_SUCCESS = exports.UNASSIGN_TEACHERS_USING_CLASSID_SUCCESS = 'UNASSIGN_TEACHERS_USING_CLASSID_SUCCESS';
var UNASSIGN_TEACHERS_USING_CLASSID_FAILURE = exports.UNASSIGN_TEACHERS_USING_CLASSID_FAILURE = 'UNASSIGN_TEACHERS_USING_CLASSID_FAILURE';
var CLOSE_UNASSIGN_MODAL_REQUEST = exports.CLOSE_UNASSIGN_MODAL_REQUEST = 'CLOSE_UNASSIGN_MODAL_REQUEST';

var unassignTeachersUsingClassId = exports.unassignTeachersUsingClassId = function unassignTeachersUsingClassId(userProfileId, classId) {
    return { type: UNASSIGN_TEACHERS_USING_CLASSID_REQUEST, userProfileId: userProfileId, isUnassignedModalOpen: true, classId: classId, unassignDisableButton: true };
};

var unassignTeachersByClassIdSuccess = exports.unassignTeachersByClassIdSuccess = function unassignTeachersByClassIdSuccess() {
    return { type: UNASSIGN_TEACHERS_USING_CLASSID_SUCCESS, isUnassignedModalOpen: false, unassignDisableButton: false };
};

var unassignTeachersByClassIdFailure = exports.unassignTeachersByClassIdFailure = function unassignTeachersByClassIdFailure() {
    return { type: UNASSIGN_TEACHERS_USING_CLASSID_FAILURE, unassignDisableButton: false };
};

var closeUnassignModalRequest = exports.closeUnassignModalRequest = function closeUnassignModalRequest() {
    return { type: CLOSE_UNASSIGN_MODAL_REQUEST };
};

var EDIT_TEACHER_REQUEST = exports.EDIT_TEACHER_REQUEST = 'EDIT_TEACHER_REQUEST';
var EDIT_TEACHER_SUCCESS_REQUEST = exports.EDIT_TEACHER_SUCCESS_REQUEST = 'EDIT_TEACHER_SUCCESS_REQUEST';
var EDIT_TEACHER_FAILURE_REQUEST = exports.EDIT_TEACHER_FAILURE_REQUEST = 'EDIT_TEACHER_FAILURE_REQUEST';

function editTeacher(teacher, updatingTeacher, context) {
    teacher.title = teacher.title.trim();
    teacher.firstName = teacher.firstName.trim();
    teacher.lastName = teacher.lastName.trim();
    if (teacher.emailAddress) {
        teacher.emailAddress = teacher.emailAddress.trim();
    }
    return {
        type: EDIT_TEACHER_REQUEST,
        teacher: teacher,
        updatingTeacher: updatingTeacher,
        context: context
    };
}

function editTeacherSuccess(context) {
    context.router.history.push('/teachers');
    return {
        type: EDIT_TEACHER_SUCCESS_REQUEST,
        updatingTeacher: false
    };
}

function editTeacherFailure(isServerError, editTeacherValidationMessage) {
    return {
        type: EDIT_TEACHER_FAILURE_REQUEST,
        editTeacherValidationMessage: editTeacherValidationMessage,
        showEditTeacherValidationModal: true,
        updatingTeacher: false,
        isServerError: isServerError
    };
}

var CLOSE_EDIT_TEACHER_VALIDATION_MODAL = exports.CLOSE_EDIT_TEACHER_VALIDATION_MODAL = 'CLOSE_EDIT_TEACHER_VALIDATION_MODAL';

function closeEditTeacherValidationModal() {
    return {
        type: CLOSE_EDIT_TEACHER_VALIDATION_MODAL,
        showEditTeacherValidationModal: false
    };
}

var REFRESH_TEACHER_LIST_ON_CANCEL_REQUEST = exports.REFRESH_TEACHER_LIST_ON_CANCEL_REQUEST = 'REFRESH_TEACHER_LIST_ON_CANCEL_REQUEST';

function refreshTeacherListOnCancel() {
    return { type: REFRESH_TEACHER_LIST_ON_CANCEL_REQUEST };
}

var PRINT_CLASSROOM_STUDENTS_SIGN_IN_CARD_REQUEST = exports.PRINT_CLASSROOM_STUDENTS_SIGN_IN_CARD_REQUEST = 'PRINT_CLASSROOM_STUDENTS_SIGN_IN_CARD_REQUEST';
var PRINT_CLASSROOM_STUDENTS_SIGN_IN_CARD_SUCCESS = exports.PRINT_CLASSROOM_STUDENTS_SIGN_IN_CARD_SUCCESS = 'PRINT_CLASSROOM_STUDENTS_SIGN_IN_CARD_SUCCESS';
var PRINT_CLASSROOM_STUDENTS_SIGN_IN_CARD_FAILURE = exports.PRINT_CLASSROOM_STUDENTS_SIGN_IN_CARD_FAILURE = 'PRINT_CLASSROOM_STUDENTS_SIGN_IN_CARD_FAILURE';

function printClassroomStudentsSignInCard(classroomId, productId, downloadingClassroomIds, SignInCardPageSizeType) {
    return { type: PRINT_CLASSROOM_STUDENTS_SIGN_IN_CARD_REQUEST, classroomId: classroomId, productId: productId, downloadingClassroomIds: downloadingClassroomIds, SignInCardPageSizeType: SignInCardPageSizeType };
}

var printClassroomStudentsSignInCardSuccess = exports.printClassroomStudentsSignInCardSuccess = function printClassroomStudentsSignInCardSuccess(classroomId, downloadUrl, downloadingClassroomIds) {
    window.location.href = downloadUrl;
    downloadingClassroomIds.delete(classroomId);
    return { type: PRINT_CLASSROOM_STUDENTS_SIGN_IN_CARD_SUCCESS, classroomId: classroomId, downloadUrl: downloadUrl, downloadingClassroomIds: downloadingClassroomIds };
};

var printClassroomStudentsSignInCardFailure = exports.printClassroomStudentsSignInCardFailure = function printClassroomStudentsSignInCardFailure(classroomId, downloadingClassroomIds) {
    downloadingClassroomIds.delete(classroomId);
    return { type: PRINT_CLASSROOM_STUDENTS_SIGN_IN_CARD_FAILURE, classroomId: classroomId, downloadingClassroomIds: downloadingClassroomIds };
};

var SEND_PASSWORD_LINK_REQUEST = exports.SEND_PASSWORD_LINK_REQUEST = 'SEND_PASSWORD_LINK_REQUEST';
var SEND_PASSWORD_LINK_SUCCESS = exports.SEND_PASSWORD_LINK_SUCCESS = 'SEND_PASSWORD_LINK_SUCCESS';
var SEND_PASSWORD_LINK_FAILURE = exports.SEND_PASSWORD_LINK_FAILURE = 'SEND_PASSWORD_LINK_FAILURE';
var RESET_PASSWORD_PARAMETERS = exports.RESET_PASSWORD_PARAMETERS = 'RESET_PASSWORD_PARAMETERS';

function sendPasswordLinkRequest(productId, userProfileId) {
    return { type: SEND_PASSWORD_LINK_REQUEST, productId: productId, userProfileId: userProfileId };
}

function sendPasswordLinkSuccess(status) {
    return { type: SEND_PASSWORD_LINK_SUCCESS, status: status };
}

function sendPasswordLinkFailure(errorMessage) {
    return { type: SEND_PASSWORD_LINK_FAILURE, errorMessage: errorMessage };
}

function resetPasswordParams() {
    return { type: RESET_PASSWORD_PARAMETERS };
}

var SEND_VERIFICATION_EMAIL_LINK_REQUEST = exports.SEND_VERIFICATION_EMAIL_LINK_REQUEST = 'SEND_VERIFICATION_EMAIL_LINK_REQUEST';
var SEND_VERIFICATION_EMAIL_LINK_SUCCESS = exports.SEND_VERIFICATION_EMAIL_LINK_SUCCESS = 'SEND_VERIFICATION_EMAIL_LINK_SUCCESS';
var SEND_VERIFICATION_EMAIL_LINK_FAILURE = exports.SEND_VERIFICATION_EMAIL_LINK_FAILURE = 'SEND_VERIFICATION_EMAIL_LINK_FAILURE';

function sendVerificationEmailLinkRequest(userProfileId) {
    return { type: SEND_VERIFICATION_EMAIL_LINK_REQUEST, userProfileId: userProfileId };
}

function sendVerificationEmailLinkSuccess(status) {
    return { type: SEND_VERIFICATION_EMAIL_LINK_SUCCESS, status: status };
}

function sendVerificationEmailLinkFailure(errorMessage) {
    return { type: SEND_VERIFICATION_EMAIL_LINK_FAILURE, errorMessage: errorMessage };
}

var VALIDATION_ERROR_MODAL_RESET = exports.VALIDATION_ERROR_MODAL_RESET = 'VALIDATION_ERROR_MODAL_RESET';

function resetValidationErrorModal() {
    return { type: VALIDATION_ERROR_MODAL_RESET };
}

/***/ }),
/* 129 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _queryString = __webpack_require__(177);

var _queryString2 = _interopRequireDefault(_queryString);

var _es = __webpack_require__(1592);

var _es2 = _interopRequireDefault(_es);

var _es3 = __webpack_require__(1316);

var _es4 = _interopRequireDefault(_es3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; } /**
                                                                                                                                                                                                                   * i18n.js
                                                                                                                                                                                                                   *
                                                                                                                                                                                                                   * This will setup the i18n language files and locale data for your app.
                                                                                                                                                                                                                   *
                                                                                                                                                                                                                   *   IMPORTANT: This file is used by the internal build
                                                                                                                                                                                                                   *   script `extract-intl`, and must use CommonJS module syntax
                                                                                                                                                                                                                   *   You CANNOT use import/export in this file.
                                                                                                                                                                                                                   */


var addLocaleData = __webpack_require__(2).addLocaleData; //eslint-disable-line
var enLocaleData = __webpack_require__(1591);

var enTranslationMessages = __webpack_require__(1315);

addLocaleData(enLocaleData);
addLocaleData(_es2.default);

var DEFAULT_LOCALE = 'en';

// prettier-ignore
var appLocales = ['en', 'en-au', 'es', 'es-mx'];

var formatTranslationMessages = function formatTranslationMessages(locale, messages) {
    var defaultFormattedMessages = locale !== DEFAULT_LOCALE ? formatTranslationMessages(DEFAULT_LOCALE, enTranslationMessages) : {};
    var flattenFormattedMessages = function flattenFormattedMessages(formattedMessages, key) {
        var formattedMessage = !messages[key] && locale !== DEFAULT_LOCALE ? defaultFormattedMessages[key] : messages[key];
        return Object.assign(formattedMessages, _defineProperty({}, key, formattedMessage));
    };
    return Object.keys(messages).reduce(flattenFormattedMessages, {});
};

var translationMessages = {
    en: formatTranslationMessages('en', enTranslationMessages),
    es: formatTranslationMessages('es', _es4.default),
    'es-mx': formatTranslationMessages('es-mx', _es4.default)
};

var getLocale = function getLocale() {
    var _queryString$parse = _queryString2.default.parse(location.search),
        locale = _queryString$parse.locale;

    return appLocales.indexOf(String(locale).toLowerCase()) !== -1 ? String(locale).toLowerCase() : DEFAULT_LOCALE;
};

exports.appLocales = appLocales;
exports.formatTranslationMessages = formatTranslationMessages;
exports.translationMessages = translationMessages;
exports.DEFAULT_LOCALE = DEFAULT_LOCALE;
exports.getLocale = getLocale;

/***/ }),
/* 130 */,
/* 131 */,
/* 132 */,
/* 133 */,
/* 134 */,
/* 135 */,
/* 136 */,
/* 137 */,
/* 138 */,
/* 139 */,
/* 140 */,
/* 141 */,
/* 142 */,
/* 143 */,
/* 144 */,
/* 145 */,
/* 146 */,
/* 147 */,
/* 148 */,
/* 149 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactStyleable = __webpack_require__(6);

var _reactStyleable2 = _interopRequireDefault(_reactStyleable);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _PulseLoader = __webpack_require__(60);

var _PulseLoader2 = _interopRequireDefault(_PulseLoader);

__webpack_require__(26);

var _index = __webpack_require__(1678);

var _index2 = _interopRequireDefault(_index);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Badge Component.
 *
 * @version 1.0.0
 * @author Team Voyager
 */
var Badge = function Badge(_ref) {
    var _ref$title = _ref.title,
        title = _ref$title === undefined ? '' : _ref$title,
        _ref$content = _ref.content,
        content = _ref$content === undefined ? null : _ref$content,
        _ref$badgeStyle = _ref.badgeStyle,
        badgeStyle = _ref$badgeStyle === undefined ? '' : _ref$badgeStyle,
        _ref$showLoader = _ref.showLoader,
        showLoader = _ref$showLoader === undefined ? false : _ref$showLoader;

    var titleElement = title === '' ? _react2.default.createElement('div', null) : _react2.default.createElement(
        'div',
        { className: _index2.default.title },
        title
    );

    var badgeElement = content === null && showLoader ? _react2.default.createElement(
        'div',
        { className: badgeStyle },
        _react2.default.createElement(_PulseLoader2.default, { margin: '2px', size: '6px' })
    ) : _react2.default.createElement(
        'div',
        { className: badgeStyle },
        content
    );

    return _react2.default.createElement(
        'div',
        { className: _index2.default.badgeComponent },
        titleElement,
        badgeElement
    );
};

Badge.propTypes = {
    /**
     * Title of the badge
     */
    title: _propTypes2.default.string,
    /**
     * Content to appear on the badge
     */
    content: _propTypes2.default.string,
    /**
     * CSS style of the badge
     */
    badgeStyle: _propTypes2.default.string,
    /**
     * Loader and hide loader
     */
    showLoader: _propTypes2.default.bool
};

exports.default = (0, _reactStyleable2.default)(_index2.default)(Badge);

/***/ }),
/* 150 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactDataGrid = __webpack_require__(178);

var _reactDataGrid2 = _interopRequireDefault(_reactDataGrid);

var _reactStyleable = __webpack_require__(6);

var _reactStyleable2 = _interopRequireDefault(_reactStyleable);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _difference = __webpack_require__(1439);

var _difference2 = _interopRequireDefault(_difference);

__webpack_require__(26);

var _index = __webpack_require__(1700);

var _index2 = _interopRequireDefault(_index);

var _iconDictionary = __webpack_require__(8);

var _index3 = __webpack_require__(76);

var _index4 = _interopRequireDefault(_index3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var DataGrid = function (_Component) {
    _inherits(DataGrid, _Component);

    function DataGrid(props) {
        _classCallCheck(this, DataGrid);

        var _this = _possibleConstructorReturn(this, (DataGrid.__proto__ || Object.getPrototypeOf(DataGrid)).call(this, props));

        _this.onRowsSelected = function (rows) {
            var allSelectedRows = _this.props.selectedRows.concat(rows.map(function (r) {
                return r.row[_this.props.rowKey];
            }));
            _this.props.handleRowSelect(allSelectedRows);
            if (_this.props.rowsCount > 0 && _this.props.rowsCount === allSelectedRows.length) {
                var selectAllCheckBox = _this.grid.getDataGridDOMNode().querySelector('#select-all-checkbox');
                selectAllCheckBox.checked = true;
            }
        };

        _this.onRowsDeselected = function (rows) {
            var allSelectedRows = (0, _difference2.default)(_this.props.selectedRows, rows.map(function (r) {
                return r.row[_this.props.rowKey];
            }));
            _this.props.handleRowSelect(allSelectedRows);
            var selectAllCheckBox = _this.grid.getDataGridDOMNode().querySelector('#select-all-checkbox');
            selectAllCheckBox.checked = false;
        };

        _this.onRowsSelected = _this.onRowsSelected.bind(_this);
        _this.onRowsDeselected = _this.onRowsDeselected.bind(_this);
        return _this;
    }

    _createClass(DataGrid, [{
        key: 'componentWillReceiveProps',
        value: function componentWillReceiveProps(nextProps) {
            if (nextProps.selectedRows.length === 0) {
                // To handle the deselect event
                if (this.props.selectedRows.length > 1 || this.props.selectedRows.length === 0) {
                    if (this.grid !== null && this.grid !== undefined) {
                        var gridCanvas = this.grid.getDataGridDOMNode().querySelector('.react-grid-Canvas');
                        gridCanvas.scrollTop = 0;
                    }
                }
            }

            if (nextProps.rowsCount !== nextProps.selectedRows.length) {
                if (this.grid !== null && this.grid !== undefined) {
                    var selectAllCheckBox = this.grid.getDataGridDOMNode().querySelector('#select-all-checkbox');
                    if (selectAllCheckBox) {
                        selectAllCheckBox.checked = false;
                    }
                }
            }
        }
    }, {
        key: 'setGridReference',
        value: function setGridReference(grid) {
            this.grid = grid;
            if (grid !== null && this.props.rowsCount > 0 && this.props.rowsCount === this.props.selectedRows.length) {
                var selectAllCheckBox = grid.getDataGridDOMNode().querySelector('#select-all-checkbox');
                if (selectAllCheckBox) {
                    selectAllCheckBox.checked = true;
                }
            }
        }
    }, {
        key: 'render',
        value: function render() {
            var _this2 = this;

            var emptyStateView = _react2.default.createElement(_index4.default, { iconName: _iconDictionary.StudentManagement });
            var gridView = this.props.showSelectionColumn ? _react2.default.createElement(_reactDataGrid2.default, {
                columns: this.props.columns,
                enableRowSelect: true,
                onGridSort: this.props.handleGridSort,
                overScan: { colsStart: 17, colsEnd: 17, rowsStart: 25, rowsEnd: 100 },
                ref: function ref(grid) {
                    return _this2.setGridReference(grid);
                },
                rowGetter: this.props.rowGetter,
                rowHeight: this.props.rowHeight,
                rowKey: this.props.rowKey,
                rowRenderer: this.props.rowRenderer,
                rowsCount: this.props.rowsCount,
                rowSelection: {
                    showCheckbox: true,
                    onRowsSelected: this.onRowsSelected,
                    onRowsDeselected: this.onRowsDeselected,
                    selectBy: {
                        keys: { rowKey: this.props.rowKey, values: this.props.selectedRows }
                    }
                }
            }) : _react2.default.createElement(_reactDataGrid2.default, {
                columns: this.props.columns,
                overScan: { colsStart: 17, colsEnd: 17, rowsStart: 25, rowsEnd: 100 },
                ref: function ref(grid) {
                    return _this2.setGridReference(grid);
                },
                rowGetter: this.props.rowGetter,
                rowHeight: this.props.rowHeight,
                rowKey: this.props.rowKey,
                rowRenderer: this.props.rowRenderer,
                rowsCount: this.props.rowsCount
            });

            var finalView = this.props.rowsCount === 0 ? emptyStateView : gridView;
            return _react2.default.createElement(
                'div',
                { className: _index2.default.gridContainer },
                finalView
            );
        }
    }]);

    return DataGrid;
}(_react.Component);

DataGrid.propTypes = {
    columns: _propTypes2.default.array,
    handleGridSort: _propTypes2.default.func,
    handleRowSelect: _propTypes2.default.func,
    rowGetter: _propTypes2.default.func,
    rowHeight: _propTypes2.default.number,
    rowKey: _propTypes2.default.string,
    rowRenderer: _propTypes2.default.func,
    rowsCount: _propTypes2.default.number,
    selectedRows: _propTypes2.default.arrayOf(_propTypes2.default.number),
    showSelectionColumn: _propTypes2.default.bool
};
DataGrid.defaultProps = {
    showSelectionColumn: true
};
exports.default = (0, _reactStyleable2.default)(_index2.default)(DataGrid);

/***/ }),
/* 151 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var DIVIDER = exports.DIVIDER = '────────────';
var DOTS = exports.DOTS = '...';
var COMPONENT_ID = exports.COMPONENT_ID = 'dropdown-list-component';
var DEFAULT_VARIANT = exports.DEFAULT_VARIANT = 'dropDownContainer';
var BORDERED = exports.BORDERED = 'bordered';
var FULL_WIDTH = exports.FULL_WIDTH = 'fullWidth';
var VARIANTS = exports.VARIANTS = [BORDERED];

/***/ }),
/* 152 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _reactIntl = __webpack_require__(2);

exports.default = (0, _reactIntl.defineMessages)({
    startFresh: {
        id: 'extend-result.components.startFresh',
        defaultMessage: 'Start Fresh or Keep Results from'
    },
    extendPeriodExpired: {
        id: 'extend-result.components.extendPeriodExpired',
        defaultMessage: 'Extend results period expired'
    },
    extendPeriodExpiredSummary: {
        id: 'extend-result.components.extendPeriodExpiredSummary',
        defaultMessage: 'The period in which your school can carry over of gold bars and results has expired'
    },
    resultsAlreadyExtended: {
        id: 'extend-result.components.resultsAlreadyExtended',
        defaultMessage: 'Results already extended'
    },
    resultsAlreadyExtendedSummary: {
        id: 'extend-result.components.resultsAlreadyExtendedSummary',
        defaultMessage: 'The gold bars and results carry over for this school has already been processed'
    },
    rolloverNotCompleted: {
        id: 'extend-result.components.rolloverNotCompleted',
        defaultMessage: 'School rollover not completed'
    },
    rolloverNotCompletedSummary: {
        id: 'extend-result.components.rolloverNotCompletedSummary',
        defaultMessage: 'Please complete a school rollover before gold bars and results carry over can be processed'
    },
    formHeader: {
        id: 'extend-result.components.formHeader',
        defaultMessage: 'Extend Result'
    },
    formContent1: {
        id: 'extend-result.components.formContent1',
        defaultMessage: 'Note: This can only be done once in an academic year, please proceed with CAUTION'
    },
    formContent2: {
        id: 'extend-result.components.formContent2',
        defaultMessage: 'Selecting Keep results will carry across Gold Bars. Selecting Start Fresh will not carry across Gold Bars.'
    },
    formContent3: {
        id: 'extend-result.components.formContent3',
        defaultMessage: 'Students will always retain their credits and certificates'
    },
    formContinueBtn: {
        id: 'extend-result.components.formContinueBtn',
        defaultMessage: 'Continue'
    },
    formHelpBtn: {
        id: 'extend-result.components.formHelpBtn',
        defaultMessage: 'What does this mean?'
    },
    successTitle: {
        id: 'extend-result.components.successTitle',
        defaultMessage: 'Results have been carried over, as per selections'
    },
    successTitleStartedFresh: {
        id: 'extend-result.components.successTitleStartedFresh',
        defaultMessage: 'Results have not been carried over'
    },
    successMessage: {
        id: 'extend-result.components.successMessage',
        defaultMessage: 'It may take up to 24 hours for results to be restored.'
    },
    failureTitle: {
        id: 'extend-result.components.failureTitle',
        defaultMessage: 'Results have not been carried over'
    },
    failureMessage: {
        id: 'extend-result.components.failureMessage',
        defaultMessage: 'Please contact Tech Support so we can follow up'
    },
    back: {
        id: 'extend-result.components.back',
        defaultMessage: 'Back'
    },
    proceed: {
        id: 'extend-result.components.proceed',
        defaultMessage: 'Proceed'
    },
    ok: {
        id: 'extend-result.components.ok',
        defaultMessage: 'OK'
    }
});

/***/ }),
/* 153 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.RolloverRowRenderer = exports.ClassRowRenderer = exports.TeacherRowRenderer = exports.StudentRowRenderer = undefined;

var _index = __webpack_require__(742);

var _index2 = _interopRequireDefault(_index);

var _index3 = __webpack_require__(743);

var _index4 = _interopRequireDefault(_index3);

var _index5 = __webpack_require__(740);

var _index6 = _interopRequireDefault(_index5);

var _index7 = __webpack_require__(741);

var _index8 = _interopRequireDefault(_index7);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.StudentRowRenderer = _index2.default;
exports.TeacherRowRenderer = _index4.default;
exports.ClassRowRenderer = _index6.default;
exports.RolloverRowRenderer = _index8.default;

/***/ }),
/* 154 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var GET_COUNTRY_YEAR_GROUPS_REQUEST = exports.GET_COUNTRY_YEAR_GROUPS_REQUEST = 'GET_COUNTRY_YEAR_GROUPS_REQUEST';
var GET_COUNTRY_YEAR_GROUPS_SUCCESS = exports.GET_COUNTRY_YEAR_GROUPS_SUCCESS = 'GET_COUNTRY_YEAR_GROUPS_SUCCESS';
var GET_COUNTRY_YEAR_GROUPS_FAILURE = exports.GET_COUNTRY_YEAR_GROUPS_FAILURE = 'GET_COUNTRY_YEAR_GROUPS_FAILURE';

var getCountryYearGroupRequest = exports.getCountryYearGroupRequest = function getCountryYearGroupRequest(countryCode, success, failure) {
    return { type: GET_COUNTRY_YEAR_GROUPS_REQUEST, countryCode: countryCode, success: success, failure: failure, countryCourses: [] };
};

var getCountryYearGroupSuccess = exports.getCountryYearGroupSuccess = function getCountryYearGroupSuccess(yearGroups) {
    return { type: GET_COUNTRY_YEAR_GROUPS_SUCCESS, isLoadingCountryCourses: false, yearGroups: yearGroups };
};

var getCountryYearGroupFailure = exports.getCountryYearGroupFailure = function getCountryYearGroupFailure() {
    return { type: GET_COUNTRY_YEAR_GROUPS_FAILURE, isLoadingCountryCourses: false };
};

var CLEAR_COURSE_LIST = exports.CLEAR_COURSE_LIST = 'CLEAR_COURSE_LIST';

var clearCourseList = exports.clearCourseList = function clearCourseList() {
    return { type: CLEAR_COURSE_LIST, productCourses: [] };
};

var DESELECT_COURSE = exports.DESELECT_COURSE = 'DESELECT_COURSE';

var deselectCourses = exports.deselectCourses = function deselectCourses() {
    var deselectCourse = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
    return { type: DESELECT_COURSE, deselectCourse: deselectCourse };
};

var GET_YEAR_GROUP_REQUEST = exports.GET_YEAR_GROUP_REQUEST = 'GET_YEAR_GROUP_REQUEST';
var GET_YEAR_GROUP_SUCCESS = exports.GET_YEAR_GROUP_SUCCESS = 'GET_YEAR_GROUP_SUCCESS';
var GET_YEAR_GROUP_FAILURE = exports.GET_YEAR_GROUP_FAILURE = 'GET_YEAR_GROUP_FAILURE';

var getYearGroup = exports.getYearGroup = function getYearGroup() {
    return { type: GET_YEAR_GROUP_REQUEST };
};

var getYearGroupSuccess = exports.getYearGroupSuccess = function getYearGroupSuccess(_ref) {
    var data = _ref.data;
    return { type: GET_YEAR_GROUP_SUCCESS, data: data };
};

var getYearGroupFailure = exports.getYearGroupFailure = function getYearGroupFailure() {
    return { type: GET_YEAR_GROUP_FAILURE };
};

var GET_COUNTRY_REQUEST = exports.GET_COUNTRY_REQUEST = 'GET_COUNTRY_REQUEST';
var GET_COUNTRY_SUCCESS = exports.GET_COUNTRY_SUCCESS = 'GET_COUNTRY_SUCCESS';
var GET_COUNTRY_FAILURE = exports.GET_COUNTRY_FAILURE = 'GET_COUNTRY_FAILURE';

var getCourseCountry = exports.getCourseCountry = function getCourseCountry(selectedProductId) {
    return { type: GET_COUNTRY_REQUEST, selectedProductId: selectedProductId };
};

var getCourseCountrySuccess = exports.getCourseCountrySuccess = function getCourseCountrySuccess(data) {
    return { type: GET_COUNTRY_SUCCESS, data: data };
};

var getCourseCountryFailure = exports.getCourseCountryFailure = function getCourseCountryFailure() {
    return { type: GET_COUNTRY_FAILURE };
};

var GET_UPF_COUNTRY_REQUEST = exports.GET_UPF_COUNTRY_REQUEST = 'GET_UPF_COUNTRY_REQUEST';
var GET_UPF_COUNTRY_SUCCESS = exports.GET_UPF_COUNTRY_SUCCESS = 'GET_UPF_COUNTRY_SUCCESS';
var GET_UPF_COUNTRY_FAILURE = exports.GET_UPF_COUNTRY_FAILURE = 'GET_UPF_COUNTRY_FAILURE';

var getUpfCourseCountry = exports.getUpfCourseCountry = function getUpfCourseCountry(selectedProductId) {
    return { type: GET_UPF_COUNTRY_REQUEST, selectedProductId: selectedProductId };
};

var getUpfCourseCountrySuccess = exports.getUpfCourseCountrySuccess = function getUpfCourseCountrySuccess(data) {
    return { type: GET_UPF_COUNTRY_SUCCESS, data: data };
};

var getUpfCourseCountryFailure = exports.getUpfCourseCountryFailure = function getUpfCourseCountryFailure() {
    return { type: GET_UPF_COUNTRY_FAILURE };
};

var GET_PRODUCT_COURSE_REQUEST = exports.GET_PRODUCT_COURSE_REQUEST = 'GET_PRODUCT_COURSE_REQUEST';
var GET_PRODUCT_COURSE_SUCCESS = exports.GET_PRODUCT_COURSE_SUCCESS = 'GET_PRODUCT_COURSE_SUCCESS';
var GET_PRODUCT_COURSE_FAILURE = exports.GET_PRODUCT_COURSE_FAILURE = 'GET_PRODUCT_COURSE_FAILURE';

var getProductCourse = exports.getProductCourse = function getProductCourse(countryCode, productId, yearGroup) {
    return { type: GET_PRODUCT_COURSE_REQUEST, countryCode: countryCode, productId: productId, yearGroup: yearGroup, isProductCoursesLoaded: false, isProductCoursesFetching: true };
};

var getProductCourseSuccess = exports.getProductCourseSuccess = function getProductCourseSuccess(data) {
    return { type: GET_PRODUCT_COURSE_SUCCESS, data: data, isProductCoursesLoaded: true, isProductCoursesFetching: false };
};

var getProductCourseFailure = exports.getProductCourseFailure = function getProductCourseFailure() {
    return { type: GET_PRODUCT_COURSE_FAILURE, isProductCoursesLoaded: true, isProductCoursesFetching: false };
};

var GET_SCHOOL_COURSE_REQUEST = exports.GET_SCHOOL_COURSE_REQUEST = 'GET_SCHOOL_COURSE_REQUEST';
var GET_SCHOOL_COURSE_SUCCESS = exports.GET_SCHOOL_COURSE_SUCCESS = 'GET_SCHOOL_COURSE_SUCCESS';
var GET_SCHOOL_COURSE_FAILURE = exports.GET_SCHOOL_COURSE_FAILURE = 'GET_SCHOOL_COURSE_FAILURE';

var getSchoolCourse = exports.getSchoolCourse = function getSchoolCourse(yearGroup) {
    return { type: GET_SCHOOL_COURSE_REQUEST, yearGroup: yearGroup };
};

var getSchoolCourseSuccess = exports.getSchoolCourseSuccess = function getSchoolCourseSuccess(data) {
    return { type: GET_SCHOOL_COURSE_SUCCESS, data: data };
};

var getSchoolCourseFailure = exports.getSchoolCourseFailure = function getSchoolCourseFailure() {
    return { type: GET_SCHOOL_COURSE_FAILURE };
};

/***/ }),
/* 155 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var EMPTY_VALUE = exports.EMPTY_VALUE = '-1';
var DATE_TIME_TIMEZONE_FORMAT = exports.DATE_TIME_TIMEZONE_FORMAT = 'YYYY-MM-DDTHH:mm:ssZ';
var SHORT_DATE_FORMAT = exports.SHORT_DATE_FORMAT = 'YYYY-MM-DD';
var REQUEST_DATE_FORMAT = exports.REQUEST_DATE_FORMAT = 'DD-MM-YYYY';
var LONG_DATE_FORMAT = exports.LONG_DATE_FORMAT = 'DD MMMM YYYY';
var SELECTED_DATE_PICKER_VALUE_TYPE = exports.SELECTED_DATE_PICKER_VALUE_TYPE = 'This school year';
var GOLD_CERTIFICATE_TYPE = exports.GOLD_CERTIFICATE_TYPE = '3';
var SILVER_CERTIFICATE_TYPE = exports.SILVER_CERTIFICATE_TYPE = '2';
var BRONZE_CERTIFICATE_TYPE = exports.BRONZE_CERTIFICATE_TYPE = '1';

var CERTIFICATE_TYPES = exports.CERTIFICATE_TYPES = [GOLD_CERTIFICATE_TYPE, SILVER_CERTIFICATE_TYPE, BRONZE_CERTIFICATE_TYPE];

var DOWNLOAD_CERTIFICATES_URL_PATH = exports.DOWNLOAD_CERTIFICATES_URL_PATH = 'api/v1/certificates/export';
var DOWNLOAD_CERTIFICATES_BY_TYPES_URL_PATH = exports.DOWNLOAD_CERTIFICATES_BY_TYPES_URL_PATH = 'api/v1/certificates/types/{type}/export';

/***/ }),
/* 156 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.downloadQuickUploadTemplate = downloadQuickUploadTemplate;
exports.quickUpload = quickUpload;
exports.quickUploadSuccess = quickUploadSuccess;
exports.quickUploadFailure = quickUploadFailure;
exports.closeModal = closeModal;
var DOWNLOAD_QUICK_UPLOAD_TEMPLATE_REQUEST = exports.DOWNLOAD_QUICK_UPLOAD_TEMPLATE_REQUEST = 'DOWNLOAD_QUICK_UPLOAD_TEMPLATE_REQUEST';
var DOWNLOAD_QUICK_UPLOAD_TEMPLATE_SUCCESS = exports.DOWNLOAD_QUICK_UPLOAD_TEMPLATE_SUCCESS = 'DOWNLOAD_QUICK_UPLOAD_TEMPLATE_SUCCESS';
var DOWNLOAD_QUICK_UPLOAD_TEMPLATE_FAILURE = exports.DOWNLOAD_QUICK_UPLOAD_TEMPLATE_FAILURE = 'DOWNLOAD_QUICK_UPLOAD_TEMPLATE_FAILURE';

function downloadQuickUploadTemplate(downloadingQuickUploadTemplate) {
    return {
        type: DOWNLOAD_QUICK_UPLOAD_TEMPLATE_REQUEST,
        downloadingQuickUploadTemplate: downloadingQuickUploadTemplate
    };
}

var downloadQuickUploadTemplateSuccess = exports.downloadQuickUploadTemplateSuccess = function downloadQuickUploadTemplateSuccess(downloadUrl, downloadingQuickUploadTemplate) {
    window.location.href = downloadUrl;
    return { type: DOWNLOAD_QUICK_UPLOAD_TEMPLATE_SUCCESS, downloadUrl: downloadUrl, downloadingQuickUploadTemplate: downloadingQuickUploadTemplate };
};

var downloadQuickUploadTemplateFailure = exports.downloadQuickUploadTemplateFailure = function downloadQuickUploadTemplateFailure() {
    return {
        type: DOWNLOAD_QUICK_UPLOAD_TEMPLATE_FAILURE
    };
};

var QUICK_UPLOAD_TEMPLATE_REQUEST = exports.QUICK_UPLOAD_TEMPLATE_REQUEST = 'QUICK_UPLOAD_TEMPLATE_REQUEST';
var QUICK_UPLOAD_TEMPLATE_SUCCESS = exports.QUICK_UPLOAD_TEMPLATE_SUCCESS = 'QUICK_UPLOAD_TEMPLATE_SUCCESS';
var QUICK_UPLOAD_TEMPLATE_FAILURE = exports.QUICK_UPLOAD_TEMPLATE_FAILURE = 'QUICK_UPLOAD_TEMPLATE_FAILURE';

function quickUpload(productId, fileContent, uploadingTemplate) {
    return {
        type: QUICK_UPLOAD_TEMPLATE_REQUEST,
        productId: productId,
        fileContent: fileContent,
        uploadingTemplate: uploadingTemplate
    };
}

function quickUploadSuccess(quickUploadResponse, showModal, uploadingTemplate) {
    return {
        type: QUICK_UPLOAD_TEMPLATE_SUCCESS,
        quickUploadResponse: quickUploadResponse,
        uploadingTemplate: uploadingTemplate,
        showModal: showModal
    };
}

function quickUploadFailure(isServerError, errorMessage, showModal, uploadingTemplate, isWarning) {
    return {
        type: QUICK_UPLOAD_TEMPLATE_FAILURE,
        isServerError: isServerError,
        errorMessage: errorMessage,
        uploadingTemplate: uploadingTemplate,
        showModal: showModal,
        isWarning: isWarning
    };
}

var QUICK_UPLOAD_CLOSE_MODAL_REQUEST = exports.QUICK_UPLOAD_CLOSE_MODAL_REQUEST = 'QUICK_UPLOAD_CLOSE_MODAL_REQUEST';

function closeModal() {
    return {
        type: QUICK_UPLOAD_CLOSE_MODAL_REQUEST,
        showModal: false
    };
}

/***/ }),
/* 157 */,
/* 158 */,
/* 159 */,
/* 160 */,
/* 161 */,
/* 162 */,
/* 163 */,
/* 164 */,
/* 165 */,
/* 166 */,
/* 167 */,
/* 168 */,
/* 169 */,
/* 170 */,
/* 171 */,
/* 172 */,
/* 173 */,
/* 174 */,
/* 175 */,
/* 176 */,
/* 177 */,
/* 178 */,
/* 179 */,
/* 180 */,
/* 181 */,
/* 182 */,
/* 183 */,
/* 184 */,
/* 185 */,
/* 186 */,
/* 187 */,
/* 188 */,
/* 189 */,
/* 190 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactStyleable = __webpack_require__(6);

var _reactStyleable2 = _interopRequireDefault(_reactStyleable);

var _index = __webpack_require__(7);

var _index2 = _interopRequireDefault(_index);

var _index3 = __webpack_require__(1725);

var _index4 = _interopRequireDefault(_index3);

var _iconDictionary = __webpack_require__(8);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var SearchBox = function (_React$Component) {
    _inherits(SearchBox, _React$Component);

    function SearchBox(props) {
        _classCallCheck(this, SearchBox);

        var _this = _possibleConstructorReturn(this, (SearchBox.__proto__ || Object.getPrototypeOf(SearchBox)).call(this, props));

        _this.handleOnSearchTextBoxChanged = function (e) {
            _this.setState({ valueAttr: e.target.value });
            _this.props.handleOnSearchClick(e.target.value);
        };

        _this.handleOnClearClick = function () {
            var emptyText = '';

            _this.props.handleOnSearchClick(emptyText);

            _this.setState({ valueAttr: emptyText });
        };

        _this.handleOnSearchClick = function () {
            _this.props.handleOnSearchClick(_this.state.valueAttr);
        };

        _this.handleOnKeyPress = function (e) {
            if (e.key === 'Enter') {
                _this.props.handleOnSearchClick(_this.state.valueAttr);
            }
        };

        _this.state = { valueAttr: props.searchTerm };
        return _this;
    }

    _createClass(SearchBox, [{
        key: 'componentWillReceiveProps',
        value: function componentWillReceiveProps(nextProps) {
            if (nextProps.searchTerm !== this.props.searchTerm) {
                this.state = { valueAttr: nextProps.searchTerm };
            }
        }
    }, {
        key: 'render',
        value: function render() {
            return _react2.default.createElement(
                'div',
                { className: _index4.default.searchBoxComponent },
                _react2.default.createElement(
                    'div',
                    { className: _index4.default.searchTextBoxComponent },
                    _react2.default.createElement('input', {
                        className: _index4.default.textBoxSearchText,
                        onChange: this.handleOnSearchTextBoxChanged,
                        onKeyPress: this.handleOnKeyPress,
                        type: 'text',
                        value: this.state.valueAttr }),
                    _react2.default.createElement(_index2.default, {
                        buttonContainer: _index4.default.buttonContainer,
                        containerClassName: _index4.default.searchClearButton,
                        disabled: false,
                        handleOnClick: this.handleOnClearClick,
                        icon: _iconDictionary.Cross,
                        iconClassName: _index4.default.svgIconContainerTextBoxSearch,
                        visible: true
                    })
                ),
                _react2.default.createElement(_index2.default, {
                    containerClassName: _index4.default.searchButton,
                    disabled: false,
                    handleOnClick: this.handleOnSearchClick,
                    icon: _iconDictionary.Search,
                    iconClassName: _index4.default.svgIconContainerSearchButton,
                    visible: true
                })
            );
        }
    }]);

    return SearchBox;
}(_react2.default.Component);

SearchBox.propTypes = {
    handleOnSearchClick: _propTypes2.default.func,
    searchTerm: _propTypes2.default.string
};

exports.default = (0, _reactStyleable2.default)(_index4.default)(SearchBox);

/***/ }),
/* 191 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var GET_COUNTRY_YEAR_GROUPS_REQUEST = exports.GET_COUNTRY_YEAR_GROUPS_REQUEST = 'GET_COUNTRY_YEAR_GROUPS_REQUEST';
var GET_COUNTRY_YEAR_GROUPS_SUCCESS = exports.GET_COUNTRY_YEAR_GROUPS_SUCCESS = 'GET_COUNTRY_YEAR_GROUPS_SUCCESS';
var GET_COUNTRY_YEAR_GROUPS_FAILURE = exports.GET_COUNTRY_YEAR_GROUPS_FAILURE = 'GET_COUNTRY_YEAR_GROUPS_FAILURE';
var CLEAR_COURSE_LIST = exports.CLEAR_COURSE_LIST = 'CLEAR_COURSE_LIST';
var DESELECT_COURSE = exports.DESELECT_COURSE = 'DESELECT_COURSE';
var GET_YEAR_GROUP_REQUEST = exports.GET_YEAR_GROUP_REQUEST = 'GET_YEAR_GROUP_REQUEST';
var GET_YEAR_GROUP_SUCCESS = exports.GET_YEAR_GROUP_SUCCESS = 'GET_YEAR_GROUP_SUCCESS';
var GET_YEAR_GROUP_FAILURE = exports.GET_YEAR_GROUP_FAILURE = 'GET_YEAR_GROUP_FAILURE';
var GET_COUNTRY_REQUEST = exports.GET_COUNTRY_REQUEST = 'GET_COUNTRY_REQUEST';
var GET_COUNTRY_SUCCESS = exports.GET_COUNTRY_SUCCESS = 'GET_COUNTRY_SUCCESS';
var GET_COUNTRY_FAILURE = exports.GET_COUNTRY_FAILURE = 'GET_COUNTRY_FAILURE';
var GET_CONQUEST_COUNTRY_REQUEST = exports.GET_CONQUEST_COUNTRY_REQUEST = 'GET_CONQUEST_COUNTRY_REQUEST';
var GET_CONQUEST_COUNTRY_SUCCESS = exports.GET_CONQUEST_COUNTRY_SUCCESS = 'GET_CONQUEST_COUNTRY_SUCCESS';
var GET_CONQUEST_COUNTRY_FAILURE = exports.GET_CONQUEST_COUNTRY_FAILURE = 'GET_CONQUEST_COUNTRY_FAILURE';
var GET_PRODUCT_COURSE_REQUEST = exports.GET_PRODUCT_COURSE_REQUEST = 'GET_PRODUCT_COURSE_REQUEST';
var GET_PRODUCT_COURSE_SUCCESS = exports.GET_PRODUCT_COURSE_SUCCESS = 'GET_PRODUCT_COURSE_SUCCESS';
var GET_PRODUCT_COURSE_FAILURE = exports.GET_PRODUCT_COURSE_FAILURE = 'GET_PRODUCT_COURSE_FAILURE';
var GET_SCHOOL_COURSE_REQUEST = exports.GET_SCHOOL_COURSE_REQUEST = 'GET_SCHOOL_COURSE_REQUEST';
var GET_SCHOOL_COURSE_SUCCESS = exports.GET_SCHOOL_COURSE_SUCCESS = 'GET_SCHOOL_COURSE_SUCCESS';
var GET_SCHOOL_COURSE_FAILURE = exports.GET_SCHOOL_COURSE_FAILURE = 'GET_SCHOOL_COURSE_FAILURE';
var SHOW_COURSE_DETAILS = exports.SHOW_COURSE_DETAILS = 'SHOW_COURSE_DETAILS';
var GET_FILTERED_CONQUEST_COURSES_REQUEST = exports.GET_FILTERED_CONQUEST_COURSES_REQUEST = 'GET_FILTERED_CONQUEST_COURSES_REQUEST';
var GET_FILTERED_CONQUEST_COURSES_SUCCESS = exports.GET_FILTERED_CONQUEST_COURSES_SUCCESS = 'GET_FILTERED_CONQUEST_COURSES_SUCCESS';
var GET_FILTERED_CONQUEST_COURSES_FAILURE = exports.GET_FILTERED_CONQUEST_COURSES_FAILURE = 'GET_FILTERED_CONQUEST_COURSES_FAILURE';

/***/ }),
/* 192 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var GET_COUNTRY_YEAR_GROUPS_REQUEST = exports.GET_COUNTRY_YEAR_GROUPS_REQUEST = 'GET_COUNTRY_YEAR_GROUPS_REQUEST';
var GET_COUNTRY_YEAR_GROUPS_SUCCESS = exports.GET_COUNTRY_YEAR_GROUPS_SUCCESS = 'GET_COUNTRY_YEAR_GROUPS_SUCCESS';
var GET_COUNTRY_YEAR_GROUPS_FAILURE = exports.GET_COUNTRY_YEAR_GROUPS_FAILURE = 'GET_COUNTRY_YEAR_GROUPS_FAILURE';
var CLEAR_COURSE_LIST = exports.CLEAR_COURSE_LIST = 'CLEAR_COURSE_LIST';
var DESELECT_COURSE = exports.DESELECT_COURSE = 'DESELECT_COURSE';
var GET_YEAR_GROUP_REQUEST = exports.GET_YEAR_GROUP_REQUEST = 'GET_YEAR_GROUP_REQUEST';
var GET_YEAR_GROUP_SUCCESS = exports.GET_YEAR_GROUP_SUCCESS = 'GET_YEAR_GROUP_SUCCESS';
var GET_YEAR_GROUP_FAILURE = exports.GET_YEAR_GROUP_FAILURE = 'GET_YEAR_GROUP_FAILURE';
var GET_COUNTRY_REQUEST = exports.GET_COUNTRY_REQUEST = 'GET_COUNTRY_REQUEST';
var GET_COUNTRY_SUCCESS = exports.GET_COUNTRY_SUCCESS = 'GET_COUNTRY_SUCCESS';
var GET_COUNTRY_FAILURE = exports.GET_COUNTRY_FAILURE = 'GET_COUNTRY_FAILURE';
var GET_PRODUCT_COURSE_REQUEST = exports.GET_PRODUCT_COURSE_REQUEST = 'GET_PRODUCT_COURSE_REQUEST';
var GET_PRODUCT_COURSE_SUCCESS = exports.GET_PRODUCT_COURSE_SUCCESS = 'GET_PRODUCT_COURSE_SUCCESS';
var GET_PRODUCT_COURSE_FAILURE = exports.GET_PRODUCT_COURSE_FAILURE = 'GET_PRODUCT_COURSE_FAILURE';
var GET_SCHOOL_COURSE_REQUEST = exports.GET_SCHOOL_COURSE_REQUEST = 'GET_SCHOOL_COURSE_REQUEST';
var GET_SCHOOL_COURSE_SUCCESS = exports.GET_SCHOOL_COURSE_SUCCESS = 'GET_SCHOOL_COURSE_SUCCESS';
var GET_SCHOOL_COURSE_FAILURE = exports.GET_SCHOOL_COURSE_FAILURE = 'GET_SCHOOL_COURSE_FAILURE';
var SHOW_COURSE_DETAILS = exports.SHOW_COURSE_DETAILS = 'SHOW_COURSE_DETAILS';
var GET_FILTERED_LEGACY_COURSES_REQUEST = exports.GET_FILTERED_LEGACY_COURSES_REQUEST = 'GET_FILTERED_LEGACY_COURSES_REQUEST';
var GET_FILTERED_LEGACY_COURSES_SUCCESS = exports.GET_FILTERED_LEGACY_COURSES_SUCCESS = 'GET_FILTERED_LEGACY_COURSES_SUCCESS';
var GET_FILTERED_LEGACY_COURSES_FAILURE = exports.GET_FILTERED_LEGACY_COURSES_FAILURE = 'GET_FILTERED_LEGACY_COURSES_FAILURE';

/***/ }),
/* 193 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var GET_COUNTRY_YEAR_GROUPS_REQUEST = exports.GET_COUNTRY_YEAR_GROUPS_REQUEST = 'GET_COUNTRY_YEAR_GROUPS_REQUEST';
var GET_COUNTRY_YEAR_GROUPS_SUCCESS = exports.GET_COUNTRY_YEAR_GROUPS_SUCCESS = 'GET_COUNTRY_YEAR_GROUPS_SUCCESS';
var GET_COUNTRY_YEAR_GROUPS_FAILURE = exports.GET_COUNTRY_YEAR_GROUPS_FAILURE = 'GET_COUNTRY_YEAR_GROUPS_FAILURE';
var CLEAR_COURSE_LIST = exports.CLEAR_COURSE_LIST = 'CLEAR_COURSE_LIST';
var DESELECT_COURSE = exports.DESELECT_COURSE = 'DESELECT_COURSE';
var GET_YEAR_GROUP_REQUEST = exports.GET_YEAR_GROUP_REQUEST = 'GET_YEAR_GROUP_REQUEST';
var GET_YEAR_GROUP_SUCCESS = exports.GET_YEAR_GROUP_SUCCESS = 'GET_YEAR_GROUP_SUCCESS';
var GET_YEAR_GROUP_FAILURE = exports.GET_YEAR_GROUP_FAILURE = 'GET_YEAR_GROUP_FAILURE';
var GET_COUNTRY_REQUEST = exports.GET_COUNTRY_REQUEST = 'GET_COUNTRY_REQUEST';
var GET_COUNTRY_SUCCESS = exports.GET_COUNTRY_SUCCESS = 'GET_COUNTRY_SUCCESS';
var GET_COUNTRY_FAILURE = exports.GET_COUNTRY_FAILURE = 'GET_COUNTRY_FAILURE';
var GET_UPF_COUNTRY_REQUEST = exports.GET_UPF_COUNTRY_REQUEST = 'GET_UPF_COUNTRY_REQUEST';
var GET_UPF_COUNTRY_SUCCESS = exports.GET_UPF_COUNTRY_SUCCESS = 'GET_UPF_COUNTRY_SUCCESS';
var GET_UPF_COUNTRY_FAILURE = exports.GET_UPF_COUNTRY_FAILURE = 'GET_UPF_COUNTRY_FAILURE';
var GET_PRODUCT_COURSE_REQUEST = exports.GET_PRODUCT_COURSE_REQUEST = 'GET_PRODUCT_COURSE_REQUEST';
var GET_PRODUCT_COURSE_SUCCESS = exports.GET_PRODUCT_COURSE_SUCCESS = 'GET_PRODUCT_COURSE_SUCCESS';
var GET_PRODUCT_COURSE_FAILURE = exports.GET_PRODUCT_COURSE_FAILURE = 'GET_PRODUCT_COURSE_FAILURE';
var GET_SCHOOL_COURSE_REQUEST = exports.GET_SCHOOL_COURSE_REQUEST = 'GET_SCHOOL_COURSE_REQUEST';
var GET_SCHOOL_COURSE_SUCCESS = exports.GET_SCHOOL_COURSE_SUCCESS = 'GET_SCHOOL_COURSE_SUCCESS';
var GET_SCHOOL_COURSE_FAILURE = exports.GET_SCHOOL_COURSE_FAILURE = 'GET_SCHOOL_COURSE_FAILURE';
var SHOW_COURSE_DETAILS = exports.SHOW_COURSE_DETAILS = 'SHOW_COURSE_DETAILS';
var GET_FILTERED_UPF_COURSES_REQUEST = exports.GET_FILTERED_UPF_COURSES_REQUEST = 'GET_FILTERED_UPF_COURSES_REQUEST';
var GET_FILTERED_UPF_COURSES_SUCCESS = exports.GET_FILTERED_UPF_COURSES_SUCCESS = 'GET_FILTERED_UPF_COURSES_SUCCESS';
var GET_FILTERED_UPF_COURSES_FAILURE = exports.GET_FILTERED_UPF_COURSES_FAILURE = 'GET_FILTERED_UPF_COURSES_FAILURE';

/***/ }),
/* 194 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var getProductId = function getProductId(state) {
  return state.product.id;
};
exports.default = getProductId;

/***/ }),
/* 195 */,
/* 196 */,
/* 197 */,
/* 198 */,
/* 199 */,
/* 200 */,
/* 201 */,
/* 202 */,
/* 203 */,
/* 204 */,
/* 205 */,
/* 206 */,
/* 207 */,
/* 208 */,
/* 209 */,
/* 210 */,
/* 211 */,
/* 212 */,
/* 213 */,
/* 214 */,
/* 215 */,
/* 216 */,
/* 217 */,
/* 218 */,
/* 219 */,
/* 220 */,
/* 221 */,
/* 222 */,
/* 223 */,
/* 224 */,
/* 225 */,
/* 226 */,
/* 227 */,
/* 228 */,
/* 229 */,
/* 230 */,
/* 231 */,
/* 232 */,
/* 233 */,
/* 234 */,
/* 235 */,
/* 236 */,
/* 237 */,
/* 238 */,
/* 239 */,
/* 240 */,
/* 241 */,
/* 242 */,
/* 243 */,
/* 244 */,
/* 245 */,
/* 246 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1101);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(5)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../node_modules/css-loader/index.js?modules&localIdentName=[local]---[hash:base64:5]!../../../node_modules/postcss-loader/lib/index.js!../../../node_modules/sass-loader/index.js!./index.scss", function() {
			var newContent = require("!!../../../node_modules/css-loader/index.js?modules&localIdentName=[local]---[hash:base64:5]!../../../node_modules/postcss-loader/lib/index.js!../../../node_modules/sass-loader/index.js!./index.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 247 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _reactIntl = __webpack_require__(2);

exports.default = (0, _reactIntl.defineMessages)({
    title: {
        id: 'app.components.AddGroup.title',
        defaultMessage: 'Enter the name of the new group'
    },
    inputPlaceholder: {
        id: 'app.components.AddGroup.inputPlaceholder',
        defaultMessage: 'Enter the name of the new group'
    },
    done: {
        id: 'app.components.AddGroup.done',
        defaultMessage: 'Done'
    },
    manageStudent: {
        id: 'app.components.AddGroup.manageStudent',
        defaultMessage: 'Manage student'
    },
    changeCourse: {
        id: 'app.components.AddGroup.changeCourse',
        defaultMessage: 'Change course'
    },
    createdAssigned: {
        id: 'app.components.AddGroup.createdAssigned',
        defaultMessage: ' created and assigned to '
    },
    maxGroupErrorTitle: {
        id: 'app.components.AddGroup.maxGroupErrorTitle',
        defaultMessage: 'This group cannot be created.'
    },
    maxGroupErrorLongDesc: {
        id: 'app.components.AddGroup.maxGroupErrorLongDesc',
        defaultMessage: 'You are allowed with a maximum of 12 groups per class, please delete a group to proceed.'
    },
    okBtn: {
        id: 'app.components.AddGroup.okBtn',
        defaultMessage: 'Ok'
    }
}); /*
     * AddClass Messages
     *
     * This contains all the text for the AddClass component.
     */

/***/ }),
/* 248 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _reactIntl = __webpack_require__(2);

exports.default = (0, _reactIntl.defineMessages)({
    startCourse: {
        id: 'assign-course-conquest.components.startCourse',
        defaultMessage: 'Queue new default course for rollover:'
    },
    setDefaultCourse: {
        id: 'assign-course-conquest.components.setDefaultCourse',
        defaultMessage: 'Set a new default course:'
    },
    searchCourse: {
        id: 'assign-course-conquest.components.searchCourse',
        defaultMessage: 'Search for a course'
    },
    selectGroup: {
        id: 'assign-course-conquest.components.selectGroup',
        defaultMessage: 'Select grade'
    },
    defaultOptionCountry: {
        id: 'assign-course-conquest.components.defaultOptionCountry',
        defaultMessage: 'Select country'
    },
    selectCourse: {
        id: 'assign-course-conquest.components.selectCourse',
        defaultMessage: 'Select course'
    },
    noCoursesFound: {
        id: 'assign-course-conquest.components.noCoursesFound',
        defaultMessage: 'No courses found'
    },
    schoolCourses: {
        id: 'assign-course-conquest.components.schoolCourses',
        defaultMessage: 'School courses'
    },
    newCourses: {
        id: 'assign-course-conquest.components.newCourses   ',
        defaultMessage: 'New Courses'
    },
    coursesActivityMastery: {
        id: 'assign-course-legacy.components.coursesActivityMastery',
        defaultMessage: 'Courses (Activity Mastery)'
    },
    courses: {
        id: 'assign-course-legacy.components.courses',
        defaultMessage: 'Courses'
    },
    assignToYear: {
        id: 'assign-course-conquest.components.assignToYear',
        defaultMessage: 'Assign to year'
    },
    optOutOfCourse: {
        id: 'assign-course-conquest.components.optOutOfCourse',
        defaultMessage: 'Opt out of course'
    },
    assignToGroup: {
        id: 'assign-course-conquest.components.assignToGroup',
        defaultMessage: 'Assign to group'
    }
});

/***/ }),
/* 249 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _reactIntl = __webpack_require__(2);

exports.default = (0, _reactIntl.defineMessages)({
    startCourse: {
        id: 'assign-course-legacy.components.startCourse',
        defaultMessage: 'Queue new default course for rollover'
    },
    searchCourse: {
        id: 'assign-course-legacy.components.searchCourse',
        defaultMessage: 'Search for a course'
    },
    selectGrade: {
        id: 'assign-course-legacy.components.selectGrade',
        defaultMessage: 'Select grade'
    },
    defaultOptionCountry: {
        id: 'assign-course-legacy.components.defaultOptionCountry',
        defaultMessage: 'Select country'
    },
    selectCourse: {
        id: 'assign-course-legacy.components.selectCourse',
        defaultMessage: 'Select course'
    },
    noCoursesFound: {
        id: 'assign-course-legacy.components.noCoursesFound',
        defaultMessage: 'No courses found'
    },
    schoolCourses: {
        id: 'assign-course-legacy.components.schoolCourses',
        defaultMessage: 'School courses'
    },
    coursesActivityMastery: {
        id: 'assign-course-legacy.components.coursesActivityMastery',
        defaultMessage: 'Courses (Activity Mastery)'
    },
    courses: {
        id: 'assign-course-legacy.components.courses',
        defaultMessage: 'Courses'
    },
    assignToGroup: {
        id: 'assign-course-legacy.components.assignToGroup',
        defaultMessage: 'Assign to group'
    },
    assignToYear: {
        id: 'assign-course-legacy.components.assignToYear',
        defaultMessage: 'Assign to year'
    }
});

/***/ }),
/* 250 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _reactIntl = __webpack_require__(2);

exports.default = (0, _reactIntl.defineMessages)({
    startCourse: {
        id: 'assign-course-upf.components.startCourse',
        defaultMessage: 'Queue new default course for rollover:'
    },
    setDefaultCourse: {
        id: 'assign-course-upf.components.setDefaultCourse',
        defaultMessage: 'Set a new default course:'
    },
    searchCourse: {
        id: 'assign-course-upf.components.searchCourse',
        defaultMessage: 'Search for a course'
    },
    selectGroup: {
        id: 'assign-course-upf.components.selectGroup',
        defaultMessage: 'Select grade'
    },
    defaultOptionCountry: {
        id: 'assign-course-upf.components.defaultOptionCountry',
        defaultMessage: 'Select country'
    },
    selectCourse: {
        id: 'assign-course-upf.components.selectCourse',
        defaultMessage: 'Select course'
    },
    noCoursesFound: {
        id: 'assign-course-upf.components.noCoursesFound',
        defaultMessage: 'No courses found'
    },
    schoolCourses: {
        id: 'assign-course-upf.components.schoolCourses',
        defaultMessage: 'School courses'
    },
    skillQuests: {
        id: 'assign-course-upf.components.skillQuests',
        defaultMessage: 'Skill Quests'
    },
    coursesActivityMastery: {
        id: 'assign-course-legacy.components.coursesActivityMastery',
        defaultMessage: 'Courses (Activity Mastery)'
    },
    newCourses: {
        id: 'assign-course-legacy.components.newCourses',
        defaultMessage: 'New Courses'
    },
    courses: {
        id: 'assign-course-legacy.components.courses',
        defaultMessage: 'Courses'
    },
    assignToYear: {
        id: 'assign-course-upf.components.assignToYear',
        defaultMessage: 'Assign to year'
    },
    optOutOfCourse: {
        id: 'assign-course-upf.components.optOutOfCourse',
        defaultMessage: 'Opt out of course'
    },
    assignToGroup: {
        id: 'assign-course-upf.components.assignToGroup',
        defaultMessage: 'Assign to group'
    }
});

/***/ }),
/* 251 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _reactIntl = __webpack_require__(2);

exports.default = (0, _reactIntl.defineMessages)({
    selectCountry: {
        id: 'app.components.changeCourse.selectCountry',
        defaultMessage: 'Select country'
    },
    countryLabel: {
        id: 'app.components.changeCourse.countryLabel',
        defaultMessage: 'Country'
    },
    selectGrade: {
        id: 'app.components.changeCourse.selectGrade',
        defaultMessage: 'Select grade'
    },
    gradeLabel: {
        id: 'app.components.changeCourse.gradeLabel',
        defaultMessage: 'Grade'
    },
    selectCourse: {
        id: 'app.components.changeCourse.selectCourse',
        defaultMessage: 'Select course'
    },
    courseLabel: {
        id: 'app.components.changeCourse.courseLabel',
        defaultMessage: 'Course'
    },
    subTitle: {
        id: 'app.components.changeCourse.subTitle',
        defaultMessage: 'is currently set to'
    },
    assignedTo: {
        id: 'app.components.changeCourse.assignedTo',
        defaultMessage: 'has been assigned to'
    },
    confirmLabel: {
        id: 'app.components.changeCourse.confirmLabel',
        defaultMessage: 'Is this correct?'
    },
    schoolCourses: {
        id: 'app.components.changeCourse.schoolCourses',
        defaultMessage: 'School courses'
    },
    confirmWithActivitiesHeader: {
        id: 'app.components.changeCourse.confirmWithActivitiesHeader',
        defaultMessage: 'You currently have {length} {length, plural, one {activity} other {activities}} assigned'
    },
    confirmWithActivitiesSubHeader: {
        id: 'app.components.changeCourse.confirmWithActivitiesSubHeader',
        defaultMessage: '\'Would you like to carry these over?\''
    },
    yesLabel: {
        id: 'app.components.changeCourse.yesLabel',
        defaultMessage: 'Yes'
    },
    noLabel: {
        id: 'app.components.changeCourse.noLabel',
        defaultMessage: 'No'
    },
    backLabel: {
        id: 'app.components.changeCourse.backLabel',
        defaultMessage: 'Back'
    },
    activityUpdated: {
        id: 'app.components.changeCourse.activityUpdated',
        defaultMessage: '{length} {length, plural, one {activity} other {activities}} carried across.'
    },
    noCoursesFound: {
        id: 'app.components.changeCourse.noCoursesFound',
        defaultMessage: 'No courses found'
    },
    skillQuests: {
        id: 'app.components.changeCourse.skillQuests',
        defaultMessage: 'Skill Quests'
    },
    selectSkillQuests: {
        id: 'app.components.changeCourse.selectSkillQuests',
        defaultMessage: 'Select Skill Quests'
    },
    newCourses: {
        id: 'app.components.changeCourse.newCourses',
        defaultMessage: 'New Courses'
    },
    selectNewCourse: {
        id: 'app.components.changeCourse.selectNewCourse',
        defaultMessage: 'Select New Course'
    },
    customCourses: {
        id: 'app.components.changeCourse.customCourses',
        defaultMessage: 'Custom school courses'
    },
    curriculumCourses: {
        id: 'app.components.changeCourse.curriculumCourses',
        defaultMessage: 'Curriculum based courses'
    },
    none: {
        id: 'app.components.changeCourse.none',
        defaultMessage: 'None'
    },
    useAdminSelection: {
        id: 'app.components.changeCourse.useAdminSelection',
        defaultMessage: 'Use admin selection'
    }
});

/***/ }),
/* 252 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactStyleable = __webpack_require__(6);

var _reactStyleable2 = _interopRequireDefault(_reactStyleable);

var _index = __webpack_require__(1686);

var _index2 = _interopRequireDefault(_index);

var _messages = __webpack_require__(381);

var _messages2 = _interopRequireDefault(_messages);

var _utils = __webpack_require__(13);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var getUPFCourseTitle = function getUPFCourseTitle(_ref) {
    var isOptedOut = _ref.isOptedOut,
        upfCourseTitle = _ref.upfCourseTitle,
        intl = _ref.intl;

    if (upfCourseTitle !== '') {
        return upfCourseTitle;
    }

    if (isOptedOut) {
        return intl.formatMessage(_messages2.default.optedOut);
    }

    return intl.formatMessage(_messages2.default.noCoursesFound);
};

var RenderClassCourses = function RenderClassCourses(_ref2) {
    var yearGroup = _ref2.yearGroup,
        courseTitle = _ref2.courseTitle,
        conquestCourseTitle = _ref2.conquestCourseTitle,
        upfCourseTitle = _ref2.upfCourseTitle,
        intl = _ref2.intl,
        _ref2$isOptedOut = _ref2.isOptedOut,
        isOptedOut = _ref2$isOptedOut === undefined ? false : _ref2$isOptedOut;

    var isNewCourseAssigned = conquestCourseTitle !== '';
    var isUPFCourseAssigned = upfCourseTitle !== '';
    var newCourseTitle = (0, _utils.getNewCoursesTitle)(yearGroup, isNewCourseAssigned, conquestCourseTitle, intl);

    var skillQuestTitle = getUPFCourseTitle({ isOptedOut: isOptedOut, upfCourseTitle: upfCourseTitle, intl: intl });
    var course = _react2.default.createElement(
        'div',
        null,
        intl.formatMessage(_messages2.default.activities),
        ': ',
        courseTitle
    );
    var upfCourse = _react2.default.createElement(
        'div',
        { className: isUPFCourseAssigned ? 'none' : _index2.default.light },
        _react2.default.createElement(
            'span',
            { className: isUPFCourseAssigned ? 'none' : _index2.default.bold },
            intl.formatMessage(_messages2.default.skillQuests),
            ':'
        ),
        ' ',
        skillQuestTitle
    );

    if ((0, _utils.displayNewCourses)()) {
        var newCourses = _react2.default.createElement(
            'div',
            { className: isNewCourseAssigned ? 'none' : _index2.default.light },
            _react2.default.createElement(
                'span',
                { className: isNewCourseAssigned ? 'none' : _index2.default.bold },
                intl.formatMessage(_messages2.default.newCourses),
                ':'
            ),
            ' ',
            newCourseTitle
        );
        return [course, newCourses, upfCourse];
    }
    return [course, upfCourse];
};

var ClassCourses = (0, _reactStyleable2.default)(_index2.default)(RenderClassCourses);

exports.default = ClassCourses;

/***/ }),
/* 253 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AssignedCoursesFormatter = exports.EmailStatusFormatter = exports.YearGroupFormatter = exports.StudentCountFormatter = exports.HeaderFormatter = exports.EditInfoFormatter = exports.AssignedTeacherFormatter = exports.AssignedClassFormatter = exports.AssignedGroupFormatter = undefined;

var _index = __webpack_require__(721);

var _index2 = _interopRequireDefault(_index);

var _index3 = __webpack_require__(719);

var _index4 = _interopRequireDefault(_index3);

var _index5 = __webpack_require__(722);

var _index6 = _interopRequireDefault(_index5);

var _index7 = __webpack_require__(723);

var _index8 = _interopRequireDefault(_index7);

var _index9 = __webpack_require__(725);

var _index10 = _interopRequireDefault(_index9);

var _index11 = __webpack_require__(726);

var _index12 = _interopRequireDefault(_index11);

var _index13 = __webpack_require__(728);

var _index14 = _interopRequireDefault(_index13);

var _index15 = __webpack_require__(724);

var _index16 = _interopRequireDefault(_index15);

var _index17 = __webpack_require__(720);

var _index18 = _interopRequireDefault(_index17);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.AssignedGroupFormatter = _index2.default;
exports.AssignedClassFormatter = _index4.default;
exports.AssignedTeacherFormatter = _index6.default;
exports.EditInfoFormatter = _index8.default;
exports.HeaderFormatter = _index10.default;
exports.StudentCountFormatter = _index12.default;
exports.YearGroupFormatter = _index14.default;
exports.EmailStatusFormatter = _index16.default;
exports.AssignedCoursesFormatter = _index18.default;

/***/ }),
/* 254 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

__webpack_require__(26);

var _index = __webpack_require__(1719);

var _index2 = _interopRequireDefault(_index);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MultilineText = function MultilineText(_ref) {
    var _ref$dataItems = _ref.dataItems,
        dataItems = _ref$dataItems === undefined ? [] : _ref$dataItems,
        _ref$dataItemClassNam = _ref.dataItemClassName,
        dataItemClassName = _ref$dataItemClassNam === undefined ? '' : _ref$dataItemClassNam;

    var multilineText = [];
    var index = 1;
    if (dataItems.length > 0) {
        if (dataItemClassName === '') {
            multilineText = dataItems.map(function (dataItem) {
                index += 1;
                return _react2.default.createElement(
                    'div',
                    { key: dataItem + '_' + index },
                    dataItem
                );
            });
        } else {
            multilineText = dataItems.map(function (dataItem) {
                index += 1;
                return _react2.default.createElement(
                    'div',
                    { className: dataItemClassName, key: dataItem + '_' + index },
                    dataItem
                );
            });
        }
    }

    return _react2.default.createElement(
        'div',
        { className: _index2.default.component },
        multilineText
    );
};

MultilineText.propTypes = {
    dataItems: _propTypes2.default.array,
    dataItemClassName: _propTypes2.default.string
};

exports.default = MultilineText;

/***/ }),
/* 255 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; /* eslint jsx-a11y/label-has-for: 0 */

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _index = __webpack_require__(1722);

var _index2 = _interopRequireDefault(_index);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var RadioButton = function RadioButton(props) {
    return _react2.default.createElement(
        'div',
        { className: _index2.default.RadioButton + ' radio-button' },
        _react2.default.createElement('input', _extends({}, props, { type: 'radio' })),
        _react2.default.createElement('label', null)
    );
};

RadioButton.propTypes = {
    onchange: _propTypes2.default.func
};

exports.default = RadioButton;

/***/ }),
/* 256 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var CLASS_GRID_ROW_HEIGHT = exports.CLASS_GRID_ROW_HEIGHT = 70;
var CLASS_GRID_TEACHER_NAME_HEIGHT = exports.CLASS_GRID_TEACHER_NAME_HEIGHT = 20;
var ROW_BUFFER = exports.ROW_BUFFER = 10;
var DEFAULT_GRID_ROW_HEIGHT = exports.DEFAULT_GRID_ROW_HEIGHT = 23;

/***/ }),
/* 257 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _index = __webpack_require__(1733);

var _index2 = _interopRequireDefault(_index);

var _iconDictionary = __webpack_require__(8);

var _svgIcon = __webpack_require__(21);

var _svgIcon2 = _interopRequireDefault(_svgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var StudentCount = function StudentCount(_ref) {
    var _ref$icon = _ref.icon,
        icon = _ref$icon === undefined ? '' : _ref$icon,
        _ref$count = _ref.count,
        count = _ref$count === undefined ? 0 : _ref$count;

    var iconStyle = icon === '' ? _index2.default.icon : icon;

    return _react2.default.createElement(
        'div',
        { className: _index2.default.container },
        _react2.default.createElement(
            'div',
            { className: iconStyle },
            _react2.default.createElement(_svgIcon2.default, { icon: _iconDictionary.Profile })
        ),
        _react2.default.createElement(
            'div',
            { className: _index2.default.count },
            count
        )
    );
};

StudentCount.propTypes = {
    count: _propTypes2.default.number,
    icon: _propTypes2.default.string
};

exports.default = StudentCount;

/***/ }),
/* 258 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactIntl = __webpack_require__(2);

var _svgIcon = __webpack_require__(21);

var _svgIcon2 = _interopRequireDefault(_svgIcon);

var _index = __webpack_require__(1754);

var _index2 = _interopRequireDefault(_index);

var _index3 = __webpack_require__(7);

var _index4 = _interopRequireDefault(_index3);

var _iconDictionary = __webpack_require__(8);

var _messages = __webpack_require__(794);

var _messages2 = _interopRequireDefault(_messages);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TeacherUnassign = function TeacherUnassign(_ref) {
    var intl = _ref.intl,
        icon = _ref.icon,
        title = _ref.title,
        handleOnOk = _ref.handleOnOk,
        handleOnCancel = _ref.handleOnCancel,
        isLoading = _ref.isLoading,
        children = _ref.children;
    return _react2.default.createElement(
        'div',
        { className: _index2.default.confirmationMessageContainer },
        _react2.default.createElement(
            'div',
            { className: _index2.default.icon },
            _react2.default.createElement(_svgIcon2.default, { icon: icon })
        ),
        _react2.default.createElement(
            'div',
            { className: _index2.default.title },
            title
        ),
        _react2.default.createElement(
            'div',
            { className: _index2.default.message },
            children,
            _react2.default.createElement(
                'div',
                { className: _index2.default.confirm },
                _react2.default.createElement(
                    'span',
                    { className: _index2.default.highlight },
                    intl.formatMessage(_messages2.default.wishToContinue)
                )
            )
        ),
        _react2.default.createElement(
            'div',
            { className: _index2.default.container },
            _react2.default.createElement(_index4.default, {
                buttonContainer: _index2.default.cancel,
                buttonContainerDisabled: _index2.default.cancelButtonDisabled,
                disabled: isLoading,
                handleOnClick: handleOnCancel,
                icon: _iconDictionary.Cross,
                iconClassName: _index2.default.iconClassName,
                loading: isLoading }),
            _react2.default.createElement(_index4.default, {
                buttonContainer: _index2.default.ok,
                buttonContainerDisabled: _index2.default.okButtonDisabled,
                disabled: isLoading,
                handleOnClick: handleOnOk,
                icon: _iconDictionary.Tick,
                iconClassName: _index2.default.iconClassName,
                loading: isLoading })
        )
    );
};

TeacherUnassign.propTypes = {
    icon: _propTypes2.default.string,
    title: _propTypes2.default.string,
    handleOnOk: _propTypes2.default.func,
    handleOnCancel: _propTypes2.default.func,
    isLoading: _propTypes2.default.bool,
    children: _propTypes2.default.node,
    intl: _reactIntl.intlShape.isRequired
};

exports.default = (0, _reactIntl.injectIntl)(TeacherUnassign);

/***/ }),
/* 259 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactIntl = __webpack_require__(2);

__webpack_require__(26);

var _index = __webpack_require__(1758);

var _index2 = _interopRequireDefault(_index);

var _svgIcon = __webpack_require__(21);

var _svgIcon2 = _interopRequireDefault(_svgIcon);

var _messages = __webpack_require__(799);

var _messages2 = _interopRequireDefault(_messages);

var _iconDictionary = __webpack_require__(8);

var _button = __webpack_require__(7);

var _button2 = _interopRequireDefault(_button);

var _variants = __webpack_require__(9);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Summary = function (_Component) {
    _inherits(Summary, _Component);

    function Summary(props) {
        _classCallCheck(this, Summary);

        var _this = _possibleConstructorReturn(this, (Summary.__proto__ || Object.getPrototypeOf(Summary)).call(this, props));

        _this.handleOnPrint = function () {
            if (_this.content) {
                window.print();
            }
        };

        _this.content = null;
        _this.setContentRef = function (element) {
            _this.content = element;
        };
        return _this;
    }

    _createClass(Summary, [{
        key: 'render',
        value: function render() {
            var _props = this.props,
                intl = _props.intl,
                message = _props.message,
                children = _props.children,
                icon = _props.icon,
                handleOnCloseModal = _props.handleOnCloseModal,
                handleOnBack = _props.handleOnBack,
                handleOnViewSummary = _props.handleOnViewSummary,
                rollOverValidationPage = _props.rollOverValidationPage,
                rollOverConfirmationPage = _props.rollOverConfirmationPage,
                quickUploadErrorPage = _props.quickUploadErrorPage;


            var buttons = {};

            if (rollOverValidationPage) {
                buttons.backButtonStyle = '' + _index2.default.button;
                buttons.printButtonStyle = '' + _index2.default.button;
                buttons.doneButtonStyle = '' + _index2.default.hidden;
                buttons.viewSummaryButtonStyle = '' + _index2.default.hidden;
            } else if (rollOverConfirmationPage) {
                buttons.viewSummaryButtonStyle = '' + _index2.default.viewSummary;
                buttons.printButtonStyle = '' + _index2.default.button;
                buttons.doneButtonStyle = '' + _index2.default.hidden;
                buttons.backButtonStyle = '' + _index2.default.hidden;
            } else {
                buttons.viewSummaryButtonStyle = '' + _index2.default.hidden;
                buttons.printButtonStyle = '' + _index2.default.hidden;
                buttons.doneButtonStyle = '' + _index2.default.button;
                buttons.backButtonStyle = '' + _index2.default.hidden;
            }

            return _react2.default.createElement(
                'div',
                { className: _index2.default.uploadValidationContainer },
                _react2.default.createElement(
                    'div',
                    { className: _index2.default.svg },
                    _react2.default.createElement(_svgIcon2.default, { icon: icon })
                ),
                _react2.default.createElement(
                    'div',
                    { className: _index2.default.errorMessage },
                    message
                ),
                _react2.default.createElement(
                    'div',
                    { className: _index2.default.errorMessagesWrapper, ref: this.setContentRef },
                    _react2.default.createElement(
                        'div',
                        { className: _index2.default.errorMessagesRow },
                        children
                    )
                ),
                _react2.default.createElement(
                    'div',
                    { className: _index2.default.buttonPanel },
                    _react2.default.createElement(
                        'div',
                        { className: _index2.default.leftPanel },
                        _react2.default.createElement(
                            'button',
                            {
                                className: buttons.backButtonStyle,
                                onClick: handleOnBack
                            },
                            intl.formatMessage(_messages2.default.back)
                        ),
                        _react2.default.createElement(
                            'button',
                            {
                                className: buttons.viewSummaryButtonStyle,
                                onClick: handleOnViewSummary
                            },
                            intl.formatMessage(_messages2.default.ViewSummary)
                        )
                    ),
                    _react2.default.createElement(
                        'div',
                        { className: _index2.default.rightPanel },
                        _react2.default.createElement(
                            'div',
                            { className: quickUploadErrorPage ? _index2.default.hidden : '' },
                            _react2.default.createElement(_button2.default, {
                                handleOnClick: this.handleOnPrint,
                                icon: _iconDictionary.PrintSignIn,
                                label: intl.formatMessage(_messages2.default.print),
                                variant: _variants.DARK })
                        )
                    ),
                    _react2.default.createElement(
                        'div',
                        { className: _index2.default.done },
                        _react2.default.createElement(
                            'button',
                            {
                                className: buttons.doneButtonStyle,
                                onClick: handleOnCloseModal
                            },
                            intl.formatMessage(_messages2.default.ok)
                        )
                    )
                )
            );
        }
    }]);

    return Summary;
}(_react.Component);

Summary.propTypes = {
    handleOnCloseModal: _propTypes2.default.func,
    handleOnBack: _propTypes2.default.func,
    handleOnViewSummary: _propTypes2.default.func,
    icon: _propTypes2.default.string,
    message: _propTypes2.default.string,
    intl: _reactIntl.intlShape.isRequired,
    children: _propTypes2.default.node,
    rollOverValidationPage: _propTypes2.default.bool,
    rollOverConfirmationPage: _propTypes2.default.bool,
    quickUploadErrorPage: _propTypes2.default.bool
};

exports.default = (0, _reactIntl.injectIntl)(Summary);

/***/ }),
/* 260 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactStyleable = __webpack_require__(6);

var _reactStyleable2 = _interopRequireDefault(_reactStyleable);

var _svgIcon = __webpack_require__(21);

var _svgIcon2 = _interopRequireDefault(_svgIcon);

var _index = __webpack_require__(1759);

var _index2 = _interopRequireDefault(_index);

var _index3 = __webpack_require__(7);

var _index4 = _interopRequireDefault(_index3);

var _iconDictionary = __webpack_require__(8);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var UserDelete = function UserDelete(_ref) {
    var icon = _ref.icon,
        title = _ref.title,
        handleOnOk = _ref.handleOnOk,
        handleOnCancel = _ref.handleOnCancel,
        isLoading = _ref.isLoading,
        children = _ref.children,
        heading = _ref.heading;
    return _react2.default.createElement(
        'div',
        { className: _index2.default.confirmationMessageContainer },
        _react2.default.createElement(
            'div',
            { className: _index2.default.icon },
            _react2.default.createElement(_svgIcon2.default, { icon: icon })
        ),
        _react2.default.createElement(
            'div',
            { className: _index2.default.title },
            title
        ),
        _react2.default.createElement(
            'div',
            { className: _index2.default.message },
            children,
            _react2.default.createElement(
                'div',
                { className: _index2.default.confirm },
                _react2.default.createElement(
                    'span',
                    { className: _index2.default.highlight },
                    heading
                )
            )
        ),
        _react2.default.createElement(
            'div',
            { className: _index2.default.container },
            _react2.default.createElement(_index4.default, {
                buttonContainer: _index2.default.cancel,
                buttonContainerDisabled: _index2.default.cancelButtonDisabled,
                disabled: isLoading,
                handleOnClick: handleOnCancel,
                icon: _iconDictionary.Cross,
                iconClassName: _index2.default.iconClassName,
                loading: isLoading }),
            _react2.default.createElement(_index4.default, {
                buttonContainer: _index2.default.ok,
                buttonContainerDisabled: _index2.default.okButtonDisabled,
                disabled: isLoading,
                handleOnClick: handleOnOk,
                icon: _iconDictionary.Tick,
                iconClassName: _index2.default.iconClassName,
                loading: isLoading })
        )
    );
};

UserDelete.propTypes = {
    icon: _propTypes2.default.string,
    title: _propTypes2.default.string,
    handleOnOk: _propTypes2.default.func,
    handleOnCancel: _propTypes2.default.func,
    isLoading: _propTypes2.default.bool,
    children: _propTypes2.default.node,
    heading: _propTypes2.default.string
};

exports.default = (0, _reactStyleable2.default)(_index2.default)(UserDelete);

/***/ }),
/* 261 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactStyleable = __webpack_require__(6);

var _reactStyleable2 = _interopRequireDefault(_reactStyleable);

var _svgIcon = __webpack_require__(21);

var _svgIcon2 = _interopRequireDefault(_svgIcon);

var _iconDictionary = __webpack_require__(8);

var _index = __webpack_require__(1760);

var _index2 = _interopRequireDefault(_index);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ViewCourse = function ViewCourse(_ref) {
    var handleOnClick = _ref.handleOnClick;
    return _react2.default.createElement(
        'button',
        { className: _index2.default.viewCourse, onClick: handleOnClick },
        _react2.default.createElement(
            'div',
            { className: _index2.default.icon },
            _react2.default.createElement(_svgIcon2.default, { icon: _iconDictionary.View })
        )
    );
};

ViewCourse.propTypes = {
    handleOnClick: _propTypes2.default.func
};

exports.default = (0, _reactStyleable2.default)(_index2.default)(ViewCourse);

/***/ }),
/* 262 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _index = __webpack_require__(94);

var _index2 = _interopRequireDefault(_index);

var _index3 = __webpack_require__(1761);

var _index4 = _interopRequireDefault(_index3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var withLoader = function withLoader(loadingProp) {
    return function (WrappedComponent) {
        return function (_Component) {
            _inherits(_class, _Component);

            function _class(props) {
                _classCallCheck(this, _class);

                var _this = _possibleConstructorReturn(this, (_class.__proto__ || Object.getPrototypeOf(_class)).call(this, props));

                _this.isLoading = _this.isLoading.bind(_this);
                return _this;
            }

            _createClass(_class, [{
                key: 'isLoading',
                value: function isLoading() {
                    var props = this.props;

                    return props[loadingProp] !== null && props[loadingProp] !== undefined && props[loadingProp] === true;
                }
            }, {
                key: 'render',
                value: function render() {
                    var loadingContent = this.isLoading() ? _react2.default.createElement(
                        'div',
                        { className: _index4.default.loadingContainer },
                        _react2.default.createElement(_index2.default, null)
                    ) : '';

                    return _react2.default.createElement(
                        'div',
                        { className: 'has-a-loader' },
                        loadingContent,
                        _react2.default.createElement(WrappedComponent, this.props)
                    );
                }
            }]);

            return _class;
        }(_react.Component);
    };
};

exports.default = withLoader;

/***/ }),
/* 263 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.ON_DATE_PICKER_CHANGE = exports.GET_CERTIFICATES_SUMMARY_FAILURE = exports.GET_CERTIFICATES_SUMMARY_SUCCESS = exports.GET_CERTIFICATES_SUMMARY_REQUEST = exports.GET_ACADEMIC_YEAR_FAILURE = exports.GET_ACADEMIC_YEAR_SUCCESS = exports.GET_ACADEMIC_YEAR_REQUEST = exports.CLEAR_CLASSROOM_GROUPS = exports.SET_GROUP_ID = exports.SET_CLASSROOM_ID = exports.SET_TEACHER_ID = exports.getClassroomGroupsFailure = exports.getClassroomGroupsSuccess = exports.getClassroomGroups = exports.GET_CLASSROOM_GROUPS_FAILURE = exports.GET_CLASSROOM_GROUPS_SUCCESS = exports.GET_CLASSROOM_GROUPS_REQUEST = exports.downloadCertificatesSuccess = exports.DOWNLOAD_CERTIFICATES_FAILURE = exports.DOWNLOAD_CERTIFICATES_SUCCESS = exports.DOWNLOAD_CERTIFICATES_REQUEST = exports.DOWNLOAD_CERTIFICATES_SETUP = undefined;
exports.downloadCertificatesSetup = downloadCertificatesSetup;
exports.downloadCertificates = downloadCertificates;
exports.downloadCertificatesFailure = downloadCertificatesFailure;
exports.setTeacherId = setTeacherId;
exports.setClassroomId = setClassroomId;
exports.setGroupId = setGroupId;
exports.clearClassroomGroups = clearClassroomGroups;
exports.getAcademicYear = getAcademicYear;
exports.getAcademicYearSuccess = getAcademicYearSuccess;
exports.getAcademicYearFailure = getAcademicYearFailure;
exports.getCertificatesSummary = getCertificatesSummary;
exports.getCertificatesSummarySuccess = getCertificatesSummarySuccess;
exports.getCertificatesSummaryFailure = getCertificatesSummaryFailure;
exports.onDatePickerChange = onDatePickerChange;

var _constants = __webpack_require__(155);

var DOWNLOAD_CERTIFICATES_SETUP = exports.DOWNLOAD_CERTIFICATES_SETUP = 'DOWNLOAD_CERTIFICATES_SETUP';

function downloadCertificatesSetup() {
    return { type: DOWNLOAD_CERTIFICATES_SETUP };
}

var DOWNLOAD_CERTIFICATES_REQUEST = exports.DOWNLOAD_CERTIFICATES_REQUEST = 'DOWNLOAD_CERTIFICATES_REQUEST';
var DOWNLOAD_CERTIFICATES_SUCCESS = exports.DOWNLOAD_CERTIFICATES_SUCCESS = 'DOWNLOAD_CERTIFICATES_SUCCESS';
var DOWNLOAD_CERTIFICATES_FAILURE = exports.DOWNLOAD_CERTIFICATES_FAILURE = 'DOWNLOAD_CERTIFICATES_FAILURE';

function downloadCertificates(certificateType) {
    var newState = { type: DOWNLOAD_CERTIFICATES_REQUEST };
    if (_constants.CERTIFICATE_TYPES.indexOf(certificateType) !== -1) {
        newState.certificateType = certificateType;
    }
    return newState;
}

var downloadCertificatesSuccess = exports.downloadCertificatesSuccess = function downloadCertificatesSuccess(downloadUrl) {
    window.location.href = downloadUrl;
    return { type: DOWNLOAD_CERTIFICATES_SUCCESS };
};

function downloadCertificatesFailure() {
    return { type: DOWNLOAD_CERTIFICATES_FAILURE };
}

var GET_CLASSROOM_GROUPS_REQUEST = exports.GET_CLASSROOM_GROUPS_REQUEST = 'GET_CLASSROOM_GROUPS_REQUEST';
var GET_CLASSROOM_GROUPS_SUCCESS = exports.GET_CLASSROOM_GROUPS_SUCCESS = 'GET_CLASSROOM_GROUPS_SUCCESS';
var GET_CLASSROOM_GROUPS_FAILURE = exports.GET_CLASSROOM_GROUPS_FAILURE = 'GET_CLASSROOM_GROUPS_FAILURE';

var getClassroomGroups = exports.getClassroomGroups = function getClassroomGroups(classroomId) {
    return {
        type: GET_CLASSROOM_GROUPS_REQUEST,
        classroomId: classroomId
    };
};

var getClassroomGroupsSuccess = exports.getClassroomGroupsSuccess = function getClassroomGroupsSuccess(_ref) {
    var data = _ref.data;
    return {
        type: GET_CLASSROOM_GROUPS_SUCCESS,
        data: data
    };
};

var getClassroomGroupsFailure = exports.getClassroomGroupsFailure = function getClassroomGroupsFailure() {
    return {
        type: GET_CLASSROOM_GROUPS_FAILURE
    };
};

var SET_TEACHER_ID = exports.SET_TEACHER_ID = 'SET_TEACHER_ID';

function setTeacherId(name, selectedTeacherId) {
    return { type: SET_TEACHER_ID, selectedTeacherId: selectedTeacherId };
}

var SET_CLASSROOM_ID = exports.SET_CLASSROOM_ID = 'SET_CLASSROOM_ID';

function setClassroomId(name, selectedClassroomId) {
    return { type: SET_CLASSROOM_ID, selectedClassroomId: selectedClassroomId };
}

var SET_GROUP_ID = exports.SET_GROUP_ID = 'SET_GROUP_ID';

function setGroupId(name, selectedGroupId) {
    return { type: SET_GROUP_ID, selectedGroupId: selectedGroupId };
}

var CLEAR_CLASSROOM_GROUPS = exports.CLEAR_CLASSROOM_GROUPS = 'CLEAR_CLASSROOM_GROUPS';

function clearClassroomGroups() {
    return { type: CLEAR_CLASSROOM_GROUPS };
}

var GET_ACADEMIC_YEAR_REQUEST = exports.GET_ACADEMIC_YEAR_REQUEST = 'GET_ACADEMIC_YEAR_REQUEST';
var GET_ACADEMIC_YEAR_SUCCESS = exports.GET_ACADEMIC_YEAR_SUCCESS = 'GET_ACADEMIC_YEAR_SUCCESS';
var GET_ACADEMIC_YEAR_FAILURE = exports.GET_ACADEMIC_YEAR_FAILURE = 'GET_ACADEMIC_YEAR_FAILURE';

function getAcademicYear() {
    return { type: GET_ACADEMIC_YEAR_REQUEST };
}

function getAcademicYearSuccess(_ref2) {
    var data = _ref2.data;

    return { type: GET_ACADEMIC_YEAR_SUCCESS, data: data };
}

function getAcademicYearFailure() {
    return { type: GET_ACADEMIC_YEAR_FAILURE };
}

var GET_CERTIFICATES_SUMMARY_REQUEST = exports.GET_CERTIFICATES_SUMMARY_REQUEST = 'GET_CERTIFICATES_SUMMARY_REQUEST';
var GET_CERTIFICATES_SUMMARY_SUCCESS = exports.GET_CERTIFICATES_SUMMARY_SUCCESS = 'GET_CERTIFICATES_SUMMARY_SUCCESS';
var GET_CERTIFICATES_SUMMARY_FAILURE = exports.GET_CERTIFICATES_SUMMARY_FAILURE = 'GET_CERTIFICATES_SUMMARY_FAILURE';

function getCertificatesSummary() {
    return { type: GET_CERTIFICATES_SUMMARY_REQUEST };
}

function getCertificatesSummarySuccess(_ref3) {
    var data = _ref3.data;

    return { type: GET_CERTIFICATES_SUMMARY_SUCCESS, data: data };
}

function getCertificatesSummaryFailure() {
    return { type: GET_CERTIFICATES_SUMMARY_FAILURE };
}

var ON_DATE_PICKER_CHANGE = exports.ON_DATE_PICKER_CHANGE = 'ON_DATE_PICKER_CHANGE';

function onDatePickerChange(dateType, startDate, endDate) {
    return { type: ON_DATE_PICKER_CHANGE, dateType: dateType, startDate: startDate, endDate: endDate };
}

/***/ }),
/* 264 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.onVerifyExtendResultInfoRequest = onVerifyExtendResultInfoRequest;
exports.onVerifyExtendResultInfoSuccess = onVerifyExtendResultInfoSuccess;
exports.onVerifyExtendResultInfoFailure = onVerifyExtendResultInfoFailure;
exports.onProceedExtendResultRequest = onProceedExtendResultRequest;
exports.onProceedExtendResultSuccess = onProceedExtendResultSuccess;
exports.onProceedExtendResultFailure = onProceedExtendResultFailure;
exports.onCloseExtendResultError = onCloseExtendResultError;
exports.onShowExtendResultInfo = onShowExtendResultInfo;
exports.setIdsToExtend = setIdsToExtend;
exports.extendResults = extendResults;
exports.extendResultsSuccess = extendResultsSuccess;
exports.extendResultsFailure = extendResultsFailure;
exports.closeFailureModal = closeFailureModal;
var VERIFY_EXTEND_RESULT_INFO_REQUEST = exports.VERIFY_EXTEND_RESULT_INFO_REQUEST = 'VERIFY_EXTEND_RESULT_INFO_REQUEST';
var VERIFY_EXTEND_RESULT_INFO_SUCCESS = exports.VERIFY_EXTEND_RESULT_INFO_SUCCESS = 'VERIFY_EXTEND_RESULT_INFO_SUCCESS';
var VERIFY_EXTEND_RESULT_INFO_FAILURE = exports.VERIFY_EXTEND_RESULT_INFO_FAILURE = 'VERIFY_EXTEND_RESULT_INFO_FAILURE';

function onVerifyExtendResultInfoRequest(productId) {
    return { type: VERIFY_EXTEND_RESULT_INFO_REQUEST, productId: productId };
}

function onVerifyExtendResultInfoSuccess(_ref) {
    var currentAcademicYear = _ref.currentAcademicYear,
        extendingResultsStatusType = _ref.extendingResultsStatusType;

    return { type: VERIFY_EXTEND_RESULT_INFO_SUCCESS,
        currentAcademicYear: currentAcademicYear,
        extendingResultsStatusType: extendingResultsStatusType };
}

function onVerifyExtendResultInfoFailure() {
    return { type: VERIFY_EXTEND_RESULT_INFO_FAILURE };
}

var PROCESS_EXTEND_RESULT_REQUEST = exports.PROCESS_EXTEND_RESULT_REQUEST = 'PROCESS_EXTEND_RESULT_REQUEST';
var PROCESS_EXTEND_RESULT_SUCCESS = exports.PROCESS_EXTEND_RESULT_SUCCESS = 'PROCESS_EXTEND_RESULT_SUCCESS';
var PROCESS_EXTEND_RESULT_FAILURE = exports.PROCESS_EXTEND_RESULT_FAILURE = 'PROCESS_EXTEND_RESULT_FAILURE';

function onProceedExtendResultRequest() {
    return { type: PROCESS_EXTEND_RESULT_REQUEST };
}

function onProceedExtendResultSuccess() {
    return { type: PROCESS_EXTEND_RESULT_SUCCESS };
}

function onProceedExtendResultFailure() {
    return { type: PROCESS_EXTEND_RESULT_FAILURE };
}

var CLOSE_EXTEND_RESULT_ERROR = exports.CLOSE_EXTEND_RESULT_ERROR = 'CLOSE_EXTEND_RESULT_ERROR';

function onCloseExtendResultError() {
    return { type: CLOSE_EXTEND_RESULT_ERROR };
}

var SHOW_EXTEND_RESULT_INFO = exports.SHOW_EXTEND_RESULT_INFO = 'SHOW_EXTEND_RESULT_INFO';

function onShowExtendResultInfo() {
    return { type: SHOW_EXTEND_RESULT_INFO,
        showOkButton: true };
}

var SET_IDS_TO_EXTEND = exports.SET_IDS_TO_EXTEND = 'SET_IDS_TO_EXTEND';

function setIdsToExtend(ids) {
    return { type: SET_IDS_TO_EXTEND, yearGroupsToBeExtended: ids };
}

var EXTEND_RESULTS = exports.EXTEND_RESULTS = 'EXTEND_RESULTS';
var EXTEND_RESULTS_SUCCESS = exports.EXTEND_RESULTS_SUCCESS = 'EXTEND_RESULTS_SUCCESS';
var EXTEND_RESULTS_FAILURE = exports.EXTEND_RESULTS_FAILURE = 'EXTEND_RESULTS_FAILURE';

function extendResults(selectedProductId, yeargroups) {
    var keys = Object.keys(yeargroups);
    var selectedYeargroups = keys.filter(function (key) {
        return yeargroups[key];
    });

    return { type: EXTEND_RESULTS, selectedProductId: selectedProductId, selectedYeargroups: selectedYeargroups };
}

function extendResultsSuccess() {
    return { type: EXTEND_RESULTS_SUCCESS };
}

function extendResultsFailure() {
    return { type: EXTEND_RESULTS_FAILURE };
}

var CLOSE_EXTEND_RESULTS_MODAL = exports.CLOSE_EXTEND_RESULTS_MODAL = 'CLOSE_EXTEND_RESULTS_MODAL';

function closeFailureModal() {
    return { type: CLOSE_EXTEND_RESULTS_MODAL };
}

/***/ }),
/* 265 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.showInitialPage = showInitialPage;
exports.showSelectionPage = showSelectionPage;
exports.showUploadPage = showUploadPage;
exports.onViewRollOverSummary = onViewRollOverSummary;
exports.rolloverUploadRequest = rolloverUploadRequest;
exports.rolloverUploadSuccess = rolloverUploadSuccess;
exports.rolloverUploadFailure = rolloverUploadFailure;
exports.closeUploadErrorModal = closeUploadErrorModal;
exports.showHelpModal = showHelpModal;
exports.hideHelpModal = hideHelpModal;
exports.rollOverIsPartial = rollOverIsPartial;
exports.rollOverIsFull = rollOverIsFull;
exports.rollOverVerifyContentRequest = rollOverVerifyContentRequest;
exports.rollOverVerifyContentSuccess = rollOverVerifyContentSuccess;
exports.rollOverVerifyContentFailure = rollOverVerifyContentFailure;
exports.downloadRolloverTemplate = downloadRolloverTemplate;
exports.downloadSchoolRollDataRollover = downloadSchoolRollDataRollover;
exports.clearRollOverVerifyData = clearRollOverVerifyData;
exports.openRollOverConfirmation = openRollOverConfirmation;
exports.closeRollOverConfirmation = closeRollOverConfirmation;
exports.onRollOverConfirmationRequest = onRollOverConfirmationRequest;
exports.onRollOverConfirmationSuccess = onRollOverConfirmationSuccess;
exports.onRollOverConfirmationFailure = onRollOverConfirmationFailure;
exports.onRollOverDownloadSignInCardRequest = onRollOverDownloadSignInCardRequest;
exports.onRollOverDownloadSignInCardSuccess = onRollOverDownloadSignInCardSuccess;
exports.onRollOverDownloadSignInCardFailure = onRollOverDownloadSignInCardFailure;
exports.onIncludeUnassignedStudentsSelection = onIncludeUnassignedStudentsSelection;
exports.onIncludeBulkTransferSelection = onIncludeBulkTransferSelection;
var ROLLOVER_UPLOAD_REQUEST = exports.ROLLOVER_UPLOAD_REQUEST = 'ROLLOVER_UPLOAD_REQUEST';
var ROLLOVER_UPLOAD_SUCCESS = exports.ROLLOVER_UPLOAD_SUCCESS = 'ROLLOVER_UPLOAD_SUCCESS';
var ROLLOVER_UPLOAD_FAILURE = exports.ROLLOVER_UPLOAD_FAILURE = 'ROLLOVER_UPLOAD_FAILURE';

var ROLLOVER_SHOW_INITIAL_PAGE = exports.ROLLOVER_SHOW_INITIAL_PAGE = 'ROLLOVER_SHOW_INITIAL_PAGE';
var ROLLOVER_SHOW_SELECTION = exports.ROLLOVER_SHOW_SELECTION = 'ROLLOVER_SHOW_SELECTION';

function showInitialPage() {
    return {
        type: ROLLOVER_SHOW_INITIAL_PAGE
    };
}

function showSelectionPage() {
    return {
        type: ROLLOVER_SHOW_SELECTION
    };
}

var ROLLOVER_SHOW_UPLOAD_PAGE = exports.ROLLOVER_SHOW_UPLOAD_PAGE = 'ROLLOVER_SHOW_UPLOAD_PAGE';

function showUploadPage() {
    return {
        type: ROLLOVER_SHOW_UPLOAD_PAGE
    };
}

var ON_VIEW_ROLLOVER_SUMMARY = exports.ON_VIEW_ROLLOVER_SUMMARY = 'ON_VIEW_ROLLOVER_SUMMARY';

function onViewRollOverSummary() {
    return {
        type: ON_VIEW_ROLLOVER_SUMMARY
    };
}

var UPLOAD_ROLLOVER_REQUEST = exports.UPLOAD_ROLLOVER_REQUEST = 'UPLOAD_ROLLOVER_REQUEST';
var UPLOAD_ROLLOVER_SUCCESS = exports.UPLOAD_ROLLOVER_SUCCESS = 'UPLOAD_ROLLOVER_SUCCESS';
var UPLOAD_ROLLOVER_FAILURE = exports.UPLOAD_ROLLOVER_FAILURE = 'UPLOAD_ROLLOVER_FAILURE';

function rolloverUploadRequest(productId, fileContent, uploadingRollover) {
    return {
        type: UPLOAD_ROLLOVER_REQUEST,
        productId: productId,
        fileContent: fileContent,
        uploadingRollover: uploadingRollover
    };
}

function rolloverUploadSuccess(rolloverUploadResponse, showModal, uploadingRollover) {
    return {
        type: UPLOAD_ROLLOVER_SUCCESS,
        rolloverUploadResponse: rolloverUploadResponse,
        uploadingRollover: uploadingRollover,
        showModal: showModal
    };
}

function rolloverUploadFailure(_ref) {
    var isServerError = _ref.isServerError,
        errorMessage = _ref.errorMessage,
        showModal = _ref.showModal,
        uploadingRollover = _ref.uploadingRollover,
        _ref$fileSize = _ref.fileSize,
        fileSize = _ref$fileSize === undefined ? 0 : _ref$fileSize,
        _ref$messageDetail = _ref.messageDetail,
        messageDetail = _ref$messageDetail === undefined ? '' : _ref$messageDetail;

    return {
        type: UPLOAD_ROLLOVER_FAILURE,
        isServerError: isServerError,
        errorMessage: errorMessage,
        uploadingRollover: uploadingRollover,
        showModal: showModal,
        messageDetail: messageDetail,
        isVerificationSuccessful: false,
        showDataGrid: false,
        fileSize: fileSize
    };
}

var CLOSE_UPLOAD_ERROR_MODAL = exports.CLOSE_UPLOAD_ERROR_MODAL = 'CLOSE_UPLOAD_ERROR_MODAL';
function closeUploadErrorModal() {
    return {
        type: CLOSE_UPLOAD_ERROR_MODAL,
        showModal: false,
        isVerificationSuccessful: false,
        validationErrors: []
    };
}

var ROLLOVER_SHOW_HELP_MODAL = exports.ROLLOVER_SHOW_HELP_MODAL = 'ROLLOVER_SHOW_HELP_MODAL';
var ROLLOVER_HIDE_HELP_MODAL = exports.ROLLOVER_HIDE_HELP_MODAL = 'ROLLOVER_HIDE_HELP_MODAL';

function showHelpModal() {
    return {
        type: ROLLOVER_SHOW_HELP_MODAL
    };
}

function hideHelpModal() {
    return {
        type: ROLLOVER_HIDE_HELP_MODAL
    };
}

var IS_PARTIAL_ROLLOVER = exports.IS_PARTIAL_ROLLOVER = 'IS_PARTIAL_ROLLOVER';
var IS_FULL_ROLLOVER = exports.IS_FULL_ROLLOVER = 'IS_FULL_ROLLOVER';

function rollOverIsPartial() {
    return {
        type: IS_PARTIAL_ROLLOVER,
        rolloverType: 'PartialRollover'
    };
}

function rollOverIsFull() {
    return {
        type: IS_FULL_ROLLOVER,
        rolloverType: 'FullRollover'
    };
}

var ROLLOVER_VERIFY_FILE_CONTENT_REQUEST = exports.ROLLOVER_VERIFY_FILE_CONTENT_REQUEST = 'ROLLOVER_VERIFY_FILE_CONTENT_REQUEST';
var ROLLOVER_VERIFY_FILE_CONTENT_SUCCESS = exports.ROLLOVER_VERIFY_FILE_CONTENT_SUCCESS = 'ROLLOVER_VERIFY_FILE_CONTENT_SUCCESS';
var ROLLOVER_VERIFY_FILE_CONTENT_FAILURE = exports.ROLLOVER_VERIFY_FILE_CONTENT_FAILURE = 'ROLLOVER_VERIFY_FILE_CONTENT_FAILURE';

function rollOverVerifyContentRequest(productId, fileContent) {
    return {
        type: ROLLOVER_VERIFY_FILE_CONTENT_REQUEST,
        isVerifyingContent: true,
        showDataGrid: false,
        isVerificationSuccessful: false,
        fileContent: fileContent,
        productId: productId
    };
}

function rollOverVerifyContentSuccess(data) {
    return {
        type: ROLLOVER_VERIFY_FILE_CONTENT_SUCCESS,
        isVerifyingContent: false,
        showUploadModal: !data.isSuccess,
        isVerificationSuccessful: data.isSuccess,
        validationErrors: data.validationErrors,
        rolloverItems: data.rolloverItems
    };
}

function rollOverVerifyContentFailure(message, isVerificationSuccessful) {
    return {
        type: ROLLOVER_VERIFY_FILE_CONTENT_FAILURE,
        isVerifyingContent: false,
        showDataGrid: false,
        isVerificationSuccessful: isVerificationSuccessful,
        message: message,
        showUploadModal: true
    };
}

var DOWNLOAD_ROLLOVER_TEMPLATE_REQUEST = exports.DOWNLOAD_ROLLOVER_TEMPLATE_REQUEST = 'DOWNLOAD_ROLLOVER_TEMPLATE_REQUEST';
var DOWNLOAD_ROLLOVER_TEMPLATE_SUCCESS = exports.DOWNLOAD_ROLLOVER_TEMPLATE_SUCCESS = 'DOWNLOAD_ROLLOVER_TEMPLATE_SUCCESS';
var DOWNLOAD_ROLLOVER_TEMPLATE_FAILURE = exports.DOWNLOAD_ROLLOVER_TEMPLATE_FAILURE = 'DOWNLOAD_ROLLOVER_TEMPLATE_FAILURE';

function downloadRolloverTemplate() {
    return {
        type: DOWNLOAD_ROLLOVER_TEMPLATE_REQUEST
    };
}

var downloadRolloverTemplateSuccess = exports.downloadRolloverTemplateSuccess = function downloadRolloverTemplateSuccess(downloadUrl) {
    window.location.href = downloadUrl;
    return { type: DOWNLOAD_ROLLOVER_TEMPLATE_SUCCESS };
};

var downloadRolloverTemplateFailure = exports.downloadRolloverTemplateFailure = function downloadRolloverTemplateFailure() {
    return {
        type: DOWNLOAD_ROLLOVER_TEMPLATE_FAILURE
    };
};

var DOWNLOAD_ROLLOVER_SCHOOL_ROLL_DATA_REQUEST = exports.DOWNLOAD_ROLLOVER_SCHOOL_ROLL_DATA_REQUEST = 'DOWNLOAD_ROLLOVER_SCHOOL_ROLL_DATA_REQUEST';
var DOWNLOAD_ROLLOVER_SCHOOL_ROLL_DATA_SUCCESS = exports.DOWNLOAD_ROLLOVER_SCHOOL_ROLL_DATA_SUCCESS = 'DOWNLOAD_ROLLOVER_SCHOOL_ROLL_DATA_SUCCESS';
var DOWNLOAD_ROLLOVER_SCHOOL_ROLL_DATA_FAILURE = exports.DOWNLOAD_ROLLOVER_SCHOOL_ROLL_DATA_FAILURE = 'DOWNLOAD_ROLLOVER_SCHOOL_ROLL_DATA_FAILURE';

function downloadSchoolRollDataRollover(productId) {
    var includeUnassignedStudents = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    var includeBulkTransfer = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

    return {
        type: DOWNLOAD_ROLLOVER_SCHOOL_ROLL_DATA_REQUEST,
        productId: productId,
        includeUnassignedStudents: includeUnassignedStudents,
        includeBulkTransfer: includeBulkTransfer
    };
}

var downloadSchoolRollDataRolloverSuccess = exports.downloadSchoolRollDataRolloverSuccess = function downloadSchoolRollDataRolloverSuccess(downloadUrl) {
    window.location.href = downloadUrl;
    return { type: DOWNLOAD_ROLLOVER_SCHOOL_ROLL_DATA_SUCCESS };
};

var downloadSchoolRollDataRolloverFailure = exports.downloadSchoolRollDataRolloverFailure = function downloadSchoolRollDataRolloverFailure() {
    return {
        type: DOWNLOAD_ROLLOVER_SCHOOL_ROLL_DATA_FAILURE
    };
};

var CLEAR_ROLLOVER_VERIFICATION_DATA = exports.CLEAR_ROLLOVER_VERIFICATION_DATA = 'CLEAR_ROLLOVER_VERIFICATION_DATA';

function clearRollOverVerifyData() {
    return {
        type: CLEAR_ROLLOVER_VERIFICATION_DATA,
        isVerifyingContent: true,
        isVerificationSuccessful: false,
        rolloverType: ''
    };
}

var OPEN_ROLLOVER_CONFIRMATION = exports.OPEN_ROLLOVER_CONFIRMATION = 'OPEN_ROLLOVER_CONFIRMATION';
var CLOSE_ROLLOVER_CONFIRMATION = exports.CLOSE_ROLLOVER_CONFIRMATION = 'CLOSE_ROLLOVER_CONFIRMATION';

function openRollOverConfirmation() {
    return {
        type: OPEN_ROLLOVER_CONFIRMATION,
        showRollOverConfirmation: true
    };
}

function closeRollOverConfirmation() {
    return {
        type: CLOSE_ROLLOVER_CONFIRMATION,
        showRollOverConfirmation: false
    };
}

var ON_ROLLOVER_CONFIRMATION_REQUEST = exports.ON_ROLLOVER_CONFIRMATION_REQUEST = 'ON_ROLLOVER_CONFIRMATION_REQUEST';
var ON_ROLLOVER_CONFIRMATION_SUCCESS = exports.ON_ROLLOVER_CONFIRMATION_SUCCESS = 'ON_ROLLOVER_CONFIRMATION_SUCCESS';
var ON_ROLLOVER_CONFIRMATION_FAILURE = exports.ON_ROLLOVER_CONFIRMATION_FAILURE = 'ON_ROLLOVER_CONFIRMATION_FAILURE';

function onRollOverConfirmationRequest(rolloverType, productId, rolloverItems) {
    return {
        type: ON_ROLLOVER_CONFIRMATION_REQUEST,
        rolloverType: rolloverType,
        productId: productId,
        rolloverItems: rolloverItems,
        isPerformingRollOver: true,
        isRolloverDone: false,
        showRollOverConfirmation: true
    };
}

function onRollOverConfirmationSuccess(rolloverSummary) {
    return {
        type: ON_ROLLOVER_CONFIRMATION_SUCCESS,
        isPerformingRollOver: false,
        isRolloverDone: true,
        showRollOverConfirmation: false,
        rolloverSummary: rolloverSummary
    };
}

function onRollOverConfirmationFailure(isVerificationSuccessful, message) {
    return {
        type: ON_ROLLOVER_CONFIRMATION_FAILURE,
        isPerformingRollOver: false,
        isRolloverDone: false,
        showRollOverConfirmation: false,
        isVerifyingContent: false,
        showDataGrid: false,
        isVerificationSuccessful: isVerificationSuccessful,
        showUploadModal: true,
        confirmationErrorMessage: message
    };
}

var ON_ROLLOVER_DOWNLOAD_SIGNIN_CARD_REQUEST = exports.ON_ROLLOVER_DOWNLOAD_SIGNIN_CARD_REQUEST = 'ON_ROLLOVER_DOWNLOAD_SIGNIN_CARD_REQUEST';
var ON_ROLLOVER_DOWNLOAD_SIGNIN_CARD_SUCCESS = exports.ON_ROLLOVER_DOWNLOAD_SIGNIN_CARD_SUCCESS = 'ON_ROLLOVER_DOWNLOAD_SIGNIN_CARD_SUCCESS';
var ON_ROLLOVER_DOWNLOAD_SIGNIN_CARD_FAILURE = exports.ON_ROLLOVER_DOWNLOAD_SIGNIN_CARD_FAILURE = 'ON_ROLLOVER_DOWNLOAD_SIGNIN_CARD_FAILURE';

function onRollOverDownloadSignInCardRequest(productId, userIds, userType, format) {
    return {
        type: ON_ROLLOVER_DOWNLOAD_SIGNIN_CARD_REQUEST,
        isDownloadingRolloverSignInCards: true,
        productId: productId,
        userType: userType,
        userIds: userIds,
        format: format
    };
}

function onRollOverDownloadSignInCardSuccess(downloadUrl) {
    window.location.href = downloadUrl;
    return {
        type: ON_ROLLOVER_DOWNLOAD_SIGNIN_CARD_SUCCESS,
        isDownloadingRolloverSignInCards: false
    };
}

function onRollOverDownloadSignInCardFailure() {
    return {
        type: ON_ROLLOVER_DOWNLOAD_SIGNIN_CARD_FAILURE,
        isDownloadingRolloverSignInCards: false
    };
}

var ON_INCLUDE_UNASSIGNED_STUDENTS_SELECTION = exports.ON_INCLUDE_UNASSIGNED_STUDENTS_SELECTION = 'ON_INCLUDE_UNASSIGNED_STUDENTS_SELECTION';

function onIncludeUnassignedStudentsSelection() {
    return {
        type: ON_INCLUDE_UNASSIGNED_STUDENTS_SELECTION
    };
}

var ON_INCLUDE_BULK_TRANSFER_SELECTION = exports.ON_INCLUDE_BULK_TRANSFER_SELECTION = 'ON_INCLUDE_BULK_TRANSFER_SELECTION';

function onIncludeBulkTransferSelection() {
    return {
        type: ON_INCLUDE_BULK_TRANSFER_SELECTION
    };
}

/***/ }),
/* 266 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _reactIntl = __webpack_require__(2);

exports.default = (0, _reactIntl.defineMessages)({
    defaultOptionStudentLastName: {
        id: 'student-roll.container.studentRoll.defaultOptionStudentLastName',
        defaultMessage: 'All surnames'
    },
    defaultOptionStudentYearGroup: {
        id: 'student-roll.container.studentRoll.defaultOptionStudentYearGroup',
        defaultMessage: 'All years'
    },
    defaultOptionStudentClass: {
        id: 'student-roll.container.studentRoll.defaultOptionStudentClass',
        defaultMessage: 'All classes'
    },
    UnassignedStudent: {
        id: 'student-roll.container.studentRoll.UnassignedStudent',
        defaultMessage: 'Unassigned students'
    },
    assignedStudents: {
        id: 'student-roll.container.studentRoll.assignedStudents',
        defaultMessage: 'Assigned Students'
    },
    errorOnDeletingAssignedStudents: {
        id: 'student-roll.container.studentRoll.errorOnDeletingAssignedStudents',
        defaultMessage: 'Error - some selected students are assigned to classes and will not be deleted'
    },
    deleteStudentSuccess: {
        id: 'student-roll.container.studentRoll.deleteStudentSuccess',
        defaultMessage: '{deletedStudentsCount} student(s) removed from the school roll'
    },
    partialDeleteMessage1: {
        id: 'student-roll.container.studentRoll.partialDeleteMessage1',
        defaultMessage: 'Error - some selected students are assigned to classes and will not be deleted -'
    },
    partialDeleteMessage2: {
        id: 'student-roll.container.studentRoll.partialDeleteMessage2',
        defaultMessage: 'Student(s) have been removed from the school roll'
    }
}); /*
     * StudentFilter Messages
     *
     * This contains all the text for the StudentFilter component.
     */

/***/ }),
/* 267 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _reactIntl = __webpack_require__(2);

exports.default = (0, _reactIntl.defineMessages)({
    defaultOptionTeacherLastName: {
        id: 'teacher-roll.container.teacherRoll.defaultOptionTeacherLastName',
        defaultMessage: 'All surnames'
    },
    defaultOptionTeacherClass: {
        id: 'teacher-roll.container.teacherRoll.defaultOptionTeacherClass',
        defaultMessage: 'All classes'
    },
    UnassignedTeacher: {
        id: 'teacher-roll.container.teacherRoll.UnassignedTeacher',
        defaultMessage: 'Unassigned teachers'
    },
    classroomList: {
        id: 'teacher-roll.container.teacherRoll.classroomList',
        defaultMessage: 'Select a {0} class'
    },
    errorOnDeletingAssignedTeachers: {
        id: 'teacher-roll.container.teacherRoll.errorOnDeletingAssignedTeachers',
        defaultMessage: 'Error - some selected teachers are assigned to classes'
    },
    deleteTeacherSuccessMessage: {
        id: 'teacher-roll.container.teacherRoll.deleteTeacherSuccessMessage',
        defaultMessage: '{count} teachers removed from the school roll'
    },
    deleteTeacherWarningMessage: {
        id: 'teacher-roll.container.teacherRoll.deleteTeacherWarningMessage',
        defaultMessage: 'Error - some selected teachers are assigned to classes and will not be deleted. {count} teachers have been removed from the school roll'
    }
}); /*
     * TeacherFilter Messages
     *
     * This contains all the text for the TeacherFilter component.
     */

/***/ }),
/* 268 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.getTeacherAuthTokenRequest = getTeacherAuthTokenRequest;
exports.getTeacherAuthTokenSuccess = getTeacherAuthTokenSuccess;
exports.getTeacherLoginFailure = getTeacherLoginFailure;
exports.getTeacherAuthTokenFailure = getTeacherAuthTokenFailure;
var GET_TEACHER_AUTH_TOKEN_REQUEST = exports.GET_TEACHER_AUTH_TOKEN_REQUEST = 'GET_TEACHER_AUTH_TOKEN_REQUEST';
var GET_TEACHER_AUTH_TOKEN_SUCCESS = exports.GET_TEACHER_AUTH_TOKEN_SUCCESS = 'GET_TEACHER_AUTH_TOKEN_SUCCESS';
var GET_TEACHER_AUTH_TOKEN_FAILURE = exports.GET_TEACHER_AUTH_TOKEN_FAILURE = 'GET_TEACHER_AUTH_TOKEN_FAILURE';
var GET_TEACHER_LOGIN_FAILURE = exports.GET_TEACHER_LOGIN_FAILURE = 'GET_TEACHER_LOGIN_FAILURE';

function getTeacherAuthTokenRequest(userProfileType, userProfileId) {
    return { type: GET_TEACHER_AUTH_TOKEN_REQUEST, userProfileType: userProfileType, userProfileId: userProfileId, isGettingToken: true };
}

function getTeacherAuthTokenSuccess(_ref) {
    var redirectUri = _ref.redirectUri,
        mathleticsToken = _ref.mathleticsToken;

    return { type: GET_TEACHER_AUTH_TOKEN_SUCCESS, redirectUri: redirectUri, authToken: mathleticsToken, isGettingToken: false };
}

function getTeacherLoginFailure(error) {
    return { type: GET_TEACHER_LOGIN_FAILURE, error: error, isGettingToken: false };
}

function getTeacherAuthTokenFailure() {
    return { type: GET_TEACHER_AUTH_TOKEN_FAILURE, isGettingToken: false };
}

/***/ }),
/* 269 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/* eslint-disable no-underscore-dangle */
/* eslint-disable no-return-assign */
/* eslint-disable no-prototype-builtins */
var storage = window.localStorage;

var LocalStorage = function () {
    function LocalStorage() {
        _classCallCheck(this, LocalStorage);
    }

    _createClass(LocalStorage, null, [{
        key: 'getAllItems',
        value: function getAllItems() {
            try {
                return storage.getItem(this.namespace) === null ? {} : JSON.parse(storage.getItem(this.namespace));
            } catch (e) {
                return {};
            }
        }
    }, {
        key: 'setItem',
        value: function setItem(key, value) {
            var allItems = this.getAllItems();
            var values = Object.assign(allItems, _defineProperty({}, key, value));
            storage.setItem('' + this.namespace, JSON.stringify(values));
        }
    }, {
        key: 'getItem',
        value: function getItem(key) {
            var allItems = this.getAllItems();
            return allItems.hasOwnProperty(key) ? allItems[key] : '';
        }
    }, {
        key: 'removeItem',
        value: function removeItem(key) {
            var values = Object.assign({}, this.getAllItems());
            delete values[key];
            storage.setItem(this.namespace, JSON.stringify(values));
        }
    }, {
        key: 'removeAllItems',
        value: function removeAllItems() {
            storage.clear();
        }
    }, {
        key: 'namespace',
        set: function set(name) {
            this._namespace = name;
        },
        get: function get() {
            return this._namespace = this._namespace ? this._namespace : Date.now();
        }
    }]);

    return LocalStorage;
}();

exports.default = LocalStorage;

/***/ }),
/* 270 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _basicResources = __webpack_require__(876);

var _basicResources2 = _interopRequireDefault(_basicResources);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

// The Resources class provides a set of static fields, one for each resource
// needed by the application. Users should call its initialise() method, to set
// up the environment and create all of the resources the application will use.

var Resources = function () {
    function Resources() {
        _classCallCheck(this, Resources);
    }

    _createClass(Resources, null, [{
        key: 'createResources',
        value: function createResources(parentEnv) {
            var env = parentEnv || Resources.env;

            this.productLicenses = env.resource('productLicenses').baseUrl('@SchoolRollGatewayUrl').service('api/v1/productLicenses');

            this.students = env.resource('students').baseUrl('@SchoolRollGatewayUrl').service('api/v1/students');

            this.studentsCsv = env.resource('studentsCsv').baseUrl('@SchoolRollGatewayUrl').service('api/v1/students/csv/{downloadKey}');

            this.yearGroups = env.resource('yearGroups').baseUrl('@SchoolRollGatewayUrl').service('api/v1/yeargroups');

            this.countryYearGroups = env.resource('countryYearGroups').baseUrl('@CourseManagerGatewayUrl').service('api/v1/yeargroups');

            this.downloadTemplateFile = env.resource('downloadTemplateFile').baseUrl('@SchoolRollGatewayUrl').service('api/v1/templates/{templateType}');

            this.quickUpload = env.resource('quickUpload').baseUrl('@SchoolRollGatewayUrl').service('api/v1/products/{productId}/quickUpload');

            this.classrooms = env.resource('classrooms').baseUrl('@SchoolRollGatewayUrl').service('api/v1/classrooms/products/{productId}');

            this.unassignStudents = env.resource('unassignStudents').baseUrl('@SchoolRollGatewayUrl').service('api/v1/classrooms/classroomUsersRelation');

            this.getStudents = env.resource('getStudents').baseUrl('@SchoolRollGatewayUrl').service('api/v1/students/{userProfileId}');

            this.studentClassroomsRelation = env.resource('studentClassroomsRelation').baseUrl('@SchoolRollGatewayUrl').service('api/v1/students/{userProfileId}/products/{productId}/classroomsRelation');

            this.teacherClassroomsRelation = env.resource('teacherClassroomsRelation').baseUrl('@SchoolRollGatewayUrl').service('api/v1/teachers/{userProfileId}/products/{productId}/classroomsRelation');

            this.teachers = env.resource('teachers').baseUrl('@SchoolRollGatewayUrl').service('api/v1/teachers');

            this.addTeacher = env.resource('addTeacher').baseUrl('@SchoolRollGatewayUrl').service('api/v1/teachers/invite');

            this.getTeachers = env.resource('getTeachers').baseUrl('@SchoolRollGatewayUrl').service('api/v1/teachers/{userProfileId}');

            this.unassignTeachers = env.resource('unassignTeachers').baseUrl('@SchoolRollGatewayUrl').service('api/v1/classrooms/classroomUsersRelation');

            this.bulkPasswordChangeStudents = env.resource('bulkPasswordChangeStudents').baseUrl('@SchoolRollGatewayUrl').service('api/v1/students/changePassword');

            this.bulkPasswordChangeTeachers = env.resource('bulkPasswordChangeTeachers').baseUrl('@SchoolRollGatewayUrl').service('api/v1/teachers/changePassword');

            this.teachersSignInCards = env.resource('teachersSignInCards').baseUrl('@SignInCardGatewayUrl').service('api/v1/products/{productId}/teacherSignInCards');

            this.classStudentsSignInCards = env.resource('classStudentsSignInCards').baseUrl('@SignInCardGatewayUrl').service('api/v1/products/{productId}/studentSignInCards');

            this.classroomsStudentsSignInCards = env.resource('classroomsStudentsSignInCards').baseUrl('@SignInCardGatewayUrl').service('api/v1/products/{productId}/classroomSignInCards');

            this.teachersCsv = env.resource('teachersCsv').baseUrl('@SchoolRollGatewayUrl').service('api/v1/teachers/csv/{downloadKey}');

            this.deleteStudents = env.resource('deleteStudents').baseUrl('@SchoolRollGatewayUrl').service('api/v1/students');

            this.deleteTeachers = env.resource('deleteTeachers').baseUrl('@SchoolRollGatewayUrl').service('api/v1/teachers');

            this.classesCsv = env.resource('classesCsv').baseUrl('@SchoolRollGatewayUrl').service('api/v1/classrooms/csv');

            this.getCourseCountries = env.resource('getCourseCountries').baseUrl('@CourseManagerGatewayUrl').service('api/v1/countries');

            this.getProductCourses = env.resource('getProductCourses').baseUrl('@CourseManagerGatewayUrl').service('api/v1/courses');

            this.getSchoolCourses = env.resource('getSchoolCourses').baseUrl('@CourseManagerGatewayUrl').service('api/v1/courses/schoolcourses');

            this.addClass = env.resource('addClass').baseUrl('@SchoolRollGatewayUrl').service('api/v1/classrooms');

            this.updateClassroomGroup = env.resource('updateClassroomGroup').baseUrl('@SchoolRollGatewayUrl').service('api/v1/{classroomId}/groups/{groupId}');

            this.getClassById = env.resource('getClassById').baseUrl('@SchoolRollGatewayUrl').service('api/v1/classrooms/{classroomId}');

            this.updateClass = env.resource('updateClass').baseUrl('@SchoolRollGatewayUrl').service('api/v1/classrooms/{classroomId}');

            this.classroomUserRelation = env.resource('classroomUserRelation').baseUrl('@SchoolRollGatewayUrl').service('api/v1/classrooms/classroomUsersRelation');

            this.deleteClassroomGroup = env.resource('deleteClassroomGroup').baseUrl('@SchoolRollGatewayUrl').service('api/v1/{classroomId}/groups/{groupId}');

            this.changeClassroomCourse = env.resource('changeClassroomCourse').baseUrl('@SchoolRollGatewayUrl').service('api/v1/{classroomId}/groups/{groupId}/checkTaskAndChangeCourse');

            this.getStudentsByClassroomId = env.resource('getStudentsByClassroomId').baseUrl('@SchoolRollGatewayUrl').service('api/v1/classrooms/{classroomId}/students');

            this.addGroup = env.resource('addGroup').baseUrl('@SchoolRollGatewayUrl').service('api/v1/{classroomId}/groups/registerGroup');

            this.getClassroomGroups = env.resource('getClassroomGroups').baseUrl('@SchoolRollGatewayUrl').service('api/v1/{classroomId}/groups');

            this.moveStudents = env.resource('moveStudents').baseUrl('@SchoolRollGatewayUrl').service('api/v1/classrooms/{classroomId}/moveStudents');

            this.deleteClassrooms = env.resource('deleteClassrooms').baseUrl('@SchoolRollGatewayUrl').service('api/v1/classrooms/bulk');

            this.changeCourseCarryOver = env.resource('changeCourseCarryOver').baseUrl('@SchoolRollGatewayUrl').service('api/v1/{classroomId}/groups/{groupId}/updateTaskAndChangeCourse');

            this.verifyRollOver = env.resource('verifyRollOver').baseUrl('@SchoolRollGatewayUrl').service('api/v1/products/{productId}/validateRollover');

            this.downloadSchoolRollData = env.resource('downloadSchoolRollData').baseUrl('@SchoolRollGatewayUrl').service('api/v1/products/{productId}/schoolRollData');

            this.performRollover = env.resource('performRollover').baseUrl('@SchoolRollGatewayUrl').service('api/v1/products/{productId}/rollover');

            this.extendingResultsStatus = env.resource('extendingResultsStatus').baseUrl('@SchoolRollGatewayUrl').service('api/v1/products/{productId}/extendingResultsStatus');

            this.extendResults = env.resource('extendResults').baseUrl('@SchoolRollGatewayUrl').service('api/v1/products/{productId}/extendResults');

            this.getDefaultCourses = env.resource('getDefaultCourses').baseUrl('@SchoolRollGatewayUrl').service('api/v1/products/{productId}/schooldefaultcourses');

            this.getCourse = env.resource('getCourse').baseUrl('@CourseManagerGatewayUrl').service('api/v1/courses/{courseId}');

            this.getAcademicYear = env.resource('getAcademicYear').baseUrl('@CertificatesGatewayUrl').service('api/v1/certificates/academicYear');

            this.getCertificatesSummary = env.resource('getCertificatesSummary').baseUrl('@CertificatesGatewayUrl').service('api/v1/certificates/summary');

            this.downloadCertificates = env.resource('downloadCertificates').baseUrl('@CertificatesGatewayUrl').service('api/v1/certificates/download');

            this.saveSchoolDefaultCourses = env.resource('saveSchoolDefaultCourses').baseUrl('@SchoolRollGatewayUrl').service('api/v1/products/{productId}/schooldefaultcourses');

            this.checkCommonTasks = env.resource('checkCommonTasks').baseUrl('@SchoolRollGatewayUrl').service('api/v1/{classroomId}/groups/{groupId}/commonTasks');

            this.assignCourses = env.resource('assignCourses').baseUrl('@SchoolRollGatewayUrl').service('api/v1/schools/changeGroupsCourse');

            this.getTeacherAuthToken = env.resource('getTeacherAuthToken').baseUrl('@UserPortalGateway').service('api/v1/authentication/logIn/{userProfileType}/{userProfileId}');

            this.sendTeacherPassword = env.resource('sendTeacherPassword').baseUrl('@SchoolRollGatewayUrl').service('api/v1/teachers/sendResetPasswordLink');

            this.sendVerificationEmail = env.resource('sendVerifyEmailLink').baseUrl('@UserPortalGateway').service('api/v1/sendVerificationEmail');

            this.sendVerificationEmails = env.resource('sendVerifyEmailLinks').baseUrl('@UserPortalGateway').service('api/v1/sendVerificationEmails');

            this.getFilteredCourses = env.resource('getFilteredCourses').baseUrl('@CourseManagerGatewayUrl').service('api/v1/courses/filter');

            this.getConquestFilteredCourses = env.resource('getConquestFilteredCourses').baseUrl('@CourseManagerGatewayUrl').service('api/v1/courses/conquest/filter');
        }

        // Initialise the environment and resources, based on the provided
        // environment name.  We return the environment so the caller has
        // access to everything, in particular the authToken if one was
        // passed in the query parameters.

    }, {
        key: 'initialise',
        value: function initialise(envName, credentials) {
            Resources.env = _basicResources2.default.initialise(envName, credentials);

            Resources.createResources();

            return Resources.env;
        }
    }]);

    return Resources;
}();

exports.default = Resources;

/***/ }),
/* 271 */,
/* 272 */,
/* 273 */,
/* 274 */,
/* 275 */,
/* 276 */,
/* 277 */,
/* 278 */,
/* 279 */,
/* 280 */,
/* 281 */,
/* 282 */,
/* 283 */,
/* 284 */,
/* 285 */,
/* 286 */,
/* 287 */,
/* 288 */,
/* 289 */,
/* 290 */,
/* 291 */,
/* 292 */,
/* 293 */,
/* 294 */,
/* 295 */,
/* 296 */,
/* 297 */,
/* 298 */,
/* 299 */,
/* 300 */,
/* 301 */,
/* 302 */,
/* 303 */,
/* 304 */,
/* 305 */,
/* 306 */,
/* 307 */,
/* 308 */,
/* 309 */,
/* 310 */,
/* 311 */,
/* 312 */,
/* 313 */,
/* 314 */,
/* 315 */,
/* 316 */,
/* 317 */,
/* 318 */,
/* 319 */,
/* 320 */,
/* 321 */,
/* 322 */,
/* 323 */,
/* 324 */,
/* 325 */,
/* 326 */,
/* 327 */,
/* 328 */,
/* 329 */,
/* 330 */,
/* 331 */,
/* 332 */,
/* 333 */,
/* 334 */,
/* 335 */,
/* 336 */,
/* 337 */,
/* 338 */,
/* 339 */,
/* 340 */,
/* 341 */,
/* 342 */,
/* 343 */,
/* 344 */,
/* 345 */,
/* 346 */,
/* 347 */,
/* 348 */,
/* 349 */,
/* 350 */,
/* 351 */,
/* 352 */,
/* 353 */,
/* 354 */,
/* 355 */,
/* 356 */,
/* 357 */,
/* 358 */,
/* 359 */,
/* 360 */,
/* 361 */,
/* 362 */,
/* 363 */,
/* 364 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1100);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(5)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../node_modules/css-loader/index.js?modules&localIdentName=[local]---[hash:base64:5]!../../../node_modules/postcss-loader/lib/index.js!../../../node_modules/sass-loader/index.js!./index.scss", function() {
			var newContent = require("!!../../../node_modules/css-loader/index.js?modules&localIdentName=[local]---[hash:base64:5]!../../../node_modules/postcss-loader/lib/index.js!../../../node_modules/sass-loader/index.js!./index.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 365 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1106);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(5)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../node_modules/css-loader/index.js?modules&localIdentName=[local]---[hash:base64:5]!../../../node_modules/postcss-loader/lib/index.js!../../../node_modules/sass-loader/index.js!./index.scss", function() {
			var newContent = require("!!../../../node_modules/css-loader/index.js?modules&localIdentName=[local]---[hash:base64:5]!../../../node_modules/postcss-loader/lib/index.js!../../../node_modules/sass-loader/index.js!./index.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 366 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1108);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(5)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../node_modules/css-loader/index.js?modules&localIdentName=[local]---[hash:base64:5]!../../../node_modules/postcss-loader/lib/index.js!../../../node_modules/sass-loader/index.js!./index.scss", function() {
			var newContent = require("!!../../../node_modules/css-loader/index.js?modules&localIdentName=[local]---[hash:base64:5]!../../../node_modules/postcss-loader/lib/index.js!../../../node_modules/sass-loader/index.js!./index.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 367 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1111);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(5)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../node_modules/css-loader/index.js?modules&localIdentName=[local]---[hash:base64:5]!../../../node_modules/postcss-loader/lib/index.js!../../../node_modules/sass-loader/index.js!./index.scss", function() {
			var newContent = require("!!../../../node_modules/css-loader/index.js?modules&localIdentName=[local]---[hash:base64:5]!../../../node_modules/postcss-loader/lib/index.js!../../../node_modules/sass-loader/index.js!./index.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 368 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1149);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(5)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../node_modules/css-loader/index.js?modules&localIdentName=[local]---[hash:base64:5]!../../../node_modules/postcss-loader/lib/index.js!../../../node_modules/sass-loader/index.js!./index.scss", function() {
			var newContent = require("!!../../../node_modules/css-loader/index.js?modules&localIdentName=[local]---[hash:base64:5]!../../../node_modules/postcss-loader/lib/index.js!../../../node_modules/sass-loader/index.js!./index.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 369 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1158);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(5)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../node_modules/css-loader/index.js?modules&localIdentName=[local]---[hash:base64:5]!../../../node_modules/postcss-loader/lib/index.js!../../../node_modules/sass-loader/index.js!./index.scss", function() {
			var newContent = require("!!../../../node_modules/css-loader/index.js?modules&localIdentName=[local]---[hash:base64:5]!../../../node_modules/postcss-loader/lib/index.js!../../../node_modules/sass-loader/index.js!./index.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 370 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1183);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(5)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../node_modules/css-loader/index.js?modules&localIdentName=[local]---[hash:base64:5]!../../../node_modules/postcss-loader/lib/index.js!../../../node_modules/sass-loader/index.js!./index.scss", function() {
			var newContent = require("!!../../../node_modules/css-loader/index.js?modules&localIdentName=[local]---[hash:base64:5]!../../../node_modules/postcss-loader/lib/index.js!../../../node_modules/sass-loader/index.js!./index.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 371 */,
/* 372 */,
/* 373 */,
/* 374 */,
/* 375 */,
/* 376 */,
/* 377 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _reactIntl = __webpack_require__(2);

exports.default = (0, _reactIntl.defineMessages)({
    addClass: {
        id: 'app.components.AddClass.addClass',
        defaultMessage: 'Add a {productName} class'
    },
    addClassConfirmation: {
        id: 'app.components.AddClass.addClassConfirmation',
        defaultMessage: 'has been created'
    },
    classNameLabel: {
        id: 'app.components.AddClass.classNameLabel',
        defaultMessage: 'Class Name'
    },
    yearDropdownLabel: {
        id: 'app.components.AddClass.yearDropdownLabel',
        defaultMessage: 'Years'
    },
    countryDropdownLabel: {
        id: 'app.components.AddClass.countryDropdownLabel',
        defaultMessage: 'Select a country'
    },
    courseDropdownLabel: {
        id: 'app.components.AddClass.courseDropdownLabel',
        defaultMessage: 'Select a course'
    },
    teacherDropdownLabel: {
        id: 'app.components.AddClass.teacherDropdownLabel',
        defaultMessage: 'Select a {product} teacher'
    },
    noTeacherDropdownLabel: {
        id: 'app.components.AddClass.noTeacherDropdownLabel',
        defaultMessage: 'No teachers found'
    },
    done: {
        id: 'app.components.AddClass.done',
        defaultMessage: 'Done'
    },
    schoolCourses: {
        id: 'app.components.AddClass.schoolCourses',
        defaultMessage: 'School courses'
    },
    noCourses: {
        id: 'app.components.AddClass.noCourses',
        defaultMessage: 'No courses found'
    },
    loadingCourses: {
        id: 'app.components.AddClass.loadingCourses',
        defaultMessage: 'Loading...'
    },
    mathsClass: {
        id: 'app.components.AddClass.mathsClass',
        defaultMessage: 'maths class'
    },
    className: {
        id: 'app.components.AddClass.className',
        defaultMessage: 'Class name'
    },
    teacher: {
        id: 'app.components.AddClass.teacher',
        defaultMessage: 'Teacher'
    },
    select: {
        id: 'app.components.AddClass.select',
        defaultMessage: 'select'
    },
    grade: {
        id: 'app.components.AddClass.grade',
        defaultMessage: 'Grade'
    },
    country: {
        id: 'app.components.AddClass.country',
        defaultMessage: 'Country'
    },
    skillQuests: {
        id: 'app.components.AddClass.skillQuests',
        defaultMessage: 'Skill Quests'
    },
    courses: {
        id: 'app.components.AddClass.courses',
        defaultMessage: 'Courses (Activity Mastery)'
    },
    coursesNonMaths: {
        id: 'app.components.AddClass.coursesNonMaths',
        defaultMessage: 'Courses'
    },
    selectDefaultCourse: {
        id: 'app.components.AddClass.selectDefaultCourse',
        defaultMessage: 'Select default course'
    },
    customCourses: {
        id: 'app.components.AddClass.customCourses',
        defaultMessage: 'Custom school courses'
    },
    curriculumCourses: {
        id: 'app.components.AddClass.curriculumCourses',
        defaultMessage: 'Curriculum based courses'
    },
    cancel: {
        id: 'app.components.AddClass.cancel',
        defaultMessage: 'Cancel'
    },
    add: {
        id: 'app.components.AddClass.add',
        defaultMessage: 'Add'
    },
    required: {
        id: 'app.components.AddClass.required',
        defaultMessage: 'Required selection'
    },
    none: {
        id: 'app.components.AddClass.none',
        defaultMessage: 'None'
    },
    noCoursesFound: {
        id: 'app.components.AddClass.noCoursesFound',
        defaultMessage: 'No courses found'
    },
    newCourses: {
        id: 'app.components.AddClass.newCourses',
        defaultMessage: 'New Courses'
    },
    useAdminSelection: {
        id: 'app.components.AddClass.useAdminSelection',
        defaultMessage: 'Use admin selection'
    }
}); /*
     * AddClass Messages
     *
     * This contains all the text for the AddClass component.
     */

/***/ }),
/* 378 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _reactIntl = __webpack_require__(2);

exports.default = (0, _reactIntl.defineMessages)({
    year: {
        id: 'app.components.assignCourseMapper.year',
        defaultMessage: 'YEAR'
    },
    class: {
        id: 'app.components.assignCourseMapper.class',
        defaultMessage: 'CLASS'
    },
    group: {
        id: 'app.components.assignCourseMapper.group',
        defaultMessage: 'GROUP'
    },
    assignedCourse: {
        id: 'app.components.assignCourseMapper.assignedCourse',
        defaultMessage: 'ASSIGNED COURSE'
    },
    save: {
        id: 'assignCourseMapper.components.save',
        defaultMessage: 'Save'
    },
    cancel: {
        id: 'assignCourseMapper.components.cancel',
        defaultMessage: 'Cancel'
    },
    assignToGroup: {
        id: 'assignCourseMapper.components.assignToGroup',
        defaultMessage: 'Assign to group'
    },
    unsavedChanges: {
        id: 'assignCourseMapper.components.unsavedChanges',
        defaultMessage: 'Unsaved changes'
    },
    assignErrorMessage: {
        id: 'assignCourseMapper.components.assignErrorMessage',
        defaultMessage: 'An unknown error occurred. Please select another course.'
    },
    saveErrorMessage: {
        id: 'assignCourseMapper.components.saveErrorMessage',
        defaultMessage: 'An unknown error occurred. Please try saving the course again.'
    },
    tasksCarryForwardMessage1: {
        id: 'assignCourseMapper.components.tasksCarryForwardMessage1',
        defaultMessage: 'You currently have {commonTasks} activities assigned'
    },
    tasksCarryForwardMessage2: {
        id: 'assignCourseMapper.components.tasksCarryForwardMessage2',
        defaultMessage: 'Would you like to carry these over ?'
    },
    back: {
        id: 'assignCourseMapper.components.back',
        defaultMessage: 'Back'
    },
    no: {
        id: 'assignCourseMapper.components.no',
        defaultMessage: 'No'
    },
    yes: {
        id: 'assignCourseMapper.components.yes',
        defaultMessage: 'Yes'
    },
    cancelWarningMessage: {
        id: 'assignCourseMapper.components.cancelWarningMessage',
        defaultMessage: 'Unsaved changes'
    },
    learningModule: {
        id: 'assignCourseMapperAdmin.components.learningModule',
        defaultMessage: 'LEARNING MODULE'
    },
    currentCourse: {
        id: 'assignCourseMapperAdmin.components.currentCourse',
        defaultMessage: 'CURRENT DEFAULT COURSE'
    },
    skillQuests: {
        id: 'assignCourseMapperAdmin.components.skillQuests',
        defaultMessage: ' Skill Quests'
    },
    newCourses: {
        id: 'assignCourseMapperAdmin.components.newCourses',
        defaultMessage: ' New Courses'
    },
    coursesActivityMastery: {
        id: 'assignCourseMapperAdmin.components.coursesActivityMastery',
        defaultMessage: 'Courses (Activity Mastery)'
    },
    courses: {
        id: 'assignCourseMapperAdmin.components.courses',
        defaultMessage: 'Courses'
    },
    optedOut: {
        id: 'assignCourseMapperAdmin.components.optedOut',
        defaultMessage: 'Opted out'
    },
    noVoluntaryCourseSet: {
        id: 'assignCourseMapperAdmin.components.noVoluntaryCourseSet',
        defaultMessage: 'No voluntary course set'
    },
    noCourseFound: {
        id: 'assignCourseMapperAdmin.components.noCourseFound',
        defaultMessage: 'No course found'
    }
}); /*
     * DefaultCourseMapper Messages
     *
     * This contains all the text for the DefaultCourseMapper component.
     */

/***/ }),
/* 379 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _reactIntl = __webpack_require__(2);

exports.default = (0, _reactIntl.defineMessages)({
    unassignedEmptyState: {
        id: 'app.components.AssignUser.unassignedEmptyState',
        defaultMessage: 'No classes found'
    },
    assignedEmptyState: {
        id: 'app.components.AssignUser.assignedEmptyState',
        defaultMessage: 'No classes assigned'
    },
    assignedClasses: {
        id: 'app.components.AssignUser.assignedClasses',
        defaultMessage: 'Assigned classes for'
    },
    assignedTeachers: {
        id: 'app.components.AssignUser.assignedTeachers',
        defaultMessage: 'Assigned teachers for'
    },
    available: {
        id: 'app.components.AssignUser.available',
        defaultMessage: 'Available'
    },
    assignedTo: {
        id: 'app.components.AssignUser.assignedTo',
        defaultMessage: 'assigned to'
    },
    teacherEmptyState: {
        id: 'app.components.AssignUser.teacherEmptyState',
        defaultMessage: 'No teachers found'
    },
    cancel: {
        id: 'app.components.AssignUser.cancel',
        defaultMessage: 'Cancel'
    },
    save: {
        id: 'app.components.AssignUser.save',
        defaultMessage: 'Save'
    },
    teachers: {
        id: 'app.components.AssignUser.teachers',
        defaultMessage: 'Teachers'
    },
    classes: {
        id: 'app.components.AssignUser.classes',
        defaultMessage: 'Classes'
    }

}); /*
     * StudentClassInfo Messages
     *
     * This contains all the text for the StudentClassInfo component.
     */

/***/ }),
/* 380 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactIntl = __webpack_require__(2);

var _reactStyleable = __webpack_require__(6);

var _reactStyleable2 = _interopRequireDefault(_reactStyleable);

__webpack_require__(26);

var _index = __webpack_require__(7);

var _index2 = _interopRequireDefault(_index);

var _index3 = __webpack_require__(254);

var _index4 = _interopRequireDefault(_index3);

var _index5 = __webpack_require__(1672);

var _index6 = _interopRequireDefault(_index5);

var _messages = __webpack_require__(649);

var _messages2 = _interopRequireDefault(_messages);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var AssignedClassesGroups = function AssignedClassesGroups(_ref) {
    var _ref$assignedTo = _ref.assignedTo,
        assignedTo = _ref$assignedTo === undefined ? [] : _ref$assignedTo,
        _ref$showAssignButton = _ref.showAssignButton,
        showAssignButton = _ref$showAssignButton === undefined ? true : _ref$showAssignButton,
        handleOnAssignClass = _ref.handleOnAssignClass,
        dependentValues = _ref.dependentValues,
        intl = _ref.intl;

    var assignElement = [];
    if (assignedTo.length > 0) {
        assignElement = _react2.default.createElement(_index4.default, { dataItems: assignedTo });
    } else if (showAssignButton) {
        assignElement = _react2.default.createElement(_index2.default, {
            containerClassName: _index6.default.assign,
            disabled: false,
            handleOnClick: function handleOnClick() {
                return handleOnAssignClass(dependentValues.userProfileId);
            },
            label: intl.formatMessage(_messages2.default.assignClass) });
    }

    return _react2.default.createElement(
        'div',
        { className: _index6.default.component },
        assignElement
    );
};

AssignedClassesGroups.propTypes = {
    assignedTo: _propTypes2.default.array,
    showAssignButton: _propTypes2.default.bool,
    dependentValues: _propTypes2.default.object,
    handleOnAssignClass: _propTypes2.default.func,
    intl: _reactIntl.intlShape.isRequired
};

exports.default = (0, _reactIntl.injectIntl)((0, _reactStyleable2.default)(_index6.default)(AssignedClassesGroups));

/***/ }),
/* 381 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _reactIntl = __webpack_require__(2);

exports.default = (0, _reactIntl.defineMessages)({
    activities: {
        id: 'app.components.classCourses.activities',
        defaultMessage: 'Activities'
    },
    newCourses: {
        id: 'app.components.classCourses.newCourses',
        defaultMessage: 'New Courses'
    },
    skillQuests: {
        id: 'app.components.classCourses.skillQuests',
        defaultMessage: 'Skill Quests'
    },
    noCourseAssigned: {
        id: 'app.components.classCourses.noCourseAssigned',
        defaultMessage: 'No course assigned'
    },
    multipleCourses: {
        id: 'app.components.classCourses.multipleCourses',
        defaultMessage: 'Multiple courses'
    },
    optedOut: {
        id: 'app.components.classCourses.optedOut',
        defaultMessage: 'Opted out'
    },
    noVoluntaryCourseSet: {
        id: 'app.components.classCourses.noVoluntaryCourseSet',
        defaultMessage: 'No voluntary course set'
    },
    noCoursesFound: {
        id: 'app.components.classCourses.noCoursesFound',
        defaultMessage: 'No course found'
    }
});

/***/ }),
/* 382 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactStyleable = __webpack_require__(6);

var _reactStyleable2 = _interopRequireDefault(_reactStyleable);

var _reactIntl = __webpack_require__(2);

var _svgIcon = __webpack_require__(21);

var _svgIcon2 = _interopRequireDefault(_svgIcon);

var _index = __webpack_require__(1696);

var _index2 = _interopRequireDefault(_index);

var _index3 = __webpack_require__(7);

var _index4 = _interopRequireDefault(_index3);

var _iconDictionary = __webpack_require__(8);

var _variants = __webpack_require__(9);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ConfirmationRequest = function ConfirmationRequest(_ref) {
    var children = _ref.children,
        handleOnCancel = _ref.handleOnCancel,
        handleOnClose = _ref.handleOnClose,
        handleOnOk = _ref.handleOnOk,
        isLoading = _ref.isLoading;
    return _react2.default.createElement(
        'div',
        { className: _index2.default.confirmationMessageContainer },
        _react2.default.createElement(
            'div',
            { className: _index2.default.icon },
            _react2.default.createElement(_svgIcon2.default, { icon: _iconDictionary.Warning })
        ),
        _react2.default.createElement(
            'div',
            { className: _index2.default.message },
            _react2.default.createElement(
                'div',
                { className: _index2.default.confirm },
                _react2.default.createElement(
                    'div',
                    null,
                    children
                )
            )
        ),
        _react2.default.createElement(
            'div',
            { className: _index2.default.container },
            _react2.default.createElement(_index4.default, {
                buttonContainer: _index2.default.cancel,
                buttonContainerDisabled: _index2.default.cancelButtonDisabled,
                disabled: isLoading,
                handleOnClick: handleOnCancel,
                icon: _iconDictionary.Cross,
                iconClassName: _index2.default.iconClassName,
                loading: isLoading }),
            _react2.default.createElement(_index4.default, {
                buttonContainer: _index2.default.ok,
                buttonContainerDisabled: _index2.default.okButtonDisabled,
                disabled: isLoading,
                handleOnClick: handleOnOk,
                icon: _iconDictionary.Tick,
                iconClassName: _index2.default.iconClassName,
                loading: isLoading })
        ),
        _react2.default.createElement(_index4.default, {
            containerClassName: _index2.default.buttonClose,
            disabled: isLoading,
            handleOnClick: handleOnClose,
            icon: _iconDictionary.Cross,
            variant: _variants.ICON_ONLY })
    );
};

ConfirmationRequest.propTypes = {
    children: _propTypes2.default.node,
    handleOnClose: _propTypes2.default.func,
    handleOnOk: _propTypes2.default.func,
    handleOnCancel: _propTypes2.default.func,
    isLoading: _propTypes2.default.bool
};

exports.default = (0, _reactIntl.injectIntl)((0, _reactStyleable2.default)(_index2.default)(ConfirmationRequest));

/***/ }),
/* 383 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactIntl = __webpack_require__(2);

var _reactStyleable = __webpack_require__(6);

var _reactStyleable2 = _interopRequireDefault(_reactStyleable);

var _svgIcon = __webpack_require__(21);

var _svgIcon2 = _interopRequireDefault(_svgIcon);

var _index = __webpack_require__(1697);

var _index2 = _interopRequireDefault(_index);

var _index3 = __webpack_require__(7);

var _index4 = _interopRequireDefault(_index3);

var _iconDictionary = __webpack_require__(8);

var _messages = __webpack_require__(681);

var _messages2 = _interopRequireDefault(_messages);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Confirmation = function Confirmation(_ref) {
    var icon = _ref.icon,
        title = _ref.title,
        handleOnOk = _ref.handleOnOk,
        handleOnCancel = _ref.handleOnCancel,
        isLoading = _ref.isLoading,
        children = _ref.children,
        intl = _ref.intl;
    return _react2.default.createElement(
        'div',
        { className: _index2.default.confirmationMessageContainer },
        _react2.default.createElement(
            'div',
            { className: _index2.default.icon },
            _react2.default.createElement(_svgIcon2.default, { icon: icon })
        ),
        _react2.default.createElement(
            'div',
            { className: _index2.default.title },
            title
        ),
        _react2.default.createElement(
            'div',
            { className: _index2.default.message },
            children,
            _react2.default.createElement(
                'div',
                { className: _index2.default.confirm },
                _react2.default.createElement(
                    'span',
                    { className: _index2.default.highlight },
                    intl.formatMessage(_messages2.default.doYouWishToContinue)
                )
            )
        ),
        _react2.default.createElement(
            'div',
            { className: _index2.default.container },
            _react2.default.createElement(_index4.default, {
                buttonContainer: _index2.default.cancel,
                buttonContainerDisabled: _index2.default.cancelButtonDisabled,
                disabled: isLoading,
                handleOnClick: handleOnCancel,
                icon: _iconDictionary.Cross,
                iconClassName: _index2.default.iconClassName,
                loading: isLoading }),
            _react2.default.createElement(_index4.default, {
                buttonContainer: _index2.default.ok,
                buttonContainerDisabled: _index2.default.okButtonDisabled,
                disabled: isLoading,
                handleOnClick: handleOnOk,
                icon: _iconDictionary.Tick,
                iconClassName: _index2.default.iconClassName,
                loading: isLoading })
        )
    );
};

Confirmation.propTypes = {
    icon: _propTypes2.default.string,
    title: _propTypes2.default.string,
    handleOnOk: _propTypes2.default.func,
    handleOnCancel: _propTypes2.default.func,
    isLoading: _propTypes2.default.bool,
    children: _propTypes2.default.node,
    intl: _reactIntl.intlShape.isRequired
};

exports.default = (0, _reactIntl.injectIntl)((0, _reactStyleable2.default)(_index2.default)(Confirmation));

/***/ }),
/* 384 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactIntl = __webpack_require__(2);

var _find = __webpack_require__(1440);

var _find2 = _interopRequireDefault(_find);

var _xlsxCore = __webpack_require__(598);

var _xlsxCore2 = _interopRequireDefault(_xlsxCore);

var _index = __webpack_require__(589);

var _index2 = _interopRequireDefault(_index);

var _messages = __webpack_require__(685);

var _messages2 = _interopRequireDefault(_messages);

var _itemSelector = __webpack_require__(684);

var _itemSelector2 = _interopRequireDefault(_itemSelector);

var _index3 = __webpack_require__(7);

var _index4 = _interopRequireDefault(_index3);

var _variants = __webpack_require__(9);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var CourseDetails = function (_Component) {
    _inherits(CourseDetails, _Component);

    function CourseDetails(props) {
        _classCallCheck(this, CourseDetails);

        var _this = _possibleConstructorReturn(this, (CourseDetails.__proto__ || Object.getPrototypeOf(CourseDetails)).call(this, props));

        _this.state = {
            course: {},
            activeTopicId: null
        };

        _this.setActiveCourse = _this.setActiveCourse.bind(_this);
        _this.exportCourse = _this.exportCourse.bind(_this);
        return _this;
    }

    _createClass(CourseDetails, [{
        key: 'setActiveCourse',
        value: function setActiveCourse(id) {
            var _this2 = this;

            this.setState({ activeTopicId: 0 });
            setTimeout(function () {
                _this2.setState({ activeTopicId: id });
            }, 5);
        }
    }, {
        key: 'getActiveTopicId',
        value: function getActiveTopicId() {
            var course = this.props.course;
            var topics = course.topics;

            var selectedTopicId = this.state.activeTopicId;

            // set initial topic index on first load
            if (this.state.activeTopicId === null && topics.length > 0) {
                selectedTopicId = topics[0].id;
            }

            return selectedTopicId;
        }
    }, {
        key: 'getTopics',
        value: function getTopics() {
            var _this3 = this;

            var course = this.props.course;
            var topics = course.topics;

            var activeTopicId = this.getActiveTopicId();

            var list = topics.map(function (item) {
                var isSelected = item.id === activeTopicId;
                return _react2.default.createElement(_itemSelector2.default, {
                    handleOnClick: function handleOnClick() {
                        return _this3.setActiveCourse(item.id);
                    },
                    key: item.id,
                    label: item.name,
                    selected: isSelected });
            });

            return list;
        }
    }, {
        key: 'getActiveActivities',
        value: function getActiveActivities() {
            var _props = this.props,
                course = _props.course,
                intl = _props.intl;
            var topics = course.topics;

            var activeTopicId = this.getActiveTopicId();

            // Get active or selected course
            var activeTopic = (0, _find2.default)(topics, function (item) {
                return item.id === activeTopicId;
            });

            // Get active or selected course
            var subList = [];

            if (activeTopic) {
                var core = activeTopic.core,
                    easier = activeTopic.easier;
                var coreActivities = core.activities;
                var easierActivities = easier.activities;

                var flag = true;

                subList = coreActivities.map(function (item) {
                    return _react2.default.createElement(_itemSelector2.default, {
                        guideUrl: item.guideUrl,
                        hasGuide: flag,
                        hasNoCursor: flag,
                        key: item.id,
                        label: item.name });
                });

                if (easierActivities.length > 0) {
                    subList.unshift(_react2.default.createElement(_itemSelector2.default, {
                        hasNoCursor: flag,
                        key: 'easier',
                        label: intl.formatMessage(_messages2.default.areYouReadyLabel) }));
                }

                if (coreActivities.length > 0) {
                    subList.push(_react2.default.createElement(_itemSelector2.default, {
                        hasNoCursor: flag,
                        key: 'core',
                        label: intl.formatMessage(_messages2.default.testLabel) }));
                }
            }
            return subList;
        }
    }, {
        key: 'exportCourse',
        value: function exportCourse() {
            var _props2 = this.props,
                course = _props2.course,
                intl = _props2.intl;
            var author = course.author,
                country = course.country,
                topics = course.topics,
                name = course.name,
                yearGroups = course.yearGroups;


            var countryLabel = intl.formatMessage(_messages2.default.countryLabel);
            var gradeLabel = intl.formatMessage(_messages2.default.gradeLabel);
            var authorLabel = intl.formatMessage(_messages2.default.authorLabel);

            var mergedYearGroups = Array(yearGroups.map(function (a) {
                return a.name;
            })).join(', ');

            var exportData = [];
            topics.forEach(function (topic) {
                var topicName = topic.name;
                var core = topic.core,
                    easier = topic.easier;
                var coreActivities = core.activities;
                var easierActivities = easier.activities;

                var topicActivityList = [];

                topicActivityList = coreActivities.map(function (item) {
                    return ['  ' + topicName, '  ' + item.name];
                });

                if (easierActivities.length > 0) {
                    topicActivityList.unshift(['  ' + topicName, '  ' + intl.formatMessage(_messages2.default.areYouReadyLabel)]);
                }

                if (coreActivities.length > 0) {
                    topicActivityList.push(['  ' + topicName, '  ' + intl.formatMessage(_messages2.default.testLabel)]);
                }

                easierActivities.forEach(function (activity, index) {
                    topicActivityList[index].splice(2, 0, activity.name);
                });

                exportData = [].concat(_toConsumableArray(exportData), _toConsumableArray(topicActivityList));
            });

            /* merge cells A1:C1 */
            var titleMerge = { s: { r: 0, c: 0 }, e: { r: 0, c: 10 } };

            /* merge cells A2:C2 */
            var subTitleMerge = { s: { r: 1, c: 0 }, e: { r: 1, c: 10 } };

            var heading = [[name], [countryLabel + ': ' + country + ' | ' + gradeLabel + ': ' + mergedYearGroups + ' | ' + authorLabel + ': ' + author], [], [intl.formatMessage(_messages2.default.topicFileLabel), intl.formatMessage(_messages2.default.activitiesFileLabel), intl.formatMessage(_messages2.default.easierActivitiesFileLabel)]];

            // Add headers
            var worksheet = _xlsxCore2.default.utils.aoa_to_sheet(heading);

            /* add merges */
            if (!worksheet['!merges']) worksheet['!merges'] = [];
            worksheet['!merges'].push(titleMerge);
            worksheet['!merges'].push(subTitleMerge);

            // Append data
            _xlsxCore2.default.utils.sheet_add_aoa(worksheet, exportData, { origin: 4, skipHeader: true });
            // Create a blank workbook using SheetJS
            var workbook = _xlsxCore2.default.utils.book_new();
            // Append the JSON sheet
            _xlsxCore2.default.utils.book_append_sheet(workbook, worksheet);

            _xlsxCore2.default.writeFile(workbook, name + '.xlsx');
        }
    }, {
        key: 'render',
        value: function render() {
            var _props3 = this.props,
                course = _props3.course,
                intl = _props3.intl,
                cssprops = _props3.css;
            var name = course.name;

            // Combine css and propped css

            var styles = _extends({}, _index2.default, cssprops);

            // Get all topics
            var list = this.getTopics();

            // Filter activites for the selected topic
            var activities = this.getActiveActivities();

            return _react2.default.createElement(
                'div',
                { className: styles.container },
                _react2.default.createElement(
                    'div',
                    { className: styles.header + ' ' + styles.headerColor },
                    _react2.default.createElement(
                        'h2',
                        null,
                        name
                    ),
                    _react2.default.createElement(
                        _index4.default,
                        { handleOnClick: this.exportCourse, variant: _variants.DARK },
                        intl.formatMessage(_messages2.default.exportLabel)
                    )
                ),
                _react2.default.createElement(
                    'div',
                    { className: styles.list + ' ' + styles.height },
                    _react2.default.createElement(
                        'div',
                        { className: styles.leftPanel },
                        _react2.default.createElement(
                            'div',
                            null,
                            _react2.default.createElement(
                                'div',
                                { className: styles.panelLabel },
                                intl.formatMessage(_messages2.default.topicLabel)
                            ),
                            list
                        )
                    ),
                    _react2.default.createElement(
                        'div',
                        { className: styles.rightPanel },
                        _react2.default.createElement(
                            'div',
                            null,
                            _react2.default.createElement(
                                'div',
                                { className: styles.panelLabel },
                                intl.formatMessage(_messages2.default.activitiesLabel)
                            ),
                            activities
                        )
                    )
                )
            );
        }
    }]);

    return CourseDetails;
}(_react.Component);

CourseDetails.propTypes = {
    /**
     * Refer to CourseManagerGateway for Course Object
     */
    course: _propTypes2.default.object,
    /**
     * Hashed CSS or stylesheets
     */
    css: _propTypes2.default.object,
    intl: _reactIntl.intlShape.isRequired
};

CourseDetails.defaultProps = {
    course: {
        name: '',
        courses: []
    }
};

exports.default = (0, _reactIntl.injectIntl)(CourseDetails);

/***/ }),
/* 385 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _DEFAULT_DATE_OPTIONS;

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var THIS_WEEK = exports.THIS_WEEK = 'This week';
var LAST_WEEK = exports.LAST_WEEK = 'Last week';
var THIS_SCHOOL_YEAR = exports.THIS_SCHOOL_YEAR = 'This school year';
var CUSTOM_DATE = exports.CUSTOM_DATE = 'Custom date';
var CUSTOM_DATE_TIME = exports.CUSTOM_DATE_TIME = 'Date and Time';
var LIFETIME = exports.LIFETIME = 'Lifetime';

var DEFAULT_DATE_OPTIONS = exports.DEFAULT_DATE_OPTIONS = [THIS_WEEK, LAST_WEEK, THIS_SCHOOL_YEAR, CUSTOM_DATE];
var DATE_OPTIONS = exports.DATE_OPTIONS = [].concat(DEFAULT_DATE_OPTIONS, [CUSTOM_DATE_TIME, LIFETIME]);

var DEFAULT_DATE_OPTIONS_LABELS = exports.DEFAULT_DATE_OPTIONS_LABELS = (_DEFAULT_DATE_OPTIONS = {}, _defineProperty(_DEFAULT_DATE_OPTIONS, THIS_WEEK, THIS_WEEK), _defineProperty(_DEFAULT_DATE_OPTIONS, LAST_WEEK, LAST_WEEK), _defineProperty(_DEFAULT_DATE_OPTIONS, THIS_SCHOOL_YEAR, THIS_SCHOOL_YEAR), _defineProperty(_DEFAULT_DATE_OPTIONS, CUSTOM_DATE, CUSTOM_DATE), _DEFAULT_DATE_OPTIONS);

/***/ }),
/* 386 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _reactIntl = __webpack_require__(2);

exports.default = (0, _reactIntl.defineMessages)({
    year: {
        id: 'app.components.DefaultCourseMapperAdmin.year',
        defaultMessage: 'YEAR'
    },
    defaultCourse: {
        id: 'app.components.DefaultCourseMapperAdmin.defaultCourse',
        defaultMessage: 'DEFAULT COURSE'
    },
    newDefaultCourse: {
        id: 'app.components.DefaultCourseMapperAdmin.newDefaultCourse',
        defaultMessage: 'NEW DEFAULT COURSE'
    },
    queue: {
        id: 'app.components.DefaultCourseMapperAdmin.queue',
        defaultMessage: 'Queue'
    },
    cancel: {
        id: 'app.components.DefaultCourseMapperAdmin.cancel',
        defaultMessage: 'Cancel'
    },
    assignToGroup: {
        id: 'app.components.DefaultCourseMapperAdmin.assignToGroup',
        defaultMessage: 'Assign to year'
    },
    unsavedChanges: {
        id: 'app.components.DefaultCourseMapperAdmin.unsavedChanges',
        defaultMessage: 'Unsaved changes'
    },
    learningModule: {
        id: 'app.components.DefaultCourseMapperAdmin.learningModule',
        defaultMessage: 'LEARNING MODULE'
    },
    skillQuests: {
        id: 'app.components.DefaultCourseMapperAdmin.skillQuests',
        defaultMessage: 'Skill Quests'
    },
    newCourses: {
        id: 'app.components.DefaultCourseMapperAdmin.newCourses',
        defaultMessage: 'New Courses'
    },
    coursesActivityMastery: {
        id: 'app.components.DefaultCourseMapperAdmin.coursesActivityMastery',
        defaultMessage: 'Courses (Activity Mastery)'
    },
    courses: {
        id: 'app.components.DefaultCourseMapperAdmin.courses',
        defaultMessage: 'Courses'
    },
    unconfirmed: {
        id: 'app.components.DefaultCourseMapperAdmin.unconfirmed',
        defaultMessage: '(Confirm by selecting queue)'
    },
    optedOut: {
        id: 'app.components.DefaultCourseMapperAdmin.optedOut',
        defaultMessage: 'Opted out'
    },
    noVoluntaryCourseSet: {
        id: 'app.components.DefaultCourseMapperAdmin.noVoluntaryCourseSet',
        defaultMessage: 'No voluntary course set'
    },
    noUPFCourseSet: {
        id: 'app.components.DefaultCourseMapperAdmin.noUPFCourseSet',
        defaultMessage: 'No course found'
    },
    queuedForRollover: {
        id: 'app.components.DefaultCourseMapperAdmin.queuedForRollover',
        defaultMessage: 'Queued for Rollover'
    },
    whileYouMightSee: {
        id: 'app.components.DefaultCourseMapperAdmin.whileYouMightSee',
        defaultMessage: 'While you might see your selection displayed under'
    },
    changesWillNotTake: {
        id: 'app.components.DefaultCourseMapperAdmin.changesWillNotTake',
        defaultMessage: 'changes will not take effect until your next scheduled rollover.'
    },
    youMayChangeYour: {
        id: 'app.components.DefaultCourseMapperAdmin.youMayChangeYour',
        defaultMessage: 'You may change your selection at any point prior to rollover.'
    },
    iUnderstand: {
        id: 'app.components.DefaultCourseMapperAdmin.iUnderstand',
        defaultMessage: 'I understand'
    },
    dontTellMeAgain: {
        id: 'app.components.DefaultCourseMapperAdmin.dontTellMeAgain',
        defaultMessage: 'Don\'t tell me again'
    }
}); /*
     * DefaultCourseMapperAdmin Messages
     *
     * This contains all the text for the DefaultCourseMapperAdmin component.
     */

/***/ }),
/* 387 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _reactIntl = __webpack_require__(2);

exports.default = (0, _reactIntl.defineMessages)({
    header: {
        id: 'download-certificates.components.header',
        defaultMessage: 'Certificates'
    },
    downloadBtn: {
        id: 'download-certificates.components.downloadBtn',
        defaultMessage: 'Download'
    },
    noCertsAvailable: {
        id: 'download-certificates.components.noCertsAvailable',
        defaultMessage: 'No certificates available'
    },
    certsAvailable: {
        id: 'download-certificates.components.certsAvailable',
        defaultMessage: 'Download {totalCount} certificates'
    },
    goldCertType: {
        id: 'download-certificates.components.goldCertType',
        defaultMessage: 'Gold certificates'
    },
    silverCertType: {
        id: 'download-certificates.components.silverCertType',
        defaultMessage: 'Silver certificates'
    },
    bronzeCertType: {
        id: 'download-certificates.components.bronzeCertType',
        defaultMessage: 'Bronze certificates'
    },
    startToEndDateLabel: {
        id: 'download-certificates.components.startToEndDateLabel',
        defaultMessage: '{startDate} to {endDate}'
    },
    teachersDropdownLabel: {
        id: 'download-certificates.components.teachersDropdownLabel',
        defaultMessage: 'All teachers'
    },
    classesDropdownLabel: {
        id: 'download-certificates.components.classesDropdownLabel',
        defaultMessage: 'All classes'
    },
    groupsDropdownLabel: {
        id: 'download-certificates.components.groupsDropdownLabel',
        defaultMessage: 'All groups'
    }
});

/***/ }),
/* 388 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _reactIntl = __webpack_require__(2);

exports.default = (0, _reactIntl.defineMessages)({
    pageTitle: {
        id: 'manageAssignCourseAdmin.components.pageTitle',
        defaultMessage: 'Course Admin - Manage Assigned Courses'
    },
    pageSubTitle: {
        id: 'manageAssignCourseAdmin.components.pageSubTitle',
        defaultMessage: 'Select a learning module to begin'
    },
    backButton: {
        id: 'manageAssignCourseAdmin.components.backButton',
        defaultMessage: 'Back'
    },
    emptyStateMessage: {
        id: 'manageAssignCourseAdmin.components.emptyStateMessage',
        defaultMessage: 'No classes found'
    }
});

/***/ }),
/* 389 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _reactIntl = __webpack_require__(2);

exports.default = (0, _reactIntl.defineMessages)({
    pageTitle: {
        id: 'manageCourse.components.pageTitle',
        defaultMessage: 'Course Admin - Manage Default Courses for Rollover'
    },
    pageSubTitle: {
        id: 'manageCourse.components.pageSubTitle',
        defaultMessage: 'Select a Learning Module to begin'
    },
    backButton: {
        id: 'manageCourse.components.backButton',
        defaultMessage: 'Back'
    }
});

/***/ }),
/* 390 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _reactIntl = __webpack_require__(2);

exports.default = (0, _reactIntl.defineMessages)({
    students: {
        id: 'sign-in-cards.components.students',
        defaultMessage: 'Students'
    },
    teachers: {
        id: 'sign-in-cards.components.teachers',
        defaultMessage: 'Teachers'
    },
    download: {
        id: 'sign-in-cards.components.download',
        defaultMessage: 'Download sign-in cards'
    },
    downloading: {
        id: 'sign-in-cards.components.downloading',
        defaultMessage: 'Downloading'
    },
    noStudents: {
        id: 'extend-result.components.noStudents',
        defaultMessage: 'No Students'
    },
    noStudentSignInCards: {
        id: 'extend-result.components.noStudentSignInCards',
        defaultMessage: 'There are no student sign in cards for the current selection'
    },
    label: {
        id: 'extend-result.components.label',
        defaultMessage: 'Label'
    },
    ok: {
        id: 'extend-result.components.ok',
        defaultMessage: 'OK'
    },
    noStudentsAvailable: {
        id: 'extend-result.components.noStudentsAvailable',
        defaultMessage: 'No students available'
    },
    allTeachers: {
        id: 'sign-in-cards.components.allTeachers',
        defaultMessage: 'All teachers'
    },
    allClasses: {
        id: 'sign-in-cards.components.allClasses',
        defaultMessage: 'All classes'
    },
    signInCards: {
        id: 'sign-in-cards.components.signInCards',
        defaultMessage: 'Sign-in cards'
    },
    code: {
        id: 'sign-in-cards.components.code',
        defaultMessage: 'code'
    },
    selectClass: {
        id: 'sign-in-cards.components.selectClass',
        defaultMessage: 'Select a class to download sign-in cards'
    }
});

/***/ }),
/* 391 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactIntl = __webpack_require__(2);

var _reactStyleable = __webpack_require__(6);

var _reactStyleable2 = _interopRequireDefault(_reactStyleable);

var _svgIcon = __webpack_require__(21);

var _svgIcon2 = _interopRequireDefault(_svgIcon);

var _index = __webpack_require__(1741);

var _index2 = _interopRequireDefault(_index);

var _index3 = __webpack_require__(7);

var _index4 = _interopRequireDefault(_index3);

var _iconDictionary = __webpack_require__(8);

var _messages = __webpack_require__(776);

var _messages2 = _interopRequireDefault(_messages);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var StudentUnassign = function StudentUnassign(_ref) {
    var icon = _ref.icon,
        title = _ref.title,
        handleOnOk = _ref.handleOnOk,
        handleOnCancel = _ref.handleOnCancel,
        isLoading = _ref.isLoading,
        children = _ref.children,
        intl = _ref.intl;
    return _react2.default.createElement(
        'div',
        { className: _index2.default.confirmationMessageContainer },
        _react2.default.createElement(
            'div',
            { className: _index2.default.icon },
            _react2.default.createElement(_svgIcon2.default, { icon: icon })
        ),
        _react2.default.createElement(
            'div',
            { className: _index2.default.title },
            title
        ),
        _react2.default.createElement(
            'div',
            { className: _index2.default.message },
            children,
            _react2.default.createElement(
                'div',
                { className: _index2.default.confirm },
                _react2.default.createElement(
                    'span',
                    { className: _index2.default.highlight },
                    intl.formatMessage(_messages2.default.doYouWishToContinue)
                )
            )
        ),
        _react2.default.createElement(
            'div',
            { className: _index2.default.container },
            _react2.default.createElement(_index4.default, {
                buttonContainer: _index2.default.cancel,
                buttonContainerDisabled: _index2.default.cancelButtonDisabled,
                disabled: isLoading,
                handleOnClick: handleOnCancel,
                icon: _iconDictionary.Cross,
                iconClassName: _index2.default.iconClassName,
                loading: isLoading }),
            _react2.default.createElement(_index4.default, {
                buttonContainer: _index2.default.ok,
                buttonContainerDisabled: _index2.default.okButtonDisabled,
                disabled: isLoading,
                handleOnClick: handleOnOk,
                icon: _iconDictionary.Tick,
                iconClassName: _index2.default.iconClassName,
                loading: isLoading })
        )
    );
};

StudentUnassign.propTypes = {
    icon: _propTypes2.default.string,
    title: _propTypes2.default.string,
    handleOnOk: _propTypes2.default.func,
    handleOnCancel: _propTypes2.default.func,
    isLoading: _propTypes2.default.bool,
    children: _propTypes2.default.node,
    intl: _reactIntl.intlShape.isRequired
};

exports.default = (0, _reactIntl.injectIntl)((0, _reactStyleable2.default)(_index2.default)(StudentUnassign));

/***/ }),
/* 392 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _cloneDeep = __webpack_require__(54);

var _cloneDeep2 = _interopRequireDefault(_cloneDeep);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var emptyFn = function emptyFn() {};
var withForm = function withForm(WrappedComponent, options) {
    var validate = options.validate || emptyFn;

    var WithFormComponent = function (_React$Component) {
        _inherits(WithFormComponent, _React$Component);

        function WithFormComponent(props) {
            _classCallCheck(this, WithFormComponent);

            var _this = _possibleConstructorReturn(this, (WithFormComponent.__proto__ || Object.getPrototypeOf(WithFormComponent)).call(this, props));

            _this.handleListOnChange = function (field, value, validationContext, callback) {
                var fields = (0, _cloneDeep2.default)(_this.state.fields);
                fields[field] = value;
                _this.setState({
                    fields: fields
                });
                if (typeof callback === 'function') {
                    callback(field, value, fields);
                }
                _this.setState({ canSubmit: validate(fields, value, validationContext) });
            };

            _this.submit = _this.submit.bind(_this);
            _this.handleTextInputOnChange = _this.handleTextInputOnChange.bind(_this);
            _this.handleListOnChange = _this.handleListOnChange.bind(_this);
            _this.state = {
                canSubmit: false,
                fields: {}
            };
            return _this;
        }

        /**
         * handleListOnChange
         * @param {*} field
         * @param {*} value
         * @param validationContext
         * @param {*} callback
         */


        _createClass(WithFormComponent, [{
            key: 'handleTextInputOnChange',


            /**
             * handleTextInputOnChange
             * @param {*} event
             * @param {*} callback
             * @param {*} rules - refer to utils/invalidCharaters
             */
            value: function handleTextInputOnChange(event, callback, rules) {
                var regexRules = rules || emptyFn;
                var fields = this.state.fields;

                var regex = new RegExp(regexRules.call());
                var value = String(event.target.value).trim();
                var field = String(event.target.name);
                if (value !== '' && !regex.test(value)) {
                    event.preventDefault();
                    return false;
                }
                fields[field] = value;
                this.setState({
                    fields: fields
                });
                if (typeof callback === 'function') {
                    callback(event, fields);
                }
                this.setState({ canSubmit: validate(fields) });
                return true;
            }

            /**
             * Submit form
             * @param {*} callback
             */

        }, {
            key: 'submit',
            value: function submit(callback) {
                var fields = this.state.fields;

                if (typeof callback === 'function') {
                    callback(fields);
                }
            }
        }, {
            key: 'render',
            value: function render() {
                var formProps = {
                    handleListOnChange: this.handleListOnChange,
                    handleTextInputOnChange: this.handleTextInputOnChange,
                    submit: this.submit
                };

                return _react2.default.createElement(
                    'div',
                    { className: 'is-a-form' },
                    _react2.default.createElement(WrappedComponent, _extends({}, this.props, {
                        canSubmit: this.state.canSubmit,
                        fields: this.state.fields,
                        form: formProps }))
                );
            }
        }]);

        return WithFormComponent;
    }(_react2.default.Component);

    return WithFormComponent;
};

exports.default = withForm;

/***/ }),
/* 393 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = __webpack_require__(28);

var _orderBy = __webpack_require__(173);

var _orderBy2 = _interopRequireDefault(_orderBy);

var _reactIntl = __webpack_require__(2);

var _assignCourseUpf = __webpack_require__(642);

var _assignCourseUpf2 = _interopRequireDefault(_assignCourseUpf);

var _constants = __webpack_require__(96);

var _constants2 = _interopRequireDefault(_constants);

var _actionTypes = __webpack_require__(193);

var actionTypes = _interopRequireWildcard(_actionTypes);

var _constants3 = __webpack_require__(40);

var _actions = __webpack_require__(38);

var _utils = __webpack_require__(13);

var _messages = __webpack_require__(810);

var _messages2 = _interopRequireDefault(_messages);

var _actions2 = __webpack_require__(65);

var _actionTypes2 = __webpack_require__(97);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var AssignCoursesUPF = function (_Component) {
    _inherits(AssignCoursesUPF, _Component);

    function AssignCoursesUPF(props) {
        _classCallCheck(this, AssignCoursesUPF);

        var _this = _possibleConstructorReturn(this, (AssignCoursesUPF.__proto__ || Object.getPrototypeOf(AssignCoursesUPF)).call(this, props));

        _this.clearSelectedCourse = function (yearGroups) {
            var dispatch = _this.props.dispatch;

            var filteredCourses = _this.state.filteredCourses.map(function (course) {
                return _extends({}, course, {
                    isSelected: false
                });
            });
            _this.setState({ filteredCourses: filteredCourses, yearGroups: yearGroups });
            dispatch({ type: actionTypes.DESELECT_COURSE, deselectCourse: false });
        };

        _this.handleOnCountryChange = function (name, selectedCountryId) {
            var dispatch = _this.props.dispatch;

            _this.selectedCountryId = selectedCountryId;

            _this.setState({
                selectedCountryId: selectedCountryId,
                selectedYearGroupId: _constants3.DEFAULT_YEAR_GROUP,
                filteredCourses: [],
                searchQuery: ''
            });

            if (selectedCountryId !== _constants3.DEFAULT_COUNTRY_ID && selectedCountryId !== _constants2.default.SCHOOL_COURSES) {
                dispatch({
                    type: actionTypes.GET_COUNTRY_YEAR_GROUPS_REQUEST,
                    countryCode: selectedCountryId,
                    countryCourses: []
                });
            }

            if (selectedCountryId === _constants2.default.SCHOOL_COURSES) {
                dispatch({ type: actionTypes.GET_YEAR_GROUP_REQUEST });
            }

            dispatch({ type: actionTypes.CLEAR_COURSE_LIST, productCourses: [] });
            _this.selectedCourse = { id: _constants3.DEFAULT_COURSE_ID, name: '' };
        };

        _this.handleOnYearGroupChange = function (name, selectedYearGroupId) {
            var _this$props = _this.props,
                selectedProduct = _this$props.selectedProduct,
                dispatch = _this$props.dispatch;


            _this.setState({ selectedYearGroupId: selectedYearGroupId, initialLoad: false, searchQuery: '' });

            if (_this.selectedCountryId === _constants2.default.SCHOOL_COURSES) {
                if (selectedYearGroupId !== _constants3.DEFAULT_YEAR_GROUP) {
                    dispatch({ type: actionTypes.GET_SCHOOL_COURSE_REQUEST, yearGroup: selectedYearGroupId });
                } else {
                    _this.updateCourseSelection();
                }
            } else if (selectedYearGroupId !== _constants3.DEFAULT_YEAR_GROUP) {
                if (_this.props.isNewCoursesSelected && (0, _utils.newCoursesAvailable)(selectedYearGroupId)) {
                    dispatch({
                        type: _actions.GET_NEW_COURSES_REQUEST,
                        countryCode: _this.selectedCountryId,
                        productId: selectedProduct.id,
                        yearGroup: selectedYearGroupId,
                        isProductCoursesFetching: true
                    });
                } else {
                    dispatch({
                        type: actionTypes.GET_FILTERED_UPF_COURSES_REQUEST,
                        countryCode: _this.selectedCountryId,
                        productId: selectedProduct.id,
                        yearGroup: selectedYearGroupId,
                        isProductCoursesLoaded: false,
                        isProductCoursesFetching: true,
                        selectGenericCourses: !_this.props.selectedCourse.legacy,
                        includeGlobalCourses: true
                    });
                }
            } else {
                _this.updateCourseSelection();
            }

            _this.selectedCourse = { id: _constants3.DEFAULT_COURSE_ID, name: '' };
            _this.props.handleOnCourseSelection(_this.selectedCourse, true);

            if (_this.state.selectedCountryId === _constants3.DEFAULT_COUNTRY_ID) {
                _this.setState({ initialLoad: true });
            }
        };

        _this.handleOnSearchCourse = function (e) {
            var courses = _this.props.courses;

            var currentCourses = courses;
            var courseFilter = [];

            if (_this.selectedCountryId === _constants2.default.SCHOOL_COURSES) {
                courseFilter = currentCourses;
            } else {
                courseFilter = (0, _orderBy2.default)(currentCourses, ['isDefault'], ['desc']);
            }
            var filteredCourses = courseFilter.filter(function (course) {
                return course.name.toLowerCase().indexOf(e.target.value.toLowerCase()) !== -1;
            });

            if (!filteredCourses.length) {
                _this.selectedCourse = { id: _constants3.DEFAULT_COURSE_ID, name: '' };
                _this.props.handleOnCourseSelection(_this.selectedCourse, true);
            }

            _this.setState({ searchQuery: e.target.value });

            _this.updateCourseSelection(filteredCourses);
        };

        _this.handleOnCourseSelection = function (course) {
            _this.selectedCourse = course;
            _this.updateCourseSelection(_this.state.filteredCourses);
            _this.props.handleOnCourseSelection(course);
        };

        _this.assignToYearGroup = function () {
            _this.props.handleOnYearGroupSave(_this.selectedCourse);
        };

        _this.handleOptOutOfCourse = function () {
            _this.selectedCourse = { id: _constants3.DEFAULT_COURSE_ID, name: '' };
            _this.props.handleOnCourseSelection(_this.selectedCourse);
            _this.props.handleOnYearGroupSave(_this.selectedCourse);
            _this.clearSelectedCourse(_this.state.yearGroups);
        };

        _this.updateCourseSelection = function () {
            var courses = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

            var filteredCourses = courses.map(function (course) {
                var isSelected = false;
                if (_this.selectedCourse && course.name.toLowerCase() === _this.selectedCourse.name.toLowerCase()) {
                    isSelected = true;
                }
                return _extends({}, course, {
                    isSelected: isSelected
                });
            });
            _this.setState({ filteredCourses: filteredCourses });
        };

        _this.disableYearGroup = function () {
            return _this.selectedCountryId === _constants3.DEFAULT_COUNTRY_ID;
        };

        _this.disableSearchCourse = function () {
            var selectedYearGroupId = _this.state.selectedYearGroupId;

            return _this.selectedCountryId === _constants3.DEFAULT_COUNTRY_ID || selectedYearGroupId === _constants3.DEFAULT_YEAR_GROUP;
        };

        _this.state = {
            searchQuery: '',
            filteredCourses: [],
            selectedYearGroupId: _constants3.DEFAULT_YEAR_GROUP,
            selectedCountryId: _constants3.DEFAULT_COUNTRY_ID,
            yearGroups: [],
            initialLoad: true,
            legacy: _this.props.selectedCourse.legacy,
            NewCourse: _this.props.selectedCourse.NewCourse,
            UPF: _this.props.selectedCourse.UPF,
            countryLoading: false
        };

        _this.countries = [];
        _this.selectedCourse = { id: _constants3.DEFAULT_COURSE_ID, name: '' };
        _this.selectedCountryId = _constants3.DEFAULT_COUNTRY_ID;
        return _this;
    }

    _createClass(AssignCoursesUPF, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            if ((!this.props.countries || !this.props.countries.length) && !this.countries.length && !this.state.coursesLoading) {
                var _props = this.props,
                    selectedProduct = _props.selectedProduct,
                    dispatch = _props.dispatch;
                // eslint-disable-next-line react/no-did-mount-set-state

                this.setState({ countryLoading: true }, function () {
                    dispatch({ type: actionTypes.GET_COUNTRY_REQUEST, selectedProductId: selectedProduct.id });
                    dispatch({ type: actionTypes.GET_UPF_COUNTRY_REQUEST, selectedProductId: selectedProduct.id });
                });
            }
        }
    }, {
        key: 'componentWillReceiveProps',
        value: function componentWillReceiveProps(nextProps) {
            var _this2 = this;

            var yearGroups = nextProps.yearGroups,
                upfCountries = nextProps.upfCountries,
                courses = nextProps.courses,
                deselectCourse = nextProps.deselectCourse,
                isNewCoursesSelected = nextProps.isNewCoursesSelected,
                newCourses = nextProps.newCourses;

            var currentCourses = courses;
            if (isNewCoursesSelected) {
                currentCourses = newCourses;
            }

            this.countries = upfCountries;

            this.selectedCourse = nextProps.selectedCourse;

            if (this.props.courses !== courses || this.props.newCourses !== newCourses) {
                if (this.selectedCountryId === _constants2.default.SCHOOL_COURSES) {
                    this.updateCourseSelection(currentCourses);
                } else {
                    this.updateCourseSelection((0, _orderBy2.default)(currentCourses, ['isDefault'], ['desc']));
                }
            }

            if (deselectCourse) {
                this.clearSelectedCourse(yearGroups);
            } else {
                this.setState({ yearGroups: yearGroups });
            }
            if (nextProps.selectedCourse.legacy !== undefined && (nextProps.selectedCourse.legacy !== this.state.legacy || nextProps.selectedCourse.UPF !== this.state.UPF || nextProps.selectedCourse.NewCourse !== this.state.NewCourse)) {
                this.setState({
                    legacy: nextProps.selectedCourse.legacy,
                    UPF: nextProps.selectedCourse.UPF,
                    NewCourse: nextProps.selectedCourse.NewCourse
                }, function () {
                    return _this2.handleOnYearGroupChange('', _this2.state.selectedYearGroupId);
                });
            }
            if (nextProps.showAssignSuccessToast) {
                this.props.dispatch((0, _actions2.showToast)(this.props.intl.formatMessage(_messages2.default.assignCourseSuccess), 'success'));
                this.props.dispatch({ type: _actionTypes2.RESET_TOASTER_STATE });
            }

            if (nextProps.showAssignErrorToast) {
                this.props.dispatch((0, _actions2.showToast)(this.props.intl.formatMessage(_messages2.default.assignCourseFailure), 'error'));
                this.props.dispatch({ type: _actionTypes2.RESET_TOASTER_STATE });
            }
        }
    }, {
        key: 'render',
        value: function render() {
            var _state = this.state,
                filteredCourses = _state.filteredCourses,
                initialLoad = _state.initialLoad,
                searchQuery = _state.searchQuery,
                selectedYearGroupId = _state.selectedYearGroupId,
                yearGroups = _state.yearGroups;


            return _react2.default.createElement(_assignCourseUpf2.default, _extends({
                disableAssignToYear: this.state.selectedYearGroupId === _constants3.DEFAULT_YEAR_GROUP || this.state.selectedCountryId === _constants3.DEFAULT_COUNTRY_ID || this.selectedCourse.id === _constants3.DEFAULT_COURSE_ID,
                disableSearch: this.disableSearchCourse(),
                disableYearGroup: this.disableYearGroup(),
                filteredCourses: filteredCourses,
                forLegacy: this.state.legacy,
                handleOnCountryChange: this.handleOnCountryChange,
                handleOnSearchCourse: this.handleOnSearchCourse,
                handleOnYearGroupChange: this.handleOnYearGroupChange,
                initialLoad: initialLoad,
                searchQuery: searchQuery,
                selectedYearGroupId: selectedYearGroupId,
                yearGroups: yearGroups
            }, this.props, {
                assignToYearGroup: this.assignToYearGroup,
                countries: this.props.isUPFSelected ? this.props.upfCountries : this.props.countries,
                handleOnCourseSelection: this.handleOnCourseSelection,
                handleOptOutOfCourse: this.handleOptOutOfCourse,
                selectedCountryId: this.selectedCountryId }));
        }
    }]);

    return AssignCoursesUPF;
}(_react.Component);

AssignCoursesUPF.propTypes = {
    intl: _reactIntl.intlShape.isRequired,
    selectedProduct: _propTypes2.default.object,
    countries: _propTypes2.default.array,
    upfCountries: _propTypes2.default.array,
    courses: _propTypes2.default.array,
    yearGroups: _propTypes2.default.array,
    selectedCourse: _propTypes2.default.object,
    isProductCoursesLoaded: _propTypes2.default.bool,
    isSchoolCoursesLoaded: _propTypes2.default.bool,
    isNewCoursesLoaded: _propTypes2.default.bool,
    deselectCourse: _propTypes2.default.bool,
    handleOnCourseSelection: _propTypes2.default.func,
    dispatch: _propTypes2.default.func.isRequired,
    isUPFSelected: _propTypes2.default.bool,
    handleOnYearGroupSave: _propTypes2.default.func,
    forYear: _propTypes2.default.bool,
    isNewCoursesSelected: _propTypes2.default.bool,
    newCourses: _propTypes2.default.array,
    showAssignSuccessToast: _propTypes2.default.bool,
    showAssignErrorToast: _propTypes2.default.bool,
    showToast: _propTypes2.default.func
};

function mapStateToProps() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    return _extends({}, state, {
        yearGroups: state.assignUPFCourses.yearGroups,
        countries: state.assignUPFCourses.countries,
        upfCountries: state.assignUPFCourses.upfCountries,
        courses: state.assignUPFCourses.filteredCourses,
        newCourses: state.classRoll.newCourses,
        isNewCoursesLoaded: state.classRoll.isProductCoursesLoaded,
        deselectCourse: state.assignUPFCourses.deselectCourse,
        isLoadingCountryYearGroups: state.assignUPFCourses.isLoadingCountryYearGroups,
        isProductCoursesLoaded: state.assignUPFCourses.isProductCoursesLoaded,
        isSchoolCoursesLoaded: state.assignUPFCourses.isSchoolCoursesLoaded,
        isCourseModalVisible: state.defaultCourses.isCourseModalVisible,
        courseDetails: state.defaultCourses.courseDetails,
        fetchingCourse: state.defaultCourses.fetchingCourse,
        selectedProduct: state.product,
        showAssignSuccessToast: state.assignCourseAdmin.showAssignSuccessToast,
        showAssignErrorToast: state.assignCourseAdmin.showAssignErrorToast
    });
}

exports.default = (0, _reactIntl.injectIntl)((0, _reactRedux.connect)(mapStateToProps)(AssignCoursesUPF));

/***/ }),
/* 394 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _reactIntl = __webpack_require__(2);

exports.default = (0, _reactIntl.defineMessages)({
    defaultOptionTeachers: {
        id: 'class-roll.container.classRoll.defaultOptionTeachers',
        defaultMessage: 'All teachers'
    },
    defaultOptionTeacherClass: {
        id: 'class-roll.container.classRoll.defaultOptionTeacherClass',
        defaultMessage: 'All classes'
    },
    defaultOptionYearGroup: {
        id: 'class-roll.container.classRoll.defaultOptionYearGroup',
        defaultMessage: 'All years'
    },
    classroomList: {
        id: 'class-roll.container.classRoll.classroomList',
        defaultMessage: 'Select a {0} class'
    },
    deletingNonEmptyClassError: {
        id: 'class-roll.container.classRoll.deletingNonEmptyClassError',
        defaultMessage: 'Only empty classes may be deleted'
    },
    addClassConfirmation: {
        id: 'class-roll.container.classRoll.addClassConfirmation',
        defaultMessage: 'has been created'
    },
    deleteClassConfirmation: {
        id: 'class-roll.container.classRoll.deleteClassConfirmation',
        defaultMessage: 'class(es) removed from the school roll'
    }
}); /*
     * TeacherFilter Messages
     *
     * This contains all the text for the TeacherFilter component.
     */

/***/ }),
/* 395 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var GET_DEFAULT_COURSE_REQUEST = exports.GET_DEFAULT_COURSE_REQUEST = 'GET_DEFAULT_COURSE_REQUEST';
var GET_DEFAULT_COURSE_SUCCESS = exports.GET_DEFAULT_COURSE_SUCCESS = 'GET_DEFAULT_COURSE_SUCCESS';
var GET_DEFAULT_COURSE_FAILURE = exports.GET_DEFAULT_COURSE_FAILURE = 'GET_DEFAULT_COURSE_FAILURE';

var getDefaultCourses = exports.getDefaultCourses = function getDefaultCourses() {
    return { type: GET_DEFAULT_COURSE_REQUEST };
};

var getDefaultCoursesSuccess = exports.getDefaultCoursesSuccess = function getDefaultCoursesSuccess(data) {
    return { type: GET_DEFAULT_COURSE_SUCCESS, data: data };
};

var getDefaultCoursesFailure = exports.getDefaultCoursesFailure = function getDefaultCoursesFailure() {
    return { type: GET_DEFAULT_COURSE_FAILURE };
};

var SHOW_COURSE_DETAILS = exports.SHOW_COURSE_DETAILS = 'SHOW_COURSE_DETAILS';

var showCourseDetails = exports.showCourseDetails = function showCourseDetails(courseId) {
    return { type: SHOW_COURSE_DETAILS, courseId: courseId };
};

var HIDE_COURSE_DETAILS = exports.HIDE_COURSE_DETAILS = 'HIDE_COURSE_DETAILS';

var hideCourseDetails = exports.hideCourseDetails = function hideCourseDetails() {
    return { type: HIDE_COURSE_DETAILS };
};

var FETCH_COURSE_DETAILS_REQUEST = exports.FETCH_COURSE_DETAILS_REQUEST = 'FETCH_COURSE_DETAILS_REQUEST';
var FETCH_COURSE_DETAILS_SUCCESS = exports.FETCH_COURSE_DETAILS_SUCCESS = 'FETCH_COURSE_DETAILS_SUCCESS';
var FETCH_COURSE_DETAILS_FAILURE = exports.FETCH_COURSE_DETAILS_FAILURE = 'FETCH_COURSE_DETAILS_FAILURE';

var fetchCourseDetails = exports.fetchCourseDetails = function fetchCourseDetails() {
    return { type: FETCH_COURSE_DETAILS_REQUEST };
};

var fetchCourseDetailsSuccess = exports.fetchCourseDetailsSuccess = function fetchCourseDetailsSuccess(data) {
    return { type: FETCH_COURSE_DETAILS_SUCCESS, courseDetails: data };
};

var fetchCourseDetailsFailure = exports.fetchCourseDetailsFailure = function fetchCourseDetailsFailure() {
    return { type: FETCH_COURSE_DETAILS_FAILURE };
};
var SAVE_DEFAULT_COURSE_REQUEST = exports.SAVE_DEFAULT_COURSE_REQUEST = 'SAVE_DEFAULT_COURSE_REQUEST';
var SAVE_DEFAULT_COURSE_SUCCESS = exports.SAVE_DEFAULT_COURSE_SUCCESS = 'SAVE_DEFAULT_COURSE_SUCCESS';
var SAVE_DEFAULT_COURSE_FAILURE = exports.SAVE_DEFAULT_COURSE_FAILURE = 'SAVE_DEFAULT_COURSE_FAILURE';

var saveDefaultCourses = exports.saveDefaultCourses = function saveDefaultCourses(yearGroupCourses) {
    return { type: SAVE_DEFAULT_COURSE_REQUEST, yearGroupCourses: yearGroupCourses };
};

var saveDefaultCoursesSuccess = exports.saveDefaultCoursesSuccess = function saveDefaultCoursesSuccess(savingDefaultCourses) {
    return { type: SAVE_DEFAULT_COURSE_SUCCESS, savingDefaultCourses: savingDefaultCourses };
};

var saveDefaultCoursesFailure = exports.saveDefaultCoursesFailure = function saveDefaultCoursesFailure(savingDefaultCourses) {
    return { type: SAVE_DEFAULT_COURSE_FAILURE, savingDefaultCourses: savingDefaultCourses };
};

/***/ }),
/* 396 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _reactIntl = __webpack_require__(2);

exports.default = (0, _reactIntl.defineMessages)({
    header: {
        id: 'app.containers.EditTeacher.header',
        defaultMessage: 'This is EditTeacher container !'
    },
    emailSent: {
        id: 'app.containers.EditTeacher.emailSent',
        defaultMessage: 'Email successfully sent, check inbox for link'
    },
    emailUsedByAnotherUser: {
        id: 'app.containers.EditTeacher.emailUsedByAnotherUser',
        defaultMessage: function defaultMessage(email) {
            return 'Email ' + email + ' belongs to another user.';
        }
    }
}); /*
     * EditTeacher Messages
     *
     * This contains all the text for the EditTeacher component.
     */

/***/ }),
/* 397 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var GET_DEFAULT_COURSE_REQUEST = exports.GET_DEFAULT_COURSE_REQUEST = 'GET_DEFAULT_COURSE_REQUEST';
var GET_DEFAULT_COURSE_SUCCESS = exports.GET_DEFAULT_COURSE_SUCCESS = 'GET_DEFAULT_COURSE_SUCCESS';
var GET_DEFAULT_COURSE_FAILURE = exports.GET_DEFAULT_COURSE_FAILURE = 'GET_DEFAULT_COURSE_FAILURE';

var getDefaultCourses = exports.getDefaultCourses = function getDefaultCourses() {
    return { type: GET_DEFAULT_COURSE_REQUEST };
};

var getDefaultCoursesSuccess = exports.getDefaultCoursesSuccess = function getDefaultCoursesSuccess(data) {
    return { type: GET_DEFAULT_COURSE_SUCCESS, data: data };
};

var getDefaultCoursesFailure = exports.getDefaultCoursesFailure = function getDefaultCoursesFailure() {
    return { type: GET_DEFAULT_COURSE_FAILURE };
};

var SHOW_COURSE_DETAILS = exports.SHOW_COURSE_DETAILS = 'SHOW_COURSE_DETAILS';

var showCourseDetails = exports.showCourseDetails = function showCourseDetails(courseId) {
    return { type: SHOW_COURSE_DETAILS, courseId: courseId };
};

var HIDE_COURSE_DETAILS = exports.HIDE_COURSE_DETAILS = 'HIDE_COURSE_DETAILS';

var hideCourseDetails = exports.hideCourseDetails = function hideCourseDetails() {
    return { type: HIDE_COURSE_DETAILS };
};

var FETCH_COURSE_DETAILS_REQUEST = exports.FETCH_COURSE_DETAILS_REQUEST = 'FETCH_COURSE_DETAILS_REQUEST';
var FETCH_COURSE_DETAILS_SUCCESS = exports.FETCH_COURSE_DETAILS_SUCCESS = 'FETCH_COURSE_DETAILS_SUCCESS';
var FETCH_COURSE_DETAILS_FAILURE = exports.FETCH_COURSE_DETAILS_FAILURE = 'FETCH_COURSE_DETAILS_FAILURE';

var fetchCourseDetails = exports.fetchCourseDetails = function fetchCourseDetails() {
    return { type: FETCH_COURSE_DETAILS_REQUEST };
};

var fetchCourseDetailsSuccess = exports.fetchCourseDetailsSuccess = function fetchCourseDetailsSuccess(data) {
    return { type: FETCH_COURSE_DETAILS_SUCCESS, courseDetails: data };
};

var fetchCourseDetailsFailure = exports.fetchCourseDetailsFailure = function fetchCourseDetailsFailure() {
    return { type: FETCH_COURSE_DETAILS_FAILURE };
};
var SAVE_DEFAULT_COURSE_REQUEST = exports.SAVE_DEFAULT_COURSE_REQUEST = 'SAVE_DEFAULT_COURSE_REQUEST';
var SAVE_DEFAULT_COURSE_SUCCESS = exports.SAVE_DEFAULT_COURSE_SUCCESS = 'SAVE_DEFAULT_COURSE_SUCCESS';
var SAVE_DEFAULT_COURSE_FAILURE = exports.SAVE_DEFAULT_COURSE_FAILURE = 'SAVE_DEFAULT_COURSE_FAILURE';

var saveDefaultCourses = exports.saveDefaultCourses = function saveDefaultCourses(yearGroupCourses) {
    return { type: SAVE_DEFAULT_COURSE_REQUEST, yearGroupCourses: yearGroupCourses };
};

var saveDefaultCoursesSuccess = exports.saveDefaultCoursesSuccess = function saveDefaultCoursesSuccess(savingDefaultCourses) {
    return { type: SAVE_DEFAULT_COURSE_SUCCESS, savingDefaultCourses: savingDefaultCourses };
};

var saveDefaultCoursesFailure = exports.saveDefaultCoursesFailure = function saveDefaultCoursesFailure(savingDefaultCourses) {
    return { type: SAVE_DEFAULT_COURSE_FAILURE, savingDefaultCourses: savingDefaultCourses };
};

/***/ }),
/* 398 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _reactIntl = __webpack_require__(2);

exports.default = (0, _reactIntl.defineMessages)({
    quickUploadSuccessMessage: {
        id: 'quick-upload.containers.quickUploadSuccessMessage',
        defaultMessage: 'You have successfully uploaded '
    },
    row: {
        id: 'quick-upload.containers.row',
        defaultMessage: 'Row'
    },
    record: {
        id: 'quick-upload.containers.record',
        defaultMessage: 'record'
    },
    success: {
        id: 'quick-upload.containers.success',
        defaultMessage: 'Success!'
    },
    errorMessageBody: {
        id: 'quick-upload.containers.errorMessageBody',
        defaultMessage: 'Please try uploading your file again.'
    },
    errorMessageHeader: {
        id: 'quick-upload.containers.errorMessageHeader',
        defaultMessage: 'Oops, something went wrong'
    },
    validationMessage: {
        id: 'quick-upload.containers.validationMessage',
        defaultMessage: 'Oops, there are errors in your file'
    },
    fileFormatValidationMessage: {
        id: 'quick-upload.containers.fileFormatValidationMessage',
        defaultMessage: 'Incorrect file format'
    },
    newStudentCM: {
        id: 'quick-upload.containers.newStudent',
        defaultMessage: 'New student'
    },
    updatedStudentCM: {
        id: 'quick-upload.containers.updatedStudent',
        defaultMessage: 'Updated student'
    },
    unassignedStudentCM: {
        id: 'quick-upload.containers.unassignedStudent',
        defaultMessage: 'Unassigned student'
    },
    newTeacherCM: {
        id: 'quick-upload.containers.newTeacher',
        defaultMessage: 'New teacher'
    },
    updatedTeacherCM: {
        id: 'quick-upload.containers.upatedTeacher',
        defaultMessage: 'Updated teacher'
    },
    newClassesCM: {
        id: 'quick-upload.containers.newClasses',
        defaultMessage: 'New classes'
    },
    updatedClassesCM: {
        id: 'quick-upload.containers.updatedClasses',
        defaultMessage: 'Updated classes'
    }
});

/***/ }),
/* 399 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _reactIntl = __webpack_require__(2);

exports.default = (0, _reactIntl.defineMessages)({
    schoolRoll: {
        id: 'school-roll.container.schoolRoll',
        defaultMessage: 'School Roll'
    },
    student: {
        id: 'school-roll.container.student',
        defaultMessage: 'Student'
    },
    teacher: {
        id: 'school-roll.container.teacher',
        defaultMessage: 'Teacher'
    },
    classes: {
        id: 'school-roll.container.classes',
        defaultMessage: 'Classes'
    },
    licenceSummary: {
        id: 'school-roll.container.schoolRoll.licenceSummary',
        defaultMessage: 'Remaining Licences'
    },
    expiredLicence: {
        id: 'school-roll.container.schoolRoll.expiredLicense',
        defaultMessage: 'Licence Expired'
    },
    classroomList: {
        id: 'school-roll.container.schoolRoll.classroomList',
        defaultMessage: 'Select a {0} class'
    },
    defaultOptionCountry: {
        id: 'school-roll.container.schoolRoll.defaultOptionCountry',
        defaultMessage: 'Country'
    },
    students: {
        id: 'school-roll.container.students',
        defaultMessage: 'Students'
    },
    teachers: {
        id: 'school-roll.container.teachers',
        defaultMessage: 'Teachers'
    }
}); /*
     * student-header messages
     *
     * This contains all the text for the student-header component.
     */

/***/ }),
/* 400 */,
/* 401 */,
/* 402 */,
/* 403 */,
/* 404 */,
/* 405 */,
/* 406 */,
/* 407 */,
/* 408 */,
/* 409 */,
/* 410 */,
/* 411 */,
/* 412 */,
/* 413 */,
/* 414 */,
/* 415 */,
/* 416 */,
/* 417 */,
/* 418 */,
/* 419 */,
/* 420 */,
/* 421 */,
/* 422 */,
/* 423 */,
/* 424 */,
/* 425 */,
/* 426 */,
/* 427 */,
/* 428 */,
/* 429 */,
/* 430 */,
/* 431 */,
/* 432 */,
/* 433 */,
/* 434 */,
/* 435 */,
/* 436 */,
/* 437 */,
/* 438 */,
/* 439 */,
/* 440 */,
/* 441 */,
/* 442 */,
/* 443 */,
/* 444 */,
/* 445 */,
/* 446 */,
/* 447 */,
/* 448 */,
/* 449 */
/***/ (function(module, exports) {

module.exports = "https://cdn-shared.mathletics.com/teacher-modules/school-roll/393/assets/fonts/4800a45cb26b5257be4a1d6b6a0eb5f9.eot";

/***/ }),
/* 450 */,
/* 451 */,
/* 452 */,
/* 453 */,
/* 454 */,
/* 455 */,
/* 456 */,
/* 457 */,
/* 458 */,
/* 459 */,
/* 460 */,
/* 461 */,
/* 462 */,
/* 463 */,
/* 464 */,
/* 465 */,
/* 466 */,
/* 467 */,
/* 468 */,
/* 469 */,
/* 470 */,
/* 471 */,
/* 472 */,
/* 473 */,
/* 474 */,
/* 475 */,
/* 476 */,
/* 477 */,
/* 478 */,
/* 479 */,
/* 480 */,
/* 481 */,
/* 482 */,
/* 483 */,
/* 484 */,
/* 485 */,
/* 486 */,
/* 487 */,
/* 488 */,
/* 489 */,
/* 490 */,
/* 491 */,
/* 492 */,
/* 493 */,
/* 494 */,
/* 495 */,
/* 496 */,
/* 497 */,
/* 498 */,
/* 499 */,
/* 500 */,
/* 501 */,
/* 502 */,
/* 503 */,
/* 504 */,
/* 505 */,
/* 506 */,
/* 507 */,
/* 508 */,
/* 509 */,
/* 510 */,
/* 511 */,
/* 512 */,
/* 513 */,
/* 514 */,
/* 515 */,
/* 516 */,
/* 517 */,
/* 518 */,
/* 519 */,
/* 520 */,
/* 521 */,
/* 522 */,
/* 523 */,
/* 524 */,
/* 525 */,
/* 526 */,
/* 527 */,
/* 528 */,
/* 529 */,
/* 530 */,
/* 531 */,
/* 532 */,
/* 533 */,
/* 534 */,
/* 535 */,
/* 536 */,
/* 537 */,
/* 538 */,
/* 539 */,
/* 540 */,
/* 541 */,
/* 542 */,
/* 543 */,
/* 544 */,
/* 545 */,
/* 546 */,
/* 547 */,
/* 548 */,
/* 549 */,
/* 550 */,
/* 551 */,
/* 552 */,
/* 553 */,
/* 554 */,
/* 555 */,
/* 556 */,
/* 557 */,
/* 558 */,
/* 559 */,
/* 560 */,
/* 561 */,
/* 562 */,
/* 563 */,
/* 564 */,
/* 565 */,
/* 566 */,
/* 567 */,
/* 568 */,
/* 569 */,
/* 570 */,
/* 571 */,
/* 572 */,
/* 573 */,
/* 574 */,
/* 575 */,
/* 576 */,
/* 577 */,
/* 578 */,
/* 579 */,
/* 580 */,
/* 581 */,
/* 582 */,
/* 583 */,
/* 584 */,
/* 585 */,
/* 586 */,
/* 587 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1110);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(5)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../node_modules/css-loader/index.js?modules&localIdentName=[local]---[hash:base64:5]!../../../node_modules/postcss-loader/lib/index.js!../../../node_modules/sass-loader/index.js!./index.scss", function() {
			var newContent = require("!!../../../node_modules/css-loader/index.js?modules&localIdentName=[local]---[hash:base64:5]!../../../node_modules/postcss-loader/lib/index.js!../../../node_modules/sass-loader/index.js!./index.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 588 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1128);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(5)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../node_modules/css-loader/index.js?modules&localIdentName=[local]---[hash:base64:5]!../../../node_modules/postcss-loader/lib/index.js!../../../node_modules/sass-loader/index.js!./index.scss", function() {
			var newContent = require("!!../../../node_modules/css-loader/index.js?modules&localIdentName=[local]---[hash:base64:5]!../../../node_modules/postcss-loader/lib/index.js!../../../node_modules/sass-loader/index.js!./index.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 589 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1145);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(5)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../node_modules/css-loader/index.js?modules&localIdentName=[local]---[hash:base64:5]!../../../node_modules/postcss-loader/lib/index.js!../../../node_modules/sass-loader/index.js!./index.scss", function() {
			var newContent = require("!!../../../node_modules/css-loader/index.js?modules&localIdentName=[local]---[hash:base64:5]!../../../node_modules/postcss-loader/lib/index.js!../../../node_modules/sass-loader/index.js!./index.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 590 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1147);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(5)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../node_modules/css-loader/index.js?modules&localIdentName=[local]---[hash:base64:5]!../../../node_modules/postcss-loader/lib/index.js!../../../node_modules/sass-loader/index.js!./index.scss", function() {
			var newContent = require("!!../../../node_modules/css-loader/index.js?modules&localIdentName=[local]---[hash:base64:5]!../../../node_modules/postcss-loader/lib/index.js!../../../node_modules/sass-loader/index.js!./index.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 591 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1148);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(5)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../node_modules/css-loader/index.js?modules&localIdentName=[local]---[hash:base64:5]!../../../node_modules/postcss-loader/lib/index.js!../../../node_modules/sass-loader/index.js!./index.scss", function() {
			var newContent = require("!!../../../node_modules/css-loader/index.js?modules&localIdentName=[local]---[hash:base64:5]!../../../node_modules/postcss-loader/lib/index.js!../../../node_modules/sass-loader/index.js!./index.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 592 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1151);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(5)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../node_modules/css-loader/index.js?modules&localIdentName=[local]---[hash:base64:5]!../../../node_modules/postcss-loader/lib/index.js!../../../node_modules/sass-loader/index.js!./index.scss", function() {
			var newContent = require("!!../../../node_modules/css-loader/index.js?modules&localIdentName=[local]---[hash:base64:5]!../../../node_modules/postcss-loader/lib/index.js!../../../node_modules/sass-loader/index.js!./index.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 593 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1167);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(5)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../node_modules/css-loader/index.js?modules&localIdentName=[local]---[hash:base64:5]!../../../node_modules/postcss-loader/lib/index.js!../../../node_modules/sass-loader/index.js!./index.scss", function() {
			var newContent = require("!!../../../node_modules/css-loader/index.js?modules&localIdentName=[local]---[hash:base64:5]!../../../node_modules/postcss-loader/lib/index.js!../../../node_modules/sass-loader/index.js!./index.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 594 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1169);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(5)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../node_modules/css-loader/index.js?modules&localIdentName=[local]---[hash:base64:5]!../../../node_modules/postcss-loader/lib/index.js!../../../node_modules/sass-loader/index.js!./index.scss", function() {
			var newContent = require("!!../../../node_modules/css-loader/index.js?modules&localIdentName=[local]---[hash:base64:5]!../../../node_modules/postcss-loader/lib/index.js!../../../node_modules/sass-loader/index.js!./index.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 595 */,
/* 596 */,
/* 597 */,
/* 598 */,
/* 599 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),
/* 600 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(Promise) {

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }(); /* global window document */
/* eslint-disable no-console */

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(182);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _reactRedux = __webpack_require__(28);

var _routingConserveParameters = __webpack_require__(881);

var _routingConserveParameters2 = _interopRequireDefault(_routingConserveParameters);

var _localStorage = __webpack_require__(269);

var _localStorage2 = _interopRequireDefault(_localStorage);

var _config = __webpack_require__(800);

var _config2 = _interopRequireDefault(_config);

var _errorHandling = __webpack_require__(877);

var _errorHandling2 = _interopRequireDefault(_errorHandling);

var _utils = __webpack_require__(13);

var _store = __webpack_require__(885);

var _store2 = _interopRequireDefault(_store);

var _i18n = __webpack_require__(129);

var _mainSaga = __webpack_require__(882);

var _mainSaga2 = _interopRequireDefault(_mainSaga);

var _portalComms = __webpack_require__(55);

var _portalComms2 = _interopRequireDefault(_portalComms);

var _productService = __webpack_require__(880);

var _productService2 = _interopRequireDefault(_productService);

var _rootContainer = __webpack_require__(753);

var _rootContainer2 = _interopRequireDefault(_rootContainer);

var _index = __webpack_require__(842);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

(0, _routingConserveParameters2.default)(['username', 'password', 'authToken', 'env', 'productId', 'lang', 'locale', 'regionId', 'countryCode']);
_localStorage2.default.namespace = 'school-roll';

var App = function () {
    function App(element, dynamicOptions) {
        var _this = this;

        _classCallCheck(this, App);

        // initial state based on selected product that has been passed in query string
        var initialState = _productService2.default.Configure();
        // Initial config
        this.store = (0, _store2.default)(initialState);
        this.store.runSaga(_mainSaga2.default);
        _config2.default.configure();
        // Add an interceptor to handle errors when accessing resources
        _errorHandling2.default.addResourceResponseErrorInterceptor();
        _portalComms2.default.Configure();

        this.element = element;
        this.options = (0, _utils.handleDefaults)({}, dynamicOptions);

        // Chunked polyfill for browsers without Intl support
        if (!window.Intl) {
            new Promise(function (resolve) {
                resolve(__webpack_require__.e/* import() */(0).then(__webpack_require__.bind(null, 1802)));
            }).then(function () {
                return Promise.all([__webpack_require__.e/* import() */(2).then(__webpack_require__.bind(null, 1803)), __webpack_require__.e/* import() */(1).then(__webpack_require__.bind(null, 1804))]);
            }).then(function () {
                return _this.renderElement(_i18n.translationMessages, _i18n.DEFAULT_LOCALE);
            }).catch(function (err) {
                throw err;
            });
        } else {
            this.renderElement(_i18n.translationMessages, _i18n.DEFAULT_LOCALE);
        }
    }

    _createClass(App, [{
        key: 'renderElement',
        value: function renderElement(messages, locale) {
            var config = (0, _utils.getAppConfig)();
            var baseName = config ? config.BaseName : ''; // definitely resolved
            var currentLocale = (0, _i18n.getLocale)() || locale;

            _reactDom2.default.render(_react2.default.createElement(
                _reactRedux.Provider,
                { store: this.store },
                _react2.default.createElement(
                    _index.LanguageProvider,
                    { locale: currentLocale, messages: messages },
                    _react2.default.createElement(_rootContainer2.default, { basename: baseName })
                )
            ), document.querySelector(this.element));
        }
    }]);

    return App;
}();

exports.default = App;


window.App = App;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(64)))

/***/ }),
/* 601 */,
/* 602 */,
/* 603 */,
/* 604 */,
/* 605 */,
/* 606 */,
/* 607 */,
/* 608 */,
/* 609 */,
/* 610 */,
/* 611 */,
/* 612 */,
/* 613 */,
/* 614 */,
/* 615 */,
/* 616 */,
/* 617 */,
/* 618 */,
/* 619 */,
/* 620 */,
/* 621 */,
/* 622 */,
/* 623 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactStyleable = __webpack_require__(6);

var _reactStyleable2 = _interopRequireDefault(_reactStyleable);

var _reactIntl = __webpack_require__(2);

var _button = __webpack_require__(7);

var _button2 = _interopRequireDefault(_button);

var _index = __webpack_require__(364);

var _index2 = _interopRequireDefault(_index);

var _index3 = __webpack_require__(48);

var _index4 = _interopRequireDefault(_index3);

var _radiobutton = __webpack_require__(255);

var _radiobutton2 = _interopRequireDefault(_radiobutton);

var _index5 = __webpack_require__(37);

var _index6 = _interopRequireDefault(_index5);

var _dropdownList = __webpack_require__(1661);

var _dropdownList2 = _interopRequireDefault(_dropdownList);

var _messages = __webpack_require__(377);

var _messages2 = _interopRequireDefault(_messages);

var _productEnum = __webpack_require__(77);

var _productEnum2 = _interopRequireDefault(_productEnum);

var _utils = __webpack_require__(13);

var _constants = __webpack_require__(40);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var AddClassForm = function (_Component) {
    _inherits(AddClassForm, _Component);

    function AddClassForm(props) {
        _classCallCheck(this, AddClassForm);

        var _this = _possibleConstructorReturn(this, (AddClassForm.__proto__ || Object.getPrototypeOf(AddClassForm)).call(this, props));

        _this.validateModal = function () {
            var _this$props = _this.props,
                isSaveInProgress = _this$props.isSaveInProgress,
                selectedProduct = _this$props.selectedProduct,
                upfCourses = _this$props.upfCourses,
                newCourses = _this$props.newCourses,
                displayNewCourses = _this$props.displayNewCourses;
            var _this$state = _this.state,
                classroom = _this$state.classroom,
                selectedLegacyCourse = _this$state.selectedLegacyCourse,
                selectedUPFCourse = _this$state.selectedUPFCourse,
                selectedNewCourse = _this$state.selectedNewCourse;
            var yearGroup = classroom.yearGroup,
                countryId = classroom.countryId;

            var classname = classroom.name.trim();
            var isValidClassroom = classname !== '' && classroom.yearGroup !== _constants.DEFAULT_YEAR_GROUP && classroom.countryId !== _constants.DEFAULT_COUNTRY_ID && classroom.teacherId !== _constants.DEFAULT_TEACHER_ID;

            if (selectedProduct.id === _productEnum2.default.MATLETICA.id) {
                isValidClassroom = classname !== '' && classroom.yearGroup !== _constants.DEFAULT_YEAR_GROUP;
            }

            var isNewCoursesAvailable = (0, _utils.newCoursesAvailable)(yearGroup, countryId) && displayNewCourses;
            var hasUPFCourses = upfCourses && upfCourses.length > 0;
            var hasNewCourses = newCourses && newCourses.length > 0;

            var isValidLegacy = selectedLegacyCourse !== _constants.DEFAULT_LEGACY_COURSE_ID;
            var isValidUPF = !hasUPFCourses || selectedUPFCourse !== _constants.DEFAULT_LEGACY_COURSE_ID;
            var isValidNew = !isNewCoursesAvailable || !hasNewCourses || selectedNewCourse !== _constants.DEFAULT_NEW_COURSE_ID;
            var enableAddButton = isValidClassroom && !isSaveInProgress && isValidLegacy && isValidUPF && isValidNew;

            _this.setState({ enableAddButton: enableAddButton });
        };

        _this.handleOnSchoolCoursesSelection = function () {
            _this.setState({
                isSchoolCoursesSelected: true,
                isCurriculumCoursesSelected: false,
                selectedLegacyCourse: _constants.DEFAULT_LEGACY_COURSE_ID
            }, function () {
                _this.validateModal();
            });
            _this.props.clearProductCourses();
            _this.props.getSchoolCourses(_this.state.classroom.yearGroup);
        };

        _this.handleOnCurriculumCoursesSelection = function () {
            _this.setState({
                isSchoolCoursesSelected: false,
                isCurriculumCoursesSelected: true,
                selectedLegacyCourse: _constants.DEFAULT_LEGACY_COURSE_ID
            }, function () {
                _this.validateModal();
            });

            _this.props.clearProductCourses();
            _this.getProductCourses();
        };

        _this.getProductCourses = function () {
            var _this$state$classroom = _this.state.classroom,
                countryId = _this$state$classroom.countryId,
                yearGroup = _this$state$classroom.yearGroup;


            if (yearGroup !== _constants.DEFAULT_YEAR_GROUP && countryId !== _constants.DEFAULT_COUNTRY_ID) {
                _this.props.getProductCourses(countryId, _this.props.selectedProduct.id, yearGroup);
            }
        };

        _this.handleTextInputOnChange = function (event) {
            var classroom = _this.state.classroom;


            _this.setState({ classroom: _extends({}, classroom, _defineProperty({}, event.target.name, event.target.value)) }, function () {
                _this.validateModal();
            });
            return true;
        };

        _this.handleListOnChange = function (field, value) {
            var selectedProduct = _this.props.selectedProduct;
            var classroom = _this.state.classroom;


            if (field === 'yearGroup' || field === 'countryId' || field === 'teacherId') {
                _this.setState({
                    classroom: _extends({}, classroom, _defineProperty({
                        courseId: '-1',
                        upfCourseId: '-1'
                    }, field, value)),
                    selectedUPFCourse: _constants.DEFAULT_LEGACY_COURSE_ID,
                    selectedNewCourse: _constants.DEFAULT_NEW_COURSE_ID,
                    selectedLegacyCourse: _constants.DEFAULT_LEGACY_COURSE_ID
                }, function () {
                    var _this$state$classroom2 = _this.state.classroom,
                        yearGroup = _this$state$classroom2.yearGroup,
                        countryId = _this$state$classroom2.countryId;


                    if (yearGroup !== _constants.DEFAULT_YEAR_GROUP && countryId !== _constants.DEFAULT_COUNTRY_ID) {
                        _this.props.getFilteredUPFCourses(countryId, selectedProduct.id, yearGroup);
                        _this.props.getFilteredNewCourses({ productId: selectedProduct.id, countryCode: countryId, yearGroup: yearGroup });
                    } else {
                        _this.props.clearUPFCourses();
                    }

                    if (_this.state.isSchoolCoursesSelected) {
                        _this.handleOnSchoolCoursesSelection();
                    } else if (_this.state.isCurriculumCoursesSelected) {
                        _this.handleOnCurriculumCoursesSelection();
                    } else if (selectedProduct.id !== _productEnum2.default.MATHLETICS.id) {
                        _this.getProductCourses();
                    }

                    _this.validateModal();
                });
            }
        };

        _this.handleOnSubmit = function () {
            var _this$props2 = _this.props,
                addClass = _this$props2.addClass,
                selectedProduct = _this$props2.selectedProduct;
            var _this$state2 = _this.state,
                classroom = _this$state2.classroom,
                selectedUPFCourse = _this$state2.selectedUPFCourse,
                selectedLegacyCourse = _this$state2.selectedLegacyCourse,
                selectedNewCourse = _this$state2.selectedNewCourse;
            var name = classroom.name,
                yearGroup = classroom.yearGroup,
                teacherId = classroom.teacherId;

            _this.setState({ enableAddButton: false });
            var teacherProfileIds = [];

            if (teacherId !== _constants.DEFAULT_TEACHER_ID) {
                teacherProfileIds.push(teacherId);
            }

            var addClassRequest = {
                productId: selectedProduct.id,
                name: String(name).trim(),
                yearGroupEnum: yearGroup,
                teacherProfileIds: teacherProfileIds,
                courseId: selectedLegacyCourse,
                upfCourseId: selectedUPFCourse,
                conquestCourseId: selectedNewCourse,
                useUpfSchoolDefault: selectedUPFCourse === _constants.DEFAULT_UPF_COURSE_ID
            };

            addClass(addClassRequest);
        };

        _this.handleOnLegacyChange = function (courseId) {
            _this.setState({
                selectedLegacyCourse: courseId
            }, function () {
                _this.validateModal();
            });
        };

        _this.handleOnUPFChange = function (upfCourseId) {
            _this.setState({
                selectedUPFCourse: upfCourseId
            }, function () {
                _this.validateModal();
            });
        };

        _this.handleOnNewCourseChange = function (courseId) {
            var selectedNewCourse = courseId === '-1' ? _constants.DEFAULT_NEW_COURSE_ID : courseId;
            _this.setState({ selectedNewCourse: selectedNewCourse }, function () {
                _this.validateModal();
            });
        };

        _this.state = {
            enableAddButton: false,
            classroom: props.classroom,
            isSchoolCoursesSelected: false,
            isCurriculumCoursesSelected: false,
            selectedUPFCourse: _constants.DEFAULT_LEGACY_COURSE_ID,
            selectedNewCourse: _constants.DEFAULT_NEW_COURSE_ID,
            selectedLegacyCourse: _constants.DEFAULT_LEGACY_COURSE_ID
        };
        _this.handleTextInputOnChange = _this.handleTextInputOnChange.bind(_this);
        return _this;
    }

    _createClass(AddClassForm, [{
        key: 'renderUPFCourses',
        value: function renderUPFCourses() {
            var _this2 = this;

            var _props = this.props,
                css = _props.css,
                intl = _props.intl,
                selectedProduct = _props.selectedProduct,
                _props$upfCourses = _props.upfCourses,
                upfCourses = _props$upfCourses === undefined ? [] : _props$upfCourses;
            var classroom = this.state.classroom;

            var upfSelector = null;

            if (selectedProduct.id === _productEnum2.default.MATHLETICS.id) {
                upfSelector = _react2.default.createElement(
                    'div',
                    { className: css.courseWrapper },
                    _react2.default.createElement(
                        'label',
                        {
                            className: css.label,
                            htmlFor: 'upfCourse' },
                        intl.formatMessage(_messages2.default.skillQuests),
                        '*'
                    ),
                    _react2.default.createElement(_index6.default, {
                        css: _dropdownList2.default,
                        disabled: classroom.yearGroup === _constants.DEFAULT_YEAR_GROUP || classroom.countryId === _constants.DEFAULT_COUNTRY_ID,
                        isLoading: this.props.isUPFCoursesFetching,
                        loadingPlaceholder: intl.formatMessage(_messages2.default.loadingCourses),
                        name: 'upfCourse',
                        onChange: function onChange(name, courseId) {
                            return _this2.handleOnUPFChange(courseId);
                        },
                        optionKey: 'id',
                        optionLength: _constants.DROPDOWN_OPTION_LENGTH,
                        options: (0, _utils.showDefaultCourseAtTop)(upfCourses, intl.formatMessage(_messages2.default.useAdminSelection)),
                        optionText: 'name',
                        placeholder: upfCourses.length ? intl.formatMessage(_messages2.default.selectDefaultCourse) : intl.formatMessage(_messages2.default.noCoursesFound)
                    })
                );
            }
            return upfSelector;
        }
    }, {
        key: 'renderNewCourses',
        value: function renderNewCourses() {
            var _this3 = this;

            var _props2 = this.props,
                css = _props2.css,
                intl = _props2.intl,
                displayNewCourses = _props2.displayNewCourses;
            var newCourses = this.props.newCourses;
            var _state$classroom = this.state.classroom,
                yearGroup = _state$classroom.yearGroup,
                countryId = _state$classroom.countryId;


            if (!displayNewCourses) return null;

            if (!(0, _utils.newCoursesAvailable)(yearGroup, countryId)) newCourses = [];

            return _react2.default.createElement(
                'div',
                { className: css.courseWrapper },
                _react2.default.createElement(
                    'label',
                    {
                        className: css.label,
                        htmlFor: 'newCourses' },
                    intl.formatMessage(_messages2.default.newCourses),
                    '*'
                ),
                _react2.default.createElement(_index6.default, {
                    css: _dropdownList2.default,
                    disabled: yearGroup === _constants.DEFAULT_YEAR_GROUP || countryId === _constants.DEFAULT_COUNTRY_ID,
                    isLoading: this.props.isNewCoursesFetching,
                    loadingPlaceholder: intl.formatMessage(_messages2.default.loadingCourses),
                    name: 'newCourses',
                    onChange: function onChange(_, courseId) {
                        return _this3.handleOnNewCourseChange(courseId);
                    },
                    optionKey: 'id',
                    optionLength: _constants.DROPDOWN_OPTION_LENGTH,
                    options: (0, _utils.moveFlaggedToFront)(newCourses, 'isDefault'),
                    optionText: 'name',
                    placeholder: newCourses.length ? intl.formatMessage(_messages2.default.selectDefaultCourse) : intl.formatMessage(_messages2.default.noCoursesFound)
                })
            );
        }
    }, {
        key: 'render',
        value: function render() {
            var _this4 = this;

            var _props3 = this.props,
                css = _props3.css,
                intl = _props3.intl,
                isSaveInProgress = _props3.isSaveInProgress,
                productCountries = _props3.productCountries,
                productTeachers = _props3.productTeachers,
                selectedProduct = _props3.selectedProduct,
                yearGroups = _props3.yearGroups,
                onAddClassCloseModal = _props3.onAddClassCloseModal,
                productCourses = _props3.productCourses,
                isProductCoursesFetching = _props3.isProductCoursesFetching,
                isSchoolCoursesFetching = _props3.isSchoolCoursesFetching,
                upfCountries = _props3.upfCountries;
            var _state = this.state,
                classroom = _state.classroom,
                isCurriculumCoursesSelected = _state.isCurriculumCoursesSelected,
                isSchoolCoursesSelected = _state.isSchoolCoursesSelected;


            var isTeacherDropdownDisabled = productCountries && productTeachers.length === 0;

            var countries = [].concat(_toConsumableArray(productCountries), _toConsumableArray(upfCountries.filter(function (obj) {
                return !productCountries.some(function (item) {
                    return item.key === obj.key;
                });
            })));

            countries = countries.sort(function (a, b) {
                return a.value.localeCompare(b.value);
            });

            var isMathleticsProduct = selectedProduct.id === _productEnum2.default.MATHLETICS.id;

            var formContent = _react2.default.createElement(
                'div',
                { className: css.addClassComponent },
                _react2.default.createElement(
                    'form',
                    { className: css.addClassForm },
                    _react2.default.createElement(
                        'div',
                        { className: css.addClassHeader },
                        ' ',
                        intl.formatMessage(_messages2.default.addClass, { productName: selectedProduct.name }),
                        ' '
                    ),
                    _react2.default.createElement(
                        'div',
                        { className: css.className },
                        _react2.default.createElement(
                            'label',
                            {
                                className: css.label,
                                htmlFor: 'name' },
                            intl.formatMessage(_messages2.default.className),
                            '*'
                        ),
                        _react2.default.createElement(_index4.default, {
                            disabled: isSaveInProgress,
                            handleOnChange: this.handleTextInputOnChange,
                            maxLength: _constants.MAX_CLASSNAME_LENGTH,
                            name: 'name',
                            placeholder: intl.formatMessage(isMathleticsProduct ? _messages2.default.mathsClass : _messages2.default.className),
                            value: classroom.name
                        })
                    ),
                    _react2.default.createElement(
                        'div',
                        { className: css.list },
                        _react2.default.createElement(
                            'label',
                            {
                                className: css.label,
                                htmlFor: 'teacherName' },
                            intl.formatMessage(_messages2.default.teacher),
                            '*'
                        ),
                        _react2.default.createElement(_index6.default, {
                            css: _dropdownList2.default,
                            disabled: isTeacherDropdownDisabled,
                            name: 'teacherId',
                            onChange: this.handleListOnChange,
                            optionLength: _constants.DROPDOWN_OPTION_LENGTH,
                            options: productTeachers,
                            placeholder: intl.formatMessage(_messages2.default.select),
                            value: classroom.teacherId
                        })
                    ),
                    _react2.default.createElement(
                        'div',
                        { className: css.yearRow },
                        _react2.default.createElement(
                            'div',
                            { className: css.year },
                            _react2.default.createElement(
                                'label',
                                {
                                    className: css.label,
                                    htmlFor: 'yearGroup' },
                                intl.formatMessage(_messages2.default.grade),
                                '*'
                            ),
                            _react2.default.createElement(_index6.default, {
                                css: _dropdownList2.default,
                                name: 'yearGroup',
                                onChange: this.handleListOnChange,
                                optionKey: 'yearGroupEnum',
                                options: yearGroups,
                                optionText: 'shortName',
                                placeholder: intl.formatMessage(_messages2.default.select),
                                value: classroom.yearGroup
                            })
                        ),
                        _react2.default.createElement(
                            'div',
                            { className: css.country },
                            _react2.default.createElement(
                                'label',
                                {
                                    className: css.label,
                                    htmlFor: 'countryId' },
                                intl.formatMessage(_messages2.default.country),
                                '*'
                            ),
                            _react2.default.createElement(_index6.default, {
                                css: _dropdownList2.default,
                                name: 'countryId',
                                onChange: this.handleListOnChange,
                                optionLength: _constants.DROPDOWN_OPTION_LENGTH,
                                options: countries,
                                placeholder: intl.formatMessage(_messages2.default.select),
                                value: classroom.country
                            })
                        )
                    ),
                    _react2.default.createElement(
                        'div',
                        { className: css.courseWrapper },
                        _react2.default.createElement(
                            'label',
                            {
                                className: css.label,
                                htmlFor: 'teacherName' },
                            intl.formatMessage(isMathleticsProduct ? _messages2.default.courses : _messages2.default.coursesNonMaths),
                            '*'
                        ),
                        isMathleticsProduct && _react2.default.createElement(
                            'fieldset',
                            { className: css.courseSelectorWrapper, id: 'courseSelector' },
                            _react2.default.createElement(
                                'div',
                                { className: css.customCoursesWrapper },
                                _react2.default.createElement(_radiobutton2.default, {
                                    id: 'customCourses',
                                    name: 'courseSelector',
                                    onChange: this.handleOnSchoolCoursesSelection,
                                    value: intl.formatMessage(_messages2.default.customCourses) }),
                                _react2.default.createElement(
                                    'label',
                                    { htmlFor: 'customCourses' },
                                    intl.formatMessage(_messages2.default.customCourses)
                                )
                            ),
                            _react2.default.createElement(
                                'div',
                                { className: css.curriculumCoursesWrapper },
                                _react2.default.createElement(_radiobutton2.default, {
                                    id: 'curriculumCourses',
                                    name: 'courseSelector',
                                    onChange: this.handleOnCurriculumCoursesSelection,
                                    value: intl.formatMessage(_messages2.default.customCourses) }),
                                _react2.default.createElement(
                                    'label',
                                    { htmlFor: 'curriculumCourses' },
                                    intl.formatMessage(_messages2.default.curriculumCourses)
                                )
                            )
                        ),
                        _react2.default.createElement(_index6.default, {
                            css: _dropdownList2.default,
                            disabled: !isCurriculumCoursesSelected && !isSchoolCoursesSelected && isMathleticsProduct || classroom.yearGroup === _constants.DEFAULT_YEAR_GROUP || classroom.countryId === _constants.DEFAULT_COUNTRY_ID,
                            isLoading: isProductCoursesFetching || isSchoolCoursesFetching,
                            loadingPlaceholder: intl.formatMessage(_messages2.default.loadingCourses),
                            name: 'productCourses',
                            onChange: function onChange(name, courseId) {
                                return _this4.handleOnLegacyChange(courseId);
                            },
                            optionLength: _constants.DROPDOWN_OPTION_LENGTH,
                            options: productCourses,
                            placeholder: productCourses.length ? intl.formatMessage(_messages2.default.selectDefaultCourse) : intl.formatMessage(_messages2.default.noCoursesFound)
                        })
                    ),
                    this.renderNewCourses(),
                    this.renderUPFCourses(),
                    _react2.default.createElement(
                        'div',
                        { className: css.required },
                        '*',
                        intl.formatMessage(_messages2.default.required)
                    ),
                    _react2.default.createElement(
                        'div',
                        { className: css.actionButtonWrapper },
                        _react2.default.createElement(_button2.default, {
                            containerClassName: css.cancelButton,
                            disabled: isSaveInProgress,
                            handleOnClick: onAddClassCloseModal,
                            label: intl.formatMessage(_messages2.default.cancel) }),
                        _react2.default.createElement(_button2.default, {
                            containerClassName: this.state.enableAddButton ? css.addButton : css.addButtonDisabled,
                            disabled: !this.state.enableAddButton,
                            handleOnClick: this.handleOnSubmit,
                            label: intl.formatMessage(_messages2.default.add) })
                    )
                )
            );

            return formContent;
        }
    }]);

    return AddClassForm;
}(_react.Component);

AddClassForm.propTypes = {
    addClass: _propTypes2.default.func,
    classroom: _propTypes2.default.object,
    css: _propTypes2.default.object,
    intl: _reactIntl.intlShape.isRequired,
    isSaveInProgress: _propTypes2.default.bool,
    productCountries: _propTypes2.default.arrayOf(_propTypes2.default.object),
    upfCountries: _propTypes2.default.arrayOf(_propTypes2.default.object),
    productTeachers: _propTypes2.default.arrayOf(_propTypes2.default.object),
    selectedProduct: _propTypes2.default.object,
    yearGroups: _propTypes2.default.arrayOf(_propTypes2.default.object),
    onAddClassCloseModal: _propTypes2.default.func,
    getFilteredUPFCourses: _propTypes2.default.func,
    getFilteredNewCourses: _propTypes2.default.func,
    upfCourses: _propTypes2.default.array,
    newCourses: _propTypes2.default.array,
    getSchoolCourses: _propTypes2.default.func.isRequired,
    productCourses: _propTypes2.default.array,
    getProductCourses: _propTypes2.default.func,
    clearProductCourses: _propTypes2.default.func,
    clearUPFCourses: _propTypes2.default.func,
    isProductCoursesFetching: _propTypes2.default.bool,
    isSchoolCoursesFetching: _propTypes2.default.bool,
    isUPFCoursesFetching: _propTypes2.default.bool,
    isNewCoursesFetching: _propTypes2.default.bool,
    displayNewCourses: _propTypes2.default.bool
};

AddClassForm.defaultProps = {
    productCourses: []
};

exports.default = (0, _reactIntl.injectIntl)((0, _reactStyleable2.default)(_index2.default)(AddClassForm));

/***/ }),
/* 624 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactStyleable = __webpack_require__(6);

var _reactStyleable2 = _interopRequireDefault(_reactStyleable);

var _reactIntl = __webpack_require__(2);

var _iconDictionary = __webpack_require__(8);

var _index = __webpack_require__(364);

var _index2 = _interopRequireDefault(_index);

var _index3 = __webpack_require__(7);

var _index4 = _interopRequireDefault(_index3);

var _variants = __webpack_require__(9);

var _svgIcon = __webpack_require__(21);

var _svgIcon2 = _interopRequireDefault(_svgIcon);

var _messages = __webpack_require__(377);

var _messages2 = _interopRequireDefault(_messages);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var AddClassConfirmation = function (_Component) {
    _inherits(AddClassConfirmation, _Component);

    function AddClassConfirmation(props) {
        _classCallCheck(this, AddClassConfirmation);

        var _this = _possibleConstructorReturn(this, (AddClassConfirmation.__proto__ || Object.getPrototypeOf(AddClassConfirmation)).call(this, props));

        _this.handleOnClose = function () {
            var onAddClassCloseModal = _this.props.onAddClassCloseModal;

            onAddClassCloseModal();
        };

        _this.handleOnClose = _this.handleOnClose.bind(_this);
        return _this;
    }

    _createClass(AddClassConfirmation, [{
        key: 'render',
        value: function render() {
            var _props = this.props,
                classroom = _props.classroom,
                intl = _props.intl;

            return _react2.default.createElement(
                'div',
                null,
                _react2.default.createElement(
                    'div',
                    { className: _index2.default.addClassComponent },
                    _react2.default.createElement(
                        'div',
                        { className: _index2.default.icon },
                        _react2.default.createElement(_svgIcon2.default, { icon: _iconDictionary.Tick })
                    ),
                    _react2.default.createElement(
                        'div',
                        { className: _index2.default.header },
                        _react2.default.createElement(
                            'span',
                            null,
                            classroom.name
                        ),
                        ' ',
                        intl.formatMessage(_messages2.default.addClassConfirmation)
                    ),
                    _react2.default.createElement(_index4.default, {
                        handleOnClick: this.handleOnClose,
                        icon: _iconDictionary.Tick,
                        label: intl.formatMessage(_messages2.default.done),
                        variant: _variants.BOX_LIGHT })
                )
            );
        }
    }]);

    return AddClassConfirmation;
}(_react.Component);

AddClassConfirmation.propTypes = {
    classroom: _propTypes2.default.object,
    intl: _reactIntl.intlShape.isRequired,
    onAddClassCloseModal: _propTypes2.default.func
};

exports.default = (0, _reactIntl.injectIntl)((0, _reactStyleable2.default)(_index2.default)(AddClassConfirmation));

/***/ }),
/* 625 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactStyleable = __webpack_require__(6);

var _reactStyleable2 = _interopRequireDefault(_reactStyleable);

var _index = __webpack_require__(364);

var _index2 = _interopRequireDefault(_index);

var _addClassForm = __webpack_require__(623);

var _addClassForm2 = _interopRequireDefault(_addClassForm);

var _confirmation = __webpack_require__(624);

var _confirmation2 = _interopRequireDefault(_confirmation);

var _withModal = __webpack_require__(49);

var _withModal2 = _interopRequireDefault(_withModal);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var AddClass = function AddClass(props) {
    var showAddClassConfirmationModal = props.showAddClassConfirmationModal;

    var content = _react2.default.createElement(_addClassForm2.default, props);

    content = showAddClassConfirmationModal ? _react2.default.createElement(_confirmation2.default, props) : content;

    return content;
};

AddClass.propTypes = {
    showAddClassConfirmationModal: _propTypes2.default.bool
};

var StyledAddClass = (0, _reactStyleable2.default)(_index2.default)(AddClass);

exports.default = (0, _withModal2.default)('isActive')(StyledAddClass);

/***/ }),
/* 626 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactStyleable = __webpack_require__(6);

var _reactStyleable2 = _interopRequireDefault(_reactStyleable);

var _reactIntl = __webpack_require__(2);

var _iconDictionary = __webpack_require__(8);

var _index = __webpack_require__(246);

var _index2 = _interopRequireDefault(_index);

var _index3 = __webpack_require__(7);

var _index4 = _interopRequireDefault(_index3);

var _variants = __webpack_require__(9);

var _svgIcon = __webpack_require__(21);

var _svgIcon2 = _interopRequireDefault(_svgIcon);

var _messages = __webpack_require__(247);

var _messages2 = _interopRequireDefault(_messages);

var _productEnum = __webpack_require__(77);

var _productEnum2 = _interopRequireDefault(_productEnum);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var AddGroupConfirmation = function (_Component) {
    _inherits(AddGroupConfirmation, _Component);

    function AddGroupConfirmation(props) {
        _classCallCheck(this, AddGroupConfirmation);

        var _this = _possibleConstructorReturn(this, (AddGroupConfirmation.__proto__ || Object.getPrototypeOf(AddGroupConfirmation)).call(this, props));

        _this.handleOnChangeCourse = function () {
            var _this$props = _this.props,
                addGroupAddedGroup = _this$props.addGroupAddedGroup,
                openChangeCourse = _this$props.openChangeCourse;

            openChangeCourse(addGroupAddedGroup.classroomId, addGroupAddedGroup.id);
            _this.handleOnClose();
        };

        _this.handleOnManageStudent = function () {
            var _this$props2 = _this.props,
                handleOnManageStudents = _this$props2.handleOnManageStudents,
                classroomDetail = _this$props2.classroomDetail,
                addGroupAddedGroup = _this$props2.addGroupAddedGroup;

            _this.handleOnClose();
            handleOnManageStudents(classroomDetail.classroomId, classroomDetail.name, addGroupAddedGroup.id);
        };

        _this.handleOnClose = function () {
            var closeAddGroup = _this.props.closeAddGroup;

            closeAddGroup();
        };

        _this.handleOnClose = _this.handleOnClose.bind(_this);
        _this.handleOnManageStudent = _this.handleOnManageStudent.bind(_this);
        _this.handleOnChangeCourse = _this.handleOnChangeCourse.bind(_this);
        return _this;
    }

    _createClass(AddGroupConfirmation, [{
        key: 'render',
        value: function render() {
            var _props = this.props,
                classroomDetail = _props.classroomDetail,
                addGroupAddedGroup = _props.addGroupAddedGroup,
                intl = _props.intl,
                selectedProduct = _props.selectedProduct;
            var classroomGroups = classroomDetail.classroomGroups;

            var addedGroup = classroomGroups.find(function (x) {
                return x.id === addGroupAddedGroup.id;
            });

            var courseName = !addedGroup ? '' : addedGroup.courseTitle;
            var upfCourseName = !addedGroup ? '' : addedGroup.upfCourseTitle;

            var isMatletica = selectedProduct.id === _productEnum2.default.MATLETICA.id;
            var isMathletics = selectedProduct.id === _productEnum2.default.MATHLETICS.id;

            return _react2.default.createElement(
                'div',
                null,
                _react2.default.createElement(
                    'div',
                    { className: _index2.default.addGroupComponent },
                    _react2.default.createElement(
                        'div',
                        { className: _index2.default.icon },
                        _react2.default.createElement(_svgIcon2.default, { icon: _iconDictionary.Tick })
                    ),
                    _react2.default.createElement(
                        'div',
                        { className: _index2.default.header },
                        _react2.default.createElement(
                            'span',
                            null,
                            addGroupAddedGroup.name
                        ),
                        ' ',
                        intl.formatMessage(_messages2.default.createdAssigned),
                        ' ',
                        _react2.default.createElement(
                            'span',
                            null,
                            courseName
                        ),
                        isMathletics && ' & ',
                        isMathletics && _react2.default.createElement(
                            'span',
                            null,
                            upfCourseName
                        )
                    ),
                    _react2.default.createElement(_index4.default, {
                        handleOnClick: this.handleOnManageStudent,
                        icon: _iconDictionary.Edit,
                        label: intl.formatMessage(_messages2.default.manageStudent),
                        variant: _variants.BOX_LIGHT }),
                    _react2.default.createElement(_index4.default, {
                        handleOnClick: this.handleOnChangeCourse,
                        hidden: isMatletica,
                        icon: _iconDictionary.Edit,
                        label: intl.formatMessage(_messages2.default.changeCourse),
                        variant: _variants.BOX_LIGHT }),
                    _react2.default.createElement(_index4.default, {
                        handleOnClick: this.handleOnClose,
                        icon: _iconDictionary.Tick,
                        label: intl.formatMessage(_messages2.default.done),
                        variant: _variants.BOX_LIGHT })
                )
            );
        }
    }]);

    return AddGroupConfirmation;
}(_react.Component);

AddGroupConfirmation.propTypes = {
    addGroupAddedGroup: _propTypes2.default.object,
    classroomDetail: _propTypes2.default.object,
    closeAddGroup: _propTypes2.default.func,
    intl: _reactIntl.intlShape.isRequired,
    openChangeCourse: _propTypes2.default.func,
    handleOnManageStudents: _propTypes2.default.func,
    selectedProduct: _propTypes2.default.object
};

exports.default = (0, _reactIntl.injectIntl)((0, _reactStyleable2.default)(_index2.default)(AddGroupConfirmation));

/***/ }),
/* 627 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactStyleable = __webpack_require__(6);

var _reactStyleable2 = _interopRequireDefault(_reactStyleable);

var _reactIntl = __webpack_require__(2);

var _index = __webpack_require__(246);

var _index2 = _interopRequireDefault(_index);

var _index3 = __webpack_require__(48);

var _index4 = _interopRequireDefault(_index3);

var _index5 = __webpack_require__(7);

var _index6 = _interopRequireDefault(_index5);

var _variants = __webpack_require__(9);

var _iconDictionary = __webpack_require__(8);

var _withForm = __webpack_require__(392);

var _withForm2 = _interopRequireDefault(_withForm);

var _messages = __webpack_require__(247);

var _messages2 = _interopRequireDefault(_messages);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var validate = function validate(fields) {
    return fields.groupname !== '';
};

var AddGroupForm = function (_Component) {
    _inherits(AddGroupForm, _Component);

    function AddGroupForm(props) {
        _classCallCheck(this, AddGroupForm);

        var _this = _possibleConstructorReturn(this, (AddGroupForm.__proto__ || Object.getPrototypeOf(AddGroupForm)).call(this, props));

        _this.handleOnSubmit = function () {
            var _this$props = _this.props,
                addGroup = _this$props.addGroup,
                classroomDetail = _this$props.classroomDetail,
                fields = _this$props.fields;

            addGroup(classroomDetail.classroomId, fields.groupname);
        };

        _this.handleOnClose = function () {
            var closeAddGroup = _this.props.closeAddGroup;

            closeAddGroup();
        };

        _this.handleOnClose = _this.handleOnClose.bind(_this);
        _this.handleOnSubmit = _this.handleOnSubmit.bind(_this);
        return _this;
    }

    _createClass(AddGroupForm, [{
        key: 'render',
        value: function render() {
            var _this2 = this;

            var _props = this.props,
                addGroupInProgress = _props.addGroupInProgress,
                form = _props.form,
                intl = _props.intl,
                modal = _props.modal,
                canSubmit = _props.canSubmit;

            var formTitle = intl.formatMessage(_messages2.default.title);
            var inputPlaceholder = intl.formatMessage(_messages2.default.inputPlaceholder);
            return _react2.default.createElement(
                'div',
                { className: _index2.default.addGroupComponent },
                _react2.default.createElement(
                    'h1',
                    { className: _index2.default.header },
                    formTitle
                ),
                _react2.default.createElement(_index4.default, {
                    handleOnChange: form.handleTextInputOnChange,
                    name: 'groupname',
                    placeholder: inputPlaceholder }),
                _react2.default.createElement(
                    'div',
                    { className: _index2.default.buttons },
                    _react2.default.createElement(_index6.default, {
                        containerClassName: _index2.default.cancelBtn,
                        disabled: addGroupInProgress,
                        handleOnClick: function handleOnClick() {
                            modal.close(_this2.handleOnClose);
                        },
                        icon: _iconDictionary.Cross,
                        variant: _variants.CIRCLE_DANGER }),
                    _react2.default.createElement(_index6.default, {
                        containerClassName: _index2.default.submitBtn,
                        disabled: !canSubmit || addGroupInProgress,
                        handleOnClick: function handleOnClick() {
                            form.submit(_this2.handleOnSubmit);
                        },
                        icon: _iconDictionary.Tick,
                        variant: _variants.CIRCLE_SUCCESS })
                ),
                _react2.default.createElement(_index6.default, {
                    containerClassName: _index2.default.buttonClose,
                    disabled: addGroupInProgress,
                    handleOnClick: function handleOnClick() {
                        modal.close(_this2.handleOnClose);
                    },
                    icon: _iconDictionary.Cross,
                    variant: _variants.ICON_ONLY })
            );
        }
    }]);

    return AddGroupForm;
}(_react.Component);

AddGroupForm.propTypes = {
    addGroup: _propTypes2.default.func,
    addGroupInProgress: _propTypes2.default.bool,
    classroomDetail: _propTypes2.default.object,
    closeAddGroup: _propTypes2.default.func,
    canSubmit: _propTypes2.default.bool,
    fields: _propTypes2.default.object,
    form: _propTypes2.default.object,
    intl: _reactIntl.intlShape.isRequired,
    modal: _propTypes2.default.object
};

var StyledAddGroup = (0, _reactIntl.injectIntl)((0, _reactStyleable2.default)(_index2.default)(AddGroupForm));

exports.default = (0, _withForm2.default)(StyledAddGroup, { validate: validate });

/***/ }),
/* 628 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactStyleable = __webpack_require__(6);

var _reactStyleable2 = _interopRequireDefault(_reactStyleable);

var _reactIntl = __webpack_require__(2);

var _index = __webpack_require__(246);

var _index2 = _interopRequireDefault(_index);

var _form = __webpack_require__(627);

var _form2 = _interopRequireDefault(_form);

var _confirmation = __webpack_require__(626);

var _confirmation2 = _interopRequireDefault(_confirmation);

var _maxGroupError = __webpack_require__(629);

var _maxGroupError2 = _interopRequireDefault(_maxGroupError);

var _withModal = __webpack_require__(49);

var _withModal2 = _interopRequireDefault(_withModal);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var maxGroupThreshold = 12;

var AddGroup = function AddGroup(props) {
    var addGroupExceedGroupError = props.addGroupExceedGroupError,
        addGroupIsSuccess = props.addGroupIsSuccess,
        classroomDetail = props.classroomDetail;
    var classroomGroups = classroomDetail.classroomGroups;


    var content = !addGroupIsSuccess ? _react2.default.createElement(_form2.default, props) : _react2.default.createElement(_confirmation2.default, props);

    if (classroomGroups.length >= maxGroupThreshold && !addGroupIsSuccess || addGroupExceedGroupError) {
        content = _react2.default.createElement(_maxGroupError2.default, props);
    }
    return content;
};

var StyledAddGroup = (0, _reactIntl.injectIntl)((0, _reactStyleable2.default)(_index2.default)(AddGroup));
var AddGroupWithModal = (0, _withModal2.default)('isActive')(StyledAddGroup);

exports.default = AddGroupWithModal;

/***/ }),
/* 629 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactStyleable = __webpack_require__(6);

var _reactStyleable2 = _interopRequireDefault(_reactStyleable);

var _reactIntl = __webpack_require__(2);

var _iconDictionary = __webpack_require__(8);

var _index = __webpack_require__(7);

var _index2 = _interopRequireDefault(_index);

var _variants = __webpack_require__(9);

var _index3 = __webpack_require__(246);

var _index4 = _interopRequireDefault(_index3);

var _svgIcon = __webpack_require__(21);

var _svgIcon2 = _interopRequireDefault(_svgIcon);

var _messages = __webpack_require__(247);

var _messages2 = _interopRequireDefault(_messages);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var MaxGroupError = function (_Component) {
    _inherits(MaxGroupError, _Component);

    function MaxGroupError(props) {
        _classCallCheck(this, MaxGroupError);

        var _this = _possibleConstructorReturn(this, (MaxGroupError.__proto__ || Object.getPrototypeOf(MaxGroupError)).call(this, props));

        _this.handleOnClose = function () {
            var closeAddGroup = _this.props.closeAddGroup;

            closeAddGroup();
        };

        _this.handleOnClose = _this.handleOnClose.bind(_this);
        return _this;
    }

    _createClass(MaxGroupError, [{
        key: 'render',
        value: function render() {
            var intl = this.props.intl;

            return _react2.default.createElement(
                'div',
                null,
                _react2.default.createElement(
                    'div',
                    { className: _index4.default.addGroupComponent },
                    _react2.default.createElement(
                        'div',
                        { className: _index4.default.icon },
                        _react2.default.createElement(_svgIcon2.default, { icon: _iconDictionary.Warning })
                    ),
                    _react2.default.createElement(
                        'div',
                        { className: _index4.default.header },
                        intl.formatMessage(_messages2.default.maxGroupErrorTitle)
                    ),
                    _react2.default.createElement(
                        'div',
                        { className: _index4.default.description },
                        intl.formatMessage(_messages2.default.maxGroupErrorLongDesc)
                    ),
                    _react2.default.createElement(_index2.default, {
                        handleOnClick: this.handleOnClose,
                        label: intl.formatMessage(_messages2.default.okBtn),
                        variant: _variants.DENIM })
                )
            );
        }
    }]);

    return MaxGroupError;
}(_react.Component);

MaxGroupError.propTypes = {
    closeAddGroup: _propTypes2.default.func,
    intl: _reactIntl.intlShape.isRequired
};

exports.default = (0, _reactIntl.injectIntl)((0, _reactStyleable2.default)(_index4.default)(MaxGroupError));

/***/ }),
/* 630 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactStyleable = __webpack_require__(6);

var _reactStyleable2 = _interopRequireDefault(_reactStyleable);

var _reactIntl = __webpack_require__(2);

var _index = __webpack_require__(1663);

var _index2 = _interopRequireDefault(_index);

var _index3 = __webpack_require__(48);

var _index4 = _interopRequireDefault(_index3);

var _index5 = __webpack_require__(37);

var _index6 = _interopRequireDefault(_index5);

var _dropdownList = __webpack_require__(1662);

var _dropdownList2 = _interopRequireDefault(_dropdownList);

var _index7 = __webpack_require__(7);

var _index8 = _interopRequireDefault(_index7);

var _variants = __webpack_require__(9);

var _iconDictionary = __webpack_require__(8);

var _messages = __webpack_require__(631);

var _messages2 = _interopRequireDefault(_messages);

var _index9 = __webpack_require__(36);

var _index10 = _interopRequireDefault(_index9);

var _utils = __webpack_require__(13);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var AddStudent = function (_Component) {
    _inherits(AddStudent, _Component);

    function AddStudent(props) {
        _classCallCheck(this, AddStudent);

        var _this = _possibleConstructorReturn(this, (AddStudent.__proto__ || Object.getPrototypeOf(AddStudent)).call(this, props));

        _this.getUpdatedClassrooms = function () {
            var _this$props = _this.props,
                intl = _this$props.intl,
                selectedProduct = _this$props.selectedProduct;
            // default classes for the add student dropdown menu

            var defaultClassoomList = [{ key: '-1', value: intl.formatMessage(_messages2.default.classroomList, { product: selectedProduct.name }), selected: true }];
            _this.setState({ classrooms: defaultClassoomList.concat(_this.filterClassrooms(_this.props.classes)) });
        };

        _this.filterClassrooms = function (classrooms) {
            var classes = classrooms.map(function (item) {
                return {
                    key: item.classroomId,
                    value: item.name
                };
            });
            return classes;
        };

        _this.validateStudentModel = function () {
            if (_this.props.student.firstName.trim() !== '' && _this.props.student.lastName.trim() !== '' && _this.props.student.yearGroup !== '-1') {
                if (_this.props.isSaveInProgress) {
                    _this.setState({ canSubmit: false });
                } else {
                    _this.setState({ canSubmit: true });
                }
            } else {
                _this.setState({ canSubmit: false });
            }
        };

        _this.handleTextInputOnChange = function (event) {
            var regex = new RegExp((0, _utils.invalidCharaters)());
            var value = event.target.value;
            var field = event.target.name;
            if (value !== '' && !regex.test(value)) {
                event.preventDefault();
                return false;
            }

            _this.props.student[field] = value;
            _this.validateStudentModel(_this.props.student);
            return true;
        };

        _this.handleListOnChange = function (field, value) {
            _this.props.student[field] = value;

            if (field === 'classroomId' && value !== -1) {
                _this.props.getClassroomGroups(value);
            }

            if (field === 'classroomId' && value === -1) {
                _this.props.student.classroomGroupId = '-1';
            }

            _this.validateStudentModel(_this.props.student);
        };

        _this.handleGroupChange = function (field, value) {
            _this.props.student[field] = value;
            _this.validateStudentModel(_this.props.student);
        };

        _this.handleOnSubmit = function () {
            _this.setState({ canSubmit: false });
            _this.props.handleOnAddStudentSubmit();
        };

        _this.handleOnCloseValidationModal = function () {
            _this.setState({ canSubmit: true });
            _this.props.closeAddStudentValidationModal();
        };

        _this.state = { canSubmit: false };
        _this.handleTextInputOnChange = _this.handleTextInputOnChange.bind(_this);
        _this.getUpdatedClassrooms = _this.getUpdatedClassrooms.bind(_this);
        return _this;
    }

    _createClass(AddStudent, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            this.getUpdatedClassrooms();
        }
    }, {
        key: 'render',
        value: function render() {
            var confirmCp = _react2.default.createElement(
                _index10.default,
                { handleOnCloseModal: this.handleOnCloseValidationModal, icon: _iconDictionary.Warning },
                _react2.default.createElement(
                    'div',
                    null,
                    this.props.addStudentValidationMessage
                )
            );

            var formCp = _react2.default.createElement(
                'div',
                { className: this.props.css.addStudentComponent },
                _react2.default.createElement(
                    'div',
                    { className: this.props.css.addStudentHeader },
                    ' ',
                    this.props.intl.formatMessage(_messages2.default.addStudent),
                    ' '
                ),
                _react2.default.createElement(
                    'div',
                    { className: this.props.css.firstName },
                    _react2.default.createElement(_index4.default, {
                        handleOnChange: this.handleTextInputOnChange,
                        maxLength: 50,
                        name: 'firstName',
                        placeholder: this.props.intl.formatMessage(_messages2.default.firstName),
                        value: this.props.student.firstName
                    })
                ),
                _react2.default.createElement(
                    'div',
                    { className: this.props.css.surName },
                    _react2.default.createElement(_index4.default, {
                        handleOnChange: this.handleTextInputOnChange,
                        maxLength: 50,
                        name: 'lastName',
                        placeholder: this.props.intl.formatMessage(_messages2.default.surname),
                        value: this.props.student.lastName
                    })
                ),
                _react2.default.createElement(
                    'div',
                    { className: '' + this.props.css.surName },
                    _react2.default.createElement(_index4.default, {
                        handleOnChange: this.handleTextInputOnChange,
                        maxLength: 50,
                        name: 'previousUsername',
                        placeholder: this.props.intl.formatMessage(_messages2.default.previousUsername),
                        value: this.props.student.previousUsername
                    })
                ),
                _react2.default.createElement(
                    'div',
                    { className: this.props.css.list },
                    _react2.default.createElement(_index6.default, {
                        css: _dropdownList2.default,
                        name: 'yearGroup',
                        onChange: this.handleListOnChange,
                        options: this.props.yearGroups,
                        value: this.props.student.yearGroup
                    })
                ),
                _react2.default.createElement(
                    'div',
                    { className: this.props.css.list },
                    _react2.default.createElement(_index6.default, {
                        css: _dropdownList2.default,
                        name: 'classroomId',
                        onChange: this.handleListOnChange,
                        optionLength: 45,
                        options: this.state.classrooms,
                        value: this.props.student.classroomId
                    })
                ),
                _react2.default.createElement(
                    'div',
                    { className: this.props.css.list },
                    _react2.default.createElement(_index6.default, {
                        css: _dropdownList2.default,
                        name: 'classroomGroupId',
                        onChange: this.handleListOnChange,
                        optionKey: 'id',
                        optionLength: 45,
                        options: this.props.classroomGroups,
                        optionText: 'name',
                        placeholder: this.props.intl.formatMessage(_messages2.default.groupLabel),
                        value: this.props.student.classroomGroupId
                    })
                ),
                _react2.default.createElement(
                    'div',
                    { className: this.props.css.actionButtonWrapper },
                    _react2.default.createElement(_index8.default, {
                        containerClassName: this.props.css.btnDanger,
                        disabled: this.props.isSaveInProgress,
                        handleOnClick: this.props.handleOnCloseModal,
                        icon: _iconDictionary.Cross,
                        iconClassName: this.props.css.svgIconContainer,
                        variant: _variants.CIRCLE_DANGER
                    }),
                    _react2.default.createElement(_index8.default, {
                        containerClassName: this.props.css.btnSuccess,
                        disabled: !this.state.canSubmit,
                        handleOnClick: this.handleOnSubmit,
                        icon: _iconDictionary.Tick,
                        iconClassName: this.props.css.svgIconContainer,
                        variant: _variants.CIRCLE_SUCCESS
                    })
                )
            );

            var finalContent = this.props.showAddStudentValidationModal ? confirmCp : formCp;

            return finalContent;
        }
    }]);

    return AddStudent;
}(_react.Component);

AddStudent.propTypes = {
    addStudentValidationMessage: _propTypes2.default.string,
    classes: _propTypes2.default.arrayOf(_propTypes2.default.object),
    closeAddStudentValidationModal: _propTypes2.default.func,
    css: _propTypes2.default.object,
    handleOnCloseModal: _propTypes2.default.func,
    handleOnAddStudentSubmit: _propTypes2.default.func,
    intl: _reactIntl.intlShape.isRequired,
    isSaveInProgress: _propTypes2.default.bool,
    selectedProduct: _propTypes2.default.object,
    showAddStudentValidationModal: _propTypes2.default.bool,
    student: _propTypes2.default.object,
    yearGroups: _propTypes2.default.arrayOf(_propTypes2.default.object),
    getClassroomGroups: _propTypes2.default.func,
    classroomGroups: _propTypes2.default.arrayOf(_propTypes2.default.object)
};

exports.default = (0, _reactIntl.injectIntl)((0, _reactStyleable2.default)(_index2.default)(AddStudent));

/***/ }),
/* 631 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _reactIntl = __webpack_require__(2);

exports.default = (0, _reactIntl.defineMessages)({
    addStudent: {
        id: 'app.components.AddStudent.addStudent',
        defaultMessage: 'Add student'
    },
    firstName: {
        id: 'app.components.AddStudent.firstName',
        defaultMessage: 'First name'
    },
    surname: {
        id: 'app.components.AddStudent.surname',
        defaultMessage: 'Surname'
    },
    previousUsername: {
        id: 'app.components.AddStudent.previousUsername',
        defaultMessage: 'Previous Username'
    },
    classroomList: {
        id: 'app.components.AddStudent.classroomList',
        defaultMessage: 'Select a {product} class'
    },
    groupLabel: {
        id: 'app.components.AddStudent.groupLabel',
        defaultMessage: 'All groups'
    }
}); /*
     * AddStudent Messages
     *
     * This contains all the text for the AddStudent component.
     */

/***/ }),
/* 632 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactStyleable = __webpack_require__(6);

var _reactStyleable2 = _interopRequireDefault(_reactStyleable);

var _reactIntl = __webpack_require__(2);

var _index = __webpack_require__(1665);

var _index2 = _interopRequireDefault(_index);

var _index3 = __webpack_require__(48);

var _index4 = _interopRequireDefault(_index3);

var _index5 = __webpack_require__(37);

var _index6 = _interopRequireDefault(_index5);

var _dropdownList = __webpack_require__(1664);

var _dropdownList2 = _interopRequireDefault(_dropdownList);

var _index7 = __webpack_require__(7);

var _index8 = _interopRequireDefault(_index7);

var _variants = __webpack_require__(9);

var _iconDictionary = __webpack_require__(8);

var _messages = __webpack_require__(633);

var _messages2 = _interopRequireDefault(_messages);

var _index9 = __webpack_require__(36);

var _index10 = _interopRequireDefault(_index9);

var _utils = __webpack_require__(13);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var AddTeacher = function (_Component) {
    _inherits(AddTeacher, _Component);

    function AddTeacher(props) {
        _classCallCheck(this, AddTeacher);

        var _this = _possibleConstructorReturn(this, (AddTeacher.__proto__ || Object.getPrototypeOf(AddTeacher)).call(this, props));

        _this.getUpdatedClassrooms = function () {
            var _this$props = _this.props,
                intl = _this$props.intl,
                selectedProduct = _this$props.selectedProduct;
            // default classes for the add student dropdown menu

            var defaultClassoomList = [{ key: '-1', value: intl.formatMessage(_messages2.default.classroomList, { product: selectedProduct.name }), selected: true }];
            _this.setState({ classrooms: defaultClassoomList.concat(_this.filterClassrooms(_this.props.classes)) });
        };

        _this.filterClassrooms = function (classrooms) {
            var classes = classrooms.map(function (item) {
                return {
                    key: item.classroomId,
                    value: item.name
                };
            });
            return classes;
        };

        _this.validateTeacherModel = function () {
            if (_this.props.teacher.firstName.trim() !== '' && _this.props.teacher.lastName.trim() !== '' && _this.props.teacher.emailAddress.trim() !== '') {
                if (_this.props.isSaveInProgress) {
                    _this.setState({ canSubmit: false });
                } else if (_this.props.teacher.emailAddress && _this.props.teacher.emailAddress.trim() !== '' && !(0, _utils.isValidEmail)(_this.props.teacher.emailAddress.trim())) {
                    _this.setState({ canSubmit: false });
                } else {
                    _this.setState({ canSubmit: true });
                }
            } else {
                _this.setState({ canSubmit: false });
            }
        };

        _this.handleTextInputOnChange = function (event) {
            var regex = new RegExp(_this.nameRegEx);
            var value = event.target.value;
            var field = event.target.name;
            if (value !== '' && !regex.test(value)) {
                event.preventDefault();
                return false;
            }

            _this.props.teacher[field] = value;
            _this.validateTeacherModel(_this.props.teacher);
            return true;
        };

        _this.handleEmailInputOnChange = function (event) {
            var regex = new RegExp((0, _utils.invalidEmailCharaters)());
            var value = event.target.value;
            var field = event.target.name;
            if (value !== '' && !regex.test(value)) {
                event.preventDefault();
                return false;
            }

            _this.props.teacher[field] = value;
            _this.validateTeacherModel(_this.props.teacher);
            return true;
        };

        _this.handleListOnChange = function (field, value) {
            _this.props.teacher[field] = value;
            _this.validateTeacherModel(_this.props.teacher);
        };

        _this.handleOnSubmit = function () {
            _this.setState({ canSubmit: false });
            _this.props.handleOnAddTeacherSubmit();
        };

        _this.handleOnCloseValidationModal = function () {
            _this.setState({ canSubmit: true });
            _this.props.closeAddTeacherValidationModal();
        };

        _this.state = { canSubmit: false };
        _this.nameRegEx = "^[a-zA-Z0-9][a-zA-Z0-9\"*()-_,.' ]*$";
        _this.handleTextInputOnChange = _this.handleTextInputOnChange.bind(_this);
        _this.handleEmailInputOnChange = _this.handleEmailInputOnChange.bind(_this);
        _this.getUpdatedClassrooms = _this.getUpdatedClassrooms.bind(_this);
        _this.props.teacherTitles[0].value = _this.props.intl.formatMessage(_messages2.default.teacherTitleNone);
        _this.props.teacherTitles[0].key = _this.props.intl.formatMessage(_messages2.default.teacherTitleNone_key);
        return _this;
    }

    _createClass(AddTeacher, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            this.getUpdatedClassrooms();
        }
    }, {
        key: 'render',
        value: function render() {
            var confirmContent = _react2.default.createElement(
                _index10.default,
                { handleOnCloseModal: this.handleOnCloseValidationModal, icon: _iconDictionary.Warning },
                _react2.default.createElement(
                    'div',
                    null,
                    this.props.addTeacherValidationMessage
                )
            );

            var formContent = _react2.default.createElement(
                'div',
                { className: this.props.css.addTeacherComponent },
                _react2.default.createElement(
                    'div',
                    {
                        className: this.props.css.addTeacherHeader },
                    ' ',
                    this.props.intl.formatMessage(_messages2.default.inviteTeacher),
                    ' '
                ),
                _react2.default.createElement(
                    'div',
                    { className: this.props.css.list },
                    _react2.default.createElement(_index6.default, {
                        css: _dropdownList2.default,
                        name: 'title',
                        onChange: this.handleListOnChange,
                        optionLength: 45,
                        options: this.props.teacherTitles,
                        value: this.props.teacher.title
                    })
                ),
                _react2.default.createElement(
                    'div',
                    { className: this.props.css.firstName },
                    _react2.default.createElement(_index4.default, {
                        handleOnChange: this.handleTextInputOnChange,
                        maxLength: 50,
                        name: 'firstName',
                        placeholder: this.props.intl.formatMessage(_messages2.default.firstName),
                        value: this.props.teacher.firstName
                    })
                ),
                _react2.default.createElement(
                    'div',
                    { className: this.props.css.surName },
                    _react2.default.createElement(_index4.default, {
                        handleOnChange: this.handleTextInputOnChange,
                        maxLength: 50,
                        name: 'lastName',
                        placeholder: this.props.intl.formatMessage(_messages2.default.surname),
                        value: this.props.teacher.lastName
                    })
                ),
                _react2.default.createElement(
                    'div',
                    { className: this.props.css.emailAddress },
                    _react2.default.createElement(_index4.default, {
                        handleOnChange: this.handleEmailInputOnChange,
                        maxLength: 70,
                        name: 'emailAddress',
                        placeholder: this.props.intl.formatMessage(_messages2.default.emailAddress),
                        value: this.props.teacher.emailAddress
                    })
                ),
                _react2.default.createElement(
                    'div',
                    { className: this.props.css.list },
                    _react2.default.createElement(_index6.default, {
                        css: _dropdownList2.default,
                        name: 'classroomId',
                        onChange: this.handleListOnChange,
                        optionLength: 45,
                        options: this.state.classrooms,
                        value: this.props.teacher.classroomId
                    })
                ),
                _react2.default.createElement(
                    'div',
                    { className: this.props.css.actionButtonWrapper },
                    _react2.default.createElement(_index8.default, {
                        containerClassName: this.props.css.btnDanger,
                        disabled: this.props.isSaveInProgress,
                        handleOnClick: this.props.handleOnCloseModal,
                        icon: _iconDictionary.Cross,
                        iconClassName: this.props.css.svgIconContainer,
                        variant: _variants.CIRCLE_DANGER
                    }),
                    _react2.default.createElement(_index8.default, {
                        containerClassName: this.props.css.btnSuccess,
                        disabled: !this.state.canSubmit,
                        handleOnClick: this.handleOnSubmit,
                        icon: _iconDictionary.Tick,
                        iconClassName: this.props.css.svgIconContainer,
                        variant: _variants.CIRCLE_SUCCESS
                    })
                )
            );

            var finalContent = this.props.showAddTeacherValidationModal ? confirmContent : formContent;

            return finalContent;
        }
    }]);

    return AddTeacher;
}(_react.Component);

AddTeacher.propTypes = {
    addTeacherValidationMessage: _propTypes2.default.string,
    classes: _propTypes2.default.arrayOf(_propTypes2.default.object),
    closeAddTeacherValidationModal: _propTypes2.default.func,
    css: _propTypes2.default.object,
    handleOnCloseModal: _propTypes2.default.func,
    handleOnAddTeacherSubmit: _propTypes2.default.func,
    intl: _reactIntl.intlShape.isRequired,
    isSaveInProgress: _propTypes2.default.bool,
    showAddTeacherValidationModal: _propTypes2.default.bool,
    selectedProduct: _propTypes2.default.object,
    teacher: _propTypes2.default.object,
    teacherTitles: _propTypes2.default.arrayOf(_propTypes2.default.object)
};

exports.default = (0, _reactIntl.injectIntl)((0, _reactStyleable2.default)(_index2.default)(AddTeacher));

/***/ }),
/* 633 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _reactIntl = __webpack_require__(2);

exports.default = (0, _reactIntl.defineMessages)({
    inviteTeacher: {
        id: 'app.components.AddTeacher.inviteTeacher',
        defaultMessage: 'Invite teacher'
    },
    title: {
        id: 'app.components.AddTeacher.title',
        defaultMessage: 'Title'
    },
    firstName: {
        id: 'app.components.AddTeacher.firstName',
        defaultMessage: 'First name'
    },
    surname: {
        id: 'app.components.AddTeacher.surname',
        defaultMessage: 'Surname'
    },
    emailAddress: {
        id: 'app.components.AddTeacher.emailAddress',
        defaultMessage: 'Email Address'
    },
    classroomList: {
        id: 'app.components.AddTeacher.classroomList',
        defaultMessage: 'Select a {product} class'
    },
    teacherTitleNone: {
        id: 'app.components.EditTeacher.teachertTitle.none',
        defaultMessage: 'None'
    },
    teacherTitleNone_key: {
        id: 'app.components.EditTeacher.teachertTitle.none.key',
        defaultMessage: 'none'
    }
}); /*
     * AddStudent Messages
     *
     * This contains all the text for the AddStudent component.
     */

/***/ }),
/* 634 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactIntl = __webpack_require__(2);

var _reactStyleable = __webpack_require__(6);

var _reactStyleable2 = _interopRequireDefault(_reactStyleable);

var _assignCourseFilter = __webpack_require__(635);

var _assignCourseFilter2 = _interopRequireDefault(_assignCourseFilter);

var _selectCourse = __webpack_require__(636);

var _selectCourse2 = _interopRequireDefault(_selectCourse);

var _index = __webpack_require__(365);

var _index2 = _interopRequireDefault(_index);

var _index3 = __webpack_require__(7);

var _index4 = _interopRequireDefault(_index3);

var _messages = __webpack_require__(248);

var _messages2 = _interopRequireDefault(_messages);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var AssignCourseConquest = function AssignCourseConquest(props) {
    return _react2.default.createElement(
        'div',
        { className: _index2.default.assignCourse },
        _react2.default.createElement(_assignCourseFilter2.default, props),
        _react2.default.createElement(_selectCourse2.default, props),
        _react2.default.createElement(
            'div',
            { className: _index2.default.footer },
            _react2.default.createElement(_index4.default, {
                containerClassName: _index2.default.assignToYear,
                disabled: props.disableAssignToYear,
                handleOnClick: function handleOnClick() {
                    return props.assignToYearGroup('conquest');
                },
                label: props.intl.formatMessage(_messages2.default.assignToYear)
            })
        )
    );
};

AssignCourseConquest.propTypes = {
    intl: _reactIntl.intlShape.isRequired,
    assignToYearGroup: _propTypes2.default.func.isRequired,
    disableAssignToYear: _propTypes2.default.bool.isRequired,
    forYear: _propTypes2.default.bool,
    handleOptOutOfCourse: _propTypes2.default.func,
    isUPFSelected: _propTypes2.default.bool
};

exports.default = (0, _reactIntl.injectIntl)((0, _reactStyleable2.default)(_index2.default)(AssignCourseConquest));

/***/ }),
/* 635 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactStyleable = __webpack_require__(6);

var _reactStyleable2 = _interopRequireDefault(_reactStyleable);

var _reactIntl = __webpack_require__(2);

var _index = __webpack_require__(365);

var _index2 = _interopRequireDefault(_index);

var _search = __webpack_require__(1666);

var _search2 = _interopRequireDefault(_search);

var _index3 = __webpack_require__(37);

var _index4 = _interopRequireDefault(_index3);

var _constant = __webpack_require__(151);

var _messages = __webpack_require__(248);

var _messages2 = _interopRequireDefault(_messages);

var _textInput = __webpack_require__(48);

var _textInput2 = _interopRequireDefault(_textInput);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var AssignCourseFilter = function AssignCourseFilter(props) {
    var intl = props.intl,
        yearGroups = props.yearGroups,
        countries = props.countries,
        handleOnYearGroupChange = props.handleOnYearGroupChange,
        handleOnCountryChange = props.handleOnCountryChange,
        handleOnSearchCourse = props.handleOnSearchCourse,
        searchQuery = props.searchQuery,
        disableSearch = props.disableSearch,
        disableYearGroup = props.disableYearGroup,
        selectedYearGroupId = props.selectedYearGroupId,
        isLoadingCountryYearGroups = props.isLoadingCountryYearGroups,
        selectedCountryId = props.selectedCountryId;


    var countriesList = countries.slice(0);

    var clearText = true;

    var getSubHeading = function getSubHeading() {
        return intl.formatMessage(_messages2.default.newCourses);
    };

    return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
            'div',
            { className: _index2.default.defaultCourse },
            _react2.default.createElement(
                'div',
                { className: _index2.default.heading },
                intl.formatMessage(_messages2.default.startCourse)
            ),
            _react2.default.createElement(
                'div',
                { className: _index2.default.subHeading },
                getSubHeading()
            ),
            _react2.default.createElement(_index4.default, {
                name: 'countries',
                onChange: handleOnCountryChange,
                optionKey: 'code',
                options: countriesList,
                optionText: 'name',
                placeholder: intl.formatMessage(_messages2.default.defaultOptionCountry),
                value: selectedCountryId,
                variant: _constant.FULL_WIDTH
            }),
            _react2.default.createElement(_index4.default, {
                disabled: disableYearGroup,
                isLoading: isLoadingCountryYearGroups,
                name: 'yearGroups',
                onChange: handleOnYearGroupChange,
                optionKey: 'yearGroupEnum',
                options: yearGroups,
                optionText: 'longName',
                placeholder: intl.formatMessage(_messages2.default.selectGroup),
                value: selectedYearGroupId,
                variant: _constant.FULL_WIDTH
            }),
            _react2.default.createElement(
                'div',
                { className: _index2.default.searchContainer },
                _react2.default.createElement(_textInput2.default, {
                    clearText: clearText,
                    css: _search2.default,
                    disabled: disableSearch,
                    handleOnChange: handleOnSearchCourse,
                    placeholder: intl.formatMessage(_messages2.default.searchCourse),
                    type: 'text',
                    value: searchQuery
                })
            )
        )
    );
};

AssignCourseFilter.propTypes = {
    intl: _reactIntl.intlShape.isRequired,
    yearGroups: _propTypes2.default.array,
    countries: _propTypes2.default.array,
    handleOnYearGroupChange: _propTypes2.default.func,
    handleOnCountryChange: _propTypes2.default.func,
    handleOnSearchCourse: _propTypes2.default.func,
    searchQuery: _propTypes2.default.string,
    disableSearch: _propTypes2.default.bool,
    disableYearGroup: _propTypes2.default.bool,
    isLoadingCountryYearGroups: _propTypes2.default.bool,
    selectedYearGroupId: _propTypes2.default.string,
    selectedCountryId: _propTypes2.default.string
};

exports.default = (0, _reactIntl.injectIntl)((0, _reactStyleable2.default)(_index2.default)(AssignCourseFilter));

/***/ }),
/* 636 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactStyleable = __webpack_require__(6);

var _reactStyleable2 = _interopRequireDefault(_reactStyleable);

var _PulseLoader = __webpack_require__(60);

var _PulseLoader2 = _interopRequireDefault(_PulseLoader);

var _reactIntl = __webpack_require__(2);

var _index = __webpack_require__(365);

var _index2 = _interopRequireDefault(_index);

var _messages = __webpack_require__(248);

var _messages2 = _interopRequireDefault(_messages);

var _index3 = __webpack_require__(76);

var _index4 = _interopRequireDefault(_index3);

var _index5 = __webpack_require__(261);

var _index6 = _interopRequireDefault(_index5);

var _actionTypes = __webpack_require__(97);

var actionTypes = _interopRequireWildcard(_actionTypes);

var _utils = __webpack_require__(13);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SelectCourse = function SelectCourse(props) {
    var intl = props.intl,
        filteredCourses = props.filteredCourses,
        handleOnCourseSelection = props.handleOnCourseSelection,
        isProductCoursesLoaded = props.isProductCoursesLoaded,
        initialLoad = props.initialLoad,
        dispatch = props.dispatch,
        forLegacy = props.forLegacy,
        selectedCountryId = props.selectedCountryId,
        selectedYearGroupId = props.selectedYearGroupId,
        isNewCoursesLoaded = props.isNewCoursesLoaded,
        isNewCoursesSelected = props.isNewCoursesSelected;

    function displayCourses() {
        if (isNewCoursesLoaded && !isProductCoursesLoaded && !initialLoad) {
            return _react2.default.createElement(
                'div',
                { className: _index2.default.loader },
                _react2.default.createElement(_PulseLoader2.default, { color: 'grey', size: '15px' })
            );
        }

        if (!filteredCourses.length || isNewCoursesSelected && !(0, _utils.newCoursesAvailable)(selectedYearGroupId, selectedCountryId)) {
            return _react2.default.createElement(
                'div',
                { className: _index2.default.empty },
                _react2.default.createElement(_index4.default, { message: intl.formatMessage(_messages2.default.noCoursesFound) })
            );
        }

        return filteredCourses.map(function (course) {
            return _react2.default.createElement(
                'div',
                { className: _index2.default.courseRow, key: 'row_' + course.id },
                _react2.default.createElement(
                    'button',
                    {
                        className: course.isSelected ? _index2.default.courseSelected : _index2.default.course,
                        key: course.id,
                        onClick: function onClick() {
                            return handleOnCourseSelection({ id: course.id, name: course.name });
                        } },
                    course.name
                ),
                forLegacy && _react2.default.createElement(_index6.default, { handleOnClick: function handleOnClick() {
                        return dispatch({ type: actionTypes.SHOW_COURSE_DETAILS, courseId: course.id });
                    } })
            );
        });
    }

    return _react2.default.createElement(
        'div',
        { className: _index2.default.selectCourseContainer },
        _react2.default.createElement(
            'div',
            { className: _index2.default.courseHeader },
            intl.formatMessage(_messages2.default.selectCourse).toUpperCase()
        ),
        _react2.default.createElement(
            'div',
            { className: _index2.default.selectCourse },
            displayCourses()
        )
    );
};

SelectCourse.propTypes = {
    intl: _reactIntl.intlShape.isRequired,
    filteredCourses: _propTypes2.default.array,
    handleOnCourseSelection: _propTypes2.default.func,
    isProductCoursesLoaded: _propTypes2.default.bool,
    isNewCoursesSelected: _propTypes2.default.bool,
    isNewCoursesLoaded: _propTypes2.default.bool,
    initialLoad: _propTypes2.default.bool,
    dispatch: _propTypes2.default.func.isRequired,
    forLegacy: _propTypes2.default.bool,
    selectedCountryId: _propTypes2.default.string,
    selectedYearGroupId: _propTypes2.default.string
};

exports.default = (0, _reactIntl.injectIntl)((0, _reactStyleable2.default)(_index2.default)(SelectCourse));

/***/ }),
/* 637 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactIntl = __webpack_require__(2);

var _reactStyleable = __webpack_require__(6);

var _reactStyleable2 = _interopRequireDefault(_reactStyleable);

var _assignCourseFilter = __webpack_require__(638);

var _assignCourseFilter2 = _interopRequireDefault(_assignCourseFilter);

var _selectCourse = __webpack_require__(639);

var _selectCourse2 = _interopRequireDefault(_selectCourse);

var _index = __webpack_require__(366);

var _index2 = _interopRequireDefault(_index);

var _index3 = __webpack_require__(7);

var _index4 = _interopRequireDefault(_index3);

var _messages = __webpack_require__(249);

var _messages2 = _interopRequireDefault(_messages);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var AssignCourseLegacy = function AssignCourseLegacy(props) {
    return _react2.default.createElement(
        'div',
        { className: _index2.default.assignCourse },
        _react2.default.createElement(_assignCourseFilter2.default, props),
        _react2.default.createElement(_selectCourse2.default, props),
        _react2.default.createElement(
            'div',
            { className: _index2.default.footer },
            _react2.default.createElement(_index4.default, {
                containerClassName: _index2.default.assignToYear,
                disabled: props.disableAssignToYear,
                handleOnClick: function handleOnClick() {
                    return props.assignToYearGroup('legacy');
                },
                label: props.forYear ? props.intl.formatMessage(_messages2.default.assignToYear) : props.intl.formatMessage(_messages2.default.assignToGroup)
            })
        )
    );
};

AssignCourseLegacy.propTypes = {
    intl: _reactIntl.intlShape.isRequired,
    assignToYearGroup: _propTypes2.default.func.isRequired,
    disableAssignToYear: _propTypes2.default.bool.isRequired,
    forYear: _propTypes2.default.bool
};

exports.default = (0, _reactIntl.injectIntl)((0, _reactStyleable2.default)(_index2.default)(AssignCourseLegacy));

/***/ }),
/* 638 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactStyleable = __webpack_require__(6);

var _reactStyleable2 = _interopRequireDefault(_reactStyleable);

var _reactIntl = __webpack_require__(2);

var _index = __webpack_require__(366);

var _index2 = _interopRequireDefault(_index);

var _search = __webpack_require__(1667);

var _search2 = _interopRequireDefault(_search);

var _index3 = __webpack_require__(37);

var _index4 = _interopRequireDefault(_index3);

var _constant = __webpack_require__(151);

var _messages = __webpack_require__(249);

var _messages2 = _interopRequireDefault(_messages);

var _productEnum = __webpack_require__(77);

var _productEnum2 = _interopRequireDefault(_productEnum);

var _constants = __webpack_require__(96);

var _constants2 = _interopRequireDefault(_constants);

var _textInput = __webpack_require__(48);

var _textInput2 = _interopRequireDefault(_textInput);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var AssignCourseFilter = function AssignCourseFilter(props) {
    var intl = props.intl,
        yearGroups = props.yearGroups,
        countries = props.countries,
        handleOnYearGroupChange = props.handleOnYearGroupChange,
        handleOnCountryChange = props.handleOnCountryChange,
        handleOnSearchCourse = props.handleOnSearchCourse,
        searchQuery = props.searchQuery,
        disableSearch = props.disableSearch,
        disableYearGroup = props.disableYearGroup,
        selectedYearGroupId = props.selectedYearGroupId,
        isLoadingCountryYearGroups = props.isLoadingCountryYearGroups,
        selectedProduct = props.selectedProduct;


    var countriesList = countries.slice(0);
    var isMathletics = selectedProduct.id === _productEnum2.default.MATHLETICS.id;

    if (isMathletics) {
        countriesList.unshift({
            name: intl.formatMessage(_messages2.default.schoolCourses),
            code: _constants2.default.SCHOOL_COURSES
        });
    }

    var clearText = true;
    return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
            'div',
            { className: _index2.default.defaultCourse },
            _react2.default.createElement(
                'div',
                { className: _index2.default.heading },
                intl.formatMessage(_messages2.default.startCourse),
                ':'
            ),
            _react2.default.createElement(
                'div',
                { className: _index2.default.subHeading },
                intl.formatMessage(_messages2.default[isMathletics ? 'coursesActivityMastery' : 'courses'])
            ),
            _react2.default.createElement(_index4.default, {
                name: 'countries',
                onChange: handleOnCountryChange,
                optionKey: 'code',
                options: countriesList,
                optionText: 'name',
                placeholder: intl.formatMessage(_messages2.default.defaultOptionCountry),
                variant: _constant.FULL_WIDTH
            }),
            _react2.default.createElement(_index4.default, {
                disabled: disableYearGroup,
                isLoading: isLoadingCountryYearGroups,
                name: 'yearGroups',
                onChange: handleOnYearGroupChange,
                optionKey: 'yearGroupEnum',
                options: yearGroups,
                optionText: 'longName',
                placeholder: intl.formatMessage(_messages2.default.selectGrade),
                value: selectedYearGroupId,
                variant: _constant.FULL_WIDTH
            }),
            _react2.default.createElement(
                'div',
                { className: _index2.default.searchContainer },
                _react2.default.createElement(_textInput2.default, {
                    clearText: clearText,
                    css: _search2.default,
                    disabled: disableSearch,
                    handleOnChange: handleOnSearchCourse,
                    placeholder: intl.formatMessage(_messages2.default.searchCourse),
                    type: 'text',
                    value: searchQuery })
            )
        )
    );
};

AssignCourseFilter.propTypes = {
    intl: _reactIntl.intlShape.isRequired,
    yearGroups: _propTypes2.default.array,
    countries: _propTypes2.default.array,
    handleOnYearGroupChange: _propTypes2.default.func,
    handleOnCountryChange: _propTypes2.default.func,
    handleOnSearchCourse: _propTypes2.default.func,
    searchQuery: _propTypes2.default.string,
    disableSearch: _propTypes2.default.bool,
    disableYearGroup: _propTypes2.default.bool,
    isLoadingCountryYearGroups: _propTypes2.default.bool,
    selectedYearGroupId: _propTypes2.default.string,
    selectedProduct: _propTypes2.default.object
};

exports.default = (0, _reactIntl.injectIntl)((0, _reactStyleable2.default)(_index2.default)(AssignCourseFilter));

/***/ }),
/* 639 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactStyleable = __webpack_require__(6);

var _reactStyleable2 = _interopRequireDefault(_reactStyleable);

var _PulseLoader = __webpack_require__(60);

var _PulseLoader2 = _interopRequireDefault(_PulseLoader);

var _reactIntl = __webpack_require__(2);

var _index = __webpack_require__(366);

var _index2 = _interopRequireDefault(_index);

var _messages = __webpack_require__(249);

var _messages2 = _interopRequireDefault(_messages);

var _index3 = __webpack_require__(76);

var _index4 = _interopRequireDefault(_index3);

var _index5 = __webpack_require__(261);

var _index6 = _interopRequireDefault(_index5);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SelectCourse = function SelectCourse(props) {
    var intl = props.intl,
        filteredCourses = props.filteredCourses,
        handleOnCourseSelection = props.handleOnCourseSelection,
        isProductCoursesLoaded = props.isProductCoursesLoaded,
        initialLoad = props.initialLoad,
        handleOnViewCourse = props.handleOnViewCourse;


    function displayCourses() {
        if (!isProductCoursesLoaded && !initialLoad) {
            return _react2.default.createElement(
                'div',
                { className: _index2.default.loader },
                _react2.default.createElement(_PulseLoader2.default, { color: 'grey', size: '15px' })
            );
        }

        if (!filteredCourses.length) {
            return _react2.default.createElement(
                'div',
                { className: _index2.default.empty },
                _react2.default.createElement(_index4.default, { message: intl.formatMessage(_messages2.default.noCoursesFound) })
            );
        }

        return filteredCourses.map(function (course) {
            return _react2.default.createElement(
                'div',
                { className: _index2.default.courseRow, key: 'row_' + course.id },
                _react2.default.createElement(
                    'button',
                    {
                        className: course.isSelected ? _index2.default.courseSelected : _index2.default.course,
                        key: course.id,
                        onClick: function onClick() {
                            return handleOnCourseSelection({ id: course.id, name: course.name });
                        } },
                    course.name
                ),
                _react2.default.createElement(_index6.default, { handleOnClick: function handleOnClick() {
                        return handleOnViewCourse(course.id);
                    } })
            );
        });
    }

    return _react2.default.createElement(
        'div',
        { className: _index2.default.selectCourseContainer },
        _react2.default.createElement(
            'div',
            { className: _index2.default.courseHeader },
            intl.formatMessage(_messages2.default.selectCourse).toUpperCase()
        ),
        _react2.default.createElement(
            'div',
            { className: _index2.default.selectCourse },
            displayCourses()
        )
    );
};

SelectCourse.propTypes = {
    intl: _reactIntl.intlShape.isRequired,
    filteredCourses: _propTypes2.default.array,
    handleOnCourseSelection: _propTypes2.default.func,
    isProductCoursesLoaded: _propTypes2.default.bool,
    initialLoad: _propTypes2.default.bool,
    handleOnViewCourse: _propTypes2.default.func.isRequired
};

exports.default = (0, _reactIntl.injectIntl)((0, _reactStyleable2.default)(_index2.default)(SelectCourse));

/***/ }),
/* 640 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactStyleable = __webpack_require__(6);

var _reactStyleable2 = _interopRequireDefault(_reactStyleable);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactIntl = __webpack_require__(2);

var _filter = __webpack_require__(137);

var _filter2 = _interopRequireDefault(_filter);

var _forEach = __webpack_require__(333);

var _forEach2 = _interopRequireDefault(_forEach);

var _messages = __webpack_require__(378);

var _messages2 = _interopRequireDefault(_messages);

var _index = __webpack_require__(587);

var _index2 = _interopRequireDefault(_index);

var _index3 = __webpack_require__(7);

var _index4 = _interopRequireDefault(_index3);

var _index5 = __webpack_require__(149);

var _index6 = _interopRequireDefault(_index5);

var _index7 = __webpack_require__(683);

var _index8 = _interopRequireDefault(_index7);

var _index9 = __webpack_require__(735);

var _index10 = _interopRequireDefault(_index9);

var _index11 = __webpack_require__(393);

var _index12 = _interopRequireDefault(_index11);

var _index13 = __webpack_require__(24);

var _index14 = _interopRequireDefault(_index13);

var _taskCarryForward = __webpack_require__(641);

var _taskCarryForward2 = _interopRequireDefault(_taskCarryForward);

var _index15 = __webpack_require__(36);

var _index16 = _interopRequireDefault(_index15);

var _iconDictionary = __webpack_require__(8);

var _portalComms = __webpack_require__(55);

var _portalComms2 = _interopRequireDefault(_portalComms);

var _index17 = __webpack_require__(383);

var _index18 = _interopRequireDefault(_index17);

var _actionTypes = __webpack_require__(97);

var actionTypes = _interopRequireWildcard(_actionTypes);

var _productEnum = __webpack_require__(77);

var _productEnum2 = _interopRequireDefault(_productEnum);

var _constants = __webpack_require__(40);

var _utils = __webpack_require__(13);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var assignCourseMapper = function (_Component) {
    _inherits(assignCourseMapper, _Component);

    function assignCourseMapper(props) {
        _classCallCheck(this, assignCourseMapper);

        var _this = _possibleConstructorReturn(this, (assignCourseMapper.__proto__ || Object.getPrototypeOf(assignCourseMapper)).call(this, props));

        _initialiseProps.call(_this);

        var defaultData = props.defaultData,
            classrooms = props.classrooms;

        _this.activeColor = '#32a8a7';
        _this.defaultColor = '#fff';
        _this.classrooms = classrooms;
        _this.isAssignEvent = false;
        _this.disableSave = true;
        _this.disableAssignToGroup = true;
        _this.showCancelConfirmation = false;
        _this.isMathletics = props.selectedProduct.id === _productEnum2.default.MATHLETICS.id;
        _this.state = {
            selectedYearGroup: defaultData.DefaultYear,
            selectedClassroom: defaultData.DefaultClassroom,
            selectedGroup: defaultData.DefaultGroup,
            groupCourse: {},
            selectedCourse: {
                id: _constants.DEFAULT_COURSE_ID,
                name: '',
                legacy: !_this.isMathletics,
                newCourse: false,
                UPF: false
            },
            isUpdated: true,
            UPFSelected: false,
            LegacySelected: true,
            NewCoursesSelected: false
        };
        return _this;
    }

    _createClass(assignCourseMapper, [{
        key: 'componentWillReceiveProps',
        value: function componentWillReceiveProps(nextProps) {
            var isAssignEvent = nextProps.isAssignEvent;

            if (isAssignEvent) {
                this.props.dispatch({ type: actionTypes.CANCEL_ASSIGN_REQUEST });
            }
        }
    }, {
        key: 'render',
        value: function render() {
            var _this2 = this;

            var _props = this.props,
                intl = _props.intl,
                activateModal = _props.activateModal,
                assigningCourses = _props.assigningCourses,
                handleViewCourse = _props.handleViewCourse;

            return _react2.default.createElement(
                'div',
                null,
                _react2.default.createElement(
                    'div',
                    { className: _index2.default.panel },
                    _react2.default.createElement(
                        'div',
                        { className: _index2.default.lhsPanel },
                        _react2.default.createElement(
                            'div',
                            { className: _index2.default.header },
                            _react2.default.createElement(
                                'div',
                                { className: _index2.default.yearColumn },
                                intl.formatMessage(_messages2.default.year)
                            ),
                            _react2.default.createElement(
                                'div',
                                {
                                    className: _index2.default.classColumn },
                                intl.formatMessage(_messages2.default.class)
                            ),
                            _react2.default.createElement(
                                'div',
                                { className: _index2.default.groupColumn },
                                intl.formatMessage(_messages2.default.group)
                            ),
                            _react2.default.createElement(
                                'div',
                                { className: _index2.default.groupColumn },
                                intl.formatMessage(_messages2.default.learningModule)
                            ),
                            _react2.default.createElement(
                                'div',
                                { className: _index2.default.assignedCourseColumn },
                                intl.formatMessage(_messages2.default.currentCourse)
                            )
                        ),
                        _react2.default.createElement(
                            'div',
                            { className: _index2.default.row },
                            _react2.default.createElement(
                                'div',
                                { className: _index2.default.yearRow },
                                this.renderYears()
                            ),
                            _react2.default.createElement(
                                'div',
                                { className: _index2.default.classRow },
                                this.renderYearClassrooms()
                            ),
                            _react2.default.createElement(
                                'div',
                                { className: _index2.default.groupRow },
                                this.renderGroups()
                            ),
                            _react2.default.createElement(
                                'div',
                                { className: _index2.default.groupRow },
                                _react2.default.createElement(
                                    'div',
                                    {
                                        className: _index2.default.infoContainer,
                                        onClick: function onClick() {
                                            return _this2.updateState('learningModule', { LegacySelected: !_this2.state.LegacySelected, UPFSelected: false, NewCoursesSelected: false });
                                        },
                                        role: 'button',
                                        tabIndex: 0 },
                                    _react2.default.createElement(
                                        _index8.default,
                                        {
                                            background: this.state.LegacySelected ? this.activeColor : this.defaultColor },
                                        _react2.default.createElement(
                                            'div',
                                            { className: this.state.LegacySelected ? _index2.default.info + ' ' + _index2.default.active : '' + _index2.default.info },
                                            intl.formatMessage(_messages2.default[this.isMathletics ? 'coursesActivityMastery' : 'courses'])
                                        )
                                    )
                                ),
                                this.shouldShowNewCourses() && _react2.default.createElement(
                                    'div',
                                    {
                                        className: _index2.default.infoContainer,
                                        onClick: function onClick() {
                                            return _this2.updateState('learningModule', { NewCoursesSelected: !_this2.state.NewCoursesSelected, UPFSelected: false, LegacySelected: false });
                                        },
                                        role: 'button',
                                        tabIndex: 0 },
                                    _react2.default.createElement(
                                        _index8.default,
                                        {
                                            background: this.state.NewCoursesSelected ? this.activeColor : this.defaultColor },
                                        _react2.default.createElement(
                                            'div',
                                            { className: this.state.NewCoursesSelected ? _index2.default.info + ' ' + _index2.default.active : '' + _index2.default.info },
                                            intl.formatMessage(_messages2.default.newCourses)
                                        )
                                    )
                                ),
                                this.isMathletics && _react2.default.createElement(
                                    'div',
                                    {
                                        className: _index2.default.infoContainer,
                                        onClick: function onClick() {
                                            return _this2.updateState('learningModule', { UPFSelected: !_this2.state.UPFSelected, LegacySelected: false, NewCoursesSelected: false });
                                        },
                                        role: 'button',
                                        tabIndex: 0 },
                                    _react2.default.createElement(
                                        _index8.default,
                                        {
                                            background: this.state.UPFSelected ? this.activeColor : this.defaultColor },
                                        _react2.default.createElement(
                                            'div',
                                            { className: this.state.UPFSelected ? _index2.default.info + ' ' + _index2.default.active : '' + _index2.default.info },
                                            intl.formatMessage(_messages2.default.skillQuests)
                                        )
                                    )
                                )
                            ),
                            _react2.default.createElement(
                                'div',
                                { className: _index2.default.courseRow },
                                this.renderCourses()
                            )
                        )
                    ),
                    _react2.default.createElement(
                        'div',
                        { className: _index2.default.rhsPanel },
                        this.shouldShowAssignedCourses() ? _react2.default.createElement(_index12.default, {
                            callbackAction: this.disableAssign,
                            handleOnCourseSelection: this.handleOnCourseSelection,
                            handleOnYearGroupSave: this.handleOnAssign,
                            handleViewCourse: handleViewCourse,
                            isLegacySelected: this.state.LegacySelected,
                            isNewCoursesSelected: this.state.NewCoursesSelected,
                            isUPFSelected: this.state.UPFSelected,
                            selectedCourse: this.state.selectedCourse
                        }) : null
                    )
                ),
                _react2.default.createElement(
                    'div',
                    { className: _index2.default.settingsFooter },
                    _react2.default.createElement(_index4.default, {
                        containerClassName: _index2.default.cancelButton,
                        disabled: assigningCourses,
                        handleOnClick: this.handleOnCancel,
                        label: intl.formatMessage(_messages2.default.cancel)
                    }),
                    _react2.default.createElement(_index4.default, {
                        containerClassName: _index2.default.saveButton,
                        disabled: assigningCourses || this.disableSave,
                        handleOnClick: this.saveAssignCourse,
                        label: intl.formatMessage(_messages2.default.save)
                    })
                ),
                _react2.default.createElement(
                    _index14.default,
                    { show: activateModal },
                    this.getModalContent()
                )
            );
        }
    }]);

    return assignCourseMapper;
}(_react.Component);

var _initialiseProps = function _initialiseProps() {
    var _this3 = this;

    this.handleOnCourseSelection = function (course) {
        var disableAssignToGroup = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

        _this3.disableAssignToGroup = disableAssignToGroup;
        _this3.setState({
            selectedCourse: _extends({}, course, {
                legacy: _this3.state.LegacySelected,
                newCourse: _this3.state.NewCoursesSelected,
                UPF: _this3.state.UPFSelected
            })
        });
    };

    this.checkForClasses = function (year) {
        var classrooms = _this3.props.classrooms;

        return !classrooms.find(function (item) {
            return item.yearGroupEnum === year;
        });
    };

    this.updateClassroomId = function (year) {
        var classrooms = _this3.props.classrooms;

        var classroom = classrooms.find(function (item) {
            return item.yearGroupEnum === year;
        });
        _this3.setState({ selectedClassroom: classroom.classroomId });
        _this3.updateClassroomGroupId(classroom.classroomId);
    };

    this.updateClassroomGroupId = function (classId) {
        var classrooms = _this3.props.classrooms;

        var classroom = classrooms.find(function (item) {
            return item.classroomId === classId;
        });
        var group = classroom.classroomGroups[0];
        _this3.setState({ selectedGroup: group.id });
    };

    this.renderYears = function () {
        var yearRows = null;
        var index = 0;
        var yearGroups = _this3.props.yearGroups;

        if (yearGroups) {
            yearRows = yearGroups.map(function (val) {
                index += 1;
                var rowStyle = _this3.checkForClasses(val.yearGroupEnum) ? '' + _index2.default.disabled : '' + _index2.default.selectable;
                return _react2.default.createElement(
                    'div',
                    {
                        className: rowStyle,
                        key: index,
                        onClick: function onClick() {
                            return _this3.updateState('year', val.yearGroupEnum);
                        },
                        role: 'button',
                        tabIndex: 0 },
                    _react2.default.createElement(
                        _index8.default,
                        {
                            background: val.yearGroupEnum === _this3.state.selectedYearGroup ? _this3.activeColor : _this3.defaultColor },
                        _react2.default.createElement(_index6.default, {
                            badgeStyle: _index2.default.yearGroup + ' yg' + val.yearGroupEnum,
                            content: val.shortName })
                    )
                );
            });
        }

        return yearRows;
    };

    this.renderYearClassrooms = function () {
        var _props2 = _this3.props,
            classrooms = _props2.classrooms,
            defaultData = _props2.defaultData;

        var classroomRows = null;
        var index = 0;
        if (classrooms) {
            var year = _this3.state.selectedYearGroup !== -1 ? _this3.state.selectedYearGroup : defaultData.DefaultYear;
            var filteredClassrooms = (0, _filter2.default)(classrooms, function (val) {
                if (val.yearGroupEnum === year) {
                    return true;
                }
                return false;
            });
            classroomRows = filteredClassrooms.map(function (val) {
                index += 1;
                return _react2.default.createElement(
                    'div',
                    {
                        className: _index2.default.infoContainer,
                        key: index,
                        onClick: function onClick() {
                            return _this3.updateState('class', val.classroomId);
                        },
                        role: 'button',
                        tabIndex: 0 },
                    _react2.default.createElement(
                        _index8.default,
                        {
                            background: val.classroomId === _this3.state.selectedClassroom ? _this3.activeColor : _this3.defaultColor },
                        _react2.default.createElement(
                            'div',
                            { className: val.classroomId === _this3.state.selectedClassroom ? _index2.default.info + ' ' + _index2.default.active : '' + _index2.default.info },
                            val.name
                        )
                    )
                );
            });
        }

        return classroomRows;
    };

    this.renderGroups = function () {
        var classrooms = _this3.props.classrooms;

        var groupRows = null;
        var index = 0;
        if (classrooms) {
            groupRows = _this3.getFilteredClassroom(classrooms).classroomGroups.map(function (val) {
                index += 1;
                return _react2.default.createElement(
                    'div',
                    {
                        className: _index2.default.infoContainer,
                        key: index,
                        onClick: function onClick() {
                            return _this3.updateState('group', val.id);
                        },
                        role: 'button',
                        tabIndex: 0 },
                    _react2.default.createElement(
                        _index8.default,
                        {
                            background: val.id === _this3.state.selectedGroup ? _this3.activeColor : _this3.defaultColor },
                        _react2.default.createElement(
                            'div',
                            { className: val.id === _this3.state.selectedGroup ? _index2.default.info + ' ' + _index2.default.active : '' + _index2.default.info },
                            val.name
                        )
                    )
                );
            });
        }

        return groupRows;
    };

    this.getUPFTitle = function (group) {
        if (group && group.upfCourseId > 0) {
            return group.upfCourseTitle;
        }

        return _this3.props.intl.formatMessage(_messages2.default.noCourseFound);
    };

    this.renderCourses = function () {
        var classroomList = _this3.classrooms;
        var group = null;
        if (_this3.classrooms) {
            var filteredClassroom = _this3.getFilteredClassroom(classroomList);
            if (_this3.state.selectedGroup !== -1) {
                group = _this3.getSelectedGroupInfo(filteredClassroom);
            }
            var showCancel = !!group.newCourseId;
            var courseName = '';
            if (_this3.state.LegacySelected) {
                courseName = group.newCourseId ? group.newCourseTitle : group.courseTitle;
            } else if (_this3.state.UPFSelected) {
                courseName = _this3.getUPFTitle(group);
            } else if (_this3.state.NewCoursesSelected) {
                courseName = group.conquestCourseTitle;
            }

            var viewCourseId = group.newCourseId || group.courseId;

            return _react2.default.createElement(
                'div',
                null,
                _react2.default.createElement(_index10.default, {
                    handleOnView: function handleOnView() {
                        return _this3.props.dispatch({ type: actionTypes.SHOW_COURSE_DETAILS, courseId: viewCourseId });
                    },
                    hideButton: !_this3.state.LegacySelected,
                    label: courseName,
                    showCancel: showCancel
                })
            );
        }

        return null;
    };

    this.addRemoveNewCourse = function (isAdd, assignedTasksIds, carryForward) {
        var clonedClassrooms = _this3.classrooms;
        var selectedCourse = _this3.state.selectedCourse;

        var classroom = _this3.getFilteredClassroom(clonedClassrooms);
        var group = _this3.getSelectedGroupInfo(classroom);

        if (_this3.state.LegacySelected) {
            group.newCourseTitle = isAdd ? selectedCourse.name : '';
            group.newCourseId = isAdd ? selectedCourse.id : 0;
            group.isOptedOut = false;
        } else if (_this3.state.UPFSelected) {
            group.upfCourseTitle = isAdd ? selectedCourse.name : '';
            group.upfCourseId = isAdd ? selectedCourse.id : 0;
            group.isOptedOut = selectedCourse.id === 0;
        } else {
            group.conquestCourseTitle = isAdd ? selectedCourse.name : '';
            group.conquestCourseId = isAdd ? selectedCourse.id : _constants.DEFAULT_NEW_COURSE_ID;
            group.isOptedOut = false;
        }

        group.assignedTasksIds = assignedTasksIds;
        group.isUpdated = isAdd || false;
        group.carryForward = carryForward || false;

        if (classroom.classroomGroups.find(function (val) {
            return !!val.isUpdated;
        })) {
            classroom.isUpdated = true;
        } else {
            classroom.isUpdated = isAdd || false;
        }
        if (!isAdd) {
            _this3.setState({
                isUpdated: true
            });
        }

        _this3.disableSave = !_this3.classrooms.find(function (val) {
            return !!val.isUpdated;
        });
        _this3.disableAssign();
    };

    this.saveAssignCourse = function () {
        var classrooms = _this3.classrooms;
        var changedCourseList = [];
        var updatedClassrooms = (0, _filter2.default)(classrooms, function (val) {
            return !!val.isUpdated;
        });

        (0, _forEach2.default)(updatedClassrooms, function (classroom) {
            var updatedGroups = classroom.classroomGroups.filter(function (val) {
                return !!val.isUpdated;
            });

            updatedGroups.forEach(function (group) {
                var courseInfo = {};
                courseInfo.classroomId = classroom.classroomId;
                courseInfo.groupId = group.id;
                courseInfo.carryForward = group.carryForward;
                courseInfo.assignedTaskIds = group.assignedTasksIds;

                courseInfo.courseId = group.newCourseId !== undefined ? group.newCourseId : group.courseId;
                courseInfo.upfCourseId = group.upfCourseId;
                courseInfo.isOptedOut = !group.upfCourseId;

                courseInfo.conquestCourseId = group.conquestCourseId;

                changedCourseList.push(courseInfo);
            });
        });

        _this3.props.handleOnSaveAssignCourses(changedCourseList);
    };

    this.getFilteredClassroom = function (classrooms) {
        var classId = _this3.state.selectedClassroom !== -1 ? _this3.state.selectedClassroom : classrooms[0].classroomId;
        return classrooms.find(function (item) {
            return item.classroomId === classId;
        });
    };

    this.getSelectedGroupInfo = function (classroom) {
        return classroom.classroomGroups.find(function (item) {
            return item.id === _this3.state.selectedGroup;
        });
    };

    this.updateState = function (type, val) {
        switch (type) {
            case 'year':
                _this3.setState({ selectedYearGroup: val });
                _this3.updateClassroomId(val);
                break;
            case 'class':
                _this3.setState({ selectedClassroom: val });
                _this3.updateClassroomGroupId(val);
                break;
            case 'group':
                _this3.setState({ selectedGroup: val });
                break;
            case 'learningModule':
                _this3.setState(_extends({}, val, {
                    selectedCourse: _extends({}, _this3.state.selectedCourse, {
                        legacy: val.LegacySelected === true,
                        UPF: val.UPFSelected,
                        newCourse: val.NewCoursesSelected
                    })
                }));
                break;
            default:
                break;
        }
    };

    this.closeModal = function (cancelConfirmationModalRequest) {
        if (cancelConfirmationModalRequest) {
            _this3.showCancelConfirmation = false;
        }
        _this3.props.dispatch({ type: actionTypes.DEACTIVATE_MODAL_REQUEST });
    };

    this.openModal = function () {
        _this3.props.dispatch({ type: actionTypes.ACTIVATE_MODAL_REQUEST });
    };

    this.handleTaskCarryForward = function (event) {
        var _props3 = _this3.props,
            assignedTasksId = _props3.assignedTasksId,
            upfCourseId = _props3.upfCourseId;

        _this3.props.dispatch({ type: actionTypes.CANCEL_ASSIGN_REQUEST });

        switch (event) {
            case 'handleOnBack':
                _this3.disableAssign();
                break;
            case 'handleOnCarryTask':
                _this3.addRemoveNewCourse(true, assignedTasksId, true, upfCourseId);
                break;
            case 'handleOnCarryTaskCancel':
                _this3.addRemoveNewCourse(true, assignedTasksId, false, upfCourseId);
                break;
            default:
                break;
        }

        _this3.closeModal();
    };

    this.getModalContent = function () {
        var _props4 = _this3.props,
            intl = _props4.intl,
            assignedTasksId = _props4.assignedTasksId,
            showAssignErrorModal = _props4.showAssignErrorModal,
            showSaveErrorModal = _props4.showSaveErrorModal,
            isAssignEvent = _props4.isAssignEvent,
            upfCourseId = _props4.upfCourseId;

        var content = null;
        var message = null;
        if (_this3.showCancelConfirmation) {
            content = _react2.default.createElement(_index18.default, {
                handleOnCancel: function handleOnCancel() {
                    return _this3.closeModal(true);
                },
                handleOnOk: _this3.handleOnConfirm,
                icon: _iconDictionary.Warning,
                title: intl.formatMessage(_messages2.default.cancelWarningMessage) });
        } else if (!showAssignErrorModal && !showSaveErrorModal) {
            if (assignedTasksId.length > 0) {
                content = _react2.default.createElement(_taskCarryForward2.default, {
                    commonTasks: assignedTasksId.length,
                    handleOnBack: function handleOnBack() {
                        return _this3.handleTaskCarryForward('handleOnBack');
                    },
                    handleOnCarryTask: function handleOnCarryTask() {
                        return _this3.handleTaskCarryForward('handleOnCarryTask');
                    },
                    handleOnCarryTaskCancel: function handleOnCarryTaskCancel() {
                        return _this3.handleTaskCarryForward('handleOnCarryTaskCancel');
                    } });
            } else if (isAssignEvent) {
                _this3.addRemoveNewCourse(true, assignedTasksId, false, upfCourseId);
            }
        } else {
            message = showAssignErrorModal ? intl.formatMessage(_messages2.default.assignErrorMessage) : intl.formatMessage(_messages2.default.saveErrorMessage);

            content = _react2.default.createElement(_index16.default, {
                handleOnCloseModal: _this3.closeModal,
                icon: _iconDictionary.Warning,
                title: message });
        }

        return content;
    };

    this.handleOnAssign = function () {
        var _state = _this3.state,
            selectedClassroom = _state.selectedClassroom,
            selectedGroup = _state.selectedGroup,
            selectedCourse = _state.selectedCourse,
            UPFSelected = _state.UPFSelected,
            LegacySelected = _state.LegacySelected,
            NewCoursesSelected = _state.NewCoursesSelected;


        _this3.props.handleOnAssign({
            classroomId: selectedClassroom,
            groupId: selectedGroup,
            courseId: selectedCourse.id,
            isUPFSelected: UPFSelected,
            isLegacySelected: LegacySelected,
            isNewCoursesSelected: NewCoursesSelected
        });
    };

    this.handleOnCancel = function () {
        var classrooms = _this3.classrooms;
        if (!classrooms.find(function (val) {
            return !!val.isUpdated;
        })) {
            _portalComms2.default.navigateToLandingScreen('Course admin');
        } else {
            _this3.showCancelConfirmation = true;
            _this3.openModal();
        }
    };

    this.handleOnConfirm = function () {
        _this3.showCancelConfirmation = false;
        _portalComms2.default.navigateToLandingScreen('Course admin');
    };

    this.disableAssign = function () {
        _this3.disableAssignToGroup = true;
    };

    this.shouldShowAssignedCourses = function () {
        var _state2 = _this3.state,
            selectedYearGroup = _state2.selectedYearGroup,
            selectedClassroom = _state2.selectedClassroom,
            selectedGroup = _state2.selectedGroup,
            UPFSelected = _state2.UPFSelected,
            LegacySelected = _state2.LegacySelected,
            NewCoursesSelected = _state2.NewCoursesSelected;

        return selectedYearGroup !== undefined && selectedYearGroup !== null && selectedClassroom && selectedGroup && (UPFSelected || LegacySelected || NewCoursesSelected);
    };

    this.shouldShowNewCourses = function () {
        var selectedYearGroup = _this3.state.selectedYearGroup;

        return (0, _utils.newCoursesAvailable)(selectedYearGroup);
    };
};

assignCourseMapper.propTypes = {
    intl: _reactIntl.intlShape.isRequired,
    classrooms: _propTypes2.default.arrayOf(_propTypes2.default.object),
    yearGroups: _propTypes2.default.array,
    defaultData: _propTypes2.default.object,
    handleOnAssign: _propTypes2.default.func,
    handleOnSaveAssignCourses: _propTypes2.default.func,
    handleViewCourse: _propTypes2.default.func,
    assignedTasksId: _propTypes2.default.array,
    upfCourseId: _propTypes2.default.number,
    showAssignErrorModal: _propTypes2.default.bool,
    showSaveErrorModal: _propTypes2.default.bool,
    activateModal: _propTypes2.default.bool,
    assigningCourses: _propTypes2.default.bool,
    isAssignEvent: _propTypes2.default.bool,
    dispatch: _propTypes2.default.func.isRequired,
    selectedProduct: _propTypes2.default.object
};

exports.default = (0, _reactIntl.injectIntl)((0, _reactStyleable2.default)(_index2.default)(assignCourseMapper));

/***/ }),
/* 641 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactStyleable = __webpack_require__(6);

var _reactStyleable2 = _interopRequireDefault(_reactStyleable);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactIntl = __webpack_require__(2);

var _iconDictionary = __webpack_require__(8);

var _svgIcon = __webpack_require__(21);

var _svgIcon2 = _interopRequireDefault(_svgIcon);

var _index = __webpack_require__(7);

var _index2 = _interopRequireDefault(_index);

var _index3 = __webpack_require__(587);

var _index4 = _interopRequireDefault(_index3);

var _variants = __webpack_require__(9);

var _messages = __webpack_require__(378);

var _messages2 = _interopRequireDefault(_messages);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TaskCarryForwardConfirmation = function TaskCarryForwardConfirmation(props) {
    var intl = props.intl,
        commonTasks = props.commonTasks,
        handleOnBack = props.handleOnBack,
        handleOnCarryTaskCancel = props.handleOnCarryTaskCancel,
        handleOnCarryTask = props.handleOnCarryTask;


    return _react2.default.createElement(
        'div',
        { className: _index4.default.confirmationContainer },
        _react2.default.createElement(
            'div',
            { className: _index4.default.icon },
            _react2.default.createElement(_svgIcon2.default, { icon: _iconDictionary.Warning })
        ),
        _react2.default.createElement(
            'div',
            { className: _index4.default.confirmTitle },
            intl.formatMessage(_messages2.default.tasksCarryForwardMessage1, { commonTasks: commonTasks })
        ),
        _react2.default.createElement(
            'div',
            { className: _index4.default.confirmTitle },
            intl.formatMessage(_messages2.default.tasksCarryForwardMessage2)
        ),
        _react2.default.createElement(
            'div',
            { className: _index4.default.confirmBtnContainer },
            _react2.default.createElement(
                'div',
                { className: _index4.default.spacing },
                _react2.default.createElement(_index2.default, {
                    handleOnClick: handleOnBack,
                    label: intl.formatMessage(_messages2.default.back),
                    variant: _variants.DARK })
            ),
            _react2.default.createElement(
                'div',
                { className: _index4.default.spacing },
                _react2.default.createElement(_index2.default, {
                    handleOnClick: handleOnCarryTaskCancel,
                    label: intl.formatMessage(_messages2.default.no),
                    variant: _variants.DARK })
            ),
            _react2.default.createElement(_index2.default, {
                handleOnClick: handleOnCarryTask,
                label: intl.formatMessage(_messages2.default.yes),
                variant: _variants.DARK })
        )
    );
};

TaskCarryForwardConfirmation.propTypes = {
    intl: _reactIntl.intlShape.isRequired,
    commonTasks: _propTypes2.default.number,
    handleOnBack: _propTypes2.default.func,
    handleOnCarryTaskCancel: _propTypes2.default.func,
    handleOnCarryTask: _propTypes2.default.func
};

exports.default = (0, _reactIntl.injectIntl)((0, _reactStyleable2.default)(_index4.default)(TaskCarryForwardConfirmation));

/***/ }),
/* 642 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactIntl = __webpack_require__(2);

var _reactStyleable = __webpack_require__(6);

var _reactStyleable2 = _interopRequireDefault(_reactStyleable);

var _assignCourseFilter = __webpack_require__(643);

var _assignCourseFilter2 = _interopRequireDefault(_assignCourseFilter);

var _selectCourse = __webpack_require__(644);

var _selectCourse2 = _interopRequireDefault(_selectCourse);

var _index = __webpack_require__(367);

var _index2 = _interopRequireDefault(_index);

var _index3 = __webpack_require__(7);

var _index4 = _interopRequireDefault(_index3);

var _messages = __webpack_require__(250);

var _messages2 = _interopRequireDefault(_messages);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var AssignCourseUPF = function AssignCourseUPF(props) {
    return _react2.default.createElement(
        'div',
        { className: _index2.default.assignCourse },
        _react2.default.createElement(_assignCourseFilter2.default, props),
        _react2.default.createElement(_selectCourse2.default, props),
        _react2.default.createElement(
            'div',
            { className: _index2.default.footer },
            _react2.default.createElement(_index4.default, {
                containerClassName: _index2.default.assignToYear,
                disabled: props.disableAssignToYear,
                handleOnClick: function handleOnClick() {
                    return props.assignToYearGroup('upf');
                },
                label: props.forYear ? props.intl.formatMessage(_messages2.default.assignToYear) : props.intl.formatMessage(_messages2.default.assignToGroup)
            })
        )
    );
};

AssignCourseUPF.propTypes = {
    intl: _reactIntl.intlShape.isRequired,
    assignToYearGroup: _propTypes2.default.func.isRequired,
    disableAssignToYear: _propTypes2.default.bool.isRequired,
    forLegacy: _propTypes2.default.bool,
    forYear: _propTypes2.default.bool,
    handleOptOutOfCourse: _propTypes2.default.func,
    isUPFSelected: _propTypes2.default.bool
};

exports.default = (0, _reactIntl.injectIntl)((0, _reactStyleable2.default)(_index2.default)(AssignCourseUPF));

/***/ }),
/* 643 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactStyleable = __webpack_require__(6);

var _reactStyleable2 = _interopRequireDefault(_reactStyleable);

var _reactIntl = __webpack_require__(2);

var _index = __webpack_require__(367);

var _index2 = _interopRequireDefault(_index);

var _search = __webpack_require__(1668);

var _search2 = _interopRequireDefault(_search);

var _index3 = __webpack_require__(37);

var _index4 = _interopRequireDefault(_index3);

var _constant = __webpack_require__(151);

var _messages = __webpack_require__(250);

var _messages2 = _interopRequireDefault(_messages);

var _constants = __webpack_require__(96);

var _constants2 = _interopRequireDefault(_constants);

var _textInput = __webpack_require__(48);

var _textInput2 = _interopRequireDefault(_textInput);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var AssignCourseFilter = function AssignCourseFilter(props) {
    var intl = props.intl,
        yearGroups = props.yearGroups,
        countries = props.countries,
        handleOnYearGroupChange = props.handleOnYearGroupChange,
        handleOnCountryChange = props.handleOnCountryChange,
        handleOnSearchCourse = props.handleOnSearchCourse,
        searchQuery = props.searchQuery,
        disableSearch = props.disableSearch,
        disableYearGroup = props.disableYearGroup,
        forLegacy = props.forLegacy,
        selectedYearGroupId = props.selectedYearGroupId,
        isLoadingCountryYearGroups = props.isLoadingCountryYearGroups,
        forManageDefaultCourses = props.forManageDefaultCourses,
        isNewCoursesSelected = props.isNewCoursesSelected,
        selectedCountryId = props.selectedCountryId,
        isLegacySelected = props.isLegacySelected;


    var countriesList = countries.slice(0);

    if (forLegacy) {
        countriesList.unshift({
            name: intl.formatMessage(_messages2.default.schoolCourses),
            code: _constants2.default.SCHOOL_COURSES
        });
    }

    var clearText = true;

    var getSubHeading = function getSubHeading() {
        if (isNewCoursesSelected) {
            return intl.formatMessage(_messages2.default.newCourses);
        } else if (isLegacySelected) {
            return intl.formatMessage(_messages2.default.courses);
        }

        return intl.formatMessage(_messages2.default.skillQuests);
    };

    return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
            'div',
            { className: _index2.default.defaultCourse },
            _react2.default.createElement(
                'div',
                { className: _index2.default.heading },
                intl.formatMessage(_messages2.default[forManageDefaultCourses ? 'startCourse' : 'setDefaultCourse'])
            ),
            _react2.default.createElement(
                'div',
                { className: _index2.default.subHeading },
                getSubHeading()
            ),
            _react2.default.createElement(_index4.default, {
                name: 'countries',
                onChange: handleOnCountryChange,
                optionKey: 'code',
                options: countriesList,
                optionText: 'name',
                placeholder: intl.formatMessage(_messages2.default.defaultOptionCountry),
                value: selectedCountryId,
                variant: _constant.FULL_WIDTH
            }),
            _react2.default.createElement(_index4.default, {
                disabled: disableYearGroup,
                isLoading: isLoadingCountryYearGroups,
                name: 'yearGroups',
                onChange: handleOnYearGroupChange,
                optionKey: 'yearGroupEnum',
                options: yearGroups,
                optionText: 'longName',
                placeholder: intl.formatMessage(_messages2.default.selectGroup),
                value: selectedYearGroupId,
                variant: _constant.FULL_WIDTH
            }),
            _react2.default.createElement(
                'div',
                { className: _index2.default.searchContainer },
                _react2.default.createElement(_textInput2.default, {
                    clearText: clearText,
                    css: _search2.default,
                    disabled: disableSearch,
                    handleOnChange: handleOnSearchCourse,
                    placeholder: intl.formatMessage(_messages2.default.searchCourse),
                    type: 'text',
                    value: searchQuery
                })
            )
        )
    );
};

AssignCourseFilter.propTypes = {
    intl: _reactIntl.intlShape.isRequired,
    yearGroups: _propTypes2.default.array,
    countries: _propTypes2.default.array,
    handleOnYearGroupChange: _propTypes2.default.func,
    handleOnCountryChange: _propTypes2.default.func,
    handleOnSearchCourse: _propTypes2.default.func,
    searchQuery: _propTypes2.default.string,
    disableSearch: _propTypes2.default.bool,
    disableYearGroup: _propTypes2.default.bool,
    forLegacy: _propTypes2.default.bool,
    isLoadingCountryYearGroups: _propTypes2.default.bool,
    selectedYearGroupId: _propTypes2.default.string,
    selectedCountryId: _propTypes2.default.string,
    forManageDefaultCourses: _propTypes2.default.bool,
    isNewCoursesSelected: _propTypes2.default.bool,
    isLegacySelected: _propTypes2.default.bool
};

AssignCourseFilter.defaultProps = {
    forManageDefaultCourses: false
};

exports.default = (0, _reactIntl.injectIntl)((0, _reactStyleable2.default)(_index2.default)(AssignCourseFilter));

/***/ }),
/* 644 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactStyleable = __webpack_require__(6);

var _reactStyleable2 = _interopRequireDefault(_reactStyleable);

var _PulseLoader = __webpack_require__(60);

var _PulseLoader2 = _interopRequireDefault(_PulseLoader);

var _reactIntl = __webpack_require__(2);

var _index = __webpack_require__(367);

var _index2 = _interopRequireDefault(_index);

var _messages = __webpack_require__(250);

var _messages2 = _interopRequireDefault(_messages);

var _index3 = __webpack_require__(76);

var _index4 = _interopRequireDefault(_index3);

var _index5 = __webpack_require__(261);

var _index6 = _interopRequireDefault(_index5);

var _actionTypes = __webpack_require__(97);

var actionTypes = _interopRequireWildcard(_actionTypes);

var _utils = __webpack_require__(13);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SelectCourse = function SelectCourse(props) {
    var intl = props.intl,
        filteredCourses = props.filteredCourses,
        handleOnCourseSelection = props.handleOnCourseSelection,
        isProductCoursesLoaded = props.isProductCoursesLoaded,
        initialLoad = props.initialLoad,
        dispatch = props.dispatch,
        forLegacy = props.forLegacy,
        selectedCountryId = props.selectedCountryId,
        selectedYearGroupId = props.selectedYearGroupId,
        isNewCoursesLoaded = props.isNewCoursesLoaded,
        isNewCoursesSelected = props.isNewCoursesSelected;

    function displayCourses() {
        if (isNewCoursesLoaded && !isProductCoursesLoaded && !initialLoad) {
            return _react2.default.createElement(
                'div',
                { className: _index2.default.loader },
                _react2.default.createElement(_PulseLoader2.default, { color: 'grey', size: '15px' })
            );
        }

        if (!filteredCourses.length || isNewCoursesSelected && !(0, _utils.newCoursesAvailable)(selectedYearGroupId, selectedCountryId)) {
            return _react2.default.createElement(
                'div',
                { className: _index2.default.empty },
                _react2.default.createElement(_index4.default, { message: intl.formatMessage(_messages2.default.noCoursesFound) })
            );
        }

        return filteredCourses.map(function (course) {
            return _react2.default.createElement(
                'div',
                { className: _index2.default.courseRow, key: 'row_' + course.id },
                _react2.default.createElement(
                    'button',
                    {
                        className: course.isSelected ? _index2.default.courseSelected : _index2.default.course,
                        key: course.id,
                        onClick: function onClick() {
                            return handleOnCourseSelection({ id: course.id, name: course.name });
                        } },
                    course.name
                ),
                forLegacy && _react2.default.createElement(_index6.default, { handleOnClick: function handleOnClick() {
                        return dispatch({ type: actionTypes.SHOW_COURSE_DETAILS, courseId: course.id });
                    } })
            );
        });
    }

    return _react2.default.createElement(
        'div',
        { className: _index2.default.selectCourseContainer },
        _react2.default.createElement(
            'div',
            { className: _index2.default.courseHeader },
            intl.formatMessage(_messages2.default.selectCourse).toUpperCase()
        ),
        _react2.default.createElement(
            'div',
            { className: _index2.default.selectCourse },
            displayCourses()
        )
    );
};

SelectCourse.propTypes = {
    intl: _reactIntl.intlShape.isRequired,
    filteredCourses: _propTypes2.default.array,
    handleOnCourseSelection: _propTypes2.default.func,
    isProductCoursesLoaded: _propTypes2.default.bool,
    isNewCoursesSelected: _propTypes2.default.bool,
    isNewCoursesLoaded: _propTypes2.default.bool,
    initialLoad: _propTypes2.default.bool,
    dispatch: _propTypes2.default.func.isRequired,
    forLegacy: _propTypes2.default.bool,
    selectedCountryId: _propTypes2.default.string,
    selectedYearGroupId: _propTypes2.default.string
};

exports.default = (0, _reactIntl.injectIntl)((0, _reactStyleable2.default)(_index2.default)(SelectCourse));

/***/ }),
/* 645 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactStyleable = __webpack_require__(6);

var _reactStyleable2 = _interopRequireDefault(_reactStyleable);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _clone = __webpack_require__(122);

var _clone2 = _interopRequireDefault(_clone);

var _index = __webpack_require__(1669);

var _index2 = _interopRequireDefault(_index);

var _index3 = __webpack_require__(149);

var _index4 = _interopRequireDefault(_index3);

var _index5 = __webpack_require__(729);

var _index6 = _interopRequireDefault(_index5);

var _utils = __webpack_require__(13);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var AssignItem = function (_Component) {
    _inherits(AssignItem, _Component);

    function AssignItem(props) {
        _classCallCheck(this, AssignItem);

        var _this = _possibleConstructorReturn(this, (AssignItem.__proto__ || Object.getPrototypeOf(AssignItem)).call(this, props));

        _initialiseProps.call(_this);

        var _this$props = _this.props,
            child = _this$props.child,
            isExpandable = _this$props.isExpandable,
            info = _this$props.info,
            disabled = _this$props.disabled;

        _this.state = {
            style: _this.setStyle(info, disabled),
            children: isExpandable ? child.data : [],
            showChildren: false
        };
        return _this;
    }

    _createClass(AssignItem, [{
        key: 'componentWillReceiveProps',
        value: function componentWillReceiveProps(nextProps) {
            if (nextProps.info.selected !== undefined) {
                var info = nextProps.info,
                    disabled = nextProps.disabled;

                this.setState({ style: this.setStyle(info, disabled) });
            }
        }
    }, {
        key: 'render',
        value: function render() {
            var _this2 = this;

            var index = 0;
            var additionalInfo = null;
            var _props = this.props,
                info = _props.info,
                child = _props.child,
                isExpandable = _props.isExpandable,
                name = _props.name,
                id = _props.id;

            var groups = this.state.children.map(function (val) {
                index += 1;
                val.classId = id;
                return _react2.default.createElement(_index6.default, {
                    group: val,
                    isMultiSelect: child.isMultiSelect,
                    key: id + '_' + val.id + '_' + index,
                    onGroupSelection: _this2.onGroupSelection });
            });

            if (info.additionalInfo.length > 0) {
                additionalInfo = info.additionalInfo.map(function (val) {
                    val = (0, _utils.truncateCharacters)('teacher', val);
                    return _react2.default.createElement(
                        'div',
                        { key: val + '_' + index },
                        val
                    );
                });
            }

            return _react2.default.createElement(
                'div',
                null,
                _react2.default.createElement(
                    'div',
                    { className: this.state.style },
                    _react2.default.createElement(
                        'div',
                        { className: _index2.default.checkbox },
                        _react2.default.createElement('input', {
                            checked: info.selected,
                            className: _index2.default.name,
                            id: this.props.elementId,
                            onChange: this.onSelection,
                            type: 'checkbox'
                        }),
                        _react2.default.createElement('label', { className: _index2.default.chklabel, htmlFor: this.props.elementId }),
                        _react2.default.createElement(
                            'span',
                            { className: _index2.default.className },
                            name
                        )
                    ),
                    _react2.default.createElement(
                        'div',
                        { className: _index2.default.yearGroupContainer },
                        _react2.default.createElement(_index4.default, {
                            badgeStyle: _index2.default.yearGroup + ' ' + info.badgeStyle,
                            content: info.badgeContent })
                    ),
                    _react2.default.createElement(
                        'div',
                        { className: _index2.default.additionalInfo },
                        additionalInfo
                    )
                ),
                _react2.default.createElement(
                    'div',
                    { className: _index2.default.childContainer },
                    isExpandable && this.state.showChildren && child.data.length > 0 ? groups : null
                )
            );
        }
    }]);

    return AssignItem;
}(_react.Component);

var _initialiseProps = function _initialiseProps() {
    var _this3 = this;

    this.setStyle = function (info, disabled) {
        if (disabled) {
            return '' + _index2.default.disableListItem;
        } else if (info.selected) {
            return _index2.default.info + ' ' + _index2.default.highlight;
        }

        return '' + _index2.default.info;
    };

    this.onSelection = function (element) {
        var checked = element.target.checked;
        var isExpandable = _this3.props.isExpandable;

        if (checked) {
            _this3.setState({
                style: _index2.default.info + ' ' + _index2.default.highlight,
                showChildren: isExpandable ? checked : false
            });
        } else {
            _this3.setState({
                style: '' + _index2.default.info,
                showChildren: isExpandable ? checked : false
            });
        }

        _this3.props.handleOnItemSelection(element.target.id, checked);
    };

    this.onGroupSelection = function (element) {
        var classGroups = (0, _clone2.default)(_this3.state.children);
        var id = _this3.props.id;

        classGroups = classGroups.map(function (group) {
            if (group.id === parseInt(element.target.id.split('_')[1], 10)) {
                group.isDefault = true;
                group.isAssigned = true;
            } else {
                group.isDefault = false;
                group.isAssigned = false;
            }

            return group;
        });

        _this3.setState({ children: classGroups });
        _this3.props.handleOnChildSelection(id, classGroups);
    };
};

AssignItem.propTypes = {
    id: _propTypes2.default.number,
    elementId: _propTypes2.default.string,
    name: _propTypes2.default.string,
    info: _propTypes2.default.object,
    disabled: _propTypes2.default.bool,
    isExpandable: _propTypes2.default.bool,
    child: _propTypes2.default.object,
    handleOnItemSelection: _propTypes2.default.func,
    handleOnChildSelection: _propTypes2.default.func
};

exports.default = (0, _reactStyleable2.default)(_index2.default)(AssignItem);

/***/ }),
/* 646 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactStyleable = __webpack_require__(6);

var _reactStyleable2 = _interopRequireDefault(_reactStyleable);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactIntl = __webpack_require__(2);

var _index = __webpack_require__(1670);

var _index2 = _interopRequireDefault(_index);

var _messages = __webpack_require__(379);

var _messages2 = _interopRequireDefault(_messages);

var _index3 = __webpack_require__(7);

var _index4 = _interopRequireDefault(_index3);

var _index5 = __webpack_require__(647);

var _index6 = _interopRequireDefault(_index5);

var _utils = __webpack_require__(13);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var AssignUser = function (_Component) {
    _inherits(AssignUser, _Component);

    function AssignUser(props) {
        _classCallCheck(this, AssignUser);

        var _this = _possibleConstructorReturn(this, (AssignUser.__proto__ || Object.getPrototypeOf(AssignUser)).call(this, props));

        _this.renderHtmlElements = function () {
            var unassignedList = [];
            var assignedList = [];
            var _this$props = _this.props,
                type = _this$props.type,
                data = _this$props.data,
                selectedYearGroup = _this$props.selectedYearGroup;


            switch (type) {
                case 'student':
                case 'teacher':
                    if (data) {
                        var _iteratorNormalCompletion = true;
                        var _didIteratorError = false;
                        var _iteratorError = undefined;

                        try {
                            for (var _iterator = data[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                                var classroom = _step.value;

                                if (classroom.isAssigned) {
                                    assignedList.push(classroom);
                                } else {
                                    unassignedList.push(classroom);
                                }
                            }
                        } catch (err) {
                            _didIteratorError = true;
                            _iteratorError = err;
                        } finally {
                            try {
                                if (!_iteratorNormalCompletion && _iterator.return) {
                                    _iterator.return();
                                }
                            } finally {
                                if (_didIteratorError) {
                                    throw _iteratorError;
                                }
                            }
                        }

                        _this.list = (0, _utils.generateStudentTeacherAssignList)(assignedList, unassignedList, selectedYearGroup, type, _this.listObject);
                    }
                    break;
                default:
                    if (data) {
                        _this.list = (0, _utils.generateClassroomAssignList)(data, _this.listObject);
                        break;
                    }
            }
        };

        _this.handleOnChildSelection = function (itemId, groups) {
            _this.props.handleOnChildSelection(itemId, groups);
        };

        _this.handleOnYearGroupSelection = function (name, val) {
            _this.setState({ selectedYearGroup: val });
            _this.props.handleOnYearGroupSelection(name, val);
        };

        _this.handleOnClassroomSelection = function (id) {
            _this.props.handleOnClassroomSelection(parseInt(id, 10));
        };

        _this.handleOnAssignItem = function (assignedListItemIds) {
            _this.props.handleOnAssignItem(assignedListItemIds);
        };

        _this.handleOnUnAssignItem = function (unAssignedListItemIds) {
            _this.props.handleOnUnAssignItem(unAssignedListItemIds);
        };

        _this.closeHandler = function () {
            _this.props.handleOnClose();
        };

        _this.saveHandler = function () {
            _this.setState({
                enableForwardButton: false,
                enableBackButton: false
            });

            _this.props.handleOnSave();
        };

        _this.list = { assignData: [], unassignData: [] };
        _this.listObject = {
            groups: [],
            isExpandable: false,
            info: {
                additionalInfo: [],
                badgeContent: '',
                badgeStyle: ''
            },
            child: {
                data: [],
                isMultiSelect: false
            }
        };
        return _this;
    }

    _createClass(AssignUser, [{
        key: 'render',
        value: function render() {
            this.renderHtmlElements();
            var _props = this.props,
                intl = _props.intl,
                header = _props.header,
                selectedYearGroup = _props.selectedYearGroup,
                type = _props.type,
                yearGroups = _props.yearGroups,
                disableAssignCancelButton = _props.disableAssignCancelButton,
                disableAssignSaveButton = _props.disableAssignSaveButton,
                isSaveInProgress = _props.isSaveInProgress;

            var pageHeading = type === 'class' ? intl.formatMessage(_messages2.default.assignedTeachers) + ' ' : intl.formatMessage(_messages2.default.assignedClasses) + ' ';
            return _react2.default.createElement(
                'div',
                { className: _index2.default.assignContainer },
                _react2.default.createElement(
                    'div',
                    { className: _index2.default.mainHeader },
                    pageHeading,
                    _react2.default.createElement(
                        'span',
                        {
                            className: _index2.default.headerDescription },
                        header
                    )
                ),
                _react2.default.createElement(_index6.default, {
                    handleOnAssignItem: this.handleOnAssignItem,
                    handleOnChildSelection: this.handleOnChildSelection,
                    handleOnClassroomSelection: this.handleOnClassroomSelection,
                    handleOnSearchClick: this.props.handleOnSearchClick,
                    handleOnUnAssignItem: this.handleOnUnAssignItem,
                    handleOnYearGroupSelection: this.handleOnYearGroupSelection,
                    header: header,
                    isSaveInProgress: isSaveInProgress,
                    leftList: this.list.unassignData,
                    rightList: this.list.assignData,
                    selectedYearGroup: selectedYearGroup,
                    type: type,
                    yearGroups: yearGroups
                }),
                _react2.default.createElement(
                    'div',
                    { className: _index2.default.assignFooter },
                    _react2.default.createElement(_index4.default, {
                        containerClassName: _index2.default.cancelButton,
                        disabled: disableAssignCancelButton,
                        handleOnClick: this.closeHandler,
                        label: intl.formatMessage(_messages2.default.cancel) }),
                    _react2.default.createElement(_index4.default, {
                        containerClassName: _index2.default.saveButton,
                        disabled: disableAssignSaveButton,
                        handleOnClick: this.saveHandler,
                        label: intl.formatMessage(_messages2.default.save)
                    })
                )
            );
        }
    }]);

    return AssignUser;
}(_react.Component);

AssignUser.propTypes = {
    header: _propTypes2.default.string,
    data: _propTypes2.default.array,
    type: _propTypes2.default.string,
    intl: _reactIntl.intlShape.isRequired,
    yearGroups: _propTypes2.default.array,
    isSaveInProgress: _propTypes2.default.bool,
    selectedYearGroup: _propTypes2.default.string,
    handleOnClassroomSelection: _propTypes2.default.func,
    handleOnChildSelection: _propTypes2.default.func,
    handleOnYearGroupSelection: _propTypes2.default.func,
    disableAssignSaveButton: _propTypes2.default.bool,
    disableAssignCancelButton: _propTypes2.default.bool,
    handleOnClose: _propTypes2.default.func,
    handleOnSave: _propTypes2.default.func,
    handleOnSearchClick: _propTypes2.default.func,
    handleOnAssignItem: _propTypes2.default.func,
    handleOnUnAssignItem: _propTypes2.default.func
};

exports.default = (0, _reactIntl.injectIntl)((0, _reactStyleable2.default)(_index2.default)(AssignUser));

/***/ }),
/* 647 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactStyleable = __webpack_require__(6);

var _reactStyleable2 = _interopRequireDefault(_reactStyleable);

var _reactIntl = __webpack_require__(2);

var _clone = __webpack_require__(122);

var _clone2 = _interopRequireDefault(_clone);

var _cloneDeep = __webpack_require__(54);

var _cloneDeep2 = _interopRequireDefault(_cloneDeep);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _index = __webpack_require__(1671);

var _index2 = _interopRequireDefault(_index);

var _index3 = __webpack_require__(37);

var _index4 = _interopRequireDefault(_index3);

var _index5 = __webpack_require__(190);

var _index6 = _interopRequireDefault(_index5);

var _iconDictionary = __webpack_require__(8);

var _index7 = __webpack_require__(7);

var _index8 = _interopRequireDefault(_index7);

var _index9 = __webpack_require__(645);

var _index10 = _interopRequireDefault(_index9);

var _index11 = __webpack_require__(76);

var _index12 = _interopRequireDefault(_index11);

var _messages = __webpack_require__(379);

var _messages2 = _interopRequireDefault(_messages);

var _messages3 = __webpack_require__(648);

var _messages4 = _interopRequireDefault(_messages3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Assign = function (_Component) {
    _inherits(Assign, _Component);

    function Assign(props) {
        _classCallCheck(this, Assign);

        var _this = _possibleConstructorReturn(this, (Assign.__proto__ || Object.getPrototypeOf(Assign)).call(this, props));

        _this.assignItem = function () {
            _this.props.handleOnAssignItem(_this.state.assignedListItemIds);
            _this.setState({ assignedListItemIds: [], enableForwardButton: false });
        };

        _this.unAssignItem = function () {
            _this.props.handleOnUnAssignItem(_this.state.unAssignedListItemIds);
            _this.setState({ unAssignedListItemIds: [], enableBackButton: false });
        };

        _this.updateItems = function (clonedObject, itemId, checked) {
            if (checked) {
                return clonedObject.concat(parseInt(itemId, 10));
            }
            var filteredArray = clonedObject.filter(function (val) {
                return val !== parseInt(itemId, 10);
            });
            return filteredArray;
        };

        _this.handleOnItemSelection = function (element, checked) {
            var _this$props = _this.props,
                isSaveInProgress = _this$props.isSaveInProgress,
                type = _this$props.type;

            var itemId = element.split('-')[1];
            var category = element.split('-')[2];
            var updateFwdButtonState = function updateFwdButtonState() {
                if (isSaveInProgress) {
                    _this.setState({ enableBackButton: false });
                } else {
                    _this.setState({ enableForwardButton: _this.state.assignedListItemIds.length });
                }
            };
            var updateBackButtonState = function updateBackButtonState() {
                if (isSaveInProgress) {
                    _this.setState({ enableBackButton: false });
                } else {
                    _this.setState({ enableBackButton: _this.state.unAssignedListItemIds.length });
                }
            };

            if (category === 'assign') {
                _this.setState({ assignedListItemIds: _this.updateItems((0, _clone2.default)(_this.state.assignedListItemIds), itemId, checked) }, updateFwdButtonState);
            } else {
                _this.setState({ unAssignedListItemIds: _this.updateItems((0, _clone2.default)(_this.state.unAssignedListItemIds), itemId, checked) }, updateBackButtonState);
            }

            if (type === 'student') {
                _this.props.handleOnClassroomSelection(parseInt(itemId, 10));
            }
        };

        _this.handleOnChildSelection = function (itemId, groups) {
            _this.props.handleOnChildSelection(itemId, groups);
        };

        _this.handleOnYearGroupSelection = function (name, val) {
            _this.state.assignedListItemIds = [];
            _this.props.handleOnYearGroupSelection(name, val);
        };

        _this.getLists = function () {
            var _this$props2 = _this.props,
                type = _this$props2.type,
                intl = _this$props2.intl,
                leftList = _this$props2.leftList,
                rightList = _this$props2.rightList;

            var index = 0;
            var leftPanelElements = [];
            var rightPanelElements = [];
            var emptyStateMessage = type === 'class' ? intl.formatMessage(_messages2.default.teacherEmptyState) : intl.formatMessage(_messages2.default.unassignedEmptyState);
            if (leftList.length > 0) {
                leftPanelElements = leftList.map(function (val) {
                    index += 1;
                    return _react2.default.createElement(
                        'div',
                        { className: _index2.default.assignItemContainer, key: val.listItemId + '_' + index },
                        _react2.default.createElement(_index10.default, {
                            child: val.child,
                            elementId: val.elementId,
                            handleOnChildSelection: _this.handleOnChildSelection,
                            handleOnItemSelection: _this.handleOnItemSelection,
                            id: val.listItemId,
                            info: val.info,
                            isExpandable: val.isExpandable,
                            name: val.name
                        })
                    );
                });
            } else {
                leftPanelElements = _react2.default.createElement(_index12.default, {
                    iconName: _iconDictionary.StudentManagement,
                    message: emptyStateMessage });
            }

            if (rightList.length > 0) {
                rightPanelElements = rightList.map(function (val) {
                    index += 1;
                    return _react2.default.createElement(
                        'div',
                        { className: _index2.default.assignItemContainer, key: val.listItemId + '_' + index },
                        _react2.default.createElement(_index10.default, {
                            child: val.child,
                            elementId: val.elementId,
                            handleOnChildSelection: _this.handleOnChildSelection,
                            handleOnItemSelection: _this.handleOnItemSelection,
                            id: val.listItemId,
                            info: val.info,
                            isExpandable: val.isExpandable,
                            name: val.name
                        })
                    );
                });
            } else {
                rightPanelElements = _react2.default.createElement(_index12.default, {
                    iconName: _iconDictionary.StudentManagement,
                    message: emptyStateMessage });
            }

            return {
                leftPanelElements: leftPanelElements,
                rightPanelElements: rightPanelElements
            };
        };

        _this.state = {
            enableForwardButton: false,
            enableBackButton: false,
            assignedListItemIds: [],
            unAssignedListItemIds: []
        };

        _this.assignItem = _this.assignItem.bind(_this);
        _this.unAssignItem = _this.unAssignItem.bind(_this);
        _this.handleOnYearGroupSelection = _this.handleOnYearGroupSelection.bind(_this);
        return _this;
    }

    _createClass(Assign, [{
        key: 'render',
        value: function render() {
            var data = this.getLists();
            var _props = this.props,
                intl = _props.intl,
                header = _props.header,
                selectedYearGroup = _props.selectedYearGroup,
                type = _props.type,
                yearGroups = _props.yearGroups,
                isSaveInProgress = _props.isSaveInProgress;

            var typeString = type === 'class' ? intl.formatMessage(_messages2.default.teachers) : intl.formatMessage(_messages2.default.classes);
            var clonedYearGroups = (0, _cloneDeep2.default)(yearGroups);

            if (clonedYearGroups) {
                delete clonedYearGroups[0];
            }

            var yearGroupDropdown = _react2.default.createElement(_index4.default, {
                name: 'yearGroup',
                onChange: this.handleOnYearGroupSelection,
                options: clonedYearGroups,
                placeholder: intl.formatMessage(_messages4.default.allYears),
                value: selectedYearGroup
            });
            var dropdownList = type !== 'class' ? yearGroupDropdown : _react2.default.createElement('div', null);
            return _react2.default.createElement(
                'div',
                { className: _index2.default.assignContainer },
                _react2.default.createElement(
                    'div',
                    { className: _index2.default.panel },
                    _react2.default.createElement(
                        'span',
                        { className: _index2.default.panelHeader },
                        intl.formatMessage(_messages2.default.available) + ' ' + typeString
                    ),
                    _react2.default.createElement(
                        'div',
                        { className: _index2.default.panelBody },
                        _react2.default.createElement(
                            'div',
                            { className: _index2.default.leftPanelHeader },
                            dropdownList,
                            _react2.default.createElement(_index6.default, { handleOnSearchClick: this.props.handleOnSearchClick })
                        ),
                        _react2.default.createElement(
                            'div',
                            { className: _index2.default.leftPanel },
                            ' ',
                            data.leftPanelElements,
                            ' '
                        )
                    )
                ),
                _react2.default.createElement(
                    'div',
                    { className: _index2.default.moveButtons },
                    _react2.default.createElement(_index8.default, {
                        containerClassName: _index2.default.assignButton,
                        disabled: !this.state.enableForwardButton || isSaveInProgress,
                        handleOnClick: this.assignItem,
                        icon: _iconDictionary.SolidRight,
                        iconClassName: _index2.default.iconClassName }),
                    _react2.default.createElement(_index8.default, {
                        buttonContainerDisabled: _index2.default.buttonContainerDisabled || isSaveInProgress,
                        containerClassName: _index2.default.assignButton,
                        disabled: !this.state.enableBackButton,
                        handleOnClick: this.unAssignItem,
                        icon: _iconDictionary.SolidLeft,
                        iconClassName: _index2.default.iconClassName })
                ),
                _react2.default.createElement(
                    'div',
                    { className: _index2.default.panel },
                    _react2.default.createElement(
                        'span',
                        {
                            className: _index2.default.panelHeader },
                        typeString + ' ' + intl.formatMessage(_messages2.default.assignedTo) + '\n                        ' + header
                    ),
                    _react2.default.createElement(
                        'div',
                        { className: _index2.default.rightPanel },
                        data.rightPanelElements
                    )
                )
            );
        }
    }]);

    return Assign;
}(_react.Component);

Assign.propTypes = {
    header: _propTypes2.default.string,
    yearGroups: _propTypes2.default.array,
    selectedYearGroup: _propTypes2.default.string,
    leftList: _propTypes2.default.array,
    rightList: _propTypes2.default.array,
    isSaveInProgress: _propTypes2.default.bool,
    intl: _reactIntl.intlShape.isRequired,
    type: _propTypes2.default.string,
    handleOnAssignItem: _propTypes2.default.func,
    handleOnUnAssignItem: _propTypes2.default.func,
    handleOnClassroomSelection: _propTypes2.default.func,
    handleOnChildSelection: _propTypes2.default.func,
    handleOnYearGroupSelection: _propTypes2.default.func,
    handleOnSearchClick: _propTypes2.default.func
};

exports.default = (0, _reactIntl.injectIntl)((0, _reactStyleable2.default)(_index2.default)(Assign));

/***/ }),
/* 648 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _reactIntl = __webpack_require__(2);

exports.default = (0, _reactIntl.defineMessages)({
    allYears: {
        id: 'app.components.Assign.allYears',
        defaultMessage: 'All years'
    }

}); /*
     * Assign Messages
     *
     * This contains all the text for the Asign component.
     */

/***/ }),
/* 649 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _reactIntl = __webpack_require__(2);

exports.default = (0, _reactIntl.defineMessages)({
    assignClass: {
        id: 'app.components.assignedClassesGroups.assignClass',
        defaultMessage: 'Assign Class'
    }
}); /*
     * AddStudent Messages
     *
     * This contains all the text for the AddStudent component.
     */

/***/ }),
/* 650 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactIntl = __webpack_require__(2);

var _reactStyleable = __webpack_require__(6);

var _reactStyleable2 = _interopRequireDefault(_reactStyleable);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _iconDictionary = __webpack_require__(8);

var _index = __webpack_require__(1673);

var _index2 = _interopRequireDefault(_index);

var _messages = __webpack_require__(651);

var _messages2 = _interopRequireDefault(_messages);

var _index3 = __webpack_require__(7);

var _index4 = _interopRequireDefault(_index3);

var _index5 = __webpack_require__(654);

var _index6 = _interopRequireDefault(_index5);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var AssignedTeacher = function AssignedTeacher(_ref) {
    var handleOnTeacherUnassign = _ref.handleOnTeacherUnassign,
        intl = _ref.intl,
        showModal = _ref.showModal,
        teachers = _ref.teachers,
        handleOnUnassignConfirm = _ref.handleOnUnassignConfirm,
        handleOnCloseModal = _ref.handleOnCloseModal,
        isUserOperationModalOpen = _ref.isUserOperationModalOpen,
        isLoading = _ref.isLoading,
        teachersOperationSuccessConfirmation = _ref.teachersOperationSuccessConfirmation,
        handleOnPrintTeacherSignInCard = _ref.handleOnPrintTeacherSignInCard,
        downloadingTeachersIds = _ref.downloadingTeachersIds,
        handleOnAssignTeacher = _ref.handleOnAssignTeacher;
    return _react2.default.createElement(
        'div',
        { className: _index2.default.assignedTeacherComponent },
        _react2.default.createElement(
            'div',
            { className: _index2.default.title },
            intl.formatMessage(_messages2.default.assignedTeachers)
        ),
        _react2.default.createElement(_index6.default, {
            downloadingTeachersIds: downloadingTeachersIds,
            handleOnCloseModal: handleOnCloseModal,
            handleOnPrintTeacherSignInCard: handleOnPrintTeacherSignInCard,
            handleOnTeacherUnassign: handleOnTeacherUnassign,
            handleOnUnassignConfirm: handleOnUnassignConfirm,
            isLoading: isLoading,
            isUserOperationModalOpen: isUserOperationModalOpen,
            showModal: showModal,
            teachers: teachers,
            teachersOperationSuccessConfirmation: teachersOperationSuccessConfirmation }),
        _react2.default.createElement(
            'div',
            { className: _index2.default.footer },
            _react2.default.createElement(_index4.default, {
                containerClassName: _index2.default.assignTeacher,
                handleOnClick: handleOnAssignTeacher,
                icon: _iconDictionary.Edit,
                iconClassName: _index2.default.icon,
                label: intl.formatMessage(_messages2.default.assignTeacher)
            })
        )
    );
};

AssignedTeacher.propTypes = {
    intl: _reactIntl.intlShape.isRequired,
    teachers: _propTypes2.default.array,
    handleOnTeacherUnassign: _propTypes2.default.func,
    showModal: _propTypes2.default.bool,
    handleOnUnassignConfirm: _propTypes2.default.func,
    isUserOperationModalOpen: _propTypes2.default.bool,
    handleOnCloseModal: _propTypes2.default.func,
    isLoading: _propTypes2.default.bool,
    teachersOperationSuccessConfirmation: _propTypes2.default.func,
    handleOnPrintTeacherSignInCard: _propTypes2.default.func,
    downloadingTeachersIds: _propTypes2.default.object,
    handleOnAssignTeacher: _propTypes2.default.func
};

exports.default = (0, _reactIntl.injectIntl)((0, _reactStyleable2.default)(_index2.default)(AssignedTeacher));

/***/ }),
/* 651 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _reactIntl = __webpack_require__(2);

exports.default = (0, _reactIntl.defineMessages)({
    assignedTeachers: {
        id: 'app.components.AssignedTeacher.assignedTeachers',
        defaultMessage: 'Assigned teachers'
    },
    assignTeacher: {
        id: 'app.components.AssignedTeacher.assignTeacher',
        defaultMessage: 'Assign Teacher(s)'
    }
});

/***/ }),
/* 652 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactIntl = __webpack_require__(2);

var _reactStyleable = __webpack_require__(6);

var _reactStyleable2 = _interopRequireDefault(_reactStyleable);

__webpack_require__(26);

var _index = __webpack_require__(7);

var _index2 = _interopRequireDefault(_index);

var _index3 = __webpack_require__(254);

var _index4 = _interopRequireDefault(_index3);

var _index5 = __webpack_require__(1674);

var _index6 = _interopRequireDefault(_index5);

var _messages = __webpack_require__(653);

var _messages2 = _interopRequireDefault(_messages);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var AssignedTeacherInfo = function AssignedTeacherInfo(_ref) {
    var _ref$assignedTeachers = _ref.assignedTeachers,
        assignedTeachers = _ref$assignedTeachers === undefined ? [] : _ref$assignedTeachers,
        _ref$showAssignButton = _ref.showAssignButton,
        showAssignButton = _ref$showAssignButton === undefined ? true : _ref$showAssignButton,
        handleOnAssignTeacher = _ref.handleOnAssignTeacher,
        dependentValues = _ref.dependentValues,
        intl = _ref.intl;

    var assignElement = [];
    if (assignedTeachers.length > 0) {
        assignElement = _react2.default.createElement(_index4.default, { dataItems: assignedTeachers });
    } else if (showAssignButton) {
        assignElement = _react2.default.createElement(_index2.default, {
            containerClassName: _index6.default.assign,
            disabled: false,
            handleOnClick: function handleOnClick() {
                return handleOnAssignTeacher(dependentValues.classroomId);
            },
            label: intl.formatMessage(_messages2.default.assignTeacher) });
    }

    return _react2.default.createElement(
        'div',
        { className: _index6.default.component },
        assignElement
    );
};

AssignedTeacherInfo.propTypes = {
    assignedTeachers: _propTypes2.default.array,
    showAssignButton: _propTypes2.default.bool,
    dependentValues: _propTypes2.default.object,
    handleOnAssignTeacher: _propTypes2.default.func,
    intl: _reactIntl.intlShape.isRequired
};

exports.default = (0, _reactIntl.injectIntl)((0, _reactStyleable2.default)(_index6.default)(AssignedTeacherInfo));

/***/ }),
/* 653 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _reactIntl = __webpack_require__(2);

exports.default = (0, _reactIntl.defineMessages)({
    assignTeacher: {
        id: 'app.components.assignedTeacherInfo.assignTeacher',
        defaultMessage: 'Assign teacher'
    }
}); /*
     * AddStudent Messages
     *
     * This contains all the text for the AddStudent component.
     */

/***/ }),
/* 654 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _map = __webpack_require__(139);

var _map2 = _interopRequireDefault(_map);

var _reactStyleable = __webpack_require__(6);

var _reactStyleable2 = _interopRequireDefault(_reactStyleable);

var _reactIntl = __webpack_require__(2);

var _index = __webpack_require__(1675);

var _index2 = _interopRequireDefault(_index);

var _index3 = __webpack_require__(7);

var _index4 = _interopRequireDefault(_index3);

var _iconDictionary = __webpack_require__(8);

var _messages = __webpack_require__(655);

var _messages2 = _interopRequireDefault(_messages);

var _index5 = __webpack_require__(36);

var _index6 = _interopRequireDefault(_index5);

var _index7 = __webpack_require__(24);

var _index8 = _interopRequireDefault(_index7);

var _index9 = __webpack_require__(258);

var _index10 = _interopRequireDefault(_index9);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var AssignedTeacherList = function AssignedTeacherList(_ref) {
    var handleOnTeacherUnassign = _ref.handleOnTeacherUnassign,
        teachers = _ref.teachers,
        intl = _ref.intl,
        handleOnUnassignConfirm = _ref.handleOnUnassignConfirm,
        teachersOperationSuccessConfirmation = _ref.teachersOperationSuccessConfirmation,
        isUserOperationModalOpen = _ref.isUserOperationModalOpen,
        isLoading = _ref.isLoading,
        showModal = _ref.showModal,
        handleOnCloseModal = _ref.handleOnCloseModal,
        handleOnPrintTeacherSignInCard = _ref.handleOnPrintTeacherSignInCard,
        downloadingTeachersIds = _ref.downloadingTeachersIds;

    var confirmation = isUserOperationModalOpen ? _react2.default.createElement(
        _index10.default,
        {
            handleOnCancel: handleOnCloseModal,
            handleOnOk: handleOnUnassignConfirm,
            icon: _iconDictionary.Warning,
            isLoading: isLoading,
            title: intl.formatMessage(_messages2.default.unassignTeachers) },
        _react2.default.createElement(
            'div',
            null,
            intl.formatMessage(_messages2.default.selectedTeachersWillBe),
            ' ',
            _react2.default.createElement(
                'span',
                {
                    className: _index2.default.highlight },
                intl.formatMessage(_messages2.default.unassigned)
            ),
            ' ',
            intl.formatMessage(_messages2.default.loseAccessToProducts),
            '.'
        )
    ) : _react2.default.createElement(_index6.default, {
        handleOnCloseModal: teachersOperationSuccessConfirmation,
        icon: _iconDictionary.Tick,
        title: intl.formatMessage(_messages2.default.teachersUnassigned) });
    return _react2.default.createElement(
        'div',
        { className: _index2.default.teacherList },
        _react2.default.createElement(
            'div',
            { className: _index2.default.header },
            intl.formatMessage(_messages2.default.teachers)
        ),
        _react2.default.createElement(
            'div',
            null,
            (0, _map2.default)(teachers, function (teacher) {
                return _react2.default.createElement(
                    'div',
                    { className: _index2.default.list, key: teacher.userProfileId },
                    _react2.default.createElement(
                        'div',
                        { className: _index2.default.listItem },
                        teacher.name
                    ),
                    _react2.default.createElement(_index4.default, {
                        containerClassName: _index2.default.downloadSignInCards,
                        handleOnClick: function handleOnClick() {
                            return handleOnPrintTeacherSignInCard(teacher.userProfileId);
                        },
                        icon: _iconDictionary.Download,
                        iconClassName: _index2.default.icon,
                        label: intl.formatMessage(_messages2.default.downloadCards),
                        loading: downloadingTeachersIds.has(teacher.userProfileId),
                        loadingLabel: intl.formatMessage(_messages2.default.downloading) }),
                    _react2.default.createElement(_index4.default, {
                        containerClassName: _index2.default.unassign,
                        handleOnClick: function handleOnClick() {
                            return handleOnTeacherUnassign(teacher.userProfileId);
                        },
                        icon: _iconDictionary.Cross,
                        iconClassName: _index2.default.icon })
                );
            })
        ),
        _react2.default.createElement(
            _index8.default,
            { show: showModal },
            confirmation
        )
    );
};

AssignedTeacherList.propTypes = {
    handleOnTeacherUnassign: _propTypes2.default.func,
    teachers: _propTypes2.default.array,
    intl: _reactIntl.intlShape.isRequired,
    teachersOperationSuccessConfirmation: _propTypes2.default.func,
    handleOnCloseModal: _propTypes2.default.func,
    handleOnUnassignConfirm: _propTypes2.default.func,
    showModal: _propTypes2.default.bool,
    isUserOperationModalOpen: _propTypes2.default.bool,
    isLoading: _propTypes2.default.bool,
    handleOnPrintTeacherSignInCard: _propTypes2.default.func,
    downloadingTeachersIds: _propTypes2.default.object
};

exports.default = (0, _reactIntl.injectIntl)((0, _reactStyleable2.default)(_index2.default)(AssignedTeacherList));

/***/ }),
/* 655 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _reactIntl = __webpack_require__(2);

exports.default = (0, _reactIntl.defineMessages)({
    downloadCards: {
        id: 'app.components.AssignedTeacherList.downloadCards',
        defaultMessage: 'Download sign-in card'
    },
    downloading: {
        id: 'app.components.AssignedTeacherList.downloading',
        defaultMessage: 'downloading'
    },
    unassignTeachers: {
        id: 'app.components.AssignedTeacherList.unassignTeachers',
        defaultMessage: 'Unassign teachers'
    },
    teachersUnassigned: {
        id: 'app.components.AssignedTeacherList.teachersUnassigned',
        defaultMessage: 'Teachers have been unassigned'
    },
    selectedTeachersWillBe: {
        id: 'app.components.AssignedTeacherList.selectedTeacherWillBe',
        defaultMessage: 'The selected teachers will be'
    },
    unassigned: {
        id: 'app.components.AssignedTeacherList.unassigned',
        defaultMessage: 'unassigned'
    },
    loseAccessToProducts: {
        id: 'app.components.AssignedTeacherList.loseAccessToProducts',
        defaultMessage: 'and will lose all access to their licenced products'
    },
    teachers: {
        id: 'app.components.AssignedTeacherList.teachers',
        defaultMessage: 'TEACHERS'
    }
});

/***/ }),
/* 656 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactIntl = __webpack_require__(2);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactStyleable = __webpack_require__(6);

var _reactStyleable2 = _interopRequireDefault(_reactStyleable);

var _index = __webpack_require__(1676);

var _index2 = _interopRequireDefault(_index);

var _variants = __webpack_require__(9);

var _button = __webpack_require__(7);

var _button2 = _interopRequireDefault(_button);

var _messages = __webpack_require__(657);

var _messages2 = _interopRequireDefault(_messages);

var _textInput = __webpack_require__(1677);

var _textInput2 = _interopRequireDefault(_textInput);

var _textInput3 = __webpack_require__(48);

var _textInput4 = _interopRequireDefault(_textInput3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var authenticate = function (_PureComponent) {
    _inherits(authenticate, _PureComponent);

    function authenticate(props) {
        _classCallCheck(this, authenticate);

        var _this = _possibleConstructorReturn(this, (authenticate.__proto__ || Object.getPrototypeOf(authenticate)).call(this, props));

        _this.handleKeyPress = function (event) {
            if (event.key === 'Enter') {
                _this.props.handleOnContinue();
            }
        };

        _this.OnPasswordChange = function (event) {
            _this.setState({ password: event.target.value });
            _this.props.handleOnPasswordChange(event);
        };

        _this.state = { password: '' };
        return _this;
    }

    _createClass(authenticate, [{
        key: 'render',
        value: function render() {
            return _react2.default.createElement(
                'div',
                { className: _index2.default.modalContent },
                _react2.default.createElement(
                    'div',
                    { className: _index2.default.modalHeader },
                    _react2.default.createElement(
                        'div',
                        { className: _index2.default.modalHeaderText },
                        this.props.intl.formatMessage(_messages2.default.pageTitle)
                    ),
                    _react2.default.createElement(
                        'div',
                        { className: _index2.default.close, onClick: this.props.handleOnCancel, role: 'button', tabIndex: 0 },
                        '\xD7'
                    )
                ),
                _react2.default.createElement(
                    'div',
                    { className: _index2.default.modalBody },
                    _react2.default.createElement(
                        'div',
                        { className: _index2.default.password },
                        this.props.intl.formatMessage(_messages2.default.password)
                    ),
                    _react2.default.createElement(
                        'div',
                        null,
                        _react2.default.createElement(_textInput4.default, {
                            css: _textInput2.default,
                            handleOnChange: this.OnPasswordChange,
                            handleOnKeyPress: this.handleKeyPress,
                            maxLength: 50,
                            name: 'adminPassword',
                            type: 'password'
                        })
                    )
                ),
                _react2.default.createElement(
                    'div',
                    { className: _index2.default.modalFooter },
                    _react2.default.createElement(
                        'div',
                        { className: _index2.default.buttonContainer },
                        _react2.default.createElement(_button2.default, {
                            disabled: !this.state.password,
                            handleOnClick: this.props.handleOnContinue,
                            label: this.props.intl.formatMessage(_messages2.default.continue),
                            variant: _variants.DARK
                        })
                    )
                )
            );
        }
    }]);

    return authenticate;
}(_react.PureComponent);

authenticate.propTypes = {
    intl: _reactIntl.intlShape.isRequired,
    handleOnCancel: _propTypes2.default.func,
    handleOnPasswordChange: _propTypes2.default.func,
    handleOnContinue: _propTypes2.default.func
};

exports.default = (0, _reactIntl.injectIntl)((0, _reactStyleable2.default)(_index2.default)(authenticate));

/***/ }),
/* 657 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _reactIntl = __webpack_require__(2);

exports.default = (0, _reactIntl.defineMessages)({
    pageTitle: {
        id: 'app.components.reAuthenticate.pageTitle',
        defaultMessage: 'Reauthenticate by entering admin password below'
    },
    password: {
        id: 'app.components.reAuthenticate.password',
        defaultMessage: 'Password'
    },
    continue: {
        id: 'app.components.reAuthenticate.continue',
        defaultMessage: 'Continue'
    }
});

/***/ }),
/* 658 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactIntl = __webpack_require__(2);

var _reactStyleable = __webpack_require__(6);

var _reactStyleable2 = _interopRequireDefault(_reactStyleable);

var _svgIcon = __webpack_require__(21);

var _svgIcon2 = _interopRequireDefault(_svgIcon);

var _index = __webpack_require__(1679);

var _index2 = _interopRequireDefault(_index);

var _index3 = __webpack_require__(7);

var _index4 = _interopRequireDefault(_index3);

var _iconDictionary = __webpack_require__(8);

var _messages = __webpack_require__(659);

var _messages2 = _interopRequireDefault(_messages);

var _index5 = __webpack_require__(48);

var _index6 = _interopRequireDefault(_index5);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var BulkPasswordChange = function (_Component) {
    _inherits(BulkPasswordChange, _Component);

    function BulkPasswordChange(props) {
        _classCallCheck(this, BulkPasswordChange);

        var _this = _possibleConstructorReturn(this, (BulkPasswordChange.__proto__ || Object.getPrototypeOf(BulkPasswordChange)).call(this, props));

        _this.handleOnInputChange = function (event) {
            if (event.target.value.trim() !== '') {
                _this.setState({ canSubmit: true });
            } else {
                _this.setState({ canSubmit: false });
            }

            _this.props.handleOnChange(event);
        };

        _this.state = { canSubmit: false };
        _this.handleOnInputChange = _this.handleOnInputChange.bind(_this);
        return _this;
    }

    _createClass(BulkPasswordChange, [{
        key: 'render',
        value: function render() {
            return _react2.default.createElement(
                'div',
                { className: _index2.default.bulkPasswordChangeContainer },
                _react2.default.createElement(
                    'div',
                    { className: _index2.default.icon },
                    _react2.default.createElement(_svgIcon2.default, { icon: this.props.icon })
                ),
                _react2.default.createElement(
                    'div',
                    { className: _index2.default.title },
                    this.props.title
                ),
                _react2.default.createElement(_index6.default, {
                    handleOnChange: this.handleOnInputChange,
                    maxLength: 50,
                    name: 'Password',
                    placeholder: this.props.intl.formatMessage(_messages2.default.newPassword),
                    value: this.props.bulkPasswordValue
                }),
                _react2.default.createElement(
                    'div',
                    { className: _index2.default.container },
                    _react2.default.createElement(_index4.default, {
                        buttonContainer: _index2.default.cancel,
                        buttonContainerDisabled: _index2.default.cancelButtonDisabled,
                        disabled: this.props.isLoading,
                        handleOnClick: this.props.handleOnCancel,
                        icon: _iconDictionary.Cross,
                        iconClassName: _index2.default.iconClassName,
                        loading: this.props.isLoading }),
                    _react2.default.createElement(_index4.default, {
                        buttonContainer: _index2.default.ok,
                        buttonContainerDisabled: _index2.default.okButtonDisabled,
                        disabled: this.props.isLoading || !this.state.canSubmit,
                        handleOnClick: this.props.handleOnOk,
                        icon: _iconDictionary.Tick,
                        iconClassName: _index2.default.iconClassName,
                        loading: this.props.isLoading || !this.state.canSubmit })
                )
            );
        }
    }]);

    return BulkPasswordChange;
}(_react.Component);

BulkPasswordChange.propTypes = {
    icon: _propTypes2.default.string,
    title: _propTypes2.default.string,
    handleOnOk: _propTypes2.default.func,
    handleOnCancel: _propTypes2.default.func,
    handleOnChange: _propTypes2.default.func,
    isLoading: _propTypes2.default.bool,
    intl: _reactIntl.intlShape.isRequired,
    bulkPasswordValue: _propTypes2.default.string
};

exports.default = (0, _reactIntl.injectIntl)((0, _reactStyleable2.default)(_index2.default)(BulkPasswordChange));

/***/ }),
/* 659 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _reactIntl = __webpack_require__(2);

exports.default = (0, _reactIntl.defineMessages)({
    newPassword: {
        id: 'app.components.bulkPasswordChange.newPassword',
        defaultMessage: 'Enter New Password'
    }
});

/***/ }),
/* 660 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactIntl = __webpack_require__(2);

var _reactStyleable = __webpack_require__(6);

var _reactStyleable2 = _interopRequireDefault(_reactStyleable);

var _confirm = __webpack_require__(1683);

var _confirm2 = _interopRequireDefault(_confirm);

var _iconDictionary = __webpack_require__(8);

var _messages = __webpack_require__(251);

var _messages2 = _interopRequireDefault(_messages);

var _svgIcon = __webpack_require__(21);

var _svgIcon2 = _interopRequireDefault(_svgIcon);

var _index = __webpack_require__(7);

var _index2 = _interopRequireDefault(_index);

var _variants = __webpack_require__(9);

var _withModal = __webpack_require__(49);

var _withModal2 = _interopRequireDefault(_withModal);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ChangeCourseConfirmationWithTasks = function (_Component) {
    _inherits(ChangeCourseConfirmationWithTasks, _Component);

    function ChangeCourseConfirmationWithTasks(props) {
        _classCallCheck(this, ChangeCourseConfirmationWithTasks);

        var _this = _possibleConstructorReturn(this, (ChangeCourseConfirmationWithTasks.__proto__ || Object.getPrototypeOf(ChangeCourseConfirmationWithTasks)).call(this, props));

        _this.handleCarryOver = _this.handleCarryOver.bind(_this);
        return _this;
    }

    _createClass(ChangeCourseConfirmationWithTasks, [{
        key: 'handleCarryOver',
        value: function handleCarryOver(isCarryOver) {
            this.props.changeCourseCarryOver(_extends({}, this.props, { isCarryOver: isCarryOver }));
        }
    }, {
        key: 'render',
        value: function render() {
            var _this2 = this;

            var _props = this.props,
                changeCourseAssignedTasks = _props.changeCourseAssignedTasks,
                backToChangeCourse = _props.backToChangeCourse,
                intl = _props.intl,
                isChangingCourseCarryOverInProgress = _props.isChangingCourseCarryOverInProgress;

            var header = intl.formatMessage(_messages2.default.confirmWithActivitiesHeader, { length: changeCourseAssignedTasks.length });

            return _react2.default.createElement(
                'div',
                null,
                _react2.default.createElement(
                    'div',
                    { className: _confirm2.default.changeCourseContainer },
                    _react2.default.createElement(
                        'div',
                        { className: _confirm2.default.icon },
                        _react2.default.createElement(_svgIcon2.default, { icon: _iconDictionary.Warning })
                    ),
                    _react2.default.createElement(
                        'div',
                        { className: _confirm2.default.header },
                        _react2.default.createElement(
                            'div',
                            null,
                            header
                        ),
                        intl.formatMessage(_messages2.default.confirmWithActivitiesSubHeader)
                    ),
                    _react2.default.createElement(
                        'div',
                        { className: _confirm2.default.buttons },
                        _react2.default.createElement(_index2.default, {
                            disabled: isChangingCourseCarryOverInProgress,
                            handleOnClick: backToChangeCourse,
                            label: intl.formatMessage(_messages2.default.backLabel),
                            variant: _variants.DARK }),
                        _react2.default.createElement(_index2.default, {
                            disabled: isChangingCourseCarryOverInProgress,
                            handleOnClick: function handleOnClick() {
                                return _this2.handleCarryOver(false);
                            },
                            label: intl.formatMessage(_messages2.default.noLabel),
                            variant: _variants.DARK }),
                        _react2.default.createElement(_index2.default, {
                            disabled: isChangingCourseCarryOverInProgress,
                            handleOnClick: function handleOnClick() {
                                return _this2.handleCarryOver(true);
                            },
                            label: intl.formatMessage(_messages2.default.yesLabel),
                            variant: _variants.DARK })
                    )
                )
            );
        }
    }]);

    return ChangeCourseConfirmationWithTasks;
}(_react.Component);

ChangeCourseConfirmationWithTasks.propTypes = {
    backToChangeCourse: _propTypes2.default.func,
    changeCourseAssignedTasks: _propTypes2.default.array,
    changeCourseCarryOver: _propTypes2.default.func,
    intl: _reactIntl.intlShape.isRequired,
    isChangingCourseCarryOverInProgress: _propTypes2.default.bool
};

var ChangeCourseConfirmationWithTasksIntl = (0, _reactIntl.injectIntl)((0, _reactStyleable2.default)(_confirm2.default)(ChangeCourseConfirmationWithTasks));
exports.default = (0, _withModal2.default)('isActive')(ChangeCourseConfirmationWithTasksIntl);

/***/ }),
/* 661 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactIntl = __webpack_require__(2);

var _reactStyleable = __webpack_require__(6);

var _reactStyleable2 = _interopRequireDefault(_reactStyleable);

var _index = __webpack_require__(588);

var _index2 = _interopRequireDefault(_index);

var _index3 = __webpack_require__(666);

var _index4 = _interopRequireDefault(_index3);

var _iconDictionary = __webpack_require__(8);

var _messages = __webpack_require__(251);

var _messages2 = _interopRequireDefault(_messages);

var _actions = __webpack_require__(106);

var _withModal = __webpack_require__(49);

var _withModal2 = _interopRequireDefault(_withModal);

var _productEnum = __webpack_require__(77);

var _productEnum2 = _interopRequireDefault(_productEnum);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ChangeCourseConfirmation = function (_Component) {
    _inherits(ChangeCourseConfirmation, _Component);

    function ChangeCourseConfirmation(props) {
        _classCallCheck(this, ChangeCourseConfirmation);

        var _this = _possibleConstructorReturn(this, (ChangeCourseConfirmation.__proto__ || Object.getPrototypeOf(ChangeCourseConfirmation)).call(this, props));

        _this.handleClose = _this.handleClose.bind(_this);
        return _this;
    }

    _createClass(ChangeCourseConfirmation, [{
        key: 'handleClose',
        value: function handleClose() {
            var closeChangeCourse = this.props.closeChangeCourse;

            closeChangeCourse();
        }
    }, {
        key: 'render',
        value: function render() {
            var findByKey = function findByKey(needle, haystack) {
                return haystack.find(function (x) {
                    return x.key === needle;
                });
            };

            var _props = this.props,
                assignedCourseId = _props.assignedCourseId,
                assignedUpfCourseId = _props.assignedUpfCourseId,
                assignedNewCourseId = _props.assignedNewCourseId,
                changeCourseAssignedTasks = _props.changeCourseAssignedTasks,
                changeCourseSubmittedFields = _props.changeCourseSubmittedFields,
                changeCourseTaskActionType = _props.changeCourseTaskActionType,
                classroomDetail = _props.classroomDetail,
                groupId = _props.groupId,
                intl = _props.intl,
                isChangingCourseCarryOverSuccess = _props.isChangingCourseCarryOverSuccess;


            var isMathletics = this.props.selectedProduct.id === _productEnum2.default.MATHLETICS.id;
            var yearGroup = changeCourseSubmittedFields.yearGroup;

            var coursesKey = 'courses';
            var yearGroupsKey = 'yearGroups';
            var assignedCourse = findByKey(assignedCourseId, this.props[coursesKey]);
            var assignedNewCourse = this.props.newCourses.find(function (newCourse) {
                return newCourse.id.toString() === assignedNewCourseId;
            });

            var assignedUPFCourse = this.props.upfCourses.find(function (upfCourse) {
                return upfCourse.id.toString() === assignedUpfCourseId.toString();
            });

            var _findByKey = findByKey(yearGroup, this.props[yearGroupsKey]),
                yearGroupLabel = _findByKey.value;

            var classroomGroups = classroomDetail.classroomGroups;

            var currentGroup = classroomGroups.find(function (group) {
                return group.id === groupId;
            });

            var updatedActivities = '';
            if (isChangingCourseCarryOverSuccess && changeCourseTaskActionType === _actions.CARRY_OVER_TASK_TYPE) {
                var carryOverMessage = intl.formatMessage(_messages2.default.activityUpdated, { length: changeCourseAssignedTasks.length });
                updatedActivities = _react2.default.createElement(
                    'div',
                    null,
                    _react2.default.createElement('br', null),
                    ' ',
                    carryOverMessage
                );
            }
            return _react2.default.createElement(
                _index4.default,
                {
                    handleOnCloseModal: this.handleClose,
                    icon: _iconDictionary.Tick },
                _react2.default.createElement(
                    'span',
                    { className: _index2.default.course },
                    currentGroup.name
                ),
                ' ',
                intl.formatMessage(_messages2.default.assignedTo),
                ' ',
                _react2.default.createElement(
                    'span',
                    { className: _index2.default.course },
                    assignedCourse.value
                ),
                _react2.default.createElement(
                    'span',
                    null,
                    isMathletics && assignedUPFCourse && _react2.default.createElement(
                        'span',
                        null,
                        ', ',
                        _react2.default.createElement(
                            'span',
                            { className: _index2.default.course },
                            assignedUPFCourse.name
                        )
                    )
                ),
                _react2.default.createElement(
                    'span',
                    null,
                    isMathletics && assignedNewCourse && _react2.default.createElement(
                        'span',
                        null,
                        '& ',
                        _react2.default.createElement(
                            'span',
                            { className: _index2.default.course },
                            assignedNewCourse.name
                        )
                    )
                ),
                ' (' + yearGroupLabel + ')',
                updatedActivities
            );
        }
    }]);

    return ChangeCourseConfirmation;
}(_react.Component);

ChangeCourseConfirmation.propTypes = {
    assignedCourseId: _propTypes2.default.string,
    assignedUpfCourseId: _propTypes2.default.string,
    assignedNewCourseId: _propTypes2.default.string,
    changeCourseAssignedTasks: _propTypes2.default.array,
    changeCourseSubmittedFields: _propTypes2.default.object,
    changeCourseTaskActionType: _propTypes2.default.string,
    classroomDetail: _propTypes2.default.object,
    closeChangeCourse: _propTypes2.default.func,
    groupId: _propTypes2.default.number,
    intl: _reactIntl.intlShape.isRequired,
    isChangingCourseCarryOverSuccess: _propTypes2.default.bool,
    upfCourses: _propTypes2.default.array,
    newCourses: _propTypes2.default.array,
    selectedProduct: _propTypes2.default.object
};

var StyledChangeCourse = (0, _reactIntl.injectIntl)((0, _reactStyleable2.default)(_index2.default)(ChangeCourseConfirmation));

exports.default = (0, _withModal2.default)('isActive')(StyledChangeCourse);

/***/ }),
/* 662 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactIntl = __webpack_require__(2);

var _cloneDeep = __webpack_require__(54);

var _cloneDeep2 = _interopRequireDefault(_cloneDeep);

var _reactStyleable = __webpack_require__(6);

var _reactStyleable2 = _interopRequireDefault(_reactStyleable);

var _index = __webpack_require__(588);

var _index2 = _interopRequireDefault(_index);

var _index3 = __webpack_require__(7);

var _index4 = _interopRequireDefault(_index3);

var _variants = __webpack_require__(9);

var _withForm = __webpack_require__(392);

var _withForm2 = _interopRequireDefault(_withForm);

var _index5 = __webpack_require__(37);

var _index6 = _interopRequireDefault(_index5);

var _iconDictionary = __webpack_require__(8);

var _messages = __webpack_require__(251);

var _messages2 = _interopRequireDefault(_messages);

var _constants = __webpack_require__(96);

var _constants2 = _interopRequireDefault(_constants);

var _withModal = __webpack_require__(49);

var _withModal2 = _interopRequireDefault(_withModal);

var _productEnum = __webpack_require__(77);

var _productEnum2 = _interopRequireDefault(_productEnum);

var _radiobutton = __webpack_require__(255);

var _radiobutton2 = _interopRequireDefault(_radiobutton);

var _constants3 = __webpack_require__(40);

var _helpers = __webpack_require__(663);

var _utils = __webpack_require__(13);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ChangeCourseForm = function (_Component) {
    _inherits(ChangeCourseForm, _Component);

    function ChangeCourseForm(props) {
        _classCallCheck(this, ChangeCourseForm);

        var _this = _possibleConstructorReturn(this, (ChangeCourseForm.__proto__ || Object.getPrototypeOf(ChangeCourseForm)).call(this, props));

        _initialiseProps.call(_this);

        _this.handleFormSubmit = _this.handleFormSubmit.bind(_this);
        _this.handleClose = _this.handleClose.bind(_this);
        _this.handleListChange = _this.handleListChange.bind(_this);
        _this.handleOnSelect = _this.handleOnSelect.bind(_this);
        _this.getDisplayNewCourses = _this.getDisplayNewCourses.bind(_this);
        var _this$props = _this.props,
            intl = _this$props.intl,
            selectedProduct = _this$props.selectedProduct;

        var isMathletics = selectedProduct.id === _productEnum2.default.MATHLETICS.id;
        var lists = void 0;

        if (isMathletics) {
            lists = [{
                key: 'country',
                pluralKey: 'countries',
                title: intl.formatMessage(_messages2.default.selectCountry),
                shortTitle: intl.formatMessage(_messages2.default.countryLabel),
                placeholder: intl.formatMessage(_messages2.default.selectCountry),
                next: 'yearGroup',
                clear: ['country', 'yearGroup', 'course', 'upfCourse', 'newCourses'],
                isActive: true
            }, {
                key: 'yearGroup',
                pluralKey: 'yearGroups',
                title: intl.formatMessage(_messages2.default.selectGrade),
                shortTitle: intl.formatMessage(_messages2.default.gradeLabel),
                placeholder: intl.formatMessage(_messages2.default.selectGrade),
                next: 'course',
                clear: ['yearGroup', 'course', 'upfCourse', 'newCourses'],
                isActive: false
            }, {
                key: 'course',
                pluralKey: 'courses',
                title: intl.formatMessage(_messages2.default.selectCourse),
                shortTitle: intl.formatMessage(_messages2.default.courseLabel),
                placeholder: intl.formatMessage(_messages2.default.selectCourse),
                emptyPlaceholder: intl.formatMessage(_messages2.default.noCoursesFound),
                next: 'upfCourse',
                clear: ['course', 'newCourses', 'upfCourse'],
                isActive: false
            }, {
                key: 'upfCourse',
                pluralKey: 'upfCourses',
                title: intl.formatMessage(_messages2.default.selectSkillQuests),
                shortTitle: intl.formatMessage(_messages2.default.skillQuests),
                placeholder: intl.formatMessage(_messages2.default.selectSkillQuests),
                next: props.displayNewCourses ? 'newCourses' : undefined,
                emptyPlaceholder: intl.formatMessage(_messages2.default.noCoursesFound),
                clear: ['upfCourse', 'newCourses'],
                isActive: false
            }];

            if (props.displayNewCourses) {
                var IS_NEW_COURSES_ASSIGNED = false;
                lists.push({
                    key: 'newCourses',
                    pluralKey: 'newCourses',
                    title: intl.formatMessage(_messages2.default.selectNewCourse),
                    shortTitle: intl.formatMessage(_messages2.default.newCourses),
                    placeholder: intl.formatMessage(_messages2.default.selectNewCourse),
                    emptyPlaceholder: (0, _utils.getNewCoursesTitle)(_this.props.form.yearGroup, IS_NEW_COURSES_ASSIGNED, '', intl),
                    clear: ['newCourses'],
                    isActive: false
                });
            }
        } else {
            lists = [{
                key: 'country',
                pluralKey: 'countries',
                title: intl.formatMessage(_messages2.default.selectCountry),
                shortTitle: intl.formatMessage(_messages2.default.countryLabel),
                placeholder: intl.formatMessage(_messages2.default.selectCountry),
                next: 'yearGroup',
                clear: ['country', 'yearGroup', 'course'],
                isActive: true
            }, {
                key: 'yearGroup',
                pluralKey: 'yearGroups',
                title: intl.formatMessage(_messages2.default.selectGrade),
                shortTitle: intl.formatMessage(_messages2.default.gradeLabel),
                placeholder: intl.formatMessage(_messages2.default.selectGrade),
                next: 'course',
                clear: ['yearGroup', 'course'],
                isActive: false
            }, {
                key: 'course',
                pluralKey: 'courses',
                title: intl.formatMessage(_messages2.default.selectCourse),
                shortTitle: intl.formatMessage(_messages2.default.courseLabel),
                placeholder: intl.formatMessage(_messages2.default.selectCourse),
                emptyPlaceholder: intl.formatMessage(_messages2.default.noCoursesFound),
                clear: ['course'],
                isActive: false
            }];
        }

        _this.state = {
            lists: lists,
            fetchCourse: false,
            selectorPressed: false,
            isSchoolCoursesSelected: false,
            isCurriculumCoursesSelected: true,
            selectedLegacyCourse: _constants3.DEFAULT_LEGACY_COURSE_ID,
            selectedCountry: _constants3.DEFAULT_COUNTRY_ID,
            selectedGrade: _constants3.DEFAULT_YEAR_GROUP
        };
        return _this;
    }

    _createClass(ChangeCourseForm, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            var _props = this.props,
                countries = _props.countries,
                upfCountries = _props.upfCountries,
                getCourseCountries = _props.getCourseCountries,
                getUpfCourseCountries = _props.getUpfCourseCountries,
                selectedProduct = _props.selectedProduct;

            if (!countries.length) {
                getCourseCountries(selectedProduct.id);
            }

            if (!upfCountries.length) {
                getUpfCourseCountries(selectedProduct.id);
            }
        }
    }, {
        key: 'handleListChange',
        value: function handleListChange(field, value, form) {
            var yearGroup = form.yearGroup,
                country = form.country;
            var _props2 = this.props,
                getSchoolCourses = _props2.getSchoolCourses,
                selectedProductId = _props2.selectedProduct.id,
                getUPFCourses = _props2.getUPFCourses,
                getNewCourses = _props2.getNewCourses,
                getProductCourses = _props2.getProductCourses,
                handleCountryDropdownChanges = _props2.handleCountryDropdownChanges;


            this.setState({
                selectedCountry: country,
                selectedGrade: yearGroup
            });

            if (field === 'country') {
                handleCountryDropdownChanges(field, value);
            }

            if (yearGroup !== undefined && yearGroup !== _constants3.DEFAULT_YEAR_GROUP && country !== undefined && country !== _constants3.DEFAULT_COUNTRY_ID) {
                if (selectedProductId === _productEnum2.default.MATHLETICS.id) {
                    if (field === 'upfCourse') getNewCourses({ productId: selectedProductId, countryCode: country, yearGroup: yearGroup });
                }

                if (country === _constants2.default.SCHOOL_COURSES || this.state.isSchoolCoursesSelected) {
                    getSchoolCourses(yearGroup);
                } else if (field === 'yearGroup') {
                    getProductCourses(country, selectedProductId, yearGroup);
                    getUPFCourses(country, selectedProductId, yearGroup);
                }
            }

            // Set the next dropdown list
            var currentList = (0, _helpers.findByKey)(field, this.state.lists);

            if (currentList.next) {
                var nextList = (0, _helpers.findByKey)(currentList.next, this.state.lists);
                this.handleOnSelect(nextList);
            } else {
                currentList.hideOverride = true;
                currentList.isActive = false;
                this.handleOnSelect(currentList);
            }
        }
    }, {
        key: 'handleClose',
        value: function handleClose() {
            this.props.closeChangeCourse();
        }
    }, {
        key: 'handleFormSubmit',
        value: function handleFormSubmit() {
            var _props3 = this.props,
                classroomId = _props3.classroomId,
                groupId = _props3.groupId,
                fields = _props3.fields,
                changeCourse = _props3.changeCourse;
            var course = fields.course,
                upfCourse = fields.upfCourse,
                newCourses = fields.newCourses;


            changeCourse({
                classroomId: classroomId,
                groupId: groupId,
                courseId: course,
                submittedFields: fields,
                upfCourseId: upfCourse,
                newCourseId: !newCourses || newCourses === '-1' ? _constants3.DEFAULT_NEW_COURSE_ID : newCourses,
                useUpfSchoolDefault: upfCourse === _constants3.DEFAULT_UPF_COURSE_ID
            });
        }
    }, {
        key: 'handleOnSelect',
        value: function handleOnSelect(list) {
            var fields = this.props.fields;

            var lists = (0, _cloneDeep2.default)(this.state.lists);
            var updatedLists = lists.map(function (item) {
                return _extends({}, item, {
                    isActive: list.key === item.key
                });
            });

            // Clear associated fields
            list.clear.forEach(function (key) {
                fields[key] = '-1';
            });

            if (list.key === 'upfCourse' && list.next === 'newCourses') {
                this.setState({
                    lists: updatedLists,
                    selectorPressed: false
                });
            } else {
                this.setState({
                    lists: updatedLists,
                    selectorPressed: list.next !== undefined || list.isActive
                });
            }
        }
    }, {
        key: 'render',
        value: function render() {
            var _this2 = this;

            var _props4 = this.props,
                canSubmit = _props4.canSubmit,
                classroomDetail = _props4.classroomDetail,
                form = _props4.form,
                fields = _props4.fields,
                groupId = _props4.groupId,
                intl = _props4.intl,
                isChangingCourseInProgress = _props4.isChangingCourseInProgress,
                modal = _props4.modal,
                selectedProduct = _props4.selectedProduct,
                upfCourses = _props4.upfCourses,
                newCourses = _props4.newCourses;


            var formTitle = this.state.lists.map(function (item) {
                var fieldValue = fields[item.key];
                var titleStyle = item.isActive ? '' : _index2.default.hidden;
                var title = !item.next && fieldValue !== undefined && fieldValue !== '-1' ? intl.formatMessage(_messages2.default.confirmLabel) : item.title;
                return item.isActive ? _react2.default.createElement(
                    'div',
                    { className: titleStyle, key: item.key },
                    title
                ) : '';
            });

            var buttonSelectors = this.state.lists.map(function (item) {
                // don't show the UPF course selector option if product is non Mathletics
                if (selectedProduct.id !== _productEnum2.default.MATHLETICS.id && item.key === 'upfCourse') {
                    return null;
                }

                var currentValue = fields[item.key];
                var selectedOption = (0, _helpers.findByKey)(currentValue, _this2.props[item.pluralKey]);
                var buttonLabel = selectedOption ? selectedOption.value : item.shortTitle;
                var isClickable = currentValue && currentValue !== '-1';
                var isClickableClass = isClickable ? _index2.default.actionClickable : _index2.default.actionUnclickable;

                return _react2.default.createElement(_index4.default, {
                    buttonContainer: '' + _index2.default.buttonContainer,
                    containerClassName: _index2.default.buttonWrapper + ' ' + _index2.default.buttonSelector + ' ' + isClickableClass,
                    handleOnClick: function handleOnClick() {
                        if (isClickable) _this2.handleOnSelect(item);
                    },
                    icon: _iconDictionary.Edit,
                    iconClassName: _index2.default.buttonIcon,
                    item: item,
                    key: item.key,
                    label: buttonLabel
                });
            });

            var dropdowns = this.state.lists.map(function (item) {
                var fieldValue = fields[item.key];
                var isDropdownLoading = _this2.props[item.key + 'Fetching'];
                var optionLists = _this2.props[item.pluralKey] || [];
                var isMathletics = selectedProduct.id === _productEnum2.default.MATHLETICS.id;

                if (item.pluralKey === 'upfCourses') {
                    optionLists = (0, _utils.showDefaultCourseAtTop)(optionLists, intl.formatMessage(_messages2.default.useAdminSelection));
                }

                if (!_this2.state.isCurriculumCoursesSelected && !_this2.state.isSchoolCoursesSelected && item.key === 'course' && item.isActive) {
                    optionLists = [];
                }

                var areNewCoursesAvailable = (0, _utils.newCoursesAvailable)(_this2.state.selectedGrade, _this2.state.selectedCountry);
                if (item.key === 'newCourses' && !areNewCoursesAvailable) {
                    optionLists = [];
                }

                if (!isMathletics && item.key === 'upfCourse') {
                    return false;
                }

                var dropdownProps = {
                    course: {
                        disabled: optionLists.length === 0 && !isDropdownLoading,
                        placeholder: optionLists.length === 0 && !isDropdownLoading ? item.emptyPlaceholder : item.placeholder
                    },
                    newCourses: {
                        optionKey: 'key',
                        optionText: 'name',
                        disabled: optionLists.length === 0 && !isDropdownLoading,
                        placeholder: optionLists.length === 0 && !isDropdownLoading ? item.emptyPlaceholder : item.placeholder
                    },
                    upfCourse: {
                        optionKey: 'key',
                        optionText: 'name',
                        disabled: optionLists.length === 0 && !isDropdownLoading,
                        placeholder: optionLists.length === 0 && !isDropdownLoading ? item.emptyPlaceholder : item.placeholder
                    }
                };
                var dropdownStyle = item.isActive ? '' : _index2.default.hidden;
                if (!item.next && fieldValue !== undefined && fieldValue !== '-1') {
                    dropdownStyle = _index2.default.hidden;
                }

                return _react2.default.createElement(
                    'div',
                    { key: item.key },
                    isMathletics && (fieldValue === undefined || fieldValue === '-1') && item.key === 'course' && item.isActive && _this2.courseSelectors(),
                    _react2.default.createElement(
                        'div',
                        { className: '' + dropdownStyle },
                        _react2.default.createElement(_index6.default, _extends({
                            isLoading: isDropdownLoading,
                            name: item.key,
                            onChange: function onChange(field, value) {
                                form.handleListOnChange(field, value, {
                                    upfCourses: upfCourses,
                                    newCourses: newCourses,
                                    areNewCoursesAvailable: areNewCoursesAvailable
                                }, _this2.handleListChange);
                            },
                            options: optionLists,
                            placeholder: item.placeholder,
                            value: fieldValue
                        }, dropdownProps[item.key]))
                    )
                );
            });

            var classroomGroups = classroomDetail.classroomGroups,
                classroomName = classroomDetail.name;

            var currentGroup = classroomGroups.find(function (group) {
                return group.id === groupId;
            });
            var isMathletics = selectedProduct.id === _productEnum2.default.MATHLETICS.id;
            var courseTitle = currentGroup.courseTitle,
                upfCourseTitle = currentGroup.upfCourseTitle,
                conquestCourseTitle = currentGroup.conquestCourseTitle;
            var selectorPressed = this.state.selectorPressed;


            var formContent = _react2.default.createElement(
                'div',
                { className: _index2.default.changeCourseContainer },
                _react2.default.createElement(
                    'div',
                    { className: _index2.default.title },
                    formTitle,
                    _react2.default.createElement(
                        'div',
                        { className: _index2.default.titleSub },
                        _react2.default.createElement(
                            'span',
                            { className: _index2.default.course },
                            classroomName
                        ),
                        ', ',
                        _react2.default.createElement(
                            'span',
                            { className: _index2.default.course },
                            currentGroup.name
                        ),
                        ' ',
                        intl.formatMessage(_messages2.default.subTitle),
                        ' ',
                        _react2.default.createElement(
                            'span',
                            { className: _index2.default.course },
                            courseTitle
                        ),
                        _react2.default.createElement(
                            'span',
                            null,
                            isMathletics && upfCourseTitle && _react2.default.createElement(
                                'span',
                                null,
                                ', ',
                                _react2.default.createElement(
                                    'span',
                                    { className: _index2.default.course },
                                    upfCourseTitle
                                )
                            )
                        ),
                        _react2.default.createElement(
                            'span',
                            null,
                            isMathletics && conquestCourseTitle && _react2.default.createElement(
                                'span',
                                null,
                                ' & ',
                                _react2.default.createElement(
                                    'span',
                                    { className: _index2.default.course },
                                    conquestCourseTitle
                                )
                            )
                        )
                    )
                ),
                _react2.default.createElement(
                    'div',
                    { className: _index2.default.buttonSelectors },
                    buttonSelectors
                ),
                dropdowns,
                _react2.default.createElement(
                    'div',
                    { className: _index2.default.actionButtonWrapper },
                    _react2.default.createElement(_index4.default, {
                        containerClassName: 'cancel-button ' + _index2.default.btnDanger,
                        disabled: isChangingCourseInProgress,
                        handleOnClick: function handleOnClick() {
                            modal.close(_this2.handleClose);
                        },
                        icon: _iconDictionary.Cross,
                        iconClassName: _index2.default.svgIconContainer,
                        variant: _variants.CIRCLE_DANGER
                    }),
                    _react2.default.createElement(_index4.default, {
                        containerClassName: 'ok-button ' + _index2.default.btnSuccess,
                        disabled: !canSubmit || selectorPressed || isChangingCourseInProgress,
                        handleOnClick: function handleOnClick() {
                            form.submit(_this2.handleFormSubmit);
                        },
                        icon: _iconDictionary.Tick,
                        iconClassName: _index2.default.svgIconContainer,
                        variant: _variants.CIRCLE_SUCCESS
                    })
                )
            );

            return formContent;
        }
    }]);

    return ChangeCourseForm;
}(_react.Component);

ChangeCourseForm.displayNewCourses = undefined && undefined.getDisplayNewCourses();

var _initialiseProps = function _initialiseProps() {
    var _this3 = this;

    this.getDisplayNewCourses = function () {
        return _this3.props.displayNewCourses;
    };

    this.handleOnSchoolCoursesSelection = function () {
        _this3.setState({
            isSchoolCoursesSelected: true,
            isCurriculumCoursesSelected: false,
            selectedLegacyCourse: _constants3.DEFAULT_LEGACY_COURSE_ID
        });

        _this3.props.clearProductCourses();
        _this3.props.getSchoolCourses(_this3.state.selectedGrade);
    };

    this.handleOnCurriculumCoursesSelection = function () {
        var _props5 = _this3.props,
            clearProductCourses = _props5.clearProductCourses,
            getProductCourses = _props5.getProductCourses,
            selectedProduct = _props5.selectedProduct;

        _this3.setState({
            isSchoolCoursesSelected: false,
            isCurriculumCoursesSelected: true,
            selectedLegacyCourse: _constants3.DEFAULT_LEGACY_COURSE_ID
        });

        clearProductCourses();
        getProductCourses(_this3.state.selectedCountry, selectedProduct.id, _this3.state.selectedGrade);
    };

    this.courseSelectors = function () {
        var intl = _this3.props.intl;

        return _react2.default.createElement(
            'div',
            { className: _index2.default.courseSelectorWrapper, id: 'courseSelector' },
            _react2.default.createElement(
                'div',
                { className: _index2.default.customCoursesWrapper },
                _react2.default.createElement(_radiobutton2.default, {
                    checked: _this3.state.isSchoolCoursesSelected,
                    id: 'customCourses',
                    name: 'courseSelector',
                    onChange: _this3.handleOnSchoolCoursesSelection,
                    value: intl.formatMessage(_messages2.default.customCourses) }),
                _react2.default.createElement(
                    'label',
                    { htmlFor: 'customCourses' },
                    intl.formatMessage(_messages2.default.customCourses)
                )
            ),
            _react2.default.createElement(
                'div',
                { className: _index2.default.curriculumCoursesWrapper },
                _react2.default.createElement(_radiobutton2.default, {
                    checked: _this3.state.isCurriculumCoursesSelected,
                    id: 'curriculumCourses',
                    name: 'courseSelector',
                    onChange: _this3.handleOnCurriculumCoursesSelection,
                    value: intl.formatMessage(_messages2.default.customCourses) }),
                _react2.default.createElement(
                    'label',
                    { htmlFor: 'curriculumCourses' },
                    intl.formatMessage(_messages2.default.curriculumCourses)
                )
            )
        );
    };
};

ChangeCourseForm.defaultProps = {
    fields: {
        upfCourse: _constants3.DEFAULT_UPF_COURSE_ID,
        newCourse: _constants3.DEFAULT_NEW_COURSE_ID
    }
};

ChangeCourseForm.propTypes = {
    canSubmit: _propTypes2.default.bool,
    classroomDetail: _propTypes2.default.object,
    classroomId: _propTypes2.default.number,
    closeChangeCourse: _propTypes2.default.func,
    changeCourse: _propTypes2.default.func,
    fields: _propTypes2.default.object,
    form: _propTypes2.default.object,
    getProductCourses: _propTypes2.default.func,
    getSchoolCourses: _propTypes2.default.func,
    groupId: _propTypes2.default.number,
    handleCountryDropdownChanges: _propTypes2.default.func,
    intl: _reactIntl.intlShape.isRequired,
    isChangingCourseInProgress: _propTypes2.default.bool,
    modal: _propTypes2.default.object,
    selectedProduct: _propTypes2.default.object,
    getUPFCourses: _propTypes2.default.func.isRequired,
    clearProductCourses: _propTypes2.default.func,
    countries: _propTypes2.default.array,
    upfCountries: _propTypes2.default.array,
    getCourseCountries: _propTypes2.default.func,
    getUpfCourseCountries: _propTypes2.default.func,
    getNewCourses: _propTypes2.default.func,
    displayNewCourses: _propTypes2.default.bool,
    upfCourses: _propTypes2.default.array,
    newCourses: _propTypes2.default.array
};

var StyledChangeCourse = (0, _reactIntl.injectIntl)((0, _reactStyleable2.default)(_index2.default)(ChangeCourseForm));

var ChangeCourseWithForm = (0, _withForm2.default)(StyledChangeCourse, {
    validate: function validate(fields, value, context) {
        var INVALID = new Set(['-1', -1, '', null, undefined]);

        var isInvalid = function isInvalid(v) {
            return v === undefined || INVALID.has(v);
        };
        var _context$upfCourses = context.upfCourses,
            upfCourses = _context$upfCourses === undefined ? [] : _context$upfCourses,
            _context$newCourses = context.newCourses,
            newCourses = _context$newCourses === undefined ? [] : _context$newCourses,
            areNewCoursesAvailable = context.areNewCoursesAvailable;


        if (isInvalid(fields.course)) return false;

        if (upfCourses.length > 0 && isInvalid(fields.upfCourse)) return false;

        if (areNewCoursesAvailable) {
            if (newCourses.length === 0 || isInvalid(fields.newCourses)) return false;
        }

        return true;
    }
});

exports.default = (0, _withModal2.default)('isActive')(ChangeCourseWithForm);

/***/ }),
/* 663 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
/* eslint-disable import/prefer-default-export */
var findByKey = exports.findByKey = function findByKey(needle) {
    var haystack = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
    return haystack.find(function (x) {
        return x.key && x.key.toString() === needle && needle.toString();
    });
};

/***/ }),
/* 664 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _redux = __webpack_require__(35);

var _reactRedux = __webpack_require__(28);

var _reactIntl = __webpack_require__(2);

var _confirmation = __webpack_require__(661);

var _confirmation2 = _interopRequireDefault(_confirmation);

var _activityConfirmation = __webpack_require__(660);

var _activityConfirmation2 = _interopRequireDefault(_activityConfirmation);

var _form = __webpack_require__(662);

var _form2 = _interopRequireDefault(_form);

var _actions = __webpack_require__(38);

var _actions2 = __webpack_require__(106);

var _actions3 = __webpack_require__(44);

var _utils = __webpack_require__(13);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function mergeAndSortCountries() {
    var countries = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
    var upfCountries = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];

    var merged = [].concat(_toConsumableArray(countries), _toConsumableArray(upfCountries.filter(function (upf) {
        return !countries.some(function (c) {
            return c.key === upf.key;
        });
    })));
    return merged.sort(function (a, b) {
        return a.value.localeCompare(b.value);
    });
}

var ChangeCourse = function ChangeCourse(props) {
    var isChangingCourseSuccess = props.isChangingCourseSuccess,
        changeCourseActivitiesIsActive = props.changeCourseActivitiesIsActive,
        changeCourseIsActive = props.changeCourseIsActive,
        upfCourses = props.upfCourses,
        newCourses = props.newCourses,
        countries = props.countries,
        upfCountries = props.upfCountries;
    /**
     * Business rule: default course set in admin is first item in new courses list.
     */

    var updatedNewCourses = (0, _utils.moveFlaggedToFront)(newCourses.map(function (newCourse) {
        return _extends({}, newCourse, {
            key: newCourse.id,
            value: newCourse.name
        });
    }), 'isDefault');
    var updatedUPFCourses = upfCourses.map(function (upfCourse) {
        return _extends({}, upfCourse, {
            key: parseInt(upfCourse.id, 10),
            value: upfCourse.name
        });
    });
    var updatedCountries = mergeAndSortCountries(countries, upfCountries);

    return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(_form2.default, _extends({
            isActive: changeCourseIsActive
        }, props, {
            countries: updatedCountries,
            newCourses: updatedNewCourses,
            upfCourses: updatedUPFCourses })),
        _react2.default.createElement(_confirmation2.default, _extends({ isActive: isChangingCourseSuccess }, props)),
        _react2.default.createElement(_activityConfirmation2.default, _extends({ isActive: changeCourseActivitiesIsActive }, props))
    );
};

ChangeCourse.propTypes = {
    changeCourseActivitiesIsActive: _propTypes2.default.bool,
    changeCourseIsActive: _propTypes2.default.bool,
    countries: _propTypes2.default.arrayOf(_propTypes2.default.object),
    upfCountries: _propTypes2.default.arrayOf(_propTypes2.default.object),
    intl: _reactIntl.intlShape.isRequired,
    isChangingCourseSuccess: _propTypes2.default.bool,
    selectedProduct: _propTypes2.default.object,
    getUPFCourses: _propTypes2.default.func,
    upfCourses: _propTypes2.default.array,
    newCourses: _propTypes2.default.array,
    clearProductCourses: _propTypes2.default.func
};

ChangeCourse.defaultProps = {
    upfCourses: []
};

function mapStateToProps() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    return {
        assignedCourseId: state.editClass.assignedCourseId,
        assignedUpfCourseId: state.editClass.assignedUpfCourseId,
        assignedNewCourseId: state.editClass.assignedNewCourseId,
        changeCourse: state.classRoll.changeCourse,
        changeCourseClassroomId: state.editClass.changeCourseClassroomId,
        changeCourseGroupId: state.editClass.changeCourseGroupId,
        changeCourseActivitiesIsActive: state.editClass.changeCourseActivitiesIsActive,
        changeCourseAssignedTasks: state.editClass.changeCourseAssignedTasks,
        changeCourseSubmittedFields: state.editClass.changeCourseSubmittedFields,
        changeCourseTaskActionType: state.editClass.changeCourseTaskActionType,
        changeCourseIsActive: state.editClass.changeCourseIsActive,
        classroomDetail: state.editClass.classroomDetail,
        countries: state.schoolRoll.countries.filtered,
        upfCountries: state.schoolRoll.upfCountries.filtered,
        courseFetching: state.classRoll.isProductCoursesFetching || state.classRoll.isSchoolCoursesFetching,
        isChangingCourseCarryOverInProgress: state.editClass.isChangingCourseCarryOverInProgress,
        isChangingCourseCarryOverSuccess: state.editClass.isChangingCourseCarryOverSuccess,
        isChangingCourseInProgress: state.editClass.isChangingCourseInProgress,
        isChangingCourseSuccess: state.editClass.isChangingCourseSuccess,
        selectedGroup: state.editClass.selectedGroup,
        selectedProduct: state.product,
        yearGroups: (0, _utils.filterYearGroups)(state.editClass.countryYearGroups),
        yearGroupFetching: state.editClass.fetchingYeargroups,
        courses: state.classRoll.productCourses,
        upfCourses: state.classRoll.upfCourses,
        newCourses: state.classRoll.newCourses
    };
}

function mapDispatchToProps(dispatch) {
    return (0, _redux.bindActionCreators)({
        backToChangeCourse: _actions2.backToChangeCourse,
        closeChangeCourse: _actions2.closeChangeCourse,
        getCourseCountries: _actions3.getCourseCountries,
        getUpfCourseCountries: _actions3.getUpfCourseCountries,
        getProductCourses: _actions.getProductCourses,
        getSchoolCourses: _actions.getSchoolCourses,
        changeCourse: _actions2.changeCourse,
        changeCourseCarryOver: _actions2.changeCourseCarryOver,
        handleCountryDropdownChanges: _actions2.handleCountryDropdownChanges,
        getUPFCourses: _actions.getUPFCourses,
        getNewCourses: _actions.getNewCourses,
        clearProductCourses: _actions.clearProductCourses
    }, dispatch);
}

var ChangeCourseIntl = (0, _reactIntl.injectIntl)(ChangeCourse);

var ConnectedChangeCourse = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(ChangeCourseIntl);

exports.default = ConnectedChangeCourse;

/***/ }),
/* 665 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _index = __webpack_require__(1684);

var _index2 = _interopRequireDefault(_index);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Checkbox = function Checkbox(_ref) {
    var key = _ref.key,
        _ref$onclick = _ref.onclick,
        onclick = _ref$onclick === undefined ? null : _ref$onclick;
    return _react2.default.createElement(
        'div',
        { className: _index2.default.component },
        _react2.default.createElement('input', { id: key, onClick: onclick, type: 'checkbox' })
    );
};

Checkbox.propTypes = {
    key: _propTypes2.default.string,
    onclick: _propTypes2.default.func
};

exports.default = Checkbox;

/***/ }),
/* 666 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactIntl = __webpack_require__(2);

var _index = __webpack_require__(1685);

var _index2 = _interopRequireDefault(_index);

var _svgIcon = __webpack_require__(21);

var _svgIcon2 = _interopRequireDefault(_svgIcon);

var _index3 = __webpack_require__(7);

var _index4 = _interopRequireDefault(_index3);

var _variants = __webpack_require__(9);

var _messages = __webpack_require__(667);

var _messages2 = _interopRequireDefault(_messages);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ClassConfirmation = function ClassConfirmation(_ref) {
    var icon = _ref.icon,
        children = _ref.children,
        handleOnCloseModal = _ref.handleOnCloseModal,
        intl = _ref.intl;
    return _react2.default.createElement(
        'div',
        { className: _index2.default.classConfirmationContainer },
        _react2.default.createElement(
            'div',
            { className: _index2.default.icon },
            _react2.default.createElement(_svgIcon2.default, { icon: icon })
        ),
        _react2.default.createElement(
            'div',
            { className: _index2.default.title },
            children
        ),
        _react2.default.createElement(_index4.default, {
            containerClassName: 'cta-button ' + _index2.default.buttonWrapper,
            handleOnClick: handleOnCloseModal,
            label: intl.formatMessage(_messages2.default.ok),
            variant: _variants.DARK })
    );
};

ClassConfirmation.propTypes = {
    icon: _propTypes2.default.string,
    handleOnCloseModal: _propTypes2.default.func,
    intl: _reactIntl.intlShape.isRequired,
    children: _propTypes2.default.node
};

exports.default = (0, _reactIntl.injectIntl)(ClassConfirmation);

/***/ }),
/* 667 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _reactIntl = __webpack_require__(2);

exports.default = (0, _reactIntl.defineMessages)({
    addAnotherTeacher: {
        id: 'app.components.TeacherConfirmation.addAnotherTeacher',
        defaultMessage: 'Add another teacher'
    },
    printSignInCard: {
        id: 'app.components.TeacherConfirmation.printSignInCard',
        defaultMessage: 'Print sign-in card'
    },
    done: {
        id: 'app.components.TeacherConfirmation.done',
        defaultMessage: 'Done'
    },
    downloading: {
        id: 'app.components.TeacherConfirmation.header',
        defaultMessage: 'downloading...'
    },
    ok: {
        id: 'app.components.TeacherConfirmation.ok',
        defaultMessage: 'OK'
    }
});

/***/ }),
/* 668 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactStyleable = __webpack_require__(6);

var _reactStyleable2 = _interopRequireDefault(_reactStyleable);

var _reactIntl = __webpack_require__(2);

var _textInput = __webpack_require__(1689);

var _textInput2 = _interopRequireDefault(_textInput);

var _index = __webpack_require__(48);

var _index2 = _interopRequireDefault(_index);

var _dropdownList = __webpack_require__(1687);

var _dropdownList2 = _interopRequireDefault(_dropdownList);

var _index3 = __webpack_require__(37);

var _index4 = _interopRequireDefault(_index3);

var _index5 = __webpack_require__(257);

var _index6 = _interopRequireDefault(_index5);

var _index7 = __webpack_require__(678);

var _index8 = _interopRequireDefault(_index7);

var _index9 = __webpack_require__(1688);

var _index10 = _interopRequireDefault(_index9);

var _messages = __webpack_require__(669);

var _messages2 = _interopRequireDefault(_messages);

var _constants = __webpack_require__(40);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ClassDetail = function ClassDetail(_ref) {
    var intl = _ref.intl,
        classroomDetail = _ref.classroomDetail,
        yearGroups = _ref.yearGroups,
        downloadStudentSignInCards = _ref.downloadStudentSignInCards,
        isDownloadingSignInCards = _ref.isDownloadingSignInCards,
        handleOnClassNameChange = _ref.handleOnClassNameChange,
        className = _ref.className,
        handleOnEditGroup = _ref.handleOnEditGroup,
        handleOnYearGroupChange = _ref.handleOnYearGroupChange,
        yearGroup = _ref.yearGroup,
        openAddGroup = _ref.openAddGroup,
        selectedProduct = _ref.selectedProduct,
        handleOnStudentSignInCards = _ref.handleOnStudentSignInCards,
        handleOnCancelStudentSignInCards = _ref.handleOnCancelStudentSignInCards,
        showHideSignInCardModal = _ref.showHideSignInCardModal,
        displayNewCourses = _ref.displayNewCourses;
    return _react2.default.createElement(
        'div',
        { className: _index10.default.classDetailComponent },
        _react2.default.createElement(
            'div',
            { className: _index10.default.title },
            intl.formatMessage(_messages2.default.classDetails)
        ),
        _react2.default.createElement(
            'div',
            { className: _index10.default.panel },
            _react2.default.createElement(
                'span',
                { className: _index10.default.label },
                intl.formatMessage(_messages2.default.className)
            ),
            _react2.default.createElement(
                'div',
                { className: _index10.default.input },
                _react2.default.createElement(_index2.default, {
                    css: _textInput2.default,
                    handleOnChange: handleOnClassNameChange,
                    maxLength: _constants.MAX_CLASSNAME_LENGTH,
                    name: 'className',
                    value: className
                })
            ),
            _react2.default.createElement(
                'span',
                { className: _index10.default.label },
                intl.formatMessage(_messages2.default.year)
            ),
            _react2.default.createElement(
                'div',
                { className: _index10.default.list },
                _react2.default.createElement(_index4.default, {
                    css: _dropdownList2.default,
                    name: 'yearGroupEnum',
                    onChange: handleOnYearGroupChange,
                    options: yearGroups,
                    value: yearGroup })
            ),
            _react2.default.createElement(
                'div',
                { className: _index10.default.studentColumn },
                _react2.default.createElement(
                    'span',
                    { className: _index10.default.label },
                    intl.formatMessage(_messages2.default.students)
                ),
                _react2.default.createElement(_index6.default, { count: classroomDetail.studentsProfileId.length, icon: _index10.default.studentCountIcon })
            )
        ),
        _react2.default.createElement(_index8.default, {
            classroomDetail: classroomDetail,
            displayNewCourses: displayNewCourses,
            downloadStudentSignInCards: downloadStudentSignInCards,
            handleOnCancelStudentSignInCards: handleOnCancelStudentSignInCards,
            handleOnEditGroup: handleOnEditGroup,
            handleOnStudentSignInCards: handleOnStudentSignInCards,
            isDownloadingSignInCards: isDownloadingSignInCards,
            openAddGroup: openAddGroup,
            selectedProduct: selectedProduct,
            showHideSignInCardModal: showHideSignInCardModal,
            yearGroup: yearGroup
        })
    );
};

ClassDetail.propTypes = {
    intl: _reactIntl.intlShape.isRequired,
    classroomDetail: _propTypes2.default.object,
    yearGroups: _propTypes2.default.arrayOf(_propTypes2.default.object),
    downloadStudentSignInCards: _propTypes2.default.func,
    isDownloadingSignInCards: _propTypes2.default.bool,
    handleOnClassNameChange: _propTypes2.default.func,
    className: _propTypes2.default.string,
    handleOnEditGroup: _propTypes2.default.func,
    handleOnYearGroupChange: _propTypes2.default.func,
    openAddGroup: _propTypes2.default.func,
    yearGroup: _propTypes2.default.string,
    selectedProduct: _propTypes2.default.object,
    handleOnStudentSignInCards: _propTypes2.default.func,
    handleOnCancelStudentSignInCards: _propTypes2.default.func,
    showHideSignInCardModal: _propTypes2.default.bool,
    displayNewCourses: _propTypes2.default.bool
};

exports.default = (0, _reactIntl.injectIntl)((0, _reactStyleable2.default)(_index10.default)(ClassDetail));

/***/ }),
/* 669 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _reactIntl = __webpack_require__(2);

exports.default = (0, _reactIntl.defineMessages)({
    classDetails: {
        id: 'app.components.ClassDetails.classDetails',
        defaultMessage: 'Class details'
    },
    className: {
        id: 'app.components.ClassDetails.className',
        defaultMessage: 'CLASS NAME'
    },
    year: {
        id: 'app.components.ClassDetails.year',
        defaultMessage: 'YEAR'
    },
    students: {
        id: 'app.components.ClassDetails.students',
        defaultMessage: 'STUDENTS'
    }
});

/***/ }),
/* 670 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactStyleable = __webpack_require__(6);

var _reactStyleable2 = _interopRequireDefault(_reactStyleable);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactIntl = __webpack_require__(2);

var _cloneDeep = __webpack_require__(54);

var _cloneDeep2 = _interopRequireDefault(_cloneDeep);

var _index = __webpack_require__(37);

var _index2 = _interopRequireDefault(_index);

var _index3 = __webpack_require__(190);

var _index4 = _interopRequireDefault(_index3);

__webpack_require__(26);

var _index5 = __webpack_require__(1690);

var _index6 = _interopRequireDefault(_index5);

var _index7 = __webpack_require__(7);

var _index8 = _interopRequireDefault(_index7);

var _variants = __webpack_require__(9);

var ButtonVariants = _interopRequireWildcard(_variants);

var _messages = __webpack_require__(671);

var _messages2 = _interopRequireDefault(_messages);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var findSelected = function findSelected(item) {
    return item.selected;
};

var ClassFilter = function ClassFilter(_ref) {
    var teachers = _ref.teachers,
        yearGroups = _ref.yearGroups,
        _ref$searchTerm = _ref.searchTerm,
        searchTerm = _ref$searchTerm === undefined ? '' : _ref$searchTerm,
        handleFilterOnChange = _ref.handleFilterOnChange,
        handleFilterOnClear = _ref.handleFilterOnClear,
        handleOnSearch = _ref.handleOnSearch,
        intl = _ref.intl;

    var selectedTeachers = teachers.find(findSelected);
    var selectedYearGroup = yearGroups.find(findSelected);

    var cloneTeachers = (0, _cloneDeep2.default)(teachers);
    delete cloneTeachers['0'];

    var cloneYearGroups = (0, _cloneDeep2.default)(yearGroups);
    delete cloneYearGroups['0'];

    return _react2.default.createElement(
        'div',
        { className: _index6.default.filterContainer },
        _react2.default.createElement(
            'div',
            { className: _index6.default.filterContainer },
            _react2.default.createElement(
                'div',
                { className: _index6.default.filters },
                _react2.default.createElement(
                    'div',
                    { className: _index6.default.teachers },
                    _react2.default.createElement(_index2.default, {
                        name: 'teachers',
                        onChange: handleFilterOnChange,
                        options: cloneTeachers,
                        placeholder: intl.formatMessage(_messages2.default.allTeachers),
                        value: selectedTeachers.key })
                ),
                _react2.default.createElement(
                    'div',
                    { className: _index6.default.year },
                    _react2.default.createElement(_index2.default, {
                        name: 'yearGroups',
                        onChange: handleFilterOnChange,
                        options: cloneYearGroups,
                        placeholder: intl.formatMessage(_messages2.default.allYears),
                        value: selectedYearGroup.key })
                ),
                _react2.default.createElement(_index8.default, {
                    containerClassName: _index6.default.clear,
                    disabled: false,
                    handleOnClick: handleFilterOnClear,
                    label: intl.formatMessage(_messages2.default.clear),
                    variant: ButtonVariants.LIGHT }),
                _react2.default.createElement(
                    'div',
                    { className: _index6.default.classSearchContainer },
                    _react2.default.createElement(_index4.default, { handleOnSearchClick: handleOnSearch, searchTerm: searchTerm })
                )
            )
        )
    );
};

ClassFilter.propTypes = {
    teachers: _propTypes2.default.array,
    yearGroups: _propTypes2.default.array,
    searchTerm: _propTypes2.default.string,
    handleFilterOnChange: _propTypes2.default.func,
    handleFilterOnClear: _propTypes2.default.func,
    handleOnSearch: _propTypes2.default.func,
    intl: _reactIntl.intlShape.isRequired
};

exports.default = (0, _reactIntl.injectIntl)((0, _reactStyleable2.default)(_index6.default)(ClassFilter));

/***/ }),
/* 671 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _reactIntl = __webpack_require__(2);

exports.default = (0, _reactIntl.defineMessages)({
    allTeachers: {
        id: 'app.components.classFilter.allTeachers',
        defaultMessage: 'All teachers'
    },
    allYears: {
        id: 'app.components.classFilter.allYears',
        defaultMessage: 'All years'
    },
    clear: {
        id: 'app.components.classFilter.clear',
        defaultMessage: 'clear'
    }
});

/***/ }),
/* 672 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactIntl = __webpack_require__(2);

var _index = __webpack_require__(1691);

var _index2 = _interopRequireDefault(_index);

var _messages = __webpack_require__(673);

var _messages2 = _interopRequireDefault(_messages);

var _button = __webpack_require__(7);

var _button2 = _interopRequireDefault(_button);

var _variants = __webpack_require__(9);

var _userDelete = __webpack_require__(260);

var _userDelete2 = _interopRequireDefault(_userDelete);

var _confirmationMessage = __webpack_require__(36);

var _confirmationMessage2 = _interopRequireDefault(_confirmationMessage);

var _modal = __webpack_require__(24);

var _modal2 = _interopRequireDefault(_modal);

var _iconDictionary = __webpack_require__(8);

var _signInCardsFormats = __webpack_require__(126);

var _signInCardsFormats2 = _interopRequireDefault(_signInCardsFormats);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ClassFooter = function ClassFooter(_ref) {
    var _ref$noOfSelectedClas = _ref.noOfSelectedClassrooms,
        noOfSelectedClassrooms = _ref$noOfSelectedClas === undefined ? 0 : _ref$noOfSelectedClas,
        handleOnDownloadStudentsSignInCards = _ref.handleOnDownloadStudentsSignInCards,
        isStudentsSignInCardDownloaded = _ref.isStudentsSignInCardDownloaded,
        handleOnDeleteClassrooms = _ref.handleOnDeleteClassrooms,
        handleOnShowDeleteClassroomsConfirmation = _ref.handleOnShowDeleteClassroomsConfirmation,
        _ref$deletingClassroo = _ref.deletingClassrooms,
        deletingClassrooms = _ref$deletingClassroo === undefined ? false : _ref$deletingClassroo,
        showDeleteClassroomsConfirmation = _ref.showDeleteClassroomsConfirmation,
        showDeleteClassroomsSuccess = _ref.showDeleteClassroomsSuccess,
        handleOnCloseDeleteClassroomsConfirmation = _ref.handleOnCloseDeleteClassroomsConfirmation,
        handleOnCloseDeleteClassroomsSuccess = _ref.handleOnCloseDeleteClassroomsSuccess,
        deletingEmptyClassrooms = _ref.deletingEmptyClassrooms,
        intl = _ref.intl,
        handleOnStudentSignInCards = _ref.handleOnStudentSignInCards,
        handleOnCancelStudentSignInCards = _ref.handleOnCancelStudentSignInCards,
        _ref$showHideSignInCa = _ref.showHideSignInCardModal,
        showHideSignInCardModal = _ref$showHideSignInCa === undefined ? false : _ref$showHideSignInCa;

    var loadModalComponent = function loadModalComponent() {
        var modalComponent = '';

        if (showDeleteClassroomsConfirmation && deletingEmptyClassrooms) {
            modalComponent = _react2.default.createElement(_userDelete2.default, {
                handleOnCancel: function handleOnCancel() {
                    handleOnCloseDeleteClassroomsConfirmation(false);
                },
                handleOnOk: handleOnDeleteClassrooms,
                heading: intl.formatMessage(_messages2.default.doYouWishToDeleteClasses),
                icon: _iconDictionary.Warning,
                isLoading: deletingClassrooms,
                title: intl.formatMessage(_messages2.default.deleteClassesConfirmation) });
        } else if (showDeleteClassroomsSuccess && deletingEmptyClassrooms) {
            modalComponent = _react2.default.createElement(_confirmationMessage2.default, {
                handleOnCloseModal: function handleOnCloseModal() {
                    handleOnCloseDeleteClassroomsSuccess(noOfSelectedClassrooms);
                },
                icon: _iconDictionary.Tick,
                title: intl.formatMessage(_messages2.default.youHaveDeleted, { noOfSelectedClassrooms: noOfSelectedClassrooms }) });
        } else if (showHideSignInCardModal) {
            modalComponent = _react2.default.createElement(_signInCardsFormats2.default, {
                handleOnCancel: handleOnCancelStudentSignInCards,
                handleOnDownloadSignInCards: handleOnDownloadStudentsSignInCards,
                isSignInCardDownloaded: isStudentsSignInCardDownloaded });
        }

        return modalComponent;
    };

    var modalView = _react2.default.createElement(
        _modal2.default,
        { show: deletingEmptyClassrooms || showHideSignInCardModal },
        loadModalComponent()
    );

    return _react2.default.createElement(
        'div',
        { className: _index2.default.classFooterComponent },
        _react2.default.createElement(
            'div',
            { className: _index2.default.buttonContainer },
            _react2.default.createElement(_button2.default, {
                containerClassName: _index2.default.downloadSignInCards,
                disabled: noOfSelectedClassrooms === 0,
                handleOnClick: handleOnStudentSignInCards,
                label: intl.formatMessage(_messages2.default.downloadSignInCards),
                variant: _variants.DARK,
                visible: true }),
            _react2.default.createElement(_button2.default, {
                containerClassName: _index2.default.footerButton,
                disabled: noOfSelectedClassrooms === 0,
                handleOnClick: handleOnShowDeleteClassroomsConfirmation,
                label: intl.formatMessage(_messages2.default.deleteClasses),
                loading: deletingClassrooms,
                loadingLabel: intl.formatMessage(_messages2.default.deleting),
                variant: _variants.DARK,
                visible: true })
        ),
        modalView
    );
};

ClassFooter.propTypes = {
    intl: _reactIntl.intlShape.isRequired,
    noOfSelectedClassrooms: _propTypes2.default.number,
    handleOnDownloadStudentsSignInCards: _propTypes2.default.func,
    handleOnShowDeleteClassroomsConfirmation: _propTypes2.default.func,
    handleOnDeleteClassrooms: _propTypes2.default.func,
    isStudentsSignInCardDownloaded: _propTypes2.default.bool,
    deletingClassrooms: _propTypes2.default.bool,
    showDeleteClassroomsConfirmation: _propTypes2.default.bool,
    showDeleteClassroomsSuccess: _propTypes2.default.bool,
    handleOnCloseDeleteClassroomsConfirmation: _propTypes2.default.func,
    handleOnCloseDeleteClassroomsSuccess: _propTypes2.default.func,
    deletingEmptyClassrooms: _propTypes2.default.bool,
    handleOnStudentSignInCards: _propTypes2.default.func,
    handleOnCancelStudentSignInCards: _propTypes2.default.func,
    showHideSignInCardModal: _propTypes2.default.bool
};

exports.default = (0, _reactIntl.injectIntl)(ClassFooter);

/***/ }),
/* 673 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _reactIntl = __webpack_require__(2);

exports.default = (0, _reactIntl.defineMessages)({
    downloadSignInCards: {
        id: 'class-footer.components.downloadSignInCards',
        defaultMessage: 'Download sign-in cards'
    },
    deleteClasses: {
        id: 'class-footer.components.deleteClasses',
        defaultMessage: 'Delete Classes'
    },
    downloading: {
        id: 'class-footer.components.downloading',
        defaultMessage: 'downloading'
    },
    deleting: {
        id: 'class-footer.components.deleting',
        defaultMessage: 'deleting'
    },
    deleteClassesConfirmation: {
        id: 'class-footer.components.deleteClassesConfirmation',
        defaultMessage: 'Delete Class(es) ?'
    },
    deletingSelectedClasses: {
        id: 'class-footer.components.deletingSelectedClasses',
        defaultMessage: 'Deleting the selected class(es) will unassign all teachers and students. ' + 'They will be unable to access the resource until assigned to another class.'
    },
    youHaveDeleted: {
        id: 'class-footer.components.youHaveDeleted',
        defaultMessage: 'You have deleted {noOfSelectedClassrooms} class.'
    },
    doYouWishToDeleteClasses: {
        id: 'class-footer.components.doYouWishToDeleteClasses',
        defaultMessage: 'Deleting the selected class(es) will remove this class from the School Roll. Teachers will be unassigned from this class.'
    }
});

/***/ }),
/* 674 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactStyleable = __webpack_require__(6);

var _reactStyleable2 = _interopRequireDefault(_reactStyleable);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _PulseLoader = __webpack_require__(60);

var _PulseLoader2 = _interopRequireDefault(_PulseLoader);

var _reactIntl = __webpack_require__(2);

var _iconDictionary = __webpack_require__(8);

var _messages = __webpack_require__(675);

var _messages2 = _interopRequireDefault(_messages);

__webpack_require__(26);

var _index = __webpack_require__(1692);

var _index2 = _interopRequireDefault(_index);

var _index3 = __webpack_require__(7);

var _index4 = _interopRequireDefault(_index3);

var _variants = __webpack_require__(9);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ClassHeader = function ClassHeader(_ref) {
    var _ref$filteredClassesC = _ref.filteredClassesCount,
        filteredClassesCount = _ref$filteredClassesC === undefined ? 0 : _ref$filteredClassesC,
        _ref$isClassroomDataL = _ref.isClassroomDataLoaded,
        isClassroomDataLoaded = _ref$isClassroomDataL === undefined ? false : _ref$isClassroomDataL,
        _ref$isClassRollDownl = _ref.isClassRollDownloaded,
        isClassRollDownloaded = _ref$isClassRollDownl === undefined ? true : _ref$isClassRollDownl,
        handleOnDownloadClassRoll = _ref.handleOnDownloadClassRoll,
        handleQuickUpload = _ref.handleQuickUpload,
        handleAddClass = _ref.handleAddClass,
        selectedProduct = _ref.selectedProduct,
        intl = _ref.intl;

    var classCount = isClassroomDataLoaded ? _react2.default.createElement(
        'span',
        null,
        filteredClassesCount
    ) : _react2.default.createElement(_PulseLoader2.default, { color: '#000', margin: '2px', size: '6px' });
    return _react2.default.createElement(
        'div',
        { className: _index2.default.classHeaderComponent },
        _react2.default.createElement(
            'div',
            { className: _index2.default.classesCountContainer },
            _react2.default.createElement(
                'span',
                { className: _index2.default.classesTitle },
                selectedProduct.name,
                '\xA0',
                intl.formatMessage(_messages2.default.classes),
                _react2.default.createElement(
                    'span',
                    { className: _index2.default.classesCount },
                    '( ',
                    classCount,
                    ' )'
                )
            )
        ),
        _react2.default.createElement(
            'div',
            { className: _index2.default.buttonContainer },
            _react2.default.createElement(_index4.default, {
                containerClassName: _index2.default.downloadClassRoll,
                disabled: filteredClassesCount === 0,
                handleOnClick: handleOnDownloadClassRoll,
                icon: _iconDictionary.Download,
                iconClassName: _index2.default.svgIconContainer,
                label: intl.formatMessage(_messages2.default.downloadClassRoll),
                loading: !isClassRollDownloaded,
                loadingLabel: intl.formatMessage(_messages2.default.downloading),
                name: 'downloadClassRoll',
                variant: _variants.DARK,
                visible: true }),
            _react2.default.createElement(_index4.default, {
                containerClassName: _index2.default.bulkUpload,
                disabled: false,
                handleOnClick: handleQuickUpload,
                icon: _iconDictionary.Plus,
                iconClassName: _index2.default.svgIconContainer,
                label: intl.formatMessage(_messages2.default.quickUpload),
                variant: _variants.DARK,
                visible: true }),
            _react2.default.createElement(_index4.default, {
                containerClassName: 'addClassBtn',
                disabled: !isClassroomDataLoaded,
                handleOnClick: handleAddClass,
                icon: _iconDictionary.Plus,
                iconClassName: _index2.default.svgIconContainer,
                label: intl.formatMessage(_messages2.default.addClass),
                variant: _variants.DARK,
                visible: true })
        )
    );
};

ClassHeader.propTypes = {
    isClassroomDataLoaded: _propTypes2.default.bool,
    isClassRollDownloaded: _propTypes2.default.bool,
    filteredClassesCount: _propTypes2.default.number,
    handleOnDownloadClassRoll: _propTypes2.default.func,
    handleQuickUpload: _propTypes2.default.func,
    handleAddClass: _propTypes2.default.func,
    selectedProduct: _propTypes2.default.object,
    intl: _reactIntl.intlShape.isRequired
};

exports.default = (0, _reactIntl.injectIntl)((0, _reactStyleable2.default)(_index2.default)(ClassHeader));

/***/ }),
/* 675 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _reactIntl = __webpack_require__(2);

exports.default = (0, _reactIntl.defineMessages)({
    downloadClassRoll: {
        id: 'class-header.components.downloadClassRoll',
        defaultMessage: 'Download class roll'
    },
    quickUpload: {
        id: 'class-header.components.quickUpload',
        defaultMessage: 'Quick upload'
    },
    addClass: {
        id: 'class-header.components.addClass',
        defaultMessage: 'Add class'
    },
    classes: {
        id: 'class-header.components.classes',
        defaultMessage: 'Classes'
    },
    downloading: {
        id: 'class-header.components.downloading',
        defaultMessage: 'downloading'
    }
}); /*
     * student-header messages
     *
     * This contains all the text for the student-header component.
     */

/***/ }),
/* 676 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactStyleable = __webpack_require__(6);

var _reactStyleable2 = _interopRequireDefault(_reactStyleable);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _PulseLoader = __webpack_require__(60);

var _PulseLoader2 = _interopRequireDefault(_PulseLoader);

var _reactIntl = __webpack_require__(2);

var _cloneDeep = __webpack_require__(54);

var _cloneDeep2 = _interopRequireDefault(_cloneDeep);

var _index = __webpack_require__(1693);

var _index2 = _interopRequireDefault(_index);

var _index3 = __webpack_require__(674);

var _index4 = _interopRequireDefault(_index3);

var _index5 = __webpack_require__(672);

var _index6 = _interopRequireDefault(_index5);

var _index7 = __webpack_require__(150);

var _index8 = _interopRequireDefault(_index7);

var _index9 = __webpack_require__(153);

var _index10 = __webpack_require__(670);

var _index11 = _interopRequireDefault(_index10);

var _index12 = __webpack_require__(76);

var _index13 = _interopRequireDefault(_index12);

var _index14 = __webpack_require__(253);

var gridFormatters = _interopRequireWildcard(_index14);

var _iconDictionary = __webpack_require__(8);

var _messages = __webpack_require__(677);

var _messages2 = _interopRequireDefault(_messages);

var _index15 = __webpack_require__(625);

var _index16 = _interopRequireDefault(_index15);

var _productEnum = __webpack_require__(77);

var _productEnum2 = _interopRequireDefault(_productEnum);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function getGridColumns(handleGridSort, handleOnClassEdit, handleOnAssignTeacher, handleOnAssignStudent, intl, selectedProduct) {
    var courseColumn = [];

    if (selectedProduct.id === _productEnum2.default.MATHLETICS.id) {
        courseColumn.push({
            key: 'courses',
            name: '' + intl.formatMessage(_messages2.default.learningModules),
            resizable: true,
            getRowMetaData: function getRowMetaData(row) {
                return row;
            },
            formatter: _react2.default.createElement(gridFormatters.AssignedCoursesFormatter, null)
        });
    } else {
        courseColumn.push({
            key: 'courseTitle',
            name: '' + intl.formatMessage(_messages2.default.learningModules),
            resizable: true,
            sortable: true,
            getRowMetaData: function getRowMetaData(row) {
                return row;
            },
            headerRenderer: _react2.default.createElement(gridFormatters.HeaderFormatter, { onSort: handleGridSort })
        });
    }

    return [{
        key: 'name',
        name: '' + intl.formatMessage(_messages2.default.class),
        resizable: true,
        sortable: true,
        headerRenderer: _react2.default.createElement(gridFormatters.HeaderFormatter, { onSort: handleGridSort })
    }, {
        key: 'yearGroupEnum',
        name: '' + intl.formatMessage(_messages2.default.year),
        sortable: true,
        width: 70,
        formatter: gridFormatters.YearGroupFormatter,
        getRowMetaData: function getRowMetaData(row) {
            return row;
        },
        headerRenderer: _react2.default.createElement(gridFormatters.HeaderFormatter, { onSort: handleGridSort })
    }].concat(courseColumn, [{
        key: 'teachers',
        name: '' + intl.formatMessage(_messages2.default.teacher),
        resizable: true,
        getRowMetaData: function getRowMetaData(row) {
            return row;
        },
        formatter: _react2.default.createElement(gridFormatters.AssignedTeacherFormatter, { handleOnAssignTeacher: handleOnAssignTeacher })
    }, {
        key: 'studentsCount',
        name: '' + intl.formatMessage(_messages2.default.students),
        width: 180,
        getRowMetaData: function getRowMetaData(row) {
            return row;
        },
        formatter: _react2.default.createElement(gridFormatters.StudentCountFormatter, { handleOnAssignStudents: handleOnAssignStudent })
    }, {
        key: 'edit',
        name: '' + intl.formatMessage(_messages2.default.edit),
        width: 70,
        locked: true,
        getRowMetaData: function getRowMetaData(row) {
            return row;
        },
        formatter: _react2.default.createElement(gridFormatters.EditInfoFormatter, { handleOnEdit: handleOnClassEdit })
    }]);
}

var ClassRoll = function ClassRoll(props) {
    var addClass = props.addClass,
        classrooms = props.classrooms,
        classesCount = props.classesCount,
        filteredClassesCount = props.filteredClassesCount,
        _props$selectedClasse = props.selectedClasses,
        selectedClasses = _props$selectedClasse === undefined ? [] : _props$selectedClasse,
        isClassroomDataLoaded = props.isClassroomDataLoaded,
        isClassRollDownloaded = props.isClassRollDownloaded,
        showAddClassConfirmationModal = props.showAddClassConfirmationModal,
        showAddClassValidationModal = props.showAddClassValidationModal,
        addClassValidationMessage = props.addClassValidationMessage,
        closeAddStudentValidationModal = props.closeAddStudentValidationModal,
        showAddClassModal = props.showAddClassModal,
        onDownloadClassRoll = props.onDownloadClassRoll,
        onQuickUpload = props.onQuickUpload,
        openAddClassModal = props.openAddClassModal,
        handleOnDownloadStudentsSignInCards = props.handleOnDownloadStudentsSignInCards,
        isStudentsSignInCardDownloaded = props.isStudentsSignInCardDownloaded,
        isProductCoursesFetching = props.isProductCoursesFetching,
        isProductCoursesLoaded = props.isProductCoursesLoaded,
        isSaveInProgress = props.isSaveInProgress,
        isSchoolCoursesFetching = props.isSchoolCoursesFetching,
        gridRowGetter = props.gridRowGetter,
        onGridSort = props.onGridSort,
        onRowSelect = props.onRowSelect,
        handleOnClassEdit = props.handleOnClassEdit,
        intl = props.intl,
        classModel = props.classModel,
        onAddClassCloseModal = props.onAddClassCloseModal,
        handleOnAddClassSubmit = props.handleOnAddClassSubmit,
        selectedProduct = props.selectedProduct,
        yearGroups = props.yearGroups,
        productCountries = props.productCountries,
        productCourses = props.productCourses,
        productTeachers = props.productTeachers,
        handleListOnChange = props.handleListOnChange,
        dataFilterOptions = props.dataFilterOptions,
        filterOnChange = props.filterOnChange,
        filterOnClear = props.filterOnClear,
        onSearch = props.onSearch,
        handleOnAssignTeacher = props.handleOnAssignTeacher,
        handleOnAssignStudent = props.handleOnAssignStudent,
        getProductCourses = props.getProductCourses,
        getSchoolCourses = props.getSchoolCourses,
        handleOnDeleteClassrooms = props.handleOnDeleteClassrooms,
        deletingClassrooms = props.deletingClassrooms,
        showDeleteClassroomsConfirmation = props.showDeleteClassroomsConfirmation,
        showDeleteClassroomsSuccess = props.showDeleteClassroomsSuccess,
        handleOnCloseDeleteClassroomsConfirmation = props.handleOnCloseDeleteClassroomsConfirmation,
        handleOnCloseDeleteClassroomsSuccess = props.handleOnCloseDeleteClassroomsSuccess,
        handleOnShowDeleteClassroomsConfirmation = props.handleOnShowDeleteClassroomsConfirmation,
        deletingEmptyClassrooms = props.deletingEmptyClassrooms,
        handleOnStudentSignInCards = props.handleOnStudentSignInCards,
        handleOnCancelStudentSignInCards = props.handleOnCancelStudentSignInCards,
        showHideSignInCardModal = props.showHideSignInCardModal,
        getFilteredUPFCourses = props.getFilteredUPFCourses,
        getFilteredNewCourses = props.getFilteredNewCourses,
        upfCourses = props.upfCourses,
        newCourses = props.newCourses,
        clearProductCourses = props.clearProductCourses,
        clearUPFCourses = props.clearUPFCourses,
        isUPFCoursesFetching = props.isUPFCoursesFetching,
        isNewCoursesFetching = props.isNewCoursesFetching,
        displayNewCourses = props.displayNewCourses,
        upfCountries = props.upfCountries;


    var loaderView = _react2.default.createElement(
        'div',
        { className: _index2.default.classListContainer },
        _react2.default.createElement(
            'div',
            { className: _index2.default.loadingContainer },
            _react2.default.createElement(_PulseLoader2.default, { className: _index2.default.loader })
        )
    );

    var emptyStateView = _react2.default.createElement(
        'div',
        { className: _index2.default.classListContainer },
        _react2.default.createElement(_index11.default, {
            handleFilterOnChange: filterOnChange,
            handleFilterOnClear: filterOnClear,
            handleOnSearch: onSearch,
            searchTerm: dataFilterOptions.searchTerm,
            teachers: dataFilterOptions.teachers,
            yearGroups: dataFilterOptions.yearGroups }),
        _react2.default.createElement(_index13.default, { iconName: _iconDictionary.StudentManagement, message: intl.formatMessage(_messages2.default.noClassesAvailable) })
    );

    var dataView = _react2.default.createElement(
        'div',
        { className: _index2.default.classListContainer },
        _react2.default.createElement(_index11.default, {
            handleFilterOnChange: filterOnChange,
            handleFilterOnClear: filterOnClear,
            handleOnSearch: onSearch,
            searchTerm: dataFilterOptions.searchTerm,
            teachers: dataFilterOptions.teachers,
            yearGroups: dataFilterOptions.yearGroups }),
        _react2.default.createElement(_index8.default, {
            columns: getGridColumns(onGridSort, handleOnClassEdit, handleOnAssignTeacher, handleOnAssignStudent, intl, selectedProduct),
            handleGridSort: onGridSort,
            handleRowSelect: onRowSelect,
            overScan: { colsStart: 17, colsEnd: 17, rowsStart: 25, rowsEnd: 25 },
            rowGetter: gridRowGetter,
            rowHeight: 150,
            rowKey: 'classroomId',
            rowRenderer: _index9.ClassRowRenderer,
            rowsCount: filteredClassesCount,
            selectedRows: selectedClasses.length > 0 ? selectedClasses : []
        })
    );

    var showAddClass = showAddClassModal || showAddClassConfirmationModal;
    var loadAddClassModalComponent = function loadAddClassModalComponent() {
        var addClassYearGroups = (0, _cloneDeep2.default)(yearGroups);

        var addClassProps = {
            addClass: addClass,
            addClassValidationMessage: addClassValidationMessage,
            classroom: classModel,
            closeAddStudentValidationModal: closeAddStudentValidationModal,
            getProductCourses: getProductCourses,
            getSchoolCourses: getSchoolCourses,
            handleListOnChange: handleListOnChange,
            handleOnSubmit: handleOnAddClassSubmit,
            isActive: showAddClass,
            isProductCoursesFetching: isProductCoursesFetching,
            isProductCoursesLoaded: isProductCoursesLoaded,
            isSaveInProgress: isSaveInProgress,
            isSchoolCoursesFetching: isSchoolCoursesFetching,
            onAddClassCloseModal: onAddClassCloseModal,
            productCountries: productCountries,
            productCourses: productCourses,
            productTeachers: productTeachers,
            selectedProduct: selectedProduct,
            showAddClassConfirmationModal: showAddClassConfirmationModal,
            showAddClassValidationModal: showAddClassValidationModal,
            yearGroups: addClassYearGroups,
            getFilteredUPFCourses: getFilteredUPFCourses,
            getFilteredNewCourses: getFilteredNewCourses,
            upfCourses: upfCourses,
            newCourses: newCourses,
            clearProductCourses: clearProductCourses,
            clearUPFCourses: clearUPFCourses,
            isUPFCoursesFetching: isUPFCoursesFetching,
            isNewCoursesFetching: isNewCoursesFetching,
            displayNewCourses: displayNewCourses,
            upfCountries: upfCountries
        };
        return _react2.default.createElement(_index16.default, addClassProps);
    };

    var addClassModalView = showAddClass ? loadAddClassModalComponent() : '';

    var finalView = void 0;
    if (!isClassroomDataLoaded) {
        finalView = loaderView;
    } else {
        finalView = filteredClassesCount === 0 ? emptyStateView : dataView;
    }

    var classesComponent = _react2.default.createElement(
        'div',
        { className: _index2.default.classRollComponent },
        _react2.default.createElement(_index4.default, {
            classesCountInSchool: classesCount,
            classroomsLength: classrooms.length,
            filteredClassesCount: filteredClassesCount,
            handleAddClass: openAddClassModal,
            handleOnDownloadClassRoll: onDownloadClassRoll,
            handleQuickUpload: onQuickUpload,
            isClassRollDownloaded: isClassRollDownloaded,
            isClassroomDataLoaded: isClassroomDataLoaded,
            selectedProduct: selectedProduct }),
        finalView,
        _react2.default.createElement(_index6.default, {
            deletingClassrooms: deletingClassrooms,
            deletingEmptyClassrooms: deletingEmptyClassrooms,
            handleOnCancelStudentSignInCards: handleOnCancelStudentSignInCards,
            handleOnCloseDeleteClassroomsConfirmation: handleOnCloseDeleteClassroomsConfirmation,
            handleOnCloseDeleteClassroomsSuccess: handleOnCloseDeleteClassroomsSuccess,
            handleOnDeleteClassrooms: handleOnDeleteClassrooms,
            handleOnDownloadStudentsSignInCards: handleOnDownloadStudentsSignInCards,
            handleOnShowDeleteClassroomsConfirmation: handleOnShowDeleteClassroomsConfirmation,
            handleOnStudentSignInCards: handleOnStudentSignInCards,
            isStudentsSignInCardDownloaded: isStudentsSignInCardDownloaded,
            noOfSelectedClassrooms: selectedClasses.length,
            showDeleteClassroomsConfirmation: showDeleteClassroomsConfirmation,
            showDeleteClassroomsSuccess: showDeleteClassroomsSuccess,
            showHideSignInCardModal: showHideSignInCardModal
        })
    );

    return _react2.default.createElement(
        'div',
        { className: _index2.default.classRollComponent },
        classesComponent,
        addClassModalView
    );
};

ClassRoll.propTypes = {
    addClass: _propTypes2.default.func,
    classrooms: _propTypes2.default.arrayOf(_propTypes2.default.object),
    selectedClasses: _propTypes2.default.arrayOf(_propTypes2.default.number),
    classesCount: _propTypes2.default.number,
    filteredClassesCount: _propTypes2.default.number,
    isClassroomDataLoaded: _propTypes2.default.bool,
    isClassRollDownloaded: _propTypes2.default.bool,
    onDownloadClassRoll: _propTypes2.default.func,
    onQuickUpload: _propTypes2.default.func,
    openAddClassModal: _propTypes2.default.func,
    handleOnDownloadStudentsSignInCards: _propTypes2.default.func,
    isStudentsSignInCardDownloaded: _propTypes2.default.bool,
    isProductCoursesFetching: _propTypes2.default.bool,
    isSchoolCoursesFetching: _propTypes2.default.bool,
    isProductCoursesLoaded: _propTypes2.default.bool,
    isSaveInProgress: _propTypes2.default.bool,
    intl: _reactIntl.intlShape.isRequired,
    handleOnClassEdit: _propTypes2.default.func,
    gridRowGetter: _propTypes2.default.func,
    onGridSort: _propTypes2.default.func,
    onRowSelect: _propTypes2.default.func,
    classModel: _propTypes2.default.object,
    showAddClassConfirmationModal: _propTypes2.default.bool,
    showAddClassValidationModal: _propTypes2.default.bool,
    addClassValidationMessage: _propTypes2.default.string,
    closeAddStudentValidationModal: _propTypes2.default.func,
    showAddClassModal: _propTypes2.default.bool,
    onAddClassCloseModal: _propTypes2.default.func,
    handleOnAddClassSubmit: _propTypes2.default.func,
    selectedProduct: _propTypes2.default.object,
    yearGroups: _propTypes2.default.arrayOf(_propTypes2.default.object),
    productCountries: _propTypes2.default.arrayOf(_propTypes2.default.object),
    upfCountries: _propTypes2.default.arrayOf(_propTypes2.default.object),
    productCourses: _propTypes2.default.arrayOf(_propTypes2.default.object),
    productTeachers: _propTypes2.default.arrayOf(_propTypes2.default.object),
    handleListOnChange: _propTypes2.default.func,
    dataFilterOptions: _propTypes2.default.object,
    filterOnChange: _propTypes2.default.func,
    filterOnClear: _propTypes2.default.func,
    onSearch: _propTypes2.default.func,
    handleOnAssignTeacher: _propTypes2.default.func,
    handleOnAssignStudent: _propTypes2.default.func,
    getProductCourses: _propTypes2.default.func,
    getSchoolCourses: _propTypes2.default.func,
    handleOnDeleteClassrooms: _propTypes2.default.func,
    deletingClassrooms: _propTypes2.default.bool,
    showDeleteClassroomsConfirmation: _propTypes2.default.bool,
    showDeleteClassroomsSuccess: _propTypes2.default.bool,
    handleOnCloseDeleteClassroomsConfirmation: _propTypes2.default.func,
    handleOnCloseDeleteClassroomsSuccess: _propTypes2.default.func,
    handleOnShowDeleteClassroomsConfirmation: _propTypes2.default.func,
    deletingEmptyClassrooms: _propTypes2.default.bool,
    handleOnStudentSignInCards: _propTypes2.default.func,
    handleOnCancelStudentSignInCards: _propTypes2.default.func,
    showHideSignInCardModal: _propTypes2.default.bool,
    getFilteredUPFCourses: _propTypes2.default.func,
    getFilteredNewCourses: _propTypes2.default.func,
    upfCourses: _propTypes2.default.array,
    newCourses: _propTypes2.default.array,
    clearProductCourses: _propTypes2.default.func,
    clearUPFCourses: _propTypes2.default.func,
    isUPFCoursesFetching: _propTypes2.default.bool,
    isNewCoursesFetching: _propTypes2.default.bool,
    displayNewCourses: _propTypes2.default.bool
};

exports.default = (0, _reactIntl.injectIntl)((0, _reactStyleable2.default)(_index2.default)(ClassRoll));

/***/ }),
/* 677 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _reactIntl = __webpack_require__(2);

exports.default = (0, _reactIntl.defineMessages)({
    classes: {
        id: 'app.components.classRoll.classes',
        defaultMessage: 'CLASSES'
    },
    edit: {
        id: 'app.components.classRoll.edit',
        defaultMessage: 'EDIT'
    },
    class: {
        id: 'app.components.classRoll.class',
        defaultMessage: 'CLASS'
    },
    year: {
        id: 'app.components.classRoll.year',
        defaultMessage: 'YEAR'
    },
    course: {
        id: 'app.components.classRoll.course',
        defaultMessage: 'COURSE'
    },
    resource: {
        id: 'app.components.classRoll.resource',
        defaultMessage: 'RESOURCE'
    },
    teacher: {
        id: 'app.components.classRoll.teacher',
        defaultMessage: 'TEACHER'
    },
    students: {
        id: 'app.components.classRoll.students',
        defaultMessage: 'STUDENTS'
    },
    noClassesAvailable: {
        id: 'app.components.classRoll.noClassesAvailable',
        defaultMessage: 'No classes available.'
    },
    allYears: {
        id: 'app.components.classRoll.allYears',
        defaultMessage: 'All years'
    },
    allTeachers: {
        id: 'app.components.classRoll.allTeachers',
        defaultMessage: 'All teachers'
    },
    learningModules: {
        id: 'app.components.classRoll.learningModules',
        defaultMessage: 'LEARNING MODULES'
    }
});

/***/ }),
/* 678 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactStyleable = __webpack_require__(6);

var _reactStyleable2 = _interopRequireDefault(_reactStyleable);

var _reactIntl = __webpack_require__(2);

var _iconDictionary = __webpack_require__(8);

var _index = __webpack_require__(1694);

var _index2 = _interopRequireDefault(_index);

var _messages = __webpack_require__(679);

var _messages2 = _interopRequireDefault(_messages);

var _index3 = __webpack_require__(257);

var _index4 = _interopRequireDefault(_index3);

var _index5 = __webpack_require__(7);

var _index6 = _interopRequireDefault(_index5);

var _productEnum = __webpack_require__(77);

var _productEnum2 = _interopRequireDefault(_productEnum);

var _index7 = __webpack_require__(24);

var _index8 = _interopRequireDefault(_index7);

var _signInCardsFormats = __webpack_require__(126);

var _signInCardsFormats2 = _interopRequireDefault(_signInCardsFormats);

var _utils = __webpack_require__(13);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ClassroomGroupList = function ClassroomGroupList(_ref) {
    var intl = _ref.intl,
        classroomDetail = _ref.classroomDetail,
        downloadStudentSignInCards = _ref.downloadStudentSignInCards,
        isDownloadingSignInCards = _ref.isDownloadingSignInCards,
        handleOnEditGroup = _ref.handleOnEditGroup,
        openAddGroup = _ref.openAddGroup,
        selectedProduct = _ref.selectedProduct,
        handleOnStudentSignInCards = _ref.handleOnStudentSignInCards,
        handleOnCancelStudentSignInCards = _ref.handleOnCancelStudentSignInCards,
        _ref$showHideSignInCa = _ref.showHideSignInCardModal,
        showHideSignInCardModal = _ref$showHideSignInCa === undefined ? false : _ref$showHideSignInCa,
        displayNewCourses = _ref.displayNewCourses,
        yearGroup = _ref.yearGroup;

    var getUPFCourseTitle = function getUPFCourseTitle(_ref2) {
        var upfCourseId = _ref2.upfCourseId,
            upfCourseTitle = _ref2.upfCourseTitle;

        if (upfCourseId !== 0) {
            return upfCourseTitle;
        }

        return intl.formatMessage(_messages2.default.noCourseFound);
    };

    return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
            'div',
            null,
            _react2.default.createElement(
                'div',
                { className: _index2.default.header },
                _react2.default.createElement(
                    'div',
                    { className: _index2.default.columns },
                    intl.formatMessage(_messages2.default.group)
                ),
                _react2.default.createElement(
                    'div',
                    { className: _index2.default.columns },
                    selectedProduct.id !== _productEnum2.default.MATLETICA.id && _react2.default.createElement(
                        'span',
                        null,
                        intl.formatMessage(_messages2.default.activities).toUpperCase()
                    )
                ),
                displayNewCourses && _react2.default.createElement(
                    'div',
                    { className: _index2.default.columns },
                    selectedProduct.id !== _productEnum2.default.MATLETICA.id && _react2.default.createElement(
                        'span',
                        null,
                        intl.formatMessage(_messages2.default.newCourses).toUpperCase()
                    )
                ),
                _react2.default.createElement(
                    'div',
                    { className: _index2.default.newCoursesColumn },
                    selectedProduct.id === _productEnum2.default.MATHLETICS.id && _react2.default.createElement(
                        'span',
                        null,
                        intl.formatMessage(_messages2.default.skillQuests).toUpperCase()
                    )
                ),
                _react2.default.createElement(
                    'div',
                    { className: _index2.default.studentColumn },
                    intl.formatMessage(_messages2.default.students)
                ),
                _react2.default.createElement('div', { className: _index2.default.editColumn })
            ),
            classroomDetail.classroomGroups.map(function (classGroup) {
                var conquestCourseTitle = classGroup.conquestCourseTitle;

                return _react2.default.createElement(
                    'div',
                    { className: _index2.default.list, key: classGroup.id },
                    _react2.default.createElement(
                        'div',
                        { className: _index2.default.columns },
                        classGroup.name
                    ),
                    _react2.default.createElement(
                        'div',
                        { className: _index2.default.columns },
                        selectedProduct.id !== _productEnum2.default.MATLETICA.id && _react2.default.createElement(
                            'span',
                            null,
                            classGroup.courseTitle
                        )
                    ),
                    displayNewCourses && _react2.default.createElement(
                        'div',
                        { className: _index2.default.columns },
                        selectedProduct.id !== _productEnum2.default.MATLETICA.id && _react2.default.createElement(
                            'span',
                            null,
                            (0, _utils.getNewCoursesTitle)(yearGroup, conquestCourseTitle !== '', conquestCourseTitle, intl)
                        )
                    ),
                    _react2.default.createElement(
                        'div',
                        { className: _index2.default.columns },
                        selectedProduct.id === _productEnum2.default.MATHLETICS.id && getUPFCourseTitle(classGroup)
                    ),
                    _react2.default.createElement(
                        'div',
                        { className: _index2.default.studentColumn },
                        _react2.default.createElement(_index4.default, {
                            count: classGroup.studentIds.length,
                            icon: _index2.default.studentCountIcon })
                    ),
                    _react2.default.createElement(
                        'div',
                        { className: _index2.default.editColumn },
                        _react2.default.createElement(_index6.default, {
                            containerClassName: 'editClassGroupBtn ' + _index2.default.buttonContainerStyle,
                            handleOnClick: function handleOnClick() {
                                return handleOnEditGroup(classGroup);
                            },
                            icon: _iconDictionary.Edit,
                            iconClassName: _index2.default.icon })
                    )
                );
            }),
            _react2.default.createElement(
                'div',
                { className: _index2.default.footer },
                _react2.default.createElement(_index6.default, {
                    containerClassName: _index2.default.downloadSignInCards,
                    disabled: classroomDetail.studentsProfileId.length === 0,
                    handleOnClick: handleOnStudentSignInCards,
                    icon: _iconDictionary.Download,
                    iconClassName: _index2.default.icon,
                    label: intl.formatMessage(_messages2.default.downloadCards) }),
                _react2.default.createElement(_index6.default, {
                    containerClassName: _index2.default.createGroup,
                    handleOnClick: openAddGroup,
                    icon: _iconDictionary.Edit,
                    iconClassName: _index2.default.icon,
                    label: intl.formatMessage(_messages2.default.createGroup) })
            )
        ),
        _react2.default.createElement(
            _index8.default,
            { show: showHideSignInCardModal },
            _react2.default.createElement(_signInCardsFormats2.default, {
                handleOnCancel: handleOnCancelStudentSignInCards,
                handleOnDownloadSignInCards: downloadStudentSignInCards,
                isSignInCardDownloaded: !isDownloadingSignInCards })
        )
    );
};

ClassroomGroupList.propTypes = {
    intl: _reactIntl.intlShape.isRequired,
    classroomDetail: _propTypes2.default.object,
    yearGroup: _propTypes2.default.number,
    downloadStudentSignInCards: _propTypes2.default.func,
    isDownloadingSignInCards: _propTypes2.default.bool,
    handleOnEditGroup: _propTypes2.default.func,
    openAddGroup: _propTypes2.default.func,
    selectedProduct: _propTypes2.default.object,
    handleOnStudentSignInCards: _propTypes2.default.func,
    handleOnCancelStudentSignInCards: _propTypes2.default.func,
    showHideSignInCardModal: _propTypes2.default.bool,
    displayNewCourses: _propTypes2.default.bool
};

exports.default = (0, _reactIntl.injectIntl)((0, _reactStyleable2.default)(_index2.default)(ClassroomGroupList));

/***/ }),
/* 679 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _reactIntl = __webpack_require__(2);

exports.default = (0, _reactIntl.defineMessages)({
    group: {
        id: 'app.components.ClassroomGroupList.group',
        defaultMessage: 'GROUP'
    },
    courses: {
        id: 'app.components.ClassroomGroupList.courses',
        defaultMessage: 'COURSES'
    },
    activities: {
        id: 'app.components.ClassroomGroupList.activities',
        defaultMessage: 'ACTIVITIES'
    },
    newCourses: {
        id: 'app.components.ClassroomGroupList.newCourses',
        defaultMessage: 'NEW COURSES'
    },
    students: {
        id: 'app.components.ClassroomGroupList.students',
        defaultMessage: 'STUDENTS'
    },
    downloadCards: {
        id: 'app.components.ClassroomGroupList.downloadCards',
        defaultMessage: 'Download sign-in cards'
    },
    downloading: {
        id: 'app.components.ClassroomGroupList.downloading',
        defaultMessage: 'downloading'
    },
    createGroup: {
        id: 'app.components.ClassroomGroupList.createGroup',
        defaultMessage: 'Create group'
    },
    skillQuests: {
        id: 'app.components.ClassroomGroupList.skillQuests',
        defaultMessage: 'SKILL QUESTS'
    },
    optedOut: {
        id: 'app.components.ClassroomGroupList.optedOut',
        defaultMessage: 'Opted out'
    },
    noVoluntaryCourseSet: {
        id: 'app.components.ClassroomGroupList.noVoluntaryCourseSet',
        defaultMessage: 'No voluntary course set'
    },
    noCourseAssigned: {
        id: 'app.components.ClassroomGroupList.noCourseAssigned',
        defaultMessage: 'No course assigned'
    },
    noCourseFound: {
        id: 'app.components.ClassroomGroupList.noCourseFound',
        defaultMessage: 'No course found.'
    }
});

/***/ }),
/* 680 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _reactIntl = __webpack_require__(2);

exports.default = (0, _reactIntl.defineMessages)({
    ok: {
        id: 'app.components.UploadValidationConfirmation.ok',
        defaultMessage: 'Ok'
    }
});

/***/ }),
/* 681 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _reactIntl = __webpack_require__(2);

exports.default = (0, _reactIntl.defineMessages)({
    doYouWishToContinue: {
        id: 'app.components.confirmationModal.doYouWishToContinue',
        defaultMessage: 'Do you wish to continue?'
    }
});

/***/ }),
/* 682 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactStyleable = __webpack_require__(6);

var _reactStyleable2 = _interopRequireDefault(_reactStyleable);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactIntl = __webpack_require__(2);

var _index = __webpack_require__(1698);

var _index2 = _interopRequireDefault(_index);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var CourseBadgeAdmin = function (_PureComponent) {
    _inherits(CourseBadgeAdmin, _PureComponent);

    function CourseBadgeAdmin() {
        _classCallCheck(this, CourseBadgeAdmin);

        return _possibleConstructorReturn(this, (CourseBadgeAdmin.__proto__ || Object.getPrototypeOf(CourseBadgeAdmin)).apply(this, arguments));
    }

    _createClass(CourseBadgeAdmin, [{
        key: 'render',
        value: function render() {
            var _props = this.props,
                children = _props.children,
                background = _props.background,
                disabled = _props.disabled;

            var childElement = children ? _react2.default.createElement(
                'div',
                { className: _index2.default.children },
                children
            ) : '';
            var badgeStyle = disabled ? _index2.default.container + ' ' + _index2.default.disabled : '' + _index2.default.container;

            return _react2.default.createElement(
                'div',
                { className: badgeStyle + ' ' + background },
                childElement
            );
        }
    }]);

    return CourseBadgeAdmin;
}(_react.PureComponent);

CourseBadgeAdmin.propTypes = {
    children: _propTypes2.default.node,
    background: _propTypes2.default.string,
    disabled: _propTypes2.default.bool
};

exports.default = (0, _reactIntl.injectIntl)((0, _reactStyleable2.default)(_index2.default)(CourseBadgeAdmin));

/***/ }),
/* 683 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactStyleable = __webpack_require__(6);

var _reactStyleable2 = _interopRequireDefault(_reactStyleable);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactIntl = __webpack_require__(2);

var _index = __webpack_require__(1699);

var _index2 = _interopRequireDefault(_index);

var _iconDictionary = __webpack_require__(8);

var _svgIcon = __webpack_require__(21);

var _svgIcon2 = _interopRequireDefault(_svgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var CourseBadge = function (_PureComponent) {
    _inherits(CourseBadge, _PureComponent);

    function CourseBadge() {
        _classCallCheck(this, CourseBadge);

        return _possibleConstructorReturn(this, (CourseBadge.__proto__ || Object.getPrototypeOf(CourseBadge)).apply(this, arguments));
    }

    _createClass(CourseBadge, [{
        key: 'render',
        value: function render() {
            var _props = this.props,
                children = _props.children,
                background = _props.background,
                disabled = _props.disabled;

            var childElement = children ? _react2.default.createElement(
                'div',
                { className: _index2.default.children },
                children
            ) : '';
            var badgeStyle = disabled ? _index2.default.container + ' ' + _index2.default.disabled : '' + _index2.default.container;

            return _react2.default.createElement(
                'div',
                { className: badgeStyle, style: { background: '' + background } },
                childElement,
                _react2.default.createElement(
                    'div',
                    { className: _index2.default.forwardButton },
                    _react2.default.createElement(_svgIcon2.default, { icon: _iconDictionary.Forward })
                )
            );
        }
    }]);

    return CourseBadge;
}(_react.PureComponent);

CourseBadge.propTypes = {
    children: _propTypes2.default.node,
    background: _propTypes2.default.string,
    disabled: _propTypes2.default.bool
};

exports.default = (0, _reactIntl.injectIntl)((0, _reactStyleable2.default)(_index2.default)(CourseBadge));

/***/ }),
/* 684 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactIntl = __webpack_require__(2);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _button = __webpack_require__(7);

var _button2 = _interopRequireDefault(_button);

var _variants = __webpack_require__(9);

var _iconDictionary = __webpack_require__(8);

var _index = __webpack_require__(589);

var _index2 = _interopRequireDefault(_index);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ItemSelector = function ItemSelector(props) {
  var selected = props.selected,
      propsCss = props.css,
      guideUrl = props.guideUrl,
      hasNoCursor = props.hasNoCursor,
      hasGuide = props.hasGuide;

  var styles = _extends({}, _index2.default, propsCss);

  // Selected class
  var selectedClassName = selected ? styles.selected : '';

  var cursorClassName = hasNoCursor ? styles.noCursor : '';

  // delete CSS props passing down to Button
  var buttonProps = props;
  delete buttonProps.css;

  var viewButton = hasGuide ? _react2.default.createElement(_button2.default, {
    containerClassName: '' + styles.button,
    handleOnClick: function handleOnClick() {
      window.open(guideUrl, '_blank');
    },
    icon: _iconDictionary.Guide,
    variant: _variants.CIRCLE_ICON }) : '';

  return _react2.default.createElement(
    'div',
    { className: styles.itemSelector + ' ' + selectedClassName },
    _react2.default.createElement(_button2.default, _extends({ containerClassName: styles.label + '  ' + cursorClassName }, buttonProps)),
    viewButton
  );
};

ItemSelector.propTypes = {
  /**
   * CSS overrides please refer to React-Styleable
   */
  css: _propTypes2.default.object,
  /**
   * Toggle to show guide or preview button
   */
  guideUrl: _propTypes2.default.string,
  /**
   * Toggle to show guide or preview button
   */
  hasGuide: _propTypes2.default.bool,
  /**
   * Hide cursor upon hover
   */
  hasNoCursor: _propTypes2.default.bool,
  /**
   * Toggle to show different style when cliced or selected
   */
  selected: _propTypes2.default.bool
};

exports.default = (0, _reactIntl.injectIntl)(ItemSelector);

/***/ }),
/* 685 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _reactIntl = __webpack_require__(2);

exports.default = (0, _reactIntl.defineMessages)({
    ok: {
        id: 'app.components.courseTopicsDetails.ok',
        defaultMessage: 'Ok'
    },
    topicLabel: {
        id: 'app.components.courseTopicsDetails.topicLabel',
        defaultMessage: 'Topics'
    },
    activitiesLabel: {
        id: 'app.components.courseTopicsDetails.activitiesLabel',
        defaultMessage: 'Activities'
    },
    areYouReadyLabel: {
        id: 'app.components.courseTopicsDetails.areYouReadyLabel',
        defaultMessage: 'Are you ready?'
    },
    testLabel: {
        id: 'app.components.courseTopicsDetails.testLabel',
        defaultMessage: 'Test'
    },
    exportLabel: {
        id: 'app.components.courseTopicsDetails.exportLabel',
        defaultMessage: 'Export'
    },
    topicFileLabel: {
        id: 'app.components.courseTopicsDetails.topicFileLabel',
        defaultMessage: 'TOPIC'
    },
    activitiesFileLabel: {
        id: 'app.components.courseTopicsDetails.activitiesFileLabel',
        defaultMessage: 'ACTIVITIES'
    },
    countryLabel: {
        id: 'app.components.courseTopicsDetails.countryLabel',
        defaultMessage: 'Country'
    },
    gradeLabel: {
        id: 'app.components.courseTopicsDetails.gradeLabel',
        defaultMessage: 'Grade'
    },
    authorLabel: {
        id: 'app.components.courseTopicsDetails.authorLabel',
        defaultMessage: 'Author'
    },
    easierActivitiesFileLabel: {
        id: 'app.components.courseTopicsDetails.easierActivitiesFileLabel',
        defaultMessage: 'SOMETHING EASIER ACTIVITIES'
    }
});

/***/ }),
/* 686 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _moment = __webpack_require__(17);

var _moment2 = _interopRequireDefault(_moment);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var DateHelper = function () {
    function DateHelper() {
        _classCallCheck(this, DateHelper);
    }

    _createClass(DateHelper, null, [{
        key: 'getPreviousMonday',
        value: function getPreviousMonday(date) {
            var prevMonday = date ? new Date(date) : new Date();
            prevMonday.setDate(prevMonday.getDate() - (prevMonday.getDay() + 6) % 7);
            return prevMonday;
        }
    }, {
        key: 'getThisWeekStartEnd',
        value: function getThisWeekStartEnd() {
            var formatString = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'YYYY-MM-DD';

            var thisMonday = DateHelper.getPreviousMonday();
            var startDate = (0, _moment2.default)(thisMonday).format(formatString);
            var endDate = (0, _moment2.default)(thisMonday).add(6, 'days').format(formatString);

            return { startDate: startDate, endDate: endDate };
        }
    }, {
        key: 'getLastWeekStartEnd',
        value: function getLastWeekStartEnd() {
            var formatString = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'YYYY-MM-DD';

            var thisMonday = DateHelper.getPreviousMonday();
            var startDate = (0, _moment2.default)(thisMonday).subtract(7, 'days').format(formatString);
            var endDate = (0, _moment2.default)(thisMonday).subtract(1, 'days').format(formatString);

            return { startDate: startDate, endDate: endDate };
        }
    }]);

    return DateHelper;
}();

exports.default = DateHelper;

/***/ }),
/* 687 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _moment = __webpack_require__(17);

var _moment2 = _interopRequireDefault(_moment);

var _reactComponents = __webpack_require__(603);

var _icon_calendar = __webpack_require__(1775);

var _icon_calendar2 = _interopRequireDefault(_icon_calendar);

var _datePickerConstants = __webpack_require__(385);

var _dateHelper = __webpack_require__(686);

var _dateHelper2 = _interopRequireDefault(_dateHelper);

var _index = __webpack_require__(590);

var _index2 = _interopRequireDefault(_index);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * DatePicker component
 * Allows user to pick 'This week' 'Last week' 'This school year' or 'Custom date' from drop down
 * Loads Calendar component if user chooses custom date range
 * Calls onDateChange callback prop when selection changes
 */
var DatePicker = function (_Component) {
    _inherits(DatePicker, _Component);

    function DatePicker(props) {
        _classCallCheck(this, DatePicker);

        var _this = _possibleConstructorReturn(this, (DatePicker.__proto__ || Object.getPrototypeOf(DatePicker)).call(this, props));

        _this.onDateChange = function (value) {
            _this.setState({
                selectedDateType: value,
                selectedCustomDates: false,
                selectedTimeRange: false,
                dateTimeSubmitted: false
            });

            var startDate = void 0;
            var endDate = void 0;

            switch (value) {
                case _datePickerConstants.THIS_WEEK:
                    var _DateHelper$getThisWe = _dateHelper2.default.getThisWeekStartEnd();

                    startDate = _DateHelper$getThisWe.startDate;
                    endDate = _DateHelper$getThisWe.endDate;

                    break;
                case _datePickerConstants.LAST_WEEK:
                    var _DateHelper$getLastWe = _dateHelper2.default.getLastWeekStartEnd();

                    startDate = _DateHelper$getLastWe.startDate;
                    endDate = _DateHelper$getLastWe.endDate;

                    break;
                case _datePickerConstants.THIS_SCHOOL_YEAR:
                case _datePickerConstants.LIFETIME:
                    var _this$props$academicY = _this.props.academicYear;
                    startDate = _this$props$academicY.startDate;
                    endDate = _this$props$academicY.endDate;

                    break;
                case _datePickerConstants.CUSTOM_DATE:
                case _datePickerConstants.CUSTOM_DATE_TIME:
                    return;
                default:
                    console.warn('Unhandled date type'); // eslint-disable-line no-console
            }

            _this.props.onDateChange(value, startDate, endDate);
        };

        _this.onCustomDateChange = function (startDate, endDate) {
            _this.props.onDateChange(_this.state.selectedDateType, startDate, endDate);
            _this.setState({ selectedCustomDates: true });
        };

        _this.onTimeRangeChange = function (time) {
            _this.props.onTimeChange(time);
            _this.setState({ selectedTimeRange: true, time: time });
        };

        _this.onCustomDateClose = function () {
            // todo: i don't like this timeout but i couldn't get cancel functionality to
            // work without it
            setTimeout(function () {
                if (!_this.state.selectedCustomDates) {
                    _this.setState({
                        selectedDateType: _this.props.currentDate.type,
                        selectedCustomDates: true,
                        hideSelectedTime: true
                    });
                }
            });
        };

        _this.onDateTimeSubmit = function () {
            _this.setState({
                selectedDateType: _datePickerConstants.CUSTOM_DATE_TIME,
                selectedCustomDates: true,
                hideSelectedTime: true,
                dateTimeSubmitted: true
            });
        };

        _this.getSelectedLabel = function () {
            var selectedDateType = _this.state.selectedDateType;


            if (selectedDateType === _datePickerConstants.CUSTOM_DATE || selectedDateType === _datePickerConstants.CUSTOM_DATE_TIME) {
                var time = _this.state.time;
                var _this$props$currentDa = _this.props.currentDate,
                    startDate = _this$props$currentDa.startDate,
                    endDate = _this$props$currentDa.endDate;

                var formatString = 'DD MMM YYYY';
                var formattedStartDate = (0, _moment2.default)(startDate).format(formatString);
                var formattedEndDate = (0, _moment2.default)(endDate).format(formatString);
                return selectedDateType === _datePickerConstants.CUSTOM_DATE ? formattedStartDate + ' - ' + formattedEndDate : formattedStartDate + ' ' + time[0] + ' - ' + formattedEndDate + ' ' + time[1];
            }

            return selectedDateType;
        };

        _this.state = {
            weeklyRangeOnly: props.weeklyRangeOnly !== undefined ? props.weeklyRangeOnly : true,
            selectedDateType: props.currentDate.type,
            selectedCustomDates: props.currentDate.type === _datePickerConstants.CUSTOM_DATE || props.currentDate.type === _datePickerConstants.CUSTOM_DATE_TIME,
            hideSelectedTime: true,
            time: ['9:00AM', '5:00PM'],
            dateTimeSubmitted: false
        };
        return _this;
    }

    // eslint-disable-next-line camelcase


    _createClass(DatePicker, [{
        key: 'UNSAFE_componentWillReceiveProps',
        value: function UNSAFE_componentWillReceiveProps(nextProps) {
            if (this.state.selectedDateType !== nextProps.currentDate.type) {
                this.setState({
                    weeklyRangeOnly: nextProps.weeklyRangeOnly !== undefined ? nextProps.weeklyRangeOnly : true,
                    selectedDateType: nextProps.currentDate.type,
                    selectedCustomDates: nextProps.currentDate.type === _datePickerConstants.CUSTOM_DATE
                });
            }
        }

        /**
         * Runs when user changes value in dropdown
         * Calls onDateChange prop with newly selected date range (unless user chose custom date)
         */


        /**
         * Runs when user selects start & end dates in calendar component
         * Calls onDateChange prop with newly selected date range
         */


        /**
         * Reverts date to previous selection if user cancelled selecting custom dates in calendar
         */

        /**
         * Generates the display text to show in the dropdown menu as the current selected option
         * Handles showing the date range if user chose custom date ie. 14 June 2018 - 28 June 2018
         */

    }, {
        key: 'render',
        value: function render() {
            var _this2 = this;

            var _state = this.state,
                selectedDateType = _state.selectedDateType,
                selectedCustomDates = _state.selectedCustomDates,
                hideSelectedTime = _state.hideSelectedTime,
                dateTimeSubmitted = _state.dateTimeSubmitted,
                weeklyRangeOnly = _state.weeklyRangeOnly;
            var _props = this.props,
                academicYear = _props.academicYear,
                reactDatesConfig = _props.reactDatesConfig,
                className = _props.className,
                options = _props.options,
                initialDate = _props.initialDate,
                labels = _props.labels;

            var selectedDateLabel = this.getSelectedLabel();
            var shouldDisplayCalendar = selectedDateType === _datePickerConstants.CUSTOM_DATE && !selectedCustomDates || selectedDateType === _datePickerConstants.CUSTOM_DATE_TIME && !dateTimeSubmitted && (!selectedCustomDates || hideSelectedTime);
            return _react2.default.createElement(
                'div',
                { className: className + ' ' + _index2.default.datePicker },
                shouldDisplayCalendar && _react2.default.createElement(_reactComponents.Calendar, {
                    includeTimeRange: selectedDateType === _datePickerConstants.CUSTOM_DATE_TIME,
                    initialDate: initialDate,
                    onClose: this.onCustomDateClose,
                    onDatesPicked: this.onCustomDateChange,
                    onSubmit: this.onDateTimeSubmit,
                    onTimesPicked: function onTimesPicked(time) {
                        return _this2.onTimeRangeChange(time);
                    },
                    range: academicYear,
                    reactDatesConfig: reactDatesConfig,
                    weeklyRangeOnly: weeklyRangeOnly
                }),
                !shouldDisplayCalendar && _react2.default.createElement(_reactComponents.DropdownMenu, {
                    icon: _icon_calendar2.default,
                    onSelectOption: function onSelectOption(option) {
                        return _this2.onDateChange(option.value);
                    },
                    options: options.map(function (option) {
                        return {
                            label: labels[option] ? labels[option] : option,
                            value: option
                        };
                    }),
                    selectedOption: {
                        label: labels[selectedDateLabel] ? labels[selectedDateLabel] : selectedDateLabel,
                        value: selectedDateType
                    }
                })
            );
        }
    }]);

    return DatePicker;
}(_react.Component);

DatePicker.propTypes = {
    /** Range to limit the date selection to */
    academicYear: _propTypes2.default.shape({
        startDate: _propTypes2.default.string,
        endDate: _propTypes2.default.string
    }).isRequired,

    /** Current selected date */
    currentDate: _propTypes2.default.shape({
        type: _propTypes2.default.oneOf(_datePickerConstants.DATE_OPTIONS),
        startDate: _propTypes2.default.string,
        endDate: _propTypes2.default.string
    }).isRequired,

    /** To show the Spanish or any passed language in the dropdown */
    labels: _propTypes2.default.objectOf(_propTypes2.default.oneOf(_datePickerConstants.DATE_OPTIONS)),

    /** Options to display in dropdown menu */
    options: _propTypes2.default.arrayOf(_propTypes2.default.oneOf(_datePickerConstants.DATE_OPTIONS)),

    /** Callback when a date selection is made */
    onDateChange: _propTypes2.default.func.isRequired,

    initialDate: _propTypes2.default.shape({
        startDate: _propTypes2.default.string,
        endDate: _propTypes2.default.string
    }),

    /** Flag whether custom date range should be mon-sun
    *  enabled by default
    */
    weeklyRangeOnly: _propTypes2.default.bool,

    /** Callback when a time selection is made
    */
    onTimeChange: _propTypes2.default.func,

    /** Custom class to attach to parent div - use this to override any styles */
    className: _propTypes2.default.string,

    /** Props overrides for react-dates component
    * @see <a href="https://github.com/airbnb/react-dates#make-some-awesome-datepickers">react-dates props</a>
    */
    reactDatesConfig: _propTypes2.default.object
};
DatePicker.defaultProps = {
    labels: _datePickerConstants.DEFAULT_DATE_OPTIONS_LABELS,
    options: _datePickerConstants.DEFAULT_DATE_OPTIONS
};


DatePicker.THIS_WEEK = _datePickerConstants.THIS_WEEK;
DatePicker.LAST_WEEK = _datePickerConstants.LAST_WEEK;
DatePicker.THIS_SCHOOL_YEAR = _datePickerConstants.THIS_SCHOOL_YEAR;
DatePicker.CUSTOM_DATE = _datePickerConstants.CUSTOM_DATE;
DatePicker.CUSTOM_DATE_TIME = _datePickerConstants.CUSTOM_DATE_TIME;
DatePicker.LIFETIME = _datePickerConstants.LIFETIME;
DatePicker.DEFAULT_DATE_OPTIONS = _datePickerConstants.DEFAULT_DATE_OPTIONS;
DatePicker.DATE_OPTIONS = _datePickerConstants.DATE_OPTIONS;

exports.default = DatePicker;

/***/ }),
/* 688 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactStyleable = __webpack_require__(6);

var _reactStyleable2 = _interopRequireDefault(_reactStyleable);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _moment = __webpack_require__(17);

var _moment2 = _interopRequireDefault(_moment);

var _reactIntl = __webpack_require__(2);

var _datePicker = __webpack_require__(687);

var _datePicker2 = _interopRequireDefault(_datePicker);

var _datePickerConstants = __webpack_require__(385);

var _messages = __webpack_require__(689);

var _messages2 = _interopRequireDefault(_messages);

var _i18n = __webpack_require__(129);

var _index = __webpack_require__(590);

var _index2 = _interopRequireDefault(_index);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var DatePickerComp = function (_Component) {
    _inherits(DatePickerComp, _Component);

    function DatePickerComp() {
        _classCallCheck(this, DatePickerComp);

        return _possibleConstructorReturn(this, (DatePickerComp.__proto__ || Object.getPrototypeOf(DatePickerComp)).apply(this, arguments));
    }

    _createClass(DatePickerComp, [{
        key: 'render',
        // eslint-disable-line react/prefer-stateless-function
        value: function render() {
            var _datePickerLabels;

            var _props = this.props,
                disabled = _props.disabled,
                intl = _props.intl;

            var datePickerLabels = (_datePickerLabels = {}, _defineProperty(_datePickerLabels, _datePickerConstants.CUSTOM_DATE, intl.formatMessage(_messages2.default.customDate)), _defineProperty(_datePickerLabels, _datePickerConstants.LAST_WEEK, intl.formatMessage(_messages2.default.lastWeek)), _defineProperty(_datePickerLabels, _datePickerConstants.THIS_SCHOOL_YEAR, intl.formatMessage(_messages2.default.thisSchoolYear)), _defineProperty(_datePickerLabels, _datePickerConstants.THIS_WEEK, intl.formatMessage(_messages2.default.thisWeek)), _datePickerLabels);
            var disabledFlag = disabled ? 'disabled-datepicker' : '';
            _moment2.default.locale((0, _i18n.getLocale)().substr(0, 2));
            return _react2.default.createElement(_datePicker2.default, _extends({}, this.props, { className: _index2.default.datepicker + ' ' + disabledFlag, labels: datePickerLabels }));
        }
    }]);

    return DatePickerComp;
}(_react.Component);

DatePickerComp.propTypes = {
    disabled: _propTypes2.default.bool,
    intl: _reactIntl.intlShape.isRequired
};

exports.default = (0, _reactIntl.injectIntl)((0, _reactStyleable2.default)(_index2.default)(DatePickerComp));

/***/ }),
/* 689 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _reactIntl = __webpack_require__(2);

exports.default = (0, _reactIntl.defineMessages)({
    thisWeek: {
        id: 'app.components.datePicker.thisWeek',
        defaultMessage: 'This week'
    },
    lastWeek: {
        id: 'app.components.datePicker.lastWeek',
        defaultMessage: 'Last week'
    },
    thisSchoolYear: {
        id: 'app.components.datePicker.thisSchoolYear',
        defaultMessage: 'This school year'
    },
    customDate: {
        id: 'app.components.datePicker.customDate',
        defaultMessage: 'Custom date'
    }
});

/***/ }),
/* 690 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactStyleable = __webpack_require__(6);

var _reactStyleable2 = _interopRequireDefault(_reactStyleable);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactIntl = __webpack_require__(2);

var _assignCoursesConquest = __webpack_require__(802);

var _assignCoursesConquest2 = _interopRequireDefault(_assignCoursesConquest);

var _localStorage = __webpack_require__(269);

var _localStorage2 = _interopRequireDefault(_localStorage);

var _utils = __webpack_require__(13);

var _messages = __webpack_require__(386);

var _messages2 = _interopRequireDefault(_messages);

var _index = __webpack_require__(591);

var _index2 = _interopRequireDefault(_index);

var _index3 = __webpack_require__(149);

var _index4 = _interopRequireDefault(_index3);

var _courseBadgeAdmin = __webpack_require__(682);

var _courseBadgeAdmin2 = _interopRequireDefault(_courseBadgeAdmin);

var _index5 = __webpack_require__(7);

var _index6 = _interopRequireDefault(_index5);

var _index7 = __webpack_require__(24);

var _index8 = _interopRequireDefault(_index7);

var _index9 = __webpack_require__(383);

var _index10 = _interopRequireDefault(_index9);

var _iconDictionary = __webpack_require__(8);

var _portalComms = __webpack_require__(55);

var _portalComms2 = _interopRequireDefault(_portalComms);

var _svgIcon = __webpack_require__(21);

var _svgIcon2 = _interopRequireDefault(_svgIcon);

var _assignCoursesUpf = __webpack_require__(393);

var _assignCoursesUpf2 = _interopRequireDefault(_assignCoursesUpf);

var _assignCoursesLegacy = __webpack_require__(806);

var _assignCoursesLegacy2 = _interopRequireDefault(_assignCoursesLegacy);

var _constants = __webpack_require__(40);

var _informationModal = __webpack_require__(691);

var _informationModal2 = _interopRequireDefault(_informationModal);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var DefaultCourseMapperAdmin = function (_Component) {
    _inherits(DefaultCourseMapperAdmin, _Component);

    function DefaultCourseMapperAdmin(props) {
        _classCallCheck(this, DefaultCourseMapperAdmin);

        var _this = _possibleConstructorReturn(this, (DefaultCourseMapperAdmin.__proto__ || Object.getPrototypeOf(DefaultCourseMapperAdmin)).call(this, props));

        _this.getFilteredCourses = function (filtered, course) {
            if (course.isSelected) {
                filtered.push({
                    yearGroupEnum: course.yearGroupId,
                    courseId: course.newCourseId
                });
            }
            return filtered;
        };

        _this.saveCourses = function () {
            _this.setState({ showInfoModal: false });

            var updatedUPFCourses = Array.isArray(_this.state.upfCourses) && _this.state.upfCourses.reduce(function (filtered, course) {
                return _this.getFilteredCourses(filtered, course);
            }, []);

            var updatedLegacyCourses = _this.state.defaultCourses.reduce(function (filtered, course) {
                return _this.getFilteredCourses(filtered, course);
            }, []);
            var updatedConquestCourses = _this.state.conquestCourses.reduce(function (filtered, course) {
                return _this.getFilteredCourses(filtered, course);
            }, []);
            _this.props.handleOnSave({
                defaultCourses: updatedLegacyCourses,
                upfCourses: updatedUPFCourses || [],
                conquestCourses: updatedConquestCourses || []
            });
        };

        _this.handleQueueCourses = function () {
            var currentSelection = _localStorage2.default.getItem(_constants.ROLLOVER_INFO_MODAL_OPTOUT);
            if (!currentSelection) {
                _this.setState({
                    showInfoModal: true
                });
                return;
            }
            _this.saveCourses();
        };

        _this.handleOnUPFCourseSelection = function (yearGroupId, courseType) {
            var _this$state = _this.state,
                showUPFCourseSelector = _this$state.showUPFCourseSelector,
                selectedUPFYearGroup = _this$state.selectedUPFYearGroup;


            _this.setState({
                selectedUPFYearGroup: yearGroupId,
                selectedCourseType: courseType,
                showUPFCourseSelector: selectedUPFYearGroup === yearGroupId ? !showUPFCourseSelector : true,
                showLegacyCourseSelector: false,
                showConquestCourseSelector: false
            });
        };

        _this.handleOnLegacyCourseSelection = function (yearGroupId, courseType) {
            var _this$state2 = _this.state,
                showLegacyCourseSelector = _this$state2.showLegacyCourseSelector,
                selectedLegacyYearGroup = _this$state2.selectedLegacyYearGroup;


            _this.setState({
                selectedLegacyYearGroup: yearGroupId,
                selectedCourseType: courseType,
                showUPFCourseSelector: false,
                showLegacyCourseSelector: selectedLegacyYearGroup === yearGroupId ? !showLegacyCourseSelector : true,
                showConquestCourseSelector: false
            });
        };

        _this.handleOnNewCoursesCourseSelection = function (yearGroupId, courseType) {
            var _this$state3 = _this.state,
                showConquestCourseSelector = _this$state3.showConquestCourseSelector,
                selectedConquestYearGroup = _this$state3.selectedConquestYearGroup;


            _this.setState({
                selectedConquestYearGroup: yearGroupId,
                selectedCourseType: courseType,
                showConquestCourseSelector: selectedConquestYearGroup === yearGroupId ? !showConquestCourseSelector : true,
                showUPFCourseSelector: false,
                showLegacyCourseSelector: false
            });
        };

        _this.getRowClass = function (yearGroupId) {
            var _this$state4 = _this.state,
                selectedUPFYearGroup = _this$state4.selectedUPFYearGroup,
                selectedLegacyYearGroup = _this$state4.selectedLegacyYearGroup,
                selectedConquestYearGroup = _this$state4.selectedConquestYearGroup,
                selectedCourseType = _this$state4.selectedCourseType;


            if (yearGroupId === selectedUPFYearGroup && selectedCourseType === 'upf' || yearGroupId === selectedLegacyYearGroup && selectedCourseType === 'legacy' || yearGroupId === selectedConquestYearGroup && selectedCourseType === 'newCourses') {
                return _index2.default.courseSelected;
            }
            return _index2.default.courseUnselected;
        };

        _this.renderRowBadge = function (_ref) {
            var isSelected = _ref.isSelected,
                yearGroupId = _ref.yearGroupId,
                yearGroupName = _ref.yearGroupName;
            return _react2.default.createElement(
                'div',
                { className: _index2.default.yearRow },
                _react2.default.createElement(
                    _courseBadgeAdmin2.default,
                    { background: isSelected ? _index2.default.yearSelected : _index2.default.yearUnselected },
                    _react2.default.createElement(_index4.default, {
                        badgeStyle: _index2.default.yearGroup + ' yg' + yearGroupId,
                        content: yearGroupName
                    })
                )
            );
        };

        _this.renderLearningModuleRow = function (_ref2) {
            var className = _ref2.className,
                onClick = _ref2.onClick,
                message = _ref2.message,
                _ref2$isVisible = _ref2.isVisible,
                isVisible = _ref2$isVisible === undefined ? true : _ref2$isVisible;

            if (!isVisible) return null;

            return _react2.default.createElement(
                'div',
                {
                    className: className,
                    onClick: onClick,
                    role: 'button',
                    tabIndex: '-1' },
                _react2.default.createElement(
                    'div',
                    { className: _index2.default.forwardButton },
                    _react2.default.createElement(_svgIcon2.default, { icon: _iconDictionary.Forward })
                ),
                _react2.default.createElement(
                    'div',
                    { className: _index2.default.learningModuleText },
                    message,
                    ':'
                )
            );
        };

        _this.renderCourseBlock = function (_ref3) {
            var className = _ref3.className,
                isSelected = _ref3.isSelected,
                textContent = _ref3.textContent,
                shouldRender = _ref3.shouldRender;
            var intl = _this.props.intl;


            if (!shouldRender) return null;

            return _react2.default.createElement(
                'div',
                { className: className },
                textContent,
                isSelected && ' ' + intl.formatMessage(_messages2.default.unconfirmed)
            );
        };

        _this.getUpfCourseText = function (_ref4) {
            var course = _ref4.course;
            var intl = _this.props.intl;


            if (!course || course.courseName === undefined || course.courseId === _constants.DEFAULT_COURSE_ID && course.courseName === '') {
                return intl.formatMessage(_messages2.default.noUPFCourseSet);
            }

            return course.courseName;
        };

        _this.renderRows = function () {
            var rows = void 0;
            var intl = _this.props.intl;
            var _this$state5 = _this.state,
                selectedUPFYearGroup = _this$state5.selectedUPFYearGroup,
                selectedLegacyYearGroup = _this$state5.selectedLegacyYearGroup,
                selectedConquestYearGroup = _this$state5.selectedConquestYearGroup,
                showUPFCourseSelector = _this$state5.showUPFCourseSelector,
                showConquestCourseSelector = _this$state5.showConquestCourseSelector,
                showLegacyCourseSelector = _this$state5.showLegacyCourseSelector,
                defaultCourses = _this$state5.defaultCourses,
                upfCourses = _this$state5.upfCourses,
                conquestCourses = _this$state5.conquestCourses;


            if (defaultCourses) {
                rows = defaultCourses.map(function (val) {
                    var rowStyle = _this.getRowClass(val.yearGroupId);
                    var upfCourse = Array.isArray(upfCourses) && upfCourses.find(function (course) {
                        return course.yearGroupId === val.yearGroupId;
                    });
                    var conquestCourse = Array.isArray(conquestCourses) && conquestCourses.find(function (course) {
                        return course.yearGroupId === val.yearGroupId;
                    });
                    var isNewCoursesAvailable = (0, _utils.newCoursesAvailable)(val.yearGroupId);

                    return _react2.default.createElement(
                        'div',
                        { className: _index2.default.row, key: val.yearGroupId },
                        _this.renderRowBadge({
                            isSelected: showLegacyCourseSelector && val.yearGroupId === selectedLegacyYearGroup || showUPFCourseSelector && val.yearGroupId === selectedUPFYearGroup || showConquestCourseSelector && val.yearGroupId === selectedConquestYearGroup,
                            yearGroupId: val.yearGroupId,
                            yearGroupName: val.yearGroupName
                        }),
                        _react2.default.createElement(
                            'div',
                            { className: _index2.default.learningModuleRow },
                            _this.renderLearningModuleRow({
                                className: _index2.default.courses + ' ' + (showLegacyCourseSelector && rowStyle),
                                onClick: function onClick() {
                                    return _this.handleOnLegacyCourseSelection(val.yearGroupId, 'legacy');
                                },
                                message: intl.formatMessage(_messages2.default.coursesActivityMastery)
                            }),
                            _this.renderLearningModuleRow({
                                className: _index2.default.upf + ' ' + (showConquestCourseSelector && rowStyle),
                                onClick: function onClick() {
                                    return _this.handleOnNewCoursesCourseSelection(val.yearGroupId, 'newCourses');
                                },
                                message: intl.formatMessage(_messages2.default.newCourses),
                                isVisible: isNewCoursesAvailable
                            }),
                            _this.renderLearningModuleRow({
                                className: _index2.default.upf + ' ' + (showUPFCourseSelector && rowStyle),
                                onClick: function onClick() {
                                    return _this.handleOnUPFCourseSelection(val.yearGroupId, 'upf');
                                },
                                message: intl.formatMessage(_messages2.default.skillQuests)
                            })
                        ),
                        _react2.default.createElement(
                            'div',
                            { className: _index2.default.currentCourseRow },
                            _this.renderCourseBlock({
                                className: _index2.default.defaultCourse + ' ' + (showLegacyCourseSelector && rowStyle),
                                isSelected: !!(val && val.isSelected),
                                textContent: val && val.courseName ? val.courseName : '',
                                shouldRender: true
                            }),
                            _this.renderCourseBlock({
                                className: _index2.default.defaultCourse + ' ' + (showConquestCourseSelector && rowStyle),
                                isSelected: !!(conquestCourse && conquestCourse.isSelected),
                                textContent: conquestCourse && conquestCourse.courseName ? conquestCourse.courseName : '',
                                shouldRender: isNewCoursesAvailable
                            }),
                            _this.renderCourseBlock({
                                className: _index2.default.upfDefaultCourse + ' ' + (showUPFCourseSelector && rowStyle),
                                isSelected: !!(upfCourse && upfCourse.isSelected),
                                textContent: _this.getUpfCourseText({ course: upfCourse }),
                                shouldRender: true
                            })
                        )
                    );
                });
            }

            return rows;
        };

        _this.handleOnClose = function () {
            _this.setState({ showConfirmationModal: false });
        };

        _this.handleOnConfirm = function () {
            _this.setState({
                disableSave: true,
                showConfirmationModal: false,
                selectedUPFYearGroup: -1,
                selectedLegacyYearGroup: -1,
                selectedConquestYearGroup: -1,
                selectedCourseType: '',
                selectedConquestCourse: { id: -1, name: '' },
                selectedUPFCourse: { id: _constants.DEFAULT_COURSE_ID, name: '' },
                selectedLegacyCourse: { id: -1, name: '' },
                defaultCourses: _this.props.defaultCourses,
                upfCourses: _this.props.upfCourses,
                conquestCourses: _this.props.conquestCourses,
                disableConquestAssignToGroup: true,
                disableUPFAssignToGroup: true,
                disableLegacyAssignToGroup: true,
                showConquestCourseSelector: false,
                showUPFCourseSelector: false,
                showLegacyCourseSelector: false,
                disableAssignToGroup: true
            });
        };

        _this.handleOnCancel = function () {
            var _this$state6 = _this.state,
                defaultCourses = _this$state6.defaultCourses,
                upfCourses = _this$state6.upfCourses,
                conquestCourses = _this$state6.conquestCourses;


            var hasSelectedCourses = [defaultCourses, upfCourses, conquestCourses].some(function (courses) {
                return courses.some(function (course) {
                    return course.isSelected;
                });
            });

            if (!hasSelectedCourses) {
                _portalComms2.default.navigateToLandingScreen('Course admin');
            } else {
                _this.setState({ showConfirmationModal: true });
            }
        };

        _this.onUPFCourseSelect = function (course) {
            var disableAssignToGroup = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

            _this.setState({
                selectedUPFCourse: course,
                disableUPFAssignToGroup: disableAssignToGroup
            });
        };

        _this.onConquestCourseSelect = function (course) {
            var disableAssignToGroup = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

            _this.setState({
                selectedConquestCourse: course,
                disableConquestAssignToGroup: disableAssignToGroup
            });
        };

        _this.onLegacyCourseSelect = function (course) {
            var disableAssignToGroup = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

            _this.setState({
                selectedLegacyCourse: course,
                disableLegacyAssignToGroup: disableAssignToGroup
            });
        };

        _this.assignToUPFYearGroup = function () {
            var _this$state7 = _this.state,
                upfCourses = _this$state7.upfCourses,
                selectedUPFYearGroup = _this$state7.selectedUPFYearGroup,
                selectedUPFCourse = _this$state7.selectedUPFCourse;

            var isYearExisting = upfCourses.find(function (course) {
                return course.yearGroupId === selectedUPFYearGroup;
            });
            var courses = void 0;

            if (!isYearExisting) {
                // In case there is no default course set for the UPF courses, the year group of that UPF course won't exist
                courses = [].concat(_toConsumableArray(upfCourses), [{
                    courseId: _constants.DEFAULT_COURSE_ID,
                    isSelected: true,
                    newCourseId: selectedUPFCourse.id,
                    newCourseName: selectedUPFCourse.name,
                    yearGroupId: selectedUPFYearGroup,
                    yearGroupName: selectedUPFYearGroup.toString()
                }]);
            } else {
                courses = upfCourses.map(function (course) {
                    if (course.yearGroupId === selectedUPFYearGroup) {
                        return _extends({}, course, {
                            isSelected: true,
                            newCourseId: selectedUPFCourse.id,
                            newCourseName: selectedUPFCourse.name
                        });
                    }
                    return course;
                });
            }

            _this.setState({
                disableSave: false,
                disableUPFAssignToGroup: true,
                selectedUPFCourse: { id: _constants.DEFAULT_COURSE_ID, name: '' },
                upfCourses: courses
            });
            _this.props.deselectCourses();
        };

        _this.assignToConquestYearGroup = function () {
            var _this$state8 = _this.state,
                conquestCourses = _this$state8.conquestCourses,
                selectedConquestYearGroup = _this$state8.selectedConquestYearGroup,
                selectedConquestCourse = _this$state8.selectedConquestCourse;

            var isYearExisting = conquestCourses.find(function (course) {
                return course.yearGroupId === selectedConquestYearGroup;
            });
            var courses = void 0;

            if (!isYearExisting) {
                // In case there is no default course set for the UPF courses, the year group of that UPF course won't exist
                courses = [].concat(_toConsumableArray(conquestCourses), [{
                    courseId: _constants.DEFAULT_COURSE_ID,
                    isSelected: true,
                    newCourseId: selectedConquestCourse.id,
                    newCourseName: selectedConquestCourse.name,
                    yearGroupId: selectedConquestYearGroup,
                    yearGroupName: selectedConquestYearGroup.toString()
                }]);
            } else {
                courses = conquestCourses.map(function (course) {
                    if (course.yearGroupId === selectedConquestYearGroup) {
                        return _extends({}, course, {
                            isSelected: true,
                            newCourseId: selectedConquestCourse.id,
                            newCourseName: selectedConquestCourse.name
                        });
                    }
                    return course;
                });
            }

            _this.setState({
                disableSave: false,
                disableConquestAssignToGroup: true,
                selectedConquestCourse: { id: _constants.DEFAULT_COURSE_ID, name: '' },
                conquestCourses: courses
            });
            _this.props.deselectCourses();
        };

        _this.assignToLegacyYearGroup = function () {
            var _this$state9 = _this.state,
                defaultCourses = _this$state9.defaultCourses,
                selectedLegacyYearGroup = _this$state9.selectedLegacyYearGroup,
                selectedLegacyCourse = _this$state9.selectedLegacyCourse;


            var courses = defaultCourses.map(function (course) {
                if (course.yearGroupId === selectedLegacyYearGroup) {
                    return _extends({}, course, {
                        isSelected: true,
                        newCourseId: selectedLegacyCourse.id,
                        newCourseName: selectedLegacyCourse.name
                    });
                }
                return course;
            });

            _this.setState({
                disableSave: false,
                disableLegacyAssignToGroup: true,
                selectedLegacyCourse: { id: -1, name: '' },
                defaultCourses: courses
            });
            _this.props.deselectCourses();
        };

        _this.state = {
            selectedConquestYearGroup: -1,
            selectedUPFYearGroup: -1,
            selectedLegacyYearGroup: -1,
            selectedCourseType: '',
            showConfirmationModal: false,
            defaultCourses: _this.props.defaultCourses,
            upfCourses: _this.props.upfCourses,
            conquestCourses: _this.props.conquestCourses,
            disableSave: true,
            disableCancel: true,
            disableAssignToGroup: true,
            disableConquestAssignToGroup: true,
            disableUPFAssignToGroup: true,
            disableLegacyAssignToGroup: true,
            selectedConquestCourse: { id: -1, name: '' },
            selectedUPFCourse: { id: _constants.DEFAULT_COURSE_ID, name: '' },
            selectedLegacyCourse: { id: -1, name: '' },
            showConquestCourseSelector: false,
            showUPFCourseSelector: false,
            showLegacyCourseSelector: false,
            showInfoModal: false
        };
        return _this;
    }

    _createClass(DefaultCourseMapperAdmin, [{
        key: 'render',
        value: function render() {
            var _props = this.props,
                intl = _props.intl,
                savingDefaultCourses = _props.savingDefaultCourses;
            var _state = this.state,
                showConfirmationModal = _state.showConfirmationModal,
                showInfoModal = _state.showInfoModal;


            return _react2.default.createElement(
                'div',
                null,
                _react2.default.createElement(_informationModal2.default, {
                    handleOnSave: this.saveCourses,
                    show: showInfoModal }),
                _react2.default.createElement(
                    'div',
                    { className: _index2.default.panel },
                    _react2.default.createElement(
                        'div',
                        { className: _index2.default.lhsPanel },
                        _react2.default.createElement(
                            'div',
                            { className: _index2.default.header },
                            _react2.default.createElement(
                                'div',
                                { className: _index2.default.yearColumn },
                                intl.formatMessage(_messages2.default.year)
                            ),
                            _react2.default.createElement(
                                'div',
                                {
                                    className: _index2.default.learningModule },
                                intl.formatMessage(_messages2.default.learningModule)
                            ),
                            _react2.default.createElement(
                                'div',
                                {
                                    className: _index2.default.currentCourseColumn },
                                intl.formatMessage(_messages2.default.defaultCourse)
                            )
                        ),
                        _react2.default.createElement(
                            'div',
                            null,
                            this.renderRows()
                        )
                    ),
                    _react2.default.createElement(
                        'div',
                        { className: this.state.showUPFCourseSelector ? _index2.default.showUPFCourseSelector : _index2.default.hideUPFCourseSelector },
                        _react2.default.createElement(_assignCoursesUpf2.default, {
                            disableAssignToYear: this.state.disableUPFAssignToGroup,
                            forManageDefaultCourses: true,
                            forYear: true,
                            handleOnCourseSelection: this.onUPFCourseSelect,
                            handleOnYearGroupSave: this.assignToUPFYearGroup,
                            isUPFSelected: this.state.showUPFCourseSelector,
                            selectedCourse: this.state.selectedUPFCourse,
                            showUPFCourseSelector: this.state.showUPFCourseSelector
                        })
                    ),
                    _react2.default.createElement(
                        'div',
                        { className: this.state.showConquestCourseSelector ? _index2.default.showUPFCourseSelector : _index2.default.hideUPFCourseSelector },
                        _react2.default.createElement(_assignCoursesConquest2.default, {
                            disableAssignToYear: this.state.disableConquestAssignToGroup,
                            handleOnCourseSelection: this.onConquestCourseSelect,
                            handleOnYearGroupSave: this.assignToConquestYearGroup,
                            selectedCourse: this.state.selectedConquestCourse
                        })
                    ),
                    _react2.default.createElement(
                        'div',
                        { className: this.state.showLegacyCourseSelector ? _index2.default.showUPFCourseSelector : _index2.default.hideUPFCourseSelector },
                        _react2.default.createElement(_assignCoursesLegacy2.default, {
                            assignToYearGroup: this.assignToLegacyYearGroup,
                            disableAssignToYear: this.state.disableLegacyAssignToGroup,
                            forYear: true,
                            handleOnCourseSelection: this.onLegacyCourseSelect,
                            selectedCourse: this.state.selectedLegacyCourse,
                            showLegacyCourseSelector: this.state.showLegacyCourseSelector
                        })
                    )
                ),
                _react2.default.createElement(
                    'div',
                    { className: _index2.default.settingsFooter },
                    _react2.default.createElement(_index6.default, {
                        containerClassName: _index2.default.cancelButton,
                        disabled: savingDefaultCourses,
                        handleOnClick: this.handleOnCancel,
                        label: intl.formatMessage(_messages2.default.cancel)
                    }),
                    _react2.default.createElement(_index6.default, {
                        containerClassName: _index2.default.queueButton,
                        disabled: savingDefaultCourses || this.state.disableSave,
                        handleOnClick: this.handleQueueCourses,
                        label: intl.formatMessage(_messages2.default.queue)
                    })
                ),
                _react2.default.createElement(
                    _index8.default,
                    { show: showConfirmationModal },
                    _react2.default.createElement(_index10.default, {
                        handleOnCancel: this.handleOnClose,
                        handleOnOk: this.handleOnConfirm,
                        icon: _iconDictionary.Warning,
                        title: intl.formatMessage(_messages2.default.unsavedChanges) })
                )
            );
        }
    }]);

    return DefaultCourseMapperAdmin;
}(_react.Component);

DefaultCourseMapperAdmin.propTypes = {
    intl: _reactIntl.intlShape.isRequired,
    defaultCourses: _propTypes2.default.arrayOf(_propTypes2.default.object),
    upfCourses: _propTypes2.default.arrayOf(_propTypes2.default.object),
    conquestCourses: _propTypes2.default.arrayOf(_propTypes2.default.object),
    savingDefaultCourses: _propTypes2.default.bool,
    handleOnSave: _propTypes2.default.func,
    deselectCourses: _propTypes2.default.func
};

exports.default = (0, _reactIntl.injectIntl)((0, _reactStyleable2.default)(_index2.default)(DefaultCourseMapperAdmin));

/***/ }),
/* 691 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactIntl = __webpack_require__(2);

var _reactStyleable = __webpack_require__(6);

var _reactStyleable2 = _interopRequireDefault(_reactStyleable);

var _localStorage = __webpack_require__(269);

var _localStorage2 = _interopRequireDefault(_localStorage);

var _modal = __webpack_require__(24);

var _modal2 = _interopRequireDefault(_modal);

var _index = __webpack_require__(591);

var _index2 = _interopRequireDefault(_index);

var _messages = __webpack_require__(386);

var _messages2 = _interopRequireDefault(_messages);

var _index3 = __webpack_require__(7);

var _index4 = _interopRequireDefault(_index3);

var _constants = __webpack_require__(40);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var InfoModal = function InfoModal(_ref) {
    var intl = _ref.intl,
        show = _ref.show,
        handleOnSave = _ref.handleOnSave;

    var onDontTellAgainSelection = function onDontTellAgainSelection() {
        var currentSelection = _localStorage2.default.getItem(_constants.ROLLOVER_INFO_MODAL_OPTOUT);

        if (!currentSelection) {
            _localStorage2.default.setItem(_constants.ROLLOVER_INFO_MODAL_OPTOUT, true);
        }
    };

    return _react2.default.createElement(
        _modal2.default,
        { show: show, smallMode: true },
        _react2.default.createElement(
            'div',
            { className: _index2.default.infoModalWrapper },
            _react2.default.createElement(
                'div',
                { className: _index2.default.title },
                intl.formatMessage(_messages2.default.queuedForRollover)
            ),
            _react2.default.createElement(
                'span',
                { className: _index2.default.content },
                intl.formatMessage(_messages2.default.whileYouMightSee) + ' ',
                _react2.default.createElement(
                    'span',
                    { className: _index2.default.contentBold },
                    intl.formatMessage(_messages2.default.defaultCourse).toLowerCase()
                ),
                ', ' + intl.formatMessage(_messages2.default.changesWillNotTake)
            ),
            _react2.default.createElement(
                'div',
                { className: _index2.default.content },
                intl.formatMessage(_messages2.default.youMayChangeYour)
            ),
            _react2.default.createElement(
                'div',
                { className: _index2.default.checkbox },
                _react2.default.createElement('input', { name: 'dontTellAgain', onClick: onDontTellAgainSelection, type: 'checkbox' }),
                _react2.default.createElement(
                    'label',
                    { htmlFor: 'dontTellAgain' },
                    intl.formatMessage(_messages2.default.dontTellMeAgain)
                )
            ),
            _react2.default.createElement(_index4.default, {
                buttonContainer: _index2.default.iUnderstandButton,
                handleOnClick: handleOnSave,
                label: intl.formatMessage(_messages2.default.iUnderstand)
            })
        )
    );
};

InfoModal.propTypes = {
    handleOnSave: _propTypes2.default.func.isRequired,
    show: _propTypes2.default.bool.isRequired,
    intl: _reactIntl.intlShape.isRequired
};

exports.default = (0, _reactIntl.injectIntl)((0, _reactStyleable2.default)(_index2.default)(InfoModal));

/***/ }),
/* 692 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactIntl = __webpack_require__(2);

var _reactStyleable = __webpack_require__(6);

var _reactStyleable2 = _interopRequireDefault(_reactStyleable);

var _moment = __webpack_require__(17);

var _moment2 = _interopRequireDefault(_moment);

var _index = __webpack_require__(7);

var _index2 = _interopRequireDefault(_index);

var _index3 = __webpack_require__(368);

var _index4 = _interopRequireDefault(_index3);

var _messages = __webpack_require__(387);

var _messages2 = _interopRequireDefault(_messages);

var _constants = __webpack_require__(155);

var _iconDictionary = __webpack_require__(8);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CertificatesTypes = function CertificatesTypes(props) {
    var currentDate = props.currentDate,
        fetchingSummarySuccess = props.fetchingSummarySuccess,
        downloadCertificates = props.downloadCertificates,
        isDownloading = props.isDownloading,
        summary = props.summary;
    var startDate = currentDate.startDate,
        endDate = currentDate.endDate;
    var goldCount = summary.goldCount,
        silverCount = summary.silverCount,
        bronzeCount = summary.bronzeCount;


    var dates = {
        startDate: (0, _moment2.default)(startDate, _constants.SHORT_DATE_FORMAT).format(_constants.LONG_DATE_FORMAT),
        endDate: (0, _moment2.default)(endDate, _constants.SHORT_DATE_FORMAT).format(_constants.LONG_DATE_FORMAT)
    };

    var hasDates = startDate !== null || endDate !== null;

    var view = hasDates ? _react2.default.createElement(
        'div',
        { className: _index4.default.certificatesSummaryContainer },
        _react2.default.createElement(
            'div',
            { className: _index4.default.certificatesSummaryHeader },
            props.intl.formatMessage(_messages2.default.startToEndDateLabel, dates)
        ),
        _react2.default.createElement(
            'div',
            { className: _index4.default.certificatesSummaryColumn },
            _react2.default.createElement(
                'div',
                null,
                props.intl.formatMessage(_messages2.default.goldCertType)
            ),
            _react2.default.createElement(_index2.default, {
                containerClassName: _index4.default.certificatesSummaryButton,
                disabled: !fetchingSummarySuccess || goldCount === 0 || isDownloading,
                handleOnClick: function handleOnClick() {
                    return downloadCertificates(_constants.GOLD_CERTIFICATE_TYPE);
                },
                icon: _iconDictionary.Download,
                iconClassName: _index4.default.icon,
                label: '' + goldCount })
        ),
        _react2.default.createElement(
            'div',
            { className: _index4.default.certificatesSummaryColumn },
            _react2.default.createElement(
                'div',
                null,
                props.intl.formatMessage(_messages2.default.silverCertType)
            ),
            _react2.default.createElement(_index2.default, {
                containerClassName: _index4.default.certificatesSummaryButton,
                disabled: !fetchingSummarySuccess || silverCount === 0 || isDownloading,
                handleOnClick: function handleOnClick() {
                    return downloadCertificates(_constants.SILVER_CERTIFICATE_TYPE);
                },
                icon: _iconDictionary.Download,
                iconClassName: _index4.default.icon,
                label: '' + silverCount })
        ),
        _react2.default.createElement(
            'div',
            { className: _index4.default.certificatesSummaryColumn },
            _react2.default.createElement(
                'div',
                null,
                props.intl.formatMessage(_messages2.default.bronzeCertType)
            ),
            _react2.default.createElement(_index2.default, {
                containerClassName: _index4.default.certificatesSummaryButton,
                disabled: !fetchingSummarySuccess || bronzeCount === 0 || isDownloading,
                handleOnClick: function handleOnClick() {
                    return downloadCertificates(_constants.BRONZE_CERTIFICATE_TYPE);
                },
                icon: _iconDictionary.Download,
                iconClassName: _index4.default.icon,
                label: '' + bronzeCount })
        )
    ) : _react2.default.createElement('div', { className: _index4.default.certificatesSummaryContainer });

    return view;
};

CertificatesTypes.propTypes = {
    currentDate: _propTypes2.default.object,
    downloadCertificates: _propTypes2.default.func,
    fetchingSummarySuccess: _propTypes2.default.bool,
    intl: _reactIntl.intlShape.isRequired,
    isDownloading: _propTypes2.default.bool,
    summary: _propTypes2.default.object
};

exports.default = (0, _reactIntl.injectIntl)((0, _reactStyleable2.default)(_index4.default)(CertificatesTypes));

/***/ }),
/* 693 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var dropdowns = exports.dropdowns = function dropdowns() {
    _classCallCheck(this, dropdowns);
};

dropdowns.TEACHERS = { id: 'teacher-dropdown', key: 'userProfileId', customLabel: function customLabel(item) {
        return item.displayTitle + ' ' + item.firstName + ' ' + item.lastName;
    } };
dropdowns.CLASSES = { id: 'classes-dropdown', key: 'classroomId', label: 'name' };
dropdowns.GROUPS = { id: 'groups-dropdown', key: 'id', label: 'name' };

var buttons = exports.buttons = function buttons() {
    _classCallCheck(this, buttons);
};

buttons.DOWNLOAD = { id: 'download-button' };

/***/ }),
/* 694 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactStyleable = __webpack_require__(6);

var _reactStyleable2 = _interopRequireDefault(_reactStyleable);

var _index = __webpack_require__(368);

var _index2 = _interopRequireDefault(_index);

var _form = __webpack_require__(695);

var _form2 = _interopRequireDefault(_form);

var _index3 = __webpack_require__(262);

var _index4 = _interopRequireDefault(_index3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var DownloadCertificates = function DownloadCertificates(props) {
    var view = _react2.default.createElement(
        'div',
        { className: _index2.default.downloadCertificatesContainer },
        _react2.default.createElement(_form2.default, props)
    );

    return view;
};

var styledCerts = (0, _reactStyleable2.default)(_index2.default)(DownloadCertificates);

exports.default = (0, _index4.default)('loading')(styledCerts);

/***/ }),
/* 695 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactIntl = __webpack_require__(2);

var _reactStyleable = __webpack_require__(6);

var _reactStyleable2 = _interopRequireDefault(_reactStyleable);

var _cloneDeep = __webpack_require__(54);

var _cloneDeep2 = _interopRequireDefault(_cloneDeep);

var _isEmpty = __webpack_require__(1446);

var _isEmpty2 = _interopRequireDefault(_isEmpty);

var _flow = __webpack_require__(1443);

var _flow2 = _interopRequireDefault(_flow);

var _filter = __webpack_require__(137);

var _filter2 = _interopRequireDefault(_filter);

var _property = __webpack_require__(513);

var _property2 = _interopRequireDefault(_property);

var _some = __webpack_require__(1458);

var _some2 = _interopRequireDefault(_some);

var _partialRight = __webpack_require__(1457);

var _partialRight2 = _interopRequireDefault(_partialRight);

var _moment = __webpack_require__(17);

var _moment2 = _interopRequireDefault(_moment);

var _index = __webpack_require__(368);

var _index2 = _interopRequireDefault(_index);

var _index3 = __webpack_require__(7);

var _index4 = _interopRequireDefault(_index3);

var _variants = __webpack_require__(9);

var _messages = __webpack_require__(387);

var _messages2 = _interopRequireDefault(_messages);

var _index5 = __webpack_require__(37);

var _index6 = _interopRequireDefault(_index5);

var _constant = __webpack_require__(151);

var _constants = __webpack_require__(693);

var _certificateSummary = __webpack_require__(692);

var _certificateSummary2 = _interopRequireDefault(_certificateSummary);

var _index7 = __webpack_require__(688);

var _index8 = _interopRequireDefault(_index7);

var _constants2 = __webpack_require__(155);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* global window */
/* eslint react/no-danger: 0 */

var DownloadCertificatesForm = function DownloadCertificatesForm(props) {
    var academicYear = props.academicYear,
        classes = props.classes,
        classroomGroups = props.classroomGroups,
        currentDate = props.currentDate,
        downloadCertificates = props.downloadCertificates,
        fetchingAcademicYear = props.fetchingAcademicYear,
        fetchingAcademicYearSuccess = props.fetchingAcademicYearSuccess,
        fetchingClassroomGroups = props.fetchingClassroomGroups,
        fetchingSummary = props.fetchingSummary,
        fetchingSummarySuccess = props.fetchingSummarySuccess,
        isDownloading = props.isDownloading,
        onDatePickerChange = props.onDatePickerChange,
        selectedTeacherId = props.selectedTeacherId,
        selectedClassroomId = props.selectedClassroomId,
        selectedGroupId = props.selectedGroupId,
        setClassroomId = props.setClassroomId,
        setGroupId = props.setGroupId,
        setTeacherId = props.setTeacherId,
        summary = props.summary,
        teachers = props.teachers;
    var totalCount = summary.totalCount;


    var isDownlodButtonEnabled = fetchingAcademicYear || fetchingSummary || isDownloading || fetchingClassroomGroups || totalCount === 0;

    var downloadButtonLabel = _messages2.default.downloadBtn;

    if (totalCount === 0) {
        downloadButtonLabel = _messages2.default.noCertsAvailable;
    }

    if (totalCount > 0) {
        downloadButtonLabel = _messages2.default.certsAvailable;
    }

    var certTypesProps = {
        currentDate: currentDate,
        downloadCertificates: downloadCertificates,
        fetchingSummarySuccess: fetchingSummarySuccess,
        isDownloading: isDownloading,
        summary: summary
    };

    var calendarProps = {
        isOutsideRange: function isOutsideRange(day) {
            return (0, _moment2.default)().diff(day) < 0;
        }
    };

    var clonedTeachers = (0, _filter2.default)((0, _cloneDeep2.default)(teachers), function (item) {
        return !(0, _isEmpty2.default)(item.assignedClassrooms);
    });

    var clonedClasses = (0, _filter2.default)((0, _cloneDeep2.default)(classes), function (item) {
        return !(0, _isEmpty2.default)(item.studentsProfileId);
    });

    var hasTeacher = selectedTeacherId !== _constants2.EMPTY_VALUE || selectedTeacherId === undefined;

    var filteredClasses = !hasTeacher ? clonedClasses : (0, _filter2.default)(clonedClasses, (0, _flow2.default)((0, _property2.default)('teachers'), (0, _partialRight2.default)(_some2.default, { userProfileId: parseInt(selectedTeacherId, 10) })));

    var infoView = _react2.default.createElement(
        'div',
        { className: _index2.default.downloadCertificatesComponent },
        _react2.default.createElement(
            'div',
            { className: _index2.default.downloadCertificatesHeader },
            props.intl.formatMessage(_messages2.default.header)
        ),
        _react2.default.createElement(
            'div',
            { className: _index2.default.downloadCertificatesContent },
            _react2.default.createElement(
                'div',
                { className: _index2.default.downloadCertificatesContentWrapper },
                _react2.default.createElement(_index6.default, {
                    customLabelFn: _constants.dropdowns.TEACHERS.customLabel,
                    disabled: teachers.length < 1,
                    name: _constants.dropdowns.TEACHERS.id,
                    onChange: setTeacherId,
                    optionKey: _constants.dropdowns.TEACHERS.key,
                    options: clonedTeachers,
                    placeholder: props.intl.formatMessage(_messages2.default.teachersDropdownLabel),
                    value: selectedTeacherId,
                    variant: _constant.BORDERED
                }),
                _react2.default.createElement(_index6.default, {
                    disabled: classes.length < 1,
                    name: _constants.dropdowns.CLASSES.id,
                    onChange: setClassroomId,
                    optionKey: _constants.dropdowns.CLASSES.key,
                    options: filteredClasses,
                    optionText: _constants.dropdowns.CLASSES.label,
                    placeholder: props.intl.formatMessage(_messages2.default.classesDropdownLabel),
                    value: selectedClassroomId,
                    variant: _constant.BORDERED
                }),
                _react2.default.createElement(_index6.default, {
                    disabled: selectedClassroomId === _constants2.EMPTY_VALUE || classroomGroups.length < 1 || fetchingClassroomGroups,
                    name: _constants.dropdowns.GROUPS.id,
                    onChange: setGroupId,
                    optionKey: _constants.dropdowns.GROUPS.key,
                    options: classroomGroups,
                    optionText: _constants.dropdowns.GROUPS.label,
                    placeholder: props.intl.formatMessage(_messages2.default.groupsDropdownLabel),
                    value: selectedGroupId,
                    variant: _constant.BORDERED
                }),
                _react2.default.createElement(_index8.default, {
                    academicYear: academicYear,
                    currentDate: currentDate,
                    disabled: !fetchingAcademicYearSuccess,
                    onDateChange: onDatePickerChange,
                    reactDatesConfig: calendarProps }),
                _react2.default.createElement(_certificateSummary2.default, certTypesProps)
            )
        ),
        _react2.default.createElement(
            'div',
            { className: _index2.default.downloadCertificatesFooter },
            _react2.default.createElement(_index4.default, {
                containerClassName: _constants.buttons.DOWNLOAD.id,
                disabled: isDownlodButtonEnabled,
                handleOnClick: downloadCertificates,
                label: props.intl.formatMessage(downloadButtonLabel, { totalCount: totalCount }),
                variant: _variants.DARK })
        )
    );

    return infoView;
};

DownloadCertificatesForm.propTypes = {
    academicYear: _propTypes2.default.object,
    classes: _propTypes2.default.arrayOf(_propTypes2.default.object),
    classroomGroups: _propTypes2.default.arrayOf(_propTypes2.default.object),
    currentDate: _propTypes2.default.object,
    downloadCertificates: _propTypes2.default.func,
    fetchingAcademicYear: _propTypes2.default.bool,
    fetchingAcademicYearSuccess: _propTypes2.default.bool,
    fetchingClassroomGroups: _propTypes2.default.bool,
    fetchingSummary: _propTypes2.default.bool,
    fetchingSummarySuccess: _propTypes2.default.bool,
    intl: _reactIntl.intlShape.isRequired,
    isDownloading: _propTypes2.default.bool,
    isSuccess: _propTypes2.default.bool,
    onDatePickerChange: _propTypes2.default.func,
    selectedTeacherId: _propTypes2.default.string,
    selectedClassroomId: _propTypes2.default.string,
    selectedGroupId: _propTypes2.default.string,
    setClassroomId: _propTypes2.default.func,
    setGroupId: _propTypes2.default.func,
    setTeacherId: _propTypes2.default.func,
    summary: _propTypes2.default.object,
    teachers: _propTypes2.default.arrayOf(_propTypes2.default.object)
};

exports.default = (0, _reactIntl.injectIntl)((0, _reactStyleable2.default)(_index2.default)(DownloadCertificatesForm));

/***/ }),
/* 696 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _reactIntl = __webpack_require__(2);

exports.default = (0, _reactIntl.defineMessages)({
    manageStudents: {
        id: 'app.components.EditClassForm.manageStudents',
        defaultMessage: 'Manage students'
    },
    changeCourse: {
        id: 'app.components.EditClassForm.changeCourse',
        defaultMessage: 'Change course'
    },
    renameGroup: {
        id: 'app.components.EditClassForm.renameGroup',
        defaultMessage: 'Rename group'
    },
    delete: {
        id: 'app.components.EditClassForm.delete',
        defaultMessage: 'Delete group'
    },
    close: {
        id: 'app.components.EditClassForm.close',
        defaultMessage: 'Close'
    },
    deleting: {
        id: 'app.components.EditClassForm.deleting',
        defaultMessage: 'Deleting'
    },
    deleteNonEmptyGroupConfirmation: {
        id: 'app.components.EditClassForm.deleteNonEmptyGroupConfirmation',
        defaultMessage: 'must be empty before it can be deleted.'
    },
    pleaseGoTo: {
        id: 'app.components.EditClassForm.pleaseGoTo',
        defaultMessage: 'Please go to'
    },
    toMoveYourStudents: {
        id: 'app.components.EditClassForm.toMoveYourStudents',
        defaultMessage: 'to move your students.'
    },
    AreYouSureYouWantToDelete: {
        id: 'app.components.EditClassForm.AreYouSureYouWantToDelete',
        defaultMessage: 'Are you sure you want to delete '
    },
    doYouWishTo: {
        id: 'app.components.EditClassForm.doYouWishTo',
        defaultMessage: 'Do you wish to rename the group'
    },
    to: {
        id: 'app.components.EditClassForm.to',
        defaultMessage: 'to'
    },
    questionMark: {
        id: 'app.components.EditClassForm.questionMark',
        defaultMessage: '?'
    },
    yourGroup: {
        id: 'app.components.EditClassForm.yourGroup',
        defaultMessage: 'Your group, '
    },
    hasBeenDeleted: {
        id: 'app.components.EditClassForm.hasBeenDeleted',
        defaultMessage: ', has been deleted.'
    }
});

/***/ }),
/* 697 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactIntl = __webpack_require__(2);

var _iconDictionary = __webpack_require__(8);

var _index = __webpack_require__(592);

var _index2 = _interopRequireDefault(_index);

var _index3 = __webpack_require__(7);

var _index4 = _interopRequireDefault(_index3);

var _deleteGroupMessages = __webpack_require__(696);

var _deleteGroupMessages2 = _interopRequireDefault(_deleteGroupMessages);

var _index5 = __webpack_require__(36);

var _index6 = _interopRequireDefault(_index5);

var _confirmationRequest = __webpack_require__(382);

var _confirmationRequest2 = _interopRequireDefault(_confirmationRequest);

var _withModal = __webpack_require__(49);

var _withModal2 = _interopRequireDefault(_withModal);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var DeleteGroup = function DeleteGroup(props) {
    var handleOnManageStudentsBeforeDeleteGroup = props.handleOnManageStudentsBeforeDeleteGroup,
        intl = props.intl,
        classTitle = props.classTitle,
        selectedGroup = props.selectedGroup,
        handleOnCloseDeleteGroupModal = props.handleOnCloseDeleteGroupModal,
        isDeletingGroupInProgress = props.isDeletingGroupInProgress,
        showDeleteNonEmptyGroupConfirmationModal = props.showDeleteNonEmptyGroupConfirmationModal,
        handleOnDeleteNonEmptyGroup = props.handleOnDeleteNonEmptyGroup,
        showDeleteGroupConfirmationBeforeSubmit = props.showDeleteGroupConfirmationBeforeSubmit,
        handleOnCancelDeleteGroupConfirmationBeforeSubmit = props.handleOnCancelDeleteGroupConfirmationBeforeSubmit,
        handleOnDeleteGroup = props.handleOnDeleteGroup,
        handleOnCloseDeleteGroupConfirmation = props.handleOnCloseDeleteGroupConfirmation,
        showDeleteGroupConfirmation = props.showDeleteGroupConfirmation;


    var loadModalComponent = function loadModalComponent() {
        var modalComponent = '';

        if (showDeleteNonEmptyGroupConfirmationModal) {
            modalComponent = _react2.default.createElement(
                _index6.default,
                {
                    handleOnCloseModal: handleOnDeleteNonEmptyGroup,
                    icon: _iconDictionary.Warning },
                _react2.default.createElement(
                    'span',
                    { className: _index2.default.highlight },
                    selectedGroup.name,
                    ' '
                ),
                intl.formatMessage(_deleteGroupMessages2.default.deleteNonEmptyGroupConfirmation),
                _react2.default.createElement('br', null),
                intl.formatMessage(_deleteGroupMessages2.default.pleaseGoTo),
                _react2.default.createElement(_index4.default, {
                    buttonContainer: _index2.default.btnContainerStudentManagement,
                    containerClassName: _index2.default.btnStudentManagement,
                    handleOnClick: function handleOnClick() {
                        return handleOnManageStudentsBeforeDeleteGroup(selectedGroup.classroomId, classTitle, selectedGroup.id);
                    },
                    label: intl.formatMessage(_deleteGroupMessages2.default.manageStudents) }),
                intl.formatMessage(_deleteGroupMessages2.default.toMoveYourStudents)
            );
        }

        if (showDeleteGroupConfirmationBeforeSubmit) {
            modalComponent = _react2.default.createElement(
                _confirmationRequest2.default,
                {
                    handleOnCancel: handleOnCancelDeleteGroupConfirmationBeforeSubmit,
                    handleOnClose: handleOnCloseDeleteGroupModal,
                    handleOnOk: handleOnDeleteGroup,
                    isLoading: isDeletingGroupInProgress },
                intl.formatMessage(_deleteGroupMessages2.default.AreYouSureYouWantToDelete),
                _react2.default.createElement(
                    'span',
                    { className: _index2.default.highlight },
                    ' ',
                    selectedGroup.name,
                    ' '
                ),
                intl.formatMessage(_deleteGroupMessages2.default.questionMark)
            );
        }

        if (showDeleteGroupConfirmation) {
            modalComponent = _react2.default.createElement(
                _index6.default,
                {
                    handleOnCloseModal: handleOnCloseDeleteGroupConfirmation,
                    icon: _iconDictionary.Tick },
                intl.formatMessage(_deleteGroupMessages2.default.yourGroup),
                _react2.default.createElement(
                    'span',
                    { className: _index2.default.highlight },
                    ' ',
                    selectedGroup.name
                ),
                intl.formatMessage(_deleteGroupMessages2.default.hasBeenDeleted)
            );
        }

        return modalComponent;
    };

    return loadModalComponent();
};

DeleteGroup.propTypes = {
    classTitle: _propTypes2.default.string,
    handleOnCloseDeleteGroupConfirmation: _propTypes2.default.func,
    handleOnCloseDeleteGroupModal: _propTypes2.default.func,
    handleOnDeleteGroup: _propTypes2.default.func,
    handleOnDeleteNonEmptyGroup: _propTypes2.default.func,
    handleOnManageStudentsBeforeDeleteGroup: _propTypes2.default.func,
    handleOnCancelDeleteGroupConfirmationBeforeSubmit: _propTypes2.default.func,
    intl: _reactIntl.intlShape.isRequired,
    isDeletingGroupInProgress: _propTypes2.default.bool,
    selectedGroup: _propTypes2.default.object,
    showDeleteNonEmptyGroupConfirmationModal: _propTypes2.default.bool,
    showDeleteGroupConfirmation: _propTypes2.default.bool,
    showDeleteGroupConfirmationBeforeSubmit: _propTypes2.default.bool
};

var IntlDeleteGroup = (0, _reactIntl.injectIntl)(DeleteGroup);
exports.default = (0, _withModal2.default)('isActive')(IntlDeleteGroup);

/***/ }),
/* 698 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactStyleable = __webpack_require__(6);

var _reactStyleable2 = _interopRequireDefault(_reactStyleable);

var _reactIntl = __webpack_require__(2);

var _spinner = __webpack_require__(94);

var _spinner2 = _interopRequireDefault(_spinner);

var _index = __webpack_require__(7);

var _index2 = _interopRequireDefault(_index);

var _variants = __webpack_require__(9);

var _index3 = __webpack_require__(592);

var _index4 = _interopRequireDefault(_index3);

var _messages = __webpack_require__(699);

var _messages2 = _interopRequireDefault(_messages);

var _index5 = __webpack_require__(668);

var _index6 = _interopRequireDefault(_index5);

var _index7 = __webpack_require__(700);

var _index8 = _interopRequireDefault(_index7);

var _index9 = __webpack_require__(650);

var _index10 = _interopRequireDefault(_index9);

var _index11 = __webpack_require__(628);

var _index12 = _interopRequireDefault(_index11);

var _index13 = __webpack_require__(664);

var _index14 = _interopRequireDefault(_index13);

var _index15 = __webpack_require__(738);

var _index16 = _interopRequireDefault(_index15);

var _deleteGroup = __webpack_require__(697);

var _deleteGroup2 = _interopRequireDefault(_deleteGroup);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var EditClassForm = function EditClassForm(props) {
    var intl = props.intl,
        handleOnCloseEditClass = props.handleOnCloseEditClass,
        isLoadingEditClassDetail = props.isLoadingEditClassDetail,
        classroomDetail = props.classroomDetail,
        yearGroups = props.yearGroups,
        downloadStudentSignInCards = props.downloadStudentSignInCards,
        isDownloadingSignInCards = props.isDownloadingSignInCards,
        handleOnClassNameChange = props.handleOnClassNameChange,
        canSubmit = props.canSubmit,
        className = props.className,
        editClassGroupIsVisible = props.editClassGroupIsVisible,
        selectedGroup = props.selectedGroup,
        selectedProduct = props.selectedProduct,
        isSelectedGroupDefault = props.isSelectedGroupDefault,
        hideEditClassGroup = props.hideEditClassGroup,
        showEditClassGroup = props.showEditClassGroup,
        handleOnRenameGroup = props.handleOnRenameGroup,
        showRenameGroupConfirmationModal = props.showRenameGroupConfirmationModal,
        handleOnCloseDeleteGroupConfirmation = props.handleOnCloseDeleteGroupConfirmation,
        handleOnCloseDeleteGroupModal = props.handleOnCloseDeleteGroupModal,
        handleOnCloseRenameGroupModal = props.handleOnCloseRenameGroupModal,
        handleOnCancelRenameGroupModal = props.handleOnCancelRenameGroupModal,
        handleOnShowRenameGroupModal = props.handleOnShowRenameGroupModal,
        showRenameGroupModal = props.showRenameGroupModal,
        isRenameGroupInProgress = props.isRenameGroupInProgress,
        handleOnCloseValidationModal = props.handleOnCloseValidationModal,
        handleOnOkRenameGroup = props.handleOnOkRenameGroup,
        showRenameGroupConfirmationBeforeSubmit = props.showRenameGroupConfirmationBeforeSubmit,
        handleOnCancelRenameGroupConfirmationBeforeSubmit = props.handleOnCancelRenameGroupConfirmationBeforeSubmit,
        yearGroup = props.yearGroup,
        handleOnYearGroupChange = props.handleOnYearGroupChange,
        handleOnCloseRenameGroupConfirmation = props.handleOnCloseRenameGroupConfirmation,
        handleOnSaveClass = props.handleOnSaveClass,
        handleOnTeacherUnassign = props.handleOnTeacherUnassign,
        showModal = props.showModal,
        handleOnUnassignConfirm = props.handleOnUnassignConfirm,
        isUserOperationModalOpen = props.isUserOperationModalOpen,
        handleOnCloseModal = props.handleOnCloseModal,
        isLoading = props.isLoading,
        teachersOperationSuccessConfirmation = props.teachersOperationSuccessConfirmation,
        isSavingClass = props.isSavingClass,
        handleOnPrintTeacherSignInCard = props.handleOnPrintTeacherSignInCard,
        downloadingTeachersIds = props.downloadingTeachersIds,
        handleOnAssignTeacher = props.handleOnAssignTeacher,
        handleOnDeleteGroup = props.handleOnDeleteGroup,
        isDeletingGroupInProgress = props.isDeletingGroupInProgress,
        showDeleteNonEmptyGroupConfirmationModal = props.showDeleteNonEmptyGroupConfirmationModal,
        showDeleteGroupConfirmation = props.showDeleteGroupConfirmation,
        showDeleteGroupConfirmationBeforeSubmit = props.showDeleteGroupConfirmationBeforeSubmit,
        handleOnDeleteNonEmptyGroup = props.handleOnDeleteNonEmptyGroup,
        handleOnCancelDeleteGroupConfirmationBeforeSubmit = props.handleOnCancelDeleteGroupConfirmationBeforeSubmit,
        handleOnDeleteGroupRequest = props.handleOnDeleteGroupRequest,
        openChangeCourse = props.openChangeCourse,
        changeCourseIsActive = props.changeCourseIsActive,
        changeCourseClassroomId = props.changeCourseClassroomId,
        changeCourseGroupId = props.changeCourseGroupId,
        addGroupIsActive = props.addGroupIsActive,
        openAddGroup = props.openAddGroup,
        closeAddGroup = props.closeAddGroup,
        addGroup = props.addGroup,
        addGroupInProgress = props.addGroupInProgress,
        addGroupIsSuccess = props.addGroupIsSuccess,
        addGroupAddedGroup = props.addGroupAddedGroup,
        handleOnManageStudents = props.handleOnManageStudents,
        handleOnManageStudentsBeforeDeleteGroup = props.handleOnManageStudentsBeforeDeleteGroup,
        addGroupExceedGroupError = props.addGroupExceedGroupError,
        handleOnStudentSignInCards = props.handleOnStudentSignInCards,
        handleOnCancelStudentSignInCards = props.handleOnCancelStudentSignInCards,
        showHideSignInCardModal = props.showHideSignInCardModal,
        displayNewCourses = props.displayNewCourses;

    var selectedCourseName = selectedGroup ? selectedGroup.courseTitle : '';
    var selectedUPFCourseName = selectedGroup ? selectedGroup.upfCourseTitle : '';
    var selectedNewCourseName = selectedGroup ? selectedGroup.conquestCourseTitle : '';
    var editClassWithoutScroll = showRenameGroupModal || editClassGroupIsVisible || changeCourseIsActive || addGroupIsActive;

    var addGroupProps = {
        addGroup: addGroup,
        addGroupAddedGroup: addGroupAddedGroup,
        addGroupExceedGroupError: addGroupExceedGroupError,
        addGroupInProgress: addGroupInProgress,
        addGroupIsSuccess: addGroupIsSuccess,
        classroomDetail: classroomDetail,
        closeAddGroup: closeAddGroup,
        isActive: addGroupIsActive,
        openAddGroup: openAddGroup,
        openChangeCourse: openChangeCourse,
        handleOnManageStudents: handleOnManageStudents,
        selectedProduct: selectedProduct,
        handleOnStudentSignInCards: handleOnStudentSignInCards,
        handleOnCancelStudentSignInCards: handleOnCancelStudentSignInCards,
        showHideSignInCardModal: showHideSignInCardModal,
        displayNewCourses: displayNewCourses
    };

    var changeGroupProps = {
        classroomId: changeCourseClassroomId,
        groupId: changeCourseGroupId,
        displayNewCourses: displayNewCourses
    };

    var renameGroupProps = {
        handleOnCancelRenameGroupConfirmationBeforeSubmit: handleOnCancelRenameGroupConfirmationBeforeSubmit,
        handleOnCancelRenameGroupModal: handleOnCancelRenameGroupModal,
        handleOnCloseRenameGroupConfirmation: handleOnCloseRenameGroupConfirmation,
        handleOnCloseRenameGroupModal: handleOnCloseRenameGroupModal,
        handleOnOk: handleOnOkRenameGroup,
        handleOnRenameGroup: handleOnRenameGroup,
        isRenameGroupInProgress: isRenameGroupInProgress,
        selectedGroup: selectedGroup,
        showRenameGroupConfirmationBeforeSubmit: showRenameGroupConfirmationBeforeSubmit,
        showRenameGroupConfirmationModal: showRenameGroupConfirmationModal
    };

    var deleteGroupProps = {
        classTitle: classroomDetail.name,
        courseName: selectedCourseName,
        handleOnChangeCourse: openChangeCourse,
        handleOnCloseDeleteGroupConfirmation: handleOnCloseDeleteGroupConfirmation,
        handleOnCloseDeleteGroupModal: handleOnCloseDeleteGroupModal,
        handleOnCloseModal: handleOnCloseModal,
        handleOnDeleteGroup: handleOnDeleteGroup,
        handleOnDeleteGroupRequest: handleOnDeleteGroupRequest,
        handleOnDeleteNonEmptyGroup: handleOnDeleteNonEmptyGroup,
        handleOnManageStudents: handleOnManageStudents,
        handleOnManageStudentsBeforeDeleteGroup: handleOnManageStudentsBeforeDeleteGroup,
        handleOnShowRenameGroupModal: handleOnShowRenameGroupModal,
        handleOnCancelDeleteGroupConfirmationBeforeSubmit: handleOnCancelDeleteGroupConfirmationBeforeSubmit,
        isDefaultGroup: isSelectedGroupDefault,
        isDeletingGroupInProgress: isDeletingGroupInProgress,
        selectedGroup: selectedGroup,
        showDeleteNonEmptyGroupConfirmationModal: showDeleteNonEmptyGroupConfirmationModal,
        showDeleteGroupConfirmation: showDeleteGroupConfirmation,
        showDeleteGroupConfirmationBeforeSubmit: showDeleteGroupConfirmationBeforeSubmit
    };

    var classEditGroupProps = {
        changeCourseIsActive: changeCourseIsActive,
        classTitle: classroomDetail.name,
        courseName: selectedCourseName,
        upfCourseName: selectedUPFCourseName,
        newCourseName: selectedNewCourseName,
        handleOnCancelDeleteGroupConfirmationBeforeSubmit: handleOnCancelDeleteGroupConfirmationBeforeSubmit,
        handleOnChangeCourse: openChangeCourse,
        handleOnCloseDeleteGroupConfirmation: handleOnCloseDeleteGroupConfirmation,
        handleOnCloseDeleteGroupModal: handleOnCloseDeleteGroupModal,
        handleOnCloseModal: hideEditClassGroup,
        handleOnCloseValidationModal: handleOnCloseValidationModal,
        handleOnDeleteGroup: handleOnDeleteGroup,
        handleOnDeleteGroupRequest: handleOnDeleteGroupRequest,
        handleOnDeleteNonEmptyGroup: handleOnDeleteNonEmptyGroup,
        handleOnManageStudents: handleOnManageStudents,
        handleOnManageStudentsBeforeDeleteGroup: handleOnManageStudentsBeforeDeleteGroup,
        handleOnOkRenameGroup: handleOnOkRenameGroup,
        handleOnShowRenameGroupModal: handleOnShowRenameGroupModal,
        isDefaultGroup: isSelectedGroupDefault,
        isDeletingGroupInProgress: isDeletingGroupInProgress,
        selectedGroup: selectedGroup,
        selectedProduct: selectedProduct,
        showDeleteGroupConfirmation: showDeleteGroupConfirmation,
        showDeleteGroupConfirmationBeforeSubmit: showDeleteGroupConfirmationBeforeSubmit,
        showDeleteNonEmptyGroupConfirmationModal: showDeleteNonEmptyGroupConfirmationModal
    };

    var isDeleteGroupActive = showDeleteNonEmptyGroupConfirmationModal || showDeleteGroupConfirmationBeforeSubmit || showDeleteGroupConfirmation;

    var editClassView = isLoadingEditClassDetail === false ? _react2.default.createElement(
        'div',
        { className: editClassWithoutScroll ? _index4.default.editClassWithoutScroll : _index4.default.editClass },
        _react2.default.createElement(
            'div',
            { className: _index4.default.className },
            className
        ),
        _react2.default.createElement(
            'div',
            { className: _index4.default.classDetails },
            _react2.default.createElement(_index6.default, _extends({
                className: className,
                classroomDetail: classroomDetail,
                downloadStudentSignInCards: downloadStudentSignInCards,
                handleOnClassNameChange: handleOnClassNameChange,
                handleOnEditGroup: showEditClassGroup,
                handleOnSaveClass: handleOnSaveClass,
                handleOnYearGroupChange: handleOnYearGroupChange,
                isDownloadingSignInCards: isDownloadingSignInCards,
                yearGroup: yearGroup,
                yearGroups: yearGroups
            }, addGroupProps)),
            _react2.default.createElement(_index10.default, {
                downloadingTeachersIds: downloadingTeachersIds,
                handleOnAssignTeacher: handleOnAssignTeacher,
                handleOnCloseModal: handleOnCloseModal,
                handleOnPrintTeacherSignInCard: handleOnPrintTeacherSignInCard,
                handleOnTeacherUnassign: handleOnTeacherUnassign,
                handleOnUnassignConfirm: handleOnUnassignConfirm,
                isLoading: isLoading,
                isUserOperationModalOpen: isUserOperationModalOpen,
                showModal: showModal,
                teachers: classroomDetail.teachers,
                teachersOperationSuccessConfirmation: teachersOperationSuccessConfirmation }),
            _react2.default.createElement(
                'div',
                { className: _index4.default.classFooter },
                _react2.default.createElement(
                    'div',
                    { className: _index4.default.buttonContainer },
                    _react2.default.createElement(_index2.default, {
                        containerClassName: _index4.default.cancelButton,
                        disabled: isSavingClass,
                        handleOnClick: handleOnCloseEditClass,
                        label: intl.formatMessage(_messages2.default.cancel),
                        variant: _variants.DARK }),
                    _react2.default.createElement(_index2.default, {
                        containerClassName: _index4.default.saveButton,
                        disabled: !canSubmit || isSavingClass,
                        handleOnClick: handleOnSaveClass,
                        label: intl.formatMessage(_messages2.default.save),
                        variant: _variants.DARK })
                )
            )
        ),
        _react2.default.createElement(_index8.default, _extends({ isActive: editClassGroupIsVisible && !isDeleteGroupActive }, classEditGroupProps)),
        _react2.default.createElement(_index12.default, addGroupProps),
        _react2.default.createElement(_index14.default, changeGroupProps),
        _react2.default.createElement(_index16.default, _extends({ isActive: showRenameGroupModal }, renameGroupProps)),
        _react2.default.createElement(_deleteGroup2.default, _extends({ isActive: isDeleteGroupActive }, deleteGroupProps))
    ) : _react2.default.createElement(
        'div',
        { className: _index4.default.loader },
        _react2.default.createElement(_spinner2.default, { color: 'grey', size: '15px' })
    );

    return editClassView;
};

EditClassForm.propTypes = {
    intl: _reactIntl.intlShape.isRequired,
    handleOnCloseEditClass: _propTypes2.default.func,
    isLoadingEditClassDetail: _propTypes2.default.bool,
    classroomDetail: _propTypes2.default.object,
    yearGroups: _propTypes2.default.arrayOf(_propTypes2.default.object),
    downloadStudentSignInCards: _propTypes2.default.func,
    isDownloadingSignInCards: _propTypes2.default.bool,
    handleOnClassNameChange: _propTypes2.default.func,
    canSubmit: _propTypes2.default.bool,
    className: _propTypes2.default.string,
    editClassGroupIsVisible: _propTypes2.default.bool,
    selectedGroup: _propTypes2.default.object,
    selectedProduct: _propTypes2.default.object,
    isSelectedGroupDefault: _propTypes2.default.bool,
    showEditClassGroup: _propTypes2.default.func,
    hideEditClassGroup: _propTypes2.default.func,
    handleOnRenameGroup: _propTypes2.default.func,
    showRenameGroupConfirmationModal: _propTypes2.default.bool,
    handleOnCloseDeleteGroupModal: _propTypes2.default.func,
    handleOnCloseRenameGroupModal: _propTypes2.default.func,
    handleOnCancelRenameGroupModal: _propTypes2.default.func,
    isRenameGroupInProgress: _propTypes2.default.bool,
    handleOnShowRenameGroupModal: _propTypes2.default.func,
    showRenameGroupModal: _propTypes2.default.bool,
    handleOnCloseValidationModal: _propTypes2.default.func,
    handleOnOkRenameGroup: _propTypes2.default.func,
    handleOnCancelRenameGroupConfirmationBeforeSubmit: _propTypes2.default.func,
    showDeleteGroupConfirmation: _propTypes2.default.bool,
    showRenameGroupConfirmationBeforeSubmit: _propTypes2.default.bool,
    handleOnYearGroupChange: _propTypes2.default.func,
    yearGroup: _propTypes2.default.string,
    handleOnCloseRenameGroupConfirmation: _propTypes2.default.func,
    handleOnSaveClass: _propTypes2.default.func,
    handleOnTeacherUnassign: _propTypes2.default.func,
    showModal: _propTypes2.default.bool,
    handleOnUnassignConfirm: _propTypes2.default.func,
    isUserOperationModalOpen: _propTypes2.default.bool,
    handleOnCloseModal: _propTypes2.default.func,
    isLoading: _propTypes2.default.bool,
    teachersOperationSuccessConfirmation: _propTypes2.default.func,
    isSavingClass: _propTypes2.default.bool,
    openChangeCourse: _propTypes2.default.func,
    changeCourseIsActive: _propTypes2.default.bool,
    changeCourseClassroomId: _propTypes2.default.number,
    changeCourseGroupId: _propTypes2.default.number,
    handleOnPrintTeacherSignInCard: _propTypes2.default.func,
    downloadingTeachersIds: _propTypes2.default.object,
    handleOnAssignTeacher: _propTypes2.default.func,
    handleOnCancelDeleteGroupConfirmationBeforeSubmit: _propTypes2.default.func,
    handleOnDeleteGroup: _propTypes2.default.func,
    showDeleteNonEmptyGroupConfirmationModal: _propTypes2.default.bool,
    showDeleteGroupConfirmationBeforeSubmit: _propTypes2.default.bool,
    handleOnCloseDeleteGroupConfirmation: _propTypes2.default.func,
    handleOnDeleteNonEmptyGroup: _propTypes2.default.func,
    handleOnDeleteGroupRequest: _propTypes2.default.func,
    openAddGroup: _propTypes2.default.func,
    addGroupIsActive: _propTypes2.default.bool,
    addGroupInProgress: _propTypes2.default.bool,
    addGroupIsSuccess: _propTypes2.default.bool,
    addGroupAddedGroup: _propTypes2.default.object,
    handleOnManageStudents: _propTypes2.default.func,
    handleOnManageStudentsBeforeDeleteGroup: _propTypes2.default.func,
    handleOnStudentSignInCards: _propTypes2.default.func,
    handleOnCancelStudentSignInCards: _propTypes2.default.func,
    showHideSignInCardModal: _propTypes2.default.bool,
    displayNewCourses: _propTypes2.default.bool
};

exports.default = (0, _reactIntl.injectIntl)((0, _reactStyleable2.default)(_index4.default)(EditClassForm));

/***/ }),
/* 699 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _reactIntl = __webpack_require__(2);

exports.default = (0, _reactIntl.defineMessages)({
    save: {
        id: 'app.components.EditClassForm.save',
        defaultMessage: 'Save'
    },
    cancel: {
        id: 'app.components.EditClassForm.cancel',
        defaultMessage: 'Cancel'
    }
});

/***/ }),
/* 700 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactIntl = __webpack_require__(2);

var _iconDictionary = __webpack_require__(8);

var _index = __webpack_require__(1702);

var _index2 = _interopRequireDefault(_index);

var _svgIcon = __webpack_require__(21);

var _svgIcon2 = _interopRequireDefault(_svgIcon);

var _index3 = __webpack_require__(7);

var _index4 = _interopRequireDefault(_index3);

var _messages = __webpack_require__(701);

var _messages2 = _interopRequireDefault(_messages);

var _withModal = __webpack_require__(49);

var _withModal2 = _interopRequireDefault(_withModal);

var _productEnum = __webpack_require__(77);

var _productEnum2 = _interopRequireDefault(_productEnum);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ClassEditGroup = function ClassEditGroup(props) {
    var icon = props.icon,
        handleOnCloseModal = props.handleOnCloseModal,
        handleOnManageStudents = props.handleOnManageStudents,
        handleOnChangeCourse = props.handleOnChangeCourse,
        intl = props.intl,
        isDefaultGroup = props.isDefaultGroup,
        classTitle = props.classTitle,
        selectedGroup = props.selectedGroup,
        courseName = props.courseName,
        handleOnShowRenameGroupModal = props.handleOnShowRenameGroupModal,
        isDeletingGroupInProgress = props.isDeletingGroupInProgress,
        handleOnDeleteGroupRequest = props.handleOnDeleteGroupRequest,
        selectedProduct = props.selectedProduct,
        upfCourseName = props.upfCourseName,
        newCourseName = props.newCourseName;
    var selectedClassroomId = selectedGroup.classroomId,
        selectedGroupId = selectedGroup.id;

    var isMatletica = _productEnum2.default.MATLETICA.id === selectedProduct.id;
    var isMathletics = _productEnum2.default.MATHLETICS.id === selectedProduct.id;

    var buttonSet = isDefaultGroup ? _react2.default.createElement(
        'div',
        { className: _index2.default.buttonGroup },
        _react2.default.createElement(_index4.default, {
            buttonContainer: _index2.default.buttonContainer,
            containerClassName: 'renameGroupBtn ' + _index2.default.buttonWrapper,
            handleOnClick: handleOnShowRenameGroupModal,
            icon: _iconDictionary.Edit,
            iconClassName: _index2.default.buttonIcon,
            label: intl.formatMessage(_messages2.default.renameGroup) }),
        _react2.default.createElement(_index4.default, {
            buttonContainer: _index2.default.buttonContainer,
            containerClassName: 'manageStudentBtn ' + _index2.default.buttonWrapper,
            handleOnClick: function handleOnClick() {
                return handleOnManageStudents(selectedGroup.classroomId, classTitle, selectedGroupId);
            },
            icon: _iconDictionary.Edit,
            iconClassName: _index2.default.buttonIcon,
            label: intl.formatMessage(_messages2.default.manageStudents) }),
        _react2.default.createElement(_index4.default, {
            buttonContainer: _index2.default.buttonContainer,
            containerClassName: 'changeCourseBtn ' + _index2.default.buttonWrapper,
            handleOnClick: function handleOnClick() {
                handleOnChangeCourse(selectedClassroomId, selectedGroupId);
            },
            hidden: isMatletica,
            icon: _iconDictionary.Edit,
            iconClassName: _index2.default.buttonIcon,
            label: intl.formatMessage(_messages2.default.changeCourse) })
    ) : _react2.default.createElement(
        'div',
        { className: _index2.default.buttonGroup },
        _react2.default.createElement(_index4.default, {
            buttonContainer: _index2.default.buttonContainer,
            containerClassName: 'renameGroupBtn ' + _index2.default.buttonWrapper,
            handleOnClick: handleOnShowRenameGroupModal,
            icon: _iconDictionary.Edit,
            iconClassName: _index2.default.buttonIcon,
            label: intl.formatMessage(_messages2.default.renameGroup) }),
        _react2.default.createElement(_index4.default, {
            buttonContainer: _index2.default.buttonContainer,
            containerClassName: 'manageStudentBtn ' + _index2.default.buttonWrapper,
            handleOnClick: function handleOnClick() {
                return handleOnManageStudents(selectedGroup.classroomId, classTitle, selectedGroupId);
            },
            icon: _iconDictionary.Edit,
            iconClassName: _index2.default.buttonIcon,
            label: intl.formatMessage(_messages2.default.manageStudents) }),
        _react2.default.createElement(_index4.default, {
            buttonContainer: _index2.default.buttonContainer,
            containerClassName: 'changeCourseBtn ' + _index2.default.buttonWrapper,
            handleOnClick: function handleOnClick() {
                handleOnChangeCourse(selectedClassroomId, selectedGroupId);
            },
            hidden: isMatletica,
            icon: _iconDictionary.Edit,
            iconClassName: _index2.default.buttonIcon,
            label: intl.formatMessage(_messages2.default.changeCourse) }),
        _react2.default.createElement(_index4.default, {
            buttonContainer: _index2.default.buttonContainer,
            buttonContainerDisabled: _index2.default.buttonContainerDisabled,
            containerClassName: _index2.default.buttonWrapper + ' ' + _index2.default.buttonDelete + ' deleteGroupBtn',
            disabled: isDeletingGroupInProgress,
            handleOnClick: handleOnDeleteGroupRequest,
            icon: _iconDictionary.Cross,
            iconClassName: _index2.default.buttonIcon,
            label: intl.formatMessage(_messages2.default.delete),
            loadingLabel: intl.formatMessage(_messages2.default.deleting) })
    );
    return _react2.default.createElement(
        'div',
        { className: _index2.default.classConfirmationContainer },
        _react2.default.createElement(
            'div',
            { className: _index2.default.icon },
            _react2.default.createElement(_svgIcon2.default, { icon: icon })
        ),
        _react2.default.createElement(
            'div',
            { className: _index2.default.title },
            classTitle,
            ' | ',
            _react2.default.createElement(
                'span',
                { className: _index2.default.selectedGroup },
                selectedGroup.name
            ),
            _react2.default.createElement(
                'div',
                null,
                _react2.default.createElement(
                    'span',
                    { className: _index2.default.titleSub },
                    isMatletica ? '' : courseName
                ),
                isMathletics && upfCourseName && _react2.default.createElement(
                    'span',
                    { className: _index2.default.titleSub },
                    ', ',
                    newCourseName
                ),
                isMathletics && upfCourseName && _react2.default.createElement(
                    'div',
                    { className: _index2.default.titleSub },
                    ' & ',
                    upfCourseName
                )
            )
        ),
        buttonSet,
        _react2.default.createElement(_index4.default, {
            buttonContainer: _index2.default.buttonContainer,
            containerClassName: _index2.default.buttonClose,
            handleOnClick: handleOnCloseModal,
            icon: _iconDictionary.Cross,
            iconClassName: _index2.default.buttonIcon })
    );
};

ClassEditGroup.propTypes = {
    classTitle: _propTypes2.default.string,
    courseName: _propTypes2.default.string,
    handleOnChangeCourse: _propTypes2.default.func,
    handleOnCloseModal: _propTypes2.default.func,
    handleOnDeleteGroupRequest: _propTypes2.default.func,
    handleOnManageStudents: _propTypes2.default.func,
    handleOnShowRenameGroupModal: _propTypes2.default.func,
    icon: _propTypes2.default.string,
    intl: _reactIntl.intlShape.isRequired,
    isDefaultGroup: _propTypes2.default.bool,
    isDeletingGroupInProgress: _propTypes2.default.bool,
    selectedGroup: _propTypes2.default.object,
    selectedProduct: _propTypes2.default.object,
    upfCourseName: _propTypes2.default.string,
    newCourseName: _propTypes2.default.string
};

var IntlClassEditGroup = (0, _reactIntl.injectIntl)(ClassEditGroup);
exports.default = (0, _withModal2.default)('isActive')(IntlClassEditGroup);

/***/ }),
/* 701 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _reactIntl = __webpack_require__(2);

exports.default = (0, _reactIntl.defineMessages)({
    manageStudents: {
        id: 'app.components.EditClassGroup.manageStudents',
        defaultMessage: 'Manage students'
    },
    changeCourse: {
        id: 'app.components.EditClassGroup.changeCourse',
        defaultMessage: 'Change course'
    },
    renameGroup: {
        id: 'app.components.EditClassGroup.renameGroup',
        defaultMessage: 'Rename group'
    },
    delete: {
        id: 'app.components.EditClassGroup.delete',
        defaultMessage: 'Delete group'
    },
    close: {
        id: 'app.components.EditClassGroup.close',
        defaultMessage: 'Close'
    },
    deleting: {
        id: 'app.components.EditClassGroup.deleting',
        defaultMessage: 'Deleting'
    },
    deleteNonEmptyGroupConfirmation: {
        id: 'app.components.EditClassGroup.deleteNonEmptyGroupConfirmation',
        defaultMessage: 'must be empty before it can be deleted.'
    },
    pleaseGoTo: {
        id: 'app.components.EditClassGroup.pleaseGoTo',
        defaultMessage: 'Please go to'
    },
    toMoveYourStudents: {
        id: 'app.components.EditClassGroup.toMoveYourStudents',
        defaultMessage: 'to move your students.'
    },
    AreYouSureYouWantToDelete: {
        id: 'app.components.EditClassGroup.AreYouSureYouWantToDelete',
        defaultMessage: 'Are you sure you want to delete '
    },
    doYouWishTo: {
        id: 'app.components.EditClassGroup.doYouWishTo',
        defaultMessage: 'Do you wish to rename the group'
    },
    to: {
        id: 'app.components.EditClassGroup.to',
        defaultMessage: 'to'
    },
    questionMark: {
        id: 'app.components.EditClassGroup.questionMark',
        defaultMessage: '?'
    },
    yourGroup: {
        id: 'app.components.EditClassGroup.yourGroup',
        defaultMessage: 'Your group, '
    },
    hasBeenDeleted: {
        id: 'app.components.EditClassGroup.hasBeenDeleted',
        defaultMessage: ', has been deleted.'
    }
});

/***/ }),
/* 702 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactStyleable = __webpack_require__(6);

var _reactStyleable2 = _interopRequireDefault(_reactStyleable);

var _cloneDeep = __webpack_require__(54);

var _cloneDeep2 = _interopRequireDefault(_cloneDeep);

var _reactIntl = __webpack_require__(2);

var _spinner = __webpack_require__(94);

var _spinner2 = _interopRequireDefault(_spinner);

var _index = __webpack_require__(1703);

var _index2 = _interopRequireDefault(_index);

var _index3 = __webpack_require__(766);

var _index4 = _interopRequireDefault(_index3);

var _index5 = __webpack_require__(760);

var _index6 = _interopRequireDefault(_index5);

var _index7 = __webpack_require__(7);

var _index8 = _interopRequireDefault(_index7);

var _messages = __webpack_require__(703);

var _messages2 = _interopRequireDefault(_messages);

var _utils = __webpack_require__(13);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var EditStudent = function (_Component) {
    _inherits(EditStudent, _Component);

    function EditStudent(props) {
        _classCallCheck(this, EditStudent);

        var _this = _possibleConstructorReturn(this, (EditStudent.__proto__ || Object.getPrototypeOf(EditStudent)).call(this, props));

        _this.validateStudentModel = function () {
            if (_this.props.student.firstName.trim() !== '' && _this.props.student.lastName.trim() !== '' && _this.props.student.yearGroupEnum !== '-1' && _this.props.student.password.trim() !== '') {
                _this.setState({ canSubmit: true });
            } else {
                _this.setState({ canSubmit: false });
            }
        };

        _this.handleTextInputOnChange = function (event) {
            var regex = new RegExp((0, _utils.invalidCharaters)());
            var value = event.target.value;
            var field = event.target.name;
            if (value !== '' && !regex.test(value)) {
                event.preventDefault();
                return false;
            }

            _this.props.student[field] = value;
            _this.validateStudentModel(_this.props.student);
            return true;
        };

        _this.handleListOnChange = function (field, value) {
            _this.props.student[field] = value;
            _this.validateStudentModel(_this.props.student);
        };

        _this.handleOnSubmit = function () {
            _this.setState({ canSubmit: false });
            _this.props.handleOnEditStudentSubmit();
        };

        _this.handleOnCloseValidationModal = function () {
            _this.setState({ canSubmit: true });
            _this.props.closeEditStudentValidationModal();
        };

        _this.state = { canSubmit: false };
        _this.handleTextInputOnChange = _this.handleTextInputOnChange.bind(_this);
        return _this;
    }

    _createClass(EditStudent, [{
        key: 'render',
        value: function render() {
            var clonedYearGroup = [];
            if (this.props.dataFilterOptions) {
                clonedYearGroup = (0, _cloneDeep2.default)(this.props.dataFilterOptions.yearGroups);
                clonedYearGroup[0].value = this.props.intl.formatMessage(_messages2.default.yearGroupList);
            }

            var editStudentView = this.props.isLoadingEditStudentDetail === false ? _react2.default.createElement(
                'div',
                { className: this.props.css.editStudent },
                _react2.default.createElement(
                    'div',
                    { className: this.props.css.studentName },
                    this.props.student.firstName,
                    '  ',
                    this.props.student.lastName
                ),
                _react2.default.createElement(
                    'div',
                    { className: this.props.css.studentDetails },
                    _react2.default.createElement(_index4.default, {
                        downloadStudentsSignInCards: this.props.downloadStudentsSignInCards,
                        editStudentValidationMessage: this.props.editStudentValidationMessage,
                        handleOnCloseModal: this.props.handleOnCloseModal,
                        handleOnCloseValidationModal: this.handleOnCloseValidationModal,
                        handleOnListChange: this.handleListOnChange,
                        handleOnPrintSignInCard: this.props.handleOnPrintSignInCard,
                        handleOnTextInputChange: this.handleTextInputOnChange,
                        isSignInCardDownloaded: this.props.isSignInCardDownloaded,
                        showEditStudentValidationModal: this.props.showEditStudentValidationModal,
                        showModal: this.props.showModal,
                        student: this.props.student,
                        yearGroups: clonedYearGroup
                    })
                ),
                _react2.default.createElement(
                    'div',
                    { className: this.props.css.classDetails },
                    _react2.default.createElement(_index6.default, {
                        editStudentDetail: this.props.editStudentDetail,
                        handleOnAssignClass: this.props.handleOnAssignClass,
                        handleOnCloseModal: this.props.handleOnCloseModal,
                        handleOnUnassignConfirm: this.props.handleOnUnassignConfirm,
                        handleOnUnassignStudent: this.props.handleOnUnassignStudent,
                        isLoading: this.props.isLoading,
                        isUnassignedModalOpen: this.props.isUnassignedModalOpen,
                        productName: this.props.productName,
                        showUnassignStudentModal: this.props.showUnassignStudentModal,
                        unassignStudentsSuccessConfirmation: this.props.unassignStudentsSuccessConfirmation })
                ),
                _react2.default.createElement(
                    'div',
                    { className: this.props.css.studentFooter },
                    _react2.default.createElement(
                        'div',
                        { className: this.props.css.buttonContainer },
                        _react2.default.createElement(_index8.default, {
                            containerClassName: this.props.css.cancelButton,
                            disabled: this.props.updatingStudent,
                            handleOnClick: this.props.closeEditStudent,
                            label: this.props.intl.formatMessage(_messages2.default.cancel) }),
                        _react2.default.createElement(_index8.default, {
                            containerClassName: this.props.css.saveButton,
                            disabled: !this.state.canSubmit,
                            handleOnClick: this.handleOnSubmit,
                            label: this.props.intl.formatMessage(_messages2.default.save) })
                    )
                )
            ) : _react2.default.createElement(
                'div',
                { className: this.props.css.loader },
                _react2.default.createElement(_spinner2.default, { color: 'grey', size: '15px' })
            );

            return editStudentView;
        }
    }]);

    return EditStudent;
}(_react.Component);

EditStudent.propTypes = {
    studentName: _propTypes2.default.string,
    updatingStudent: _propTypes2.default.bool,
    css: _propTypes2.default.object,
    student: _propTypes2.default.object,
    dataFilterOptions: _propTypes2.default.object,
    handleOnEditStudentSubmit: _propTypes2.default.func,
    showEditStudentValidationModal: _propTypes2.default.bool,
    editStudentValidationMessage: _propTypes2.default.string,
    closeEditStudentValidationModal: _propTypes2.default.func,
    closeEditStudent: _propTypes2.default.func,
    handleOnPrintSignInCard: _propTypes2.default.func,
    isSignInCardDownloaded: _propTypes2.default.bool,
    productName: _propTypes2.default.string,
    editStudentDetail: _propTypes2.default.object,
    handleOnUnassignStudent: _propTypes2.default.func,
    handleOnCloseModal: _propTypes2.default.func,
    handleOnUnassignConfirm: _propTypes2.default.func,
    unassignStudentsSuccessConfirmation: _propTypes2.default.func,
    isUnassignedModalOpen: _propTypes2.default.bool,
    showUnassignStudentModal: _propTypes2.default.bool,
    isLoading: _propTypes2.default.bool,
    isLoadingEditStudentDetail: _propTypes2.default.bool,
    intl: _reactIntl.intlShape.isRequired,
    handleOnAssignClass: _propTypes2.default.func,
    showModal: _propTypes2.default.bool,
    downloadStudentsSignInCards: _propTypes2.default.func
};

exports.default = (0, _reactIntl.injectIntl)((0, _reactStyleable2.default)(_index2.default)(EditStudent));

/***/ }),
/* 703 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _reactIntl = __webpack_require__(2);

exports.default = (0, _reactIntl.defineMessages)({
    save: {
        id: 'app.components.EditStudent.save',
        defaultMessage: 'Save'
    },
    cancel: {
        id: 'app.components.EditStudent.cancel',
        defaultMessage: 'Cancel'
    },
    yearGroupList: {
        id: 'app.components.EditStudent.yearGroupList',
        defaultMessage: 'Year'
    }
}); /*
     * EditStudent Messages
     *
     * This contains all the text for the EditStudent component.
     */

/***/ }),
/* 704 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactStyleable = __webpack_require__(6);

var _reactStyleable2 = _interopRequireDefault(_reactStyleable);

var _reactIntl = __webpack_require__(2);

var _spinner = __webpack_require__(94);

var _spinner2 = _interopRequireDefault(_spinner);

var _index = __webpack_require__(1704);

var _index2 = _interopRequireDefault(_index);

var _index3 = __webpack_require__(784);

var _index4 = _interopRequireDefault(_index3);

var _index5 = __webpack_require__(778);

var _index6 = _interopRequireDefault(_index5);

var _index7 = __webpack_require__(7);

var _index8 = _interopRequireDefault(_index7);

var _variants = __webpack_require__(9);

var _messages = __webpack_require__(705);

var _messages2 = _interopRequireDefault(_messages);

var _utils = __webpack_require__(13);

var _modal = __webpack_require__(24);

var _modal2 = _interopRequireDefault(_modal);

var _authentication = __webpack_require__(656);

var _authentication2 = _interopRequireDefault(_authentication);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var EditTeacherForm = function (_Component) {
    _inherits(EditTeacherForm, _Component);

    function EditTeacherForm(props) {
        _classCallCheck(this, EditTeacherForm);

        var _this = _possibleConstructorReturn(this, (EditTeacherForm.__proto__ || Object.getPrototypeOf(EditTeacherForm)).call(this, props));

        _this.validateTeacherModel = function (isDirty) {
            var canSubmit = false;
            if (_this.props.teacher.firstName.trim() !== '' && _this.props.teacher.lastName.trim() !== '') {
                canSubmit = true;
            }

            _this.setState({ canSubmit: canSubmit, isDirty: isDirty });
        };

        _this.handleTextInputOnChange = function (event) {
            var regex = new RegExp((0, _utils.invalidCharaters)());
            var value = event.target.value;
            var field = event.target.name;
            if (value !== '' && !regex.test(value)) {
                event.preventDefault();
                return false;
            }

            _this.props.teacher[field] = value;
            _this.validateTeacherModel(true);
            return true;
        };

        _this.handleEmailInputOnChange = function (event) {
            var regex = new RegExp((0, _utils.invalidEmailCharaters)());
            var value = event.target.value;
            var field = event.target.name;
            if (value !== '' && !regex.test(value)) {
                event.preventDefault();
                return false;
            }

            _this.props.teacher[field] = value;
            _this.validateTeacherModel(true);
            return true;
        };

        _this.handleListOnChange = function (field, value) {
            _this.props.teacher[field] = value;
            _this.validateTeacherModel(true);
        };

        _this.handleOnPasswordInputChange = function (event) {
            var teacher = _this.props.teacher;

            var value = event.target.value;
            var field = event.target.name;
            teacher[field] = value;
            _this.setState({ canSubmit: true });
        };

        _this.handleOnSubmit = function () {
            var teacher = _this.props.teacher;

            var regex = new RegExp((0, _utils.validatePassword)());
            var isValid = true;
            var MAX_PASSWORD_LENGTH = 8;

            if (teacher.emailAddress !== '' && (0, _utils.isValidEmail)(teacher.emailAddress)) {
                if (teacher.isResetTeacherpassword) {
                    if (!teacher.newPassword || !teacher.confirmationPassword) {
                        _this.props.showToast(_this.props.intl.formatMessage(_messages2.default.passwordValidationMessage4), 'error');
                        isValid = false;
                    } else if (teacher.newPassword !== '' && teacher.confirmationPassword !== '') {
                        if (teacher.newPassword !== teacher.confirmationPassword) {
                            _this.props.showToast(_this.props.intl.formatMessage(_messages2.default.passwordValidationMessage2), 'error');
                            isValid = false;
                        } else {
                            [teacher.newPassword, teacher.confirmationPassword].forEach(function (password) {
                                if (!regex.test(password) || password.length < MAX_PASSWORD_LENGTH) {
                                    _this.props.showToast(_this.props.intl.formatMessage(_messages2.default.passwordValidationMessage1), 'error');
                                    isValid = false;
                                }
                            });
                        }
                    }
                }
            } else {
                _this.props.showToast(_this.props.intl.formatMessage(_messages2.default.emailRequiredMessage), 'error');
                isValid = false;
            }

            if (isValid) {
                // Temporarily commenting below line to disable reauthentication (Req : COY-4285)
                // this.setState({ showAuthenticationModal: true });
                _this.saveChanges();
            } else {
                _this.setState({ canSubmit: true });
            }
        };

        _this.saveChanges = function () {
            _this.setState({ canSubmit: false });
            _this.props.handleOnEditTeacherSubmit();
        };

        _this.handleOnCloseValidationModal = function () {
            _this.setState({ canSubmit: true });
            _this.props.closeEditTeacherValidationModal();
        };

        _this.resetPassword = function (status) {
            var teacher = _this.props.teacher;

            teacher.isResetTeacherpassword = status;
            teacher.confirmationPassword = '';
            teacher.newPassword = '';
            teacher.adminPassword = '';
            if (_this.state.isDirty && !status) {
                _this.setState({ canSubmit: true });
            } else if (!_this.state.isDirty && !status) {
                _this.setState({ canSubmit: false });
            }
        };

        _this.updateAdminPassword = function (event) {
            var teacher = _this.props.teacher;

            teacher.adminPassword = event.target.value.trim();
            _this.setState({ adminPassword: event.target.value.trim() });
        };

        _this.callActionBasedonType = function (type) {
            switch (type) {
                case 'passwordReset':
                    _this.props.handleOnSendTeacherPassword();
                    break;
                case 'verifyEmail':
                    _this.props.handleOnSendEmailVerificationLink();
                    break;
                default:
                    _this.saveChanges();
                    _this.setState({ showAuthenticationModal: false });
                    break;
            }
        };

        _this.closeAuthentionModal = function () {
            _this.setState({ showAuthenticationModal: false });
        };

        _this.authentication = function () {
            _this.callActionBasedonType('save');
        };

        _this.enableSave = function () {
            if (_this.state.canSubmit || _this.props.enableSave) {
                return true;
            }

            return false;
        };

        _this.state = { canSubmit: false, isDirty: false, showAuthenticationModal: false, adminPassword: '' };
        _this.handleTextInputOnChange = _this.handleTextInputOnChange.bind(_this);
        _this.handleEmailInputOnChange = _this.handleEmailInputOnChange.bind(_this);
        _this.props.teacherTitles[0].value = _this.props.intl.formatMessage(_messages2.default.teacherTitleNone);
        _this.props.teacherTitles[0].key = _this.props.intl.formatMessage(_messages2.default.teacherTitleNone_key);
        return _this;
    }

    _createClass(EditTeacherForm, [{
        key: 'render',
        value: function render() {
            var sortedTitles = this.props.teacherTitles.slice(1).sort(function (a, b) {
                return a.value.localeCompare(b.value);
            });
            sortedTitles.unshift(this.props.teacherTitles[0]);
            var editTeacherView = this.props.isLoadingEditTeacherDetail === false ? _react2.default.createElement(
                'div',
                { className: this.props.css.editTeacher },
                _react2.default.createElement(
                    'div',
                    {
                        className: this.props.css.teacherName },
                    this.props.teacher.title,
                    ' ',
                    this.props.teacher.firstName,
                    ' ',
                    this.props.teacher.lastName
                ),
                _react2.default.createElement(
                    'div',
                    { className: this.props.css.teacherDetails },
                    _react2.default.createElement(_index4.default, {
                        editTeacherValidationMessage: this.props.editTeacherValidationMessage,
                        handleEmailInputOnChange: this.handleEmailInputOnChange,
                        handleOnCloseValidationModal: this.handleOnCloseValidationModal,
                        handleOnListChange: this.handleListOnChange,
                        handleOnPasswordInputChange: this.handleOnPasswordInputChange,
                        handleOnSendTeacherPassword: this.callActionBasedonType,
                        handleOnTextInputChange: this.handleTextInputOnChange,
                        resetPassword: this.resetPassword,
                        teacher: this.props.teacher,
                        teacherTitles: sortedTitles
                    })
                ),
                _react2.default.createElement(
                    'div',
                    { className: this.props.css.classDetails },
                    _react2.default.createElement(_index6.default, {
                        downloadingClassroomIds: this.props.downloadingClassroomIds,
                        editTeacherDetail: this.props.editTeacherDetail,
                        handleOnAssignClass: this.props.handleOnAssignClass,
                        handleOnCancelStudentSignInCards: this.props.handleOnCancelStudentSignInCards,
                        handleOnCloseModal: this.props.handleOnCloseModal,
                        handleOnUnassignConfirm: this.props.handleOnUnassignConfirm,
                        handleOnUnassignTeacher: this.props.handleOnUnassignTeacher,
                        isLoading: this.props.isLoading,
                        isUnassignedModalOpen: this.props.isUnassignedModalOpen,
                        productName: this.props.productName,
                        showHideSignInCardModal: this.props.showHideSignInCardModal,
                        showUnassignTeacherModal: this.props.showUnassignTeacherModal,
                        unassignTeachersSuccessConfirmation: this.props.unassignTeachersSuccessConfirmation
                    })
                ),
                _react2.default.createElement(
                    'div',
                    { className: this.props.css.teacherFooter },
                    _react2.default.createElement(
                        'div',
                        { className: this.props.css.buttonContainer },
                        _react2.default.createElement(_index8.default, {
                            containerClassName: this.props.css.cancelButton,
                            disabled: this.props.updatingTeacher,
                            handleOnClick: this.props.closeEditTeacher,
                            label: this.props.intl.formatMessage(_messages2.default.cancel),
                            variant: _variants.DARK }),
                        _react2.default.createElement(_index8.default, {
                            containerClassName: this.props.css.saveButton,
                            disabled: !this.enableSave(),
                            handleOnClick: this.handleOnSubmit,
                            label: this.props.intl.formatMessage(_messages2.default.save),
                            variant: _variants.DARK })
                    )
                ),
                _react2.default.createElement(
                    _modal2.default,
                    { show: this.state.showAuthenticationModal },
                    _react2.default.createElement(_authentication2.default, {
                        handleOnCancel: this.closeAuthentionModal,
                        handleOnContinue: this.authentication,
                        handleOnPasswordChange: this.updateAdminPassword
                    })
                )
            ) : _react2.default.createElement(
                'div',
                { className: this.props.css.loader },
                _react2.default.createElement(_spinner2.default, { color: 'grey', size: '15px' })
            );

            return editTeacherView;
        }
    }]);

    return EditTeacherForm;
}(_react.Component);

EditTeacherForm.propTypes = {
    teacherName: _propTypes2.default.string,
    updatingTeacher: _propTypes2.default.bool,
    css: _propTypes2.default.object,
    teacher: _propTypes2.default.object,
    teacherTitles: _propTypes2.default.arrayOf(_propTypes2.default.object),
    handleOnEditTeacherSubmit: _propTypes2.default.func,
    editTeacherValidationMessage: _propTypes2.default.string,
    closeEditTeacherValidationModal: _propTypes2.default.func,
    closeEditTeacher: _propTypes2.default.func,
    productName: _propTypes2.default.string,
    editTeacherDetail: _propTypes2.default.object,
    handleOnUnassignTeacher: _propTypes2.default.func,
    handleOnCloseModal: _propTypes2.default.func,
    handleOnUnassignConfirm: _propTypes2.default.func,
    unassignTeachersSuccessConfirmation: _propTypes2.default.func,
    isUnassignedModalOpen: _propTypes2.default.bool,
    showUnassignTeacherModal: _propTypes2.default.bool,
    isLoading: _propTypes2.default.bool,
    isLoadingEditTeacherDetail: _propTypes2.default.bool,
    downloadingClassroomIds: _propTypes2.default.object,
    intl: _reactIntl.intlShape.isRequired,
    handleOnAssignClass: _propTypes2.default.func,
    handleOnCancelStudentSignInCards: _propTypes2.default.func,
    showHideSignInCardModal: _propTypes2.default.bool,
    showToast: _propTypes2.default.func,
    handleOnSendTeacherPassword: _propTypes2.default.func,
    handleOnSendEmailVerificationLink: _propTypes2.default.func,
    enableSave: _propTypes2.default.bool
};

exports.default = (0, _reactIntl.injectIntl)((0, _reactStyleable2.default)(_index2.default)(EditTeacherForm));

/***/ }),
/* 705 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _reactIntl = __webpack_require__(2);

exports.default = (0, _reactIntl.defineMessages)({
    save: {
        id: 'app.components.EditTeacher.save',
        defaultMessage: 'Save'
    },
    cancel: {
        id: 'app.components.EditTeacher.cancel',
        defaultMessage: 'Cancel'
    },
    passwordValidationMessage1: {
        id: 'app.components.EditTeacher.passwordValidationMessage1',
        defaultMessage: 'New password does not meet stated rules'
    },
    passwordValidationMessage2: {
        id: 'app.components.EditTeacher.passwordValidationMessage2',
        defaultMessage: 'Ensure teacher passwords match'
    },
    passwordValidationMessage3: {
        id: 'app.components.EditTeacher.passwordValidationMessage3',
        defaultMessage: 'Please enter admin password'
    },
    passwordValidationMessage4: {
        id: 'app.components.EditTeacher.passwordValidationMessage4',
        defaultMessage: 'Password cannot be blank'
    },
    emailRequiredMessage: {
        id: 'app.components.EditTeacher.emailRequiredMessage',
        defaultMessage: 'Email is required'
    },
    emailValidationMessage: {
        id: 'app.components.EditTeacher.emailValidationMessage',
        defaultMessage: 'Invalid email'
    },
    teacherTitleNone: {
        id: 'app.components.EditTeacher.teachertTitle.none',
        defaultMessage: 'None'
    },
    teacherTitleNone_key: {
        id: 'app.components.EditTeacher.teachertTitle.none.key',
        defaultMessage: 'none'
    }
}); /*
     * EditTeacher Messages
     *
     * This contains all the text for the EditTeacher component.
     */

/***/ }),
/* 706 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactIntl = __webpack_require__(2);

var _svgIcon = __webpack_require__(21);

var _svgIcon2 = _interopRequireDefault(_svgIcon);

var _iconDictionary = __webpack_require__(8);

var _messages = __webpack_require__(707);

var _messages2 = _interopRequireDefault(_messages);

var _index = __webpack_require__(1705);

var _index2 = _interopRequireDefault(_index);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var EmailStatus = function EmailStatus(props) {
    var status = props.status;


    var getEmailStatusIcon = function getEmailStatusIcon() {
        switch (status.toLowerCase()) {
            case 'invalid':
                return _react2.default.createElement(_svgIcon2.default, { icon: _iconDictionary.EmailInvalid });
            case 'unverified':
                return _react2.default.createElement(_svgIcon2.default, { icon: _iconDictionary.EmailValid });
            case 'awaitingverification':
                return _react2.default.createElement(_svgIcon2.default, { icon: _iconDictionary.EmailSent });
            case 'verified':
                return _react2.default.createElement(_svgIcon2.default, { icon: _iconDictionary.EmailVerified });
            default:
                return status;
        }
    };

    var getEmailStatusTooltip = function getEmailStatusTooltip() {
        switch (status.toLowerCase()) {
            case 'invalid':
                return props.intl.formatMessage(_messages2.default.invalidTooltip);
            case 'unverified':
                return props.intl.formatMessage(_messages2.default.unverifiedTooltip);
            case 'awaitingverification':
                return props.intl.formatMessage(_messages2.default.awaitingVerificationTooltip);
            case 'verified':
                return props.intl.formatMessage(_messages2.default.verifiedTooltip);
            default:
                return status;
        }
    };

    return _react2.default.createElement(
        'div',
        { className: _index2.default.container },
        _react2.default.createElement(
            'div',
            { className: _index2.default.icon, key: Math.random() * 100, title: getEmailStatusTooltip() },
            getEmailStatusIcon()
        )
    );
};

EmailStatus.propTypes = {
    status: _propTypes2.default.string,
    intl: _reactIntl.intlShape.isRequired
};

exports.default = (0, _reactIntl.injectIntl)(EmailStatus);

/***/ }),
/* 707 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _reactIntl = __webpack_require__(2);

exports.default = (0, _reactIntl.defineMessages)({
    verifiedTooltip: {
        id: 'email-status.components.verifiedTooltip',
        defaultMessage: 'Teacher\'s account has been activated.'
    },
    awaitingVerificationTooltip: {
        id: 'email-status.components.awaitingVerificationTooltip',
        defaultMessage: 'Invite email has been sent to this user.'
    },
    unverifiedTooltip: {
        id: 'email-status.components.unverifiedTooltip',
        defaultMessage: 'Password reset link needs to be sent.'
    },
    invalidTooltip: {
        id: 'email-status.components.invalidTooltip',
        defaultMessage: 'Email is either invalid or duplicated, please check email, or contact support.'
    }
});

/***/ }),
/* 708 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _reactIntl = __webpack_require__(2);

exports.default = (0, _reactIntl.defineMessages)({
    noResultFound: {
        id: 'empty-state.components.noResultFound',
        defaultMessage: 'No results found'
    }
}); /*
     * student-header messages
     *
     * This contains all the text for the student-header component.
     */

/***/ }),
/* 709 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactStyleable = __webpack_require__(6);

var _reactStyleable2 = _interopRequireDefault(_reactStyleable);

var _reactIntl = __webpack_require__(2);

var _cloneDeep = __webpack_require__(54);

var _cloneDeep2 = _interopRequireDefault(_cloneDeep);

var _index = __webpack_require__(1707);

var _index2 = _interopRequireDefault(_index);

var _index3 = __webpack_require__(255);

var _index4 = _interopRequireDefault(_index3);

var _messages = __webpack_require__(710);

var _messages2 = _interopRequireDefault(_messages);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ExtendResultTable = function (_Component) {
    _inherits(ExtendResultTable, _Component);

    function ExtendResultTable(props) {
        _classCallCheck(this, ExtendResultTable);

        var _this = _possibleConstructorReturn(this, (ExtendResultTable.__proto__ || Object.getPrototypeOf(ExtendResultTable)).call(this, props));

        _this.handleOnChange = function (yeargroups) {
            var yearGroups = _this.props.yearGroups;

            var clonedValue = (0, _cloneDeep2.default)(yeargroups);
            var onChange = _this.props.onChange;

            onChange(clonedValue);

            var keys = Object.keys(yeargroups);
            var selectedYeargroups = keys.filter(function (key) {
                return yeargroups[key];
            });
            _this.setState({ isStartFreshChecked: selectedYeargroups.length === 0 });
            _this.setState({ isKeepResultsChecked: selectedYeargroups.length === yearGroups.length });
        };

        _this.componentWillMount = function () {
            var yearGroups = _this.props.yearGroups;

            var extendTable = {};
            yearGroups.forEach(function (item) {
                extendTable[item.yearGroupEnum] = false;
            });
            _this.setState({ yeargroups: extendTable });
            _this.handleOnChange(extendTable);
        };

        _this.handleSelectorToggle = function (flag) {
            var clonedState = (0, _cloneDeep2.default)(_this.state.yeargroups);
            Object.keys(clonedState).forEach(function (v) {
                clonedState[v] = flag;
            });
            _this.setState({ yeargroups: clonedState });
            _this.handleOnChange(clonedState);
        };

        _this.handleOnToggle = function (key) {
            var newState = _extends({}, _this.state.yeargroups);
            newState[key] = !newState[key];
            _this.setState({ yeargroups: newState });
            _this.handleOnChange(newState);
        };

        _this.handleOnToggle = _this.handleOnToggle.bind(_this);
        _this.handleOnChange = _this.handleOnChange.bind(_this);
        _this.handleSelectorToggle = _this.handleSelectorToggle.bind(_this);
        _this.state = {
            yeargroups: {},
            isSelectorToggled: false,
            isStartFreshChecked: false,
            isKeepResultsChecked: false
        };
        return _this;
    }

    _createClass(ExtendResultTable, [{
        key: 'render',
        value: function render() {
            var _this2 = this;

            var _props = this.props,
                intl = _props.intl,
                yearGroups = _props.yearGroups;

            var items = [];
            if (yearGroups.length > 0) {
                items = yearGroups.map(function (item) {
                    var yearName = item.longName;
                    var yearValue = item.yearGroupEnum;
                    var key = 'year_' + item.shortName;
                    return _react2.default.createElement(
                        'tr',
                        { key: yearValue },
                        _react2.default.createElement(
                            'td',
                            null,
                            yearName
                        ),
                        _react2.default.createElement(
                            'td',
                            null,
                            _react2.default.createElement(_index4.default, {
                                checked: _this2.state.yeargroups[yearValue] !== true,
                                name: key,
                                onChange: function onChange() {
                                    _this2.handleOnToggle(yearValue);
                                } })
                        ),
                        _react2.default.createElement(
                            'td',
                            null,
                            _react2.default.createElement(_index4.default, {
                                checked: _this2.state.yeargroups[yearValue] === true,
                                name: key,
                                onChange: function onChange() {
                                    _this2.handleOnToggle(yearValue);
                                } })
                        )
                    );
                });
            }
            var tableHeader = yearGroups.length > 0 ? _react2.default.createElement(
                'tr',
                null,
                _react2.default.createElement(
                    'td',
                    null,
                    intl.formatMessage(_messages2.default.levelHeader)
                ),
                _react2.default.createElement(
                    'td',
                    null,
                    _react2.default.createElement(
                        'div',
                        null,
                        intl.formatMessage(_messages2.default.startFreshHeader)
                    ),
                    _react2.default.createElement(_index4.default, {
                        checked: this.state.isStartFreshChecked,
                        className: 'start-fresh-toggle',
                        name: 'mode',
                        onChange: function onChange() {
                            _this2.handleSelectorToggle(false);
                        },
                        value: 'on' })
                ),
                _react2.default.createElement(
                    'td',
                    null,
                    _react2.default.createElement(
                        'div',
                        null,
                        intl.formatMessage(_messages2.default.keepResultsHeader)
                    ),
                    _react2.default.createElement(_index4.default, {
                        checked: this.state.isKeepResultsChecked,
                        className: 'keep-result-toggle',
                        name: 'mode',
                        onChange: function onChange() {
                            _this2.handleSelectorToggle(true);
                        },
                        value: 'off' })
                )
            ) : '';
            return _react2.default.createElement(
                'div',
                { className: _index2.default.extendResultTableContainer },
                _react2.default.createElement(
                    'table',
                    { className: _index2.default.extendResultTable },
                    _react2.default.createElement(
                        'thead',
                        null,
                        tableHeader
                    ),
                    _react2.default.createElement(
                        'tbody',
                        null,
                        items
                    )
                )
            );
        }
    }]);

    return ExtendResultTable;
}(_react.Component);

ExtendResultTable.propTypes = {
    intl: _reactIntl.intlShape.isRequired,
    onChange: _propTypes2.default.func,
    yearGroups: _propTypes2.default.arrayOf(_propTypes2.default.object)
};

exports.default = (0, _reactIntl.injectIntl)((0, _reactStyleable2.default)(_index2.default)(ExtendResultTable));

/***/ }),
/* 710 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _reactIntl = __webpack_require__(2);

exports.default = (0, _reactIntl.defineMessages)({
    levelHeader: {
        id: 'app.components.ExtendResultTable.levelHeader',
        defaultMessage: 'Level'
    },
    keepResultsHeader: {
        id: 'app.components.ExtendResultTable.keepResultsHeader',
        defaultMessage: 'Keep results'
    },
    startFreshHeader: {
        id: 'app.components.ExtendResultTable.startFreshHeader',
        defaultMessage: 'Start fresh'
    }
}); /*
     * FileUploader Messages
     *
     * This contains all the text for the FileUploader component.
     */

/***/ }),
/* 711 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactStyleable = __webpack_require__(6);

var _reactStyleable2 = _interopRequireDefault(_reactStyleable);

var _spinner = __webpack_require__(94);

var _spinner2 = _interopRequireDefault(_spinner);

var _extendInfo = __webpack_require__(716);

var _extendInfo2 = _interopRequireDefault(_extendInfo);

var _extendForm = __webpack_require__(715);

var _extendForm2 = _interopRequireDefault(_extendForm);

var _error = __webpack_require__(712);

var _error2 = _interopRequireDefault(_error);

var _index = __webpack_require__(369);

var _index2 = _interopRequireDefault(_index);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ExtendResult = function ExtendResult(props) {
    var extendingResultsStatusType = props.extendingResultsStatusType;


    var extendResultView = extendingResultsStatusType === '' ? _react2.default.createElement(
        'div',
        { className: _index2.default.loader },
        _react2.default.createElement(_spinner2.default, { color: 'grey', size: '15px' })
    ) : _react2.default.createElement(
        'div',
        { className: _index2.default.extendResultContainer },
        _react2.default.createElement(_extendInfo2.default, props),
        _react2.default.createElement(_extendForm2.default, props),
        _react2.default.createElement(_error2.default, props)
    );

    return extendResultView;
};

exports.default = (0, _reactStyleable2.default)(_index2.default)(ExtendResult);

/***/ }),
/* 712 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactIntl = __webpack_require__(2);

var _index = __webpack_require__(24);

var _index2 = _interopRequireDefault(_index);

var _index3 = __webpack_require__(36);

var _index4 = _interopRequireDefault(_index3);

var _iconDictionary = __webpack_require__(8);

var _messages = __webpack_require__(152);

var _messages2 = _interopRequireDefault(_messages);

var _portalComms = __webpack_require__(55);

var _portalComms2 = _interopRequireDefault(_portalComms);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ExtendResultError = function ExtendResultError(props) {
    var intl = props.intl,
        extendingResultsStatusType = props.extendingResultsStatusType;


    var confirmation = _react2.default.createElement('div', null);

    switch (extendingResultsStatusType) {
        case 'ResultAlreadyExtended':
            confirmation = _react2.default.createElement(
                _index4.default,
                {
                    handleOnCloseModal: function handleOnCloseModal() {
                        _portalComms2.default.navigateToLandingScreen('Rollover');
                    },
                    icon: _iconDictionary.Warning,
                    title: intl.formatMessage(_messages2.default.resultsAlreadyExtended) },
                intl.formatMessage(_messages2.default.resultsAlreadyExtendedSummary)
            );
            break;

        case 'OutOfExtendPeriod':
            confirmation = _react2.default.createElement(
                _index4.default,
                {
                    handleOnCloseModal: function handleOnCloseModal() {
                        _portalComms2.default.navigateToLandingScreen('Rollover');
                    },
                    icon: _iconDictionary.Warning,
                    title: intl.formatMessage(_messages2.default.extendPeriodExpired) },
                intl.formatMessage(_messages2.default.extendPeriodExpiredSummary)
            );
            break;

        case 'RolloverRequired':
            confirmation = _react2.default.createElement(
                _index4.default,
                {
                    handleOnCloseModal: function handleOnCloseModal() {
                        _portalComms2.default.navigateToLandingScreen('Rollover');
                    },
                    icon: _iconDictionary.Warning,
                    title: intl.formatMessage(_messages2.default.rolloverNotCompleted) },
                intl.formatMessage(_messages2.default.rolloverNotCompletedSummary)
            );
            break;

        default:
            confirmation = _react2.default.createElement('div', null);
            break;
    }

    return _react2.default.createElement(
        _index2.default,
        { show: extendingResultsStatusType !== 'IsExtendable' },
        confirmation
    );
};

ExtendResultError.propTypes = {
    intl: _reactIntl.intlShape.isRequired,
    extendingResultsStatusType: _propTypes2.default.string
};

exports.default = (0, _reactIntl.injectIntl)(ExtendResultError);

/***/ }),
/* 713 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactIntl = __webpack_require__(2);

var _index = __webpack_require__(36);

var _index2 = _interopRequireDefault(_index);

var _iconDictionary = __webpack_require__(8);

var _messages = __webpack_require__(152);

var _messages2 = _interopRequireDefault(_messages);

var _withModal = __webpack_require__(49);

var _withModal2 = _interopRequireDefault(_withModal);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ExtendResultFailure = function ExtendResultFailure(props) {
    var intl = props.intl,
        handleOnClick = props.handleOnClick;


    return _react2.default.createElement(
        _index2.default,
        {
            handleOnCloseModal: handleOnClick,
            icon: _iconDictionary.Warning,
            title: intl.formatMessage(_messages2.default.failureTitle) },
        intl.formatMessage(_messages2.default.failureMessage)
    );
};

ExtendResultFailure.propTypes = {
    handleOnClick: _propTypes2.default.func,
    intl: _reactIntl.intlShape.isRequired
};

exports.default = (0, _withModal2.default)('isActive')((0, _reactIntl.injectIntl)(ExtendResultFailure));

/***/ }),
/* 714 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactIntl = __webpack_require__(2);

var _index = __webpack_require__(36);

var _index2 = _interopRequireDefault(_index);

var _iconDictionary = __webpack_require__(8);

var _messages = __webpack_require__(152);

var _messages2 = _interopRequireDefault(_messages);

var _withModal = __webpack_require__(49);

var _withModal2 = _interopRequireDefault(_withModal);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ExtendResultSuccess = function ExtendResultSuccess(props) {
    var intl = props.intl,
        handleOnClick = props.handleOnClick,
        extendedYearGroups = props.extendedYearGroups;


    var extendedGroups = extendedYearGroups || {};
    var startedFreshFlag = Object.keys(extendedGroups).every(function (k) {
        return !extendedGroups[k];
    });

    var successTitle = startedFreshFlag ? intl.formatMessage(_messages2.default.successTitleStartedFresh) : intl.formatMessage(_messages2.default.successTitle);
    var successMessage = startedFreshFlag ? '' : intl.formatMessage(_messages2.default.successMessage);
    return _react2.default.createElement(
        _index2.default,
        {
            handleOnCloseModal: handleOnClick,
            icon: _iconDictionary.Tick,
            title: successTitle },
        successMessage
    );
};

ExtendResultSuccess.propTypes = {
    handleOnClick: _propTypes2.default.func,
    intl: _reactIntl.intlShape.isRequired,
    extendedYearGroups: _propTypes2.default.object
};

exports.default = (0, _withModal2.default)('isActive')((0, _reactIntl.injectIntl)(ExtendResultSuccess));

/***/ }),
/* 715 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactIntl = __webpack_require__(2);

var _reactStyleable = __webpack_require__(6);

var _reactStyleable2 = _interopRequireDefault(_reactStyleable);

var _index = __webpack_require__(369);

var _index2 = _interopRequireDefault(_index);

var _index3 = __webpack_require__(7);

var _index4 = _interopRequireDefault(_index3);

var _variants = __webpack_require__(9);

var _messages = __webpack_require__(152);

var _messages2 = _interopRequireDefault(_messages);

var _index5 = __webpack_require__(709);

var _index6 = _interopRequireDefault(_index5);

var _success = __webpack_require__(714);

var _success2 = _interopRequireDefault(_success);

var _failure = __webpack_require__(713);

var _failure2 = _interopRequireDefault(_failure);

var _portalComms = __webpack_require__(55);

var _portalComms2 = _interopRequireDefault(_portalComms);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* global window */
/* eslint react/no-danger: 0 */

var ExtendResultForm = function ExtendResultForm(props) {
    var closeFailureModal = props.closeFailureModal,
        extendResults = props.extendResults,
        onShowExtendResultInfo = props.onShowExtendResultInfo,
        extendResultForm = props.extendResultForm,
        isExtending = props.isExtending,
        isFail = props.isFail,
        isSuccess = props.isSuccess,
        yearGroups = props.yearGroups,
        yearGroupsToBeExtended = props.yearGroupsToBeExtended,
        product = props.product;


    var onTableChange = function onTableChange(value) {
        var setIdsToExtend = props.setIdsToExtend;

        setIdsToExtend(value);
    };

    var onProceed = function onProceed() {
        var id = product.id;

        extendResults(id, yearGroupsToBeExtended);
    };

    var extendTableProps = {
        onChange: onTableChange,
        yearGroups: yearGroups
    };

    var infoView = extendResultForm ? _react2.default.createElement(
        'div',
        { className: _index2.default.extendFormComponent },
        _react2.default.createElement(
            'div',
            { className: _index2.default.extendFormHeader },
            props.intl.formatMessage(_messages2.default.formHeader)
        ),
        _react2.default.createElement(
            'div',
            { className: _index2.default.extendFormContent },
            _react2.default.createElement(
                'div',
                { className: _index2.default.extendFormContentWrapper },
                _react2.default.createElement(
                    'div',
                    { className: _index2.default.extendFormContentLabels },
                    _react2.default.createElement(
                        'div',
                        { className: _index2.default.extendFormContentWarning },
                        props.intl.formatMessage(_messages2.default.formContent1)
                    ),
                    _react2.default.createElement(
                        'div',
                        null,
                        props.intl.formatMessage(_messages2.default.formContent2)
                    ),
                    _react2.default.createElement(
                        'div',
                        null,
                        props.intl.formatMessage(_messages2.default.formContent3)
                    )
                ),
                _react2.default.createElement(_index6.default, extendTableProps)
            )
        ),
        _react2.default.createElement(
            'div',
            { className: _index2.default.extendFormFooter },
            _react2.default.createElement(_index4.default, {
                containerClassName: 'continue-button',
                disabled: isExtending,
                handleOnClick: onProceed,
                label: props.intl.formatMessage(_messages2.default.formContinueBtn),
                variant: _variants.DARK }),
            _react2.default.createElement(_index4.default, {
                containerClassName: 'help-button',
                handleOnClick: onShowExtendResultInfo,
                label: props.intl.formatMessage(_messages2.default.formHelpBtn),
                variant: _variants.DARK })
        ),
        _react2.default.createElement(_success2.default, {
            extendedYearGroups: yearGroupsToBeExtended,
            handleOnClick: function handleOnClick() {
                _portalComms2.default.navigateToLandingScreen('Rollover');
            },
            isActive: isSuccess }),
        _react2.default.createElement(_failure2.default, { handleOnClick: closeFailureModal, isActive: isFail })
    ) : _react2.default.createElement('div', null);

    return infoView;
};

ExtendResultForm.propTypes = {
    intl: _reactIntl.intlShape.isRequired,
    closeFailureModal: _propTypes2.default.func,
    extendResultForm: _propTypes2.default.bool,
    isFail: _propTypes2.default.bool,
    isSuccess: _propTypes2.default.bool,
    onShowExtendResultInfo: _propTypes2.default.func,
    setIdsToExtend: _propTypes2.default.func,
    yearGroups: _propTypes2.default.arrayOf(_propTypes2.default.object),
    yearGroupsToBeExtended: _propTypes2.default.object
};

exports.default = (0, _reactIntl.injectIntl)((0, _reactStyleable2.default)(_index2.default)(ExtendResultForm));

/***/ }),
/* 716 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactIntl = __webpack_require__(2);

var _reactStyleable = __webpack_require__(6);

var _reactStyleable2 = _interopRequireDefault(_reactStyleable);

var _utils = __webpack_require__(13);

var _index = __webpack_require__(369);

var _index2 = _interopRequireDefault(_index);

var _index3 = __webpack_require__(7);

var _index4 = _interopRequireDefault(_index3);

var _variants = __webpack_require__(9);

var _messages = __webpack_require__(152);

var _messages2 = _interopRequireDefault(_messages);

var _portalComms = __webpack_require__(55);

var _portalComms2 = _interopRequireDefault(_portalComms);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* global window */
/* eslint react/no-danger: 0 */

var ExtendResultInfo = function ExtendResultInfo(props) {
    var extendResultInfo = props.extendResultInfo,
        onProceedExtendResultRequest = props.onProceedExtendResultRequest,
        yearGroups = props.yearGroups,
        extendingResultsStatusType = props.extendingResultsStatusType,
        currentAcademicYear = props.currentAcademicYear,
        intl = props.intl,
        showOkButton = props.showOkButton;


    var config = (0, _utils.getAppConfig)();
    var extendInfoHtml = config ? config.ExtendResultInfoContent : '';

    var infoView = extendingResultsStatusType === 'IsExtendable' && extendResultInfo ? _react2.default.createElement(
        'div',
        { className: _index2.default.infoContainer },
        _react2.default.createElement(
            'div',
            { className: _index2.default.infoHeading },
            ' ' + intl.formatMessage(_messages2.default.startFresh) + ' ' + (currentAcademicYear - 1)
        ),
        _react2.default.createElement(
            'div',
            { className: _index2.default.infoContent },
            _react2.default.createElement('div', { dangerouslySetInnerHTML: { __html: extendInfoHtml } })
        ),
        _react2.default.createElement(
            'div',
            { className: _index2.default.extendInfoFooter },
            _react2.default.createElement(_index4.default, {
                containerClassName: 'back-button',
                handleOnClick: function handleOnClick() {
                    _portalComms2.default.navigateToLandingScreen('Rollover');
                },
                hidden: showOkButton,
                label: intl.formatMessage(_messages2.default.back),
                variant: _variants.DARK }),
            _react2.default.createElement(_index4.default, {
                containerClassName: 'back-button',
                handleOnClick: onProceedExtendResultRequest,
                hidden: !showOkButton,
                label: intl.formatMessage(_messages2.default.ok),
                variant: _variants.DARK }),
            _react2.default.createElement(_index4.default, {
                containerClassName: 'proceed-button',
                disabled: !(yearGroups.length > 0),
                handleOnClick: onProceedExtendResultRequest,
                hidden: showOkButton,
                label: intl.formatMessage(_messages2.default.proceed),
                variant: _variants.DARK })
        )
    ) : _react2.default.createElement('div', null);

    return infoView;
};

ExtendResultInfo.propTypes = {
    intl: _reactIntl.intlShape.isRequired,
    extendingResultsStatusType: _propTypes2.default.string,
    onProceedExtendResultRequest: _propTypes2.default.func,
    yearGroups: _propTypes2.default.arrayOf(_propTypes2.default.object),
    currentAcademicYear: _propTypes2.default.number,
    showOkButton: _propTypes2.default.bool
};

exports.default = (0, _reactIntl.injectIntl)((0, _reactStyleable2.default)(_index2.default)(ExtendResultInfo));

/***/ }),
/* 717 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactStyleable = __webpack_require__(6);

var _reactStyleable2 = _interopRequireDefault(_reactStyleable);

var _reactIntl = __webpack_require__(2);

var _messages = __webpack_require__(718);

var _messages2 = _interopRequireDefault(_messages);

var _index = __webpack_require__(7);

var _index2 = _interopRequireDefault(_index);

var _index3 = __webpack_require__(1708);

var _index4 = _interopRequireDefault(_index3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var FileUploader = function (_Component) {
    _inherits(FileUploader, _Component);

    function FileUploader(props) {
        _classCallCheck(this, FileUploader);

        var _this = _possibleConstructorReturn(this, (FileUploader.__proto__ || Object.getPrototypeOf(FileUploader)).call(this, props));

        _this.handleOnUploadChange = function (e) {
            var file = e.target.files[0];
            _this.setState({ uploadedFile: file, filename: file.name, disableUpload: false });
        };

        _this.handleOnUploadClick = function () {
            _this.props.handleOnUploadClick(_this.state.uploadedFile);
            _this.uploadFile.value = '';
        };

        _this.state = { uploadedFile: '', filename: '', disableUpload: true };
        return _this;
    }

    _createClass(FileUploader, [{
        key: 'render',
        value: function render() {
            var _this2 = this;

            this.uploadFile = function (element) {
                _this2.uploadFile = element;
            };
            return _react2.default.createElement(
                'div',
                null,
                _react2.default.createElement(
                    'div',
                    { className: _index4.default.fileUpload },
                    _react2.default.createElement(
                        'div',
                        null,
                        this.props.intl.formatMessage(_messages2.default.fileUpload)
                    ),
                    _react2.default.createElement(
                        'div',
                        { className: _index4.default.uploadTextBox },
                        ' ',
                        this.state.filename,
                        ' '
                    ),
                    _react2.default.createElement(
                        'div',
                        { className: this.props.isUploading ? _index4.default.browseButtonWrapperDisabled : _index4.default.browseButtonWrapper },
                        _react2.default.createElement('input', {
                            accept: '.xls,.xlsx',
                            className: _index4.default.browseButton,
                            id: 'file',
                            name: 'file',
                            onChange: this.handleOnUploadChange,
                            ref: this.uploadFile,
                            type: 'file' }),
                        _react2.default.createElement(
                            'label',
                            { htmlFor: 'file' },
                            this.props.intl.formatMessage(_messages2.default.browse)
                        )
                    )
                ),
                _react2.default.createElement(
                    'div',
                    null,
                    _react2.default.createElement(_index2.default, {
                        containerClassName: _index4.default.uploadButton,
                        disabled: this.state.disableUpload,
                        handleOnClick: this.handleOnUploadClick,
                        label: this.props.intl.formatMessage(_messages2.default.upload),
                        loading: this.props.isUploading,
                        loadingLabel: this.props.intl.formatMessage(_messages2.default.uploading)
                    })
                )
            );
        }
    }]);

    return FileUploader;
}(_react.Component);

FileUploader.propTypes = {
    handleOnUploadClick: _propTypes2.default.func,
    isUploading: _propTypes2.default.bool,
    intl: _reactIntl.intlShape.isRequired
};

exports.default = (0, _reactIntl.injectIntl)((0, _reactStyleable2.default)(_index4.default)(FileUploader));

/***/ }),
/* 718 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _reactIntl = __webpack_require__(2);

exports.default = (0, _reactIntl.defineMessages)({
    fileUpload: {
        id: 'app.components.FileUploader.fileUpload',
        defaultMessage: 'Upload file:'
    },
    browse: {
        id: 'app.components.FileUploader.browse',
        defaultMessage: 'Browse...'
    },
    upload: {
        id: 'app.components.FileUploader.upload',
        defaultMessage: 'Upload'
    },
    uploading: {
        id: 'app.components.components.uploading',
        defaultMessage: 'uploading'
    }
}); /*
     * FileUploader Messages
     *
     * This contains all the text for the FileUploader component.
     */

/***/ }),
/* 719 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

__webpack_require__(26);

var _index = __webpack_require__(380);

var _index2 = _interopRequireDefault(_index);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var AssignedClassFormatter = function AssignedClassFormatter(_ref) {
    var dependentValues = _ref.dependentValues,
        _ref$value = _ref.value,
        value = _ref$value === undefined ? [] : _ref$value,
        handleOnAssignClass = _ref.handleOnAssignClass;
    return _react2.default.createElement(_index2.default, {
        assignedTo: value,
        dependentValues: dependentValues,
        handleOnAssignClass: handleOnAssignClass,
        showAssignButton: true });
};

AssignedClassFormatter.propTypes = {
    value: _propTypes2.default.array,
    dependentValues: _propTypes2.default.object,
    handleOnAssignClass: _propTypes2.default.func
};

exports.default = AssignedClassFormatter;

/***/ }),
/* 720 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

__webpack_require__(26);

var _index = __webpack_require__(1709);

var _index2 = _interopRequireDefault(_index);

var _index3 = __webpack_require__(254);

var _index4 = _interopRequireDefault(_index3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var AssignedCoursesFormatter = function AssignedCoursesFormatter(_ref) {
    var value = _ref.value;
    return _react2.default.createElement(
        'div',
        { className: _index2.default.component },
        _react2.default.createElement(_index4.default, { dataItems: value })
    );
};

AssignedCoursesFormatter.propTypes = {
    value: _propTypes2.default.object
};

exports.default = AssignedCoursesFormatter;

/***/ }),
/* 721 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

__webpack_require__(26);

var _index = __webpack_require__(380);

var _index2 = _interopRequireDefault(_index);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var AssignedGroupFormatter = function AssignedGroupFormatter(_ref) {
    var _ref$value = _ref.value,
        value = _ref$value === undefined ? [] : _ref$value;
    return _react2.default.createElement(_index2.default, { assignedTo: value, showAssignButton: false });
};

AssignedGroupFormatter.propTypes = {
    value: _propTypes2.default.array
};

exports.default = AssignedGroupFormatter;

/***/ }),
/* 722 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

__webpack_require__(26);

var _index = __webpack_require__(652);

var _index2 = _interopRequireDefault(_index);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var AssignedTeacherFormatter = function AssignedTeacherFormatter(_ref) {
    var value = _ref.value,
        handleOnAssignTeacher = _ref.handleOnAssignTeacher,
        dependentValues = _ref.dependentValues;
    return _react2.default.createElement(_index2.default, {
        assignedTeachers: value,
        dependentValues: dependentValues,
        handleOnAssignTeacher: handleOnAssignTeacher });
};

AssignedTeacherFormatter.propTypes = {
    value: _propTypes2.default.array,
    dependentValues: _propTypes2.default.object,
    handleOnAssignTeacher: _propTypes2.default.func
};

exports.default = AssignedTeacherFormatter;

/***/ }),
/* 723 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

__webpack_require__(26);

var _index = __webpack_require__(1710);

var _index2 = _interopRequireDefault(_index);

var _index3 = __webpack_require__(7);

var _index4 = _interopRequireDefault(_index3);

var _iconDictionary = __webpack_require__(8);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var EditInfoFormatter = function EditInfoFormatter(_ref) {
    var dependentValues = _ref.dependentValues,
        handleOnEdit = _ref.handleOnEdit;

    var id = dependentValues.userProfileId !== undefined ? dependentValues.userProfileId : dependentValues.classroomId;

    return _react2.default.createElement(_index4.default, {
        containerClassName: _index2.default.editInfo,
        handleOnClick: function handleOnClick() {
            return handleOnEdit(id);
        },
        icon: _iconDictionary.Edit,
        iconClassName: _index2.default.svgIconContainer });
};

EditInfoFormatter.propTypes = {
    dependentValues: _propTypes2.default.object,
    handleOnEdit: _propTypes2.default.func
};

exports.default = EditInfoFormatter;

/***/ }),
/* 724 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _emailStatus = __webpack_require__(706);

var _emailStatus2 = _interopRequireDefault(_emailStatus);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var EmailStatusFormatter = function EmailStatusFormatter(_ref) {
    var value = _ref.value;
    return _react2.default.createElement(_emailStatus2.default, { status: value });
};

EmailStatusFormatter.propTypes = {
    value: _propTypes2.default.string
};

exports.default = EmailStatusFormatter;

/***/ }),
/* 725 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

__webpack_require__(26);

var _index = __webpack_require__(1711);

var _index2 = _interopRequireDefault(_index);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var HeaderFormatter = function HeaderFormatter(_ref) {
    var column = _ref.column,
        onSort = _ref.onSort;
    return _react2.default.createElement(
        'div',
        { className: _index2.default.component, onClick: function onClick() {
                return onSort(column.key);
            }, role: 'button', tabIndex: '0' },
        _react2.default.createElement(
            'div',
            { className: _index2.default.title },
            column.name
        ),
        _react2.default.createElement('div', { className: _index2.default.sort })
    );
};

HeaderFormatter.propTypes = {
    column: _propTypes2.default.object,
    onSort: _propTypes2.default.func
};

exports.default = HeaderFormatter;

/***/ }),
/* 726 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactIntl = __webpack_require__(2);

var _reactStyleable = __webpack_require__(6);

var _reactStyleable2 = _interopRequireDefault(_reactStyleable);

__webpack_require__(26);

var _index = __webpack_require__(1712);

var _index2 = _interopRequireDefault(_index);

var _index3 = __webpack_require__(257);

var _index4 = _interopRequireDefault(_index3);

var _index5 = __webpack_require__(7);

var _index6 = _interopRequireDefault(_index5);

var _messages = __webpack_require__(727);

var _messages2 = _interopRequireDefault(_messages);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var StudentCountFormatter = function StudentCountFormatter(_ref) {
    var dependentValues = _ref.dependentValues,
        handleOnAssignStudents = _ref.handleOnAssignStudents,
        intl = _ref.intl;

    if (dependentValues.studentsCount === 0) {
        return _react2.default.createElement(_index6.default, {
            containerClassName: _index2.default.assign,
            disabled: false,
            handleOnClick: function handleOnClick() {
                return handleOnAssignStudents(dependentValues.classroomId, dependentValues.name);
            },
            label: intl.formatMessage(_messages2.default.assignStudents) });
    }

    return _react2.default.createElement(_index4.default, {
        count: dependentValues.studentsCount });
};

StudentCountFormatter.propTypes = {
    dependentValues: _propTypes2.default.object,
    handleOnAssignStudents: _propTypes2.default.func,
    intl: _reactIntl.intlShape.isRequired
};

exports.default = (0, _reactIntl.injectIntl)((0, _reactStyleable2.default)(_index2.default)(StudentCountFormatter));

/***/ }),
/* 727 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _reactIntl = __webpack_require__(2);

exports.default = (0, _reactIntl.defineMessages)({
    assignStudents: {
        id: 'app.components.StudentCountFormatter.assignStudents',
        defaultMessage: 'Assign students'
    }
}); /*
     * HeaderFormatter Messages
     *
     * This contains all the text for the HeaderFormatter component.
     */

/***/ }),
/* 728 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

__webpack_require__(26);

var _index = __webpack_require__(1713);

var _index2 = _interopRequireDefault(_index);

var _index3 = __webpack_require__(149);

var _index4 = _interopRequireDefault(_index3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var YearGroupFormatter = function YearGroupFormatter(_ref) {
    var dependentValues = _ref.dependentValues;

    var yearStyle = 'yg' + dependentValues.yearGroupEnum;
    return _react2.default.createElement(_index4.default, { badgeStyle: _index2.default.yearGroup + ' ' + yearStyle, content: dependentValues.year });
};

YearGroupFormatter.propTypes = {
    dependentValues: _propTypes2.default.object
};

exports.default = YearGroupFormatter;

/***/ }),
/* 729 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactStyleable = __webpack_require__(6);

var _reactStyleable2 = _interopRequireDefault(_reactStyleable);

var _index = __webpack_require__(1714);

var _index2 = _interopRequireDefault(_index);

var _utils = __webpack_require__(13);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ClassInfo = function (_PureComponent) {
    _inherits(ClassInfo, _PureComponent);

    function ClassInfo() {
        _classCallCheck(this, ClassInfo);

        return _possibleConstructorReturn(this, (ClassInfo.__proto__ || Object.getPrototypeOf(ClassInfo)).apply(this, arguments));
    }

    _createClass(ClassInfo, [{
        key: 'render',
        value: function render() {
            var _props = this.props,
                group = _props.group,
                isMultiSelect = _props.isMultiSelect;

            var radioButton = '';
            var groupStyle = '' + _index2.default.groupInfo;
            var elementId = 'rb_' + group.id + '_' + group.classId;
            if (isMultiSelect) {
                radioButton = _react2.default.createElement(
                    'div',
                    null,
                    ' ',
                    _react2.default.createElement('input', {
                        checked: group.isDefault,
                        className: _index2.default.group,
                        id: elementId,
                        name: elementId,
                        onChange: this.props.onGroupSelection,
                        type: 'radio'
                    }),
                    _react2.default.createElement('label', { htmlFor: elementId })
                );

                if (group.isDefault) {
                    groupStyle = _index2.default.groupInfo + ' ' + _index2.default.highlight;
                }
            }

            var groupName = (0, _utils.truncateCharacters)('group', group.name);
            var courseName = (0, _utils.truncateCharacters)('course', group.courseName);

            return _react2.default.createElement(
                'div',
                null,
                _react2.default.createElement(
                    'div',
                    { className: groupStyle },
                    _react2.default.createElement(
                        'div',
                        { className: _index2.default.radio },
                        radioButton,
                        _react2.default.createElement(
                            'div',
                            { className: _index2.default.info },
                            _react2.default.createElement(
                                'span',
                                { className: _index2.default.groupName },
                                groupName
                            ),
                            _react2.default.createElement(
                                'span',
                                { className: _index2.default.courseName },
                                courseName
                            )
                        )
                    )
                )
            );
        }
    }]);

    return ClassInfo;
}(_react.PureComponent);

ClassInfo.propTypes = {
    group: _propTypes2.default.object,
    isMultiSelect: _propTypes2.default.bool,
    onGroupSelection: _propTypes2.default.func
};

exports.default = (0, _reactStyleable2.default)(_index2.default)(ClassInfo);

/***/ }),
/* 730 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactStyleable = __webpack_require__(6);

var _reactStyleable2 = _interopRequireDefault(_reactStyleable);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

__webpack_require__(26);

var _index = __webpack_require__(1715);

var _index2 = _interopRequireDefault(_index);

var _index3 = __webpack_require__(149);

var _index4 = _interopRequireDefault(_index3);

var _index5 = __webpack_require__(777);

var _index6 = _interopRequireDefault(_index5);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Header = function Header(_ref) {
    var _ref$headerTitle = _ref.headerTitle,
        headerTitle = _ref$headerTitle === undefined ? '' : _ref$headerTitle,
        licenceSummaryTitle = _ref.licenceSummaryTitle,
        licenceSummary = _ref.licenceSummary,
        tabs = _ref.tabs;
    return _react2.default.createElement(
        'div',
        { className: _index2.default.headerComponent },
        _react2.default.createElement(
            'div',
            { className: _index2.default.headerText },
            headerTitle
        ),
        _react2.default.createElement(
            'div',
            { className: _index2.default.tabContainer },
            tabs.map(function (val, index) {
                return _react2.default.createElement(_index6.default, { key: val.id, name: val.name, route: val.route, tabIndex: index });
            })
        ),
        _react2.default.createElement(
            'div',
            { className: _index2.default.badgeContainer },
            _react2.default.createElement(_index4.default, { badgeStyle: _index2.default.licenceCount, content: licenceSummary, showLoader: true, title: licenceSummaryTitle })
        )
    );
};

Header.propTypes = {
    headerTitle: _propTypes2.default.string,
    licenceSummaryTitle: _propTypes2.default.string,
    licenceSummary: _propTypes2.default.string,
    tabs: _propTypes2.default.array
};

exports.default = (0, _reactStyleable2.default)(_index2.default)(Header);

/***/ }),
/* 731 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactStyleable = __webpack_require__(6);

var _reactStyleable2 = _interopRequireDefault(_reactStyleable);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactIntl = __webpack_require__(2);

var _messages = __webpack_require__(388);

var _messages2 = _interopRequireDefault(_messages);

var _index = __webpack_require__(593);

var _index2 = _interopRequireDefault(_index);

var _assignCourseMapperAdmin = __webpack_require__(640);

var _assignCourseMapperAdmin2 = _interopRequireDefault(_assignCourseMapperAdmin);

var _withLoader = __webpack_require__(262);

var _withLoader2 = _interopRequireDefault(_withLoader);

var _viewCourse = __webpack_require__(732);

var _viewCourse2 = _interopRequireDefault(_viewCourse);

var _index3 = __webpack_require__(76);

var _index4 = _interopRequireDefault(_index3);

var _iconDictionary = __webpack_require__(8);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ManageAssignCourse = function (_PureComponent) {
    _inherits(ManageAssignCourse, _PureComponent);

    function ManageAssignCourse() {
        var _ref;

        var _temp, _this, _ret;

        _classCallCheck(this, ManageAssignCourse);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = ManageAssignCourse.__proto__ || Object.getPrototypeOf(ManageAssignCourse)).call.apply(_ref, [this].concat(args))), _this), _this.getDefaultObject = function () {
            var _this$props = _this.props,
                classrooms = _this$props.classrooms,
                yearGroups = _this$props.yearGroups,
                isYearGroupDataLoaded = _this$props.isYearGroupDataLoaded,
                isClassroomDataLoaded = _this$props.isClassroomDataLoaded;


            if (isYearGroupDataLoaded && isClassroomDataLoaded) {
                var _loop = function _loop(year) {
                    var classroom = classrooms.find(function (item) {
                        return item.yearGroupEnum === year.yearGroupEnum;
                    });
                    if (classroom) {
                        var group = classroom.classroomGroups[0];
                        return {
                            v: {
                                DefaultYear: year.yearGroupEnum,
                                DefaultClassroom: classroom.classroomId,
                                DefaultGroup: group.id
                            }
                        };
                    }
                };

                var _iteratorNormalCompletion = true;
                var _didIteratorError = false;
                var _iteratorError = undefined;

                try {
                    for (var _iterator = yearGroups[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                        var year = _step.value;

                        var _ret2 = _loop(year);

                        if ((typeof _ret2 === 'undefined' ? 'undefined' : _typeof(_ret2)) === "object") return _ret2.v;
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally {
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return) {
                            _iterator.return();
                        }
                    } finally {
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
            }

            return -1;
        }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    _createClass(ManageAssignCourse, [{
        key: 'render',
        value: function render() {
            var _props = this.props,
                intl = _props.intl,
                classrooms = _props.classrooms,
                courseDetails = _props.courseDetails,
                yearGroups = _props.yearGroups,
                isYearGroupDataLoaded = _props.isYearGroupDataLoaded,
                isClassroomDataLoaded = _props.isClassroomDataLoaded,
                isCourseModalVisible = _props.isCourseModalVisible,
                handleOnAssign = _props.handleOnAssign,
                assignedTasksId = _props.assignedTasksId,
                showAssignErrorModal = _props.showAssignErrorModal,
                showSaveErrorModal = _props.showSaveErrorModal,
                assigningCourses = _props.assigningCourses,
                activateModal = _props.activateModal,
                handleOnSaveAssignCourses = _props.handleOnSaveAssignCourses,
                isAssignEvent = _props.isAssignEvent,
                dispatch = _props.dispatch,
                selectedProduct = _props.selectedProduct;


            var pageContent = null;

            if (isYearGroupDataLoaded && isClassroomDataLoaded) {
                if (classrooms.length) {
                    pageContent = _react2.default.createElement(_assignCourseMapperAdmin2.default, {
                        activateModal: activateModal,
                        assignedTasksId: assignedTasksId,
                        assigningCourses: assigningCourses,
                        classrooms: classrooms,
                        defaultCourses: this.props.defaultCourses,
                        defaultData: this.getDefaultObject(),
                        dispatch: dispatch,
                        handleOnAssign: handleOnAssign,
                        handleOnSaveAssignCourses: handleOnSaveAssignCourses,
                        isAssignEvent: isAssignEvent,
                        selectedProduct: selectedProduct,
                        showAssignErrorModal: showAssignErrorModal,
                        showSaveErrorModal: showSaveErrorModal,
                        upfCourseId: this.props.upfCourseId,
                        yearGroups: yearGroups
                    });
                } else {
                    pageContent = _react2.default.createElement(
                        'div',
                        { className: _index2.default.emptyState },
                        _react2.default.createElement(_index4.default, {
                            iconName: _iconDictionary.StudentManagement,
                            message: intl.formatMessage(_messages2.default.emptyStateMessage) })
                    );
                }
            } else {
                pageContent = _react2.default.createElement('div', null);
            }

            return _react2.default.createElement(
                'div',
                null,
                _react2.default.createElement(
                    'div',
                    { className: _index2.default.header },
                    _react2.default.createElement(
                        'div',
                        { className: _index2.default.mainHeading },
                        _react2.default.createElement(
                            'div',
                            { className: _index2.default.title },
                            intl.formatMessage(_messages2.default.pageTitle)
                        )
                    ),
                    _react2.default.createElement(
                        'div',
                        { className: _index2.default.subHeading },
                        _react2.default.createElement(
                            'span',
                            null,
                            ' ',
                            intl.formatMessage(_messages2.default.pageSubTitle),
                            ' '
                        )
                    )
                ),
                pageContent,
                _react2.default.createElement(_viewCourse2.default, {
                    courseDetails: courseDetails,
                    handleOnViewCourse: this.props.handleOnViewCourse,
                    hideCourseDetails: this.props.hideCourseDetails,
                    show: isCourseModalVisible })
            );
        }
    }]);

    return ManageAssignCourse;
}(_react.PureComponent);

ManageAssignCourse.propTypes = {
    intl: _reactIntl.intlShape.isRequired,
    isYearGroupDataLoaded: _propTypes2.default.bool,
    isClassroomDataLoaded: _propTypes2.default.bool,
    isCourseModalVisible: _propTypes2.default.bool,
    classrooms: _propTypes2.default.arrayOf(_propTypes2.default.object),
    courseDetails: _propTypes2.default.object,
    yearGroups: _propTypes2.default.array,
    handleOnAssign: _propTypes2.default.func,
    handleOnSaveAssignCourses: _propTypes2.default.func,
    assignedTasksId: _propTypes2.default.array,
    upfCourseId: _propTypes2.default.number,
    showAssignErrorModal: _propTypes2.default.bool,
    showSaveErrorModal: _propTypes2.default.bool,
    activateModal: _propTypes2.default.bool,
    assigningCourses: _propTypes2.default.bool,
    isAssignEvent: _propTypes2.default.bool,
    dispatch: _propTypes2.default.func.isRequired,
    handleOnViewCourse: _propTypes2.default.func,
    hideCourseDetails: _propTypes2.default.func.isRequired,
    defaultCourses: _propTypes2.default.object,
    selectedProduct: _propTypes2.default.object
};

var DefaultCourseWithDataLoader = (0, _withLoader2.default)('fetching')(ManageAssignCourse);
exports.default = (0, _reactIntl.injectIntl)((0, _reactStyleable2.default)(_index2.default)(DefaultCourseWithDataLoader));

/***/ }),
/* 732 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactIntl = __webpack_require__(2);

var _index = __webpack_require__(593);

var _index2 = _interopRequireDefault(_index);

var _courseTopics = __webpack_require__(1716);

var _courseTopics2 = _interopRequireDefault(_courseTopics);

var _withModal = __webpack_require__(49);

var _withModal2 = _interopRequireDefault(_withModal);

var _courseTopicsDetails = __webpack_require__(384);

var _courseTopicsDetails2 = _interopRequireDefault(_courseTopicsDetails);

var _button = __webpack_require__(7);

var _button2 = _interopRequireDefault(_button);

var _variants = __webpack_require__(9);

var _messages = __webpack_require__(388);

var _messages2 = _interopRequireDefault(_messages);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ViewCourseModal = function ViewCourseModal(_ref) {
    var courseDetails = _ref.courseDetails,
        intl = _ref.intl,
        hideCourseDetails = _ref.hideCourseDetails;
    return _react2.default.createElement(
        'div',
        { className: _index2.default.courseDetailModal },
        _react2.default.createElement(
            'div',
            { className: _index2.default.courseDetailContent },
            _react2.default.createElement(_courseTopicsDetails2.default, { course: courseDetails, css: _courseTopics2.default })
        ),
        _react2.default.createElement(
            'div',
            { className: _index2.default.courseDetailFooter },
            _react2.default.createElement(_button2.default, {
                handleOnClick: hideCourseDetails,
                label: intl.formatMessage(_messages2.default.backButton),
                variant: _variants.DARK
            })
        )
    );
};

ViewCourseModal.propTypes = {
    courseDetails: _propTypes2.default.object,
    hideCourseDetails: _propTypes2.default.func.isRequired,
    intl: _reactIntl.intlShape.isRequired
};

exports.default = (0, _withModal2.default)('show')((0, _reactIntl.injectIntl)(ViewCourseModal));

/***/ }),
/* 733 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactStyleable = __webpack_require__(6);

var _reactStyleable2 = _interopRequireDefault(_reactStyleable);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactIntl = __webpack_require__(2);

var _messages = __webpack_require__(389);

var _messages2 = _interopRequireDefault(_messages);

var _index = __webpack_require__(594);

var _index2 = _interopRequireDefault(_index);

var _index3 = __webpack_require__(690);

var _index4 = _interopRequireDefault(_index3);

var _viewCourse = __webpack_require__(734);

var _viewCourse2 = _interopRequireDefault(_viewCourse);

var _withLoader = __webpack_require__(262);

var _withLoader2 = _interopRequireDefault(_withLoader);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ManageCourse = function (_PureComponent) {
    _inherits(ManageCourse, _PureComponent);

    function ManageCourse() {
        _classCallCheck(this, ManageCourse);

        return _possibleConstructorReturn(this, (ManageCourse.__proto__ || Object.getPrototypeOf(ManageCourse)).apply(this, arguments));
    }

    _createClass(ManageCourse, [{
        key: 'render',
        value: function render() {
            var _props = this.props,
                intl = _props.intl,
                isDefaultCoursesLoaded = _props.isDefaultCoursesLoaded,
                defaultCourses = _props.defaultCourses,
                savingDefaultCourses = _props.savingDefaultCourses,
                handleOnSave = _props.handleOnSave,
                showCourseDetails = _props.showCourseDetails,
                hideCourseDetails = _props.hideCourseDetails,
                isCourseModalVisible = _props.isCourseModalVisible,
                courseDetails = _props.courseDetails,
                selectedProduct = _props.selectedProduct,
                deselectCourses = _props.deselectCourses,
                upfCourses = _props.upfCourses,
                conquestCourses = _props.conquestCourses;

            var mapperProps = {
                showCourseDetails: showCourseDetails
            };

            var content = !isDefaultCoursesLoaded ? _react2.default.createElement('div', null) : _react2.default.createElement(
                'div',
                null,
                _react2.default.createElement(
                    'div',
                    null,
                    _react2.default.createElement(_index4.default, _extends({
                        conquestCourses: conquestCourses,
                        defaultCourses: defaultCourses,
                        deselectCourses: deselectCourses,
                        handleOnSave: handleOnSave,
                        savingDefaultCourses: savingDefaultCourses,
                        selectedProduct: selectedProduct,
                        upfCourses: upfCourses
                    }, mapperProps)),
                    _react2.default.createElement(_viewCourse2.default, {
                        courseDetails: courseDetails,
                        onClose: hideCourseDetails,
                        show: isCourseModalVisible })
                )
            );

            return _react2.default.createElement(
                'div',
                null,
                _react2.default.createElement(
                    'div',
                    { className: _index2.default.header },
                    _react2.default.createElement(
                        'div',
                        { className: _index2.default.mainHeading },
                        _react2.default.createElement(
                            'div',
                            { className: _index2.default.title },
                            intl.formatMessage(_messages2.default.pageTitle)
                        )
                    ),
                    _react2.default.createElement(
                        'div',
                        { className: _index2.default.subHeading },
                        _react2.default.createElement(
                            'span',
                            null,
                            ' ',
                            intl.formatMessage(_messages2.default.pageSubTitle),
                            ' '
                        )
                    )
                ),
                content
            );
        }
    }]);

    return ManageCourse;
}(_react.PureComponent);

ManageCourse.propTypes = {
    intl: _reactIntl.intlShape.isRequired,
    isDefaultCoursesLoaded: _propTypes2.default.bool,
    defaultCourses: _propTypes2.default.arrayOf(_propTypes2.default.object),
    savingDefaultCourses: _propTypes2.default.bool,
    handleOnSave: _propTypes2.default.func,
    selectedProduct: _propTypes2.default.object,
    showCourseDetails: _propTypes2.default.func,
    hideCourseDetails: _propTypes2.default.func,
    isCourseModalVisible: _propTypes2.default.bool,
    courseDetails: _propTypes2.default.object,
    deselectCourses: _propTypes2.default.func,
    upfCourses: _propTypes2.default.arrayOf(_propTypes2.default.object),
    conquestCourses: _propTypes2.default.arrayOf(_propTypes2.default.object)
};

ManageCourse.defaultProps = {
    upfCourses: []
};

var ManageCourseWithDataLoader = (0, _withLoader2.default)('fetching')(ManageCourse);
exports.default = (0, _reactIntl.injectIntl)((0, _reactStyleable2.default)(_index2.default)(ManageCourseWithDataLoader));

/***/ }),
/* 734 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactIntl = __webpack_require__(2);

var _index = __webpack_require__(594);

var _index2 = _interopRequireDefault(_index);

var _courseTopics = __webpack_require__(1717);

var _courseTopics2 = _interopRequireDefault(_courseTopics);

var _withModal = __webpack_require__(49);

var _withModal2 = _interopRequireDefault(_withModal);

var _courseTopicsDetails = __webpack_require__(384);

var _courseTopicsDetails2 = _interopRequireDefault(_courseTopicsDetails);

var _button = __webpack_require__(7);

var _button2 = _interopRequireDefault(_button);

var _variants = __webpack_require__(9);

var _messages = __webpack_require__(389);

var _messages2 = _interopRequireDefault(_messages);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ViewCourseModal = function ViewCourseModal(_ref) {
    var courseDetails = _ref.courseDetails,
        intl = _ref.intl,
        onClose = _ref.onClose;
    return _react2.default.createElement(
        'div',
        { className: _index2.default.courseDetailModal },
        _react2.default.createElement(
            'div',
            { className: _index2.default.courseDetailContent },
            _react2.default.createElement(_courseTopicsDetails2.default, { course: courseDetails, css: _courseTopics2.default })
        ),
        _react2.default.createElement(
            'div',
            { className: _index2.default.courseDetailFooter },
            _react2.default.createElement(_button2.default, {
                handleOnClick: onClose,
                label: intl.formatMessage(_messages2.default.backButton),
                variant: _variants.DARK
            })
        )
    );
};

ViewCourseModal.propTypes = {
    courseDetails: _propTypes2.default.object,
    onClose: _propTypes2.default.func,
    intl: _reactIntl.intlShape.isRequired
};

exports.default = (0, _withModal2.default)('show')((0, _reactIntl.injectIntl)(ViewCourseModal));

/***/ }),
/* 735 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactStyleable = __webpack_require__(6);

var _reactStyleable2 = _interopRequireDefault(_reactStyleable);

var _reactIntl = __webpack_require__(2);

var _index = __webpack_require__(1720);

var _index2 = _interopRequireDefault(_index);

var _index3 = __webpack_require__(7);

var _index4 = _interopRequireDefault(_index3);

var _iconDictionary = __webpack_require__(8);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var NewCourseLabel = function (_PureComponent) {
    _inherits(NewCourseLabel, _PureComponent);

    function NewCourseLabel() {
        _classCallCheck(this, NewCourseLabel);

        return _possibleConstructorReturn(this, (NewCourseLabel.__proto__ || Object.getPrototypeOf(NewCourseLabel)).apply(this, arguments));
    }

    _createClass(NewCourseLabel, [{
        key: 'render',
        value: function render() {
            var _props = this.props,
                showCancel = _props.showCancel,
                label = _props.label,
                handleOnView = _props.handleOnView,
                handleOnCancel = _props.handleOnCancel,
                hideButton = _props.hideButton;

            var cancelButton = showCancel === false ? '' : _react2.default.createElement(
                'div',
                {
                    className: _index2.default.spacing,
                    onClick: handleOnCancel,
                    role: 'button',
                    tabIndex: 0 },
                _react2.default.createElement(_index4.default, {
                    containerClassName: _index2.default.cancel,
                    icon: _iconDictionary.Cross,
                    iconClassName: _index2.default.svgIconContainer
                })
            );
            return _react2.default.createElement(
                'div',
                { className: _index2.default.container },
                _react2.default.createElement(
                    'div',
                    { className: _index2.default.label },
                    label
                ),
                _react2.default.createElement(
                    'div',
                    { className: _index2.default.buttonWrapper },
                    hideButton ? null : _react2.default.createElement(
                        'div',
                        {
                            className: _index2.default.spacing,
                            onClick: handleOnView,
                            role: 'button',
                            tabIndex: 0 },
                        _react2.default.createElement(_index4.default, {
                            containerClassName: _index2.default.view,
                            icon: _iconDictionary.View,
                            iconClassName: _index2.default.svgIconContainer
                        })
                    ),
                    cancelButton
                )
            );
        }
    }]);

    return NewCourseLabel;
}(_react.PureComponent);

NewCourseLabel.propTypes = {
    label: _propTypes2.default.string,
    showCancel: _propTypes2.default.bool,
    handleOnView: _propTypes2.default.func,
    handleOnCancel: _propTypes2.default.func,
    hideButton: _propTypes2.default.bool
};

exports.default = (0, _reactIntl.injectIntl)((0, _reactStyleable2.default)(_index2.default)(NewCourseLabel));

/***/ }),
/* 736 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactStyleable = __webpack_require__(6);

var _reactStyleable2 = _interopRequireDefault(_reactStyleable);

var _reactIntl = __webpack_require__(2);

var _index = __webpack_require__(7);

var _index2 = _interopRequireDefault(_index);

var _iconDictionary = __webpack_require__(8);

var _index3 = __webpack_require__(717);

var _index4 = _interopRequireDefault(_index3);

var _messages = __webpack_require__(737);

var _messages2 = _interopRequireDefault(_messages);

var _index5 = __webpack_require__(1721);

var _index6 = _interopRequireDefault(_index5);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Upload = function Upload(_ref) {
    var isUploading = _ref.isUploading,
        downloadingQuickUploadTemplate = _ref.downloadingQuickUploadTemplate,
        handleOnDownloadTemplate = _ref.handleOnDownloadTemplate,
        handleOnUploadClick = _ref.handleOnUploadClick,
        productName = _ref.productName,
        intl = _ref.intl;
    return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
            'div',
            { className: _index6.default.header },
            _react2.default.createElement(
                'div',
                { className: _index6.default.title },
                intl.formatMessage(_messages2.default.header)
            )
        ),
        _react2.default.createElement(
            'div',
            { className: _index6.default.subTitle },
            intl.formatMessage(_messages2.default.subTitle),
            ' ',
            productName
        ),
        _react2.default.createElement(
            'div',
            { className: _index6.default.content },
            _react2.default.createElement(
                'div',
                { className: _index6.default.contentWrapper },
                _react2.default.createElement(
                    'div',
                    { className: _index6.default.contentLabel },
                    intl.formatMessage(_messages2.default.contentLabel),
                    ' ',
                    productName
                ),
                _react2.default.createElement(
                    'div',
                    null,
                    _react2.default.createElement(_index2.default, {
                        containerClassName: _index6.default.downloadStudentRoll,
                        handleOnClick: handleOnDownloadTemplate,
                        icon: _iconDictionary.Download,
                        iconClassName: _index6.default.svgIconContainer,
                        label: intl.formatMessage(_messages2.default.downloadTemplate),
                        loading: downloadingQuickUploadTemplate,
                        loadingLabel: intl.formatMessage(_messages2.default.download) })
                ),
                _react2.default.createElement('div', { className: _index6.default.line }),
                _react2.default.createElement(_index4.default, { handleOnUploadClick: handleOnUploadClick, isUploading: isUploading })
            )
        )
    );
};

Upload.propTypes = {
    handleOnUploadClick: _propTypes2.default.func,
    handleOnDownloadTemplate: _propTypes2.default.func,
    downloadingQuickUploadTemplate: _propTypes2.default.bool,
    isUploading: _propTypes2.default.bool,
    productName: _propTypes2.default.string,
    intl: _reactIntl.intlShape.isRequired
};

exports.default = (0, _reactIntl.injectIntl)((0, _reactStyleable2.default)(_index6.default)(Upload));

/***/ }),
/* 737 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _reactIntl = __webpack_require__(2);

exports.default = (0, _reactIntl.defineMessages)({
    downloadTemplate: {
        id: 'quick-upload.components.downloadStudentRoll',
        defaultMessage: 'Download template'
    },
    download: {
        id: 'quick-upload.components.download',
        defaultMessage: 'Downloading'
    },
    header: {
        id: 'quick-upload.components.header',
        defaultMessage: 'Quick upload'
    },
    subTitle: {
        id: 'student-header.components.subTitle',
        defaultMessage: 'Quick upload for'
    },
    contentLabel: {
        id: 'student-header.components.contentLabel',
        defaultMessage: 'Use the link below to download the template for uploading new students into'

    }
});

/***/ }),
/* 738 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactStyleable = __webpack_require__(6);

var _reactStyleable2 = _interopRequireDefault(_reactStyleable);

var _reactIntl = __webpack_require__(2);

var _index = __webpack_require__(48);

var _index2 = _interopRequireDefault(_index);

var _index3 = __webpack_require__(1723);

var _index4 = _interopRequireDefault(_index3);

var _messages = __webpack_require__(739);

var _messages2 = _interopRequireDefault(_messages);

var _iconDictionary = __webpack_require__(8);

var _index5 = __webpack_require__(7);

var _index6 = _interopRequireDefault(_index5);

var _index7 = __webpack_require__(382);

var _index8 = _interopRequireDefault(_index7);

var _index9 = __webpack_require__(36);

var _index10 = _interopRequireDefault(_index9);

var _variants = __webpack_require__(9);

var _withModal = __webpack_require__(49);

var _withModal2 = _interopRequireDefault(_withModal);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var RenameGroup = function (_Component) {
    _inherits(RenameGroup, _Component);

    function RenameGroup(props) {
        _classCallCheck(this, RenameGroup);

        var _this = _possibleConstructorReturn(this, (RenameGroup.__proto__ || Object.getPrototypeOf(RenameGroup)).call(this, props));

        _this.validateModel = function () {
            if (_this.newName !== '') {
                if (_this.props.isRenameGroupInProgress) {
                    _this.setState({ canSubmit: false });
                } else {
                    _this.setState({ canSubmit: true });
                }
            } else {
                _this.setState({ canSubmit: false });
            }
        };

        _this.handleTextInputOnChange = function (event) {
            _this.newName = event.target.value;
            _this.validateModel();
        };

        _this.handleOnOk = function () {
            _this.setState({ canSubmit: false });
            _this.props.handleOnOk(_this.newName.trim());
        };

        _this.handleOnCloseRenameGroupConfirmationBeforeSubmit = function () {
            _this.props.handleOnCancelRenameGroupConfirmationBeforeSubmit();
            _this.props.handleOnCloseRenameGroupModal();
        };

        _this.state = {
            canSubmit: false
        };
        _this.oldName = _this.props.selectedGroup.name;

        if (_this.props.selectedGroup.isDefault) {
            var groupLength = _this.props.selectedGroup.name.length;
            var defaultGroupIndicator = _this.props.selectedGroup.name.substr(groupLength - 2, 2);

            if (defaultGroupIndicator === ' *') {
                _this.oldName = _this.props.selectedGroup.name.slice(0, -2);
            }
        }

        _this.newName = _this.oldName;
        _this.handleTextInputOnChange = _this.handleTextInputOnChange.bind(_this);
        _this.handleOnOk = _this.handleOnOk.bind(_this);
        _this.handleOnCloseRenameGroupConfirmationBeforeSubmit = _this.handleOnCloseRenameGroupConfirmationBeforeSubmit.bind(_this);
        return _this;
    }

    _createClass(RenameGroup, [{
        key: 'render',
        value: function render() {
            var renameGroupComponent = _react2.default.createElement(
                'div',
                { className: _index4.default.renameGroupComponent },
                _react2.default.createElement(
                    'div',
                    {
                        className: _index4.default.renameGroupHeader },
                    ' ',
                    this.props.intl.formatMessage(_messages2.default.renameGroup),
                    ' '
                ),
                _react2.default.createElement(
                    'div',
                    { className: _index4.default.groupName },
                    _react2.default.createElement(_index2.default, {
                        disabled: this.props.isRenameGroupInProgress,
                        handleOnChange: this.handleTextInputOnChange,
                        maxLength: 50,
                        name: 'name',
                        placeholder: this.props.intl.formatMessage(_messages2.default.groupNameLabel),
                        value: this.newName
                    })
                ),
                _react2.default.createElement(
                    'div',
                    { className: _index4.default.actionButtonWrapper },
                    _react2.default.createElement(_index6.default, {
                        containerClassName: _index4.default.btnDanger,
                        disabled: this.props.isRenameGroupInProgress,
                        handleOnClick: this.props.handleOnCancelRenameGroupModal,
                        icon: _iconDictionary.Cross,
                        iconClassName: _index4.default.svgIconContainer
                    }),
                    _react2.default.createElement(_index6.default, {
                        containerClassName: _index4.default.btnSuccess,
                        disabled: !this.state.canSubmit,
                        handleOnClick: this.handleOnOk,
                        icon: _iconDictionary.Tick,
                        iconClassName: _index4.default.svgIconContainer
                    })
                ),
                _react2.default.createElement(_index6.default, {
                    containerClassName: _index4.default.buttonClose,
                    disabled: this.props.isRenameGroupInProgress,
                    handleOnClick: this.props.handleOnCloseRenameGroupModal,
                    icon: _iconDictionary.Cross,
                    variant: _variants.ICON_ONLY })
            );

            var modalComponent = '';

            if (this.props.showRenameGroupConfirmationBeforeSubmit) {
                modalComponent = _react2.default.createElement(
                    _index8.default,
                    {
                        handleOnCancel: this.props.handleOnCancelRenameGroupConfirmationBeforeSubmit,
                        handleOnClose: this.handleOnCloseRenameGroupConfirmationBeforeSubmit,
                        handleOnOk: this.props.handleOnRenameGroup,
                        isLoading: this.props.isRenameGroupInProgress },
                    this.props.intl.formatMessage(_messages2.default.doYouWishTo),
                    _react2.default.createElement(
                        'span',
                        { className: _index4.default.highlight },
                        ' ',
                        this.oldName,
                        ' '
                    ),
                    this.props.intl.formatMessage(_messages2.default.to),
                    _react2.default.createElement(
                        'span',
                        { className: _index4.default.highlight },
                        ' ',
                        this.newName,
                        ' '
                    ),
                    this.props.intl.formatMessage(_messages2.default.questionMark)
                );
            }

            if (this.props.showRenameGroupConfirmationModal) {
                modalComponent = _react2.default.createElement(
                    _index10.default,
                    {
                        handleOnCloseModal: this.props.handleOnCloseRenameGroupConfirmation,
                        icon: _iconDictionary.Tick },
                    this.props.intl.formatMessage(_messages2.default.renameGroupConfirmation)
                );
            }

            var componentToRender = this.props.showRenameGroupConfirmationBeforeSubmit || this.props.showRenameGroupConfirmationModal ? modalComponent : renameGroupComponent;

            return _react2.default.createElement(
                'div',
                null,
                componentToRender
            );
        }
    }]);

    return RenameGroup;
}(_react.Component);

RenameGroup.propTypes = {
    selectedGroup: _propTypes2.default.object,
    isRenameGroupInProgress: _propTypes2.default.bool,
    handleOnOk: _propTypes2.default.func,
    handleOnCloseRenameGroupModal: _propTypes2.default.func,
    handleOnCancelRenameGroupModal: _propTypes2.default.func,
    showRenameGroupConfirmationBeforeSubmit: _propTypes2.default.bool,
    handleOnCancelRenameGroupConfirmationBeforeSubmit: _propTypes2.default.func,
    handleOnRenameGroup: _propTypes2.default.func,
    showRenameGroupConfirmationModal: _propTypes2.default.bool,
    handleOnCloseRenameGroupConfirmation: _propTypes2.default.func,
    intl: _reactIntl.intlShape.isRequired
};

var StyledRenameGroup = (0, _reactIntl.injectIntl)((0, _reactStyleable2.default)(_index4.default)(RenameGroup));
exports.default = (0, _withModal2.default)('isActive')(StyledRenameGroup);

/***/ }),
/* 739 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _reactIntl = __webpack_require__(2);

exports.default = (0, _reactIntl.defineMessages)({
    renameGroup: {
        id: 'app.components.RenameGroup.renameGroup',
        defaultMessage: 'Rename your group'
    },
    groupNameLabel: {
        id: 'app.components.RenameGroup.groupNameLabel',
        defaultMessage: 'Group Name'
    },
    renameGroupConfirmation: {
        id: 'app.components.RenameGroup.renameGroupConfirmation',
        defaultMessage: 'Your group has been renamed.'
    },
    doYouWishTo: {
        id: 'app.components.RenameGroup.doYouWishTo',
        defaultMessage: 'Do you wish to rename the group'
    },
    to: {
        id: 'app.components.RenameGroup.to',
        defaultMessage: 'to'
    },
    questionMark: {
        id: 'app.components.RenameGroup.questionMark',
        defaultMessage: '?'
    }
});

/***/ }),
/* 740 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactDataGrid = __webpack_require__(178);

var _constants = __webpack_require__(256);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ClassRowRenderer = function (_PureComponent) {
    _inherits(ClassRowRenderer, _PureComponent);

    function ClassRowRenderer() {
        _classCallCheck(this, ClassRowRenderer);

        return _possibleConstructorReturn(this, (ClassRowRenderer.__proto__ || Object.getPrototypeOf(ClassRowRenderer)).apply(this, arguments));
    }

    _createClass(ClassRowRenderer, [{
        key: 'setScrollLeft',
        value: function setScrollLeft(scrollBy) {
            // if you want freeze columns to work, you need to make sure you implement this as apass through
            this.row.setScrollLeft(scrollBy);
        }
    }, {
        key: 'getComponentReference',
        value: function getComponentReference(currentComponent) {
            this.row = currentComponent;
        }
    }, {
        key: 'render',
        value: function render() {
            var _this2 = this;

            var height = this.props.row.teachersCount > 3 ? this.props.row.teachersCount * _constants.CLASS_GRID_TEACHER_NAME_HEIGHT + _constants.ROW_BUFFER : _constants.CLASS_GRID_ROW_HEIGHT;

            return _react2.default.createElement(_reactDataGrid.Row, _extends({ ref: function ref(node) {
                    return _this2.getComponentReference(node);
                } }, this.props, { height: height }));
        }
    }]);

    return ClassRowRenderer;
}(_react.PureComponent);

ClassRowRenderer.propTypes = {
    row: _propTypes2.default.object
};
exports.default = ClassRowRenderer;

/***/ }),
/* 741 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactDataGrid = __webpack_require__(178);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var RollOverRowRenderer = function (_PureComponent) {
    _inherits(RollOverRowRenderer, _PureComponent);

    function RollOverRowRenderer() {
        _classCallCheck(this, RollOverRowRenderer);

        return _possibleConstructorReturn(this, (RollOverRowRenderer.__proto__ || Object.getPrototypeOf(RollOverRowRenderer)).apply(this, arguments));
    }

    _createClass(RollOverRowRenderer, [{
        key: 'setScrollLeft',
        value: function setScrollLeft(scrollBy) {
            // if you want freeze columns to work, you need to make sure you implement this as apass through
            this.row.setScrollLeft(scrollBy);
        }
    }, {
        key: 'getComponentReference',
        value: function getComponentReference(currentComponent) {
            this.row = currentComponent;
        }
    }, {
        key: 'render',
        value: function render() {
            var _this2 = this;

            var height = this.props.row.length * 23;
            return _react2.default.createElement(_reactDataGrid.Row, _extends({ ref: function ref(node) {
                    return _this2.getComponentReference(node);
                } }, this.props, { height: height }));
        }
    }]);

    return RollOverRowRenderer;
}(_react.PureComponent);

RollOverRowRenderer.propTypes = {
    row: _propTypes2.default.object
};
exports.default = RollOverRowRenderer;

/***/ }),
/* 742 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactDataGrid = __webpack_require__(178);

var _constants = __webpack_require__(256);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var StudentRowRenderer = function (_PureComponent) {
    _inherits(StudentRowRenderer, _PureComponent);

    function StudentRowRenderer() {
        _classCallCheck(this, StudentRowRenderer);

        return _possibleConstructorReturn(this, (StudentRowRenderer.__proto__ || Object.getPrototypeOf(StudentRowRenderer)).apply(this, arguments));
    }

    _createClass(StudentRowRenderer, [{
        key: 'setScrollLeft',
        value: function setScrollLeft(scrollBy) {
            // if you want freeze columns to work, you need to make sure you implement this as apass through
            this.row.setScrollLeft(scrollBy);
        }
    }, {
        key: 'getComponentReference',
        value: function getComponentReference(currentComponent) {
            this.row = currentComponent;
        }
    }, {
        key: 'render',
        value: function render() {
            var _this2 = this;

            var height = this.props.row.classesCount * _constants.CLASS_GRID_TEACHER_NAME_HEIGHT + _constants.ROW_BUFFER;
            return _react2.default.createElement(_reactDataGrid.Row, _extends({ ref: function ref(node) {
                    return _this2.getComponentReference(node);
                } }, this.props, { height: height }));
        }
    }]);

    return StudentRowRenderer;
}(_react.PureComponent);

StudentRowRenderer.propTypes = {
    row: _propTypes2.default.object
};
exports.default = StudentRowRenderer;

/***/ }),
/* 743 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactDataGrid = __webpack_require__(178);

var _constants = __webpack_require__(256);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var TeacherRowRenderer = function (_PureComponent) {
    _inherits(TeacherRowRenderer, _PureComponent);

    function TeacherRowRenderer() {
        _classCallCheck(this, TeacherRowRenderer);

        return _possibleConstructorReturn(this, (TeacherRowRenderer.__proto__ || Object.getPrototypeOf(TeacherRowRenderer)).apply(this, arguments));
    }

    _createClass(TeacherRowRenderer, [{
        key: 'setScrollLeft',
        value: function setScrollLeft(scrollBy) {
            // if you want freeze columns to work, you need to make sure you implement this as apass through
            this.row.setScrollLeft(scrollBy);
        }
    }, {
        key: 'getComponentReference',
        value: function getComponentReference(currentComponent) {
            this.row = currentComponent;
        }
    }, {
        key: 'render',
        value: function render() {
            var _this2 = this;

            var height = this.props.row.classesCount * _constants.CLASS_GRID_TEACHER_NAME_HEIGHT + _constants.ROW_BUFFER;

            return _react2.default.createElement(_reactDataGrid.Row, _extends({ ref: function ref(node) {
                    return _this2.getComponentReference(node);
                } }, this.props, { height: height }));
        }
    }]);

    return TeacherRowRenderer;
}(_react.PureComponent);

TeacherRowRenderer.propTypes = {
    row: _propTypes2.default.object
};
exports.default = TeacherRowRenderer;

/***/ }),
/* 744 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactStyleable = __webpack_require__(6);

var _reactStyleable2 = _interopRequireDefault(_reactStyleable);

var _initial = __webpack_require__(749);

var _initial2 = _interopRequireDefault(_initial);

var _selection = __webpack_require__(750);

var _selection2 = _interopRequireDefault(_selection);

var _help = __webpack_require__(747);

var _help2 = _interopRequireDefault(_help);

var _error = __webpack_require__(746);

var _error2 = _interopRequireDefault(_error);

var _upload = __webpack_require__(752);

var _upload2 = _interopRequireDefault(_upload);

var _confirmation = __webpack_require__(745);

var _confirmation2 = _interopRequireDefault(_confirmation);

var _results = __webpack_require__(748);

var _results2 = _interopRequireDefault(_results);

var _summary = __webpack_require__(751);

var _summary2 = _interopRequireDefault(_summary);

var _index = __webpack_require__(92);

var _index2 = _interopRequireDefault(_index);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var RollOver = function RollOver(props) {
    var helpModal = props.helpModal,
        selectionPage = props.selectionPage,
        uploadPage = props.uploadPage,
        initialPage = props.initialPage,
        summaryPage = props.summaryPage;


    var component = void 0;

    if (selectionPage) {
        component = _react2.default.createElement(_selection2.default, props);
    } else if (initialPage) {
        component = _react2.default.createElement(_initial2.default, props);
    } else if (uploadPage) {
        component = _react2.default.createElement(_upload2.default, props);
    } else if (summaryPage) {
        component = _react2.default.createElement(_summary2.default, props);
    }

    return _react2.default.createElement(
        'div',
        { className: _index2.default.rollOverContainer },
        component,
        _react2.default.createElement(_help2.default, _extends({ isActive: helpModal }, props)),
        _react2.default.createElement(_error2.default, props),
        _react2.default.createElement(_confirmation2.default, props),
        _react2.default.createElement(_results2.default, props)
    );
};

RollOver.propTypes = {
    helpModal: _propTypes2.default.bool,
    selectionPage: _propTypes2.default.bool,
    uploadPage: _propTypes2.default.bool,
    initialPage: _propTypes2.default.bool,
    showUploadModal: _propTypes2.default.bool,
    message: _propTypes2.default.object,
    closeModal: _propTypes2.default.func,
    closeUploadErrorModal: _propTypes2.default.func,
    summaryPage: _propTypes2.default.bool
};

exports.default = (0, _reactStyleable2.default)(_index2.default)(RollOver);

/***/ }),
/* 745 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactStyleable = __webpack_require__(6);

var _reactStyleable2 = _interopRequireDefault(_reactStyleable);

var _reactIntl = __webpack_require__(2);

var _index = __webpack_require__(24);

var _index2 = _interopRequireDefault(_index);

var _iconDictionary = __webpack_require__(8);

var _svgIcon = __webpack_require__(21);

var _svgIcon2 = _interopRequireDefault(_svgIcon);

var _index3 = __webpack_require__(7);

var _index4 = _interopRequireDefault(_index3);

var _index5 = __webpack_require__(92);

var _index6 = _interopRequireDefault(_index5);

var _variants = __webpack_require__(9);

var _messages = __webpack_require__(93);

var _messages2 = _interopRequireDefault(_messages);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var RollOverConfirmation = function RollOverConfirmation(props) {
    var showRollOverConfirmation = props.showRollOverConfirmation,
        intl = props.intl,
        closeRollOverConfirmation = props.closeRollOverConfirmation,
        rolloverType = props.rolloverType,
        onRollOverConfirmationRequest = props.onRollOverConfirmationRequest,
        selectedProduct = props.selectedProduct,
        rolloverItems = props.rolloverItems,
        isPerformingRollOver = props.isPerformingRollOver;


    var rolloverMessage = rolloverType === 'FullRollover' ? intl.formatMessage(_messages2.default.fullRollOver) : intl.formatMessage(_messages2.default.partialRollOver);
    return _react2.default.createElement(
        _index2.default,
        { show: showRollOverConfirmation },
        _react2.default.createElement(
            'div',
            { className: _index6.default.confirmationContainer },
            _react2.default.createElement(
                'div',
                { className: _index6.default.icon },
                _react2.default.createElement(_svgIcon2.default, { icon: _iconDictionary.Warning })
            ),
            _react2.default.createElement(
                'div',
                { className: _index6.default.confirmTitle },
                intl.formatMessage(_messages2.default.aboutToProceed),
                ' ',
                rolloverMessage
            ),
            _react2.default.createElement(
                'div',
                { className: _index6.default.confirmTitle },
                intl.formatMessage(_messages2.default.areYouSure)
            ),
            _react2.default.createElement(
                'div',
                { className: _index6.default.confirmBtnContainer },
                _react2.default.createElement(_index4.default, {
                    disabled: isPerformingRollOver,
                    handleOnClick: closeRollOverConfirmation,
                    label: intl.formatMessage(_messages2.default.cancel),
                    variant: _variants.DARK }),
                _react2.default.createElement(_index4.default, {
                    disabled: isPerformingRollOver,
                    handleOnClick: function handleOnClick() {
                        return onRollOverConfirmationRequest(rolloverType, selectedProduct.id, rolloverItems);
                    },
                    label: intl.formatMessage(_messages2.default.proceed),
                    variant: _variants.DARK })
            )
        )
    );
};

RollOverConfirmation.propTypes = {
    showRollOverConfirmation: _propTypes2.default.bool,
    intl: _reactIntl.intlShape.isRequired,
    closeRollOverConfirmation: _propTypes2.default.func,
    rolloverType: _propTypes2.default.string,
    onRollOverConfirmationRequest: _propTypes2.default.func,
    selectedProduct: _propTypes2.default.object,
    rolloverItems: _propTypes2.default.array,
    isPerformingRollOver: _propTypes2.default.bool
};

exports.default = (0, _reactIntl.injectIntl)((0, _reactStyleable2.default)(_index6.default)(RollOverConfirmation));

/***/ }),
/* 746 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _uniqueId = __webpack_require__(175);

var _uniqueId2 = _interopRequireDefault(_uniqueId);

var _reactIntl = __webpack_require__(2);

var _index = __webpack_require__(24);

var _index2 = _interopRequireDefault(_index);

var _index3 = __webpack_require__(36);

var _index4 = _interopRequireDefault(_index3);

var _index5 = __webpack_require__(259);

var _index6 = _interopRequireDefault(_index5);

var _iconDictionary = __webpack_require__(8);

var _messages = __webpack_require__(93);

var _messages2 = _interopRequireDefault(_messages);

var _index7 = __webpack_require__(92);

var _index8 = _interopRequireDefault(_index7);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var RollOverError = function RollOverError(props) {
    var closeUploadErrorModal = props.closeUploadErrorModal,
        message = props.message,
        showUploadModal = props.showUploadModal,
        intl = props.intl,
        validationErrors = props.validationErrors,
        showDataGrid = props.showDataGrid,
        isServerError = props.isServerError,
        fileSize = props.fileSize;


    var errorView = _react2.default.createElement('div', null);

    var GenerateErrorRow = function GenerateErrorRow(errors) {
        var errorMessages = [];

        errorMessages = errors.map(function (error) {
            return _react2.default.createElement(
                'div',
                { className: _index8.default.rowNumber, key: (0, _uniqueId2.default)('UploadValidationMessages') },
                intl.formatMessage(_messages2.default.row),
                '\xA0',
                error.rowReference,
                _react2.default.createElement(
                    'div',
                    { className: _index8.default.message },
                    error.message
                )
            );
        });

        return errorMessages;
    };

    if (!showDataGrid) {
        if (validationErrors.length) {
            errorView = _react2.default.createElement(
                _index6.default,
                {
                    handleOnBack: closeUploadErrorModal,
                    icon: _iconDictionary.Warning,
                    message: intl.formatMessage(_messages2.default.errorsInYourFile),
                    rollOverValidationPage: true },
                GenerateErrorRow(validationErrors)
            );
        } else {
            if (isServerError) {
                message.header = intl.formatMessage(_messages2.default.somethingWentWrong);
                message.body = intl.formatMessage(_messages2.default.pleaseTryUploadingAgain);
            } else if (fileSize > 1) {
                message.header = intl.formatMessage(_messages2.default.fileSizeMessage);
                message.body = '';
            }

            errorView = _react2.default.createElement(
                _index4.default,
                {
                    handleOnCloseModal: closeUploadErrorModal,
                    icon: _iconDictionary.Warning,
                    title: message.header },
                message.body
            );
        }
    }

    return _react2.default.createElement(
        _index2.default,
        { show: showUploadModal },
        errorView
    );
};

RollOverError.propTypes = {
    intl: _reactIntl.intlShape.isRequired,
    closeUploadErrorModal: _propTypes2.default.func,
    message: _propTypes2.default.object,
    showUploadModal: _propTypes2.default.bool,
    validationErrors: _propTypes2.default.array,
    showDataGrid: _propTypes2.default.bool,
    isServerError: _propTypes2.default.bool,
    fileSize: _propTypes2.default.number
};

exports.default = (0, _reactIntl.injectIntl)(RollOverError);

/***/ }),
/* 747 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactStyleable = __webpack_require__(6);

var _reactStyleable2 = _interopRequireDefault(_reactStyleable);

var _reactIntl = __webpack_require__(2);

var _utils = __webpack_require__(13);

var _i18n = __webpack_require__(129);

var _messages = __webpack_require__(93);

var _messages2 = _interopRequireDefault(_messages);

var _index = __webpack_require__(92);

var _index2 = _interopRequireDefault(_index);

var _withModal = __webpack_require__(49);

var _withModal2 = _interopRequireDefault(_withModal);

var _index3 = __webpack_require__(7);

var _index4 = _interopRequireDefault(_index3);

var _variants = __webpack_require__(9);

var _iconDictionary = __webpack_require__(8);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* global window */
/* eslint react/no-danger: 0 */

var RollOverHelp = function RollOverHelp(props) {
    var downloadRolloverTemplate = props.downloadRolloverTemplate,
        downloadSchoolRollDataRollover = props.downloadSchoolRollDataRollover,
        hideHelpModal = props.hideHelpModal,
        intl = props.intl,
        isDownloadingSchoolRollData = props.isDownloadingSchoolRollData,
        isDownloadingTemplate = props.isDownloadingTemplate,
        selectedProduct = props.selectedProduct;


    var config = (0, _utils.getAppConfig)();
    var help = config ? config.RolloverHelpContent : '';

    var someHtml = '';

    if (help !== '' && (0, _i18n.getLocale)().substr(0, 2) === 'es' && JSON.parse(help).es) {
        someHtml = JSON.parse(help).es;
    } else if (help !== '' && JSON.parse(help).en) {
        someHtml = JSON.parse(help).en;
    } else {
        someHtml = help;
    }

    return _react2.default.createElement(
        'div',
        { className: _index2.default.rollOverModal },
        _react2.default.createElement(
            'div',
            { className: _index2.default.rollOverModalContent },
            _react2.default.createElement('div', { dangerouslySetInnerHTML: { __html: someHtml } }),
            _react2.default.createElement(_index4.default, {
                containerClassName: _index2.default.rollOverModalCloseBtn,
                handleOnClick: hideHelpModal,
                icon: _iconDictionary.Cross,
                label: intl.formatMessage(_messages2.default.closeButton),
                variant: _variants.ICON_ONLY })
        ),
        _react2.default.createElement(
            'div',
            { className: _index2.default.rollOverModalFooter },
            _react2.default.createElement(
                'div',
                { className: _index2.default.rollOverModalFooterLeft },
                _react2.default.createElement(_index4.default, {
                    disabled: isDownloadingTemplate,
                    handleOnClick: downloadRolloverTemplate,
                    label: intl.formatMessage(_messages2.default.downloadTemplateBtn),
                    variant: _variants.DARK }),
                _react2.default.createElement(_index4.default, {
                    disabled: isDownloadingSchoolRollData,
                    handleOnClick: function handleOnClick() {
                        downloadSchoolRollDataRollover(selectedProduct.id);
                    },
                    label: intl.formatMessage(_messages2.default.downloadSchoolDataBtn),
                    variant: _variants.DARK })
            ),
            _react2.default.createElement(
                'div',
                { className: _index2.default.rollOverModalFooterRight },
                _react2.default.createElement(_index4.default, {
                    handleOnClick: hideHelpModal,
                    label: intl.formatMessage(_messages2.default.closeButton),
                    variant: _variants.DARK })
            )
        )
    );
};

RollOverHelp.propTypes = {
    downloadSchoolRollDataRollover: _propTypes2.default.func,
    downloadRolloverTemplate: _propTypes2.default.func,
    hideHelpModal: _propTypes2.default.func,
    intl: _reactIntl.intlShape.isRequired,
    isDownloadingSchoolRollData: _propTypes2.default.bool,
    isDownloadingTemplate: _propTypes2.default.bool,
    selectedProduct: _propTypes2.default.object
};

var DownloadHelpIntl = (0, _reactIntl.injectIntl)((0, _reactStyleable2.default)(_index2.default)(RollOverHelp));
exports.default = (0, _withModal2.default)('isActive')(DownloadHelpIntl);

/***/ }),
/* 748 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactIntl = __webpack_require__(2);

var _uniqueId = __webpack_require__(175);

var _uniqueId2 = _interopRequireDefault(_uniqueId);

var _index = __webpack_require__(24);

var _index2 = _interopRequireDefault(_index);

var _iconDictionary = __webpack_require__(8);

var _index3 = __webpack_require__(259);

var _index4 = _interopRequireDefault(_index3);

var _messages = __webpack_require__(93);

var _messages2 = _interopRequireDefault(_messages);

var _index5 = __webpack_require__(92);

var _index6 = _interopRequireDefault(_index5);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var RollOverResult = function RollOverResult(props) {
    var isRolloverDone = props.isRolloverDone,
        intl = props.intl,
        rolloverSummary = props.rolloverSummary,
        onViewRollOverSummary = props.onViewRollOverSummary;


    var GenerateResultRow = function GenerateResultRow() {
        return _react2.default.createElement(
            'div',
            { className: _index6.default.resultContainer, key: (0, _uniqueId2.default)('rolloverResult') },
            intl.formatMessage(_messages2.default.rollOverHasCompleted),
            _react2.default.createElement(
                'div',
                { className: _index6.default.resultSection },
                _react2.default.createElement(
                    'div',
                    null,
                    ' ',
                    rolloverSummary.newStudents.length,
                    ' ',
                    intl.formatMessage(_messages2.default.newStudents)
                ),
                _react2.default.createElement(
                    'div',
                    null,
                    ' ',
                    rolloverSummary.updatedStudents.length,
                    ' ',
                    intl.formatMessage(_messages2.default.updatedStudents)
                ),
                _react2.default.createElement(
                    'div',
                    null,
                    ' ',
                    rolloverSummary.unassignedStudents.length,
                    ' ',
                    intl.formatMessage(_messages2.default.unassignedStudents)
                ),
                _react2.default.createElement(
                    'div',
                    null,
                    ' ',
                    rolloverSummary.transferredStudents.length,
                    ' ',
                    intl.formatMessage(_messages2.default.transferredStudents)
                )
            ),
            _react2.default.createElement(
                'div',
                { className: _index6.default.resultSection },
                _react2.default.createElement(
                    'div',
                    null,
                    ' ',
                    rolloverSummary.newTeachers.length,
                    ' ',
                    intl.formatMessage(_messages2.default.newTeachers)
                ),
                _react2.default.createElement(
                    'div',
                    null,
                    ' ',
                    rolloverSummary.updatedTeachers.length,
                    ' ',
                    intl.formatMessage(_messages2.default.updatedTeachers)
                )
            ),
            _react2.default.createElement(
                'div',
                { className: _index6.default.resultSection },
                _react2.default.createElement(
                    'div',
                    null,
                    ' ',
                    rolloverSummary.newClassrooms.length,
                    ' ',
                    intl.formatMessage(_messages2.default.newClasses)
                ),
                _react2.default.createElement(
                    'div',
                    null,
                    ' ',
                    rolloverSummary.updatedClassrooms.length,
                    ' ',
                    intl.formatMessage(_messages2.default.updatedClasses)
                )
            )
        );
    };

    return _react2.default.createElement(
        _index2.default,
        { show: isRolloverDone },
        _react2.default.createElement(
            _index4.default,
            {
                handleOnViewSummary: onViewRollOverSummary,
                icon: _iconDictionary.Tick,
                message: intl.formatMessage(_messages2.default.rolloverComplete),
                rollOverConfirmationPage: true },
            GenerateResultRow()
        )
    );
};

RollOverResult.propTypes = {
    intl: _reactIntl.intlShape.isRequired,
    isRolloverDone: _propTypes2.default.bool,
    rolloverSummary: _propTypes2.default.object,
    onViewRollOverSummary: _propTypes2.default.func
};

exports.default = (0, _reactIntl.injectIntl)(RollOverResult);

/***/ }),
/* 749 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactStyleable = __webpack_require__(6);

var _reactStyleable2 = _interopRequireDefault(_reactStyleable);

var _reactIntl = __webpack_require__(2);

var _index = __webpack_require__(7);

var _index2 = _interopRequireDefault(_index);

var _variants = __webpack_require__(9);

var _index3 = __webpack_require__(665);

var _index4 = _interopRequireDefault(_index3);

var _iconDictionary = __webpack_require__(8);

var _messages = __webpack_require__(93);

var _messages2 = _interopRequireDefault(_messages);

var _index5 = __webpack_require__(92);

var _index6 = _interopRequireDefault(_index5);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var RollOverInitial = function RollOverInitial(props) {
    var downloadSchoolRollDataRollover = props.downloadSchoolRollDataRollover,
        intl = props.intl,
        isDownloadingSchoolRollData = props.isDownloadingSchoolRollData,
        selectedProduct = props.selectedProduct,
        showHelpModal = props.showHelpModal,
        showSelectionPage = props.showSelectionPage,
        onIncludeUnassignedStudentsSelection = props.onIncludeUnassignedStudentsSelection,
        includeUnassignedStudents = props.includeUnassignedStudents,
        onIncludeBulkTransferSelection = props.onIncludeBulkTransferSelection,
        includeBulkTransfer = props.includeBulkTransfer;
    var productName = selectedProduct.name;


    return _react2.default.createElement(
        'div',
        { className: _index6.default.rollOverComponent },
        _react2.default.createElement(
            'div',
            { className: _index6.default.header },
            _react2.default.createElement(
                'div',
                { className: _index6.default.title },
                intl.formatMessage(_messages2.default.header)
            )
        ),
        _react2.default.createElement(
            'div',
            { className: _index6.default.content + ' ' + _index6.default.rollOverInitial },
            _react2.default.createElement(
                'div',
                { className: _index6.default.contentWrapper },
                _react2.default.createElement(
                    'div',
                    { className: _index6.default.contentLabel },
                    intl.formatMessage(_messages2.default.initialTitle, { productName: productName }),
                    _react2.default.createElement(_index2.default, {
                        buttonContainer: _index6.default.helpButtonContainer,
                        containerClassName: _index6.default.helpButton,
                        handleOnClick: showHelpModal,
                        label: intl.formatMessage(_messages2.default.buttonIcon)
                    })
                ),
                _react2.default.createElement(
                    'div',
                    { className: _index6.default.contentBody },
                    _react2.default.createElement(
                        'div',
                        { className: _index6.default.listContainer },
                        _react2.default.createElement(
                            'div',
                            { className: _index6.default.listItem },
                            _react2.default.createElement(
                                'span',
                                { className: _index6.default.listItemBullet },
                                '1'
                            ),
                            intl.formatMessage(_messages2.default.initialDownloadTemplate, { productName: productName }),
                            _react2.default.createElement(_index2.default, {
                                containerClassName: _index6.default.downloadButton,
                                disabled: isDownloadingSchoolRollData,
                                handleOnClick: function handleOnClick() {
                                    downloadSchoolRollDataRollover(selectedProduct.id, includeUnassignedStudents, includeBulkTransfer);
                                },
                                icon: _iconDictionary.Download,
                                variant: _variants.ICON_ONLY
                            })
                        ),
                        _react2.default.createElement(
                            'div',
                            { className: _index6.default.includeUnassigned },
                            _react2.default.createElement(_index4.default, {
                                onclick: onIncludeUnassignedStudentsSelection
                            }),
                            intl.formatMessage(_messages2.default.includeUnassigned)
                        ),
                        _react2.default.createElement(
                            'div',
                            { className: _index6.default.includeBulkTransfer },
                            _react2.default.createElement(_index4.default, {
                                onclick: onIncludeBulkTransferSelection
                            }),
                            intl.formatMessage(_messages2.default.includeBulkTransfer)
                        ),
                        _react2.default.createElement(
                            'div',
                            { className: _index6.default.listItem },
                            _react2.default.createElement(
                                'span',
                                { className: _index6.default.listItemBullet },
                                '2'
                            ),
                            intl.formatMessage(_messages2.default.initialUpdateSpreadsheet)
                        )
                    )
                )
            )
        ),
        _react2.default.createElement(
            'div',
            { className: _index6.default.rollOverFooter },
            _react2.default.createElement(_index2.default, {
                handleOnClick: showSelectionPage,
                label: intl.formatMessage(_messages2.default.nextButton),
                variant: _variants.DARK
            })
        )
    );
};

RollOverInitial.propTypes = {
    downloadSchoolRollDataRollover: _propTypes2.default.func,
    intl: _reactIntl.intlShape.isRequired,
    isDownloadingSchoolRollData: _propTypes2.default.bool,
    selectedProduct: _propTypes2.default.object,
    showHelpModal: _propTypes2.default.func,
    showSelectionPage: _propTypes2.default.func,
    onIncludeUnassignedStudentsSelection: _propTypes2.default.func,
    onIncludeBulkTransferSelection: _propTypes2.default.func,
    includeUnassignedStudents: _propTypes2.default.bool,
    includeBulkTransfer: _propTypes2.default.bool
};

exports.default = (0, _reactIntl.injectIntl)((0, _reactStyleable2.default)(_index6.default)(RollOverInitial));

/***/ }),
/* 750 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactStyleable = __webpack_require__(6);

var _reactStyleable2 = _interopRequireDefault(_reactStyleable);

var _reactIntl = __webpack_require__(2);

var _index = __webpack_require__(7);

var _index2 = _interopRequireDefault(_index);

var _variants = __webpack_require__(9);

var _messages = __webpack_require__(93);

var _messages2 = _interopRequireDefault(_messages);

var _index3 = __webpack_require__(92);

var _index4 = _interopRequireDefault(_index3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var RollOverSelection = function RollOverSelection(props) {
    var intl = props.intl,
        isFullRollover = props.isFullRollover,
        isPartialRollover = props.isPartialRollover,
        rollOverIsFull = props.rollOverIsFull,
        rollOverIsPartial = props.rollOverIsPartial,
        selectedProduct = props.selectedProduct,
        showHelpModal = props.showHelpModal,
        showInitialPage = props.showInitialPage,
        showUploadPage = props.showUploadPage;


    var isPartialActive = isPartialRollover ? _index4.default.rollOverPartialIsActive : '';
    var isFullActive = isFullRollover ? _index4.default.rollOverFullIsActive : '';
    return _react2.default.createElement(
        'div',
        { className: _index4.default.rollOverComponent },
        _react2.default.createElement(
            'div',
            { className: _index4.default.header },
            _react2.default.createElement(
                'div',
                { className: _index4.default.title },
                intl.formatMessage(_messages2.default.header)
            )
        ),
        _react2.default.createElement(
            'div',
            { className: _index4.default.content },
            _react2.default.createElement(
                'div',
                { className: _index4.default.contentWrapper },
                _react2.default.createElement(
                    'div',
                    { className: _index4.default.contentLabel },
                    intl.formatMessage(_messages2.default.selectionTitle),
                    ' ',
                    _react2.default.createElement(_index2.default, {
                        buttonContainer: _index4.default.helpButtonContainer,
                        containerClassName: _index4.default.helpButton,
                        handleOnClick: showHelpModal,
                        label: intl.formatMessage(_messages2.default.buttonIcon) })
                ),
                _react2.default.createElement(
                    'div',
                    { className: _index4.default.contentBody },
                    _react2.default.createElement(
                        'div',
                        { className: _index4.default.selectionContainer },
                        _react2.default.createElement(
                            _index2.default,
                            {
                                containerClassName: _index4.default.selectionItem + ' ' + isPartialActive,
                                handleOnClick: rollOverIsPartial },
                            _react2.default.createElement(
                                'div',
                                { className: _index4.default.selectionItemContent },
                                _react2.default.createElement(
                                    'h2',
                                    null,
                                    intl.formatMessage(_messages2.default.partialRolloverTitle)
                                ),
                                _react2.default.createElement(
                                    'p',
                                    null,
                                    intl.formatMessage(_messages2.default.partialRolloverDesc1, { productName: selectedProduct.name })
                                ),
                                _react2.default.createElement(
                                    'p',
                                    null,
                                    intl.formatMessage(_messages2.default.partialRolloverDesc2)
                                )
                            )
                        ),
                        _react2.default.createElement(
                            _index2.default,
                            {
                                containerClassName: _index4.default.selectionItem + ' ' + isFullActive,
                                handleOnClick: rollOverIsFull },
                            _react2.default.createElement(
                                'div',
                                { className: _index4.default.selectionItemContent },
                                _react2.default.createElement(
                                    'h2',
                                    null,
                                    intl.formatMessage(_messages2.default.fullRolloverTitle)
                                ),
                                _react2.default.createElement(
                                    'p',
                                    null,
                                    intl.formatMessage(_messages2.default.fullRolloverDesc1, { productName: selectedProduct.name })
                                ),
                                _react2.default.createElement(
                                    'p',
                                    null,
                                    intl.formatMessage(_messages2.default.fullRolloverDesc2, { productName: selectedProduct.name })
                                )
                            )
                        )
                    )
                )
            )
        ),
        _react2.default.createElement(
            'div',
            { className: _index4.default.rollOverFooter },
            _react2.default.createElement(_index2.default, { disabled: !isFullRollover && !isPartialRollover, handleOnClick: showUploadPage, label: intl.formatMessage(_messages2.default.nextButton), variant: _variants.DARK }),
            _react2.default.createElement(_index2.default, { handleOnClick: showInitialPage, label: intl.formatMessage(_messages2.default.backButton), variant: _variants.DARK })
        )
    );
};

RollOverSelection.propTypes = {
    intl: _reactIntl.intlShape.isRequired,
    isFullRollover: _propTypes2.default.bool,
    isPartialRollover: _propTypes2.default.bool,
    rollOverIsFull: _propTypes2.default.func,
    rollOverIsPartial: _propTypes2.default.func,
    selectedProduct: _propTypes2.default.object,
    showHelpModal: _propTypes2.default.func,
    showInitialPage: _propTypes2.default.func,
    showUploadPage: _propTypes2.default.func
};

exports.default = (0, _reactIntl.injectIntl)((0, _reactStyleable2.default)(_index4.default)(RollOverSelection));

/***/ }),
/* 751 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactIntl = __webpack_require__(2);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactStyleable = __webpack_require__(6);

var _reactStyleable2 = _interopRequireDefault(_reactStyleable);

var _toLower = __webpack_require__(1461);

var _toLower2 = _interopRequireDefault(_toLower);

var _xlsxCore = __webpack_require__(598);

var _xlsxCore2 = _interopRequireDefault(_xlsxCore);

var _cloneDeep = __webpack_require__(54);

var _cloneDeep2 = _interopRequireDefault(_cloneDeep);

var _index = __webpack_require__(150);

var _index2 = _interopRequireDefault(_index);

var _messages = __webpack_require__(93);

var _messages2 = _interopRequireDefault(_messages);

var _index3 = __webpack_require__(92);

var _index4 = _interopRequireDefault(_index3);

var _index5 = __webpack_require__(153);

var _gridUtil = __webpack_require__(86);

var _variants = __webpack_require__(9);

var _index6 = __webpack_require__(7);

var _index7 = _interopRequireDefault(_index6);

var _index8 = __webpack_require__(37);

var _index9 = _interopRequireDefault(_index8);

var _portalComms = __webpack_require__(55);

var _portalComms2 = _interopRequireDefault(_portalComms);

var _iconDictionary = __webpack_require__(8);

var _modal = __webpack_require__(24);

var _modal2 = _interopRequireDefault(_modal);

var _signInCardsFormats = __webpack_require__(126);

var _signInCardsFormats2 = _interopRequireDefault(_signInCardsFormats);

var _i18n = __webpack_require__(129);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function getGridColumns(intl) {
    var filterType = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'newStudents';

    var gridColumns = [];
    switch (filterType) {
        case 'newStudents':
        case 'updatedStudents':
        case 'transferredStudents':
            gridColumns = [{
                key: 'firstName',
                name: '' + intl.formatMessage(_messages2.default.firstName)
            }, {
                key: 'surname',
                name: '' + intl.formatMessage(_messages2.default.surname)
            }, {
                key: 'yearGroup',
                name: '' + intl.formatMessage(_messages2.default.year),
                width: 70
            }, {
                key: 'classroomName',
                name: '' + intl.formatMessage(_messages2.default.className)
            }, {
                key: 'username',
                name: '' + intl.formatMessage(_messages2.default.username)
            }, {
                key: 'password',
                name: '' + intl.formatMessage(_messages2.default.password)
            }];
            break;

        case 'unassignedStudents':
            gridColumns = [{
                key: 'firstName',
                name: '' + intl.formatMessage(_messages2.default.firstName)
            }, {
                key: 'surname',
                name: '' + intl.formatMessage(_messages2.default.surname)
            }, {
                key: 'username',
                name: '' + intl.formatMessage(_messages2.default.username)
            }, {
                key: 'password',
                name: '' + intl.formatMessage(_messages2.default.password)
            }];
            break;

        case 'newTeachers':
        case 'updatedTeachers':
            gridColumns = [{
                key: 'title',
                name: '' + intl.formatMessage(_messages2.default.title),
                width: 70
            }, {
                key: 'firstName',
                name: '' + intl.formatMessage(_messages2.default.firstName)
            }, {
                key: 'surname',
                name: '' + intl.formatMessage(_messages2.default.surname)
            }, {
                key: 'email',
                name: '' + intl.formatMessage(_messages2.default.teacherEmail)
            }, {
                key: 'username',
                name: '' + intl.formatMessage(_messages2.default.username)
            }];
            break;

        case 'newClassrooms':
        case 'updatedClassrooms':
            gridColumns = [{
                key: 'classroomName',
                name: '' + intl.formatMessage(_messages2.default.className)
            }, {
                key: 'teacherName',
                name: '' + intl.formatMessage(_messages2.default.teacherName)
            }, {
                key: 'yearGroup',
                name: '' + intl.formatMessage(_messages2.default.year),
                width: 80
            }, {
                key: 'assignedStudents',
                name: '' + intl.formatMessage(_messages2.default.assignedStudents),
                width: 200
            }];
            break;

        default:
            gridColumns = [];
            break;
    }
    return gridColumns;
}

var RollOverSummary = function (_Component) {
    _inherits(RollOverSummary, _Component);

    function RollOverSummary(props) {
        _classCallCheck(this, RollOverSummary);

        var _this = _possibleConstructorReturn(this, (RollOverSummary.__proto__ || Object.getPrototypeOf(RollOverSummary)).call(this, props));

        var rolloverSummary = _this.props.rolloverSummary;


        _this.filterType = 'newStudents';
        _this.rows = (0, _gridUtil.createRolloverSummaryRows)(rolloverSummary);
        _this.state = { rows: _this.rows };
        _this.onFilterDropdown = _this.onFilterDropdown.bind(_this);
        _this.dropDownOptions = _this.dropDownOptions.bind(_this);
        _this.getCurrentSelection = _this.getCurrentSelection.bind(_this);
        _this.onPrintSignInCards = _this.onPrintSignInCards.bind(_this);
        _this.writeToExcel = _this.writeToExcel.bind(_this);
        return _this;
    }

    _createClass(RollOverSummary, [{
        key: 'onFilterDropdown',
        value: function onFilterDropdown(name, value) {
            this.filterType = value;
            var rolloverSummary = this.props.rolloverSummary;

            this.rows = (0, _gridUtil.createRolloverSummaryRows)(rolloverSummary, value);
            this.setState({ rows: this.rows });
        }
    }, {
        key: 'getCurrentSelection',
        value: function getCurrentSelection() {
            var _props = this.props,
                intl = _props.intl,
                rolloverSummary = _props.rolloverSummary;

            var user = {};
            switch (this.filterType) {
                case 'newStudents':
                    user = {
                        downloadLabel: intl.formatMessage(_messages2.default.theNewStudent),
                        userType: (0, _toLower2.default)(intl.formatMessage(_messages2.default.newStudents)),
                        length: rolloverSummary[this.filterType].length
                    };
                    break;

                case 'updatedStudents':
                    user = {
                        downloadLabel: intl.formatMessage(_messages2.default.theUpdatedStudent),
                        userType: (0, _toLower2.default)(intl.formatMessage(_messages2.default.updatedStudents)),
                        length: rolloverSummary[this.filterType].length
                    };
                    break;

                case 'unassignedStudents':
                    user = {
                        downloadLabel: intl.formatMessage(_messages2.default.theUnassignedStudent),
                        userType: (0, _toLower2.default)(intl.formatMessage(_messages2.default.unassignedStudents)),
                        length: rolloverSummary[this.filterType].length
                    };
                    break;
                case 'transferredStudents':
                    user = {
                        downloadLabel: intl.formatMessage(_messages2.default.theTransferredStudent),
                        userType: (0, _toLower2.default)(intl.formatMessage(_messages2.default.transferredStudents)),
                        length: rolloverSummary[this.filterType].length
                    };
                    break;

                case 'newTeachers':
                    user = {
                        downloadLabel: intl.formatMessage(_messages2.default.theNewTeacher),
                        userType: (0, _toLower2.default)(intl.formatMessage(_messages2.default.newTeachers)),
                        length: rolloverSummary[this.filterType].length
                    };
                    break;

                case 'updatedTeachers':
                    user = {
                        downloadLabel: intl.formatMessage(_messages2.default.theUpdatedTeacher),
                        userType: (0, _toLower2.default)(intl.formatMessage(_messages2.default.updatedTeachers)),
                        length: rolloverSummary[this.filterType].length
                    };
                    break;

                case 'unassignedTeachers':
                    user = {
                        downloadLabel: intl.formatMessage(_messages2.default.theUnassignedTeacher),
                        userType: (0, _toLower2.default)(intl.formatMessage(_messages2.default.unassignedTeachers)),
                        length: rolloverSummary[this.filterType].length
                    };
                    break;

                case 'newClassrooms':
                    user = {
                        downloadLabel: intl.formatMessage(_messages2.default.theNewClasses),
                        userType: (0, _toLower2.default)(intl.formatMessage(_messages2.default.newClasses)),
                        length: rolloverSummary[this.filterType].length
                    };
                    break;

                case 'updatedClassrooms':
                    user = {
                        downloadLabel: intl.formatMessage(_messages2.default.theUpdatedClasses),
                        userType: (0, _toLower2.default)(intl.formatMessage(_messages2.default.updatedClasses)),
                        length: rolloverSummary[this.filterType].length
                    };
                    break;

                default:
                    break;
            }
            return user;
        }
    }, {
        key: 'dropDownOptions',
        value: function dropDownOptions() {
            var _props2 = this.props,
                intl = _props2.intl,
                rolloverSummary = _props2.rolloverSummary;

            return [{
                key: 'newStudents',
                value: intl.formatMessage(_messages2.default.newStudents) + ' (' + rolloverSummary.newStudents.length + ')',
                selected: true
            }, {
                key: 'updatedStudents',
                value: intl.formatMessage(_messages2.default.updatedStudents) + ' (' + rolloverSummary.updatedStudents.length + ')',
                selected: false
            }, {
                key: 'unassignedStudents',
                value: intl.formatMessage(_messages2.default.unassignedStudents) + ' (' + rolloverSummary.unassignedStudents.length + ')',
                selected: false
            }, {
                key: 'transferredStudents',
                value: intl.formatMessage(_messages2.default.transferredStudents) + ' (' + rolloverSummary.transferredStudents.length + ')',
                selected: false
            }, {
                key: 'newTeachers',
                value: intl.formatMessage(_messages2.default.newTeachers) + ' (' + rolloverSummary.newTeachers.length + ')',
                selected: false
            }, {
                key: 'updatedTeachers',
                value: intl.formatMessage(_messages2.default.updatedTeachers) + ' (' + rolloverSummary.updatedTeachers.length + ')',
                selected: false
            }, {
                key: 'newClassrooms',
                value: intl.formatMessage(_messages2.default.newClasses) + ' (' + rolloverSummary.newClassrooms.length + ')',
                selected: false
            }, {
                key: 'updatedClassrooms',
                value: intl.formatMessage(_messages2.default.updatedClasses) + ' (' + rolloverSummary.updatedClassrooms.length + ')',
                selected: false
            }];
        }
    }, {
        key: 'onPrintSignInCards',
        value: function onPrintSignInCards(format) {
            var selectedProduct = this.props.selectedProduct;

            var userIds = this.rows.map(function (row) {
                return row.id;
            });
            var locale = (0, _i18n.getLocale)();

            switch (this.filterType) {
                case 'newStudents':
                case 'updatedStudents':
                case 'unassignedStudents':
                case 'transferredStudents':
                    this.props.onRollOverDownloadSignInCardRequest(selectedProduct.id, userIds, 'student', format, locale);
                    break;

                case 'newTeachers':
                case 'updatedTeachers':
                    this.props.onRollOverDownloadSignInCardRequest(selectedProduct.id, userIds, 'teacher', 'QR_3X3', locale);
                    break;

                case 'updatedClassrooms':
                case 'newClassrooms':
                    this.props.onRollOverDownloadSignInCardRequest(selectedProduct.id, userIds, 'classroom', format, locale);
                    break;

                default:
                    break;
            }

            this.props.showHideSignInCardModalRequest(false);
        }
    }, {
        key: 'writeToExcel',
        value: function writeToExcel() {
            var _this2 = this;

            var _props3 = this.props,
                intl = _props3.intl,
                rolloverSummary = _props3.rolloverSummary;


            var sheetHeaders = [];
            var downloadingFileName = '';

            switch (this.filterType) {
                case 'newStudents':
                    sheetHeaders = [intl.formatMessage(_messages2.default.firstName), intl.formatMessage(_messages2.default.surname), intl.formatMessage(_messages2.default.year), intl.formatMessage(_messages2.default.className), intl.formatMessage(_messages2.default.username), intl.formatMessage(_messages2.default.password)];
                    downloadingFileName = intl.formatMessage(_messages2.default.newStudentsFile);
                    break;

                case 'updatedStudents':
                    sheetHeaders = [intl.formatMessage(_messages2.default.firstName), intl.formatMessage(_messages2.default.surname), intl.formatMessage(_messages2.default.year), intl.formatMessage(_messages2.default.className), intl.formatMessage(_messages2.default.username), intl.formatMessage(_messages2.default.password)];
                    downloadingFileName = intl.formatMessage(_messages2.default.updatedStudentsFile);
                    break;

                case 'unassignedStudents':
                    sheetHeaders = [intl.formatMessage(_messages2.default.firstName), intl.formatMessage(_messages2.default.surname), intl.formatMessage(_messages2.default.username), intl.formatMessage(_messages2.default.password)];
                    downloadingFileName = intl.formatMessage(_messages2.default.unassignedStudentsFile);
                    break;

                case 'transferredStudents':
                    sheetHeaders = [intl.formatMessage(_messages2.default.firstName), intl.formatMessage(_messages2.default.surname), intl.formatMessage(_messages2.default.year), intl.formatMessage(_messages2.default.className), intl.formatMessage(_messages2.default.username), intl.formatMessage(_messages2.default.password)];
                    downloadingFileName = intl.formatMessage(_messages2.default.transferredStudentsFile);
                    break;

                case 'newTeachers':
                    sheetHeaders = [intl.formatMessage(_messages2.default.title), intl.formatMessage(_messages2.default.firstName), intl.formatMessage(_messages2.default.surname), intl.formatMessage(_messages2.default.teacherEmail), intl.formatMessage(_messages2.default.username)];
                    downloadingFileName = intl.formatMessage(_messages2.default.newTeachersFile);
                    break;

                case 'updatedTeachers':
                    sheetHeaders = [intl.formatMessage(_messages2.default.title), intl.formatMessage(_messages2.default.firstName), intl.formatMessage(_messages2.default.surname), intl.formatMessage(_messages2.default.teacherEmail), intl.formatMessage(_messages2.default.username)];
                    downloadingFileName = intl.formatMessage(_messages2.default.updatedTeachersFile);
                    break;

                case 'newClassrooms':
                    sheetHeaders = [intl.formatMessage(_messages2.default.className), intl.formatMessage(_messages2.default.teacherName), intl.formatMessage(_messages2.default.year), intl.formatMessage(_messages2.default.assignedStudents)];
                    downloadingFileName = intl.formatMessage(_messages2.default.newClassroomsFile);
                    break;

                case 'updatedClassrooms':
                    sheetHeaders = [intl.formatMessage(_messages2.default.className), intl.formatMessage(_messages2.default.teacherName), intl.formatMessage(_messages2.default.year), intl.formatMessage(_messages2.default.assignedStudents)];
                    downloadingFileName = intl.formatMessage(_messages2.default.updatedClassroomsFile);
                    break;

                default:
                    sheetHeaders = [];
                    break;
            }
            // Clone the result from rolloversummary
            var sheetData = (0, _cloneDeep2.default)(rolloverSummary[this.filterType]);
            var results = sheetData.map(function (item) {
                var isUnassignedStudents = ['unassignedStudents'].indexOf(_this2.filterType) !== -1;
                var newItem = [];
                delete item.id;
                delete item.index;
                if (isUnassignedStudents) {
                    // FE fix the ordering of data columns for teachers
                    var firstName = item.firstName,
                        surname = item.surname,
                        username = item.username,
                        password = item.password;

                    newItem = [].concat(_toConsumableArray(newItem), [firstName, surname, username, password]);
                } else {
                    var _iteratorNormalCompletion = true;
                    var _didIteratorError = false;
                    var _iteratorError = undefined;

                    try {
                        for (var _iterator = Object.entries(item)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                            var _ref = _step.value;

                            var _ref2 = _slicedToArray(_ref, 1);

                            var key = _ref2[0];

                            if (_this2.filterType.indexOf('Teachers') !== -1 && key !== 'password') {
                                newItem.push(item[key]);
                            } else if (_this2.filterType.indexOf('Teachers') === -1) {
                                newItem.push(item[key]);
                            }
                        }
                    } catch (err) {
                        _didIteratorError = true;
                        _iteratorError = err;
                    } finally {
                        try {
                            if (!_iteratorNormalCompletion && _iterator.return) {
                                _iterator.return();
                            }
                        } finally {
                            if (_didIteratorError) {
                                throw _iteratorError;
                            }
                        }
                    }
                }

                return newItem;
            });
            // Add headers
            var worksheet = _xlsxCore2.default.utils.aoa_to_sheet([sheetHeaders]);
            // Append data
            _xlsxCore2.default.utils.sheet_add_aoa(worksheet, results, { origin: 1, skipHeader: true });
            // Create a blank workbook using SheetJS
            var workbook = _xlsxCore2.default.utils.book_new();
            // Append the JSON sheet
            _xlsxCore2.default.utils.book_append_sheet(workbook, worksheet);

            _xlsxCore2.default.writeFile(workbook, downloadingFileName);
        }
    }, {
        key: 'render',
        value: function render() {
            var _this3 = this;

            var _props4 = this.props,
                intl = _props4.intl,
                isDownloadingRolloverSignInCards = _props4.isDownloadingRolloverSignInCards,
                rolloverSummary = _props4.rolloverSummary;

            var rowGetter = function rowGetter(rowNumber) {
                return _this3.rows[rowNumber];
            };
            var dataGridClasses = [_index4.default.dataGridContainer, _index4.default.summaryDatagrid].join(' ');
            var summaryContentClasses = [_index4.default.contentWrapper, _index4.default.summaryContentWrapper].join(' ');
            var exportBtnIsDisabled = rolloverSummary[this.filterType].length === 0;
            return _react2.default.createElement(
                'div',
                null,
                _react2.default.createElement(
                    'div',
                    { className: _index4.default.rollOverComponent },
                    _react2.default.createElement(
                        'div',
                        { className: _index4.default.header },
                        _react2.default.createElement(
                            'div',
                            { className: _index4.default.title },
                            intl.formatMessage(_messages2.default.header)
                        )
                    ),
                    _react2.default.createElement(
                        'div',
                        { className: _index4.default.content },
                        _react2.default.createElement(
                            'div',
                            { className: summaryContentClasses },
                            _react2.default.createElement(
                                'div',
                                { className: _index4.default.dataGridWrapper },
                                _react2.default.createElement(
                                    'div',
                                    { className: _index4.default.summaryWrapper },
                                    _react2.default.createElement(
                                        'div',
                                        { className: _index4.default.summary },
                                        intl.formatMessage(_messages2.default.summary)
                                    ),
                                    _react2.default.createElement(
                                        'span',
                                        { className: _index4.default.dropdownBorder },
                                        _react2.default.createElement(_index9.default, {
                                            onChange: this.onFilterDropdown,
                                            options: this.dropDownOptions()
                                        })
                                    )
                                ),
                                _react2.default.createElement(
                                    'div',
                                    { className: dataGridClasses },
                                    _react2.default.createElement(_index2.default, {
                                        columns: getGridColumns(intl, this.filterType),
                                        rowGetter: rowGetter,
                                        rowKey: 'id',
                                        rowRenderer: _index5.RollOverSummaryRenderer,
                                        rowsCount: this.rows.length,
                                        rowSelectionEnabled: false,
                                        selectedRows: [],
                                        showSelectionColumn: false })
                                )
                            )
                        ),
                        _react2.default.createElement(
                            'div',
                            { className: _index4.default.rollOverFooter },
                            _react2.default.createElement(
                                'div',
                                { className: _index4.default.rollOverFooterRight },
                                _react2.default.createElement(_index7.default, {
                                    handleOnClick: function handleOnClick() {
                                        return _portalComms2.default.navigateToLandingScreen('Rollover');
                                    },
                                    label: intl.formatMessage(_messages2.default.done),
                                    variant: _variants.DARK })
                            ),
                            _react2.default.createElement(
                                'div',
                                { className: _index4.default.rollOverFooterLeft },
                                this.getCurrentSelection().downloadLabel.indexOf('teacher') !== -1 ? _react2.default.createElement(_index7.default, {
                                    disabled: this.getCurrentSelection().length === 0,
                                    handleOnClick: function handleOnClick() {
                                        return _this3.onPrintSignInCards('QR_3X3');
                                    },
                                    hidden: this.getCurrentSelection().userType === 'classes',
                                    icon: _iconDictionary.Download,
                                    label: ' ' + intl.formatMessage(_messages2.default.download) + ' ' + this.getCurrentSelection().downloadLabel,
                                    loading: isDownloadingRolloverSignInCards,
                                    loadingLabel: this.props.intl.formatMessage(_messages2.default.downloading),
                                    variant: _variants.DARK }) : _react2.default.createElement(_index7.default, {
                                    disabled: this.getCurrentSelection().length === 0,
                                    handleOnClick: function handleOnClick() {
                                        return _this3.props.showHideSignInCardModalRequest(true);
                                    },
                                    hidden: this.getCurrentSelection().userType === 'classes',
                                    icon: _iconDictionary.Download,
                                    label: ' ' + intl.formatMessage(_messages2.default.download) + ' ' + this.getCurrentSelection().downloadLabel,
                                    variant: _variants.DARK }),
                                _react2.default.createElement(_index7.default, {
                                    disabled: exportBtnIsDisabled,
                                    handleOnClick: this.writeToExcel,
                                    label: intl.formatMessage(_messages2.default.exportSummary),
                                    variant: _variants.DARK })
                            )
                        )
                    )
                ),
                _react2.default.createElement(
                    _modal2.default,
                    { show: this.props.showHideSignInCardModal },
                    _react2.default.createElement(_signInCardsFormats2.default, {
                        handleOnCancel: function handleOnCancel() {
                            return _this3.props.showHideSignInCardModalRequest(false);
                        },
                        handleOnDownloadSignInCards: function handleOnDownloadSignInCards(format) {
                            return _this3.onPrintSignInCards(format);
                        },
                        isSignInCardDownloaded: !isDownloadingRolloverSignInCards })
                )
            );
        }
    }]);

    return RollOverSummary;
}(_react.Component);

RollOverSummary.propTypes = {
    intl: _reactIntl.intlShape.isRequired,
    rolloverSummary: _propTypes2.default.object,
    onRollOverDownloadSignInCardRequest: _propTypes2.default.func,
    isDownloadingRolloverSignInCards: _propTypes2.default.bool,
    selectedProduct: _propTypes2.default.object,
    showHideSignInCardModal: _propTypes2.default.bool,
    showHideSignInCardModalRequest: _propTypes2.default.func
};

exports.default = (0, _reactIntl.injectIntl)((0, _reactStyleable2.default)(_index4.default)(RollOverSummary));

/***/ }),
/* 752 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactStyleable = __webpack_require__(6);

var _reactStyleable2 = _interopRequireDefault(_reactStyleable);

var _reactIntl = __webpack_require__(2);

var _includes = __webpack_require__(232);

var _includes2 = _interopRequireDefault(_includes);

var _iconDictionary = __webpack_require__(8);

var _index = __webpack_require__(7);

var _index2 = _interopRequireDefault(_index);

var _variants = __webpack_require__(9);

var _messages = __webpack_require__(93);

var _messages2 = _interopRequireDefault(_messages);

var _index3 = __webpack_require__(92);

var _index4 = _interopRequireDefault(_index3);

var _index5 = __webpack_require__(150);

var _index6 = _interopRequireDefault(_index5);

var _index7 = __webpack_require__(153);

var _index8 = __webpack_require__(76);

var _index9 = _interopRequireDefault(_index8);

var _gridUtil = __webpack_require__(86);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function getGridColumns(intl) {
    return [{
        key: 'studentFirstName',
        name: '' + intl.formatMessage(_messages2.default.studentFirstName)
    }, {
        key: 'studentLastName',
        name: '' + intl.formatMessage(_messages2.default.studentSurname)
    }, {
        key: 'year',
        name: '' + intl.formatMessage(_messages2.default.year),
        width: 60
    }, {
        key: 'className',
        name: '' + intl.formatMessage(_messages2.default.className)
    }, {
        key: 'title',
        name: '' + intl.formatMessage(_messages2.default.title),
        width: 60
    }, {
        key: 'teacherFirstName',
        name: '' + intl.formatMessage(_messages2.default.teacherFirstName)
    }, {
        key: 'teacherLastName',
        name: '' + intl.formatMessage(_messages2.default.teacherSurname)
    }, {
        key: 'teacherEmail',
        name: '' + intl.formatMessage(_messages2.default.teacherEmail)
    }, {
        key: 'previousUsername',
        name: '' + intl.formatMessage(_messages2.default.previousUsername)
    }];
}

var RollOverUpload = function (_Component) {
    _inherits(RollOverUpload, _Component);

    function RollOverUpload(props) {
        _classCallCheck(this, RollOverUpload);

        var _this = _possibleConstructorReturn(this, (RollOverUpload.__proto__ || Object.getPrototypeOf(RollOverUpload)).call(this, props));

        _this.handleOnFileSelection = function (event) {
            var _this$props = _this.props,
                intl = _this$props.intl,
                selectedProduct = _this$props.selectedProduct;


            var file = event.target.files[0];
            var fileReader = new FileReader();
            var isServerError = false;
            var showModal = true;
            var uploadingRollover = false;

            fileReader.onload = function (e) {
                var fileContent = e.target.result.split(',')[1];

                if (_this.validateFileType(file.type)) {
                    var fileSize = file.size / _this.maxFileSize;
                    if (fileSize > 1) {
                        var errorMessage = intl.formatMessage(_messages2.default.fileSizeMessage);
                        _this.props.rolloverUploadFailure({ isServerError: isServerError, errorMessage: errorMessage, showModal: showModal, uploadingRollover: uploadingRollover, fileSize: fileSize });
                    } else {
                        _this.props.rollOverVerifyContentRequest(selectedProduct.id, fileContent);
                    }
                } else {
                    var isInvalidFile = true;
                    var _errorMessage = intl.formatMessage(_messages2.default.fileFormatValidationMessage);
                    _this.props.rolloverUploadFailure({ isServerError: isServerError, errorMessage: _errorMessage, showModal: showModal, uploadingRollover: uploadingRollover, isInvalidFile: isInvalidFile });
                }
            };

            fileReader.onError = function () {
                var messageDetail = intl.formatMessage(_messages2.default.pleaseTryUploadingAgain);
                var errorMessage = intl.formatMessage(_messages2.default.somethingWentWrong);
                _this.props.rolloverUploadFailure({ isServerError: isServerError, errorMessage: errorMessage, showModal: showModal, uploadingRollover: uploadingRollover, messageDetail: messageDetail });
            };

            fileReader.readAsDataURL(file);
            _this.uploadFile.value = '';
        };

        _this.validateFileType = function (fileType) {
            var allowedFileTypes = ['application/vnd.ms-excel', 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'];
            return (0, _includes2.default)(allowedFileTypes, fileType);
        };

        _this.handleOnBackButton = function () {
            _this.props.clearRollOverVerifyData();
            _this.props.showSelectionPage();
        };

        _this.maxFileSize = 1024 * 1024; // 1MB
        _this.fileReader = new FileReader();

        _this.handleOnUpload = _this.handleOnUpload.bind(_this);
        _this.handleOnFileSelection = _this.handleOnFileSelection.bind(_this);
        return _this;
    }

    _createClass(RollOverUpload, [{
        key: 'handleOnUpload',
        value: function handleOnUpload() {
            this.uploadFile.click();
        }
    }, {
        key: 'render',
        value: function render() {
            var _this2 = this;

            var _props = this.props,
                intl = _props.intl,
                isVerifyingContent = _props.isVerifyingContent,
                isVerificationSuccessful = _props.isVerificationSuccessful,
                rolloverItems = _props.rolloverItems,
                showDataGrid = _props.showDataGrid,
                openRollOverConfirmation = _props.openRollOverConfirmation;


            var allowedFileExt = ['.xls', '.xlsx'].join(',');
            var uploadContentCss = [_index4.default.content, _index4.default.uploadContainer].join(' ');

            this.uploadFile = function (element) {
                _this2.uploadFile = element;
            };

            var uploadButton = _react2.default.createElement(_index2.default, {
                containerClassName: _index4.default.uploadFile,
                handleOnClick: this.handleOnUpload,
                icon: _iconDictionary.Plus,
                iconClassName: isVerifyingContent ? _index4.default.svgContainer : _index4.default.svgIconContainer,
                label: intl.formatMessage(_messages2.default.uploadFile),
                loading: isVerifyingContent,
                loadingLabel: intl.formatMessage(_messages2.default.verifying) });

            this.rows = (0, _gridUtil.createRolloverRows)(rolloverItems);
            var rowGetter = function rowGetter(rowNumber) {
                return _this2.rows[rowNumber];
            };

            var component = showDataGrid ? _react2.default.createElement(
                'div',
                { className: _index4.default.dataGridWrapper },
                _react2.default.createElement(
                    'div',
                    { className: _index4.default.uploadContentWrapper },
                    _react2.default.createElement(
                        'div',
                        { className: _index4.default.uploadContentLabel },
                        intl.formatMessage(_messages2.default.uploadMessage)
                    ),
                    _react2.default.createElement(
                        'div',
                        { className: _index4.default.uploadButtonContainer },
                        uploadButton
                    )
                ),
                _react2.default.createElement(
                    'div',
                    { className: _index4.default.dataGridContainer },
                    _react2.default.createElement(_index6.default, {
                        columns: getGridColumns(intl),
                        rowGetter: rowGetter,
                        rowKey: 'index',
                        rowRenderer: _index7.RollOverRowRenderer,
                        rowsCount: this.rows.length,
                        rowSelectionEnabled: false,
                        selectedRows: [],
                        showSelectionColumn: false
                    })
                )
            ) : _react2.default.createElement(
                'div',
                { className: _index4.default.emptyOuterContainer },
                _react2.default.createElement(_index9.default, {
                    iconName: _iconDictionary.Upload,
                    message: intl.formatMessage(_messages2.default.uploadMessage) }),
                uploadButton
            );

            return _react2.default.createElement(
                'div',
                { className: _index4.default.rollOverComponent },
                _react2.default.createElement(
                    'div',
                    { className: _index4.default.header },
                    _react2.default.createElement(
                        'div',
                        { className: _index4.default.title },
                        intl.formatMessage(_messages2.default.header)
                    )
                ),
                _react2.default.createElement(
                    'div',
                    { className: uploadContentCss },
                    _react2.default.createElement(
                        'div',
                        { className: _index4.default.contentWrapper },
                        _react2.default.createElement('input', {
                            accept: allowedFileExt,
                            className: _index4.default.browseButton,
                            id: 'file',
                            name: 'file',
                            onChange: function onChange(event) {
                                return _this2.handleOnFileSelection(event);
                            },
                            ref: this.uploadFile,
                            type: 'file' }),
                        component
                    )
                ),
                _react2.default.createElement(
                    'div',
                    { className: _index4.default.rollOverFooter },
                    _react2.default.createElement(_index2.default, {
                        disabled: !isVerificationSuccessful,
                        handleOnClick: openRollOverConfirmation,
                        label: intl.formatMessage(_messages2.default.confirm),
                        variant: _variants.DARK }),
                    _react2.default.createElement(_index2.default, {
                        disabled: isVerifyingContent,
                        handleOnClick: this.handleOnBackButton,
                        label: intl.formatMessage(_messages2.default.back),
                        variant: _variants.DARK })
                )
            );
        }
    }]);

    return RollOverUpload;
}(_react.Component);

RollOverUpload.propTypes = {
    intl: _reactIntl.intlShape.isRequired,
    showSelectionPage: _propTypes2.default.func,
    rolloverUploadFailure: _propTypes2.default.func,
    rollOverVerifyContentRequest: _propTypes2.default.func,
    selectedProduct: _propTypes2.default.object,
    isVerifyingContent: _propTypes2.default.bool,
    isVerificationSuccessful: _propTypes2.default.bool,
    rolloverItems: _propTypes2.default.array,
    showDataGrid: _propTypes2.default.bool,
    clearRollOverVerifyData: _propTypes2.default.func,
    openRollOverConfirmation: _propTypes2.default.func
};

exports.default = (0, _reactIntl.injectIntl)((0, _reactStyleable2.default)(_index4.default)(RollOverUpload));

/***/ }),
/* 753 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRouterDom = __webpack_require__(244);

var _routes = __webpack_require__(884);

var _routes2 = _interopRequireDefault(_routes);

var _toast = __webpack_require__(797);

var _toast2 = _interopRequireDefault(_toast);

var _index = __webpack_require__(1724);

var _index2 = _interopRequireDefault(_index);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var RootContainer = function RootContainer(props) {
    var container = _react2.default.createElement(
        'div',
        { className: _index2.default.rootContainer },
        _react2.default.createElement(
            _reactRouterDom.BrowserRouter,
            { basename: props.basename },
            _react2.default.createElement(_routes2.default, null)
        ),
        _react2.default.createElement(_toast2.default, null)
    );
    return container;
};

RootContainer.propTypes = {
    basename: _propTypes2.default.string
};

exports.default = RootContainer;

/***/ }),
/* 754 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactIntl = __webpack_require__(2);

var _svgIcon = __webpack_require__(21);

var _svgIcon2 = _interopRequireDefault(_svgIcon);

var _index = __webpack_require__(1726);

var _index2 = _interopRequireDefault(_index);

var _messages = __webpack_require__(755);

var _messages2 = _interopRequireDefault(_messages);

var _iconDictionary = __webpack_require__(8);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SendEmailResult = function SendEmailResult(props) {
    var sendingEmailsResult = props.sendingEmailsResult,
        fatalError = props.fatalError,
        onCloseModal = props.onCloseModal;
    var successfulSending = sendingEmailsResult.successfulSending,
        alreadyVerifiedEmails = sendingEmailsResult.alreadyVerifiedEmails,
        duplicateEmails = sendingEmailsResult.duplicateEmails,
        invalidRequests = sendingEmailsResult.invalidRequests;


    var failedEmailMessage = function failedEmailMessage() {
        var notSent = alreadyVerifiedEmails + duplicateEmails + invalidRequests;
        var notValid = duplicateEmails + invalidRequests === 0 ? null : _react2.default.createElement(
            'li',
            { className: _index2.default.comment },
            invalidRequests + duplicateEmails,
            ' ',
            props.intl.formatMessage(_messages2.default.notValidOrDuplicate)
        );
        var alreadyVerified = alreadyVerifiedEmails === 0 ? null : _react2.default.createElement(
            'li',
            { className: _index2.default.comment },
            alreadyVerifiedEmails,
            ' ',
            alreadyVerifiedEmails > 1 ? props.intl.formatMessage(_messages2.default.emailsAlreadyVerified) : props.intl.formatMessage(_messages2.default.emailAlreadyVerified)
        );

        return notSent === 0 ? null : _react2.default.createElement(
            'div',
            { className: _index2.default.row },
            _react2.default.createElement(
                'div',
                { className: _index2.default.icon },
                _react2.default.createElement(_svgIcon2.default, { icon: _iconDictionary.Unsent })
            ),
            _react2.default.createElement(
                'div',
                { className: _index2.default.message },
                _react2.default.createElement(
                    'div',
                    { className: _index2.default.mainItem },
                    notSent + ' ' + (notSent > 1 ? props.intl.formatMessage(_messages2.default.emailsNotSent) : props.intl.formatMessage(_messages2.default.emailNotSent))
                ),
                _react2.default.createElement(
                    'ul',
                    null,
                    notValid,
                    alreadyVerified
                )
            )
        );
    };

    var errorBody = _react2.default.createElement(
        'div',
        { className: _index2.default.error },
        _react2.default.createElement(
            'div',
            { className: _index2.default.row },
            _react2.default.createElement(
                'div',
                { className: _index2.default.icon },
                _react2.default.createElement(_svgIcon2.default, { icon: _iconDictionary.Warning2 })
            ),
            _react2.default.createElement(
                'div',
                { className: _index2.default.message },
                _react2.default.createElement(
                    'div',
                    { className: _index2.default.mainItem },
                    props.intl.formatMessage(_messages2.default.unableToSend)
                ),
                _react2.default.createElement(
                    'div',
                    { className: _index2.default.mainItem },
                    props.intl.formatMessage(_messages2.default.tryAgain)
                )
            )
        )
    );

    var successBody = _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
            'div',
            { className: _index2.default.row },
            _react2.default.createElement(
                'div',
                { className: _index2.default.icon },
                _react2.default.createElement(_svgIcon2.default, { icon: _iconDictionary.Sent })
            ),
            _react2.default.createElement(
                'div',
                { className: _index2.default.message },
                _react2.default.createElement(
                    'div',
                    { className: _index2.default.mainItem },
                    successfulSending + ' ' + (successfulSending > 1 ? props.intl.formatMessage(_messages2.default.emailsSent) : props.intl.formatMessage(_messages2.default.emailSent))
                )
            )
        ),
        failedEmailMessage()
    );

    return _react2.default.createElement(
        'div',
        { className: _index2.default.confirmationMessageContainer },
        _react2.default.createElement(
            'div',
            { className: _index2.default.title },
            props.intl.formatMessage(_messages2.default.sendEmails)
        ),
        _react2.default.createElement(
            'div',
            { className: _index2.default.recordsMessage },
            fatalError ? errorBody : successBody
        ),
        _react2.default.createElement(
            'div',
            null,
            _react2.default.createElement(
                'button',
                {
                    className: _index2.default.okButton,
                    onClick: onCloseModal
                },
                props.intl.formatMessage(_messages2.default.ok)
            )
        )
    );
};

SendEmailResult.propTypes = {
    sendingEmailsResult: _propTypes2.default.object,
    fatalError: _propTypes2.default.bool,
    onCloseModal: _propTypes2.default.func,
    intl: _reactIntl.intlShape.isRequired
};

exports.default = (0, _reactIntl.injectIntl)(SendEmailResult);

/***/ }),
/* 755 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _reactIntl = __webpack_require__(2);

exports.default = (0, _reactIntl.defineMessages)({
    ok: {
        id: 'app.components.SendEmailResult.ok',
        defaultMessage: 'Ok'
    },
    notValidOrDuplicate: {
        id: 'app.components.SendEmailResult.notValidOrDuplicate',
        defaultMessage: 'not valid or duplicate email'
    },
    emailSent: {
        id: 'app.components.SendEmailResult.emailSent',
        defaultMessage: 'email successfully sent'
    },
    emailsSent: {
        id: 'app.components.SendEmailResult.emailsSent',
        defaultMessage: 'emails successfully sent'
    },
    emailNotSent: {
        id: 'app.components.SendEmailResult.emailNotSent',
        defaultMessage: 'email not sent'
    },
    emailsNotSent: {
        id: 'app.components.SendEmailResult.emailsNotSent',
        defaultMessage: 'emails not sent'
    },
    emailAlreadyVerified: {
        id: 'app.components.SendEmailResult.emailAlreadyVerified',
        defaultMessage: 'email address already verified'
    },
    emailsAlreadyVerified: {
        id: 'app.components.SendEmailResult.emailsAlreadyVerified',
        defaultMessage: 'email addresses already verified'
    },
    unableToSend: {
        id: 'app.components.SendEmailResult.unableToSend',
        defaultMessage: 'Unable to send email at this time.'
    },
    tryAgain: {
        id: 'app.components.SendEmailResult.tryAgain',
        defaultMessage: 'Please try again later.'
    },
    sendEmails: {
        id: 'app.components.SendEmailResult.sendEmails',
        defaultMessage: 'Send verification emails'
    }
});

/***/ }),
/* 756 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _reactIntl = __webpack_require__(2);

exports.default = (0, _reactIntl.defineMessages)({
    qr2x2: {
        id: 'app.components.studentUnAssign.qr2x2',
        defaultMessage: 'QR codes 2x2'
    },
    qr3x3: {
        id: 'app.components.studentUnAssign.qr3x3',
        defaultMessage: 'QR codes 3x3'
    },
    f2x5: {
        id: 'app.components.studentUnAssign.f2x5',
        defaultMessage: '2x5 label'
    },
    f2x7: {
        id: 'app.components.studentUnAssign.f2x7',
        defaultMessage: '2x7 label'
    },
    f3x8: {
        id: 'app.components.studentUnAssign.f3x8',
        defaultMessage: '3x8 label'
    },
    downloading: {
        id: 'app.components.studentUnAssign.downloading',
        defaultMessage: 'downloading'
    },
    download: {
        id: 'app.components.studentUnAssign.download',
        defaultMessage: 'download'
    },
    header: {
        id: 'app.components.studentUnAssign.header',
        defaultMessage: 'Please select format for sign in cards'
    }
});

/***/ }),
/* 757 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactStyleable = __webpack_require__(6);

var _reactStyleable2 = _interopRequireDefault(_reactStyleable);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _spinner = __webpack_require__(94);

var _spinner2 = _interopRequireDefault(_spinner);

var _index = __webpack_require__(370);

var _index2 = _interopRequireDefault(_index);

var _blankState = __webpack_require__(758);

var _blankState2 = _interopRequireDefault(_blankState);

var _signInCards = __webpack_require__(759);

var _signInCards2 = _interopRequireDefault(_signInCards);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SignInCards = function SignInCards(props) {
    var isClassroomsLoaded = props.isClassroomsLoaded,
        isTeachersLoaded = props.isTeachersLoaded,
        filteredClassrooms = props.filteredClassrooms;


    var classesWithStudents = filteredClassrooms.filter(function (classes) {
        return classes.studentsCount;
    }).length;

    var finalView = isClassroomsLoaded && isTeachersLoaded ? _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(_blankState2.default, _extends({
            classesWithStudents: classesWithStudents
        }, props)),
        _react2.default.createElement(_signInCards2.default, props)
    ) : _react2.default.createElement(
        'div',
        { className: _index2.default.loader },
        _react2.default.createElement(_spinner2.default, { color: 'grey', size: '15px' })
    );

    return finalView;
};

SignInCards.propTypes = {
    filteredClassrooms: _propTypes2.default.array,
    isClassroomsLoaded: _propTypes2.default.bool,
    isTeachersLoaded: _propTypes2.default.bool
};

exports.default = (0, _reactStyleable2.default)(_index2.default)(SignInCards);

/***/ }),
/* 758 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactIntl = __webpack_require__(2);

var _reactStyleable = __webpack_require__(6);

var _reactStyleable2 = _interopRequireDefault(_reactStyleable);

var _index = __webpack_require__(24);

var _index2 = _interopRequireDefault(_index);

var _portalComms = __webpack_require__(55);

var _portalComms2 = _interopRequireDefault(_portalComms);

var _iconDictionary = __webpack_require__(8);

var _svgIcon = __webpack_require__(21);

var _svgIcon2 = _interopRequireDefault(_svgIcon);

var _index3 = __webpack_require__(7);

var _index4 = _interopRequireDefault(_index3);

var _variants = __webpack_require__(9);

var _messages = __webpack_require__(390);

var _messages2 = _interopRequireDefault(_messages);

var _index5 = __webpack_require__(370);

var _index6 = _interopRequireDefault(_index5);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SignInCardsEmptyState = function SignInCardsEmptyState(props) {
    var intl = props.intl,
        selectedTeachersId = props.selectedTeachersId,
        classesWithStudents = props.classesWithStudents;


    return _react2.default.createElement(
        _index2.default,
        { show: !selectedTeachersId.length && !classesWithStudents },
        _react2.default.createElement(
            'div',
            { className: _index6.default.emptyContainer },
            _react2.default.createElement(
                'div',
                { className: _index6.default.emptyNotice },
                _react2.default.createElement(
                    'div',
                    { className: _index6.default.emptyState },
                    _react2.default.createElement(
                        'div',
                        { className: _index6.default.emptyIconContainer },
                        _react2.default.createElement(_svgIcon2.default, { icon: _iconDictionary.StudentManagement })
                    )
                ),
                _react2.default.createElement(
                    'div',
                    { className: _index6.default.noResult },
                    intl.formatMessage(_messages2.default.noStudentsAvailable)
                )
            )
        ),
        _react2.default.createElement(
            'div',
            { className: _index6.default.emptyStateFooter },
            _react2.default.createElement(_index4.default, {
                handleOnClick: function handleOnClick() {
                    _portalComms2.default.navigateToLandingScreen('School roll');
                },
                label: intl.formatMessage(_messages2.default.ok),
                variant: _variants.DARK })
        )
    );
};

SignInCardsEmptyState.propTypes = {
    intl: _reactIntl.intlShape.isRequired,
    selectedTeachersId: _propTypes2.default.oneOfType([_propTypes2.default.array, _propTypes2.default.string]),
    classesWithStudents: _propTypes2.default.number
};

exports.default = (0, _reactIntl.injectIntl)((0, _reactStyleable2.default)(_index6.default)(SignInCardsEmptyState));

/***/ }),
/* 759 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactStyleable = __webpack_require__(6);

var _reactStyleable2 = _interopRequireDefault(_reactStyleable);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactIntl = __webpack_require__(2);

var _cloneDeep = __webpack_require__(54);

var _cloneDeep2 = _interopRequireDefault(_cloneDeep);

var _PulseLoader = __webpack_require__(60);

var _PulseLoader2 = _interopRequireDefault(_PulseLoader);

var _index = __webpack_require__(370);

var _index2 = _interopRequireDefault(_index);

var _messages = __webpack_require__(390);

var _messages2 = _interopRequireDefault(_messages);

var _index3 = __webpack_require__(7);

var _index4 = _interopRequireDefault(_index3);

var _variants = __webpack_require__(9);

var _index5 = __webpack_require__(37);

var _index6 = _interopRequireDefault(_index5);

var _dropdownList = __webpack_require__(1728);

var _dropdownList2 = _interopRequireDefault(_dropdownList);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SignInCardsDownloadView = function SignInCardsDownloadView(props) {
    var intl = props.intl,
        teachers = props.teachers,
        onTeacherSelection = props.onTeacherSelection,
        isClassroomsLoaded = props.isClassroomsLoaded,
        isTeachersLoaded = props.isTeachersLoaded,
        currentSelection = props.currentSelection,
        onLabelSelectionChange = props.onLabelSelectionChange,
        signInCardsEnum = props.signInCardsEnum,
        filteredClassrooms = props.filteredClassrooms,
        onClassSelectionChange = props.onClassSelectionChange,
        disableDownload = props.disableDownload,
        onDownloadSignInCards = props.onDownloadSignInCards,
        isStudentSignInCardDownloaded = props.isStudentSignInCardDownloaded,
        isTeacherSignInCardDownloaded = props.isTeacherSignInCardDownloaded;


    var cloneAllTeachers = (0, _cloneDeep2.default)(teachers);
    delete cloneAllTeachers['0'];

    var cloneFilteredClasses = (0, _cloneDeep2.default)(filteredClassrooms);
    delete cloneFilteredClasses['0'];

    signInCardsEnum.LABELS.SIZES[0].value = 'QR ' + intl.formatMessage(_messages2.default.code) + ' 3 X 3';
    signInCardsEnum.LABELS.SIZES[1].value = 'QR ' + intl.formatMessage(_messages2.default.code) + ' 2 X 2';
    signInCardsEnum.LABELS.SIZES[2].value = '2 x 5 ' + intl.formatMessage(_messages2.default.label);
    signInCardsEnum.LABELS.SIZES[3].value = '2 x 7 ' + intl.formatMessage(_messages2.default.label);
    signInCardsEnum.LABELS.SIZES[4].value = '3 x 8 ' + intl.formatMessage(_messages2.default.label);

    var finalView = isClassroomsLoaded && isTeachersLoaded ? _react2.default.createElement(
        'div',
        { className: _index2.default.container },
        _react2.default.createElement(
            'div',
            { className: _index2.default.header },
            intl.formatMessage(_messages2.default.signInCards)
        ),
        _react2.default.createElement(
            'span',
            { className: _index2.default.title },
            intl.formatMessage(_messages2.default.selectClass)
        ),
        _react2.default.createElement(
            'div',
            { className: _index2.default.list },
            _react2.default.createElement(_index6.default, {
                css: _dropdownList2.default,
                name: 'teachers',
                onChange: onTeacherSelection,
                options: cloneAllTeachers,
                placeholder: intl.formatMessage(_messages2.default.allTeachers)
            }),
            _react2.default.createElement(_index6.default, {
                css: _dropdownList2.default,
                disabled: currentSelection === signInCardsEnum.TEACHERS,
                name: 'classrooms',
                onChange: onClassSelectionChange,
                options: cloneFilteredClasses,
                placeholder: intl.formatMessage(_messages2.default.allClasses)
            }),
            _react2.default.createElement(_index6.default, {
                css: _dropdownList2.default,
                disabled: currentSelection === signInCardsEnum.TEACHERS,
                name: 'labelSizes',
                onChange: onLabelSelectionChange,
                options: signInCardsEnum.LABELS.SIZES
            })
        ),
        _react2.default.createElement(
            'div',
            { className: _index2.default.footer },
            _react2.default.createElement(_index4.default, {
                disabled: disableDownload,
                handleOnClick: onDownloadSignInCards,
                label: intl.formatMessage(_messages2.default.download),
                loading: !isStudentSignInCardDownloaded || !isTeacherSignInCardDownloaded,
                loadingLabel: intl.formatMessage(_messages2.default.downloading),
                variant: _variants.DARK })
        )
    ) : _react2.default.createElement(
        'div',
        { className: _index2.default.loader },
        _react2.default.createElement(_PulseLoader2.default, { color: 'grey', size: '15px' })
    );

    return finalView;
};

SignInCardsDownloadView.propTypes = {
    intl: _reactIntl.intlShape.isRequired,
    teachers: _propTypes2.default.array,
    labelSize: _propTypes2.default.array,
    filteredClassrooms: _propTypes2.default.array,
    onTeacherSelection: _propTypes2.default.func,
    onClassSelectionChange: _propTypes2.default.func,
    onLabelSelectionChange: _propTypes2.default.func,
    onDownloadSignInCards: _propTypes2.default.func,
    signInCardsEnum: _propTypes2.default.func,
    isClassroomsLoaded: _propTypes2.default.bool,
    isTeachersLoaded: _propTypes2.default.bool,
    disableDownload: _propTypes2.default.bool,
    isStudentSignInCardDownloaded: _propTypes2.default.bool,
    isTeacherSignInCardDownloaded: _propTypes2.default.bool,
    currentSelection: _propTypes2.default.string
};

exports.default = (0, _reactIntl.injectIntl)((0, _reactStyleable2.default)(_index2.default)(SignInCardsDownloadView));

/***/ }),
/* 760 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactStyleable = __webpack_require__(6);

var _reactStyleable2 = _interopRequireDefault(_reactStyleable);

var _reactIntl = __webpack_require__(2);

var _iconDictionary = __webpack_require__(8);

var _index = __webpack_require__(1730);

var _index2 = _interopRequireDefault(_index);

var _index3 = __webpack_require__(7);

var _index4 = _interopRequireDefault(_index3);

var _index5 = __webpack_require__(762);

var _index6 = _interopRequireDefault(_index5);

var _messages = __webpack_require__(761);

var _messages2 = _interopRequireDefault(_messages);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var StudentClassDetail = function StudentClassDetail(_ref) {
    var editStudentDetail = _ref.editStudentDetail,
        handleOnUnassignStudent = _ref.handleOnUnassignStudent,
        productName = _ref.productName,
        isUnassignedModalOpen = _ref.isUnassignedModalOpen,
        handleOnUnassignConfirm = _ref.handleOnUnassignConfirm,
        handleOnCloseModal = _ref.handleOnCloseModal,
        unassignStudentsSuccessConfirmation = _ref.unassignStudentsSuccessConfirmation,
        showUnassignStudentModal = _ref.showUnassignStudentModal,
        isLoading = _ref.isLoading,
        handleOnAssignClass = _ref.handleOnAssignClass,
        intl = _ref.intl;

    var assignedClassrooms = editStudentDetail !== undefined ? editStudentDetail.assignedClassrooms : [];
    return _react2.default.createElement(
        'div',
        { className: _index2.default.classDetailComponent },
        _react2.default.createElement(
            'div',
            { className: _index2.default.title },
            intl.formatMessage(_messages2.default.classDetails),
            ' (',
            productName,
            ')'
        ),
        _react2.default.createElement(
            'div',
            { className: _index2.default.header },
            _react2.default.createElement(_index6.default, {
                assignedClassrooms: assignedClassrooms,
                handleOnCloseModal: handleOnCloseModal,
                handleOnStudentUnassign: handleOnUnassignStudent,
                handleOnUnassignConfirm: handleOnUnassignConfirm,
                isLoading: isLoading,
                isUnassignedModalOpen: isUnassignedModalOpen,
                showUnassignStudentModal: showUnassignStudentModal,
                unassignStudentsSuccessConfirmation: unassignStudentsSuccessConfirmation })
        ),
        _react2.default.createElement(
            'div',
            { className: _index2.default.footer },
            _react2.default.createElement(_index4.default, {
                containerClassName: _index2.default.assignClass,
                handleOnClick: handleOnAssignClass,
                icon: _iconDictionary.Plus,
                iconClassName: _index2.default.icon,
                label: intl.formatMessage(_messages2.default.assignClasses) })
        )
    );
};

StudentClassDetail.propTypes = {
    editStudentDetail: _propTypes2.default.object,
    productName: _propTypes2.default.string,
    handleOnUnassignStudent: _propTypes2.default.func,
    handleOnUnassignConfirm: _propTypes2.default.func,
    handleOnCloseModal: _propTypes2.default.func,
    unassignStudentsSuccessConfirmation: _propTypes2.default.func,
    isUnassignedModalOpen: _propTypes2.default.bool,
    showUnassignStudentModal: _propTypes2.default.bool,
    isLoading: _propTypes2.default.bool,
    intl: _reactIntl.intlShape.isRequired,
    handleOnAssignClass: _propTypes2.default.func
};

exports.default = (0, _reactIntl.injectIntl)((0, _reactStyleable2.default)(_index2.default)(StudentClassDetail));

/***/ }),
/* 761 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _reactIntl = __webpack_require__(2);

exports.default = (0, _reactIntl.defineMessages)({
    assignClasses: {
        id: 'app.components.StudentClassDetail.assignClasses',
        defaultMessage: 'Assign Class(es)'
    },
    classDetails: {
        id: 'app.components.StudentClassDetail.classDetails',
        defaultMessage: 'Class details'
    }
});

/***/ }),
/* 762 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _map = __webpack_require__(139);

var _map2 = _interopRequireDefault(_map);

var _uniqueId = __webpack_require__(175);

var _uniqueId2 = _interopRequireDefault(_uniqueId);

var _reactStyleable = __webpack_require__(6);

var _reactStyleable2 = _interopRequireDefault(_reactStyleable);

var _reactIntl = __webpack_require__(2);

var _iconDictionary = __webpack_require__(8);

var _index = __webpack_require__(1731);

var _index2 = _interopRequireDefault(_index);

var _index3 = __webpack_require__(7);

var _index4 = _interopRequireDefault(_index3);

var _messages = __webpack_require__(763);

var _messages2 = _interopRequireDefault(_messages);

var _index5 = __webpack_require__(24);

var _index6 = _interopRequireDefault(_index5);

var _index7 = __webpack_require__(391);

var _index8 = _interopRequireDefault(_index7);

var _index9 = __webpack_require__(36);

var _index10 = _interopRequireDefault(_index9);

var _classCourses = __webpack_require__(252);

var _classCourses2 = _interopRequireDefault(_classCourses);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var StudentClassList = function StudentClassList(_ref) {
    var assignedClassrooms = _ref.assignedClassrooms,
        handleOnStudentUnassign = _ref.handleOnStudentUnassign,
        unassignStudentsSuccessConfirmation = _ref.unassignStudentsSuccessConfirmation,
        isUnassignedModalOpen = _ref.isUnassignedModalOpen,
        showUnassignStudentModal = _ref.showUnassignStudentModal,
        handleOnCloseModal = _ref.handleOnCloseModal,
        handleOnUnassignConfirm = _ref.handleOnUnassignConfirm,
        isLoading = _ref.isLoading,
        intl = _ref.intl;

    var confirmation = isUnassignedModalOpen ? _react2.default.createElement(
        _index8.default,
        {
            handleOnCancel: handleOnCloseModal,
            handleOnOk: handleOnUnassignConfirm,
            icon: _iconDictionary.Warning,
            isLoading: isLoading,
            title: intl.formatMessage(_messages2.default.unassignStudent) },
        _react2.default.createElement(
            'div',
            null,
            intl.formatMessage(_messages2.default.selectedStudentWillBe),
            _react2.default.createElement(
                'span',
                { className: _index2.default.highlight },
                ' ' + intl.formatMessage(_messages2.default.unassignedClassList) + ' '
            ),
            intl.formatMessage(_messages2.default.mayLoseAccessToProducts)
        )
    ) : _react2.default.createElement(_index10.default, {
        handleOnCloseModal: unassignStudentsSuccessConfirmation,
        icon: _iconDictionary.Tick,
        title: intl.formatMessage(_messages2.default.studentsUnassigned) });

    return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
            'div',
            { className: _index2.default.header },
            _react2.default.createElement(
                'div',
                { className: _index2.default.columns },
                intl.formatMessage(_messages2.default.class)
            ),
            _react2.default.createElement(
                'div',
                { className: _index2.default.columns },
                intl.formatMessage(_messages2.default.group)
            ),
            _react2.default.createElement(
                'div',
                { className: _index2.default.columns },
                intl.formatMessage(_messages2.default.course)
            ),
            _react2.default.createElement(
                'div',
                { className: _index2.default.columns },
                intl.formatMessage(_messages2.default.teacher)
            ),
            _react2.default.createElement(
                'div',
                { className: _index2.default.columns },
                intl.formatMessage(_messages2.default.year)
            )
        ),
        (0, _map2.default)(assignedClassrooms, function (classInfo) {
            return _react2.default.createElement(
                'div',
                { className: _index2.default.list, key: classInfo.classId },
                _react2.default.createElement(
                    'div',
                    { className: _index2.default.columns },
                    classInfo.name
                ),
                _react2.default.createElement(
                    'div',
                    { className: _index2.default.columns },
                    classInfo.groupName
                ),
                _react2.default.createElement(
                    'div',
                    { className: _index2.default.columns },
                    (0, _classCourses2.default)({
                        courseTitle: classInfo.courseName,
                        conquestCourseTitle: classInfo.conquestCourseName,
                        upfCourseTitle: classInfo.upfCourseName,
                        yearGroup: classInfo.yearGroup,
                        intl: intl,
                        isOptedOut: classInfo.isOptedOut })
                ),
                _react2.default.createElement(
                    'div',
                    { className: _index2.default.columns },
                    (0, _map2.default)(classInfo.teachersName, function (teacher) {
                        return _react2.default.createElement(
                            'div',
                            { key: (0, _uniqueId2.default)('Student_Class_List_Teacher_') },
                            teacher
                        );
                    })
                ),
                _react2.default.createElement(
                    'div',
                    { className: _index2.default.columns },
                    classInfo.yearGroup
                ),
                _react2.default.createElement(_index4.default, {
                    containerClassName: _index2.default.unassignClass,
                    handleOnClick: function handleOnClick() {
                        return handleOnStudentUnassign(classInfo.classId);
                    },
                    icon: _iconDictionary.Cross,
                    iconClassName: _index2.default.icon })
            );
        }),
        _react2.default.createElement(
            _index6.default,
            { show: showUnassignStudentModal },
            confirmation
        )
    );
};

StudentClassList.propTypes = {
    assignedClassrooms: _propTypes2.default.array,
    handleOnStudentUnassign: _propTypes2.default.func,
    showUnassignStudentModal: _propTypes2.default.bool,
    unassignStudentsSuccessConfirmation: _propTypes2.default.func,
    isUnassignedModalOpen: _propTypes2.default.bool,
    handleOnUnassignConfirm: _propTypes2.default.func,
    handleOnCloseModal: _propTypes2.default.func,
    isLoading: _propTypes2.default.bool,
    intl: _reactIntl.intlShape.isRequired
};

exports.default = (0, _reactIntl.injectIntl)((0, _reactStyleable2.default)(_index2.default)(StudentClassList));

/***/ }),
/* 763 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _reactIntl = __webpack_require__(2);

exports.default = (0, _reactIntl.defineMessages)({
    class: {
        id: 'app.components.StudentClassList.class',
        defaultMessage: 'CLASS'
    },
    group: {
        id: 'app.components.StudentClassList.group',
        defaultMessage: 'GROUP'
    },
    course: {
        id: 'app.components.StudentClassList.course',
        defaultMessage: 'COURSE'
    },
    teacher: {
        id: 'app.components.StudentClassList.teacher',
        defaultMessage: 'TEACHER'
    },
    year: {
        id: 'app.components.StudentClassList.year',
        defaultMessage: 'YEAR'
    },
    unassignStudent: {
        id: 'app.components.StudentClassList.unassignStudents',
        defaultMessage: 'Unassign Student'
    },
    studentsUnassigned: {
        id: 'app.components.StudentClassList.studentsUnassigned',
        defaultMessage: 'Student have been unassigned'
    },
    selectedStudentWillBe: {
        id: 'app.components.StudentClassList.selectedStudentWillBe',
        defaultMessage: 'The selected student will be'
    },
    unassignedClassList: {
        id: 'app.components.StudentClassList.unassignedClassList',
        defaultMessage: 'unassigned'
    },
    mayLoseAccessToProducts: {
        id: 'app.components.StudentClassList.mayLoseAccessToProducts',
        defaultMessage: 'and may lose access to the current product.'
    }
});

/***/ }),
/* 764 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactIntl = __webpack_require__(2);

var _iconDictionary = __webpack_require__(8);

var _index = __webpack_require__(1732);

var _index2 = _interopRequireDefault(_index);

var _svgIcon = __webpack_require__(21);

var _svgIcon2 = _interopRequireDefault(_svgIcon);

var _index3 = __webpack_require__(7);

var _index4 = _interopRequireDefault(_index3);

var _messages = __webpack_require__(765);

var _messages2 = _interopRequireDefault(_messages);

var _modal = __webpack_require__(24);

var _modal2 = _interopRequireDefault(_modal);

var _signInCardsFormats = __webpack_require__(126);

var _signInCardsFormats2 = _interopRequireDefault(_signInCardsFormats);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var StudentConfirmation = function StudentConfirmation(_ref) {
    var icon = _ref.icon,
        title = _ref.title,
        _ref$showHideSignInCa = _ref.showHideSignInCardModal,
        showHideSignInCardModal = _ref$showHideSignInCa === undefined ? false : _ref$showHideSignInCa,
        handleOnAddStudent = _ref.handleOnAddStudent,
        handleOnCloseModal = _ref.handleOnCloseModal,
        handleOnPrintSignInCard = _ref.handleOnPrintSignInCard,
        _ref$isSignInCardDown = _ref.isSignInCardDownloaded,
        isSignInCardDownloaded = _ref$isSignInCardDown === undefined ? true : _ref$isSignInCardDown,
        intl = _ref.intl,
        handleOnStudentSignInCards = _ref.handleOnStudentSignInCards,
        handleOnCancelStudentSignInCards = _ref.handleOnCancelStudentSignInCards;
    return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
            'div',
            { className: _index2.default.studentConfirmationContainer },
            _react2.default.createElement(
                'div',
                { className: _index2.default.icon },
                _react2.default.createElement(_svgIcon2.default, { icon: icon })
            ),
            _react2.default.createElement(
                'div',
                { className: _index2.default.title },
                title
            ),
            _react2.default.createElement(_index4.default, {
                buttonContainer: _index2.default.buttonContainer,
                containerClassName: _index2.default.buttonWrapper,
                handleOnClick: handleOnAddStudent,
                icon: _iconDictionary.Plus,
                iconClassName: _index2.default.buttonIcon,
                label: intl.formatMessage(_messages2.default.addAnotherStudent) }),
            _react2.default.createElement(_index4.default, {
                buttonContainer: _index2.default.buttonContainer,
                buttonContainerDisabled: _index2.default.buttonContainerDisabled,
                containerClassName: _index2.default.buttonWrapper,
                handleOnClick: handleOnStudentSignInCards,
                icon: _iconDictionary.PrintSignIn,
                iconClassName: _index2.default.buttonIcon,
                label: intl.formatMessage(_messages2.default.printSignInCard)
            }),
            _react2.default.createElement(_index4.default, {
                buttonContainer: _index2.default.buttonContainer,
                containerClassName: _index2.default.buttonWrapper,
                handleOnClick: handleOnCloseModal,
                icon: _iconDictionary.Tick,
                iconClassName: _index2.default.buttonIcon,
                label: intl.formatMessage(_messages2.default.done) })
        ),
        _react2.default.createElement(
            _modal2.default,
            { show: showHideSignInCardModal },
            _react2.default.createElement(_signInCardsFormats2.default, {
                handleOnCancel: handleOnCancelStudentSignInCards,
                handleOnDownloadSignInCards: handleOnPrintSignInCard,
                isSignInCardDownloaded: isSignInCardDownloaded })
        )
    );
};

StudentConfirmation.propTypes = {
    icon: _propTypes2.default.string,
    title: _propTypes2.default.string,
    handleOnAddStudent: _propTypes2.default.func,
    handleOnCloseModal: _propTypes2.default.func,
    handleOnPrintSignInCard: _propTypes2.default.func,
    isSignInCardDownloaded: _propTypes2.default.bool,
    intl: _reactIntl.intlShape.isRequired,
    showHideSignInCardModal: _propTypes2.default.bool,
    handleOnStudentSignInCards: _propTypes2.default.func,
    handleOnCancelStudentSignInCards: _propTypes2.default.func
};

exports.default = (0, _reactIntl.injectIntl)(StudentConfirmation);

/***/ }),
/* 765 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _reactIntl = __webpack_require__(2);

exports.default = (0, _reactIntl.defineMessages)({
    addAnotherStudent: {
        id: 'app.components.StudentConfirmation.addAnotherStuent',
        defaultMessage: 'Add another student'
    },
    printSignInCard: {
        id: 'app.components.StudentConfirmation.printSignInCard',
        defaultMessage: 'Print sign-in card'
    },
    done: {
        id: 'app.components.StudentConfirmation.done',
        defaultMessage: 'Done'
    },
    downloading: {
        id: 'app.components.StudentConfirmation.header',
        defaultMessage: 'downloading...'
    }
});

/***/ }),
/* 766 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactStyleable = __webpack_require__(6);

var _reactStyleable2 = _interopRequireDefault(_reactStyleable);

var _reactIntl = __webpack_require__(2);

var _index = __webpack_require__(1735);

var _index2 = _interopRequireDefault(_index);

var _textInput = __webpack_require__(1736);

var _textInput2 = _interopRequireDefault(_textInput);

var _index3 = __webpack_require__(48);

var _index4 = _interopRequireDefault(_index3);

var _index5 = __webpack_require__(37);

var _index6 = _interopRequireDefault(_index5);

var _dropdownList = __webpack_require__(1734);

var _dropdownList2 = _interopRequireDefault(_dropdownList);

var _index7 = __webpack_require__(7);

var _index8 = _interopRequireDefault(_index7);

var _iconDictionary = __webpack_require__(8);

var _messages = __webpack_require__(767);

var _messages2 = _interopRequireDefault(_messages);

var _index9 = __webpack_require__(24);

var _index10 = _interopRequireDefault(_index9);

var _index11 = __webpack_require__(36);

var _index12 = _interopRequireDefault(_index11);

var _signInCardsFormats = __webpack_require__(126);

var _signInCardsFormats2 = _interopRequireDefault(_signInCardsFormats);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var StudentDetails = function (_Component) {
    _inherits(StudentDetails, _Component);

    function StudentDetails() {
        var _ref;

        var _temp, _this, _ret;

        _classCallCheck(this, StudentDetails);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = StudentDetails.__proto__ || Object.getPrototypeOf(StudentDetails)).call.apply(_ref, [this].concat(args))), _this), _this.getChildren = function () {
            var _this$props = _this.props,
                showEditStudentValidationModal = _this$props.showEditStudentValidationModal,
                showModal = _this$props.showModal,
                handleOnCloseValidationModal = _this$props.handleOnCloseValidationModal,
                editStudentValidationMessage = _this$props.editStudentValidationMessage,
                handleOnPrintSignInCard = _this$props.handleOnPrintSignInCard,
                isSignInCardDownloaded = _this$props.isSignInCardDownloaded,
                handleOnCloseModal = _this$props.handleOnCloseModal;


            if (showEditStudentValidationModal) {
                return _react2.default.createElement(
                    _index12.default,
                    { handleOnCloseModal: handleOnCloseValidationModal, icon: _iconDictionary.Warning },
                    _react2.default.createElement(
                        'div',
                        null,
                        editStudentValidationMessage
                    )
                );
            } else if (showModal) {
                return _react2.default.createElement(_signInCardsFormats2.default, {
                    handleOnCancel: handleOnCloseModal,
                    handleOnDownloadSignInCards: handleOnPrintSignInCard,
                    isSignInCardDownloaded: isSignInCardDownloaded });
            }
            return '<div />';
        }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    _createClass(StudentDetails, [{
        key: 'render',
        value: function render() {
            return _react2.default.createElement(
                'div',
                null,
                _react2.default.createElement(
                    'div',
                    null,
                    _react2.default.createElement(
                        'div',
                        { className: this.props.css.studentDetailHeader },
                        this.props.intl.formatMessage(_messages2.default.studentDetails)
                    ),
                    _react2.default.createElement(
                        'div',
                        { className: this.props.css.panel },
                        _react2.default.createElement(
                            'div',
                            { className: this.props.css.leftPanel },
                            _react2.default.createElement(
                                'div',
                                null,
                                _react2.default.createElement(
                                    'div',
                                    { className: this.props.css.label },
                                    this.props.intl.formatMessage(_messages2.default.firstname)
                                ),
                                _react2.default.createElement(_index4.default, {
                                    css: _textInput2.default,
                                    handleOnChange: this.props.handleOnTextInputChange,
                                    maxLength: 50,
                                    name: 'firstName',
                                    value: this.props.student.firstName
                                })
                            ),
                            _react2.default.createElement(
                                'div',
                                null,
                                _react2.default.createElement(
                                    'div',
                                    { className: this.props.css.label },
                                    this.props.intl.formatMessage(_messages2.default.lastname)
                                ),
                                _react2.default.createElement(_index4.default, {
                                    css: _textInput2.default,
                                    handleOnChange: this.props.handleOnTextInputChange,
                                    maxLength: 50,
                                    name: 'lastName',
                                    value: this.props.student.lastName
                                })
                            ),
                            _react2.default.createElement(
                                'div',
                                null,
                                _react2.default.createElement(
                                    'div',
                                    { className: this.props.css.label },
                                    this.props.intl.formatMessage(_messages2.default.year)
                                ),
                                _react2.default.createElement(
                                    'div',
                                    { className: this.props.css.list },
                                    _react2.default.createElement(_index6.default, {
                                        css: _dropdownList2.default,
                                        name: 'yearGroupEnum',
                                        onChange: this.props.handleOnListChange,
                                        options: this.props.yearGroups,
                                        value: this.props.student.yearGroupEnum.toString() })
                                )
                            )
                        ),
                        _react2.default.createElement(
                            'div',
                            { className: this.props.css.rightPanel },
                            _react2.default.createElement(
                                'div',
                                null,
                                _react2.default.createElement(
                                    'div',
                                    { className: this.props.css.label },
                                    this.props.intl.formatMessage(_messages2.default.username)
                                ),
                                _react2.default.createElement(_index4.default, {
                                    css: _textInput2.default,
                                    disabled: true,
                                    maxLength: 50,
                                    name: 'userName',
                                    value: this.props.student.userName
                                })
                            ),
                            _react2.default.createElement(
                                'div',
                                null,
                                _react2.default.createElement(
                                    'div',
                                    { className: this.props.css.label },
                                    this.props.intl.formatMessage(_messages2.default.password)
                                ),
                                _react2.default.createElement(_index4.default, {
                                    css: _textInput2.default,
                                    handleOnChange: this.props.handleOnTextInputChange,
                                    maxLength: 50,
                                    name: 'password',
                                    value: this.props.student.password
                                })
                            ),
                            _react2.default.createElement(
                                'div',
                                null,
                                _react2.default.createElement('div', { className: this.props.css.label }),
                                _react2.default.createElement(
                                    'div',
                                    { className: this.props.css.warning },
                                    ' ',
                                    this.props.intl.formatMessage(_messages2.default.warning),
                                    ' '
                                )
                            )
                        )
                    ),
                    _react2.default.createElement(
                        'div',
                        { className: this.props.css.signCardPanel },
                        _react2.default.createElement(_index8.default, {
                            containerClassName: this.props.css.downloadSignInCards,
                            handleOnClick: this.props.downloadStudentsSignInCards,
                            icon: _iconDictionary.Download,
                            iconClassName: this.props.css.iconClassName,
                            label: this.props.intl.formatMessage(_messages2.default.downloadSignInCard)
                        })
                    )
                ),
                _react2.default.createElement(
                    _index10.default,
                    { show: this.props.showEditStudentValidationModal || this.props.showModal },
                    this.getChildren()
                )
            );
        }
    }]);

    return StudentDetails;
}(_react.Component);

StudentDetails.propTypes = {
    yearGroups: _propTypes2.default.arrayOf(_propTypes2.default.object),
    css: _propTypes2.default.object,
    student: _propTypes2.default.object,
    handleOnTextInputChange: _propTypes2.default.func,
    handleOnListChange: _propTypes2.default.func,
    showEditStudentValidationModal: _propTypes2.default.bool,
    editStudentValidationMessage: _propTypes2.default.string,
    handleOnCloseValidationModal: _propTypes2.default.func,
    handleOnPrintSignInCard: _propTypes2.default.func,
    isSignInCardDownloaded: _propTypes2.default.bool,
    intl: _reactIntl.intlShape.isRequired,
    showModal: _propTypes2.default.bool,
    downloadStudentsSignInCards: _propTypes2.default.func,
    handleOnCloseModal: _propTypes2.default.func
};

exports.default = (0, _reactIntl.injectIntl)((0, _reactStyleable2.default)(_index2.default)(StudentDetails));

/***/ }),
/* 767 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _reactIntl = __webpack_require__(2);

exports.default = (0, _reactIntl.defineMessages)({
    header: {
        id: 'app.components.StudentDetails.header',
        defaultMessage: 'This is the StudentDetails component !'
    },
    studentDetails: {
        id: 'app.components.StudentDetails.studentDetails',
        defaultMessage: 'Student details'
    },
    firstname: {
        id: 'app.components.StudentDetails.firstname',
        defaultMessage: 'FIRST NAME'
    },
    lastname: {
        id: 'app.components.StudentDetails.lastname',
        defaultMessage: 'SURNAME'
    },
    username: {
        id: 'app.components.StudentDetails.username',
        defaultMessage: 'USERNAME'
    },
    password: {
        id: 'app.components.StudentDetails.password',
        defaultMessage: 'PASSWORD'
    },
    warning: {
        id: 'app.components.StudentDetails.warning',
        defaultMessage: 'Username and password is used across all resources'
    },
    year: {
        id: 'app.components.StudentDetails.year',
        defaultMessage: 'YEAR'
    },
    downloadSignInCard: {
        id: 'app.components.StudentDetails.downSignInCard',
        defaultMessage: 'Download sign-in card'
    }
}); /*
     * StudentDetails Messages
     *
     * This contains all the text for the StudentDetails component.
     */

/***/ }),
/* 768 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactStyleable = __webpack_require__(6);

var _reactStyleable2 = _interopRequireDefault(_reactStyleable);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactIntl = __webpack_require__(2);

var _cloneDeep = __webpack_require__(54);

var _cloneDeep2 = _interopRequireDefault(_cloneDeep);

var _index = __webpack_require__(37);

var _index2 = _interopRequireDefault(_index);

var _index3 = __webpack_require__(190);

var _index4 = _interopRequireDefault(_index3);

__webpack_require__(26);

var _index5 = __webpack_require__(1737);

var _index6 = _interopRequireDefault(_index5);

var _index7 = __webpack_require__(7);

var _index8 = _interopRequireDefault(_index7);

var _variants = __webpack_require__(9);

var _messages = __webpack_require__(769);

var _messages2 = _interopRequireDefault(_messages);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var findSelected = function findSelected(item) {
    return item.selected;
};

var StudentFilter = function StudentFilter(_ref) {
    var lastNames = _ref.lastNames,
        yearGroups = _ref.yearGroups,
        classrooms = _ref.classrooms,
        _ref$searchTerm = _ref.searchTerm,
        searchTerm = _ref$searchTerm === undefined ? '' : _ref$searchTerm,
        handleFilterOnChange = _ref.handleFilterOnChange,
        handleFilterOnClear = _ref.handleFilterOnClear,
        handleOnSearch = _ref.handleOnSearch,
        intl = _ref.intl;

    var selectedYearGroup = yearGroups.find(findSelected);
    var selectedClassroom = classrooms.find(findSelected);

    var clonedLastNames = (0, _cloneDeep2.default)(lastNames);
    delete clonedLastNames['0'];

    var clonedYearGroup = (0, _cloneDeep2.default)(yearGroups);
    delete clonedYearGroup['0'];

    return _react2.default.createElement(
        'div',
        { className: _index6.default.filterContainer },
        _react2.default.createElement(
            'div',
            { className: _index6.default.filterContainer },
            _react2.default.createElement(
                'div',
                { className: _index6.default.filters },
                _react2.default.createElement(
                    'div',
                    { className: _index6.default.year },
                    _react2.default.createElement(_index2.default, {
                        name: 'yearGroups',
                        onChange: handleFilterOnChange,
                        options: clonedYearGroup,
                        placeholder: intl.formatMessage(_messages2.default.allYears),
                        value: selectedYearGroup.key })
                ),
                _react2.default.createElement(
                    'div',
                    { className: _index6.default.class },
                    _react2.default.createElement(_index2.default, {
                        name: 'classrooms',
                        onChange: handleFilterOnChange,
                        options: classrooms,
                        value: selectedClassroom.key })
                ),
                _react2.default.createElement(_index8.default, {
                    containerClassName: _index6.default.clear,
                    disabled: false,
                    handleOnClick: handleFilterOnClear,
                    label: intl.formatMessage(_messages2.default.clear),
                    variant: _variants.LIGHT }),
                _react2.default.createElement(
                    'div',
                    { className: _index6.default.studentSearchContainer },
                    _react2.default.createElement(_index4.default, { handleOnSearchClick: handleOnSearch, searchTerm: searchTerm })
                )
            )
        )
    );
};

StudentFilter.propTypes = {
    lastNames: _propTypes2.default.array,
    yearGroups: _propTypes2.default.array,
    classrooms: _propTypes2.default.array,
    searchTerm: _propTypes2.default.string,
    handleFilterOnChange: _propTypes2.default.func,
    handleFilterOnClear: _propTypes2.default.func,
    handleOnSearch: _propTypes2.default.func,
    intl: _reactIntl.intlShape.isRequired
};

exports.default = (0, _reactIntl.injectIntl)((0, _reactStyleable2.default)(_index6.default)(StudentFilter));

/***/ }),
/* 769 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _reactIntl = __webpack_require__(2);

exports.default = (0, _reactIntl.defineMessages)({
    defaultOptionStudentLastName: {
        id: 'app.components.studentFilter.defaultOptionStudentLastName',
        defaultMessage: 'All surnames'
    },
    defaultOptionStudentYearGroup: {
        id: 'app.components.studentFilter.defaultOptionStudentYearGroup',
        defaultMessage: 'All years'
    },
    defaultOptionStudentClass: {
        id: 'app.components.studentFilter.defaultOptionStudentClass',
        defaultMessage: 'All classes'
    },
    UnassignedStudent: {
        id: 'app.components.studentFilter.UnassignedStudent',
        defaultMessage: 'Unassigned students'
    },
    allSurnames: {
        id: 'app.components.studentFilter.allSurnames',
        defaultMessage: 'All surnames'
    },
    allYears: {
        id: 'app.components.studentFilter.allYears',
        defaultMessage: 'All years'
    },
    clear: {
        id: 'app.components.studentFilter.clear',
        defaultMessage: 'clear'
    }
}); /*
     * StudentFilter Messages
     *
     * This contains all the text for the StudentFilter component.
     */

/***/ }),
/* 770 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactIntl = __webpack_require__(2);

var _index = __webpack_require__(1738);

var _index2 = _interopRequireDefault(_index);

var _messages = __webpack_require__(771);

var _messages2 = _interopRequireDefault(_messages);

var _index3 = __webpack_require__(7);

var _index4 = _interopRequireDefault(_index3);

var _variants = __webpack_require__(9);

var _iconDictionary = __webpack_require__(8);

var _index5 = __webpack_require__(24);

var _index6 = _interopRequireDefault(_index5);

var _index7 = __webpack_require__(658);

var _index8 = _interopRequireDefault(_index7);

var _index9 = __webpack_require__(391);

var _index10 = _interopRequireDefault(_index9);

var _index11 = __webpack_require__(36);

var _index12 = _interopRequireDefault(_index11);

var _index13 = __webpack_require__(260);

var _index14 = _interopRequireDefault(_index13);

var _signInCardsFormats = __webpack_require__(126);

var _signInCardsFormats2 = _interopRequireDefault(_signInCardsFormats);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var StudentFooter = function StudentFooter(_ref) {
    var _ref$noOfSelectedStud = _ref.noOfSelectedStudents,
        noOfSelectedStudents = _ref$noOfSelectedStud === undefined ? 0 : _ref$noOfSelectedStud,
        handleOnStudentUnassign = _ref.handleOnStudentUnassign,
        handleOnStudentBulkPasswordChange = _ref.handleOnStudentBulkPasswordChange,
        handleOnDownloadSignInCards = _ref.handleOnDownloadSignInCards,
        showModal = _ref.showModal,
        handleOnCloseModal = _ref.handleOnCloseModal,
        handleOnUnassignConfirm = _ref.handleOnUnassignConfirm,
        isUserOperationModalOpen = _ref.isUserOperationModalOpen,
        handleOnBulkPasswordChangeConfirm = _ref.handleOnBulkPasswordChangeConfirm,
        handleOnChangeBulkPasswordSetValue = _ref.handleOnChangeBulkPasswordSetValue,
        isLoading = _ref.isLoading,
        studentsOperationSuccessConfirmation = _ref.studentsOperationSuccessConfirmation,
        isSignInCardDownloaded = _ref.isSignInCardDownloaded,
        handleOnStudentDeleteConfirmation = _ref.handleOnStudentDeleteConfirmation,
        handleOnDeleteStudent = _ref.handleOnDeleteStudent,
        operationType = _ref.operationType,
        bulkPasswordValue = _ref.bulkPasswordValue,
        intl = _ref.intl,
        handleOnDeleteConfirmation = _ref.handleOnDeleteConfirmation,
        downloadStudentsSignInCards = _ref.downloadStudentsSignInCards;

    var confirmation = _react2.default.createElement('div', null);
    switch (operationType) {
        case 'downloadSignInCard':
            confirmation = isUserOperationModalOpen ? _react2.default.createElement(_signInCardsFormats2.default, {
                handleOnCancel: handleOnCloseModal,
                handleOnDownloadSignInCards: handleOnDownloadSignInCards,
                isSignInCardDownloaded: isSignInCardDownloaded }) : _react2.default.createElement('div', null);
            break;
        case 'unassignUser':
            confirmation = isUserOperationModalOpen ? _react2.default.createElement(
                _index10.default,
                {
                    handleOnCancel: handleOnCloseModal,
                    handleOnOk: handleOnUnassignConfirm,
                    icon: _iconDictionary.Warning,
                    isLoading: isLoading,
                    title: intl.formatMessage(_messages2.default.unassignStudent, { s: noOfSelectedStudents > 1 ? 's' : '' }) },
                _react2.default.createElement(
                    'div',
                    null,
                    intl.formatMessage(_messages2.default.selectedStudentWill, { s: noOfSelectedStudents > 1 ? 's' : '' }),
                    _react2.default.createElement(
                        'span',
                        { className: _index2.default.highlight },
                        ' ' + intl.formatMessage(_messages2.default.unassignedFooter) + ' '
                    ),
                    intl.formatMessage(_messages2.default.mayLoseAccessToProducts)
                )
            ) : _react2.default.createElement(_index12.default, {
                handleOnCloseModal: studentsOperationSuccessConfirmation,
                icon: _iconDictionary.Tick,
                title: intl.formatMessage(_messages2.default.studentsUnassignedFooter, { s: noOfSelectedStudents > 1 ? 's' : '' }) });
            break;

        case 'deleteUser':
            confirmation = isUserOperationModalOpen ? _react2.default.createElement(_index14.default, {
                handleOnCancel: handleOnCloseModal,
                handleOnOk: handleOnDeleteStudent,
                heading: intl.formatMessage(_messages2.default.deleteConfirmation),
                icon: _iconDictionary.Warning,
                isLoading: isLoading,
                title: intl.formatMessage(_messages2.default.deleteStudents) }) : handleOnDeleteConfirmation();
            break;

        case 'bulkPasswordChange':
            confirmation = isUserOperationModalOpen ? _react2.default.createElement(_index8.default, {
                bulkPasswordValue: bulkPasswordValue,
                handleOnCancel: handleOnCloseModal,
                handleOnChange: handleOnChangeBulkPasswordSetValue,
                handleOnOk: handleOnBulkPasswordChangeConfirm,
                isLoading: isLoading,
                title: intl.formatMessage(_messages2.default.bulkPasswordChange) }) : _react2.default.createElement(_index12.default, {
                handleOnCloseModal: studentsOperationSuccessConfirmation,
                icon: _iconDictionary.Tick,
                title: intl.formatMessage(_messages2.default.bulkPasswordChangeSucess) });
            break;

        default:
            break;
    }

    return _react2.default.createElement(
        'div',
        { className: _index2.default.studentFooterComponent },
        _react2.default.createElement(
            'div',
            { className: _index2.default.buttonContainer },
            _react2.default.createElement(_index4.default, {
                containerClassName: _index2.default.bulkPasswordChange,
                disabled: noOfSelectedStudents < 2,
                handleOnClick: handleOnStudentBulkPasswordChange,
                label: intl.formatMessage(_messages2.default.bulkPasswordChange),
                variant: _variants.DARK,
                visible: true }),
            _react2.default.createElement(_index4.default, {
                containerClassName: _index2.default.deleteStudents,
                disabled: noOfSelectedStudents === 0,
                handleOnClick: handleOnStudentDeleteConfirmation,
                label: intl.formatMessage(_messages2.default.deleteStudents),
                variant: _variants.DARK,
                visible: true }),
            _react2.default.createElement(_index4.default, {
                containerClassName: _index2.default.downloadSignInCards,
                disabled: noOfSelectedStudents === 0,
                handleOnClick: downloadStudentsSignInCards,
                label: intl.formatMessage(_messages2.default.downloadSignInCards),
                variant: _variants.DARK,
                visible: true }),
            _react2.default.createElement(_index4.default, {
                containerClassName: _index2.default.unassign,
                disabled: noOfSelectedStudents === 0,
                handleOnClick: handleOnStudentUnassign,
                label: intl.formatMessage(_messages2.default.unassign),
                variant: _variants.DARK,
                visible: true })
        ),
        _react2.default.createElement(
            _index6.default,
            { show: showModal },
            confirmation
        )
    );
};

StudentFooter.propTypes = {
    noOfSelectedStudents: _propTypes2.default.number,
    handleOnStudentUnassign: _propTypes2.default.func,
    handleOnDownloadSignInCards: _propTypes2.default.func,
    studentsOperationSuccessConfirmation: _propTypes2.default.func,
    handleOnCloseModal: _propTypes2.default.func,
    handleOnUnassignConfirm: _propTypes2.default.func,
    showModal: _propTypes2.default.bool,
    isUserOperationModalOpen: _propTypes2.default.bool,
    handleOnStudentBulkPasswordChange: _propTypes2.default.func,
    handleOnBulkPasswordChangeConfirm: _propTypes2.default.func,
    handleOnChangeBulkPasswordSetValue: _propTypes2.default.func,
    bulkPasswordValue: _propTypes2.default.string,
    isLoading: _propTypes2.default.bool,
    isSignInCardDownloaded: _propTypes2.default.bool,
    handleOnStudentDeleteConfirmation: _propTypes2.default.func,
    intl: _reactIntl.intlShape.isRequired,
    handleOnDeleteStudent: _propTypes2.default.func,
    operationType: _propTypes2.default.string,
    handleOnDeleteConfirmation: _propTypes2.default.func,
    downloadStudentsSignInCards: _propTypes2.default.func
};

exports.default = (0, _reactIntl.injectIntl)(StudentFooter);

/***/ }),
/* 771 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _reactIntl = __webpack_require__(2);

exports.default = (0, _reactIntl.defineMessages)({
    downloadSignInCards: {
        id: 'student-footer.components.downloadSignInCards',
        defaultMessage: 'Download sign-in cards'
    },
    unassign: {
        id: 'student-footer.components.unassign',
        defaultMessage: 'Unassign'
    },
    unassignStudent: {
        id: 'student-footer.components.unassignStudent',
        defaultMessage: 'Unassign Student{s}'
    },
    studentsUnassignedFooter: {
        id: 'student-footer.components.studentsUnassignedFooter',
        defaultMessage: 'Student{s} have been unassigned'
    },
    downloading: {
        id: 'student-footer.components.downloading',
        defaultMessage: 'downloading'
    },
    selectedStudentWill: {
        id: 'student-footer.components.selectedStudentWill',
        defaultMessage: 'The selected student{s} will be'
    },
    unassignedFooter: {
        id: 'student-footer.components.unassignedFooter',
        defaultMessage: 'unassigned'
    },
    selectedStudentsWillBe: {
        id: 'student-footer.components.mayLoseAccessTselectedStudentsWillBeoProducts',
        defaultMessage: 'The selected student(s) will be'
    },
    mayLoseAccessToProducts: {
        id: 'student-footer.components.mayLoseAccessToProducts',
        defaultMessage: 'and may lose access to the current product.'
    },
    bulkPasswordChange: {
        id: 'student-footer.components.bulkPasswordChange',
        defaultMessage: 'Bulk Password Change'
    },
    bulkPasswordChangeSucess: {
        id: 'student-footer.components.bulkPasswordChangeSucess',
        defaultMessage: 'Passwords have been updated'
    },
    deleteStudents: {
        id: 'student-footer.components.deleteStudents',
        defaultMessage: 'Delete Students'
    },
    deleteStudentsTitle: {
        id: 'student-footer.components.deleteStudentsTitle',
        defaultMessage: 'Do you wish to delete the selected student(s) from school roll?'
    },
    studentsDeleted: {
        id: 'student-footer.components.studentsDeleted',
        defaultMessage: 'The selected student(s) will be removed from the school roll.'
    },
    deleteConfirmation: {
        id: 'student-footer.components.deleteConfirmation',
        defaultMessage: 'Some students are assigned to classes in other products, please confirm to delete from School Roll entirely.'
    },
    removedFromSchool: {
        id: 'student-footer.components.removedFromSchool',
        defaultMessage: 'and removed from school roll for all classes and products'
    },
    studentRemoveConfirmation: {
        id: 'student-footer.components.studentRemoveConfirmation',
        defaultMessage: 'The selected student(s) will be removed from the school roll'
    }
});

/***/ }),
/* 772 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactStyleable = __webpack_require__(6);

var _reactStyleable2 = _interopRequireDefault(_reactStyleable);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _PulseLoader = __webpack_require__(60);

var _PulseLoader2 = _interopRequireDefault(_PulseLoader);

var _reactIntl = __webpack_require__(2);

var _iconDictionary = __webpack_require__(8);

var _messages = __webpack_require__(773);

var _messages2 = _interopRequireDefault(_messages);

__webpack_require__(26);

var _index = __webpack_require__(1739);

var _index2 = _interopRequireDefault(_index);

var _index3 = __webpack_require__(7);

var _index4 = _interopRequireDefault(_index3);

var _variants = __webpack_require__(9);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var StudentHeader = function StudentHeader(_ref) {
    var _ref$filteredStudents = _ref.filteredStudentsCount,
        filteredStudentsCount = _ref$filteredStudents === undefined ? 0 : _ref$filteredStudents,
        _ref$isStudentDataLoa = _ref.isStudentDataLoaded,
        isStudentDataLoaded = _ref$isStudentDataLoa === undefined ? false : _ref$isStudentDataLoa,
        _ref$isStudentRollDow = _ref.isStudentRollDownloaded,
        isStudentRollDownloaded = _ref$isStudentRollDow === undefined ? true : _ref$isStudentRollDow,
        handleOnDownloadStudentRoll = _ref.handleOnDownloadStudentRoll,
        handleQuickUpload = _ref.handleQuickUpload,
        handleAddStudent = _ref.handleAddStudent,
        intl = _ref.intl;

    var studentsCount = isStudentDataLoaded ? _react2.default.createElement(
        'span',
        null,
        filteredStudentsCount
    ) : _react2.default.createElement(_PulseLoader2.default, { color: '#000', margin: '2px', size: '6px' });
    return _react2.default.createElement(
        'div',
        { className: _index2.default.studentHeaderComponent },
        _react2.default.createElement(
            'div',
            { className: _index2.default.studentsCountContainer },
            _react2.default.createElement(
                'span',
                { className: _index2.default.studentsTitle },
                intl.formatMessage(_messages2.default.students),
                _react2.default.createElement(
                    'span',
                    { className: _index2.default.studentsCount },
                    '( ',
                    studentsCount,
                    ' )'
                )
            )
        ),
        _react2.default.createElement(
            'div',
            { className: _index2.default.buttonContainer },
            _react2.default.createElement(_index4.default, {
                containerClassName: _index2.default.downloadStudentRoll,
                disabled: filteredStudentsCount === 0,
                handleOnClick: handleOnDownloadStudentRoll,
                icon: _iconDictionary.Download,
                iconClassName: _index2.default.svgIconContainer,
                label: intl.formatMessage(_messages2.default.downloadStudentRoll),
                loading: !isStudentRollDownloaded,
                loadingLabel: intl.formatMessage(_messages2.default.downloading),
                variant: _variants.DARK,
                visible: true }),
            _react2.default.createElement(_index4.default, {
                containerClassName: _index2.default.bulkUpload,
                disabled: false,
                handleOnClick: handleQuickUpload,
                icon: _iconDictionary.Plus,
                iconClassName: _index2.default.svgIconContainer,
                label: intl.formatMessage(_messages2.default.quickUpload),
                variant: _variants.DARK,
                visible: true }),
            _react2.default.createElement(_index4.default, {
                containerClassName: _index2.default.addStudent,
                disabled: !isStudentDataLoaded,
                handleOnClick: handleAddStudent,
                icon: _iconDictionary.Plus,
                iconClassName: _index2.default.svgIconContainer,
                label: intl.formatMessage(_messages2.default.addStudent),
                variant: _variants.DARK,
                visible: true })
        )
    );
};

StudentHeader.propTypes = {
    isStudentDataLoaded: _propTypes2.default.bool,
    isStudentRollDownloaded: _propTypes2.default.bool,
    filteredStudentsCount: _propTypes2.default.number,
    handleOnDownloadStudentRoll: _propTypes2.default.func,
    handleQuickUpload: _propTypes2.default.func,
    handleAddStudent: _propTypes2.default.func,
    intl: _reactIntl.intlShape.isRequired
};

exports.default = (0, _reactIntl.injectIntl)((0, _reactStyleable2.default)(_index2.default)(StudentHeader));

/***/ }),
/* 773 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _reactIntl = __webpack_require__(2);

exports.default = (0, _reactIntl.defineMessages)({
    downloadStudentRoll: {
        id: 'student-header.components.downloadStudentRoll',
        defaultMessage: 'Download student roll'
    },
    quickUpload: {
        id: 'student-header.components.quickUpload',
        defaultMessage: 'Quick upload'
    },
    addStudent: {
        id: 'student-header.components.addStudent',
        defaultMessage: 'Add student'
    },
    students: {
        id: 'student-header.components.students',
        defaultMessage: 'Students'
    },
    downloading: {
        id: 'student-header.components.downloading',
        defaultMessage: 'downloading'
    }
}); /*
     * student-header messages
     *
     * This contains all the text for the student-header component.
     */

/***/ }),
/* 774 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactStyleable = __webpack_require__(6);

var _reactStyleable2 = _interopRequireDefault(_reactStyleable);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _cloneDeep = __webpack_require__(54);

var _cloneDeep2 = _interopRequireDefault(_cloneDeep);

var _PulseLoader = __webpack_require__(60);

var _PulseLoader2 = _interopRequireDefault(_PulseLoader);

var _reactIntl = __webpack_require__(2);

var _index = __webpack_require__(1740);

var _index2 = _interopRequireDefault(_index);

var _index3 = __webpack_require__(772);

var _index4 = _interopRequireDefault(_index3);

var _index5 = __webpack_require__(768);

var _index6 = _interopRequireDefault(_index5);

var _index7 = __webpack_require__(153);

var _index8 = __webpack_require__(253);

var gridFormatters = _interopRequireWildcard(_index8);

var _index9 = __webpack_require__(76);

var _index10 = _interopRequireDefault(_index9);

var _index11 = __webpack_require__(770);

var _index12 = _interopRequireDefault(_index11);

var _index13 = __webpack_require__(24);

var _index14 = _interopRequireDefault(_index13);

var _index15 = __webpack_require__(630);

var _index16 = _interopRequireDefault(_index15);

var _iconDictionary = __webpack_require__(8);

var _index17 = __webpack_require__(764);

var _index18 = _interopRequireDefault(_index17);

var _index19 = __webpack_require__(150);

var _index20 = _interopRequireDefault(_index19);

var _messages = __webpack_require__(775);

var _messages2 = _interopRequireDefault(_messages);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function getGridColumns(selectedProduct, handleGridSort, handleOnStudentEdit, intl, handleOnAssignClass) {
    return [{
        key: 'firstName',
        name: '' + intl.formatMessage(_messages2.default.firstName),
        resizable: true,
        width: 150,
        sortable: true,
        headerRenderer: _react2.default.createElement(gridFormatters.HeaderFormatter, { onSort: handleGridSort })
    }, {
        key: 'lastName',
        name: '' + intl.formatMessage(_messages2.default.surname),
        resizable: true,
        width: 150,
        sortable: true,
        headerRenderer: _react2.default.createElement(gridFormatters.HeaderFormatter, { onSort: handleGridSort })
    }, {
        key: 'yearGroupEnum',
        name: '' + intl.formatMessage(_messages2.default.year),
        sortable: true,
        width: 70,
        formatter: gridFormatters.YearGroupFormatter,
        getRowMetaData: function getRowMetaData(row) {
            return row;
        },
        headerRenderer: _react2.default.createElement(gridFormatters.HeaderFormatter, { onSort: handleGridSort })
    }, {
        key: 'userName',
        name: '' + intl.formatMessage(_messages2.default.username),
        width: 200,
        sortable: true,
        resizable: true,
        headerRenderer: _react2.default.createElement(gridFormatters.HeaderFormatter, { onSort: handleGridSort })
    }, {
        key: 'password',
        name: '' + intl.formatMessage(_messages2.default.password),
        width: 130,
        sortable: true,
        headerRenderer: _react2.default.createElement(gridFormatters.HeaderFormatter, { onSort: handleGridSort })
    }, {
        key: 'class',
        name: selectedProduct.name.toUpperCase() + ' ' + intl.formatMessage(_messages2.default.classes),
        width: 200,
        resizable: true,
        getRowMetaData: function getRowMetaData(row) {
            return row;
        },
        formatter: _react2.default.createElement(gridFormatters.AssignedClassFormatter, { handleOnAssignClass: handleOnAssignClass })
    }, {
        key: 'group',
        width: 200,
        name: '' + intl.formatMessage(_messages2.default.groups),
        resizable: true,
        formatter: gridFormatters.AssignedGroupFormatter
    }, {
        key: 'teachers',
        name: '' + intl.formatMessage(_messages2.default.teachers),
        width: 200,
        resizable: true,
        formatter: gridFormatters.AssignedGroupFormatter
    }, {
        key: '',
        name: ''
    }, {
        key: 'edit',
        name: '' + intl.formatMessage(_messages2.default.edit),
        width: 70,
        locked: true,
        getRowMetaData: function getRowMetaData(row) {
            return row;
        },
        formatter: _react2.default.createElement(gridFormatters.EditInfoFormatter, { handleOnEdit: handleOnStudentEdit })
    }];
}

var StudentRoll = function StudentRoll(_ref) {
    var students = _ref.students,
        studentsCount = _ref.studentsCount,
        _ref$selectedStudents = _ref.selectedStudents,
        selectedStudents = _ref$selectedStudents === undefined ? [] : _ref$selectedStudents,
        isStudentDataLoaded = _ref.isStudentDataLoaded,
        isStudentRollDownloaded = _ref.isStudentRollDownloaded,
        gridRowGetter = _ref.gridRowGetter,
        onGridSort = _ref.onGridSort,
        onRowSelect = _ref.onRowSelect,
        onDownloadStudentRoll = _ref.onDownloadStudentRoll,
        onQuickUpload = _ref.onQuickUpload,
        onAddStudent = _ref.onAddStudent,
        onAddAnotherStudent = _ref.onAddAnotherStudent,
        dataFilterOptions = _ref.dataFilterOptions,
        filterOnChange = _ref.filterOnChange,
        filterOnClear = _ref.filterOnClear,
        onSearch = _ref.onSearch,
        selectedProduct = _ref.selectedProduct,
        handleOnStudentUnassign = _ref.handleOnStudentUnassign,
        showModal = _ref.showModal,
        handleOnCloseModal = _ref.handleOnCloseModal,
        handleOnUnassignConfirm = _ref.handleOnUnassignConfirm,
        isUserOperationModalOpen = _ref.isUserOperationModalOpen,
        studentsOperationSuccessConfirmation = _ref.studentsOperationSuccessConfirmation,
        unassignStudentsSuccessConfirmation = _ref.unassignStudentsSuccessConfirmation,
        handleOnStudentBulkPasswordChange = _ref.handleOnStudentBulkPasswordChange,
        handleOnStudentBulkPasswordChangeCloseModal = _ref.handleOnStudentBulkPasswordChangeCloseModal,
        handleOnBulkPasswordChangeConfirm = _ref.handleOnBulkPasswordChangeConfirm,
        bulkPasswordChangeSuccessConfirmation = _ref.bulkPasswordChangeSuccessConfirmation,
        handleOnChangeBulkPasswordSetValue = _ref.handleOnChangeBulkPasswordSetValue,
        bulkPasswordValue = _ref.bulkPasswordValue,
        isLoading = _ref.isLoading,
        showAddStudentsModal = _ref.showAddStudentsModal,
        onAddStudentCloseModal = _ref.onAddStudentCloseModal,
        classrooms = _ref.classrooms,
        student = _ref.student,
        isSaveInProgress = _ref.isSaveInProgress,
        handleOnAddStudentSubmit = _ref.handleOnAddStudentSubmit,
        showAddStudentValidationModal = _ref.showAddStudentValidationModal,
        addStudentValidationMessage = _ref.addStudentValidationMessage,
        closeAddStudentValidationModal = _ref.closeAddStudentValidationModal,
        showAddStudentConfirmationModal = _ref.showAddStudentConfirmationModal,
        isSignInCardDownloaded = _ref.isSignInCardDownloaded,
        handleOnPrintSignInCard = _ref.handleOnPrintSignInCard,
        handleOnPrintMultipleSignInCard = _ref.handleOnPrintMultipleSignInCard,
        handleOnStudentEdit = _ref.handleOnStudentEdit,
        intl = _ref.intl,
        handleOnAssignClass = _ref.handleOnAssignClass,
        filteredStudentsCount = _ref.filteredStudentsCount,
        handleOnStudentDeleteConfirmation = _ref.handleOnStudentDeleteConfirmation,
        handleOnStudentDeleteClose = _ref.handleOnStudentDeleteClose,
        isDeleteUserModalOpen = _ref.isDeleteUserModalOpen,
        handleOnDeleteStudent = _ref.handleOnDeleteStudent,
        operationType = _ref.operationType,
        handleOnDeleteConfirmation = _ref.handleOnDeleteConfirmation,
        classroomGroups = _ref.classroomGroups,
        getClassroomGroups = _ref.getClassroomGroups,
        downloadStudentsSignInCards = _ref.downloadStudentsSignInCards,
        showHideSignInCardModal = _ref.showHideSignInCardModal,
        handleOnStudentSignInCards = _ref.handleOnStudentSignInCards,
        handleOnCancelStudentSignInCards = _ref.handleOnCancelStudentSignInCards;

    var loaderView = _react2.default.createElement(
        'div',
        { className: _index2.default.studentListContainer },
        _react2.default.createElement(
            'div',
            { className: _index2.default.loadingContainer },
            _react2.default.createElement(_PulseLoader2.default, { className: _index2.default.loader })
        )
    );

    var loadAddStudentModalComponent = function loadAddStudentModalComponent() {
        var modalComponent = '';
        if (showAddStudentConfirmationModal) {
            modalComponent = _react2.default.createElement(_index18.default, {
                handleOnAddStudent: onAddAnotherStudent,
                handleOnCancelStudentSignInCards: handleOnCancelStudentSignInCards,
                handleOnCloseModal: onAddStudentCloseModal,
                handleOnPrintSignInCard: handleOnPrintSignInCard,
                handleOnStudentSignInCards: handleOnStudentSignInCards,
                icon: _iconDictionary.Tick,
                isSignInCardDownloaded: isSignInCardDownloaded,
                showHideSignInCardModal: showHideSignInCardModal,
                title: intl.formatMessage(_messages2.default.addStudentConfirmation)
            });
        } else {
            var yearGroups = (0, _cloneDeep2.default)(dataFilterOptions.yearGroups);
            yearGroups[0].value = intl.formatMessage(_messages2.default.yearGroupList);
            modalComponent = _react2.default.createElement(_index16.default, {
                addStudentValidationMessage: addStudentValidationMessage,
                classes: classrooms,
                classroomGroups: classroomGroups,
                closeAddStudentValidationModal: closeAddStudentValidationModal,
                getClassroomGroups: getClassroomGroups,
                handleOnAddStudentSubmit: handleOnAddStudentSubmit,
                handleOnCloseModal: onAddStudentCloseModal,
                isSaveInProgress: isSaveInProgress,
                selectedProduct: selectedProduct,
                showAddStudentValidationModal: showAddStudentValidationModal,
                student: student,
                yearGroups: yearGroups
            });
        }

        return modalComponent;
    };

    var addStudentModalView = _react2.default.createElement(
        _index14.default,
        { show: showAddStudentsModal },
        loadAddStudentModalComponent()
    );

    dataFilterOptions.classrooms[0].value = intl.formatMessage(_messages2.default.assignedStudents);
    dataFilterOptions.classrooms[1].value = intl.formatMessage(_messages2.default.allClasses);
    dataFilterOptions.classrooms[2].value = intl.formatMessage(_messages2.default.unassignedStudents);

    var emptyStateView = _react2.default.createElement(
        'div',
        { className: _index2.default.studentListContainer },
        _react2.default.createElement(_index6.default, {
            classrooms: dataFilterOptions.classrooms,
            handleFilterOnChange: filterOnChange,
            handleFilterOnClear: filterOnClear,
            handleOnSearch: onSearch,
            lastNames: dataFilterOptions.lastNames,
            searchTerm: dataFilterOptions.searchTerm,
            yearGroups: dataFilterOptions.yearGroups }),
        _react2.default.createElement(_index10.default, {
            iconName: _iconDictionary.StudentManagement,
            message: intl.formatMessage(_messages2.default.noStudentsAvailable) }),
        addStudentModalView
    );

    var dataView = _react2.default.createElement(
        'div',
        { className: _index2.default.studentListContainer },
        _react2.default.createElement(_index6.default, {
            classrooms: dataFilterOptions.classrooms,
            handleFilterOnChange: filterOnChange,
            handleFilterOnClear: filterOnClear,
            handleOnSearch: onSearch,
            lastNames: dataFilterOptions.lastNames,
            searchTerm: dataFilterOptions.searchTerm,
            yearGroups: dataFilterOptions.yearGroups }),
        _react2.default.createElement(_index20.default, {
            columns: getGridColumns(selectedProduct, onGridSort, handleOnStudentEdit, intl, handleOnAssignClass),
            handleGridSort: onGridSort,
            handleRowSelect: onRowSelect,
            overScan: { colsStart: 17, colsEnd: 17, rowsStart: 25, rowsEnd: 25 },
            rowGetter: gridRowGetter,
            rowHeight: 150,
            rowKey: 'userProfileId',
            rowRenderer: _index7.StudentRowRenderer,
            rowsCount: students.length,
            selectedRows: selectedStudents.length > 0 ? selectedStudents : []
        }),
        addStudentModalView
    );

    var finalView = void 0;
    if (!isStudentDataLoaded) {
        finalView = loaderView;
    } else {
        finalView = filteredStudentsCount === 0 ? emptyStateView : dataView;
    }
    var studentsComponent = _react2.default.createElement(
        'div',
        { className: _index2.default.studentRollComponent },
        _react2.default.createElement(_index4.default, {
            filteredStudentsCount: students.length,
            handleAddStudent: onAddStudent,
            handleOnDownloadStudentRoll: onDownloadStudentRoll,
            handleQuickUpload: onQuickUpload,
            isStudentDataLoaded: isStudentDataLoaded,
            isStudentRollDownloaded: isStudentRollDownloaded,
            studentsCountInSchool: studentsCount }),
        finalView,
        _react2.default.createElement(_index12.default, {
            bulkPasswordChangeSuccessConfirmation: bulkPasswordChangeSuccessConfirmation,
            bulkPasswordValue: bulkPasswordValue,
            downloadStudentsSignInCards: downloadStudentsSignInCards,
            handleOnBulkPasswordChangeConfirm: handleOnBulkPasswordChangeConfirm,
            handleOnChangeBulkPasswordSetValue: handleOnChangeBulkPasswordSetValue,
            handleOnCloseModal: handleOnCloseModal,
            handleOnDeleteConfirmation: handleOnDeleteConfirmation,
            handleOnDeleteStudent: handleOnDeleteStudent,
            handleOnDownloadSignInCards: handleOnPrintMultipleSignInCard,
            handleOnStudentBulkPasswordChange: handleOnStudentBulkPasswordChange,
            handleOnStudentBulkPasswordChangeCloseModal: handleOnStudentBulkPasswordChangeCloseModal,
            handleOnStudentDeleteClose: handleOnStudentDeleteClose,
            handleOnStudentDeleteConfirmation: handleOnStudentDeleteConfirmation,
            handleOnStudentUnassign: handleOnStudentUnassign,
            handleOnUnassignConfirm: handleOnUnassignConfirm,
            isDeleteUserModalOpen: isDeleteUserModalOpen,
            isLoading: isLoading,
            isSignInCardDownloaded: isSignInCardDownloaded,
            isUserOperationModalOpen: isUserOperationModalOpen,
            noOfSelectedStudents: selectedStudents.length,
            operationType: operationType,
            showModal: showModal,
            studentsOperationSuccessConfirmation: studentsOperationSuccessConfirmation,
            unassignStudentsSuccessConfirmation: unassignStudentsSuccessConfirmation
        })
    );

    return _react2.default.createElement(
        'div',
        { className: _index2.default.studentRollComponent },
        studentsComponent
    );
};

StudentRoll.propTypes = {
    isStudentDataLoaded: _propTypes2.default.bool,
    isStudentRollDownloaded: _propTypes2.default.bool,
    showAddStudentConfirmationModal: _propTypes2.default.bool,
    student: _propTypes2.default.object,
    students: _propTypes2.default.arrayOf(_propTypes2.default.object),
    classrooms: _propTypes2.default.arrayOf(_propTypes2.default.object),
    selectedStudents: _propTypes2.default.arrayOf(_propTypes2.default.number),
    gridRowGetter: _propTypes2.default.func,
    studentsCount: _propTypes2.default.number,
    filteredStudentsCount: _propTypes2.default.number,
    onGridSort: _propTypes2.default.func,
    onRowSelect: _propTypes2.default.func,
    onDownloadStudentRoll: _propTypes2.default.func,
    onQuickUpload: _propTypes2.default.func,
    onAddStudent: _propTypes2.default.func,
    closeAddStudentValidationModal: _propTypes2.default.func,
    dataFilterOptions: _propTypes2.default.object,
    filterOnChange: _propTypes2.default.func,
    filterOnClear: _propTypes2.default.func,
    onSearch: _propTypes2.default.func,
    onAddStudentCloseModal: _propTypes2.default.func,
    handleOnAddStudentSubmit: _propTypes2.default.func,
    selectedProduct: _propTypes2.default.object,
    showAddStudentsModal: _propTypes2.default.bool,
    isSaveInProgress: _propTypes2.default.bool,
    showAddStudentValidationModal: _propTypes2.default.bool,
    isSignInCardDownloaded: _propTypes2.default.bool,
    addStudentValidationMessage: _propTypes2.default.string,
    handleOnPrintSignInCard: _propTypes2.default.func,
    handleOnPrintMultipleSignInCard: _propTypes2.default.func,
    handleOnStudentUnassign: _propTypes2.default.func,
    handleOnCloseModal: _propTypes2.default.func,
    showModal: _propTypes2.default.bool,
    handleOnUnassignConfirm: _propTypes2.default.func,
    isUserOperationModalOpen: _propTypes2.default.bool,
    isLoading: _propTypes2.default.bool,
    studentsOperationSuccessConfirmation: _propTypes2.default.func,
    unassignStudentsSuccessConfirmation: _propTypes2.default.func,
    handleOnStudentBulkPasswordChange: _propTypes2.default.func,
    handleOnStudentBulkPasswordChangeCloseModal: _propTypes2.default.func,
    handleOnBulkPasswordChangeConfirm: _propTypes2.default.func,
    handleOnChangeBulkPasswordSetValue: _propTypes2.default.func,
    bulkPasswordChangeSuccessConfirmation: _propTypes2.default.func,
    bulkPasswordValue: _propTypes2.default.string,
    onAddAnotherStudent: _propTypes2.default.func,
    handleOnStudentEdit: _propTypes2.default.func,
    intl: _reactIntl.intlShape.isRequired,
    handleOnAssignClass: _propTypes2.default.func,
    handleOnStudentDeleteConfirmation: _propTypes2.default.func,
    handleOnStudentDeleteClose: _propTypes2.default.func,
    isDeleteUserModalOpen: _propTypes2.default.bool,
    handleOnDeleteStudent: _propTypes2.default.func,
    operationType: _propTypes2.default.string,
    handleOnDeleteConfirmation: _propTypes2.default.func,
    classroomGroups: _propTypes2.default.arrayOf(_propTypes2.default.object),
    getClassroomGroups: _propTypes2.default.func,
    downloadStudentsSignInCards: _propTypes2.default.func,
    showHideSignInCardModal: _propTypes2.default.bool,
    handleOnStudentSignInCards: _propTypes2.default.func,
    handleOnCancelStudentSignInCards: _propTypes2.default.func
};

exports.default = (0, _reactIntl.injectIntl)((0, _reactStyleable2.default)(_index2.default)(StudentRoll));

/***/ }),
/* 775 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _reactIntl = __webpack_require__(2);

exports.default = (0, _reactIntl.defineMessages)({
    addStudentConfirmation: {
        id: 'app.components.studentRoll.addStudentConfirmation',
        defaultMessage: 'Student added'
    },
    yearGroupList: {
        id: 'app.components.studentRoll.yearGroupList',
        defaultMessage: 'Year'
    },
    firstName: {
        id: 'app.components.studentRoll.firstName',
        defaultMessage: 'FIRST NAME'
    },
    surname: {
        id: 'app.components.studentRoll.surname',
        defaultMessage: 'SURNAME'
    },
    year: {
        id: 'app.components.studentRoll.year',
        defaultMessage: 'YEAR'
    },
    username: {
        id: 'app.components.studentRoll.username',
        defaultMessage: 'USERNAME'
    },
    password: {
        id: 'app.components.studentRoll.password',
        defaultMessage: 'PASSWORD'
    },
    classes: {
        id: 'app.components.studentRoll.classes',
        defaultMessage: 'CLASSES'
    },
    groups: {
        id: 'app.components.studentRoll.groups',
        defaultMessage: 'GROUPS'
    },
    teachers: {
        id: 'app.components.studentRoll.teachers',
        defaultMessage: 'TEACHERS'
    },
    edit: {
        id: 'app.components.studentRoll.edit',
        defaultMessage: 'EDIT'
    },
    noStudentsAvailable: {
        id: 'app.components.studentRoll.noStudentsAvailable',
        defaultMessage: 'No students available'
    },
    allSurnames: {
        id: 'app.components.studentRoll.allSurnames',
        defaultMessage: 'All surnames'
    },
    allYears: {
        id: 'app.components.studentRoll.allYears',
        defaultMessage: 'All years'
    },
    allClasses: {
        id: 'app.components.studentRoll.allClasses',
        defaultMessage: 'All classes'
    },
    unassignedStudents: {
        id: 'app.components.studentRoll.unassignedStudents',
        defaultMessage: 'Unassigned students'
    },
    assignedStudents: {
        id: 'app.components.studentRoll.assignedStudents',
        defaultMessage: 'Assigned students'
    }
});

/***/ }),
/* 776 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _reactIntl = __webpack_require__(2);

exports.default = (0, _reactIntl.defineMessages)({
    doYouWishToContinue: {
        id: 'app.components.studentUnAssign.doYouWishToContinue',
        defaultMessage: 'Do you wish to continue?'
    }
});

/***/ }),
/* 777 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactStyleable = __webpack_require__(6);

var _reactStyleable2 = _interopRequireDefault(_reactStyleable);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRouterDom = __webpack_require__(244);

__webpack_require__(26);

var _index = __webpack_require__(1743);

var _index2 = _interopRequireDefault(_index);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TabButton = function TabButton(_ref) {
    var name = _ref.name,
        route = _ref.route;

    var linkName = '/' + route.toLowerCase();
    return _react2.default.createElement(
        _reactRouterDom.NavLink,
        {
            activeClassName: _index2.default.highlight,
            className: _index2.default.tabButtonComponent,
            exact: true,
            to: { pathname: linkName }
        },
        name
    );
};

TabButton.propTypes = {
    name: _propTypes2.default.string,
    route: _propTypes2.default.string
};

exports.default = (0, _reactStyleable2.default)(_index2.default)(TabButton);

/***/ }),
/* 778 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactStyleable = __webpack_require__(6);

var _reactStyleable2 = _interopRequireDefault(_reactStyleable);

var _reactIntl = __webpack_require__(2);

var _iconDictionary = __webpack_require__(8);

var _index = __webpack_require__(1744);

var _index2 = _interopRequireDefault(_index);

var _index3 = __webpack_require__(7);

var _index4 = _interopRequireDefault(_index3);

var _index5 = __webpack_require__(780);

var _index6 = _interopRequireDefault(_index5);

var _messages = __webpack_require__(779);

var _messages2 = _interopRequireDefault(_messages);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TeacherClassDetail = function TeacherClassDetail(_ref) {
    var editTeacherDetail = _ref.editTeacherDetail,
        handleOnUnassignTeacher = _ref.handleOnUnassignTeacher,
        productName = _ref.productName,
        isUnassignedModalOpen = _ref.isUnassignedModalOpen,
        handleOnUnassignConfirm = _ref.handleOnUnassignConfirm,
        handleOnCloseModal = _ref.handleOnCloseModal,
        unassignTeachersSuccessConfirmation = _ref.unassignTeachersSuccessConfirmation,
        showUnassignTeacherModal = _ref.showUnassignTeacherModal,
        isLoading = _ref.isLoading,
        downloadingClassroomIds = _ref.downloadingClassroomIds,
        intl = _ref.intl,
        handleOnAssignClass = _ref.handleOnAssignClass;

    var assignedClassrooms = editTeacherDetail !== undefined ? editTeacherDetail.assignedClassrooms : [];
    return _react2.default.createElement(
        'div',
        { className: _index2.default.classDetailComponent },
        _react2.default.createElement(
            'div',
            { className: _index2.default.title },
            intl.formatMessage(_messages2.default.classDetails),
            ' (',
            productName,
            ')'
        ),
        _react2.default.createElement(
            'div',
            { className: _index2.default.header },
            _react2.default.createElement(_index6.default, {
                assignedClassrooms: assignedClassrooms,
                downloadingClassroomIds: downloadingClassroomIds,
                handleOnCloseModal: handleOnCloseModal,
                handleOnTeacherUnassign: handleOnUnassignTeacher,
                handleOnUnassignConfirm: handleOnUnassignConfirm,
                isLoading: isLoading,
                isUnassignedModalOpen: isUnassignedModalOpen,
                showUnassignTeacherModal: showUnassignTeacherModal,
                unassignTeachersSuccessConfirmation: unassignTeachersSuccessConfirmation
            })
        ),
        _react2.default.createElement(
            'div',
            { className: _index2.default.footer },
            _react2.default.createElement(_index4.default, {
                containerClassName: _index2.default.assignClass,
                handleOnClick: handleOnAssignClass,
                icon: _iconDictionary.Plus,
                iconClassName: _index2.default.icon,
                label: intl.formatMessage(_messages2.default.assignClasses) })
        )
    );
};

TeacherClassDetail.propTypes = {
    editTeacherDetail: _propTypes2.default.object,
    productName: _propTypes2.default.string,
    handleOnUnassignTeacher: _propTypes2.default.func,
    handleOnUnassignConfirm: _propTypes2.default.func,
    handleOnCloseModal: _propTypes2.default.func,
    unassignTeachersSuccessConfirmation: _propTypes2.default.func,
    isUnassignedModalOpen: _propTypes2.default.bool,
    showUnassignTeacherModal: _propTypes2.default.bool,
    isLoading: _propTypes2.default.bool,
    downloadingClassroomIds: _propTypes2.default.object,
    intl: _reactIntl.intlShape.isRequired,
    handleOnAssignClass: _propTypes2.default.func
};

exports.default = (0, _reactIntl.injectIntl)((0, _reactStyleable2.default)(_index2.default)(TeacherClassDetail));

/***/ }),
/* 779 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _reactIntl = __webpack_require__(2);

exports.default = (0, _reactIntl.defineMessages)({
    assignClasses: {
        id: 'app.components.TeacherClassDetail.assignClasses',
        defaultMessage: 'Assign Class(es)'
    },
    classDetails: {
        id: 'app.components.TeacherClassDetail.classDetails',
        defaultMessage: 'Class details'
    }
});

/***/ }),
/* 780 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _map = __webpack_require__(139);

var _map2 = _interopRequireDefault(_map);

var _reactStyleable = __webpack_require__(6);

var _reactStyleable2 = _interopRequireDefault(_reactStyleable);

var _reactIntl = __webpack_require__(2);

var _iconDictionary = __webpack_require__(8);

var _index = __webpack_require__(1745);

var _index2 = _interopRequireDefault(_index);

var _index3 = __webpack_require__(7);

var _index4 = _interopRequireDefault(_index3);

var _messages = __webpack_require__(781);

var _messages2 = _interopRequireDefault(_messages);

var _index5 = __webpack_require__(24);

var _index6 = _interopRequireDefault(_index5);

var _index7 = __webpack_require__(258);

var _index8 = _interopRequireDefault(_index7);

var _index9 = __webpack_require__(36);

var _index10 = _interopRequireDefault(_index9);

var _classCourses = __webpack_require__(252);

var _classCourses2 = _interopRequireDefault(_classCourses);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var TeacherClassList = function (_Component) {
    _inherits(TeacherClassList, _Component);

    function TeacherClassList(props) {
        _classCallCheck(this, TeacherClassList);

        var _this = _possibleConstructorReturn(this, (TeacherClassList.__proto__ || Object.getPrototypeOf(TeacherClassList)).call(this, props));

        _this.showSignInCardFormat = function (classId) {
            _this.selectedClassroomId = classId;
            _this.props.handleOnStudentSignInCards();
        };

        _this.renderChildren = function () {
            var _this$props = _this.props,
                unassignTeachersSuccessConfirmation = _this$props.unassignTeachersSuccessConfirmation,
                isUnassignedModalOpen = _this$props.isUnassignedModalOpen,
                handleOnCloseModal = _this$props.handleOnCloseModal,
                handleOnUnassignConfirm = _this$props.handleOnUnassignConfirm,
                isLoading = _this$props.isLoading,
                intl = _this$props.intl,
                showUnassignTeacherModal = _this$props.showUnassignTeacherModal;

            var children = null;
            if (showUnassignTeacherModal) {
                if (isUnassignedModalOpen) {
                    children = _react2.default.createElement(
                        _index8.default,
                        {
                            handleOnCancel: handleOnCloseModal,
                            handleOnOk: handleOnUnassignConfirm,
                            icon: _iconDictionary.Warning,
                            isLoading: isLoading,
                            title: intl.formatMessage(_messages2.default.unassignTeacher) },
                        _react2.default.createElement(
                            'div',
                            null,
                            intl.formatMessage(_messages2.default.selectedTeacherWillBe),
                            ' ',
                            _react2.default.createElement(
                                'span',
                                { className: _index2.default.highlight },
                                intl.formatMessage(_messages2.default.unassigned)
                            ),
                            ' ',
                            intl.formatMessage(_messages2.default.loseAccessToProducts),
                            '.'
                        )
                    );
                } else {
                    children = _react2.default.createElement(_index10.default, {
                        handleOnCloseModal: unassignTeachersSuccessConfirmation,
                        icon: _iconDictionary.Tick,
                        title: intl.formatMessage(_messages2.default.teachersUnassigned) });
                }
            }
            return children;
        };

        _this.renderCourses = function (_ref) {
            var courseName = _ref.courseName,
                conquestCourseName = _ref.conquestCourseName,
                upfCourseName = _ref.upfCourseName,
                yearGroup = _ref.yearGroup,
                intl = _ref.intl;
            return (0, _classCourses2.default)({
                yearGroup: yearGroup,
                courseTitle: courseName,
                conquestCourseTitle: conquestCourseName,
                upfCourseTitle: upfCourseName,
                intl: intl });
        };

        _this.selectedClassroomId = -1;
        return _this;
    }

    _createClass(TeacherClassList, [{
        key: 'render',
        value: function render() {
            var _this2 = this;

            var _props = this.props,
                assignedClassrooms = _props.assignedClassrooms,
                handleOnTeacherUnassign = _props.handleOnTeacherUnassign,
                showUnassignTeacherModal = _props.showUnassignTeacherModal,
                showHideSignInCardModal = _props.showHideSignInCardModal,
                intl = _props.intl;

            return _react2.default.createElement(
                'div',
                null,
                _react2.default.createElement(
                    'div',
                    { className: _index2.default.header },
                    _react2.default.createElement(
                        'div',
                        { className: _index2.default.classNameColumn },
                        intl.formatMessage(_messages2.default.class)
                    ),
                    _react2.default.createElement(
                        'div',
                        { className: _index2.default.courseNameColumn },
                        intl.formatMessage(_messages2.default.course)
                    ),
                    _react2.default.createElement(
                        'div',
                        { className: _index2.default.yearGroupColumn },
                        intl.formatMessage(_messages2.default.year)
                    ),
                    _react2.default.createElement('div', { className: _index2.default.unassignColumn })
                ),
                (0, _map2.default)(assignedClassrooms, function (classInfo) {
                    return _react2.default.createElement(
                        'div',
                        { className: _index2.default.list, key: classInfo.id },
                        _react2.default.createElement(
                            'div',
                            { className: _index2.default.classNameColumn },
                            classInfo.name
                        ),
                        _react2.default.createElement(
                            'div',
                            { className: _index2.default.courseNameColumn },
                            _this2.renderCourses(_extends({}, classInfo, { intl: intl }))
                        ),
                        _react2.default.createElement(
                            'div',
                            { className: _index2.default.yearGroupColumn },
                            classInfo.yearGroupName
                        ),
                        _react2.default.createElement(
                            'div',
                            { className: _index2.default.unassignColumn },
                            _react2.default.createElement(_index4.default, {
                                containerClassName: _index2.default.unassignClass,
                                handleOnClick: function handleOnClick() {
                                    return handleOnTeacherUnassign(classInfo.id);
                                },
                                icon: _iconDictionary.Cross,
                                iconClassName: _index2.default.icon })
                        )
                    );
                }),
                _react2.default.createElement(
                    _index6.default,
                    { show: showUnassignTeacherModal || showHideSignInCardModal },
                    this.renderChildren()
                )
            );
        }
    }]);

    return TeacherClassList;
}(_react.Component);

TeacherClassList.propTypes = {
    assignedClassrooms: _propTypes2.default.array,
    handleOnTeacherUnassign: _propTypes2.default.func,
    showUnassignTeacherModal: _propTypes2.default.bool,
    unassignTeachersSuccessConfirmation: _propTypes2.default.func,
    isUnassignedModalOpen: _propTypes2.default.bool,
    handleOnUnassignConfirm: _propTypes2.default.func,
    handleOnCloseModal: _propTypes2.default.func,
    isLoading: _propTypes2.default.bool,
    intl: _reactIntl.intlShape.isRequired,
    handleOnStudentSignInCards: _propTypes2.default.func,
    showHideSignInCardModal: _propTypes2.default.bool
};

exports.default = (0, _reactIntl.injectIntl)((0, _reactStyleable2.default)(_index2.default)(TeacherClassList));

/***/ }),
/* 781 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _reactIntl = __webpack_require__(2);

exports.default = (0, _reactIntl.defineMessages)({
    class: {
        id: 'app.components.TeacherClassList.class',
        defaultMessage: 'CLASS'
    },
    group: {
        id: 'app.components.TeacherClassList.group',
        defaultMessage: 'GROUP'
    },
    course: {
        id: 'app.components.TeacherClassList.course',
        defaultMessage: 'COURSE'
    },
    teacher: {
        id: 'app.components.TeacherClassList.teacher',
        defaultMessage: 'TEACHER'
    },
    year: {
        id: 'app.components.TeacherClassList.year',
        defaultMessage: 'YEAR'
    },
    unassignTeacher: {
        id: 'app.components.TeacherClassList.unassignTeachers',
        defaultMessage: 'Unassign Teacher'
    },
    teachersUnassigned: {
        id: 'app.components.TeacherClassList.teachersUnassigned',
        defaultMessage: 'Teacher have been unassigned'
    },
    selectedTeacherWillBe: {
        id: 'app.components.TeacherClassList.selectedTeacherWillBe',
        defaultMessage: 'The selected teacher will be'
    },
    unassigned: {
        id: 'app.components.TeacherClassList.unassigned',
        defaultMessage: 'unassigned'
    },
    loseAccessToProducts: {
        id: 'app.components.TeacherClassList.loseAccessToProducts',
        defaultMessage: 'and will lose all access to their licenced products'
    },
    downloadSignInCard: {
        id: 'app.components.TeacherClassList.downloadSignInCard',
        defaultMessage: 'Download sign-in cards'
    }
});

/***/ }),
/* 782 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactIntl = __webpack_require__(2);

var _iconDictionary = __webpack_require__(8);

var _index = __webpack_require__(1746);

var _index2 = _interopRequireDefault(_index);

var _svgIcon = __webpack_require__(21);

var _svgIcon2 = _interopRequireDefault(_svgIcon);

var _index3 = __webpack_require__(7);

var _index4 = _interopRequireDefault(_index3);

var _messages = __webpack_require__(783);

var _messages2 = _interopRequireDefault(_messages);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TeacherConfirmation = function TeacherConfirmation(_ref) {
    var icon = _ref.icon,
        title = _ref.title,
        handleOnAddTeacher = _ref.handleOnAddTeacher,
        handleOnCloseModal = _ref.handleOnCloseModal,
        intl = _ref.intl;
    return _react2.default.createElement(
        'div',
        { className: _index2.default.teacherConfirmationContainer },
        _react2.default.createElement(
            'div',
            { className: _index2.default.icon },
            _react2.default.createElement(_svgIcon2.default, { icon: icon })
        ),
        _react2.default.createElement(
            'div',
            { className: _index2.default.title },
            title
        ),
        _react2.default.createElement(_index4.default, {
            buttonContainer: _index2.default.buttonContainer,
            containerClassName: _index2.default.buttonWrapper,
            handleOnClick: handleOnAddTeacher,
            icon: _iconDictionary.Plus,
            iconClassName: _index2.default.buttonIcon,
            label: intl.formatMessage(_messages2.default.addAnotherTeacher) }),
        _react2.default.createElement(_index4.default, {
            buttonContainer: _index2.default.buttonContainer,
            containerClassName: _index2.default.buttonWrapper,
            handleOnClick: handleOnCloseModal,
            icon: _iconDictionary.Tick,
            iconClassName: _index2.default.buttonIcon,
            label: intl.formatMessage(_messages2.default.done) })
    );
};

TeacherConfirmation.propTypes = {
    icon: _propTypes2.default.string,
    title: _propTypes2.default.string,
    handleOnAddTeacher: _propTypes2.default.func,
    handleOnCloseModal: _propTypes2.default.func,
    intl: _reactIntl.intlShape.isRequired
};

exports.default = (0, _reactIntl.injectIntl)(TeacherConfirmation);

/***/ }),
/* 783 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _reactIntl = __webpack_require__(2);

exports.default = (0, _reactIntl.defineMessages)({
    addAnotherTeacher: {
        id: 'app.components.TeacherConfirmation.addAnotherTeacher',
        defaultMessage: 'Add another teacher'
    },
    printSignInCard: {
        id: 'app.components.TeacherConfirmation.printSignInCard',
        defaultMessage: 'Print sign-in card'
    },
    done: {
        id: 'app.components.TeacherConfirmation.done',
        defaultMessage: 'Done'
    },
    downloading: {
        id: 'app.components.TeacherConfirmation.header',
        defaultMessage: 'downloading...'
    }
});

/***/ }),
/* 784 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactStyleable = __webpack_require__(6);

var _reactStyleable2 = _interopRequireDefault(_reactStyleable);

var _reactIntl = __webpack_require__(2);

var _utils = __webpack_require__(13);

var _index = __webpack_require__(1748);

var _index2 = _interopRequireDefault(_index);

var _textInput = __webpack_require__(1749);

var _textInput2 = _interopRequireDefault(_textInput);

var _index3 = __webpack_require__(48);

var _index4 = _interopRequireDefault(_index3);

var _index5 = __webpack_require__(37);

var _index6 = _interopRequireDefault(_index5);

var _dropdownList = __webpack_require__(1747);

var _dropdownList2 = _interopRequireDefault(_dropdownList);

var _index7 = __webpack_require__(7);

var _index8 = _interopRequireDefault(_index7);

var _messages = __webpack_require__(785);

var _messages2 = _interopRequireDefault(_messages);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var TeacherDetails = function (_Component) {
    _inherits(TeacherDetails, _Component);

    function TeacherDetails(props) {
        _classCallCheck(this, TeacherDetails);

        var _this = _possibleConstructorReturn(this, (TeacherDetails.__proto__ || Object.getPrototypeOf(TeacherDetails)).call(this, props));

        _this.renderPasswordSection = function (showVerifyEmailLink) {
            return _react2.default.createElement(
                'div',
                { className: _this.props.css.passwordButtonSection },
                _react2.default.createElement(
                    'div',
                    null,
                    _this.state.showResetPasswordSection ? _react2.default.createElement(
                        'div',
                        null,
                        _react2.default.createElement(
                            'div',
                            { className: _this.props.css.passwordSection },
                            _react2.default.createElement(
                                'div',
                                {
                                    className: _this.props.css.passwordLabel },
                                _this.props.intl.formatMessage(_messages2.default.newTeacherPassword)
                            ),
                            _react2.default.createElement(
                                'div',
                                { className: _this.props.css.password },
                                _react2.default.createElement(_index4.default, {
                                    css: _textInput2.default,
                                    handleOnChange: _this.props.handleOnPasswordInputChange,
                                    maxLength: 25,
                                    name: 'newPassword',
                                    type: 'password'
                                })
                            )
                        ),
                        _react2.default.createElement(
                            'div',
                            { className: _this.props.css.passwordSection },
                            _react2.default.createElement(
                                'div',
                                {
                                    className: _this.props.css.passwordLabel },
                                _this.props.intl.formatMessage(_messages2.default.repeatTeacherPassword)
                            ),
                            _react2.default.createElement(
                                'div',
                                { className: _this.props.css.password },
                                _react2.default.createElement(_index4.default, {
                                    css: _textInput2.default,
                                    handleOnChange: _this.props.handleOnPasswordInputChange,
                                    maxLength: 25,
                                    name: 'confirmationPassword',
                                    type: 'password'
                                })
                            )
                        ),
                        _react2.default.createElement(
                            'div',
                            { className: _this.props.css.passwordSection },
                            _react2.default.createElement('div', { className: _this.props.css.passwordLabel }),
                            _react2.default.createElement(
                                'div',
                                { className: _this.props.css.informationMessage },
                                _react2.default.createElement(
                                    'div',
                                    {
                                        className: _this.props.css.warning },
                                    ' ',
                                    _this.props.intl.formatMessage(_messages2.default.warning),
                                    ' '
                                ),
                                _react2.default.createElement(
                                    'div',
                                    {
                                        className: _this.props.css.warning },
                                    ' ',
                                    _this.props.intl.formatMessage(_messages2.default.passwordWarning),
                                    ' '
                                )
                            )
                        )
                    ) : _react2.default.createElement('div', null)
                ),
                _react2.default.createElement(
                    'div',
                    { className: _this.props.css.linkButtonPanel },
                    _react2.default.createElement(
                        'div',
                        { className: _this.props.css.linkButtons },
                        _react2.default.createElement(_index8.default, {
                            containerClassName: _this.props.css.linkButton,
                            disabled: !_this.state.email,
                            handleOnClick: function handleOnClick() {
                                return _this.props.handleOnSendTeacherPassword('passwordReset');
                            },
                            label: _this.props.intl.formatMessage(_messages2.default.teacherPasswordLink)
                        })
                    ),
                    showVerifyEmailLink && _react2.default.createElement(
                        'div',
                        { className: _this.props.css.linkButtons },
                        _react2.default.createElement(_index8.default, {
                            containerClassName: _this.props.css.linkButton,
                            disabled: !_this.state.email || _this.props.teacher.isEmailVerified,
                            handleOnClick: function handleOnClick() {
                                return _this.props.handleOnSendTeacherPassword('verifyEmail');
                            },
                            label: _this.props.intl.formatMessage(_messages2.default.teacherVerifyEmailLink)
                        })
                    )
                )
            );
        };

        _this.onSelection = function (element) {
            _this.setState({ showResetPasswordSection: element.target.checked });
            _this.props.resetPassword(element.target.checked);
        };

        _this.state = {
            showResetPasswordSection: false,
            email: props.teacher.emailAddress
        };
        return _this;
    }

    _createClass(TeacherDetails, [{
        key: 'render',
        value: function render() {
            //  window.pppAppConfig returns string values from configuration
            var config = (0, _utils.getAppConfig)();
            var showVerifyEmailLink = config ? config.showVerifyEmailLink === 'true' : false;

            var title = this.props.teacher.title.toString() === '' ? 'None' : this.props.teacher.title.toString();

            return _react2.default.createElement(
                'div',
                { className: this.props.css.teacherDetailContainer },
                _react2.default.createElement(
                    'div',
                    {
                        className: this.props.css.teacherDetailHeader },
                    this.props.intl.formatMessage(_messages2.default.teacherDetails)
                ),
                _react2.default.createElement(
                    'div',
                    { className: this.props.css.panel },
                    _react2.default.createElement(
                        'div',
                        { className: this.props.css.leftPanel },
                        _react2.default.createElement(
                            'div',
                            { className: this.props.css.dataItem },
                            _react2.default.createElement(
                                'div',
                                { className: this.props.css.label },
                                this.props.intl.formatMessage(_messages2.default.title)
                            ),
                            _react2.default.createElement(
                                'div',
                                { className: this.props.css.list },
                                _react2.default.createElement(_index6.default, {
                                    css: _dropdownList2.default,
                                    name: 'title',
                                    onChange: this.props.handleOnListChange,
                                    options: this.props.teacherTitles,
                                    value: title })
                            )
                        ),
                        _react2.default.createElement(
                            'div',
                            { className: this.props.css.dataItem },
                            _react2.default.createElement(
                                'div',
                                {
                                    className: this.props.css.label },
                                this.props.intl.formatMessage(_messages2.default.firstname)
                            ),
                            _react2.default.createElement(_index4.default, {
                                css: _textInput2.default,
                                handleOnChange: this.props.handleOnTextInputChange,
                                maxLength: 50,
                                name: 'firstName',
                                value: this.props.teacher.firstName
                            })
                        ),
                        _react2.default.createElement(
                            'div',
                            { className: this.props.css.dataItem },
                            _react2.default.createElement(
                                'div',
                                {
                                    className: this.props.css.label },
                                this.props.intl.formatMessage(_messages2.default.lastname)
                            ),
                            _react2.default.createElement(_index4.default, {
                                css: _textInput2.default,
                                handleOnChange: this.props.handleOnTextInputChange,
                                maxLength: 50,
                                name: 'lastName',
                                value: this.props.teacher.lastName
                            })
                        ),
                        _react2.default.createElement(
                            'div',
                            { className: this.props.css.dataItem },
                            _react2.default.createElement(
                                'div',
                                {
                                    className: this.props.css.label },
                                this.props.intl.formatMessage(_messages2.default.emailaddress)
                            ),
                            showVerifyEmailLink && this.state.email && !this.props.teacher.isEmailVerified ? _react2.default.createElement(
                                'div',
                                { className: this.props.css.dataItem },
                                _react2.default.createElement(
                                    'div',
                                    {
                                        className: this.props.css.label },
                                    '\xA0'
                                ),
                                _react2.default.createElement(
                                    'div',
                                    { className: this.props.css.emailUnverified },
                                    this.props.intl.formatMessage(_messages2.default.emailUnverified)
                                )
                            ) : '',
                            _react2.default.createElement(_index4.default, {
                                css: _textInput2.default,
                                handleOnChange: this.props.handleEmailInputOnChange,
                                maxLength: 70,
                                name: 'emailAddress',
                                value: this.props.teacher.emailAddress
                            })
                        )
                    ),
                    _react2.default.createElement(
                        'div',
                        { className: this.props.css.rightPanel },
                        _react2.default.createElement(
                            'div',
                            { className: this.props.css.dataItem },
                            _react2.default.createElement(
                                'div',
                                {
                                    className: this.props.css.label },
                                this.props.intl.formatMessage(_messages2.default.username)
                            ),
                            _react2.default.createElement(_index4.default, {
                                css: _textInput2.default,
                                disabled: true,
                                maxLength: 50,
                                name: 'userName',
                                value: this.props.teacher.userName
                            })
                        ),
                        _react2.default.createElement(
                            'div',
                            { className: this.props.css.buttonPanel },
                            _react2.default.createElement(
                                'div',
                                { className: this.props.css.reset },
                                _react2.default.createElement(
                                    'div',
                                    { className: this.props.css.checkbox },
                                    _react2.default.createElement('input', {
                                        className: this.props.css.name,
                                        id: 'chkResetPassword',
                                        onChange: this.onSelection,
                                        type: 'checkbox'
                                    }),
                                    _react2.default.createElement('label', { className: this.props.css.chklabel, htmlFor: 'chkResetPassword' }),
                                    _react2.default.createElement(
                                        'span',
                                        {
                                            className: this.props.css.className },
                                        this.props.intl.formatMessage(_messages2.default.resetTeacherPassword)
                                    )
                                )
                            )
                        ),
                        _react2.default.createElement(
                            'div',
                            null,
                            this.renderPasswordSection(showVerifyEmailLink)
                        )
                    )
                )
            );
        }
    }]);

    return TeacherDetails;
}(_react.Component);

TeacherDetails.propTypes = {
    css: _propTypes2.default.object,
    teacher: _propTypes2.default.object,
    teacherTitles: _propTypes2.default.arrayOf(_propTypes2.default.object),
    handleOnTextInputChange: _propTypes2.default.func,
    handleEmailInputOnChange: _propTypes2.default.func,
    handleOnListChange: _propTypes2.default.func,
    intl: _reactIntl.intlShape.isRequired,
    handleOnPasswordInputChange: _propTypes2.default.func,
    handleOnSendTeacherPassword: _propTypes2.default.func,
    resetPassword: _propTypes2.default.func
};

exports.default = (0, _reactIntl.injectIntl)((0, _reactStyleable2.default)(_index2.default)(TeacherDetails));

/***/ }),
/* 785 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _reactIntl = __webpack_require__(2);

exports.default = (0, _reactIntl.defineMessages)({
    header: {
        id: 'app.components.TeacherDetails.header',
        defaultMessage: 'This is the TeacherDetails component !'
    },
    teacherDetails: {
        id: 'app.components.TeacherDetails.teacherDetails',
        defaultMessage: 'Teacher details'
    },
    title: {
        id: 'app.components.TeacherDetails.title',
        defaultMessage: 'TITLE'
    },
    firstname: {
        id: 'app.components.TeacherDetails.firstname',
        defaultMessage: 'FIRST NAME'
    },
    lastname: {
        id: 'app.components.TeacherDetails.lastname',
        defaultMessage: 'SURNAME'
    },
    emailaddress: {
        id: 'app.components.TeacherDetails.emailaddress',
        defaultMessage: 'EMAIL'
    },
    username: {
        id: 'app.components.TeacherDetails.username',
        defaultMessage: 'USERNAME'
    },
    password: {
        id: 'app.components.TeacherDetails.password',
        defaultMessage: 'PASSWORD'
    },
    warning: {
        id: 'app.components.TeacherDetails.warning',
        defaultMessage: 'Username and password is used across all resources'
    },
    passwordWarning: {
        id: 'app.components.TeacherDetails.passwordWarning',
        defaultMessage: 'Please ensure the new teacher password is at least 8 characters long and contains both letters and numbers'
    },
    adminPassword: {
        id: 'app.components.TeacherDetails.adminPassword',
        defaultMessage: 'ADMIN PASSWORD'
    },
    newTeacherPassword: {
        id: 'app.components.TeacherDetails.newTeacherPassword',
        defaultMessage: 'NEW TEACHER PASSWORD'
    },
    repeatTeacherPassword: {
        id: 'app.components.TeacherDetails.repeatTeacherPassword',
        defaultMessage: 'CONFIRM TEACHER PASSWORD'
    },
    resetTeacherPassword: {
        id: 'app.components.TeacherDetails.resetTeacherPassword',
        defaultMessage: 'Reset teacher password'
    },
    teacherPasswordLink: {
        id: 'app.components.TeacherDetails.teacherPasswordLink',
        defaultMessage: 'Send teacher password link'
    },
    teacherVerifyEmailLink: {
        id: 'app.components.TeacherDetails.teacherVerifyEmailLink',
        defaultMessage: 'Send verify email link'
    },
    emailUnverified: {
        id: 'app.components.TeacherDetails.emailUnverified',
        defaultMessage: 'Email unverified'
    }
}); /*
     * TeacherDetails Messages
     *
     * This contains all the text for the TeacherDetails component.
     */

/***/ }),
/* 786 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactStyleable = __webpack_require__(6);

var _reactStyleable2 = _interopRequireDefault(_reactStyleable);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactIntl = __webpack_require__(2);

var _index = __webpack_require__(37);

var _index2 = _interopRequireDefault(_index);

var _index3 = __webpack_require__(190);

var _index4 = _interopRequireDefault(_index3);

__webpack_require__(26);

var _index5 = __webpack_require__(1750);

var _index6 = _interopRequireDefault(_index5);

var _index7 = __webpack_require__(7);

var _index8 = _interopRequireDefault(_index7);

var _variants = __webpack_require__(9);

var _messages = __webpack_require__(787);

var _messages2 = _interopRequireDefault(_messages);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var findSelected = function findSelected(item) {
    return item.selected;
};

var TeacherFilter = function TeacherFilter(_ref) {
    var lastNames = _ref.lastNames,
        classrooms = _ref.classrooms,
        _ref$searchTerm = _ref.searchTerm,
        searchTerm = _ref$searchTerm === undefined ? '' : _ref$searchTerm,
        handleFilterOnChange = _ref.handleFilterOnChange,
        handleFilterOnClear = _ref.handleFilterOnClear,
        handleOnSearch = _ref.handleOnSearch,
        intl = _ref.intl;

    var selectedClassroom = classrooms.find(findSelected);

    lastNames[0].value = intl.formatMessage(_messages2.default.allSurnames);
    classrooms[0].value = intl.formatMessage(_messages2.default.allClasses);
    classrooms[1].value = intl.formatMessage(_messages2.default.UnassignedTeacher);

    return _react2.default.createElement(
        'div',
        { className: _index6.default.filterContainer },
        _react2.default.createElement(
            'div',
            { className: _index6.default.filterContainer },
            _react2.default.createElement(
                'div',
                { className: _index6.default.filters },
                _react2.default.createElement(
                    'div',
                    { className: _index6.default.class },
                    _react2.default.createElement(_index2.default, {
                        name: 'classrooms',
                        onChange: handleFilterOnChange,
                        options: classrooms,
                        value: selectedClassroom.key })
                ),
                _react2.default.createElement(_index8.default, {
                    containerClassName: _index6.default.clear,
                    disabled: false,
                    handleOnClick: handleFilterOnClear,
                    label: intl.formatMessage(_messages2.default.clear),
                    variant: _variants.LIGHT }),
                _react2.default.createElement(
                    'div',
                    { className: _index6.default.teacherSearchContainer },
                    _react2.default.createElement(_index4.default, { handleOnSearchClick: handleOnSearch, searchTerm: searchTerm })
                )
            )
        )
    );
};

TeacherFilter.propTypes = {
    lastNames: _propTypes2.default.array,
    classrooms: _propTypes2.default.array,
    searchTerm: _propTypes2.default.string,
    handleFilterOnChange: _propTypes2.default.func,
    handleFilterOnClear: _propTypes2.default.func,
    handleOnSearch: _propTypes2.default.func,
    intl: _reactIntl.intlShape.isRequired
};

exports.default = (0, _reactIntl.injectIntl)((0, _reactStyleable2.default)(_index6.default)(TeacherFilter));

/***/ }),
/* 787 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _reactIntl = __webpack_require__(2);

exports.default = (0, _reactIntl.defineMessages)({
    defaultOptionStudentLastName: {
        id: 'app.components.teacherFilter.defaultOptionStudentLastName',
        defaultMessage: 'All surnames'
    },
    defaultOptionStudentYearGroup: {
        id: 'app.components.teacherFilter.defaultOptionStudentYearGroup',
        defaultMessage: 'All years'
    },
    defaultOptionStudentClass: {
        id: 'app.components.teacherFilter.defaultOptionStudentClass',
        defaultMessage: 'All classes'
    },
    UnassignedTeacher: {
        id: 'app.components.teacherFilter.UnassignedTeacher',
        defaultMessage: 'Unassigned teachers'
    },
    clear: {
        id: 'app.components.teacherFilter.clear',
        defaultMessage: 'clear'
    },
    allSurnames: {
        id: 'app.components.teacherFilter.allSurnames',
        defaultMessage: 'All surnames'
    },
    allClasses: {
        id: 'app.components.teacherFilter.allClasses',
        defaultMessage: 'All classes'
    }
}); /*
     * TeacherFilter Messages
     *
     * This contains all the text for the TeacherFilter component.
     */

/***/ }),
/* 788 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactIntl = __webpack_require__(2);

var _index = __webpack_require__(1751);

var _index2 = _interopRequireDefault(_index);

var _messages = __webpack_require__(789);

var _messages2 = _interopRequireDefault(_messages);

var _index3 = __webpack_require__(7);

var _index4 = _interopRequireDefault(_index3);

var _variants = __webpack_require__(9);

var _iconDictionary = __webpack_require__(8);

var _index5 = __webpack_require__(24);

var _index6 = _interopRequireDefault(_index5);

var _index7 = __webpack_require__(258);

var _index8 = _interopRequireDefault(_index7);

var _index9 = __webpack_require__(36);

var _index10 = _interopRequireDefault(_index9);

var _index11 = __webpack_require__(260);

var _index12 = _interopRequireDefault(_index11);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TeacherFooter = function TeacherFooter(_ref) {
    var _ref$noOfSelectedTeac = _ref.noOfSelectedTeachers,
        noOfSelectedTeachers = _ref$noOfSelectedTeac === undefined ? 0 : _ref$noOfSelectedTeac,
        handleOnTeacherUnassign = _ref.handleOnTeacherUnassign,
        showModal = _ref.showModal,
        handleOnCloseModal = _ref.handleOnCloseModal,
        handleOnUnassignConfirm = _ref.handleOnUnassignConfirm,
        isUserOperationModalOpen = _ref.isUserOperationModalOpen,
        isLoading = _ref.isLoading,
        handleOnTeacherDeleteOpenModal = _ref.handleOnTeacherDeleteOpenModal,
        handleOnDeleteTeacher = _ref.handleOnDeleteTeacher,
        operationType = _ref.operationType,
        teachersOperationSuccessConfirmation = _ref.teachersOperationSuccessConfirmation,
        intl = _ref.intl,
        deletingTeacher = _ref.deletingTeacher;

    var confirmation = _react2.default.createElement('div', null);

    switch (operationType) {
        case 'unassignTeacher':
            confirmation = isUserOperationModalOpen ? _react2.default.createElement(
                _index8.default,
                {
                    handleOnCancel: handleOnCloseModal,
                    handleOnOk: handleOnUnassignConfirm,
                    icon: _iconDictionary.Warning,
                    isLoading: isLoading,
                    title: intl.formatMessage(_messages2.default.unassignTeachers) },
                _react2.default.createElement(
                    'div',
                    null,
                    intl.formatMessage(_messages2.default.selectedTeachersWillBe),
                    ' ',
                    _react2.default.createElement(
                        'span',
                        {
                            className: _index2.default.highlight },
                        intl.formatMessage(_messages2.default.unassigned)
                    ),
                    ' ',
                    intl.formatMessage(_messages2.default.loseAccessToProducts),
                    '.'
                )
            ) : _react2.default.createElement(_index10.default, {
                handleOnCloseModal: teachersOperationSuccessConfirmation,
                icon: _iconDictionary.Tick,
                title: intl.formatMessage(_messages2.default.teachersUnassigned) });
            break;
        case 'deleteTeacher':
            confirmation = isUserOperationModalOpen ? _react2.default.createElement(_index12.default, {
                handleOnCancel: handleOnCloseModal,
                handleOnOk: handleOnDeleteTeacher,
                heading: intl.formatMessage(_messages2.default.deleteConfirmation),
                icon: _iconDictionary.Warning,
                isLoading: isLoading,
                title: intl.formatMessage(_messages2.default.deleteTeachers) }) : _react2.default.createElement(_index10.default, {
                handleOnCloseModal: teachersOperationSuccessConfirmation,
                icon: _iconDictionary.Tick,
                title: intl.formatMessage(_messages2.default.teachersDeleted) });
            break;
        default:
            break;
    }

    return _react2.default.createElement(
        'div',
        { className: _index2.default.teacherFooterComponent },
        _react2.default.createElement(
            'div',
            { className: _index2.default.buttonContainer },
            _react2.default.createElement(_index4.default, {
                containerClassName: _index2.default.deleteTeachers,
                disabled: noOfSelectedTeachers === 0 || deletingTeacher,
                handleOnClick: handleOnTeacherDeleteOpenModal,
                label: intl.formatMessage(_messages2.default.deleteTeachers),
                variant: _variants.DARK,
                visible: true }),
            _react2.default.createElement(_index4.default, {
                containerClassName: _index2.default.unassign,
                disabled: noOfSelectedTeachers === 0 || deletingTeacher,
                handleOnClick: handleOnTeacherUnassign,
                label: intl.formatMessage(_messages2.default.unassign),
                variant: _variants.DARK,
                visible: true })
        ),
        _react2.default.createElement(
            _index6.default,
            { show: showModal },
            confirmation
        )
    );
};

TeacherFooter.propTypes = {
    noOfSelectedTeachers: _propTypes2.default.number,
    handleOnTeacherUnassign: _propTypes2.default.func,
    handleOnCloseModal: _propTypes2.default.func,
    handleOnUnassignConfirm: _propTypes2.default.func,
    showModal: _propTypes2.default.bool,
    isUserOperationModalOpen: _propTypes2.default.bool,
    isLoading: _propTypes2.default.bool,
    intl: _reactIntl.intlShape.isRequired,
    handleOnDeleteTeacher: _propTypes2.default.func,
    operationType: _propTypes2.default.string,
    handleOnTeacherDeleteOpenModal: _propTypes2.default.func,
    teachersOperationSuccessConfirmation: _propTypes2.default.func,
    deletingTeacher: _propTypes2.default.bool
};

exports.default = (0, _reactIntl.injectIntl)(TeacherFooter);

/***/ }),
/* 789 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _reactIntl = __webpack_require__(2);

exports.default = (0, _reactIntl.defineMessages)({
    unassign: {
        id: 'teacher-footer.components.unassign',
        defaultMessage: 'Unassign'
    },
    unassignTeachers: {
        id: 'teacher-footer.components.unassignTeachers',
        defaultMessage: 'Unassign teachers'
    },
    teachersUnassigned: {
        id: 'teacher-footer.components.teachersUnassigned',
        defaultMessage: 'Teachers have been unassigned'
    },
    selectedTeachersWillBe: {
        id: 'teacher-footer.components.selectedTeacherWillBe',
        defaultMessage: 'The selected teacher(s) will be removed from the school roll.'
    },
    unassigned: {
        id: 'teacher-footer.components.unassigned',
        defaultMessage: 'unassigned'
    },
    loseAccessToProducts: {
        id: 'teacher-footer.components.loseAccessToProducts',
        defaultMessage: 'and will lose all access to their licenced products'
    },
    deleteTeachers: {
        id: 'teacher-footer.components.deleteTeachers',
        defaultMessage: 'Delete Teachers'
    },
    deleteTeachersTitle: {
        id: 'teacher-footer.components.deleteTeachersTitle',
        defaultMessage: 'Do you wish to delete the selected teacher(s) from school roll?'
    },
    teachersDeleted: {
        id: 'teacher-footer.components.teachersDeleted',
        defaultMessage: 'Teacher(s) have been deleted'
    },
    deleteConfirmation: {
        id: 'teacher-footer.components.deleteConfirmation',
        defaultMessage: 'Some teachers are assigned to classes in other products, please confirm to delete from School Roll entirely.'
    },
    removedFromSchool: {
        id: 'teacher-footer.components.removedFromSchool',
        defaultMessage: 'and removed from school roll for all classes and products'
    },
    wishToDelete: {
        id: 'teacher-footer.components.wishToDelete',
        defaultMessage: 'Do you wish to delete the selected teacher(s) from school roll?'
    },
    bulkPasswordChange: {
        id: 'teacher-footer.components.bulkPasswordChange',
        defaultMessage: 'Bulk Password Change'
    },
    bulkPasswordChangeSuccess: {
        id: 'teacher-footer.components.bulkPasswordChangeSucess',
        defaultMessage: 'Passwords have been updated'
    },
    sendVerificationEmails: {
        id: 'teacher-footer.components.sendVerificationEmails',
        defaultMessage: 'Send verification emails'
    }
});

/***/ }),
/* 790 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactStyleable = __webpack_require__(6);

var _reactStyleable2 = _interopRequireDefault(_reactStyleable);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _PulseLoader = __webpack_require__(60);

var _PulseLoader2 = _interopRequireDefault(_PulseLoader);

var _reactIntl = __webpack_require__(2);

var _iconDictionary = __webpack_require__(8);

var _messages = __webpack_require__(791);

var _messages2 = _interopRequireDefault(_messages);

__webpack_require__(26);

var _index = __webpack_require__(1752);

var _index2 = _interopRequireDefault(_index);

var _index3 = __webpack_require__(7);

var _index4 = _interopRequireDefault(_index3);

var _variants = __webpack_require__(9);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TeacherHeader = function TeacherHeader(_ref) {
    var _ref$filteredTeachers = _ref.filteredTeachersCount,
        filteredTeachersCount = _ref$filteredTeachers === undefined ? 0 : _ref$filteredTeachers,
        _ref$isTeacherDataLoa = _ref.isTeacherDataLoaded,
        isTeacherDataLoaded = _ref$isTeacherDataLoa === undefined ? false : _ref$isTeacherDataLoa,
        _ref$isTeacherRollDow = _ref.isTeacherRollDownloaded,
        isTeacherRollDownloaded = _ref$isTeacherRollDow === undefined ? true : _ref$isTeacherRollDow,
        handleOnDownloadTeacherRoll = _ref.handleOnDownloadTeacherRoll,
        handleQuickUpload = _ref.handleQuickUpload,
        handleAddTeacher = _ref.handleAddTeacher,
        intl = _ref.intl;

    var teacherCount = isTeacherDataLoaded ? _react2.default.createElement(
        'span',
        null,
        filteredTeachersCount
    ) : _react2.default.createElement(_PulseLoader2.default, { color: '#000', margin: '2px', size: '6px' });
    return _react2.default.createElement(
        'div',
        { className: _index2.default.teacherHeaderComponent },
        _react2.default.createElement(
            'div',
            { className: _index2.default.teachersCountContainer },
            _react2.default.createElement(
                'span',
                { className: _index2.default.teachersTitle },
                intl.formatMessage(_messages2.default.teachers),
                _react2.default.createElement(
                    'span',
                    { className: _index2.default.teachersCount },
                    '( ',
                    teacherCount,
                    ' )'
                )
            )
        ),
        _react2.default.createElement(
            'div',
            { className: _index2.default.buttonContainer },
            _react2.default.createElement(_index4.default, {
                containerClassName: _index2.default.downloadTeacherRoll,
                disabled: filteredTeachersCount === 0,
                handleOnClick: handleOnDownloadTeacherRoll,
                icon: _iconDictionary.Download,
                iconClassName: _index2.default.svgIconContainer,
                label: intl.formatMessage(_messages2.default.downloadTeacherRoll),
                loading: !isTeacherRollDownloaded,
                loadingLabel: intl.formatMessage(_messages2.default.downloading),
                variant: _variants.DARK,
                visible: true }),
            _react2.default.createElement(_index4.default, {
                containerClassName: _index2.default.bulkUpload,
                disabled: false,
                handleOnClick: handleQuickUpload,
                icon: _iconDictionary.Plus,
                iconClassName: _index2.default.svgIconContainer,
                label: intl.formatMessage(_messages2.default.quickUpload),
                variant: _variants.DARK,
                visible: true }),
            _react2.default.createElement(_index4.default, {
                containerClassName: _index2.default.inviteTeacher,
                disabled: !isTeacherDataLoaded,
                handleOnClick: handleAddTeacher,
                icon: _iconDictionary.Plus,
                iconClassName: _index2.default.svgIconContainer,
                label: intl.formatMessage(_messages2.default.inviteTeacher),
                variant: _variants.DARK,
                visible: true })
        )
    );
};

TeacherHeader.propTypes = {
    isTeacherDataLoaded: _propTypes2.default.bool,
    isTeacherRollDownloaded: _propTypes2.default.bool,
    filteredTeachersCount: _propTypes2.default.number,
    handleOnDownloadTeacherRoll: _propTypes2.default.func,
    handleQuickUpload: _propTypes2.default.func,
    handleAddTeacher: _propTypes2.default.func,
    intl: _reactIntl.intlShape.isRequired
};

exports.default = (0, _reactIntl.injectIntl)((0, _reactStyleable2.default)(_index2.default)(TeacherHeader));

/***/ }),
/* 791 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _reactIntl = __webpack_require__(2);

exports.default = (0, _reactIntl.defineMessages)({
    downloadTeacherRoll: {
        id: 'teacher-header.components.downloadTeacherRoll',
        defaultMessage: 'Download teacher roll'
    },
    quickUpload: {
        id: 'teacher-header.components.quickUpload',
        defaultMessage: 'Quick upload'
    },
    inviteTeacher: {
        id: 'teacher-header.components.inviteTeacher',
        defaultMessage: 'Invite teacher'
    },
    teachers: {
        id: 'teacher-header.components.teachers',
        defaultMessage: 'Teachers'
    },
    downloading: {
        id: 'teacher-header.components.downloading',
        defaultMessage: 'downloading'
    }
}); /*
     * student-header messages
     *
     * This contains all the text for the student-header component.
     */

/***/ }),
/* 792 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactStyleable = __webpack_require__(6);

var _reactStyleable2 = _interopRequireDefault(_reactStyleable);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _PulseLoader = __webpack_require__(60);

var _PulseLoader2 = _interopRequireDefault(_PulseLoader);

var _reactIntl = __webpack_require__(2);

var _index = __webpack_require__(1753);

var _index2 = _interopRequireDefault(_index);

var _teacherHeader = __webpack_require__(790);

var _teacherHeader2 = _interopRequireDefault(_teacherHeader);

var _teacherFilter = __webpack_require__(786);

var _teacherFilter2 = _interopRequireDefault(_teacherFilter);

var _renderers = __webpack_require__(153);

var _formatters = __webpack_require__(253);

var gridFormatters = _interopRequireWildcard(_formatters);

var _emptyState = __webpack_require__(76);

var _emptyState2 = _interopRequireDefault(_emptyState);

var _teacherFooter = __webpack_require__(788);

var _teacherFooter2 = _interopRequireDefault(_teacherFooter);

var _modal = __webpack_require__(24);

var _modal2 = _interopRequireDefault(_modal);

var _addTeacher = __webpack_require__(632);

var _addTeacher2 = _interopRequireDefault(_addTeacher);

var _iconDictionary = __webpack_require__(8);

var _teacherConfirmation = __webpack_require__(782);

var _teacherConfirmation2 = _interopRequireDefault(_teacherConfirmation);

var _sendEmailResult = __webpack_require__(754);

var _sendEmailResult2 = _interopRequireDefault(_sendEmailResult);

var _messages = __webpack_require__(793);

var _messages2 = _interopRequireDefault(_messages);

var _index3 = __webpack_require__(150);

var _index4 = _interopRequireDefault(_index3);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function getGridColumns(selectedProduct, handleGridSort, handleOnTeacherEdit, intl, handleOnAssignClass) {
    return [{
        key: 'displayTitle',
        name: '' + intl.formatMessage(_messages2.default.title),
        resizable: true,
        width: 70,
        sortable: true,
        headerRenderer: _react2.default.createElement(gridFormatters.HeaderFormatter, { onSort: handleGridSort })
    }, {
        key: 'firstName',
        name: '' + intl.formatMessage(_messages2.default.firstName),
        resizable: true,
        width: 160,
        sortable: true,
        headerRenderer: _react2.default.createElement(gridFormatters.HeaderFormatter, { onSort: handleGridSort })
    }, {
        key: 'lastName',
        name: '' + intl.formatMessage(_messages2.default.surname),
        resizable: true,
        width: 160,
        sortable: true,
        headerRenderer: _react2.default.createElement(gridFormatters.HeaderFormatter, { onSort: handleGridSort })
    }, {
        key: 'emailAddress',
        name: '' + intl.formatMessage(_messages2.default.emailAddress),
        resizable: true,
        width: 300,
        sortable: true,
        headerRenderer: _react2.default.createElement(gridFormatters.HeaderFormatter, { onSort: handleGridSort })
    }, {
        key: 'userName',
        name: '' + intl.formatMessage(_messages2.default.username),
        resizable: true,
        width: 150,
        sortable: true,
        headerRenderer: _react2.default.createElement(gridFormatters.HeaderFormatter, { onSort: handleGridSort })
    }, {
        key: 'class',
        name: selectedProduct.name.toUpperCase() + ' ' + intl.formatMessage(_messages2.default.classes),
        width: 250,
        resizable: true,
        getRowMetaData: function getRowMetaData(row) {
            return row;
        },
        formatter: _react2.default.createElement(gridFormatters.AssignedClassFormatter, { handleOnAssignClass: handleOnAssignClass })
    }, {
        key: 'emailStatus',
        name: ('' + intl.formatMessage(_messages2.default.accountStatus)).toUpperCase(),
        resizable: true,
        width: 200,
        sortable: true,
        formatter: _react2.default.createElement(gridFormatters.EmailStatusFormatter, null),
        headerRenderer: _react2.default.createElement(gridFormatters.HeaderFormatter, { onSort: handleGridSort })
    }, {
        key: '',
        name: ''
    }, {
        key: 'edit',
        name: '' + intl.formatMessage(_messages2.default.edit),
        width: 70,
        locked: true,
        getRowMetaData: function getRowMetaData(row) {
            return row;
        },
        formatter: _react2.default.createElement(gridFormatters.EditInfoFormatter, { handleOnEdit: handleOnTeacherEdit })
    }];
}

var TeacherRoll = function TeacherRoll(_ref) {
    var teachers = _ref.teachers,
        teacherTitles = _ref.teacherTitles,
        teachersCount = _ref.teachersCount,
        _ref$selectedTeachers = _ref.selectedTeachers,
        selectedTeachers = _ref$selectedTeachers === undefined ? [] : _ref$selectedTeachers,
        isTeacherDataLoaded = _ref.isTeacherDataLoaded,
        isTeacherRollDownloaded = _ref.isTeacherRollDownloaded,
        gridRowGetter = _ref.gridRowGetter,
        onGridSort = _ref.onGridSort,
        onRowSelect = _ref.onRowSelect,
        onDownloadTeacherRoll = _ref.onDownloadTeacherRoll,
        onQuickUpload = _ref.onQuickUpload,
        onAddTeacher = _ref.onAddTeacher,
        onAddAnotherTeacher = _ref.onAddAnotherTeacher,
        dataFilterOptions = _ref.dataFilterOptions,
        filterOnChange = _ref.filterOnChange,
        filterOnClear = _ref.filterOnClear,
        onSearch = _ref.onSearch,
        selectedProduct = _ref.selectedProduct,
        handleOnTeacherUnassign = _ref.handleOnTeacherUnassign,
        showModal = _ref.showModal,
        handleOnCloseModal = _ref.handleOnCloseModal,
        handleOnUnassignConfirm = _ref.handleOnUnassignConfirm,
        isUserOperationModalOpen = _ref.isUserOperationModalOpen,
        isEmailVerificationModalOpen = _ref.isEmailVerificationModalOpen,
        sendingEmailsResult = _ref.sendingEmailsResult,
        emailVerificationError = _ref.emailVerificationError,
        handleOnCloseEmailVerificationModal = _ref.handleOnCloseEmailVerificationModal,
        isLoading = _ref.isLoading,
        showAddTeachersModal = _ref.showAddTeachersModal,
        onAddTeacherCloseModal = _ref.onAddTeacherCloseModal,
        classrooms = _ref.classrooms,
        teacher = _ref.teacher,
        isSaveInProgress = _ref.isSaveInProgress,
        handleOnAddTeacherSubmit = _ref.handleOnAddTeacherSubmit,
        showAddTeacherValidationModal = _ref.showAddTeacherValidationModal,
        addTeacherValidationMessage = _ref.addTeacherValidationMessage,
        closeAddTeacherValidationModal = _ref.closeAddTeacherValidationModal,
        showAddTeacherConfirmationModal = _ref.showAddTeacherConfirmationModal,
        isSignInCardDownloaded = _ref.isSignInCardDownloaded,
        handleOnPrintSignInCard = _ref.handleOnPrintSignInCard,
        handleOnTeacherEdit = _ref.handleOnTeacherEdit,
        intl = _ref.intl,
        handleOnAssignClass = _ref.handleOnAssignClass,
        filteredTeachersCount = _ref.filteredTeachersCount,
        handleOnTeacherDeleteOpenModal = _ref.handleOnTeacherDeleteOpenModal,
        handleOnDeleteTeacher = _ref.handleOnDeleteTeacher,
        operationType = _ref.operationType,
        teachersOperationSuccessConfirmation = _ref.teachersOperationSuccessConfirmation,
        deletingTeacher = _ref.deletingTeacher;

    teacherTitles[0].value = intl.formatMessage(_messages2.default.teacherTitleNone);
    teacherTitles[0].value = intl.formatMessage(_messages2.default.teacherTitleNone_key);
    teacherTitles[5].value = intl.formatMessage(_messages2.default.dr);
    teacherTitles[5].key = intl.formatMessage(_messages2.default.dr_key);
    teacherTitles[1].value = intl.formatMessage(_messages2.default.miss);
    teacherTitles[1].key = intl.formatMessage(_messages2.default.miss_key);
    teacherTitles[2].value = intl.formatMessage(_messages2.default.mr);
    teacherTitles[2].key = intl.formatMessage(_messages2.default.mr_key);
    teacherTitles[3].value = intl.formatMessage(_messages2.default.mrs);
    teacherTitles[3].key = intl.formatMessage(_messages2.default.mrs_key);
    teacherTitles[4].value = intl.formatMessage(_messages2.default.ms);
    teacherTitles[4].key = intl.formatMessage(_messages2.default.ms_key);
    var sortedTitles = teacherTitles.slice(1).sort(function (a, b) {
        return a.value.localeCompare(b.value);
    });
    sortedTitles.unshift(teacherTitles[0]);

    var loaderView = _react2.default.createElement(
        'div',
        { className: _index2.default.teacherListContainer },
        _react2.default.createElement(
            'div',
            { className: _index2.default.loadingContainer },
            _react2.default.createElement(_PulseLoader2.default, { className: _index2.default.loader })
        )
    );

    var loadAddTeacherModalComponent = function loadAddTeacherModalComponent() {
        var modalComponent = '';
        if (showAddTeacherConfirmationModal) {
            modalComponent = _react2.default.createElement(_teacherConfirmation2.default, {
                handleOnAddTeacher: onAddAnotherTeacher,
                handleOnCloseModal: onAddTeacherCloseModal,
                handleOnPrintSignInCard: handleOnPrintSignInCard,
                icon: _iconDictionary.Tick,
                isSignInCardDownloaded: isSignInCardDownloaded,
                title: intl.formatMessage(_messages2.default.addTeacherConfirmation)
            });
        } else {
            modalComponent = _react2.default.createElement(_addTeacher2.default, {
                addTeacherValidationMessage: addTeacherValidationMessage,
                classes: classrooms,
                closeAddTeacherValidationModal: closeAddTeacherValidationModal,
                handleOnAddTeacherSubmit: handleOnAddTeacherSubmit,
                handleOnCloseModal: onAddTeacherCloseModal,
                isSaveInProgress: isSaveInProgress,
                selectedProduct: selectedProduct,
                showAddTeacherValidationModal: showAddTeacherValidationModal,
                teacher: teacher,
                teacherTitles: sortedTitles
            });
        }

        return modalComponent;
    };

    var addTeacherModalView = _react2.default.createElement(
        _modal2.default,
        { show: showAddTeachersModal },
        loadAddTeacherModalComponent()
    );

    var emailVerificationModalView = _react2.default.createElement(
        _modal2.default,
        { show: isEmailVerificationModalOpen, smallMode: true },
        _react2.default.createElement(_sendEmailResult2.default, {
            fatalError: emailVerificationError,
            onCloseModal: handleOnCloseEmailVerificationModal,
            sendingEmailsResult: sendingEmailsResult
        })
    );

    var emptyStateView = _react2.default.createElement(
        'div',
        { className: _index2.default.teacherListContainer },
        _react2.default.createElement(_teacherFilter2.default, {
            classrooms: dataFilterOptions.classrooms,
            handleFilterOnChange: filterOnChange,
            handleFilterOnClear: filterOnClear,
            handleOnSearch: onSearch,
            lastNames: dataFilterOptions.lastNames,
            searchTerm: dataFilterOptions.searchTerm }),
        _react2.default.createElement(_emptyState2.default, { iconName: _iconDictionary.StudentManagement, message: intl.formatMessage(_messages2.default.noTeachersAvailable) }),
        addTeacherModalView
    );

    var dataView = _react2.default.createElement(
        'div',
        { className: _index2.default.teacherListContainer },
        _react2.default.createElement(_teacherFilter2.default, {
            classrooms: dataFilterOptions.classrooms,
            handleFilterOnChange: filterOnChange,
            handleFilterOnClear: filterOnClear,
            handleOnSearch: onSearch,
            lastNames: dataFilterOptions.lastNames,
            searchTerm: dataFilterOptions.searchTerm }),
        _react2.default.createElement(_index4.default, {
            columns: getGridColumns(selectedProduct, onGridSort, handleOnTeacherEdit, intl, handleOnAssignClass),
            handleGridSort: onGridSort,
            handleRowSelect: onRowSelect,
            overScan: { colsStart: 17, colsEnd: 17, rowsStart: 25, rowsEnd: 25 },
            rowGetter: gridRowGetter,
            rowHeight: 150,
            rowKey: 'userProfileId',
            rowRenderer: _renderers.TeacherRowRenderer,
            rowsCount: teachers.length,
            selectedRows: selectedTeachers.length > 0 ? selectedTeachers : []
        }),
        addTeacherModalView,
        emailVerificationModalView
    );

    var finalView = void 0;
    if (!isTeacherDataLoaded) {
        finalView = loaderView;
    } else {
        finalView = filteredTeachersCount === 0 ? emptyStateView : dataView;
    }
    var teachersComponent = _react2.default.createElement(
        'div',
        { className: _index2.default.teacherRollComponent },
        _react2.default.createElement(_teacherHeader2.default, {
            filteredTeachersCount: teachers.length,
            handleAddTeacher: onAddTeacher,
            handleOnDownloadTeacherRoll: onDownloadTeacherRoll,
            handleQuickUpload: onQuickUpload,
            isTeacherDataLoaded: isTeacherDataLoaded,
            isTeacherRollDownloaded: isTeacherRollDownloaded,
            teachersCountInSchool: teachersCount }),
        finalView,
        _react2.default.createElement(_teacherFooter2.default, {
            deletingTeacher: deletingTeacher,
            handleOnCloseModal: handleOnCloseModal,
            handleOnDeleteTeacher: handleOnDeleteTeacher,
            handleOnTeacherDeleteOpenModal: handleOnTeacherDeleteOpenModal,
            handleOnTeacherUnassign: handleOnTeacherUnassign,
            handleOnUnassignConfirm: handleOnUnassignConfirm,
            isLoading: isLoading,
            isUserOperationModalOpen: isUserOperationModalOpen,
            noOfSelectedTeachers: selectedTeachers.length,
            operationType: operationType,
            showModal: showModal,
            teachersOperationSuccessConfirmation: teachersOperationSuccessConfirmation })
    );

    return _react2.default.createElement(
        'div',
        { className: _index2.default.teacherRollComponent },
        teachersComponent
    );
};

TeacherRoll.propTypes = {
    isTeacherDataLoaded: _propTypes2.default.bool,
    isTeacherRollDownloaded: _propTypes2.default.bool,
    showAddTeacherConfirmationModal: _propTypes2.default.bool,
    teacher: _propTypes2.default.object,
    teachers: _propTypes2.default.arrayOf(_propTypes2.default.object),
    teacherTitles: _propTypes2.default.arrayOf(_propTypes2.default.object),
    classrooms: _propTypes2.default.arrayOf(_propTypes2.default.object),
    selectedTeachers: _propTypes2.default.arrayOf(_propTypes2.default.number),
    gridRowGetter: _propTypes2.default.func,
    teachersCount: _propTypes2.default.number,
    filteredTeachersCount: _propTypes2.default.number,
    onGridSort: _propTypes2.default.func,
    onRowSelect: _propTypes2.default.func,
    onDownloadTeacherRoll: _propTypes2.default.func,
    onQuickUpload: _propTypes2.default.func,
    onAddTeacher: _propTypes2.default.func,
    closeAddTeacherValidationModal: _propTypes2.default.func,
    dataFilterOptions: _propTypes2.default.object,
    filterOnChange: _propTypes2.default.func,
    filterOnClear: _propTypes2.default.func,
    onSearch: _propTypes2.default.func,
    onAddTeacherCloseModal: _propTypes2.default.func,
    handleOnAddTeacherSubmit: _propTypes2.default.func,
    selectedProduct: _propTypes2.default.object,
    showAddTeachersModal: _propTypes2.default.bool,
    isSaveInProgress: _propTypes2.default.bool,
    showAddTeacherValidationModal: _propTypes2.default.bool,
    isSignInCardDownloaded: _propTypes2.default.bool,
    addTeacherValidationMessage: _propTypes2.default.string,
    handleOnPrintSignInCard: _propTypes2.default.func,
    handleOnTeacherUnassign: _propTypes2.default.func,
    handleOnCloseModal: _propTypes2.default.func,
    showModal: _propTypes2.default.bool,
    handleOnUnassignConfirm: _propTypes2.default.func,
    isUserOperationModalOpen: _propTypes2.default.bool,
    isEmailVerificationModalOpen: _propTypes2.default.bool,
    sendingEmailsResult: _propTypes2.default.object,
    emailVerificationError: _propTypes2.default.bool,
    handleOnCloseEmailVerificationModal: _propTypes2.default.func,
    isLoading: _propTypes2.default.bool,
    teachersOperationSuccessConfirmation: _propTypes2.default.func,
    onAddAnotherTeacher: _propTypes2.default.func,
    handleOnTeacherEdit: _propTypes2.default.func,
    intl: _reactIntl.intlShape.isRequired,
    handleOnAssignClass: _propTypes2.default.func,
    handleOnTeacherDeleteOpenModal: _propTypes2.default.func,
    handleOnDeleteTeacher: _propTypes2.default.func,
    operationType: _propTypes2.default.string,
    deletingTeacher: _propTypes2.default.bool
};

exports.default = (0, _reactIntl.injectIntl)((0, _reactStyleable2.default)(_index2.default)(TeacherRoll));

/***/ }),
/* 793 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _reactIntl = __webpack_require__(2);

exports.default = (0, _reactIntl.defineMessages)({
    addTeacherConfirmation: {
        id: 'app.components.teacherRoll.addTeacherConfirmation',
        defaultMessage: 'Teacher added'
    },
    yearGroupList: {
        id: 'app.components.teacherRoll.yearGroupList',
        defaultMessage: 'Year'
    },
    title: {
        id: 'app.components.teacherRoll.title',
        defaultMessage: 'TITLE'
    },
    firstName: {
        id: 'app.components.teacherRoll.firstName',
        defaultMessage: 'FIRST NAME'
    },
    surname: {
        id: 'app.components.teacherRoll.surname',
        defaultMessage: 'SURNAME'
    },
    emailAddress: {
        id: 'app.components.teacherRoll.emailAddress',
        defaultMessage: 'EMAIL ADDRESS'
    },
    accountStatus: {
        id: 'app.components.teacherRoll.accountStatus',
        defaultMessage: 'Account Status'
    },
    username: {
        id: 'app.components.teacherRoll.username',
        defaultMessage: 'USERNAME'
    },
    password: {
        id: 'app.components.teacherRoll.password',
        defaultMessage: 'PASSWORD'
    },
    classes: {
        id: 'app.components.teacherRoll.classes',
        defaultMessage: 'CLASSES'
    },
    edit: {
        id: 'app.components.teacherRoll.edit',
        defaultMessage: 'EDIT'
    },
    noTeachersAvailable: {
        id: 'app.components.teacherRoll.noTeachersAvailable',
        defaultMessage: 'No teachers available'
    },
    miss: {
        id: 'app.components.teacherRoll.miss',
        defaultMessage: 'Miss'
    },
    mr: {
        id: 'app.components.teacherRoll.mr',
        defaultMessage: 'Mr'
    },
    mrs: {
        id: 'app.components.teacherRoll.mrs',
        defaultMessage: 'Mrs'
    },
    ms: {
        id: 'app.components.teacherRoll.ms',
        defaultMessage: 'Ms'
    },
    dr: {
        id: 'app.components.teacherRoll.dr',
        defaultMessage: 'Dr'
    },
    miss_key: {
        id: 'app.components.teacherRoll.miss.key',
        defaultMessage: 'Miss'
    },
    mr_key: {
        id: 'app.components.teacherRoll.mr.key',
        defaultMessage: 'Mr'
    },
    mrs_key: {
        id: 'app.components.teacherRoll.mrs.key',
        defaultMessage: 'Mrs'
    },
    ms_key: {
        id: 'app.components.teacherRoll.ms.key',
        defaultMessage: 'Ms'
    },
    dr_key: {
        id: 'app.components.teacherRoll.dr.key',
        defaultMessage: 'Dr'
    },
    teacherTitleNone: {
        id: 'app.components.EditTeacher.teachertTitle.none',
        defaultMessage: 'None'
    },
    teacherTitleNone_key: {
        id: 'app.components.EditTeacher.teachertTitle.none.key',
        defaultMessage: 'none'
    }
});

/***/ }),
/* 794 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _reactIntl = __webpack_require__(2);

exports.default = (0, _reactIntl.defineMessages)({
    wishToContinue: {
        id: 'app.components.teacherUnassign.wishToContinue',
        defaultMessage: 'Do you wish to continue?'
    }
});

/***/ }),
/* 795 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactStyleable = __webpack_require__(6);

var _reactStyleable2 = _interopRequireDefault(_reactStyleable);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactIntl = __webpack_require__(2);

var _spinner = __webpack_require__(94);

var _spinner2 = _interopRequireDefault(_spinner);

var _index = __webpack_require__(1755);

var _index2 = _interopRequireDefault(_index);

var _messages = __webpack_require__(796);

var _messages2 = _interopRequireDefault(_messages);

var _index3 = __webpack_require__(7);

var _index4 = _interopRequireDefault(_index3);

var _variants = __webpack_require__(9);

var _index5 = __webpack_require__(37);

var _index6 = _interopRequireDefault(_index5);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TeacherView = function TeacherView(props) {
    var intl = props.intl,
        teachers = props.teachers,
        onTeacherSelection = props.onTeacherSelection,
        isTeachersLoaded = props.isTeachersLoaded,
        selectedTeacherId = props.selectedTeacherId,
        handleOnLaunch = props.handleOnLaunch,
        isGettingToken = props.isGettingToken,
        isFetchingData = props.isFetchingData;


    var finalView = isTeachersLoaded ? _react2.default.createElement(
        'div',
        { className: _index2.default.container },
        _react2.default.createElement(
            'div',
            { className: _index2.default.header },
            intl.formatMessage(_messages2.default.teacherView)
        ),
        _react2.default.createElement(
            'div',
            { className: _index2.default.teachers },
            _react2.default.createElement(_index6.default, {
                name: 'teachers',
                onChange: onTeacherSelection,
                optionKey: 'id',
                options: teachers,
                optionText: 'name',
                placeholder: intl.formatMessage(_messages2.default.selectTeacher)
            }),
            _react2.default.createElement(
                'div',
                { className: _index2.default.subHeader },
                intl.formatMessage(_messages2.default.teacherViewSubHeading)
            ),
            _react2.default.createElement(_index4.default, {
                disabled: selectedTeacherId === '-1' || isGettingToken || isFetchingData,
                handleOnClick: handleOnLaunch,
                label: intl.formatMessage(_messages2.default.launch),
                variant: _variants.DENIM })
        ),
        _react2.default.createElement('div', { className: _index2.default.header })
    ) : _react2.default.createElement(
        'div',
        { className: _index2.default.loader },
        _react2.default.createElement(_spinner2.default, { color: 'grey', size: '15px' })
    );

    return finalView;
};

TeacherView.propTypes = {
    intl: _reactIntl.intlShape.isRequired,
    teachers: _propTypes2.default.array,
    onTeacherSelection: _propTypes2.default.func,
    isTeachersLoaded: _propTypes2.default.bool,
    selectedTeacherId: _propTypes2.default.string,
    handleOnLaunch: _propTypes2.default.func,
    isGettingToken: _propTypes2.default.bool,
    isFetchingData: _propTypes2.default.bool
};

exports.default = (0, _reactIntl.injectIntl)((0, _reactStyleable2.default)(_index2.default)(TeacherView));

/***/ }),
/* 796 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _reactIntl = __webpack_require__(2);

exports.default = (0, _reactIntl.defineMessages)({
    launch: {
        id: 'app.components.teacher-view.launch',
        defaultMessage: 'Launch'
    },
    teacherView: {
        id: 'app.components.teacher-view.teacherView',
        defaultMessage: 'Teacher view'
    },
    selectTeacher: {
        id: 'app.components.teacher-view.selectTeacher',
        defaultMessage: 'Select teacher'
    },
    teacherViewSubHeading: {
        id: 'app.components.teacher-view.teacherView.subHeading',
        defaultMessage: 'Only teachers assigned to a class will appear in this list.'
    }
});

/***/ }),
/* 797 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = __webpack_require__(28);

var _redux = __webpack_require__(35);

var _reactStyleable = __webpack_require__(6);

var _reactStyleable2 = _interopRequireDefault(_reactStyleable);

var _index = __webpack_require__(1757);

var _index2 = _interopRequireDefault(_index);

var _actions = __webpack_require__(65);

var _button = __webpack_require__(7);

var _button2 = _interopRequireDefault(_button);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Toast = function (_Component) {
    _inherits(Toast, _Component);

    function Toast(props) {
        _classCallCheck(this, Toast);

        var _this = _possibleConstructorReturn(this, (Toast.__proto__ || Object.getPrototypeOf(Toast)).call(this, props));

        _this.startTimer = function () {
            _this.setState({ isToastVisible: false, message: '' });
            if (_this.props.isToastVisible) {
                _this.props.hideToast();
                clearTimeout(_this.timeoutInstance);
            }
        };

        _this.hideToast = function () {
            _this.setState({ isToastVisible: false, message: '' });
            _this.props.hideToast();
            clearTimeout(_this.timeoutInstance);
        };

        _this.setToastColor = function () {
            var messageType = _this.props.messageType;

            var color = '';
            switch (messageType) {
                case 'success':
                    color = '#5cb85c';
                    break;
                case 'warning':
                    color = '#e07e02';
                    break;
                default:
                    color = '#c53902';
                    break;
            }

            return color;
        };

        _this.state = { isToastVisible: false, message: '' };
        return _this;
    }

    _createClass(Toast, [{
        key: 'componentWillReceiveProps',
        value: function componentWillReceiveProps(nextProps) {
            if (nextProps.isToastVisible !== this.props.isToastVisible) {
                this.setState({ isToastVisible: nextProps.isToastVisible, message: nextProps.message });
                this.timeoutInstance = setTimeout(this.startTimer, 7000);
            }
        }
    }, {
        key: 'render',
        value: function render() {
            var toastHtmlElement = this.state.isToastVisible ? _react2.default.createElement(
                'div',
                { className: _index2.default.toast, style: { background: this.setToastColor() } },
                _react2.default.createElement(
                    _button2.default,
                    { containerClassName: _index2.default.toastContent, handleOnClick: this.hideToast },
                    _react2.default.createElement(
                        'div',
                        { className: _index2.default.message },
                        this.state.message
                    )
                )
            ) : _react2.default.createElement('div', { className: _index2.default.empty });
            return toastHtmlElement;
        }
    }]);

    return Toast;
}(_react.Component);

var mapStateToProps = function mapStateToProps(state) {
    return _extends({}, state, {
        isToastVisible: state.toast.isToastVisible,
        message: state.toast.message,
        messageType: state.toast.messageType
    });
};

function mapDispatchToProps(dispatch) {
    return (0, _redux.bindActionCreators)({
        hideToast: _actions.hideToast
    }, dispatch);
}

Toast.propTypes = {
    message: _propTypes2.default.string,
    isToastVisible: _propTypes2.default.bool,
    hideToast: _propTypes2.default.func,
    messageType: _propTypes2.default.string
};

var StyledToast = (0, _reactStyleable2.default)(_index2.default)(Toast);
exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(StyledToast);

/***/ }),
/* 798 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.default = function () {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
    var action = arguments[1];

    switch (action.type) {
        case actions.SHOW_TOAST:
            return _extends({}, state, { isToastVisible: action.isToastVisible, message: action.message, messageType: action.messageType });

        case actions.HIDE_TOAST:
            return _extends({}, state, { isToastVisible: action.isToastVisible });
        default:
            return _extends({}, state);
    }
};

var _actions = __webpack_require__(65);

var actions = _interopRequireWildcard(_actions);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var initialState = {
    isToastVisible: false,
    message: '',
    messageType: ''
};

/***/ }),
/* 799 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _reactIntl = __webpack_require__(2);

exports.default = (0, _reactIntl.defineMessages)({
    ok: {
        id: 'app.components.Summary.header',
        defaultMessage: 'Ok'
    },
    ViewSummary: {
        id: 'app.components.Summary.ViewSummary',
        defaultMessage: 'View summary'
    },
    back: {
        id: 'app.components.Summary.back',
        defaultMessage: 'Back'
    },
    print: {
        id: 'app.components.Summary.print',
        defaultMessage: 'Print'
    }
}); /*
     * Summary Messages
     *
     * This contains all the text for the Summary component.
     */

/***/ }),
/* 800 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }(); /* eslint-disable no-console */

var _querystring = __webpack_require__(1486);

var _querystring2 = _interopRequireDefault(_querystring);

var _resources = __webpack_require__(270);

var _resources2 = _interopRequireDefault(_resources);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Configuration = function () {
    function Configuration() {
        _classCallCheck(this, Configuration);
    }

    _createClass(Configuration, null, [{
        key: 'configure',
        value: function configure() {
            // How we want to configure things depends on where this app is running,
            // and where the services we want to access live.
            //
            // 1. When running on a developer's machine, using a mock server we want
            //    to use a hard-coded config from
            //
            //       helpers/local-resource-config.js
            //
            // 2. When running on a developer's machine, but we want to use back-end
            //    services on demo, QA or live, we want to get the configuration from
            //    the configuration of the host app.
            //
            // 3. When running on demo, QA or live, the configuration will be injected
            //    based on the host app's configuration, but can be overridden by query
            //    parameters.
            //
            // We determine which situation we have by looking at the window location
            // URL and the query parameters, and whether there is a pppAppConfig property
            // on the window object.

            var location = window.location;
            var runningOnDeveloperMachine = /^https?:\/\/localhost/.test(location);
            var queryParams = location.search;
            var query = queryParams.replace('?', '');
            var params = _querystring2.default.parse(query);

            if (runningOnDeveloperMachine) {
                Configuration.configureForDeveloperMachine(params);
            } else {
                Configuration.configureForRemoteHost(params);
            }
        }
    }, {
        key: 'configureForDeveloperMachine',
        value: function configureForDeveloperMachine(params) {
            var envName = params.env;

            if (!envName) {
                console.log('Configuration.configureForDeveloperMachine() - you did not provide an "env" query' + ' parameter, so I am assuming you want to talk to live.');

                envName = 'live';
            }

            var credentials = Configuration.getCredentials(params);

            if (envName === 'local' || Configuration.weHaveUsableCredentials(credentials)) {
                _resources2.default.initialise(envName, credentials);
            }
        }
    }, {
        key: 'configureForRemoteHost',
        value: function configureForRemoteHost(params) {
            var config = window.pppAppConfig || {};
            var envName = config.env || 'live';
            var credentials = Configuration.getCredentials(params);

            if (!config.BaseName) {
                console.log('Configuration.configureForRemoteHost() - your pppAppConfig does not' + ' include a BaseName item; we will assume it should be blank.');

                config.BaseName = '';
            }

            if (Configuration.weHaveUsableCredentials(credentials)) {
                _resources2.default.initialise(envName, credentials);
                _resources2.default.env.setConfiguration(config);
            }
        }
    }, {
        key: 'getCredentials',
        value: function getCredentials(params) {
            var credentials = {};
            var items = ['authToken', 'username', 'password'];

            for (var paramName in params) {
                var value = params[paramName];

                var _iteratorNormalCompletion = true;
                var _didIteratorError = false;
                var _iteratorError = undefined;

                try {
                    for (var _iterator = items[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                        var item = _step.value;

                        if (paramName.toLowerCase() === item.toLowerCase()) {
                            credentials[item] = value;
                        }
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally {
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return) {
                            _iterator.return();
                        }
                    } finally {
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
            }

            return credentials;
        }
    }, {
        key: 'weHaveUsableCredentials',
        value: function weHaveUsableCredentials(credentials) {
            var usableCredentials = false;

            if (credentials.authToken) {
                usableCredentials = true;
            } else if (credentials.username && credentials.password) {
                usableCredentials = true;
            }

            if (!usableCredentials) {
                /* eslint-disable no-console */
                console.error('EntryApp.configureForDeveloperMachine() - to execute, we need either an authToken or' + ' a username/password pair.  After combining data from window.pppAppConfig and the query' + ' parameters, I still do not have what I need. The app will probably not function correctly if' + ' it requires any 3P resources.');
                /* eslint-disable no-console */
            }

            return usableCredentials;
        }
    }]);

    return Configuration;
}();

exports.default = Configuration;

/***/ }),
/* 801 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.getSchoolCourse = exports.getProductCourseFailure = exports.getProductCourseSuccess = exports.getProductCourse = exports.getConquestCourseCountryFailure = exports.getConquestCourseCountrySuccess = exports.getConquestCourseCountry = exports.getCourseCountryFailure = exports.getCourseCountrySuccess = exports.getCourseCountry = exports.deselectCourses = exports.getCountryYearGroupFailure = exports.getCountryYearGroupSuccess = exports.getCountryYearGroupRequest = undefined;

var _actionTypes = __webpack_require__(191);

var actionTypes = _interopRequireWildcard(_actionTypes);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var getCountryYearGroupRequest = exports.getCountryYearGroupRequest = function getCountryYearGroupRequest(countryCode, success, failure) {
    return { type: actionTypes.GET_COUNTRY_YEAR_GROUPS_REQUEST, countryCode: countryCode, success: success, failure: failure, countryCourses: [] };
};

var getCountryYearGroupSuccess = exports.getCountryYearGroupSuccess = function getCountryYearGroupSuccess(yearGroups) {
    return { type: actionTypes.GET_COUNTRY_YEAR_GROUPS_SUCCESS, isLoadingCountryCourses: false, yearGroups: yearGroups };
};

var getCountryYearGroupFailure = exports.getCountryYearGroupFailure = function getCountryYearGroupFailure() {
    return { type: actionTypes.GET_COUNTRY_YEAR_GROUPS_FAILURE, isLoadingCountryCourses: false };
};

var deselectCourses = exports.deselectCourses = function deselectCourses() {
    var deselectCourse = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
    return { type: actionTypes.DESELECT_COURSE, deselectCourse: deselectCourse };
};

var getCourseCountry = exports.getCourseCountry = function getCourseCountry(selectedProductId) {
    return { type: actionTypes.GET_COUNTRY_REQUEST, selectedProductId: selectedProductId };
};

var getCourseCountrySuccess = exports.getCourseCountrySuccess = function getCourseCountrySuccess(data) {
    return { type: actionTypes.GET_COUNTRY_SUCCESS, data: data };
};

var getCourseCountryFailure = exports.getCourseCountryFailure = function getCourseCountryFailure() {
    return { type: actionTypes.GET_COUNTRY_FAILURE };
};

var getConquestCourseCountry = exports.getConquestCourseCountry = function getConquestCourseCountry(selectedProductId) {
    return { type: actionTypes.GET_CONQUEST_COUNTRY_REQUEST, selectedProductId: selectedProductId };
};

var getConquestCourseCountrySuccess = exports.getConquestCourseCountrySuccess = function getConquestCourseCountrySuccess(data) {
    return { type: actionTypes.GET_CONQUEST_COUNTRY_SUCCESS, data: data };
};

var getConquestCourseCountryFailure = exports.getConquestCourseCountryFailure = function getConquestCourseCountryFailure() {
    return { type: actionTypes.GET_CONQUEST_COUNTRY_FAILURE };
};

var getProductCourse = exports.getProductCourse = function getProductCourse(countryCode, productId, yearGroup) {
    return { type: actionTypes.GET_PRODUCT_COURSE_REQUEST, countryCode: countryCode, productId: productId, yearGroup: yearGroup, isProductCoursesLoaded: false, isProductCoursesFetching: true };
};

var getProductCourseSuccess = exports.getProductCourseSuccess = function getProductCourseSuccess(data) {
    return { type: actionTypes.GET_PRODUCT_COURSE_SUCCESS, data: data, isProductCoursesLoaded: true, isProductCoursesFetching: false };
};

var getProductCourseFailure = exports.getProductCourseFailure = function getProductCourseFailure() {
    return { type: actionTypes.GET_PRODUCT_COURSE_FAILURE, isProductCoursesLoaded: true, isProductCoursesFetching: false };
};

var getSchoolCourse = exports.getSchoolCourse = function getSchoolCourse(yearGroup) {
    return { type: actionTypes.GET_SCHOOL_COURSE_REQUEST, yearGroup: yearGroup };
};

/***/ }),
/* 802 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = __webpack_require__(28);

var _orderBy = __webpack_require__(173);

var _orderBy2 = _interopRequireDefault(_orderBy);

var _reactIntl = __webpack_require__(2);

var _assignCourseConquest = __webpack_require__(634);

var _assignCourseConquest2 = _interopRequireDefault(_assignCourseConquest);

var _constants = __webpack_require__(96);

var _constants2 = _interopRequireDefault(_constants);

var _actionTypes = __webpack_require__(191);

var actionTypes = _interopRequireWildcard(_actionTypes);

var _constants3 = __webpack_require__(40);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var AssignCoursesConquest = function (_Component) {
    _inherits(AssignCoursesConquest, _Component);

    function AssignCoursesConquest(props) {
        _classCallCheck(this, AssignCoursesConquest);

        var _this = _possibleConstructorReturn(this, (AssignCoursesConquest.__proto__ || Object.getPrototypeOf(AssignCoursesConquest)).call(this, props));

        _this.clearSelectedCourse = function (yearGroups) {
            var dispatch = _this.props.dispatch;

            var filteredCourses = _this.state.filteredCourses.map(function (course) {
                return _extends({}, course, {
                    isSelected: false
                });
            });
            _this.setState({ filteredCourses: filteredCourses, yearGroups: yearGroups });
            dispatch({ type: actionTypes.DESELECT_COURSE, deselectCourse: false });
        };

        _this.handleOnCountryChange = function (name, selectedCountryId) {
            var dispatch = _this.props.dispatch;

            _this.selectedCountryId = selectedCountryId;

            _this.setState({
                selectedCountryId: selectedCountryId,
                selectedYearGroupId: '-1',
                filteredCourses: [],
                searchQuery: ''
            });

            if (selectedCountryId !== '-1' && selectedCountryId !== _constants2.default.SCHOOL_COURSES) {
                dispatch({
                    type: actionTypes.GET_COUNTRY_YEAR_GROUPS_REQUEST,
                    countryCode: selectedCountryId,
                    countryCourses: []
                });
            }

            if (selectedCountryId === _constants2.default.SCHOOL_COURSES) {
                dispatch({ type: actionTypes.GET_YEAR_GROUP_REQUEST });
            }

            dispatch({ type: actionTypes.CLEAR_COURSE_LIST, productCourses: [] });
            _this.selectedCourse = { id: '-1', name: '' };
            _this.props.handleOnCourseSelection(_this.selectedCourse, true);
        };

        _this.handleOnYearGroupChange = function (name, selectedYearGroupId) {
            var _this$props = _this.props,
                selectedProduct = _this$props.selectedProduct,
                dispatch = _this$props.dispatch;


            _this.setState({ selectedYearGroupId: selectedYearGroupId, initialLoad: false, searchQuery: '' });

            if (selectedYearGroupId !== '-1') {
                dispatch({
                    type: actionTypes.GET_FILTERED_CONQUEST_COURSES_REQUEST,
                    countryCode: _this.selectedCountryId,
                    productId: selectedProduct.id,
                    yearGroup: selectedYearGroupId,
                    isProductCoursesLoaded: false,
                    isProductCoursesFetching: true,
                    selectGenericCourses: false,
                    includeGlobalCourses: true
                });
            } else {
                _this.updateCourseSelection();
            }

            _this.selectedCourse = { id: '-1', name: '' };
            _this.props.handleOnCourseSelection(_this.selectedCourse, true);
        };

        _this.handleOnSearchCourse = function (e) {
            var courses = _this.props.courses;

            var currentCourses = courses;
            var courseFilter = [];

            if (_this.selectedCountryId === _constants2.default.SCHOOL_COURSES) {
                courseFilter = currentCourses;
            } else {
                courseFilter = (0, _orderBy2.default)(currentCourses, ['isDefault'], ['desc']);
            }
            var filteredCourses = courseFilter.filter(function (course) {
                return course.name.toLowerCase().indexOf(e.target.value.toLowerCase()) !== -1;
            });

            if (!filteredCourses.length) {
                _this.selectedCourse = { id: '-1', name: '' };
                _this.props.handleOnCourseSelection(_this.selectedCourse, true);
            }

            _this.setState({ searchQuery: e.target.value });
            _this.updateCourseSelection(filteredCourses);
        };

        _this.handleOnCourseSelection = function (course) {
            _this.selectedCourse = course;
            _this.updateCourseSelection(_this.state.filteredCourses);
            _this.props.handleOnCourseSelection(course);
        };

        _this.assignToYearGroup = function () {
            _this.props.handleOnYearGroupSave(_this.selectedCourse);
            _this.clearSelectedCourse();
        };

        _this.handleOptOutOfCourse = function () {
            _this.selectedCourse = { id: _constants3.DEFAULT_COURSE_ID, name: '' };
            _this.props.handleOnCourseSelection(_this.selectedCourse);
            _this.props.handleOnYearGroupSave(_this.selectedCourse);
            _this.clearSelectedCourse(_this.state.yearGroups);
        };

        _this.updateCourseSelection = function () {
            var courses = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

            var filteredCourses = courses.map(function (course) {
                var isSelected = false;
                if (_this.selectedCourse && course.name.toLowerCase() === _this.selectedCourse.name.toLowerCase()) {
                    isSelected = true;
                }
                return _extends({}, course, {
                    isSelected: isSelected
                });
            });
            _this.setState({ filteredCourses: filteredCourses });
        };

        _this.disableYearGroup = function () {
            return _this.selectedCountryId === _constants3.DEFAULT_COUNTRY_ID;
        };

        _this.disableSearchCourse = function () {
            var selectedYearGroupId = _this.state.selectedYearGroupId;

            return _this.selectedCountryId === _constants3.DEFAULT_COUNTRY_ID || selectedYearGroupId === _constants3.DEFAULT_YEAR_GROUP;
        };

        _this.state = {
            searchQuery: '',
            filteredCourses: [],
            selectedYearGroupId: '-1',
            selectedCountryId: '-1',
            yearGroups: [],
            initialLoad: true
        };

        _this.countries = [];
        _this.selectedCourse = { id: -1, name: '' };
        _this.selectedCountryId = '-1';
        return _this;
    }

    _createClass(AssignCoursesConquest, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            var _props = this.props,
                selectedProduct = _props.selectedProduct,
                dispatch = _props.dispatch;
            // eslint-disable-next-line react/no-did-mount-set-state

            this.setState({ countryLoading: true }, function () {
                dispatch({ type: actionTypes.GET_CONQUEST_COUNTRY_REQUEST, selectedProductId: selectedProduct.id });
            });
        }
    }, {
        key: 'componentWillReceiveProps',
        value: function componentWillReceiveProps(nextProps) {
            var yearGroups = nextProps.yearGroups,
                countries = nextProps.countries,
                courses = nextProps.courses,
                deselectCourse = nextProps.deselectCourse;


            this.countries = countries;
            this.selectedCourse = nextProps.selectedCourse;

            if (this.props.courses !== courses) {
                if (this.selectedCountryId === _constants2.default.SCHOOL_COURSES) {
                    this.updateCourseSelection(courses);
                } else {
                    this.updateCourseSelection((0, _orderBy2.default)(courses, ['isDefault'], ['desc']));
                }
            }

            if (deselectCourse) {
                this.clearSelectedCourse(yearGroups);
            } else {
                this.setState({ yearGroups: yearGroups });
            }
        }
    }, {
        key: 'render',
        value: function render() {
            var _state = this.state,
                filteredCourses = _state.filteredCourses,
                initialLoad = _state.initialLoad,
                searchQuery = _state.searchQuery,
                selectedYearGroupId = _state.selectedYearGroupId,
                yearGroups = _state.yearGroups;


            return _react2.default.createElement(_assignCourseConquest2.default, _extends({
                disableAssignToYear: this.state.selectedYearGroupId === '-1' || this.state.selectedCountryId === _constants3.DEFAULT_COUNTRY_ID || this.selectedCourse.id === _constants3.DEFAULT_COURSE_ID,
                disableSearch: this.disableSearchCourse(),
                disableYearGroup: this.disableYearGroup(),
                filteredCourses: filteredCourses,
                forLegacy: this.state.legacy,
                handleOnCountryChange: this.handleOnCountryChange,
                handleOnSearchCourse: this.handleOnSearchCourse,
                handleOnYearGroupChange: this.handleOnYearGroupChange,
                initialLoad: initialLoad,
                searchQuery: searchQuery,
                selectedYearGroupId: selectedYearGroupId,
                yearGroups: yearGroups
            }, this.props, {
                assignToYearGroup: this.assignToYearGroup,
                countries: this.props.conquestCountries,
                handleOnCourseSelection: this.handleOnCourseSelection,
                handleOptOutOfCourse: this.handleOptOutOfCourse,
                selectedCountryId: this.selectedCountryId }));
        }
    }]);

    return AssignCoursesConquest;
}(_react.Component);

AssignCoursesConquest.propTypes = {
    intl: _reactIntl.intlShape.isRequired,
    selectedProduct: _propTypes2.default.object,
    countries: _propTypes2.default.array,
    conquestCountries: _propTypes2.default.array,
    courses: _propTypes2.default.array,
    yearGroups: _propTypes2.default.array,
    selectedCourse: _propTypes2.default.object,
    isProductCoursesLoaded: _propTypes2.default.bool,
    isSchoolCoursesLoaded: _propTypes2.default.bool,
    isNewCoursesLoaded: _propTypes2.default.bool,
    deselectCourse: _propTypes2.default.bool,
    handleOnCourseSelection: _propTypes2.default.func,
    dispatch: _propTypes2.default.func.isRequired,
    handleOnYearGroupSave: _propTypes2.default.func,
    isNewCoursesSelected: _propTypes2.default.bool,
    newCourses: _propTypes2.default.array,
    showAssignSuccessToast: _propTypes2.default.bool,
    showAssignErrorToast: _propTypes2.default.bool,
    showToast: _propTypes2.default.func
};

function mapStateToProps() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    return _extends({}, state, {
        yearGroups: state.assignConquestCourses.yearGroups,
        countries: state.assignConquestCourses.countries,
        conquestCountries: state.assignConquestCourses.conquestCountries,
        courses: state.assignConquestCourses.filteredCourses,
        newCourses: state.classRoll.newCourses,
        isNewCoursesLoaded: state.classRoll.isProductCoursesLoaded,
        deselectCourse: state.assignConquestCourses.deselectCourse,
        isLoadingCountryYearGroups: state.assignConquestCourses.isLoadingCountryYearGroups,
        isProductCoursesLoaded: state.assignConquestCourses.isProductCoursesLoaded,
        isSchoolCoursesLoaded: state.assignConquestCourses.isSchoolCoursesLoaded,
        isCourseModalVisible: state.defaultCourses.isCourseModalVisible,
        courseDetails: state.defaultCourses.courseDetails,
        fetchingCourse: state.defaultCourses.fetchingCourse,
        selectedProduct: state.product,
        showAssignSuccessToast: state.assignCourseAdmin.showAssignSuccessToast,
        showAssignErrorToast: state.assignCourseAdmin.showAssignErrorToast
    });
}

exports.default = (0, _reactIntl.injectIntl)((0, _reactRedux.connect)(mapStateToProps)(AssignCoursesConquest));

/***/ }),
/* 803 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.default = function () {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
    var action = arguments[1];

    switch (action.type) {
        case actionTypes.GET_YEAR_GROUP_SUCCESS:
            {
                return _extends({}, state, { yearGroups: action.data });
            }
        case actionTypes.GET_COUNTRY_SUCCESS:
            {
                return _extends({}, state, { countries: action.data });
            }
        case actionTypes.GET_CONQUEST_COUNTRY_SUCCESS:
            {
                return _extends({}, state, { conquestCountries: action.data });
            }
        case actionTypes.GET_COUNTRY_YEAR_GROUPS_REQUEST:
            {
                return _extends({}, state, { isLoadingCountryYearGroups: true });
            }
        case actionTypes.GET_COUNTRY_YEAR_GROUPS_SUCCESS:
            {
                return _extends({}, state, {
                    isLoadingCountryYearGroups: action.isLoadingCountryYearGroups,
                    yearGroups: action.yearGroups });
            }
        case actionTypes.GET_COUNTRY_YEAR_GROUPS_FAILURE:
            {
                return _extends({}, state, { isLoadingCountryYearGroups: action.isLoadingCountryYearGroups });
            }

        case actionTypes.GET_PRODUCT_COURSE_REQUEST:
        case actionTypes.GET_SCHOOL_COURSE_REQUEST:
            {
                return _extends({}, state, {
                    isProductCoursesLoaded: false,
                    productCourses: [],
                    filteredCourses: []
                });
            }

        case actionTypes.GET_PRODUCT_COURSE_SUCCESS:
        case actionTypes.GET_SCHOOL_COURSE_SUCCESS:
            {
                return _extends({}, state, {
                    isProductCoursesLoaded: true,
                    productCourses: action.data,
                    filteredCourses: action.data
                });
            }

        case actionTypes.GET_FILTERED_CONQUEST_COURSES_SUCCESS:
            {
                return _extends({}, state, {
                    isProductCoursesLoaded: true,
                    filteredCourses: action.data
                });
            }

        case actionTypes.GET_PRODUCT_COURSE_FAILURE:
        case actionTypes.GET_SCHOOL_COURSE_FAILURE:
        case actionTypes.GET_FILTERED_CONQUEST_COURSES_FAILURE:
            {
                return _extends({}, state, {
                    isProductCoursesLoaded: true,
                    productCourses: [],
                    filteredCourses: []
                });
            }
        case actionTypes.CLEAR_COURSE_LIST:
            {
                return _extends({}, state, { productCourses: action.productCourses });
            }

        case actionTypes.DESELECT_COURSE:
            {
                return _extends({}, state, { deselectCourse: action.deselectCourse });
            }

        default:
            return _extends({}, state);
    }
};

var _actionTypes = __webpack_require__(191);

var actionTypes = _interopRequireWildcard(_actionTypes);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var initialState = {
    courses: [],
    yearGroups: [],
    countries: [],
    conquestCountries: [],
    isLoadingCountryYearGroups: false,
    isProductCoursesLoaded: false,
    deselectCourse: false,
    productCourses: [],
    filteredCourses: []
};

/***/ }),
/* 804 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.getCountryYearGroups = getCountryYearGroups;
exports.getCountryYearGroupsSaga = getCountryYearGroupsSaga;
exports.getYearGroup = getYearGroup;
exports.getYearGroupsSaga = getYearGroupsSaga;
exports.getCourseCountry = getCourseCountry;
exports.getCourseCountrySaga = getCourseCountrySaga;
exports.getConquestCourseCountry = getConquestCourseCountry;
exports.getConquestCourseCountrySaga = getConquestCourseCountrySaga;
exports.getProductCourse = getProductCourse;
exports.getProductCourseSaga = getProductCourseSaga;
exports.getSchoolCourse = getSchoolCourse;
exports.getSchoolCourseSaga = getSchoolCourseSaga;
exports.getFilteredConquestCourse = getFilteredConquestCourse;
exports.getFilteredConquestCourseSaga = getFilteredConquestCourseSaga;

var _effects = __webpack_require__(32);

var _api = __webpack_require__(33);

var api = _interopRequireWildcard(_api);

var _actions = __webpack_require__(801);

var actions = _interopRequireWildcard(_actions);

var _actionTypes = __webpack_require__(191);

var actionTypes = _interopRequireWildcard(_actionTypes);

var _constants = __webpack_require__(40);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var _marked = /*#__PURE__*/regeneratorRuntime.mark(getCountryYearGroups),
    _marked2 = /*#__PURE__*/regeneratorRuntime.mark(getCountryYearGroupsSaga),
    _marked3 = /*#__PURE__*/regeneratorRuntime.mark(getYearGroup),
    _marked4 = /*#__PURE__*/regeneratorRuntime.mark(getYearGroupsSaga),
    _marked5 = /*#__PURE__*/regeneratorRuntime.mark(getCourseCountry),
    _marked6 = /*#__PURE__*/regeneratorRuntime.mark(getCourseCountrySaga),
    _marked7 = /*#__PURE__*/regeneratorRuntime.mark(getConquestCourseCountry),
    _marked8 = /*#__PURE__*/regeneratorRuntime.mark(getConquestCourseCountrySaga),
    _marked9 = /*#__PURE__*/regeneratorRuntime.mark(getProductCourse),
    _marked10 = /*#__PURE__*/regeneratorRuntime.mark(getProductCourseSaga),
    _marked11 = /*#__PURE__*/regeneratorRuntime.mark(getSchoolCourse),
    _marked12 = /*#__PURE__*/regeneratorRuntime.mark(getSchoolCourseSaga),
    _marked13 = /*#__PURE__*/regeneratorRuntime.mark(getFilteredConquestCourse),
    _marked14 = /*#__PURE__*/regeneratorRuntime.mark(getFilteredConquestCourseSaga);

function getCountryYearGroups(action) {
    var countryCode, _action$success, success, _action$failure, failure, response;

    return regeneratorRuntime.wrap(function getCountryYearGroups$(_context) {
        while (1) {
            switch (_context.prev = _context.next) {
                case 0:
                    countryCode = action.countryCode, _action$success = action.success, success = _action$success === undefined ? actions.getCountryYearGroupSuccess : _action$success, _action$failure = action.failure, failure = _action$failure === undefined ? actions.getCountryYearGroupFailure : _action$failure;
                    _context.next = 3;
                    return (0, _effects.call)(api.getCountryYearGroups, { countryCode: countryCode });

                case 3:
                    response = _context.sent;

                    if (!(response.status === 200)) {
                        _context.next = 9;
                        break;
                    }

                    _context.next = 7;
                    return (0, _effects.put)(success(response.data));

                case 7:
                    _context.next = 11;
                    break;

                case 9:
                    _context.next = 11;
                    return (0, _effects.put)(failure());

                case 11:
                case 'end':
                    return _context.stop();
            }
        }
    }, _marked, this);
}

function getCountryYearGroupsSaga() {
    return regeneratorRuntime.wrap(function getCountryYearGroupsSaga$(_context2) {
        while (1) {
            switch (_context2.prev = _context2.next) {
                case 0:
                    _context2.next = 2;
                    return (0, _effects.takeLatest)(actionTypes.GET_COUNTRY_YEAR_GROUPS_REQUEST, getCountryYearGroups);

                case 2:
                case 'end':
                    return _context2.stop();
            }
        }
    }, _marked2, this);
}

function getYearGroup() {
    var payload;
    return regeneratorRuntime.wrap(function getYearGroup$(_context3) {
        while (1) {
            switch (_context3.prev = _context3.next) {
                case 0:
                    _context3.next = 2;
                    return (0, _effects.call)(api.getYearGroups);

                case 2:
                    payload = _context3.sent;

                    if (!(payload.status === 200)) {
                        _context3.next = 8;
                        break;
                    }

                    _context3.next = 6;
                    return (0, _effects.put)({ type: actionTypes.GET_YEAR_GROUP_SUCCESS, data: payload });

                case 6:
                    _context3.next = 10;
                    break;

                case 8:
                    _context3.next = 10;
                    return (0, _effects.put)({ type: actionTypes.GET_YEAR_GROUP_FAILURE });

                case 10:
                case 'end':
                    return _context3.stop();
            }
        }
    }, _marked3, this);
}

function getYearGroupsSaga() {
    return regeneratorRuntime.wrap(function getYearGroupsSaga$(_context4) {
        while (1) {
            switch (_context4.prev = _context4.next) {
                case 0:
                    _context4.next = 2;
                    return (0, _effects.takeLatest)(actionTypes.GET_YEAR_GROUP_REQUEST, getYearGroup);

                case 2:
                case 'end':
                    return _context4.stop();
            }
        }
    }, _marked4, this);
}

function getCourseCountry(_ref) {
    var selectedProductId = _ref.selectedProductId;
    var countriesRequest, response;
    return regeneratorRuntime.wrap(function getCourseCountry$(_context5) {
        while (1) {
            switch (_context5.prev = _context5.next) {
                case 0:
                    countriesRequest = { ProductId: selectedProductId };
                    _context5.next = 3;
                    return (0, _effects.call)(api.getCourseCountries, countriesRequest);

                case 3:
                    response = _context5.sent;

                    if (!(response.status === 200)) {
                        _context5.next = 9;
                        break;
                    }

                    _context5.next = 7;
                    return (0, _effects.put)(actions.getCourseCountrySuccess(response.data));

                case 7:
                    _context5.next = 11;
                    break;

                case 9:
                    _context5.next = 11;
                    return (0, _effects.put)(actions.getCourseCountryFailure());

                case 11:
                case 'end':
                    return _context5.stop();
            }
        }
    }, _marked5, this);
}

function getCourseCountrySaga() {
    return regeneratorRuntime.wrap(function getCourseCountrySaga$(_context6) {
        while (1) {
            switch (_context6.prev = _context6.next) {
                case 0:
                    _context6.next = 2;
                    return (0, _effects.takeLatest)(actionTypes.GET_COUNTRY_REQUEST, getCourseCountry);

                case 2:
                case 'end':
                    return _context6.stop();
            }
        }
    }, _marked6, this);
}

function getConquestCourseCountry(_ref2) {
    var selectedProductId = _ref2.selectedProductId,
        _ref2$countryCourseTy = _ref2.countryCourseType,
        countryCourseType = _ref2$countryCourseTy === undefined ? _constants.COUNTRY_COURSE_TYPE.CONQUEST : _ref2$countryCourseTy;
    var countriesRequest, response;
    return regeneratorRuntime.wrap(function getConquestCourseCountry$(_context7) {
        while (1) {
            switch (_context7.prev = _context7.next) {
                case 0:
                    countriesRequest = { ProductId: selectedProductId, countryCourseType: countryCourseType };
                    _context7.next = 3;
                    return (0, _effects.call)(api.getConquestCourseCountries, countriesRequest);

                case 3:
                    response = _context7.sent;

                    if (!(response.status === 200)) {
                        _context7.next = 9;
                        break;
                    }

                    _context7.next = 7;
                    return (0, _effects.put)(actions.getConquestCourseCountrySuccess(response.data));

                case 7:
                    _context7.next = 11;
                    break;

                case 9:
                    _context7.next = 11;
                    return (0, _effects.put)(actions.getConquestCourseCountryFailure());

                case 11:
                case 'end':
                    return _context7.stop();
            }
        }
    }, _marked7, this);
}

function getConquestCourseCountrySaga() {
    return regeneratorRuntime.wrap(function getConquestCourseCountrySaga$(_context8) {
        while (1) {
            switch (_context8.prev = _context8.next) {
                case 0:
                    _context8.next = 2;
                    return (0, _effects.takeLatest)(actionTypes.GET_CONQUEST_COUNTRY_REQUEST, getConquestCourseCountry);

                case 2:
                case 'end':
                    return _context8.stop();
            }
        }
    }, _marked8, this);
}

function getProductCourse(_ref3) {
    var countryCode = _ref3.countryCode,
        productId = _ref3.productId,
        yearGroup = _ref3.yearGroup;
    var countriesRequest, response;
    return regeneratorRuntime.wrap(function getProductCourse$(_context9) {
        while (1) {
            switch (_context9.prev = _context9.next) {
                case 0:
                    countriesRequest = { countryCode: countryCode, productId: productId, yearGroup: yearGroup };
                    _context9.next = 3;
                    return (0, _effects.call)(api.getProductCourses, countriesRequest);

                case 3:
                    response = _context9.sent;

                    if (!(response.status === 200)) {
                        _context9.next = 9;
                        break;
                    }

                    _context9.next = 7;
                    return (0, _effects.put)(actions.getProductCourseSuccess(response.data));

                case 7:
                    _context9.next = 11;
                    break;

                case 9:
                    _context9.next = 11;
                    return (0, _effects.put)(actions.getProductCourseFailure());

                case 11:
                case 'end':
                    return _context9.stop();
            }
        }
    }, _marked9, this);
}

function getProductCourseSaga() {
    return regeneratorRuntime.wrap(function getProductCourseSaga$(_context10) {
        while (1) {
            switch (_context10.prev = _context10.next) {
                case 0:
                    _context10.next = 2;
                    return (0, _effects.takeLatest)(actionTypes.GET_PRODUCT_COURSE_REQUEST, getProductCourse);

                case 2:
                case 'end':
                    return _context10.stop();
            }
        }
    }, _marked10, this);
}

function getSchoolCourse(_ref4) {
    var yearGroup = _ref4.yearGroup;
    var request, response;
    return regeneratorRuntime.wrap(function getSchoolCourse$(_context11) {
        while (1) {
            switch (_context11.prev = _context11.next) {
                case 0:
                    request = { yearGroup: yearGroup };
                    _context11.next = 3;
                    return (0, _effects.call)(api.getSchoolCourses, request);

                case 3:
                    response = _context11.sent;

                    if (!(response.status === 200)) {
                        _context11.next = 9;
                        break;
                    }

                    _context11.next = 7;
                    return (0, _effects.put)(actions.getSchoolCourseSuccess(response.data));

                case 7:
                    _context11.next = 11;
                    break;

                case 9:
                    _context11.next = 11;
                    return (0, _effects.put)({ type: actionTypes.GET_SCHOOL_COURSE_FAILURE });

                case 11:
                case 'end':
                    return _context11.stop();
            }
        }
    }, _marked11, this);
}

function getSchoolCourseSaga() {
    return regeneratorRuntime.wrap(function getSchoolCourseSaga$(_context12) {
        while (1) {
            switch (_context12.prev = _context12.next) {
                case 0:
                    _context12.next = 2;
                    return (0, _effects.takeLatest)(actionTypes.GET_SCHOOL_COURSE_REQUEST, getSchoolCourse);

                case 2:
                case 'end':
                    return _context12.stop();
            }
        }
    }, _marked12, this);
}

function getFilteredConquestCourse(_ref5) {
    var countryCode = _ref5.countryCode,
        productId = _ref5.productId,
        yearGroup = _ref5.yearGroup,
        selectGenericCourses = _ref5.selectGenericCourses,
        includeGlobalCourses = _ref5.includeGlobalCourses;
    var countriesRequest, response;
    return regeneratorRuntime.wrap(function getFilteredConquestCourse$(_context13) {
        while (1) {
            switch (_context13.prev = _context13.next) {
                case 0:
                    countriesRequest = { countryCode: countryCode, productId: productId, yearGroup: yearGroup, selectGenericCourses: selectGenericCourses, includeGlobalCourses: includeGlobalCourses };
                    _context13.next = 3;
                    return (0, _effects.call)(api.getConquestFilteredCourses, countriesRequest);

                case 3:
                    response = _context13.sent;

                    if (!(response.status === 200)) {
                        _context13.next = 9;
                        break;
                    }

                    _context13.next = 7;
                    return (0, _effects.put)({
                        type: actionTypes.GET_FILTERED_CONQUEST_COURSES_SUCCESS,
                        data: response.data,
                        isProductCoursesLoaded: true,
                        isProductCoursesFetching: false
                    });

                case 7:
                    _context13.next = 11;
                    break;

                case 9:
                    _context13.next = 11;
                    return (0, _effects.put)({ type: actionTypes.GET_FILTERED_CONQUEST_COURSES_FAILURE, isProductCoursesLoaded: true, isProductCoursesFetching: false });

                case 11:
                case 'end':
                    return _context13.stop();
            }
        }
    }, _marked13, this);
}

function getFilteredConquestCourseSaga() {
    return regeneratorRuntime.wrap(function getFilteredConquestCourseSaga$(_context14) {
        while (1) {
            switch (_context14.prev = _context14.next) {
                case 0:
                    _context14.next = 2;
                    return (0, _effects.takeLatest)(actionTypes.GET_FILTERED_CONQUEST_COURSES_REQUEST, getFilteredConquestCourse);

                case 2:
                case 'end':
                    return _context14.stop();
            }
        }
    }, _marked14, this);
}

/***/ }),
/* 805 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.getSchoolCourse = exports.getProductCourseFailure = exports.getProductCourseSuccess = exports.getProductCourse = exports.getCourseCountryFailure = exports.getCourseCountrySuccess = exports.getCourseCountry = exports.deselectCourses = exports.getCountryYearGroupFailure = exports.getCountryYearGroupSuccess = exports.getCountryYearGroupRequest = undefined;

var _actionTypes = __webpack_require__(192);

var actionTypes = _interopRequireWildcard(_actionTypes);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var getCountryYearGroupRequest = exports.getCountryYearGroupRequest = function getCountryYearGroupRequest(countryCode, success, failure) {
    return { type: actionTypes.GET_COUNTRY_YEAR_GROUPS_REQUEST, countryCode: countryCode, success: success, failure: failure, countryCourses: [] };
};

var getCountryYearGroupSuccess = exports.getCountryYearGroupSuccess = function getCountryYearGroupSuccess(yearGroups) {
    return { type: actionTypes.GET_COUNTRY_YEAR_GROUPS_SUCCESS, isLoadingCountryCourses: false, yearGroups: yearGroups };
};

var getCountryYearGroupFailure = exports.getCountryYearGroupFailure = function getCountryYearGroupFailure() {
    return { type: actionTypes.GET_COUNTRY_YEAR_GROUPS_FAILURE, isLoadingCountryCourses: false };
};

var deselectCourses = exports.deselectCourses = function deselectCourses() {
    var deselectCourse = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
    return { type: actionTypes.DESELECT_COURSE, deselectCourse: deselectCourse };
};

var getCourseCountry = exports.getCourseCountry = function getCourseCountry(selectedProductId) {
    return { type: actionTypes.GET_COUNTRY_REQUEST, selectedProductId: selectedProductId };
};

var getCourseCountrySuccess = exports.getCourseCountrySuccess = function getCourseCountrySuccess(data) {
    return { type: actionTypes.GET_COUNTRY_SUCCESS, data: data };
};

var getCourseCountryFailure = exports.getCourseCountryFailure = function getCourseCountryFailure() {
    return { type: actionTypes.GET_COUNTRY_FAILURE };
};

var getProductCourse = exports.getProductCourse = function getProductCourse(countryCode, productId, yearGroup) {
    return { type: actionTypes.GET_PRODUCT_COURSE_REQUEST, countryCode: countryCode, productId: productId, yearGroup: yearGroup, isProductCoursesLoaded: false, isProductCoursesFetching: true };
};

var getProductCourseSuccess = exports.getProductCourseSuccess = function getProductCourseSuccess(data) {
    return { type: actionTypes.GET_PRODUCT_COURSE_SUCCESS, data: data, isProductCoursesLoaded: true, isProductCoursesFetching: false };
};

var getProductCourseFailure = exports.getProductCourseFailure = function getProductCourseFailure() {
    return { type: actionTypes.GET_PRODUCT_COURSE_FAILURE, isProductCoursesLoaded: true, isProductCoursesFetching: false };
};

var getSchoolCourse = exports.getSchoolCourse = function getSchoolCourse(yearGroup) {
    return { type: actionTypes.GET_SCHOOL_COURSE_REQUEST, yearGroup: yearGroup };
};

/***/ }),
/* 806 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = __webpack_require__(28);

var _orderBy = __webpack_require__(173);

var _orderBy2 = _interopRequireDefault(_orderBy);

var _assignCourseLegacy = __webpack_require__(637);

var _assignCourseLegacy2 = _interopRequireDefault(_assignCourseLegacy);

var _constants = __webpack_require__(96);

var _constants2 = _interopRequireDefault(_constants);

var _actionTypes = __webpack_require__(192);

var actionTypes = _interopRequireWildcard(_actionTypes);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var AssignCoursesLegacy = function (_Component) {
    _inherits(AssignCoursesLegacy, _Component);

    function AssignCoursesLegacy(props) {
        _classCallCheck(this, AssignCoursesLegacy);

        var _this = _possibleConstructorReturn(this, (AssignCoursesLegacy.__proto__ || Object.getPrototypeOf(AssignCoursesLegacy)).call(this, props));

        _this.clearSelectedCourse = function (yearGroups) {
            var dispatch = _this.props.dispatch;

            var filteredCourses = _this.state.filteredCourses.map(function (course) {
                return _extends({}, course, {
                    isSelected: false
                });
            });
            _this.setState({ filteredCourses: filteredCourses, yearGroups: yearGroups });
            dispatch({ type: actionTypes.DESELECT_COURSE, deselectCourse: false });
        };

        _this.handleOnCountryChange = function (name, value) {
            var dispatch = _this.props.dispatch;

            _this.selectedCountryId = value;

            _this.setState({
                selectedCountryId: value,
                selectedYearGroupId: '-1',
                filteredCourses: [],
                searchQuery: ''
            });

            if (value !== '-1' && value !== _constants2.default.SCHOOL_COURSES) {
                dispatch({
                    type: actionTypes.GET_COUNTRY_YEAR_GROUPS_REQUEST,
                    countryCode: value,
                    countryCourses: []
                });
            }

            if (value === _constants2.default.SCHOOL_COURSES) {
                dispatch({ type: actionTypes.GET_YEAR_GROUP_REQUEST });
            }

            dispatch({ type: actionTypes.CLEAR_COURSE_LIST, productCourses: [] });
            _this.selectedCourse = { id: -1, name: '' };
            _this.props.handleOnCourseSelection(_this.selectedCourse, true);
        };

        _this.handleOnYearGroupChange = function (name, value) {
            var _this$props = _this.props,
                selectedProduct = _this$props.selectedProduct,
                dispatch = _this$props.dispatch;


            _this.setState({ selectedYearGroupId: value, initialLoad: false, searchQuery: '' });

            if (_this.selectedCountryId === _constants2.default.SCHOOL_COURSES) {
                if (value !== '-1') {
                    dispatch({ type: actionTypes.GET_SCHOOL_COURSE_REQUEST, yearGroup: value });
                } else {
                    _this.updateCourseSelection();
                }
            } else if (value !== '-1') {
                dispatch({
                    type: actionTypes.GET_FILTERED_LEGACY_COURSES_REQUEST,
                    countryCode: _this.selectedCountryId,
                    productId: selectedProduct.id,
                    yearGroup: value,
                    isProductCoursesLoaded: false,
                    isProductCoursesFetching: true,
                    selectGenericCourses: false,
                    includeGlobalCourses: true
                });
            } else {
                _this.updateCourseSelection();
            }

            _this.selectedCourse = { id: -1, name: '' };
            _this.props.handleOnCourseSelection(_this.selectedCourse, true);
        };

        _this.handleOnClearSearch = function () {
            var courses = _this.props.courses;


            _this.setState({ searchQuery: '' });

            if (_this.selectedCountryId === _constants2.default.SCHOOL_COURSES) {
                _this.updateCourseSelection(courses);
            } else {
                _this.updateCourseSelection((0, _orderBy2.default)(courses, ['isDefault'], ['desc']));
            }
        };

        _this.assignToYearGroup = function () {
            _this.props.assignToYearGroup(_this.selectedCourse);
            _this.clearSelectedCourse();
        };

        _this.handleOnSearchCourse = function (e) {
            var courses = _this.props.courses;

            var courseFilter = [];
            if (_this.selectedCountryId === _constants2.default.SCHOOL_COURSES) {
                courseFilter = courses;
            } else {
                courseFilter = (0, _orderBy2.default)(courses, ['isDefault'], ['desc']);
            }
            var filteredCourses = courseFilter.filter(function (course) {
                return course.name.toLowerCase().indexOf(e.target.value.toLowerCase()) !== -1;
            });

            if (!filteredCourses.length) {
                _this.selectedCourse = { id: -1, name: '' };
                _this.props.handleOnCourseSelection(_this.selectedCourse, true);
            }

            _this.setState({ searchQuery: e.target.value });
            _this.updateCourseSelection(filteredCourses);
        };

        _this.handleOnCourseSelection = function (course) {
            _this.selectedCourse = course;
            _this.updateCourseSelection(_this.state.filteredCourses);
            _this.props.handleOnCourseSelection(course);
        };

        _this.updateCourseSelection = function () {
            var courses = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

            var filteredCourses = courses.map(function (course) {
                var isSelected = false;
                if (_this.selectedCourse && course.name.toLowerCase() === _this.selectedCourse.name.toLowerCase()) {
                    isSelected = true;
                }
                return _extends({}, course, {
                    isSelected: isSelected
                });
            });
            _this.setState({ filteredCourses: filteredCourses });
        };

        _this.disableYearGroup = function () {
            return _this.selectedCountryId === '-1';
        };

        _this.disableSearchCourse = function () {
            var selectedYearGroupId = _this.state.selectedYearGroupId;

            return _this.selectedCountryId === '-1' || selectedYearGroupId === '-1';
        };

        _this.handleOnViewCourse = function (courseId) {
            _this.props.dispatch({ type: actionTypes.SHOW_COURSE_DETAILS, courseId: courseId });
        };

        _this.state = {
            searchQuery: '',
            filteredCourses: [],
            selectedYearGroupId: '-1',
            selectedCountryId: '-1',
            yearGroups: [],
            initialLoad: true
        };

        _this.countries = [];
        _this.selectedCourse = { id: -1, name: '' };
        _this.selectedCountryId = '-1';
        return _this;
    }

    _createClass(AssignCoursesLegacy, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            var _props = this.props,
                selectedProduct = _props.selectedProduct,
                dispatch = _props.dispatch;

            dispatch({ type: actionTypes.GET_COUNTRY_REQUEST, selectedProductId: selectedProduct.id });
        }
    }, {
        key: 'componentWillReceiveProps',
        value: function componentWillReceiveProps(nextProps) {
            var yearGroups = nextProps.yearGroups,
                countries = nextProps.countries,
                courses = nextProps.courses,
                deselectCourse = nextProps.deselectCourse;


            this.countries = countries;
            this.selectedCourse = nextProps.selectedCourse;

            if (this.props.courses !== courses) {
                if (this.selectedCountryId === _constants2.default.SCHOOL_COURSES) {
                    this.updateCourseSelection(courses);
                } else {
                    this.updateCourseSelection((0, _orderBy2.default)(courses, ['isDefault'], ['desc']));
                }
            }

            if (deselectCourse) {
                this.clearSelectedCourse(yearGroups);
            } else {
                this.setState({ yearGroups: yearGroups });
            }
        }
    }, {
        key: 'render',
        value: function render() {
            var _state = this.state,
                filteredCourses = _state.filteredCourses,
                initialLoad = _state.initialLoad,
                searchQuery = _state.searchQuery,
                selectedYearGroupId = _state.selectedYearGroupId,
                yearGroups = _state.yearGroups;


            return _react2.default.createElement(_assignCourseLegacy2.default, _extends({
                countries: this.countries,
                disableSearch: this.disableSearchCourse(),
                disableYearGroup: this.disableYearGroup(),
                filteredCourses: filteredCourses,
                handleOnCountryChange: this.handleOnCountryChange,
                handleOnSearchCourse: this.handleOnSearchCourse,
                handleOnViewCourse: this.handleOnViewCourse,
                handleOnYearGroupChange: this.handleOnYearGroupChange,
                initialLoad: initialLoad,
                searchQuery: searchQuery,
                selectedYearGroupId: selectedYearGroupId,
                yearGroups: yearGroups
            }, this.props, {
                assignToYearGroup: this.assignToYearGroup,
                handleOnCourseSelection: this.handleOnCourseSelection }));
        }
    }]);

    return AssignCoursesLegacy;
}(_react.Component);

AssignCoursesLegacy.propTypes = {
    selectedProduct: _propTypes2.default.object,
    countries: _propTypes2.default.array,
    courses: _propTypes2.default.array,
    yearGroups: _propTypes2.default.array,
    handleOnCourseSelection: _propTypes2.default.func.isRequired,
    selectedCourse: _propTypes2.default.object,
    isProductCoursesLoaded: _propTypes2.default.bool,
    isSchoolCoursesLoaded: _propTypes2.default.bool,
    deselectCourse: _propTypes2.default.bool,
    dispatch: _propTypes2.default.func.isRequired,
    assignToYearGroup: _propTypes2.default.func.isRequired
};

function mapStateToProps() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    return _extends({}, state, {
        yearGroups: state.assignLegacyCourses.yearGroups,
        countries: state.assignLegacyCourses.countries,
        courses: state.assignLegacyCourses.productCourses,
        deselectCourse: state.assignLegacyCourses.deselectCourse,
        isLoadingCountryYearGroups: state.assignLegacyCourses.isLoadingCountryYearGroups,
        isProductCoursesLoaded: state.assignLegacyCourses.isProductCoursesLoaded,
        isSchoolCoursesLoaded: state.assignLegacyCourses.isSchoolCoursesLoaded,
        isCourseModalVisible: state.defaultCourses.isCourseModalVisible,
        courseDetails: state.defaultCourses.courseDetails,
        fetchingCourse: state.defaultCourses.fetchingCourse,
        selectedProduct: state.product,
        forYear: _propTypes2.default.bool
    });
}

exports.default = (0, _reactRedux.connect)(mapStateToProps)(AssignCoursesLegacy);

/***/ }),
/* 807 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.default = function () {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
    var action = arguments[1];

    switch (action.type) {
        case actionTypes.GET_YEAR_GROUP_SUCCESS:
            {
                return _extends({}, state, { yearGroups: action.data });
            }
        case actionTypes.GET_COUNTRY_SUCCESS:
            {
                return _extends({}, state, { countries: action.data });
            }

        case actionTypes.GET_COUNTRY_YEAR_GROUPS_REQUEST:
            {
                return _extends({}, state, { isLoadingCountryYearGroups: true });
            }
        case actionTypes.GET_COUNTRY_YEAR_GROUPS_SUCCESS:
            {
                return _extends({}, state, {
                    isLoadingCountryYearGroups: action.isLoadingCountryYearGroups,
                    yearGroups: action.yearGroups });
            }
        case actionTypes.GET_COUNTRY_YEAR_GROUPS_FAILURE:
            {
                return _extends({}, state, { isLoadingCountryYearGroups: action.isLoadingCountryYearGroups });
            }

        case actionTypes.GET_PRODUCT_COURSE_REQUEST:
        case actionTypes.GET_SCHOOL_COURSE_REQUEST:
            {
                return _extends({}, state, {
                    isProductCoursesLoaded: false,
                    productCourses: []
                });
            }

        case actionTypes.GET_PRODUCT_COURSE_SUCCESS:
        case actionTypes.GET_SCHOOL_COURSE_SUCCESS:
            {
                return _extends({}, state, {
                    isProductCoursesLoaded: true,
                    productCourses: action.data
                });
            }

        case actionTypes.GET_FILTERED_LEGACY_COURSES_SUCCESS:
            {
                return _extends({}, state, {
                    isProductCoursesLoaded: true,
                    productCourses: action.data
                });
            }

        case actionTypes.GET_PRODUCT_COURSE_FAILURE:
        case actionTypes.GET_SCHOOL_COURSE_FAILURE:
        case actionTypes.GET_FILTERED_LEGACY_COURSES_FAILURE:
            {
                return _extends({}, state, {
                    isProductCoursesLoaded: true,
                    productCourses: []
                });
            }
        case actionTypes.CLEAR_COURSE_LIST:
            {
                return _extends({}, state, { productCourses: action.productCourses });
            }

        case actionTypes.DESELECT_COURSE:
            {
                return _extends({}, state, { deselectCourse: action.deselectCourse });
            }

        default:
            return _extends({}, state);
    }
};

var _actionTypes = __webpack_require__(192);

var actionTypes = _interopRequireWildcard(_actionTypes);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var initialState = {
    courses: [],
    yearGroups: [],
    countries: [],
    isLoadingCountryYearGroups: false,
    isProductCoursesLoaded: false,
    deselectCourse: false,
    productCourses: []
};

/***/ }),
/* 808 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.getCountryYearGroups = getCountryYearGroups;
exports.getCountryYearGroupsSaga = getCountryYearGroupsSaga;
exports.getYearGroup = getYearGroup;
exports.getYearGroupsSaga = getYearGroupsSaga;
exports.getCourseCountry = getCourseCountry;
exports.getCourseCountrySaga = getCourseCountrySaga;
exports.getProductCourse = getProductCourse;
exports.getProductCourseSaga = getProductCourseSaga;
exports.getSchoolCourse = getSchoolCourse;
exports.getSchoolCourseSaga = getSchoolCourseSaga;
exports.getFilteredLegacyCourse = getFilteredLegacyCourse;
exports.getFilteredLegacyCourseSaga = getFilteredLegacyCourseSaga;

var _effects = __webpack_require__(32);

var _api = __webpack_require__(33);

var api = _interopRequireWildcard(_api);

var _actions = __webpack_require__(805);

var actions = _interopRequireWildcard(_actions);

var _actionTypes = __webpack_require__(192);

var actionTypes = _interopRequireWildcard(_actionTypes);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var _marked = /*#__PURE__*/regeneratorRuntime.mark(getCountryYearGroups),
    _marked2 = /*#__PURE__*/regeneratorRuntime.mark(getCountryYearGroupsSaga),
    _marked3 = /*#__PURE__*/regeneratorRuntime.mark(getYearGroup),
    _marked4 = /*#__PURE__*/regeneratorRuntime.mark(getYearGroupsSaga),
    _marked5 = /*#__PURE__*/regeneratorRuntime.mark(getCourseCountry),
    _marked6 = /*#__PURE__*/regeneratorRuntime.mark(getCourseCountrySaga),
    _marked7 = /*#__PURE__*/regeneratorRuntime.mark(getProductCourse),
    _marked8 = /*#__PURE__*/regeneratorRuntime.mark(getProductCourseSaga),
    _marked9 = /*#__PURE__*/regeneratorRuntime.mark(getSchoolCourse),
    _marked10 = /*#__PURE__*/regeneratorRuntime.mark(getSchoolCourseSaga),
    _marked11 = /*#__PURE__*/regeneratorRuntime.mark(getFilteredLegacyCourse),
    _marked12 = /*#__PURE__*/regeneratorRuntime.mark(getFilteredLegacyCourseSaga);

function getCountryYearGroups(action) {
    var countryCode, _action$success, success, _action$failure, failure, response;

    return regeneratorRuntime.wrap(function getCountryYearGroups$(_context) {
        while (1) {
            switch (_context.prev = _context.next) {
                case 0:
                    countryCode = action.countryCode, _action$success = action.success, success = _action$success === undefined ? actions.getCountryYearGroupSuccess : _action$success, _action$failure = action.failure, failure = _action$failure === undefined ? actions.getCountryYearGroupFailure : _action$failure;
                    _context.next = 3;
                    return (0, _effects.call)(api.getCountryYearGroups, { countryCode: countryCode });

                case 3:
                    response = _context.sent;

                    if (!(response.status === 200)) {
                        _context.next = 9;
                        break;
                    }

                    _context.next = 7;
                    return (0, _effects.put)(success(response.data));

                case 7:
                    _context.next = 11;
                    break;

                case 9:
                    _context.next = 11;
                    return (0, _effects.put)(failure());

                case 11:
                case 'end':
                    return _context.stop();
            }
        }
    }, _marked, this);
}

function getCountryYearGroupsSaga() {
    return regeneratorRuntime.wrap(function getCountryYearGroupsSaga$(_context2) {
        while (1) {
            switch (_context2.prev = _context2.next) {
                case 0:
                    _context2.next = 2;
                    return (0, _effects.takeLatest)(actionTypes.GET_COUNTRY_YEAR_GROUPS_REQUEST, getCountryYearGroups);

                case 2:
                case 'end':
                    return _context2.stop();
            }
        }
    }, _marked2, this);
}

function getYearGroup() {
    var payload;
    return regeneratorRuntime.wrap(function getYearGroup$(_context3) {
        while (1) {
            switch (_context3.prev = _context3.next) {
                case 0:
                    _context3.next = 2;
                    return (0, _effects.call)(api.getYearGroups);

                case 2:
                    payload = _context3.sent;

                    if (!(payload.status === 200)) {
                        _context3.next = 8;
                        break;
                    }

                    _context3.next = 6;
                    return (0, _effects.put)({ type: actionTypes.GET_YEAR_GROUP_SUCCESS, data: payload });

                case 6:
                    _context3.next = 10;
                    break;

                case 8:
                    _context3.next = 10;
                    return (0, _effects.put)({ type: actionTypes.GET_YEAR_GROUP_FAILURE });

                case 10:
                case 'end':
                    return _context3.stop();
            }
        }
    }, _marked3, this);
}

function getYearGroupsSaga() {
    return regeneratorRuntime.wrap(function getYearGroupsSaga$(_context4) {
        while (1) {
            switch (_context4.prev = _context4.next) {
                case 0:
                    _context4.next = 2;
                    return (0, _effects.takeLatest)(actionTypes.GET_YEAR_GROUP_REQUEST, getYearGroup);

                case 2:
                case 'end':
                    return _context4.stop();
            }
        }
    }, _marked4, this);
}

function getCourseCountry(_ref) {
    var selectedProductId = _ref.selectedProductId;
    var countriesRequest, response;
    return regeneratorRuntime.wrap(function getCourseCountry$(_context5) {
        while (1) {
            switch (_context5.prev = _context5.next) {
                case 0:
                    countriesRequest = { ProductId: selectedProductId };
                    _context5.next = 3;
                    return (0, _effects.call)(api.getCourseCountries, countriesRequest);

                case 3:
                    response = _context5.sent;

                    if (!(response.status === 200)) {
                        _context5.next = 9;
                        break;
                    }

                    _context5.next = 7;
                    return (0, _effects.put)(actions.getCourseCountrySuccess(response.data));

                case 7:
                    _context5.next = 11;
                    break;

                case 9:
                    _context5.next = 11;
                    return (0, _effects.put)(actions.getCourseCountryFailure());

                case 11:
                case 'end':
                    return _context5.stop();
            }
        }
    }, _marked5, this);
}

function getCourseCountrySaga() {
    return regeneratorRuntime.wrap(function getCourseCountrySaga$(_context6) {
        while (1) {
            switch (_context6.prev = _context6.next) {
                case 0:
                    _context6.next = 2;
                    return (0, _effects.takeLatest)(actionTypes.GET_COUNTRY_REQUEST, getCourseCountry);

                case 2:
                case 'end':
                    return _context6.stop();
            }
        }
    }, _marked6, this);
}

function getProductCourse(_ref2) {
    var countryCode = _ref2.countryCode,
        productId = _ref2.productId,
        yearGroup = _ref2.yearGroup;
    var countriesRequest, response;
    return regeneratorRuntime.wrap(function getProductCourse$(_context7) {
        while (1) {
            switch (_context7.prev = _context7.next) {
                case 0:
                    countriesRequest = { countryCode: countryCode, productId: productId, yearGroup: yearGroup };
                    _context7.next = 3;
                    return (0, _effects.call)(api.getProductCourses, countriesRequest);

                case 3:
                    response = _context7.sent;

                    if (!(response.status === 200)) {
                        _context7.next = 9;
                        break;
                    }

                    _context7.next = 7;
                    return (0, _effects.put)(actions.getProductCourseSuccess(response.data));

                case 7:
                    _context7.next = 11;
                    break;

                case 9:
                    _context7.next = 11;
                    return (0, _effects.put)(actions.getProductCourseFailure());

                case 11:
                case 'end':
                    return _context7.stop();
            }
        }
    }, _marked7, this);
}

function getProductCourseSaga() {
    return regeneratorRuntime.wrap(function getProductCourseSaga$(_context8) {
        while (1) {
            switch (_context8.prev = _context8.next) {
                case 0:
                    _context8.next = 2;
                    return (0, _effects.takeLatest)(actionTypes.GET_PRODUCT_COURSE_REQUEST, getProductCourse);

                case 2:
                case 'end':
                    return _context8.stop();
            }
        }
    }, _marked8, this);
}

function getSchoolCourse(_ref3) {
    var yearGroup = _ref3.yearGroup;
    var request, response;
    return regeneratorRuntime.wrap(function getSchoolCourse$(_context9) {
        while (1) {
            switch (_context9.prev = _context9.next) {
                case 0:
                    request = { yearGroup: yearGroup };
                    _context9.next = 3;
                    return (0, _effects.call)(api.getSchoolCourses, request);

                case 3:
                    response = _context9.sent;

                    if (!(response.status === 200)) {
                        _context9.next = 9;
                        break;
                    }

                    _context9.next = 7;
                    return (0, _effects.put)(actions.getSchoolCourseSuccess(response.data));

                case 7:
                    _context9.next = 11;
                    break;

                case 9:
                    _context9.next = 11;
                    return (0, _effects.put)({ type: actionTypes.GET_SCHOOL_COURSE_FAILURE });

                case 11:
                case 'end':
                    return _context9.stop();
            }
        }
    }, _marked9, this);
}

function getSchoolCourseSaga() {
    return regeneratorRuntime.wrap(function getSchoolCourseSaga$(_context10) {
        while (1) {
            switch (_context10.prev = _context10.next) {
                case 0:
                    _context10.next = 2;
                    return (0, _effects.takeLatest)(actionTypes.GET_SCHOOL_COURSE_REQUEST, getSchoolCourse);

                case 2:
                case 'end':
                    return _context10.stop();
            }
        }
    }, _marked10, this);
}

function getFilteredLegacyCourse(_ref4) {
    var countryCode = _ref4.countryCode,
        productId = _ref4.productId,
        yearGroup = _ref4.yearGroup,
        selectGenericCourses = _ref4.selectGenericCourses,
        includeGlobalCourses = _ref4.includeGlobalCourses;
    var countriesRequest, response;
    return regeneratorRuntime.wrap(function getFilteredLegacyCourse$(_context11) {
        while (1) {
            switch (_context11.prev = _context11.next) {
                case 0:
                    countriesRequest = { countryCode: countryCode, productId: productId, yearGroup: yearGroup, selectGenericCourses: selectGenericCourses, includeGlobalCourses: includeGlobalCourses };
                    _context11.next = 3;
                    return (0, _effects.call)(api.getFilteredCourses, countriesRequest);

                case 3:
                    response = _context11.sent;

                    if (!(response.status === 200)) {
                        _context11.next = 9;
                        break;
                    }

                    _context11.next = 7;
                    return (0, _effects.put)({
                        type: actionTypes.GET_FILTERED_LEGACY_COURSES_SUCCESS,
                        data: response.data,
                        isProductCoursesLoaded: true,
                        isProductCoursesFetching: false
                    });

                case 7:
                    _context11.next = 11;
                    break;

                case 9:
                    _context11.next = 11;
                    return (0, _effects.put)({ type: actionTypes.GET_FILTERED_LEGACY_COURSES_FAILURE, isProductCoursesLoaded: true, isProductCoursesFetching: false });

                case 11:
                case 'end':
                    return _context11.stop();
            }
        }
    }, _marked11, this);
}

function getFilteredLegacyCourseSaga() {
    return regeneratorRuntime.wrap(function getFilteredLegacyCourseSaga$(_context12) {
        while (1) {
            switch (_context12.prev = _context12.next) {
                case 0:
                    _context12.next = 2;
                    return (0, _effects.takeLatest)(actionTypes.GET_FILTERED_LEGACY_COURSES_REQUEST, getFilteredLegacyCourse);

                case 2:
                case 'end':
                    return _context12.stop();
            }
        }
    }, _marked12, this);
}

/***/ }),
/* 809 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.getSchoolCourse = exports.getProductCourseFailure = exports.getProductCourseSuccess = exports.getProductCourse = exports.getUpfCourseCountryFailure = exports.getUpfCourseCountrySuccess = exports.getUpfCourseCountry = exports.getCourseCountryFailure = exports.getCourseCountrySuccess = exports.getCourseCountry = exports.deselectCourses = exports.getCountryYearGroupFailure = exports.getCountryYearGroupSuccess = exports.getCountryYearGroupRequest = undefined;

var _actionTypes = __webpack_require__(193);

var actionTypes = _interopRequireWildcard(_actionTypes);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var getCountryYearGroupRequest = exports.getCountryYearGroupRequest = function getCountryYearGroupRequest(countryCode, success, failure) {
    return { type: actionTypes.GET_COUNTRY_YEAR_GROUPS_REQUEST, countryCode: countryCode, success: success, failure: failure, countryCourses: [] };
};

var getCountryYearGroupSuccess = exports.getCountryYearGroupSuccess = function getCountryYearGroupSuccess(yearGroups) {
    return { type: actionTypes.GET_COUNTRY_YEAR_GROUPS_SUCCESS, isLoadingCountryCourses: false, yearGroups: yearGroups };
};

var getCountryYearGroupFailure = exports.getCountryYearGroupFailure = function getCountryYearGroupFailure() {
    return { type: actionTypes.GET_COUNTRY_YEAR_GROUPS_FAILURE, isLoadingCountryCourses: false };
};

var deselectCourses = exports.deselectCourses = function deselectCourses() {
    var deselectCourse = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
    return { type: actionTypes.DESELECT_COURSE, deselectCourse: deselectCourse };
};

var getCourseCountry = exports.getCourseCountry = function getCourseCountry(selectedProductId) {
    return { type: actionTypes.GET_COUNTRY_REQUEST, selectedProductId: selectedProductId };
};

var getCourseCountrySuccess = exports.getCourseCountrySuccess = function getCourseCountrySuccess(data) {
    return { type: actionTypes.GET_COUNTRY_SUCCESS, data: data };
};

var getCourseCountryFailure = exports.getCourseCountryFailure = function getCourseCountryFailure() {
    return { type: actionTypes.GET_COUNTRY_FAILURE };
};

var getUpfCourseCountry = exports.getUpfCourseCountry = function getUpfCourseCountry(selectedProductId) {
    return { type: actionTypes.GET_UPF_COUNTRY_REQUEST, selectedProductId: selectedProductId };
};

var getUpfCourseCountrySuccess = exports.getUpfCourseCountrySuccess = function getUpfCourseCountrySuccess(data) {
    return { type: actionTypes.GET_UPF_COUNTRY_SUCCESS, data: data };
};

var getUpfCourseCountryFailure = exports.getUpfCourseCountryFailure = function getUpfCourseCountryFailure() {
    return { type: actionTypes.GET_UPF_COUNTRY_FAILURE };
};

var getProductCourse = exports.getProductCourse = function getProductCourse(countryCode, productId, yearGroup) {
    return { type: actionTypes.GET_PRODUCT_COURSE_REQUEST, countryCode: countryCode, productId: productId, yearGroup: yearGroup, isProductCoursesLoaded: false, isProductCoursesFetching: true };
};

var getProductCourseSuccess = exports.getProductCourseSuccess = function getProductCourseSuccess(data) {
    return { type: actionTypes.GET_PRODUCT_COURSE_SUCCESS, data: data, isProductCoursesLoaded: true, isProductCoursesFetching: false };
};

var getProductCourseFailure = exports.getProductCourseFailure = function getProductCourseFailure() {
    return { type: actionTypes.GET_PRODUCT_COURSE_FAILURE, isProductCoursesLoaded: true, isProductCoursesFetching: false };
};

var getSchoolCourse = exports.getSchoolCourse = function getSchoolCourse(yearGroup) {
    return { type: actionTypes.GET_SCHOOL_COURSE_REQUEST, yearGroup: yearGroup };
};

/***/ }),
/* 810 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _reactIntl = __webpack_require__(2);

exports.default = (0, _reactIntl.defineMessages)({
    assignCourseSuccess: {
        id: 'app.containers.AssignCoursesUPF.assignCourseSuccess',
        defaultMessage: 'The course has been successfully assigned'
    },
    assignCourseFailure: {
        id: 'app.containers.AssignCoursesUPF.assignCourseFailure',
        defaultMessage: 'Failed to assign the course. Please try again later'
    }
});

/***/ }),
/* 811 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.default = function () {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
    var action = arguments[1];

    switch (action.type) {
        case actionTypes.GET_YEAR_GROUP_SUCCESS:
            {
                return _extends({}, state, { yearGroups: action.data });
            }
        case actionTypes.GET_COUNTRY_SUCCESS:
            {
                return _extends({}, state, { countries: action.data });
            }
        case actionTypes.GET_UPF_COUNTRY_SUCCESS:
            {
                return _extends({}, state, { upfCountries: action.data });
            }
        case actionTypes.GET_COUNTRY_YEAR_GROUPS_REQUEST:
            {
                return _extends({}, state, { isLoadingCountryYearGroups: true });
            }
        case actionTypes.GET_COUNTRY_YEAR_GROUPS_SUCCESS:
            {
                return _extends({}, state, {
                    isLoadingCountryYearGroups: action.isLoadingCountryYearGroups,
                    yearGroups: action.yearGroups });
            }
        case actionTypes.GET_COUNTRY_YEAR_GROUPS_FAILURE:
            {
                return _extends({}, state, { isLoadingCountryYearGroups: action.isLoadingCountryYearGroups });
            }

        case actionTypes.GET_PRODUCT_COURSE_REQUEST:
        case actionTypes.GET_SCHOOL_COURSE_REQUEST:
            {
                return _extends({}, state, {
                    isProductCoursesLoaded: false,
                    productCourses: [],
                    filteredCourses: []
                });
            }

        case actionTypes.GET_PRODUCT_COURSE_SUCCESS:
        case actionTypes.GET_SCHOOL_COURSE_SUCCESS:
            {
                return _extends({}, state, {
                    isProductCoursesLoaded: true,
                    productCourses: action.data,
                    filteredCourses: action.data
                });
            }

        case actionTypes.GET_FILTERED_UPF_COURSES_SUCCESS:
            {
                return _extends({}, state, {
                    isProductCoursesLoaded: true,
                    filteredCourses: action.data
                });
            }

        case actionTypes.GET_PRODUCT_COURSE_FAILURE:
        case actionTypes.GET_SCHOOL_COURSE_FAILURE:
        case actionTypes.GET_FILTERED_UPF_COURSES_FAILURE:
            {
                return _extends({}, state, {
                    isProductCoursesLoaded: true,
                    productCourses: [],
                    filteredCourses: []
                });
            }
        case actionTypes.CLEAR_COURSE_LIST:
            {
                return _extends({}, state, { productCourses: action.productCourses });
            }

        case actionTypes.DESELECT_COURSE:
            {
                return _extends({}, state, { deselectCourse: action.deselectCourse });
            }

        default:
            return _extends({}, state);
    }
};

var _actionTypes = __webpack_require__(193);

var actionTypes = _interopRequireWildcard(_actionTypes);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var initialState = {
    courses: [],
    yearGroups: [],
    countries: [],
    upfCountries: [],
    isLoadingCountryYearGroups: false,
    isProductCoursesLoaded: false,
    deselectCourse: false,
    productCourses: [],
    filteredCourses: []
};

/***/ }),
/* 812 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.getCountryYearGroups = getCountryYearGroups;
exports.getCountryYearGroupsSaga = getCountryYearGroupsSaga;
exports.getYearGroup = getYearGroup;
exports.getYearGroupsSaga = getYearGroupsSaga;
exports.getCourseCountry = getCourseCountry;
exports.getCourseCountrySaga = getCourseCountrySaga;
exports.getUpfCourseCountry = getUpfCourseCountry;
exports.getUpfCourseCountrySaga = getUpfCourseCountrySaga;
exports.getProductCourse = getProductCourse;
exports.getProductCourseSaga = getProductCourseSaga;
exports.getSchoolCourse = getSchoolCourse;
exports.getSchoolCourseSaga = getSchoolCourseSaga;
exports.getFilteredUPFCourse = getFilteredUPFCourse;
exports.getFilteredUPFCourseSaga = getFilteredUPFCourseSaga;

var _effects = __webpack_require__(32);

var _api = __webpack_require__(33);

var api = _interopRequireWildcard(_api);

var _actions = __webpack_require__(809);

var actions = _interopRequireWildcard(_actions);

var _actionTypes = __webpack_require__(193);

var actionTypes = _interopRequireWildcard(_actionTypes);

var _constants = __webpack_require__(40);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var _marked = /*#__PURE__*/regeneratorRuntime.mark(getCountryYearGroups),
    _marked2 = /*#__PURE__*/regeneratorRuntime.mark(getCountryYearGroupsSaga),
    _marked3 = /*#__PURE__*/regeneratorRuntime.mark(getYearGroup),
    _marked4 = /*#__PURE__*/regeneratorRuntime.mark(getYearGroupsSaga),
    _marked5 = /*#__PURE__*/regeneratorRuntime.mark(getCourseCountry),
    _marked6 = /*#__PURE__*/regeneratorRuntime.mark(getCourseCountrySaga),
    _marked7 = /*#__PURE__*/regeneratorRuntime.mark(getUpfCourseCountry),
    _marked8 = /*#__PURE__*/regeneratorRuntime.mark(getUpfCourseCountrySaga),
    _marked9 = /*#__PURE__*/regeneratorRuntime.mark(getProductCourse),
    _marked10 = /*#__PURE__*/regeneratorRuntime.mark(getProductCourseSaga),
    _marked11 = /*#__PURE__*/regeneratorRuntime.mark(getSchoolCourse),
    _marked12 = /*#__PURE__*/regeneratorRuntime.mark(getSchoolCourseSaga),
    _marked13 = /*#__PURE__*/regeneratorRuntime.mark(getFilteredUPFCourse),
    _marked14 = /*#__PURE__*/regeneratorRuntime.mark(getFilteredUPFCourseSaga);

function getCountryYearGroups(action) {
    var countryCode, _action$success, success, _action$failure, failure, response;

    return regeneratorRuntime.wrap(function getCountryYearGroups$(_context) {
        while (1) {
            switch (_context.prev = _context.next) {
                case 0:
                    countryCode = action.countryCode, _action$success = action.success, success = _action$success === undefined ? actions.getCountryYearGroupSuccess : _action$success, _action$failure = action.failure, failure = _action$failure === undefined ? actions.getCountryYearGroupFailure : _action$failure;
                    _context.next = 3;
                    return (0, _effects.call)(api.getCountryYearGroups, { countryCode: countryCode });

                case 3:
                    response = _context.sent;

                    if (!(response.status === 200)) {
                        _context.next = 9;
                        break;
                    }

                    _context.next = 7;
                    return (0, _effects.put)(success(response.data));

                case 7:
                    _context.next = 11;
                    break;

                case 9:
                    _context.next = 11;
                    return (0, _effects.put)(failure());

                case 11:
                case 'end':
                    return _context.stop();
            }
        }
    }, _marked, this);
}

function getCountryYearGroupsSaga() {
    return regeneratorRuntime.wrap(function getCountryYearGroupsSaga$(_context2) {
        while (1) {
            switch (_context2.prev = _context2.next) {
                case 0:
                    _context2.next = 2;
                    return (0, _effects.takeLatest)(actionTypes.GET_COUNTRY_YEAR_GROUPS_REQUEST, getCountryYearGroups);

                case 2:
                case 'end':
                    return _context2.stop();
            }
        }
    }, _marked2, this);
}

function getYearGroup() {
    var payload;
    return regeneratorRuntime.wrap(function getYearGroup$(_context3) {
        while (1) {
            switch (_context3.prev = _context3.next) {
                case 0:
                    _context3.next = 2;
                    return (0, _effects.call)(api.getYearGroups);

                case 2:
                    payload = _context3.sent;

                    if (!(payload.status === 200)) {
                        _context3.next = 8;
                        break;
                    }

                    _context3.next = 6;
                    return (0, _effects.put)({ type: actionTypes.GET_YEAR_GROUP_SUCCESS, data: payload });

                case 6:
                    _context3.next = 10;
                    break;

                case 8:
                    _context3.next = 10;
                    return (0, _effects.put)({ type: actionTypes.GET_YEAR_GROUP_FAILURE });

                case 10:
                case 'end':
                    return _context3.stop();
            }
        }
    }, _marked3, this);
}

function getYearGroupsSaga() {
    return regeneratorRuntime.wrap(function getYearGroupsSaga$(_context4) {
        while (1) {
            switch (_context4.prev = _context4.next) {
                case 0:
                    _context4.next = 2;
                    return (0, _effects.takeLatest)(actionTypes.GET_YEAR_GROUP_REQUEST, getYearGroup);

                case 2:
                case 'end':
                    return _context4.stop();
            }
        }
    }, _marked4, this);
}

function getCourseCountry(_ref) {
    var selectedProductId = _ref.selectedProductId;
    var countriesRequest, response;
    return regeneratorRuntime.wrap(function getCourseCountry$(_context5) {
        while (1) {
            switch (_context5.prev = _context5.next) {
                case 0:
                    countriesRequest = { ProductId: selectedProductId };
                    _context5.next = 3;
                    return (0, _effects.call)(api.getCourseCountries, countriesRequest);

                case 3:
                    response = _context5.sent;

                    if (!(response.status === 200)) {
                        _context5.next = 9;
                        break;
                    }

                    _context5.next = 7;
                    return (0, _effects.put)(actions.getCourseCountrySuccess(response.data));

                case 7:
                    _context5.next = 11;
                    break;

                case 9:
                    _context5.next = 11;
                    return (0, _effects.put)(actions.getCourseCountryFailure());

                case 11:
                case 'end':
                    return _context5.stop();
            }
        }
    }, _marked5, this);
}

function getCourseCountrySaga() {
    return regeneratorRuntime.wrap(function getCourseCountrySaga$(_context6) {
        while (1) {
            switch (_context6.prev = _context6.next) {
                case 0:
                    _context6.next = 2;
                    return (0, _effects.takeLatest)(actionTypes.GET_COUNTRY_REQUEST, getCourseCountry);

                case 2:
                case 'end':
                    return _context6.stop();
            }
        }
    }, _marked6, this);
}

function getUpfCourseCountry(_ref2) {
    var selectedProductId = _ref2.selectedProductId,
        _ref2$countryCourseTy = _ref2.countryCourseType,
        countryCourseType = _ref2$countryCourseTy === undefined ? _constants.COUNTRY_COURSE_TYPE.UPF : _ref2$countryCourseTy;
    var countriesRequest, response;
    return regeneratorRuntime.wrap(function getUpfCourseCountry$(_context7) {
        while (1) {
            switch (_context7.prev = _context7.next) {
                case 0:
                    countriesRequest = { ProductId: selectedProductId, countryCourseType: countryCourseType };
                    _context7.next = 3;
                    return (0, _effects.call)(api.getUpfCourseCountries, countriesRequest);

                case 3:
                    response = _context7.sent;

                    if (!(response.status === 200)) {
                        _context7.next = 9;
                        break;
                    }

                    _context7.next = 7;
                    return (0, _effects.put)(actions.getUpfCourseCountrySuccess(response.data));

                case 7:
                    _context7.next = 11;
                    break;

                case 9:
                    _context7.next = 11;
                    return (0, _effects.put)(actions.getUpfCourseCountryFailure());

                case 11:
                case 'end':
                    return _context7.stop();
            }
        }
    }, _marked7, this);
}

function getUpfCourseCountrySaga() {
    return regeneratorRuntime.wrap(function getUpfCourseCountrySaga$(_context8) {
        while (1) {
            switch (_context8.prev = _context8.next) {
                case 0:
                    _context8.next = 2;
                    return (0, _effects.takeLatest)(actionTypes.GET_UPF_COUNTRY_REQUEST, getUpfCourseCountry);

                case 2:
                case 'end':
                    return _context8.stop();
            }
        }
    }, _marked8, this);
}

function getProductCourse(_ref3) {
    var countryCode = _ref3.countryCode,
        productId = _ref3.productId,
        yearGroup = _ref3.yearGroup;
    var countriesRequest, response;
    return regeneratorRuntime.wrap(function getProductCourse$(_context9) {
        while (1) {
            switch (_context9.prev = _context9.next) {
                case 0:
                    countriesRequest = { countryCode: countryCode, productId: productId, yearGroup: yearGroup };
                    _context9.next = 3;
                    return (0, _effects.call)(api.getProductCourses, countriesRequest);

                case 3:
                    response = _context9.sent;

                    if (!(response.status === 200)) {
                        _context9.next = 9;
                        break;
                    }

                    _context9.next = 7;
                    return (0, _effects.put)(actions.getProductCourseSuccess(response.data));

                case 7:
                    _context9.next = 11;
                    break;

                case 9:
                    _context9.next = 11;
                    return (0, _effects.put)(actions.getProductCourseFailure());

                case 11:
                case 'end':
                    return _context9.stop();
            }
        }
    }, _marked9, this);
}

function getProductCourseSaga() {
    return regeneratorRuntime.wrap(function getProductCourseSaga$(_context10) {
        while (1) {
            switch (_context10.prev = _context10.next) {
                case 0:
                    _context10.next = 2;
                    return (0, _effects.takeLatest)(actionTypes.GET_PRODUCT_COURSE_REQUEST, getProductCourse);

                case 2:
                case 'end':
                    return _context10.stop();
            }
        }
    }, _marked10, this);
}

function getSchoolCourse(_ref4) {
    var yearGroup = _ref4.yearGroup;
    var request, response;
    return regeneratorRuntime.wrap(function getSchoolCourse$(_context11) {
        while (1) {
            switch (_context11.prev = _context11.next) {
                case 0:
                    request = { yearGroup: yearGroup };
                    _context11.next = 3;
                    return (0, _effects.call)(api.getSchoolCourses, request);

                case 3:
                    response = _context11.sent;

                    if (!(response.status === 200)) {
                        _context11.next = 9;
                        break;
                    }

                    _context11.next = 7;
                    return (0, _effects.put)(actions.getSchoolCourseSuccess(response.data));

                case 7:
                    _context11.next = 11;
                    break;

                case 9:
                    _context11.next = 11;
                    return (0, _effects.put)({ type: actionTypes.GET_SCHOOL_COURSE_FAILURE });

                case 11:
                case 'end':
                    return _context11.stop();
            }
        }
    }, _marked11, this);
}

function getSchoolCourseSaga() {
    return regeneratorRuntime.wrap(function getSchoolCourseSaga$(_context12) {
        while (1) {
            switch (_context12.prev = _context12.next) {
                case 0:
                    _context12.next = 2;
                    return (0, _effects.takeLatest)(actionTypes.GET_SCHOOL_COURSE_REQUEST, getSchoolCourse);

                case 2:
                case 'end':
                    return _context12.stop();
            }
        }
    }, _marked12, this);
}

function getFilteredUPFCourse(_ref5) {
    var countryCode = _ref5.countryCode,
        productId = _ref5.productId,
        yearGroup = _ref5.yearGroup,
        selectGenericCourses = _ref5.selectGenericCourses,
        includeGlobalCourses = _ref5.includeGlobalCourses;
    var countriesRequest, response;
    return regeneratorRuntime.wrap(function getFilteredUPFCourse$(_context13) {
        while (1) {
            switch (_context13.prev = _context13.next) {
                case 0:
                    countriesRequest = { countryCode: countryCode, productId: productId, yearGroup: yearGroup, selectGenericCourses: selectGenericCourses, includeGlobalCourses: includeGlobalCourses };
                    _context13.next = 3;
                    return (0, _effects.call)(api.getFilteredCourses, countriesRequest);

                case 3:
                    response = _context13.sent;

                    if (!(response.status === 200)) {
                        _context13.next = 9;
                        break;
                    }

                    _context13.next = 7;
                    return (0, _effects.put)({
                        type: actionTypes.GET_FILTERED_UPF_COURSES_SUCCESS,
                        data: response.data,
                        isProductCoursesLoaded: true,
                        isProductCoursesFetching: false
                    });

                case 7:
                    _context13.next = 11;
                    break;

                case 9:
                    _context13.next = 11;
                    return (0, _effects.put)({ type: actionTypes.GET_FILTERED_UPF_COURSES_FAILURE, isProductCoursesLoaded: true, isProductCoursesFetching: false });

                case 11:
                case 'end':
                    return _context13.stop();
            }
        }
    }, _marked13, this);
}

function getFilteredUPFCourseSaga() {
    return regeneratorRuntime.wrap(function getFilteredUPFCourseSaga$(_context14) {
        while (1) {
            switch (_context14.prev = _context14.next) {
                case 0:
                    _context14.next = 2;
                    return (0, _effects.takeLatest)(actionTypes.GET_FILTERED_UPF_COURSES_REQUEST, getFilteredUPFCourse);

                case 2:
                case 'end':
                    return _context14.stop();
            }
        }
    }, _marked14, this);
}

/***/ }),
/* 813 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.default = function () {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
    var action = arguments[1];

    switch (action.type) {
        case actions.GET_YEAR_GROUP_SUCCESS:
            {
                return _extends({}, state, { yearGroups: action.data });
            }
        case actions.GET_COUNTRY_SUCCESS:
            {
                return _extends({}, state, { countries: action.data });
            }

        case actions.GET_COUNTRY_YEAR_GROUPS_REQUEST:
            {
                return _extends({}, state, { isLoadingCountryYearGroups: true });
            }
        case actions.GET_COUNTRY_YEAR_GROUPS_SUCCESS:
            {
                return _extends({}, state, {
                    isLoadingCountryYearGroups: action.isLoadingCountryYearGroups,
                    yearGroups: action.yearGroups });
            }
        case actions.GET_COUNTRY_YEAR_GROUPS_FAILURE:
            {
                return _extends({}, state, { isLoadingCountryYearGroups: action.isLoadingCountryYearGroups });
            }

        case actions.GET_PRODUCT_COURSE_REQUEST:
        case actions.GET_SCHOOL_COURSE_REQUEST:
            {
                return _extends({}, state, {
                    isProductCoursesLoaded: false,
                    productCourses: []
                });
            }

        case actions.GET_PRODUCT_COURSE_SUCCESS:
        case actions.GET_SCHOOL_COURSE_SUCCESS:
            {
                return _extends({}, state, {
                    isProductCoursesLoaded: true,
                    productCourses: action.data
                });
            }
        case actions.GET_PRODUCT_COURSE_FAILURE:
        case actions.GET_SCHOOL_COURSE_FAILURE:
            {
                return _extends({}, state, {
                    isProductCoursesLoaded: true,
                    productCourses: []
                });
            }
        case actions.CLEAR_COURSE_LIST:
            {
                return _extends({}, state, { productCourses: action.productCourses });
            }

        case actions.DESELECT_COURSE:
            {
                return _extends({}, state, { deselectCourse: action.deselectCourse });
            }

        default:
            return _extends({}, state);
    }
};

var _actions = __webpack_require__(154);

var actions = _interopRequireWildcard(_actions);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var initialState = {
    courses: [],
    yearGroups: [],
    countries: [],
    isLoadingCountryYearGroups: false,
    isProductCoursesLoaded: false,
    deselectCourse: false,
    productCourses: []
};

/***/ }),
/* 814 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.getCountryYearGroups = getCountryYearGroups;
exports.getCountryYearGroupsSaga = getCountryYearGroupsSaga;
exports.getYearGroup = getYearGroup;
exports.getYearGroupsSaga = getYearGroupsSaga;
exports.getCourseCountry = getCourseCountry;
exports.getCourseCountrySaga = getCourseCountrySaga;
exports.getUpfCourseCountry = getUpfCourseCountry;
exports.getUpfCourseCountrySaga = getUpfCourseCountrySaga;
exports.getProductCourse = getProductCourse;
exports.getProductCourseSaga = getProductCourseSaga;
exports.getSchoolCourse = getSchoolCourse;
exports.getSchoolCourseSaga = getSchoolCourseSaga;

var _effects = __webpack_require__(32);

var _api = __webpack_require__(33);

var api = _interopRequireWildcard(_api);

var _actions = __webpack_require__(154);

var actions = _interopRequireWildcard(_actions);

var _constants = __webpack_require__(40);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var _marked = /*#__PURE__*/regeneratorRuntime.mark(getCountryYearGroups),
    _marked2 = /*#__PURE__*/regeneratorRuntime.mark(getCountryYearGroupsSaga),
    _marked3 = /*#__PURE__*/regeneratorRuntime.mark(getYearGroup),
    _marked4 = /*#__PURE__*/regeneratorRuntime.mark(getYearGroupsSaga),
    _marked5 = /*#__PURE__*/regeneratorRuntime.mark(getCourseCountry),
    _marked6 = /*#__PURE__*/regeneratorRuntime.mark(getCourseCountrySaga),
    _marked7 = /*#__PURE__*/regeneratorRuntime.mark(getUpfCourseCountry),
    _marked8 = /*#__PURE__*/regeneratorRuntime.mark(getUpfCourseCountrySaga),
    _marked9 = /*#__PURE__*/regeneratorRuntime.mark(getProductCourse),
    _marked10 = /*#__PURE__*/regeneratorRuntime.mark(getProductCourseSaga),
    _marked11 = /*#__PURE__*/regeneratorRuntime.mark(getSchoolCourse),
    _marked12 = /*#__PURE__*/regeneratorRuntime.mark(getSchoolCourseSaga);

function getCountryYearGroups(action) {
    var countryCode, _action$success, success, _action$failure, failure, response;

    return regeneratorRuntime.wrap(function getCountryYearGroups$(_context) {
        while (1) {
            switch (_context.prev = _context.next) {
                case 0:
                    countryCode = action.countryCode, _action$success = action.success, success = _action$success === undefined ? actions.getCountryYearGroupSuccess : _action$success, _action$failure = action.failure, failure = _action$failure === undefined ? actions.getCountryYearGroupFailure : _action$failure;
                    _context.next = 3;
                    return (0, _effects.call)(api.getCountryYearGroups, { countryCode: countryCode });

                case 3:
                    response = _context.sent;

                    if (!(response.status === 200)) {
                        _context.next = 9;
                        break;
                    }

                    _context.next = 7;
                    return (0, _effects.put)(success(response.data));

                case 7:
                    _context.next = 11;
                    break;

                case 9:
                    _context.next = 11;
                    return (0, _effects.put)(failure());

                case 11:
                case 'end':
                    return _context.stop();
            }
        }
    }, _marked, this);
}

function getCountryYearGroupsSaga() {
    return regeneratorRuntime.wrap(function getCountryYearGroupsSaga$(_context2) {
        while (1) {
            switch (_context2.prev = _context2.next) {
                case 0:
                    _context2.next = 2;
                    return (0, _effects.takeLatest)(actions.GET_COUNTRY_YEAR_GROUPS_REQUEST, getCountryYearGroups);

                case 2:
                case 'end':
                    return _context2.stop();
            }
        }
    }, _marked2, this);
}

function getYearGroup() {
    var payload;
    return regeneratorRuntime.wrap(function getYearGroup$(_context3) {
        while (1) {
            switch (_context3.prev = _context3.next) {
                case 0:
                    _context3.next = 2;
                    return (0, _effects.call)(api.getYearGroups);

                case 2:
                    payload = _context3.sent;

                    if (!(payload.status === 200)) {
                        _context3.next = 8;
                        break;
                    }

                    _context3.next = 6;
                    return (0, _effects.put)(actions.getYearGroupSuccess(payload));

                case 6:
                    _context3.next = 10;
                    break;

                case 8:
                    _context3.next = 10;
                    return (0, _effects.put)(actions.getYearGroupFailure());

                case 10:
                case 'end':
                    return _context3.stop();
            }
        }
    }, _marked3, this);
}

function getYearGroupsSaga() {
    return regeneratorRuntime.wrap(function getYearGroupsSaga$(_context4) {
        while (1) {
            switch (_context4.prev = _context4.next) {
                case 0:
                    _context4.next = 2;
                    return (0, _effects.takeLatest)(actions.GET_YEAR_GROUP_REQUEST, getYearGroup);

                case 2:
                case 'end':
                    return _context4.stop();
            }
        }
    }, _marked4, this);
}

function getCourseCountry(_ref) {
    var selectedProductId = _ref.selectedProductId;
    var countriesRequest, response;
    return regeneratorRuntime.wrap(function getCourseCountry$(_context5) {
        while (1) {
            switch (_context5.prev = _context5.next) {
                case 0:
                    countriesRequest = { ProductId: selectedProductId };
                    _context5.next = 3;
                    return (0, _effects.call)(api.getCourseCountries, countriesRequest);

                case 3:
                    response = _context5.sent;

                    if (!(response.status === 200)) {
                        _context5.next = 9;
                        break;
                    }

                    _context5.next = 7;
                    return (0, _effects.put)(actions.getCourseCountrySuccess(response.data));

                case 7:
                    _context5.next = 11;
                    break;

                case 9:
                    _context5.next = 11;
                    return (0, _effects.put)(actions.getCourseCountryFailure());

                case 11:
                case 'end':
                    return _context5.stop();
            }
        }
    }, _marked5, this);
}

function getCourseCountrySaga() {
    return regeneratorRuntime.wrap(function getCourseCountrySaga$(_context6) {
        while (1) {
            switch (_context6.prev = _context6.next) {
                case 0:
                    _context6.next = 2;
                    return (0, _effects.takeLatest)(actions.GET_COUNTRY_REQUEST, getCourseCountry);

                case 2:
                case 'end':
                    return _context6.stop();
            }
        }
    }, _marked6, this);
}

function getUpfCourseCountry(_ref2) {
    var selectedProductId = _ref2.selectedProductId,
        _ref2$countryCourseTy = _ref2.countryCourseType,
        countryCourseType = _ref2$countryCourseTy === undefined ? _constants.COUNTRY_COURSE_TYPE.UPF : _ref2$countryCourseTy;
    var countriesRequest, response;
    return regeneratorRuntime.wrap(function getUpfCourseCountry$(_context7) {
        while (1) {
            switch (_context7.prev = _context7.next) {
                case 0:
                    countriesRequest = { ProductId: selectedProductId, countryCourseType: countryCourseType };
                    _context7.next = 3;
                    return (0, _effects.call)(api.getUpfCourseCountries, countriesRequest);

                case 3:
                    response = _context7.sent;

                    if (!(response.status === 200)) {
                        _context7.next = 9;
                        break;
                    }

                    _context7.next = 7;
                    return (0, _effects.put)(actions.getUpfCourseCountriesSuccess(response.data));

                case 7:
                    _context7.next = 11;
                    break;

                case 9:
                    _context7.next = 11;
                    return (0, _effects.put)(actions.getUpfCourseCountriesFailure());

                case 11:
                case 'end':
                    return _context7.stop();
            }
        }
    }, _marked7, this);
}

function getUpfCourseCountrySaga() {
    return regeneratorRuntime.wrap(function getUpfCourseCountrySaga$(_context8) {
        while (1) {
            switch (_context8.prev = _context8.next) {
                case 0:
                    _context8.next = 2;
                    return (0, _effects.takeLatest)(actions.GET_UPF_COUNTRY_REQUEST, getUpfCourseCountry);

                case 2:
                case 'end':
                    return _context8.stop();
            }
        }
    }, _marked8, this);
}

function getProductCourse(_ref3) {
    var countryCode = _ref3.countryCode,
        productId = _ref3.productId,
        yearGroup = _ref3.yearGroup;
    var countriesRequest, response;
    return regeneratorRuntime.wrap(function getProductCourse$(_context9) {
        while (1) {
            switch (_context9.prev = _context9.next) {
                case 0:
                    countriesRequest = { countryCode: countryCode, productId: productId, yearGroup: yearGroup };
                    _context9.next = 3;
                    return (0, _effects.call)(api.getProductCourses, countriesRequest);

                case 3:
                    response = _context9.sent;

                    if (!(response.status === 200)) {
                        _context9.next = 9;
                        break;
                    }

                    _context9.next = 7;
                    return (0, _effects.put)(actions.getProductCourseSuccess(response.data));

                case 7:
                    _context9.next = 11;
                    break;

                case 9:
                    _context9.next = 11;
                    return (0, _effects.put)(actions.getProductCourseFailure());

                case 11:
                case 'end':
                    return _context9.stop();
            }
        }
    }, _marked9, this);
}

function getProductCourseSaga() {
    return regeneratorRuntime.wrap(function getProductCourseSaga$(_context10) {
        while (1) {
            switch (_context10.prev = _context10.next) {
                case 0:
                    _context10.next = 2;
                    return (0, _effects.takeLatest)(actions.GET_PRODUCT_COURSE_REQUEST, getProductCourse);

                case 2:
                case 'end':
                    return _context10.stop();
            }
        }
    }, _marked10, this);
}

function getSchoolCourse(_ref4) {
    var yearGroup = _ref4.yearGroup;
    var request, response;
    return regeneratorRuntime.wrap(function getSchoolCourse$(_context11) {
        while (1) {
            switch (_context11.prev = _context11.next) {
                case 0:
                    request = { yearGroup: yearGroup };
                    _context11.next = 3;
                    return (0, _effects.call)(api.getSchoolCourses, request);

                case 3:
                    response = _context11.sent;

                    if (!(response.status === 200)) {
                        _context11.next = 9;
                        break;
                    }

                    _context11.next = 7;
                    return (0, _effects.put)(actions.getSchoolCourseSuccess(response.data));

                case 7:
                    _context11.next = 11;
                    break;

                case 9:
                    _context11.next = 11;
                    return (0, _effects.put)(actions.getSchoolCourseFailure());

                case 11:
                case 'end':
                    return _context11.stop();
            }
        }
    }, _marked11, this);
}

function getSchoolCourseSaga() {
    return regeneratorRuntime.wrap(function getSchoolCourseSaga$(_context12) {
        while (1) {
            switch (_context12.prev = _context12.next) {
                case 0:
                    _context12.next = 2;
                    return (0, _effects.takeLatest)(actions.GET_SCHOOL_COURSE_REQUEST, getSchoolCourse);

                case 2:
                case 'end':
                    return _context12.stop();
            }
        }
    }, _marked12, this);
}

/***/ }),
/* 815 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __webpack_require__(28);

var _redux = __webpack_require__(35);

var _reactIntl = __webpack_require__(2);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _clone = __webpack_require__(122);

var _clone2 = _interopRequireDefault(_clone);

var _spinner = __webpack_require__(94);

var _spinner2 = _interopRequireDefault(_spinner);

var _actions = __webpack_require__(95);

var _actions2 = __webpack_require__(44);

var _index = __webpack_require__(24);

var _index2 = _interopRequireDefault(_index);

var _index3 = __webpack_require__(36);

var _index4 = _interopRequireDefault(_index3);

var _iconDictionary = __webpack_require__(8);

var _messages = __webpack_require__(816);

var _messages2 = _interopRequireDefault(_messages);

var _index5 = __webpack_require__(1762);

var _index6 = _interopRequireDefault(_index5);

var _index7 = __webpack_require__(646);

var _index8 = _interopRequireDefault(_index7);

var _utils = __webpack_require__(13);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var AssignUser = function (_Component) {
    _inherits(AssignUser, _Component);

    function AssignUser(props) {
        _classCallCheck(this, AssignUser);

        var _this = _possibleConstructorReturn(this, (AssignUser.__proto__ || Object.getPrototypeOf(AssignUser)).call(this, props));

        _this.assignTeacherToStateObject = function (searchTerm, assignedIds) {
            var teachers = _this.props.teachers;

            var classroomId = parseInt(_this.id, 10);
            var existingAssignedTeachersIds = _this.state.existingAssignedTeachers;
            _this.setState({ teachers: (0, _utils.getClassroomTeacherMapping)(teachers, classroomId, searchTerm, assignedIds, existingAssignedTeachersIds, existingAssignedTeachersIds.length > 0) });
            _this.setState({ existingAssignedTeachers: existingAssignedTeachersIds });
        };

        _this.getTeachersAssignObject = function () {
            _this.assignTeacherToStateObject();
            _this.props.classroomTeacherMappingSuccess();
        };

        _this.handleOnFilterClassroom = function () {
            var studentClassrooms = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
            var searchCriteria = arguments[1];
            var userClassroomRelation = _this.props.userClassroomRelation;

            if (studentClassrooms.length === 0) {
                studentClassrooms = userClassroomRelation.classrooms;
            }
            _this.setState({ classrooms: (0, _utils.assignClassroomFilter)(studentClassrooms, searchCriteria) });
        };

        _this.handleOnYearGroupSelection = function (name, value) {
            var studentClassrooms = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
            var isPageLoad = arguments[3];
            var searchTerm = _this.props.searchTerm;

            _this.props.updateSelectedYearGroup(value);
            _this.searchCriteria = { selectedYearGroup: value, query: searchTerm };
            if (isPageLoad === undefined && studentClassrooms.length > 0) {
                studentClassrooms.filter(function (val) {
                    return !val.isAssigned;
                });
            }
            _this.handleOnFilterClassroom(studentClassrooms, _this.searchCriteria);
        };

        _this.handleOnSearchClick = function (query) {
            query = query.trim().toLowerCase();
            var _this$props = _this.props,
                selectedYearGroup = _this$props.selectedYearGroup,
                userClassroomRelation = _this$props.userClassroomRelation;

            if (_this.assignType === 'teacherToClass') {
                var classroomTeacherMapping = (0, _clone2.default)(_this.state.teachers);
                var assignedIds = classroomTeacherMapping.reduce(function (teacherProfileIds, val) {
                    if (val.isAssigned) {
                        teacherProfileIds.push(val.id);
                    }
                    return teacherProfileIds;
                }, []);
                _this.assignTeacherToStateObject(query, assignedIds);
            } else {
                _this.props.updateSearchTerm(query);
                _this.searchCriteria = { selectedYearGroup: selectedYearGroup, query: query };
                _this.handleOnFilterClassroom(userClassroomRelation.classrooms, _this.searchCriteria);
            }
        };

        _this.updateClassrooms = function (classIds, isAssigned) {
            var userClassroomRelation = (0, _clone2.default)(_this.state.classrooms);
            var classrooms = userClassroomRelation.map(function (val) {
                if (classIds.indexOf(val.id) !== -1) {
                    val.isAssigned = isAssigned;
                }
                return val;
            });
            _this.setState({ classrooms: classrooms });
            _this.props.updateClassrooms();
        };

        _this.updateClassGroups = function (classId, groups) {
            var userClassroomRelation = (0, _clone2.default)(_this.state.classrooms);
            var classrooms = userClassroomRelation.map(function (val) {
                if (val.id === classId) {
                    val.groups = groups;
                }
                return val;
            });

            _this.setState({ classrooms: classrooms });
        };

        _this.assignDefaultGroupToClass = function (classId) {
            var userClassroomRelation = (0, _clone2.default)(_this.state.classrooms);
            var classroom = userClassroomRelation.find(function (val) {
                return val.id === classId;
            });
            classroom.groups.map(function (val) {
                if (val.isDefault) {
                    val.isAssigned = true;
                }
                return val;
            });

            _this.setState({ userClassroomRelation: userClassroomRelation });
        };

        _this.updateClassroomTeacherMapping = function (listItemIds, isAssigned) {
            var classroomTeacherRelation = (0, _clone2.default)(_this.state.teachers);
            var teachers = classroomTeacherRelation.map(function (val) {
                if (listItemIds.indexOf(val.id) !== -1) {
                    val.isAssigned = isAssigned;
                }
                return val;
            });
            _this.setState({ teachers: teachers });
            _this.props.updateClassrooms();
        };

        _this.handleOnAssignUser = function (listItemIds) {
            if (_this.assignType === 'teacherToClass') {
                _this.updateClassroomTeacherMapping(listItemIds, true);
            } else {
                _this.updateClassrooms(listItemIds, true);
            }
        };

        _this.handleOnUnAssignUser = function (listItemIds) {
            if (_this.assignType === 'teacherToClass') {
                _this.updateClassroomTeacherMapping(listItemIds, false);
            } else {
                _this.updateClassrooms(listItemIds, false);
            }
        };

        _this.handleOnGroupSelection = function (classId, groups) {
            _this.updateClassGroups(classId, groups);
        };

        _this.handleOnClassroomSelection = function (classId) {
            _this.assignDefaultGroupToClass(classId);
        };

        _this.handleOnSave = function () {
            var selectedProduct = _this.props.selectedProduct;

            if (_this.assignType !== 'teacherToClass') {
                var assignedClassrooms = [];
                var assignedStudentClassrooms = _this.state.classrooms.filter(function (val) {
                    return val.isAssigned;
                });
                var _iteratorNormalCompletion = true;
                var _didIteratorError = false;
                var _iteratorError = undefined;

                try {
                    for (var _iterator = assignedStudentClassrooms[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                        var classroom = _step.value;

                        var classroomId = classroom.id;
                        if (_this.assignType === 'classToStudent') {
                            var groupId = classroom.groups.find(function (group) {
                                return group.isAssigned;
                            }).id;
                            assignedClassrooms.push({ classroomId: classroomId, groupId: groupId });
                        } else {
                            assignedClassrooms.push({ classroomId: classroomId });
                        }
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally {
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return) {
                            _iterator.return();
                        }
                    } finally {
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }

                if (_this.assignType === 'classToStudent') {
                    _this.props.assignStudentRequest(assignedClassrooms, _this.id, _this.props.selectedProduct.id);
                } else {
                    _this.props.assignTeacherRequest(assignedClassrooms, _this.id, _this.props.selectedProduct.id);
                }
            } else {
                var classroomTeacherMapping = (0, _clone2.default)(_this.state.teachers);
                var existingAssignedTeacherIds = _this.state.existingAssignedTeachers;
                var assignedIds = classroomTeacherMapping.reduce(function (teacherProfileIds, val) {
                    if (val.isAssigned) {
                        teacherProfileIds.push(val.id);
                    }
                    return teacherProfileIds;
                }, []);
                var teacherClassroomMapping = {
                    classroomId: parseInt(_this.id, 10),
                    productId: selectedProduct.id,
                    teachersProfileIdToAssign: assignedIds,
                    teachersProfileIdToUnassign: existingAssignedTeacherIds.filter(function (id) {
                        return assignedIds.indexOf(id) === -1;
                    })
                };
                _this.props.assignTeacherToClassroomRequest(teacherClassroomMapping, _this.context.router);
            }
        };

        _this.handleOnClose = function () {
            _this.props.resetUserClassroomRelation();
            _this.context.router.history.goBack();
        };

        _this.closeAssignConfirmationModal = function () {
            _this.props.closeAssignConfirmationModal();
            _this.props.cancelUserAssign();
            _this.context.router.history.goBack();
            _this.props.resetUserClassroomRelation();
        };

        _this.handleOnYearGroupSelection = _this.handleOnYearGroupSelection.bind(_this);
        _this.handleOnSearchClick = _this.handleOnSearchClick.bind(_this);
        _this.handleOnAssignUser = _this.handleOnAssignUser.bind(_this);
        _this.handleOnUnAssignUser = _this.handleOnUnAssignUser.bind(_this);
        _this.handleOnFilterClassroom = _this.handleOnFilterClassroom.bind(_this);
        _this.state = { classrooms: [], teachers: [], existingAssignedTeachers: [] };
        _this.searchCriteria = { selectedYearGroup: -1, query: '' };
        var match = _this.props.match;

        _this.assignType = match.params.assignType;
        _this.id = match.params.id;
        return _this;
    }

    _createClass(AssignUser, [{
        key: 'componentWillReceiveProps',
        value: function componentWillReceiveProps(nextProps) {
            var yearGroupEnum = this.props.yearGroupEnum;

            if (nextProps.yearGroupEnum !== yearGroupEnum && this.assignType !== 'teacherToClass') {
                this.handleOnYearGroupSelection('', nextProps.yearGroupEnum, nextProps.userClassroomRelation.classrooms, true);
            }
        }
    }, {
        key: 'componentDidMount',
        value: function componentDidMount() {
            var _props = this.props,
                yearGroupEnum = _props.yearGroupEnum,
                yearGroups = _props.yearGroups,
                selectedProduct = _props.selectedProduct;

            if (this.assignType === 'classToStudent') {
                this.props.getStudentClassroomsRelationRequest(this.id, selectedProduct.id);
            } else if (this.assignType === 'classToTeacher') {
                this.props.getTeacherClassroomsRelationRequest(this.id, selectedProduct.id);
            }

            if (yearGroupEnum && this.assignType !== 'teacherToClass') {
                this.handleOnYearGroupSelection('', yearGroupEnum);
            }

            if (yearGroups.length <= 1 && this.assignType !== 'teacherToClass') {
                this.props.getYearGroups();
            }

            if (this.assignType === 'teacherToClass') {
                this.getTeachersAssignObject();
            }
        }
    }, {
        key: 'render',
        value: function render() {
            var header = '';
            var _props2 = this.props,
                classrooms = _props2.classrooms,
                userClassroomRelation = _props2.userClassroomRelation,
                intl = _props2.intl,
                showAssignConfirmationModal = _props2.showAssignConfirmationModal,
                isLoadingClassroomDetail = _props2.isLoadingClassroomDetail,
                isLoadingClassroomTeacherMapping = _props2.isLoadingClassroomTeacherMapping,
                disableAssignCancelButton = _props2.disableAssignCancelButton,
                disableAssignSaveButton = _props2.disableAssignSaveButton,
                isSaveInProgress = _props2.isSaveInProgress,
                selectedYearGroup = _props2.selectedYearGroup,
                yearGroups = _props2.yearGroups;


            if (this.assignType === 'teacherToClass') {
                var classId = parseInt(this.id, 10);
                header = classrooms.length > 0 ? classrooms.find(function (val) {
                    return val.classroomId === classId;
                }).name : '';
            } else {
                header = (userClassroomRelation.title ? userClassroomRelation.title : '') + ' ' + userClassroomRelation.firstName + ' \n             ' + userClassroomRelation.lastName;
            }

            var confirmationMessage = intl.formatMessage(_messages2.default.classesFor) + ' ' + header + ' \n             ' + intl.formatMessage(_messages2.default.updated);

            var modal = _react2.default.createElement(
                _index2.default,
                { show: showAssignConfirmationModal },
                _react2.default.createElement(
                    _index4.default,
                    { handleOnCloseModal: this.closeAssignConfirmationModal, icon: _iconDictionary.Tick },
                    _react2.default.createElement(
                        'div',
                        null,
                        confirmationMessage,
                        '.'
                    )
                )
            );

            var loader = _react2.default.createElement(
                'div',
                { className: _index6.default.loader },
                _react2.default.createElement(_spinner2.default, { color: 'grey', size: '15px' })
            );

            var assignUserView = _react2.default.createElement('div', null);
            if (this.assignType === 'classToStudent') {
                assignUserView = !isLoadingClassroomDetail ? _react2.default.createElement(
                    'div',
                    null,
                    _react2.default.createElement(_index8.default, {
                        data: this.state.classrooms,
                        disableAssignCancelButton: disableAssignCancelButton,
                        disableAssignSaveButton: disableAssignSaveButton,
                        handleOnAssignItem: this.handleOnAssignUser,
                        handleOnChildSelection: this.handleOnGroupSelection,
                        handleOnClassroomSelection: this.handleOnClassroomSelection,
                        handleOnClose: this.handleOnClose,
                        handleOnSave: this.handleOnSave,
                        handleOnSearchClick: this.handleOnSearchClick,
                        handleOnUnAssignItem: this.handleOnUnAssignUser,
                        handleOnYearGroupSelection: this.handleOnYearGroupSelection,
                        header: header,
                        isSaveInProgress: isSaveInProgress,
                        selectedYearGroup: '' + selectedYearGroup,
                        type: 'student',
                        userClassroomRelation: userClassroomRelation,
                        yearGroups: yearGroups
                    }),
                    modal
                ) : _react2.default.createElement(
                    'div',
                    null,
                    loader
                );
            } else if (this.assignType === 'classToTeacher') {
                assignUserView = !isLoadingClassroomDetail ? _react2.default.createElement(
                    'div',
                    null,
                    _react2.default.createElement(_index8.default, {
                        data: this.state.classrooms,
                        disableAssignCancelButton: disableAssignCancelButton,
                        disableAssignSaveButton: disableAssignSaveButton,
                        handleOnAssignItem: this.handleOnAssignUser,
                        handleOnClose: this.handleOnClose,
                        handleOnSave: this.handleOnSave,
                        handleOnSearchClick: this.handleOnSearchClick,
                        handleOnUnAssignItem: this.handleOnUnAssignUser,
                        handleOnYearGroupSelection: this.handleOnYearGroupSelection,
                        header: header,
                        isSaveInProgress: isSaveInProgress,
                        selectedYearGroup: '' + selectedYearGroup,
                        type: 'teacher',
                        userClassroomRelation: userClassroomRelation,
                        yearGroups: yearGroups
                    }),
                    modal
                ) : _react2.default.createElement(
                    'div',
                    null,
                    loader
                );
            } else {
                assignUserView = isLoadingClassroomTeacherMapping ? _react2.default.createElement(
                    'div',
                    null,
                    _react2.default.createElement(_index8.default, {
                        data: this.state.teachers,
                        disableAssignCancelButton: disableAssignCancelButton,
                        disableAssignSaveButton: disableAssignSaveButton,
                        handleOnAssignItem: this.handleOnAssignUser,
                        handleOnClose: this.handleOnClose,
                        handleOnSave: this.handleOnSave,
                        handleOnSearchClick: this.handleOnSearchClick,
                        handleOnUnAssignItem: this.handleOnUnAssignUser,
                        header: header,
                        isSaveInProgress: isSaveInProgress,
                        type: 'class'
                    }),
                    modal
                ) : _react2.default.createElement(
                    'div',
                    null,
                    loader
                );
            }

            return assignUserView;
        }
    }]);

    return AssignUser;
}(_react.Component);

AssignUser.contextTypes = {
    router: _propTypes2.default.object.isRequired
};


AssignUser.propTypes = {
    classrooms: _propTypes2.default.arrayOf(_propTypes2.default.object),
    updateSearchTerm: _propTypes2.default.func,
    getStudentClassroomsRelationRequest: _propTypes2.default.func,
    getTeacherClassroomsRelationRequest: _propTypes2.default.func,
    yearGroups: _propTypes2.default.array,
    match: _propTypes2.default.object.isRequired,
    disableAssignSaveButton: _propTypes2.default.bool,
    yearGroupEnum: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
    userClassroomRelation: _propTypes2.default.object,
    updateSelectedYearGroup: _propTypes2.default.func,
    assignStudentRequest: _propTypes2.default.func,
    assignTeacherRequest: _propTypes2.default.func,
    selectedYearGroup: _propTypes2.default.number,
    searchTerm: _propTypes2.default.string,
    showAssignConfirmationModal: _propTypes2.default.bool,
    updateClassrooms: _propTypes2.default.func,
    closeAssignConfirmationModal: _propTypes2.default.func,
    intl: _reactIntl.intlShape.isRequired,
    disableAssignCancelButton: _propTypes2.default.bool,
    cancelUserAssign: _propTypes2.default.func,
    resetUserClassroomRelation: _propTypes2.default.func,
    isSaveInProgress: _propTypes2.default.bool,
    selectedProduct: _propTypes2.default.object,
    isLoadingClassroomDetail: _propTypes2.default.bool,
    getYearGroups: _propTypes2.default.func,
    classroomTeacherMappingSuccess: _propTypes2.default.func,
    teachers: _propTypes2.default.array,
    isLoadingClassroomTeacherMapping: _propTypes2.default.bool,
    assignTeacherToClassroomRequest: _propTypes2.default.func
};

function mapStateToProps(state) {
    return {
        classrooms: state.classRoll.classrooms,
        selectedProduct: state.product,
        teachers: state.teacherRoll.teachers,
        yearGroups: state.studentRoll.dataFilterOption.yearGroups,
        isLoadingClassroomDetail: state.assignUser.isLoadingClassroomDetail,
        yearGroupEnum: state.assignUser.yearGroupEnum,
        userClassroomRelation: state.assignUser.userClassroomRelation,
        searchTerm: state.assignUser.searchTerm,
        selectedYearGroup: state.assignUser.selectedYearGroup,
        disableAssignSaveButton: state.assignUser.disableAssignSaveButton,
        showAssignConfirmationModal: state.assignUser.showAssignUserConfirmationModal,
        disableAssignCancelButton: state.assignUser.disableAssignCancelButton,
        isSaveInProgress: state.assignUser.isSaveInProgress,
        isLoadingClassroomTeacherMapping: state.assignUser.isLoadingClassroomTeacherMapping
    };
}

function mapDispatchToProps(dispatch) {
    return (0, _redux.bindActionCreators)({
        updateSearchTerm: _actions.updateSearchTerm,
        getStudentClassroomsRelationRequest: _actions.getStudentClassroomsRelationRequest,
        getTeacherClassroomsRelationRequest: _actions.getTeacherClassroomsRelationRequest,
        updateSelectedYearGroup: _actions.updateSelectedYearGroup,
        assignStudentRequest: _actions.assignStudentRequest,
        assignTeacherRequest: _actions.assignTeacherRequest,
        updateClassrooms: _actions.updateClassrooms,
        closeAssignConfirmationModal: _actions.closeAssignConfirmationModal,
        cancelUserAssign: _actions.cancelUserAssign,
        resetUserClassroomRelation: _actions.resetUserClassroomRelation,
        getYearGroups: _actions2.getYearGroups,
        classroomTeacherMappingSuccess: _actions.classroomTeacherMappingSuccess,
        assignTeacherToClassroomRequest: _actions.assignTeacherToClassroomRequest
    }, dispatch);
}

exports.default = (0, _reactIntl.injectIntl)((0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(AssignUser));

/***/ }),
/* 816 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _reactIntl = __webpack_require__(2);

exports.default = (0, _reactIntl.defineMessages)({
    classesFor: {
        id: 'app.containers.AssignUser.classesFor',
        defaultMessage: 'Classes for'
    },
    updated: {
        id: 'app.containers.AssignUser.confirmationMessage',
        defaultMessage: 'have been updated'
    }
}); /*
     * AssignUser Messages
     *
     * This contains all the text for the AssignUser component.
     */

/***/ }),
/* 817 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.filterGroups = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _filter = __webpack_require__(137);

var _filter2 = _interopRequireDefault(_filter);

var _actions = __webpack_require__(95);

var actions = _interopRequireWildcard(_actions);

var _actions2 = __webpack_require__(44);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var initialState = {
    yearGroups: [],
    searchTerm: '',
    userClassroomRelation: { classrooms: [] },
    isLoadingClassroomDetail: true,
    isLoadingYearGroupDetail: true,
    isLoadingClassroomTeacherMapping: false,
    selectedYearGroup: -1,
    disableAssignSaveButton: true,
    disableAssignCancelButton: false,
    showAssignUserConfirmationModal: false,
    isSaveInProgress: false
};

var filterGroups = exports.filterGroups = function filterGroups(data, searchTerm) {
    var groups = (0, _filter2.default)(data, function (item) {
        if (item.name.indexOf(searchTerm) !== -1) {
            return item;
        }

        (0, _filter2.default)(item.assignedTeachersName, function (teacher) {
            if (teacher.indexOf(searchTerm) !== -1) {
                return item;
            }
            (0, _filter2.default)(item.groups, function (group) {
                if (group.name.indexOf(searchTerm) !== -1 || group.courseName.indexOf(searchTerm) !== -1) {
                    return item;
                }
                return false;
            });
            return false;
        });
        return false;
    });

    return groups;
};

function assignUserReducer() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
    var action = arguments[1];

    switch (action.type) {
        case _actions2.GET_YEAR_GROUPS_SUCCESS:
            return _extends({}, state, { yearGroups: action.yearGroups });

        case actions.UPDATE_ASSIGN_STUDENT_SEARCH_TERM:
            {
                var filteredGroups = filterGroups(state.classrooms, action.searchTerm);
                return _extends({}, state, { filteredGroups: filteredGroups, searchTerm: action.searchTerm });
            }

        case actions.UPDATE_SELECTED_YEAR_GROUP:
            return _extends({}, state, { selectedYearGroup: Number(action.selectedYearGroup) });

        case actions.GET_STUDENT_CLASSROOMS_RELATION_REQUEST:
            return _extends({}, state, { isLoadingClassroomDetail: true, yearGroupEnum: -2, searchTerm: '' });

        case actions.GET_STUDENT_CLASSROOMS_RELATION_SUCCESS:
            return _extends({}, state, { userClassroomRelation: action.classrooms, isLoadingClassroomDetail: false, yearGroupEnum: action.classrooms.yearGroupEnum });

        case actions.GET_STUDENT_CLASSROOMS_RELATION_FAILURE:
            return _extends({}, state, { isLoadingClassroomDetail: false });

        case actions.UPDATE_CLASSROOM_REQUEST:
            return _extends({}, state, { disableAssignSaveButton: false });

        case actions.ASSIGN_STUDENT_REQUEST:
            return _extends({}, state, { disableAssignSaveButton: true, disableAssignCancelButton: true, isSaveInProgress: action.isSaveInProgress });

        case actions.ASSIGN_STUDENT_SUCCESS:
            return _extends({}, state, { showAssignUserConfirmationModal: true, disableAssignSaveButton: false, disableAssignCancelButton: false, isSaveInProgress: action.isSaveInProgress });

        case actions.ASSIGN_STUDENT_FAILURE:
            return _extends({}, state, { disableAssignSaveButton: false, disableAssignCancelButton: false, isSaveInProgress: action.isSaveInProgress });

        case actions.CLOSE_ASSIGN_CONFIRMATION_MODAL_REQUEST:
            return _extends({}, state, { showAssignUserConfirmationModal: false, disableAssignSaveButton: true });

        case actions.RESET_USER_CLASSROOM_RELATION:
            return _extends({}, state, { userClassroomRelation: { classrooms: [] }, disableAssignSaveButton: true });

        case actions.GET_TEACHER_CLASSROOMS_RELATION_REQUEST:
            return _extends({}, state, { isLoadingClassroomDetail: true, yearGroupEnum: -2, searchTerm: '' });

        case actions.GET_TEACHER_CLASSROOMS_RELATION_SUCCESS:
            return _extends({}, state, { userClassroomRelation: action.classrooms, isLoadingClassroomDetail: false, yearGroupEnum: -1 });

        case actions.GET_TEACHER_CLASSROOMS_RELATION_FAILURE:
            return _extends({}, state, { isLoadingClassroomDetail: false });

        case actions.ASSIGN_TEACHER_REQUEST:
            return _extends({}, state, { disableAssignSaveButton: true, disableAssignCancelButton: true, isSaveInProgress: action.isSaveInProgress });

        case actions.ASSIGN_TEACHER_SUCCESS:
            return _extends({}, state, { showAssignUserConfirmationModal: true, disableAssignSaveButton: false, disableAssignCancelButton: false, isSaveInProgress: action.isSaveInProgress });

        case actions.ASSIGN_TEACHER_FAILURE:
            return _extends({}, state, { disableAssignSaveButton: false, disableAssignCancelButton: false, isSaveInProgress: action.isSaveInProgress });

        case actions.CLASSROOM_TEACHER_MAPPING_SUCCESS:
            {
                return _extends({}, state, { isLoadingClassroomTeacherMapping: true, disableAssignSaveButton: true });
            }

        case actions.ASSIGN_TEACHER_TO_CLASSROOM_REQUEST:
            return _extends({}, state, { disableAssignSaveButton: true, disableAssignCancelButton: true, isSaveInProgress: action.isSaveInProgress });

        case actions.ASSIGN_TEACHER_TO_CLASSROOM_SUCCESS:
            return _extends({}, state, { disableAssignSaveButton: false, disableAssignCancelButton: false, isSaveInProgress: action.isSaveInProgress, isLoadingClassroomTeacherMapping: false });

        case actions.ASSIGN_TEACHER_TO_CLASSROOM_FAILURE:
            return _extends({}, state, { disableAssignSaveButton: false, disableAssignCancelButton: false, isSaveInProgress: action.isSaveInProgress });

        default:
            return state;
    }
}

exports.default = assignUserReducer;

/***/ }),
/* 818 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.getStudentClassroomsRelation = getStudentClassroomsRelation;
exports.getStudentClassroomsRelationSaga = getStudentClassroomsRelationSaga;
exports.assignStudent = assignStudent;
exports.assignStudentSaga = assignStudentSaga;
exports.getTeacherClassroomsRelation = getTeacherClassroomsRelation;
exports.getTeacherClassroomsRelationSaga = getTeacherClassroomsRelationSaga;
exports.assignTeacher = assignTeacher;
exports.assignTeacherSaga = assignTeacherSaga;
exports.assignTeacherToClassroom = assignTeacherToClassroom;
exports.assignTeacherToClassroomSaga = assignTeacherToClassroomSaga;

var _effects = __webpack_require__(32);

var _api = __webpack_require__(33);

var api = _interopRequireWildcard(_api);

var _actions = __webpack_require__(95);

var actions = _interopRequireWildcard(_actions);

var _actions2 = __webpack_require__(44);

var schoolRollActions = _interopRequireWildcard(_actions2);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var _marked = /*#__PURE__*/regeneratorRuntime.mark(getStudentClassroomsRelation),
    _marked2 = /*#__PURE__*/regeneratorRuntime.mark(getStudentClassroomsRelationSaga),
    _marked3 = /*#__PURE__*/regeneratorRuntime.mark(assignStudent),
    _marked4 = /*#__PURE__*/regeneratorRuntime.mark(assignStudentSaga),
    _marked5 = /*#__PURE__*/regeneratorRuntime.mark(getTeacherClassroomsRelation),
    _marked6 = /*#__PURE__*/regeneratorRuntime.mark(getTeacherClassroomsRelationSaga),
    _marked7 = /*#__PURE__*/regeneratorRuntime.mark(assignTeacher),
    _marked8 = /*#__PURE__*/regeneratorRuntime.mark(assignTeacherSaga),
    _marked9 = /*#__PURE__*/regeneratorRuntime.mark(assignTeacherToClassroom),
    _marked10 = /*#__PURE__*/regeneratorRuntime.mark(assignTeacherToClassroomSaga);

function getStudentClassroomsRelation(_ref) {
    var userProfileId = _ref.userProfileId,
        productId = _ref.productId;
    var payload;
    return regeneratorRuntime.wrap(function getStudentClassroomsRelation$(_context) {
        while (1) {
            switch (_context.prev = _context.next) {
                case 0:
                    _context.next = 2;
                    return (0, _effects.call)(api.getStudentClassroomsRelation, userProfileId, productId);

                case 2:
                    payload = _context.sent;

                    if (!(payload.status === 200)) {
                        _context.next = 8;
                        break;
                    }

                    _context.next = 6;
                    return (0, _effects.put)(actions.getStudentClassroomsRelationSuccess(payload.data));

                case 6:
                    _context.next = 10;
                    break;

                case 8:
                    _context.next = 10;
                    return (0, _effects.put)(actions.getStudentClassroomsRelationFailure());

                case 10:
                case 'end':
                    return _context.stop();
            }
        }
    }, _marked, this);
}

function getStudentClassroomsRelationSaga() {
    return regeneratorRuntime.wrap(function getStudentClassroomsRelationSaga$(_context2) {
        while (1) {
            switch (_context2.prev = _context2.next) {
                case 0:
                    _context2.next = 2;
                    return (0, _effects.takeLatest)(actions.GET_STUDENT_CLASSROOMS_RELATION_REQUEST, getStudentClassroomsRelation);

                case 2:
                case 'end':
                    return _context2.stop();
            }
        }
    }, _marked2, this);
}

function assignStudent(_ref2) {
    var assignedClassrooms = _ref2.assignedClassrooms,
        userProfileId = _ref2.userProfileId,
        productId = _ref2.productId;
    var payload;
    return regeneratorRuntime.wrap(function assignStudent$(_context3) {
        while (1) {
            switch (_context3.prev = _context3.next) {
                case 0:
                    _context3.next = 2;
                    return (0, _effects.call)(api.assignStudentClassrooms, assignedClassrooms, userProfileId, productId);

                case 2:
                    payload = _context3.sent;

                    if (!(payload.status === 200)) {
                        _context3.next = 10;
                        break;
                    }

                    _context3.next = 6;
                    return (0, _effects.put)(actions.assignStudentSuccess());

                case 6:
                    _context3.next = 8;
                    return (0, _effects.put)(schoolRollActions.getLicenceCapSummary(productId));

                case 8:
                    _context3.next = 12;
                    break;

                case 10:
                    _context3.next = 12;
                    return (0, _effects.put)(actions.assignStudentFailure());

                case 12:
                case 'end':
                    return _context3.stop();
            }
        }
    }, _marked3, this);
}

function assignStudentSaga() {
    return regeneratorRuntime.wrap(function assignStudentSaga$(_context4) {
        while (1) {
            switch (_context4.prev = _context4.next) {
                case 0:
                    _context4.next = 2;
                    return (0, _effects.takeLatest)(actions.ASSIGN_STUDENT_REQUEST, assignStudent);

                case 2:
                case 'end':
                    return _context4.stop();
            }
        }
    }, _marked4, this);
}

function getTeacherClassroomsRelation(_ref3) {
    var userProfileId = _ref3.userProfileId,
        productId = _ref3.productId;
    var payload;
    return regeneratorRuntime.wrap(function getTeacherClassroomsRelation$(_context5) {
        while (1) {
            switch (_context5.prev = _context5.next) {
                case 0:
                    _context5.next = 2;
                    return (0, _effects.call)(api.getTeacherClassroomsRelation, userProfileId, productId);

                case 2:
                    payload = _context5.sent;

                    if (!(payload.status === 200)) {
                        _context5.next = 8;
                        break;
                    }

                    _context5.next = 6;
                    return (0, _effects.put)(actions.getTeacherClassroomsRelationSuccess(payload.data));

                case 6:
                    _context5.next = 10;
                    break;

                case 8:
                    _context5.next = 10;
                    return (0, _effects.put)(actions.getTeacherClassroomsRelationFailure());

                case 10:
                case 'end':
                    return _context5.stop();
            }
        }
    }, _marked5, this);
}

function getTeacherClassroomsRelationSaga() {
    return regeneratorRuntime.wrap(function getTeacherClassroomsRelationSaga$(_context6) {
        while (1) {
            switch (_context6.prev = _context6.next) {
                case 0:
                    _context6.next = 2;
                    return (0, _effects.takeLatest)(actions.GET_TEACHER_CLASSROOMS_RELATION_REQUEST, getTeacherClassroomsRelation);

                case 2:
                case 'end':
                    return _context6.stop();
            }
        }
    }, _marked6, this);
}

function assignTeacher(_ref4) {
    var assignedClassrooms = _ref4.assignedClassrooms,
        userProfileId = _ref4.userProfileId,
        productId = _ref4.productId;
    var payload;
    return regeneratorRuntime.wrap(function assignTeacher$(_context7) {
        while (1) {
            switch (_context7.prev = _context7.next) {
                case 0:
                    _context7.next = 2;
                    return (0, _effects.call)(api.assignTeacherClassrooms, assignedClassrooms, userProfileId, productId);

                case 2:
                    payload = _context7.sent;

                    if (!(payload.status === 200)) {
                        _context7.next = 8;
                        break;
                    }

                    _context7.next = 6;
                    return (0, _effects.put)(actions.assignTeacherSuccess());

                case 6:
                    _context7.next = 10;
                    break;

                case 8:
                    _context7.next = 10;
                    return (0, _effects.put)(actions.assignTeacherFailure());

                case 10:
                case 'end':
                    return _context7.stop();
            }
        }
    }, _marked7, this);
}

function assignTeacherSaga() {
    return regeneratorRuntime.wrap(function assignTeacherSaga$(_context8) {
        while (1) {
            switch (_context8.prev = _context8.next) {
                case 0:
                    _context8.next = 2;
                    return (0, _effects.takeLatest)(actions.ASSIGN_TEACHER_REQUEST, assignTeacher);

                case 2:
                case 'end':
                    return _context8.stop();
            }
        }
    }, _marked8, this);
}

function assignTeacherToClassroom(_ref5) {
    var teacherClassroomMapping = _ref5.teacherClassroomMapping,
        context = _ref5.context;
    var payload;
    return regeneratorRuntime.wrap(function assignTeacherToClassroom$(_context9) {
        while (1) {
            switch (_context9.prev = _context9.next) {
                case 0:
                    _context9.next = 2;
                    return (0, _effects.call)(api.classroomUserRelation, teacherClassroomMapping);

                case 2:
                    payload = _context9.sent;

                    if (!(payload.status === 200)) {
                        _context9.next = 8;
                        break;
                    }

                    _context9.next = 6;
                    return (0, _effects.put)(actions.assignTeacherToClassroomSuccess(context));

                case 6:
                    _context9.next = 10;
                    break;

                case 8:
                    _context9.next = 10;
                    return (0, _effects.put)(actions.assignTeacherToClassroomFailure());

                case 10:
                case 'end':
                    return _context9.stop();
            }
        }
    }, _marked9, this);
}

function assignTeacherToClassroomSaga() {
    return regeneratorRuntime.wrap(function assignTeacherToClassroomSaga$(_context10) {
        while (1) {
            switch (_context10.prev = _context10.next) {
                case 0:
                    _context10.next = 2;
                    return (0, _effects.takeLatest)(actions.ASSIGN_TEACHER_TO_CLASSROOM_REQUEST, assignTeacherToClassroom);

                case 2:
                case 'end':
                    return _context10.stop();
            }
        }
    }, _marked10, this);
}

/***/ }),
/* 819 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __webpack_require__(28);

var _redux = __webpack_require__(35);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactIntl = __webpack_require__(2);

var _index = __webpack_require__(676);

var _index2 = _interopRequireDefault(_index);

var _portalComms = __webpack_require__(55);

var _portalComms2 = _interopRequireDefault(_portalComms);

var _gridUtil = __webpack_require__(86);

var _utils = __webpack_require__(13);

var _actions = __webpack_require__(44);

var _actions2 = __webpack_require__(50);

var _constants = __webpack_require__(96);

var _constants2 = _interopRequireDefault(_constants);

var _actions3 = __webpack_require__(65);

var _messages = __webpack_require__(394);

var _messages2 = _interopRequireDefault(_messages);

var _actions4 = __webpack_require__(38);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ClassRollContainer = function (_Component) {
    _inherits(ClassRollContainer, _Component);

    function ClassRollContainer(props) {
        _classCallCheck(this, ClassRollContainer);

        var _this = _possibleConstructorReturn(this, (ClassRollContainer.__proto__ || Object.getPrototypeOf(ClassRollContainer)).call(this, props));

        _this.handleRowSelect = function (rows) {
            _this.props.retrieveSelectedClasses(rows);
        };

        _this.handleFilterOnClear = function () {
            _this.props.clearFilterValue();
        };

        _this.handleFilterOnChange = function (collectionName, key) {
            _this.props.changeFilterValue(collectionName, key);
        };

        _this.handleOnSearch = function (searchTerm) {
            _this.props.updateSearchTerm(searchTerm);
        };

        _this.handleOnDownloadClassRoll = function () {
            _this.props.downloadClassRoll(_this.props.filteredClasses, false);
        };

        _this.handleOnQuickUpload = function () {
            _this.context.router.history.push('quickUpload');
        };

        _this.handleOnCloseModal = function () {
            _this.props.closeAddClassModal();
        };

        _this.handleListOnChange = function (classModel, field) {
            if (classModel.yearGroup !== '-1' && classModel.countryId !== '-1' && (field === 'yearGroup' || field === 'countryId')) {
                classModel.courseId = '-1';
                _this.props.getProductCourses(classModel.countryId, _this.props.selectedProduct.id, classModel.yearGroup);
            }
        };

        _this.handleOnDownloadStudentsSignInCards = function (format) {
            var studentSignInCardsData = { ClassroomIds: _this.props.selectedClasses, SignInCardPageSizeType: format };
            _this.props.printStudentsSignInCard(_this.props.selectedProduct.id, studentSignInCardsData);
        };

        _this.refreshList = function () {
            _this.props.getProductClassrooms(_this.props.selectedProduct.id);
        };

        _this.handleOnClassEdit = function (classroomId) {
            _this.context.router.history.push('/edit-class/' + classroomId);
        };

        _this.handleOnAssignTeacher = function (classroomId) {
            var assignType = 'teacherToClass';
            _this.context.router.history.push('/assign-user/' + classroomId + '/' + assignType);
        };

        _this.handleOnAssignStudent = function (classId) {
            var config = (0, _utils.getAppConfig)();
            var moduleId = config ? config.ModuleIdStudentMgmt : _constants2.default.FALLBACK_ID;
            var sourceModuleId = config ? config.ModuleIdSchoolRoll : _constants2.default.FALLBACK_ID;
            _portalComms2.default.requestModuleChange({ moduleId: moduleId, classId: classId, sourceModuleId: sourceModuleId });
        };

        _this.handleOnShowDeleteClassroomsConfirmation = function () {
            if (_this.props.selectedClasses.length > 0 && _this.state.rows.length > 0) {
                var selectedClassrooms = (0, _utils.filterClassroomByIds)(_this.state.rows, _this.props.selectedClasses);
                var isThereNonEmptyClassrooms = selectedClassrooms.some(_utils.nonEmptyClassroom);

                if (isThereNonEmptyClassrooms) {
                    _this.props.showToast(_this.props.intl.formatMessage(_messages2.default.deletingNonEmptyClassError), 'error');
                }
                _this.props.openDeleteClassroomsConfirmation(!isThereNonEmptyClassrooms);
            }
        };

        _this.handleOnDeleteClassrooms = function () {
            _this.props.deleteClassrooms(_this.props.selectedClasses);
        };

        _this.handleOnStudentSignInCards = function () {
            _this.props.showHideSignInCardModalRequest(true);
        };

        _this.handleOnCancelStudentSignInCards = function () {
            _this.props.showHideSignInCardModalRequest(false);
        };

        _this.getFilteredUPFCourses = function (countryCode, productId, yearGroup) {
            _this.props.getUPFCourses(countryCode, productId, yearGroup);
        };

        _this.getFilteredNewCourses = function (_ref) {
            var productId = _ref.productId,
                countryCode = _ref.countryCode,
                yearGroup = _ref.yearGroup;

            _this.props.getNewCourses({ productId: productId, countryCode: countryCode, yearGroup: yearGroup });
        };

        _this.handleGridSort = _this.handleGridSort.bind(_this);
        _this.rows = props.isClassroomDataLoaded ? (0, _gridUtil.createClassRows)(props.filteredClasses, props.intl) : [];
        _this.state = {
            rows: _this.rows,
            dataFilterOption: _this.props.dataFilterOption
        };
        _this.handleOnCloseModal = _this.handleOnCloseModal.bind(_this);
        _this.handleListOnChange = _this.handleListOnChange.bind(_this);
        _this.handleOnAssignStudent = _this.handleOnAssignStudent.bind(_this);
        _this.displayNewCourses = (0, _utils.displayNewCourses)();
        return _this;
    }

    _createClass(ClassRollContainer, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            if (!this.props.isClassroomDataLoaded) {
                this.props.getProductClassrooms(this.props.selectedProduct.id);
            }

            if (!this.props.isTeacherDataLoaded) {
                this.props.getProductTeachers(this.props.selectedProduct.id);
            }

            if (!this.props.isCountriesLoaded) {
                this.props.getCourseCountries(this.props.selectedProduct.id);
            }

            if (!this.props.isUpfCountriesLoaded) {
                this.props.getUpfCourseCountries(this.props.selectedProduct.id);
            }
        }
    }, {
        key: 'componentWillReceiveProps',
        value: function componentWillReceiveProps(nextProps) {
            if (nextProps.isClassroomDataLoaded || (0, _gridUtil.isListDifferent)(nextProps.filteredClasses, this.props.filteredClasses, 'classroomId')) {
                this.rows = (0, _gridUtil.createClassRows)(nextProps.filteredClasses, nextProps.intl);
                this.setState({ rows: this.rows });
            }

            if (nextProps.refreshList !== this.props.refreshList) {
                if (nextProps.refreshList) {
                    this.refreshList();
                }

                if (nextProps.deletedClassesCount) {
                    this.props.showToast(nextProps.deletedClassesCount + ' ' + this.props.intl.formatMessage(_messages2.default.deleteClassConfirmation), 'success');
                } else {
                    this.props.showToast(nextProps.classAdded + ' ' + this.props.intl.formatMessage(_messages2.default.addClassConfirmation), 'success');
                }
            }

            if (nextProps.isStudentsSignInCardDownloaded !== this.props.isStudentsSignInCardDownloaded) {
                setTimeout(this.props.showHideSignInCardModalRequest(false), 1000);
            }

            this.setState({ dataFilterOption: this.props.dataFilterOption });
        }
    }, {
        key: 'handleGridSort',
        value: function handleGridSort(sortColumn) {
            this.props.sortClassList(sortColumn);
        }
    }, {
        key: 'render',
        value: function render() {
            var _this2 = this;

            var rowGetter = function rowGetter(rowNumber) {
                return _this2.state.rows[rowNumber];
            };
            return _react2.default.createElement(_index2.default, _extends({
                classesCount: this.props.classrooms.length,
                classrooms: this.state.rows,
                closeAddStudentValidationModal: this.handleOnCloseValidationModal,
                dataFilterOptions: this.state.dataFilterOption,
                displayNewCourses: this.displayNewCourses,
                filteredClassesCount: this.props.filteredClasses.length,
                filterOnChange: this.handleFilterOnChange,
                filterOnClear: this.handleFilterOnClear,
                getFilteredNewCourses: this.getFilteredNewCourses,
                getFilteredUPFCourses: this.getFilteredUPFCourses,
                gridRowGetter: rowGetter,
                handleListOnChange: this.handleListOnChange,
                handleOnAssignStudent: this.handleOnAssignStudent,
                handleOnAssignTeacher: this.handleOnAssignTeacher,
                handleOnCancelStudentSignInCards: this.handleOnCancelStudentSignInCards,
                handleOnClassEdit: this.handleOnClassEdit,
                handleOnCloseDeleteClassroomsConfirmation: this.props.closeDeleteClassroomsConfirmation,
                handleOnCloseDeleteClassroomsSuccess: this.props.closeDeleteClassroomsSuccess,
                handleOnDeleteClassrooms: this.handleOnDeleteClassrooms,
                handleOnDownloadStudentsSignInCards: this.handleOnDownloadStudentsSignInCards,
                handleOnShowDeleteClassroomsConfirmation: this.handleOnShowDeleteClassroomsConfirmation,
                handleOnStudentSignInCards: this.handleOnStudentSignInCards,
                onAddClassCloseModal: this.handleOnCloseModal,
                onDownloadClassRoll: this.handleOnDownloadClassRoll,
                onGridSort: this.handleGridSort,
                onQuickUpload: this.handleOnQuickUpload,
                onRowSelect: this.handleRowSelect,
                onSearch: this.handleOnSearch,
                yearGroups: this.props.dataFilterOption.yearGroups
            }, this.props));
        }
    }]);

    return ClassRollContainer;
}(_react.Component);

ClassRollContainer.propTypes = {
    intl: _reactIntl.intlShape.isRequired,
    selectedProduct: _propTypes2.default.object,
    isClassroomDataLoaded: _propTypes2.default.bool,
    isClassRollDownloaded: _propTypes2.default.bool,
    classrooms: _propTypes2.default.arrayOf(_propTypes2.default.object),
    openAddClassModal: _propTypes2.default.func,
    closeAddClassModal: _propTypes2.default.func,
    showAddClassModal: _propTypes2.default.bool,
    showAddClassConfirmationModal: _propTypes2.default.bool,
    showAddClassValidationModal: _propTypes2.default.bool,
    addClassValidationMessage: _propTypes2.default.string,
    yearGroups: _propTypes2.default.arrayOf(_propTypes2.default.object),
    getCourseCountries: _propTypes2.default.func,
    getUpfCourseCountries: _propTypes2.default.func,
    productCountries: _propTypes2.default.arrayOf(_propTypes2.default.object),
    upfCountries: _propTypes2.default.arrayOf(_propTypes2.default.object),
    productTeachers: _propTypes2.default.arrayOf(_propTypes2.default.object),
    productCourses: _propTypes2.default.arrayOf(_propTypes2.default.object),
    getProductCourses: _propTypes2.default.func,
    getProductTeachers: _propTypes2.default.func,
    getProductClassrooms: _propTypes2.default.func,
    isTeacherDataLoaded: _propTypes2.default.bool,
    isCountriesLoaded: _propTypes2.default.bool,
    classModel: _propTypes2.default.object,
    selectedClasses: _propTypes2.default.arrayOf(_propTypes2.default.number),
    filteredClasses: _propTypes2.default.arrayOf(_propTypes2.default.object),
    printStudentsSignInCard: _propTypes2.default.func,
    isStudentsSignInCardDownloaded: _propTypes2.default.bool,
    isProductCoursesLoaded: _propTypes2.default.bool,
    isSaveInProgress: _propTypes2.default.bool,
    downloadClassRoll: _propTypes2.default.func,
    sortClassList: _propTypes2.default.func,
    retrieveSelectedClasses: _propTypes2.default.func,
    dataFilterOption: _propTypes2.default.object,
    addClass: _propTypes2.default.func,
    closeAddClassValidationModal: _propTypes2.default.func,
    refreshList: _propTypes2.default.bool,
    clearFilterValue: _propTypes2.default.func,
    changeFilterValue: _propTypes2.default.func,
    updateSearchTerm: _propTypes2.default.func,
    getStudentByClassroomIdRequest: _propTypes2.default.func,
    deleteClassrooms: _propTypes2.default.func,
    openDeleteClassroomsConfirmation: _propTypes2.default.func,
    closeDeleteClassroomsConfirmation: _propTypes2.default.func,
    openDeleteClassroomsSuccess: _propTypes2.default.func,
    closeDeleteClassroomsSuccess: _propTypes2.default.func,
    getProductStudents: _propTypes2.default.func,
    showToast: _propTypes2.default.func,
    showHideSignInCardModalRequest: _propTypes2.default.func,
    showHideSignInCardModal: _propTypes2.default.bool,
    getUPFCourses: _propTypes2.default.func,
    getNewCourses: _propTypes2.default.func,
    clearProductCourses: _propTypes2.default.func,
    classAdded: _propTypes2.default.string,
    deletedClassesCount: _propTypes2.default.number,
    isUpfCountriesLoaded: _propTypes2.default.bool
};
ClassRollContainer.contextTypes = {
    router: _propTypes2.default.object
};


function mapStateToProps() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    return _extends({}, state, {
        selectedProduct: state.product,
        classrooms: state.classRoll.classrooms,
        classModel: state.classRoll.classModel,
        dataFilterOption: state.classRoll.dataFilterOption,
        isClassroomDataLoaded: state.classRoll.isClassroomDataLoaded,
        isClassRollDownloaded: state.classRoll.isClassRollDownloaded,
        showAddClassModal: state.classRoll.showAddClassModal,
        showAddClassConfirmationModal: state.classRoll.showAddClassConfirmationModal,
        yearGroups: state.schoolRoll.yearGroups,
        productCountries: state.schoolRoll.countries.filtered,
        upfCountries: state.schoolRoll.upfCountries.filtered,
        productTeachers: state.teacherRoll.teachersFiltered,
        productCourses: state.classRoll.productCourses,
        isCountriesLoaded: state.schoolRoll.isCountriesLoaded,
        isProductCoursesFetching: state.classRoll.isProductCoursesFetching,
        isSchoolCoursesFetching: state.classRoll.isSchoolCoursesFetching,
        isTeacherDataLoaded: state.teacherRoll.isTeacherDataLoaded,
        isYearGroupDataLoaded: state.schoolRoll.isYearGroupDataLoaded,
        selectedClasses: state.classRoll.selectedClasses,
        filteredClasses: state.classRoll.filteredClasses,
        isStudentsSignInCardDownloaded: state.classRoll.isStudentsSignInCardDownloaded,
        isProductCoursesLoaded: state.classRoll.isProductCoursesLoaded,
        isSaveInProgress: state.classRoll.isSaveInProgress,
        showAddClassValidationModal: state.classRoll.showAddClassValidationModal,
        addClassValidationMessage: state.classRoll.addClassValidationMessage,
        refreshList: state.classRoll.refreshList,
        changeCourse: state.classRoll.changeCourse,
        deletingClassrooms: state.classRoll.deletingClassrooms,
        showDeleteClassroomsConfirmation: state.classRoll.showDeleteClassroomsConfirmation,
        showDeleteClassroomsSuccess: state.classRoll.showDeleteClassroomsSuccess,
        deletingEmptyClassrooms: state.classRoll.deletingEmptyClassrooms,
        showHideSignInCardModal: state.classRoll.showHideSignInCardModal,
        upfCourses: state.classRoll.upfCourses,
        newCourses: state.classRoll.newCourses,
        classAdded: state.classRoll.classAdded,
        deletedClassesCount: state.classRoll.deletedClassesCount,
        isUPFCoursesFetching: state.classRoll.isUPFCoursesFetching,
        isNewCoursesFetching: state.classRoll.isNewCoursesFetching
    });
}

function mapDispatchToProps(dispatch) {
    return (0, _redux.bindActionCreators)({
        printStudentsSignInCard: _actions4.printStudentsSignInCard,
        clearFilterValue: _actions4.clearFilterValue,
        changeFilterValue: _actions4.changeFilterValue,
        updateSearchTerm: _actions4.updateSearchTerm,
        sortClassList: _actions4.sortClassList,
        retrieveSelectedClasses: _actions4.retrieveSelectedClasses,
        openAddClassModal: _actions4.openAddClassModal,
        closeAddClassModal: _actions4.closeAddClassModal,
        getCourseCountries: _actions.getCourseCountries,
        getUpfCourseCountries: _actions.getUpfCourseCountries,
        getProductTeachers: _actions2.getProductTeachers,
        getProductCourses: _actions4.getProductCourses,
        getProductClassrooms: _actions4.getProductClassrooms,
        getSchoolCourses: _actions4.getSchoolCourses,
        addClass: _actions4.addClass,
        downloadClassRoll: _actions4.downloadClassRoll,
        closeAddClassValidationModal: _actions4.closeAddClassValidationModal,
        getStudentByClassroomIdRequest: _actions4.getStudentByClassroomIdRequest,
        deleteClassrooms: _actions4.deleteClassrooms,
        openDeleteClassroomsConfirmation: _actions4.openDeleteClassroomsConfirmation,
        closeDeleteClassroomsConfirmation: _actions4.closeDeleteClassroomsConfirmation,
        openDeleteClassroomsSuccess: _actions4.openDeleteClassroomsSuccess,
        closeDeleteClassroomsSuccess: _actions4.closeDeleteClassroomsSuccess,
        showToast: _actions3.showToast,
        showHideSignInCardModalRequest: _actions4.showHideSignInCardModalRequest,
        getUPFCourses: _actions4.getUPFCourses,
        getNewCourses: _actions4.getNewCourses,
        clearProductCourses: _actions4.clearProductCourses,
        clearUPFCourses: _actions4.clearUPFCourses
    }, dispatch);
}

var ContainerWithIntl = (0, _reactIntl.injectIntl)(ClassRollContainer);
exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(ContainerWithIntl);

/***/ }),
/* 820 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.default = function () {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initState;
    var action = arguments[1];

    switch (action.type) {
        case actions.GET_CLASSROOMS_REQUEST:
            {
                return _extends({}, state, { isClassroomDataLoaded: action.isClassroomDataLoaded, deletedClassesCount: 0 });
            }
        case actions.GET_CLASSROOMS_SUCCESS:
            {
                return _extends({}, state, {
                    classrooms: action.data,
                    filteredClasses: action.data,
                    isClassroomDataLoaded: action.isClassroomDataLoaded,
                    refreshList: false
                });
            }
        case actions.GET_CLASSROOMS_FAILURE:
            {
                return _extends({}, state, { isClassroomDataLoaded: action.isClassroomDataLoaded });
            }

        case actions.DOWNLOAD_CLASS_ROLL_REQUEST:
            {
                return _extends({}, state, { isClassRollDownloaded: action.isClassRollDownloaded });
            }

        case actions.DOWNLOAD_CLASS_ROLL_SUCCESS:
            {
                return _extends({}, state, { isClassRollDownloaded: action.isClassRollDownloaded });
            }

        case actions.DOWNLOAD_CLASS_ROLL_FAILURE:
            {
                return _extends({}, state, { isClassRollDownloaded: action.isClassRollDownloaded });
            }

        case actions.PRINT_STUDENTS_SIGN_IN_CARD_REQUEST:
            return _extends({}, state, { isStudentsSignInCardDownloaded: action.isStudentsSignInCardDownloaded });

        case actions.PRINT_STUDENTS_SIGN_IN_CARD_SUCCESS:
            {
                window.location.href = action.downloadUrl;
                return _extends({}, state, { isStudentsSignInCardDownloaded: action.isStudentsSignInCardDownloaded });
            }

        case actions.PRINT_STUDENTS_SIGN_IN_CARD_FAILURE:
            {
                return _extends({}, state, { isStudentsSignInCardDownloaded: action.isStudentsSignInCardDownloaded });
            }

        case _actions2.GET_YEAR_GROUPS_SUCCESS:
            {
                return _extends({}, state, { dataFilterOption: (0, _utils.updateYearGroups)(state.dataFilterOption, action.data) });
            }

        case teacherRollActions.GET_PRODUCT_TEACHERS_SUCCESS:
            {
                return _extends({}, state, { dataFilterOption: (0, _utils.updateTeachers)(state.dataFilterOption, action.data) });
            }

        case actions.RETRIEVE_SELECTED_CLASSES:
            {
                return _extends({}, state, { selectedClasses: action.selectedClasses });
            }

        case actions.SORT_CLASS_LIST:
            {
                var sortDirection = 'asc';
                if (state.dataFilterOption.sortColumn === action.columnToSort) {
                    if (state.dataFilterOption.sortDirection === 'asc') {
                        sortDirection = 'desc';
                    }
                }
                var filterOption = _extends({}, state.dataFilterOption, { sortColumn: action.columnToSort, sortDirection: sortDirection });
                var filteredClasses = getSortedData(state.filteredClasses, filterOption);
                return _extends({}, state, { filteredClasses: filteredClasses, dataFilterOption: filterOption });
            }
        case actions.CLASS_UPDATE_SEARCH_TERM:
            {
                var _filterOption = _extends({}, state.dataFilterOption, { searchTerm: action.searchTerm });
                var _filteredClasses = getFilteredData(state.classrooms, _filterOption);
                return _extends({}, state, { filteredClasses: _filteredClasses, dataFilterOption: _filterOption });
            }
        case actions.ADD_CLASS_OPEN_MODAL_REQUEST:
            {
                return _extends({}, state, {
                    showAddClassModal: action.showAddClassModal,
                    classModel: assignEmptyClassObject(),
                    showAddClassConfirmationModal: action.showAddClassConfirmationModal,
                    lastAddedClassId: 0
                });
            }

        case actions.ADD_CLASS_CLOSE_MODAL_REQUEST:
            {
                return _extends({}, state, {
                    showAddClassModal: action.showAddClassModal,
                    classModel: assignEmptyClassObject(),
                    showAddClassConfirmationModal: action.showAddClassConfirmationModal,
                    lastAddedClassId: 0,
                    productCourses: [],
                    refreshList: false
                });
            }

        case actions.GET_PRODUCT_COURSES_REQUEST:
            {
                return _extends({}, state, {
                    productCourses: [],
                    classModel: _extends({}, state.classModel, { courseId: '-1' }),
                    isProductCoursesLoaded: action.isProductCoursesLoaded,
                    isProductCoursesFetching: action.isProductCoursesFetching });
            }

        case actions.GET_PRODUCT_COURSES_SUCCESS:
            {
                return _extends({}, state, {
                    productCourses: (0, _utils.filterProductCourses)(action.data),
                    classModel: _extends({}, state.classModel, { courseId: '-1' }),
                    isProductCoursesLoaded: action.isProductCoursesLoaded,
                    isProductCoursesFetching: action.isProductCoursesFetching });
            }

        case actions.GET_PRODUCT_COURSES_FAILURE:
            {
                return _extends({}, state, {
                    isProductCoursesLoaded: action.isProductCoursesLoaded,
                    isProductCoursesFetching: action.isProductCoursesFetching });
            }

        case actions.ADD_CLASS_REQUEST:
            {
                return _extends({}, state, { isSaveInProgress: true, classAdded: action.ClassModel.name });
            }

        case actions.ADD_CLASS_SUCCESS:
            {
                return _extends({}, state, {
                    isSaveInProgress: false,
                    showAddClassConfirmationModal: false,
                    showAddClassModal: false,
                    refreshList: true,
                    selectedClasses: [],
                    dataFilterOption: resetFilterOptions(state.dataFilterOption)
                });
            }

        case actions.ADD_CLASS_FAILURE:
            {
                return _extends({}, state, {
                    isSaveInProgress: false,
                    showAddClassModal: true,
                    showAddClassValidationModal: action.showAddClassValidationModal,
                    addClassValidationMessage: action.errorMessage
                });
            }

        case actions.CLOSE_ADD_CLASS_VALIDATION_MODAL:
            {
                return _extends({}, state, {
                    showAddClassValidationModal: action.showAddClassValidationModal
                });
            }

        case actions.CLASS_FILTER_VALUE_CLEARED:
            {
                if (state.dataFilterOption.sortDirection === 'desc') {
                    state.dataFilterOption.sortDirection = 'asc';
                }
                var _filterOption2 = resetFilterOptions(state.dataFilterOption);
                var _filteredClasses2 = getFilteredData(state.classrooms, _filterOption2);
                return _extends({}, state, { filteredClasses: _filteredClasses2, dataFilterOption: _filterOption2, selectedClasses: [] });
            }
        case actions.CLASS_FILTER_VALUE_CHANGED:
            {
                var _filterOption3 = changeFilterOptions(state.dataFilterOption, action.collectionName, action.key);
                var _filteredClasses3 = getFilteredData(state.classrooms, _filterOption3);
                return _extends({}, state, { filteredClasses: _filteredClasses3, dataFilterOption: _filterOption3, selectedClasses: [] });
            }
        case actions.REFRESH_CLASS_LIST:
            {
                return _extends({}, state, { refreshList: false });
            }
        case assignUser.ASSIGN_STUDENT_SUCCESS:
        case assignUser.ASSIGN_TEACHER_SUCCESS:
        case assignUser.ASSIGN_TEACHER_TO_CLASSROOM_SUCCESS:
        case editStudentActions.UNASSIGN_STUDENTS_USING_CLASSID_SUCCESS:
        case editTeacherActions.EDIT_TEACHER_SUCCESS_REQUEST:
        case editTeacherActions.UNASSIGN_TEACHERS_USING_CLASSID_SUCCESS:
        case studentRollActions.UNASSIGN_STUDENTS_SUCCESS:
        case studentRollActions.DELETE_STUDENT_SUCCESS:
        case studentRollActions.ADD_STUDENT_SUCCESS:
        case teacherRollActions.ADD_TEACHER_SUCCESS:
        case teacherRollActions.UNASSIGN_TEACHERS_SUCCESS:
        case teacherRollActions.DELETE_TEACHER_SUCCESS:
        case editClassActions.CHANGE_COURSE_SUCCESS:
        case editClassActions.DELETE_GROUP_SUCCESS:
        case editClassActions.ADD_GROUP_SUCCESS:
        case editClassActions.MODIFIED_CLASS_SAVE_SUCCESS:
        case editClassActions.CLOSE_EDIT_CLASS:
            {
                return _extends({}, state, { isClassroomDataLoaded: false, dataFilterOption: resetFilterOptions(state.dataFilterOption) });
            }

        case actions.GET_SCHOOL_COURSES_REQUEST:
            {
                return _extends({}, state, {
                    productCourses: [],
                    classModel: _extends({}, state.classModel, { courseId: '-1' }),
                    isSchoolCoursesLoaded: false,
                    isSchoolCoursesFetching: true });
            }

        case actions.GET_SCHOOL_COURSES_SUCCESS:
            {
                return _extends({}, state, {
                    productCourses: (0, _utils.filterProductCourses)(action.data),
                    classModel: _extends({}, state.classModel, { courseId: '-1' }),
                    isSchoolCoursesLoaded: true,
                    isSchoolCoursesFetching: false });
            }

        case actions.GET_SCHOOL_COURSES_FAILURE:
            {
                return _extends({}, state, {
                    isSchoolCoursesLoaded: false,
                    isSchoolCoursesFetching: false });
            }

        case actions.DELETE_CLASSROOMS_REQUEST:
            {
                return _extends({}, state, {
                    deletingClassrooms: action.deletingClassrooms,
                    refreshList: action.refreshList
                });
            }
        case actions.DELETE_CLASSROOMS_SUCCESS:
        case actions.DELETE_CLASSROOMS_FAILURE:
            {
                return _extends({}, state, {
                    deletingClassrooms: action.deletingClassrooms
                });
            }

        case actions.CLOSE_DELETE_CLASSROOMS_CONFIRMATION:
            {
                return _extends({}, state, {
                    showDeleteClassroomsConfirmation: action.showDeleteClassroomsConfirmation,
                    deletingEmptyClassrooms: action.deletingEmptyClassrooms,
                    selectedClasses: action.deletingEmptyClassrooms ? [].concat(_toConsumableArray(state.selectedClasses)) : []
                });
            }
        case actions.SHOW_DELETE_CLASSROOMS_CONFIRMATION:
            {
                return _extends({}, state, {
                    showDeleteClassroomsConfirmation: action.showDeleteClassroomsConfirmation,
                    deletingEmptyClassrooms: action.deletingEmptyClassrooms
                });
            }
        case actions.SHOW_DELETE_CLASSROOMS_SUCCESS:
            {
                return _extends({}, state, {
                    showDeleteClassroomsSuccess: action.showDeleteClassroomsSuccess

                });
            }
        case actions.CLOSE_DELETE_CLASSROOMS_SUCCESS:
            {
                var _filterOption4 = resetFilterOptions(state.dataFilterOption);
                _filterOption4.searchTerm = '';
                return _extends({}, state, {
                    showDeleteClassroomsSuccess: action.showDeleteClassroomsSuccess,
                    selectedClasses: [],
                    refreshList: action.refreshList,
                    dataFilterOption: _filterOption4,
                    deletedClassesCount: action.deletedClassesCount,
                    deletingEmptyClassrooms: false
                });
            }
        case actions.GET_STUDENTS_BY_CLASSROOM_REQUEST:
            {
                return _extends({}, state, {
                    isClassroomStudentsLoaded: action.isStudentDataLoaded
                });
            }

        case actions.GET_STUDENTS_BY_CLASSROOM_SUCCESS:
            {
                return _extends({}, state, {
                    isClassroomStudentsLoaded: action.isStudentDataLoaded,
                    assignedStudents: selectAllStudents(action.students, false)
                });
            }

        case actions.GET_STUDENTS_BY_CLASSROOM_FAILURE:
            {
                return _extends({}, state, {
                    isClassroomStudentsLoaded: action.isStudentDataLoaded
                });
            }

        case actions.SHOW_HIDE_SIGNIN_CARD_MODAL:
            {
                return _extends({}, state, { showHideSignInCardModal: action.showHideSignInCardModal });
            }

        case actions.GET_UPF_COURSES:
            {
                return _extends({}, state, {
                    isUPFCoursesFetching: action.isUPFCoursesFetching
                });
            }

        case actions.GET_UPF_COURSES_SUCCESS:
            {
                return _extends({}, state, {
                    upfCourses: action.data,
                    isUPFCoursesFetching: false
                });
            }

        case actions.GET_UPF_COURSES_FAILURE:
        case actions.CLEAR_UPF_COURSES:
            {
                return _extends({}, state, {
                    upfCourses: [],
                    isUPFCoursesFetching: false
                });
            }

        case actions.GET_NEW_COURSES_REQUEST:
            {
                return _extends({}, state, {
                    isNewCoursesFetching: action.isNewCoursesFetching
                });
            }

        case actions.GET_NEW_COURSES_SUCCESS:
            {
                return _extends({}, state, {
                    newCourses: action.data,
                    isNewCoursesFetching: false
                });
            }

        case actions.GET_NEW_COURSES_FAILURE:
            {
                return _extends({}, state, {
                    newCourses: [],
                    isNewCoursesFetching: false
                });
            }

        case actions.CLEAR_PRODUCT_COURSES:
            {
                return _extends({}, state, {
                    productCourses: []
                });
            }

        default:
            return _extends({}, state);
    }
};

var _map = __webpack_require__(139);

var _map2 = _interopRequireDefault(_map);

var _actions = __webpack_require__(38);

var actions = _interopRequireWildcard(_actions);

var _actions2 = __webpack_require__(44);

var _actions3 = __webpack_require__(98);

var studentRollActions = _interopRequireWildcard(_actions3);

var _actions4 = __webpack_require__(127);

var editStudentActions = _interopRequireWildcard(_actions4);

var _actions5 = __webpack_require__(50);

var teacherRollActions = _interopRequireWildcard(_actions5);

var _actions6 = __webpack_require__(128);

var editTeacherActions = _interopRequireWildcard(_actions6);

var _actions7 = __webpack_require__(95);

var assignUser = _interopRequireWildcard(_actions7);

var _actions8 = __webpack_require__(106);

var editClassActions = _interopRequireWildcard(_actions8);

var _utils = __webpack_require__(13);

var _gridUtil = __webpack_require__(86);

var _messages = __webpack_require__(394);

var _messages2 = _interopRequireDefault(_messages);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var dataFilterOption = {
    yearGroups: [{ key: '-1', value: _messages2.default.defaultOptionYearGroup, selected: true }],
    teachers: [{ key: '-1', value: _messages2.default.defaultOptionTeachers, selected: true }],
    searchTerm: '',
    sortColumn: 'name',
    sortDirection: 'asc'
};

var assignEmptyClassObject = function assignEmptyClassObject() {
    return { name: '', yearGroup: '-1', countryId: '-1', courseId: '-1', teacherId: '-1', productId: '-1', upfCourseId: '-1' };
};

var initState = {
    isClassroomDataLoaded: false,
    classrooms: [],
    yearGroups: [],
    productCourses: [],
    isProductCoursesLoaded: false,
    isProductCoursesFetching: false,
    isUPFCoursesFetching: false,
    isNewCoursesFetching: false,
    classModel: assignEmptyClassObject(),
    lastAddedClassId: 0,
    showAddClassModal: false,
    showAddClassConfirmationModal: false,
    selectedClasses: [],
    filteredClasses: [],
    operationType: '',
    isStudentsSignInCardDownloaded: true,
    refreshList: false,
    isClassRollDownloaded: true,
    deletingClassrooms: false,
    showDeleteClassroomsConfirmation: false,
    showDeleteClassroomsSuccess: false,
    deletingEmptyClassrooms: false,
    dataFilterOption: dataFilterOption,
    showHideSignInCardModal: false,
    upfCourses: [],
    newCourses: [],
    classAdded: '',
    deletedClassesCount: 0
};

var selectAllStudents = function selectAllStudents(students, checked) {
    var studentList = (0, _map2.default)(students, function (student) {
        student.selected = checked;
        return student;
    });
    return studentList;
};

var getSortedData = function getSortedData(classrooms, filterOptions) {
    return (0, _gridUtil.sort)(classrooms, filterOptions.sortColumn, filterOptions.sortDirection);
};

var getFilteredData = function getFilteredData(classrooms, filterOptions) {
    return (0, _gridUtil.filterClasses)(classrooms, filterOptions);
};

var resetSelectedItem = function resetSelectedItem(items) {
    var selectedItem = items.find(function (item) {
        return item.selected === true;
    });
    selectedItem.selected = false;
    items[0].selected = true;
    return items;
};

var resetFilterOptions = function resetFilterOptions(currentOptions) {
    var yearGroups = resetSelectedItem(currentOptions.yearGroups);
    var teachers = resetSelectedItem(currentOptions.teachers);

    return _extends({}, currentOptions, { yearGroups: yearGroups, teachers: teachers, searchTerm: currentOptions.searchTerm });
};

var changeFilterOptions = function changeFilterOptions(currentOptions, collectionName, key) {
    var items = currentOptions[collectionName];
    var selectedItem = items.find(function (item) {
        return item.selected === true;
    });
    selectedItem.selected = false;
    var newSelection = items.find(function (item) {
        return item.key.toString() === key;
    });
    newSelection.selected = true;
    return _extends({}, currentOptions, _defineProperty({}, collectionName, currentOptions[collectionName]));
};

/***/ }),
/* 821 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.getClassrooms = getClassrooms;
exports.getClassroomsSaga = getClassroomsSaga;
exports.downloadClassroomStudentsSignInsCards = downloadClassroomStudentsSignInsCards;
exports.downloadClassroomStudentsSignInsCardsSaga = downloadClassroomStudentsSignInsCardsSaga;
exports.getProductCourses = getProductCourses;
exports.getProductCoursesSaga = getProductCoursesSaga;
exports.addClass = addClass;
exports.addClassSaga = addClassSaga;
exports.downloadClassRoll = downloadClassRoll;
exports.downloadClassRollSaga = downloadClassRollSaga;
exports.getSchoolCourses = getSchoolCourses;
exports.getSchoolCoursesSaga = getSchoolCoursesSaga;
exports.deleteClassrooms = deleteClassrooms;
exports.deleteClassroomsSaga = deleteClassroomsSaga;
exports.getUPFCourses = getUPFCourses;
exports.getUPFCoursesSaga = getUPFCoursesSaga;
exports.getNewCourses = getNewCourses;
exports.getNewCoursesSaga = getNewCoursesSaga;

var _effects = __webpack_require__(32);

var _product = __webpack_require__(194);

var _product2 = _interopRequireDefault(_product);

var _actions = __webpack_require__(38);

var actions = _interopRequireWildcard(_actions);

var _api = __webpack_require__(33);

var api = _interopRequireWildcard(_api);

var _actions2 = __webpack_require__(65);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

var _marked = /*#__PURE__*/regeneratorRuntime.mark(getClassrooms),
    _marked2 = /*#__PURE__*/regeneratorRuntime.mark(getClassroomsSaga),
    _marked3 = /*#__PURE__*/regeneratorRuntime.mark(downloadClassroomStudentsSignInsCards),
    _marked4 = /*#__PURE__*/regeneratorRuntime.mark(downloadClassroomStudentsSignInsCardsSaga),
    _marked5 = /*#__PURE__*/regeneratorRuntime.mark(getProductCourses),
    _marked6 = /*#__PURE__*/regeneratorRuntime.mark(getProductCoursesSaga),
    _marked7 = /*#__PURE__*/regeneratorRuntime.mark(addClass),
    _marked8 = /*#__PURE__*/regeneratorRuntime.mark(addClassSaga),
    _marked9 = /*#__PURE__*/regeneratorRuntime.mark(downloadClassRoll),
    _marked10 = /*#__PURE__*/regeneratorRuntime.mark(downloadClassRollSaga),
    _marked11 = /*#__PURE__*/regeneratorRuntime.mark(getSchoolCourses),
    _marked12 = /*#__PURE__*/regeneratorRuntime.mark(getSchoolCoursesSaga),
    _marked13 = /*#__PURE__*/regeneratorRuntime.mark(deleteClassrooms),
    _marked14 = /*#__PURE__*/regeneratorRuntime.mark(deleteClassroomsSaga),
    _marked15 = /*#__PURE__*/regeneratorRuntime.mark(getUPFCourses),
    _marked16 = /*#__PURE__*/regeneratorRuntime.mark(getUPFCoursesSaga),
    _marked17 = /*#__PURE__*/regeneratorRuntime.mark(getNewCourses),
    _marked18 = /*#__PURE__*/regeneratorRuntime.mark(getNewCoursesSaga);

function getClassrooms() {
    var productId, payload;
    return regeneratorRuntime.wrap(function getClassrooms$(_context) {
        while (1) {
            switch (_context.prev = _context.next) {
                case 0:
                    _context.next = 2;
                    return (0, _effects.select)(_product2.default);

                case 2:
                    productId = _context.sent;
                    _context.next = 5;
                    return (0, _effects.call)(api.getClassrooms, productId);

                case 5:
                    payload = _context.sent;

                    if (!(payload.status === 200)) {
                        _context.next = 11;
                        break;
                    }

                    _context.next = 9;
                    return (0, _effects.put)(actions.getProductClassroomsSuccess(payload, productId));

                case 9:
                    _context.next = 13;
                    break;

                case 11:
                    _context.next = 13;
                    return (0, _effects.put)(actions.getProductClassroomsFailure(productId));

                case 13:
                case 'end':
                    return _context.stop();
            }
        }
    }, _marked, this);
}

function getClassroomsSaga() {
    return regeneratorRuntime.wrap(function getClassroomsSaga$(_context2) {
        while (1) {
            switch (_context2.prev = _context2.next) {
                case 0:
                    _context2.next = 2;
                    return (0, _effects.takeLatest)(actions.GET_CLASSROOMS_REQUEST, getClassrooms);

                case 2:
                case 'end':
                    return _context2.stop();
            }
        }
    }, _marked2, this);
}

function downloadClassroomStudentsSignInsCards(_ref) {
    var selectedProductId = _ref.selectedProductId,
        studentSignInCardsData = _ref.studentSignInCardsData;
    var response, downloadUrl;
    return regeneratorRuntime.wrap(function downloadClassroomStudentsSignInsCards$(_context3) {
        while (1) {
            switch (_context3.prev = _context3.next) {
                case 0:
                    _context3.next = 2;
                    return (0, _effects.call)(api.downloadClassroomsStudentsSignInCards, {
                        productId: selectedProductId,
                        studentSignInCardsData: studentSignInCardsData
                    });

                case 2:
                    response = _context3.sent;

                    if (!(response.status === 201)) {
                        _context3.next = 9;
                        break;
                    }

                    downloadUrl = response.verb.url + '/' + response.data;
                    _context3.next = 7;
                    return (0, _effects.put)(actions.printStudentsSignInCardSuccess(downloadUrl));

                case 7:
                    _context3.next = 11;
                    break;

                case 9:
                    _context3.next = 11;
                    return (0, _effects.put)(actions.printStudentsSignInCardFailure());

                case 11:
                case 'end':
                    return _context3.stop();
            }
        }
    }, _marked3, this);
}

function downloadClassroomStudentsSignInsCardsSaga() {
    return regeneratorRuntime.wrap(function downloadClassroomStudentsSignInsCardsSaga$(_context4) {
        while (1) {
            switch (_context4.prev = _context4.next) {
                case 0:
                    _context4.next = 2;
                    return (0, _effects.takeLatest)(actions.PRINT_STUDENTS_SIGN_IN_CARD_REQUEST, downloadClassroomStudentsSignInsCards);

                case 2:
                case 'end':
                    return _context4.stop();
            }
        }
    }, _marked4, this);
}

function getProductCourses(_ref2) {
    var countryCode = _ref2.countryCode,
        productId = _ref2.productId,
        yearGroup = _ref2.yearGroup;
    var countriesRequest, response;
    return regeneratorRuntime.wrap(function getProductCourses$(_context5) {
        while (1) {
            switch (_context5.prev = _context5.next) {
                case 0:
                    countriesRequest = { countryCode: countryCode, productId: productId, yearGroup: yearGroup };
                    _context5.next = 3;
                    return (0, _effects.call)(api.getProductCourses, countriesRequest);

                case 3:
                    response = _context5.sent;

                    if (!(response.status === 200)) {
                        _context5.next = 9;
                        break;
                    }

                    _context5.next = 7;
                    return (0, _effects.put)(actions.getProductCoursesSuccess(response.data));

                case 7:
                    _context5.next = 11;
                    break;

                case 9:
                    _context5.next = 11;
                    return (0, _effects.put)(actions.getProductCoursesFailure());

                case 11:
                case 'end':
                    return _context5.stop();
            }
        }
    }, _marked5, this);
}

function getProductCoursesSaga() {
    return regeneratorRuntime.wrap(function getProductCoursesSaga$(_context6) {
        while (1) {
            switch (_context6.prev = _context6.next) {
                case 0:
                    _context6.next = 2;
                    return (0, _effects.takeLatest)(actions.GET_PRODUCT_COURSES_REQUEST, getProductCourses);

                case 2:
                case 'end':
                    return _context6.stop();
            }
        }
    }, _marked6, this);
}

function addClass(_ref3) {
    var ClassModel = _ref3.ClassModel;
    var response;
    return regeneratorRuntime.wrap(function addClass$(_context7) {
        while (1) {
            switch (_context7.prev = _context7.next) {
                case 0:
                    _context7.next = 2;
                    return (0, _effects.call)(api.addClass, ClassModel);

                case 2:
                    response = _context7.sent;

                    if (!(response.status === 200)) {
                        _context7.next = 8;
                        break;
                    }

                    _context7.next = 6;
                    return (0, _effects.put)(actions.AddClassSuccess(response.data.userProfileId));

                case 6:
                    _context7.next = 17;
                    break;

                case 8:
                    if (!(response.status === 400 || response.status === 409)) {
                        _context7.next = 15;
                        break;
                    }

                    _context7.next = 11;
                    return (0, _effects.put)(actions.AddClassFailure(false, response.message));

                case 11:
                    _context7.next = 13;
                    return (0, _effects.put)((0, _actions2.showToast)(response.message, 'error'));

                case 13:
                    _context7.next = 17;
                    break;

                case 15:
                    _context7.next = 17;
                    return (0, _effects.put)(actions.AddClassFailure(true, ''));

                case 17:
                case 'end':
                    return _context7.stop();
            }
        }
    }, _marked7, this);
}

function addClassSaga() {
    return regeneratorRuntime.wrap(function addClassSaga$(_context8) {
        while (1) {
            switch (_context8.prev = _context8.next) {
                case 0:
                    _context8.next = 2;
                    return (0, _effects.takeLatest)(actions.ADD_CLASS_REQUEST, addClass);

                case 2:
                case 'end':
                    return _context8.stop();
            }
        }
    }, _marked8, this);
}

function downloadClassRoll(_ref4) {
    var classrooms = _ref4.classrooms;
    var classInfo, response, downloadUrl;
    return regeneratorRuntime.wrap(function downloadClassRoll$(_context9) {
        while (1) {
            switch (_context9.prev = _context9.next) {
                case 0:
                    classInfo = classrooms.map(function (classroom) {
                        return {
                            className: classroom.name,
                            yearGroupShortName: classroom.yearGroupShortName,
                            course: classroom.courseTitle,
                            upfCourse: classroom.upfCourseTitle,
                            conquestCourse: classroom.conquestCourseTitle,
                            assignedTeachersName: classroom.teachers.map(function (teacher) {
                                return teacher.name;
                            }),
                            studentsCount: classroom.studentsProfileId.length
                        };
                    });
                    _context9.next = 3;
                    return (0, _effects.call)(api.postClassesPriorDownload, classInfo);

                case 3:
                    response = _context9.sent;

                    if (!(response.status === 201)) {
                        _context9.next = 10;
                        break;
                    }

                    downloadUrl = response.verb.url + '/' + response.data;
                    _context9.next = 8;
                    return (0, _effects.put)(actions.downloadClassRollSuccess(downloadUrl, true));

                case 8:
                    _context9.next = 12;
                    break;

                case 10:
                    _context9.next = 12;
                    return (0, _effects.put)(actions.downloadClassRollFailure(true));

                case 12:
                case 'end':
                    return _context9.stop();
            }
        }
    }, _marked9, this);
}

function downloadClassRollSaga() {
    return regeneratorRuntime.wrap(function downloadClassRollSaga$(_context10) {
        while (1) {
            switch (_context10.prev = _context10.next) {
                case 0:
                    _context10.next = 2;
                    return (0, _effects.takeLatest)(actions.DOWNLOAD_CLASS_ROLL_REQUEST, downloadClassRoll);

                case 2:
                case 'end':
                    return _context10.stop();
            }
        }
    }, _marked10, this);
}

function getSchoolCourses(_ref5) {
    var yearGroup = _ref5.yearGroup;
    var request, response;
    return regeneratorRuntime.wrap(function getSchoolCourses$(_context11) {
        while (1) {
            switch (_context11.prev = _context11.next) {
                case 0:
                    request = { yearGroup: yearGroup };
                    _context11.next = 3;
                    return (0, _effects.call)(api.getSchoolCourses, request);

                case 3:
                    response = _context11.sent;

                    if (!(response.status === 200)) {
                        _context11.next = 9;
                        break;
                    }

                    _context11.next = 7;
                    return (0, _effects.put)(actions.getSchoolCoursesSuccess(response.data));

                case 7:
                    _context11.next = 11;
                    break;

                case 9:
                    _context11.next = 11;
                    return (0, _effects.put)(actions.getSchoolCoursesFailure());

                case 11:
                case 'end':
                    return _context11.stop();
            }
        }
    }, _marked11, this);
}

function getSchoolCoursesSaga() {
    return regeneratorRuntime.wrap(function getSchoolCoursesSaga$(_context12) {
        while (1) {
            switch (_context12.prev = _context12.next) {
                case 0:
                    _context12.next = 2;
                    return (0, _effects.takeLatest)(actions.GET_SCHOOL_COURSES_REQUEST, getSchoolCourses);

                case 2:
                case 'end':
                    return _context12.stop();
            }
        }
    }, _marked12, this);
}

function deleteClassrooms(_ref6) {
    var selectedClassroomIds = _ref6.selectedClassroomIds;
    var ids, response;
    return regeneratorRuntime.wrap(function deleteClassrooms$(_context13) {
        while (1) {
            switch (_context13.prev = _context13.next) {
                case 0:
                    ids = { classroomIds: selectedClassroomIds };
                    _context13.next = 3;
                    return (0, _effects.call)(api.deleteClassrooms, ids);

                case 3:
                    response = _context13.sent;
                    _context13.next = 6;
                    return (0, _effects.put)(actions.closeDeleteClassroomsConfirmation());

                case 6:
                    if (!(response.status === 200)) {
                        _context13.next = 13;
                        break;
                    }

                    _context13.next = 9;
                    return (0, _effects.put)(actions.openDeleteClassroomsSuccess());

                case 9:
                    _context13.next = 11;
                    return (0, _effects.put)(actions.deleteClassroomsSuccess(response));

                case 11:
                    _context13.next = 24;
                    break;

                case 13:
                    if (!(response.status === 400 || response.status === 409)) {
                        _context13.next = 20;
                        break;
                    }

                    _context13.next = 16;
                    return (0, _effects.put)(actions.deleteClassroomsFailure(response.message));

                case 16:
                    _context13.next = 18;
                    return (0, _effects.put)((0, _actions2.showToast)(response.message, 'error'));

                case 18:
                    _context13.next = 24;
                    break;

                case 20:
                    _context13.next = 22;
                    return (0, _effects.put)(actions.deleteClassroomsFailure());

                case 22:
                    _context13.next = 24;
                    return (0, _effects.put)((0, _actions2.showToast)(response.message, 'error'));

                case 24:
                case 'end':
                    return _context13.stop();
            }
        }
    }, _marked13, this);
}

function deleteClassroomsSaga() {
    return regeneratorRuntime.wrap(function deleteClassroomsSaga$(_context14) {
        while (1) {
            switch (_context14.prev = _context14.next) {
                case 0:
                    _context14.next = 2;
                    return (0, _effects.takeLatest)(actions.DELETE_CLASSROOMS_REQUEST, deleteClassrooms);

                case 2:
                case 'end':
                    return _context14.stop();
            }
        }
    }, _marked14, this);
}

function getUPFCourses(_ref7) {
    var countryCode = _ref7.countryCode,
        productId = _ref7.productId,
        yearGroup = _ref7.yearGroup,
        selectGenericCourses = _ref7.selectGenericCourses,
        includeGlobalCourses = _ref7.includeGlobalCourses;
    var countriesRequest, response;
    return regeneratorRuntime.wrap(function getUPFCourses$(_context15) {
        while (1) {
            switch (_context15.prev = _context15.next) {
                case 0:
                    countriesRequest = { countryCode: countryCode, productId: productId, yearGroup: yearGroup, selectGenericCourses: selectGenericCourses, includeGlobalCourses: includeGlobalCourses };
                    _context15.next = 3;
                    return (0, _effects.call)(api.getFilteredCourses, countriesRequest);

                case 3:
                    response = _context15.sent;

                    if (!(response.status === 200)) {
                        _context15.next = 9;
                        break;
                    }

                    _context15.next = 7;
                    return (0, _effects.put)({
                        type: actions.GET_UPF_COURSES_SUCCESS,
                        data: response.data,
                        isProductCoursesLoaded: true,
                        isProductCoursesFetching: false
                    });

                case 7:
                    _context15.next = 11;
                    break;

                case 9:
                    _context15.next = 11;
                    return (0, _effects.put)({ type: actions.GET_UPF_COURSES_FAILURE, isProductCoursesLoaded: true, isProductCoursesFetching: false });

                case 11:
                case 'end':
                    return _context15.stop();
            }
        }
    }, _marked15, this);
}

function getUPFCoursesSaga() {
    return regeneratorRuntime.wrap(function getUPFCoursesSaga$(_context16) {
        while (1) {
            switch (_context16.prev = _context16.next) {
                case 0:
                    _context16.next = 2;
                    return (0, _effects.takeLatest)(actions.GET_UPF_COURSES, getUPFCourses);

                case 2:
                case 'end':
                    return _context16.stop();
            }
        }
    }, _marked16, this);
}

function getNewCourses(_ref8) {
    var productId = _ref8.productId,
        countryCode = _ref8.countryCode,
        yearGroup = _ref8.yearGroup;
    var request, response, sortedDataByName;
    return regeneratorRuntime.wrap(function getNewCourses$(_context17) {
        while (1) {
            switch (_context17.prev = _context17.next) {
                case 0:
                    request = { productId: productId, countryCode: countryCode, yearGroup: yearGroup };
                    _context17.next = 3;
                    return (0, _effects.call)(api.getConquestFilteredCourses, request);

                case 3:
                    response = _context17.sent;

                    if (!(response.status === 200)) {
                        _context17.next = 10;
                        break;
                    }

                    sortedDataByName = [].concat(_toConsumableArray(response.data)).sort(function (a, b) {
                        return a.name.toLowerCase() > b.name.toLowerCase() ? 1 : -1;
                    });
                    _context17.next = 8;
                    return (0, _effects.put)({
                        type: actions.GET_NEW_COURSES_SUCCESS,
                        data: sortedDataByName,
                        isProductCoursesLoaded: true,
                        isProductCoursesFetching: false
                    });

                case 8:
                    _context17.next = 12;
                    break;

                case 10:
                    _context17.next = 12;
                    return (0, _effects.put)({ type: actions.GET_NEW_COURSES_FAILURE, isProductCoursesLoaded: true, isProductCoursesFetching: false });

                case 12:
                case 'end':
                    return _context17.stop();
            }
        }
    }, _marked17, this);
}

function getNewCoursesSaga() {
    return regeneratorRuntime.wrap(function getNewCoursesSaga$(_context18) {
        while (1) {
            switch (_context18.prev = _context18.next) {
                case 0:
                    _context18.next = 2;
                    return (0, _effects.takeLatest)(actions.GET_NEW_COURSES_REQUEST, getNewCourses);

                case 2:
                case 'end':
                    return _context18.stop();
            }
        }
    }, _marked18, this);
}

/***/ }),
/* 822 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.default = function () {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
    var action = arguments[1];

    switch (action.type) {
        case actions.GET_DEFAULT_COURSE_SUCCESS:
            {
                return _extends({}, state, {
                    courses: (0, _utils.customDefaultCourses)(action.data.defaultCourses),
                    isDefaultCoursesLoaded: true,
                    onSuccessfulSave: false
                });
            }
        case actions.GET_DEFAULT_COURSE_FAILURE:
            {
                return _extends({}, state, { isDefaultCoursesLoaded: false });
            }
        case actions.SHOW_COURSE_DETAILS:
            {
                return _extends({}, state, { selectedCourseId: action.courseId });
            }
        case actions.HIDE_COURSE_DETAILS:
            {
                return _extends({}, state, { courseDetails: initialState.courseDetails, selectedCourseId: false, isCourseModalVisible: false });
            }
        case actions.FETCH_COURSE_DETAILS_REQUEST:
            {
                return _extends({}, state, { fetchingCourse: true });
            }
        case actions.FETCH_COURSE_DETAILS_SUCCESS:
            {
                return _extends({}, state, { courseDetails: action.courseDetails, fetchingCourse: false, isCourseModalVisible: true });
            }
        case actions.FETCH_COURSE_DETAILS_FAILURE:
            {
                return _extends({}, state, { fetchingCourse: false });
            }
        case actions.SAVE_DEFAULT_COURSE_REQUEST:
            {
                return _extends({}, state, { savingDefaultCourses: true });
            }
        case actions.SAVE_DEFAULT_COURSE_SUCCESS:
            {
                return _extends({}, state, {
                    savingDefaultCourses: action.savingDefaultCourses,
                    onSuccessfulSave: true,
                    isDefaultCoursesLoaded: false
                });
            }
        case actions.SAVE_DEFAULT_COURSE_FAILURE:
            {
                return _extends({}, state, { savingDefaultCourses: action.savingDefaultCourses, onSuccessfulSave: false });
            }

        default:
            return _extends({}, state);
    }
};

var _actions = __webpack_require__(395);

var actions = _interopRequireWildcard(_actions);

var _utils = __webpack_require__(13);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var initialState = {
    courses: [],
    courseDetails: {
        name: '',
        topics: []
    },
    isCourseModalVisible: false,
    isDefaultCoursesLoaded: false,
    selectedCourseId: false,
    savingDefaultCourses: false,
    onSuccessfulSave: false
};

/***/ }),
/* 823 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.getDefaultCourses = getDefaultCourses;
exports.getDefaultCoursesSaga = getDefaultCoursesSaga;
exports.fetchingCourseDetails = fetchingCourseDetails;
exports.fetchingCourseDetailsSaga = fetchingCourseDetailsSaga;
exports.showCourseDetails = showCourseDetails;
exports.showCourseDetailsSaga = showCourseDetailsSaga;
exports.saveDefaultCourses = saveDefaultCourses;
exports.saveDefaultCoursesSaga = saveDefaultCoursesSaga;

var _effects = __webpack_require__(32);

var _api = __webpack_require__(33);

var api = _interopRequireWildcard(_api);

var _actions = __webpack_require__(395);

var actions = _interopRequireWildcard(_actions);

var _product = __webpack_require__(194);

var _product2 = _interopRequireDefault(_product);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var _marked = /*#__PURE__*/regeneratorRuntime.mark(getDefaultCourses),
    _marked2 = /*#__PURE__*/regeneratorRuntime.mark(getDefaultCoursesSaga),
    _marked3 = /*#__PURE__*/regeneratorRuntime.mark(fetchingCourseDetails),
    _marked4 = /*#__PURE__*/regeneratorRuntime.mark(fetchingCourseDetailsSaga),
    _marked5 = /*#__PURE__*/regeneratorRuntime.mark(showCourseDetails),
    _marked6 = /*#__PURE__*/regeneratorRuntime.mark(showCourseDetailsSaga),
    _marked7 = /*#__PURE__*/regeneratorRuntime.mark(saveDefaultCourses),
    _marked8 = /*#__PURE__*/regeneratorRuntime.mark(saveDefaultCoursesSaga);

function getDefaultCourses() {
    var productId, payload;
    return regeneratorRuntime.wrap(function getDefaultCourses$(_context) {
        while (1) {
            switch (_context.prev = _context.next) {
                case 0:
                    _context.next = 2;
                    return (0, _effects.select)(_product2.default);

                case 2:
                    productId = _context.sent;
                    _context.next = 5;
                    return (0, _effects.call)(api.getDefaultCourses, { productId: productId });

                case 5:
                    payload = _context.sent;

                    if (!(payload.status === 200)) {
                        _context.next = 11;
                        break;
                    }

                    _context.next = 9;
                    return (0, _effects.put)(actions.getDefaultCoursesSuccess(payload.data));

                case 9:
                    _context.next = 13;
                    break;

                case 11:
                    _context.next = 13;
                    return (0, _effects.put)(actions.getDefaultCoursesFailure());

                case 13:
                case 'end':
                    return _context.stop();
            }
        }
    }, _marked, this);
}

function getDefaultCoursesSaga() {
    return regeneratorRuntime.wrap(function getDefaultCoursesSaga$(_context2) {
        while (1) {
            switch (_context2.prev = _context2.next) {
                case 0:
                    _context2.next = 2;
                    return (0, _effects.takeLatest)(actions.GET_DEFAULT_COURSE_REQUEST, getDefaultCourses);

                case 2:
                case 'end':
                    return _context2.stop();
            }
        }
    }, _marked2, this);
}

function fetchingCourseDetails() {
    var state, courseId, payload;
    return regeneratorRuntime.wrap(function fetchingCourseDetails$(_context3) {
        while (1) {
            switch (_context3.prev = _context3.next) {
                case 0:
                    _context3.next = 2;
                    return (0, _effects.select)();

                case 2:
                    state = _context3.sent;
                    courseId = state.defaultCourses.selectedCourseId;
                    _context3.next = 6;
                    return (0, _effects.call)(api.getCourse, { courseId: courseId });

                case 6:
                    payload = _context3.sent;

                    if (!(payload.status === 200)) {
                        _context3.next = 12;
                        break;
                    }

                    _context3.next = 10;
                    return (0, _effects.put)(actions.fetchCourseDetailsSuccess(payload.data));

                case 10:
                    _context3.next = 14;
                    break;

                case 12:
                    _context3.next = 14;
                    return (0, _effects.put)(actions.fetchCourseDetailsFailure());

                case 14:
                case 'end':
                    return _context3.stop();
            }
        }
    }, _marked3, this);
}

function fetchingCourseDetailsSaga() {
    return regeneratorRuntime.wrap(function fetchingCourseDetailsSaga$(_context4) {
        while (1) {
            switch (_context4.prev = _context4.next) {
                case 0:
                    _context4.next = 2;
                    return (0, _effects.takeLatest)(actions.FETCH_COURSE_DETAILS_REQUEST, fetchingCourseDetails);

                case 2:
                case 'end':
                    return _context4.stop();
            }
        }
    }, _marked4, this);
}

function showCourseDetails(_ref) {
    var courseId = _ref.courseId;
    return regeneratorRuntime.wrap(function showCourseDetails$(_context5) {
        while (1) {
            switch (_context5.prev = _context5.next) {
                case 0:
                    _context5.next = 2;
                    return (0, _effects.put)(actions.fetchCourseDetails(courseId));

                case 2:
                case 'end':
                    return _context5.stop();
            }
        }
    }, _marked5, this);
}

function showCourseDetailsSaga() {
    return regeneratorRuntime.wrap(function showCourseDetailsSaga$(_context6) {
        while (1) {
            switch (_context6.prev = _context6.next) {
                case 0:
                    _context6.next = 2;
                    return (0, _effects.takeLatest)(actions.SHOW_COURSE_DETAILS, showCourseDetails);

                case 2:
                case 'end':
                    return _context6.stop();
            }
        }
    }, _marked6, this);
}

function saveDefaultCourses(_ref2) {
    var yearGroupCourses = _ref2.yearGroupCourses;
    var productId, response;
    return regeneratorRuntime.wrap(function saveDefaultCourses$(_context7) {
        while (1) {
            switch (_context7.prev = _context7.next) {
                case 0:
                    _context7.next = 2;
                    return (0, _effects.select)(_product2.default);

                case 2:
                    productId = _context7.sent;
                    _context7.next = 5;
                    return (0, _effects.call)(api.saveSchoolDefaultCourses, productId, yearGroupCourses);

                case 5:
                    response = _context7.sent;

                    if (!(response.status === 200)) {
                        _context7.next = 11;
                        break;
                    }

                    _context7.next = 9;
                    return (0, _effects.put)(actions.saveDefaultCoursesSuccess(false));

                case 9:
                    _context7.next = 13;
                    break;

                case 11:
                    _context7.next = 13;
                    return (0, _effects.put)(actions.saveDefaultCoursesFailure(false));

                case 13:
                case 'end':
                    return _context7.stop();
            }
        }
    }, _marked7, this);
}

function saveDefaultCoursesSaga() {
    return regeneratorRuntime.wrap(function saveDefaultCoursesSaga$(_context8) {
        while (1) {
            switch (_context8.prev = _context8.next) {
                case 0:
                    _context8.next = 2;
                    return (0, _effects.takeLatest)(actions.SAVE_DEFAULT_COURSE_REQUEST, saveDefaultCourses);

                case 2:
                case 'end':
                    return _context8.stop();
            }
        }
    }, _marked8, this);
}

/***/ }),
/* 824 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = __webpack_require__(28);

var _redux = __webpack_require__(35);

var _reactIntl = __webpack_require__(2);

var _index = __webpack_require__(694);

var _index2 = _interopRequireDefault(_index);

var _actions = __webpack_require__(263);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var DownloadCertificatesContainer = function (_Component) {
    _inherits(DownloadCertificatesContainer, _Component);

    function DownloadCertificatesContainer() {
        _classCallCheck(this, DownloadCertificatesContainer);

        return _possibleConstructorReturn(this, (DownloadCertificatesContainer.__proto__ || Object.getPrototypeOf(DownloadCertificatesContainer)).apply(this, arguments));
    }

    _createClass(DownloadCertificatesContainer, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            this.props.downloadCertificatesSetup();
        }
    }, {
        key: 'render',
        value: function render() {
            return _react2.default.createElement(
                'div',
                null,
                _react2.default.createElement(_index2.default, _extends({}, this.props, {
                    loading: this.props.fetchingAcademicYear || this.props.fetchingSummary }))
            );
        }
    }]);

    return DownloadCertificatesContainer;
}(_react.Component);

DownloadCertificatesContainer.propTypes = {
    downloadCertificatesSetup: _propTypes2.default.func,
    fetchingAcademicYear: _propTypes2.default.bool,
    fetchingSummary: _propTypes2.default.bool
};

var mapStateToProps = function mapStateToProps(state) {
    return _extends({}, state.downloadCertificates, {
        classes: state.classRoll.classrooms,
        product: state.product,
        teachers: state.teacherRoll.teachers,
        yearGroups: state.schoolRoll.yearGroups
    });
};

function mapDispatchToProps(dispatch) {
    return (0, _redux.bindActionCreators)({
        downloadCertificates: _actions.downloadCertificates,
        downloadCertificatesSetup: _actions.downloadCertificatesSetup,
        onDatePickerChange: _actions.onDatePickerChange,
        setClassroomId: _actions.setClassroomId,
        setGroupId: _actions.setGroupId,
        setTeacherId: _actions.setTeacherId
    }, dispatch);
}

exports.default = (0, _reactIntl.injectIntl)((0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(DownloadCertificatesContainer));

/***/ }),
/* 825 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.default = function () {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initState;
    var action = arguments[1];

    switch (action.type) {
        case actions.DOWNLOAD_CERTIFICATES_REQUEST:
            {
                return _extends({}, state, {
                    isDownloading: true,
                    isDownloadSuccess: false,
                    isFail: false
                });
            }

        case actions.DOWNLOAD_CERTIFICATES_SUCCESS:
            {
                return _extends({}, state, {
                    isDownloading: false,
                    isDownloadSuccess: true,
                    isFail: false
                });
            }

        case actions.DOWNLOAD_CERTIFICATES_FAILURE:
            {
                return _extends({}, state, {
                    isDownloading: false,
                    isDownloadSuccess: false,
                    isFail: true
                });
            }

        case actions.SET_TEACHER_ID:
            {
                var newState = _extends({}, state, {
                    selectedClassroomId: _constants.EMPTY_VALUE,
                    selectedGroupId: _constants.EMPTY_VALUE,
                    selectedTeacherId: action.selectedTeacherId
                });
                return newState;
            }

        case actions.SET_CLASSROOM_ID:
            {
                var _newState = _extends({}, state, {
                    selectedClassroomId: action.selectedClassroomId,
                    selectedGroupId: _constants.EMPTY_VALUE
                });
                if (action.selectedClassroomId === _constants.EMPTY_VALUE) {
                    _newState.summary = defaultSummary;
                }
                return _newState;
            }

        case actions.SET_GROUP_ID:
            {
                var _newState2 = _extends({}, state, {
                    selectedGroupId: action.selectedGroupId
                });
                if (action.selectedGroupId === _constants.EMPTY_VALUE) {
                    _newState2.summary = defaultSummary;
                }
                return _newState2;
            }

        case actions.GET_CLASSROOM_GROUPS_REQUEST:
            {
                return _extends({}, state, {
                    fetchingClassroomGroups: true,
                    fetchingClassroomGroupsSuccess: false,
                    fetchingClassroomGroupsFail: false
                });
            }

        case actions.GET_CLASSROOM_GROUPS_SUCCESS:
            {
                return _extends({}, state, {
                    fetchingClassroomGroups: false,
                    fetchingClassroomGroupsSuccess: true,
                    fetchingClassroomGroupsFail: false,
                    classroomGroups: action.data
                });
            }

        case actions.GET_CLASSROOM_GROUPS_FAILURE:
            {
                return _extends({}, state, {
                    fetchingClassroomGroups: false,
                    fetchingClassroomGroupsSuccess: false,
                    fetchingClassroomGroupsFail: true
                });
            }

        case actions.CLEAR_CLASSROOM_GROUPS:
            {
                return _extends({}, state, {
                    classroomGroups: [],
                    selectedGroupId: _constants.EMPTY_VALUE
                });
            }

        case actions.GET_ACADEMIC_YEAR_REQUEST:
            {
                return _extends({}, state, {
                    fetchingAcademicYear: true,
                    fetchingAcademicYearSuccess: false,
                    fetchingAcademicYearFailed: false
                });
            }

        case actions.GET_ACADEMIC_YEAR_SUCCESS:
            {
                var _action$data = action.data,
                    oldStartDate = _action$data.startDate,
                    oldEndDate = _action$data.endDate;

                var startDate = (0, _moment2.default)(oldStartDate, _constants.DATE_TIME_TIMEZONE_FORMAT).format(_constants.SHORT_DATE_FORMAT);
                var endDate = (0, _moment2.default)(oldEndDate, _constants.DATE_TIME_TIMEZONE_FORMAT).format(_constants.SHORT_DATE_FORMAT);

                var academicYear = {
                    startDate: startDate,
                    endDate: endDate,
                    raw: action.data
                };

                var newCurrentDate = {
                    type: _constants.SELECTED_DATE_PICKER_VALUE_TYPE,
                    startDate: startDate,
                    endDate: endDate
                };

                return _extends({}, state, {
                    academicYear: academicYear,
                    currentDate: _extends({}, newCurrentDate),
                    fetchingAcademicYear: false,
                    fetchingAcademicYearSuccess: true,
                    fetchingAcademicYearFailed: false
                });
            }

        case actions.GET_ACADEMIC_YEAR_FAILURE:
            {
                return _extends({}, state, {
                    fetchingAcademicYear: false,
                    fetchingAcademicYearSuccess: false,
                    fetchingAcademicYearFailed: true
                });
            }

        case actions.GET_CERTIFICATES_SUMMARY_REQUEST:
            {
                return _extends({}, state, {
                    fetchingSummary: true,
                    fetchingSummarySuccess: false,
                    fetchingSummaryFailed: false
                });
            }

        case actions.GET_CERTIFICATES_SUMMARY_SUCCESS:
            {
                var _action$data2 = action.data,
                    goldCount = _action$data2.goldCount,
                    silverCount = _action$data2.silverCount,
                    bronzeCount = _action$data2.bronzeCount;

                var newTotalCount = goldCount + silverCount + bronzeCount;

                var newSummary = _extends({}, action.data, {
                    totalCount: newTotalCount
                });
                return _extends({}, state, {
                    summary: newSummary,
                    fetchingSummary: false,
                    fetchingSummarySuccess: true,
                    fetchingSummaryFailed: false
                });
            }

        case actions.GET_CERTIFICATES_SUMMARY_FAILURE:
            {
                return _extends({}, state, {
                    fetchingSummary: false,
                    fetchingSummarySuccess: false,
                    fetchingSummaryFailed: true
                });
            }

        case actions.ON_DATE_PICKER_CHANGE:
            {
                var _newCurrentDate = {
                    type: action.dateType,
                    startDate: action.startDate,
                    endDate: action.endDate
                };

                return _extends({}, state, {
                    currentDate: _newCurrentDate
                });
            }

        case actions.DOWNLOAD_CERTIFICATES_SETUP:
        default:
            return _extends({}, state);
    }
};

var _moment = __webpack_require__(17);

var _moment2 = _interopRequireDefault(_moment);

var _actions = __webpack_require__(263);

var actions = _interopRequireWildcard(_actions);

var _constants = __webpack_require__(155);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var defaultSummary = {
    goldCount: 0,
    silverCount: 0,
    bronzeCount: 0,
    totalCount: 0
};

var initState = {
    classroomGroups: [],
    academicYear: {
        startDate: null,
        endDate: null
    },
    currentDate: {
        type: _constants.SELECTED_DATE_PICKER_VALUE_TYPE,
        startDate: null,
        endDate: null
    },
    isDownloading: false,
    isDownloadSuccess: false,
    isFail: false,
    selectedTeacherId: _constants.EMPTY_VALUE,
    summary: defaultSummary
};

/***/ }),
/* 826 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.downloadCertificatesSetup = downloadCertificatesSetup;
exports.downloadCertificatesSetupSaga = downloadCertificatesSetupSaga;
exports.downloadCertificates = downloadCertificates;
exports.downloadCertificatesSaga = downloadCertificatesSaga;
exports.setTeacher = setTeacher;
exports.setTeacherSaga = setTeacherSaga;
exports.setClassroom = setClassroom;
exports.setClassroomSaga = setClassroomSaga;
exports.setGroup = setGroup;
exports.setGroupSaga = setGroupSaga;
exports.getClassroomGroups = getClassroomGroups;
exports.getClassroomGroupsSaga = getClassroomGroupsSaga;
exports.getAcademicYear = getAcademicYear;
exports.getAcademicYearSaga = getAcademicYearSaga;
exports.getCertificatesSummary = getCertificatesSummary;
exports.getCertificatesSummarySaga = getCertificatesSummarySaga;
exports.onDatePickerChange = onDatePickerChange;
exports.onDatePickerChangeSaga = onDatePickerChangeSaga;

var _effects = __webpack_require__(32);

var _moment = __webpack_require__(17);

var _moment2 = _interopRequireDefault(_moment);

var _api = __webpack_require__(33);

var api = _interopRequireWildcard(_api);

var _actions = __webpack_require__(263);

var actions = _interopRequireWildcard(_actions);

var _constants = __webpack_require__(155);

var _product = __webpack_require__(194);

var _product2 = _interopRequireDefault(_product);

var _actions2 = __webpack_require__(50);

var _actions3 = __webpack_require__(38);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _marked = /*#__PURE__*/regeneratorRuntime.mark(downloadCertificatesSetup),
    _marked2 = /*#__PURE__*/regeneratorRuntime.mark(downloadCertificatesSetupSaga),
    _marked3 = /*#__PURE__*/regeneratorRuntime.mark(downloadCertificates),
    _marked4 = /*#__PURE__*/regeneratorRuntime.mark(downloadCertificatesSaga),
    _marked5 = /*#__PURE__*/regeneratorRuntime.mark(setTeacher),
    _marked6 = /*#__PURE__*/regeneratorRuntime.mark(setTeacherSaga),
    _marked7 = /*#__PURE__*/regeneratorRuntime.mark(setClassroom),
    _marked8 = /*#__PURE__*/regeneratorRuntime.mark(setClassroomSaga),
    _marked9 = /*#__PURE__*/regeneratorRuntime.mark(setGroup),
    _marked10 = /*#__PURE__*/regeneratorRuntime.mark(setGroupSaga),
    _marked11 = /*#__PURE__*/regeneratorRuntime.mark(getClassroomGroups),
    _marked12 = /*#__PURE__*/regeneratorRuntime.mark(getClassroomGroupsSaga),
    _marked13 = /*#__PURE__*/regeneratorRuntime.mark(getAcademicYear),
    _marked14 = /*#__PURE__*/regeneratorRuntime.mark(getAcademicYearSaga),
    _marked15 = /*#__PURE__*/regeneratorRuntime.mark(getCertificatesSummary),
    _marked16 = /*#__PURE__*/regeneratorRuntime.mark(getCertificatesSummarySaga),
    _marked17 = /*#__PURE__*/regeneratorRuntime.mark(onDatePickerChange),
    _marked18 = /*#__PURE__*/regeneratorRuntime.mark(onDatePickerChangeSaga);

var requestDateFormat = function requestDateFormat(givenDate) {
    return (0, _moment2.default)(givenDate, _constants.DATE_TIME_TIMEZONE_FORMAT).format(_constants.REQUEST_DATE_FORMAT);
};
var getRequestsData = function getRequestsData(state) {
    var productId = (0, _product2.default)(state);
    var _state$downloadCertif = state.downloadCertificates,
        currentDate = _state$downloadCertif.currentDate,
        selectedClassroomId = _state$downloadCertif.selectedClassroomId,
        selectedGroupId = _state$downloadCertif.selectedGroupId,
        selectedTeacherId = _state$downloadCertif.selectedTeacherId;
    var oldStartDate = currentDate.startDate,
        oldEndDate = currentDate.endDate;


    var startDate = requestDateFormat(oldStartDate);
    var endDate = requestDateFormat(oldEndDate);

    var request = { productId: productId, startDate: startDate, endDate: endDate };

    if (selectedTeacherId !== undefined && selectedTeacherId !== _constants.EMPTY_VALUE) {
        request.teacherUserProfileId = selectedTeacherId;
    }

    if (selectedClassroomId !== undefined && selectedClassroomId !== _constants.EMPTY_VALUE) {
        request.classroomId = selectedClassroomId;
    }

    if (selectedGroupId !== undefined && selectedGroupId !== _constants.EMPTY_VALUE) {
        request.groupId = selectedGroupId;
    }

    return request;
};

function downloadCertificatesSetup() {
    var productId;
    return regeneratorRuntime.wrap(function downloadCertificatesSetup$(_context) {
        while (1) {
            switch (_context.prev = _context.next) {
                case 0:
                    _context.next = 2;
                    return (0, _effects.select)(_product2.default);

                case 2:
                    productId = _context.sent;
                    _context.next = 5;
                    return (0, _effects.put)((0, _actions2.getProductTeachers)(productId));

                case 5:
                    _context.next = 7;
                    return (0, _effects.put)((0, _actions3.getProductClassrooms)(productId));

                case 7:
                    _context.next = 9;
                    return (0, _effects.put)(actions.getAcademicYear());

                case 9:
                case 'end':
                    return _context.stop();
            }
        }
    }, _marked, this);
}

function downloadCertificatesSetupSaga() {
    return regeneratorRuntime.wrap(function downloadCertificatesSetupSaga$(_context2) {
        while (1) {
            switch (_context2.prev = _context2.next) {
                case 0:
                    _context2.next = 2;
                    return (0, _effects.takeLatest)(actions.DOWNLOAD_CERTIFICATES_SETUP, downloadCertificatesSetup);

                case 2:
                case 'end':
                    return _context2.stop();
            }
        }
    }, _marked2, this);
}
function downloadCertificates(_ref) {
    var certificateType = _ref.certificateType;
    var state, request, response, downloadUrl;
    return regeneratorRuntime.wrap(function downloadCertificates$(_context3) {
        while (1) {
            switch (_context3.prev = _context3.next) {
                case 0:
                    _context3.next = 2;
                    return (0, _effects.select)();

                case 2:
                    state = _context3.sent;
                    request = getRequestsData(state);

                    if (certificateType) {
                        request.type = certificateType;
                    }
                    response = {};
                    _context3.next = 8;
                    return (0, _effects.call)(api.downloadCertificates, _extends({}, request));

                case 8:
                    response = _context3.sent;

                    if (!(response.status === 201)) {
                        _context3.next = 15;
                        break;
                    }

                    downloadUrl = response.verb.url + '/' + response.data;
                    _context3.next = 13;
                    return (0, _effects.put)(actions.downloadCertificatesSuccess(downloadUrl, true));

                case 13:
                    _context3.next = 17;
                    break;

                case 15:
                    _context3.next = 17;
                    return (0, _effects.put)(actions.downloadCertificatesFailure(false));

                case 17:
                case 'end':
                    return _context3.stop();
            }
        }
    }, _marked3, this);
}

function downloadCertificatesSaga() {
    return regeneratorRuntime.wrap(function downloadCertificatesSaga$(_context4) {
        while (1) {
            switch (_context4.prev = _context4.next) {
                case 0:
                    _context4.next = 2;
                    return (0, _effects.takeLatest)(actions.DOWNLOAD_CERTIFICATES_REQUEST, downloadCertificates);

                case 2:
                case 'end':
                    return _context4.stop();
            }
        }
    }, _marked4, this);
}

function setTeacher() {
    return regeneratorRuntime.wrap(function setTeacher$(_context5) {
        while (1) {
            switch (_context5.prev = _context5.next) {
                case 0:
                    _context5.next = 2;
                    return (0, _effects.put)(actions.getCertificatesSummary());

                case 2:
                case 'end':
                    return _context5.stop();
            }
        }
    }, _marked5, this);
}

function setTeacherSaga() {
    return regeneratorRuntime.wrap(function setTeacherSaga$(_context6) {
        while (1) {
            switch (_context6.prev = _context6.next) {
                case 0:
                    _context6.next = 2;
                    return (0, _effects.takeLatest)(actions.SET_TEACHER_ID, setTeacher);

                case 2:
                case 'end':
                    return _context6.stop();
            }
        }
    }, _marked6, this);
}

function setClassroom() {
    var state, selectedClassroomId;
    return regeneratorRuntime.wrap(function setClassroom$(_context7) {
        while (1) {
            switch (_context7.prev = _context7.next) {
                case 0:
                    _context7.next = 2;
                    return (0, _effects.select)();

                case 2:
                    state = _context7.sent;
                    selectedClassroomId = state.downloadCertificates.selectedClassroomId;

                    if (!(selectedClassroomId !== _constants.EMPTY_VALUE)) {
                        _context7.next = 9;
                        break;
                    }

                    _context7.next = 7;
                    return (0, _effects.put)(actions.getClassroomGroups());

                case 7:
                    _context7.next = 11;
                    break;

                case 9:
                    _context7.next = 11;
                    return (0, _effects.put)(actions.clearClassroomGroups());

                case 11:
                    _context7.next = 13;
                    return (0, _effects.put)(actions.getCertificatesSummary());

                case 13:
                case 'end':
                    return _context7.stop();
            }
        }
    }, _marked7, this);
}

function setClassroomSaga() {
    return regeneratorRuntime.wrap(function setClassroomSaga$(_context8) {
        while (1) {
            switch (_context8.prev = _context8.next) {
                case 0:
                    _context8.next = 2;
                    return (0, _effects.takeLatest)(actions.SET_CLASSROOM_ID, setClassroom);

                case 2:
                case 'end':
                    return _context8.stop();
            }
        }
    }, _marked8, this);
}

function setGroup() {
    return regeneratorRuntime.wrap(function setGroup$(_context9) {
        while (1) {
            switch (_context9.prev = _context9.next) {
                case 0:
                    _context9.next = 2;
                    return (0, _effects.put)(actions.getCertificatesSummary());

                case 2:
                case 'end':
                    return _context9.stop();
            }
        }
    }, _marked9, this);
}

function setGroupSaga() {
    return regeneratorRuntime.wrap(function setGroupSaga$(_context10) {
        while (1) {
            switch (_context10.prev = _context10.next) {
                case 0:
                    _context10.next = 2;
                    return (0, _effects.takeLatest)(actions.SET_GROUP_ID, setGroup);

                case 2:
                case 'end':
                    return _context10.stop();
            }
        }
    }, _marked10, this);
}

function getClassroomGroups() {
    var state, selectedClassroomId, payload;
    return regeneratorRuntime.wrap(function getClassroomGroups$(_context11) {
        while (1) {
            switch (_context11.prev = _context11.next) {
                case 0:
                    _context11.next = 2;
                    return (0, _effects.select)();

                case 2:
                    state = _context11.sent;
                    selectedClassroomId = state.downloadCertificates.selectedClassroomId;
                    _context11.next = 6;
                    return (0, _effects.call)(api.getClassroomGroups, selectedClassroomId);

                case 6:
                    payload = _context11.sent;

                    if (!(payload.status === 200)) {
                        _context11.next = 12;
                        break;
                    }

                    _context11.next = 10;
                    return (0, _effects.put)(actions.getClassroomGroupsSuccess(payload));

                case 10:
                    _context11.next = 14;
                    break;

                case 12:
                    _context11.next = 14;
                    return (0, _effects.put)(actions.getClassroomGroupsFailure());

                case 14:
                case 'end':
                    return _context11.stop();
            }
        }
    }, _marked11, this);
}

function getClassroomGroupsSaga() {
    return regeneratorRuntime.wrap(function getClassroomGroupsSaga$(_context12) {
        while (1) {
            switch (_context12.prev = _context12.next) {
                case 0:
                    _context12.next = 2;
                    return (0, _effects.takeLatest)(actions.GET_CLASSROOM_GROUPS_REQUEST, getClassroomGroups);

                case 2:
                case 'end':
                    return _context12.stop();
            }
        }
    }, _marked12, this);
}

function getAcademicYear() {
    var payload;
    return regeneratorRuntime.wrap(function getAcademicYear$(_context13) {
        while (1) {
            switch (_context13.prev = _context13.next) {
                case 0:
                    _context13.next = 2;
                    return (0, _effects.call)(api.getAcademicYear);

                case 2:
                    payload = _context13.sent;

                    if (!(payload.status === 200)) {
                        _context13.next = 8;
                        break;
                    }

                    _context13.next = 6;
                    return (0, _effects.put)(actions.getAcademicYearSuccess(payload));

                case 6:
                    _context13.next = 10;
                    break;

                case 8:
                    _context13.next = 10;
                    return (0, _effects.put)(actions.getAcademicYearFailure());

                case 10:
                case 'end':
                    return _context13.stop();
            }
        }
    }, _marked13, this);
}

function getAcademicYearSaga() {
    return regeneratorRuntime.wrap(function getAcademicYearSaga$(_context14) {
        while (1) {
            switch (_context14.prev = _context14.next) {
                case 0:
                    _context14.next = 2;
                    return (0, _effects.takeLatest)(actions.GET_ACADEMIC_YEAR_REQUEST, getAcademicYear);

                case 2:
                case 'end':
                    return _context14.stop();
            }
        }
    }, _marked14, this);
}

function getCertificatesSummary() {
    var state, request, payload;
    return regeneratorRuntime.wrap(function getCertificatesSummary$(_context15) {
        while (1) {
            switch (_context15.prev = _context15.next) {
                case 0:
                    _context15.next = 2;
                    return (0, _effects.select)();

                case 2:
                    state = _context15.sent;
                    request = getRequestsData(state);
                    _context15.next = 6;
                    return (0, _effects.call)(api.getCertificatesSummary, request);

                case 6:
                    payload = _context15.sent;

                    if (!(payload.status === 200)) {
                        _context15.next = 12;
                        break;
                    }

                    _context15.next = 10;
                    return (0, _effects.put)(actions.getCertificatesSummarySuccess(payload));

                case 10:
                    _context15.next = 14;
                    break;

                case 12:
                    _context15.next = 14;
                    return (0, _effects.put)(actions.getCertificatesSummaryFailure());

                case 14:
                case 'end':
                    return _context15.stop();
            }
        }
    }, _marked15, this);
}

function getCertificatesSummarySaga() {
    return regeneratorRuntime.wrap(function getCertificatesSummarySaga$(_context16) {
        while (1) {
            switch (_context16.prev = _context16.next) {
                case 0:
                    _context16.next = 2;
                    return (0, _effects.takeLatest)(actions.GET_ACADEMIC_YEAR_SUCCESS, getCertificatesSummary);

                case 2:
                    _context16.next = 4;
                    return (0, _effects.takeLatest)(actions.GET_CERTIFICATES_SUMMARY_REQUEST, getCertificatesSummary);

                case 4:
                case 'end':
                    return _context16.stop();
            }
        }
    }, _marked16, this);
}

function onDatePickerChange() {
    return regeneratorRuntime.wrap(function onDatePickerChange$(_context17) {
        while (1) {
            switch (_context17.prev = _context17.next) {
                case 0:
                    _context17.next = 2;
                    return (0, _effects.put)(actions.getCertificatesSummary());

                case 2:
                case 'end':
                    return _context17.stop();
            }
        }
    }, _marked17, this);
}

function onDatePickerChangeSaga() {
    return regeneratorRuntime.wrap(function onDatePickerChangeSaga$(_context18) {
        while (1) {
            switch (_context18.prev = _context18.next) {
                case 0:
                    _context18.next = 2;
                    return (0, _effects.takeLatest)(actions.ON_DATE_PICKER_CHANGE, onDatePickerChange);

                case 2:
                case 'end':
                    return _context18.stop();
            }
        }
    }, _marked18, this);
}

/***/ }),
/* 827 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var editClassEnum = function editClassEnum() {
    _classCallCheck(this, editClassEnum);
};

editClassEnum.FALLBACK_ID = -1;
exports.default = editClassEnum;

/***/ }),
/* 828 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __webpack_require__(28);

var _redux = __webpack_require__(35);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _editClassForm = __webpack_require__(698);

var _editClassForm2 = _interopRequireDefault(_editClassForm);

var _portalComms = __webpack_require__(55);

var _portalComms2 = _interopRequireDefault(_portalComms);

var _actions = __webpack_require__(106);

var _actions2 = __webpack_require__(38);

var _actions3 = __webpack_require__(50);

var _actions4 = __webpack_require__(44);

var _selectors = __webpack_require__(831);

var _selectors2 = __webpack_require__(861);

var _constants = __webpack_require__(827);

var _constants2 = _interopRequireDefault(_constants);

var _utils = __webpack_require__(13);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var EditClass = function (_Component) {
    _inherits(EditClass, _Component);

    function EditClass(props) {
        _classCallCheck(this, EditClass);

        var _this = _possibleConstructorReturn(this, (EditClass.__proto__ || Object.getPrototypeOf(EditClass)).call(this, props));

        _this.getClassYearGroups = function () {
            var result = [];
            _this.props.yearGroups.map(function (val) {
                if (Number(val.key) !== -1) {
                    result.push(val);
                }
                return false;
            });
            return result;
        };

        _this.validateClassModel = function (className) {
            if (className.trim() !== '') {
                _this.setState({ canSubmit: true });
            } else {
                _this.setState({ canSubmit: false });
            }
        };

        _this.handleOnCloseEditClass = function () {
            _this.props.updateSearchTerm('');
            _this.props.clearFilterValue();
            _this.context.router.history.push('/classes');
            if (_this.state.refreshListOnCancel) {
                _this.props.closeEditClass();
            }
        };

        _this.handleOnDownloadStudentSignInCards = function (format) {
            var _this$props = _this.props,
                selectedProduct = _this$props.selectedProduct,
                match = _this$props.match;

            _this.props.downloadStudentSignInCardsRequest(selectedProduct.id, match.params.classroomId, format);
        };

        _this.handleOnClassNameChange = function (event) {
            _this.setState({ className: event.target.value });
            _this.validateClassModel(event.target.value);
            return true;
        };

        _this.handleOnCloseRenameGroupModal = function () {
            _this.props.hideRenameGroup();
            _this.props.closeEditGroup();
        };

        _this.handleOnCancelRenameGroupModal = function () {
            _this.props.hideRenameGroup();
        };

        _this.handleOnShowRenameGroupModal = function () {
            _this.props.showRenameGroup();
        };

        _this.handleOnConfirmRenameGroup = function (newGroupName) {
            _this.newGroupName = newGroupName;
            _this.props.openRenameGroupConfirmationBeforeSubmit();
        };

        _this.handleOnCancelRenameGroupConfirmationBeforeSubmit = function () {
            _this.props.closeRenameGroupConfirmationBeforeSubmit();
        };

        _this.handleOnCloseRenameGroupConfirmation = function () {
            _this.props.closeRenameGroupConfirmation();
        };

        _this.handleOnRenameClassroomGroup = function () {
            _this.props.renameClassroomGroup(_this.props.selectedGroup.classroomId, _this.props.selectedGroup.id, _this.newGroupName);
        };

        _this.handleOnYearGroupChange = function (name, value) {
            _this.setState({ yearGroup: value });
            _this.validateClassModel(_this.state.className);
        };

        _this.handleOnDownloadTeacherSignInCards = function (teacherId) {
            var selectedProduct = _this.props.selectedProduct;

            _this.props.printTeacherSignInCard(selectedProduct.id, teacherId);
        };

        _this.handleOnTeacherUnassign = function (teacherId) {
            _this.setState({ showModal: true, teacherId: teacherId });
            _this.props.openUnAssignTeachersModal();
        };

        _this.teachersOperationSuccessConfirmation = function () {
            _this.setState({ refreshListOnCancel: true });
            var _this$props2 = _this.props,
                selectedProduct = _this$props2.selectedProduct,
                match = _this$props2.match;

            _this.handleOnCloseModal();
            _this.props.getProductClassrooms(selectedProduct.id);
            _this.props.getProductTeachers(selectedProduct.id);
            _this.props.closeTeachersOperationConfirmationModal();
            _this.props.getClassByClassroomId(selectedProduct.id, match.params.classroomId);
        };

        _this.handleOnCloseModal = function () {
            _this.setState({ showModal: false });
        };

        _this.handleOnUnassignConfirm = function () {
            var _this$props3 = _this.props,
                classroomDetail = _this$props3.classroomDetail,
                selectedProduct = _this$props3.selectedProduct;

            var selectedTeachers = [];
            selectedTeachers.push(_this.state.teacherId);
            _this.props.unassignTeachers(classroomDetail.classroomId, selectedTeachers, selectedProduct.id);
        };

        _this.handleOnPrintTeacherSignInCard = function (teacherId) {
            _this.downloadingTeachersIds.add(teacherId);
            _this.props.printClassroomTeacherSignInCard(teacherId, _this.props.selectedProduct.id, _this.downloadingTeachersIds, 'QR_3X3');
        };

        _this.handleOnDeleteGroup = function () {
            _this.props.deleteGroup(_this.props.selectedGroup.classroomId, _this.props.selectedGroup.id);
        };

        _this.handleOnDeleteNonEmptyGroup = function () {
            _this.props.closeDeleteNonEmptyGroupConfirmation();
        };

        _this.handleOnAssignTeacher = function () {
            var assignType = 'teacherToClass';
            _this.context.router.history.push('/assign-user/' + _this.props.match.params.classroomId + '/' + assignType);
        };

        _this.handleOnCancelDeleteGroupConfirmationBeforeSubmit = function () {
            _this.props.closeDeleteGroupConfirmationBeforeSubmit();
        };

        _this.handleOnCloseDeleteGroupConfirmation = function () {
            _this.props.closeDeleteGroupConfirmation();
        };

        _this.handleOnDeleteGroupRequest = function () {
            if (_this.props.selectedGroup.studentIds.length > 0) {
                _this.props.openDeleteNonEmptyGroupConfirmation();
            } else {
                _this.props.openDeleteGroupConfirmationBeforeSubmit();
            }
        };

        _this.handleOnCloseDeleteGroupModal = function () {
            _this.props.closeDeleteGroupConfirmationBeforeSubmit();
            _this.props.closeEditGroup();
        };

        _this.handleOnManageStudents = function (classId, classroomName, groupId) {
            _this.props.getStudentByClassroomIdRequest(classId);
            _this.props.closeEditGroup();
            var config = (0, _utils.getAppConfig)();
            var moduleId = config ? config.ModuleIdStudentMgmt : _constants2.default.FALLBACK_ID;
            var sourceModuleId = config ? config.ModuleIdSchoolRoll : _constants2.default.FALLBACK_ID;
            _portalComms2.default.requestModuleChange({ classId: classId, moduleId: moduleId, classroomName: classroomName, groupId: groupId, sourceModuleId: sourceModuleId });
        };

        _this.handleOnManageStudentsBeforeDeleteGroup = function (classroomId, classroomName, groupId) {
            _this.handleOnDeleteNonEmptyGroup();
            _this.handleOnManageStudents(classroomId, classroomName, groupId);
        };

        _this.handleOnStudentSignInCards = function () {
            _this.props.showHideSignInCardModalRequest(true);
        };

        _this.handleOnCancelStudentSignInCards = function () {
            _this.props.showHideSignInCardModalRequest(false);
        };

        _this.state = {
            addGroupIsActive: true,
            className: props.classroomDetail.name,
            canSubmit: false,
            yearGroup: '' + props.classroomDetail.yearGroupEnum,
            refreshListOnCancel: false
        };

        _this.newGroupName = '';

        _this.handleOnCloseEditClass = _this.handleOnCloseEditClass.bind(_this);
        _this.handleOnCloseDeleteGroupModal = _this.handleOnCloseDeleteGroupModal.bind(_this);
        _this.handleOnDownloadStudentSignInCards = _this.handleOnDownloadStudentSignInCards.bind(_this);
        _this.handleOnClassNameChange = _this.handleOnClassNameChange.bind(_this);
        _this.handleOnSaveClass = _this.handleOnSaveClass.bind(_this);
        _this.handleOnYearGroupChange = _this.handleOnYearGroupChange.bind(_this);
        _this.handleOnTeacherUnassign = _this.handleOnTeacherUnassign.bind(_this);
        _this.handleOnUnassignConfirm = _this.handleOnUnassignConfirm.bind(_this);
        _this.handleOnCloseModal = _this.handleOnCloseModal.bind(_this);
        _this.handleOnPrintTeacherSignInCard = _this.handleOnPrintTeacherSignInCard.bind(_this);
        _this.getClassYearGroups = _this.getClassYearGroups.bind(_this);
        _this.handleOnDeleteGroupRequest = _this.handleOnDeleteGroupRequest.bind(_this);
        _this.handleOnManageStudents = _this.handleOnManageStudents.bind(_this);
        _this.handleOnManageStudentsBeforeDeleteGroup = _this.handleOnManageStudentsBeforeDeleteGroup.bind(_this);
        _this.downloadingTeachersIds = new Set();
        _this.displayNewCourses = (0, _utils.displayNewCourses)();
        return _this;
    }

    _createClass(EditClass, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            var _props = this.props,
                selectedProduct = _props.selectedProduct,
                match = _props.match,
                yearGroups = _props.yearGroups;

            this.props.getClassByClassroomId(selectedProduct.id, match.params.classroomId);

            if (yearGroups.length <= 1) {
                this.props.getYearGroups();
            }
        }
    }, {
        key: 'componentWillReceiveProps',
        value: function componentWillReceiveProps(nextProps) {
            if (nextProps.isUpdateSuccessful && nextProps.isSavingClass !== this.props.isSavingClass) {
                this.handleOnCloseEditClass();
            }

            if (nextProps.classroomDetail.name !== this.props.classroomDetail.name || nextProps.classroomDetail.yearGroupShortName !== this.props.classroomDetail.yearGroupShortName) {
                this.setState({
                    className: nextProps.classroomDetail.name.trim(),
                    yearGroup: '' + nextProps.classroomDetail.yearGroupEnum
                });
            }

            if (nextProps.refreshEditClass && nextProps.refreshEditClass !== this.props.refreshEditClass) {
                this.props.getClassByClassroomId(this.props.selectedProduct.id, this.props.match.params.classroomId);
            }

            if (nextProps.isDownloadingSignInCards !== this.props.isDownloadingSignInCards) {
                setTimeout(this.props.showHideSignInCardModalRequest(false), 1000);
            }
        }
    }, {
        key: 'handleOnSaveClass',
        value: function handleOnSaveClass() {
            var match = this.props.match;

            this.props.saveModifiedClass(match.params.classroomId, this.state.className, this.state.yearGroup);
        }
    }, {
        key: 'render',
        value: function render() {
            return _react2.default.createElement(_editClassForm2.default, _extends({
                canSubmit: this.state.canSubmit,
                className: this.state.className,
                downloadStudentSignInCards: this.handleOnDownloadStudentSignInCards,
                downloadTeacherSignInCards: this.handleOnDownloadTeacherSignInCards,
                handleDeleteNonEmptyGroup: this.handleDeleteNonEmptyGroup,
                handleOnAssignTeacher: this.handleOnAssignTeacher,
                handleOnCancelDeleteGroupConfirmationBeforeSubmit: this.handleOnCancelDeleteGroupConfirmationBeforeSubmit,
                handleOnCancelRenameGroupConfirmationBeforeSubmit: this.handleOnCancelRenameGroupConfirmationBeforeSubmit,
                handleOnCancelRenameGroupModal: this.handleOnCancelRenameGroupModal,
                handleOnClassNameChange: this.handleOnClassNameChange,
                handleOnCloseDeleteGroupConfirmation: this.handleOnCloseDeleteGroupConfirmation,
                handleOnCloseDeleteGroupModal: this.handleOnCloseDeleteGroupModal,
                handleOnCloseEditClass: this.handleOnCloseEditClass,
                handleOnCloseModal: this.handleOnCloseModal,
                handleOnCloseRenameGroupConfirmation: this.handleOnCloseRenameGroupConfirmation,
                handleOnCloseRenameGroupModal: this.handleOnCloseRenameGroupModal,
                handleOnDeleteGroup: this.handleOnDeleteGroup,
                handleOnDeleteGroupRequest: this.handleOnDeleteGroupRequest,
                handleOnDeleteNonEmptyGroup: this.handleOnDeleteNonEmptyGroup,
                handleOnManageStudents: this.handleOnManageStudents,
                handleOnManageStudentsBeforeDeleteGroup: this.handleOnManageStudentsBeforeDeleteGroup,
                handleOnOkRenameGroup: this.handleOnConfirmRenameGroup,
                handleOnPrintTeacherSignInCard: this.handleOnPrintTeacherSignInCard,
                handleOnRenameGroup: this.handleOnRenameClassroomGroup,
                handleOnSaveClass: this.handleOnSaveClass,
                handleOnShowRenameGroupModal: this.handleOnShowRenameGroupModal,
                handleOnTeacherUnassign: this.handleOnTeacherUnassign,
                handleOnUnassignConfirm: this.handleOnUnassignConfirm,
                handleOnYearGroupChange: this.handleOnYearGroupChange,
                isLoading: this.props.disableConfirmationButtons,
                showModal: this.state.showModal,
                teachersOperationSuccessConfirmation: this.teachersOperationSuccessConfirmation,
                yearGroup: this.state.yearGroup
            }, this.props, {
                displayNewCourses: this.displayNewCourses,
                handleOnCancelStudentSignInCards: this.handleOnCancelStudentSignInCards,
                handleOnStudentSignInCards: this.handleOnStudentSignInCards,
                yearGroups: this.getClassYearGroups()
            }));
        }
    }]);

    return EditClass;
}(_react.Component);

EditClass.contextTypes = {
    router: _propTypes2.default.object.isRequired
};


EditClass.propTypes = {
    getClassByClassroomId: _propTypes2.default.func,
    match: _propTypes2.default.object.isRequired,
    selectedProduct: _propTypes2.default.object,
    isLoadingEditClassDetail: _propTypes2.default.bool,
    classroomDetail: _propTypes2.default.object,
    yearGroups: _propTypes2.default.arrayOf(_propTypes2.default.object),
    downloadStudentSignInCardsRequest: _propTypes2.default.func,
    isDownloadingSignInCards: _propTypes2.default.bool,
    selectedGroup: _propTypes2.default.object,
    renameClassroomGroup: _propTypes2.default.func,
    handleOnRenameGroup: _propTypes2.default.func,
    handleOnCloseRenameGroupModal: _propTypes2.default.func,
    handleOnCloseDeleteGroupModal: _propTypes2.default.func,
    isRenameGroupInProgress: _propTypes2.default.bool,
    handleOnShowRenameGroupModal: _propTypes2.default.func,
    handleOnCloseValidationModal: _propTypes2.default.func,
    showRenameGroup: _propTypes2.default.func,
    hideRenameGroup: _propTypes2.default.func,
    handleOnOkRenameGroup: _propTypes2.default.func,
    openRenameGroupConfirmationBeforeSubmit: _propTypes2.default.func,
    closeRenameGroupConfirmationBeforeSubmit: _propTypes2.default.func,
    saveModifiedClass: _propTypes2.default.func,
    getYearGroups: _propTypes2.default.func,
    closeRenameGroupConfirmation: _propTypes2.default.func,
    printTeacherSignInCard: _propTypes2.default.func,
    openUnAssignTeachersModal: _propTypes2.default.func,
    closeTeachersOperationConfirmationModal: _propTypes2.default.func,
    unassignTeachers: _propTypes2.default.func,
    isUserOperationModalOpen: _propTypes2.default.bool,
    disableConfirmationButtons: _propTypes2.default.bool,
    isSavingClass: _propTypes2.default.bool,
    printClassroomTeacherSignInCard: _propTypes2.default.func,
    downloadingTeachersIds: _propTypes2.default.object,
    isUpdateSuccessful: _propTypes2.default.bool,
    deleteGroup: _propTypes2.default.func,
    hideEditClassGroup: _propTypes2.default.func,
    refreshEditClass: _propTypes2.default.bool,
    showDeleteNonEmptyGroupConfirmationModal: _propTypes2.default.bool,
    showDeleteGroupConfirmation: _propTypes2.default.bool,
    showDeleteGroupConfirmationBeforeSubmit: _propTypes2.default.bool,
    openDeleteNonEmptyGroupConfirmation: _propTypes2.default.func,
    closeDeleteNonEmptyGroupConfirmation: _propTypes2.default.func,
    openDeleteGroupConfirmationBeforeSubmit: _propTypes2.default.func,
    closeDeleteGroupConfirmation: _propTypes2.default.func,
    closeDeleteGroupConfirmationBeforeSubmit: _propTypes2.default.func,
    openChangeCourse: _propTypes2.default.func,
    changeCourseIsActive: _propTypes2.default.bool,
    closeEditClass: _propTypes2.default.func,
    getStudentByClassroomIdRequest: _propTypes2.default.func,
    clearFilterValue: _propTypes2.default.func,
    updateSearchTerm: _propTypes2.default.func,
    closeEditGroup: _propTypes2.default.func,
    getProductTeachers: _propTypes2.default.func,
    getProductClassrooms: _propTypes2.default.func,
    showHideSignInCardModalRequest: _propTypes2.default.func,
    showHideSignInCardModal: _propTypes2.default.bool
};

var mapStateToProps = function mapStateToProps(state) {
    return {
        addGroupIsActive: state.editClass.addGroupIsActive,
        addGroupInProgress: state.editClass.addGroupInProgress,
        addGroupIsSuccess: state.editClass.addGroupIsSuccess,
        addGroupAddedGroup: state.editClass.addGroupAddedGroup,
        addGroupExceedGroupError: state.editClass.addGroupExceedGroupError,
        changeCourseIsActive: state.editClass.changeCourseIsActive,
        changeCourseClassroomId: state.editClass.changeCourseClassroomId,
        changeCourseGroupId: state.editClass.changeCourseGroupId,
        classroomDetail: (0, _selectors.getClassroomDetail)(state),
        disableConfirmationButtons: (0, _selectors.getDisableConfirmationButtons)(state),
        editClassGroupIsVisible: (0, _selectors.getEditClassGroupVisibility)(state),
        isSelectedGroupDefault: (0, _selectors.getSelectedGroupIsDefault)(state),
        isDownloadingSignInCards: (0, _selectors.getIsDownloadingSignInCards)(state),
        isLoadingEditClassDetail: (0, _selectors.getIsLoadingEditClassDetail)(state),
        isSavingClass: (0, _selectors.getIsSavingClass)(state),
        selectedGroup: (0, _selectors.getSelectedGroup)(state),
        selectedProduct: (0, _selectors2.getProduct)(state),
        showRenameGroupModal: state.editClass.showRenameGroupModal,
        showRenameGroupConfirmationModal: state.editClass.showRenameGroupConfirmationModal,
        isRenameGroupInProgress: state.editClass.isRenameGroupInProgress,
        showRenameGroupConfirmationBeforeSubmit: state.editClass.showRenameGroupConfirmationBeforeSubmit,
        isUserOperationModalOpen: state.editClass.isUserOperationModalOpen,
        downloadingTeachersIds: state.editClass.downloadingTeachersIds,
        isUpdateSuccessful: state.editClass.isUpdateSuccessful,
        editClassValidationMessage: state.editClass.editClassValidationMessage,
        yearGroups: state.studentRoll.dataFilterOption.yearGroups,
        isDeletingGroupInProgress: state.editClass.isDeletingGroupInProgress,
        showDeleteNonEmptyGroupConfirmationModal: state.editClass.showDeleteNonEmptyGroupConfirmationModal,
        showDeleteGroupConfirmation: state.editClass.showDeleteGroupConfirmation,
        showDeleteGroupConfirmationBeforeSubmit: state.editClass.showDeleteGroupConfirmationBeforeSubmit,
        refreshEditClass: state.editClass.refreshEditClass,
        showHideSignInCardModal: state.classRoll.showHideSignInCardModal
    };
};

function mapDispatchToProps(dispatch) {
    return (0, _redux.bindActionCreators)({
        downloadStudentSignInCardsRequest: _actions.downloadStudentSignInCardsRequest,
        getClassByClassroomId: _actions.getClassByClassroomId,
        hideEditClassGroup: _actions.hideEditClassGroup,
        showRenameGroup: _actions.showRenameGroup,
        hideRenameGroup: _actions.hideRenameGroup,
        openRenameGroupConfirmationBeforeSubmit: _actions.openRenameGroupConfirmationBeforeSubmit,
        closeRenameGroupConfirmationBeforeSubmit: _actions.closeRenameGroupConfirmationBeforeSubmit,
        renameClassroomGroup: _actions.renameClassroomGroup,
        showEditClassGroup: _actions.showEditClassGroup,
        saveModifiedClass: _actions.saveModifiedClass,
        getYearGroups: _actions4.getYearGroups,
        closeRenameGroupConfirmation: _actions.closeRenameGroupConfirmation,
        printTeacherSignInCard: _actions.printTeacherSignInCard,
        openUnAssignTeachersModal: _actions.openUnAssignTeachersModal,
        closeTeachersOperationConfirmationModal: _actions.closeTeachersOperationConfirmationModal,
        handleOnCloseValidationModal: _actions.handleOnCloseValidationModal,
        unassignTeachers: _actions.unassignTeachers,
        openChangeCourse: _actions.openChangeCourse,
        printClassroomTeacherSignInCard: _actions.printClassroomTeacherSignInCard,
        deleteGroup: _actions.deleteGroup,
        openDeleteNonEmptyGroupConfirmation: _actions.openDeleteNonEmptyGroupConfirmation,
        closeDeleteNonEmptyGroupConfirmation: _actions.closeDeleteNonEmptyGroupConfirmation,
        openDeleteGroupConfirmationBeforeSubmit: _actions.openDeleteGroupConfirmationBeforeSubmit,
        closeDeleteGroupConfirmation: _actions.closeDeleteGroupConfirmation,
        closeDeleteGroupConfirmationBeforeSubmit: _actions.closeDeleteGroupConfirmationBeforeSubmit,
        closeEditClass: _actions.closeEditClass,
        openAddGroup: _actions.openAddGroup,
        closeAddGroup: _actions.closeAddGroup,
        addGroup: _actions.addGroup,
        getStudentByClassroomIdRequest: _actions2.getStudentByClassroomIdRequest,
        closeEditGroup: _actions.closeEditGroup,
        clearFilterValue: _actions2.clearFilterValue,
        updateSearchTerm: _actions2.updateSearchTerm,
        getProductClassrooms: _actions2.getProductClassrooms,
        getProductTeachers: _actions3.getProductTeachers,
        showHideSignInCardModalRequest: _actions2.showHideSignInCardModalRequest
    }, dispatch);
}

exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(EditClass);

/***/ }),
/* 829 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _actions = __webpack_require__(106);

var actions = _interopRequireWildcard(_actions);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var assignEmptyClassObject = function assignEmptyClassObject() {
    return {
        classroomGroups: [],
        name: '',
        studentsProfileId: [],
        teachersName: [],
        teachersProfileId: []
    };
};

var initialState = {
    addGroupIsActive: false,
    addGroupIsSuccess: false,
    addGroupInProgress: false,
    addGroupAddedGroup: {},
    classroomDetail: assignEmptyClassObject(),
    isLoadingEditClassDetail: false,
    isDownloadingSignInCards: false,
    editClassGroupIsVisible: false,
    selectedGroup: {
        classroomId: 0,
        courseId: 0,
        courseTitle: '',
        id: 0,
        isDefault: false,
        isTaskVisible: false,
        name: 'Default Group',
        studentIds: []
    },
    isSelectedGroupDefault: false,
    showRenameGroupModal: false,
    showRenameGroupConfirmationModal: false,
    isRenameGroupInProgress: false,
    showRenameGroupConfirmationBeforeSubmit: false,
    showDeleteGroupConfirmation: false,
    showDeleteGroupConfirmationBeforeSubmit: false,
    showDeleteNonEmptyGroupConfirmationModal: false,
    isSavingClass: false,
    isUserOperationModalOpen: false,
    disableConfirmationButtons: false,
    isSignInCardDownloaded: false,
    downloadingTeachersIds: new Set(),
    isUpdateSuccessful: true,
    editClassValidationMessage: '',
    isDeletingGroupInProgress: false,
    refreshEditClass: false,
    operationType: '',
    refreshTeacherList: false,
    selectedTeachers: [],
    changeCourseAssignedTasks: [],
    changeCourseIsActive: false,
    changeCourseTaskActionType: false,
    countryYearGroups: []
};

function editClassReducer() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
    var action = arguments[1];

    switch (action.type) {
        case actions.GET_CLASS_REQUEST:
            {
                return _extends({}, state, { isLoadingEditClassDetail: action.isLoadingEditClassDetail });
            }

        case actions.GET_CLASS_SUCCESS:
            {
                return _extends({}, state, {
                    classroomDetail: action.data,
                    isLoadingEditClassDetail: action.isLoadingEditClassDetail
                });
            }

        case actions.GET_CLASS_FAILURE:
            {
                return _extends({}, state, { isLoadingEditClassDetail: action.isLoadingEditClassDetail });
            }

        case actions.DOWNLOAD_STUDENT_SIGN_IN_CARDS_REQUEST:
            {
                return _extends({}, state, { isDownloadingSignInCards: action.isDownloadingSignInCards });
            }

        case actions.DOWNLOAD_STUDENT_SIGN_IN_CARDS_SUCCESS:
            {
                return _extends({}, state, { isDownloadingSignInCards: action.isDownloadingSignInCards });
            }

        case actions.DOWNLOAD_STUDENT_SIGN_IN_CARDS_FAILURE:
            {
                return _extends({}, state, { isDownloadingSignInCards: action.isDownloadingSignInCards });
            }

        case actions.RENAME_GROUP_REQUEST:
            {
                return _extends({}, state, { isRenameGroupInProgress: action.isRenameGroupInProgress });
            }

        case actions.RENAME_GROUP_SUCCESS:
            {
                return _extends({}, state, {
                    isRenameGroupInProgress: action.isRenameGroupInProgress,
                    showRenameGroupConfirmationModal: action.showRenameGroupConfirmationModal,
                    showRenameGroupConfirmationBeforeSubmit: action.showRenameGroupConfirmationBeforeSubmit
                });
            }

        case actions.RENAME_GROUP_FAILURE:
            {
                return _extends({}, state, {
                    isRenameGroupInProgress: action.isRenameGroupInProgress,
                    showRenameGroupConfirmationBeforeSubmit: action.showRenameGroupConfirmationBeforeSubmit

                });
            }

        case actions.SHOW_EDIT_CLASS_GROUP:
            {
                return _extends({}, state, { editClassGroupIsVisible: true, selectedGroup: action.selectedGroup });
            }

        case actions.HIDE_EDIT_CLASS_GROUP:
            {
                return _extends({}, state, { editClassGroupIsVisible: false, selectedGroup: null });
            }

        case actions.CLOSE_EDIT_GROUP:
            {
                return _extends({}, state, { editClassGroupIsVisible: false });
            }

        case actions.SHOW_RENAME_GROUP_MODAL:
            {
                return _extends({}, state, {
                    showRenameGroupModal: action.showRenameGroupModal
                });
            }

        case actions.HIDE_RENAME_GROUP_MODAL:
            {
                return _extends({}, state, { showRenameGroupModal: action.showRenameGroupModal
                });
            }

        case actions.OPEN_RENAME_GROUP_CONFIRMATION_BEFORE_SUBMIT:
            {
                return _extends({}, state, {
                    showRenameGroupConfirmationBeforeSubmit: action.showRenameGroupConfirmationBeforeSubmit,
                    refreshEditClass: action.refreshEditClass
                });
            }
        case actions.CLOSE_RENAME_GROUP_CONFIRMATION_BEFORE_SUBMIT:
            {
                return _extends({}, state, {
                    showRenameGroupConfirmationBeforeSubmit: action.showRenameGroupConfirmationBeforeSubmit
                });
            }

        case actions.CLOSE_RENAME_GROUP_CONFIRMATION:
            {
                return _extends({}, state, {
                    showRenameGroupConfirmationModal: action.showRenameGroupConfirmationModal,
                    showRenameGroupModal: action.showRenameGroupModal,
                    editClassGroupIsVisible: action.editClassGroupIsVisible,
                    refreshEditClass: action.refreshEditClass,
                    selectedGroup: action.selectedGroup
                });
            }

        case actions.MODIFIED_CLASS_SAVE_REQUEST:
            {
                return _extends({}, state, {
                    isSavingClass: action.isSavingClass,
                    isUpdateSuccessful: action.isUpdateSuccessful
                });
            }

        case actions.MODIFIED_CLASS_SAVE_SUCCESS:
            {
                return _extends({}, state, {
                    isSavingClass: action.isSavingClass,
                    isUpdateSuccessful: action.isUpdateSuccessful
                });
            }

        case actions.MODIFIED_CLASS_SAVE_FAILURE:
            {
                return _extends({}, state, {
                    isSavingClass: action.isSavingClass,
                    editClassValidationMessage: action.editClassValidationMessage,
                    isUpdateSuccessful: action.isUpdateSuccessful
                });
            }

        case actions.OPEN_UNASSIGN_TEACHERS_MODAL:
            {
                return _extends({}, state, { isUserOperationModalOpen: action.isUserOperationModalOpen, operationType: action.operationType });
            }
        case actions.CLOSE_TEACHERS_OPERATION_CONFIRMATION_MODAL:
            {
                return _extends({}, state, { refreshTeacherList: action.refreshTeacherList, selectedTeachers: action.selectedTeachers });
            }

        case actions.UNASSIGN_TEACHER_REQUEST:
            {
                return _extends({}, state, {
                    disableConfirmationButtons: action.disableConfirmationButtons,
                    selectedTeachers: [] });
            }
        case actions.UNASSIGN_TEACHER_SUCCESS:
            {
                return _extends({}, state, {
                    isUserOperationModalOpen: action.isUserOperationModalOpen,
                    disableConfirmationButtons: action.disableConfirmationButtons,
                    selectedTeachers: []
                });
            }
        case actions.UNASSIGN_TEACHER_FAILURE:
            {
                return _extends({}, state, { disableConfirmationButtons: action.disableConfirmationButtons });
            }
        case actions.PRINT_CLASSROOM_TEACHERS_SIGN_IN_CARD_REQUEST:
            {
                return _extends({}, state, { downloadingTeachersIds: action.downloadingTeachersIds });
            }
        case actions.PRINT_CLASSROOM_TEACHERS_SIGN_IN_CARD_SUCCESS:
            {
                return _extends({}, state, { downloadingTeachersIds: action.downloadingTeachersIds });
            }
        case actions.PRINT_CLASSROOM_TEACHERS_SIGN_IN_CARD_FAILURE:
            {
                return _extends({}, state, { downloadingTeachersIds: action.downloadingTeachersIds });
            }

        case actions.CLOSE_CLASS_VALIDATION_MODAL:
            {
                return _extends({}, state, { isUpdateSuccessful: action.isUpdateSuccessful });
            }
        case actions.DELETE_GROUP_REQUEST:
            {
                return _extends({}, state, {
                    isDeletingGroupInProgress: action.isDeletingGroupInProgress,
                    refreshEditClass: action.refreshEditClass
                });
            }
        case actions.DELETE_GROUP_SUCCESS:
            {
                return _extends({}, state, {
                    isDeletingGroupInProgress: action.isDeletingGroupInProgress,
                    showDeleteGroupConfirmationBeforeSubmit: action.showDeleteGroupConfirmationBeforeSubmit,
                    showDeleteGroupConfirmation: action.showDeleteGroupConfirmation
                });
            }
        case actions.DELETE_GROUP_FAILURE:
            {
                return _extends({}, state, {
                    isDeletingGroupInProgress: action.isDeletingGroupInProgress,
                    refreshEditClass: action.refreshEditClass,
                    showDeleteGroupConfirmationBeforeSubmit: action.showDeleteGroupConfirmationBeforeSubmit
                });
            }
        case actions.OPEN_DELETE_GROUP_CONFIRMATION_BEFORE_SUBMIT:
        case actions.CLOSE_DELETE_GROUP_CONFIRMATION_BEFORE_SUBMIT:
            {
                return _extends({}, state, {
                    showDeleteGroupConfirmationBeforeSubmit: action.showDeleteGroupConfirmationBeforeSubmit
                });
            }
        case actions.OPEN_DELETE_NON_EMPTY_GROUP_CONFIRMATION:
        case actions.CLOSE_DELETE_NON_EMPTY_GROUP_CONFIRMATION:
            {
                return _extends({}, state, {
                    showDeleteNonEmptyGroupConfirmationModal: action.showDeleteNonEmptyGroupConfirmationModal
                });
            }
        case actions.CLOSE_DELETE_GROUP_CONFIRMATION:
            {
                return _extends({}, state, {
                    refreshEditClass: action.refreshEditClass,
                    editClassGroupIsVisible: action.editClassGroupIsVisible,
                    showDeleteGroupConfirmation: action.showDeleteGroupConfirmation
                });
            }
        case actions.OPEN_CHANGE_COURSE:
            {
                return _extends({}, state, {
                    changeCourseIsActive: true,
                    changeCourseClassroomId: action.classroomId,
                    changeCourseGroupId: action.groupId,
                    changeCourseActivitiesIsActive: false,
                    changeCourseAssignedTasks: [],
                    changeCourseTaskActionType: ''
                });
            }

        case actions.CLOSE_CHANGE_COURSE:
            {
                return _extends({}, state, {
                    changeCourseIsActive: false,
                    isChangingCourseSuccess: false,
                    editClassGroupIsVisible: false,
                    refreshEditClass: true
                });
            }

        case actions.BACK_TO_CHANGE_COURSE:
            {
                return _extends({}, state, {
                    changeCourseActivitiesIsActive: false,
                    changeCourseIsActive: true,
                    isChangingCourseSuccess: false,
                    editClassGroupIsVisible: false,
                    changeCourseAssignedTasks: [],
                    changeCourseTaskActionType: ''
                });
            }

        case actions.CHANGE_COURSE_SUCCESS:
            {
                var changeCourseActivitiesIsActive = action.data.assignedTasksId.length > 0;
                return _extends({}, state, {
                    isChangingCourseSuccess: !changeCourseActivitiesIsActive,
                    isChangingCourseInProgress: false,
                    editClassGroupIsVisible: true,
                    assignedCourseId: action.assignedCourseId,
                    assignedUpfCourseId: action.assignedUpfCourseId,
                    assignedNewCourseId: action.assignedNewCourseId,
                    changeCourseClassroomId: action.classroomId,
                    changeCourseGroupId: action.groupId,
                    changeCourseSubmittedFields: action.submittedFields,
                    changeCourseAssignedTasks: action.data.assignedTasksId,
                    changeCourseActivitiesIsActive: changeCourseActivitiesIsActive
                });
            }
        case actions.CHANGE_COURSE_REQUEST:
            {
                return _extends({}, state, {
                    isChangingCourseSuccess: false,
                    isChangingCourseInProgress: true,
                    refreshEditClass: false
                });
            }

        case actions.CHANGE_COURSE_FAILURE:
            {
                return _extends({}, state, {
                    isChangingCourseSuccess: false,
                    isChangingCourseInProgress: false,
                    refreshEditClass: false
                });
            }

        case actions.CHANGE_COURSE_CARRY_OVER_REQUEST:
            {
                return _extends({}, state, {
                    isChangingCourseCarryOverSuccess: false,
                    isChangingCourseCarryOverInProgress: true,
                    refreshEditClass: false,
                    changeCourseTaskActionType: action.taskActionType
                });
            }

        case actions.CHANGE_COURSE_CARRY_OVER_SUCCESS:
            {
                return _extends({}, state, {
                    changeCourseActivitiesIsActive: false,
                    isChangingCourseSuccess: true,
                    isChangingCourseCarryOverSuccess: true,
                    isChangingCourseCarryOverInProgress: false,
                    refreshEditClass: true,
                    editClassGroupIsVisible: true
                });
            }

        case actions.CHANGE_COURSE_CARRY_OVER_FAILURE:
            {
                return _extends({}, state, {
                    isChangingCourseCarryOverSuccess: false,
                    isChangingCourseCarryOverInProgress: false,
                    refreshEditClass: false
                });
            }

        case actions.OPEN_ADD_GROUP:
            {
                return _extends({}, state, {
                    addGroupIsActive: true
                });
            }

        case actions.CLOSE_ADD_GROUP:
            {
                return _extends({}, state, {
                    addGroupIsActive: false,
                    addGroupInProgress: false,
                    addGroupIsSuccess: false,
                    addGroupExceedGroupError: false
                });
            }

        case actions.ADD_GROUP_REQUEST:
            {
                return _extends({}, state, {
                    addGroupInProgress: true,
                    addGroupIsSuccess: false,
                    refreshEditClass: false
                });
            }

        case actions.ADD_GROUP_SUCCESS:
            {
                return _extends({}, state, {
                    addGroupInProgress: false,
                    addGroupIsSuccess: true,
                    refreshEditClass: true,
                    addGroupAddedGroup: action.data
                });
            }

        case actions.ADD_GROUP_FAILURE:
            {
                return _extends({}, state, {
                    addGroupInProgress: false,
                    addGroupIsSuccess: false,
                    addGroupExceedGroupError: action.addGroupErrorCode === 'MaxGroupInClassExceeded'
                });
            }

        case actions.HANDLE_COUNTRY_DROPDOWN_CHANGES:
            {
                return _extends({}, state, {
                    fetchingYeargroups: true,
                    fetchedYeargroups: false
                });
            }

        case actions.GET_YEARGROUPS_BY_COUNTRY_SUCCESS:
            {
                return _extends({}, state, {
                    fetchingYeargroups: false,
                    fetchedYeargroups: true,
                    countryYearGroups: action.data
                });
            }

        case actions.GET_YEARGROUPS_BY_COUNTRY_FAILURE:
            {
                return _extends({}, state, {
                    fetchingYeargroups: false,
                    fetchedYeargroups: false
                });
            }

        default:
            return _extends({}, state);
    }
}

exports.default = editClassReducer;

/***/ }),
/* 830 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.renameClassroomGroup = renameClassroomGroup;
exports.renameClassroomGroupSaga = renameClassroomGroupSaga;
exports.getClassByClassroomId = getClassByClassroomId;
exports.getClassByClassroomIdSaga = getClassByClassroomIdSaga;
exports.downloadStudentSignInCards = downloadStudentSignInCards;
exports.downloadStudentSignInCardsSaga = downloadStudentSignInCardsSaga;
exports.saveModifiedClass = saveModifiedClass;
exports.saveModifiedClassSaga = saveModifiedClassSaga;
exports.downloadTeacherSignInCards = downloadTeacherSignInCards;
exports.downloadTeachersSignInCardSaga = downloadTeachersSignInCardSaga;
exports.unassignTeacher = unassignTeacher;
exports.unassignTeacherSaga = unassignTeacherSaga;
exports.deleteClassroomGroup = deleteClassroomGroup;
exports.deleteClassroomGroupSaga = deleteClassroomGroupSaga;
exports.changeClassroomCourse = changeClassroomCourse;
exports.changeClassroomCourseSaga = changeClassroomCourseSaga;
exports.addGroup = addGroup;
exports.addGroupSaga = addGroupSaga;
exports.changeCourseCarryOver = changeCourseCarryOver;
exports.changeCourseCarryOverSaga = changeCourseCarryOverSaga;
exports.handleCountryDropdownChanges = handleCountryDropdownChanges;
exports.handleCountryDropdownChangesSaga = handleCountryDropdownChangesSaga;

var _effects = __webpack_require__(32);

var _api = __webpack_require__(33);

var api = _interopRequireWildcard(_api);

var _actions = __webpack_require__(106);

var actions = _interopRequireWildcard(_actions);

var _actions2 = __webpack_require__(154);

var _actions3 = __webpack_require__(65);

var _constants = __webpack_require__(96);

var _constants2 = _interopRequireDefault(_constants);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var _marked = /*#__PURE__*/regeneratorRuntime.mark(renameClassroomGroup),
    _marked2 = /*#__PURE__*/regeneratorRuntime.mark(renameClassroomGroupSaga),
    _marked3 = /*#__PURE__*/regeneratorRuntime.mark(getClassByClassroomId),
    _marked4 = /*#__PURE__*/regeneratorRuntime.mark(getClassByClassroomIdSaga),
    _marked5 = /*#__PURE__*/regeneratorRuntime.mark(downloadStudentSignInCards),
    _marked6 = /*#__PURE__*/regeneratorRuntime.mark(downloadStudentSignInCardsSaga),
    _marked7 = /*#__PURE__*/regeneratorRuntime.mark(saveModifiedClass),
    _marked8 = /*#__PURE__*/regeneratorRuntime.mark(saveModifiedClassSaga),
    _marked9 = /*#__PURE__*/regeneratorRuntime.mark(downloadTeacherSignInCards),
    _marked10 = /*#__PURE__*/regeneratorRuntime.mark(downloadTeachersSignInCardSaga),
    _marked11 = /*#__PURE__*/regeneratorRuntime.mark(unassignTeacher),
    _marked12 = /*#__PURE__*/regeneratorRuntime.mark(unassignTeacherSaga),
    _marked13 = /*#__PURE__*/regeneratorRuntime.mark(deleteClassroomGroup),
    _marked14 = /*#__PURE__*/regeneratorRuntime.mark(deleteClassroomGroupSaga),
    _marked15 = /*#__PURE__*/regeneratorRuntime.mark(changeClassroomCourse),
    _marked16 = /*#__PURE__*/regeneratorRuntime.mark(changeClassroomCourseSaga),
    _marked17 = /*#__PURE__*/regeneratorRuntime.mark(addGroup),
    _marked18 = /*#__PURE__*/regeneratorRuntime.mark(addGroupSaga),
    _marked19 = /*#__PURE__*/regeneratorRuntime.mark(changeCourseCarryOver),
    _marked20 = /*#__PURE__*/regeneratorRuntime.mark(changeCourseCarryOverSaga),
    _marked21 = /*#__PURE__*/regeneratorRuntime.mark(handleCountryDropdownChanges),
    _marked22 = /*#__PURE__*/regeneratorRuntime.mark(handleCountryDropdownChangesSaga);

function renameClassroomGroup(_ref) {
    var classroomId = _ref.classroomId,
        groupId = _ref.groupId,
        newGroupName = _ref.newGroupName;
    var response;
    return regeneratorRuntime.wrap(function renameClassroomGroup$(_context) {
        while (1) {
            switch (_context.prev = _context.next) {
                case 0:
                    _context.next = 2;
                    return (0, _effects.call)(api.updateClassroomGroup, newGroupName, classroomId, groupId);

                case 2:
                    response = _context.sent;

                    if (!(response.status === 200)) {
                        _context.next = 8;
                        break;
                    }

                    _context.next = 6;
                    return (0, _effects.put)(actions.renameClassroomGroupSuccess());

                case 6:
                    _context.next = 19;
                    break;

                case 8:
                    if (!(response.status === 400 || response.status === 409)) {
                        _context.next = 15;
                        break;
                    }

                    _context.next = 11;
                    return (0, _effects.put)(actions.renameClassroomGroupFailure(response.message));

                case 11:
                    _context.next = 13;
                    return (0, _effects.put)((0, _actions3.showToast)(response.message, 'error'));

                case 13:
                    _context.next = 19;
                    break;

                case 15:
                    _context.next = 17;
                    return (0, _effects.put)(actions.renameClassroomGroupFailure());

                case 17:
                    _context.next = 19;
                    return (0, _effects.put)((0, _actions3.showToast)(response.message, 'error'));

                case 19:
                case 'end':
                    return _context.stop();
            }
        }
    }, _marked, this);
}

function renameClassroomGroupSaga() {
    return regeneratorRuntime.wrap(function renameClassroomGroupSaga$(_context2) {
        while (1) {
            switch (_context2.prev = _context2.next) {
                case 0:
                    _context2.next = 2;
                    return (0, _effects.takeLatest)(actions.RENAME_GROUP_REQUEST, renameClassroomGroup);

                case 2:
                case 'end':
                    return _context2.stop();
            }
        }
    }, _marked2, this);
}

function getClassByClassroomId(_ref2) {
    var classroomId = _ref2.classroomId;
    var payload;
    return regeneratorRuntime.wrap(function getClassByClassroomId$(_context3) {
        while (1) {
            switch (_context3.prev = _context3.next) {
                case 0:
                    _context3.next = 2;
                    return (0, _effects.call)(api.getClassroomById, classroomId);

                case 2:
                    payload = _context3.sent;

                    if (!(payload.status === 200)) {
                        _context3.next = 8;
                        break;
                    }

                    _context3.next = 6;
                    return (0, _effects.put)(actions.getClassSuccess(payload));

                case 6:
                    _context3.next = 10;
                    break;

                case 8:
                    _context3.next = 10;
                    return (0, _effects.put)(actions.getClassFailure());

                case 10:
                case 'end':
                    return _context3.stop();
            }
        }
    }, _marked3, this);
}

function getClassByClassroomIdSaga() {
    return regeneratorRuntime.wrap(function getClassByClassroomIdSaga$(_context4) {
        while (1) {
            switch (_context4.prev = _context4.next) {
                case 0:
                    _context4.next = 2;
                    return (0, _effects.takeLatest)(actions.GET_CLASS_REQUEST, getClassByClassroomId);

                case 2:
                case 'end':
                    return _context4.stop();
            }
        }
    }, _marked4, this);
}

function downloadStudentSignInCards(_ref3) {
    var productId = _ref3.productId,
        classroomId = _ref3.classroomId,
        SignInCardPageSizeType = _ref3.SignInCardPageSizeType;
    var response, downloadUrl;
    return regeneratorRuntime.wrap(function downloadStudentSignInCards$(_context5) {
        while (1) {
            switch (_context5.prev = _context5.next) {
                case 0:
                    _context5.next = 2;
                    return (0, _effects.call)(api.downloadClassroomStudentsSignInCards, { productId: productId, classroomId: classroomId, SignInCardPageSizeType: SignInCardPageSizeType });

                case 2:
                    response = _context5.sent;

                    if (!(response.status === 201)) {
                        _context5.next = 9;
                        break;
                    }

                    downloadUrl = response.verb.url + '/' + response.data;
                    _context5.next = 7;
                    return (0, _effects.put)(actions.downloadStudentSignInCardsSuccess(downloadUrl));

                case 7:
                    _context5.next = 11;
                    break;

                case 9:
                    _context5.next = 11;
                    return (0, _effects.put)(actions.downloadStudentSignInCardsFailure());

                case 11:
                case 'end':
                    return _context5.stop();
            }
        }
    }, _marked5, this);
}

function downloadStudentSignInCardsSaga() {
    return regeneratorRuntime.wrap(function downloadStudentSignInCardsSaga$(_context6) {
        while (1) {
            switch (_context6.prev = _context6.next) {
                case 0:
                    _context6.next = 2;
                    return (0, _effects.takeLatest)(actions.DOWNLOAD_STUDENT_SIGN_IN_CARDS_REQUEST, downloadStudentSignInCards);

                case 2:
                case 'end':
                    return _context6.stop();
            }
        }
    }, _marked6, this);
}

function saveModifiedClass(_ref4) {
    var classroomId = _ref4.classroomId,
        newClassroomName = _ref4.newClassroomName,
        newYearGroup = _ref4.newYearGroup;
    var response;
    return regeneratorRuntime.wrap(function saveModifiedClass$(_context7) {
        while (1) {
            switch (_context7.prev = _context7.next) {
                case 0:
                    _context7.next = 2;
                    return (0, _effects.call)(api.updateClass, { classroomId: classroomId, newClassroomName: newClassroomName, newYearGroup: newYearGroup });

                case 2:
                    response = _context7.sent;

                    if (!(response.status === 200)) {
                        _context7.next = 8;
                        break;
                    }

                    _context7.next = 6;
                    return (0, _effects.put)(actions.saveModifiedClassSuccess());

                case 6:
                    _context7.next = 19;
                    break;

                case 8:
                    if (!(response.status === 400 || response.status === 409)) {
                        _context7.next = 15;
                        break;
                    }

                    _context7.next = 11;
                    return (0, _effects.put)(actions.saveModifiedClassFailure(response.message));

                case 11:
                    _context7.next = 13;
                    return (0, _effects.put)((0, _actions3.showToast)(response.message, 'error'));

                case 13:
                    _context7.next = 19;
                    break;

                case 15:
                    _context7.next = 17;
                    return (0, _effects.put)(actions.saveModifiedClassFailure(''));

                case 17:
                    _context7.next = 19;
                    return (0, _effects.put)((0, _actions3.showToast)(response.message, 'error'));

                case 19:
                case 'end':
                    return _context7.stop();
            }
        }
    }, _marked7, this);
}

function saveModifiedClassSaga() {
    return regeneratorRuntime.wrap(function saveModifiedClassSaga$(_context8) {
        while (1) {
            switch (_context8.prev = _context8.next) {
                case 0:
                    _context8.next = 2;
                    return (0, _effects.takeLatest)(actions.MODIFIED_CLASS_SAVE_REQUEST, saveModifiedClass);

                case 2:
                case 'end':
                    return _context8.stop();
            }
        }
    }, _marked8, this);
}

function downloadTeacherSignInCards(_ref5) {
    var teacherId = _ref5.teacherId,
        productId = _ref5.productId,
        downloadingTeachersIds = _ref5.downloadingTeachersIds,
        format = _ref5.format;
    var teacherSignInCardsData, response, downloadUrl;
    return regeneratorRuntime.wrap(function downloadTeacherSignInCards$(_context9) {
        while (1) {
            switch (_context9.prev = _context9.next) {
                case 0:
                    teacherSignInCardsData = { teacherUserProfileIds: [teacherId], SignInCardPageSizeType: format };
                    _context9.next = 3;
                    return (0, _effects.call)(api.downloadTeachersSignInCards, productId, teacherSignInCardsData);

                case 3:
                    response = _context9.sent;

                    if (!(response.status === 201)) {
                        _context9.next = 10;
                        break;
                    }

                    downloadUrl = response.verb.url + '/' + response.data;
                    _context9.next = 8;
                    return (0, _effects.put)(actions.printClassroomTeacherSignInCardSuccess(teacherId, downloadUrl, downloadingTeachersIds));

                case 8:
                    _context9.next = 12;
                    break;

                case 10:
                    _context9.next = 12;
                    return (0, _effects.put)(actions.printClassroomTeacherSignInCardFailure(teacherId, downloadingTeachersIds));

                case 12:
                case 'end':
                    return _context9.stop();
            }
        }
    }, _marked9, this);
}

function downloadTeachersSignInCardSaga() {
    return regeneratorRuntime.wrap(function downloadTeachersSignInCardSaga$(_context10) {
        while (1) {
            switch (_context10.prev = _context10.next) {
                case 0:
                    _context10.next = 2;
                    return (0, _effects.takeEvery)(actions.PRINT_CLASSROOM_TEACHERS_SIGN_IN_CARD_REQUEST, downloadTeacherSignInCards);

                case 2:
                case 'end':
                    return _context10.stop();
            }
        }
    }, _marked10, this);
}

function unassignTeacher(_ref6) {
    var classroomId = _ref6.classroomId,
        selectedTeachers = _ref6.selectedTeachers,
        productId = _ref6.productId;
    var userRelationship, response;
    return regeneratorRuntime.wrap(function unassignTeacher$(_context11) {
        while (1) {
            switch (_context11.prev = _context11.next) {
                case 0:
                    userRelationship = { productId: productId, classroomId: classroomId, teachersProfileIdToUnassign: selectedTeachers };
                    _context11.next = 3;
                    return (0, _effects.call)(api.unAssignTeachers, userRelationship);

                case 3:
                    response = _context11.sent;

                    if (!(response.status === 200)) {
                        _context11.next = 9;
                        break;
                    }

                    _context11.next = 7;
                    return (0, _effects.put)(actions.unassignTeachersSuccess());

                case 7:
                    _context11.next = 11;
                    break;

                case 9:
                    _context11.next = 11;
                    return (0, _effects.put)(actions.unassignTeachersFailure());

                case 11:
                case 'end':
                    return _context11.stop();
            }
        }
    }, _marked11, this);
}

function unassignTeacherSaga() {
    return regeneratorRuntime.wrap(function unassignTeacherSaga$(_context12) {
        while (1) {
            switch (_context12.prev = _context12.next) {
                case 0:
                    _context12.next = 2;
                    return (0, _effects.takeLatest)(actions.UNASSIGN_TEACHER_REQUEST, unassignTeacher);

                case 2:
                case 'end':
                    return _context12.stop();
            }
        }
    }, _marked12, this);
}

function deleteClassroomGroup(_ref7) {
    var classroomId = _ref7.classroomId,
        groupId = _ref7.groupId;
    var response;
    return regeneratorRuntime.wrap(function deleteClassroomGroup$(_context13) {
        while (1) {
            switch (_context13.prev = _context13.next) {
                case 0:
                    _context13.next = 2;
                    return (0, _effects.call)(api.deleteClassroomGroup, classroomId, groupId);

                case 2:
                    response = _context13.sent;

                    if (!(response.status === 200)) {
                        _context13.next = 8;
                        break;
                    }

                    _context13.next = 6;
                    return (0, _effects.put)(actions.deleteGroupSuccess());

                case 6:
                    _context13.next = 10;
                    break;

                case 8:
                    _context13.next = 10;
                    return (0, _effects.put)(actions.deleteGroupFailure());

                case 10:
                case 'end':
                    return _context13.stop();
            }
        }
    }, _marked13, this);
}

function deleteClassroomGroupSaga() {
    return regeneratorRuntime.wrap(function deleteClassroomGroupSaga$(_context14) {
        while (1) {
            switch (_context14.prev = _context14.next) {
                case 0:
                    _context14.next = 2;
                    return (0, _effects.takeLatest)(actions.DELETE_GROUP_REQUEST, deleteClassroomGroup);

                case 2:
                case 'end':
                    return _context14.stop();
            }
        }
    }, _marked14, this);
}

function changeClassroomCourse(_ref8) {
    var classroomId = _ref8.classroomId,
        groupId = _ref8.groupId,
        courseId = _ref8.courseId,
        submittedFields = _ref8.submittedFields,
        upfCourseId = _ref8.upfCourseId,
        newCourseId = _ref8.newCourseId,
        useUpfSchoolDefault = _ref8.useUpfSchoolDefault;
    var response;
    return regeneratorRuntime.wrap(function changeClassroomCourse$(_context15) {
        while (1) {
            switch (_context15.prev = _context15.next) {
                case 0:
                    _context15.next = 2;
                    return (0, _effects.call)(api.changeClassroomCourse, classroomId, groupId, courseId, upfCourseId, newCourseId, useUpfSchoolDefault);

                case 2:
                    response = _context15.sent;

                    if (!(response.status === 200)) {
                        _context15.next = 8;
                        break;
                    }

                    _context15.next = 6;
                    return (0, _effects.put)(actions.changeCourseSuccess(classroomId, groupId, courseId, submittedFields, upfCourseId, newCourseId, useUpfSchoolDefault, response));

                case 6:
                    _context15.next = 10;
                    break;

                case 8:
                    _context15.next = 10;
                    return (0, _effects.put)(actions.changeCourseFailure());

                case 10:
                case 'end':
                    return _context15.stop();
            }
        }
    }, _marked15, this);
}

function changeClassroomCourseSaga() {
    return regeneratorRuntime.wrap(function changeClassroomCourseSaga$(_context16) {
        while (1) {
            switch (_context16.prev = _context16.next) {
                case 0:
                    _context16.next = 2;
                    return (0, _effects.takeLatest)(actions.CHANGE_COURSE_REQUEST, changeClassroomCourse);

                case 2:
                case 'end':
                    return _context16.stop();
            }
        }
    }, _marked16, this);
}

function addGroup(_ref9) {
    var classroomId = _ref9.classroomId,
        name = _ref9.name;
    var response, hasExceededGroup;
    return regeneratorRuntime.wrap(function addGroup$(_context17) {
        while (1) {
            switch (_context17.prev = _context17.next) {
                case 0:
                    _context17.next = 2;
                    return (0, _effects.call)(api.addGroup, classroomId, name);

                case 2:
                    response = _context17.sent;

                    if (!(response.status === 200)) {
                        _context17.next = 8;
                        break;
                    }

                    _context17.next = 6;
                    return (0, _effects.put)(actions.addGroupSuccess(response));

                case 6:
                    _context17.next = 14;
                    break;

                case 8:
                    hasExceededGroup = response.code !== 'MaxGroupInClassExceeded';
                    _context17.next = 11;
                    return (0, _effects.put)(actions.addGroupFailure(response));

                case 11:
                    if (!hasExceededGroup) {
                        _context17.next = 14;
                        break;
                    }

                    _context17.next = 14;
                    return (0, _effects.put)((0, _actions3.showToast)(response.message, 'error'));

                case 14:
                case 'end':
                    return _context17.stop();
            }
        }
    }, _marked17, this);
}

function addGroupSaga() {
    return regeneratorRuntime.wrap(function addGroupSaga$(_context18) {
        while (1) {
            switch (_context18.prev = _context18.next) {
                case 0:
                    _context18.next = 2;
                    return (0, _effects.takeLatest)(actions.ADD_GROUP_REQUEST, addGroup);

                case 2:
                case 'end':
                    return _context18.stop();
            }
        }
    }, _marked18, this);
}

function changeCourseCarryOver(_ref10) {
    var classroomId = _ref10.classroomId,
        groupId = _ref10.groupId,
        newCourseId = _ref10.newCourseId,
        newUpfCourseId = _ref10.newUpfCourseId,
        taskActionType = _ref10.taskActionType,
        courses = _ref10.courses,
        newConquestCourseId = _ref10.newConquestCourseId;
    var response;
    return regeneratorRuntime.wrap(function changeCourseCarryOver$(_context19) {
        while (1) {
            switch (_context19.prev = _context19.next) {
                case 0:
                    _context19.next = 2;
                    return (0, _effects.call)(api.changeCourseCarryOver, classroomId, groupId, newCourseId, newUpfCourseId, taskActionType, courses, newConquestCourseId);

                case 2:
                    response = _context19.sent;

                    if (!(response.status === 200)) {
                        _context19.next = 8;
                        break;
                    }

                    _context19.next = 6;
                    return (0, _effects.put)(actions.changeCourseCarryOverSuccess());

                case 6:
                    _context19.next = 12;
                    break;

                case 8:
                    _context19.next = 10;
                    return (0, _effects.put)(actions.changeCourseCarryOverFailure());

                case 10:
                    _context19.next = 12;
                    return (0, _effects.put)((0, _actions3.showToast)(response.message, 'error'));

                case 12:
                case 'end':
                    return _context19.stop();
            }
        }
    }, _marked19, this);
}

function changeCourseCarryOverSaga() {
    return regeneratorRuntime.wrap(function changeCourseCarryOverSaga$(_context20) {
        while (1) {
            switch (_context20.prev = _context20.next) {
                case 0:
                    _context20.next = 2;
                    return (0, _effects.takeLatest)(actions.CHANGE_COURSE_CARRY_OVER_REQUEST, changeCourseCarryOver);

                case 2:
                case 'end':
                    return _context20.stop();
            }
        }
    }, _marked20, this);
}

function handleCountryDropdownChanges(_ref11) {
    var value = _ref11.value;
    var countryCode;
    return regeneratorRuntime.wrap(function handleCountryDropdownChanges$(_context21) {
        while (1) {
            switch (_context21.prev = _context21.next) {
                case 0:
                    countryCode = value !== _constants2.default.SCHOOL_COURSES ? value : '';
                    _context21.next = 3;
                    return (0, _effects.put)((0, _actions2.getCountryYearGroupRequest)(countryCode, actions.getYearGroupsByCountrySuccess, actions.getYearGroupsByCountryFailure));

                case 3:
                case 'end':
                    return _context21.stop();
            }
        }
    }, _marked21, this);
}

function handleCountryDropdownChangesSaga() {
    return regeneratorRuntime.wrap(function handleCountryDropdownChangesSaga$(_context22) {
        while (1) {
            switch (_context22.prev = _context22.next) {
                case 0:
                    _context22.next = 2;
                    return (0, _effects.takeLatest)(actions.HANDLE_COUNTRY_DROPDOWN_CHANGES, handleCountryDropdownChanges);

                case 2:
                case 'end':
                    return _context22.stop();
            }
        }
    }, _marked22, this);
}

/***/ }),
/* 831 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
/**
 * get EditClassGroup visibility
 * @param state
 * @returns {*|boolean}
 */

var getEditClassGroupVisibility = exports.getEditClassGroupVisibility = function getEditClassGroupVisibility(state) {
  return state.editClass.editClassGroupIsVisible;
};

/**
 * get Selected Group from Edit Class
 * @param state
 * @returns {*|null}
 */
var getSelectedGroup = exports.getSelectedGroup = function getSelectedGroup(state) {
  return state.editClass.selectedGroup;
};

/**
 * get selected group default status
 * @param state
 * @returns {*}
 */
var getSelectedGroupIsDefault = exports.getSelectedGroupIsDefault = function getSelectedGroupIsDefault(state) {
  return state.editClass.selectedGroup && state.editClass.selectedGroup.isDefault;
};

var getIsLoadingEditClassDetail = exports.getIsLoadingEditClassDetail = function getIsLoadingEditClassDetail(state) {
  return state.editClass.isLoadingEditClassDetail;
};

var getClassroomDetail = exports.getClassroomDetail = function getClassroomDetail(state) {
  return state.editClass.classroomDetail;
};

var getIsDownloadingSignInCards = exports.getIsDownloadingSignInCards = function getIsDownloadingSignInCards(state) {
  return state.editClass.isDownloadingSignInCards;
};

var getIsSavingClass = exports.getIsSavingClass = function getIsSavingClass(state) {
  return state.editClass.isSavingClass;
};

var getDisableConfirmationButtons = exports.getDisableConfirmationButtons = function getDisableConfirmationButtons(state) {
  return state.editClass.disableConfirmationButtons;
};

/***/ }),
/* 832 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.EditStudents = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __webpack_require__(28);

var _clone = __webpack_require__(122);

var _clone2 = _interopRequireDefault(_clone);

var _redux = __webpack_require__(35);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _actions = __webpack_require__(127);

var _actions2 = __webpack_require__(98);

var _editStudentForm = __webpack_require__(702);

var _editStudentForm2 = _interopRequireDefault(_editStudentForm);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var EditStudents = exports.EditStudents = function (_Component) {
    _inherits(EditStudents, _Component);

    function EditStudents(props) {
        _classCallCheck(this, EditStudents);

        var _this = _possibleConstructorReturn(this, (EditStudents.__proto__ || Object.getPrototypeOf(EditStudents)).call(this, props));

        _this.handleOnUnassignStudentUsingClassId = function (classId) {
            _this.setState({ showUnassignStudentModal: true, classId: classId });
            _this.props.openUnAssignStudentsModal();
        };

        _this.handleOnUnassignConfirm = function () {
            _this.props.unassignStudentsUsingClassId(_this.props.editStudentDetail.userProfileId, _this.state.classId);
        };

        _this.handleOnCloseModal = function () {
            _this.setState({ showUnassignStudentModal: false });
            _this.props.showHideModal(false);
        };

        _this.unassignStudentsSuccessConfirmation = function () {
            _this.handleOnCloseModal();
            _this.setState({ refreshListOnCancel: true });
            _this.props.getStudentsByUserId(_this.props.selectedProduct.id, _this.props.match.params.id);
        };

        _this.handleOnEditStudentSubmit = function () {
            var student = (0, _clone2.default)(_this.props.studentDetail);
            student.yearGroup = parseInt(student.yearGroupEnum, 10);
            _this.props.editStudent(student, true, _this.context);
        };

        _this.handleOnCloseEditStudentValidationModal = function () {
            _this.props.closeEditStudentValidationModal();
        };

        _this.handleOnCloseEditStudent = function () {
            _this.context.router.history.push('/students');
            if (_this.state.refreshListOnCancel === true) {
                _this.props.refreshStudentListOnCancel();
            }
        };

        _this.handleOnPrintSignInCard = function (format) {
            var studentSignInCardData = { studentUserProfileIds: [_this.props.match.params.id],
                SignInCardPageSizeType: format };
            _this.props.printSignInCard(_this.props.selectedProduct.id, studentSignInCardData);
        };

        _this.handleOnAssignClass = function () {
            var assignType = 'classToStudent';
            _this.context.router.history.push('/assign-user/' + _this.props.match.params.id + '/' + assignType);
        };

        _this.handleOnDownSignInCards = function () {
            _this.props.showHideModal(true);
        };

        _this.handleOnUnassignStudentUsingClassId = _this.handleOnUnassignStudentUsingClassId.bind(_this);
        _this.handleOnUnassignConfirm = _this.handleOnUnassignConfirm.bind(_this);
        _this.handleOnCloseModal = _this.handleOnCloseModal.bind(_this);
        _this.unassignStudentsSuccessConfirmation = _this.unassignStudentsSuccessConfirmation.bind(_this);
        _this.handleOnDownSignInCards = _this.handleOnDownSignInCards.bind(_this);
        _this.state = { showUnassignStudentModal: false, refreshListOnCancel: false };
        return _this;
    }

    _createClass(EditStudents, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            this.props.getStudentsByUserId(this.props.selectedProduct.id, this.props.match.params.id);
        }
    }, {
        key: 'componentWillReceiveProps',
        value: function componentWillReceiveProps(nextProps) {
            if (nextProps.isSignInCardDownloaded !== this.props.isSignInCardDownloaded) {
                setTimeout(this.props.showHideModal(false), 1000);
            }
        }
    }, {
        key: 'render',
        value: function render() {
            return _react2.default.createElement(
                'div',
                null,
                _react2.default.createElement(_editStudentForm2.default, {
                    closeEditStudent: this.handleOnCloseEditStudent,
                    closeEditStudentValidationModal: this.handleOnCloseEditStudentValidationModal,
                    dataFilterOptions: this.props.dataFilterOption,
                    displayNewCourses: this.displayNewCourses,
                    downloadStudentsSignInCards: this.handleOnDownSignInCards,
                    editStudentDetail: this.props.editStudentDetail,
                    editStudentValidationMessage: this.props.editStudentValidationMessage,
                    handleOnAssignClass: this.handleOnAssignClass,
                    handleOnCloseModal: this.handleOnCloseModal,
                    handleOnEditStudentSubmit: this.handleOnEditStudentSubmit,
                    handleOnPrintSignInCard: this.handleOnPrintSignInCard,
                    handleOnUnassignConfirm: this.handleOnUnassignConfirm,
                    handleOnUnassignStudent: this.handleOnUnassignStudentUsingClassId,
                    isLoading: this.props.unassignDisableButton,
                    isLoadingEditStudentDetail: this.props.isLoadingEditStudentDetail,
                    isSignInCardDownloaded: this.props.isSignInCardDownloaded,
                    isUnassignedModalOpen: this.props.isUnassignedModalOpen,
                    productName: this.props.selectedProduct.name,
                    showEditStudentValidationModal: this.props.showEditStudentValidationModal,
                    showModal: this.props.showModal,
                    showUnassignStudentModal: this.state.showUnassignStudentModal,
                    student: this.props.studentDetail,
                    unassignStudentsSuccessConfirmation: this.unassignStudentsSuccessConfirmation,
                    updatingStudent: this.props.updatingStudent
                })
            );
        }
    }]);

    return EditStudents;
}(_react.Component);

EditStudents.propTypes = {
    selectedProduct: _propTypes2.default.object,
    match: _propTypes2.default.object.isRequired,
    editStudentDetail: _propTypes2.default.object,
    openUnAssignStudentsModal: _propTypes2.default.func,
    unassignStudentsUsingClassId: _propTypes2.default.func,
    getStudentsByUserId: _propTypes2.default.func,
    isUnassignedModalOpen: _propTypes2.default.bool,
    unassignDisableButton: _propTypes2.default.bool,
    isLoadingEditStudentDetail: _propTypes2.default.bool,
    editStudent: _propTypes2.default.func,
    dataFilterOption: _propTypes2.default.object,
    studentDetail: _propTypes2.default.object,
    updatingStudent: _propTypes2.default.bool,
    showEditStudentValidationModal: _propTypes2.default.bool,
    editStudentValidationMessage: _propTypes2.default.string,
    closeEditStudentValidationModal: _propTypes2.default.func,
    printSignInCard: _propTypes2.default.func,
    isSignInCardDownloaded: _propTypes2.default.bool,
    refreshStudentListOnCancel: _propTypes2.default.func,
    showHideModal: _propTypes2.default.func,
    showModal: _propTypes2.default.bool
};
EditStudents.contextTypes = {
    router: _propTypes2.default.object
};


var mapStateToProps = function mapStateToProps(state) {
    return {
        dataFilterOption: state.studentRoll.dataFilterOption,
        selectedProduct: state.product,
        editStudentsReducer: state.editStudentsReducer,
        editStudentDetail: state.editStudent.editStudentDetail,
        isUnassignedModalOpen: state.editStudent.isUnassignedModalOpen,
        unassignDisableButton: state.editStudent.unassignDisableButton,
        isLoadingEditStudentDetail: state.editStudent.isLoadingEditStudentDetail,
        studentDetail: state.editStudent.studentDetail,
        updatingStudent: state.editStudent.updatingStudent,
        showEditStudentValidationModal: state.editStudent.showEditStudentValidationModal,
        editStudentValidationMessage: state.editStudent.editStudentValidationMessage,
        isSignInCardDownloaded: state.studentRoll.isSignInCardDownloaded,
        showModal: state.editStudent.showModal
    };
};

function mapDispatchToProps(dispatch) {
    return (0, _redux.bindActionCreators)({
        getStudentsByUserId: _actions.getStudentsByUserId,
        editStudent: _actions.editStudent,
        openUnAssignStudentsModal: _actions.openUnAssignStudentsModal,
        unassignStudentsUsingClassId: _actions.unassignStudentsUsingClassId,
        refreshStudentListOnCancel: _actions.refreshStudentListOnCancel,
        closeEditStudentValidationModal: _actions.closeEditStudentValidationModal,
        printSignInCard: _actions2.printSignInCard,
        showHideModal: _actions.showHideModal
    }, dispatch);
}

exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(EditStudents);

/***/ }),
/* 833 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.default = function () {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
    var action = arguments[1];

    switch (action.type) {
        case actions.GET_STUDENTS_REQUEST:
            {
                return _extends({}, state, { isLoadingEditStudentDetail: action.isLoadingEditStudentDetail });
            }

        case actions.GET_STUDENTS_SUCCESS:
            {
                return _extends({}, state, { editStudentDetail: action.data, isLoadingEditStudentDetail: action.isLoadingEditStudentDetail, studentDetail: action.data });
            }
        case actions.EDIT_STUDENT_REQUEST:
            {
                return _extends({}, state, { updatingStudent: true });
            }
        case actions.EDIT_STUDENT_SUCCESS_REQUEST:
            {
                return _extends({}, state, { updatingStudent: false, studentDetail: assignEmptyStudentObject() });
            }
        case actions.EDIT_STUDENT_FAILURE_REQUEST:
            {
                var errorMessage = '';
                if (action.isServerError) {
                    errorMessage = _messages2.default.errorMessageHeader;
                } else {
                    errorMessage = action.editStudentValidationMessage;
                }
                return _extends({}, state, { updatingStudent: false, showEditStudentValidationModal: action.showEditStudentValidationModal, editStudentValidationMessage: errorMessage });
            }
        case actions.CLOSE_EDIT_STUDENT_VALIDATION_MODAL:
            {
                return _extends({}, state, { showEditStudentValidationModal: action.showEditStudentValidationModal });
            }

        case actions.GET_STUDENTS_FAILURE:
            {
                return _extends({}, state, { editStudentDetail: [], isLoadingEditStudentDetail: action.isLoadingEditStudentDetail });
            }

        case actions.OPEN_UNASSIGN_STUDENTS_MODAL:
            {
                return _extends({}, state, { isUnassignedModalOpen: action.isUnassignedModalOpen });
            }

        case actions.UNASSIGN_STUDENTS_USING_CLASSID_REQUEST:
            {
                return _extends({}, state, { unassignDisableButton: action.unassignDisableButton, isUnassignedModalOpen: action.isUnassignedModalOpen });
            }

        case actions.UNASSIGN_STUDENTS_USING_CLASSID_SUCCESS:
            {
                return _extends({}, state, { isUnassignedModalOpen: action.isUnassignedModalOpen, unassignDisableButton: action.unassignDisableButton });
            }

        case actions.UNASSIGN_STUDENTS_USING_CLASSID_FAILURE:
            {
                return _extends({}, state, { unassignDisableButton: action.unassignDisableButton });
            }

        case actions.CLOSE_UNASSIGN_STUDENTS_MODAL_CONFIRMATION:
            {
                return _extends({}, state, { refreshStudentsAfterUnAssign: action.refreshStudentsAfterUnAssign });
            }

        case actions.SHOW_HIDE_MODAL:
            {
                return _extends({}, state, { showModal: action.showModal });
            }

        default:
            return state;
    }
};

var _actions = __webpack_require__(127);

var actions = _interopRequireWildcard(_actions);

var _messages = __webpack_require__(266);

var _messages2 = _interopRequireDefault(_messages);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var assignEmptyStudentObject = function assignEmptyStudentObject() {
    return { firstName: '', lastName: '', yearGroupEnum: '', userName: '', password: '' };
};

var initialState = { studentDetail: assignEmptyStudentObject(), updatingStudent: false, isLoadingEditStudentDetail: false, showModal: false };

/***/ }),
/* 834 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.getStudentsByUserProfileId = getStudentsByUserProfileId;
exports.editStudentInformation = editStudentInformation;
exports.getStudentsByUserProfileIdSaga = getStudentsByUserProfileIdSaga;
exports.unassignStudentsByClassId = unassignStudentsByClassId;
exports.unassignStudentsByClassIdSaga = unassignStudentsByClassIdSaga;
exports.editStudentSaga = editStudentSaga;

var _effects = __webpack_require__(32);

var _api = __webpack_require__(33);

var api = _interopRequireWildcard(_api);

var _actions = __webpack_require__(127);

var actions = _interopRequireWildcard(_actions);

var _actions2 = __webpack_require__(65);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var _marked = /*#__PURE__*/regeneratorRuntime.mark(getStudentsByUserProfileId),
    _marked2 = /*#__PURE__*/regeneratorRuntime.mark(editStudentInformation),
    _marked3 = /*#__PURE__*/regeneratorRuntime.mark(getStudentsByUserProfileIdSaga),
    _marked4 = /*#__PURE__*/regeneratorRuntime.mark(unassignStudentsByClassId),
    _marked5 = /*#__PURE__*/regeneratorRuntime.mark(unassignStudentsByClassIdSaga),
    _marked6 = /*#__PURE__*/regeneratorRuntime.mark(editStudentSaga);

function getStudentsByUserProfileId(_ref) {
    var productId = _ref.productId,
        userProfileId = _ref.userProfileId;
    var payload;
    return regeneratorRuntime.wrap(function getStudentsByUserProfileId$(_context) {
        while (1) {
            switch (_context.prev = _context.next) {
                case 0:
                    _context.next = 2;
                    return (0, _effects.call)(api.getStudentByUserProfileId, productId, userProfileId);

                case 2:
                    payload = _context.sent;

                    if (!(payload.status === 200)) {
                        _context.next = 8;
                        break;
                    }

                    _context.next = 6;
                    return (0, _effects.put)(actions.getStudentsSuccess(payload));

                case 6:
                    _context.next = 10;
                    break;

                case 8:
                    _context.next = 10;
                    return (0, _effects.put)(actions.getStudentsFailure());

                case 10:
                case 'end':
                    return _context.stop();
            }
        }
    }, _marked, this);
}

function editStudentInformation(_ref2) {
    var student = _ref2.student,
        context = _ref2.context;
    var response;
    return regeneratorRuntime.wrap(function editStudentInformation$(_context2) {
        while (1) {
            switch (_context2.prev = _context2.next) {
                case 0:
                    _context2.next = 2;
                    return (0, _effects.call)(api.editStudent, student);

                case 2:
                    response = _context2.sent;

                    if (!(response.status === 200)) {
                        _context2.next = 8;
                        break;
                    }

                    _context2.next = 6;
                    return (0, _effects.put)(actions.editStudentSuccess(context));

                case 6:
                    _context2.next = 17;
                    break;

                case 8:
                    if (!(response.status === 400 || response.status === 409)) {
                        _context2.next = 15;
                        break;
                    }

                    _context2.next = 11;
                    return (0, _effects.put)(actions.editStudentFailure(false, response.message, false));

                case 11:
                    _context2.next = 13;
                    return (0, _effects.put)((0, _actions2.showToast)(response.message, 'error'));

                case 13:
                    _context2.next = 17;
                    break;

                case 15:
                    _context2.next = 17;
                    return (0, _effects.put)(actions.editStudentFailure(true, ''));

                case 17:
                case 'end':
                    return _context2.stop();
            }
        }
    }, _marked2, this);
}

function getStudentsByUserProfileIdSaga() {
    return regeneratorRuntime.wrap(function getStudentsByUserProfileIdSaga$(_context3) {
        while (1) {
            switch (_context3.prev = _context3.next) {
                case 0:
                    _context3.next = 2;
                    return (0, _effects.takeLatest)(actions.GET_STUDENTS_REQUEST, getStudentsByUserProfileId);

                case 2:
                case 'end':
                    return _context3.stop();
            }
        }
    }, _marked3, this);
}

function unassignStudentsByClassId(_ref3) {
    var userProfileId = _ref3.userProfileId,
        classId = _ref3.classId;
    var StudentDetail, response;
    return regeneratorRuntime.wrap(function unassignStudentsByClassId$(_context4) {
        while (1) {
            switch (_context4.prev = _context4.next) {
                case 0:
                    StudentDetail = {
                        classroomId: classId,
                        studentsProfileIdToUnassign: [userProfileId]
                    };
                    _context4.next = 3;
                    return (0, _effects.call)(api.unAssignStudents, StudentDetail);

                case 3:
                    response = _context4.sent;

                    if (!(response.status === 200)) {
                        _context4.next = 9;
                        break;
                    }

                    _context4.next = 7;
                    return (0, _effects.put)(actions.unassignStudentsByClassIdSuccess());

                case 7:
                    _context4.next = 11;
                    break;

                case 9:
                    _context4.next = 11;
                    return (0, _effects.put)(actions.unassignStudentsByClassIdFailure());

                case 11:
                case 'end':
                    return _context4.stop();
            }
        }
    }, _marked4, this);
}

function unassignStudentsByClassIdSaga() {
    return regeneratorRuntime.wrap(function unassignStudentsByClassIdSaga$(_context5) {
        while (1) {
            switch (_context5.prev = _context5.next) {
                case 0:
                    _context5.next = 2;
                    return (0, _effects.takeLatest)(actions.UNASSIGN_STUDENTS_USING_CLASSID_REQUEST, unassignStudentsByClassId);

                case 2:
                case 'end':
                    return _context5.stop();
            }
        }
    }, _marked5, this);
}

function editStudentSaga() {
    return regeneratorRuntime.wrap(function editStudentSaga$(_context6) {
        while (1) {
            switch (_context6.prev = _context6.next) {
                case 0:
                    _context6.next = 2;
                    return (0, _effects.takeLatest)(actions.EDIT_STUDENT_REQUEST, editStudentInformation);

                case 2:
                case 'end':
                    return _context6.stop();
            }
        }
    }, _marked6, this);
}

/***/ }),
/* 835 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.EditTeacher = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __webpack_require__(28);

var _reactIntl = __webpack_require__(2);

var _clone = __webpack_require__(122);

var _clone2 = _interopRequireDefault(_clone);

var _redux = __webpack_require__(35);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _actions = __webpack_require__(128);

var _actions2 = __webpack_require__(38);

var _actions3 = __webpack_require__(50);

var _editTeacherForm = __webpack_require__(704);

var _editTeacherForm2 = _interopRequireDefault(_editTeacherForm);

var _actions4 = __webpack_require__(65);

var _messages = __webpack_require__(396);

var _messages2 = _interopRequireDefault(_messages);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var EditTeacher = exports.EditTeacher = function (_Component) {
    _inherits(EditTeacher, _Component);

    function EditTeacher(props) {
        _classCallCheck(this, EditTeacher);

        var _this = _possibleConstructorReturn(this, (EditTeacher.__proto__ || Object.getPrototypeOf(EditTeacher)).call(this, props));

        _this.handleOnUnassignTeacherUsingClassId = function (classId) {
            _this.setState({ showUnassignTeacherModal: true, classId: classId });
            _this.props.openUnAssignTeachersModal();
        };

        _this.handleOnUnassignConfirm = function () {
            _this.props.unassignTeachersUsingClassId(_this.props.editTeacherDetail.userProfileId, _this.state.classId);
        };

        _this.handleOnCloseModal = function () {
            _this.setState({ showUnassignTeacherModal: false });
            _this.props.closeUnassignModalRequest();
        };

        _this.unassignTeachersSuccessConfirmation = function () {
            _this.handleOnCloseModal();
            _this.setState({ refreshListOnCancel: true });
            _this.props.getTeacherByUserId(_this.props.selectedProduct.id, _this.props.match.params.id);
        };

        _this.handleOnEditTeacherSubmit = function () {
            var teacher = (0, _clone2.default)(_this.props.teacherDetail);
            _this.props.editTeacher(teacher, true, _this.context);
        };

        _this.handleOnCloseEditTeacherValidationModal = function () {
            _this.props.closeEditTeacherValidationModal();
        };

        _this.handleOnCloseEditTeacher = function () {
            _this.context.router.history.push('/teachers');
            if (_this.state.refreshListOnCancel === true) {
                _this.props.refreshTeacherListOnCancel();
            }
        };

        _this.handleOnPrintSignInCard = function () {
            var teacherSignInCardData = {
                teacherUserProfileIds: [_this.props.match.params.id],
                SignInCardPageSizeType: 'QR_3X3'
            };
            _this.props.printTeacherSignInCard(_this.props.selectedProduct.id, teacherSignInCardData);
        };

        _this.handlePrintClassroomSignInCard = function (classId, SignInCardPageSizeType) {
            _this.downloadingClassroomIds.add(classId);
            _this.props.printClassroomStudentsSignInCard(classId, _this.props.selectedProduct.id, _this.downloadingClassroomIds, SignInCardPageSizeType);
            _this.props.showHideSignInCardModalRequest(false);
        };

        _this.handleOnAssignClass = function () {
            var assignType = 'classToTeacher';
            _this.context.router.history.push('/assign-user/' + _this.props.match.params.id + '/' + assignType);
        };

        _this.handleOnStudentSignInCards = function () {
            _this.props.showHideSignInCardModalRequest(true);
        };

        _this.handleOnCancelStudentSignInCards = function () {
            _this.props.showHideSignInCardModalRequest(false);
        };

        _this.handleOnSendTeacherPassword = function () {
            _this.props.sendPasswordLinkRequest(_this.props.selectedProduct.id, parseInt(_this.props.match.params.id, 10));
        };

        _this.handleOnSendEmailVerificationLink = function () {
            _this.props.sendVerificationEmailLinkRequest(parseInt(_this.props.match.params.id, 10));
        };

        _this.handleOnUnassignTeacherUsingClassId = _this.handleOnUnassignTeacherUsingClassId.bind(_this);
        _this.handleOnUnassignConfirm = _this.handleOnUnassignConfirm.bind(_this);
        _this.handleOnCloseModal = _this.handleOnCloseModal.bind(_this);
        _this.handlePrintClassroomSignInCard = _this.handlePrintClassroomSignInCard.bind(_this);
        _this.unassignTeachersSuccessConfirmation = _this.unassignTeachersSuccessConfirmation.bind(_this);
        _this.state = { showUnassignTeacherModal: false, refreshListOnCancel: false };
        _this.downloadingClassroomIds = new Set();
        return _this;
    }

    _createClass(EditTeacher, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            this.props.getTeacherByUserId(this.props.selectedProduct.id, this.props.match.params.id);
        }
    }, {
        key: 'componentWillReceiveProps',
        value: function componentWillReceiveProps(nextProps) {
            if (nextProps.emailStatus) {
                this.props.showToast(this.props.intl.formatMessage(_messages2.default.emailSent), 'success');
                this.props.resetPasswordParams();
            } else if (!nextProps.emailStatus && nextProps.emailValidationMessage !== '') {
                this.props.showToast(nextProps.emailValidationMessage, 'error');
                this.props.resetPasswordParams();
            } else if (nextProps.showEditTeacherValidationModal) {
                this.props.showToast(nextProps.editTeacherValidationMessage, 'error');
                this.props.resetValidationErrorModal();
            }
        }
    }, {
        key: 'render',
        value: function render() {
            return _react2.default.createElement(
                'div',
                null,
                _react2.default.createElement(_editTeacherForm2.default, _extends({
                    closeEditTeacher: this.handleOnCloseEditTeacher,
                    closeEditTeacherValidationModal: this.handleOnCloseEditTeacherValidationModal,
                    dataFilterOptions: this.props.dataFilterOption,
                    downloadingClassroomIds: this.props.downloadingClassroomIds,
                    editTeacherDetail: this.props.editTeacherDetail,
                    editTeacherValidationMessage: this.props.editTeacherValidationMessage,
                    handleOnAssignClass: this.handleOnAssignClass,
                    handleOnCancelStudentSignInCards: this.handleOnCancelStudentSignInCards,
                    handleOnCloseModal: this.handleOnCloseModal,
                    handleOnEditTeacherSubmit: this.handleOnEditTeacherSubmit,
                    handleOnPrintClassroomSignInCard: this.handlePrintClassroomSignInCard,
                    handleOnPrintSignInCard: this.handleOnPrintSignInCard,
                    handleOnSendEmailVerificationLink: this.handleOnSendEmailVerificationLink,
                    handleOnSendTeacherPassword: this.handleOnSendTeacherPassword,
                    handleOnStudentSignInCards: this.handleOnStudentSignInCards,
                    handleOnUnassignConfirm: this.handleOnUnassignConfirm,
                    handleOnUnassignTeacher: this.handleOnUnassignTeacherUsingClassId,
                    isLoading: this.props.unassignDisableButton,
                    isLoadingEditTeacherDetail: this.props.isLoadingEditTeacherDetail,
                    isSignInCardDownloaded: this.props.isSignInCardDownloaded,
                    isUnassignedModalOpen: this.props.isUnassignedModalOpen,
                    productName: this.props.selectedProduct.name,
                    showUnassignTeacherModal: this.state.showUnassignTeacherModal,
                    teacher: this.props.teacherDetail,
                    teacherTitles: this.props.teacherTitles,
                    unassignTeachersSuccessConfirmation: this.unassignTeachersSuccessConfirmation,
                    updatingTeacher: this.props.updatingTeacher
                }, this.props))
            );
        }
    }]);

    return EditTeacher;
}(_react.Component);

EditTeacher.propTypes = {
    selectedProduct: _propTypes2.default.object,
    match: _propTypes2.default.object.isRequired,
    editTeacherDetail: _propTypes2.default.object,
    openUnAssignTeachersModal: _propTypes2.default.func,
    unassignTeachersUsingClassId: _propTypes2.default.func,
    getTeacherByUserId: _propTypes2.default.func,
    isUnassignedModalOpen: _propTypes2.default.bool,
    unassignDisableButton: _propTypes2.default.bool,
    isLoadingEditTeacherDetail: _propTypes2.default.bool,
    editTeacher: _propTypes2.default.func,
    dataFilterOption: _propTypes2.default.object,
    teacherDetail: _propTypes2.default.object,
    teacherTitles: _propTypes2.default.arrayOf(_propTypes2.default.object),
    updatingTeacher: _propTypes2.default.bool,
    showEditTeacherValidationModal: _propTypes2.default.bool,
    editTeacherValidationMessage: _propTypes2.default.string,
    closeEditTeacherValidationModal: _propTypes2.default.func,
    printTeacherSignInCard: _propTypes2.default.func,
    printClassroomStudentsSignInCard: _propTypes2.default.func,
    isSignInCardDownloaded: _propTypes2.default.bool,
    downloadingClassroomIds: _propTypes2.default.object,
    refreshTeacherListOnCancel: _propTypes2.default.func,
    showHideSignInCardModalRequest: _propTypes2.default.func,
    closeUnassignModalRequest: _propTypes2.default.func,
    showToast: _propTypes2.default.func,
    sendPasswordLinkRequest: _propTypes2.default.func,
    emailStatus: _propTypes2.default.bool,
    emailValidationMessage: _propTypes2.default.string,
    resetPasswordParams: _propTypes2.default.func,
    sendVerificationEmailLinkRequest: _propTypes2.default.func,
    intl: _reactIntl.intlShape.isRequired,
    resetValidationErrorModal: _propTypes2.default.func
};
EditTeacher.contextTypes = {
    router: _propTypes2.default.object
};


var mapStateToProps = function mapStateToProps(state) {
    return {
        dataFilterOption: state.teacherRoll.dataFilterOption,
        selectedProduct: state.product,
        editTeacherReducer: state.editTeacherReducer,
        editTeacherDetail: state.editTeacher.editTeacherDetail,
        isUnassignedModalOpen: state.editTeacher.isUnassignedModalOpen,
        unassignDisableButton: state.editTeacher.unassignDisableButton,
        isLoadingEditTeacherDetail: state.editTeacher.isLoadingEditTeacherDetail,
        teacherDetail: state.editTeacher.teacherDetail,
        teacherTitles: state.teacherRoll.teacherTitles,
        updatingTeacher: state.editTeacher.updatingTeacher,
        showEditTeacherValidationModal: state.editTeacher.showEditTeacherValidationModal,
        editTeacherValidationMessage: state.editTeacher.editTeacherValidationMessage,
        isSignInCardDownloaded: state.teacherRoll.isSignInCardDownloaded,
        downloadingClassroomIds: state.editTeacher.downloadingClassroomIds,
        showHideSignInCardModal: state.classRoll.showHideSignInCardModal,
        emailStatus: state.editTeacher.emailStatus,
        emailValidationMessage: state.editTeacher.emailValidationMessage,
        enableSave: state.editTeacher.enableSave
    };
};

function mapDispatchToProps(dispatch) {
    return (0, _redux.bindActionCreators)({
        getTeacherByUserId: _actions.getTeacherByUserId,
        editTeacher: _actions.editTeacher,
        openUnAssignTeachersModal: _actions.openUnAssignTeachersModal,
        unassignTeachersUsingClassId: _actions.unassignTeachersUsingClassId,
        refreshTeacherListOnCancel: _actions.refreshTeacherListOnCancel,
        closeEditTeacherValidationModal: _actions.closeEditTeacherValidationModal,
        printTeacherSignInCard: _actions3.printTeacherSignInCard,
        printClassroomStudentsSignInCard: _actions.printClassroomStudentsSignInCard,
        showHideSignInCardModalRequest: _actions2.showHideSignInCardModalRequest,
        closeUnassignModalRequest: _actions.closeUnassignModalRequest,
        showToast: _actions4.showToast,
        sendPasswordLinkRequest: _actions.sendPasswordLinkRequest,
        resetPasswordParams: _actions.resetPasswordParams,
        sendVerificationEmailLinkRequest: _actions.sendVerificationEmailLinkRequest,
        resetValidationErrorModal: _actions.resetValidationErrorModal
    }, dispatch);
}

exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)((0, _reactIntl.injectIntl)(EditTeacher));

/***/ }),
/* 836 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.default = function () {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
    var action = arguments[1];

    switch (action.type) {
        case actions.GET_TEACHER_REQUEST:
            {
                return _extends({}, state, { isLoadingEditTeacherDetail: action.isLoadingEditTeacherDetail });
            }

        case actions.GET_TEACHER_SUCCESS:
            {
                return _extends({}, state, { editTeacherDetail: action.data, isLoadingEditTeacherDetail: action.isLoadingEditTeacherDetail, teacherDetail: action.data });
            }
        case actions.EDIT_TEACHER_REQUEST:
            {
                return _extends({}, state, { updatingTeacher: true, enableSave: false });
            }
        case actions.EDIT_TEACHER_SUCCESS_REQUEST:
            {
                return _extends({}, state, { updatingTeacher: false, teacherDetail: assignEmptyTeacherObject(), enableSave: false });
            }
        case actions.EDIT_TEACHER_FAILURE_REQUEST:
            {
                var errorMessage = '';
                if (action.isServerError) {
                    errorMessage = _messages2.default.errorMessageHeader;
                } else {
                    errorMessage = action.editTeacherValidationMessage;
                }
                return _extends({}, state, { updatingTeacher: false, showEditTeacherValidationModal: action.showEditTeacherValidationModal, editTeacherValidationMessage: errorMessage });
            }
        case actions.CLOSE_EDIT_TEACHER_VALIDATION_MODAL:
            {
                return _extends({}, state, { showEditTeacherValidationModal: action.showEditTeacherValidationModal });
            }

        case actions.GET_TEACHER_FAILURE:
            {
                return _extends({}, state, { editTeacherDetail: [], isLoadingEditTeacherDetail: action.isLoadingEditTeacherDetail });
            }

        case actions.OPEN_UNASSIGN_TEACHERS_MODAL:
            {
                return _extends({}, state, { isUnassignedModalOpen: action.isUnassignedModalOpen });
            }

        case actions.UNASSIGN_TEACHERS_USING_CLASSID_REQUEST:
            {
                return _extends({}, state, { unassignDisableButton: action.unassignDisableButton, isUnassignedModalOpen: action.isUnassignedModalOpen });
            }

        case actions.UNASSIGN_TEACHERS_USING_CLASSID_SUCCESS:
            {
                return _extends({}, state, { isUnassignedModalOpen: action.isUnassignedModalOpen, unassignDisableButton: action.unassignDisableButton });
            }

        case actions.UNASSIGN_TEACHERS_USING_CLASSID_FAILURE:
            {
                return _extends({}, state, { unassignDisableButton: action.unassignDisableButton });
            }

        case actions.CLOSE_UNASSIGN_TEACHERS_MODAL_CONFIRMATION:
            {
                return _extends({}, state, { refreshTeachersAfterUnAssign: action.refreshTeachersAfterUnAssign });
            }

        case actions.PRINT_CLASSROOM_STUDENTS_SIGN_IN_CARD_REQUEST:
            {
                return _extends({}, state, { downloadingClassroomIds: action.downloadingClassroomIds });
            }

        case actions.PRINT_CLASSROOM_STUDENTS_SIGN_IN_CARD_SUCCESS:
            {
                return _extends({}, state, { downloadingClassroomIds: action.downloadingClassroomIds });
            }

        case actions.PRINT_CLASSROOM_STUDENTS_SIGN_IN_CARD_FAILURE:
            {
                return _extends({}, state, { downloadingClassroomIds: action.downloadingClassroomIds });
            }

        case actions.CLOSE_UNASSIGN_MODAL_REQUEST:
            {
                return _extends({}, state, { isUnassignedModalOpen: false });
            }

        case actions.SEND_PASSWORD_LINK_REQUEST:
            {
                return _extends({}, state, { emailStatus: false, emailValidationMessage: '' });
            }

        case actions.SEND_PASSWORD_LINK_SUCCESS:
            {
                return _extends({}, state, { emailStatus: true, emailValidationMessage: '' });
            }

        case actions.SEND_PASSWORD_LINK_FAILURE:
            {
                return _extends({}, state, { emailStatus: false, emailValidationMessage: action.errorMessage });
            }

        case actions.SEND_VERIFICATION_EMAIL_LINK_REQUEST:
            {
                return _extends({}, state, { emailStatus: false, emailValidationMessage: '' });
            }

        case actions.SEND_VERIFICATION_EMAIL_LINK_SUCCESS:
            {
                return _extends({}, state, { emailStatus: true, emailValidationMessage: '' });
            }

        case actions.SEND_VERIFICATION_EMAIL_LINK_FAILURE:
            {
                return _extends({}, state, { emailStatus: false, emailValidationMessage: action.errorMessage });
            }

        case actions.RESET_PASSWORD_PARAMETERS:
            {
                return _extends({}, state, { emailStatus: false, emailValidationMessage: '' });
            }

        case actions.VALIDATION_ERROR_MODAL_RESET:
            {
                return _extends({}, state, { showEditTeacherValidationModal: false, enableSave: true });
            }

        default:
            return state;
    }
};

var _actions = __webpack_require__(128);

var actions = _interopRequireWildcard(_actions);

var _messages = __webpack_require__(267);

var _messages2 = _interopRequireDefault(_messages);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var assignEmptyTeacherObject = function assignEmptyTeacherObject() {
    return {
        title: '',
        firstName: '',
        lastName: '',
        emailAddress: '',
        userName: '',
        password: '',
        isResetpassword: false,
        adminPassword: '',
        newPassword: '',
        confirmationPassword: ''
    };
};

var initialState = {
    teacherDetail: assignEmptyTeacherObject(),
    updatingTeacher: false,
    isLoadingEditTeacherDetail: false,
    downloadingClassroomIds: new Set(),
    emailStatus: false,
    emailValidationMessage: '',
    showEditTeacherValidationModal: false,
    enableSave: false
};

/***/ }),
/* 837 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.getTeacherByUserProfileId = getTeacherByUserProfileId;
exports.editTeacherInformation = editTeacherInformation;
exports.downloadClassroomStudentsSignInCards = downloadClassroomStudentsSignInCards;
exports.getTeacherByUserProfileIdSaga = getTeacherByUserProfileIdSaga;
exports.unassignTeachersByClassId = unassignTeachersByClassId;
exports.unassignTeachersByClassIdSaga = unassignTeachersByClassIdSaga;
exports.editTeacherSaga = editTeacherSaga;
exports.downloadClassroomStudentsSignInCardSaga = downloadClassroomStudentsSignInCardSaga;
exports.sendPasswordLink = sendPasswordLink;
exports.sendPasswordLinkSaga = sendPasswordLinkSaga;
exports.sendEmailVerificationLink = sendEmailVerificationLink;
exports.sendEmailVerificationLinkSaga = sendEmailVerificationLinkSaga;

var _effects = __webpack_require__(32);

var _api = __webpack_require__(33);

var api = _interopRequireWildcard(_api);

var _actions = __webpack_require__(128);

var actions = _interopRequireWildcard(_actions);

var _messages = __webpack_require__(396);

var _messages2 = _interopRequireDefault(_messages);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var _marked = /*#__PURE__*/regeneratorRuntime.mark(getTeacherByUserProfileId),
    _marked2 = /*#__PURE__*/regeneratorRuntime.mark(editTeacherInformation),
    _marked3 = /*#__PURE__*/regeneratorRuntime.mark(downloadClassroomStudentsSignInCards),
    _marked4 = /*#__PURE__*/regeneratorRuntime.mark(getTeacherByUserProfileIdSaga),
    _marked5 = /*#__PURE__*/regeneratorRuntime.mark(unassignTeachersByClassId),
    _marked6 = /*#__PURE__*/regeneratorRuntime.mark(unassignTeachersByClassIdSaga),
    _marked7 = /*#__PURE__*/regeneratorRuntime.mark(editTeacherSaga),
    _marked8 = /*#__PURE__*/regeneratorRuntime.mark(downloadClassroomStudentsSignInCardSaga),
    _marked9 = /*#__PURE__*/regeneratorRuntime.mark(sendPasswordLink),
    _marked10 = /*#__PURE__*/regeneratorRuntime.mark(sendPasswordLinkSaga),
    _marked11 = /*#__PURE__*/regeneratorRuntime.mark(sendEmailVerificationLink),
    _marked12 = /*#__PURE__*/regeneratorRuntime.mark(sendEmailVerificationLinkSaga);

function getResponseText(message, params) {
    switch (message) {
        case 'EMAIL_USED_BY_ANOTHER_USER':
            return _messages2.default.emailUsedByAnotherUser.defaultMessage(params.email);
        default:
            return message;
    }
}

function getTeacherByUserProfileId(_ref) {
    var productId = _ref.productId,
        userProfileId = _ref.userProfileId;
    var payload;
    return regeneratorRuntime.wrap(function getTeacherByUserProfileId$(_context) {
        while (1) {
            switch (_context.prev = _context.next) {
                case 0:
                    _context.next = 2;
                    return (0, _effects.call)(api.getTeacherByUserProfileId, productId, userProfileId);

                case 2:
                    payload = _context.sent;

                    if (!(payload.status === 200)) {
                        _context.next = 12;
                        break;
                    }

                    payload.adminPassword = '';
                    payload.newPassword = '';
                    payload.confirmationPassword = '';
                    payload.isResetTeacherpassword = false;
                    _context.next = 10;
                    return (0, _effects.put)(actions.getTeacherSuccess(payload));

                case 10:
                    _context.next = 14;
                    break;

                case 12:
                    _context.next = 14;
                    return (0, _effects.put)(actions.getTeacherFailure());

                case 14:
                case 'end':
                    return _context.stop();
            }
        }
    }, _marked, this);
}

function editTeacherInformation(_ref2) {
    var teacher = _ref2.teacher,
        context = _ref2.context;
    var response, message;
    return regeneratorRuntime.wrap(function editTeacherInformation$(_context2) {
        while (1) {
            switch (_context2.prev = _context2.next) {
                case 0:
                    _context2.next = 2;
                    return (0, _effects.call)(api.editTeacher, teacher);

                case 2:
                    response = _context2.sent;

                    if (!(response.status === 200)) {
                        _context2.next = 8;
                        break;
                    }

                    _context2.next = 6;
                    return (0, _effects.put)(actions.editTeacherSuccess(context));

                case 6:
                    _context2.next = 16;
                    break;

                case 8:
                    if (!(response.status === 400 || response.status === 409)) {
                        _context2.next = 14;
                        break;
                    }

                    message = getResponseText(response.message, { email: teacher.emailAddress });
                    _context2.next = 12;
                    return (0, _effects.put)(actions.editTeacherFailure(false, message));

                case 12:
                    _context2.next = 16;
                    break;

                case 14:
                    _context2.next = 16;
                    return (0, _effects.put)(actions.editTeacherFailure(true, ''));

                case 16:
                case 'end':
                    return _context2.stop();
            }
        }
    }, _marked2, this);
}

function downloadClassroomStudentsSignInCards(_ref3) {
    var classroomId = _ref3.classroomId,
        productId = _ref3.productId,
        downloadingClassroomIds = _ref3.downloadingClassroomIds,
        SignInCardPageSizeType = _ref3.SignInCardPageSizeType;
    var response, downloadUrl;
    return regeneratorRuntime.wrap(function downloadClassroomStudentsSignInCards$(_context3) {
        while (1) {
            switch (_context3.prev = _context3.next) {
                case 0:
                    _context3.next = 2;
                    return (0, _effects.call)(api.downloadClassroomStudentsSignInCards, { productId: productId, classroomId: classroomId, SignInCardPageSizeType: SignInCardPageSizeType });

                case 2:
                    response = _context3.sent;

                    if (!(response.status === 201)) {
                        _context3.next = 9;
                        break;
                    }

                    downloadUrl = response.verb.url + '/' + response.data;
                    _context3.next = 7;
                    return (0, _effects.put)(actions.printClassroomStudentsSignInCardSuccess(classroomId, downloadUrl, downloadingClassroomIds));

                case 7:
                    _context3.next = 11;
                    break;

                case 9:
                    _context3.next = 11;
                    return (0, _effects.put)(actions.printClassroomStudentsSignInCardFailure(classroomId, downloadingClassroomIds));

                case 11:
                case 'end':
                    return _context3.stop();
            }
        }
    }, _marked3, this);
}

function getTeacherByUserProfileIdSaga() {
    return regeneratorRuntime.wrap(function getTeacherByUserProfileIdSaga$(_context4) {
        while (1) {
            switch (_context4.prev = _context4.next) {
                case 0:
                    _context4.next = 2;
                    return (0, _effects.takeLatest)(actions.GET_TEACHER_REQUEST, getTeacherByUserProfileId);

                case 2:
                case 'end':
                    return _context4.stop();
            }
        }
    }, _marked4, this);
}

function unassignTeachersByClassId(_ref4) {
    var userProfileId = _ref4.userProfileId,
        classId = _ref4.classId;
    var teacherDetail, response;
    return regeneratorRuntime.wrap(function unassignTeachersByClassId$(_context5) {
        while (1) {
            switch (_context5.prev = _context5.next) {
                case 0:
                    teacherDetail = {
                        classroomId: classId,
                        teachersProfileIdToUnassign: [userProfileId]
                    };
                    _context5.next = 3;
                    return (0, _effects.call)(api.unAssignTeachers, teacherDetail);

                case 3:
                    response = _context5.sent;

                    if (!(response.status === 200)) {
                        _context5.next = 9;
                        break;
                    }

                    _context5.next = 7;
                    return (0, _effects.put)(actions.unassignTeachersByClassIdSuccess());

                case 7:
                    _context5.next = 11;
                    break;

                case 9:
                    _context5.next = 11;
                    return (0, _effects.put)(actions.unassignTeachersByClassIdFailure());

                case 11:
                case 'end':
                    return _context5.stop();
            }
        }
    }, _marked5, this);
}

function unassignTeachersByClassIdSaga() {
    return regeneratorRuntime.wrap(function unassignTeachersByClassIdSaga$(_context6) {
        while (1) {
            switch (_context6.prev = _context6.next) {
                case 0:
                    _context6.next = 2;
                    return (0, _effects.takeLatest)(actions.UNASSIGN_TEACHERS_USING_CLASSID_REQUEST, unassignTeachersByClassId);

                case 2:
                case 'end':
                    return _context6.stop();
            }
        }
    }, _marked6, this);
}

function editTeacherSaga() {
    return regeneratorRuntime.wrap(function editTeacherSaga$(_context7) {
        while (1) {
            switch (_context7.prev = _context7.next) {
                case 0:
                    _context7.next = 2;
                    return (0, _effects.takeLatest)(actions.EDIT_TEACHER_REQUEST, editTeacherInformation);

                case 2:
                case 'end':
                    return _context7.stop();
            }
        }
    }, _marked7, this);
}

function downloadClassroomStudentsSignInCardSaga() {
    return regeneratorRuntime.wrap(function downloadClassroomStudentsSignInCardSaga$(_context8) {
        while (1) {
            switch (_context8.prev = _context8.next) {
                case 0:
                    _context8.next = 2;
                    return (0, _effects.takeEvery)(actions.PRINT_CLASSROOM_STUDENTS_SIGN_IN_CARD_REQUEST, downloadClassroomStudentsSignInCards);

                case 2:
                case 'end':
                    return _context8.stop();
            }
        }
    }, _marked8, this);
}

function sendPasswordLink(data) {
    var request, payload;
    return regeneratorRuntime.wrap(function sendPasswordLink$(_context9) {
        while (1) {
            switch (_context9.prev = _context9.next) {
                case 0:
                    request = { productId: data.productId, userProfileId: data.userProfileId };
                    _context9.next = 3;
                    return (0, _effects.call)(api.sendTeacherPassword, request);

                case 3:
                    payload = _context9.sent;

                    if (!(payload.status === 200)) {
                        _context9.next = 9;
                        break;
                    }

                    _context9.next = 7;
                    return (0, _effects.put)(actions.sendPasswordLinkSuccess(payload));

                case 7:
                    _context9.next = 11;
                    break;

                case 9:
                    _context9.next = 11;
                    return (0, _effects.put)(actions.sendPasswordLinkFailure(payload.message));

                case 11:
                case 'end':
                    return _context9.stop();
            }
        }
    }, _marked9, this);
}

function sendPasswordLinkSaga() {
    return regeneratorRuntime.wrap(function sendPasswordLinkSaga$(_context10) {
        while (1) {
            switch (_context10.prev = _context10.next) {
                case 0:
                    _context10.next = 2;
                    return (0, _effects.takeEvery)(actions.SEND_PASSWORD_LINK_REQUEST, sendPasswordLink);

                case 2:
                case 'end':
                    return _context10.stop();
            }
        }
    }, _marked10, this);
}

function sendEmailVerificationLink(data) {
    var request, payload;
    return regeneratorRuntime.wrap(function sendEmailVerificationLink$(_context11) {
        while (1) {
            switch (_context11.prev = _context11.next) {
                case 0:
                    request = { userProfileId: data.userProfileId };
                    _context11.next = 3;
                    return (0, _effects.call)(api.sendVerificationEmail, request);

                case 3:
                    payload = _context11.sent;

                    if (!(payload.status === 200)) {
                        _context11.next = 9;
                        break;
                    }

                    _context11.next = 7;
                    return (0, _effects.put)(actions.sendVerificationEmailLinkSuccess(payload));

                case 7:
                    _context11.next = 11;
                    break;

                case 9:
                    _context11.next = 11;
                    return (0, _effects.put)(actions.sendVerificationEmailLinkFailure(payload.message));

                case 11:
                case 'end':
                    return _context11.stop();
            }
        }
    }, _marked11, this);
}

function sendEmailVerificationLinkSaga() {
    return regeneratorRuntime.wrap(function sendEmailVerificationLinkSaga$(_context12) {
        while (1) {
            switch (_context12.prev = _context12.next) {
                case 0:
                    _context12.next = 2;
                    return (0, _effects.takeEvery)(actions.SEND_VERIFICATION_EMAIL_LINK_REQUEST, sendEmailVerificationLink);

                case 2:
                case 'end':
                    return _context12.stop();
            }
        }
    }, _marked12, this);
}

/***/ }),
/* 838 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = __webpack_require__(28);

var _redux = __webpack_require__(35);

var _reactIntl = __webpack_require__(2);

var _index = __webpack_require__(711);

var _index2 = _interopRequireDefault(_index);

var _actions = __webpack_require__(44);

var _actions2 = __webpack_require__(264);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ExtendResultContainer = function (_Component) {
    _inherits(ExtendResultContainer, _Component);

    function ExtendResultContainer(props) {
        _classCallCheck(this, ExtendResultContainer);

        var _this = _possibleConstructorReturn(this, (ExtendResultContainer.__proto__ || Object.getPrototypeOf(ExtendResultContainer)).call(this, props));

        var product = props.product;

        props.onVerifyExtendResultInfoRequest(product.id);
        return _this;
    }

    _createClass(ExtendResultContainer, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            this.props.getYearGroups();
        }
    }, {
        key: 'render',
        value: function render() {
            return _react2.default.createElement(_index2.default, this.props);
        }
    }]);

    return ExtendResultContainer;
}(_react.Component);

ExtendResultContainer.propTypes = {
    getYearGroups: _propTypes2.default.func,
    onVerifyExtendResultInfoRequest: _propTypes2.default.func,
    product: _propTypes2.default.object
};

var mapStateToProps = function mapStateToProps(state) {
    return {
        extendResultInfo: state.extendResult.extendResultInfo,
        extendResultForm: state.extendResult.extendResultForm,
        isExtending: state.extendResult.isExtending,
        showExtendInfoError: state.extendResult.showExtendInfoError,
        resultsAlreadyExtended: state.extendResult.resultsAlreadyExtended,
        outOfExtendPeriod: state.extendResult.outOfExtendPeriod,
        rollOverRequired: state.extendResult.rollOverRequired,
        currentAcademicYear: state.extendResult.currentAcademicYear,
        extendingResultsStatusType: state.extendResult.extendingResultsStatusType,
        isFail: state.extendResult.isFail,
        isSuccess: state.extendResult.isSuccess,
        yearGroupsToBeExtended: state.extendResult.yearGroupsToBeExtended,
        showOkButton: state.extendResult.showOkButton,
        yearGroups: state.schoolRoll.yearGroups,
        product: state.product
    };
};

function mapDispatchToProps(dispatch) {
    return (0, _redux.bindActionCreators)({
        closeFailureModal: _actions2.closeFailureModal,
        extendResults: _actions2.extendResults,
        getYearGroups: _actions.getYearGroups,
        onProceedExtendResultRequest: _actions2.onProceedExtendResultRequest,
        onCloseExtendResultError: _actions2.onCloseExtendResultError,
        setIdsToExtend: _actions2.setIdsToExtend,
        onVerifyExtendResultInfoRequest: _actions2.onVerifyExtendResultInfoRequest,
        onShowExtendResultInfo: _actions2.onShowExtendResultInfo
    }, dispatch);
}

exports.default = (0, _reactIntl.injectIntl)((0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(ExtendResultContainer));

/***/ }),
/* 839 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.default = function () {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initState;
    var action = arguments[1];

    switch (action.type) {
        case actions.VERIFY_EXTEND_RESULT_INFO_SUCCESS:
            {
                return _extends({}, state, {
                    currentAcademicYear: action.currentAcademicYear,
                    extendingResultsStatusType: action.extendingResultsStatusType
                });
            }

        case actions.SHOW_EXTEND_RESULT_INFO:
            {
                return _extends({}, state, { extendResultForm: false, extendResultInfo: true, showOkButton: action.showOkButton });
            }

        case actions.HIDE_EXTEND_RESULT_INFO:
        case actions.CLOSE_EXTEND_RESULT_ERROR:
            {
                return _extends({}, state, { extendingResultsStatusType: '', showOkButton: false });
            }

        case actions.PROCESS_EXTEND_RESULT_REQUEST:
            {
                return _extends({}, state, { extendResultForm: true, extendResultInfo: false });
            }

        case actions.SET_IDS_TO_EXTEND:
            {
                return _extends({}, state, { yearGroupsToBeExtended: action.yearGroupsToBeExtended });
            }

        case actions.EXTEND_RESULTS:
            {
                return _extends({}, state, { isExtending: true, isSuccess: false, isFail: false });
            }

        case actions.EXTEND_RESULTS_SUCCESS:
            {
                return _extends({}, state, { isExtending: false, isSuccess: true });
            }

        case actions.EXTEND_RESULTS_FAILURE:
            {
                return _extends({}, state, { isExtending: false, isSuccess: false, isFail: true });
            }

        case actions.CLOSE_EXTEND_RESULTS_MODAL:
            {
                return _extends({}, state, { isSuccess: false, isFail: false });
            }

        default:
            return _extends({}, state);
    }
};

var _actions = __webpack_require__(264);

var actions = _interopRequireWildcard(_actions);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var initState = {
    extendResultInfo: true,
    extendResultForm: false,
    extendingResultsStatusType: '',
    isExtending: false,
    showOkButton: false,
    yearGroupsToBeExtended: {}
};

/***/ }),
/* 840 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.verifyExtendResult = verifyExtendResult;
exports.verifyExtendResultSaga = verifyExtendResultSaga;
exports.extendResults = extendResults;
exports.extendResultSaga = extendResultSaga;

var _effects = __webpack_require__(32);

var _api = __webpack_require__(33);

var api = _interopRequireWildcard(_api);

var _actions = __webpack_require__(264);

var actions = _interopRequireWildcard(_actions);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var _marked = /*#__PURE__*/regeneratorRuntime.mark(verifyExtendResult),
    _marked2 = /*#__PURE__*/regeneratorRuntime.mark(verifyExtendResultSaga),
    _marked3 = /*#__PURE__*/regeneratorRuntime.mark(extendResults),
    _marked4 = /*#__PURE__*/regeneratorRuntime.mark(extendResultSaga);

function verifyExtendResult(productId) {
    var response;
    return regeneratorRuntime.wrap(function verifyExtendResult$(_context) {
        while (1) {
            switch (_context.prev = _context.next) {
                case 0:
                    _context.next = 2;
                    return (0, _effects.call)(api.extendingResultsStatus, productId);

                case 2:
                    response = _context.sent;

                    if (!(response.status === 200)) {
                        _context.next = 8;
                        break;
                    }

                    _context.next = 6;
                    return (0, _effects.put)(actions.onVerifyExtendResultInfoSuccess(_extends({}, response.data)));

                case 6:
                    _context.next = 10;
                    break;

                case 8:
                    _context.next = 10;
                    return (0, _effects.put)(actions.onVerifyExtendResultInfoFailure());

                case 10:
                case 'end':
                    return _context.stop();
            }
        }
    }, _marked, this);
}

function verifyExtendResultSaga() {
    return regeneratorRuntime.wrap(function verifyExtendResultSaga$(_context2) {
        while (1) {
            switch (_context2.prev = _context2.next) {
                case 0:
                    _context2.next = 2;
                    return (0, _effects.takeLatest)(actions.VERIFY_EXTEND_RESULT_INFO_REQUEST, verifyExtendResult);

                case 2:
                case 'end':
                    return _context2.stop();
            }
        }
    }, _marked2, this);
}

function extendResults(_ref) {
    var selectedProductId = _ref.selectedProductId,
        selectedYeargroups = _ref.selectedYeargroups;
    var response;
    return regeneratorRuntime.wrap(function extendResults$(_context3) {
        while (1) {
            switch (_context3.prev = _context3.next) {
                case 0:
                    _context3.next = 2;
                    return (0, _effects.call)(api.extendResults, selectedProductId, selectedYeargroups);

                case 2:
                    response = _context3.sent;

                    if (!(response.status === 200)) {
                        _context3.next = 8;
                        break;
                    }

                    _context3.next = 6;
                    return (0, _effects.put)(actions.extendResultsSuccess(_extends({}, response.data)));

                case 6:
                    _context3.next = 10;
                    break;

                case 8:
                    _context3.next = 10;
                    return (0, _effects.put)(actions.extendResultsFailure());

                case 10:
                case 'end':
                    return _context3.stop();
            }
        }
    }, _marked3, this);
}

function extendResultSaga() {
    return regeneratorRuntime.wrap(function extendResultSaga$(_context4) {
        while (1) {
            switch (_context4.prev = _context4.next) {
                case 0:
                    _context4.next = 2;
                    return (0, _effects.takeLatest)(actions.EXTEND_RESULTS, extendResults);

                case 2:
                case 'end':
                    return _context4.stop();
            }
        }
    }, _marked4, this);
}

/***/ }),
/* 841 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
/*
 *
 * LanguageProvider constants
 *
 */
var CHANGE_LOCALE = 'app/LanguageProvider/CHANGE_LOCALE';
exports.default = CHANGE_LOCALE;

/***/ }),
/* 842 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.LanguageProvider = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = __webpack_require__(28);

var _reselect = __webpack_require__(582);

var _reactIntl = __webpack_require__(2);

var _selectors = __webpack_require__(844);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /*
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * LanguageProvider
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * this component connects the redux state language locale to the
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * IntlProvider component and i18n messages (loaded from `app/translations`)
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */

var LanguageProvider = exports.LanguageProvider = function (_PureComponent) {
    _inherits(LanguageProvider, _PureComponent);

    function LanguageProvider() {
        _classCallCheck(this, LanguageProvider);

        return _possibleConstructorReturn(this, (LanguageProvider.__proto__ || Object.getPrototypeOf(LanguageProvider)).apply(this, arguments));
    }

    _createClass(LanguageProvider, [{
        key: 'render',
        value: function render() {
            return _react2.default.createElement(
                _reactIntl.IntlProvider,
                {
                    key: this.props.locale,
                    locale: this.props.locale,
                    messages: this.props.messages[this.props.locale]
                },
                _react2.default.Children.only(this.props.children)
            );
        }
    }]);

    return LanguageProvider;
}(_react.PureComponent);

LanguageProvider.propTypes = {
    locale: _propTypes2.default.string,
    messages: _propTypes2.default.object,
    children: _propTypes2.default.element.isRequired
};

var mapStateToProps = (0, _reselect.createSelector)((0, _selectors.makeSelectLocale)(), function (locale) {
    return {
        locale: locale
    };
});

exports.default = (0, _reactRedux.connect)(mapStateToProps)(LanguageProvider);

/***/ }),
/* 843 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.initialState = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; /*
                                                                                                                                                                                                                                                                   *
                                                                                                                                                                                                                                                                   * LanguageProvider reducer
                                                                                                                                                                                                                                                                   *
                                                                                                                                                                                                                                                                   */

var _constants = __webpack_require__(841);

var _constants2 = _interopRequireDefault(_constants);

var _i18n = __webpack_require__(129);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var initialState = exports.initialState = {
    locale: _i18n.DEFAULT_LOCALE
};

function languageProviderReducer() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
    var action = arguments[1];

    switch (action.type) {
        case _constants2.default:
            {
                return _extends({}, state, { locale: action.locale });
            }
        default:
            return state;
    }
}

exports.default = languageProviderReducer;

/***/ }),
/* 844 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.makeSelectLocale = exports.selectLanguage = undefined;

var _reselect = __webpack_require__(582);

/**
 * Direct selector to the languageToggle state domain
 */
var selectLanguage = function selectLanguage(state) {
  return state.language;
};

/**
 * Select the language locale
 */

var makeSelectLocale = function makeSelectLocale() {
  return (0, _reselect.createSelector)(selectLanguage, function (languageState) {
    return languageState.locale;
  });
};

exports.selectLanguage = selectLanguage;
exports.makeSelectLocale = makeSelectLocale;

/***/ }),
/* 845 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.fetchCourseDetailsFailure = exports.fetchCourseDetailsSuccess = exports.fetchCourseDetails = exports.hideCourseDetails = exports.showCourseDetails = exports.assignCoursesFailure = exports.assignCoursesSuccess = exports.assignCoursesRequest = exports.checkCommonTasksFailure = exports.checkCommonTasksSuccess = exports.getDefaultCoursesFailure = exports.getDefaultCoursesSuccess = exports.getDefaultCourses = undefined;

var _actionTypes = __webpack_require__(97);

var actionTypes = _interopRequireWildcard(_actionTypes);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var getDefaultCourses = exports.getDefaultCourses = function getDefaultCourses() {
    return { type: actionTypes.GET_ADMIN_DEFAULT_COURSE_REQUEST };
};

var getDefaultCoursesSuccess = exports.getDefaultCoursesSuccess = function getDefaultCoursesSuccess(data) {
    return { type: actionTypes.GET_ADMIN_DEFAULT_COURSE_SUCCESS, data: data };
};

var getDefaultCoursesFailure = exports.getDefaultCoursesFailure = function getDefaultCoursesFailure() {
    return { type: actionTypes.GET_ADMIN_DEFAULT_COURSE_FAILURE };
};

var checkCommonTasksSuccess = exports.checkCommonTasksSuccess = function checkCommonTasksSuccess(assignedTasksId) {
    return { type: actionTypes.CHECK_COMMON_TASKS_SUCCESS, assignedTasksId: assignedTasksId };
};

var checkCommonTasksFailure = exports.checkCommonTasksFailure = function checkCommonTasksFailure() {
    return { type: actionTypes.CHECK_COMMON_TASKS_FAILURE };
};

var assignCoursesRequest = exports.assignCoursesRequest = function assignCoursesRequest(changeCourseRequests) {
    return { type: actionTypes.ASSIGN_COURSES_REQUEST, changeCourseRequests: changeCourseRequests };
};

var assignCoursesSuccess = exports.assignCoursesSuccess = function assignCoursesSuccess(assigningCourses) {
    return { type: actionTypes.ASSIGN_COURSES_SUCCESS, assigningCourses: assigningCourses };
};

var assignCoursesFailure = exports.assignCoursesFailure = function assignCoursesFailure(assigningCourses) {
    return { type: actionTypes.ASSIGN_COURSES_FAILURE, assigningCourses: assigningCourses };
};

var showCourseDetails = exports.showCourseDetails = function showCourseDetails(courseId) {
    return { type: actionTypes.SHOW_COURSE_DETAILS, courseId: courseId };
};

var hideCourseDetails = exports.hideCourseDetails = function hideCourseDetails() {
    return { type: actionTypes.HIDE_COURSE_DETAILS };
};

var fetchCourseDetails = exports.fetchCourseDetails = function fetchCourseDetails() {
    return { type: actionTypes.FETCH_COURSE_DETAILS_REQUEST };
};

var fetchCourseDetailsSuccess = exports.fetchCourseDetailsSuccess = function fetchCourseDetailsSuccess(data) {
    return { type: actionTypes.FETCH_COURSE_DETAILS_SUCCESS, courseDetails: data };
};

var fetchCourseDetailsFailure = exports.fetchCourseDetailsFailure = function fetchCourseDetailsFailure() {
    return { type: actionTypes.FETCH_COURSE_DETAILS_FAILURE };
};

/***/ }),
/* 846 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __webpack_require__(28);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactIntl = __webpack_require__(2);

var _actionTypes = __webpack_require__(97);

var actionTypes = _interopRequireWildcard(_actionTypes);

var _manageAssignedCourse = __webpack_require__(731);

var _manageAssignedCourse2 = _interopRequireDefault(_manageAssignedCourse);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ManageAssignedCourses = function (_Component) {
    _inherits(ManageAssignedCourses, _Component);

    function ManageAssignedCourses() {
        var _ref;

        var _temp, _this, _ret;

        _classCallCheck(this, ManageAssignedCourses);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = ManageAssignedCourses.__proto__ || Object.getPrototypeOf(ManageAssignedCourses)).call.apply(_ref, [this].concat(args))), _this), _this.checkCommonTasks = function (_ref2) {
            var isUPFSelected = _ref2.isUPFSelected,
                isLegacySelected = _ref2.isLegacySelected,
                isNewCoursesSelected = _ref2.isNewCoursesSelected,
                classroomId = _ref2.classroomId,
                groupId = _ref2.groupId,
                courseId = _ref2.courseId;

            if (isLegacySelected) {
                _this.props.dispatch({
                    type: actionTypes.CHECK_COMMON_TASKS_REQUEST,
                    classroomId: classroomId,
                    groupId: groupId,
                    courseId: courseId
                });
            } else if (isUPFSelected) {
                _this.props.dispatch({ type: actionTypes.SET_ASSIGN_UPF_COURSE, payload: { id: courseId } });
            } else if (isNewCoursesSelected) {
                _this.props.dispatch({ type: actionTypes.SET_ASSIGN_NEW_COURSE, payload: { id: courseId } });
            }
        }, _this.saveAssignCourses = function (changeCourseRequests) {
            _this.props.dispatch({ type: actionTypes.ASSIGN_COURSES_REQUEST, changeCourseRequests: changeCourseRequests });
        }, _this.hideCourseDetails = function () {
            _this.props.dispatch({ type: actionTypes.HIDE_COURSE_DETAILS });
        }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    _createClass(ManageAssignedCourses, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            var _props = this.props,
                selectedProduct = _props.selectedProduct,
                dispatch = _props.dispatch;

            dispatch({ type: actionTypes.GET_YEAR_GROUPS_REQUEST });
            dispatch({
                type: actionTypes.GET_CLASSROOMS_REQUEST,
                productId: selectedProduct.id,
                isClassroomDataLoaded: false
            });
        }
    }, {
        key: 'componentWillReceiveProps',
        value: function componentWillReceiveProps(nextProps) {
            var dispatch = this.props.dispatch;
            var selectedProduct = nextProps.selectedProduct,
                isYearGroupDataLoaded = nextProps.isYearGroupDataLoaded,
                isClassroomDataLoaded = nextProps.isClassroomDataLoaded;


            if (!isYearGroupDataLoaded && isYearGroupDataLoaded !== this.props.isYearGroupDataLoaded) {
                dispatch({ type: actionTypes.GET_YEAR_GROUPS_REQUEST });
            }

            if (!isClassroomDataLoaded && isClassroomDataLoaded !== this.props.isClassroomDataLoaded) {
                dispatch({
                    type: actionTypes.GET_CLASSROOMS_REQUEST,
                    productId: selectedProduct.id,
                    isClassroomDataLoaded: false
                });
            }
        }
    }, {
        key: 'render',
        value: function render() {
            var _props2 = this.props,
                fetchingCourse = _props2.fetchingCourse,
                isYearGroupDataLoaded = _props2.isYearGroupDataLoaded,
                isClassroomDataLoaded = _props2.isClassroomDataLoaded;

            var isFetching = !isYearGroupDataLoaded || !isClassroomDataLoaded || fetchingCourse;
            return _react2.default.createElement(_manageAssignedCourse2.default, _extends({
                fetching: isFetching
            }, this.props, {
                handleOnAssign: this.checkCommonTasks,
                handleOnSaveAssignCourses: this.saveAssignCourses,
                hideCourseDetails: this.hideCourseDetails
            }));
        }
    }]);

    return ManageAssignedCourses;
}(_react.Component);

ManageAssignedCourses.propTypes = {
    isYearGroupDataLoaded: _propTypes2.default.bool,
    isClassroomDataLoaded: _propTypes2.default.bool,
    selectedProduct: _propTypes2.default.object,
    fetchingCourse: _propTypes2.default.bool,
    dispatch: _propTypes2.default.func.isRequired,
    assigningCourses: _propTypes2.default.bool
};


function mapStateToProps() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    return _extends({}, state, {
        selectedProduct: state.product,
        yearGroups: state.schoolRoll.yearGroups,
        classrooms: state.classRoll.classrooms,
        isYearGroupDataLoaded: state.schoolRoll.isYearGroupDataLoaded,
        isClassroomDataLoaded: state.classRoll.isClassroomDataLoaded,
        assignedTasksId: state.assignCourseAdmin.assignedTasksId,
        upfCourseId: state.assignCourseAdmin.upfCourseId,
        showAssignErrorModal: state.assignCourseAdmin.showAssignErrorModal,
        showSaveErrorModal: state.assignCourseAdmin.showSaveErrorModal,
        activateModal: state.assignCourseAdmin.activateModal,
        assigningCourses: state.assignCourseAdmin.assigningCourses,
        isAssignEvent: state.assignCourseAdmin.isAssignEvent,
        courseDetails: state.assignCourseAdmin.courseDetails,
        isCourseModalVisible: state.assignCourseAdmin.isCourseModalVisible,
        fetchingCourse: state.assignCourseAdmin.fetchingCourse,
        defaultCourses: state.assignCourseAdmin.defaultCourses
    });
}

exports.default = (0, _reactIntl.injectIntl)((0, _reactRedux.connect)(mapStateToProps)(ManageAssignedCourses));

/***/ }),
/* 847 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.default = function () {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
    var action = arguments[1];

    switch (action.type) {
        case actionTypes.GET_ADMIN_DEFAULT_COURSE_FAILURE:
            {
                return _extends({}, state);
            }
        case actionTypes.GET_ADMIN_DEFAULT_COURSE_SUCCESS:
            {
                return _extends({}, state, { defaultCourses: action.data });
            }
        case actionTypes.GET_ADMIN_DEFAULT_COURSE_REQUEST:
            {
                return _extends({}, state);
            }
        case actionTypes.CHECK_COMMON_TASKS_SUCCESS:
            {
                return _extends({}, state, {
                    assignedTasksId: action.assignedTasksId,
                    activateModal: action.assignedTasksId.length > 0,
                    isAssignEvent: true
                });
            }
        case actionTypes.SET_ASSIGN_UPF_COURSE:
            {
                return _extends({}, state, { isAssignEvent: true, upfCourseId: action.payload.id });
            }

        case actionTypes.SET_ASSIGN_NEW_COURSE:
            {
                return _extends({}, state, { isAssignEvent: true, conquestCourseId: action.payload.id });
            }
        case actionTypes.CHECK_COMMON_TASKS_FAILURE:
            {
                return _extends({}, state, { showAssignErrorModal: true, activateModal: true
                });
            }
        case actionTypes.CANCEL_ASSIGN_REQUEST:
            {
                return _extends({}, state, { isAssignEvent: false
                });
            }
        case actionTypes.ACTIVATE_MODAL_REQUEST:
            {
                return _extends({}, state, { activateModal: true
                });
            }
        case actionTypes.DEACTIVATE_MODAL_REQUEST:
            {
                return _extends({}, state, { activateModal: false
                });
            }
        case actionTypes.ASSIGN_COURSES_REQUEST:
            {
                return _extends({}, state, { assigningCourses: true
                });
            }
        case actionTypes.ASSIGN_COURSES_SUCCESS:
            {
                return _extends({}, state, {
                    assigningCourses: action.assigningCourses,
                    showAssignSuccessToast: true
                });
            }
        case actionTypes.ASSIGN_COURSES_FAILURE:
            {
                return _extends({}, state, {
                    assigningCourses: action.assigningCourses,
                    showSaveErrorModal: false,
                    showAssignErrorToast: true,
                    activateModal: false
                });
            }
        case actionTypes.RESET_TOASTER_STATE:
            {
                return _extends({}, state, {
                    showAssignSuccessToast: false,
                    showAssignErrorToast: false
                });
            }
        case actionTypes.SHOW_COURSE_DETAILS:
            {
                return _extends({}, state, { selectedCourseId: action.courseId });
            }
        case actionTypes.HIDE_COURSE_DETAILS:
            {
                return _extends({}, state, { courseDetails: initialState.courseDetails, selectedCourseId: false, isCourseModalVisible: false });
            }
        case actionTypes.FETCH_COURSE_DETAILS_REQUEST:
            {
                return _extends({}, state, { fetchingCourse: true });
            }
        case actionTypes.FETCH_COURSE_DETAILS_SUCCESS:
            {
                return _extends({}, state, { courseDetails: action.courseDetails, fetchingCourse: false, isCourseModalVisible: true });
            }
        case actionTypes.FETCH_COURSE_DETAILS_FAILURE:
            {
                return _extends({}, state, { fetchingCourse: false });
            }
        case actionTypes.GET_NEW_COURSES_REQUEST:
            {
                return _extends({}, state, {
                    isNewCoursesFetching: action.isNewCoursesFetching
                });
            }

        case actionTypes.GET_NEW_COURSES_SUCCESS:
            {
                return _extends({}, state, {
                    newCourses: action.data,
                    isNewCoursesFetching: false
                });
            }

        case actionTypes.GET_NEW_COURSES_FAILURE:
            {
                return _extends({}, state, {
                    newCourses: [],
                    isNewCoursesFetching: false
                });
            }
        default:
            return _extends({}, state);
    }
};

var _actionTypes = __webpack_require__(97);

var actionTypes = _interopRequireWildcard(_actionTypes);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var initialState = {
    assignedTasksId: [],
    showAssignErrorModal: false,
    showSaveErrorModal: false,
    showAssignErrorToast: false,
    showAssignSuccessToast: false,
    activateModal: false,
    assigningCourses: false,
    isAssignEvent: false,
    isCourseModalVisible: false
};

/***/ }),
/* 848 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.getDefaultCourses = getDefaultCourses;
exports.getDefaultCoursesSaga = getDefaultCoursesSaga;
exports.checkCommonTasks = checkCommonTasks;
exports.checkCommonTasksSaga = checkCommonTasksSaga;
exports.assignCourses = assignCourses;
exports.assignCoursesSaga = assignCoursesSaga;

var _effects = __webpack_require__(32);

var _api = __webpack_require__(33);

var api = _interopRequireWildcard(_api);

var _actions = __webpack_require__(845);

var actions = _interopRequireWildcard(_actions);

var _actionTypes = __webpack_require__(97);

var actionTypes = _interopRequireWildcard(_actionTypes);

var _actions2 = __webpack_require__(154);

var assignCourseActions = _interopRequireWildcard(_actions2);

var _product = __webpack_require__(194);

var _product2 = _interopRequireDefault(_product);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var _marked = /*#__PURE__*/regeneratorRuntime.mark(getDefaultCourses),
    _marked2 = /*#__PURE__*/regeneratorRuntime.mark(getDefaultCoursesSaga),
    _marked3 = /*#__PURE__*/regeneratorRuntime.mark(checkCommonTasks),
    _marked4 = /*#__PURE__*/regeneratorRuntime.mark(checkCommonTasksSaga),
    _marked5 = /*#__PURE__*/regeneratorRuntime.mark(assignCourses),
    _marked6 = /*#__PURE__*/regeneratorRuntime.mark(assignCoursesSaga);

function getDefaultCourses() {
    var productId, payload;
    return regeneratorRuntime.wrap(function getDefaultCourses$(_context) {
        while (1) {
            switch (_context.prev = _context.next) {
                case 0:
                    _context.next = 2;
                    return (0, _effects.select)(_product2.default);

                case 2:
                    productId = _context.sent;
                    _context.next = 5;
                    return (0, _effects.call)(api.getDefaultCourses, { productId: productId });

                case 5:
                    payload = _context.sent;

                    if (!(payload.status === 200)) {
                        _context.next = 11;
                        break;
                    }

                    _context.next = 9;
                    return (0, _effects.put)(actions.getDefaultCoursesSuccess(payload.data));

                case 9:
                    _context.next = 13;
                    break;

                case 11:
                    _context.next = 13;
                    return (0, _effects.put)(actions.getDefaultCoursesFailure());

                case 13:
                case 'end':
                    return _context.stop();
            }
        }
    }, _marked, this);
}

function getDefaultCoursesSaga() {
    return regeneratorRuntime.wrap(function getDefaultCoursesSaga$(_context2) {
        while (1) {
            switch (_context2.prev = _context2.next) {
                case 0:
                    _context2.next = 2;
                    return (0, _effects.takeLatest)(actionTypes.GET_ADMIN_DEFAULT_COURSE_REQUEST, getDefaultCourses);

                case 2:
                case 'end':
                    return _context2.stop();
            }
        }
    }, _marked2, this);
}

function checkCommonTasks(data) {
    var payload;
    return regeneratorRuntime.wrap(function checkCommonTasks$(_context3) {
        while (1) {
            switch (_context3.prev = _context3.next) {
                case 0:
                    _context3.next = 2;
                    return (0, _effects.call)(api.checkCommonTasks, data);

                case 2:
                    payload = _context3.sent;

                    if (!(payload.status === 200)) {
                        _context3.next = 8;
                        break;
                    }

                    _context3.next = 6;
                    return (0, _effects.put)(actions.checkCommonTasksSuccess(payload.data.assignedTasksId));

                case 6:
                    _context3.next = 10;
                    break;

                case 8:
                    _context3.next = 10;
                    return (0, _effects.put)(actions.checkCommonTasksFailure());

                case 10:
                    _context3.next = 12;
                    return (0, _effects.put)(assignCourseActions.deselectCourses());

                case 12:
                case 'end':
                    return _context3.stop();
            }
        }
    }, _marked3, this);
}

function checkCommonTasksSaga() {
    return regeneratorRuntime.wrap(function checkCommonTasksSaga$(_context4) {
        while (1) {
            switch (_context4.prev = _context4.next) {
                case 0:
                    _context4.next = 2;
                    return (0, _effects.takeLatest)(actionTypes.CHECK_COMMON_TASKS_REQUEST, checkCommonTasks);

                case 2:
                case 'end':
                    return _context4.stop();
            }
        }
    }, _marked4, this);
}

function assignCourses(_ref) {
    var changeCourseRequests = _ref.changeCourseRequests;
    var response;
    return regeneratorRuntime.wrap(function assignCourses$(_context5) {
        while (1) {
            switch (_context5.prev = _context5.next) {
                case 0:
                    _context5.next = 2;
                    return (0, _effects.call)(api.assignCourses, changeCourseRequests);

                case 2:
                    response = _context5.sent;

                    if (!(response.status === 200)) {
                        _context5.next = 8;
                        break;
                    }

                    _context5.next = 6;
                    return (0, _effects.put)(actions.assignCoursesSuccess(false));

                case 6:
                    _context5.next = 10;
                    break;

                case 8:
                    _context5.next = 10;
                    return (0, _effects.put)(actions.assignCoursesFailure(false));

                case 10:
                case 'end':
                    return _context5.stop();
            }
        }
    }, _marked5, this);
}

function assignCoursesSaga() {
    return regeneratorRuntime.wrap(function assignCoursesSaga$(_context6) {
        while (1) {
            switch (_context6.prev = _context6.next) {
                case 0:
                    _context6.next = 2;
                    return (0, _effects.takeLatest)(actionTypes.ASSIGN_COURSES_REQUEST, assignCourses);

                case 2:
                case 'end':
                    return _context6.stop();
            }
        }
    }, _marked6, this);
}

/***/ }),
/* 849 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = __webpack_require__(28);

var _redux = __webpack_require__(35);

var _reactIntl = __webpack_require__(2);

var _actions = __webpack_require__(397);

var _index = __webpack_require__(733);

var _index2 = _interopRequireDefault(_index);

var _actions2 = __webpack_require__(154);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ManageDefaultCourses = function (_Component) {
    _inherits(ManageDefaultCourses, _Component);

    function ManageDefaultCourses() {
        var _ref;

        var _temp, _this, _ret;

        _classCallCheck(this, ManageDefaultCourses);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = ManageDefaultCourses.__proto__ || Object.getPrototypeOf(ManageDefaultCourses)).call.apply(_ref, [this].concat(args))), _this), _this.deselectCourses = function () {
            _this.props.deselectCourses();
        }, _this.saveDefaultCourses = function (yearGroupCourses) {
            _this.props.saveDefaultCourses(yearGroupCourses);
        }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    _createClass(ManageDefaultCourses, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            this.props.getDefaultCourses();
        }
    }, {
        key: 'componentWillReceiveProps',
        value: function componentWillReceiveProps(nextProps) {
            var isDefaultCoursesLoaded = nextProps.isDefaultCoursesLoaded;


            if (!isDefaultCoursesLoaded && isDefaultCoursesLoaded !== this.props.isDefaultCoursesLoaded) {
                this.props.getDefaultCourses();
            }
        }
    }, {
        key: 'render',
        value: function render() {
            var _props = this.props,
                fetchingCourse = _props.fetchingCourse,
                isDefaultCoursesLoaded = _props.isDefaultCoursesLoaded;

            var isFetching = !isDefaultCoursesLoaded || fetchingCourse;

            return _react2.default.createElement(
                'div',
                null,
                _react2.default.createElement(_index2.default, _extends({
                    deselectCourses: this.deselectCourses,
                    fetching: isFetching,
                    handleOnSave: this.saveDefaultCourses
                }, this.props))
            );
        }
    }]);

    return ManageDefaultCourses;
}(_react.Component);

ManageDefaultCourses.propTypes = {
    fetchingCourse: _propTypes2.default.bool,
    getDefaultCourses: _propTypes2.default.func,
    saveDefaultCourses: _propTypes2.default.func,
    isDefaultCoursesLoaded: _propTypes2.default.bool,
    selectedProduct: _propTypes2.default.object,
    onSuccessfulSave: _propTypes2.default.bool,
    deselectCourses: _propTypes2.default.func
};


function mapStateToProps() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    return _extends({}, state, {
        defaultCourses: state.courseAdmin.defaultCourses,
        upfCourses: state.courseAdmin.upfCourses,
        isDefaultCoursesLoaded: state.courseAdmin.isDefaultCoursesLoaded,
        savingDefaultCourses: state.courseAdmin.savingDefaultCourses,
        onSuccessfulSave: state.courseAdmin.onSuccessfulSave,
        isCourseModalVisible: state.courseAdmin.isCourseModalVisible,
        courseDetails: state.courseAdmin.courseDetails,
        fetchingCourse: state.courseAdmin.fetchingCourse,
        selectedProduct: state.product,
        conquestCourses: state.courseAdmin.conquestCourses
    });
}

function mapDispatchToProps(dispatch) {
    return (0, _redux.bindActionCreators)({
        getDefaultCourses: _actions.getDefaultCourses,
        saveDefaultCourses: _actions.saveDefaultCourses,
        showCourseDetails: _actions.showCourseDetails,
        hideCourseDetails: _actions.hideCourseDetails,
        deselectCourses: _actions2.deselectCourses
    }, dispatch);
}

exports.default = (0, _reactIntl.injectIntl)((0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(ManageDefaultCourses));

/***/ }),
/* 850 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.default = function () {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
    var action = arguments[1];

    switch (action.type) {
        case actions.GET_DEFAULT_COURSE_SUCCESS:
            {
                return _extends({}, state, {
                    defaultCourses: (0, _utils.customDefaultCourses)(action.data.defaultCourses),
                    upfCourses: (0, _utils.customDefaultCourses)(action.data.upfCourses),
                    conquestCourses: (0, _utils.customDefaultCourses)(action.data.conquestCourses),
                    isDefaultCoursesLoaded: true,
                    onSuccessfulSave: false
                });
            }
        case actions.GET_DEFAULT_COURSE_FAILURE:
            {
                return _extends({}, state, { isDefaultCoursesLoaded: false });
            }
        case actions.SHOW_COURSE_DETAILS:
            {
                return _extends({}, state, { selectedCourseId: action.courseId });
            }
        case actions.HIDE_COURSE_DETAILS:
            {
                return _extends({}, state, { courseDetails: initialState.courseDetails, selectedCourseId: false, isCourseModalVisible: false });
            }
        case actions.FETCH_COURSE_DETAILS_REQUEST:
            {
                return _extends({}, state, { fetchingCourse: true });
            }
        case actions.FETCH_COURSE_DETAILS_SUCCESS:
            {
                return _extends({}, state, { courseDetails: action.courseDetails, fetchingCourse: false, isCourseModalVisible: true });
            }
        case actions.FETCH_COURSE_DETAILS_FAILURE:
            {
                return _extends({}, state, { fetchingCourse: false });
            }
        case actions.SAVE_DEFAULT_COURSE_REQUEST:
            {
                return _extends({}, state, { savingDefaultCourses: true });
            }
        case actions.SAVE_DEFAULT_COURSE_SUCCESS:
            {
                return _extends({}, state, {
                    savingDefaultCourses: action.savingDefaultCourses,
                    onSuccessfulSave: true,
                    isDefaultCoursesLoaded: false
                });
            }
        case actions.SAVE_DEFAULT_COURSE_FAILURE:
            {
                return _extends({}, state, { savingDefaultCourses: action.savingDefaultCourses, onSuccessfulSave: false });
            }

        default:
            return _extends({}, state);
    }
};

var _actions = __webpack_require__(397);

var actions = _interopRequireWildcard(_actions);

var _utils = __webpack_require__(13);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var initialState = {
    defaultCourses: [],
    upfCourses: [],
    conquestCourses: [],
    courseDetails: {
        name: '',
        topics: []
    },
    isCourseModalVisible: false,
    isDefaultCoursesLoaded: false,
    selectedCourseId: false,
    savingDefaultCourses: false,
    onSuccessfulSave: false
};

/***/ }),
/* 851 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __webpack_require__(28);

var _redux = __webpack_require__(35);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _uniqueId = __webpack_require__(175);

var _uniqueId2 = _interopRequireDefault(_uniqueId);

var _includes = __webpack_require__(232);

var _includes2 = _interopRequireDefault(_includes);

var _reactIntl = __webpack_require__(2);

var _messages = __webpack_require__(398);

var _messages2 = _interopRequireDefault(_messages);

var _index = __webpack_require__(736);

var _index2 = _interopRequireDefault(_index);

var _actions = __webpack_require__(156);

var _iconDictionary = __webpack_require__(8);

var _index3 = __webpack_require__(24);

var _index4 = _interopRequireDefault(_index3);

var _index5 = __webpack_require__(259);

var _index6 = _interopRequireDefault(_index5);

var _index7 = __webpack_require__(36);

var _index8 = _interopRequireDefault(_index7);

var _index9 = __webpack_require__(1763);

var _index10 = _interopRequireDefault(_index9);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var QuickUpload = function (_Component) {
    _inherits(QuickUpload, _Component);

    function QuickUpload() {
        var _ref;

        var _temp, _this, _ret;

        _classCallCheck(this, QuickUpload);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = QuickUpload.__proto__ || Object.getPrototypeOf(QuickUpload)).call.apply(_ref, [this].concat(args))), _this), _this.handleDownloadQuickUploadTemplate = function () {
            _this.props.downloadQuickUploadTemplate(true);
        }, _this.handleQuickUpload = function (file) {
            var intl = _this.props.intl;

            var fileReader = new FileReader();
            fileReader.onload = function (e) {
                var fileContent = e.target.result.split(',')[1];
                _this.props.quickUpload(_this.props.selectedProduct.id, fileContent, true);
            };

            fileReader.onError = function () {
                _this.props.quickUploadFailure(true, '', true, false);
            };

            if (_this.validateFileType(file.type)) {
                fileReader.readAsDataURL(file);
            } else {
                _this.props.quickUploadFailure(false, intl.formatMessage(_messages2.default.fileFormatValidationMessage), true, false, true);
            }
        }, _this.validateFileType = function (fileType) {
            var allowedFileTypes = ['application/vnd.ms-excel', 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'];
            return (0, _includes2.default)(allowedFileTypes, fileType);
        }, _this.closeModal = function () {
            _this.props.closeModal(false);
        }, _this.handleOnSuccess = function () {
            _this.props.closeModal(false);
            _this.context.router.history.push('students');
        }, _this.generateErrorRow = function (errors, intl) {
            var errorMessages = [];
            errorMessages = errors.map(function (error) {
                return _react2.default.createElement(
                    'div',
                    { className: _index10.default.rowNumber, key: (0, _uniqueId2.default)('uploadValidationMessages') },
                    error.rowReference !== '-1' ? intl.formatMessage(_messages2.default.row) + ' ' + error.rowReference : '',
                    _react2.default.createElement(
                        'div',
                        { className: _index10.default.message },
                        error.message
                    )
                );
            });

            return errorMessages;
        }, _this.GenerateResultRow = function (intl, uploadSummary) {
            return _react2.default.createElement(
                'div',
                {
                    className: _index10.default.resultContainer,
                    key: (0, _uniqueId2.default)('quickUploadResult') },
                _react2.default.createElement(
                    'div',
                    { className: _index10.default.resultSection },
                    _react2.default.createElement(
                        'div',
                        null,
                        ' ',
                        uploadSummary.newStudents.length,
                        ' ',
                        intl.formatMessage(_messages2.default.newStudentCM)
                    ),
                    _react2.default.createElement(
                        'div',
                        null,
                        ' ',
                        uploadSummary.updatedStudents.length,
                        ' ',
                        intl.formatMessage(_messages2.default.updatedStudentCM)
                    ),
                    _react2.default.createElement(
                        'div',
                        null,
                        ' ',
                        uploadSummary.unassignedStudents.length,
                        ' ',
                        intl.formatMessage(_messages2.default.unassignedStudentCM)
                    )
                ),
                _react2.default.createElement(
                    'div',
                    { className: _index10.default.resultSection },
                    _react2.default.createElement(
                        'div',
                        null,
                        ' ',
                        uploadSummary.newTeachers.length,
                        ' ',
                        intl.formatMessage(_messages2.default.newTeacherCM)
                    ),
                    _react2.default.createElement(
                        'div',
                        null,
                        ' ',
                        uploadSummary.updatedTeachers.length,
                        ' ',
                        intl.formatMessage(_messages2.default.updatedTeacherCM)
                    )
                ),
                _react2.default.createElement(
                    'div',
                    { className: _index10.default.resultSection },
                    _react2.default.createElement(
                        'div',
                        null,
                        ' ',
                        uploadSummary.newClassrooms.length,
                        ' ',
                        intl.formatMessage(_messages2.default.newClassesCM)
                    ),
                    _react2.default.createElement(
                        'div',
                        null,
                        ' ',
                        uploadSummary.updatedClassrooms.length,
                        ' ',
                        intl.formatMessage(_messages2.default.updatedClassesCM)
                    )
                )
            );
        }, _this.loadModalComponent = function (componentType) {
            if (componentType) {
                var _this$props = _this.props,
                    intl = _this$props.intl,
                    message = _this$props.message,
                    uploadSummary = _this$props.uploadSummary;

                var messageTitle = message.header !== '' ? intl.formatMessage(message.header) : '';
                var messageBody = message.body;

                var component = '';

                switch (componentType) {
                    case 'validation':
                        component = _react2.default.createElement(
                            _index6.default,
                            {
                                handleOnCloseModal: _this.closeModal,
                                icon: _iconDictionary.Warning,
                                message: messageTitle,
                                quickUploadErrorPage: true },
                            ' ',
                            _this.generateErrorRow(messageBody, intl)
                        );
                        break;
                    case 'confirmation':
                        component = _react2.default.createElement(
                            _index8.default,
                            {
                                handleOnCloseModal: _this.handleOnSuccess,
                                icon: _iconDictionary.Tick,
                                title: messageTitle },
                            _this.GenerateResultRow(intl, uploadSummary)
                        );
                        break;
                    case 'warning':
                        component = _react2.default.createElement(
                            _index8.default,
                            {
                                handleOnCloseModal: _this.closeModal,
                                icon: _iconDictionary.Warning,
                                message: messageBody,
                                title: messageTitle },
                            _react2.default.createElement(
                                'div',
                                null,
                                messageBody
                            )
                        );
                        break;
                    default:
                        break;
                }

                return component;
            }
            return '';
        }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    _createClass(QuickUpload, [{
        key: 'render',
        value: function render() {
            var _props = this.props,
                showModal = _props.showModal,
                componentType = _props.componentType;

            return _react2.default.createElement(
                'div',
                null,
                _react2.default.createElement(_index2.default, {
                    downloadingQuickUploadTemplate: this.props.downloadingQuickUploadTemplate,
                    handleOnDownloadTemplate: this.handleDownloadQuickUploadTemplate,
                    handleOnUploadClick: this.handleQuickUpload,
                    isUploading: this.props.uploadingTemplate,
                    productName: this.props.selectedProduct.name
                }),
                _react2.default.createElement(
                    _index4.default,
                    { show: showModal },
                    this.loadModalComponent(componentType)
                )
            );
        }
    }]);

    return QuickUpload;
}(_react.Component);

QuickUpload.propTypes = {
    componentType: _propTypes2.default.string,
    downloadingQuickUploadTemplate: _propTypes2.default.bool,
    uploadingTemplate: _propTypes2.default.bool,
    showModal: _propTypes2.default.bool,
    message: _propTypes2.default.object,
    uploadSummary: _propTypes2.default.object,
    downloadQuickUploadTemplate: _propTypes2.default.func,
    quickUpload: _propTypes2.default.func,
    quickUploadFailure: _propTypes2.default.func,
    closeModal: _propTypes2.default.func,
    selectedProduct: _propTypes2.default.object,
    intl: _reactIntl.intlShape.isRequired
};
QuickUpload.contextTypes = {
    router: _propTypes2.default.object
};


var mapStateToProps = function mapStateToProps(state) {
    return _extends({}, state, {
        downloadingQuickUploadTemplate: state.quickUpload.downloadingQuickUploadTemplate,
        uploadingTemplate: state.quickUpload.uploadingTemplate,
        showModal: state.quickUpload.showModal,
        message: state.quickUpload.message,
        componentType: state.quickUpload.componentType,
        selectedProduct: state.product,
        uploadSummary: state.quickUpload.uploadSummary
    });
};

function mapDispatchToProps(dispatch) {
    return (0, _redux.bindActionCreators)({
        downloadQuickUploadTemplate: _actions.downloadQuickUploadTemplate,
        quickUpload: _actions.quickUpload,
        quickUploadFailure: _actions.quickUploadFailure,
        closeModal: _actions.closeModal
    }, dispatch);
}

exports.default = (0, _reactIntl.injectIntl)((0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(QuickUpload));

/***/ }),
/* 852 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.default = function () {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initState;
    var action = arguments[1];

    switch (action.type) {
        case actions.DOWNLOAD_QUICK_UPLOAD_TEMPLATE_REQUEST:
            {
                return _extends({}, state, {
                    downloadingQuickUploadTemplate: action.downloadingQuickUploadTemplate,
                    showModal: initState.showModal
                });
            }
        case actions.DOWNLOAD_QUICK_UPLOAD_TEMPLATE_SUCCESS:
            {
                return _extends({}, state, { downloadingQuickUploadTemplate: action.downloadingQuickUploadTemplate });
            }
        case actions.QUICK_UPLOAD_TEMPLATE_REQUEST:
            {
                return _extends({}, state, { uploadingTemplate: action.uploadingTemplate });
            }
        case actions.QUICK_UPLOAD_TEMPLATE_SUCCESS:
            {
                return _extends({}, state, {
                    showModal: action.showModal,
                    uploadingTemplate: action.uploadingTemplate,
                    uploadSummary: action.quickUploadResponse,
                    message: { header: _messages2.default.quickUploadSuccessMessage, body: '' },
                    componentType: 'confirmation'
                });
            }
        case actions.QUICK_UPLOAD_TEMPLATE_FAILURE:
            {
                if (action.isServerError) {
                    message.header = _messages2.default.errorMessageHeader;
                    message.body = _messages2.default.errorMessageBody.defaultMessage;
                } else {
                    message.header = action.isWarning ? '' : _messages2.default.validationMessage;
                    message.body = action.errorMessage.indexOf('Rollover') !== -1 ? action.errorMessage.split('Rollover')[1] : action.errorMessage;
                }
                return _extends({}, state, {
                    showModal: action.showModal,
                    uploadingTemplate: action.uploadingTemplate,
                    message: message,
                    componentType: action.isWarning ? 'warning' : 'validation'
                });
            }
        case actions.QUICK_UPLOAD_CLOSE_MODAL_REQUEST:
            {
                return _extends({}, state, { showModal: action.showModal });
            }
        default:
            return _extends({}, state);
    }
};

var _actions = __webpack_require__(156);

var actions = _interopRequireWildcard(_actions);

var _messages = __webpack_require__(398);

var _messages2 = _interopRequireDefault(_messages);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var initState = { showModal: false,
    uploadSummary: {
        validationErrors: [],
        newStudents: [],
        updatedStudents: [],
        unassignedStudents: [],
        newTeachers: [],
        updatedTeachers: [],
        unassignedTeachers: [],
        newClassrooms: [],
        updatedClassrooms: []
    } };
var message = { header: {}, body: '' };

/***/ }),
/* 853 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.downloadTemplateForQuickUpload = downloadTemplateForQuickUpload;
exports.upload = upload;
exports.downloadTemplateForQuickUploadSaga = downloadTemplateForQuickUploadSaga;
exports.quickUploadSaga = quickUploadSaga;

var _effects = __webpack_require__(32);

var _api = __webpack_require__(33);

var api = _interopRequireWildcard(_api);

var _actions = __webpack_require__(156);

var actions = _interopRequireWildcard(_actions);

var _actions2 = __webpack_require__(44);

var schoolRollActions = _interopRequireWildcard(_actions2);

var _utils = __webpack_require__(13);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var _marked = /*#__PURE__*/regeneratorRuntime.mark(downloadTemplateForQuickUpload),
    _marked2 = /*#__PURE__*/regeneratorRuntime.mark(upload),
    _marked3 = /*#__PURE__*/regeneratorRuntime.mark(downloadTemplateForQuickUploadSaga),
    _marked4 = /*#__PURE__*/regeneratorRuntime.mark(quickUploadSaga);

function downloadTemplateForQuickUpload() {
    var response, downloadUrl;
    return regeneratorRuntime.wrap(function downloadTemplateForQuickUpload$(_context) {
        while (1) {
            switch (_context.prev = _context.next) {
                case 0:
                    _context.next = 2;
                    return (0, _effects.call)(api.downloadTemplateFile, { templateType: 'quickUpload' });

                case 2:
                    response = _context.sent;

                    if (!(response.status === 201)) {
                        _context.next = 9;
                        break;
                    }

                    downloadUrl = response.verb.url + '/' + response.data;
                    _context.next = 7;
                    return (0, _effects.put)(actions.downloadQuickUploadTemplateSuccess(downloadUrl, false));

                case 7:
                    _context.next = 11;
                    break;

                case 9:
                    _context.next = 11;
                    return (0, _effects.put)(actions.downloadQuickUploadTemplateFailure());

                case 11:
                case 'end':
                    return _context.stop();
            }
        }
    }, _marked, this);
}

function upload(data) {
    var response, rollover, uploadResponse;
    return regeneratorRuntime.wrap(function upload$(_context2) {
        while (1) {
            switch (_context2.prev = _context2.next) {
                case 0:
                    _context2.next = 2;
                    return (0, _effects.call)(api.verifyRollover, data.productId, data.fileContent);

                case 2:
                    response = _context2.sent;

                    if (!(response.status === 200)) {
                        _context2.next = 24;
                        break;
                    }

                    if (!response.data.isSuccess) {
                        _context2.next = 20;
                        break;
                    }

                    rollover = { rolloverItems: response.data.rolloverItems, rolloverType: _utils.PARTIAL_ROLLOVER };
                    _context2.next = 8;
                    return (0, _effects.call)(api.performRollover, data.productId, rollover);

                case 8:
                    uploadResponse = _context2.sent;

                    if (!(uploadResponse.status === 200)) {
                        _context2.next = 16;
                        break;
                    }

                    _context2.next = 12;
                    return (0, _effects.put)(actions.quickUploadSuccess(uploadResponse.data, true, false));

                case 12:
                    _context2.next = 14;
                    return (0, _effects.put)(schoolRollActions.getLicenceCapSummary(data.productId));

                case 14:
                    _context2.next = 18;
                    break;

                case 16:
                    _context2.next = 18;
                    return (0, _effects.put)(actions.quickUploadFailure(true, '', true, false));

                case 18:
                    _context2.next = 22;
                    break;

                case 20:
                    _context2.next = 22;
                    return (0, _effects.put)(actions.quickUploadFailure(false, response.data.validationErrors, true, false));

                case 22:
                    _context2.next = 31;
                    break;

                case 24:
                    if (!(response.status === 400)) {
                        _context2.next = 29;
                        break;
                    }

                    _context2.next = 27;
                    return (0, _effects.put)(actions.quickUploadFailure(false, response.message, true, false, true));

                case 27:
                    _context2.next = 31;
                    break;

                case 29:
                    _context2.next = 31;
                    return (0, _effects.put)(actions.quickUploadFailure(true, '', true, false));

                case 31:
                case 'end':
                    return _context2.stop();
            }
        }
    }, _marked2, this);
}

function downloadTemplateForQuickUploadSaga() {
    return regeneratorRuntime.wrap(function downloadTemplateForQuickUploadSaga$(_context3) {
        while (1) {
            switch (_context3.prev = _context3.next) {
                case 0:
                    _context3.next = 2;
                    return (0, _effects.takeLatest)(actions.DOWNLOAD_QUICK_UPLOAD_TEMPLATE_REQUEST, downloadTemplateForQuickUpload);

                case 2:
                case 'end':
                    return _context3.stop();
            }
        }
    }, _marked3, this);
}

function quickUploadSaga() {
    return regeneratorRuntime.wrap(function quickUploadSaga$(_context4) {
        while (1) {
            switch (_context4.prev = _context4.next) {
                case 0:
                    _context4.next = 2;
                    return (0, _effects.takeLatest)(actions.QUICK_UPLOAD_TEMPLATE_REQUEST, upload);

                case 2:
                case 'end':
                    return _context4.stop();
            }
        }
    }, _marked4, this);
}

/***/ }),
/* 854 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __webpack_require__(28);

var _redux = __webpack_require__(35);

var _reactIntl = __webpack_require__(2);

var _index = __webpack_require__(744);

var _index2 = _interopRequireDefault(_index);

var _actions = __webpack_require__(265);

var _actions2 = __webpack_require__(38);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var RollOverContainer = function RollOverContainer(props) {
    return _react2.default.createElement(_index2.default, props);
};

var mapStateToProps = function mapStateToProps(state) {
    return {
        helpModal: state.rollOver.helpModal,
        initialPage: state.rollOver.initialPage,
        isDownloadingSchoolRollData: state.rollOver.isDownloadingSchoolRollData,
        isDownloadingTemplate: state.rollOver.isDownloadingTemplate,
        isPartialRollover: state.rollOver.isPartialRollover,
        isFullRollover: state.rollOver.isFullRollover,
        selectionPage: state.rollOver.selectionPage,
        selectedProduct: state.product,
        uploadPage: state.rollOver.uploadPage,
        message: state.rollOver.message,
        showUploadModal: state.rollOver.showUploadModal,
        isVerifyingContent: state.rollOver.isVerifyingContent,
        isVerificationSuccessful: state.rollOver.isVerificationSuccessful,
        validationErrors: state.rollOver.validationErrors,
        showDataGrid: state.rollOver.showDataGrid,
        rolloverItems: state.rollOver.rolloverItems,
        showRollOverConfirmation: state.rollOver.showRollOverConfirmation,
        rolloverType: state.rollOver.rolloverType,
        isPerformingRollOver: state.rollOver.isPerformingRollOver,
        isRolloverDone: state.rollOver.isRolloverDone,
        rolloverSummary: state.rollOver.rolloverSummary,
        summaryPage: state.rollOver.summaryPage,
        isDownloadingRolloverSignInCards: state.rollOver.isDownloadingRolloverSignInCards,
        includeUnassignedStudents: state.rollOver.includeUnassignedStudents,
        includeBulkTransfer: state.rollOver.includeBulkTransfer,
        isServerError: state.rollOver.isServerError,
        fileSize: state.rollOver.fileSize,
        showHideSignInCardModal: state.classRoll.showHideSignInCardModal
    };
};

function mapDispatchToProps(dispatch) {
    return (0, _redux.bindActionCreators)({
        downloadRolloverTemplate: _actions.downloadRolloverTemplate,
        downloadSchoolRollDataRollover: _actions.downloadSchoolRollDataRollover,
        hideHelpModal: _actions.hideHelpModal,
        showHelpModal: _actions.showHelpModal,
        rollOverIsFull: _actions.rollOverIsFull,
        rollOverIsPartial: _actions.rollOverIsPartial,
        showInitialPage: _actions.showInitialPage,
        showSelectionPage: _actions.showSelectionPage,
        showUploadPage: _actions.showUploadPage,
        rolloverUploadFailure: _actions.rolloverUploadFailure,
        closeUploadErrorModal: _actions.closeUploadErrorModal,
        rollOverVerifyContentRequest: _actions.rollOverVerifyContentRequest,
        clearRollOverVerifyData: _actions.clearRollOverVerifyData,
        openRollOverConfirmation: _actions.openRollOverConfirmation,
        closeRollOverConfirmation: _actions.closeRollOverConfirmation,
        onRollOverConfirmationRequest: _actions.onRollOverConfirmationRequest,
        onViewRollOverSummary: _actions.onViewRollOverSummary,
        onRollOverDownloadSignInCardRequest: _actions.onRollOverDownloadSignInCardRequest,
        onIncludeUnassignedStudentsSelection: _actions.onIncludeUnassignedStudentsSelection,
        onIncludeBulkTransferSelection: _actions.onIncludeBulkTransferSelection,
        showHideSignInCardModalRequest: _actions2.showHideSignInCardModalRequest
    }, dispatch);
}

exports.default = (0, _reactIntl.injectIntl)((0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(RollOverContainer));

/***/ }),
/* 855 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _reactIntl = __webpack_require__(2);

exports.default = (0, _reactIntl.defineMessages)({
    errorMessageHeader: {
        id: 'rollover.errorMessageHeader',
        defaultMessage: 'Oops, something went wrong'
    },
    errorMessageBody: {
        id: 'rollover.errorMessageBody',
        defaultMessage: 'Please try uploading your file again.'
    },
    somethingWentWrong: {
        id: 'rollover.somethingWentWrong',
        defaultMessage: 'Something went wrong on our side and we are working on it.'
    },
    pleaseTryAgain: {
        id: 'rollover.pleaseTryAgain',
        defaultMessage: 'Please try again later or contact Tech Support'
    }
});

/***/ }),
/* 856 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.default = function () {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initState;
    var action = arguments[1];

    switch (action.type) {
        case actions.ROLLOVER_SHOW_INITIAL_PAGE:
            {
                return _extends({}, state, {
                    initialPage: true,
                    selectionPage: false,
                    isPartialRollover: false,
                    isFullRollover: false,
                    uploadPage: false,
                    summaryPage: false
                });
            }
        case actions.ROLLOVER_SHOW_SELECTION:
            {
                return _extends({}, state, {
                    initialPage: false,
                    selectionPage: true,
                    isPartialRollover: false,
                    isFullRollover: false,
                    uploadPage: false,
                    summaryPage: false
                });
            }
        case actions.ROLLOVER_SHOW_UPLOAD_PAGE:
            {
                return _extends({}, state, {
                    initialPage: false,
                    selectionPage: false,
                    isPartialRollover: false,
                    isFullRollover: false,
                    uploadPage: true,
                    summaryPage: false
                });
            }
        case actions.ON_VIEW_ROLLOVER_SUMMARY:
            {
                return _extends({}, state, {
                    initialPage: false,
                    selectionPage: false,
                    isPartialRollover: false,
                    isFullRollover: false,
                    uploadPage: false,
                    summaryPage: true,
                    isRolloverDone: false
                });
            }
        case actions.ROLLOVER_SHOW_HELP_MODAL:
            {
                return _extends({}, state, {
                    helpModal: true
                });
            }
        case actions.ROLLOVER_HIDE_HELP_MODAL:
            {
                return _extends({}, state, {
                    helpModal: false
                });
            }
        case actions.IS_PARTIAL_ROLLOVER:
            {
                return _extends({}, state, {
                    isPartialRollover: true,
                    isFullRollover: false,
                    rolloverType: action.rolloverType
                });
            }
        case actions.IS_FULL_ROLLOVER:
            {
                return _extends({}, state, {
                    isPartialRollover: false,
                    isFullRollover: true,
                    rolloverType: action.rolloverType
                });
            }
        case actions.DOWNLOAD_ROLLOVER_TEMPLATE_REQUEST:
            {
                return _extends({}, state, {
                    isDownloadingTemplate: true,
                    isDownloadingTemplateSuccess: false
                });
            }
        case actions.DOWNLOAD_ROLLOVER_TEMPLATE_SUCCESS:
            {
                return _extends({}, state, {
                    isDownloadingTemplate: false,
                    isDownloadingTemplateSuccess: true
                });
            }
        case actions.DOWNLOAD_ROLLOVER_TEMPLATE_FAILURE:
            {
                return _extends({}, state, {
                    isDownloadingTemplate: false,
                    isDownloadingTemplateSuccess: false
                });
            }
        case actions.DOWNLOAD_ROLLOVER_SCHOOL_ROLL_DATA_REQUEST:
            {
                return _extends({}, state, {
                    isDownloadingSchoolRollData: true,
                    isDownloadingSchoolRollDataSuccess: false,
                    productId: action.productId
                });
            }
        case actions.DOWNLOAD_ROLLOVER_SCHOOL_ROLL_DATA_SUCCESS:
            {
                return _extends({}, state, {
                    isDownloadingSchoolRollData: false,
                    isDownloadingSchoolRollDataSuccess: true
                });
            }
        case actions.DOWNLOAD_ROLLOVER_SCHOOL_ROLL_DATA_FAILURE:
            {
                return _extends({}, state, {
                    isDownloadingSchoolRollData: false,
                    isDownloadingSchoolRollDataSuccess: false
                });
            }
        case actions.UPLOAD_ROLLOVER_FAILURE:
            {
                if (action.isServerError) {
                    message.header = _messages2.default.errorMessageHeader;
                    message.body = _messages2.default.errorMessageBody;
                } else {
                    message.header = action.errorMessage;
                    message.body = action.messageDetail;
                }
                return _extends({}, state, {
                    showUploadModal: action.showModal,
                    message: message,
                    isServerError: action.isServerError,
                    showDataGrid: action.showDataGrid,
                    isVerificationSuccessful: action.isVerificationSuccessful,
                    fileSize: action.fileSize });
            }
        case actions.CLOSE_UPLOAD_ERROR_MODAL:
            {
                return _extends({}, state, {
                    showUploadModal: action.showModal,
                    message: message,
                    isVerificationSuccessful: action.isVerificationSuccessful,
                    validationErrors: action.validationErrors });
            }

        case actions.ROLLOVER_VERIFY_FILE_CONTENT_REQUEST:
            {
                return _extends({}, state, {
                    isVerifyingContent: action.isVerifyingContent,
                    showDataGrid: action.showDataGrid,
                    isVerificationSuccessful: action.isVerificationSuccessful
                });
            }

        case actions.ROLLOVER_VERIFY_FILE_CONTENT_SUCCESS:
            {
                return _extends({}, state, {
                    isVerifyingContent: action.isVerifyingContent,
                    showUploadModal: action.showUploadModal,
                    showDataGrid: action.isVerificationSuccessful,
                    isVerificationSuccessful: action.isVerificationSuccessful,
                    validationErrors: action.validationErrors,
                    rolloverItems: action.rolloverItems
                });
            }

        case actions.ROLLOVER_VERIFY_FILE_CONTENT_FAILURE:
            {
                message.header = action.message;
                message.body = '';
                return _extends({}, state, {
                    isVerifyingContent: action.isVerifyingContent,
                    showDataGrid: action.showDataGrid,
                    isVerificationSuccessful: action.isVerificationSuccessful,
                    showUploadModal: action.showUploadModal,
                    message: message });
            }

        case actions.CLEAR_ROLLOVER_VERIFICATION_DATA:
            {
                return _extends({}, state, {
                    showDataGrid: false,
                    rolloverType: action.rolloverType,
                    isVerificationSuccessful: action.isVerificationSuccessful
                });
            }

        case actions.OPEN_ROLLOVER_CONFIRMATION:
            {
                return _extends({}, state, {
                    showRollOverConfirmation: action.showRollOverConfirmation
                });
            }

        case actions.CLOSE_ROLLOVER_CONFIRMATION:
            {
                return _extends({}, state, {
                    showRollOverConfirmation: action.showRollOverConfirmation
                });
            }

        case actions.ON_ROLLOVER_CONFIRMATION_REQUEST:
            {
                return _extends({}, state, {
                    isPerformingRollOver: action.isPerformingRollOver,
                    isRolloverDone: action.isRolloverDone,
                    showRollOverConfirmation: action.showRollOverConfirmation
                });
            }

        case actions.ON_ROLLOVER_CONFIRMATION_SUCCESS:
            {
                return _extends({}, state, {
                    isPerformingRollOver: action.isPerformingRollOver,
                    showRollOverConfirmation: action.showRollOverConfirmation,
                    isRolloverDone: action.isRolloverDone,
                    rolloverSummary: action.rolloverSummary
                });
            }

        case actions.ON_ROLLOVER_CONFIRMATION_FAILURE:
            {
                message.header = _messages2.default.somethingWentWrong;
                message.body = _messages2.default.pleaseTryAgain;

                if (action.confirmationErrorMessage) {
                    message.header = _messages2.default.errorMessageHeader;
                    message.body = action.confirmationErrorMessage;
                }

                return _extends({}, state, {
                    isPerformingRollOver: action.isPerformingRollOver,
                    showRollOverConfirmation: action.showRollOverConfirmation,
                    isRolloverDone: action.isRolloverDone,
                    isVerifyingContent: action.isVerifyingContent,
                    showDataGrid: action.showDataGrid,
                    isVerificationSuccessful: action.isVerificationSuccessful,
                    showUploadModal: action.showUploadModal,
                    message: message
                });
            }

        case actions.ON_ROLLOVER_DOWNLOAD_SIGNIN_CARD_REQUEST:
            {
                return _extends({}, state, {
                    isDownloadingRolloverSignInCards: action.isDownloadingRolloverSignInCards });
            }

        case actions.ON_ROLLOVER_DOWNLOAD_SIGNIN_CARD_SUCCESS:
            {
                return _extends({}, state, {
                    isDownloadingRolloverSignInCards: action.isDownloadingRolloverSignInCards });
            }

        case actions.ON_ROLLOVER_DOWNLOAD_SIGNIN_CARD_FAILURE:
            {
                return _extends({}, state, {
                    isDownloadingRolloverSignInCards: action.isDownloadingRolloverSignInCards });
            }

        case actions.ON_INCLUDE_UNASSIGNED_STUDENTS_SELECTION:
            {
                return _extends({}, state, {
                    includeUnassignedStudents: !state.includeUnassignedStudents });
            }

        case actions.ON_INCLUDE_BULK_TRANSFER_SELECTION:
            {
                return _extends({}, state, {
                    includeBulkTransfer: !state.includeBulkTransfer });
            }

        default:
            return _extends({}, state);
    }
};

var _actions = __webpack_require__(265);

var actions = _interopRequireWildcard(_actions);

var _messages = __webpack_require__(855);

var _messages2 = _interopRequireDefault(_messages);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var initState = {
    helpModal: false,
    initialPage: true,
    selectionPage: false,
    summaryPage: false,
    isPartialRollover: false,
    isFullRollover: false,
    uploadPage: false,
    showUploadModal: false,
    message: { header: '', body: '' },
    isVerifyingContent: false,
    isVerificationSuccessful: false,
    isPerformingRollOver: false,
    isRolloverDone: false,
    validationErrors: [],
    rolloverItems: [],
    rolloverSummary: {
        validationErrors: [],
        newStudents: [],
        updatedStudents: [],
        unassignedStudents: [],
        transferredStudents: [],
        newTeachers: [],
        updatedTeachers: [],
        unassignedTeachers: [],
        newClassrooms: [],
        updatedClassrooms: []
    },
    isServerError: false,
    showDataGrid: false,
    showRollOverConfirmation: false,
    rolloverType: '',
    isDownloadingRolloverSignInCards: false,
    includeUnassignedStudents: false,
    includeBulkTransfer: false,
    fileSize: 0
};

var message = { header: '', body: '' };

/***/ }),
/* 857 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.downloadTemplateRollover = downloadTemplateRollover;
exports.downloadTemplateForRolloverSaga = downloadTemplateForRolloverSaga;
exports.downloadSchoolRollDataRollover = downloadSchoolRollDataRollover;
exports.downloadSchoolRollDataRolloverSaga = downloadSchoolRollDataRolloverSaga;
exports.rollOverVerifyContent = rollOverVerifyContent;
exports.rollOverVerifyContentSaga = rollOverVerifyContentSaga;
exports.performRollOver = performRollOver;
exports.performRollOverSaga = performRollOverSaga;
exports.downloadRolloverSignInCards = downloadRolloverSignInCards;
exports.downloadRolloverSignInCardsSaga = downloadRolloverSignInCardsSaga;

var _effects = __webpack_require__(32);

var _api = __webpack_require__(33);

var api = _interopRequireWildcard(_api);

var _actions = __webpack_require__(265);

var actions = _interopRequireWildcard(_actions);

var _portalComms = __webpack_require__(55);

var _portalComms2 = _interopRequireDefault(_portalComms);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var _marked = /*#__PURE__*/regeneratorRuntime.mark(downloadTemplateRollover),
    _marked2 = /*#__PURE__*/regeneratorRuntime.mark(downloadTemplateForRolloverSaga),
    _marked3 = /*#__PURE__*/regeneratorRuntime.mark(downloadSchoolRollDataRollover),
    _marked4 = /*#__PURE__*/regeneratorRuntime.mark(downloadSchoolRollDataRolloverSaga),
    _marked5 = /*#__PURE__*/regeneratorRuntime.mark(rollOverVerifyContent),
    _marked6 = /*#__PURE__*/regeneratorRuntime.mark(rollOverVerifyContentSaga),
    _marked7 = /*#__PURE__*/regeneratorRuntime.mark(performRollOver),
    _marked8 = /*#__PURE__*/regeneratorRuntime.mark(performRollOverSaga),
    _marked9 = /*#__PURE__*/regeneratorRuntime.mark(downloadRolloverSignInCards),
    _marked10 = /*#__PURE__*/regeneratorRuntime.mark(downloadRolloverSignInCardsSaga);

function downloadTemplateRollover() {
    var response, downloadUrl;
    return regeneratorRuntime.wrap(function downloadTemplateRollover$(_context) {
        while (1) {
            switch (_context.prev = _context.next) {
                case 0:
                    _context.next = 2;
                    return (0, _effects.call)(api.downloadTemplateFile, { templateType: 'rollover' });

                case 2:
                    response = _context.sent;

                    if (!(response.status === 201)) {
                        _context.next = 9;
                        break;
                    }

                    downloadUrl = response.verb.url + '/' + response.data;
                    _context.next = 7;
                    return (0, _effects.put)(actions.downloadRolloverTemplateSuccess(downloadUrl, false));

                case 7:
                    _context.next = 11;
                    break;

                case 9:
                    _context.next = 11;
                    return (0, _effects.put)(actions.downloadRolloverTemplateFailure());

                case 11:
                case 'end':
                    return _context.stop();
            }
        }
    }, _marked, this);
}

function downloadTemplateForRolloverSaga() {
    return regeneratorRuntime.wrap(function downloadTemplateForRolloverSaga$(_context2) {
        while (1) {
            switch (_context2.prev = _context2.next) {
                case 0:
                    _context2.next = 2;
                    return (0, _effects.takeLatest)(actions.DOWNLOAD_ROLLOVER_TEMPLATE_REQUEST, downloadTemplateRollover);

                case 2:
                case 'end':
                    return _context2.stop();
            }
        }
    }, _marked2, this);
}

function downloadSchoolRollDataRollover(_ref) {
    var productId = _ref.productId,
        includeUnassignedStudents = _ref.includeUnassignedStudents,
        includeBulkTransfer = _ref.includeBulkTransfer;
    var response, downloadUrl;
    return regeneratorRuntime.wrap(function downloadSchoolRollDataRollover$(_context3) {
        while (1) {
            switch (_context3.prev = _context3.next) {
                case 0:
                    _context3.next = 2;
                    return (0, _effects.call)(api.downloadSchoolRollData, productId, includeUnassignedStudents, includeBulkTransfer);

                case 2:
                    response = _context3.sent;

                    if (!(response.status === 201)) {
                        _context3.next = 9;
                        break;
                    }

                    downloadUrl = response.verb.url.slice(0, response.verb.url.indexOf('?')) + '/' + response.data;
                    _context3.next = 7;
                    return (0, _effects.put)(actions.downloadSchoolRollDataRolloverSuccess(downloadUrl));

                case 7:
                    _context3.next = 11;
                    break;

                case 9:
                    _context3.next = 11;
                    return (0, _effects.put)(actions.downloadSchoolRollDataRolloverFailure());

                case 11:
                case 'end':
                    return _context3.stop();
            }
        }
    }, _marked3, this);
}

function downloadSchoolRollDataRolloverSaga() {
    return regeneratorRuntime.wrap(function downloadSchoolRollDataRolloverSaga$(_context4) {
        while (1) {
            switch (_context4.prev = _context4.next) {
                case 0:
                    _context4.next = 2;
                    return (0, _effects.takeLatest)(actions.DOWNLOAD_ROLLOVER_SCHOOL_ROLL_DATA_REQUEST, downloadSchoolRollDataRollover);

                case 2:
                case 'end':
                    return _context4.stop();
            }
        }
    }, _marked4, this);
}

function rollOverVerifyContent(_ref2) {
    var productId = _ref2.productId,
        fileContent = _ref2.fileContent;
    var response;
    return regeneratorRuntime.wrap(function rollOverVerifyContent$(_context5) {
        while (1) {
            switch (_context5.prev = _context5.next) {
                case 0:
                    _context5.next = 2;
                    return (0, _effects.call)(api.verifyRollover, productId, fileContent);

                case 2:
                    response = _context5.sent;

                    if (!(response.status === 200)) {
                        _context5.next = 8;
                        break;
                    }

                    _context5.next = 6;
                    return (0, _effects.put)(actions.rollOverVerifyContentSuccess(response.data));

                case 6:
                    _context5.next = 15;
                    break;

                case 8:
                    if (!(response.status === 400)) {
                        _context5.next = 13;
                        break;
                    }

                    _context5.next = 11;
                    return (0, _effects.put)(actions.rollOverVerifyContentFailure(response.message, true));

                case 11:
                    _context5.next = 15;
                    break;

                case 13:
                    _context5.next = 15;
                    return (0, _effects.put)(actions.rollOverVerifyContentFailure('', false));

                case 15:
                case 'end':
                    return _context5.stop();
            }
        }
    }, _marked5, this);
}

function rollOverVerifyContentSaga() {
    return regeneratorRuntime.wrap(function rollOverVerifyContentSaga$(_context6) {
        while (1) {
            switch (_context6.prev = _context6.next) {
                case 0:
                    _context6.next = 2;
                    return (0, _effects.takeLatest)(actions.ROLLOVER_VERIFY_FILE_CONTENT_REQUEST, rollOverVerifyContent);

                case 2:
                case 'end':
                    return _context6.stop();
            }
        }
    }, _marked6, this);
}

function performRollOver(_ref3) {
    var rolloverType = _ref3.rolloverType,
        productId = _ref3.productId,
        rolloverItems = _ref3.rolloverItems;
    var schoolRollover, response, message;
    return regeneratorRuntime.wrap(function performRollOver$(_context7) {
        while (1) {
            switch (_context7.prev = _context7.next) {
                case 0:
                    schoolRollover = { rolloverItems: rolloverItems, rolloverType: rolloverType };
                    _context7.next = 3;
                    return (0, _effects.call)(api.performRollover, productId, schoolRollover);

                case 3:
                    response = _context7.sent;

                    if (!(response.status === 200)) {
                        _context7.next = 10;
                        break;
                    }

                    _portalComms2.default.informMakeAPICall({
                        productId: productId,
                        apiType: 'Notification'
                    });
                    _context7.next = 8;
                    return (0, _effects.put)(actions.onRollOverConfirmationSuccess(response.data, productId));

                case 8:
                    _context7.next = 13;
                    break;

                case 10:
                    message = response.message;
                    _context7.next = 13;
                    return (0, _effects.put)(actions.onRollOverConfirmationFailure(false, message));

                case 13:
                case 'end':
                    return _context7.stop();
            }
        }
    }, _marked7, this);
}

function performRollOverSaga() {
    return regeneratorRuntime.wrap(function performRollOverSaga$(_context8) {
        while (1) {
            switch (_context8.prev = _context8.next) {
                case 0:
                    _context8.next = 2;
                    return (0, _effects.takeLatest)(actions.ON_ROLLOVER_CONFIRMATION_REQUEST, performRollOver);

                case 2:
                case 'end':
                    return _context8.stop();
            }
        }
    }, _marked8, this);
}

function downloadRolloverSignInCards(_ref4) {
    var productId = _ref4.productId,
        userIds = _ref4.userIds,
        userType = _ref4.userType,
        format = _ref4.format;
    var response, studentsSignInCardsData, teacherSignInCardsData, studentSignInCardsData, downloadUrl;
    return regeneratorRuntime.wrap(function downloadRolloverSignInCards$(_context9) {
        while (1) {
            switch (_context9.prev = _context9.next) {
                case 0:
                    response = {};

                    if (!(userType === 'student')) {
                        _context9.next = 8;
                        break;
                    }

                    studentsSignInCardsData = { studentUserProfileIds: userIds, SignInCardPageSizeType: format };
                    _context9.next = 5;
                    return (0, _effects.call)(api.downloadStudentsSignInCards, productId, studentsSignInCardsData);

                case 5:
                    response = _context9.sent;
                    _context9.next = 19;
                    break;

                case 8:
                    if (!(userType === 'teacher')) {
                        _context9.next = 15;
                        break;
                    }

                    teacherSignInCardsData = { teacherUserProfileIds: userIds, SignInCardPageSizeType: format };
                    _context9.next = 12;
                    return (0, _effects.call)(api.downloadTeachersSignInCards, productId, teacherSignInCardsData);

                case 12:
                    response = _context9.sent;
                    _context9.next = 19;
                    break;

                case 15:
                    studentSignInCardsData = { ClassroomIds: userIds, SignInCardPageSizeType: format };
                    _context9.next = 18;
                    return (0, _effects.call)(api.downloadClassroomsStudentsSignInCards, { productId: productId, studentSignInCardsData: studentSignInCardsData });

                case 18:
                    response = _context9.sent;

                case 19:
                    if (!(response.status === 201)) {
                        _context9.next = 25;
                        break;
                    }

                    downloadUrl = response.verb.url + '/' + response.data;
                    _context9.next = 23;
                    return (0, _effects.put)(actions.onRollOverDownloadSignInCardSuccess(downloadUrl, true));

                case 23:
                    _context9.next = 27;
                    break;

                case 25:
                    _context9.next = 27;
                    return (0, _effects.put)(actions.onRollOverDownloadSignInCardFailure(false));

                case 27:
                case 'end':
                    return _context9.stop();
            }
        }
    }, _marked9, this);
}

function downloadRolloverSignInCardsSaga() {
    return regeneratorRuntime.wrap(function downloadRolloverSignInCardsSaga$(_context10) {
        while (1) {
            switch (_context10.prev = _context10.next) {
                case 0:
                    _context10.next = 2;
                    return (0, _effects.takeLatest)(actions.ON_ROLLOVER_DOWNLOAD_SIGNIN_CARD_REQUEST, downloadRolloverSignInCards);

                case 2:
                case 'end':
                    return _context10.stop();
            }
        }
    }, _marked10, this);
}

/***/ }),
/* 858 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __webpack_require__(28);

var _reactRouterDom = __webpack_require__(244);

var _redux = __webpack_require__(35);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactIntl = __webpack_require__(2);

var _index = __webpack_require__(1764);

var _index2 = _interopRequireDefault(_index);

var _index3 = __webpack_require__(730);

var _index4 = _interopRequireDefault(_index3);

var _messages = __webpack_require__(399);

var _messages2 = _interopRequireDefault(_messages);

var _actions = __webpack_require__(44);

var _teacherRoll = __webpack_require__(869);

var _teacherRoll2 = _interopRequireDefault(_teacherRoll);

var _studentRoll = __webpack_require__(866);

var _studentRoll2 = _interopRequireDefault(_studentRoll);

var _classRoll = __webpack_require__(819);

var _classRoll2 = _interopRequireDefault(_classRoll);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var SchoolRollContainer = function (_Component) {
    _inherits(SchoolRollContainer, _Component);

    function SchoolRollContainer() {
        _classCallCheck(this, SchoolRollContainer);

        return _possibleConstructorReturn(this, (SchoolRollContainer.__proto__ || Object.getPrototypeOf(SchoolRollContainer)).apply(this, arguments));
    }

    _createClass(SchoolRollContainer, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            if (this.props.loadLicenceSummary) {
                this.props.getLicenceCapSummary(this.props.selectedProduct.id);
            }

            if (!this.props.isYearGroupDataLoaded) {
                this.props.getYearGroups();
            }
        }
    }, {
        key: 'componentWillReceiveProps',
        value: function componentWillReceiveProps(nextProps) {
            if (!this.props.loadLicenceSummary && nextProps.loadLicenceSummary) {
                this.props.getLicenceCapSummary(this.props.selectedProduct.id);
            }
        }
    }, {
        key: 'render',
        value: function render() {
            var _props = this.props,
                tabs = _props.tabs,
                intl = _props.intl;

            tabs[0].name = intl.formatMessage(_messages2.default.students);
            tabs[1].name = intl.formatMessage(_messages2.default.teachers);
            tabs[2].name = intl.formatMessage(_messages2.default.classes);

            return _react2.default.createElement(
                'div',
                { className: _index2.default.schoolRollComponent },
                _react2.default.createElement(_index4.default, {
                    headerTitle: this.props.intl.formatMessage(_messages2.default.schoolRoll),
                    licenceSummary: this.props.licenceSummary,
                    licenceSummaryTitle: this.props.intl.formatMessage(_messages2.default.licenceSummary),
                    tabs: tabs
                }),
                _react2.default.createElement(
                    'div',
                    { className: _index2.default.mainContent },
                    _react2.default.createElement(_reactRouterDom.Route, { component: _studentRoll2.default, path: '/students' }),
                    _react2.default.createElement(_reactRouterDom.Route, { component: _teacherRoll2.default, path: '/teachers' }),
                    _react2.default.createElement(_reactRouterDom.Route, { component: _classRoll2.default, path: '/classes' })
                )
            );
        }
    }]);

    return SchoolRollContainer;
}(_react.Component);

SchoolRollContainer.propTypes = {
    licenceSummary: _propTypes2.default.string,
    loadLicenceSummary: _propTypes2.default.bool,
    isYearGroupDataLoaded: _propTypes2.default.bool,
    selectedProduct: _propTypes2.default.object,
    tabs: _propTypes2.default.array,
    getLicenceCapSummary: _propTypes2.default.func,
    getYearGroups: _propTypes2.default.func,
    intl: _reactIntl.intlShape.isRequired
};


function mapStateToProps(state) {
    return _extends({}, state, {
        licenceSummary: state.schoolRoll.licenceSummary,
        licenceSummaryTitle: state.schoolRoll.licenceSummaryTitle,
        loadLicenceSummary: state.schoolRoll.loadLicenceSummary,
        tabs: state.schoolRoll.tabs.data,
        isYearGroupDataLoaded: state.schoolRoll.isYearGroupDataLoaded,
        selectedProduct: state.product
    });
}

function mapDispatchToProps(dispatch) {
    return (0, _redux.bindActionCreators)({
        getLicenceCapSummary: _actions.getLicenceCapSummary,
        getYearGroups: _actions.getYearGroups
    }, dispatch);
}

exports.default = (0, _reactIntl.injectIntl)((0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(SchoolRollContainer));

/***/ }),
/* 859 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.default = function () {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initState;
    var action = arguments[1];

    switch (action.type) {
        case classRollActions.DELETE_CLASSROOMS_SUCCESS:
        case editStudentActions.UNASSIGN_STUDENTS_USING_CLASSID_SUCCESS:
        case studentRollActions.UNASSIGN_STUDENTS_SUCCESS:
        case studentRollActions.ADD_STUDENT_SUCCESS:
        case actions.GET_LICENCE_CAP_SUMMARY_REQUEST:
            {
                return _extends({}, state, { loadLicenceSummary: true });
            }

        case actions.GET_LICENCE_CAP_SUMMARY_SUCCESS:
            {
                var licenceDetail = action.data;

                var licenceSummary = licenceDetail.remainingLicenceCount.toString();
                var licenceSummaryTitle = _messages2.default.licenceSummary.defaultMessage;
                if (!licenceDetail.isActive) {
                    licenceSummary = _messages2.default.expiredLicence.defaultMessage;
                    licenceSummaryTitle = '';
                }
                return _extends({}, state, { licenceSummary: licenceSummary, licenceSummaryTitle: licenceSummaryTitle, loadLicenceSummary: false });
            }
        case actions.GET_LICENCE_CAP_SUMMARY_FAILURE:
            {
                return _extends({}, state, { loadLicenceSummary: false });
            }

        case actions.GET_COUNTRIES_REQUEST:
            {
                return _extends({}, state, { isCountriesLoaded: false });
            }
        case actions.GET_COUNTRIES_SUCCESS:
            {
                return _extends({}, state, {
                    isCountriesLoaded: true,
                    countries: { raw: action.data, filtered: (0, _utils.filterProductCountries)(action.data) }
                });
            }
        case actions.GET_COUNTRIES_FAILURE:
            {
                return _extends({}, state, { isCountriesLoaded: true });
            }

        case actions.GET_UPF_COUNTRIES_REQUEST:
            {
                return _extends({}, state, { isUpfCountriesLoaded: false });
            }
        case actions.GET_UPF_COUNTRIES_SUCCESS:
            {
                return _extends({}, state, {
                    isUpfCountriesLoaded: true,
                    upfCountries: { raw: action.data, filtered: (0, _utils.filterProductCountries)(action.data) }
                });
            }
        case actions.GET_UPF_COUNTRIES_FAILURE:
            {
                return _extends({}, state, { isUpfCountriesLoaded: true });
            }

        case actions.GET_YEAR_GROUPS_REQUEST:
            {
                return _extends({}, state, { isYearGroupDataLoaded: false });
            }

        case actions.GET_YEAR_GROUPS_SUCCESS:
            {
                return _extends({}, state, { isYearGroupDataLoaded: true, yearGroups: action.data });
            }

        case actions.GET_YEAR_GROUPS_FAILURE:
            {
                return _extends({}, state, { isYearGroupDataLoaded: true });
            }
        default:
            return _extends({}, state);
    }
};

var _actions = __webpack_require__(44);

var actions = _interopRequireWildcard(_actions);

var _messages = __webpack_require__(399);

var _messages2 = _interopRequireDefault(_messages);

var _actions2 = __webpack_require__(98);

var studentRollActions = _interopRequireWildcard(_actions2);

var _actions3 = __webpack_require__(127);

var editStudentActions = _interopRequireWildcard(_actions3);

var _actions4 = __webpack_require__(38);

var classRollActions = _interopRequireWildcard(_actions4);

var _utils = __webpack_require__(13);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var tabs = {
    data: [{ id: 1, name: 'Students', route: 'students' }, { id: 2, name: 'Teachers', route: 'teachers' }, { id: 3, name: 'Classes', route: 'classes' }]
};

var initState = {
    licenceSummaryTitle: _messages2.default.licenceSummary.defaultMessage,
    licenceSummary: undefined,
    tabs: tabs,
    loadLicenceSummary: true,
    loadClassroomData: true,
    yearGroups: [],
    isYearGroupDataLoaded: false,
    countries: {
        raw: [],
        filtered: []
    },
    upfCountries: {
        raw: [],
        filtered: []
    },
    isCountriesLoaded: false,
    isUpfCountriesLoaded: false,
    lastAddedTeacherUserProfileId: 0
};

/***/ }),
/* 860 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.getYearGroups = getYearGroups;
exports.getYearGroupSaga = getYearGroupSaga;
exports.getLicenceCapSummary = getLicenceCapSummary;
exports.getLicenceCapSummarySaga = getLicenceCapSummarySaga;
exports.getCourseCountries = getCourseCountries;
exports.getCourseCountriesSaga = getCourseCountriesSaga;
exports.getUpfCourseCountries = getUpfCourseCountries;
exports.getUpfCourseCountriesSaga = getUpfCourseCountriesSaga;

var _effects = __webpack_require__(32);

var _actions = __webpack_require__(44);

var actions = _interopRequireWildcard(_actions);

var _api = __webpack_require__(33);

var api = _interopRequireWildcard(_api);

var _constants = __webpack_require__(40);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var _marked = /*#__PURE__*/regeneratorRuntime.mark(getYearGroups),
    _marked2 = /*#__PURE__*/regeneratorRuntime.mark(getYearGroupSaga),
    _marked3 = /*#__PURE__*/regeneratorRuntime.mark(getLicenceCapSummary),
    _marked4 = /*#__PURE__*/regeneratorRuntime.mark(getLicenceCapSummarySaga),
    _marked5 = /*#__PURE__*/regeneratorRuntime.mark(getCourseCountries),
    _marked6 = /*#__PURE__*/regeneratorRuntime.mark(getCourseCountriesSaga),
    _marked7 = /*#__PURE__*/regeneratorRuntime.mark(getUpfCourseCountries),
    _marked8 = /*#__PURE__*/regeneratorRuntime.mark(getUpfCourseCountriesSaga);

function getYearGroups() {
    var payload;
    return regeneratorRuntime.wrap(function getYearGroups$(_context) {
        while (1) {
            switch (_context.prev = _context.next) {
                case 0:
                    _context.next = 2;
                    return (0, _effects.call)(api.getYearGroups);

                case 2:
                    payload = _context.sent;

                    if (!(payload.status === 200)) {
                        _context.next = 8;
                        break;
                    }

                    _context.next = 6;
                    return (0, _effects.put)(actions.getYearGroupsSuccess(payload));

                case 6:
                    _context.next = 10;
                    break;

                case 8:
                    _context.next = 10;
                    return (0, _effects.put)(actions.getYearGroupsFailure());

                case 10:
                case 'end':
                    return _context.stop();
            }
        }
    }, _marked, this);
}

function getYearGroupSaga() {
    return regeneratorRuntime.wrap(function getYearGroupSaga$(_context2) {
        while (1) {
            switch (_context2.prev = _context2.next) {
                case 0:
                    _context2.next = 2;
                    return (0, _effects.takeLatest)(actions.GET_YEAR_GROUPS_REQUEST, getYearGroups);

                case 2:
                case 'end':
                    return _context2.stop();
            }
        }
    }, _marked2, this);
}

function getLicenceCapSummary(_ref) {
    var productId = _ref.productId;
    var payload;
    return regeneratorRuntime.wrap(function getLicenceCapSummary$(_context3) {
        while (1) {
            switch (_context3.prev = _context3.next) {
                case 0:
                    _context3.next = 2;
                    return (0, _effects.call)(api.getLicenceSummaryByProduct, productId);

                case 2:
                    payload = _context3.sent;

                    if (!(payload.status === 200)) {
                        _context3.next = 8;
                        break;
                    }

                    _context3.next = 6;
                    return (0, _effects.put)(actions.getLicenceCapSummarySuccess(payload));

                case 6:
                    _context3.next = 10;
                    break;

                case 8:
                    _context3.next = 10;
                    return (0, _effects.put)(actions.getLicenceCapSummaryFailure());

                case 10:
                case 'end':
                    return _context3.stop();
            }
        }
    }, _marked3, this);
}

function getLicenceCapSummarySaga() {
    return regeneratorRuntime.wrap(function getLicenceCapSummarySaga$(_context4) {
        while (1) {
            switch (_context4.prev = _context4.next) {
                case 0:
                    _context4.next = 2;
                    return (0, _effects.takeLatest)(actions.GET_LICENCE_CAP_SUMMARY_REQUEST, getLicenceCapSummary);

                case 2:
                case 'end':
                    return _context4.stop();
            }
        }
    }, _marked4, this);
}

function getCourseCountries(_ref2) {
    var selectedProductId = _ref2.selectedProductId;
    var countriesRequest, response;
    return regeneratorRuntime.wrap(function getCourseCountries$(_context5) {
        while (1) {
            switch (_context5.prev = _context5.next) {
                case 0:
                    countriesRequest = { ProductId: selectedProductId };
                    _context5.next = 3;
                    return (0, _effects.call)(api.getCourseCountries, countriesRequest);

                case 3:
                    response = _context5.sent;

                    if (!(response.status === 200)) {
                        _context5.next = 9;
                        break;
                    }

                    _context5.next = 7;
                    return (0, _effects.put)(actions.getCourseCountriesSuccess(response.data));

                case 7:
                    _context5.next = 11;
                    break;

                case 9:
                    _context5.next = 11;
                    return (0, _effects.put)(actions.getCourseCountriesFailure());

                case 11:
                case 'end':
                    return _context5.stop();
            }
        }
    }, _marked5, this);
}

function getCourseCountriesSaga() {
    return regeneratorRuntime.wrap(function getCourseCountriesSaga$(_context6) {
        while (1) {
            switch (_context6.prev = _context6.next) {
                case 0:
                    _context6.next = 2;
                    return (0, _effects.takeLatest)(actions.GET_COUNTRIES_REQUEST, getCourseCountries);

                case 2:
                case 'end':
                    return _context6.stop();
            }
        }
    }, _marked6, this);
}

function getUpfCourseCountries(_ref3) {
    var selectedProductId = _ref3.selectedProductId,
        _ref3$countryCourseTy = _ref3.countryCourseType,
        countryCourseType = _ref3$countryCourseTy === undefined ? _constants.COUNTRY_COURSE_TYPE.UPF : _ref3$countryCourseTy;
    var countriesRequest, response;
    return regeneratorRuntime.wrap(function getUpfCourseCountries$(_context7) {
        while (1) {
            switch (_context7.prev = _context7.next) {
                case 0:
                    countriesRequest = { ProductId: selectedProductId, countryCourseType: countryCourseType };
                    _context7.next = 3;
                    return (0, _effects.call)(api.getUpfCourseCountries, countriesRequest);

                case 3:
                    response = _context7.sent;

                    if (!(response.status === 200)) {
                        _context7.next = 9;
                        break;
                    }

                    _context7.next = 7;
                    return (0, _effects.put)(actions.getUpfCourseCountriesSuccess(response.data));

                case 7:
                    _context7.next = 11;
                    break;

                case 9:
                    _context7.next = 11;
                    return (0, _effects.put)(actions.getUpfCourseCountriesFailure());

                case 11:
                case 'end':
                    return _context7.stop();
            }
        }
    }, _marked7, this);
}

function getUpfCourseCountriesSaga() {
    return regeneratorRuntime.wrap(function getUpfCourseCountriesSaga$(_context8) {
        while (1) {
            switch (_context8.prev = _context8.next) {
                case 0:
                    _context8.next = 2;
                    return (0, _effects.takeLatest)(actions.GET_UPF_COUNTRIES_REQUEST, getUpfCourseCountries);

                case 2:
                case 'end':
                    return _context8.stop();
            }
        }
    }, _marked8, this);
}

/***/ }),
/* 861 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
/**
 * get selected product
 * @param state
 * @returns {*|boolean}
 */

var getProduct = exports.getProduct = function getProduct(state) {
  return state.product;
};

exports.default = getProduct;

/***/ }),
/* 862 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var signInCardsEnum = function signInCardsEnum() {
    _classCallCheck(this, signInCardsEnum);
};

signInCardsEnum.LABELS = {
    SIZES: [{
        key: 'QR_3X3',
        value: 'QR'
    }, {
        key: 'QR',
        value: 'QR'
    }, {
        key: '_2X5',
        value: '2 x 5'
    }, {
        key: '_2X7',
        value: '2 x 7'
    }, {
        key: '_3X8',
        value: '3 x 8'
    }],
    DEFAULT_SIZE: 'QR_3X3'
};
signInCardsEnum.STUDENTS = 'students';
signInCardsEnum.TEACHERS = 'teachers';
exports.default = signInCardsEnum;

/***/ }),
/* 863 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = __webpack_require__(28);

var _filter = __webpack_require__(137);

var _filter2 = _interopRequireDefault(_filter);

var _indexOf = __webpack_require__(1445);

var _indexOf2 = _interopRequireDefault(_indexOf);

var _map = __webpack_require__(139);

var _map2 = _interopRequireDefault(_map);

var _redux = __webpack_require__(35);

var _signInCards = __webpack_require__(757);

var _signInCards2 = _interopRequireDefault(_signInCards);

var _actions = __webpack_require__(50);

var _actions2 = __webpack_require__(38);

var _constants = __webpack_require__(862);

var _constants2 = _interopRequireDefault(_constants);

var _actions3 = __webpack_require__(98);

var _constants3 = __webpack_require__(40);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var SignInCardsContainer = function (_PureComponent) {
    _inherits(SignInCardsContainer, _PureComponent);

    function SignInCardsContainer(props) {
        _classCallCheck(this, SignInCardsContainer);

        var _this = _possibleConstructorReturn(this, (SignInCardsContainer.__proto__ || Object.getPrototypeOf(SignInCardsContainer)).call(this, props));

        _this.filterClassroomsByStudentsCount = function (classrooms) {
            return (0, _filter2.default)(classrooms, function (classroom) {
                return classroom.key === -1 || classroom.studentsCount;
            });
        };

        _this.filterClassroomsByTeacher = function (classrooms) {
            var filteredClassrooms = (0, _filter2.default)(classrooms, function (classroom) {
                return classroom.key === -1 || (0, _indexOf2.default)(classroom.teachersId, Number(_this.selectedTeacherId)) !== -1;
            });
            return filteredClassrooms;
        };

        _this.onTeacherSelectionChange = function (name, value) {
            var classrooms = _this.props.classrooms;

            if (value === _constants3.DEFAULT_TEACHER_ID) {
                _this.selectedTeacherId = _constants3.DEFAULT_TEACHER_ID;
                _this.filteredClassrooms = _this.filterClassroomsByStudentsCount(classrooms);
            } else {
                _this.selectedTeacherId = value;
                _this.filteredClassrooms = _this.filterClassroomsByTeacher(_this.filterClassroomsByStudentsCount(classrooms));
            }
            _this.selectedClassroomId = _constants3.DEFAULT_CLASSROOM_ID;
            _this.onChangeCurrentSelection(_this.state.currentSelection, _this.filteredClassrooms);
        };

        _this.onClassSelectionChange = function (name, value) {
            _this.selectedClassroomId = value;
        };

        _this.getAllSchoolTeachers = function () {
            var teachers = _this.props.teachers;

            var filteredTeachers = teachers.filter(function (teacher) {
                return teacher.key !== -1;
            });
            _this.schoolTeachers = (0, _map2.default)(filteredTeachers, function (teacher) {
                return teacher.key;
            });
        };

        _this.onLabelSelectionChange = function (name, value) {
            _this.selectedLabelSize = value;
        };

        _this.onChangeCurrentSelection = function (value, filteredClassrooms) {
            var teachers = _this.props.teachers;


            var disableDownload = false;

            if (value === _constants2.default.STUDENTS) {
                disableDownload = filteredClassrooms && filteredClassrooms.length <= 1;
            } else if (value === _constants2.default.TEACHERS) {
                disableDownload = teachers.length <= 1;
            }
            _this.setState({ currentSelection: value, disableDownload: disableDownload, filteredClassrooms: filteredClassrooms });
        };

        _this.state = {
            filteredClassrooms: [],
            disableDownload: false,
            currentSelection: _constants2.default.STUDENTS
        };

        _this.selectedLabelSize = _constants2.default.LABELS.DEFAULT_SIZE;
        _this.schoolTeachers = [];
        _this.selectedTeacherId = _constants3.DEFAULT_TEACHER_ID;
        _this.filteredClassrooms = [];
        _this.selectedClassroomId = _constants3.DEFAULT_CLASSROOM_ID;

        _this.downloadStudentSignInCards = _this.downloadStudentSignInCards.bind(_this);
        return _this;
    }

    _createClass(SignInCardsContainer, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            var _props = this.props,
                teachers = _props.teachers,
                selectedProduct = _props.selectedProduct,
                classrooms = _props.classrooms;

            if (!teachers.length) {
                this.props.getProductTeachers(selectedProduct.id);
            } else {
                this.getAllSchoolTeachers();
            }

            if (!classrooms.length) {
                this.props.getProductClassrooms(selectedProduct.id);
            } else {
                this.filteredClassrooms = this.filterClassroomsByStudentsCount(classrooms);
                this.onChangeCurrentSelection(_constants2.default.STUDENTS, this.filteredClassrooms);
            }
        }
    }, {
        key: 'componentWillReceiveProps',
        value: function componentWillReceiveProps(nextProps) {
            if (this.props.isStudentSignInCardDownloaded === nextProps.isStudentSignInCardDownloaded) {
                var classrooms = nextProps.classrooms;

                if (this.state.currentSelection && this.state.currentSelection === _constants2.default.STUDENTS) {
                    this.filteredClassrooms = this.filterClassroomsByStudentsCount(classrooms);
                    this.setState({ filteredClassrooms: this.filteredClassrooms });
                    this.getAllSchoolTeachers();
                }
                this.onChangeCurrentSelection(this.state.currentSelection, this.filteredClassrooms);
            }
        }
    }, {
        key: 'downloadStudentSignInCards',
        value: function downloadStudentSignInCards() {
            var studentSignInCardsData = { signInCardPageSizeType: this.selectedLabelSize };
            if (this.selectedClassroomId && this.selectedClassroomId !== _constants3.DEFAULT_CLASSROOM_ID) {
                studentSignInCardsData.classroomId = Number(this.selectedClassroomId);
            }
            if (this.selectedTeacherId && this.selectedTeacherId !== _constants3.DEFAULT_TEACHER_ID) {
                studentSignInCardsData.teacherUserProfileId = Number(this.selectedTeacherId);
            }
            this.props.printSignInCard(this.props.selectedProduct.id, studentSignInCardsData);
        }
    }, {
        key: 'render',
        value: function render() {
            return _react2.default.createElement(_signInCards2.default, _extends({
                currentSelection: this.state.currentSelection,
                disableDownload: this.state.disableDownload,
                filteredClassrooms: this.state.filteredClassrooms,
                onClassSelectionChange: this.onClassSelectionChange,
                onDownloadSignInCards: this.downloadStudentSignInCards,
                onLabelSelectionChange: this.onLabelSelectionChange,
                onTeacherSelection: this.onTeacherSelectionChange,
                selectedTeachersId: this.schoolTeachers,
                signInCardsEnum: _constants2.default
            }, this.props));
        }
    }]);

    return SignInCardsContainer;
}(_react.PureComponent);

SignInCardsContainer.propTypes = {
    selectedProduct: _propTypes2.default.object,
    teachers: _propTypes2.default.array,
    classrooms: _propTypes2.default.array,
    getProductTeachers: _propTypes2.default.func,
    getProductClassrooms: _propTypes2.default.func,
    printSignInCard: _propTypes2.default.func,
    printTeacherSignInCard: _propTypes2.default.func,
    isClassroomsLoaded: _propTypes2.default.bool,
    isTeachersLoaded: _propTypes2.default.bool,
    isStudentSignInCardDownloaded: _propTypes2.default.bool,
    isTeacherSignInCardDownloaded: _propTypes2.default.bool
};

var mapStateToProps = function mapStateToProps(state) {
    return {
        selectedProduct: state.product,
        teachers: state.signInCards.teachers,
        classrooms: state.signInCards.classrooms,
        isTeachersLoaded: state.signInCards.isTeachersLoaded,
        isClassroomsLoaded: state.signInCards.isClassroomsLoaded,
        isStudentSignInCardDownloaded: state.studentRoll.isSignInCardDownloaded,
        isTeacherSignInCardDownloaded: state.teacherRoll.isSignInCardDownloaded
    };
};

function mapDispatchToProps(dispatch) {
    return (0, _redux.bindActionCreators)({
        getProductTeachers: _actions.getProductTeachers,
        getProductClassrooms: _actions2.getProductClassrooms,
        printSignInCard: _actions3.printSignInCard,
        printTeacherSignInCard: _actions.printTeacherSignInCard
    }, dispatch);
}

exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(SignInCardsContainer);

/***/ }),
/* 864 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _reactIntl = __webpack_require__(2);

exports.default = (0, _reactIntl.defineMessages)({
    defaultOptionTeachers: {
        id: 'sign-in-cards.defaultOptionTeachers',
        defaultMessage: 'All teachers'
    },
    defaultOptionClassrooms: {
        id: 'sign-in-cards.defaultOptionClassrooms',
        defaultMessage: 'All classes'
    }
});

/***/ }),
/* 865 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.default = function () {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initState;
    var action = arguments[1];

    switch (action.type) {
        case _actions2.GET_PRODUCT_TEACHERS_SUCCESS:
            {
                return _extends({}, state, {
                    teachers: getUpdatedTeachers(action.data),
                    isTeachersLoaded: true
                });
            }

        case _actions.GET_CLASSROOMS_SUCCESS:
            {
                return _extends({}, state, {
                    classrooms: getUpdatedClassrooms(action.data),
                    isClassroomsLoaded: true
                });
            }

        default:
            return _extends({}, state);
    }
};

var _actions = __webpack_require__(38);

var _actions2 = __webpack_require__(50);

var _messages = __webpack_require__(864);

var _messages2 = _interopRequireDefault(_messages);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var initState = {
    teachers: [],
    classrooms: [],
    isTeachersLoaded: false,
    isClassroomsLoaded: false
};

var dataFilterOption = {
    classrooms: [{ key: -1, value: _messages2.default.defaultOptionClassrooms, selected: true }],
    teachers: [{ key: -1, value: _messages2.default.defaultOptionTeachers, selected: true }]
};

var getUpdatedClassrooms = function getUpdatedClassrooms(classrooms) {
    var classes = classrooms.map(function (classroom) {
        return {
            value: classroom.name,
            key: classroom.classroomId,
            selected: false,
            studentsCount: classroom.studentsProfileId.length,
            teachersId: classroom.teachers.map(function (teacher) {
                return teacher.userProfileId;
            })
        };
    });

    return dataFilterOption.classrooms.concat(classes);
};

var getUpdatedTeachers = function getUpdatedTeachers(teachers) {
    var teachersList = teachers.map(function (teacher) {
        return {
            value: teacher.lastName + ', ' + teacher.firstName,
            name: teacher.firstName + ' ' + teacher.lastName,
            key: teacher.userProfileId,
            selected: false
        };
    });

    return dataFilterOption.teachers.concat(teachersList);
};

/***/ }),
/* 866 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __webpack_require__(28);

var _redux = __webpack_require__(35);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _clone = __webpack_require__(122);

var _clone2 = _interopRequireDefault(_clone);

var _filter = __webpack_require__(137);

var _filter2 = _interopRequireDefault(_filter);

var _reactIntl = __webpack_require__(2);

var _actions = __webpack_require__(98);

var _actions2 = __webpack_require__(95);

var _actions3 = __webpack_require__(65);

var _messages = __webpack_require__(266);

var _messages2 = _interopRequireDefault(_messages);

var _index = __webpack_require__(774);

var _index2 = _interopRequireDefault(_index);

var _gridUtil = __webpack_require__(86);

var _actions4 = __webpack_require__(38);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var StudentRollContainer = function (_Component) {
    _inherits(StudentRollContainer, _Component);

    function StudentRollContainer(props) {
        _classCallCheck(this, StudentRollContainer);

        var _this = _possibleConstructorReturn(this, (StudentRollContainer.__proto__ || Object.getPrototypeOf(StudentRollContainer)).call(this, props));

        _this.filterClassrooms = function (classrooms) {
            var classes = classrooms.map(function (item) {
                return {
                    key: item.name,
                    value: item.name,
                    classroomId: item.classroomId
                };
            });
            return classes;
        };

        _this.handleOnDownloadStudentRoll = function () {
            _this.props.downloadStudentRoll(_this.props.filteredStudents, false);
        };

        _this.handleOnQuickUpload = function () {
            _this.context.router.history.push('quickUpload');
        };

        _this.handleOnAddStudent = function () {
            _this.props.openAddStudentModal();
        };

        _this.reloadStudentList = function () {
            var refreshStudentList = _this.props.lastAddedStudentUserProfileId > 0;
            if (refreshStudentList) {
                _this.props.getProductStudents(_this.props.selectedProduct.id);
            }
        };

        _this.handleOnCloseAddStudentModal = function () {
            _this.setState({ canSubmit: false });
            _this.props.closeAddStudentModal();
            _this.reloadStudentList();
        };

        _this.handleOnCloseAddStudentValidationModal = function () {
            _this.setState({ canSubmit: true });
            _this.props.closeAddStudentValidationModal();
        };

        _this.handleFilterOnClear = function () {
            _this.props.clearFilterValue();
        };

        _this.handleFilterOnChange = function (collectionName, key) {
            _this.props.changeFilterValue(collectionName, key);
        };

        _this.handleOnSearch = function (searchTerm) {
            _this.props.updateSearchTerm(searchTerm);
        };

        _this.handleRowSelect = function (rows) {
            _this.props.retrieveSelectedStudents(rows);
        };

        _this.handleOnAddStudentSubmit = function () {
            var student = (0, _clone2.default)(_this.props.student);
            student.yearGroup = parseInt(student.yearGroup, 10);
            student.classroomId = parseInt(student.classroomId, 10);
            _this.setState({ canSubmit: false });
            _this.props.addStudent(student);
        };

        _this.handleOnAddStudentGetGroups = function (classroomId) {
            _this.props.getClassroomGroups(classroomId);
        };

        _this.handleOnStudentUnassign = function () {
            _this.setState({ showModal: true });
            _this.props.openUnAssignStudentsModal();
        };

        _this.handleOnUnassignConfirm = function () {
            _this.props.unassignStudents(_this.props.selectedStudents, _this.props.selectedProduct.id);
        };

        _this.handleOnCloseModal = function () {
            _this.setState({ showModal: false });
            _this.props.resetUserClassroomRelation();
        };

        _this.handleOnAddAnotherStudent = function () {
            _this.props.addAnotherStudentModal();
        };

        _this.studentsOperationSuccessConfirmation = function () {
            _this.handleOnCloseModal();
            _this.props.closeStudentsOperationConfirmationModal();
        };

        _this.handleOnStudentEdit = function (userProfileId) {
            _this.context.router.history.push('/edit-student/' + userProfileId);
        };

        _this.handleOnAssignClass = function (id) {
            var assignType = 'classToStudent';
            _this.context.router.history.push('/assign-user/' + id + '/' + assignType);
        };

        _this.handleOnStudentDeleteConfirmation = function () {
            var _this$props = _this.props,
                students = _this$props.students,
                selectedStudents = _this$props.selectedStudents;

            var selectedStudentsForDelete = (0, _filter2.default)(students, function (student) {
                return selectedStudents.indexOf(student.userProfileId) !== -1;
            });

            var totalAssignedClasses = (0, _filter2.default)(selectedStudentsForDelete, function (student) {
                return student.assignedClassrooms.length > 0;
            });
            var totalAssignedProducts = selectedStudentsForDelete.filter(function (student) {
                return student.accessibleProducts.length > 0;
            });

            if (totalAssignedClasses.length > 0) {
                _this.props.showToast(_this.props.intl.formatMessage(_messages2.default.errorOnDeletingAssignedStudents), 'error');
            } else if (totalAssignedProducts.length > 0) {
                _this.setState({ showModal: true });
                _this.props.openDeleteUserConfirmation();
            } else {
                _this.handleOnDeleteStudent();
            }
        };

        _this.handleOnStudentDeleteClose = function () {
            _this.setState({ showModal: false });
            _this.props.closeStudentsOperationConfirmationModal();
        };

        _this.handleOnDeleteStudent = function () {
            _this.props.deleteStudentRequest(_this.props.selectedStudents, _this.props.selectedProduct.id);
        };

        _this.handleOnStudentBulkPasswordChange = function () {
            _this.setState({ showModal: true, bulkPasswordValue: '' });
            _this.props.openBulkPasswordChangeStudentsModal();
        };

        _this.handleOnStudentBulkPasswordChangeNewValue = function (event) {
            _this.setState({
                bulkPasswordValue: event.target.value.trim()
            });
        };

        _this.handleOnBulkPasswordChangeConfirm = function () {
            _this.props.bulkPasswordChangeStudents(_this.props.selectedStudents, _this.state.bulkPasswordValue);
        };

        _this.showDeleteConfirmationInToast = function () {
            var _this$props2 = _this.props,
                deletedStudentsCount = _this$props2.deletedStudentsCount,
                isPartialDelete = _this$props2.isPartialDelete;


            _this.setState({ showModal: false });
            if (isPartialDelete) {
                _this.props.showToast(_this.props.intl.formatMessage(_messages2.default.partialDeleteMessage1) + ' \n            ' + deletedStudentsCount + ' ' + _this.props.intl.formatMessage(_messages2.default.partialDeleteMessage2), 'warning');
            } else {
                _this.props.showToast(_this.props.intl.formatMessage(_messages2.default.deleteStudentSuccess, { deletedStudentsCount: deletedStudentsCount }), 'success');
            }
            _this.props.clearOperationTypeRequest();
        };

        _this.handleOnDownSignInCards = function () {
            _this.setState({ showModal: true });
            _this.props.downloadStudentsSignInCards();
        };

        _this.handleOnStudentSignInCards = function () {
            _this.props.showHideSignInCardModalRequest(true);
        };

        _this.handleOnCancelStudentSignInCards = function () {
            _this.props.showHideSignInCardModalRequest(false);
        };

        _this.handleGridSort = _this.handleGridSort.bind(_this);
        _this.rows = props.isStudentDataLoaded ? (0, _gridUtil.createRows)(props.filteredStudents) : [];
        _this.state = {
            rows: _this.rows,
            dataFilterOption: _this.props.dataFilterOption,
            bulkPasswordValue: ''
        };

        _this.handleOnPrintSignInCard = _this.handleOnPrintSignInCard.bind(_this);
        _this.handleOnPrintMultipleSignInCard = _this.handleOnPrintMultipleSignInCard.bind(_this);
        _this.handleOnStudentUnassign = _this.handleOnStudentUnassign.bind(_this);
        _this.handleOnCloseModal = _this.handleOnCloseModal.bind(_this);
        _this.handleOnUnassignConfirm = _this.handleOnUnassignConfirm.bind(_this);
        _this.filterClassrooms = _this.filterClassrooms.bind(_this);
        _this.handleOnStudentBulkPasswordChange = _this.handleOnStudentBulkPasswordChange.bind(_this);
        _this.handleOnStudentBulkPasswordChangeNewValue = _this.handleOnStudentBulkPasswordChangeNewValue.bind(_this);
        _this.handleOnBulkPasswordChangeConfirm = _this.handleOnBulkPasswordChangeConfirm.bind(_this);
        _this.handleOnAddStudentGetGroups = _this.handleOnAddStudentGetGroups.bind(_this);
        return _this;
    }

    _createClass(StudentRollContainer, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            if (!this.props.isStudentDataLoaded) {
                this.props.getProductStudents(this.props.selectedProduct.id);
            }

            if (!this.props.isClassroomDataLoaded) {
                this.props.getProductClassrooms(this.props.selectedProduct.id);
            }
        }
    }, {
        key: 'componentWillReceiveProps',
        value: function componentWillReceiveProps(nextProps) {
            if (nextProps.isStudentDataLoaded || (0, _gridUtil.isListDifferent)(nextProps.filteredStudents, this.props.filteredStudents, 'userProfileId')) {
                this.rows = (0, _gridUtil.createRows)(nextProps.filteredStudents);
                this.setState({ rows: this.rows });
            }

            if (nextProps.refreshStudentList && nextProps.refreshStudentList !== this.props.refreshStudentList) {
                this.props.getProductStudents(this.props.selectedProduct.id);
            }

            if (nextProps.isSignInCardDownloaded !== this.props.isSignInCardDownloaded) {
                setTimeout(this.handleOnCloseModal, 1000);
                setTimeout(this.props.showHideSignInCardModalRequest(false), 1000);
            }

            this.setState({ dataFilterOption: this.props.dataFilterOption });
        }
    }, {
        key: 'handleOnPrintSignInCard',
        value: function handleOnPrintSignInCard(format) {
            var studentProfileIds = [];
            studentProfileIds.push(this.props.lastAddedStudentUserProfileId);
            var studentSignInCardsData = { studentUserProfileIds: studentProfileIds, SignInCardPageSizeType: format };
            this.props.printSignInCard(this.props.selectedProduct.id, studentSignInCardsData);
        }
    }, {
        key: 'handleOnPrintMultipleSignInCard',
        value: function handleOnPrintMultipleSignInCard(format) {
            var studentSignInCardsData = { studentUserProfileIds: this.props.selectedStudents,
                SignInCardPageSizeType: format };
            this.props.printSignInCard(this.props.selectedProduct.id, studentSignInCardsData);
        }
    }, {
        key: 'handleGridSort',
        value: function handleGridSort(sortColumn) {
            this.props.sortStudentList(sortColumn);
        }
    }, {
        key: 'render',
        value: function render() {
            var _this2 = this;

            var rowGetter = function rowGetter(rowNumber) {
                return _this2.state.rows[rowNumber];
            };
            return _react2.default.createElement(_index2.default, {
                addStudentValidationMessage: this.props.addStudentValidationMessage,
                bulkPasswordChangeSuccessConfirmation: this.bulkPasswordChangeSuccessConfirmation,
                bulkPasswordValue: this.state.bulkPasswordValue,
                classroomGroups: this.props.classroomGroups,
                classrooms: this.props.classrooms,
                closeAddStudentValidationModal: this.handleOnCloseAddStudentValidationModal,
                dataFilterOptions: this.state.dataFilterOption,
                deleteStudent: this.props.deleteStudentRequest,
                downloadStudentsSignInCards: this.handleOnDownSignInCards,
                filteredStudentsCount: this.props.filteredStudents.length,
                filterOnChange: this.handleFilterOnChange,
                filterOnClear: this.handleFilterOnClear,
                getClassroomGroups: this.handleOnAddStudentGetGroups,
                gridRowGetter: rowGetter,
                handleOnAddStudentSubmit: this.handleOnAddStudentSubmit,
                handleOnAssignClass: this.handleOnAssignClass,
                handleOnBulkPasswordChangeConfirm: this.handleOnBulkPasswordChangeConfirm,
                handleOnCancelStudentSignInCards: this.handleOnCancelStudentSignInCards,
                handleOnChangeBulkPasswordSetValue: this.handleOnStudentBulkPasswordChangeNewValue,
                handleOnCloseModal: this.handleOnCloseModal,
                handleOnDeleteConfirmation: this.showDeleteConfirmationInToast,
                handleOnDeleteStudent: this.handleOnDeleteStudent,
                handleOnPrintMultipleSignInCard: this.handleOnPrintMultipleSignInCard,
                handleOnPrintSignInCard: this.handleOnPrintSignInCard,
                handleOnStudentBulkPasswordChange: this.handleOnStudentBulkPasswordChange,
                handleOnStudentDeleteClose: this.handleOnStudentDeleteClose,
                handleOnStudentDeleteConfirmation: this.handleOnStudentDeleteConfirmation,
                handleOnStudentEdit: this.handleOnStudentEdit,
                handleOnStudentSignInCards: this.handleOnStudentSignInCards,
                handleOnStudentUnassign: this.handleOnStudentUnassign,
                handleOnUnassignConfirm: this.handleOnUnassignConfirm,
                isDeleteUserModalOpen: this.props.isDeleteUserModalOpen,
                isLoading: this.props.disableConfirmationButton,
                isSaveInProgress: this.props.isSaveInProgress,
                isSignInCardDownloaded: this.props.isSignInCardDownloaded,
                isStudentDataLoaded: this.props.isStudentDataLoaded,
                isStudentRollDownloaded: this.props.isStudentRollDownloaded,
                isUserOperationModalOpen: this.props.isUserOperationModalOpen,
                onAddAnotherStudent: this.handleOnAddAnotherStudent,
                onAddStudent: this.handleOnAddStudent,
                onAddStudentCloseModal: this.handleOnCloseAddStudentModal,
                onDownloadStudentRoll: this.handleOnDownloadStudentRoll,
                onGridSort: this.handleGridSort,
                onQuickUpload: this.handleOnQuickUpload,
                onRowSelect: this.handleRowSelect,
                onSearch: this.handleOnSearch,
                operationType: this.props.operationType,
                selectedProduct: this.props.selectedProduct,
                selectedStudents: this.props.selectedStudents,
                showAddStudentConfirmationModal: this.props.showAddStudentConfirmationModal,
                showAddStudentsModal: this.props.showModal,
                showAddStudentValidationModal: this.props.showAddStudentValidationModal,
                showHideSignInCardModal: this.props.showHideSignInCardModal,
                showModal: this.state.showModal,
                student: this.props.student,
                students: this.state.rows,
                studentsCount: this.props.students.length,
                studentsOperationSuccessConfirmation: this.studentsOperationSuccessConfirmation
            });
        }
    }]);

    return StudentRollContainer;
}(_react.Component);

StudentRollContainer.propTypes = {
    isStudentDataLoaded: _propTypes2.default.bool,
    isClassroomDataLoaded: _propTypes2.default.bool,
    isSaveInProgress: _propTypes2.default.bool,
    isStudentRollDownloaded: _propTypes2.default.bool,
    isSignInCardDownloaded: _propTypes2.default.bool,
    showAddStudentValidationModal: _propTypes2.default.bool,
    showModal: _propTypes2.default.bool,
    showAddStudentConfirmationModal: _propTypes2.default.bool,
    addStudentValidationMessage: _propTypes2.default.string,
    lastAddedStudentUserProfileId: _propTypes2.default.number,
    student: _propTypes2.default.object,
    dataFilterOption: _propTypes2.default.object,
    students: _propTypes2.default.arrayOf(_propTypes2.default.object),
    classrooms: _propTypes2.default.arrayOf(_propTypes2.default.object),
    filteredStudents: _propTypes2.default.arrayOf(_propTypes2.default.object),
    selectedStudents: _propTypes2.default.arrayOf(_propTypes2.default.number),
    selectedProduct: _propTypes2.default.object,
    getProductStudents: _propTypes2.default.func,
    getProductClassrooms: _propTypes2.default.func,
    downloadStudentRoll: _propTypes2.default.func,
    clearFilterValue: _propTypes2.default.func,
    changeFilterValue: _propTypes2.default.func,
    retrieveSelectedStudents: _propTypes2.default.func,
    updateSearchTerm: _propTypes2.default.func,
    sortStudentList: _propTypes2.default.func,
    unassignStudents: _propTypes2.default.func,
    isUserOperationModalOpen: _propTypes2.default.bool,
    refreshStudentList: _propTypes2.default.bool,
    openUnAssignStudentsModal: _propTypes2.default.func,
    closeStudentsOperationConfirmationModal: _propTypes2.default.func,
    disableConfirmationButton: _propTypes2.default.bool,
    openAddStudentModal: _propTypes2.default.func,
    closeAddStudentModal: _propTypes2.default.func,
    addStudent: _propTypes2.default.func,
    closeAddStudentValidationModal: _propTypes2.default.func,
    printSignInCard: _propTypes2.default.func,
    addAnotherStudentModal: _propTypes2.default.func,
    bulkPasswordChangeStudents: _propTypes2.default.func,
    openBulkPasswordChangeStudentsModal: _propTypes2.default.func,
    openDeleteUserConfirmation: _propTypes2.default.func,
    isDeleteUserModalOpen: _propTypes2.default.bool,
    deleteStudentRequest: _propTypes2.default.func,
    operationType: _propTypes2.default.string,
    showToast: _propTypes2.default.func,
    intl: _reactIntl.intlShape.isRequired,
    deletedStudentsCount: _propTypes2.default.number,
    isPartialDelete: _propTypes2.default.bool,
    clearOperationTypeRequest: _propTypes2.default.func,
    getClassroomGroups: _propTypes2.default.func,
    downloadStudentsSignInCards: _propTypes2.default.func,
    classroomGroups: _propTypes2.default.arrayOf(_propTypes2.default.object),
    showHideSignInCardModal: _propTypes2.default.bool,
    showHideSignInCardModalRequest: _propTypes2.default.func,
    resetUserClassroomRelation: _propTypes2.default.func
};
StudentRollContainer.contextTypes = {
    router: _propTypes2.default.object
};


function mapStateToProps() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    return _extends({}, state, {
        classrooms: state.classRoll.classrooms,
        classroomGroups: state.studentRoll.classroomGroups,
        yearGroups: state.schoolRoll.yearGroups,
        selectedProduct: state.product,
        students: state.studentRoll.students,
        filteredStudents: state.studentRoll.filteredStudents,
        selectedStudents: state.studentRoll.selectedStudents,
        isStudentDataLoaded: state.studentRoll.isStudentDataLoaded,
        isClassroomDataLoaded: state.studentRoll.isStudentDataLoaded,
        isYearGroupDataLoaded: state.studentRoll.isYearGroupDataLoaded,
        isStudentRollDownloaded: state.studentRoll.isStudentRollDownloaded,
        dataFilterOption: state.studentRoll.dataFilterOption,
        showModal: state.studentRoll.showModal,
        student: state.studentRoll.studentModel,
        isSaveInProgress: state.studentRoll.isSaveInProgress,
        showAddStudentValidationModal: state.studentRoll.showAddStudentValidationModal,
        addStudentValidationMessage: state.studentRoll.addStudentValidationMessage,
        isSignInCardDownloaded: state.studentRoll.isSignInCardDownloaded,
        showAddStudentConfirmationModal: state.studentRoll.showAddStudentConfirmationModal,
        lastAddedStudentUserProfileId: state.studentRoll.lastAddedStudentUserProfileId,
        isUserOperationModalOpen: state.studentRoll.isUserOperationModalOpen,
        refreshStudentList: state.studentRoll.refreshStudentList,
        disableConfirmationButton: state.studentRoll.disableConfirmationButton,
        isDeleteUserModalOpen: state.studentRoll.isDeleteUserModalOpen,
        operationType: state.studentRoll.operationType,
        unassignDisableButton: state.studentRoll.unassignDisableButton,
        bulkPasswordChangeDisableButton: state.studentRoll.bulkPasswordChangeDisableButton,
        deletedStudentsCount: state.studentRoll.deletedStudentsCount,
        isPartialDelete: state.studentRoll.isPartialDelete,
        showHideSignInCardModal: state.studentRoll.showHideSignInCardModal
    });
}

function mapDispatchToProps(dispatch) {
    return (0, _redux.bindActionCreators)({
        getProductStudents: _actions.getProductStudents,
        getProductClassrooms: _actions4.getProductClassrooms,
        downloadStudentRoll: _actions.downloadStudentRoll,
        clearFilterValue: _actions.clearFilterValue,
        changeFilterValue: _actions.changeFilterValue,
        updateSearchTerm: _actions.updateSearchTerm,
        sortStudentList: _actions.sortStudentList,
        retrieveSelectedStudents: _actions.retrieveSelectedStudents,
        openAddStudentModal: _actions.openAddStudentModal,
        closeAddStudentModal: _actions.closeAddStudentModal,
        addStudent: _actions.addStudent,
        closeAddStudentValidationModal: _actions.closeAddStudentValidationModal,
        printSignInCard: _actions.printSignInCard,
        unassignStudents: _actions.unassignStudents,
        addAnotherStudentModal: _actions.addAnotherStudentModal,
        openUnAssignStudentsModal: _actions.openUnAssignStudentsModal,
        closeStudentsOperationConfirmationModal: _actions.closeStudentsOperationConfirmationModal,
        openDeleteUserConfirmation: _actions.openDeleteUserConfirmation,
        deleteStudentRequest: _actions.deleteStudentRequest,
        openBulkPasswordChangeStudentsModal: _actions.openBulkPasswordChangeStudentsModal,
        bulkPasswordChangeStudents: _actions.bulkPasswordChangeStudents,
        showToast: _actions3.showToast,
        clearOperationTypeRequest: _actions.clearOperationTypeRequest,
        getClassroomGroups: _actions.getClassroomGroups,
        downloadStudentsSignInCards: _actions.downloadStudentsSignInCards,
        showHideSignInCardModalRequest: _actions.showHideSignInCardModalRequest,
        resetUserClassroomRelation: _actions2.resetUserClassroomRelation
    }, dispatch);
}

var intlContainer = (0, _reactIntl.injectIntl)(StudentRollContainer);
exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(intlContainer);

/***/ }),
/* 867 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.default = function () {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initState;
    var action = arguments[1];

    switch (action.type) {
        case actions.GET_PRODUCT_STUDENTS_REQUEST:
            {
                return _extends({}, state, { isStudentDataLoaded: false, students: [], filteredStudents: [] });
            }
        case actions.GET_PRODUCT_STUDENTS_SUCCESS:
            {
                state.dataFilterOption.searchTerm = '';
                return _extends({}, state, {
                    isStudentDataLoaded: true,
                    refreshStudentList: false,
                    students: action.data,
                    filteredStudents: getFilteredData(action.data, resetFilterOptions(state.dataFilterOption)),
                    studentsCount: action.data.length,
                    dataFilterOption: resetFilterOptions(state.dataFilterOption)
                });
            }
        case actions.DOWNLOAD_STUDENT_ROLL_REQUEST:
            {
                return _extends({}, state, { isStudentRollDownloaded: action.isStudentRollDownloaded });
            }
        case actions.DOWNLOAD_STUDENT_ROLL_SUCCESS:
            {
                return _extends({}, state, { isStudentRollDownloaded: action.isStudentRollDownloaded });
            }
        case actions.FILTER_VALUE_CLEARED:
            {
                var filterOption = resetFilterOptions(state.dataFilterOption);
                var filteredStudents = getFilteredData(state.students, filterOption);
                return _extends({}, state, { filteredStudents: filteredStudents, dataFilterOption: filterOption, selectedStudents: [] });
            }
        case actions.FILTER_VALUE_CHANGED:
            {
                var _filterOption = changeFilterOptions(state.dataFilterOption, action.collectionName, action.key);
                var _filteredStudents = getFilteredData(state.students, _filterOption);
                return _extends({}, state, { filteredStudents: _filteredStudents, dataFilterOption: _filterOption, selectedStudents: [] });
            }
        case actions.UPDATE_SEARCH_TERM:
            {
                var _filterOption2 = _extends({}, state.dataFilterOption, { searchTerm: action.searchTerm });
                var _filteredStudents2 = getFilteredData(state.students, _filterOption2);
                return _extends({}, state, { filteredStudents: _filteredStudents2, dataFilterOption: _filterOption2, selectedStudents: [] });
            }
        case actions.SORT_STUDENT_LIST:
            {
                var sortDirection = 'asc';
                if (state.dataFilterOption.sortColumn === action.columnToSort) {
                    if (state.dataFilterOption.sortDirection === 'asc') {
                        sortDirection = 'desc';
                    }
                }

                var _filterOption3 = _extends({}, state.dataFilterOption, { sortColumn: action.columnToSort, sortDirection: sortDirection });
                var _filteredStudents3 = getSortedData(state.filteredStudents, _filterOption3);
                return _extends({}, state, { filteredStudents: _filteredStudents3, dataFilterOption: _filterOption3 });
            }
        case actions.RETRIEVE_SELECTED_STUDENT:
            {
                return _extends({}, state, { selectedStudents: action.selectedStudents });
            }
        case actions.UNASSIGN_STUDENTS_REQUEST:
            {
                return _extends({}, state, { disableConfirmationButton: action.disableConfirmationButton });
            }
        case actions.UNASSIGN_STUDENTS_SUCCESS:
            {
                var _filterOption4 = _extends({}, state.dataFilterOption, { searchTerm: action.searchTerm });
                var _filteredStudents4 = getFilteredData(state.students, _filterOption4);
                return _extends({}, state, {
                    isUserOperationModalOpen: action.isUserOperationModalOpen,
                    disableConfirmationButton: action.disableConfirmationButton,
                    filteredStudents: _filteredStudents4
                });
            }
        case actions.UNASSIGN_STUDENTS_FAILURE:
            {
                return _extends({}, state, { disableConfirmationButton: action.disableConfirmationButton });
            }
        case actions.OPEN_UNASSIGN_STUDENTS_MODAL:
            {
                return _extends({}, state, { isUserOperationModalOpen: action.isUserOperationModalOpen, operationType: action.operationType });
            }
        case actions.CLOSE_STUDENTS_OPERATION_CONFIRMATION_MODAL:
            {
                return _extends({}, state, { refreshStudentList: action.refreshStudentList, selectedStudents: action.selectedStudents, operationType: action.operationType });
            }
        case actions.ADD_STUDENT_OPEN_MODAL_REQUEST:
            {
                return _extends({}, state, { showModal: action.showModal, studentModel: assignEmptyStudentObject(), showAddStudentConfirmationModal: action.showAddStudentConfirmationModal, lastAddedStudentUserProfileId: 0 });
            }
        case actions.ADD_ANOTHER_STUDENT_OPEN_MODAL_REQUEST:
            {
                return _extends({}, state, { showModal: action.showModal, studentModel: assignEmptyStudentObject(), showAddStudentConfirmationModal: action.showAddStudentConfirmationModal });
            }
        case actions.ADD_STUDENT_CLOSE_MODAL_REQUEST:
            {
                return _extends({}, state, {
                    showModal: action.showModal
                });
            }
        case actions.ADD_STUDENT_REQUEST:
            {
                return _extends({}, state, { isSaveInProgress: action.isSaveInProgress });
            }
        case actions.ADD_STUDENT_SUCCESS:
            {
                return _extends({}, state, {
                    isSaveInProgress: false,
                    studentModel: assignEmptyStudentObject(),
                    showAddStudentConfirmationModal: action.showAddStudentConfirmationModal,
                    lastAddedStudentUserProfileId: action.userProfileId,
                    selectedStudents: []
                });
            }
        case actions.ADD_STUDENT_FAILURE:
            {
                var errorMessage = '';
                if (action.isServerError) {
                    errorMessage = _messages2.default.errorMessageHeader;
                } else {
                    errorMessage = action.addStudentValidationMessage;
                }
                return _extends({}, state, { isSaveInProgress: false, showAddStudentValidationModal: action.showAddStudentValidationModal, addStudentValidationMessage: errorMessage });
            }
        case actions.ADD_STUDENT_GET_GROUPS_REQUEST:
            {
                return _extends({}, state, { isFetchingGroupsAddStudent: true, fetchedGroupsAddStudent: false });
            }
        case actions.ADD_STUDENT_GET_GROUPS_SUCCESS:
            {
                return _extends({}, state, { classroomGroups: action.classroomGroups, isFetchingGroupsAddStudent: false, fetchedGroupsAddStudent: true });
            }
        case actions.ADD_STUDENT_GET_GROUPS_FAILURE:
            {
                return _extends({}, state, { isFetchingGroupsAddStudent: false, fetchedGroupsAddStudent: false });
            }
        case actions.CLOSE_ADD_STUDENT_VALIDATION_MODAL:
            {
                return _extends({}, state, { showAddStudentValidationModal: action.showAddStudentValidationModal });
            }
        case actions.PRINT_SIGN_IN_CARD_REQUEST:
            {
                return _extends({}, state, { isSignInCardDownloaded: action.isSignInCardDownloaded });
            }
        case actions.PRINT_SIGN_IN_CARD_SUCCESS:
            {
                return _extends({}, state, { isSignInCardDownloaded: action.isSignInCardDownloaded });
            }
        case actions.PRINT_SIGN_IN_CARD_FAILURE:
            {
                return _extends({}, state, { isSignInCardDownloaded: action.isSignInCardDownloaded });
            }
        case actions.BULK_PASSWORD_CHANGE_STUDENTS_REQUEST:
            {
                return _extends({}, state, { disableConfirmationButton: action.disableConfirmationButton });
            }
        case actions.BULK_PASSWORD_CHANGE_STUDENTS_SET_VALUE:
            {
                return _extends({}, state, { bulkPasswordValue: action.bulkPasswordValue });
            }
        case actions.BULK_PASSWORD_CHANGE_STUDENTS_SUCCESS:
            {
                return _extends({}, state, { isUserOperationModalOpen: action.isUserOperationModalOpen, disableConfirmationButton: false });
            }
        case actions.BULK_PASSWORD_CHANGE_STUDENTS_FAILURE:
            {
                return _extends({}, state, { bulkPasswordChangeDisableButton: action.bulkPasswordChangeDisableButton, disableConfirmationButton: false });
            }
        case actions.OPEN_BULK_PASSWORD_CHANGE_STUDENTS_MODAL:
            {
                return _extends({}, state, { isUserOperationModalOpen: action.isUserOperationModalOpen, disableConfirmationButton: false, bulkPasswordValue: '', operationType: action.operationType });
            }
        case actions.OPEN_DELETE_USER_MODAL:
            {
                return _extends({}, state, { isUserOperationModalOpen: action.isUserOperationModalOpen, operationType: action.operationType });
            }
        case actions.DELETE_STUDENT_REQUEST:
            {
                return _extends({}, state, { disableConfirmationButton: action.disableConfirmationButton, operationType: action.operationType });
            }
        case actions.DELETE_STUDENT_SUCCESS:
            {
                return _extends({}, state, {
                    disableConfirmationButton: action.disableConfirmationButton,
                    isUserOperationModalOpen: action.isUserOperationModalOpen,
                    deletedStudentsCount: action.deletedStudentsCount,
                    isPartialDelete: action.isPartialDelete,
                    refreshStudentList: action.deletedStudentsCount > 0,
                    selectedStudents: action.selectedStudents
                });
            }
        case actions.DELETE_STUDENT_FAILURE:
            {
                return _extends({}, state, { disableConfirmationButton: action.disableConfirmationButton });
            }

        case schoolRollActions.GET_YEAR_GROUPS_SUCCESS:
            {
                return _extends({}, state, { dataFilterOption: (0, _utils.updateYearGroups)(state.dataFilterOption, action.data) });
            }

        case classRollActions.GET_CLASSROOMS_SUCCESS:
            {
                return _extends({}, state, {
                    dataFilterOption: (0, _utils.updateClassroomList)(resetFilterOptions(state.dataFilterOption), action.data),
                    filteredStudents: getFilteredData(state.students, (0, _utils.updateClassroomList)(state.dataFilterOption, action.data))
                });
            }

        case quickUploadActions.QUICK_UPLOAD_CLOSE_MODAL_REQUEST:
        case assignUserActions.CANCEL_USER_ASSIGN_REQUEST:
            {
                return _extends({}, state, { isStudentDataLoaded: false, selectedStudents: [] });
            }

        case assignUserActions.RESET_USER_CLASSROOM_RELATION:
            {
                return _extends({}, state, { selectedStudents: [] });
            }

        case editStudentActions.EDIT_STUDENT_SUCCESS_REQUEST:
            {
                return _extends({}, state, { refreshStudentList: true, selectedStudents: [] });
            }

        case actions.CLEAR_OPERATION_TYPE:
            {
                return _extends({}, state, { operationType: '' });
            }

        case classRollActions.DELETE_CLASSROOMS_SUCCESS:
        case assignUserActions.ASSIGN_STUDENT_SUCCESS:
        case assignUserActions.ASSIGN_TEACHER_SUCCESS:
        case teacherRollActions.DELETE_TEACHER_SUCCESS:
        case teacherRollActions.UNASSIGN_TEACHERS_SUCCESS:
        case editTeacherActions.EDIT_TEACHER_SUCCESS_REQUEST:
        case editTeacherActions.UNASSIGN_TEACHERS_USING_CLASSID_SUCCESS:
        case editStudentActions.REFRESH_STUDENT_LIST_ON_CANCEL_REQUEST:
        case assignUserActions.ASSIGN_TEACHER_TO_CLASSROOM_SUCCESS:
            {
                return _extends({}, state, { refreshStudentList: action.refreshStudentList, isStudentDataLoaded: false, selectedStudents: [] });
            }

        case actions.DOWNLOAD_STUDENTS_SIGN_IN_CARD:
            {
                return _extends({}, state, { operationType: action.operationType, isUserOperationModalOpen: action.isUserOperationModalOpen });
            }

        case actions.SHOW_HIDE_SIGNIN_CARD_MODAL:
            {
                return _extends({}, state, { showHideSignInCardModal: action.showHideSignInCardModal });
            }
        default:
            return _extends({}, state);
    }
};

var _actions = __webpack_require__(98);

var actions = _interopRequireWildcard(_actions);

var _actions2 = __webpack_require__(44);

var schoolRollActions = _interopRequireWildcard(_actions2);

var _actions3 = __webpack_require__(156);

var quickUploadActions = _interopRequireWildcard(_actions3);

var _actions4 = __webpack_require__(50);

var teacherRollActions = _interopRequireWildcard(_actions4);

var _actions5 = __webpack_require__(95);

var assignUserActions = _interopRequireWildcard(_actions5);

var _actions6 = __webpack_require__(127);

var editStudentActions = _interopRequireWildcard(_actions6);

var _actions7 = __webpack_require__(128);

var editTeacherActions = _interopRequireWildcard(_actions7);

var _actions8 = __webpack_require__(38);

var classRollActions = _interopRequireWildcard(_actions8);

var _messages = __webpack_require__(266);

var _messages2 = _interopRequireDefault(_messages);

var _utils = __webpack_require__(13);

var _gridUtil = __webpack_require__(86);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var getStudentLastNames = function getStudentLastNames() {
    var names = [{ key: '-1', value: _messages2.default.defaultOptionStudentLastName, selected: true }];
    var namePrefixes = (0, _utils.getAlphaNumericCharacters)().split('').map(function (item) {
        return { key: item, value: item };
    });
    var allNamePrefixes = names.concat(namePrefixes);
    return allNamePrefixes;
};

var dataFilterOption = {
    yearGroups: [{ key: '-1', value: _messages2.default.defaultOptionStudentYearGroup, selected: true }],
    lastNames: getStudentLastNames(),
    classrooms: [{ key: 'assignedStudents', value: _messages2.default.assignedStudents, selected: true }, { key: '-1', value: _messages2.default.defaultOptionStudentClass, selected: false }, { key: 'classes', value: _messages2.default.UnassignedStudent, selected: false }],
    searchTerm: '',
    sortColumn: 'lastName',
    sortDirection: 'asc'
};

var assignEmptyStudentObject = function assignEmptyStudentObject() {
    return { firstName: '', lastName: '', yearGroup: '-1', classroomId: '-1', previousUsername: '' };
};

var initState = {
    students: [],
    filteredStudents: [],
    isStudentDataLoaded: false,
    dataFilterOption: dataFilterOption,
    selectedStudents: [],
    isSaveInProgress: false,
    studentModel: assignEmptyStudentObject(),
    deletedStudentsCount: 0,
    isPartialDelete: false,
    lastAddedStudentUserProfileId: 0,
    isSignInCardDownloaded: true,
    isUserOperationModalOpen: false,
    isUnassignedModalOpen: false,
    unassignDisableButton: false,
    isBulkPasswordChangeModalOpen: false,
    bulkPasswordChangeDisableButton: false,
    bulkPasswordValue: '',
    refreshStudentList: false,
    disableConfirmationButton: false,
    isDeleteUserModalOpen: false,
    operationType: '',
    showHideSignInCardModal: false
};

var resetSelectedItem = function resetSelectedItem(items) {
    var selectedItem = items.find(function (item) {
        return item.selected === true;
    });
    selectedItem = selectedItem === undefined ? {} : selectedItem;
    selectedItem.selected = false;
    items[0].selected = true;
    return items;
};

var resetFilterOptions = function resetFilterOptions(currentOptions) {
    var yearGroups = resetSelectedItem(currentOptions.yearGroups);
    var lastNames = resetSelectedItem(currentOptions.lastNames);
    var classrooms = resetSelectedItem(currentOptions.classrooms);
    return _extends({}, currentOptions, { yearGroups: yearGroups, lastNames: lastNames, classrooms: classrooms, searchTerm: currentOptions.searchTerm });
};

var getFilteredData = function getFilteredData(students, filterOptions) {
    return (0, _gridUtil.filterStudents)(students, filterOptions);
};

var getSortedData = function getSortedData(students, filterOptions) {
    return (0, _gridUtil.sort)(students, filterOptions.sortColumn, filterOptions.sortDirection);
};

var changeFilterOptions = function changeFilterOptions(currentOptions, collectionName, key) {
    var items = currentOptions[collectionName];
    var selectedItem = items.find(function (item) {
        return item.selected === true;
    });
    selectedItem.selected = false;
    var newSelection = items.find(function (item) {
        return item.key.toString() === key;
    });
    newSelection.selected = true;
    return _extends({}, currentOptions, _defineProperty({}, collectionName, currentOptions[collectionName]));
};

/***/ }),
/* 868 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.getStudents = getStudents;
exports.downloadStudentRoll = downloadStudentRoll;
exports.addStudent = addStudent;
exports.getStudentsSaga = getStudentsSaga;
exports.downloadStudentRollSaga = downloadStudentRollSaga;
exports.unassignStudents = unassignStudents;
exports.unassignStudentsSaga = unassignStudentsSaga;
exports.downloadStudentSignInCards = downloadStudentSignInCards;
exports.downloadSignInCardSaga = downloadSignInCardSaga;
exports.addStudentSaga = addStudentSaga;
exports.deleteStudent = deleteStudent;
exports.deleteStudentSaga = deleteStudentSaga;
exports.bulkPasswordChangeStudents = bulkPasswordChangeStudents;
exports.bulkPasswordChangeStudentsSaga = bulkPasswordChangeStudentsSaga;
exports.getClassroomGroups = getClassroomGroups;
exports.getClassroomGroupsSaga = getClassroomGroupsSaga;

var _effects = __webpack_require__(32);

var _api = __webpack_require__(33);

var api = _interopRequireWildcard(_api);

var _actions = __webpack_require__(98);

var actions = _interopRequireWildcard(_actions);

var _actions2 = __webpack_require__(44);

var schoolRollActions = _interopRequireWildcard(_actions2);

var _actions3 = __webpack_require__(65);

var _utils = __webpack_require__(13);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var _marked = /*#__PURE__*/regeneratorRuntime.mark(getStudents),
    _marked2 = /*#__PURE__*/regeneratorRuntime.mark(downloadStudentRoll),
    _marked3 = /*#__PURE__*/regeneratorRuntime.mark(addStudent),
    _marked4 = /*#__PURE__*/regeneratorRuntime.mark(getStudentsSaga),
    _marked5 = /*#__PURE__*/regeneratorRuntime.mark(downloadStudentRollSaga),
    _marked6 = /*#__PURE__*/regeneratorRuntime.mark(unassignStudents),
    _marked7 = /*#__PURE__*/regeneratorRuntime.mark(unassignStudentsSaga),
    _marked8 = /*#__PURE__*/regeneratorRuntime.mark(downloadStudentSignInCards),
    _marked9 = /*#__PURE__*/regeneratorRuntime.mark(downloadSignInCardSaga),
    _marked10 = /*#__PURE__*/regeneratorRuntime.mark(addStudentSaga),
    _marked11 = /*#__PURE__*/regeneratorRuntime.mark(deleteStudent),
    _marked12 = /*#__PURE__*/regeneratorRuntime.mark(deleteStudentSaga),
    _marked13 = /*#__PURE__*/regeneratorRuntime.mark(bulkPasswordChangeStudents),
    _marked14 = /*#__PURE__*/regeneratorRuntime.mark(bulkPasswordChangeStudentsSaga),
    _marked15 = /*#__PURE__*/regeneratorRuntime.mark(getClassroomGroups),
    _marked16 = /*#__PURE__*/regeneratorRuntime.mark(getClassroomGroupsSaga);

function getStudents(_ref) {
    var productId = _ref.productId,
        classrooms = _ref.classrooms;
    var payload;
    return regeneratorRuntime.wrap(function getStudents$(_context) {
        while (1) {
            switch (_context.prev = _context.next) {
                case 0:
                    _context.next = 2;
                    return (0, _effects.call)(api.getStudentsByProduct, productId);

                case 2:
                    payload = _context.sent;

                    if (!(payload.status === 200)) {
                        _context.next = 8;
                        break;
                    }

                    _context.next = 6;
                    return (0, _effects.put)(actions.getProductStudentsSuccess(payload.data, classrooms));

                case 6:
                    _context.next = 10;
                    break;

                case 8:
                    _context.next = 10;
                    return (0, _effects.put)(actions.getProductStudentsFailure());

                case 10:
                case 'end':
                    return _context.stop();
            }
        }
    }, _marked, this);
}

function downloadStudentRoll(students) {
    var response, downloadUrl;
    return regeneratorRuntime.wrap(function downloadStudentRoll$(_context2) {
        while (1) {
            switch (_context2.prev = _context2.next) {
                case 0:
                    _context2.next = 2;
                    return (0, _effects.call)(api.postStudentsPriorDownload, students);

                case 2:
                    response = _context2.sent;

                    if (!(response.status === 201)) {
                        _context2.next = 9;
                        break;
                    }

                    downloadUrl = response.verb.url + response.data;
                    _context2.next = 7;
                    return (0, _effects.put)(actions.downloadStudentRollSuccess(downloadUrl, true));

                case 7:
                    _context2.next = 11;
                    break;

                case 9:
                    _context2.next = 11;
                    return (0, _effects.put)(actions.downloadStudentRollFailure());

                case 11:
                case 'end':
                    return _context2.stop();
            }
        }
    }, _marked2, this);
}

function addStudent(_ref2) {
    var student = _ref2.student;
    var response;
    return regeneratorRuntime.wrap(function addStudent$(_context3) {
        while (1) {
            switch (_context3.prev = _context3.next) {
                case 0:
                    _context3.next = 2;
                    return (0, _effects.call)(api.addStudent, student);

                case 2:
                    response = _context3.sent;

                    if (!(response.status === 200)) {
                        _context3.next = 8;
                        break;
                    }

                    _context3.next = 6;
                    return (0, _effects.put)(actions.addStudentSuccess(response.data.userProfileId));

                case 6:
                    _context3.next = 17;
                    break;

                case 8:
                    if (!(response.status === 400 || response.status === 409)) {
                        _context3.next = 15;
                        break;
                    }

                    _context3.next = 11;
                    return (0, _effects.put)(actions.addStudentFailure(false, response.message, false));

                case 11:
                    _context3.next = 13;
                    return (0, _effects.put)((0, _actions3.showToast)(response.message, 'error'));

                case 13:
                    _context3.next = 17;
                    break;

                case 15:
                    _context3.next = 17;
                    return (0, _effects.put)(actions.addStudentFailure(true, ''));

                case 17:
                case 'end':
                    return _context3.stop();
            }
        }
    }, _marked3, this);
}

function getStudentsSaga() {
    return regeneratorRuntime.wrap(function getStudentsSaga$(_context4) {
        while (1) {
            switch (_context4.prev = _context4.next) {
                case 0:
                    _context4.next = 2;
                    return (0, _effects.takeLatest)(actions.GET_PRODUCT_STUDENTS_REQUEST, getStudents);

                case 2:
                case 'end':
                    return _context4.stop();
            }
        }
    }, _marked4, this);
}

function downloadStudentRollSaga() {
    return regeneratorRuntime.wrap(function downloadStudentRollSaga$(_context5) {
        while (1) {
            switch (_context5.prev = _context5.next) {
                case 0:
                    _context5.next = 2;
                    return (0, _effects.takeEvery)(actions.DOWNLOAD_STUDENT_ROLL_REQUEST, downloadStudentRoll);

                case 2:
                case 'end':
                    return _context5.stop();
            }
        }
    }, _marked5, this);
}

function unassignStudents(_ref3) {
    var selectedStudents = _ref3.selectedStudents,
        productId = _ref3.productId;
    var userRelationship, response;
    return regeneratorRuntime.wrap(function unassignStudents$(_context6) {
        while (1) {
            switch (_context6.prev = _context6.next) {
                case 0:
                    userRelationship = { productId: productId, studentsProfileIdToUnassign: selectedStudents };
                    _context6.next = 3;
                    return (0, _effects.call)(api.unAssignStudents, userRelationship);

                case 3:
                    response = _context6.sent;

                    if (!(response.status === 200)) {
                        _context6.next = 9;
                        break;
                    }

                    _context6.next = 7;
                    return (0, _effects.put)(actions.unassignStudentsSuccess());

                case 7:
                    _context6.next = 11;
                    break;

                case 9:
                    _context6.next = 11;
                    return (0, _effects.put)(actions.unassignStudentsFailure());

                case 11:
                case 'end':
                    return _context6.stop();
            }
        }
    }, _marked6, this);
}

function unassignStudentsSaga() {
    return regeneratorRuntime.wrap(function unassignStudentsSaga$(_context7) {
        while (1) {
            switch (_context7.prev = _context7.next) {
                case 0:
                    _context7.next = 2;
                    return (0, _effects.takeLatest)(actions.UNASSIGN_STUDENTS_REQUEST, unassignStudents);

                case 2:
                case 'end':
                    return _context7.stop();
            }
        }
    }, _marked7, this);
}

function downloadStudentSignInCards(_ref4) {
    var productId = _ref4.productId,
        studentSignInCardsData = _ref4.studentSignInCardsData;
    var response, downloadUrl;
    return regeneratorRuntime.wrap(function downloadStudentSignInCards$(_context8) {
        while (1) {
            switch (_context8.prev = _context8.next) {
                case 0:
                    _context8.next = 2;
                    return (0, _effects.call)(api.downloadStudentsSignInCards, productId, studentSignInCardsData);

                case 2:
                    response = _context8.sent;

                    if (!(response.status === 201)) {
                        _context8.next = 9;
                        break;
                    }

                    downloadUrl = response.verb.url + '/' + response.data;
                    _context8.next = 7;
                    return (0, _effects.put)(actions.printSignInCardSuccess(downloadUrl, true));

                case 7:
                    _context8.next = 11;
                    break;

                case 9:
                    _context8.next = 11;
                    return (0, _effects.put)(actions.printSignInCardFailure(true));

                case 11:
                case 'end':
                    return _context8.stop();
            }
        }
    }, _marked8, this);
}

function downloadSignInCardSaga() {
    return regeneratorRuntime.wrap(function downloadSignInCardSaga$(_context9) {
        while (1) {
            switch (_context9.prev = _context9.next) {
                case 0:
                    _context9.next = 2;
                    return (0, _effects.takeLatest)(actions.PRINT_SIGN_IN_CARD_REQUEST, downloadStudentSignInCards);

                case 2:
                case 'end':
                    return _context9.stop();
            }
        }
    }, _marked9, this);
}

function addStudentSaga() {
    return regeneratorRuntime.wrap(function addStudentSaga$(_context10) {
        while (1) {
            switch (_context10.prev = _context10.next) {
                case 0:
                    _context10.next = 2;
                    return (0, _effects.takeLatest)(actions.ADD_STUDENT_REQUEST, addStudent);

                case 2:
                case 'end':
                    return _context10.stop();
            }
        }
    }, _marked10, this);
}

function deleteStudent(_ref5) {
    var userProfileIds = _ref5.userProfileIds,
        productId = _ref5.productId;
    var userRelationship, response, result;
    return regeneratorRuntime.wrap(function deleteStudent$(_context11) {
        while (1) {
            switch (_context11.prev = _context11.next) {
                case 0:
                    userRelationship = { userProfileIds: userProfileIds };
                    _context11.next = 3;
                    return (0, _effects.call)(api.deleteStudents, userRelationship);

                case 3:
                    response = _context11.sent;

                    if (!(response.status === 200)) {
                        _context11.next = 12;
                        break;
                    }

                    result = (0, _utils.validateStudentDeletion)(response.data);
                    _context11.next = 8;
                    return (0, _effects.put)(actions.deleteStudentSuccess(result));

                case 8:
                    _context11.next = 10;
                    return (0, _effects.put)(schoolRollActions.getLicenceCapSummary(productId));

                case 10:
                    _context11.next = 14;
                    break;

                case 12:
                    _context11.next = 14;
                    return (0, _effects.put)(actions.deleteStudentFailure());

                case 14:
                case 'end':
                    return _context11.stop();
            }
        }
    }, _marked11, this);
}

function deleteStudentSaga() {
    return regeneratorRuntime.wrap(function deleteStudentSaga$(_context12) {
        while (1) {
            switch (_context12.prev = _context12.next) {
                case 0:
                    _context12.next = 2;
                    return (0, _effects.takeLatest)(actions.DELETE_STUDENT_REQUEST, deleteStudent);

                case 2:
                case 'end':
                    return _context12.stop();
            }
        }
    }, _marked12, this);
}

/**
 * @param selectedStudents
 * @param newPassword
 */
function bulkPasswordChangeStudents(_ref6) {
    var selectedStudents = _ref6.selectedStudents,
        newPassword = _ref6.newPassword;
    var changePassword, response;
    return regeneratorRuntime.wrap(function bulkPasswordChangeStudents$(_context13) {
        while (1) {
            switch (_context13.prev = _context13.next) {
                case 0:
                    changePassword = { UserProfileIds: selectedStudents, NewPassword: newPassword };
                    _context13.next = 3;
                    return (0, _effects.call)(api.bulkPasswordChangeStudents, changePassword);

                case 3:
                    response = _context13.sent;

                    if (!(response.status === 200)) {
                        _context13.next = 9;
                        break;
                    }

                    _context13.next = 7;
                    return (0, _effects.put)(actions.bulkPasswordChangeStudentsSuccess());

                case 7:
                    _context13.next = 11;
                    break;

                case 9:
                    _context13.next = 11;
                    return (0, _effects.put)(actions.bulkPasswordChangeStudentsFailure());

                case 11:
                case 'end':
                    return _context13.stop();
            }
        }
    }, _marked13, this);
}

function bulkPasswordChangeStudentsSaga() {
    return regeneratorRuntime.wrap(function bulkPasswordChangeStudentsSaga$(_context14) {
        while (1) {
            switch (_context14.prev = _context14.next) {
                case 0:
                    _context14.next = 2;
                    return (0, _effects.takeLatest)(actions.BULK_PASSWORD_CHANGE_STUDENTS_REQUEST, bulkPasswordChangeStudents);

                case 2:
                case 'end':
                    return _context14.stop();
            }
        }
    }, _marked14, this);
}

function getClassroomGroups(_ref7) {
    var classroomId = _ref7.classroomId;
    var state, emptyListValue, payload, studentModel;
    return regeneratorRuntime.wrap(function getClassroomGroups$(_context15) {
        while (1) {
            switch (_context15.prev = _context15.next) {
                case 0:
                    _context15.next = 2;
                    return (0, _effects.select)();

                case 2:
                    state = _context15.sent;
                    emptyListValue = '-1';

                    if (!(classroomId === emptyListValue)) {
                        _context15.next = 7;
                        break;
                    }

                    state.studentRoll.classroomGroups = [];
                    return _context15.abrupt('return');

                case 7:
                    _context15.next = 9;
                    return (0, _effects.call)(api.getClassroomGroups, classroomId);

                case 9:
                    payload = _context15.sent;

                    if (!(payload.status === 200)) {
                        _context15.next = 17;
                        break;
                    }

                    studentModel = state.studentRoll.studentModel;

                    if (payload.data.length === 1) {
                        studentModel.classroomGroupId = String(payload.data[0].id);
                    } else {
                        studentModel.classroomGroupId = emptyListValue;
                    }

                    _context15.next = 15;
                    return (0, _effects.put)(actions.getClassroomGroupsSuccess(payload.data));

                case 15:
                    _context15.next = 19;
                    break;

                case 17:
                    _context15.next = 19;
                    return (0, _effects.put)(actions.getClassroomGroupsFailure());

                case 19:
                case 'end':
                    return _context15.stop();
            }
        }
    }, _marked15, this);
}

function getClassroomGroupsSaga() {
    return regeneratorRuntime.wrap(function getClassroomGroupsSaga$(_context16) {
        while (1) {
            switch (_context16.prev = _context16.next) {
                case 0:
                    _context16.next = 2;
                    return (0, _effects.takeLatest)(actions.ADD_STUDENT_GET_GROUPS_REQUEST, getClassroomGroups);

                case 2:
                case 'end':
                    return _context16.stop();
            }
        }
    }, _marked16, this);
}

/***/ }),
/* 869 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __webpack_require__(28);

var _redux = __webpack_require__(35);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _clone = __webpack_require__(122);

var _clone2 = _interopRequireDefault(_clone);

var _reactIntl = __webpack_require__(2);

var _actions = __webpack_require__(50);

var _actions2 = __webpack_require__(95);

var _index = __webpack_require__(792);

var _index2 = _interopRequireDefault(_index);

var _gridUtil = __webpack_require__(86);

var _actions3 = __webpack_require__(38);

var _actions4 = __webpack_require__(65);

var _messages = __webpack_require__(267);

var _messages2 = _interopRequireDefault(_messages);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var TeacherRollContainer = function (_Component) {
    _inherits(TeacherRollContainer, _Component);

    function TeacherRollContainer(props) {
        _classCallCheck(this, TeacherRollContainer);

        var _this = _possibleConstructorReturn(this, (TeacherRollContainer.__proto__ || Object.getPrototypeOf(TeacherRollContainer)).call(this, props));

        _this.filterClassrooms = function (classrooms) {
            var classes = classrooms.map(function (item) {
                return {
                    key: item.name,
                    value: item.name,
                    classroomId: item.classroomId
                };
            });
            return classes;
        };

        _this.handleOnDownloadTeacherRoll = function () {
            _this.props.downloadTeacherRoll(_this.props.filteredTeachers, false);
        };

        _this.handleOnQuickUpload = function () {
            _this.context.router.history.push('quickUpload');
        };

        _this.handleOnAddTeacher = function () {
            _this.props.openAddTeacherModal();
        };

        _this.reloadTeacherList = function () {
            var refreshTeacherList = _this.props.lastAddedTeacherUserProfileId > 0;
            if (refreshTeacherList) {
                _this.props.getProductTeachers(_this.props.selectedProduct.id);
            }
        };

        _this.handleOnCloseAddTeacherModal = function () {
            _this.setState({ canSubmit: false });
            _this.props.closeAddTeacherModal();
            _this.reloadTeacherList();
        };

        _this.handleOnCloseAddTeacherValidationModal = function () {
            _this.setState({ canSubmit: true });
            _this.props.closeAddTeacherValidationModal();
        };

        _this.handleFilterOnClear = function () {
            _this.props.clearFilterValue();
        };

        _this.handleFilterOnChange = function (collectionName, key) {
            _this.props.changeFilterValue(collectionName, key);
        };

        _this.handleOnSearch = function (searchTerm) {
            _this.props.updateSearchTerm(searchTerm);
        };

        _this.handleRowSelect = function (rows) {
            _this.props.retrieveSelectedTeachers(rows);
        };

        _this.handleOnAddTeacherSubmit = function () {
            var selectedProduct = _this.props.selectedProduct;

            var teacher = (0, _clone2.default)(_this.props.teacher);
            teacher.classroomId = parseInt(teacher.classroomId, 10);
            teacher.productId = selectedProduct.id;
            delete teacher.classrooms;
            _this.setState({ canSubmit: false });
            _this.props.addTeacher(teacher);
        };

        _this.handleOnTeacherUnassign = function () {
            _this.setState({ showModal: true });
            _this.props.openUnAssignTeachersModal();
        };

        _this.handleOnUnassignConfirm = function () {
            _this.props.unassignTeachers(_this.props.selectedTeachers, _this.props.selectedProduct.id);
        };

        _this.handleOnCloseModal = function () {
            _this.setState({ showModal: false });
            _this.props.resetUserClassroomRelation();
        };

        _this.handleOnAddAnotherTeacher = function () {
            _this.props.addAnotherTeacherModal();
        };

        _this.teachersOperationSuccessConfirmation = function () {
            _this.handleOnCloseModal();
            _this.props.closeTeachersOperationConfirmationModal();
        };

        _this.handleOnTeacherEdit = function (userProfileId) {
            _this.context.router.history.push('/edit-teacher/' + userProfileId);
        };

        _this.handleOnAssignClass = function (id) {
            var assignType = 'classToTeacher';
            _this.context.router.history.push('/assign-user/' + id + '/' + assignType);
        };

        _this.handleOnTeacherDeleteOpenModal = function () {
            var teachers = _this.props.teachers;


            var hasClassroomsAssigned = false;
            var hasProductsAssigned = false;

            teachers.find(function (teacher) {
                if (_this.props.selectedTeachers.indexOf(teacher.userProfileId) !== -1 && teacher.assignedClassrooms.length > 0) {
                    hasClassroomsAssigned = true;
                }

                if (teacher.accessibleProducts && teacher.accessibleProducts.length > 0) {
                    hasProductsAssigned = true;
                }

                if (hasClassroomsAssigned && hasProductsAssigned) {
                    return true;
                }

                return false;
            });

            if (hasClassroomsAssigned) {
                _this.props.showToast(_this.props.intl.formatMessage(_messages2.default.errorOnDeletingAssignedTeachers), 'error');
            } else if (hasProductsAssigned) {
                _this.setState({ showModal: true });
                _this.props.openDeleteTeacherModal();
            } else {
                _this.handleOnDeleteTeacher();
            }
        };

        _this.handleOnDeleteTeacher = function () {
            _this.props.deleteTeacherRequest(_this.props.selectedTeachers);
        };

        _this.handleOnTeacherBulkPasswordChange = function () {
            _this.setState({ showModal: true, bulkPasswordValue: '' });
            _this.props.openBulkPasswordChangeTeachersModal();
        };

        _this.handleOnTeacherBulkPasswordChangeNewValue = function (event) {
            _this.setState({
                bulkPasswordValue: event.target.value.trim()
            });
        };

        _this.handleOnBulkPasswordChangeConfirm = function () {
            _this.props.bulkPasswordChangeTeachersRequest(_this.props.selectedTeachers, _this.state.bulkPasswordValue);
        };

        _this.handleOnSendEmailVerification = function () {
            _this.props.sendVerificationEmailRequest(_this.props.selectedTeachers);
        };

        _this.handleOnCloseEmailVerificationModal = function () {
            _this.props.closeVerificationModal();
        };

        _this.handleGridSort = _this.handleGridSort.bind(_this);
        _this.rows = props.isTeacherDataLoaded ? (0, _gridUtil.createTeacherRows)(props.filteredTeachers) : [];
        _this.state = {
            rows: _this.rows,
            dataFilterOption: _this.props.dataFilterOption
        };

        _this.handleOnPrintSignInCard = _this.handleOnPrintSignInCard.bind(_this);
        _this.handleOnPrintMultipleSignInCard = _this.handleOnPrintMultipleSignInCard.bind(_this);
        _this.handleOnTeacherUnassign = _this.handleOnTeacherUnassign.bind(_this);
        _this.handleOnCloseModal = _this.handleOnCloseModal.bind(_this);
        _this.handleOnUnassignConfirm = _this.handleOnUnassignConfirm.bind(_this);
        _this.filterClassrooms = _this.filterClassrooms.bind(_this);
        _this.handleOnTeacherBulkPasswordChange = _this.handleOnTeacherBulkPasswordChange.bind(_this);
        _this.handleOnTeacherBulkPasswordChangeNewValue = _this.handleOnTeacherBulkPasswordChangeNewValue.bind(_this);
        _this.handleOnBulkPasswordChangeConfirm = _this.handleOnBulkPasswordChangeConfirm.bind(_this);
        return _this;
    }

    _createClass(TeacherRollContainer, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            if (!this.props.isTeacherDataLoaded || this.props.refreshTeacherList) {
                this.props.getProductTeachers(this.props.selectedProduct.id);
            }

            if (!this.props.isClassroomDataLoaded) {
                this.props.getProductClassrooms(this.props.selectedProduct.id);
            }
        }
    }, {
        key: 'componentWillReceiveProps',
        value: function componentWillReceiveProps(nextProps) {
            if (nextProps.isTeacherDataLoaded || (0, _gridUtil.isListDifferent)(nextProps.filteredTeachers, this.props.filteredTeachers, 'userProfileId')) {
                this.rows = (0, _gridUtil.createTeacherRows)(nextProps.filteredTeachers);
                this.setState({ rows: this.rows });
            }

            if (nextProps.refreshTeacherList && nextProps.refreshTeacherList !== this.props.refreshTeacherList) {
                this.props.getProductTeachers(this.props.selectedProduct.id);
            }

            this.setState({ dataFilterOption: this.props.dataFilterOption });
            if (nextProps.deleteSuccess !== this.props.deleteSuccess && nextProps.deleteSuccess) {
                var notDeletedTeachers = nextProps.notDeletedTeachers;

                this.setState({ showModal: false });

                var teacherDeleted = notDeletedTeachers.filter(function (teacher) {
                    return !teacher.hasError;
                });

                if (teacherDeleted.length === notDeletedTeachers.length) {
                    this.props.showToast(this.props.intl.formatMessage(_messages2.default.deleteTeacherSuccessMessage, { count: notDeletedTeachers.length }), 'success');
                } else {
                    this.props.showToast(this.props.intl.formatMessage(_messages2.default.deleteTeacherWarningMessage, { count: teacherDeleted.length || '0' }), 'warning');
                }
            }
        }
    }, {
        key: 'handleOnPrintSignInCard',
        value: function handleOnPrintSignInCard() {
            var teacherProfileIds = [];
            teacherProfileIds.push(this.props.lastAddedTeacherUserProfileId);
            this.props.printTeacherSignInCard(this.props.selectedProduct.id, { teacherUserProfileIds: teacherProfileIds, SignInCardPageSizeType: 'QR_3X3' });
        }
    }, {
        key: 'handleOnPrintMultipleSignInCard',
        value: function handleOnPrintMultipleSignInCard() {
            this.props.printTeacherSignInCard(this.props.selectedProduct.id, { teacherUserProfileIds: this.props.selectedTeachers, SignInCardPageSizeType: 'QR_3X3' });
        }
    }, {
        key: 'handleGridSort',
        value: function handleGridSort(sortColumn) {
            this.props.sortTeacherList(sortColumn);
        }
    }, {
        key: 'render',
        value: function render() {
            var _this2 = this;

            var rowGetter = function rowGetter(rowNumber) {
                return _this2.state.rows[rowNumber];
            };
            return _react2.default.createElement(_index2.default, {
                addTeacherValidationMessage: this.props.addTeacherValidationMessage,
                bulkPasswordValue: this.state.bulkPasswordValue,
                classrooms: this.props.classrooms,
                closeAddTeacherValidationModal: this.handleOnCloseAddTeacherValidationModal,
                dataFilterOptions: this.state.dataFilterOption,
                deletingTeacher: this.props.deletingTeacher,
                emailVerificationError: this.props.emailVerificationError,
                filteredTeachersCount: this.props.filteredTeachers.length,
                filterOnChange: this.handleFilterOnChange,
                filterOnClear: this.handleFilterOnClear,
                gridRowGetter: rowGetter,
                handleOnAddTeacherSubmit: this.handleOnAddTeacherSubmit,
                handleOnAssignClass: this.handleOnAssignClass,
                handleOnBulkPasswordChangeConfirm: this.handleOnBulkPasswordChangeConfirm,
                handleOnChangeBulkPasswordSetValue: this.handleOnTeacherBulkPasswordChangeNewValue,
                handleOnCloseEmailVerificationModal: this.handleOnCloseEmailVerificationModal,
                handleOnCloseModal: this.handleOnCloseModal,
                handleOnDeleteTeacher: this.handleOnDeleteTeacher,
                handleOnPrintMultipleSignInCard: this.handleOnPrintMultipleSignInCard,
                handleOnPrintSignInCard: this.handleOnPrintSignInCard,
                handleOnTeacherBulkPasswordChange: this.handleOnTeacherBulkPasswordChange,
                handleOnTeacherDeleteOpenModal: this.handleOnTeacherDeleteOpenModal,
                handleOnTeacherEdit: this.handleOnTeacherEdit,
                handleOnTeacherUnassign: this.handleOnTeacherUnassign,
                handleOnUnassignConfirm: this.handleOnUnassignConfirm,
                isEmailVerificationModalOpen: this.props.isEmailVerificationModalOpen,
                isLoading: this.props.disableConfirmationButtons,
                isSaveInProgress: this.props.isSaveInProgress,
                isSignInCardDownloaded: this.props.isSignInCardDownloaded,
                isTeacherDataLoaded: this.props.isTeacherDataLoaded,
                isTeacherRollDownloaded: this.props.isTeacherRollDownloaded,
                isUserOperationModalOpen: this.props.isUserOperationModalOpen,
                onAddAnotherTeacher: this.handleOnAddAnotherTeacher,
                onAddTeacher: this.handleOnAddTeacher,
                onAddTeacherCloseModal: this.handleOnCloseAddTeacherModal,
                onDownloadTeacherRoll: this.handleOnDownloadTeacherRoll,
                onGridSort: this.handleGridSort,
                onQuickUpload: this.handleOnQuickUpload,
                onRowSelect: this.handleRowSelect,
                onSearch: this.handleOnSearch,
                operationType: this.props.operationType,
                selectedProduct: this.props.selectedProduct,
                selectedTeachers: this.props.selectedTeachers,
                sendingEmailsResult: this.props.sendingEmailsResult,
                showAddTeacherConfirmationModal: this.props.showAddTeacherConfirmationModal,
                showAddTeachersModal: this.props.showModal,
                showAddTeacherValidationModal: this.props.showAddTeacherValidationModal,
                showModal: this.state.showModal,
                teacher: this.props.teacher,
                teachers: this.state.rows,
                teachersCount: this.props.teachers.length,
                teachersOperationSuccessConfirmation: this.teachersOperationSuccessConfirmation,
                teacherTitles: this.props.teacherTitles
            });
        }
    }]);

    return TeacherRollContainer;
}(_react.Component);

TeacherRollContainer.propTypes = {
    isTeacherDataLoaded: _propTypes2.default.bool,
    isClassroomDataLoaded: _propTypes2.default.bool,
    isSaveInProgress: _propTypes2.default.bool,
    isTeacherRollDownloaded: _propTypes2.default.bool,
    isSignInCardDownloaded: _propTypes2.default.bool,
    showAddTeacherValidationModal: _propTypes2.default.bool,
    showModal: _propTypes2.default.bool,
    showAddTeacherConfirmationModal: _propTypes2.default.bool,
    addTeacherValidationMessage: _propTypes2.default.string,
    lastAddedTeacherUserProfileId: _propTypes2.default.number,
    teacher: _propTypes2.default.object,
    dataFilterOption: _propTypes2.default.object,
    teachers: _propTypes2.default.arrayOf(_propTypes2.default.object),
    teacherTitles: _propTypes2.default.arrayOf(_propTypes2.default.object),
    classrooms: _propTypes2.default.arrayOf(_propTypes2.default.object),
    filteredTeachers: _propTypes2.default.arrayOf(_propTypes2.default.object),
    selectedTeachers: _propTypes2.default.arrayOf(_propTypes2.default.number),
    selectedProduct: _propTypes2.default.object,
    getProductTeachers: _propTypes2.default.func,
    getProductClassrooms: _propTypes2.default.func,
    downloadTeacherRoll: _propTypes2.default.func,
    clearFilterValue: _propTypes2.default.func,
    changeFilterValue: _propTypes2.default.func,
    retrieveSelectedTeachers: _propTypes2.default.func,
    updateSearchTerm: _propTypes2.default.func,
    sortTeacherList: _propTypes2.default.func,
    unassignTeachers: _propTypes2.default.func,
    isUserOperationModalOpen: _propTypes2.default.bool,
    isEmailVerificationModalOpen: _propTypes2.default.bool,
    sendingEmailsResult: _propTypes2.default.object,
    emailVerificationError: _propTypes2.default.bool,
    refreshTeacherList: _propTypes2.default.bool,
    openUnAssignTeachersModal: _propTypes2.default.func,
    closeTeachersOperationConfirmationModal: _propTypes2.default.func,
    disableConfirmationButtons: _propTypes2.default.bool,
    openAddTeacherModal: _propTypes2.default.func,
    closeAddTeacherModal: _propTypes2.default.func,
    addTeacher: _propTypes2.default.func,
    closeAddTeacherValidationModal: _propTypes2.default.func,
    printTeacherSignInCard: _propTypes2.default.func,
    addAnotherTeacherModal: _propTypes2.default.func,
    openDeleteTeacherModal: _propTypes2.default.func,
    deleteTeacherRequest: _propTypes2.default.func,
    operationType: _propTypes2.default.string,
    openBulkPasswordChangeTeachersModal: _propTypes2.default.func,
    bulkPasswordChangeTeachersRequest: _propTypes2.default.func,
    showToast: _propTypes2.default.func,
    intl: _reactIntl.intlShape.isRequired,
    deletingTeacher: _propTypes2.default.bool,
    deleteSuccess: _propTypes2.default.bool,
    notDeletedTeachers: _propTypes2.default.arrayOf(_propTypes2.default.object),
    sendVerificationEmailRequest: _propTypes2.default.func,
    closeVerificationModal: _propTypes2.default.func,
    resetUserClassroomRelation: _propTypes2.default.func
};
TeacherRollContainer.contextTypes = {
    router: _propTypes2.default.object
};


function mapStateToProps() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    return _extends({}, state, {
        classrooms: state.classRoll.classrooms,
        selectedProduct: state.product,
        teachers: state.teacherRoll.teachers,
        teacherTitles: state.teacherRoll.teacherTitles,
        filteredTeachers: state.teacherRoll.filteredTeachers,
        selectedTeachers: state.teacherRoll.selectedTeachers,
        isTeacherDataLoaded: state.teacherRoll.isTeacherDataLoaded,
        isClassroomDataLoaded: state.classRoll.isClassroomDataLoaded,
        isEmailVerificationModalOpen: state.teacherRoll.isEmailVerificationModalOpen,
        sendingEmailsResult: state.teacherRoll.sendingEmailsResult,
        emailVerificationError: state.teacherRoll.emailVerificationError,
        isYearGroupDataLoaded: state.teacherRoll.isYearGroupDataLoaded,
        isTeacherRollDownloaded: state.teacherRoll.isTeacherRollDownloaded,
        dataFilterOption: state.teacherRoll.dataFilterOption,
        showModal: state.teacherRoll.showModal,
        teacher: state.teacherRoll.teacherModel,
        isSaveInProgress: state.teacherRoll.isSaveInProgress,
        showAddTeacherValidationModal: state.teacherRoll.showAddTeacherValidationModal,
        addTeacherValidationMessage: state.teacherRoll.addTeacherValidationMessage,
        isSignInCardDownloaded: state.teacherRoll.isSignInCardDownloaded,
        showAddTeacherConfirmationModal: state.teacherRoll.showAddTeacherConfirmationModal,
        lastAddedTeacherUserProfileId: state.teacherRoll.lastAddedTeacherUserProfileId,
        isUserOperationModalOpen: state.teacherRoll.isUserOperationModalOpen,
        refreshTeacherList: state.teacherRoll.refreshTeacherList,
        disableConfirmationButtons: state.teacherRoll.disableConfirmationButtons,
        operationType: state.teacherRoll.operationType,
        deletingTeacher: state.teacherRoll.deletingTeacher,
        deleteSuccess: state.teacherRoll.deleteSuccess,
        notDeletedTeachers: state.teacherRoll.notDeletedTeachers
    });
}

function mapDispatchToProps(dispatch) {
    return (0, _redux.bindActionCreators)({
        getProductTeachers: _actions.getProductTeachers,
        getProductClassrooms: _actions3.getProductClassrooms,
        downloadTeacherRoll: _actions.downloadTeacherRoll,
        clearFilterValue: _actions.clearFilterValue,
        changeFilterValue: _actions.changeFilterValue,
        updateSearchTerm: _actions.updateSearchTerm,
        sortTeacherList: _actions.sortTeacherList,
        retrieveSelectedTeachers: _actions.retrieveSelectedTeachers,
        openAddTeacherModal: _actions.openAddTeacherModal,
        closeAddTeacherModal: _actions.closeAddTeacherModal,
        addTeacher: _actions.addTeacher,
        closeAddTeacherValidationModal: _actions.closeAddTeacherValidationModal,
        printTeacherSignInCard: _actions.printTeacherSignInCard,
        unassignTeachers: _actions.unassignTeachers,
        addAnotherTeacherModal: _actions.addAnotherTeacherModal,
        openUnAssignTeachersModal: _actions.openUnAssignTeachersModal,
        closeTeachersOperationConfirmationModal: _actions.closeTeachersOperationConfirmationModal,
        openDeleteTeacherModal: _actions.openDeleteTeacherModal,
        deleteTeacherRequest: _actions.deleteTeacherRequest,
        sendVerificationEmailRequest: _actions.sendVerificationEmailRequest,
        closeVerificationModal: _actions.closeVerificationModal,
        openBulkPasswordChangeTeachersModal: _actions.openBulkPasswordChangeTeachersModal,
        bulkPasswordChangeTeachersRequest: _actions.bulkPasswordChangeTeachersRequest,
        showToast: _actions4.showToast,
        resetUserClassroomRelation: _actions2.resetUserClassroomRelation
    }, dispatch);
}
var intlContainer = (0, _reactIntl.injectIntl)(TeacherRollContainer);
exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(intlContainer);

/***/ }),
/* 870 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.default = function () {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initState;
    var action = arguments[1];

    switch (action.type) {
        case actions.GET_PRODUCT_TEACHERS_REQUEST:
            {
                return _extends({}, state, { isTeacherDataLoaded: false, teachers: [], filteredTeachers: [] });
            }
        case actions.GET_PRODUCT_TEACHERS_SUCCESS:
            {
                state.dataFilterOption.searchTerm = '';
                return _extends({}, state, {
                    isTeacherDataLoaded: true,
                    refreshTeacherList: false,
                    teachers: action.data,
                    filteredTeachers: action.data,
                    teachersCount: action.data.length,
                    teachersFiltered: (0, _utils.filterProductTeachers)(action.data),
                    dataFilterOption: resetFilterOptions(state.dataFilterOption)
                });
            }
        case actions.DOWNLOAD_TEACHER_ROLL_REQUEST:
            {
                return _extends({}, state, { isTeacherRollDownloaded: action.isTeacherRollDownloaded });
            }
        case actions.DOWNLOAD_TEACHER_ROLL_SUCCESS:
            {
                return _extends({}, state, { isTeacherRollDownloaded: action.isTeacherRollDownloaded });
            }
        case actions.TEACHER_FILTER_VALUE_CLEARED:
            {
                var filterOption = resetFilterOptions(state.dataFilterOption);
                var filteredTeachers = getFilteredData(state.teachers, filterOption);
                return _extends({}, state, {
                    filteredTeachers: filteredTeachers,
                    dataFilterOption: filterOption,
                    selectedTeachers: []
                });
            }
        case actions.TEACHER_FILTER_VALUE_CHANGED:
            {
                var _filterOption = changeFilterOptions(state.dataFilterOption, action.collectionName, action.key);
                var _filteredTeachers = getFilteredData(state.teachers, _filterOption);
                return _extends({}, state, {
                    filteredTeachers: _filteredTeachers,
                    dataFilterOption: _filterOption,
                    selectedTeachers: []
                });
            }
        case actions.UPDATE_TEACHER_SEARCH_TERM:
            {
                var _filterOption2 = _extends({}, state.dataFilterOption, { searchTerm: action.searchTerm });
                var _filteredTeachers2 = getFilteredData(state.teachers, _filterOption2);
                return _extends({}, state, {
                    filteredTeachers: _filteredTeachers2,
                    dataFilterOption: _filterOption2,
                    selectedTeachers: []
                });
            }
        case actions.SORT_TEACHER_LIST:
            {
                var sortDirection = 'asc';
                if (state.dataFilterOption.sortColumn === action.columnToSort) {
                    if (state.dataFilterOption.sortDirection === 'asc') {
                        sortDirection = 'desc';
                    }
                }

                var _filterOption3 = _extends({}, state.dataFilterOption, { sortColumn: action.columnToSort, sortDirection: sortDirection });
                var _filteredTeachers3 = getSortedData(state.filteredTeachers, _filterOption3);
                return _extends({}, state, { filteredTeachers: _filteredTeachers3, dataFilterOption: _filterOption3 });
            }
        case actions.RETRIEVE_SELECTED_TEACHER:
            {
                return _extends({}, state, { selectedTeachers: action.selectedTeachers });
            }
        case actions.UNASSIGN_TEACHERS_REQUEST:
            {
                return _extends({}, state, { disableConfirmationButtons: action.disableConfirmationButtons, selectedTeachers: [] });
            }
        case actions.UNASSIGN_TEACHERS_SUCCESS:
            {
                return _extends({}, state, {
                    isUserOperationModalOpen: action.isUserOperationModalOpen,
                    disableConfirmationButtons: action.disableConfirmationButtons,
                    selectedTeachers: []
                });
            }
        case actions.UNASSIGN_TEACHERS_FAILURE:
            {
                return _extends({}, state, { disableConfirmationButtons: action.disableConfirmationButtons });
            }
        case actions.OPEN_UNASSIGN_TEACHERS_MODAL:
            {
                return _extends({}, state, { isUserOperationModalOpen: action.isUserOperationModalOpen, operationType: action.operationType });
            }
        case actions.CLOSE_TEACHERS_OPERATION_CONFIRMATION_MODAL:
            {
                return _extends({}, state, { refreshTeacherList: action.refreshTeacherList, selectedTeachers: action.selectedTeachers });
            }
        case actions.ADD_TEACHER_OPEN_MODAL_REQUEST:
            {
                return _extends({}, state, {
                    showModal: action.showModal,
                    showAddTeacherConfirmationModal: action.showAddTeacherConfirmationModal,
                    lastAddedTeacherUserProfileId: 0,
                    teacherModel: assignEmptyTeacherObject()
                });
            }
        case actions.ADD_ANOTHER_TEACHER_OPEN_MODAL_REQUEST:
            {
                return _extends({}, state, {
                    showModal: action.showModal,
                    showAddTeacherConfirmationModal: action.showAddTeacherConfirmationModal,
                    teacherModel: assignEmptyTeacherObject()
                });
            }
        case actions.ADD_TEACHER_CLOSE_MODAL_REQUEST:
            {
                return _extends({}, state, {
                    showModal: action.showModal
                });
            }
        case actions.ADD_TEACHER_REQUEST:
            {
                return _extends({}, state, { isSaveInProgress: action.isSaveInProgress });
            }
        case actions.ADD_TEACHER_SUCCESS:
            {
                return _extends({}, state, {
                    isSaveInProgress: false,
                    showAddTeacherConfirmationModal: action.showAddTeacherConfirmationModal,
                    lastAddedTeacherUserProfileId: action.userProfileId,
                    selectedTeachers: []
                });
            }
        case actions.ADD_TEACHER_FAILURE:
            {
                var errorMessage = '';
                if (action.isServerError) {
                    errorMessage = _messages2.default.errorMessageHeader;
                } else {
                    errorMessage = action.addTeacherValidationMessage;
                }
                return _extends({}, state, {
                    isSaveInProgress: false,
                    showAddTeacherValidationModal: action.showAddTeacherValidationModal,
                    addTeacherValidationMessage: errorMessage });
            }
        case actions.CLOSE_ADD_TEACHER_VALIDATION_MODAL:
            {
                return _extends({}, state, { showAddTeacherValidationModal: action.showAddTeacherValidationModal });
            }
        case actions.PRINT_TEACHER_SIGN_IN_CARD_REQUEST:
            {
                return _extends({}, state, { isSignInCardDownloaded: action.isSignInCardDownloaded });
            }
        case actions.PRINT_TEACHER_SIGN_IN_CARD_SUCCESS:
            {
                return _extends({}, state, { isSignInCardDownloaded: action.isSignInCardDownloaded });
            }
        case actions.PRINT_TEACHER_SIGN_IN_CARD_FAILURE:
            {
                return _extends({}, state, { isSignInCardDownloaded: action.isSignInCardDownloaded });
            }
        case actions.OPEN_DELETE_TEACHER_MODAL:
            {
                return _extends({}, state, { isUserOperationModalOpen: action.isUserOperationModalOpen, operationType: action.operationType });
            }
        case actions.DELETE_TEACHER_REQUEST:
            {
                return _extends({}, state, { deletingTeacher: true, deleteSuccess: false, disableConfirmationButtons: action.disableConfirmationButtons, operationType: action.operationType });
            }
        case actions.DELETE_TEACHER_SUCCESS:
            {
                return _extends({}, state, {
                    deletingTeacher: false,
                    deleteSuccess: true,
                    disableConfirmationButtons: action.disableConfirmationButtons,
                    isUserOperationModalOpen: action.isUserOperationModalOpen,
                    notDeletedTeachers: action.notDeletedTeachers,
                    refreshTeacherList: true,
                    selectedTeachers: action.selectedTeachers
                });
            }
        case actions.DELETE_TEACHER_FAILURE:
            {
                return _extends({}, state, { deletingTeacher: false, deleteSuccess: false, disableConfirmationButtons: action.disableConfirmationButtons });
            }
        case _actions4.QUICK_UPLOAD_CLOSE_MODAL_REQUEST:
        case _actions5.CANCEL_USER_ASSIGN_REQUEST:
        case _actions5.ASSIGN_TEACHER_SUCCESS:
            {
                return _extends({}, state, { isTeacherDataLoaded: false, selectedTeachers: [] });
            }

        case _actions5.RESET_USER_CLASSROOM_RELATION:
            {
                return _extends({}, state, { selectedTeachers: [] });
            }

        case _actions2.DELETE_CLASSROOMS_SUCCESS:
        case _actions2.ADD_CLASS_SUCCESS:
        case _actions3.ADD_STUDENT_SUCCESS:
        case _actions6.REFRESH_TEACHER_LIST_ON_CANCEL_REQUEST:
        case _actions6.EDIT_TEACHER_SUCCESS_REQUEST:
        case _actions5.ASSIGN_TEACHER_TO_CLASSROOM_SUCCESS:
            {
                return _extends({}, state, { refreshTeacherList: true, selectedTeachers: [] });
            }

        case _actions2.GET_CLASSROOMS_SUCCESS:
            {
                return _extends({}, state, {
                    dataFilterOption: (0, _utils.updateClassroomList)(resetFilterOptions(state.dataFilterOption), action.data),
                    teacherModel: updateEmptyTeacherModel(action.data)
                });
            }
        case _actions7.UNASSIGN_TEACHER_SUCCESS:
            {
                return _extends({}, state, { isTeacherDataLoaded: false });
            }
        case actions.SEND_VERIFICATION_EMAIL_SUCCESS:
            return sendVerificationEmailSuccess(state, action.results);
        case actions.SEND_VERIFICATION_EMAIL_FAILURE:
            return sendVerificationEmailFailure(state);
        case actions.CLOSE_EMAIL_VERIFICATION_MODAL:
            return closeVerificationModal(state);
        default:
            return _extends({}, state);
    }
};

var _actions = __webpack_require__(50);

var actions = _interopRequireWildcard(_actions);

var _actions2 = __webpack_require__(38);

var _actions3 = __webpack_require__(98);

var _actions4 = __webpack_require__(156);

var _actions5 = __webpack_require__(95);

var _actions6 = __webpack_require__(128);

var _actions7 = __webpack_require__(106);

var _messages = __webpack_require__(267);

var _messages2 = _interopRequireDefault(_messages);

var _utils = __webpack_require__(13);

var _gridUtil = __webpack_require__(86);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var getTeacherLastNames = function getTeacherLastNames() {
    var names = [{ key: '-1', value: _messages2.default.defaultOptionTeacherLastName, selected: true }];
    var namePrefixes = (0, _utils.getAlphaNumericCharacters)().split('').map(function (item) {
        return { key: item, value: item };
    });
    var allNamePrefixes = names.concat(namePrefixes);
    return allNamePrefixes;
};

var dataFilterOption = {
    lastNames: getTeacherLastNames(),
    classrooms: [{ key: '-1', value: _messages2.default.defaultOptionTeacherClass, selected: true }, { key: 'classes', value: _messages2.default.UnassignedTeacher, selected: false }],
    searchTerm: '',
    sortColumn: 'lastName',
    sortDirection: 'asc'
};

var assignEmptyTeacherObject = function assignEmptyTeacherObject() {
    return { firstName: '', lastName: '', classroomId: '-1', title: '', emailAddress: '', classrooms: [] };
};

var initState = {
    teachers: [],
    filteredTeachers: [],
    isTeacherDataLoaded: false,
    dataFilterOption: dataFilterOption,
    selectedTeachers: [],
    isSaveInProgress: false,
    teacherModel: assignEmptyTeacherObject(),
    teacherTitles: [{ key: '', value: 'Title', selected: true }, { key: 'Miss', value: 'Miss' }, { key: 'Mr', value: 'Mr' }, { key: 'Mrs', value: 'Mrs' }, { key: 'Ms', value: 'Ms' }, { key: 'Dr', value: 'Dr' }],
    lastAddedTeacherUserProfileId: 0,
    isSignInCardDownloaded: true,
    isUserOperationModalOpen: false,
    isEmailVerificationModalOpen: false,
    sendingEmailsResult: {
        totalRequests: 0,
        successfulSending: 0,
        alreadyVerifiedEmails: 0,
        duplicateEmails: 0,
        invalidRequests: 0
    },
    emailVerificationError: false,
    refreshTeacherList: false,
    disableConfirmationButtons: false,
    operationType: '',
    teachersFiltered: []
};

var updateEmptyTeacherModel = function updateEmptyTeacherModel(classrooms) {
    var classes = classrooms.map(function (item) {
        return {
            key: item.classroomId,
            value: item.name
        };
    });

    return _extends({}, assignEmptyTeacherObject(), { classrooms: classes });
};

var resetSelectedItem = function resetSelectedItem(items) {
    var selectedItem = items.find(function (item) {
        return item.selected === true;
    });
    selectedItem.selected = false;
    items[0].selected = true;
    return items;
};

var resetFilterOptions = function resetFilterOptions(currentOptions) {
    var lastNames = resetSelectedItem(currentOptions.lastNames);
    var classrooms = resetSelectedItem(currentOptions.classrooms);

    return _extends({}, currentOptions, { lastNames: lastNames, classrooms: classrooms, searchTerm: currentOptions.searchTerm });
};

var getFilteredData = function getFilteredData(teachers, filterOptions) {
    return (0, _gridUtil.filterTeachers)(teachers, filterOptions);
};

var getSortedData = function getSortedData(teachers, filterOptions) {
    return (0, _gridUtil.sort)(teachers, filterOptions.sortColumn, filterOptions.sortDirection);
};

var changeFilterOptions = function changeFilterOptions(currentOptions, collectionName, key) {
    var items = currentOptions[collectionName];
    var selectedItem = items.find(function (item) {
        return item.selected === true;
    });
    selectedItem.selected = false;
    var newSelection = items.find(function (item) {
        return item.key.toString() === key;
    });
    newSelection.selected = true;
    return _extends({}, currentOptions, _defineProperty({}, collectionName, currentOptions[collectionName]));
};

var sendVerificationEmailSuccess = function sendVerificationEmailSuccess(state, sendingEmailsResult) {
    return _extends({}, state, {
        isEmailVerificationModalOpen: true,
        emailVerificationError: false,
        sendingEmailsResult: sendingEmailsResult
    });
};

var sendVerificationEmailFailure = function sendVerificationEmailFailure(state) {
    return _extends({}, state, { isEmailVerificationModalOpen: true, emailVerificationError: true });
};

var closeVerificationModal = function closeVerificationModal(state) {
    return _extends({}, state, { isEmailVerificationModalOpen: false, selectedTeachers: [] });
};

/***/ }),
/* 871 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.getTeachers = getTeachers;
exports.downloadTeacherRoll = downloadTeacherRoll;
exports.addTeacher = addTeacher;
exports.unassignTeachers = unassignTeachers;
exports.downloadTeacherSignInCards = downloadTeacherSignInCards;
exports.getTeachersSaga = getTeachersSaga;
exports.downloadTeacherRollSaga = downloadTeacherRollSaga;
exports.unassignTeachersSaga = unassignTeachersSaga;
exports.downloadSignInCardSaga = downloadSignInCardSaga;
exports.addTeacherSaga = addTeacherSaga;
exports.deleteTeacher = deleteTeacher;
exports.deleteTeacherSaga = deleteTeacherSaga;
exports.sendVerificationEmail = sendVerificationEmail;
exports.sendVerificationEmailSaga = sendVerificationEmailSaga;

var _effects = __webpack_require__(32);

var _api = __webpack_require__(33);

var api = _interopRequireWildcard(_api);

var _actions = __webpack_require__(50);

var actions = _interopRequireWildcard(_actions);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var _marked = /*#__PURE__*/regeneratorRuntime.mark(getTeachers),
    _marked2 = /*#__PURE__*/regeneratorRuntime.mark(downloadTeacherRoll),
    _marked3 = /*#__PURE__*/regeneratorRuntime.mark(addTeacher),
    _marked4 = /*#__PURE__*/regeneratorRuntime.mark(unassignTeachers),
    _marked5 = /*#__PURE__*/regeneratorRuntime.mark(downloadTeacherSignInCards),
    _marked6 = /*#__PURE__*/regeneratorRuntime.mark(getTeachersSaga),
    _marked7 = /*#__PURE__*/regeneratorRuntime.mark(downloadTeacherRollSaga),
    _marked8 = /*#__PURE__*/regeneratorRuntime.mark(unassignTeachersSaga),
    _marked9 = /*#__PURE__*/regeneratorRuntime.mark(downloadSignInCardSaga),
    _marked10 = /*#__PURE__*/regeneratorRuntime.mark(addTeacherSaga),
    _marked11 = /*#__PURE__*/regeneratorRuntime.mark(deleteTeacher),
    _marked12 = /*#__PURE__*/regeneratorRuntime.mark(deleteTeacherSaga),
    _marked13 = /*#__PURE__*/regeneratorRuntime.mark(sendVerificationEmail),
    _marked14 = /*#__PURE__*/regeneratorRuntime.mark(sendVerificationEmailSaga);

function getTeachers(_ref) {
    var productId = _ref.productId;
    var payload;
    return regeneratorRuntime.wrap(function getTeachers$(_context) {
        while (1) {
            switch (_context.prev = _context.next) {
                case 0:
                    _context.next = 2;
                    return (0, _effects.call)(api.getTeachersByProduct, productId);

                case 2:
                    payload = _context.sent;

                    if (!(payload.status === 200)) {
                        _context.next = 8;
                        break;
                    }

                    _context.next = 6;
                    return (0, _effects.put)(actions.getProductTeachersSuccess(payload));

                case 6:
                    _context.next = 10;
                    break;

                case 8:
                    _context.next = 10;
                    return (0, _effects.put)(actions.getProductTeachersFailure());

                case 10:
                case 'end':
                    return _context.stop();
            }
        }
    }, _marked, this);
}

function downloadTeacherRoll(teachers) {
    var response, downloadUrl;
    return regeneratorRuntime.wrap(function downloadTeacherRoll$(_context2) {
        while (1) {
            switch (_context2.prev = _context2.next) {
                case 0:
                    _context2.next = 2;
                    return (0, _effects.call)(api.postTeachersPriorDownload, teachers);

                case 2:
                    response = _context2.sent;

                    if (!(response.status === 201)) {
                        _context2.next = 9;
                        break;
                    }

                    downloadUrl = response.verb.url + response.data;
                    _context2.next = 7;
                    return (0, _effects.put)(actions.downloadTeacherRollSuccess(downloadUrl, true));

                case 7:
                    _context2.next = 11;
                    break;

                case 9:
                    _context2.next = 11;
                    return (0, _effects.put)(actions.downloadTeacherRollFailure());

                case 11:
                case 'end':
                    return _context2.stop();
            }
        }
    }, _marked2, this);
}

function addTeacher(teacher) {
    var response;
    return regeneratorRuntime.wrap(function addTeacher$(_context3) {
        while (1) {
            switch (_context3.prev = _context3.next) {
                case 0:
                    _context3.next = 2;
                    return (0, _effects.call)(api.addTeacher, teacher);

                case 2:
                    response = _context3.sent;

                    if (!(response.status === 200)) {
                        _context3.next = 8;
                        break;
                    }

                    _context3.next = 6;
                    return (0, _effects.put)(actions.addTeacherSuccess(response.data.userProfileId));

                case 6:
                    _context3.next = 15;
                    break;

                case 8:
                    if (!(response.status === 400 || response.status === 409)) {
                        _context3.next = 13;
                        break;
                    }

                    _context3.next = 11;
                    return (0, _effects.put)(actions.addTeacherFailure(false, response.message));

                case 11:
                    _context3.next = 15;
                    break;

                case 13:
                    _context3.next = 15;
                    return (0, _effects.put)(actions.addTeacherFailure(true, ''));

                case 15:
                case 'end':
                    return _context3.stop();
            }
        }
    }, _marked3, this);
}

function unassignTeachers(_ref2) {
    var selectedTeachers = _ref2.selectedTeachers,
        productId = _ref2.productId;
    var userRelationship, response;
    return regeneratorRuntime.wrap(function unassignTeachers$(_context4) {
        while (1) {
            switch (_context4.prev = _context4.next) {
                case 0:
                    userRelationship = { productId: productId, teachersProfileIdToUnassign: selectedTeachers };
                    _context4.next = 3;
                    return (0, _effects.call)(api.unAssignTeachers, userRelationship);

                case 3:
                    response = _context4.sent;

                    if (!(response.status === 200)) {
                        _context4.next = 9;
                        break;
                    }

                    _context4.next = 7;
                    return (0, _effects.put)(actions.unassignTeachersSuccess());

                case 7:
                    _context4.next = 11;
                    break;

                case 9:
                    _context4.next = 11;
                    return (0, _effects.put)(actions.unassignTeachersFailure());

                case 11:
                case 'end':
                    return _context4.stop();
            }
        }
    }, _marked4, this);
}

function downloadTeacherSignInCards(_ref3) {
    var productId = _ref3.productId,
        teacherSignInCardsData = _ref3.teacherSignInCardsData;
    var response, downloadUrl;
    return regeneratorRuntime.wrap(function downloadTeacherSignInCards$(_context5) {
        while (1) {
            switch (_context5.prev = _context5.next) {
                case 0:
                    _context5.next = 2;
                    return (0, _effects.call)(api.downloadTeachersSignInCards, productId, teacherSignInCardsData);

                case 2:
                    response = _context5.sent;

                    if (!(response.status === 201)) {
                        _context5.next = 9;
                        break;
                    }

                    downloadUrl = response.verb.url + '/' + response.data;
                    _context5.next = 7;
                    return (0, _effects.put)(actions.printTeacherSignInCardSuccess(downloadUrl, true));

                case 7:
                    _context5.next = 11;
                    break;

                case 9:
                    _context5.next = 11;
                    return (0, _effects.put)(actions.printTeacherSignInCardFailure(true));

                case 11:
                case 'end':
                    return _context5.stop();
            }
        }
    }, _marked5, this);
}

function getTeachersSaga() {
    return regeneratorRuntime.wrap(function getTeachersSaga$(_context6) {
        while (1) {
            switch (_context6.prev = _context6.next) {
                case 0:
                    _context6.next = 2;
                    return (0, _effects.takeLatest)(actions.GET_PRODUCT_TEACHERS_REQUEST, getTeachers);

                case 2:
                case 'end':
                    return _context6.stop();
            }
        }
    }, _marked6, this);
}

function downloadTeacherRollSaga() {
    return regeneratorRuntime.wrap(function downloadTeacherRollSaga$(_context7) {
        while (1) {
            switch (_context7.prev = _context7.next) {
                case 0:
                    _context7.next = 2;
                    return (0, _effects.takeEvery)(actions.DOWNLOAD_TEACHER_ROLL_REQUEST, downloadTeacherRoll);

                case 2:
                case 'end':
                    return _context7.stop();
            }
        }
    }, _marked7, this);
}

function unassignTeachersSaga() {
    return regeneratorRuntime.wrap(function unassignTeachersSaga$(_context8) {
        while (1) {
            switch (_context8.prev = _context8.next) {
                case 0:
                    _context8.next = 2;
                    return (0, _effects.takeLatest)(actions.UNASSIGN_TEACHERS_REQUEST, unassignTeachers);

                case 2:
                case 'end':
                    return _context8.stop();
            }
        }
    }, _marked8, this);
}

function downloadSignInCardSaga() {
    return regeneratorRuntime.wrap(function downloadSignInCardSaga$(_context9) {
        while (1) {
            switch (_context9.prev = _context9.next) {
                case 0:
                    _context9.next = 2;
                    return (0, _effects.takeLatest)(actions.PRINT_TEACHER_SIGN_IN_CARD_REQUEST, downloadTeacherSignInCards);

                case 2:
                case 'end':
                    return _context9.stop();
            }
        }
    }, _marked9, this);
}

function addTeacherSaga() {
    return regeneratorRuntime.wrap(function addTeacherSaga$(_context10) {
        while (1) {
            switch (_context10.prev = _context10.next) {
                case 0:
                    _context10.next = 2;
                    return (0, _effects.takeLatest)(actions.ADD_TEACHER_REQUEST, addTeacher);

                case 2:
                case 'end':
                    return _context10.stop();
            }
        }
    }, _marked10, this);
}

function deleteTeacher(userProfileIds) {
    var userRelationship, response, data;
    return regeneratorRuntime.wrap(function deleteTeacher$(_context11) {
        while (1) {
            switch (_context11.prev = _context11.next) {
                case 0:
                    userRelationship = { userProfileIds: userProfileIds };
                    _context11.next = 3;
                    return (0, _effects.call)(api.deleteTeachers, userRelationship.userProfileIds);

                case 3:
                    response = _context11.sent;

                    if (!(response.status === 200)) {
                        _context11.next = 10;
                        break;
                    }

                    data = response.data;
                    _context11.next = 8;
                    return (0, _effects.put)(actions.deleteTeacherSuccess(data));

                case 8:
                    _context11.next = 12;
                    break;

                case 10:
                    _context11.next = 12;
                    return (0, _effects.put)(actions.deleteTeacherFailure());

                case 12:
                case 'end':
                    return _context11.stop();
            }
        }
    }, _marked11, this);
}

function deleteTeacherSaga() {
    return regeneratorRuntime.wrap(function deleteTeacherSaga$(_context12) {
        while (1) {
            switch (_context12.prev = _context12.next) {
                case 0:
                    _context12.next = 2;
                    return (0, _effects.takeLatest)(actions.DELETE_TEACHER_REQUEST, deleteTeacher);

                case 2:
                case 'end':
                    return _context12.stop();
            }
        }
    }, _marked12, this);
}

function sendVerificationEmail(data) {
    var request, payload;
    return regeneratorRuntime.wrap(function sendVerificationEmail$(_context13) {
        while (1) {
            switch (_context13.prev = _context13.next) {
                case 0:
                    request = { userProfileIds: data.userProfileIds };
                    _context13.next = 3;
                    return (0, _effects.call)(api.sendVerificationEmails, request);

                case 3:
                    payload = _context13.sent;

                    if (!(payload.status === 200)) {
                        _context13.next = 9;
                        break;
                    }

                    _context13.next = 7;
                    return (0, _effects.put)(actions.sendVerificationEmailSuccess(payload.data));

                case 7:
                    _context13.next = 11;
                    break;

                case 9:
                    _context13.next = 11;
                    return (0, _effects.put)(actions.sendVerificationEmailFailure(payload.message));

                case 11:
                case 'end':
                    return _context13.stop();
            }
        }
    }, _marked13, this);
}

function sendVerificationEmailSaga() {
    return regeneratorRuntime.wrap(function sendVerificationEmailSaga$(_context14) {
        while (1) {
            switch (_context14.prev = _context14.next) {
                case 0:
                    _context14.next = 2;
                    return (0, _effects.takeEvery)(actions.SEND_VERIFICATION_EMAIL_REQUEST, sendVerificationEmail);

                case 2:
                case 'end':
                    return _context14.stop();
            }
        }
    }, _marked14, this);
}

/***/ }),
/* 872 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(Promise) {

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = __webpack_require__(28);

var _redux = __webpack_require__(35);

var _reactIntl = __webpack_require__(2);

var _index = __webpack_require__(795);

var _index2 = _interopRequireDefault(_index);

var _actions = __webpack_require__(50);

var _actions2 = __webpack_require__(268);

var _constants = __webpack_require__(40);

var _messages = __webpack_require__(873);

var _messages2 = _interopRequireDefault(_messages);

var _api = __webpack_require__(33);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var TeacherViewContainer = function (_Component) {
    _inherits(TeacherViewContainer, _Component);

    function TeacherViewContainer(props) {
        var _this2 = this;

        _classCallCheck(this, TeacherViewContainer);

        var _this = _possibleConstructorReturn(this, (TeacherViewContainer.__proto__ || Object.getPrototypeOf(TeacherViewContainer)).call(this, props));

        _this.updateTeacherTitle = function (teachers) {
            var updatedTeachers = teachers.map(function (teacher) {
                return _extends({}, teacher, {
                    name: teacher.isCurrentUser ? teacher.name + ' (' + _this.props.intl.formatMessage(_messages2.default.teacherViewYou) + ')' : teacher.name
                });
            });

            return updatedTeachers;
        };

        _this.handleOnLaunch = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
            var _this$state, teachers, selectedTeacherId, response, redirectUri, isCurrentUser, tStamp, separator, timestampedRedirectUri;

            return regeneratorRuntime.wrap(function _callee$(_context) {
                while (1) {
                    switch (_context.prev = _context.next) {
                        case 0:
                            /* Previous implementation url
                            const portalUrl = `${config.portalUrl}${authToken}&tstamp=${tStamp}&lang=${getLocale()}&productId=${selectedProduct.id}&JWT=${teacherJWTToken}`;
                            } */
                            // TODO: Revisit to determine if we need the extra query params for new redirection rules
                            // New Teacher impersonation involves redirecting to the URL specified in the login response object
                            // 3Essential / 3P Roster teachers will be redirected to the 3E TUI, the others will be redirected to MX portal
                            _this$state = _this.state, teachers = _this$state.teachers, selectedTeacherId = _this$state.selectedTeacherId;

                            if (!(selectedTeacherId !== _constants.DEFAULT_TEACHER_ID)) {
                                _context.next = 17;
                                break;
                            }

                            _this.setState({ isFetchingData: true });
                            _context.next = 5;
                            return (0, _api.getTeacherAuthToken)(_constants.teacherUserTypeId, Number(selectedTeacherId));

                        case 5:
                            response = _context.sent;
                            redirectUri = response.data.redirectUri;

                            if (!redirectUri) {
                                _context.next = 17;
                                break;
                            }

                            _this.setState({ isFetchingData: false });

                            isCurrentUser = teachers.filter(function (teacher) {
                                return teacher.id.toString() === _this.state.selectedTeacherId;
                            })[0].isCurrentUser;

                            if (!isCurrentUser) {
                                _context.next = 13;
                                break;
                            }

                            window.parent.location.href = redirectUri;
                            return _context.abrupt('return');

                        case 13:
                            tStamp = new Date().getTime();
                            separator = redirectUri.includes('?') ? '&' : '?';
                            timestampedRedirectUri = '' + redirectUri + separator + 'tstamp=' + tStamp;

                            window.open(timestampedRedirectUri, '_blank');

                        case 17:
                        case 'end':
                            return _context.stop();
                    }
                }
            }, _callee, _this2);
        }));

        _this.onTeacherSelectionChange = function (name, value) {
            _this.setState({ selectedTeacherId: value });
        };

        _this.state = {
            selectedTeacherId: _constants.DEFAULT_TEACHER_ID,
            teachers: [],
            redirectUri: undefined,
            isFetchingData: false
        };
        return _this;
    }

    _createClass(TeacherViewContainer, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            var _props = this.props,
                teachers = _props.teachers,
                selectedProduct = _props.selectedProduct;


            if (!teachers.length) {
                this.props.getProductTeachers(selectedProduct.id);
            }
        }
    }, {
        key: 'componentWillReceiveProps',
        value: function componentWillReceiveProps(nextProps) {
            this.setState({
                teachers: this.updateTeacherTitle(nextProps.teachers)
            });
            this.setState({
                redirectUri: nextProps.redirectUri
            });
        }
    }, {
        key: 'render',
        value: function render() {
            return _react2.default.createElement(_index2.default, _extends({
                handleOnLaunch: this.handleOnLaunch,
                onTeacherSelection: this.onTeacherSelectionChange,
                selectedTeacherId: this.state.selectedTeacherId
            }, this.props, {
                isFetchingData: this.state.isFetchingData,
                teachers: this.state.teachers
            }));
        }
    }]);

    return TeacherViewContainer;
}(_react.Component);

// TODO: Cleanup JWTToken - we don't seem to use it anywhere. With 3Essentials / 3P Roster, it is obsolete.


TeacherViewContainer.propTypes = {
    selectedProduct: _propTypes2.default.object,
    teachers: _propTypes2.default.array,
    getProductTeachers: _propTypes2.default.func,
    isTeachersLoaded: _propTypes2.default.bool,
    getTeacherAuthTokenRequest: _propTypes2.default.func,
    authToken: _propTypes2.default.string,
    teacherJWTToken: _propTypes2.default.string,
    redirectUri: _propTypes2.default.string,
    isGettingToken: _propTypes2.default.bool,
    intl: _reactIntl.intlShape.isRequired
};

var mapStateToProps = function mapStateToProps(state) {
    return {
        selectedProduct: state.product,
        teachers: state.teacherView.teachers,
        isTeachersLoaded: state.teacherView.isTeachersLoaded,
        authToken: state.teacherView.authToken,
        teacherJWTToken: state.teacherView.teacherJWTToken,
        redirectUri: state.teacherView.redirectUri,
        isGettingToken: state.teacherView.isGettingToken
    };
};

function mapDispatchToProps(dispatch) {
    return (0, _redux.bindActionCreators)({
        getProductTeachers: _actions.getProductTeachers,
        getTeacherAuthTokenRequest: _actions2.getTeacherAuthTokenRequest
    }, dispatch);
}

exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)((0, _reactIntl.injectIntl)(TeacherViewContainer));
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(64)))

/***/ }),
/* 873 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _reactIntl = __webpack_require__(2);

exports.default = (0, _reactIntl.defineMessages)({
    teacherViewYou: {
        id: 'teacher-roll.container.teacherView.you',
        defaultMessage: 'You'
    }
});

/***/ }),
/* 874 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.default = function () {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initState;
    var action = arguments[1];

    switch (action.type) {
        case _actions.GET_PRODUCT_TEACHERS_SUCCESS:
            {
                return _extends({}, state, {
                    teachers: getUpdatedTeachers(action.data),
                    isTeachersLoaded: true
                });
            }

        case actions.GET_TEACHER_AUTH_TOKEN_REQUEST:
            {
                return _extends({}, state, {
                    authToken: '',
                    redirectUri: '',
                    isGettingToken: action.isGettingToken
                });
            }

        case actions.GET_TEACHER_AUTH_TOKEN_SUCCESS:
            {
                return _extends({}, state, {
                    authToken: action.authToken,
                    redirectUri: action.redirectUri,
                    isGettingToken: action.isGettingToken
                });
            }

        default:
            return _extends({}, state);
    }
};

var _lodash = __webpack_require__(1452);

var _actions = __webpack_require__(50);

var _actions2 = __webpack_require__(268);

var actions = _interopRequireWildcard(_actions2);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var initState = {
    teachers: [],
    isTeachersLoaded: false,
    authToken: '',
    teacherJWTToken: '',
    isGettingToken: false
};

var getUpdatedTeachers = function getUpdatedTeachers(teachers) {
    var filteredTeachers = (0, _lodash.filter)(teachers, function (teacher) {
        return teacher.assignedClassrooms.length;
    });

    var teachersList = filteredTeachers.map(function (teacher) {
        return {
            name: teacher.lastName + ', ' + teacher.firstName,
            id: teacher.userProfileId,
            assignedClassrooms: teacher.assignedClassrooms,
            userName: teacher.userName,
            isCurrentUser: teacher.isCurrentUser
        };
    });

    return teachersList;
};

/***/ }),
/* 875 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.getTeacherAuthToken = getTeacherAuthToken;
exports.getTeacherAuthTokenRequestSaga = getTeacherAuthTokenRequestSaga;

var _effects = __webpack_require__(32);

var _api = __webpack_require__(33);

var api = _interopRequireWildcard(_api);

var _actions = __webpack_require__(268);

var actions = _interopRequireWildcard(_actions);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var _marked = /*#__PURE__*/regeneratorRuntime.mark(getTeacherAuthToken),
    _marked2 = /*#__PURE__*/regeneratorRuntime.mark(getTeacherAuthTokenRequestSaga);

function getTeacherAuthToken(_ref) {
    var userProfileType = _ref.userProfileType,
        userProfileId = _ref.userProfileId;
    var response;
    return regeneratorRuntime.wrap(function getTeacherAuthToken$(_context) {
        while (1) {
            switch (_context.prev = _context.next) {
                case 0:
                    _context.next = 2;
                    return (0, _effects.call)(api.getTeacherAuthToken, userProfileType, userProfileId);

                case 2:
                    response = _context.sent;

                    if (!(response.status === 200)) {
                        _context.next = 13;
                        break;
                    }

                    if (!response.data.success) {
                        _context.next = 9;
                        break;
                    }

                    _context.next = 7;
                    return (0, _effects.put)(actions.getTeacherAuthTokenSuccess(response.data));

                case 7:
                    _context.next = 11;
                    break;

                case 9:
                    _context.next = 11;
                    return (0, _effects.put)(actions.getTeacherLoginFailure(response.data.error));

                case 11:
                    _context.next = 15;
                    break;

                case 13:
                    _context.next = 15;
                    return (0, _effects.put)(actions.getTeacherAuthTokenFailure());

                case 15:
                case 'end':
                    return _context.stop();
            }
        }
    }, _marked, this);
}

function getTeacherAuthTokenRequestSaga() {
    return regeneratorRuntime.wrap(function getTeacherAuthTokenRequestSaga$(_context2) {
        while (1) {
            switch (_context2.prev = _context2.next) {
                case 0:
                    _context2.next = 2;
                    return (0, _effects.takeLatest)(actions.GET_TEACHER_AUTH_TOKEN_REQUEST, getTeacherAuthToken);

                case 2:
                case 'end':
                    return _context2.stop();
            }
        }
    }, _marked2, this);
}

/***/ }),
/* 876 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _resource = __webpack_require__(611);

var _resource2 = _interopRequireDefault(_resource);

var _localResourceConfig = __webpack_require__(878);

var _localResourceConfig2 = _interopRequireDefault(_localResourceConfig);

var _constants = __webpack_require__(40);

var _constants2 = _interopRequireDefault(_constants);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var BasicResources = function () {
    function BasicResources() {
        _classCallCheck(this, BasicResources);
    }

    _createClass(BasicResources, null, [{
        key: 'initialise',
        value: function initialise(envName, credentials) {
            // Race condition here. The result is inconsistent. In configuration: { values: ... }
            var env = (0, _resource2.default)({
                name: envName,
                application: _constants2.default,
                // eslint-disable-next-line no-underscore-dangle
                config: window._env_
            });
            var location = window.location;
            var runningOnDeveloperMachine = /^https?:\/\/localhost/.test(location);

            if (runningOnDeveloperMachine) {
                if (envName === 'local') {
                    // This implies we'll be hitting the mock REST server,
                    // which does not require authentication.
                    env.bypassAuthentication();
                    env.setConfiguration(_localResourceConfig2.default);
                } else if (credentials.authToken) {
                    env.authToken = credentials.authToken;
                } else {
                    env.setCredentials(credentials.username, credentials.password);
                }
            } else if (credentials.authToken) {
                env.authToken = credentials.authToken;
            } else if (credentials.username && credentials.password) {
                env.username = credentials.username;
                env.password = credentials.password;
            } else {
                // The caller should have provided a valid set of credentials, so
                // hopefully this will never happen.
                /* eslint-disable no-console */
                console.log('BasicResources.initialise() - to execute, we need either an authToken or' + ' a username/password pair.  The credentials object that was provided does not' + ' contain either.  So, expect things to fail badly :-(.');
                /* eslint-enable no-console */
            }

            return env;
        }
    }]);

    return BasicResources;
}();

exports.default = BasicResources;

/***/ }),
/* 877 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _resources = __webpack_require__(270);

var _resources2 = _interopRequireDefault(_resources);

var _portalComms = __webpack_require__(55);

var _portalComms2 = _interopRequireDefault(_portalComms);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var MESSAGE = {
    UNKNOWN: 'Something went wrong. Please try again.',
    INVALID_TOKEN: 'Invalid session. Please login and try again.'
};

var ErrorHandling = function () {
    function ErrorHandling() {
        _classCallCheck(this, ErrorHandling);
    }

    _createClass(ErrorHandling, null, [{
        key: 'addResourceResponseErrorInterceptor',
        value: function addResourceResponseErrorInterceptor() {
            var interceptor = ErrorHandling.handleErrors;

            _resources2.default.env.addResponseInterceptor(interceptor);
        }
    }, {
        key: 'handleErrors',
        value: function handleErrors(result) {
            var message = void 0;
            var valid = false;

            try {
                switch (result.status) {
                    case 200:case 201:case 204:
                        valid = true;
                        break;

                    case 0:case 400:case 404:case 409:
                        // bad request handle locally
                        valid = true;
                        break;

                    case 401:
                        message = MESSAGE.INVALID_TOKEN;
                        break;

                    default:
                        message = result.message;
                }
            } catch (e) {
                message = MESSAGE.UNKNOWN;
            }

            // Global Error handling
            if (valid === false) {
                _portalComms2.default.serverError(message);
            }

            // Pass Errors to Local actions to handle explicitly
            // when result.valid === true BUT
            // result contains result.message && result.code,
            // it means it requires to handle in async functions response
            result.valid = valid;

            return result;
        }
    }]);

    return ErrorHandling;
}();

exports.default = ErrorHandling;

/***/ }),
/* 878 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

// For local development, we can use mock-rest-server (or a similar REST server like json-server)
//
// You should be able to use this code as is, apart from perhaps changing MOCK_SERVICE_PORT to whatever
// port you're using for your mock server.

var MOCK_SERVICES_PORT = 8080; // TODO: DEFINE THE PORT YOUR MOCK SERVER IS LISTENING ON

var MOCK_SERVICES_HOST = 'localhost';
var MOCK_SERVICES_URL = 'http://' + MOCK_SERVICES_HOST + ':' + MOCK_SERVICES_PORT;

// The app's configuration will have a base URL for each service we use.  For local testing, we define
// the configuration to point to our local server.
//
// For each resource, we have a constant for the base URL, as it would be in production. For example,
// below we have "AvatarAdminBaseUrl" which represents the base of the URL for access to all of
// the Avatar Admin application's resources.  Replace that with the resource(s) your application uses.

var COMMON_CONFIG = {
    BaseName: '',
    SchoolRollGatewayUrl: MOCK_SERVICES_URL + '/SchoolRollGateway/api/v1'
};

exports.default = {
    local: _extends({}, COMMON_CONFIG),

    live: _extends({}, COMMON_CONFIG, {
        'Shared.AuthenticationServicePathUrl': 'http://mzaue2.phoenix.mathletics.com/AuthenticationService-R170/'
    }),

    qa: _extends({}, COMMON_CONFIG, {
        'Shared.AuthenticationServicePathUrl': 'http://qa.phoenix.mathletics.com/AuthenticationService-R170/'
    }),

    demo: _extends({}, COMMON_CONFIG, {
        'Shared.AuthenticationServicePathUrl': 'http://demo.3plearning.com/AuthenticationService/'
    })
};

/***/ }),
/* 879 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var MESSAGES = {
    ERROR: 'ERROR',
    MODULE_CHANGE: 'MODULE_CHANGE',
    MODULE_CHANGE_REQUEST: 'MODULE_CHANGE_REQUEST',
    NAVIGATE_TO_LANDING_REQUEST: 'NAVIGATE_TO_LANDING_REQUEST',
    LOADING_SPINNER_REQUEST: 'LOADING_SPINNER_REQUEST',
    SET_CURRENT_CLASS_GROUP: 'SET_CURRENT_CLASS_GROUP',
    LOGOUT_REQUEST: 'LOGOUT_REQUEST',
    MAKE_API_CALL: 'MAKE_API_CALL',
    DUCS_EVENT_MODAL: 'DUCS_EVENT_MODAL',
    SET_DYNAMIC_PARAMS: 'SET_DYNAMIC_PARAMS'
};

var portalCommunication = {
    // The list of shared magic string codes. Used privately here, publicly by the portal to interpret incoming messages
    MESSAGES: MESSAGES,

    postPortalMessage: function postPortalMessage(message) {
        // TODO: Node module for frame communication messages?
        // TODO: Domain checking
        window.top.postMessage(JSON.stringify(message), '*');
    },


    /**
     * Set the currently selected class and group. If a new module is selected, the classId and groupId will be passed to it
     * @param {string} classId
     * @param {string} groupId
     */
    informClassGroupSelection: function informClassGroupSelection(classId, groupId) {
        this.postPortalMessage({
            type: this.MESSAGES.SET_CURRENT_CLASS_GROUP,
            params: {
                classId: classId,
                groupId: groupId
            }
        });
    },


    /**
     * Inform the portal that the currently selected module has changed (For example, you have moved from route to another internally)
     * @param {string} newModuleId
     */
    informModuleChange: function informModuleChange(newModuleId) {
        this.postPortalMessage({
            type: this.MESSAGES.MODULE_CHANGE,
            message: newModuleId
        });
    },


    /**
     * Inform the portal to go back to the portal landing screen for the currently loaded module
     * @param {string} moduleId
     */
    requestNavigateToLanding: function requestNavigateToLanding(moduleId) {
        this.postPortalMessage({
            type: this.MESSAGES.NAVIGATE_TO_LANDING_REQUEST,
            message: moduleId
        });
    },


    /**
     * Ask the portal to change the currently selected module, optionally selecting a class/group at the same time
     * @param {string} newModuleId
     * @param {object} params An object containing the classId and (optionally) the groupId to select
     */
    requestModuleChange: function requestModuleChange(newModuleId, params) {
        this.postPortalMessage({
            type: this.MESSAGES.MODULE_CHANGE_REQUEST,
            message: newModuleId,
            params: params
        });
    },


    /**
     * Show or hide the loading spinner. This should be called with false on every route that can be accessed by the portal,
     * and then turned on/off as needed
     * @param {boolean} isLoading True shows the spinner, false hides it
     */
    requestLoadingSpinner: function requestLoadingSpinner(isLoading) {
        this.postPortalMessage({
            type: this.MESSAGES.LOADING_SPINNER_REQUEST,
            message: isLoading
        });
    },


    /**
     * Request the portal alert the user of a server error (Unexpected 500)
     */
    requestServerError: function requestServerError() {
        this.postPortalMessage({
            type: this.MESSAGES.ERROR,
            message: '_SERVER_ERROR_'
        });
    },


    /**
     * Request the portal alert the user to an expired token error
     */
    requestSessionError: function requestSessionError() {
        this.postPortalMessage({
            type: this.MESSAGES.ERROR,
            message: '_SESSION_EXPIRED_'
        });
    },


    /**
     * Request the portal to logout
     * @param {string} logoutUrl
     */
    logout: function logout(logoutUrl) {
        this.postPortalMessage({
            type: this.MESSAGES.LOGOUT_REQUEST,
            message: logoutUrl
        });
    },


    /**
     * Inform the portal to make an API call based on apiType
     * @param {object} params An object containing the productId and apiType to select
     */
    informMakeAPICall: function informMakeAPICall(params) {
        this.postPortalMessage({
            type: this.MESSAGES.MAKE_API_CALL,
            params: params
        });
    },


    /**
     * Request the portal to open ducs event modal
     * @param {string[]} arrayGirlId
     */
    requestDucsModal: function requestDucsModal(arrayGirlId) {
        this.postPortalMessage({
            type: this.MESSAGES.DUCS_EVENT_MODAL,
            message: arrayGirlId
        });
    },
    setDynamicParams: function setDynamicParams(_ref) {
        var id = _ref.id,
            value = _ref.value;

        this.postPortalMessage({
            type: this.MESSAGES.SET_DYNAMIC_PARAMS,
            message: _defineProperty({}, id, value)
        });
    }
};

exports.default = portalCommunication;

/***/ }),
/* 880 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _queryString = __webpack_require__(177);

var _queryString2 = _interopRequireDefault(_queryString);

var _productEnum = __webpack_require__(77);

var _productEnum2 = _interopRequireDefault(_productEnum);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var productService = function () {
    function productService() {
        _classCallCheck(this, productService);
    }

    _createClass(productService, null, [{
        key: 'Configure',
        value: function Configure() {
            var selectedProductId = void 0;

            var productIdInQueryString = _queryString2.default.parse(location.search);

            if (productIdInQueryString.productId) {
                selectedProductId = Number.parseInt(productIdInQueryString.productId, 10);
            }
            var initialState = {
                product: {
                    id: selectedProductId,
                    name: this.getProductNameById(selectedProductId)
                } };
            return initialState;
        }
    }, {
        key: 'getProductNameById',
        value: function getProductNameById(id) {
            var productName = '';
            if (id) {
                for (var key in _productEnum2.default) {
                    if (_productEnum2.default[key].id === id) {
                        productName = _productEnum2.default[key].name;
                        break;
                    }
                }
            }
            return productName;
        }
    }]);

    return productService;
}();

exports.default = productService;

/***/ }),
/* 881 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _queryString = __webpack_require__(177);

var queryString = _interopRequireWildcard(_queryString);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function ConserveParameters(importantParams) {
    function modifyPath(path) {
        var currentParams = queryString.parse(window.location.search);

        var paramList = {};
        var paramsToAdd = false;

        importantParams.forEach(function (param) {
            if (currentParams[param]) {
                if (!path.match('(\\?|&)' + param + '=')) {
                    paramList[param] = currentParams[param];
                    paramsToAdd = true;
                }
            }
        });

        if (paramsToAdd) {
            path += path.indexOf('?') === -1 ? '?' : '&';
            path += queryString.stringify(paramList);
        }

        return path;
    }

    var oldPushState = window.history.pushState;
    var oldReplaceState = window.history.replaceState;

    window.history.pushState = function newPushState() {
        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        args[2] = modifyPath(args[2]);
        oldPushState.apply(this, args);
    };

    window.history.replaceState = function newReplaceState() {
        for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
            args[_key2] = arguments[_key2];
        }

        args[2] = modifyPath(args[2]);
        oldReplaceState.apply(this, args);
    };
}

exports.default = ConserveParameters;

/***/ }),
/* 882 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _effects = __webpack_require__(32);

var _saga = __webpack_require__(860);

var schoolRollSaga = _interopRequireWildcard(_saga);

var _saga2 = __webpack_require__(868);

var studentRollSaga = _interopRequireWildcard(_saga2);

var _saga3 = __webpack_require__(871);

var teacherRollSaga = _interopRequireWildcard(_saga3);

var _saga4 = __webpack_require__(821);

var classRollSaga = _interopRequireWildcard(_saga4);

var _saga5 = __webpack_require__(853);

var quickUploadSaga = _interopRequireWildcard(_saga5);

var _saga6 = __webpack_require__(834);

var editStudentSaga = _interopRequireWildcard(_saga6);

var _saga7 = __webpack_require__(818);

var assignUserSaga = _interopRequireWildcard(_saga7);

var _saga8 = __webpack_require__(837);

var editTeacherSaga = _interopRequireWildcard(_saga8);

var _saga9 = __webpack_require__(830);

var editClassSaga = _interopRequireWildcard(_saga9);

var _saga10 = __webpack_require__(857);

var rollOverSaga = _interopRequireWildcard(_saga10);

var _saga11 = __webpack_require__(840);

var extendResultSaga = _interopRequireWildcard(_saga11);

var _saga12 = __webpack_require__(823);

var defaultCoursesSaga = _interopRequireWildcard(_saga12);

var _saga13 = __webpack_require__(826);

var downloadCertificatesSaga = _interopRequireWildcard(_saga13);

var _saga14 = __webpack_require__(875);

var teacherViewSaga = _interopRequireWildcard(_saga14);

var _saga15 = __webpack_require__(814);

var assignCoursesSaga = _interopRequireWildcard(_saga15);

var _saga16 = __webpack_require__(812);

var assignUPFCoursesSaga = _interopRequireWildcard(_saga16);

var _saga17 = __webpack_require__(808);

var assignLegacyCoursesSaga = _interopRequireWildcard(_saga17);

var _saga18 = __webpack_require__(848);

var assignCourseAdminSaga = _interopRequireWildcard(_saga18);

var _saga19 = __webpack_require__(804);

var assignConquestCoursesSaga = _interopRequireWildcard(_saga19);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var _marked = /*#__PURE__*/regeneratorRuntime.mark(mainSaga);

function mainSaga() {
    return regeneratorRuntime.wrap(function mainSaga$(_context) {
        while (1) {
            switch (_context.prev = _context.next) {
                case 0:
                    _context.next = 2;
                    return (0, _effects.all)([schoolRollSaga.getLicenceCapSummarySaga(), classRollSaga.getClassroomsSaga(), schoolRollSaga.getCourseCountriesSaga(), schoolRollSaga.getUpfCourseCountriesSaga(), classRollSaga.getProductCoursesSaga(), classRollSaga.addClassSaga(), studentRollSaga.getStudentsSaga(), schoolRollSaga.getYearGroupSaga(), studentRollSaga.downloadStudentRollSaga(), studentRollSaga.unassignStudentsSaga(), studentRollSaga.downloadSignInCardSaga(), studentRollSaga.addStudentSaga(), studentRollSaga.deleteStudentSaga(), studentRollSaga.bulkPasswordChangeStudentsSaga(), studentRollSaga.getClassroomGroupsSaga(), quickUploadSaga.downloadTemplateForQuickUploadSaga(), quickUploadSaga.quickUploadSaga(), editStudentSaga.unassignStudentsByClassIdSaga(), editStudentSaga.getStudentsByUserProfileIdSaga(), editStudentSaga.editStudentSaga(), assignUserSaga.getStudentClassroomsRelationSaga(), assignUserSaga.getTeacherClassroomsRelationSaga(), assignUserSaga.assignStudentSaga(), assignUserSaga.assignTeacherSaga(), assignUserSaga.assignTeacherToClassroomSaga(), teacherRollSaga.getTeachersSaga(), teacherRollSaga.addTeacherSaga(), teacherRollSaga.downloadTeacherRollSaga(), teacherRollSaga.downloadSignInCardSaga(), teacherRollSaga.unassignTeachersSaga(), teacherRollSaga.deleteTeacherSaga(), teacherRollSaga.sendVerificationEmailSaga(), editTeacherSaga.editTeacherSaga(), editTeacherSaga.getTeacherByUserProfileIdSaga(), editTeacherSaga.downloadClassroomStudentsSignInCardSaga(), editTeacherSaga.unassignTeachersByClassIdSaga(), classRollSaga.downloadClassroomStudentsSignInsCardsSaga(), editTeacherSaga.unassignTeachersByClassIdSaga(), editTeacherSaga.sendPasswordLinkSaga(), editTeacherSaga.sendEmailVerificationLinkSaga(), classRollSaga.downloadClassRollSaga(), classRollSaga.getSchoolCoursesSaga(), classRollSaga.deleteClassroomsSaga(), classRollSaga.getUPFCoursesSaga(), classRollSaga.getNewCoursesSaga(), editClassSaga.renameClassroomGroupSaga(), editClassSaga.getClassByClassroomIdSaga(), editClassSaga.downloadStudentSignInCardsSaga(), editClassSaga.saveModifiedClassSaga(), editClassSaga.unassignTeacherSaga(), editClassSaga.downloadTeachersSignInCardSaga(), editClassSaga.deleteClassroomGroupSaga(), editClassSaga.changeClassroomCourseSaga(), editClassSaga.addGroupSaga(), editClassSaga.changeCourseCarryOverSaga(), editClassSaga.handleCountryDropdownChangesSaga(), rollOverSaga.rollOverVerifyContentSaga(), rollOverSaga.downloadTemplateForRolloverSaga(), rollOverSaga.downloadSchoolRollDataRolloverSaga(), rollOverSaga.performRollOverSaga(), rollOverSaga.downloadRolloverSignInCardsSaga(), extendResultSaga.verifyExtendResultSaga(), extendResultSaga.extendResultSaga(), defaultCoursesSaga.getDefaultCoursesSaga(), defaultCoursesSaga.showCourseDetailsSaga(), defaultCoursesSaga.fetchingCourseDetailsSaga(), downloadCertificatesSaga.downloadCertificatesSetupSaga(), downloadCertificatesSaga.downloadCertificatesSaga(), downloadCertificatesSaga.getAcademicYearSaga(), downloadCertificatesSaga.getCertificatesSummarySaga(), downloadCertificatesSaga.setTeacherSaga(), downloadCertificatesSaga.setClassroomSaga(), downloadCertificatesSaga.setGroupSaga(), downloadCertificatesSaga.getClassroomGroupsSaga(), downloadCertificatesSaga.onDatePickerChangeSaga(), defaultCoursesSaga.saveDefaultCoursesSaga(), teacherViewSaga.getTeacherAuthTokenRequestSaga(), assignCoursesSaga.getCountryYearGroupsSaga(), assignCoursesSaga.getYearGroupsSaga(), assignCoursesSaga.getCourseCountrySaga(), assignCoursesSaga.getProductCourseSaga(), assignCoursesSaga.getSchoolCourseSaga(), assignUPFCoursesSaga.getFilteredUPFCourseSaga(), assignUPFCoursesSaga.getUpfCourseCountrySaga(), assignConquestCoursesSaga.getConquestCourseCountrySaga(), assignConquestCoursesSaga.getFilteredConquestCourseSaga(), assignLegacyCoursesSaga.getFilteredLegacyCourseSaga(), assignCourseAdminSaga.getDefaultCoursesSaga(), assignCourseAdminSaga.checkCommonTasksSaga(), assignCourseAdminSaga.assignCoursesSaga()]);

                case 2:
                case 'end':
                    return _context.stop();
            }
        }
    }, _marked, this);
}

exports.default = mainSaga;

/***/ }),
/* 883 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _redux = __webpack_require__(35);

var _reducer = __webpack_require__(859);

var _reducer2 = _interopRequireDefault(_reducer);

var _reducer3 = __webpack_require__(867);

var _reducer4 = _interopRequireDefault(_reducer3);

var _reducer5 = __webpack_require__(870);

var _reducer6 = _interopRequireDefault(_reducer5);

var _reducer7 = __webpack_require__(820);

var _reducer8 = _interopRequireDefault(_reducer7);

var _reducer9 = __webpack_require__(852);

var _reducer10 = _interopRequireDefault(_reducer9);

var _reducer11 = __webpack_require__(833);

var _reducer12 = _interopRequireDefault(_reducer11);

var _reducer13 = __webpack_require__(817);

var _reducer14 = _interopRequireDefault(_reducer13);

var _reducer15 = __webpack_require__(836);

var _reducer16 = _interopRequireDefault(_reducer15);

var _reducer17 = __webpack_require__(829);

var _reducer18 = _interopRequireDefault(_reducer17);

var _reducer19 = __webpack_require__(856);

var _reducer20 = _interopRequireDefault(_reducer19);

var _reducer21 = __webpack_require__(798);

var _reducer22 = _interopRequireDefault(_reducer21);

var _reducer23 = __webpack_require__(839);

var _reducer24 = _interopRequireDefault(_reducer23);

var _reducer25 = __webpack_require__(825);

var _reducer26 = _interopRequireDefault(_reducer25);

var _reducer27 = __webpack_require__(865);

var _reducer28 = _interopRequireDefault(_reducer27);

var _reducer29 = __webpack_require__(822);

var _reducer30 = _interopRequireDefault(_reducer29);

var _reducer31 = __webpack_require__(843);

var _reducer32 = _interopRequireDefault(_reducer31);

var _reducer33 = __webpack_require__(874);

var _reducer34 = _interopRequireDefault(_reducer33);

var _reducer35 = __webpack_require__(813);

var _reducer36 = _interopRequireDefault(_reducer35);

var _reducer37 = __webpack_require__(811);

var _reducer38 = _interopRequireDefault(_reducer37);

var _reducer39 = __webpack_require__(803);

var _reducer40 = _interopRequireDefault(_reducer39);

var _reducer41 = __webpack_require__(807);

var _reducer42 = _interopRequireDefault(_reducer41);

var _reducer43 = __webpack_require__(847);

var _reducer44 = _interopRequireDefault(_reducer43);

var _reducer45 = __webpack_require__(850);

var _reducer46 = _interopRequireDefault(_reducer45);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var reducers = (0, _redux.combineReducers)({
    product: function product(state) {
        return _extends({}, state);
    },
    language: _reducer32.default,
    toast: _reducer22.default,
    schoolRoll: _reducer2.default,
    studentRoll: _reducer4.default,
    teacherRoll: _reducer6.default,
    classRoll: _reducer8.default,
    quickUpload: _reducer10.default,
    editStudent: _reducer12.default,
    assignUser: _reducer14.default,
    editTeacher: _reducer16.default,
    editClass: _reducer18.default,
    rollOver: _reducer20.default,
    extendResult: _reducer24.default,
    defaultCourses: _reducer30.default,
    downloadCertificates: _reducer26.default,
    signInCards: _reducer28.default,
    teacherView: _reducer34.default,
    assignCourses: _reducer36.default,
    assignCourseAdmin: _reducer44.default,
    courseAdmin: _reducer46.default,
    assignUPFCourses: _reducer38.default,
    assignConquestCourses: _reducer40.default,
    assignLegacyCourses: _reducer42.default
});

exports.default = reducers;

/***/ }),
/* 884 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRouterDom = __webpack_require__(244);

var _index = __webpack_require__(858);

var _index2 = _interopRequireDefault(_index);

var _quickUpload = __webpack_require__(851);

var _quickUpload2 = _interopRequireDefault(_quickUpload);

var _index3 = __webpack_require__(815);

var _index4 = _interopRequireDefault(_index3);

var _index5 = __webpack_require__(828);

var _index6 = _interopRequireDefault(_index5);

var _index7 = __webpack_require__(835);

var _index8 = _interopRequireDefault(_index7);

var _index9 = __webpack_require__(832);

var _index10 = _interopRequireDefault(_index9);

var _rollOver = __webpack_require__(854);

var _rollOver2 = _interopRequireDefault(_rollOver);

var _index11 = __webpack_require__(838);

var _index12 = _interopRequireDefault(_index11);

var _index13 = __webpack_require__(824);

var _index14 = _interopRequireDefault(_index13);

var _manageDefaultCourses = __webpack_require__(849);

var _manageDefaultCourses2 = _interopRequireDefault(_manageDefaultCourses);

var _manageAssignedCourses = __webpack_require__(846);

var _manageAssignedCourses2 = _interopRequireDefault(_manageAssignedCourses);

var _index15 = __webpack_require__(863);

var _index16 = _interopRequireDefault(_index15);

var _index17 = __webpack_require__(872);

var _index18 = _interopRequireDefault(_index17);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Routes = function Routes() {
    return _react2.default.createElement(
        _reactRouterDom.Switch,
        null,
        _react2.default.createElement(_reactRouterDom.Route, { component: _manageDefaultCourses2.default, path: '/manage-default-courses' }),
        _react2.default.createElement(_reactRouterDom.Route, { component: _manageAssignedCourses2.default, path: '/manage-assigned-courses' }),
        _react2.default.createElement(_reactRouterDom.Route, {
            component: _index14.default,
            path: '/download-certificates'
        }),
        _react2.default.createElement(_reactRouterDom.Route, { component: _index16.default, path: '/sign-in-cards' }),
        _react2.default.createElement(_reactRouterDom.Route, { component: _index18.default, path: '/teacher-view' }),
        _react2.default.createElement(_reactRouterDom.Route, { component: _index12.default, path: '/extend-result' }),
        _react2.default.createElement(_reactRouterDom.Route, { component: _rollOver2.default, path: '/rollover' }),
        _react2.default.createElement(_reactRouterDom.Route, { component: _quickUpload2.default, path: '/quickUpload' }),
        _react2.default.createElement(_reactRouterDom.Route, { component: _index4.default, path: '/assign-user/:id/:assignType' }),
        _react2.default.createElement(_reactRouterDom.Route, { component: _index6.default, path: '/edit-class/:classroomId' }),
        _react2.default.createElement(_reactRouterDom.Route, { component: _index8.default, path: '/edit-teacher/:id' }),
        _react2.default.createElement(_reactRouterDom.Route, { component: _index10.default, path: '/edit-student/:id' }),
        _react2.default.createElement(_reactRouterDom.Route, { component: _index2.default, path: '/' })
    );
};

exports.default = Routes;

/***/ }),
/* 885 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

exports.default = configureStore;

var _redux = __webpack_require__(35);

var _reduxSaga = __webpack_require__(1644);

var _reduxSaga2 = _interopRequireDefault(_reduxSaga);

var _reducers = __webpack_require__(883);

var _reducers2 = _interopRequireDefault(_reducers);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var sagaMiddleware = (0, _reduxSaga2.default)();

function configureStore() {
    var initialState = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    var env = "production" || 'development';

    // Create the store with middlewares
    var middlewares = [sagaMiddleware];

    if (env === 'development') {
        // middlewares.push(logger);
    }

    var enhancers = [_redux.applyMiddleware.apply(undefined, middlewares)];

    // If Redux DevTools Extension is installed use it, otherwise use Redux compose
    /* eslint-disable no-underscore-dangle */
    var composeEnhancers =  false ? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ : _redux.compose;
    /* eslint-enable */

    var store = (0, _redux.createStore)(_reducers2.default, initialState, composeEnhancers.apply(undefined, enhancers));

    // Extensions
    store.runSaga = sagaMiddleware.run;

    return store;
}

/***/ }),
/* 886 */,
/* 887 */,
/* 888 */,
/* 889 */,
/* 890 */,
/* 891 */,
/* 892 */,
/* 893 */,
/* 894 */,
/* 895 */,
/* 896 */,
/* 897 */,
/* 898 */,
/* 899 */,
/* 900 */,
/* 901 */,
/* 902 */,
/* 903 */,
/* 904 */,
/* 905 */,
/* 906 */,
/* 907 */,
/* 908 */,
/* 909 */,
/* 910 */,
/* 911 */,
/* 912 */,
/* 913 */,
/* 914 */,
/* 915 */,
/* 916 */,
/* 917 */,
/* 918 */,
/* 919 */,
/* 920 */,
/* 921 */,
/* 922 */,
/* 923 */,
/* 924 */,
/* 925 */,
/* 926 */,
/* 927 */,
/* 928 */,
/* 929 */,
/* 930 */,
/* 931 */,
/* 932 */,
/* 933 */,
/* 934 */,
/* 935 */,
/* 936 */,
/* 937 */,
/* 938 */,
/* 939 */,
/* 940 */,
/* 941 */,
/* 942 */,
/* 943 */,
/* 944 */,
/* 945 */,
/* 946 */,
/* 947 */,
/* 948 */,
/* 949 */,
/* 950 */,
/* 951 */,
/* 952 */,
/* 953 */,
/* 954 */,
/* 955 */,
/* 956 */,
/* 957 */,
/* 958 */,
/* 959 */,
/* 960 */,
/* 961 */,
/* 962 */,
/* 963 */,
/* 964 */,
/* 965 */,
/* 966 */,
/* 967 */,
/* 968 */,
/* 969 */,
/* 970 */,
/* 971 */,
/* 972 */,
/* 973 */,
/* 974 */,
/* 975 */,
/* 976 */,
/* 977 */,
/* 978 */,
/* 979 */,
/* 980 */,
/* 981 */,
/* 982 */,
/* 983 */,
/* 984 */,
/* 985 */,
/* 986 */,
/* 987 */,
/* 988 */,
/* 989 */,
/* 990 */,
/* 991 */,
/* 992 */,
/* 993 */,
/* 994 */,
/* 995 */,
/* 996 */,
/* 997 */,
/* 998 */,
/* 999 */,
/* 1000 */,
/* 1001 */,
/* 1002 */,
/* 1003 */,
/* 1004 */,
/* 1005 */,
/* 1006 */,
/* 1007 */,
/* 1008 */,
/* 1009 */,
/* 1010 */,
/* 1011 */,
/* 1012 */,
/* 1013 */,
/* 1014 */,
/* 1015 */,
/* 1016 */,
/* 1017 */,
/* 1018 */,
/* 1019 */,
/* 1020 */,
/* 1021 */,
/* 1022 */,
/* 1023 */,
/* 1024 */,
/* 1025 */,
/* 1026 */,
/* 1027 */,
/* 1028 */,
/* 1029 */,
/* 1030 */,
/* 1031 */,
/* 1032 */,
/* 1033 */,
/* 1034 */,
/* 1035 */,
/* 1036 */,
/* 1037 */,
/* 1038 */,
/* 1039 */,
/* 1040 */,
/* 1041 */,
/* 1042 */,
/* 1043 */,
/* 1044 */,
/* 1045 */,
/* 1046 */,
/* 1047 */,
/* 1048 */,
/* 1049 */,
/* 1050 */,
/* 1051 */,
/* 1052 */,
/* 1053 */,
/* 1054 */,
/* 1055 */,
/* 1056 */,
/* 1057 */,
/* 1058 */,
/* 1059 */,
/* 1060 */,
/* 1061 */,
/* 1062 */,
/* 1063 */,
/* 1064 */,
/* 1065 */,
/* 1066 */,
/* 1067 */,
/* 1068 */,
/* 1069 */,
/* 1070 */,
/* 1071 */,
/* 1072 */,
/* 1073 */,
/* 1074 */,
/* 1075 */,
/* 1076 */,
/* 1077 */,
/* 1078 */,
/* 1079 */,
/* 1080 */,
/* 1081 */,
/* 1082 */,
/* 1083 */,
/* 1084 */,
/* 1085 */,
/* 1086 */,
/* 1087 */,
/* 1088 */,
/* 1089 */,
/* 1090 */,
/* 1091 */,
/* 1092 */,
/* 1093 */,
/* 1094 */,
/* 1095 */,
/* 1096 */,
/* 1097 */,
/* 1098 */,
/* 1099 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(4)();
// imports


// module
exports.push([module.i, ".dropDownContainer---60XGN {\n  position: relative;\n  display: table;\n  width: 100%;\n  border-radius: 2px;\n  background: #fff; }\n  .dropDownContainer---60XGN select:disabled,\n  .dropDownContainer---60XGN select[disabled], .dropDownContainer---60XGN.disabled---1ITC6 {\n    opacity: 0.5; }\n  .dropDownContainer---60XGN.large---3k8qZ select {\n    font-size: 23px;\n    color: #4e5c67; }\n  .dropDownContainer---60XGN.large---3k8qZ::after {\n    margin-top: -6px; }\n  .dropDownContainer---60XGN select {\n    line-height: 1.3;\n    width: 100%;\n    height: 50px;\n    margin: 0;\n    border: 2px solid #c2cfda;\n    border-radius: 10px;\n    outline: none;\n    padding: 0.55em 0.8em 0.45em;\n    -webkit-box-sizing: border-box;\n    box-sizing: border-box;\n    font-size: 16px;\n    font-weight: 500; }\n  .dropDownContainer---60XGN select:focus {\n      outline: none; }\n  .dropDownContainer---60XGN::after {\n    width: 0;\n    height: 0;\n    border-left: 8px solid transparent;\n    border-right: 8px solid transparent;\n    border-top: 10px solid #666;\n    margin-top: -1px;\n    content: \" \";\n    position: absolute;\n    top: 50%;\n    right: 1em;\n    z-index: 2;\n    pointer-events: none;\n    display: none; }\n  .dropDownContainer---60XGN::after {\n  display: block; }\n  .dropDownContainer---60XGN select {\n  padding-right: 3em;\n  background: none;\n  border: 2px solid #c2cfda;\n  -webkit-appearance: none;\n  -moz-appearance: none;\n  appearance: none; }\n  @media screen and (-ms-high-contrast: active), (-ms-high-contrast: none) {\n  .dropDownContainer---60XGN select::-ms-expand {\n    display: none; }\n  .dropDownContainer---60XGN select:focus {\n    border-color: #e7e9ea; }\n  .dropDownContainer---60XGN select:focus::-ms-value {\n    background: transparent;\n    color: #222; }\n  .dropDownContainer---60XGN select {\n    padding-right: 2em;\n    background: none;\n    border: 1px solid #e7e9ea; }\n  .dropDownContainer---60XGN::after {\n    display: block; } }\n", ""]);

// exports
exports.locals = {
	"dropDownContainer": "dropDownContainer---60XGN",
	"disabled": "disabled---1ITC6",
	"large": "large---3k8qZ"
};

/***/ }),
/* 1100 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(4)();
// imports


// module
exports.push([module.i, ".react-grid-HeaderCell:nth-child(n+6):nth-child(-n+8) {\n  color: #1c7fc3; }\n\n.react-grid-HeaderCell:nth-child(8) {\n  min-width: 40px; }\n\n.react-grid-Cell:nth-child(8) {\n  min-width: 40px; }\n\n.addClassComponent---10-oJ {\n  display: -webkit-box;\n  display: -moz-flex;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: center;\n  -ms-flex-pack: center;\n  -moz-justify-content: center;\n  justify-content: center;\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n  -moz-align-items: center;\n  align-items: center;\n  -webkit-box-direction: normal;\n  -webkit-box-orient: vertical;\n  -moz-flex-direction: column;\n  -ms-flex-direction: column;\n  flex-direction: column;\n  padding: 75px 0;\n  outline: none;\n  position: relative;\n  padding: 25px 0; }\n\n.header---1vXNl {\n  width: 90%;\n  min-height: 22px;\n  margin: 33px;\n  color: #4e5c67;\n  font-family: Poppins;\n  font-size: 28px;\n  font-weight: 500;\n  line-height: 1.2em;\n  text-align: center; }\n\n.header---1vXNl span {\n    color: #32a8a7; }\n\n.description---grovi {\n  margin-bottom: 20px;\n  font-size: 18px;\n  color: #4e5c67;\n  line-height: 1.3em; }\n\n.icon---Lzxbh {\n  width: 80px;\n  height: 75px; }\n\n.addClassHeader---3i1_N {\n  display: -webkit-box;\n  display: -moz-flex;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: center;\n  -ms-flex-pack: center;\n  -moz-justify-content: center;\n  justify-content: center;\n  padding: 30px;\n  color: #8b8b8b;\n  font-family: Poppins;\n  font-size: 28px;\n  font-weight: 500;\n  line-height: 27px; }\n\n.label---tJ7LM {\n  color: #8b8b8b; }\n\n.topSpacing---FRWdm, .className---1ws5J, .list---1gkUM, .yearRow---kCq25, .year---3HQuV,\n.country---1zCo_, .actionButtonWrapper---3e1gZ {\n  padding-top: 10px; }\n\n.className---1ws5J ::-webkit-input-placeholder {\n  color: lightgray; }\n\n.className---1ws5J ::-moz-placeholder {\n  color: lightgray; }\n\n.className---1ws5J :-moz-placeholder {\n  color: lightgray; }\n\n.className---1ws5J :-ms-input-placeholder {\n  color: lightgray; }\n\n.list---1gkUM, .yearRow---kCq25 {\n  min-width: 484px; }\n\n.year---3HQuV,\n.country---1zCo_ {\n  width: 230px;\n  display: -webkit-box;\n  display: -moz-flex;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-direction: normal;\n  -webkit-box-orient: vertical;\n  -moz-flex-direction: column;\n  -ms-flex-direction: column;\n  flex-direction: column; }\n\n.yearRow---kCq25 {\n  display: -webkit-box;\n  display: -moz-flex;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: justify;\n  -ms-flex-pack: justify;\n  -moz-justify-content: space-between;\n  justify-content: space-between; }\n\n.actionButtonWrapper---3e1gZ {\n  display: -webkit-box;\n  display: -moz-flex;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: justify;\n  -ms-flex-pack: justify;\n  -moz-justify-content: space-between;\n  justify-content: space-between; }\n\n.courseWrapper---2Eqjo {\n  border: 2px solid #cfd2d4;\n  border-radius: 10px;\n  min-width: 484px;\n  padding: 10px;\n  margin-top: 10px; }\n\n.cancelButton---2ricf, .addButton---Xca9F, .addButtonDisabled---NwxSc {\n  display: -webkit-box;\n  display: -moz-flex;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: center;\n  -ms-flex-pack: center;\n  -moz-justify-content: center;\n  justify-content: center;\n  border-radius: 25px;\n  width: 150px;\n  height: 40px;\n  background-color: #c53902;\n  color: white; }\n\n.addButton---Xca9F {\n  background-color: #249d46; }\n\n.addButtonDisabled---NwxSc {\n  background-color: #cfd2d4;\n  color: black; }\n\n.customCoursesWrapper---taMHI, .curriculumCoursesWrapper---1cMKJ {\n  display: -webkit-box;\n  display: -moz-flex;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: center;\n  -ms-flex-pack: center;\n  -moz-justify-content: center;\n  justify-content: center;\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n  -moz-align-items: center;\n  align-items: center;\n  width: 225px;\n  margin: 7px 0; }\n\n.customCoursesWrapper---taMHI label, .curriculumCoursesWrapper---1cMKJ label {\n    cursor: pointer;\n    color: #8b8b8b;\n    margin-bottom: 0; }\n\n.curriculumCoursesWrapper---1cMKJ {\n  width: 210px;\n  margin-left: 15px; }\n\n.courseSelectorWrapper---zlbtN {\n  display: -webkit-box;\n  display: -moz-flex;\n  display: -ms-flexbox;\n  display: flex; }\n\n.required---19GDP {\n  display: -webkit-box;\n  display: -moz-flex;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: end;\n  -ms-flex-pack: end;\n  -moz-justify-content: flex-end;\n  justify-content: flex-end;\n  margin-top: 5px; }\n\n.addClassForm---2z7zg {\n  width: 485px;\n  max-width: 485px; }\n", ""]);

// exports
exports.locals = {
	"addClassComponent": "addClassComponent---10-oJ",
	"header": "header---1vXNl",
	"description": "description---grovi",
	"icon": "icon---Lzxbh",
	"addClassHeader": "addClassHeader---3i1_N",
	"label": "label---tJ7LM",
	"topSpacing": "topSpacing---FRWdm",
	"className": "className---1ws5J",
	"list": "list---1gkUM",
	"yearRow": "yearRow---kCq25",
	"year": "year---3HQuV",
	"country": "country---1zCo_",
	"actionButtonWrapper": "actionButtonWrapper---3e1gZ",
	"courseWrapper": "courseWrapper---2Eqjo",
	"cancelButton": "cancelButton---2ricf",
	"addButton": "addButton---Xca9F",
	"addButtonDisabled": "addButtonDisabled---NwxSc",
	"customCoursesWrapper": "customCoursesWrapper---taMHI",
	"curriculumCoursesWrapper": "curriculumCoursesWrapper---1cMKJ",
	"courseSelectorWrapper": "courseSelectorWrapper---zlbtN",
	"required": "required---19GDP",
	"addClassForm": "addClassForm---2z7zg"
};

/***/ }),
/* 1101 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(4)();
// imports


// module
exports.push([module.i, ".addGroupComponent---3xscT {\n  display: -webkit-box;\n  display: -moz-flex;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: center;\n  -ms-flex-pack: center;\n  -moz-justify-content: center;\n  justify-content: center;\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n  -moz-align-items: center;\n  align-items: center;\n  -webkit-box-direction: normal;\n  -webkit-box-orient: vertical;\n  -moz-flex-direction: column;\n  -ms-flex-direction: column;\n  flex-direction: column;\n  padding: 75px 0;\n  outline: none;\n  position: relative; }\n\n.header---3zSvZ {\n  width: 90%;\n  min-height: 22px;\n  margin: 33px;\n  color: #4e5c67;\n  font-family: Poppins;\n  font-size: 28px;\n  font-weight: 500;\n  line-height: 1.2em;\n  text-align: center; }\n\n.header---3zSvZ span {\n    color: #32a8a7; }\n\n.description---jrDP2 {\n  margin-bottom: 20px;\n  font-size: 18px;\n  color: #4e5c67;\n  line-height: 1.3em; }\n\n.icon---33Ppt {\n  width: 80px;\n  height: 75px; }\n\n.buttons---1fzR1 {\n  display: -webkit-box;\n  display: -moz-flex;\n  display: -ms-flexbox;\n  display: flex;\n  padding-top: 20px; }\n\n.cancelBtn---1F9e6,\n.submitBtn---rgVI9 {\n  margin: 5px; }\n\n.buttonClose---6KSqM {\n  position: absolute;\n  right: 10%;\n  top: 0; }\n", ""]);

// exports
exports.locals = {
	"addGroupComponent": "addGroupComponent---3xscT",
	"header": "header---3zSvZ",
	"description": "description---jrDP2",
	"icon": "icon---33Ppt",
	"buttons": "buttons---1fzR1",
	"cancelBtn": "cancelBtn---1F9e6",
	"submitBtn": "submitBtn---rgVI9",
	"buttonClose": "buttonClose---6KSqM"
};

/***/ }),
/* 1102 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(4)();
// imports


// module
exports.push([module.i, ".dropDownContainer---1sggT {\n  position: relative;\n  display: table;\n  width: 100%;\n  border-radius: 2px;\n  background: #fff; }\n  .dropDownContainer---1sggT select:disabled,\n  .dropDownContainer---1sggT select[disabled], .dropDownContainer---1sggT.disabled---3eqLb {\n    opacity: 0.5; }\n  .dropDownContainer---1sggT.large---1rhUa select {\n    font-size: 23px;\n    color: #4e5c67; }\n  .dropDownContainer---1sggT.large---1rhUa::after {\n    margin-top: -6px; }\n  .dropDownContainer---1sggT select {\n    line-height: 1.3;\n    width: 100%;\n    height: 50px;\n    margin: 0;\n    border: 2px solid #c2cfda;\n    border-radius: 10px;\n    outline: none;\n    padding: 0.55em 0.8em 0.45em;\n    -webkit-box-sizing: border-box;\n    box-sizing: border-box;\n    font-size: 16px;\n    font-weight: 500; }\n  .dropDownContainer---1sggT select:focus {\n      outline: none; }\n  .dropDownContainer---1sggT::after {\n    width: 0;\n    height: 0;\n    border-left: 8px solid transparent;\n    border-right: 8px solid transparent;\n    border-top: 10px solid #666;\n    margin-top: -1px;\n    content: \" \";\n    position: absolute;\n    top: 50%;\n    right: 1em;\n    z-index: 2;\n    pointer-events: none;\n    display: none; }\n  .dropDownContainer---1sggT::after {\n  display: block; }\n  .dropDownContainer---1sggT select {\n  padding-right: 3em;\n  background: none;\n  border: 2px solid #c2cfda;\n  -webkit-appearance: none;\n  -moz-appearance: none;\n  appearance: none; }\n  @media screen and (-ms-high-contrast: active), (-ms-high-contrast: none) {\n  .dropDownContainer---1sggT select::-ms-expand {\n    display: none; }\n  .dropDownContainer---1sggT select:focus {\n    border-color: #e7e9ea; }\n  .dropDownContainer---1sggT select:focus::-ms-value {\n    background: transparent;\n    color: #222; }\n  .dropDownContainer---1sggT select {\n    padding-right: 2em;\n    background: none;\n    border: 1px solid #e7e9ea; }\n  .dropDownContainer---1sggT::after {\n    display: block; } }\n", ""]);

// exports
exports.locals = {
	"dropDownContainer": "dropDownContainer---1sggT",
	"disabled": "disabled---3eqLb",
	"large": "large---1rhUa"
};

/***/ }),
/* 1103 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(4)();
// imports


// module
exports.push([module.i, ".react-grid-HeaderCell:nth-child(n+6):nth-child(-n+8) {\n  color: #1c7fc3; }\n\n.react-grid-HeaderCell:nth-child(8) {\n  min-width: 40px; }\n\n.react-grid-Cell:nth-child(8) {\n  min-width: 40px; }\n\n.addStudentComponent---2t79p {\n  display: -webkit-box;\n  display: -moz-flex;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-direction: normal;\n  -webkit-box-orient: vertical;\n  -moz-flex-direction: column;\n  -ms-flex-direction: column;\n  flex-direction: column;\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n  -moz-align-items: center;\n  align-items: center; }\n\n.addStudentHeader---HqPhc {\n  padding: 30px;\n  color: #4e5c67;\n  font-family: Poppins;\n  font-size: 28px;\n  font-weight: 500;\n  line-height: 27px; }\n\n.topSpacing---1WM6b, .firstName---3SP7M,\n.surName---1ff3Y, .list---zL9-d, .actionButtonWrapper---2OURW {\n  padding-top: 10px; }\n\n.firstName---3SP7M ::-webkit-input-placeholder,\n.surName---1ff3Y ::-webkit-input-placeholder {\n  color: lightgray; }\n\n.firstName---3SP7M ::-moz-placeholder,\n.surName---1ff3Y ::-moz-placeholder {\n  color: lightgray; }\n\n.firstName---3SP7M :-moz-placeholder,\n.surName---1ff3Y :-moz-placeholder {\n  color: lightgray; }\n\n.firstName---3SP7M :-ms-input-placeholder,\n.surName---1ff3Y :-ms-input-placeholder {\n  color: lightgray; }\n\n.list---zL9-d {\n  min-width: 484px; }\n\n.actionButtonWrapper---2OURW {\n  display: -webkit-box;\n  display: -moz-flex;\n  display: -ms-flexbox;\n  display: flex; }\n\n.actionButton---1C6OP, .btnSuccess---1Mnm_,\n.btnDanger---1bYEp {\n  margin: 0 5px; }\n", ""]);

// exports
exports.locals = {
	"addStudentComponent": "addStudentComponent---2t79p",
	"addStudentHeader": "addStudentHeader---HqPhc",
	"topSpacing": "topSpacing---1WM6b",
	"firstName": "firstName---3SP7M",
	"surName": "surName---1ff3Y",
	"list": "list---zL9-d",
	"actionButtonWrapper": "actionButtonWrapper---2OURW",
	"actionButton": "actionButton---1C6OP",
	"btnSuccess": "btnSuccess---1Mnm_",
	"btnDanger": "btnDanger---1bYEp"
};

/***/ }),
/* 1104 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(4)();
// imports


// module
exports.push([module.i, ".dropDownContainer---2041H {\n  position: relative;\n  display: table;\n  width: 100%;\n  border-radius: 2px;\n  background: #fff; }\n  .dropDownContainer---2041H select:disabled,\n  .dropDownContainer---2041H select[disabled], .dropDownContainer---2041H.disabled---1R7uX {\n    opacity: 0.5; }\n  .dropDownContainer---2041H.large---2r1M4 select {\n    font-size: 23px;\n    color: #4e5c67; }\n  .dropDownContainer---2041H.large---2r1M4::after {\n    margin-top: -6px; }\n  .dropDownContainer---2041H select {\n    line-height: 1.3;\n    width: 100%;\n    height: 50px;\n    margin: 0;\n    border: 2px solid #c2cfda;\n    border-radius: 10px;\n    outline: none;\n    padding: 0.55em 0.8em 0.45em;\n    -webkit-box-sizing: border-box;\n    box-sizing: border-box;\n    font-size: 16px;\n    font-weight: 500; }\n  .dropDownContainer---2041H select:focus {\n      outline: none; }\n  .dropDownContainer---2041H::after {\n    width: 0;\n    height: 0;\n    border-left: 8px solid transparent;\n    border-right: 8px solid transparent;\n    border-top: 10px solid #666;\n    margin-top: -1px;\n    content: \" \";\n    position: absolute;\n    top: 50%;\n    right: 1em;\n    pointer-events: none;\n    display: none; }\n  .dropDownContainer---2041H::after {\n  display: block; }\n  .dropDownContainer---2041H select {\n  padding-right: 3em;\n  background: none;\n  border: 2px solid #c2cfda;\n  -webkit-appearance: none;\n  -moz-appearance: none;\n  appearance: none; }\n  @media screen and (-ms-high-contrast: active), (-ms-high-contrast: none) {\n  .dropDownContainer---2041H select::-ms-expand {\n    display: none; }\n  .dropDownContainer---2041H select:focus {\n    border-color: #e7e9ea; }\n  .dropDownContainer---2041H select:focus::-ms-value {\n    background: transparent;\n    color: #222; }\n  .dropDownContainer---2041H select {\n    padding-right: 2em;\n    background: none;\n    border: 1px solid #e7e9ea; }\n  .dropDownContainer---2041H::after {\n    display: block; } }\n", ""]);

// exports
exports.locals = {
	"dropDownContainer": "dropDownContainer---2041H",
	"disabled": "disabled---1R7uX",
	"large": "large---2r1M4"
};

/***/ }),
/* 1105 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(4)();
// imports


// module
exports.push([module.i, ".react-grid-HeaderCell:nth-child(n+6):nth-child(-n+8) {\n  color: #1c7fc3; }\n\n.react-grid-HeaderCell:nth-child(8) {\n  min-width: 40px; }\n\n.react-grid-Cell:nth-child(8) {\n  min-width: 40px; }\n\n.addTeacherComponent---238De {\n  display: -webkit-box;\n  display: -moz-flex;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-direction: normal;\n  -webkit-box-orient: vertical;\n  -moz-flex-direction: column;\n  -ms-flex-direction: column;\n  flex-direction: column;\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n  -moz-align-items: center;\n  align-items: center; }\n\n.addTeacherHeader---3zH1J {\n  padding: 30px;\n  color: #4e5c67;\n  font-family: Poppins;\n  font-size: 28px;\n  font-weight: 500;\n  line-height: 27px; }\n\n.topSpacing---dA5Wd, .firstName---YdCZi, .surName---yeJQi, .emailAddress---3zPFu, .list---1Vb5m, .actionButtonWrapper---1d7Ff {\n  padding-top: 10px; }\n\n.firstName---YdCZi ::-webkit-input-placeholder {\n  color: lightgray; }\n\n.firstName---YdCZi ::-moz-placeholder {\n  color: lightgray; }\n\n.firstName---YdCZi :-moz-placeholder {\n  color: lightgray; }\n\n.firstName---YdCZi :-ms-input-placeholder {\n  color: lightgray; }\n\n.surName---yeJQi ::-webkit-input-placeholder {\n  color: lightgray; }\n\n.surName---yeJQi ::-moz-placeholder {\n  color: lightgray; }\n\n.surName---yeJQi :-moz-placeholder {\n  color: lightgray; }\n\n.surName---yeJQi :-ms-input-placeholder {\n  color: lightgray; }\n\n.emailAddress---3zPFu ::-webkit-input-placeholder {\n  color: lightgray; }\n\n.emailAddress---3zPFu ::-moz-placeholder {\n  color: lightgray; }\n\n.emailAddress---3zPFu :-moz-placeholder {\n  color: lightgray; }\n\n.emailAddress---3zPFu :-ms-input-placeholder {\n  color: lightgray; }\n\n.list---1Vb5m {\n  min-width: 484px; }\n\n.actionButtonWrapper---1d7Ff {\n  display: -webkit-box;\n  display: -moz-flex;\n  display: -ms-flexbox;\n  display: flex; }\n\n.actionButton---1bUvj, .btnSuccess---30Jcp,\n.btnDanger---1abL0 {\n  margin: 0 5px; }\n", ""]);

// exports
exports.locals = {
	"addTeacherComponent": "addTeacherComponent---238De",
	"addTeacherHeader": "addTeacherHeader---3zH1J",
	"topSpacing": "topSpacing---dA5Wd",
	"firstName": "firstName---YdCZi",
	"surName": "surName---yeJQi",
	"emailAddress": "emailAddress---3zPFu",
	"list": "list---1Vb5m",
	"actionButtonWrapper": "actionButtonWrapper---1d7Ff",
	"actionButton": "actionButton---1bUvj",
	"btnSuccess": "btnSuccess---30Jcp",
	"btnDanger": "btnDanger---1abL0"
};

/***/ }),
/* 1106 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(4)();
// imports


// module
exports.push([module.i, ".react-grid-HeaderCell:nth-child(n+6):nth-child(-n+8) {\n  color: #1c7fc3; }\n\n.react-grid-HeaderCell:nth-child(8) {\n  min-width: 40px; }\n\n.react-grid-Cell:nth-child(8) {\n  min-width: 40px; }\n\n.assignCourse---3d9UJ {\n  -webkit-box-flex: 1;\n  -moz-flex: 1;\n  -ms-flex: 1;\n  flex: 1;\n  -webkit-box-direction: normal;\n  -webkit-box-orient: vertical;\n  -moz-flex-direction: column;\n  -ms-flex-direction: column;\n  flex-direction: column;\n  -webkit-box-pack: justify;\n  -ms-flex-pack: justify;\n  -moz-justify-content: space-between;\n  justify-content: space-between;\n  padding: 10px;\n  border-radius: 15px;\n  background-color: #e7e9ea;\n  height: 100%; }\n\n.assignCourse---3d9UJ ::-webkit-scrollbar {\n    width: 14px; }\n\n.assignCourse---3d9UJ ::-webkit-scrollbar-track {\n    background: #cfd2d4;\n    border-radius: 7px; }\n\n.assignCourse---3d9UJ ::-webkit-scrollbar-thumb {\n    background: #415667;\n    border-radius: 7px; }\n\n.assignCourse---3d9UJ ::-webkit-scrollbar-thumb:hover {\n    background: #4e5c67; }\n\n.assignCourse---3d9UJ ::-ms-clear {\n    display: none; }\n\n.heading---3KrBr, .subHeading---1rnnL {\n  color: #444;\n  font-size: 16px;\n  font-family: Poppins; }\n\n.subHeading---1rnnL {\n  font-size: 14px; }\n\n.defaultCourse---3OuDY {\n  display: -webkit-box;\n  display: -moz-flex;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: justify;\n  -ms-flex-pack: justify;\n  -moz-justify-content: space-between;\n  justify-content: space-between;\n  -webkit-box-direction: normal;\n  -webkit-box-orient: vertical;\n  -moz-flex-direction: column;\n  -ms-flex-direction: column;\n  flex-direction: column;\n  height: 200px; }\n\n.selectCourseContainer---2xBFK {\n  display: -webkit-box;\n  display: -moz-flex;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-direction: normal;\n  -webkit-box-orient: vertical;\n  -moz-flex-direction: column;\n  -ms-flex-direction: column;\n  flex-direction: column;\n  margin-top: 25px;\n  height: calc(50vh - 60px); }\n\n.courseHeader---3K6-n {\n  color: #415667;\n  font-family: Poppins;\n  font-size: 13px; }\n\n.selectCourse---3G-za {\n  overflow-y: scroll;\n  height: 100%; }\n\n.course---2Q1pQ, .courseSelected---2Kwk3 {\n  min-height: 44px;\n  width: 85%;\n  border: 1px solid #cfd2d4;\n  background-color: #fff;\n  border-radius: 10px;\n  -webkit-box-shadow: 3px 3px #bcbcbc;\n          box-shadow: 3px 3px #bcbcbc;\n  padding-top: 4px;\n  padding-left: 10px;\n  text-align: left;\n  margin-bottom: 10px;\n  outline: none; }\n\n.courseSelected---2Kwk3 {\n  background-color: #1981c4;\n  -webkit-box-shadow: inset -1px 1px 5px rgba(25, 25, 25, .44);\n          box-shadow: inset -1px 1px 5px rgba(25, 25, 25, .44);\n  color: white; }\n\n.empty---23MMk {\n  transform: scale(0.7, 0.7);\n  -ms-transform: scale(0.7, 0.7);\n  /* IE 9 */\n  -webkit-transform: scale(0.7, 0.7);\n  /* Safari and Chrome */\n  -o-transform: scale(0.7, 0.7);\n  /* Opera */\n  -moz-transform: scale(0.7, 0.7);\n  /* Firefox */ }\n\n.emptyContainer---1b2fS {\n  display: -webkit-box;\n  display: -moz-flex;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-flex: 1;\n  -moz-flex: 1;\n  -ms-flex: 1;\n  flex: 1;\n  -webkit-box-direction: normal;\n  -webkit-box-orient: vertical;\n  -moz-flex-direction: column;\n  -ms-flex-direction: column;\n  flex-direction: column;\n  -webkit-box-pack: center;\n  -ms-flex-pack: center;\n  -moz-justify-content: center;\n  justify-content: center;\n  width: 100%;\n  padding: 10px;\n  border-radius: 6px; }\n\n.emptyNotice---GwvjV {\n  display: -webkit-box;\n  display: -moz-flex;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-direction: normal;\n  -webkit-box-orient: vertical;\n  -moz-flex-direction: column;\n  -ms-flex-direction: column;\n  flex-direction: column;\n  -webkit-box-pack: center;\n  -ms-flex-pack: center;\n  -moz-justify-content: center;\n  justify-content: center; }\n\n.courseRow---wx3gi {\n  display: -webkit-box;\n  display: -moz-flex;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n  -moz-align-items: center;\n  align-items: center; }\n\n.loader---1dsvf {\n  display: -webkit-box;\n  display: -moz-flex;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n  -moz-align-items: center;\n  align-items: center;\n  -webkit-box-pack: center;\n  -ms-flex-pack: center;\n  -moz-justify-content: center;\n  justify-content: center;\n  position: relative;\n  top: 0;\n  bottom: 0;\n  left: 0;\n  right: 0;\n  height: 100%; }\n\n.search---IuSpl {\n  height: 38px;\n  width: 94%;\n  padding-left: 13px;\n  border: none;\n  color: #8b8b8b;\n  font-size: 16px;\n  font-family: Poppins;\n  outline: none; }\n\n.clear---nbLfs {\n  position: relative;\n  float: right;\n  width: 6%;\n  padding-left: 5px;\n  padding-top: 7px;\n  border: none;\n  background: white;\n  font-size: 18px;\n  cursor: pointer;\n  outline: none; }\n\n.searchContainer---21iF0 {\n  min-height: 38px;\n  background: white; }\n\n.footer---2y_cG, .footerLegacy---2ryWA {\n  display: -webkit-box;\n  display: -moz-flex;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: space-evenly;\n  -ms-flex-pack: space-evenly;\n  -moz-justify-content: space-evenly;\n  justify-content: space-evenly; }\n\n.footerLegacy---2ryWA {\n  -webkit-box-pack: end;\n  -ms-flex-pack: end;\n  -moz-justify-content: flex-end;\n  justify-content: flex-end;\n  margin-right: 20px !important; }\n\n.assignToYear---21zJy, .optOut---1lzvj {\n  width: 150px;\n  height: 40px;\n  border-radius: 20px;\n  margin: 10px;\n  padding-top: 10px;\n  color: #fff;\n  background-color: #415667;\n  font-family: Poppins;\n  font-size: 15px;\n  line-height: 20px; }\n\n.optOut---1lzvj {\n  width: 160px;\n  background-color: #c53902; }\n\n@media screen and (max-width: 1400px) {\n  .empty---23MMk {\n    display: -webkit-inline-box;\n    display: -moz-inline-flex;\n    display: -ms-inline-flexbox;\n    display: inline-flex; }\n  .selectCourse---3G-za {\n    overflow-x: hidden; }\n  .clear---nbLfs {\n    width: 10%; }\n  .search---IuSpl {\n    width: 90%; } }\n\n@media screen and (max-height: 900px) {\n  .selectCourseContainer---2xBFK {\n    margin-top: 12px; } }\n\n@media screen and (max-height: 800px) {\n  .selectCourseContainer---2xBFK {\n    margin-top: 10px;\n    height: 55%; } }\n\n@media screen and (max-height: 600px) {\n  .selectCourseContainer---2xBFK {\n    margin-top: 12px;\n    height: 45%; } }\n", ""]);

// exports
exports.locals = {
	"assignCourse": "assignCourse---3d9UJ",
	"heading": "heading---3KrBr",
	"subHeading": "subHeading---1rnnL",
	"defaultCourse": "defaultCourse---3OuDY",
	"selectCourseContainer": "selectCourseContainer---2xBFK",
	"courseHeader": "courseHeader---3K6-n",
	"selectCourse": "selectCourse---3G-za",
	"course": "course---2Q1pQ",
	"courseSelected": "courseSelected---2Kwk3",
	"empty": "empty---23MMk",
	"emptyContainer": "emptyContainer---1b2fS",
	"emptyNotice": "emptyNotice---GwvjV",
	"courseRow": "courseRow---wx3gi",
	"loader": "loader---1dsvf",
	"search": "search---IuSpl",
	"clear": "clear---nbLfs",
	"searchContainer": "searchContainer---21iF0",
	"footer": "footer---2y_cG",
	"footerLegacy": "footerLegacy---2ryWA",
	"assignToYear": "assignToYear---21zJy",
	"optOut": "optOut---1lzvj"
};

/***/ }),
/* 1107 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(4)();
// imports


// module
exports.push([module.i, ".inputTextComponent---YK-mY {\n  position: relative; }\n\n.inputText---Dt8ml {\n  height: 38px;\n  width: 100%;\n  padding-left: 13px;\n  padding-right: 30px;\n  border: none;\n  color: #8b8b8b;\n  font-size: 16px;\n  font-family: Poppins;\n  outline: none; }\n", ""]);

// exports
exports.locals = {
	"inputTextComponent": "inputTextComponent---YK-mY",
	"inputText": "inputText---Dt8ml"
};

/***/ }),
/* 1108 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(4)();
// imports


// module
exports.push([module.i, ".react-grid-HeaderCell:nth-child(n+6):nth-child(-n+8) {\n  color: #1c7fc3; }\n\n.react-grid-HeaderCell:nth-child(8) {\n  min-width: 40px; }\n\n.react-grid-Cell:nth-child(8) {\n  min-width: 40px; }\n\n.assignCourse---2BPoo {\n  -webkit-box-flex: 1;\n  -moz-flex: 1;\n  -ms-flex: 1;\n  flex: 1;\n  -webkit-box-direction: normal;\n  -webkit-box-orient: vertical;\n  -moz-flex-direction: column;\n  -ms-flex-direction: column;\n  flex-direction: column;\n  -webkit-box-pack: justify;\n  -ms-flex-pack: justify;\n  -moz-justify-content: space-between;\n  justify-content: space-between;\n  padding: 10px;\n  border-radius: 15px;\n  background-color: #e7e9ea;\n  height: 100%; }\n\n.assignCourse---2BPoo ::-webkit-scrollbar {\n    width: 14px; }\n\n.assignCourse---2BPoo ::-webkit-scrollbar-track {\n    background: #cfd2d4;\n    border-radius: 7px; }\n\n.assignCourse---2BPoo ::-webkit-scrollbar-thumb {\n    background: #415667;\n    border-radius: 7px; }\n\n.assignCourse---2BPoo ::-webkit-scrollbar-thumb:hover {\n    background: #4e5c67; }\n\n.assignCourse---2BPoo ::-ms-clear {\n    display: none; }\n\n.heading---G-PnN, .subHeading---1cJFE {\n  color: #444;\n  font-size: 16px;\n  font-family: Poppins; }\n\n.subHeading---1cJFE {\n  font-size: 14px; }\n\n.defaultCourse---2Njyu {\n  display: -webkit-box;\n  display: -moz-flex;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: justify;\n  -ms-flex-pack: justify;\n  -moz-justify-content: space-between;\n  justify-content: space-between;\n  -webkit-box-direction: normal;\n  -webkit-box-orient: vertical;\n  -moz-flex-direction: column;\n  -ms-flex-direction: column;\n  flex-direction: column;\n  height: 200px; }\n\n.selectCourseContainer---3giTh {\n  display: -webkit-box;\n  display: -moz-flex;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-direction: normal;\n  -webkit-box-orient: vertical;\n  -moz-flex-direction: column;\n  -ms-flex-direction: column;\n  flex-direction: column;\n  margin-top: 25px;\n  height: calc(50vh - 60px); }\n\n.courseHeader---1zK8w {\n  color: #415667;\n  font-family: Poppins;\n  font-size: 13px; }\n\n.selectCourse---_o_qx {\n  overflow-y: scroll;\n  height: 100%; }\n\n.course---MICdf, .courseSelected---1bSkr {\n  min-height: 44px;\n  width: 85%;\n  border: 1px solid #cfd2d4;\n  background-color: #fff;\n  border-radius: 10px;\n  -webkit-box-shadow: 3px 3px #bcbcbc;\n          box-shadow: 3px 3px #bcbcbc;\n  padding-top: 4px;\n  padding-left: 10px;\n  text-align: left;\n  margin-bottom: 10px;\n  outline: none; }\n\n.courseSelected---1bSkr {\n  background-color: #1981c4;\n  -webkit-box-shadow: inset -1px 1px 5px rgba(25, 25, 25, .44);\n          box-shadow: inset -1px 1px 5px rgba(25, 25, 25, .44);\n  color: white; }\n\n.empty---1ceE- {\n  transform: scale(0.7, 0.7);\n  -ms-transform: scale(0.7, 0.7);\n  /* IE 9 */\n  -webkit-transform: scale(0.7, 0.7);\n  /* Safari and Chrome */\n  -o-transform: scale(0.7, 0.7);\n  /* Opera */\n  -moz-transform: scale(0.7, 0.7);\n  /* Firefox */ }\n\n.emptyContainer---3qg4- {\n  display: -webkit-box;\n  display: -moz-flex;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-flex: 1;\n  -moz-flex: 1;\n  -ms-flex: 1;\n  flex: 1;\n  -webkit-box-direction: normal;\n  -webkit-box-orient: vertical;\n  -moz-flex-direction: column;\n  -ms-flex-direction: column;\n  flex-direction: column;\n  -webkit-box-pack: center;\n  -ms-flex-pack: center;\n  -moz-justify-content: center;\n  justify-content: center;\n  width: 100%;\n  padding: 10px;\n  border-radius: 6px; }\n\n.emptyNotice---KbPbC {\n  display: -webkit-box;\n  display: -moz-flex;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-direction: normal;\n  -webkit-box-orient: vertical;\n  -moz-flex-direction: column;\n  -ms-flex-direction: column;\n  flex-direction: column;\n  -webkit-box-pack: center;\n  -ms-flex-pack: center;\n  -moz-justify-content: center;\n  justify-content: center; }\n\n.courseRow---2bHzE {\n  display: -webkit-box;\n  display: -moz-flex;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n  -moz-align-items: center;\n  align-items: center; }\n\n.loader---2IZYY {\n  display: -webkit-box;\n  display: -moz-flex;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n  -moz-align-items: center;\n  align-items: center;\n  -webkit-box-pack: center;\n  -ms-flex-pack: center;\n  -moz-justify-content: center;\n  justify-content: center;\n  position: relative;\n  top: 0;\n  bottom: 0;\n  left: 0;\n  right: 0;\n  height: 100%; }\n\n.search---1hzF7 {\n  height: 38px;\n  width: 94%;\n  padding-left: 13px;\n  border: none;\n  color: #8b8b8b;\n  font-size: 16px;\n  font-family: Poppins;\n  outline: none; }\n\n.clear---2Btaa {\n  position: relative;\n  float: right;\n  width: 6%;\n  padding-left: 5px;\n  padding-top: 7px;\n  border: none;\n  background: white;\n  font-size: 18px;\n  cursor: pointer;\n  outline: none; }\n\n.searchContainer---2F9Y5 {\n  min-height: 38px;\n  background: white; }\n\n.footer---3sdLt {\n  display: -webkit-box;\n  display: -moz-flex;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: end;\n  -ms-flex-pack: end;\n  -moz-justify-content: flex-end;\n  justify-content: flex-end; }\n\n.assignToYear---IMngw {\n  width: 150px;\n  height: 40px;\n  border-radius: 20px;\n  margin: 10px;\n  padding-top: 10px;\n  color: #fff;\n  background-color: #415667;\n  font-family: Poppins;\n  font-size: 16px;\n  line-height: 20px; }\n\n@media screen and (max-width: 1400px) {\n  .empty---1ceE- {\n    display: -webkit-inline-box;\n    display: -moz-inline-flex;\n    display: -ms-inline-flexbox;\n    display: inline-flex; }\n  .selectCourse---_o_qx {\n    overflow-x: hidden; }\n  .clear---2Btaa {\n    width: 10%; }\n  .search---1hzF7 {\n    width: 90%; } }\n\n@media screen and (max-height: 900px) {\n  .selectCourseContainer---3giTh {\n    margin-top: 12px; } }\n\n@media screen and (max-height: 800px) {\n  .selectCourseContainer---3giTh {\n    margin-top: 10px;\n    height: 55%; } }\n\n@media screen and (max-height: 600px) {\n  .selectCourseContainer---3giTh {\n    margin-top: 12px;\n    height: 45%; } }\n", ""]);

// exports
exports.locals = {
	"assignCourse": "assignCourse---2BPoo",
	"heading": "heading---G-PnN",
	"subHeading": "subHeading---1cJFE",
	"defaultCourse": "defaultCourse---2Njyu",
	"selectCourseContainer": "selectCourseContainer---3giTh",
	"courseHeader": "courseHeader---1zK8w",
	"selectCourse": "selectCourse---_o_qx",
	"course": "course---MICdf",
	"courseSelected": "courseSelected---1bSkr",
	"empty": "empty---1ceE-",
	"emptyContainer": "emptyContainer---3qg4-",
	"emptyNotice": "emptyNotice---KbPbC",
	"courseRow": "courseRow---2bHzE",
	"loader": "loader---2IZYY",
	"search": "search---1hzF7",
	"clear": "clear---2Btaa",
	"searchContainer": "searchContainer---2F9Y5",
	"footer": "footer---3sdLt",
	"assignToYear": "assignToYear---IMngw"
};

/***/ }),
/* 1109 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(4)();
// imports


// module
exports.push([module.i, ".inputTextComponent---x0Ghm {\n  position: relative; }\n\n.inputText---nsrxK {\n  height: 38px;\n  width: 100%;\n  padding-left: 13px;\n  padding-right: 30px;\n  border: none;\n  color: #8b8b8b;\n  font-size: 16px;\n  font-family: Poppins;\n  outline: none; }\n", ""]);

// exports
exports.locals = {
	"inputTextComponent": "inputTextComponent---x0Ghm",
	"inputText": "inputText---nsrxK"
};

/***/ }),
/* 1110 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(4)();
// imports


// module
exports.push([module.i, ".yg0---xoyoC {\n  background-color: #e7b300; }\n\n.yg1---3iOO8 {\n  background-color: #ec7500; }\n\n.yg2---2eWl3 {\n  background-color: #f12800; }\n\n.yg3---1vZ1Y {\n  background-color: #de1c9c; }\n\n.yg4---U-sEN {\n  background-color: #6c32a8; }\n\n.yg5---jDCVW {\n  background-color: #4461cd; }\n\n.yg6---z0Nkp {\n  background-color: #00b4ff; }\n\n.yg7---14S3W {\n  background-color: #44d62c; }\n\n.yg8---2dF3x {\n  background-color: #249d46; }\n\n.yg9---2k1i- {\n  background-color: #7c871d; }\n\n.yg10---3tGQw {\n  background-color: #ad6f0c; }\n\n.yg11---2dUdn {\n  background-color: #643808; }\n\n.yg12---3z3IX {\n  background-color: #2a2a2a; }\n\n/**\n * Basic Breakpoint\n * url: https://responsivedesign.is/develop/getting-started-with-sass-and-breakpoint-mixin\n *\n * Usage:\n *\n * breakpoint(small-only | medium-up | medium-only | large-up | large-only) {\n * styles goes here\n * }\n*/\n\n.confirmationContainer---3SY58 {\n  display: -webkit-box;\n  display: -moz-flex;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: center;\n  -ms-flex-pack: center;\n  -moz-justify-content: center;\n  justify-content: center;\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n  -moz-align-items: center;\n  align-items: center;\n  -webkit-box-direction: normal;\n  -webkit-box-orient: vertical;\n  -moz-flex-direction: column;\n  -ms-flex-direction: column;\n  flex-direction: column;\n  outline: none;\n  color: #4e5c67; }\n\n.icon---rYN_0 {\n  width: 60px;\n  height: 75px;\n  margin-bottom: 15px; }\n\n.okButton---3n_YT {\n  -webkit-box-shadow: none;\n          box-shadow: none;\n  border-radius: 22px;\n  margin-top: 15px;\n  background-color: #415667;\n  width: 95px;\n  height: 45px;\n  border: none;\n  color: white;\n  font-size: 16px;\n  font-weight: 500;\n  outline: none; }\n\n.cancelBtn---27p5X,\n.proceedBtn---34v0M {\n  -webkit-box-shadow: none;\n          box-shadow: none;\n  border-radius: 22px;\n  margin-top: 15px;\n  background-color: #415667;\n  width: 95px;\n  height: 45px;\n  border: none;\n  color: white;\n  font-size: 16px;\n  font-weight: 500;\n  outline: none; }\n\n.confirmBtnContainer---37d8C {\n  display: -webkit-box;\n  display: -moz-flex;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: justify;\n  -ms-flex-pack: justify;\n  -moz-justify-content: space-between;\n  justify-content: space-between;\n  width: 210px;\n  margin: 40px; }\n\n.confirmTitle---2lBR0 {\n  color: #4e5c67;\n  font-size: 30px;\n  font-weight: 500;\n  margin-bottom: 10px;\n  min-height: 40px;\n  -webkit-box-flex: 1;\n  -moz-flex: 1;\n  -ms-flex: 1;\n  flex: 1; }\n\n@media screen and (max-width: 39.9375em) {\n    .confirmTitle---2lBR0 {\n      font-size: 20px;\n      line-height: 1.2em;\n      text-align: center;\n      margin-bottom: 10px; } }\n\n.spacing---13Vdr {\n  padding-right: 10px; }\n\n.header---3hv3p {\n  display: -webkit-box;\n  display: -moz-flex;\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-negative: 0;\n  flex-shrink: 0;\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n  -moz-align-items: center;\n  align-items: center;\n  height: 40px;\n  height: 50px;\n  color: #415667;\n  font-family: Poppins, sans-serif;\n  font-size: 13px;\n  font-weight: 600;\n  line-height: 27px; }\n\n.headerColumns---1XdNH, .yearColumn---KjuG-, .classColumn---2g_RJ, .groupColumn---HhGA2, .assignedCourseColumn---76pHP {\n  height: 100%;\n  border-right: 1px solid #adb6bc;\n  background: #fff;\n  text-align: center;\n  word-wrap: break-word;\n  line-height: 52px; }\n\n.yearColumn---KjuG- {\n  width: 10%; }\n\n.yearColumn---KjuG- div {\n    margin-left: 21px; }\n\n.classColumn---2g_RJ {\n  width: 25%; }\n\n.groupColumn---HhGA2 {\n  width: 25%; }\n\n.assignedCourseColumn---76pHP {\n  width: 40%; }\n\n.settingsFooter---3wNbd {\n  display: -webkit-box;\n  display: -moz-flex;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n  -moz-align-items: center;\n  align-items: center;\n  -webkit-box-pack: end;\n  -ms-flex-pack: end;\n  -moz-justify-content: flex-end;\n  justify-content: flex-end;\n  position: fixed;\n  bottom: 0.1px;\n  left: 0.1px;\n  width: 100%;\n  padding-right: 10px;\n  background-color: #adb6bc; }\n\n.cancelButton---2KR5q, .saveButton---wVPZX, .assignToYearButton---1ROoe {\n  width: 115px;\n  height: 45px;\n  border-radius: 22px;\n  margin: 10px;\n  padding-top: 14px;\n  color: #fff;\n  background-color: #415667;\n  font-family: Poppins;\n  font-size: 16px;\n  line-height: 20px; }\n\n.saveButton---wVPZX {\n  width: 95px; }\n\n.assignToYearButton---1ROoe {\n  width: 150px; }\n\n.panel---D7OT2 {\n  display: -webkit-box;\n  display: -moz-flex;\n  display: -ms-flexbox;\n  display: flex;\n  height: 84vh; }\n\n@media screen and (max-height: 760px) {\n    .panel---D7OT2 {\n      height: 75vh; } }\n\n.lhsPanel---1YE_M {\n  display: -webkit-box;\n  display: -moz-flex;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-direction: normal;\n  -webkit-box-orient: vertical;\n  -moz-flex-direction: column;\n  -ms-flex-direction: column;\n  flex-direction: column;\n  overflow: auto;\n  width: 70%;\n  background-color: white; }\n\n.rhsPanel---23_Iv {\n  width: 30%;\n  padding: 20px;\n  background-color: white; }\n\n.newCourseLabelWrapper---3O1tx {\n  height: 100%; }\n\n.row---1OTFy {\n  display: -webkit-box;\n  display: -moz-flex;\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-negative: 0;\n  flex-shrink: 0;\n  -webkit-box-flex: 1;\n  -moz-flex: 1;\n  -ms-flex: 1;\n  flex: 1; }\n\n.rowColumn---13YeI, .yearRow---3BSCQ, .classRow---sGoNn, .groupRow---2GQ69, .courseRow---2tNEa {\n  height: 100%;\n  border-right: 1px solid #adb6bc;\n  background: #fff; }\n\n.yearRow---3BSCQ {\n  min-width: 8%;\n  max-width: 8%;\n  outline: none; }\n\n.yearRow---3BSCQ div {\n    outline: none; }\n\n.yearGroup---1OPir {\n  border-radius: 15px;\n  margin-left: 8px;\n  width: 35px;\n  height: 24px;\n  text-align: center;\n  color: #fff;\n  font-size: 12px;\n  font-weight: 500;\n  line-height: 25px; }\n\n.classRow---sGoNn {\n  min-width: 20%;\n  max-width: 20%;\n  outline: none;\n  height: inherit;\n  line-height: 12px;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis; }\n\n.classRow---sGoNn div {\n    outline: none; }\n\n.infoContainer---3mJ_x {\n  height: 30px;\n  cursor: pointer; }\n\n.infoContainer---3mJ_x div:nth-child(1) {\n    width: 100% !important;\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    height: 100%;\n    padding-top: 3px; }\n\n.infoContainer---3mJ_x div:nth-child(2) {\n    height: 100%; }\n\n.info---qPQjr {\n  width: 100%;\n  padding-top: 4px;\n  padding-left: 4px;\n  color: #444;\n  font-family: Poppins, sans-serif;\n  font-size: 13px;\n  font-weight: 600; }\n\n.info---qPQjr.active---1zgEK {\n    color: #fff; }\n\n.groupRow---2GQ69 {\n  min-width: 20%;\n  max-width: 20%;\n  outline: none;\n  line-height: 12px;\n  height: inherit;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis; }\n\n.groupRow---2GQ69 div {\n    outline: none; }\n\n.courseRow---2tNEa {\n  width: 32%;\n  outline: none;\n  height: inherit; }\n\n.disabled---buwSj {\n  height: 42px;\n  opacity: 0.4;\n  pointer-events: none;\n  cursor: not-allowed; }\n\n.selectable---2tGgT {\n  cursor: pointer;\n  height: 42px; }\n", ""]);

// exports
exports.locals = {
	"yg0": "yg0---xoyoC",
	"yg1": "yg1---3iOO8",
	"yg2": "yg2---2eWl3",
	"yg3": "yg3---1vZ1Y",
	"yg4": "yg4---U-sEN",
	"yg5": "yg5---jDCVW",
	"yg6": "yg6---z0Nkp",
	"yg7": "yg7---14S3W",
	"yg8": "yg8---2dF3x",
	"yg9": "yg9---2k1i-",
	"yg10": "yg10---3tGQw",
	"yg11": "yg11---2dUdn",
	"yg12": "yg12---3z3IX",
	"confirmationContainer": "confirmationContainer---3SY58",
	"icon": "icon---rYN_0",
	"okButton": "okButton---3n_YT",
	"cancelBtn": "cancelBtn---27p5X",
	"proceedBtn": "proceedBtn---34v0M",
	"confirmBtnContainer": "confirmBtnContainer---37d8C",
	"confirmTitle": "confirmTitle---2lBR0",
	"spacing": "spacing---13Vdr",
	"header": "header---3hv3p",
	"headerColumns": "headerColumns---1XdNH",
	"yearColumn": "yearColumn---KjuG-",
	"classColumn": "classColumn---2g_RJ",
	"groupColumn": "groupColumn---HhGA2",
	"assignedCourseColumn": "assignedCourseColumn---76pHP",
	"settingsFooter": "settingsFooter---3wNbd",
	"cancelButton": "cancelButton---2KR5q",
	"saveButton": "saveButton---wVPZX",
	"assignToYearButton": "assignToYearButton---1ROoe",
	"panel": "panel---D7OT2",
	"lhsPanel": "lhsPanel---1YE_M",
	"rhsPanel": "rhsPanel---23_Iv",
	"newCourseLabelWrapper": "newCourseLabelWrapper---3O1tx",
	"row": "row---1OTFy",
	"rowColumn": "rowColumn---13YeI",
	"yearRow": "yearRow---3BSCQ",
	"classRow": "classRow---sGoNn",
	"groupRow": "groupRow---2GQ69",
	"courseRow": "courseRow---2tNEa",
	"yearGroup": "yearGroup---1OPir",
	"infoContainer": "infoContainer---3mJ_x",
	"info": "info---qPQjr",
	"active": "active---1zgEK",
	"disabled": "disabled---buwSj",
	"selectable": "selectable---2tGgT"
};

/***/ }),
/* 1111 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(4)();
// imports


// module
exports.push([module.i, ".react-grid-HeaderCell:nth-child(n+6):nth-child(-n+8) {\n  color: #1c7fc3; }\n\n.react-grid-HeaderCell:nth-child(8) {\n  min-width: 40px; }\n\n.react-grid-Cell:nth-child(8) {\n  min-width: 40px; }\n\n.assignCourse---2USsK {\n  -webkit-box-flex: 1;\n  -moz-flex: 1;\n  -ms-flex: 1;\n  flex: 1;\n  -webkit-box-direction: normal;\n  -webkit-box-orient: vertical;\n  -moz-flex-direction: column;\n  -ms-flex-direction: column;\n  flex-direction: column;\n  -webkit-box-pack: justify;\n  -ms-flex-pack: justify;\n  -moz-justify-content: space-between;\n  justify-content: space-between;\n  padding: 10px;\n  border-radius: 15px;\n  background-color: #e7e9ea;\n  height: 100%; }\n\n.assignCourse---2USsK ::-webkit-scrollbar {\n    width: 14px; }\n\n.assignCourse---2USsK ::-webkit-scrollbar-track {\n    background: #cfd2d4;\n    border-radius: 7px; }\n\n.assignCourse---2USsK ::-webkit-scrollbar-thumb {\n    background: #415667;\n    border-radius: 7px; }\n\n.assignCourse---2USsK ::-webkit-scrollbar-thumb:hover {\n    background: #4e5c67; }\n\n.assignCourse---2USsK ::-ms-clear {\n    display: none; }\n\n.heading---18N8t, .subHeading---15EzW {\n  color: #444;\n  font-size: 16px;\n  font-family: Poppins; }\n\n.subHeading---15EzW {\n  font-size: 14px; }\n\n.defaultCourse---fs3-n {\n  display: -webkit-box;\n  display: -moz-flex;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: justify;\n  -ms-flex-pack: justify;\n  -moz-justify-content: space-between;\n  justify-content: space-between;\n  -webkit-box-direction: normal;\n  -webkit-box-orient: vertical;\n  -moz-flex-direction: column;\n  -ms-flex-direction: column;\n  flex-direction: column;\n  height: 200px; }\n\n.selectCourseContainer---2RoFM {\n  display: -webkit-box;\n  display: -moz-flex;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-direction: normal;\n  -webkit-box-orient: vertical;\n  -moz-flex-direction: column;\n  -ms-flex-direction: column;\n  flex-direction: column;\n  margin-top: 25px;\n  height: calc(50vh - 60px); }\n\n.courseHeader---1ZJ8W {\n  color: #415667;\n  font-family: Poppins;\n  font-size: 13px; }\n\n.selectCourse---2j96b {\n  overflow-y: scroll;\n  height: 100%; }\n\n.course---2UZ5Q, .courseSelected---3YRM9 {\n  min-height: 44px;\n  width: 85%;\n  border: 1px solid #cfd2d4;\n  background-color: #fff;\n  border-radius: 10px;\n  -webkit-box-shadow: 3px 3px #bcbcbc;\n          box-shadow: 3px 3px #bcbcbc;\n  padding-top: 4px;\n  padding-left: 10px;\n  text-align: left;\n  margin-bottom: 10px;\n  outline: none; }\n\n.courseSelected---3YRM9 {\n  background-color: #1981c4;\n  -webkit-box-shadow: inset -1px 1px 5px rgba(25, 25, 25, .44);\n          box-shadow: inset -1px 1px 5px rgba(25, 25, 25, .44);\n  color: white; }\n\n.empty---3qkwe {\n  transform: scale(0.7, 0.7);\n  -ms-transform: scale(0.7, 0.7);\n  /* IE 9 */\n  -webkit-transform: scale(0.7, 0.7);\n  /* Safari and Chrome */\n  -o-transform: scale(0.7, 0.7);\n  /* Opera */\n  -moz-transform: scale(0.7, 0.7);\n  /* Firefox */ }\n\n.emptyContainer---2uRyp {\n  display: -webkit-box;\n  display: -moz-flex;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-flex: 1;\n  -moz-flex: 1;\n  -ms-flex: 1;\n  flex: 1;\n  -webkit-box-direction: normal;\n  -webkit-box-orient: vertical;\n  -moz-flex-direction: column;\n  -ms-flex-direction: column;\n  flex-direction: column;\n  -webkit-box-pack: center;\n  -ms-flex-pack: center;\n  -moz-justify-content: center;\n  justify-content: center;\n  width: 100%;\n  padding: 10px;\n  border-radius: 6px; }\n\n.emptyNotice---1xz64 {\n  display: -webkit-box;\n  display: -moz-flex;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-direction: normal;\n  -webkit-box-orient: vertical;\n  -moz-flex-direction: column;\n  -ms-flex-direction: column;\n  flex-direction: column;\n  -webkit-box-pack: center;\n  -ms-flex-pack: center;\n  -moz-justify-content: center;\n  justify-content: center; }\n\n.courseRow---1ts_5 {\n  display: -webkit-box;\n  display: -moz-flex;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n  -moz-align-items: center;\n  align-items: center; }\n\n.loader---118gw {\n  display: -webkit-box;\n  display: -moz-flex;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n  -moz-align-items: center;\n  align-items: center;\n  -webkit-box-pack: center;\n  -ms-flex-pack: center;\n  -moz-justify-content: center;\n  justify-content: center;\n  position: relative;\n  top: 0;\n  bottom: 0;\n  left: 0;\n  right: 0;\n  height: 100%; }\n\n.search---3wRER {\n  height: 38px;\n  width: 94%;\n  padding-left: 13px;\n  border: none;\n  color: #8b8b8b;\n  font-size: 16px;\n  font-family: Poppins;\n  outline: none; }\n\n.clear---2cYh9 {\n  position: relative;\n  float: right;\n  width: 6%;\n  padding-left: 5px;\n  padding-top: 7px;\n  border: none;\n  background: white;\n  font-size: 18px;\n  cursor: pointer;\n  outline: none; }\n\n.searchContainer---2a8hg {\n  min-height: 38px;\n  background: white; }\n\n.footer---3mqJP, .footerLegacy---22Aer {\n  display: -webkit-box;\n  display: -moz-flex;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: space-evenly;\n  -ms-flex-pack: space-evenly;\n  -moz-justify-content: space-evenly;\n  justify-content: space-evenly; }\n\n.footerLegacy---22Aer {\n  -webkit-box-pack: end;\n  -ms-flex-pack: end;\n  -moz-justify-content: flex-end;\n  justify-content: flex-end;\n  margin-right: 20px !important; }\n\n.assignToYear---3gLSi, .optOut---3AM0I {\n  width: 150px;\n  height: 40px;\n  border-radius: 20px;\n  margin: 10px;\n  padding-top: 10px;\n  color: #fff;\n  background-color: #415667;\n  font-family: Poppins;\n  font-size: 15px;\n  line-height: 20px; }\n\n.optOut---3AM0I {\n  width: 160px;\n  background-color: #c53902; }\n\n@media screen and (max-width: 1400px) {\n  .empty---3qkwe {\n    display: -webkit-inline-box;\n    display: -moz-inline-flex;\n    display: -ms-inline-flexbox;\n    display: inline-flex; }\n  .selectCourse---2j96b {\n    overflow-x: hidden; }\n  .clear---2cYh9 {\n    width: 10%; }\n  .search---3wRER {\n    width: 90%; } }\n\n@media screen and (max-height: 900px) {\n  .selectCourseContainer---2RoFM {\n    margin-top: 12px; } }\n\n@media screen and (max-height: 800px) {\n  .selectCourseContainer---2RoFM {\n    margin-top: 10px;\n    height: 55%; } }\n\n@media screen and (max-height: 600px) {\n  .selectCourseContainer---2RoFM {\n    margin-top: 12px;\n    height: 45%; } }\n", ""]);

// exports
exports.locals = {
	"assignCourse": "assignCourse---2USsK",
	"heading": "heading---18N8t",
	"subHeading": "subHeading---15EzW",
	"defaultCourse": "defaultCourse---fs3-n",
	"selectCourseContainer": "selectCourseContainer---2RoFM",
	"courseHeader": "courseHeader---1ZJ8W",
	"selectCourse": "selectCourse---2j96b",
	"course": "course---2UZ5Q",
	"courseSelected": "courseSelected---3YRM9",
	"empty": "empty---3qkwe",
	"emptyContainer": "emptyContainer---2uRyp",
	"emptyNotice": "emptyNotice---1xz64",
	"courseRow": "courseRow---1ts_5",
	"loader": "loader---118gw",
	"search": "search---3wRER",
	"clear": "clear---2cYh9",
	"searchContainer": "searchContainer---2a8hg",
	"footer": "footer---3mqJP",
	"footerLegacy": "footerLegacy---22Aer",
	"assignToYear": "assignToYear---3gLSi",
	"optOut": "optOut---3AM0I"
};

/***/ }),
/* 1112 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(4)();
// imports


// module
exports.push([module.i, ".inputTextComponent---1PCST {\n  position: relative; }\n\n.inputText---2UDnt {\n  height: 38px;\n  width: 100%;\n  padding-left: 13px;\n  padding-right: 30px;\n  border: none;\n  color: #8b8b8b;\n  font-size: 16px;\n  font-family: Poppins;\n  outline: none; }\n", ""]);

// exports
exports.locals = {
	"inputTextComponent": "inputTextComponent---1PCST",
	"inputText": "inputText---2UDnt"
};

/***/ }),
/* 1113 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(4)();
// imports


// module
exports.push([module.i, ".yg0---2EjzX {\n  background-color: #e7b300; }\n\n.yg1---3E6kg {\n  background-color: #ec7500; }\n\n.yg2---4Gs4Q {\n  background-color: #f12800; }\n\n.yg3---1bl1y {\n  background-color: #de1c9c; }\n\n.yg4---hg9oz {\n  background-color: #6c32a8; }\n\n.yg5---gW4Zv {\n  background-color: #4461cd; }\n\n.yg6---1Gqn9 {\n  background-color: #00b4ff; }\n\n.yg7---zxrcV {\n  background-color: #44d62c; }\n\n.yg8---1vQmJ {\n  background-color: #249d46; }\n\n.yg9---SODUr {\n  background-color: #7c871d; }\n\n.yg10---2UGH8 {\n  background-color: #ad6f0c; }\n\n.yg11---3qDMm {\n  background-color: #643808; }\n\n.yg12---3tBcf {\n  background-color: #2a2a2a; }\n\n.container---3HMnV {\n  padding: 5px; }\n\n.info---2tYTT, .disableListItem---2ixi9 {\n  overflow: auto;\n  border: 1px solid #cdcdcd;\n  border-radius: 7px;\n  -webkit-box-shadow: 5px 5px 1px rgba(179, 179, 179, .3);\n          box-shadow: 5px 5px 1px rgba(179, 179, 179, .3);\n  background-color: #fff; }\n\n.info---2tYTT.highlight---1tGZx, .highlight---1tGZx.disableListItem---2ixi9 {\n    background-color: #E7C240; }\n\n.disableListItem---2ixi9 {\n  opacity: 0.4;\n  pointer-events: none;\n  cursor: not-allowed; }\n\n.checkbox---3n_QH {\n  display: -webkit-inline-box;\n  display: -moz-inline-flex;\n  display: -ms-inline-flexbox;\n  display: inline-flex;\n  margin: 8px; }\n\n.checkbox---3n_QH .chklabel---1AS1J {\n  width: 20px;\n  height: 20px;\n  border: 1px solid #cdcdcd; }\n\n.checkbox---3n_QH .name---ugGZD {\n  display: none; }\n\n.checkbox---3n_QH .className---1QRLa {\n  padding-left: 10px;\n  color: #555555;\n  font-family: Poppins;\n  font-size: 14px;\n  font-weight: 500; }\n\n.name---ugGZD + label {\n  position: relative;\n  overflow: hidden;\n  border-radius: 3px;\n  -webkit-appearance: none;\n  cursor: pointer; }\n\n.name---ugGZD:checked + label::after {\n  background-color: #fff !important;\n  content: \"\\E900\";\n  color: #000 !important;\n  font: 13pt icomoon; }\n\n.additionalInfo---3fJjh {\n  float: right;\n  margin: 8px;\n  font-family: Poppins; }\n\n.yearGroupContainer---luhZ9 {\n  float: right;\n  margin: 8px; }\n\n.yearGroup---1yNNV {\n  padding: 4px 10px;\n  border-radius: 15px;\n  margin-left: 8px;\n  min-width: 35px;\n  min-height: 24px;\n  text-align: center;\n  color: #fff;\n  font-size: 12px;\n  font-weight: 500; }\n\n.childContainer---3fo5I {\n  width: 98%; }\n", ""]);

// exports
exports.locals = {
	"yg0": "yg0---2EjzX",
	"yg1": "yg1---3E6kg",
	"yg2": "yg2---4Gs4Q",
	"yg3": "yg3---1bl1y",
	"yg4": "yg4---hg9oz",
	"yg5": "yg5---gW4Zv",
	"yg6": "yg6---1Gqn9",
	"yg7": "yg7---zxrcV",
	"yg8": "yg8---1vQmJ",
	"yg9": "yg9---SODUr",
	"yg10": "yg10---2UGH8",
	"yg11": "yg11---3qDMm",
	"yg12": "yg12---3tBcf",
	"container": "container---3HMnV",
	"info": "info---2tYTT",
	"disableListItem": "disableListItem---2ixi9",
	"highlight": "highlight---1tGZx",
	"checkbox": "checkbox---3n_QH",
	"chklabel": "chklabel---1AS1J",
	"name": "name---ugGZD",
	"className": "className---1QRLa",
	"additionalInfo": "additionalInfo---3fJjh",
	"yearGroupContainer": "yearGroupContainer---luhZ9",
	"yearGroup": "yearGroup---1yNNV",
	"childContainer": "childContainer---3fo5I"
};

/***/ }),
/* 1114 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(4)();
// imports


// module
exports.push([module.i, ".assignContainer---1p4tH {\n  display: -webkit-box;\n  display: -moz-flex;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-direction: normal;\n  -webkit-box-orient: vertical;\n  -moz-flex-direction: column;\n  -ms-flex-direction: column;\n  flex-direction: column;\n  height: 94vh;\n  padding: 20px;\n  background-color: #e7e9ea; }\n\n.mainHeader---2912c {\n  color: #415667;\n  font-family: Poppins;\n  font-size: 26px;\n  font-weight: 500;\n  line-height: 27px; }\n\n.headerDescription---Digkx {\n  color: #32a8a7; }\n\n.assignFooter---1A3nI {\n  display: -webkit-box;\n  display: -moz-flex;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n  -moz-align-items: center;\n  align-items: center;\n  -webkit-box-pack: end;\n  -ms-flex-pack: end;\n  -moz-justify-content: flex-end;\n  justify-content: flex-end;\n  position: absolute;\n  bottom: 0.1px;\n  left: 0.1px;\n  width: 100%;\n  height: 77px;\n  padding-right: 10px;\n  background-color: #adb6bc; }\n\n.cancelButton---1Ub9l, .saveButton---17Xk2 {\n  width: 115px;\n  height: 45px;\n  border-radius: 22px;\n  margin: 10px;\n  padding-top: 14px;\n  color: #fff;\n  background-color: #415667;\n  font-family: Poppins;\n  font-size: 16px;\n  line-height: 20px; }\n\n.saveButton---17Xk2 {\n  width: 95px; }\n\n@media screen and (max-width: 800px) {\n  .availableClassHeader---k8oX6 {\n    padding: 10px 5px; } }\n", ""]);

// exports
exports.locals = {
	"assignContainer": "assignContainer---1p4tH",
	"mainHeader": "mainHeader---2912c",
	"headerDescription": "headerDescription---Digkx",
	"assignFooter": "assignFooter---1A3nI",
	"cancelButton": "cancelButton---1Ub9l",
	"saveButton": "saveButton---17Xk2",
	"availableClassHeader": "availableClassHeader---k8oX6"
};

/***/ }),
/* 1115 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(4)();
// imports


// module
exports.push([module.i, ".assignContainer---3MGxE {\n  display: -webkit-box;\n  display: -moz-flex;\n  display: -ms-flexbox;\n  display: flex;\n  width: 100%;\n  height: 100%;\n  padding-left: 20px;\n  border-radius: 5px;\n  -webkit-box-shadow: 5px 5px 1px rgba(179, 179, 179, .3);\n          box-shadow: 5px 5px 1px rgba(179, 179, 179, .3);\n  margin: 20px auto;\n  background-color: #fff; }\n\n.panel---3HaXY {\n  display: -webkit-box;\n  display: -moz-flex;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-direction: normal;\n  -webkit-box-orient: vertical;\n  -moz-flex-direction: column;\n  -ms-flex-direction: column;\n  flex-direction: column;\n  width: 49%;\n  min-height: 0.1px;\n  height: 100%; }\n\n.panelHeader---jE0-8 {\n  color: #32a8a7;\n  font-family: Poppins;\n  font-size: 18px;\n  font-weight: 500;\n  line-height: 50px; }\n\n.panelBody---3cQsx, .rightPanel---1-ywz {\n  display: -webkit-box;\n  display: -moz-flex;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-direction: normal;\n  -webkit-box-orient: vertical;\n  -moz-flex-direction: column;\n  -ms-flex-direction: column;\n  flex-direction: column;\n  -webkit-box-flex: 1;\n  -moz-flex-grow: 1;\n  -ms-flex-positive: 1;\n  flex-grow: 1;\n  overflow: hidden;\n  height: 200px;\n  border: 1px solid #cfd2d4;\n  border-radius: 5px;\n  margin-bottom: 10px; }\n\n.rightPanel---1-ywz {\n  overflow: auto;\n  margin-right: 10px; }\n\n.leftPanelHeader---2wRcY {\n  display: -webkit-box;\n  display: -moz-flex;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: justify;\n  -ms-flex-pack: justify;\n  -moz-justify-content: space-between;\n  justify-content: space-between;\n  -webkit-box-flex: none;\n  -moz-flex: none;\n  -ms-flex: none;\n  flex: none;\n  padding: 10px 20px;\n  background-color: #cfd2d4; }\n\n.leftPanel---3Dxyp {\n  overflow: auto; }\n\n@media screen and (max-width: 800px) {\n  .leftPanelHeader---2wRcY {\n    padding: 10px 5px; } }\n\n.assignItemContainer---1_W6v {\n  padding: 7px; }\n\n.moveButtons---2mAHu {\n  display: -webkit-box;\n  display: -moz-flex;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-direction: normal;\n  -webkit-box-orient: vertical;\n  -moz-flex-direction: column;\n  -ms-flex-direction: column;\n  flex-direction: column;\n  -webkit-box-pack: center;\n  -ms-flex-pack: center;\n  -moz-justify-content: center;\n  justify-content: center; }\n\n.assignButton---1UzvV, .buttonContainerDisabled---31VML {\n  display: -webkit-box;\n  display: -moz-flex;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n  -moz-align-items: center;\n  align-items: center;\n  -webkit-box-pack: center;\n  -ms-flex-pack: center;\n  -moz-justify-content: center;\n  justify-content: center;\n  width: 50px;\n  height: 50px;\n  padding-top: 8px;\n  border-radius: 25px;\n  margin: 10px;\n  background-color: #415667; }\n\n.assignButton---1UzvV path, .buttonContainerDisabled---31VML path {\n    fill: #fff !important; }\n\n.buttonContainerDisabled---31VML {\n  cursor: not-allowed;\n  background-color: #1c7fc3; }\n\n.iconClassName---3dvnW {\n  width: 19px; }\n", ""]);

// exports
exports.locals = {
	"assignContainer": "assignContainer---3MGxE",
	"panel": "panel---3HaXY",
	"panelHeader": "panelHeader---jE0-8",
	"panelBody": "panelBody---3cQsx",
	"rightPanel": "rightPanel---1-ywz",
	"leftPanelHeader": "leftPanelHeader---2wRcY",
	"leftPanel": "leftPanel---3Dxyp",
	"assignItemContainer": "assignItemContainer---1_W6v",
	"moveButtons": "moveButtons---2mAHu",
	"assignButton": "assignButton---1UzvV",
	"buttonContainerDisabled": "buttonContainerDisabled---31VML",
	"iconClassName": "iconClassName---3dvnW"
};

/***/ }),
/* 1116 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(4)();
// imports


// module
exports.push([module.i, ".component---2XwXQ {\n  display: block;\n  margin: 2px; }\n\n.assignedClass---3B6qD {\n  padding: 2px; }\n\n.button---20aOa, .assign---2sHWI {\n  height: 25px;\n  background-color: #415667;\n  border-radius: 15px;\n  color: #fff;\n  font-family: Poppins, sans-serif;\n  font-size: 14px;\n  font-weight: 500;\n  line-height: 20px;\n  border: 1px solid #959595;\n  margin-left: 5px;\n  -webkit-box-pack: center;\n  -ms-flex-pack: center;\n  -moz-justify-content: center;\n  justify-content: center;\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n  -moz-align-items: center;\n  align-items: center; }\n\n.assign---2sHWI {\n  min-width: 110px;\n  display: inline-block;\n  padding: 0 15px; }\n\n.assign---2sHWI > div {\n    height: 100%; }\n", ""]);

// exports
exports.locals = {
	"component": "component---2XwXQ",
	"assignedClass": "assignedClass---3B6qD",
	"button": "button---20aOa",
	"assign": "assign---2sHWI"
};

/***/ }),
/* 1117 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(4)();
// imports


// module
exports.push([module.i, ".assignedTeacherComponent---2Btis {\n  display: -webkit-box;\n  display: -moz-flex;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-direction: normal;\n  -webkit-box-orient: vertical;\n  -moz-flex-direction: column;\n  -ms-flex-direction: column;\n  flex-direction: column;\n  -webkit-box-shadow: 5px 5px 1px rgba(179, 179, 179, .3);\n          box-shadow: 5px 5px 1px rgba(179, 179, 179, .3);\n  min-height: 200px;\n  padding: 20px;\n  border-radius: 10px;\n  margin-bottom: 100px;\n  background-color: #fff;\n  font-family: Poppins, sans-serif;\n  font-size: 18px;\n  font-weight: 500;\n  outline: none; }\n\n.title---rvVeZ {\n  margin-bottom: 10px;\n  color: #32a8a7; }\n\n.footer---2b33C {\n  display: -webkit-box;\n  display: -moz-flex;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: end;\n  -ms-flex-pack: end;\n  -moz-justify-content: flex-end;\n  justify-content: flex-end;\n  margin-top: 10px;\n  padding-top: 15px;\n  border-top: 1px solid #adb6bc; }\n\n.icon---2VFRn {\n  width: 16px;\n  height: 17px;\n  margin: 5px; }\n\n.icon---2VFRn path {\n    fill: white !important; }\n\n.assignTeacher---2Vreb {\n  background-color: #415667;\n  width: 181px;\n  height: 36px;\n  border-radius: 18px;\n  -webkit-user-select: none;\n     -moz-user-select: none;\n      -ms-user-select: none;\n          user-select: none;\n  font-size: 14px;\n  color: #fff;\n  padding-top: 5px; }\n", ""]);

// exports
exports.locals = {
	"assignedTeacherComponent": "assignedTeacherComponent---2Btis",
	"title": "title---rvVeZ",
	"footer": "footer---2b33C",
	"icon": "icon---2VFRn",
	"assignTeacher": "assignTeacher---2Vreb"
};

/***/ }),
/* 1118 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(4)();
// imports


// module
exports.push([module.i, ".component---2QACf {\n  display: block;\n  margin: 2px; }\n\n.assignedClass---39yEy {\n  padding: 2px; }\n\n.button---3TYzq, .assign---a0N0E {\n  min-width: 135px;\n  height: 25px;\n  background-color: #415667;\n  border-radius: 15px;\n  color: #fff;\n  font-family: Poppins, sans-serif;\n  font-size: 14px;\n  font-weight: 500;\n  line-height: 20px;\n  border: 1px solid #959595;\n  margin-left: 5px;\n  -webkit-box-pack: center;\n  -ms-flex-pack: center;\n  -moz-justify-content: center;\n  justify-content: center;\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n  -moz-align-items: center;\n  align-items: center; }\n\n.assign---a0N0E {\n  min-width: 110px;\n  display: inline-block;\n  padding: 0 15px; }\n\n.assign---a0N0E > div {\n    height: 100%; }\n", ""]);

// exports
exports.locals = {
	"component": "component---2QACf",
	"assignedClass": "assignedClass---39yEy",
	"button": "button---3TYzq",
	"assign": "assign---a0N0E"
};

/***/ }),
/* 1119 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(4)();
// imports


// module
exports.push([module.i, ".list---3TEw9 {\n  display: -webkit-box;\n  display: -moz-flex;\n  display: -ms-flexbox;\n  display: flex;\n  margin-bottom: 10px; }\n\n.header---1vfD2 {\n  color: #adb6bc;\n  font-family: Poppins, sans-serif;\n  font-size: 13px;\n  font-weight: 500;\n  margin-bottom: 24px; }\n\n.listItem---2Hfcf {\n  color: #415667;\n  font-family: Poppins, sans-serif;\n  font-size: 13px;\n  font-weight: 500;\n  width: 85%; }\n\n.downloadSignInCards---3o5Gv {\n  background-color: #415667;\n  min-width: 250px;\n  max-width: 350px;\n  height: 36px;\n  border-radius: 18px;\n  -webkit-user-select: none;\n     -moz-user-select: none;\n      -ms-user-select: none;\n          user-select: none;\n  font-size: 14px;\n  color: #fff;\n  padding: 5px 10px 0;\n  margin-right: 20px; }\n\n.unassign---2mbtb {\n  height: 30px;\n  width: 30px;\n  border-radius: 15px;\n  background-color: #c53902; }\n\n.icon---2xOIS {\n  width: 16px;\n  height: 17px;\n  margin: 5px; }\n\n.icon---2xOIS path {\n    fill: white !important; }\n\n.highlight---jl4At {\n  color: #32a8a7; }\n\n/* Medium screens */\n\n@media all and (max-width: 1100px) {\n  .downloadSignInCards---3o5Gv {\n    background-color: #415667;\n    width: 275px;\n    height: 36px;\n    border-radius: 18px;\n    -webkit-user-select: none;\n       -moz-user-select: none;\n        -ms-user-select: none;\n            user-select: none;\n    font-size: 14px;\n    color: #fff;\n    padding-top: 5px;\n    margin-right: 20px; } }\n", ""]);

// exports
exports.locals = {
	"list": "list---3TEw9",
	"header": "header---1vfD2",
	"listItem": "listItem---2Hfcf",
	"downloadSignInCards": "downloadSignInCards---3o5Gv",
	"unassign": "unassign---2mbtb",
	"icon": "icon---2xOIS",
	"highlight": "highlight---jl4At"
};

/***/ }),
/* 1120 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(4)();
// imports


// module
exports.push([module.i, ".modalContent---2mdrt {\n  display: -webkit-box;\n  display: -moz-flex;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: centre;\n  -ms-flex-align: centre;\n  -moz-align-items: centre;\n  align-items: centre;\n  -webkit-box-direction: normal;\n  -webkit-box-orient: vertical;\n  -moz-flex-direction: column;\n  -ms-flex-direction: column;\n  flex-direction: column;\n  outline: none;\n  -webkit-user-select: none;\n     -moz-user-select: none;\n      -ms-user-select: none;\n          user-select: none;\n  background: #e7e9ea;\n  width: 22%;\n  height: 180px;\n  margin: auto;\n  border-radius: 10px; }\n\n.close---3dYRK {\n  color: #aaa;\n  font-size: 28px;\n  font-weight: bold;\n  padding-top: 4px; }\n\n.close---3dYRK:hover,\n.close---3dYRK:focus {\n  color: black;\n  text-decoration: none;\n  cursor: pointer;\n  outline: none; }\n\n.modalHeader---2YaGi {\n  display: -webkit-box;\n  display: -moz-flex;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n  -moz-align-items: center;\n  align-items: center;\n  padding-left: 13px;\n  padding-right: 5px;\n  background-color: #cfd2d4;\n  color: #4e5c67;\n  width: 100%;\n  border-radius: 10px 10px 1px 1px; }\n\n.modalBody---2RtRI {\n  padding: 2px 16px;\n  height: 98px;\n  margin-top: 5px; }\n\n.modalFooter---1WD9S {\n  padding: 2px 16px;\n  background-color: #cfd2d4;\n  color: white;\n  width: 100%; }\n\n.modalHeaderText---3j68_ {\n  width: 95%;\n  font-family: poppins;\n  font-weight: 600; }\n\n.formatContainer---34itW {\n  display: -webkit-box;\n  display: -moz-flex;\n  display: -ms-flexbox;\n  display: flex; }\n\n.formatName---11y6N {\n  font-family: poppins;\n  font-weight: 500;\n  padding-top: 13px;\n  padding-left: 10px; }\n\n.buttonContainer---12dNv {\n  display: -webkit-box;\n  display: -moz-flex;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n  -moz-align-items: center;\n  align-items: center;\n  -webkit-box-flex: 1;\n  -moz-flex: 1;\n  -ms-flex: 1;\n  flex: 1;\n  padding: 4px; }\n\n.password---1HqE7 {\n  font-family: poppins;\n  font-weight: 500; }\n", ""]);

// exports
exports.locals = {
	"modalContent": "modalContent---2mdrt",
	"close": "close---3dYRK",
	"modalHeader": "modalHeader---2YaGi",
	"modalBody": "modalBody---2RtRI",
	"modalFooter": "modalFooter---1WD9S",
	"modalHeaderText": "modalHeaderText---3j68_",
	"formatContainer": "formatContainer---34itW",
	"formatName": "formatName---11y6N",
	"buttonContainer": "buttonContainer---12dNv",
	"password": "password---1HqE7"
};

/***/ }),
/* 1121 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(4)();
// imports


// module
exports.push([module.i, ".inputText---Rq80s, .disabled---2uVUJ {\n  height: 38px;\n  width: 100%;\n  padding: 0 12px;\n  border: 1px solid #e7e9ea;\n  border-radius: 4px;\n  color: #4e5c67;\n  font-family: Poppins;\n  font-weight: 500;\n  line-height: 38px;\n  outline: none; }\n\n.disabled---2uVUJ {\n  opacity: 0.4;\n  pointer-events: none;\n  cursor: not-allowed; }\n", ""]);

// exports
exports.locals = {
	"inputText": "inputText---Rq80s",
	"disabled": "disabled---2uVUJ"
};

/***/ }),
/* 1122 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(4)();
// imports


// module
exports.push([module.i, ".badgeComponent---2v39P {\n  display: -webkit-box;\n  display: -moz-flex;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n  -moz-align-items: center;\n  align-items: center;\n  -webkit-box-pack: end;\n  -ms-flex-pack: end;\n  -moz-justify-content: flex-end;\n  justify-content: flex-end;\n  -webkit-box-flex: 1;\n  -moz-flex: 1;\n  -ms-flex: 1;\n  flex: 1; }\n\n.title---3lLDn {\n  color: #4e5c67;\n  font-family: Poppins, sans-serif;\n  font-size: 18px;\n  font-weight: 500;\n  -webkit-box-pack: center;\n  -ms-flex-pack: center;\n  -moz-justify-content: center;\n  justify-content: center;\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n  -moz-align-items: center;\n  align-items: center; }\n\n.loaderStyle---2Apwh {\n  -webkit-box-pack: center;\n  -ms-flex-pack: center;\n  -moz-justify-content: center;\n  justify-content: center;\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n  -moz-align-items: center;\n  align-items: center;\n  color: #fff;\n  padding-top: 4px; }\n", ""]);

// exports
exports.locals = {
	"badgeComponent": "badgeComponent---2v39P",
	"title": "title---3lLDn",
	"loaderStyle": "loaderStyle---2Apwh"
};

/***/ }),
/* 1123 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(4)();
// imports


// module
exports.push([module.i, ".react-grid-HeaderCell:nth-child(n+6):nth-child(-n+8) {\n  color: #1c7fc3; }\n\n.react-grid-HeaderCell:nth-child(8) {\n  min-width: 40px; }\n\n.react-grid-Cell:nth-child(8) {\n  min-width: 40px; }\n\n.bulkPasswordChangeContainer---1BQ-9 {\n  display: -webkit-box;\n  display: -moz-flex;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: center;\n  -ms-flex-pack: center;\n  -moz-justify-content: center;\n  justify-content: center;\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n  -moz-align-items: center;\n  align-items: center;\n  -webkit-box-direction: normal;\n  -webkit-box-orient: vertical;\n  -moz-flex-direction: column;\n  -ms-flex-direction: column;\n  flex-direction: column;\n  outline: none;\n  -webkit-user-select: none;\n     -moz-user-select: none;\n      -ms-user-select: none;\n          user-select: none; }\n\n.icon---3YEAm {\n  width: 60px;\n  height: 75px;\n  margin-bottom: 31px; }\n\n.title---kufHk {\n  width: 90%;\n  padding: 25px;\n  color: #4e5c67;\n  font-family: Poppins;\n  font-size: 28px;\n  font-weight: 500;\n  text-align: center;\n  line-height: 27px; }\n\n.confirm---ED1u4 {\n  padding-top: 20px; }\n\n.container---s1D5_ {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  padding: 25px; }\n\n.ok---BZ8Uy, .cancel---21Laz {\n  position: relative;\n  display: inline-block;\n  width: 90px;\n  height: 90px;\n  border-radius: 45px;\n  margin: 10px;\n  background-color: #37c97c;\n  cursor: pointer;\n  outline: none; }\n\n.cancel---21Laz {\n  background-color: #c53902; }\n\n.okButtonDisabled---avdJN, .cancelButtonDisabled---2yBod {\n  position: relative;\n  display: inline-block;\n  width: 90px;\n  height: 90px;\n  border-radius: 45px;\n  margin: 10px;\n  background-color: #37c97c;\n  cursor: not-allowed;\n  outline: none;\n  opacity: 0.4; }\n\n.okButtonDisabled---avdJN :nth-child(3), .cancelButtonDisabled---2yBod :nth-child(3) {\n    display: none; }\n\n.cancelButtonDisabled---2yBod {\n  background-color: #c53902; }\n\n.iconClassName---1F2cr {\n  position: absolute;\n  top: 35%;\n  left: 35%;\n  width: 29px;\n  height: 32px; }\n\n.iconClassName---1F2cr path {\n    fill: white !important; }\n", ""]);

// exports
exports.locals = {
	"bulkPasswordChangeContainer": "bulkPasswordChangeContainer---1BQ-9",
	"icon": "icon---3YEAm",
	"title": "title---kufHk",
	"confirm": "confirm---ED1u4",
	"container": "container---s1D5_",
	"ok": "ok---BZ8Uy",
	"cancel": "cancel---21Laz",
	"okButtonDisabled": "okButtonDisabled---avdJN",
	"cancelButtonDisabled": "cancelButtonDisabled---2yBod",
	"iconClassName": "iconClassName---1F2cr"
};

/***/ }),
/* 1124 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(4)();
// imports


// module
exports.push([module.i, ".boxLight---2hoK0, .container---37Vwu {\n  display: -webkit-box;\n  display: -moz-flex;\n  display: -ms-flexbox;\n  display: flex; }\n\n.container---37Vwu {\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n  -moz-align-items: center;\n  align-items: center;\n  -webkit-box-pack: center;\n  -ms-flex-pack: center;\n  -moz-justify-content: center;\n  justify-content: center;\n  -webkit-box-shadow: 3px 3px 1px #e7e9ea;\n          box-shadow: 3px 3px 1px #e7e9ea;\n  min-width: 20%;\n  height: 36px;\n  border: 1px solid #e1e1e1;\n  border-radius: 5px;\n  margin-bottom: 14px;\n  background-color: #fff;\n  color: #4e5c67;\n  font-family: Poppins;\n  font-size: 14px;\n  font-weight: 500;\n  text-align: center;\n  cursor: pointer; }\n\n.wrapper---fx-pn {\n  width: 100%;\n  outline: none; }\n\n.wrapper---fx-pn span {\n    width: 80%;\n    -webkit-user-select: none;\n       -moz-user-select: none;\n        -ms-user-select: none;\n            user-select: none; }\n\n.icon---3zFgy {\n  width: 20px;\n  height: 21px;\n  margin-right: 10px;\n  float: right; }\n", ""]);

// exports
exports.locals = {
	"boxLight": "boxLight---2hoK0",
	"container": "container---37Vwu",
	"wrapper": "wrapper---fx-pn",
	"icon": "icon---3zFgy"
};

/***/ }),
/* 1125 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(4)();
// imports


// module
exports.push([module.i, ".component---1QTPR {\n  display: inline-block; }\n\n.componentDisabled---1Ifui {\n  cursor: not-allowed; }\n\n.buttonContainer---3Ctpt, .reverseButtonContainer---2hWzH, .buttonContainerDisabled---1Ho9p {\n  display: -webkit-box;\n  display: -moz-flex;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: center;\n  -ms-flex-pack: center;\n  -moz-justify-content: center;\n  justify-content: center;\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n  -moz-align-items: center;\n  align-items: center;\n  outline: none; }\n\n.reverseButtonContainer---2hWzH {\n  -ms-flex-flow: row-reverse wrap;\n  -webkit-box-orient: horizontal;\n  -webkit-box-direction: reverse;\n          flex-flow: row-reverse wrap; }\n\n.buttonContainerDisabled---1Ho9p {\n  opacity: 0.4;\n  pointer-events: none;\n  cursor: not-allowed; }\n\n/**\n * Rounded button\n */\n\n.dark---1A8ui, .denim---3SXJQ {\n  display: -webkit-box;\n  display: -moz-flex;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: center;\n  -ms-flex-pack: center;\n  -moz-justify-content: center;\n  justify-content: center;\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n  -moz-align-items: center;\n  align-items: center;\n  height: 45px;\n  min-width: 80px;\n  border: 1px solid #959595;\n  border-radius: 25px;\n  background-color: #415667;\n  color: #fff;\n  font-family: Poppins, sans-serif;\n  font-size: 16px;\n  font-weight: 500;\n  line-height: 1.2em; }\n\n.dark---1A8ui > div, .denim---3SXJQ > div {\n    padding: 9px 18px;\n    width: 100%;\n    height: 100%; }\n\n.dark---1A8ui > div > span, .denim---3SXJQ > div > span {\n    white-space: nowrap; }\n\n.light---3fZNV {\n  display: -webkit-box;\n  display: -moz-flex;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: center;\n  -ms-flex-pack: center;\n  -moz-justify-content: center;\n  justify-content: center;\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n  -moz-align-items: center;\n  align-items: center;\n  height: 40px;\n  width: auto;\n  border: 1px solid #e1e1e1;\n  background-color: #fff;\n  border-radius: 24px;\n  margin: auto;\n  text-align: center;\n  padding: 9px;\n  color: #444;\n  font-family: Poppins, sans-serif;\n  font-size: 16px;\n  font-weight: 500;\n  cursor: pointer; }\n\n.light---3fZNV > div {\n    width: 100%;\n    height: 100%; }\n\n.light---3fZNV > div > span {\n    white-space: nowrap; }\n\n.denim---3SXJQ {\n  border: 1px solid #1981c4;\n  background-color: #1981c4; }\n\n.defaultIcon---2UzRv, .darkIcon---17M66, .lightIcon---2HyJs {\n  width: 25px;\n  height: 25px;\n  margin: 7px; }\n\n.darkIcon---17M66 svg path {\n  fill: #fff !important; }\n\n.lightIcon---2HyJs svg path {\n  fill: #415667 !important; }\n\n/**\n * Circle button\n */\n\n.circleBtn---2JUxP, .circleSuccess---3rbB_, .circleDanger---29XAW {\n  height: 90px;\n  width: 90px;\n  border-radius: 90px;\n  background-color: #5cb85c; }\n\n.circleSuccess---3rbB_ {\n  background-color: #5cb85c; }\n\n.circleIconSvg---2ik4p {\n  width: 40px;\n  height: 40px;\n  margin: 22px; }\n\n.circleIconSvg---2ik4p svg path {\n    fill: white !important; }\n\n.circleDanger---29XAW {\n  background-color: #c53902; }\n\n/**\n * Icon only button\n */\n\n.iconOnly---2p_vJ {\n  width: 20px;\n  height: 21px; }\n\n.iconOnlySvg----thXv {\n  width: 100%;\n  height: 100%; }\n\n.iconOnlySvg----thXv svg path {\n    fill: #1981c4 !important; }\n", ""]);

// exports
exports.locals = {
	"component": "component---1QTPR",
	"componentDisabled": "componentDisabled---1Ifui",
	"buttonContainer": "buttonContainer---3Ctpt",
	"reverseButtonContainer": "reverseButtonContainer---2hWzH",
	"buttonContainerDisabled": "buttonContainerDisabled---1Ho9p",
	"dark": "dark---1A8ui",
	"denim": "denim---3SXJQ",
	"light": "light---3fZNV",
	"defaultIcon": "defaultIcon---2UzRv",
	"darkIcon": "darkIcon---17M66",
	"lightIcon": "lightIcon---2HyJs",
	"circleBtn": "circleBtn---2JUxP",
	"circleSuccess": "circleSuccess---3rbB_",
	"circleDanger": "circleDanger---29XAW",
	"circleIconSvg": "circleIconSvg---2ik4p",
	"iconOnly": "iconOnly---2p_vJ",
	"iconOnlySvg": "iconOnlySvg----thXv"
};

/***/ }),
/* 1126 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(4)();
// imports


// module
exports.push([module.i, ".circleWithIcon---1QlP2 {\n  height: 100%;\n  width: 100%;\n  border-radius: 100%;\n  background: #1c7fc3; }\n\n.icon---3f9Mp {\n  width: 50%;\n  padding-top: 5px; }\n\n.icon---3f9Mp svg path {\n    fill: white !important; }\n", ""]);

// exports
exports.locals = {
	"circleWithIcon": "circleWithIcon---1QlP2",
	"icon": "icon---3f9Mp"
};

/***/ }),
/* 1127 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(4)();
// imports


// module
exports.push([module.i, ".changeCourseContainer---1L3t9 {\n  display: -webkit-box;\n  display: -moz-flex;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: center;\n  -ms-flex-pack: center;\n  -moz-justify-content: center;\n  justify-content: center;\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n  -moz-align-items: center;\n  align-items: center;\n  -webkit-box-direction: normal;\n  -webkit-box-orient: vertical;\n  -moz-flex-direction: column;\n  -ms-flex-direction: column;\n  flex-direction: column;\n  padding: 75px 0;\n  outline: none;\n  position: relative; }\n\n.header---1cqP4 {\n  width: 90%;\n  min-height: 22px;\n  margin: 33px;\n  color: #4e5c67;\n  font-family: Poppins;\n  font-size: 28px;\n  font-weight: 500;\n  line-height: 1.2em;\n  text-align: center; }\n\n.header---1cqP4 span {\n    color: #32a8a7; }\n\n.description---1ZgjK {\n  margin-bottom: 20px;\n  font-size: 18px;\n  color: #4e5c67;\n  line-height: 1.3em; }\n\n.icon---3GxB9 {\n  width: 80px;\n  height: 75px; }\n\n.buttons---6HaB7 {\n  display: -webkit-box;\n  display: -moz-flex;\n  display: -ms-flexbox;\n  display: flex; }\n\n.buttons---6HaB7 > div {\n    margin: 5px; }\n", ""]);

// exports
exports.locals = {
	"changeCourseContainer": "changeCourseContainer---1L3t9",
	"header": "header---1cqP4",
	"description": "description---1ZgjK",
	"icon": "icon---3GxB9",
	"buttons": "buttons---6HaB7"
};

/***/ }),
/* 1128 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(4)();
// imports


// module
exports.push([module.i, ".changeCourseContainer---3hQtD {\n  display: -webkit-box;\n  display: -moz-flex;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: center;\n  -ms-flex-pack: center;\n  -moz-justify-content: center;\n  justify-content: center;\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n  -moz-align-items: center;\n  align-items: center;\n  -webkit-box-direction: normal;\n  -webkit-box-orient: vertical;\n  -moz-flex-direction: column;\n  -ms-flex-direction: column;\n  flex-direction: column;\n  position: relative;\n  outline: none; }\n  .changeCourseContainer---3hQtD .hidden---ZA7e4 {\n    display: none; }\n  .title---1BGco {\n  width: 90%;\n  height: auto;\n  margin: 33px 33px 50px;\n  color: #4e5c67;\n  font-family: Poppins;\n  font-size: 28px;\n  font-weight: 500;\n  line-height: 1.2em;\n  text-align: center; }\n  .title---1BGco .course---36jwt {\n    color: #1981c4; }\n  .titleSub---145_u {\n    font-size: 18px; }\n  .changeCourseContainer---3hQtD select {\n  border: 1px solid #c2cfda;\n  color: #4e5c67;\n  font-size: 25px;\n  margin-top: 20px;\n  margin-bottom: 30px;\n  min-width: 450px;\n  max-width: 500px; }\n  .topSpacing---j3LUI, .actionButtonWrapper---jjmdJ {\n  padding-top: 10px; }\n  .actionButtonWrapper---jjmdJ {\n  display: -webkit-box;\n  display: -moz-flex;\n  display: -ms-flexbox;\n  display: flex; }\n  .actionClickable---_Y-CW {\n  background-color: #1981c4 !important;\n  color: #fff !important; }\n  .actionClickable---_Y-CW svg path {\n    fill: white !important; }\n  .actionUnclickable---38rGZ * {\n  cursor: not-allowed !important; }\n  .btnSuccess---2iId-,\n.btnDanger---3UfbB {\n  margin: 5px; }\n  .buttonWrapper---1pzXe {\n  display: -webkit-box;\n  display: -moz-flex;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n  -moz-align-items: center;\n  align-items: center;\n  -webkit-box-pack: center;\n  -ms-flex-pack: center;\n  -moz-justify-content: center;\n  justify-content: center;\n  -webkit-box-shadow: 3px 3px 1px #e7e9ea;\n          box-shadow: 3px 3px 1px #e7e9ea;\n  min-width: 20%;\n  height: 36px;\n  border: 1px solid #e1e1e1;\n  border-radius: 5px;\n  margin-bottom: 14px;\n  background-color: #fff;\n  color: #4e5c67;\n  font-family: Poppins;\n  font-size: 14px;\n  font-weight: 500;\n  text-align: center;\n  cursor: pointer; }\n  .buttonSelectors---13Mmy {\n  display: -webkit-box;\n  display: -moz-flex;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: center;\n  -ms-flex-pack: center;\n  -moz-justify-content: center;\n  justify-content: center;\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n  -moz-align-items: center;\n  align-items: center;\n  -webkit-box-direction: normal;\n  -webkit-box-orient: vertical;\n  -moz-flex-direction: column;\n  -ms-flex-direction: column;\n  flex-direction: column;\n  outline: none;\n  width: 100%; }\n  .buttonSelector---1fG05 {\n  width: 500px;\n  margin-right: 2px;\n  margin-left: 2px;\n  padding-left: 5px; }\n  .buttonContainer---18nBi {\n  width: 100%;\n  outline: none; }\n  .buttonContainer---18nBi span {\n    width: 80%;\n    -webkit-user-select: none;\n       -moz-user-select: none;\n        -ms-user-select: none;\n            user-select: none; }\n  .buttonIcon---HBIGc {\n  width: 20px;\n  height: 21px;\n  margin-left: 5px;\n  margin-right: 10px;\n  float: right; }\n  .svgIconContainer---2tRdL {\n  width: 40px;\n  height: 40px;\n  margin: 22px; }\n  .svgIconContainer---2tRdL svg path {\n    fill: white !important; }\n  .courseSelectorWrapper---3q_Wu {\n  display: -webkit-box;\n  display: -moz-flex;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: center;\n  -ms-flex-pack: center;\n  -moz-justify-content: center;\n  justify-content: center;\n  margin-top: 30px; }\n  .courseSelectorWrapper---3q_Wu label {\n    margin-bottom: 0;\n    margin-left: 5px;\n    cursor: pointer; }\n  .customCoursesWrapper---5gIAb, .curriculumCoursesWrapper---3OcHX {\n  display: -webkit-box;\n  display: -moz-flex;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: start;\n  -ms-flex-pack: start;\n  -moz-justify-content: flex-start;\n  justify-content: flex-start;\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n  -moz-align-items: center;\n  align-items: center;\n  margin: 7px 0; }\n  .curriculumCoursesWrapper---3OcHX {\n  margin-left: 15px; }\n", ""]);

// exports
exports.locals = {
	"changeCourseContainer": "changeCourseContainer---3hQtD",
	"hidden": "hidden---ZA7e4",
	"title": "title---1BGco",
	"course": "course---36jwt",
	"titleSub": "titleSub---145_u",
	"topSpacing": "topSpacing---j3LUI",
	"actionButtonWrapper": "actionButtonWrapper---jjmdJ",
	"actionClickable": "actionClickable---_Y-CW",
	"actionUnclickable": "actionUnclickable---38rGZ",
	"btnSuccess": "btnSuccess---2iId-",
	"btnDanger": "btnDanger---3UfbB",
	"buttonWrapper": "buttonWrapper---1pzXe",
	"buttonSelectors": "buttonSelectors---13Mmy",
	"buttonSelector": "buttonSelector---1fG05",
	"buttonContainer": "buttonContainer---18nBi",
	"buttonIcon": "buttonIcon---HBIGc",
	"svgIconContainer": "svgIconContainer---2tRdL",
	"courseSelectorWrapper": "courseSelectorWrapper---3q_Wu",
	"customCoursesWrapper": "customCoursesWrapper---5gIAb",
	"curriculumCoursesWrapper": "curriculumCoursesWrapper---3OcHX"
};

/***/ }),
/* 1129 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(4)();
// imports


// module
exports.push([module.i, ".component---HPz4V {\n  display: block;\n  margin: 10px; }\n", ""]);

// exports
exports.locals = {
	"component": "component---HPz4V"
};

/***/ }),
/* 1130 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(4)();
// imports


// module
exports.push([module.i, ".classConfirmationContainer---2UCAF {\n  display: -webkit-box;\n  display: -moz-flex;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: center;\n  -ms-flex-pack: center;\n  -moz-justify-content: center;\n  justify-content: center;\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n  -moz-align-items: center;\n  align-items: center;\n  -webkit-box-direction: normal;\n  -webkit-box-orient: vertical;\n  -moz-flex-direction: column;\n  -ms-flex-direction: column;\n  flex-direction: column;\n  outline: none; }\n\n.icon---c3K6w {\n  width: 80px;\n  height: 75px; }\n\n.title---1YUhn {\n  width: 90%;\n  min-height: 22px;\n  margin: 33px;\n  color: #4e5c67;\n  font-family: Poppins;\n  font-size: 28px;\n  font-weight: 500;\n  line-height: 1.2em;\n  text-align: center; }\n\n.title---1YUhn span {\n    color: #1981c4; }\n\n.buttonWrapper---20VHU {\n  min-width: 120px; }\n\n@media screen and (max-width: 1000px) {\n  .buttonWrapper---20VHU {\n    min-width: 30%; } }\n", ""]);

// exports
exports.locals = {
	"classConfirmationContainer": "classConfirmationContainer---2UCAF",
	"icon": "icon---c3K6w",
	"title": "title---1YUhn",
	"buttonWrapper": "buttonWrapper---20VHU"
};

/***/ }),
/* 1131 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(4)();
// imports


// module
exports.push([module.i, ".light---xwBY3, .bold---3TFEO {\n  color: #5c6c7f; }\n\n.bold---3TFEO {\n  font-weight: 600; }\n", ""]);

// exports
exports.locals = {
	"light": "light---xwBY3",
	"bold": "bold---3TFEO"
};

/***/ }),
/* 1132 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(4)();
// imports


// module
exports.push([module.i, ".dropDownContainer---3AC2R {\n  position: relative;\n  display: table;\n  width: 100%;\n  border-radius: 2px;\n  background: #fff; }\n  .dropDownContainer---3AC2R select:disabled,\n  .dropDownContainer---3AC2R select[disabled], .dropDownContainer---3AC2R.disabled---2UOhv {\n    opacity: 0.5; }\n  .dropDownContainer---3AC2R.large---1HsBi select {\n    font-size: 23px;\n    color: #4e5c67; }\n  .dropDownContainer---3AC2R.large---1HsBi::after {\n    margin-top: -6px; }\n  .dropDownContainer---3AC2R select {\n    line-height: 1.3;\n    border-radius: 0.2em;\n    width: 100%;\n    margin: 0;\n    outline: none;\n    padding: 0.55em 0.8em 0.45em;\n    -webkit-box-sizing: border-box;\n    box-sizing: border-box;\n    font-size: 16px;\n    font-weight: 500; }\n  .dropDownContainer---3AC2R select:focus {\n      outline: none; }\n  .dropDownContainer---3AC2R::after {\n    width: 0;\n    height: 0;\n    border-left: 8px solid transparent;\n    border-right: 8px solid transparent;\n    border-top: 10px solid #666;\n    margin-top: -1px;\n    content: \" \";\n    position: absolute;\n    top: 50%;\n    right: 1em;\n    z-index: 2;\n    pointer-events: none;\n    display: none; }\n  .dropDownContainer---3AC2R::after {\n  display: block; }\n  .dropDownContainer---3AC2R select {\n  padding-right: 3em;\n  background: none;\n  border: 1px solid #e7e9ea;\n  -webkit-appearance: none;\n  -moz-appearance: none;\n  appearance: none; }\n  @media screen and (-ms-high-contrast: active), (-ms-high-contrast: none) {\n  .dropDownContainer---3AC2R select::-ms-expand {\n    display: none; }\n  .dropDownContainer---3AC2R select:focus {\n    border-color: #e7e9ea; }\n  .dropDownContainer---3AC2R select:focus::-ms-value {\n    background: transparent;\n    color: #222; }\n  .dropDownContainer---3AC2R select {\n    padding-right: 2em;\n    background: none;\n    border: 1px solid #e7e9ea; }\n  .dropDownContainer---3AC2R::after {\n    display: block; } }\n", ""]);

// exports
exports.locals = {
	"dropDownContainer": "dropDownContainer---3AC2R",
	"disabled": "disabled---2UOhv",
	"large": "large---1HsBi"
};

/***/ }),
/* 1133 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(4)();
// imports


// module
exports.push([module.i, ".classDetailComponent---1HX2p {\n  display: -webkit-box;\n  display: -moz-flex;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-direction: normal;\n  -webkit-box-orient: vertical;\n  -moz-flex-direction: column;\n  -ms-flex-direction: column;\n  flex-direction: column;\n  -webkit-box-shadow: 5px 5px 1px rgba(179, 179, 179, .3);\n          box-shadow: 5px 5px 1px rgba(179, 179, 179, .3);\n  min-height: 300px;\n  padding: 20px;\n  border-radius: 10px;\n  margin-bottom: 50px;\n  background-color: #fff;\n  font-family: Poppins, sans-serif;\n  font-size: 18px;\n  font-weight: 500;\n  outline: none; }\n\n.title---9rg6b {\n  margin-bottom: 10px;\n  color: #32a8a7; }\n\n.label---3RQlZ {\n  margin-right: 10px;\n  color: #4e5c67;\n  font-family: Poppins;\n  font-size: 13px;\n  font-weight: 500;\n  line-height: 25px; }\n\n.panel---31RZe {\n  padding-bottom: 20px;\n  border-bottom: 1px solid #adb6bc;\n  margin-top: 15px;\n  margin-bottom: 20px; }\n\n.input---xIwsP {\n  display: -webkit-inline-box;\n  display: -moz-inline-flex;\n  display: -ms-inline-flexbox;\n  display: inline-flex;\n  margin-right: 60px;\n  font-size: 13px; }\n\n.studentColumn---i9gZ9 {\n  display: -webkit-inline-box;\n  display: -moz-inline-flex;\n  display: -ms-inline-flexbox;\n  display: inline-flex;\n  float: right;\n  height: 25px;\n  min-height: 1px;\n  color: #415667;\n  margin-right: 7%; }\n\n.studentCountIcon---1nlWp {\n  float: left;\n  width: 14px;\n  margin-right: 2px;\n  opacity: 0.3; }\n\n.list---3-vpU {\n  display: -webkit-inline-box;\n  display: -moz-inline-flex;\n  display: -ms-inline-flexbox;\n  display: inline-flex;\n  width: 20%; }\n\n/* Medium screens */\n\n@media all and (max-width: 1100px) {\n  .list---3-vpU {\n    display: -webkit-inline-box;\n    display: -moz-inline-flex;\n    display: -ms-inline-flexbox;\n    display: inline-flex;\n    width: 12%; }\n  .input---xIwsP {\n    display: -webkit-inline-box;\n    display: -moz-inline-flex;\n    display: -ms-inline-flexbox;\n    display: inline-flex;\n    margin-right: 20px; } }\n", ""]);

// exports
exports.locals = {
	"classDetailComponent": "classDetailComponent---1HX2p",
	"title": "title---9rg6b",
	"label": "label---3RQlZ",
	"panel": "panel---31RZe",
	"input": "input---xIwsP",
	"studentColumn": "studentColumn---i9gZ9",
	"studentCountIcon": "studentCountIcon---1nlWp",
	"list": "list---3-vpU"
};

/***/ }),
/* 1134 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(4)();
// imports


// module
exports.push([module.i, ".inputText---37djw, .disabled---mxQl9 {\n  height: 38px;\n  width: 375px;\n  padding: 12px 22px;\n  border: 1px solid #e7e9ea;\n  border-radius: 4px;\n  color: #4e5c67;\n  font-family: Poppins;\n  font-weight: 500;\n  line-height: 27px;\n  outline: none; }\n\n.disabled---mxQl9 {\n  opacity: 0.4;\n  cursor: not-allowed; }\n", ""]);

// exports
exports.locals = {
	"inputText": "inputText---37djw",
	"disabled": "disabled---mxQl9"
};

/***/ }),
/* 1135 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(4)();
// imports


// module
exports.push([module.i, ".classSearchContainer---2J4qQ {\n  display: -webkit-box;\n  display: -moz-flex;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n  -moz-align-items: center;\n  align-items: center;\n  -webkit-box-pack: end;\n  -ms-flex-pack: end;\n  -moz-justify-content: flex-end;\n  justify-content: flex-end;\n  margin-left: 17px;\n  padding: 8px; }\n\n.filterContainer---W0EgJ {\n  display: -webkit-box;\n  display: -moz-flex;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n  -moz-align-items: center;\n  align-items: center;\n  -webkit-box-pack: center;\n  -ms-flex-pack: center;\n  -moz-justify-content: center;\n  justify-content: center;\n  width: 100%;\n  min-height: 80px;\n  background-color: #cfd2d4;\n  outline: none; }\n\n.filters---3p4K_ {\n  display: -webkit-box;\n  display: -moz-flex;\n  display: -ms-flexbox;\n  display: flex;\n  margin: 10px; }\n\n.year---1m4Ex {\n  min-width: 92px;\n  padding: 8px; }\n\n.teachers---28PIv {\n  min-width: 112px;\n  padding: 8px; }\n\n.clear---3WJ_d {\n  width: 77px; }\n", ""]);

// exports
exports.locals = {
	"classSearchContainer": "classSearchContainer---2J4qQ",
	"filterContainer": "filterContainer---W0EgJ",
	"filters": "filters---3p4K_",
	"year": "year---1m4Ex",
	"teachers": "teachers---28PIv",
	"clear": "clear---3WJ_d"
};

/***/ }),
/* 1136 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(4)();
// imports


// module
exports.push([module.i, ".classFooterComponent---2Z397 {\n  position: fixed;\n  left: 0;\n  bottom: 0;\n  width: 100%;\n  min-height: 80px;\n  padding: 20px;\n  background-color: #adb6bc; }\n\n.buttonContainer---vJE1V {\n  display: -webkit-box;\n  display: -moz-flex;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n  -moz-align-items: center;\n  align-items: center;\n  -webkit-box-pack: end;\n  -ms-flex-pack: end;\n  -moz-justify-content: flex-end;\n  justify-content: flex-end;\n  -webkit-box-flex: 1;\n  -moz-flex: 1;\n  -ms-flex: 1;\n  flex: 1; }\n\n.footerButton---3PbYh,\n.downloadSignInCards---10-GK {\n  margin-left: 10px; }\n\n.iconClassName---3BxFp {\n  height: 40px;\n  width: 1px; }\n", ""]);

// exports
exports.locals = {
	"classFooterComponent": "classFooterComponent---2Z397",
	"buttonContainer": "buttonContainer---vJE1V",
	"footerButton": "footerButton---3PbYh",
	"downloadSignInCards": "downloadSignInCards---10-GK",
	"iconClassName": "iconClassName---3BxFp"
};

/***/ }),
/* 1137 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(4)();
// imports


// module
exports.push([module.i, ".classHeaderComponent---1Cgst {\n  display: -webkit-box;\n  display: -moz-flex;\n  display: -ms-flexbox;\n  display: flex;\n  font-family: Poppins, sans-serif;\n  min-height: 70px;\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n  -moz-align-items: center;\n  align-items: center;\n  background-color: #e7e9ea;\n  -webkit-box-pack: justify;\n  -ms-flex-pack: justify;\n  -moz-justify-content: space-between;\n  justify-content: space-between; }\n\n.buttonContainer---38r5n {\n  display: -webkit-box;\n  display: -moz-flex;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n  -moz-align-items: center;\n  align-items: center;\n  margin-right: 25px;\n  -webkit-box-pack: end;\n  -ms-flex-pack: end;\n  -moz-justify-content: flex-end;\n  justify-content: flex-end; }\n\n.buttonContainer---38r5n > div {\n    margin-left: 10px; }\n\n/* Medium screens */\n\n@media all and (max-width: 800px) {\n  .buttonContainer---38r5n {\n    -ms-flex-pack: distribute;\n    -moz-justify-content: space-around;\n    justify-content: space-around; } }\n\n/* Small screens */\n\n@media all and (max-width: 500px) {\n  .buttonContainer---38r5n {\n    -webkit-box-direction: normal;\n    -webkit-box-orient: vertical;\n    -moz-flex-direction: column;\n    -ms-flex-direction: column;\n    flex-direction: column; } }\n\n.svgIconContainer---YFnw2 {\n  width: 25px;\n  height: 25px;\n  margin: 7px; }\n\n.svgIconContainer---YFnw2 svg path {\n    fill: white !important; }\n\n.bulkUpload---nHSfU {\n  display: none; }\n\n@media (min-width: 1025px) {\n    .bulkUpload---nHSfU {\n      display: -webkit-box;\n      display: -ms-flexbox;\n      display: flex; } }\n\n.classesCountContainer---2VUyO {\n  margin-left: 25px;\n  display: -webkit-box;\n  display: -moz-flex;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n  -moz-align-items: center;\n  align-items: center;\n  -webkit-box-pack: start;\n  -ms-flex-pack: start;\n  -moz-justify-content: flex-start;\n  justify-content: flex-start;\n  -webkit-box-direction: normal;\n  -webkit-box-orient: horizontal;\n  -moz-flex-direction: row;\n  -ms-flex-direction: row;\n  flex-direction: row;\n  -webkit-box-flex: 1;\n  -moz-flex: 1;\n  -ms-flex: 1;\n  flex: 1; }\n\n.classesFontBase---2oggY, .classesCount---1xsuA, .classesTitle---1XGgW {\n  font-family: Poppins, sans-serif;\n  color: #415667;\n  font-weight: 500; }\n\n.classesCount---1xsuA {\n  font-size: 20px;\n  margin-left: 5px;\n  display: -webkit-box;\n  display: -moz-flex;\n  display: -ms-flexbox;\n  display: flex; }\n\n.classesTitle---1XGgW {\n  height: 23px;\n  width: 100%;\n  font-size: 26px;\n  line-height: 27px;\n  display: -webkit-box;\n  display: -moz-flex;\n  display: -ms-flexbox;\n  display: flex; }\n", ""]);

// exports
exports.locals = {
	"classHeaderComponent": "classHeaderComponent---1Cgst",
	"buttonContainer": "buttonContainer---38r5n",
	"svgIconContainer": "svgIconContainer---YFnw2",
	"bulkUpload": "bulkUpload---nHSfU",
	"classesCountContainer": "classesCountContainer---2VUyO",
	"classesFontBase": "classesFontBase---2oggY",
	"classesCount": "classesCount---1xsuA",
	"classesTitle": "classesTitle---1XGgW"
};

/***/ }),
/* 1138 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(4)();
// imports


// module
exports.push([module.i, ".classRollComponent---3sLhT, .class---11Zj- {\n  display: -webkit-box;\n  display: -moz-flex;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-flex: 10;\n  -moz-flex: 10;\n  -ms-flex: 10;\n  flex: 10;\n  -webkit-box-direction: normal;\n  -webkit-box-orient: vertical;\n  -moz-flex-direction: column;\n  -ms-flex-direction: column;\n  flex-direction: column;\n  background-color: #e7e9ea;\n  height: 100%; }\n\n.classListContainer---1k602 {\n  display: -webkit-box;\n  display: -moz-flex;\n  display: -ms-flexbox;\n  display: flex;\n  font-family: Poppins;\n  margin: 0 25px;\n  padding: 20px 20px 100px;\n  background: #fff;\n  -webkit-box-shadow: 5px 5px 0 0 rgba(0, 0, 0, .07);\n          box-shadow: 5px 5px 0 0 rgba(0, 0, 0, .07);\n  min-height: 70vh;\n  -webkit-box-direction: normal;\n  -webkit-box-orient: vertical;\n  -moz-flex-direction: column;\n  -ms-flex-direction: column;\n  flex-direction: column;\n  -webkit-box-align: start;\n  -ms-flex-align: start;\n  -moz-align-items: flex-start;\n  align-items: flex-start;\n  -webkit-box-pack: start;\n  -ms-flex-pack: start;\n  -moz-justify-content: flex-start;\n  justify-content: flex-start;\n  -webkit-box-flex: 1;\n  -moz-flex-grow: 1;\n  -ms-flex-positive: 1;\n  flex-grow: 1; }\n\n.class---11Zj- {\n  z-index: 100001; }\n\n.loadingContainer---3_VYJ {\n  height: 100%;\n  width: 100%;\n  display: -webkit-box;\n  display: -moz-flex;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: center;\n  -ms-flex-pack: center;\n  -moz-justify-content: center;\n  justify-content: center;\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n  -moz-align-items: center;\n  align-items: center;\n  -webkit-box-flex: 1;\n  -moz-flex-grow: 1;\n  -ms-flex-positive: 1;\n  flex-grow: 1; }\n\n.loader---1dwxh > div {\n  background-color: #4e5c67 !important;\n  width: 16px !important;\n  height: 16px !important;\n  margin: 4px !important; }\n", ""]);

// exports
exports.locals = {
	"classRollComponent": "classRollComponent---3sLhT",
	"class": "class---11Zj-",
	"classListContainer": "classListContainer---1k602",
	"loadingContainer": "loadingContainer---3_VYJ",
	"loader": "loader---1dwxh"
};

/***/ }),
/* 1139 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(4)();
// imports


// module
exports.push([module.i, ".header---2ywrA {\n  display: -webkit-box;\n  display: -moz-flex;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n  -moz-align-items: center;\n  align-items: center;\n  -webkit-box-pack: space-evenly;\n  -ms-flex-pack: space-evenly;\n  -moz-justify-content: space-evenly;\n  justify-content: space-evenly;\n  padding-bottom: 10px;\n  border-bottom: 1px solid #e1e1e1;\n  margin-bottom: 24px;\n  color: #415667;\n  font-family: Poppins;\n  font-size: 13px;\n  font-weight: 600; }\n\n.columns---336ID, .upfColumn---fkUkU, .newCoursesColumn---eOmFB {\n  float: left;\n  width: 26%;\n  min-height: 1px;\n  padding-right: 15px;\n  color: #415667;\n  word-wrap: break-word; }\n\n.upfColumn---fkUkU {\n  min-width: 200px; }\n\n.newCoursesColumn---eOmFB {\n  min-width: 200px; }\n\n.studentColumn---26sjd {\n  color: #415667;\n  width: 5%;\n  min-height: 1px;\n  padding-right: 15px;\n  padding-top: 5px; }\n\n.editColumn---3-2ZG {\n  width: 10%;\n  min-height: 1px;\n  -webkit-box-align: right;\n  -ms-flex-align: right;\n  -moz-align-items: right;\n  align-items: right; }\n\n.list---1y3jf {\n  display: -webkit-box;\n  display: -moz-flex;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: space-evenly;\n  -ms-flex-pack: space-evenly;\n  -moz-justify-content: space-evenly;\n  justify-content: space-evenly;\n  width: 100%;\n  padding-bottom: 10px;\n  margin-bottom: 1px;\n  color: #4e5c67;\n  font-family: Poppins;\n  font-size: 13px;\n  font-weight: 500; }\n\n.buttonContainerStyle---3df_S {\n  width: 36px;\n  height: 26px;\n  border-radius: 15px;\n  background-color: #415667;\n  -webkit-user-select: none;\n     -moz-user-select: none;\n      -ms-user-select: none;\n          user-select: none; }\n\n.downloadSignInCards---3KsLb, .createGroup---2zbvc {\n  min-width: 200px;\n  max-width: 350px;\n  height: 36px;\n  padding: 5px 10px 0;\n  border-radius: 18px;\n  font-size: 14px;\n  background-color: #415667;\n  color: #fff;\n  -webkit-user-select: none;\n     -moz-user-select: none;\n      -ms-user-select: none;\n          user-select: none; }\n\n.createGroup---2zbvc {\n  width: 157px;\n  margin-left: 10px; }\n\n.icon---2dd9n {\n  width: 16px;\n  height: 17px;\n  margin: 5px; }\n\n.icon---2dd9n path {\n    fill: white !important; }\n\n.footer---2SfX2 {\n  display: -webkit-box;\n  display: -moz-flex;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: end;\n  -ms-flex-pack: end;\n  -moz-justify-content: flex-end;\n  justify-content: flex-end;\n  margin-top: 30px; }\n\n.studentCountIcon---2QPGt {\n  float: left;\n  width: 14px;\n  height: 15px;\n  margin-right: 2px;\n  opacity: 1; }\n", ""]);

// exports
exports.locals = {
	"header": "header---2ywrA",
	"columns": "columns---336ID",
	"upfColumn": "upfColumn---fkUkU",
	"newCoursesColumn": "newCoursesColumn---eOmFB",
	"studentColumn": "studentColumn---26sjd",
	"editColumn": "editColumn---3-2ZG",
	"list": "list---1y3jf",
	"buttonContainerStyle": "buttonContainerStyle---3df_S",
	"downloadSignInCards": "downloadSignInCards---3KsLb",
	"createGroup": "createGroup---2zbvc",
	"icon": "icon---2dd9n",
	"footer": "footer---2SfX2",
	"studentCountIcon": "studentCountIcon---2QPGt"
};

/***/ }),
/* 1140 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(4)();
// imports


// module
exports.push([module.i, ".confirmationMessageContainer---MvdRl {\n  display: -webkit-box;\n  display: -moz-flex;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: center;\n  -ms-flex-pack: center;\n  -moz-justify-content: center;\n  justify-content: center;\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n  -moz-align-items: center;\n  align-items: center;\n  -webkit-box-direction: normal;\n  -webkit-box-orient: vertical;\n  -moz-flex-direction: column;\n  -ms-flex-direction: column;\n  flex-direction: column;\n  outline: none;\n  color: #4e5c67;\n  background: #fff; }\n\n.icon---jnR4S {\n  width: 60px;\n  height: 75px;\n  margin-bottom: 15px; }\n\n.success---2nmze {\n  width: 90%;\n  color: #4e5c67;\n  font-family: Poppins;\n  font-size: 28px;\n  font-weight: 500;\n  text-align: center; }\n\n.recordsMessage---wJQQq {\n  width: 90%;\n  margin: 15px;\n  color: #4e5c67;\n  font-family: Poppins;\n  font-size: 20px;\n  line-height: 27px;\n  text-align: center; }\n\n.records---2R-7j {\n  color: #32a8a7; }\n\n.okButton---3nA_d {\n  -webkit-box-shadow: none;\n          box-shadow: none;\n  border-radius: 22px;\n  margin-top: 15px;\n  background-color: #415667;\n  width: 95px;\n  height: 45px;\n  border: none;\n  color: white;\n  font-size: 16px;\n  font-weight: 500;\n  outline: none; }\n", ""]);

// exports
exports.locals = {
	"confirmationMessageContainer": "confirmationMessageContainer---MvdRl",
	"icon": "icon---jnR4S",
	"success": "success---2nmze",
	"recordsMessage": "recordsMessage---wJQQq",
	"records": "records---2R-7j",
	"okButton": "okButton---3nA_d"
};

/***/ }),
/* 1141 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(4)();
// imports


// module
exports.push([module.i, ".confirmationMessageContainer---2pt-N {\n  display: -webkit-box;\n  display: -moz-flex;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: center;\n  -ms-flex-pack: center;\n  -moz-justify-content: center;\n  justify-content: center;\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n  -moz-align-items: center;\n  align-items: center;\n  -webkit-box-direction: normal;\n  -webkit-box-orient: vertical;\n  -moz-flex-direction: column;\n  -ms-flex-direction: column;\n  flex-direction: column;\n  position: relative;\n  color: #4e5c67; }\n\n.icon---XvyCX {\n  width: 60px;\n  height: 75px;\n  margin-bottom: 31px; }\n\n.title---3I9d2 {\n  width: 90%;\n  color: #4e5c67;\n  font-family: Poppins;\n  margin-top: 20px;\n  margin-bottom: 20px;\n  font-size: 28px;\n  font-weight: 500;\n  text-align: center;\n  line-height: 40px; }\n\n.message---JYCBl {\n  width: 60%;\n  margin-top: 10px;\n  margin-bottom: 45px;\n  color: black;\n  font-family: Poppins;\n  font-size: 20px;\n  text-align: center;\n  line-height: 27px; }\n\n.highlight---1TRh7 {\n  color: #32a8a7; }\n\n.confirm---2RKz0 {\n  padding-top: 20px;\n  color: #4e5c67; }\n\n.container---3w5wB {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex; }\n\n.ok---1m5xA, .cancel---3Aa4v {\n  position: relative;\n  display: inline-block;\n  width: 90px;\n  height: 90px;\n  border-radius: 45px;\n  margin: 10px;\n  background-color: #37c97c;\n  cursor: pointer;\n  outline: none; }\n\n.cancel---3Aa4v {\n  background-color: #c53902; }\n\n.okButtonDisabled---2YGF3, .cancelButtonDisabled---2cShx {\n  position: relative;\n  display: inline-block;\n  width: 90px;\n  height: 90px;\n  border-radius: 45px;\n  margin: 10px;\n  background-color: #37c97c;\n  cursor: not-allowed;\n  outline: none;\n  opacity: 0.4; }\n\n.okButtonDisabled---2YGF3 :nth-child(3), .cancelButtonDisabled---2cShx :nth-child(3) {\n    display: none; }\n\n.cancelButtonDisabled---2cShx {\n  background-color: #c53902; }\n\n.iconClassName---3I32c {\n  position: absolute;\n  top: 35%;\n  left: 35%;\n  width: 29px;\n  height: 32px; }\n\n.iconClassName---3I32c path {\n    fill: white !important; }\n\n.buttonClose---NEn9R {\n  position: absolute;\n  right: 10%;\n  top: 0; }\n", ""]);

// exports
exports.locals = {
	"confirmationMessageContainer": "confirmationMessageContainer---2pt-N",
	"icon": "icon---XvyCX",
	"title": "title---3I9d2",
	"message": "message---JYCBl",
	"highlight": "highlight---1TRh7",
	"confirm": "confirm---2RKz0",
	"container": "container---3w5wB",
	"ok": "ok---1m5xA",
	"cancel": "cancel---3Aa4v",
	"okButtonDisabled": "okButtonDisabled---2YGF3",
	"cancelButtonDisabled": "cancelButtonDisabled---2cShx",
	"iconClassName": "iconClassName---3I32c",
	"buttonClose": "buttonClose---NEn9R"
};

/***/ }),
/* 1142 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(4)();
// imports


// module
exports.push([module.i, ".confirmationMessageContainer---1v9ZM {\n  display: -webkit-box;\n  display: -moz-flex;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: center;\n  -ms-flex-pack: center;\n  -moz-justify-content: center;\n  justify-content: center;\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n  -moz-align-items: center;\n  align-items: center;\n  -webkit-box-direction: normal;\n  -webkit-box-orient: vertical;\n  -moz-flex-direction: column;\n  -ms-flex-direction: column;\n  flex-direction: column;\n  outline: none;\n  -webkit-user-select: none;\n     -moz-user-select: none;\n      -ms-user-select: none;\n          user-select: none; }\n\n.icon---3TlbS {\n  width: 60px;\n  height: 75px;\n  margin-bottom: 31px; }\n\n.title---1uJgu {\n  width: 90%;\n  color: #4e5c67;\n  font-family: Poppins;\n  font-size: 28px;\n  font-weight: 500;\n  text-align: center;\n  line-height: 27px; }\n\n.message---d0IxF {\n  width: 50%;\n  margin: 45px;\n  color: black;\n  font-family: Poppins;\n  font-size: 20px;\n  text-align: center;\n  line-height: 27px; }\n\n.highlight---2sS6o {\n  color: #32a8a7; }\n\n.confirm---r7Ao4 {\n  padding-top: 20px; }\n\n.container---22D-p {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex; }\n\n.ok---1iCNK, .cancel---3jeSE {\n  position: relative;\n  display: inline-block;\n  width: 90px;\n  height: 90px;\n  border-radius: 45px;\n  margin: 10px;\n  background-color: #37c97c;\n  cursor: pointer;\n  outline: none; }\n\n.cancel---3jeSE {\n  background-color: #c53902; }\n\n.okButtonDisabled---3Xc6F, .cancelButtonDisabled---1jkTj {\n  position: relative;\n  display: inline-block;\n  width: 90px;\n  height: 90px;\n  border-radius: 45px;\n  margin: 10px;\n  background-color: #37c97c;\n  cursor: not-allowed;\n  outline: none;\n  opacity: 0.4; }\n\n.okButtonDisabled---3Xc6F :nth-child(3), .cancelButtonDisabled---1jkTj :nth-child(3) {\n    display: none; }\n\n.cancelButtonDisabled---1jkTj {\n  background-color: #c53902; }\n\n.iconClassName---2TcoY {\n  position: absolute;\n  top: 35%;\n  left: 35%;\n  width: 29px;\n  height: 32px; }\n\n.iconClassName---2TcoY path {\n    fill: white !important; }\n", ""]);

// exports
exports.locals = {
	"confirmationMessageContainer": "confirmationMessageContainer---1v9ZM",
	"icon": "icon---3TlbS",
	"title": "title---1uJgu",
	"message": "message---d0IxF",
	"highlight": "highlight---2sS6o",
	"confirm": "confirm---r7Ao4",
	"container": "container---22D-p",
	"ok": "ok---1iCNK",
	"cancel": "cancel---3jeSE",
	"okButtonDisabled": "okButtonDisabled---3Xc6F",
	"cancelButtonDisabled": "cancelButtonDisabled---1jkTj",
	"iconClassName": "iconClassName---2TcoY"
};

/***/ }),
/* 1143 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(4)();
// imports


// module
exports.push([module.i, ".container---3r1a_ {\n  display: -webkit-box;\n  display: -moz-flex;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n  -moz-align-items: center;\n  align-items: center;\n  -webkit-box-pack: center;\n  -ms-flex-pack: center;\n  -moz-justify-content: center;\n  justify-content: center;\n  height: 100%; }\n\n.children---1UMph {\n  padding-right: 6px; }\n\n.label---1i3KQ {\n  font-family: Poppins, sans-serif;\n  font-size: 13px;\n  font-weight: 600; }\n\n.forwardButton---3Tqwl {\n  width: 19px;\n  height: 19px; }\n\n.forwardButton---3Tqwl svg path {\n    fill: white !important; }\n\n.disabled---3IwVs {\n  opacity: 0.4;\n  pointer-events: none;\n  cursor: not-allowed; }\n", ""]);

// exports
exports.locals = {
	"container": "container---3r1a_",
	"children": "children---1UMph",
	"label": "label---1i3KQ",
	"forwardButton": "forwardButton---3Tqwl",
	"disabled": "disabled---3IwVs"
};

/***/ }),
/* 1144 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(4)();
// imports


// module
exports.push([module.i, ".container---4Nbm_ {\n  display: -webkit-box;\n  display: -moz-flex;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n  -moz-align-items: center;\n  align-items: center;\n  -webkit-box-pack: center;\n  -ms-flex-pack: center;\n  -moz-justify-content: center;\n  justify-content: center;\n  height: 100%; }\n\n.children---2N1Lh {\n  padding-right: 6px; }\n\n.label---3r0lv {\n  font-family: Poppins, sans-serif;\n  font-size: 13px;\n  font-weight: 600; }\n\n.forwardButton---FGYHg {\n  width: 19px;\n  height: 19px; }\n\n.forwardButton---FGYHg svg path {\n    fill: white !important; }\n\n.disabled----iGLC {\n  opacity: 0.4;\n  pointer-events: none;\n  cursor: not-allowed; }\n", ""]);

// exports
exports.locals = {
	"container": "container---4Nbm_",
	"children": "children---2N1Lh",
	"label": "label---3r0lv",
	"forwardButton": "forwardButton---FGYHg",
	"disabled": "disabled----iGLC"
};

/***/ }),
/* 1145 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(4)();
// imports


// module
exports.push([module.i, ".container---3ASO9 {\n  background-color: #fff;\n  padding-bottom: 10px; }\n\n.header---3IXbO {\n  display: -webkit-box;\n  display: -moz-flex;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: center;\n  -ms-flex-pack: center;\n  -moz-justify-content: center;\n  justify-content: center;\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n  -moz-align-items: center;\n  align-items: center;\n  padding: 20px 0; }\n\n.headerColor---tAQCI {\n    color: #4e5c67; }\n\n.header---3IXbO > h2 {\n    -webkit-box-flex: 1;\n    -moz-flex: 1;\n    -ms-flex: 1;\n    flex: 1; }\n\n.list---395S1 {\n  display: -webkit-box;\n  display: -moz-flex;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: center;\n  -ms-flex-pack: center;\n  -moz-justify-content: center;\n  justify-content: center;\n  -webkit-box-align: stretch;\n  -ms-flex-align: stretch;\n  -moz-align-items: stretch;\n  align-items: stretch;\n  -webkit-box-direction: normal;\n  -webkit-box-orient: horizontal;\n  -moz-flex-direction: row;\n  -ms-flex-direction: row;\n  flex-direction: row;\n  min-height: 320px;\n  max-height: 60vh;\n  width: 100%;\n  padding: 5px;\n  background: #fff;\n  border: 1px solid rgba(65, 86, 103, .2);\n  border-radius: 7px;\n  -webkit-box-shadow: 5px 5px 1px rgba(65, 86, 103, .3);\n  box-shadow: 5px 5px 1px rgba(65, 86, 103, .3);\n  color: #4e5c67;\n  outline: none;\n  overflow: hidden; }\n\n.height---15_1b {\n  height: 100%; }\n\n.leftPanel---28c0N,\n.rightPanel---16zyT {\n  width: 50%;\n  height: 100%;\n  padding: 0;\n  overflow-y: auto; }\n\n.leftPanel---28c0N > div,\n  .rightPanel---16zyT > div {\n    padding: 20px 0; }\n\n.leftPanel---28c0N::-webkit-scrollbar,\n  .rightPanel---16zyT::-webkit-scrollbar {\n    border-radius: 3px;\n    width: 1em;\n    padding: 6px; }\n\n.leftPanel---28c0N::-webkit-scrollbar-track,\n  .rightPanel---16zyT::-webkit-scrollbar-track {\n    -webkit-box-shadow: inset 0 0 0.1px;\n    box-shadow: inset 0 0 0.1px; }\n\n.leftPanel---28c0N::-webkit-scrollbar-thumb,\n  .rightPanel---16zyT::-webkit-scrollbar-thumb {\n    background-color: rgba(65, 86, 103, .3);\n    outline: 1px solid rgba(65, 86, 103, .3);\n    border-radius: 10px; }\n\n.panelLabel---2X6C9 {\n  margin-bottom: 16px;\n  font-weight: 600;\n  text-transform: uppercase; }\n\n.leftPanel---28c0N {\n  padding-right: 20px;\n  padding-left: 10px;\n  margin-right: 5px; }\n\n.rightPanel---16zyT {\n  border-left: 1px solid rgba(65, 86, 103, .3);\n  padding-left: 25px;\n  padding-right: 10px; }\n\n.itemSelector---INp6a {\n  display: -webkit-box;\n  display: -moz-flex;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: center;\n  -ms-flex-pack: center;\n  -moz-justify-content: center;\n  justify-content: center;\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n  -moz-align-items: center;\n  align-items: center;\n  -webkit-box-direction: normal;\n  -webkit-box-orient: horizontal;\n  -moz-flex-direction: row;\n  -ms-flex-direction: row;\n  flex-direction: row;\n  position: relative;\n  height: 46px;\n  margin-bottom: 14px;\n  padding-right: 5px;\n  -webkit-box-shadow: 5px 5px 1px rgba(65, 86, 103, .3);\n  box-shadow: 5px 5px 1px rgba(65, 86, 103, .3);\n  border: 1px solid #cfd2d4;\n  border-radius: 7px; }\n\n.label---aNZsZ {\n  height: 100%;\n  width: 100%; }\n\n.label---aNZsZ > div {\n    -webkit-box-pack: start;\n    -ms-flex-pack: start;\n    -moz-justify-content: start;\n    justify-content: start;\n    height: 100%;\n    padding-left: 16px; }\n\n.button---16J64 {\n  width: 30px;\n  height: 30px;\n  -webkit-box-flex: 0;\n      -ms-flex: none;\n          flex: none; }\n\n.button---16J64 > div {\n    height: 100%; }\n\n.selected---3XLyv {\n  background-color: #1981c4;\n  color: #fff;\n  -webkit-box-shadow: inset 5px 5px 1px rgba(65, 86, 103, .3);\n  box-shadow: inset 5px 5px 1px rgba(65, 86, 103, .3); }\n\n.noCursor---FcA2N * {\n  cursor: auto; }\n", ""]);

// exports
exports.locals = {
	"container": "container---3ASO9",
	"header": "header---3IXbO",
	"headerColor": "headerColor---tAQCI",
	"list": "list---395S1",
	"height": "height---15_1b",
	"leftPanel": "leftPanel---28c0N",
	"rightPanel": "rightPanel---16zyT",
	"panelLabel": "panelLabel---2X6C9",
	"itemSelector": "itemSelector---INp6a",
	"label": "label---aNZsZ",
	"button": "button---16J64",
	"selected": "selected---3XLyv",
	"noCursor": "noCursor---FcA2N"
};

/***/ }),
/* 1146 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(4)();
// imports


// module
exports.push([module.i, ".gridContainer---1v_xe {\n  display: -webkit-box;\n  display: -moz-flex;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-flex: 1;\n  -moz-flex: 1;\n  -ms-flex: 1;\n  flex: 1;\n  width: 100%;\n  margin-top: 20px;\n  -webkit-overflow-scrolling: auto; }\n\n.react-grid-Main {\n  height: 100% !important; }\n\n.react-grid-Grid {\n  height: 100% !important; }\n\n.react-grid-Canvas {\n  height: 100% !important; }\n\n.react-grid-HeaderCell {\n  background: #e7e9ea !important;\n  height: 42px !important;\n  padding-top: 10px !important; }\n\n.react-grid-Header {\n  height: 42px !important; }\n\n.react-grid-HeaderRow {\n  height: 42px !important;\n  overflow-y: hidden !important; }\n\n.react-grid-HeaderRow > div {\n  height: 42px !important; }\n\n.react-grid-Viewport {\n  top: 42px !important; }\n\n.react-grid-Row {\n  min-height: 40px; }\n\n.react-grid-Row .row-selected {\n  background-color: #cfd2d4 !important; }\n\n.react-grid-Cell {\n  min-height: 40px;\n  border-right: 0 !important;\n  border-bottom: 1px solid #e1e1e1 !important; }\n\n.react-grid-Cell:focus {\n  outline: none !important; }\n\n.react-grid-Cell--locked {\n  min-height: 40px;\n  z-index: 0 !important; }\n\n@media (min-width: 680px) {\n  .react-grid-Cell--locked:last-of-type {\n    left: calc(100% - 70px) !important; } }\n\n.react-grid-HeaderCell--locked {\n  min-height: 40px; }\n\n.react-grid-Row:hover .react-grid-Cell {\n  background-color: #ebedf2 !important; }\n\n.react-grid-HeaderCell--locked:last-child {\n  left: unset !important;\n  text-align: center; }\n\n@media (min-width: 680px) {\n    .react-grid-HeaderCell--locked:last-child {\n      left: calc(100% - 70px) !important; } }\n\n.react-grid-HeaderCell {\n  padding-top: 12px; }\n\n.react-grid-checkbox:checked + .react-grid-checkbox-label::before {\n  background-color: #fff !important;\n  content: \"\\E900\";\n  color: #000 !important;\n  display: block;\n  font-family: 'icomoon'; }\n", ""]);

// exports
exports.locals = {
	"gridContainer": "gridContainer---1v_xe"
};

/***/ }),
/* 1147 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(4)();
// imports


// module
exports.push([module.i, ".datepicker---iKo95 {\n  border: 2px solid #c2cfda;\n  border-radius: 8px;\n  height: 60px; }\n  .datepicker---iKo95 * {\n    outline: none; }\n  .datepicker---iKo95 .CalendarDay {\n    vertical-align: middle; }\n  .datepicker---iKo95 .DateRangePicker {\n    width: 100%;\n    margin-top: 10px; }\n  .datepicker---iKo95 .DateRangePickerInput {\n    width: calc(100% - 1px);\n    border: none;\n    border-radius: 8px; }\n  .datepicker---iKo95 .DateInput {\n    width: 150px; }\n  .datepicker---iKo95 .DateInput_input__focused {\n    border-bottom: 2px solid #c2cfda; }\n  .datepicker---iKo95 .DateRangePicker_picker {\n    left: -60px !important;\n    top: 50px !important; }\n  .datepicker---iKo95 > div {\n    width: 100%;\n    max-width: 100%;\n    padding-left: 1px;\n    padding-top: 0; }\n  .datepicker---iKo95 > div ul {\n      margin-bottom: 0;\n      z-index: 100; }\n  .datepicker---iKo95 > div > [class*=\"-MenuIcon\"] {\n      max-width: 40px;\n      border-radius: 5px;\n      margin-right: 0; }\n  .datepicker---iKo95 > div > [class*=\"-MenuIcon\"] > div {\n        position: relative;\n        width: 100%; }\n  .datepicker---iKo95 > div > [class*=\"-MenuIcon\"] > div svg {\n          position: absolute;\n          left: 0; }\n  .datepicker---iKo95 > div [class*=\"sec-Menu \"] {\n      position: absolute;\n      z-index: 2; }\n  .datepicker---iKo95 > div [class*=\"edmio-Menu \"] {\n      width: 100%;\n      max-width: 500px; }\n  .datepicker---iKo95 > div [class*=\"-MenuButton\"] {\n      border: none;\n      border-radius: 8px;\n      font-size: 25px;\n      padding: 9px 15px;\n      text-align: left; }\n  .datepicker---iKo95 > div [class*=\"-MenuButton\"] > span {\n      width: 100%;\n      line-height: 1.5em; }\n  .disabled-datepicker {\n  opacity: 0.5;\n  pointer-events: none; }\n", ""]);

// exports
exports.locals = {
	"datepicker": "datepicker---iKo95"
};

/***/ }),
/* 1148 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(4)();
// imports


// module
exports.push([module.i, ".yg0---gTnJg {\n  background-color: #e7b300; }\n\n.yg1---2JNtG {\n  background-color: #ec7500; }\n\n.yg2---3EEWF {\n  background-color: #f12800; }\n\n.yg3---2wnrS {\n  background-color: #de1c9c; }\n\n.yg4---3iJ0_ {\n  background-color: #6c32a8; }\n\n.yg5---2yR0T {\n  background-color: #4461cd; }\n\n.yg6---284nN {\n  background-color: #00b4ff; }\n\n.yg7---wqFpU {\n  background-color: #44d62c; }\n\n.yg8---3sEiy {\n  background-color: #249d46; }\n\n.yg9---3AjKE {\n  background-color: #7c871d; }\n\n.yg10---357BH {\n  background-color: #ad6f0c; }\n\n.yg11---1FNGU {\n  background-color: #643808; }\n\n.yg12---3Z9-y {\n  background-color: #2a2a2a; }\n\n.header---2_UHP, .row---17CTw, .rowShort---3j_U- {\n  display: -webkit-box;\n  display: -moz-flex;\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-negative: 0;\n  flex-shrink: 0;\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n  -moz-align-items: center;\n  align-items: center;\n  height: 40px;\n  height: 50px;\n  color: #415667;\n  font-family: Poppins, sans-serif;\n  font-size: 13px;\n  font-weight: 600;\n  line-height: 27px; }\n\n.headerColumns---356Rb, .yearColumn---iulrL, .currentCourseColumn---1FPgC, .learningModule---1Ywf1, .currentNewColumn---1E-HF {\n  height: 100%;\n  border-right: 1px solid #adb6bc;\n  border-bottom: 1px solid #959595;\n  background: #fff;\n  word-wrap: break-word;\n  line-height: 52px; }\n\n.yearColumn---iulrL {\n  width: 10%;\n  text-align: center; }\n\n.currentCourseColumn---1FPgC {\n  width: 60%;\n  padding-left: 36px; }\n\n.learningModule---1Ywf1 {\n  width: 30%;\n  padding-left: 36px; }\n\n.currentNewColumn---1E-HF {\n  width: 60%; }\n\n.yearGroup---3cDwf {\n  border-radius: 15px;\n  margin-left: 8px;\n  width: 35px;\n  height: 24px;\n  text-align: center;\n  color: #fff;\n  font-size: 12px;\n  font-weight: 500;\n  line-height: 25px; }\n\n.row---17CTw, .rowShort---3j_U- {\n  height: 12vh;\n  color: #444;\n  font-weight: 500; }\n\n.rowShort---3j_U- {\n  height: 6vh; }\n\n.rowColumn---v_-0y, .yearRow---Z1uYW, .currentCourseRow---4e5Bx, .learningModuleRow---3FOZ2, .currentNewRow---1i9mP {\n  height: 100%;\n  border-right: 1px solid #adb6bc;\n  border-bottom: 1px solid #959595;\n  background: #fff;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis; }\n\n.yearRow---Z1uYW {\n  width: 10%;\n  outline: none; }\n\n.currentCourseRow---4e5Bx {\n  display: -webkit-box;\n  display: -moz-flex;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n  -moz-align-items: center;\n  align-items: center;\n  -webkit-box-direction: normal;\n  -webkit-box-orient: vertical;\n  -moz-flex-direction: column;\n  -ms-flex-direction: column;\n  flex-direction: column;\n  width: 60%;\n  font-family: Poppins;\n  font-size: 13px;\n  -webkit-user-select: none;\n     -moz-user-select: none;\n      -ms-user-select: none;\n          user-select: none; }\n\n.currentCourseRow---4e5Bx > *:not(:last-child) {\n    border-bottom: 1px solid #bcbcbc; }\n\n.learningModuleRow---3FOZ2 {\n  display: -webkit-box;\n  display: -moz-flex;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n  -moz-align-items: center;\n  align-items: center;\n  -webkit-box-direction: normal;\n  -webkit-box-orient: vertical;\n  -moz-flex-direction: column;\n  -ms-flex-direction: column;\n  flex-direction: column;\n  width: 30%;\n  font-family: Poppins;\n  font-size: 13px;\n  -webkit-user-select: none;\n     -moz-user-select: none;\n      -ms-user-select: none;\n          user-select: none; }\n\n.learningModuleRow---3FOZ2 > *:not(:last-child) {\n    border-bottom: 1px solid #bcbcbc; }\n\n.courses---2mDPB, .coursesShort---1s6ND, .upf---1PxBs, .upfDefaultCourse---h8Yf2, .defaultCourse---OFvbR, .defaultCourseShort---18sQ- {\n  display: -webkit-box;\n  display: -moz-flex;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n  -moz-align-items: center;\n  align-items: center;\n  height: 50%;\n  width: 100%;\n  padding-left: 15px;\n  cursor: pointer;\n  outline: none; }\n\n.coursesShort---1s6ND {\n  height: 100%; }\n\n.upf---1PxBs, .upfDefaultCourse---h8Yf2, .defaultCourse---OFvbR, .defaultCourseShort---18sQ- {\n  height: 50%;\n  width: 100%;\n  padding-left: 15px;\n  border-bottom: none; }\n\n.upfDefaultCourse---h8Yf2, .defaultCourse---OFvbR, .defaultCourseShort---18sQ- {\n  cursor: default;\n  padding-left: 36px; }\n\n.defaultCourseShort---18sQ- {\n  height: 100%; }\n\n.currentNewRow---1i9mP {\n  width: 60%;\n  color: #444;\n  font-family: Poppins;\n  font-size: 13px; }\n\n.settingsFooter---2pFxJ {\n  display: -webkit-box;\n  display: -moz-flex;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n  -moz-align-items: center;\n  align-items: center;\n  -webkit-box-pack: end;\n  -ms-flex-pack: end;\n  -moz-justify-content: flex-end;\n  justify-content: flex-end;\n  position: fixed;\n  bottom: 0.1px;\n  left: 0.1px;\n  width: 100%;\n  padding-right: 10px;\n  background-color: #adb6bc; }\n\n.cancelButton---3_4HV, .assignToYearButton---2_pGR,\n.queueButton---2SYrt {\n  width: -webkit-fit-content;\n  width: -moz-fit-content;\n  width: fit-content;\n  height: 45px;\n  border-radius: 22px;\n  margin: 10px;\n  padding: 14px;\n  color: #fff;\n  background-color: #415667;\n  font-family: Poppins;\n  font-size: 16px;\n  line-height: 20px; }\n\n.assignToYearButton---2_pGR {\n  width: 150px; }\n\n.panel---2sVWI {\n  display: -webkit-box;\n  display: -moz-flex;\n  display: -ms-flexbox;\n  display: flex;\n  height: 84vh;\n  position: relative; }\n\n.lhsPanel---198nx {\n  display: -webkit-box;\n  display: -moz-flex;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-direction: normal;\n  -webkit-box-orient: vertical;\n  -moz-flex-direction: column;\n  -ms-flex-direction: column;\n  flex-direction: column;\n  overflow: auto;\n  position: relative;\n  height: calc(100% - 20px);\n  width: 100%;\n  background-color: white;\n  margin-bottom: 20px; }\n\n.rhsPanel---TlNci {\n  width: 30%;\n  padding: 20px;\n  background-color: white; }\n\n.newCourseLabelWrapper---1SFcu {\n  height: 100%; }\n\n.forwardButton---87epS {\n  width: 19px;\n  height: 19px;\n  margin-right: 5px;\n  margin-bottom: 5px; }\n\n.forwardButton---87epS svg path {\n    fill: white !important; }\n\n.learningModuleText---2ONIz {\n  height: 19px;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center; }\n\n.courseSelected---1-L3j {\n  background-color: #32a8a7;\n  color: #fff;\n  font-weight: 600; }\n\n.courseUnselected---jm-6n {\n  background-color: #fff;\n  color: #444;\n  font-weight: 500; }\n\n.showUPFCourseSelector---23ZtL {\n  position: absolute;\n  right: 15px;\n  height: calc(100% - 45px);\n  width: 400px;\n  margin-top: 10px; }\n\n.hideUPFCourseSelector---wx6K1 {\n  display: none; }\n\n.yearSelected---1LqDR {\n  background-color: rgba(60, 168, 167, .3); }\n\n.yearUnselected---21FnZ {\n  background-color: #fff; }\n\n.infoModalWrapper---HtNbB {\n  display: -webkit-box;\n  display: -moz-flex;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: center;\n  -ms-flex-pack: center;\n  -moz-justify-content: center;\n  justify-content: center;\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n  -moz-align-items: center;\n  align-items: center;\n  -webkit-box-direction: normal;\n  -webkit-box-orient: vertical;\n  -moz-flex-direction: column;\n  -ms-flex-direction: column;\n  flex-direction: column;\n  width: 540px;\n  height: 350px;\n  border-radius: 15px;\n  background-color: white;\n  -webkit-box-shadow: 2px 2px 10px;\n          box-shadow: 2px 2px 10px; }\n\n.content---1b8_K, .contentBold---2VcV6, .title---o9IMf {\n  color: #4e5c67;\n  font-family: Poppins;\n  font-size: 16px;\n  width: 80%;\n  margin-bottom: 10px; }\n\n.contentBold---2VcV6, .title---o9IMf {\n  font-weight: 700;\n  margin-bottom: 0; }\n\n.title---o9IMf {\n  display: -webkit-box;\n  display: -moz-flex;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: center;\n  -ms-flex-pack: center;\n  -moz-justify-content: center;\n  justify-content: center;\n  font-size: 22px;\n  line-height: 27px;\n  margin-bottom: 15px; }\n\n.checkbox---2aqH6 {\n  display: -webkit-box;\n  display: -moz-flex;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: start;\n  -ms-flex-pack: start;\n  -moz-justify-content: flex-start;\n  justify-content: flex-start;\n  font-size: 16px;\n  width: 80%;\n  margin-bottom: 10px; }\n\n.checkbox---2aqH6 > input[type='checkbox'] {\n  margin-right: 5px; }\n\n.checkbox---2aqH6 > label {\n  color: #4e5c67;\n  font-weight: 100; }\n\n.iUnderstandButton---1ABvo {\n  display: -webkit-box;\n  display: -moz-flex;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: center;\n  -ms-flex-pack: center;\n  -moz-justify-content: center;\n  justify-content: center;\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n  -moz-align-items: center;\n  align-items: center;\n  background-color: #4e5c67;\n  color: white;\n  width: 135px;\n  height: 30px;\n  border-radius: 20px;\n  font-size: 12px; }\n", ""]);

// exports
exports.locals = {
	"yg0": "yg0---gTnJg",
	"yg1": "yg1---2JNtG",
	"yg2": "yg2---3EEWF",
	"yg3": "yg3---2wnrS",
	"yg4": "yg4---3iJ0_",
	"yg5": "yg5---2yR0T",
	"yg6": "yg6---284nN",
	"yg7": "yg7---wqFpU",
	"yg8": "yg8---3sEiy",
	"yg9": "yg9---3AjKE",
	"yg10": "yg10---357BH",
	"yg11": "yg11---1FNGU",
	"yg12": "yg12---3Z9-y",
	"header": "header---2_UHP",
	"row": "row---17CTw",
	"rowShort": "rowShort---3j_U-",
	"headerColumns": "headerColumns---356Rb",
	"yearColumn": "yearColumn---iulrL",
	"currentCourseColumn": "currentCourseColumn---1FPgC",
	"learningModule": "learningModule---1Ywf1",
	"currentNewColumn": "currentNewColumn---1E-HF",
	"yearGroup": "yearGroup---3cDwf",
	"rowColumn": "rowColumn---v_-0y",
	"yearRow": "yearRow---Z1uYW",
	"currentCourseRow": "currentCourseRow---4e5Bx",
	"learningModuleRow": "learningModuleRow---3FOZ2",
	"currentNewRow": "currentNewRow---1i9mP",
	"courses": "courses---2mDPB",
	"coursesShort": "coursesShort---1s6ND",
	"upf": "upf---1PxBs",
	"upfDefaultCourse": "upfDefaultCourse---h8Yf2",
	"defaultCourse": "defaultCourse---OFvbR",
	"defaultCourseShort": "defaultCourseShort---18sQ-",
	"settingsFooter": "settingsFooter---2pFxJ",
	"cancelButton": "cancelButton---3_4HV",
	"assignToYearButton": "assignToYearButton---2_pGR",
	"queueButton": "queueButton---2SYrt",
	"panel": "panel---2sVWI",
	"lhsPanel": "lhsPanel---198nx",
	"rhsPanel": "rhsPanel---TlNci",
	"newCourseLabelWrapper": "newCourseLabelWrapper---1SFcu",
	"forwardButton": "forwardButton---87epS",
	"learningModuleText": "learningModuleText---2ONIz",
	"courseSelected": "courseSelected---1-L3j",
	"courseUnselected": "courseUnselected---jm-6n",
	"showUPFCourseSelector": "showUPFCourseSelector---23ZtL",
	"hideUPFCourseSelector": "hideUPFCourseSelector---wx6K1",
	"yearSelected": "yearSelected---1LqDR",
	"yearUnselected": "yearUnselected---21FnZ",
	"infoModalWrapper": "infoModalWrapper---HtNbB",
	"content": "content---1b8_K",
	"contentBold": "contentBold---2VcV6",
	"title": "title---o9IMf",
	"checkbox": "checkbox---2aqH6",
	"iUnderstandButton": "iUnderstandButton---1ABvo"
};

/***/ }),
/* 1149 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(4)();
// imports


// module
exports.push([module.i, "/**\n * Basic Breakpoint\n * url: https://responsivedesign.is/develop/getting-started-with-sass-and-breakpoint-mixin\n *\n * Usage:\n *\n * breakpoint(small-only | medium-up | medium-only | large-up | large-only) {\n * styles goes here\n * }\n*/\n.downloadCertificatesComponent---JzGEz {\n  display: -webkit-box;\n  display: -moz-flex;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-flex: 10;\n  -moz-flex: 10;\n  -ms-flex: 10;\n  flex: 10;\n  -webkit-box-direction: normal;\n  -webkit-box-orient: vertical;\n  -moz-flex-direction: column;\n  -ms-flex-direction: column;\n  flex-direction: column;\n  position: absolute;\n  color: #4e5c67;\n  font-family: Poppins;\n  background-color: #e7e9ea;\n  height: 100%;\n  width: 100%; }\n.downloadCertificatesContainer---uGnl4 {\n  height: 100%; }\n.downloadCertificatesHeader---kv9dj {\n  display: -webkit-box;\n  display: -moz-flex;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n  -moz-align-items: center;\n  align-items: center;\n  -webkit-box-pack: justify;\n  -ms-flex-pack: justify;\n  -moz-justify-content: space-between;\n  justify-content: space-between;\n  min-height: 80px;\n  font-family: Poppins, sans-serif;\n  background-color: #cfd2d4;\n  color: inherit;\n  padding: 0 25px;\n  font-size: 30px;\n  font-weight: 500; }\n.downloadCertificatesContent---3_vvl {\n  display: -webkit-box;\n  display: -moz-flex;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-flex: none;\n  -moz-flex: none;\n  -ms-flex: none;\n  flex: none;\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n  -moz-align-items: center;\n  align-items: center;\n  -webkit-box-pack: center;\n  -ms-flex-pack: center;\n  -moz-justify-content: center;\n  justify-content: center;\n  width: calc(100% - 45px);\n  min-height: calc(100% - 120px);\n  margin: 20px 24px;\n  background-color: #fff;\n  -webkit-box-shadow: 5px 5px 1px rgba(179, 179, 179, .3);\n          box-shadow: 5px 5px 1px rgba(179, 179, 179, .3);\n  border-radius: 6px;\n  padding-bottom: 80px;\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n  -moz-align-items: center;\n  align-items: center; }\n@media screen and (max-width: 39.9375em) {\n    .downloadCertificatesContent---3_vvl {\n      padding-bottom: 75px; } }\n.downloadCertificatesContentWrapper---2xIOr {\n    display: -webkit-box;\n    display: -moz-flex;\n    display: -ms-flexbox;\n    display: flex;\n    -webkit-box-direction: normal;\n    -webkit-box-orient: vertical;\n    -moz-flex-direction: column;\n    -ms-flex-direction: column;\n    flex-direction: column;\n    -webkit-box-pack: center;\n    -ms-flex-pack: center;\n    -moz-justify-content: center;\n    justify-content: center;\n    height: inherit;\n    width: inherit;\n    padding: 0;\n    text-align: center;\n    padding: 50px 25px 0;\n    max-width: 550px;\n    width: 100%; }\n.downloadCertificatesContentWrapper---2xIOr > div {\n      margin-bottom: 10px; }\n.downloadCertificatesContentWrapper---2xIOr div > select {\n      height: auto;\n      font-size: 25px; }\n.downloadCertificatesFooter---zH9Sq {\n  display: -webkit-box;\n  display: -moz-flex;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n  -moz-align-items: center;\n  align-items: center;\n  -webkit-box-pack: justify;\n  -ms-flex-pack: justify;\n  -moz-justify-content: space-between;\n  justify-content: space-between;\n  -webkit-box-direction: reverse;\n  -webkit-box-orient: horizontal;\n  -moz-flex-direction: row-reverse;\n  -ms-flex-direction: row-reverse;\n  flex-direction: row-reverse;\n  position: fixed;\n  bottom: 0.1px;\n  left: 0.1px;\n  width: 100%;\n  height: 77px;\n  padding-left: 40px;\n  padding-right: 40px;\n  background-color: #adb6bc;\n  -webkit-box-pack: center;\n  -ms-flex-pack: center;\n  -moz-justify-content: center;\n  justify-content: center; }\n@media screen and (max-width: 39.9375em) {\n    .downloadCertificatesFooter---zH9Sq {\n      padding: 0 20px; } }\n.downloadCertificatesFooterLeft---_q4hf {\n    width: auto; }\n.downloadCertificatesFooterRight---1DZyo {\n    -webkit-box-pack: end;\n    -ms-flex-pack: end;\n    -moz-justify-content: flex-end;\n    justify-content: flex-end;\n    width: auto; }\n.downloadCertificatesFooterRight---1DZyo, .downloadCertificatesFooterLeft---_q4hf {\n    display: -webkit-box;\n    display: -moz-flex;\n    display: -ms-flexbox;\n    display: flex; }\n.downloadCertificatesFooterRight---1DZyo > div, .downloadCertificatesFooterLeft---_q4hf > div {\n      margin: 0 5px; }\n.certificatesSummaryContainer---2HDWL {\n  display: -webkit-box;\n  display: -moz-flex;\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-wrap: wrap;\n  flex-wrap: wrap;\n  padding: 20px 0;\n  min-height: 120px; }\n.certificatesSummaryHeader---b8byN {\n  -webkit-box-flex: none;\n  -moz-flex: none;\n  -ms-flex: none;\n  flex: none;\n  font-size: 16px;\n  font-weight: 600;\n  width: 100%;\n  padding-bottom: 20px; }\n.certificatesSummaryColumn---34Ykh {\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n  -moz-align-items: center;\n  align-items: center;\n  -webkit-box-pack: center;\n  -ms-flex-pack: center;\n  -moz-justify-content: center;\n  justify-content: center;\n  width: 33.33333%; }\n.certificatesSummaryButton---23kjc {\n  display: inline-block;\n  min-width: 47px;\n  height: 27px;\n  margin: 10px auto;\n  border-radius: 25px;\n  background-color: #1981c4;\n  color: #fff;\n  font-size: 18px; }\n.certificatesSummaryButton---23kjc > div {\n    height: 27px;\n    -webkit-box-orient: horizontal;\n    -webkit-box-direction: reverse;\n        -ms-flex-direction: row-reverse;\n            flex-direction: row-reverse;\n    padding-left: 10px;\n    padding-right: 10px; }\n.icon---1S7O7 {\n  padding-left: 5px;\n  width: 20px; }\n.icon---1S7O7 svg path {\n    fill: #fff !important; }\n", ""]);

// exports
exports.locals = {
	"downloadCertificatesComponent": "downloadCertificatesComponent---JzGEz",
	"downloadCertificatesContainer": "downloadCertificatesContainer---uGnl4",
	"downloadCertificatesHeader": "downloadCertificatesHeader---kv9dj",
	"downloadCertificatesContent": "downloadCertificatesContent---3_vvl",
	"downloadCertificatesContentWrapper": "downloadCertificatesContentWrapper---2xIOr",
	"downloadCertificatesFooter": "downloadCertificatesFooter---zH9Sq",
	"downloadCertificatesFooterLeft": "downloadCertificatesFooterLeft---_q4hf",
	"downloadCertificatesFooterRight": "downloadCertificatesFooterRight---1DZyo",
	"certificatesSummaryContainer": "certificatesSummaryContainer---2HDWL",
	"certificatesSummaryHeader": "certificatesSummaryHeader---b8byN",
	"certificatesSummaryColumn": "certificatesSummaryColumn---34Ykh",
	"certificatesSummaryButton": "certificatesSummaryButton---23kjc",
	"icon": "icon---1S7O7"
};

/***/ }),
/* 1150 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(4)();
// imports


// module
exports.push([module.i, ".dropDownContainer---3pkdq {\n  position: relative;\n  display: table;\n  border-radius: 2px;\n  background: #fff; }\n  .dropDownContainer---3pkdq select:disabled,\n  .dropDownContainer---3pkdq select[disabled], .dropDownContainer---3pkdq.disabled---1l49G {\n    opacity: 0.5; }\n  .dropDownContainer---3pkdq.large---llv4z select {\n    font-size: 23px;\n    color: #4e5c67; }\n  .dropDownContainer---3pkdq.large---llv4z::after {\n    margin-top: -6px; }\n  .dropDownContainer---3pkdq select {\n    line-height: 1.3;\n    border-radius: 0.2em;\n    width: 100%;\n    margin: 0;\n    outline: none;\n    padding: 0.55em 0.8em 0.45em;\n    -webkit-box-sizing: border-box;\n    box-sizing: border-box;\n    font-size: 16px;\n    font-weight: 500; }\n  .dropDownContainer---3pkdq select:focus {\n      outline: none; }\n  .dropDownContainer---3pkdq::after {\n    width: 0;\n    height: 0;\n    border-left: 8px solid transparent;\n    border-right: 8px solid transparent;\n    border-top: 10px solid #666;\n    margin-top: -4px;\n    content: \" \";\n    position: absolute;\n    top: 50%;\n    right: 1em;\n    pointer-events: none;\n    display: none; }\n  .dropDownContainer---3pkdq:hover {\n    border-color: #bbcad6; }\n  .dropDownContainer---3pkdq::after {\n  display: block; }\n  .dropDownContainer---3pkdq select {\n  padding-right: 3em;\n  background: none;\n  border: 1px solid transparent;\n  -webkit-appearance: none;\n  -moz-appearance: none;\n  appearance: none; }\n  @media screen and (-ms-high-contrast: active), (-ms-high-contrast: none) {\n  .dropDownContainer---3pkdq select::-ms-expand {\n    display: none; }\n  .dropDownContainer---3pkdq select:focus {\n    border-color: #aaa; }\n  .dropDownContainer---3pkdq select:focus::-ms-value {\n    background: transparent;\n    color: #222; }\n  .dropDownContainer---3pkdq select {\n    padding-right: 2em;\n    background: none;\n    border: 1px solid transparent; }\n  .dropDownContainer---3pkdq::after {\n    display: block; } }\n  .bordered---2sMPo {\n  width: 100%; }\n  .bordered---2sMPo select {\n    line-height: 1.3;\n    height: 50px;\n    border: 2px solid #c2cfda;\n    border-radius: 10px; }\n  .bordered---2sMPo::after {\n    margin-top: -1px;\n    display: block; }\n  .bordered---2sMPo select {\n    padding-right: 3em;\n    background: none;\n    border: 2px solid #c2cfda;\n    -webkit-appearance: none;\n    -moz-appearance: none;\n    appearance: none; }\n  @media screen and (-ms-high-contrast: active), (-ms-high-contrast: none) {\n    .bordered---2sMPo select:focus {\n      border-color: #e7e9ea; }\n    .bordered---2sMPo select {\n      border-color: #e7e9ea; } }\n  .fullWidth---1XsgN {\n  position: relative;\n  display: table;\n  border-radius: 2px;\n  background: #fff;\n  width: 100%; }\n  .fullWidth---1XsgN select:disabled,\n  .fullWidth---1XsgN select[disabled], .fullWidth---1XsgN.disabled---1l49G {\n    opacity: 0.5; }\n  .fullWidth---1XsgN.large---llv4z select {\n    font-size: 23px;\n    color: #4e5c67; }\n  .fullWidth---1XsgN.large---llv4z::after {\n    margin-top: -6px; }\n  .fullWidth---1XsgN select {\n    line-height: 1.3;\n    border-radius: 0.2em;\n    width: 100%;\n    margin: 0;\n    outline: none;\n    padding: 0.55em 0.8em 0.45em;\n    -webkit-box-sizing: border-box;\n    box-sizing: border-box;\n    font-size: 16px;\n    font-weight: 500; }\n  .fullWidth---1XsgN select:focus {\n      outline: none; }\n  .fullWidth---1XsgN::after {\n    width: 0;\n    height: 0;\n    border-left: 8px solid transparent;\n    border-right: 8px solid transparent;\n    border-top: 10px solid #666;\n    margin-top: -4px;\n    content: \" \";\n    position: absolute;\n    top: 50%;\n    right: 1em;\n    pointer-events: none;\n    display: none; }\n  .fullWidth---1XsgN:hover {\n    border-color: #bbcad6; }\n  .fullWidth---1XsgN::after {\n  display: block; }\n  .fullWidth---1XsgN select {\n  padding-right: 3em;\n  background: none;\n  border: 1px solid transparent;\n  -webkit-appearance: none;\n  -moz-appearance: none;\n  appearance: none; }\n  @media screen and (-ms-high-contrast: active), (-ms-high-contrast: none) {\n  .fullWidth---1XsgN select::-ms-expand {\n    display: none; }\n  .fullWidth---1XsgN select:focus {\n    border-color: #aaa; }\n  .fullWidth---1XsgN select:focus::-ms-value {\n    background: transparent;\n    color: #222; }\n  .fullWidth---1XsgN select {\n    padding-right: 2em;\n    background: none;\n    border: 1px solid transparent; }\n  .fullWidth---1XsgN::after {\n    display: block; } }\n", ""]);

// exports
exports.locals = {
	"dropDownContainer": "dropDownContainer---3pkdq",
	"disabled": "disabled---1l49G",
	"large": "large---llv4z",
	"bordered": "bordered---2sMPo",
	"fullWidth": "fullWidth---1XsgN"
};

/***/ }),
/* 1151 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(4)();
// imports


// module
exports.push([module.i, ".header---3_aUg {\n  margin-top: 24px;\n  margin-left: 79px;\n  color: #415667;\n  font-family: Poppins;\n  font-size: 26px;\n  font-weight: 500;\n  line-height: 27px; }\n\n.classFooter---2oCKZ {\n  position: fixed;\n  bottom: 0;\n  left: 1px !important;\n  width: 100%;\n  min-height: 80px;\n  padding: 20px 40px 20px 20px;\n  background-color: #adb6bc; }\n\n.actionButton---fvdBC, .cancelButton---xZSSX,\n.saveButton---2Kx43 {\n  margin-left: 10px; }\n\n.buttonContainer---322Jd {\n  display: -webkit-box;\n  display: -moz-flex;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n  -moz-align-items: center;\n  align-items: center;\n  -webkit-box-pack: end;\n  -ms-flex-pack: end;\n  -moz-justify-content: flex-end;\n  justify-content: flex-end;\n  -webkit-box-flex: 1;\n  -moz-flex: 1;\n  -ms-flex: 1;\n  flex: 1; }\n\n.loader---KMYQF {\n  display: -webkit-box;\n  display: -moz-flex;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n  -moz-align-items: center;\n  align-items: center;\n  -webkit-box-pack: center;\n  -ms-flex-pack: center;\n  -moz-justify-content: center;\n  justify-content: center;\n  position: fixed;\n  z-index: 100004;\n  top: 0;\n  bottom: 0;\n  left: 0;\n  right: 0;\n  background-color: rgba(255, 255, 255, .85); }\n\n.classDetails---_0cQX {\n  width: calc(100% - 60px);\n  height: 310px;\n  border-radius: 6px;\n  margin: 0 25px 50px;\n  -webkit-box-shadow: none;\n          box-shadow: none;\n  background-color: rgba(0, 0, 0, 0); }\n\n@media (max-width: 1024px) {\n    .classDetails---_0cQX {\n      height: 461px; } }\n\n.editClass---1YcVI, .editClassWithoutScroll---1ZDGF {\n  position: fixed;\n  top: 0;\n  bottom: 0;\n  left: 0;\n  right: 0;\n  background-color: #e7e9ea;\n  z-index: 100005;\n  overflow-y: scroll; }\n\n.editClassWithoutScroll---1ZDGF {\n  overflow-y: hidden; }\n\n.className---26694 {\n  min-height: 25px;\n  padding: 25px 0 25px 25px;\n  color: #415667;\n  font-family: Poppins;\n  font-size: 26px;\n  font-weight: 500;\n  line-height: 1.3em; }\n\n.highlight---3L4YV {\n  color: #32a8a7; }\n\n.btnStudentManagement---1Vkbt {\n  display: -webkit-inline-box;\n  display: -moz-inline-flex;\n  display: -ms-inline-flexbox;\n  display: inline-flex;\n  margin: 0 9px; }\n\n.btnStudentManagement---1Vkbt span {\n  display: block;\n  color: #1c7fc3;\n  text-decoration: underline; }\n\n.btnContainerStudentManagement---6updY {\n  -webkit-box-pack: center;\n  -ms-flex-pack: center;\n  -moz-justify-content: center;\n  justify-content: center;\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n  -moz-align-items: center;\n  align-items: center;\n  outline: none; }\n\n@media screen and (max-width: 1000px) {\n  .buttonWrapper---29P9r {\n    min-width: 30%; } }\n", ""]);

// exports
exports.locals = {
	"header": "header---3_aUg",
	"classFooter": "classFooter---2oCKZ",
	"actionButton": "actionButton---fvdBC",
	"cancelButton": "cancelButton---xZSSX",
	"saveButton": "saveButton---2Kx43",
	"buttonContainer": "buttonContainer---322Jd",
	"loader": "loader---KMYQF",
	"classDetails": "classDetails---_0cQX",
	"editClass": "editClass---1YcVI",
	"editClassWithoutScroll": "editClassWithoutScroll---1ZDGF",
	"className": "className---26694",
	"highlight": "highlight---3L4YV",
	"btnStudentManagement": "btnStudentManagement---1Vkbt",
	"btnContainerStudentManagement": "btnContainerStudentManagement---6updY",
	"buttonWrapper": "buttonWrapper---29P9r"
};

/***/ }),
/* 1152 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(4)();
// imports


// module
exports.push([module.i, ".classConfirmationContainer---2iPTj {\n  display: -webkit-box;\n  display: -moz-flex;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: center;\n  -ms-flex-pack: center;\n  -moz-justify-content: center;\n  justify-content: center;\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n  -moz-align-items: center;\n  align-items: center;\n  -webkit-box-direction: normal;\n  -webkit-box-orient: vertical;\n  -moz-flex-direction: column;\n  -ms-flex-direction: column;\n  flex-direction: column;\n  position: relative;\n  outline: none; }\n\n.icon---158jV {\n  width: 80px;\n  height: 75px; }\n\n.title---3YsSj {\n  width: 90%;\n  height: auto;\n  margin: 33px;\n  color: #4e5c67;\n  font-family: Poppins;\n  font-size: 28px;\n  font-weight: 500;\n  line-height: 1.2em;\n  text-align: center; }\n\n.title---3YsSj .selectedGroup---11C2A {\n    color: #1981c4; }\n\n.titleSub---2z62U {\n    font-size: 18px; }\n\n.buttonWrapper---MNEo1 {\n  display: -webkit-box;\n  display: -moz-flex;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n  -moz-align-items: center;\n  align-items: center;\n  -webkit-box-pack: center;\n  -ms-flex-pack: center;\n  -moz-justify-content: center;\n  justify-content: center;\n  -webkit-box-shadow: 3px 3px 1px #e7e9ea;\n          box-shadow: 3px 3px 1px #e7e9ea;\n  min-width: 20%;\n  height: 36px;\n  border: 1px solid #e1e1e1;\n  border-radius: 5px;\n  margin-bottom: 14px;\n  background-color: #fff;\n  color: #4e5c67;\n  font-family: Poppins;\n  font-size: 14px;\n  font-weight: 500;\n  text-align: center;\n  cursor: pointer; }\n\n.buttonContainer---3XaIn {\n  width: 100%;\n  outline: none; }\n\n.buttonContainer---3XaIn span {\n    width: 80%;\n    -webkit-user-select: none;\n       -moz-user-select: none;\n        -ms-user-select: none;\n            user-select: none; }\n\n.buttonContainerDisabled---2B3Bw {\n  width: 100%;\n  outline: none;\n  opacity: 0.4;\n  pointer-events: none;\n  cursor: not-allowed; }\n\n.buttonContainerDisabled---2B3Bw .buttonIcon---3vi5e {\n    height: 21px;\n    width: 20px;\n    float: right;\n    margin-right: 10px; }\n\n.buttonContainerDisabled---2B3Bw div {\n    display: inline; }\n\n.buttonTitle---1o4j7 {\n  width: 80%;\n  color: #4e5c67;\n  font-family: Poppins;\n  font-size: 14px;\n  font-weight: 500;\n  text-align: center; }\n\n.buttonIcon---3vi5e {\n  width: 20px;\n  height: 21px;\n  margin-right: 10px;\n  float: right; }\n\n.buttonGroup---1L2yX {\n  width: 250px; }\n\n.buttonDelete---1IwAy {\n  background-color: #c53902;\n  color: #fff; }\n\n.buttonDelete---1IwAy .buttonIcon---3vi5e svg path {\n    fill: #fff !important; }\n\n.buttonClose---2_wOX {\n  position: absolute;\n  right: 10%;\n  top: 0; }\n\n.buttonClose---2_wOX .buttonIcon---3vi5e svg path {\n    fill: #1981c4 !important; }\n", ""]);

// exports
exports.locals = {
	"classConfirmationContainer": "classConfirmationContainer---2iPTj",
	"icon": "icon---158jV",
	"title": "title---3YsSj",
	"selectedGroup": "selectedGroup---11C2A",
	"titleSub": "titleSub---2z62U",
	"buttonWrapper": "buttonWrapper---MNEo1",
	"buttonContainer": "buttonContainer---3XaIn",
	"buttonContainerDisabled": "buttonContainerDisabled---2B3Bw",
	"buttonIcon": "buttonIcon---3vi5e",
	"buttonTitle": "buttonTitle---1o4j7",
	"buttonGroup": "buttonGroup---1L2yX",
	"buttonDelete": "buttonDelete---1IwAy",
	"buttonClose": "buttonClose---2_wOX"
};

/***/ }),
/* 1153 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(4)();
// imports


// module
exports.push([module.i, ".editStudent---2iwIs {\n  position: fixed;\n  top: 0;\n  bottom: 0;\n  left: 0;\n  right: 0;\n  background-color: #e7e9ea;\n  z-index: 100005;\n  overflow-y: scroll; }\n\n.studentName---3iHAK {\n  padding: 25px 25px 0;\n  color: #415667;\n  font-family: Poppins;\n  font-size: 26px;\n  font-weight: 500;\n  line-height: 1.3em; }\n\n.studentDetails---1pdHL, .classDetails---1CByo {\n  width: calc(100% - 60px);\n  height: 310px;\n  border-radius: 6px;\n  margin: 25px 25px 50px;\n  -webkit-box-shadow: 5px 5px 1px rgba(179, 179, 179, .3);\n          box-shadow: 5px 5px 1px rgba(179, 179, 179, .3);\n  background-color: #fff; }\n\n@media (max-width: 1024px) {\n    .studentDetails---1pdHL, .classDetails---1CByo {\n      height: 461px; } }\n\n.classDetails---1CByo {\n  -webkit-box-shadow: none;\n          box-shadow: none;\n  background-color: rgba(0, 0, 0, 0); }\n\n.studentFooter---2cAx5 {\n  position: fixed;\n  bottom: 0;\n  width: 100%;\n  min-height: 80px;\n  padding: 20px 40px 20px 20px;\n  background-color: #adb6bc; }\n\n.buttonContainer---1AzMv {\n  display: -webkit-box;\n  display: -moz-flex;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n  -moz-align-items: center;\n  align-items: center;\n  -webkit-box-pack: end;\n  -ms-flex-pack: end;\n  -moz-justify-content: flex-end;\n  justify-content: flex-end;\n  -webkit-box-flex: 1;\n  -moz-flex: 1;\n  -ms-flex: 1;\n  flex: 1; }\n\n.actionButton---34JKb, .saveButton---2oa4Q, .cancelButton---3OzR3 {\n  -webkit-box-pack: center;\n  -ms-flex-pack: center;\n  -moz-justify-content: center;\n  justify-content: center;\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n  -moz-align-items: center;\n  align-items: center;\n  display: none !important;\n  height: 45px;\n  background-color: #415667;\n  border-radius: 20px;\n  color: #fff;\n  font-family: Poppins, sans-serif;\n  font-size: 16px;\n  font-weight: 500;\n  line-height: 27px;\n  border: 1px solid #959595; }\n\n.actionButton---34JKb span, .saveButton---2oa4Q span, .cancelButton---3OzR3 span {\n    margin-top: 7px; }\n\n@media (min-width: 320px) {\n    .actionButton---34JKb, .saveButton---2oa4Q, .cancelButton---3OzR3 {\n      display: block !important; } }\n\n.saveButton---2oa4Q {\n  width: 95px; }\n\n.cancelButton---3OzR3 {\n  width: 115px;\n  margin-right: 5px; }\n\n.loader---1vWtL {\n  display: -webkit-box;\n  display: -moz-flex;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n  -moz-align-items: center;\n  align-items: center;\n  -webkit-box-pack: center;\n  -ms-flex-pack: center;\n  -moz-justify-content: center;\n  justify-content: center;\n  position: fixed;\n  z-index: 100004;\n  top: 0;\n  bottom: 0;\n  left: 0;\n  right: 0;\n  background-color: rgba(255, 255, 255, .85); }\n", ""]);

// exports
exports.locals = {
	"editStudent": "editStudent---2iwIs",
	"studentName": "studentName---3iHAK",
	"studentDetails": "studentDetails---1pdHL",
	"classDetails": "classDetails---1CByo",
	"studentFooter": "studentFooter---2cAx5",
	"buttonContainer": "buttonContainer---1AzMv",
	"actionButton": "actionButton---34JKb",
	"saveButton": "saveButton---2oa4Q",
	"cancelButton": "cancelButton---3OzR3",
	"loader": "loader---1vWtL"
};

/***/ }),
/* 1154 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(4)();
// imports


// module
exports.push([module.i, ".editTeacher---139Hy {\n  position: fixed;\n  top: 0;\n  bottom: 0;\n  left: 0;\n  right: 0;\n  background-color: #e7e9ea;\n  z-index: 100005;\n  overflow-y: scroll; }\n\n.teacherName---1AnJp {\n  padding: 25px 25px 0;\n  color: #415667;\n  font-family: Poppins;\n  font-size: 26px;\n  font-weight: 500;\n  line-height: 1.3em; }\n\n.teacherDetails---13_Af, .classDetails---3-GjV {\n  width: calc(100% - 60px);\n  border-radius: 6px;\n  margin: 25px 25px 50px;\n  -webkit-box-shadow: 5px 5px 1px rgba(179, 179, 179, .3);\n          box-shadow: 5px 5px 1px rgba(179, 179, 179, .3);\n  background-color: #fff; }\n\n.classDetails---3-GjV {\n  -webkit-box-shadow: none;\n          box-shadow: none;\n  background-color: rgba(0, 0, 0, 0); }\n\n.teacherFooter---272gF {\n  position: fixed;\n  bottom: 0;\n  width: 100%;\n  min-height: 80px;\n  padding: 20px 40px 20px 20px;\n  background-color: #adb6bc; }\n\n.buttonContainer---2zJCS {\n  display: -webkit-box;\n  display: -moz-flex;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n  -moz-align-items: center;\n  align-items: center;\n  -webkit-box-pack: end;\n  -ms-flex-pack: end;\n  -moz-justify-content: flex-end;\n  justify-content: flex-end;\n  -webkit-box-flex: 1;\n  -moz-flex: 1;\n  -ms-flex: 1;\n  flex: 1; }\n\n.actionButton---3PsvM, .saveButton---1aFFE, .cancelButton---3wl5P {\n  margin-left: 10px; }\n\n.loader---1CUcx {\n  display: -webkit-box;\n  display: -moz-flex;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n  -moz-align-items: center;\n  align-items: center;\n  -webkit-box-pack: center;\n  -ms-flex-pack: center;\n  -moz-justify-content: center;\n  justify-content: center;\n  position: fixed;\n  z-index: 100004;\n  top: 0;\n  bottom: 0;\n  left: 0;\n  right: 0;\n  background-color: rgba(255, 255, 255, .85); }\n", ""]);

// exports
exports.locals = {
	"editTeacher": "editTeacher---139Hy",
	"teacherName": "teacherName---1AnJp",
	"teacherDetails": "teacherDetails---13_Af",
	"classDetails": "classDetails---3-GjV",
	"teacherFooter": "teacherFooter---272gF",
	"buttonContainer": "buttonContainer---2zJCS",
	"actionButton": "actionButton---3PsvM",
	"saveButton": "saveButton---1aFFE",
	"cancelButton": "cancelButton---3wl5P",
	"loader": "loader---1CUcx"
};

/***/ }),
/* 1155 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(4)();
// imports


// module
exports.push([module.i, ".container---V2Xm- {\n  display: -webkit-box;\n  display: -moz-flex;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n  -moz-align-items: center;\n  align-items: center;\n  width: 45px;\n  margin: 0 auto; }\n\n.icon---25wPv {\n  float: left;\n  width: 30px;\n  height: 30px;\n  margin-right: 2px; }\n", ""]);

// exports
exports.locals = {
	"container": "container---V2Xm-",
	"icon": "icon---25wPv"
};

/***/ }),
/* 1156 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(4)();
// imports


// module
exports.push([module.i, "/**\n * Basic Breakpoint\n * url: https://responsivedesign.is/develop/getting-started-with-sass-and-breakpoint-mixin\n *\n * Usage:\n *\n * breakpoint(small-only | medium-up | medium-only | large-up | large-only) {\n * styles goes here\n * }\n*/\n.emptyContainer---35Gs6 {\n  display: -webkit-box;\n  display: -moz-flex;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-flex: 1;\n  -moz-flex: 1;\n  -ms-flex: 1;\n  flex: 1;\n  -webkit-box-direction: normal;\n  -webkit-box-orient: vertical;\n  -moz-flex-direction: column;\n  -ms-flex-direction: column;\n  flex-direction: column;\n  -webkit-box-pack: center;\n  -ms-flex-pack: center;\n  -moz-justify-content: center;\n  justify-content: center;\n  width: 100%;\n  padding: 10px;\n  border-radius: 6px; }\n.emptyNotice---2KzYt {\n  display: -webkit-box;\n  display: -moz-flex;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-direction: normal;\n  -webkit-box-orient: vertical;\n  -moz-flex-direction: column;\n  -ms-flex-direction: column;\n  flex-direction: column;\n  -webkit-box-pack: center;\n  -ms-flex-pack: center;\n  -moz-justify-content: center;\n  justify-content: center; }\n.emptyState---2_w0K {\n  display: -webkit-box;\n  display: -moz-flex;\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-pack: distribute;\n  -moz-justify-content: space-around;\n  justify-content: space-around;\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n  -moz-align-items: center;\n  align-items: center;\n  border-radius: 300px;\n  width: 300px;\n  height: 300px;\n  background: #cfd2d4;\n  margin: auto; }\n@media screen and (max-width: 39.9375em) {\n    .emptyState---2_w0K {\n      border-radius: 150px;\n      width: 150px;\n      height: 150px; } }\n.emptyIconContainer---3n5Rd {\n  width: 180px;\n  height: 180px;\n  margin-bottom: 20px; }\n@media screen and (max-width: 39.9375em) {\n    .emptyIconContainer---3n5Rd {\n      width: 100px;\n      height: 100px; } }\n.emptyIconContainer---3n5Rd svg path {\n    fill: #fff !important; }\n.noResult---3xcCD {\n  display: -webkit-box;\n  display: -moz-flex;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: center;\n  -ms-flex-pack: center;\n  -moz-justify-content: center;\n  justify-content: center;\n  color: #415667;\n  font-family: Poppins;\n  font-size: 26px;\n  font-weight: 500;\n  margin-top: 40px; }\n@media screen and (max-width: 39.9375em) {\n    .noResult---3xcCD {\n      font-size: 20px; } }\n", ""]);

// exports
exports.locals = {
	"emptyContainer": "emptyContainer---35Gs6",
	"emptyNotice": "emptyNotice---2KzYt",
	"emptyState": "emptyState---2_w0K",
	"emptyIconContainer": "emptyIconContainer---3n5Rd",
	"noResult": "noResult---3xcCD"
};

/***/ }),
/* 1157 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(4)();
// imports


// module
exports.push([module.i, ".extendResultTableContainer---3g7qx {\n  width: 100%;\n  max-width: 500px;\n  margin: 0 auto; }\n  .extendResultTableContainer---3g7qx table {\n    width: 100%;\n    border-collapse: collapse; }\n  .extendResultTableContainer---3g7qx table > thead {\n      background-color: #e7e9ea; }\n  .extendResultTableContainer---3g7qx table > thead > tr > td,\n      .extendResultTableContainer---3g7qx table > thead > tr > th {\n        padding-top: 15px;\n        padding-bottom: 10px;\n        font-size: 12px;\n        font-weight: 400;\n        text-transform: uppercase; }\n  .extendResultTableContainer---3g7qx table > tbody > tr > td,\n    .extendResultTableContainer---3g7qx table > tbody > tr > th {\n      padding: 5px; }\n  .extendResultTableContainer---3g7qx table,\n  .extendResultTableContainer---3g7qx th,\n  .extendResultTableContainer---3g7qx td {\n    border: 1px solid #e1e1e1; }\n", ""]);

// exports
exports.locals = {
	"extendResultTableContainer": "extendResultTableContainer---3g7qx"
};

/***/ }),
/* 1158 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(4)();
// imports


// module
exports.push([module.i, "/**\n * Basic Breakpoint\n * url: https://responsivedesign.is/develop/getting-started-with-sass-and-breakpoint-mixin\n *\n * Usage:\n *\n * breakpoint(small-only | medium-up | medium-only | large-up | large-only) {\n * styles goes here\n * }\n*/\n.extendFormComponent---3fMNR {\n  display: -webkit-box;\n  display: -moz-flex;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-flex: 10;\n  -moz-flex: 10;\n  -ms-flex: 10;\n  flex: 10;\n  -webkit-box-direction: normal;\n  -webkit-box-orient: vertical;\n  -moz-flex-direction: column;\n  -ms-flex-direction: column;\n  flex-direction: column;\n  position: absolute;\n  color: #4e5c67;\n  font-family: Poppins;\n  background-color: #e7e9ea;\n  height: 100%;\n  width: 100%; }\n.extendFormContainer---2iGBJ {\n  height: 100%; }\n.extendFormHeader---sR4E0 {\n  display: -webkit-box;\n  display: -moz-flex;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n  -moz-align-items: center;\n  align-items: center;\n  -webkit-box-pack: justify;\n  -ms-flex-pack: justify;\n  -moz-justify-content: space-between;\n  justify-content: space-between;\n  min-height: 80px;\n  font-family: Poppins, sans-serif;\n  background-color: #cfd2d4;\n  color: inherit;\n  padding: 0 25px;\n  font-size: 30px;\n  font-weight: 500; }\n.extendFormContent---1QIBN {\n  display: -webkit-box;\n  display: -moz-flex;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-flex: none;\n  -moz-flex: none;\n  -ms-flex: none;\n  flex: none;\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n  -moz-align-items: center;\n  align-items: center;\n  -webkit-box-pack: center;\n  -ms-flex-pack: center;\n  -moz-justify-content: center;\n  justify-content: center;\n  width: calc(100% - 45px);\n  min-height: calc(100% - 120px);\n  margin: 20px 24px;\n  background-color: #fff;\n  -webkit-box-shadow: 5px 5px 1px rgba(179, 179, 179, .3);\n          box-shadow: 5px 5px 1px rgba(179, 179, 179, .3);\n  border-radius: 6px;\n  padding-bottom: 80px;\n  -webkit-box-align: start;\n  -ms-flex-align: start;\n  -moz-align-items: start;\n  align-items: start; }\n@media screen and (max-width: 39.9375em) {\n    .extendFormContent---1QIBN {\n      padding-bottom: 75px; } }\n.extendFormContentWrapper---109eo {\n    display: -webkit-box;\n    display: -moz-flex;\n    display: -ms-flexbox;\n    display: flex;\n    -webkit-box-direction: normal;\n    -webkit-box-orient: vertical;\n    -moz-flex-direction: column;\n    -ms-flex-direction: column;\n    flex-direction: column;\n    -webkit-box-pack: center;\n    -ms-flex-pack: center;\n    -moz-justify-content: center;\n    justify-content: center;\n    height: inherit;\n    width: inherit;\n    padding: 0;\n    text-align: center;\n    padding-top: 25px; }\n.extendFormContentLabels---2Ideg {\n    margin-bottom: 20px;\n    font-size: 16px; }\n.extendFormContentLabels---2Ideg > div {\n      line-height: 1.5em; }\n.extendFormContentWarning---3KlFX {\n    color: red; }\n.extendFormFooter---2IsVu {\n  display: -webkit-box;\n  display: -moz-flex;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n  -moz-align-items: center;\n  align-items: center;\n  -webkit-box-pack: justify;\n  -ms-flex-pack: justify;\n  -moz-justify-content: space-between;\n  justify-content: space-between;\n  -webkit-box-direction: reverse;\n  -webkit-box-orient: horizontal;\n  -moz-flex-direction: row-reverse;\n  -ms-flex-direction: row-reverse;\n  flex-direction: row-reverse;\n  position: fixed;\n  bottom: 0.1px;\n  left: 0.1px;\n  width: 100%;\n  height: 77px;\n  padding-left: 40px;\n  padding-right: 40px;\n  background-color: #adb6bc;\n  -webkit-box-pack: end;\n  -ms-flex-pack: end;\n  -moz-justify-content: end;\n  justify-content: end; }\n@media screen and (max-width: 39.9375em) {\n    .extendFormFooter---2IsVu {\n      padding: 0 20px; } }\n.extendFormFooterLeft---RQxGC {\n    width: auto; }\n.extendFormFooterRight---2e9K3 {\n    -webkit-box-pack: end;\n    -ms-flex-pack: end;\n    -moz-justify-content: flex-end;\n    justify-content: flex-end;\n    width: auto; }\n.extendFormFooterRight---2e9K3, .extendFormFooterLeft---RQxGC {\n    display: -webkit-box;\n    display: -moz-flex;\n    display: -ms-flexbox;\n    display: flex; }\n.extendFormFooterRight---2e9K3 > div, .extendFormFooterLeft---RQxGC > div {\n      margin: 0 5px; }\n.extendFormFooter---2IsVu > div {\n    margin-left: 15px; }\n@media screen and (max-width: 39.9375em) {\n    .extendFormFooter---2IsVu {\n      -webkit-box-pack: justify;\n      -ms-flex-pack: justify;\n      -moz-justify-content: space-between;\n      justify-content: space-between; }\n      .extendFormFooter---2IsVu > div {\n        margin-left: 0; } }\n.extendResultContainer---aW9kr {\n  height: 100%; }\n.infoContainer---3W0Cu {\n  display: -webkit-box;\n  display: -moz-flex;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-direction: normal;\n  -webkit-box-orient: vertical;\n  -moz-flex-direction: column;\n  -ms-flex-direction: column;\n  flex-direction: column;\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n  -moz-align-items: center;\n  align-items: center;\n  -webkit-box-pack: center;\n  -ms-flex-pack: center;\n  -moz-justify-content: center;\n  justify-content: center;\n  height: 100%;\n  max-width: 800px;\n  padding: 0 25px;\n  margin: 0 auto; }\n.infoHeading---fj_8h {\n  color: #415667;\n  font-family: Poppins;\n  font-size: 24px;\n  font-weight: 500; }\n.infoContent---1miAB {\n  width: 100%;\n  font-size: 16px;\n  font-family: Poppins;\n  padding: 25px 0.1px; }\n.extendInfoFooter---3AIm8 {\n  display: -webkit-box;\n  display: -moz-flex;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n  -moz-align-items: center;\n  align-items: center;\n  -webkit-box-pack: justify;\n  -ms-flex-pack: justify;\n  -moz-justify-content: space-between;\n  justify-content: space-between;\n  width: 100%; }\n.loader---23TlT {\n  display: -webkit-box;\n  display: -moz-flex;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n  -moz-align-items: center;\n  align-items: center;\n  -webkit-box-pack: center;\n  -ms-flex-pack: center;\n  -moz-justify-content: center;\n  justify-content: center;\n  position: fixed;\n  z-index: 100004;\n  top: 0;\n  bottom: 0;\n  left: 0;\n  right: 0;\n  background-color: rgba(255, 255, 255, .85); }\n", ""]);

// exports
exports.locals = {
	"extendFormComponent": "extendFormComponent---3fMNR",
	"extendFormContainer": "extendFormContainer---2iGBJ",
	"extendFormHeader": "extendFormHeader---sR4E0",
	"extendFormContent": "extendFormContent---1QIBN",
	"extendFormContentWrapper": "extendFormContentWrapper---109eo",
	"extendFormContentLabels": "extendFormContentLabels---2Ideg",
	"extendFormContentWarning": "extendFormContentWarning---3KlFX",
	"extendFormFooter": "extendFormFooter---2IsVu",
	"extendFormFooterLeft": "extendFormFooterLeft---RQxGC",
	"extendFormFooterRight": "extendFormFooterRight---2e9K3",
	"extendResultContainer": "extendResultContainer---aW9kr",
	"infoContainer": "infoContainer---3W0Cu",
	"infoHeading": "infoHeading---fj_8h",
	"infoContent": "infoContent---1miAB",
	"extendInfoFooter": "extendInfoFooter---3AIm8",
	"loader": "loader---23TlT"
};

/***/ }),
/* 1159 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(4)();
// imports


// module
exports.push([module.i, ".fileUpload---2cbTz {\n  display: -webkit-box;\n  display: -moz-flex;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n  -moz-align-items: center;\n  align-items: center;\n  -webkit-box-pack: center;\n  -ms-flex-pack: center;\n  -moz-justify-content: center;\n  justify-content: center;\n  color: #4e5c67;\n  font-family: Poppins;\n  font-size: 16px;\n  font-weight: 500; }\n\n.uploadTextBox---4IPcM {\n  -webkit-box-flex: 0;\n  -moz-flex-grow: 0;\n  -ms-flex-positive: 0;\n  flex-grow: 0;\n  height: 38px;\n  min-width: 240px;\n  border: 1px solid #cfd2d4;\n  background-color: #fff;\n  border-radius: 2px;\n  margin-left: 10px;\n  padding: 7px; }\n\n.uploadButton---2NUCi {\n  height: 45px;\n  width: 135px;\n  background-color: #415667;\n  border-radius: 20px;\n  color: #fff;\n  font-family: Poppins, sans-serif;\n  font-size: 16px;\n  font-weight: 500;\n  line-height: 27px;\n  border: 1px solid #959595;\n  cursor: pointer;\n  margin: 20px auto;\n  padding: 8px; }\n\n.browseButtonWrapper---2I80L, .browseButtonWrapperDisabled---3cG99 {\n  padding-top: 4px; }\n\n.browseButtonWrapperDisabled---3cG99 {\n  opacity: 0.4;\n  pointer-events: none;\n  cursor: not-allowed; }\n\n.browseButton---b322S {\n  width: 0;\n  overflow: hidden;\n  position: absolute; }\n\n.browseButton---b322S + label {\n  height: 37px;\n  width: 94px;\n  border: 1px solid #e1e1e1;\n  background-color: #8b8b8b;\n  border-radius: 4px;\n  margin-left: 5px;\n  padding-top: 7px;\n  color: #fff;\n  font-family: Poppins, sans-serif;\n  font-size: 16px;\n  font-weight: 500;\n  cursor: pointer; }\n", ""]);

// exports
exports.locals = {
	"fileUpload": "fileUpload---2cbTz",
	"uploadTextBox": "uploadTextBox---4IPcM",
	"uploadButton": "uploadButton---2NUCi",
	"browseButtonWrapper": "browseButtonWrapper---2I80L",
	"browseButtonWrapperDisabled": "browseButtonWrapperDisabled---3cG99",
	"browseButton": "browseButton---b322S"
};

/***/ }),
/* 1160 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(4)();
// imports


// module
exports.push([module.i, ".component---27DkK {\n  display: block; }\n", ""]);

// exports
exports.locals = {
	"component": "component---27DkK"
};

/***/ }),
/* 1161 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(4)();
// imports


// module
exports.push([module.i, ".component---1J650 {\n  display: block; }\n\n.svgIconContainer---2Svoo {\n  width: 17px;\n  height: 17px;\n  margin: 3px; }\n\n.svgIconContainer---2Svoo svg path {\n    fill: white !important; }\n\n.button---3AnB0, .editInfo---2cr4q {\n  height: 25px;\n  background-color: #415667;\n  border-radius: 20px;\n  color: #fff;\n  font-family: Poppins, sans-serif;\n  font-size: 16px;\n  font-weight: 500;\n  line-height: 27px;\n  border: 1px solid #959595;\n  margin-left: 5px;\n  -webkit-box-pack: center;\n  -ms-flex-pack: center;\n  -moz-justify-content: center;\n  justify-content: center;\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n  -moz-align-items: center;\n  align-items: center; }\n\n.editInfo---2cr4q {\n  display: block !important;\n  width: 40px; }\n", ""]);

// exports
exports.locals = {
	"component": "component---1J650",
	"svgIconContainer": "svgIconContainer---2Svoo",
	"button": "button---3AnB0",
	"editInfo": "editInfo---2cr4q"
};

/***/ }),
/* 1162 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(4)();
// imports


// module
exports.push([module.i, ".component---1x7xU {\n  display: -webkit-box;\n  display: -moz-flex;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-direction: normal;\n  -webkit-box-orient: horizontal;\n  -moz-flex-direction: row;\n  -ms-flex-direction: row;\n  flex-direction: row;\n  outline: none; }\n\n.sort---11pKc {\n  width: 10px;\n  height: 30px;\n  margin-left: auto;\n  outline: none; }\n\n.title---2GAFk {\n  display: inline-block; }\n\n.sort---11pKc::before {\n  font-family: icomoon;\n  content: \"\\E902\"; }\n", ""]);

// exports
exports.locals = {
	"component": "component---1x7xU",
	"sort": "sort---11pKc",
	"title": "title---2GAFk"
};

/***/ }),
/* 1163 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(4)();
// imports


// module
exports.push([module.i, ".component---2h1gN {\n  display: block;\n  margin: 2px; }\n\n.svgIconContainer---3dw8Y {\n  width: 17px;\n  height: 17px;\n  margin: 3px; }\n\n.svgIconContainer---3dw8Y svg path {\n    fill: white !important; }\n\n.button---1-qFu, .assign---3jr_B {\n  height: 25px;\n  min-width: 135px;\n  background-color: #415667;\n  border-radius: 20px;\n  color: #fff;\n  font-family: Poppins, sans-serif;\n  font-size: 14px;\n  font-weight: 500;\n  line-height: 20px;\n  border: 1px solid #959595;\n  margin-left: 5px;\n  -webkit-box-pack: center;\n  -ms-flex-pack: center;\n  -moz-justify-content: center;\n  justify-content: center;\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n  -moz-align-items: center;\n  align-items: center; }\n\n.assignedStudents---3ReKh {\n  padding: 2px; }\n\n.assign---3jr_B {\n  min-width: 110px;\n  display: inline-block;\n  padding: 0 15px; }\n\n.assign---3jr_B > div {\n    height: 100%; }\n", ""]);

// exports
exports.locals = {
	"component": "component---2h1gN",
	"svgIconContainer": "svgIconContainer---3dw8Y",
	"button": "button---1-qFu",
	"assign": "assign---3jr_B",
	"assignedStudents": "assignedStudents---3ReKh"
};

/***/ }),
/* 1164 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(4)();
// imports


// module
exports.push([module.i, ".component---Huezm {\n  display: block; }\n\n.yearGroup---1OviN {\n  min-height: 24px;\n  padding: 4px 10px;\n  min-width: 35px;\n  border-radius: 15px;\n  margin-left: 8px;\n  text-align: center;\n  color: #fff;\n  font-size: 12px;\n  font-weight: 500; }\n\n.yg0 {\n  background-color: #e7b300; }\n\n.yg1 {\n  background-color: #ec7500; }\n\n.yg2 {\n  background-color: #f12800; }\n\n.yg3 {\n  background-color: #de1c9c; }\n\n.yg4 {\n  background-color: #6c32a8; }\n\n.yg5 {\n  background-color: #4461cd; }\n\n.yg6 {\n  background-color: #00b4ff; }\n\n.yg7 {\n  background-color: #44d62c; }\n\n.yg8 {\n  background-color: #249d46; }\n\n.yg9 {\n  background-color: #7c871d; }\n\n.yg10 {\n  background-color: #ad6f0c; }\n\n.yg11 {\n  background-color: #643808; }\n\n.yg12 {\n  background-color: #2a2a2a; }\n", ""]);

// exports
exports.locals = {
	"component": "component---Huezm",
	"yearGroup": "yearGroup---1OviN"
};

/***/ }),
/* 1165 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(4)();
// imports


// module
exports.push([module.i, ".groupInfo---1UMIi {\n  width: 98%;\n  margin-top: 10px;\n  margin-left: 15px;\n  border: 1px solid #cdcdcd;\n  border-radius: 7px;\n  background-color: #fff;\n  -webkit-box-shadow: 5px 5px 1px rgba(179, 179, 179, .3);\n          box-shadow: 5px 5px 1px rgba(179, 179, 179, .3); }\n  .groupInfo---1UMIi.highlight---OLe3_ {\n    background-color: #cdcdcd; }\n  .radio---2IQIf {\n  display: -webkit-inline-box;\n  display: -moz-inline-flex;\n  display: -ms-inline-flexbox;\n  display: inline-flex; }\n  .radio---2IQIf .group---HhIrm {\n  display: none; }\n  .radio---2IQIf .groupName---1_4hY {\n  padding-left: 10px;\n  color: #555555;\n  font-family: Poppins;\n  font-size: 14px;\n  font-weight: 500; }\n  .radio---2IQIf .courseName---3dA3n {\n  padding-left: 10px;\n  color: #555555;\n  font-family: Poppins;\n  font-size: 14px;\n  font-weight: 500; }\n  input[type=\"radio\"] + label {\n  position: relative;\n  overflow: hidden;\n  width: 15px;\n  height: 15px;\n  border-radius: 10px;\n  border: 1px solid #bcbcbc;\n  margin-top: 15px;\n  margin-left: 10px;\n  -webkit-appearance: none;\n  cursor: pointer; }\n  input[type=\"radio\"] + label::before {\n  content: \"\";\n  display: block;\n  position: absolute;\n  margin-top: 2px;\n  margin-left: 2px;\n  height: 9px;\n  width: 9px;\n  background: white;\n  border-radius: 9px;\n  -webkit-border-radius: 9px;\n  -moz-border-radius: 9px;\n  -o-border-radius: 9px; }\n  input[type=\"radio\"]:checked + label::before {\n  background: #000; }\n  .info---3JRwG {\n  display: -webkit-box;\n  display: -moz-flex;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-direction: normal;\n  -webkit-box-orient: vertical;\n  -moz-flex-direction: column;\n  -ms-flex-direction: column;\n  flex-direction: column;\n  margin-top: 5px;\n  margin-bottom: 5px; }\n", ""]);

// exports
exports.locals = {
	"groupInfo": "groupInfo---1UMIi",
	"highlight": "highlight---OLe3_",
	"radio": "radio---2IQIf",
	"group": "group---HhIrm",
	"groupName": "groupName---1_4hY",
	"courseName": "courseName---3dA3n",
	"info": "info---3JRwG"
};

/***/ }),
/* 1166 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(4)();
// imports


// module
exports.push([module.i, ".headerComponent---La_eD {\n  display: -webkit-box;\n  display: -moz-flex;\n  display: -ms-flexbox;\n  display: flex;\n  font-family: Poppins, sans-serif;\n  background-color: #cfd2d4;\n  padding: 0 25px;\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n  -moz-align-items: center;\n  align-items: center;\n  -webkit-box-pack: justify;\n  -ms-flex-pack: justify;\n  -moz-justify-content: space-between;\n  justify-content: space-between;\n  min-height: 80px; }\n\n.headerText---2z8OX {\n  color: #4e5c67;\n  font-size: 30px;\n  font-weight: 500;\n  -webkit-box-flex: 1;\n  -moz-flex: 1;\n  -ms-flex: 1;\n  flex: 1; }\n\n.badgeContainer---S2aF1 {\n  -webkit-box-flex: 1;\n  -moz-flex: 1;\n  -ms-flex: 1;\n  flex: 1; }\n\n.licenceCount---17hY9 {\n  min-height: 26px;\n  padding: 4px 10px;\n  min-width: 50px;\n  background-color: #959595;\n  border-radius: 15px;\n  margin-left: 10px;\n  text-align: center;\n  color: #fff;\n  font-size: 14px;\n  font-weight: 500; }\n\n.tabContainer---3eUqg {\n  display: -webkit-box;\n  display: -moz-flex;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: center;\n  -ms-flex-pack: center;\n  -moz-justify-content: center;\n  justify-content: center;\n  color: #4e5c67;\n  font-family: Poppins, sans-serif;\n  font-size: 18px;\n  font-weight: 500;\n  outline: none;\n  -webkit-box-flex: 1;\n  -moz-flex: 1;\n  -ms-flex: 1;\n  flex: 1; }\n\n.tabContainer---3eUqg a:first-child {\n    border-top-left-radius: 7px;\n    border-bottom-left-radius: 7px; }\n\n.tabContainer---3eUqg a:last-child {\n    border-top-right-radius: 7px;\n    border-bottom-right-radius: 7px; }\n", ""]);

// exports
exports.locals = {
	"headerComponent": "headerComponent---La_eD",
	"headerText": "headerText---2z8OX",
	"badgeContainer": "badgeContainer---S2aF1",
	"licenceCount": "licenceCount---17hY9",
	"tabContainer": "tabContainer---3eUqg"
};

/***/ }),
/* 1167 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(4)();
// imports


// module
exports.push([module.i, ".courseDetailModal---2Jw0L {\n  display: -webkit-box;\n  display: -moz-flex;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-direction: normal;\n  -webkit-box-orient: vertical;\n  -moz-flex-direction: column;\n  -ms-flex-direction: column;\n  flex-direction: column;\n  font-family: Poppins; }\n\n.courseDetailHeader---19TCs {\n  -webkit-box-flex: none;\n  -moz-flex: none;\n  -ms-flex: none;\n  flex: none;\n  padding: 20px 25px;\n  color: #415667;\n  font-size: 27px; }\n\n.courseDetailContent---3GyJD {\n  min-height: 60vh;\n  max-height: 80vh;\n  padding: 0 25px;\n  overflow-y: auto; }\n\n.courseDetailFooter---3C3Vz {\n  -webkit-box-flex: none;\n  -moz-flex: none;\n  -ms-flex: none;\n  flex: none;\n  display: -webkit-box;\n  display: -moz-flex;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: end;\n  -ms-flex-pack: end;\n  -moz-justify-content: flex-end;\n  justify-content: flex-end;\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n  -moz-align-items: center;\n  align-items: center;\n  padding: 0 25px;\n  height: 75px; }\n\n.header----48Do {\n  background-color: #cfd2d4; }\n\n.mainHeading---3gEj3 {\n  font-family: Poppins, sans-serif;\n  padding: 10px 0 5px 25px;\n  font-size: 30px;\n  font-weight: 500; }\n\n.title---10V-a {\n  color: #4e5c67;\n  font-size: 30px;\n  font-weight: 500; }\n\n.subHeading---2qfvS {\n  font-family: Poppins, sans-serif;\n  padding: 5px 0 10px 25px;\n  font-size: 16px;\n  font-style: italic;\n  font-weight: 500; }\n\n.loader---2PEc5 > div {\n  background-color: #4e5c67 !important;\n  width: 16px !important;\n  height: 16px !important;\n  margin: 4px !important; }\n\n.loaderContainer---2lYp3 {\n  display: -webkit-box;\n  display: -moz-flex;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n  -moz-align-items: center;\n  align-items: center;\n  -webkit-box-pack: center;\n  -ms-flex-pack: center;\n  -moz-justify-content: center;\n  justify-content: center;\n  height: 500px; }\n\n.emptyState---caVif {\n  display: -webkit-box;\n  display: -moz-flex;\n  display: -ms-flexbox;\n  display: flex;\n  height: 84vh; }\n\n@media screen and (max-height: 760px) {\n    .emptyState---caVif {\n      height: 75vh; } }\n", ""]);

// exports
exports.locals = {
	"courseDetailModal": "courseDetailModal---2Jw0L",
	"courseDetailHeader": "courseDetailHeader---19TCs",
	"courseDetailContent": "courseDetailContent---3GyJD",
	"courseDetailFooter": "courseDetailFooter---3C3Vz",
	"header": "header----48Do",
	"mainHeading": "mainHeading---3gEj3",
	"title": "title---10V-a",
	"subHeading": "subHeading---2qfvS",
	"loader": "loader---2PEc5",
	"loaderContainer": "loaderContainer---2lYp3",
	"emptyState": "emptyState---caVif"
};

/***/ }),
/* 1168 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(4)();
// imports


// module
exports.push([module.i, "/**\n * Fix for vw, vh, vmin, vmax on iOS 7.\n * http://caniuse.com/#feat=viewport-units\n *\n * This fix works by replacing viewport units with px values on known screen sizes.\n *\n * iPhone 6 and 6 Plus cannot run iOS 7, so are not targeted by this fix.\n * Target devices running iOS 8+ will incidentally execute the media query,\n * but this will still produce the expected result; so this is not a problem.\n *\n * As an example, replace:\n *\n *   height: 50vh;\n *   font-size: 5vmin;\n *\n * with:\n *\n *   @include viewport-unit(height, 50vh);\n *   @include viewport-unit(font-size, 5vmin);\n */\n.height---3gtNG {\n  height: 60vh; }\n@media only screen and (-webkit-min-device-pixel-ratio: 1) and (device-width: 768px) and (device-height: 1024px) and (orientation: portrait) {\n    .height---3gtNG {\n      height: 614.4px; } }\n@media only screen and (-webkit-min-device-pixel-ratio: 1) and (device-width: 768px) and (device-height: 1024px) and (orientation: landscape) {\n    .height---3gtNG {\n      height: 460.8px; } }\n@media only screen and (-webkit-min-device-pixel-ratio: 1) and (device-width: 320px) and (device-height: 480px) and (orientation: portrait) {\n    .height---3gtNG {\n      height: 288px; } }\n@media only screen and (-webkit-min-device-pixel-ratio: 1) and (device-width: 320px) and (device-height: 480px) and (orientation: landscape) {\n    .height---3gtNG {\n      height: 192px; } }\n@media only screen and (-webkit-min-device-pixel-ratio: 1) and (device-width: 320px) and (device-height: 568px) and (orientation: portrait) {\n    .height---3gtNG {\n      height: 340.8px; } }\n@media only screen and (-webkit-min-device-pixel-ratio: 1) and (device-width: 320px) and (device-height: 568px) and (orientation: landscape) {\n    .height---3gtNG {\n      height: 192px; } }\n", ""]);

// exports
exports.locals = {
	"height": "height---3gtNG"
};

/***/ }),
/* 1169 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(4)();
// imports


// module
exports.push([module.i, ".courseDetailModal---1u26Z {\n  display: -webkit-box;\n  display: -moz-flex;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-direction: normal;\n  -webkit-box-orient: vertical;\n  -moz-flex-direction: column;\n  -ms-flex-direction: column;\n  flex-direction: column;\n  font-family: Poppins; }\n\n.courseDetailHeader---2a8CX {\n  -webkit-box-flex: none;\n  -moz-flex: none;\n  -ms-flex: none;\n  flex: none;\n  padding: 20px 25px;\n  color: #415667;\n  font-size: 27px; }\n\n.courseDetailContent---2_BuA {\n  min-height: 60vh;\n  max-height: 80vh;\n  padding: 0 25px;\n  overflow-y: auto; }\n\n.courseDetailFooter---3fjV2 {\n  -webkit-box-flex: none;\n  -moz-flex: none;\n  -ms-flex: none;\n  flex: none;\n  display: -webkit-box;\n  display: -moz-flex;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: end;\n  -ms-flex-pack: end;\n  -moz-justify-content: flex-end;\n  justify-content: flex-end;\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n  -moz-align-items: center;\n  align-items: center;\n  padding: 0 25px;\n  height: 75px; }\n\n.header---2rrxv {\n  background-color: #cfd2d4; }\n\n.subHeader---5kvdj {\n  background-color: #e7e9ea; }\n\n.mainHeading---6QQ-9 {\n  font-family: Poppins, sans-serif;\n  padding: 10px 0 10px 25px;\n  font-size: 30px;\n  font-weight: 500; }\n\n.title---RWNuN {\n  color: #4e5c67;\n  font-size: 30px;\n  font-weight: 500; }\n\n.subHeading---1ggAa {\n  font-family: Poppins, sans-serif;\n  padding: 10px 0 10px 25px;\n  font-size: 16px;\n  font-style: italic;\n  font-weight: 500; }\n\n.loader---3gKBh > div {\n  background-color: #4e5c67 !important;\n  width: 16px !important;\n  height: 16px !important;\n  margin: 4px !important; }\n\n.loaderContainer---3xGJp {\n  display: -webkit-box;\n  display: -moz-flex;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n  -moz-align-items: center;\n  align-items: center;\n  -webkit-box-pack: center;\n  -ms-flex-pack: center;\n  -moz-justify-content: center;\n  justify-content: center;\n  height: 500px; }\n", ""]);

// exports
exports.locals = {
	"courseDetailModal": "courseDetailModal---1u26Z",
	"courseDetailHeader": "courseDetailHeader---2a8CX",
	"courseDetailContent": "courseDetailContent---2_BuA",
	"courseDetailFooter": "courseDetailFooter---3fjV2",
	"header": "header---2rrxv",
	"subHeader": "subHeader---5kvdj",
	"mainHeading": "mainHeading---6QQ-9",
	"title": "title---RWNuN",
	"subHeading": "subHeading---1ggAa",
	"loader": "loader---3gKBh",
	"loaderContainer": "loaderContainer---3xGJp"
};

/***/ }),
/* 1170 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(4)();
// imports


// module
exports.push([module.i, "/**\n * Fix for vw, vh, vmin, vmax on iOS 7.\n * http://caniuse.com/#feat=viewport-units\n *\n * This fix works by replacing viewport units with px values on known screen sizes.\n *\n * iPhone 6 and 6 Plus cannot run iOS 7, so are not targeted by this fix.\n * Target devices running iOS 8+ will incidentally execute the media query,\n * but this will still produce the expected result; so this is not a problem.\n *\n * As an example, replace:\n *\n *   height: 50vh;\n *   font-size: 5vmin;\n *\n * with:\n *\n *   @include viewport-unit(height, 50vh);\n *   @include viewport-unit(font-size, 5vmin);\n */\n.height---2-P4i {\n  height: 60vh; }\n@media only screen and (-webkit-min-device-pixel-ratio: 1) and (device-width: 768px) and (device-height: 1024px) and (orientation: portrait) {\n    .height---2-P4i {\n      height: 614.4px; } }\n@media only screen and (-webkit-min-device-pixel-ratio: 1) and (device-width: 768px) and (device-height: 1024px) and (orientation: landscape) {\n    .height---2-P4i {\n      height: 460.8px; } }\n@media only screen and (-webkit-min-device-pixel-ratio: 1) and (device-width: 320px) and (device-height: 480px) and (orientation: portrait) {\n    .height---2-P4i {\n      height: 288px; } }\n@media only screen and (-webkit-min-device-pixel-ratio: 1) and (device-width: 320px) and (device-height: 480px) and (orientation: landscape) {\n    .height---2-P4i {\n      height: 192px; } }\n@media only screen and (-webkit-min-device-pixel-ratio: 1) and (device-width: 320px) and (device-height: 568px) and (orientation: portrait) {\n    .height---2-P4i {\n      height: 340.8px; } }\n@media only screen and (-webkit-min-device-pixel-ratio: 1) and (device-width: 320px) and (device-height: 568px) and (orientation: landscape) {\n    .height---2-P4i {\n      height: 192px; } }\n", ""]);

// exports
exports.locals = {
	"height": "height---2-P4i"
};

/***/ }),
/* 1171 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(4)();
// imports


// module
exports.push([module.i, "/**\n * Basic Breakpoint\n * url: https://responsivedesign.is/develop/getting-started-with-sass-and-breakpoint-mixin\n *\n * Usage:\n *\n * breakpoint(small-only | medium-up | medium-only | large-up | large-only) {\n * styles goes here\n * }\n*/\n.modal---1os_3 {\n  display: -webkit-box;\n  display: -moz-flex;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-direction: normal;\n  -webkit-box-orient: vertical;\n  -moz-flex-direction: column;\n  -ms-flex-direction: column;\n  flex-direction: column;\n  -webkit-box-pack: center;\n  -ms-flex-pack: center;\n  -moz-justify-content: center;\n  justify-content: center;\n  height: 100%;\n  background-color: rgba(255, 255, 255, .9);\n  border-radius: 5px;\n  max-width: 100%;\n  margin: 0 auto;\n  padding: 30px;\n  z-index: 99991; }\n.modal---1os_3 .is-a-modal {\n    height: 100%;\n    overflow: auto; }\n@media screen and (max-width: 39.9375em) {\n    .modal---1os_3 {\n      padding: 10px; } }\n.modalBackdrop---3EUUD {\n  position: fixed;\n  top: 0;\n  bottom: 0;\n  left: 0;\n  right: 0;\n  padding: 10px;\n  z-index: 99990; }\n.modalSmall---1ABAp {\n  display: -webkit-box;\n  display: -moz-flex;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-direction: normal;\n  -webkit-box-orient: vertical;\n  -moz-flex-direction: column;\n  -ms-flex-direction: column;\n  flex-direction: column;\n  -webkit-box-pack: center;\n  -ms-flex-pack: center;\n  -moz-justify-content: center;\n  justify-content: center;\n  height: 100%;\n  background-color: rgba(0, 0, 0, .3);\n  max-width: 100%;\n  margin: 0 auto;\n  padding: 30px;\n  z-index: 99991;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center; }\n@media screen and (max-width: 39.9375em) {\n    .modalSmall---1ABAp {\n      padding: 10px; } }\n.modalBackdropSmall---32TD7 {\n  position: fixed;\n  top: 0;\n  bottom: 0;\n  left: 0;\n  right: 0;\n  z-index: 99990; }\n@media print {\n  body,\n  div {\n    display: block !important;\n    height: 100%;\n    width: 100%; }\n  div[class^=\"modalBackdrop-\"],\n  div[class*=\"modalBackdrop-\"] {\n    position: absolute;\n    page-break-inside: avoid;\n    height: 100% !important;\n    display: block !important; }\n  div[class^=\"modal-\"],\n  div[class*=\"modal-\"] {\n    height: 100% !important; } }\n", ""]);

// exports
exports.locals = {
	"modal": "modal---1os_3",
	"modalBackdrop": "modalBackdrop---3EUUD",
	"modalSmall": "modalSmall---1ABAp",
	"modalBackdropSmall": "modalBackdropSmall---32TD7"
};

/***/ }),
/* 1172 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(4)();
// imports


// module
exports.push([module.i, ".component---2DM5F {\n  display: block; }\n", ""]);

// exports
exports.locals = {
	"component": "component---2DM5F"
};

/***/ }),
/* 1173 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(4)();
// imports


// module
exports.push([module.i, ".container---2A5Br {\n  display: -webkit-box;\n  display: -moz-flex;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n  -moz-align-items: center;\n  align-items: center;\n  height: 100%;\n  min-height: 30px;\n  background: #dbeeed; }\n\n.label---2d819 {\n  width: 84%;\n  padding-left: 10px;\n  float: left;\n  color: #444;\n  font-family: Poppins, sans-serif;\n  font-size: 13px;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis; }\n\n.svgIconContainer---3WEvE {\n  width: 17px;\n  height: 17px;\n  padding-top: 5px; }\n\n.svgIconContainer---3WEvE svg path {\n    fill: white !important; }\n\n.buttonWrapper---1m2VR {\n  display: -webkit-box;\n  display: -moz-flex;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: center;\n  -ms-flex-pack: center;\n  -moz-justify-content: center;\n  justify-content: center;\n  float: right;\n  width: 15%; }\n\n.button---3gv5L, .view---3j8fP, .cancel---2DYgx {\n  height: 30px;\n  width: 30px;\n  border-radius: 30px; }\n\n.spacing---14X0P {\n  padding: 3px; }\n\n.view---3j8fP {\n  background: #1c7fc3; }\n\n.cancel---2DYgx {\n  background: #a3c1c0; }\n", ""]);

// exports
exports.locals = {
	"container": "container---2A5Br",
	"label": "label---2d819",
	"svgIconContainer": "svgIconContainer---3WEvE",
	"buttonWrapper": "buttonWrapper---1m2VR",
	"button": "button---3gv5L",
	"view": "view---3j8fP",
	"cancel": "cancel---2DYgx",
	"spacing": "spacing---14X0P"
};

/***/ }),
/* 1174 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(4)();
// imports


// module
exports.push([module.i, ".header---zUV78 {\n  display: -webkit-box;\n  display: -moz-flex;\n  display: -ms-flexbox;\n  display: flex;\n  font-family: Poppins, sans-serif;\n  background-color: #cfd2d4;\n  padding: 0 25px;\n  font-size: 30px;\n  font-weight: 500;\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n  -moz-align-items: center;\n  align-items: center;\n  -webkit-box-pack: justify;\n  -ms-flex-pack: justify;\n  -moz-justify-content: space-between;\n  justify-content: space-between;\n  min-height: 80px; }\n\n.title---3XHxb {\n  color: #4e5c67;\n  font-size: 30px;\n  font-weight: 500;\n  -webkit-box-flex: 1;\n  -moz-flex: 1;\n  -ms-flex: 1;\n  flex: 1; }\n\n.subTitle---16i4Y {\n  font-family: Poppins, sans-serif;\n  padding: 26px;\n  height: 27px;\n  color: #415667;\n  font-size: 26px;\n  font-weight: 500;\n  line-height: 27px; }\n\n.content---3G_vH {\n  width: calc(100% - 60px);\n  height: 332px;\n  margin: 20px 24px;\n  background-color: #fff;\n  -webkit-box-shadow: 5px 5px 2px 0 #e7e9ea;\n          box-shadow: 5px 5px 2px 0 #e7e9ea;\n  border-radius: 6px; }\n\n.contentWrapper---2AUBk {\n  display: -webkit-box;\n  display: -moz-flex;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-direction: normal;\n  -webkit-box-orient: vertical;\n  -moz-flex-direction: column;\n  -ms-flex-direction: column;\n  flex-direction: column;\n  text-align: center; }\n\n.contentLabel---3Z-DP {\n  color: #4e5c67;\n  font-family: Poppins;\n  font-size: 16px;\n  font-weight: 500;\n  line-height: 27px;\n  padding: 25px; }\n\n.downloadStudentRoll---1lDu0 {\n  height: 45px;\n  width: 248px;\n  background-color: #415667;\n  border-radius: 20px;\n  color: #fff;\n  font-family: Poppins, sans-serif;\n  font-size: 16px;\n  font-weight: 500;\n  line-height: 27px;\n  border: 1px solid #959595;\n  margin: auto; }\n\n.svgIconContainer---2mZLP {\n  width: 25px;\n  height: 25px;\n  margin: 7px; }\n\n.svgIconContainer---2mZLP svg path {\n    fill: white !important; }\n\n.line---1WKw3 {\n  height: 1px;\n  width: calc(100% - 60px);\n  background-color: #e1e1e1;\n  margin: 25px auto; }\n", ""]);

// exports
exports.locals = {
	"header": "header---zUV78",
	"title": "title---3XHxb",
	"subTitle": "subTitle---16i4Y",
	"content": "content---3G_vH",
	"contentWrapper": "contentWrapper---2AUBk",
	"contentLabel": "contentLabel---3Z-DP",
	"downloadStudentRoll": "downloadStudentRoll---1lDu0",
	"svgIconContainer": "svgIconContainer---2mZLP",
	"line": "line---1WKw3"
};

/***/ }),
/* 1175 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(4)();
// imports


// module
exports.push([module.i, ".RadioButton---2pfLs {\n  display: inline-block;\n  width: 15px;\n  height: 15px;\n  margin-right: 5px;\n  position: relative; }\n  .RadioButton---2pfLs input[type=\"radio\"] {\n    z-index: 999;\n    opacity: 0;\n    position: absolute;\n    width: 100%;\n    height: 100%;\n    margin: 0;\n    cursor: pointer; }\n  .RadioButton---2pfLs input[type=\"radio\"] + label {\n    position: relative;\n    overflow: hidden;\n    margin: 0;\n    width: inherit;\n    height: inherit;\n    border-radius: 50%;\n    border: 1px solid rgba(172, 172, 172, .8); }\n  .RadioButton---2pfLs input[type=\"radio\"] + label::before {\n    content: \"\";\n    display: block;\n    position: absolute;\n    margin-top: -1px;\n    margin-left: -1px;\n    height: calc(100% + 2px);\n    width: calc(100% + 2px);\n    background: white;\n    border-radius: 50%;\n    -webkit-border-radius: 50%;\n    -moz-border-radius: 50%;\n    -o-border-radius: 50%; }\n  .RadioButton---2pfLs input[type=\"radio\"]:checked + label::before {\n    background: #415667;\n    border-color: transparent; }\n", ""]);

// exports
exports.locals = {
	"RadioButton": "RadioButton---2pfLs"
};

/***/ }),
/* 1176 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(4)();
// imports


// module
exports.push([module.i, ".react-grid-HeaderCell:nth-child(n+6):nth-child(-n+8) {\n  color: #1c7fc3; }\n\n.react-grid-HeaderCell:nth-child(8) {\n  min-width: 40px; }\n\n.react-grid-Cell:nth-child(8) {\n  min-width: 40px; }\n\n.renameGroupComponent---1kvUJ {\n  display: -webkit-box;\n  display: -moz-flex;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-direction: normal;\n  -webkit-box-orient: vertical;\n  -moz-flex-direction: column;\n  -ms-flex-direction: column;\n  flex-direction: column;\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n  -moz-align-items: center;\n  align-items: center;\n  position: relative; }\n\n.renameGroupHeader---1ipXi {\n  padding: 30px;\n  color: #4e5c67;\n  font-family: Poppins;\n  font-size: 28px;\n  font-weight: 500;\n  line-height: 27px; }\n\n.topSpacing----kuq-, .groupName---33MsM, .actionButtonWrapper---1GHc9 {\n  padding-top: 10px; }\n\n.groupName---33MsM ::-webkit-input-placeholder {\n  color: lightgray; }\n\n.groupName---33MsM ::-moz-placeholder {\n  color: lightgray; }\n\n.groupName---33MsM :-moz-placeholder {\n  color: lightgray; }\n\n.groupName---33MsM :-ms-input-placeholder {\n  color: lightgray; }\n\n.actionButtonWrapper---1GHc9 {\n  display: -webkit-box;\n  display: -moz-flex;\n  display: -ms-flexbox;\n  display: flex; }\n\n.actionButton---1mjvA, .btnSuccess---1F2D7, .btnDanger---3rD7R {\n  height: 90px;\n  width: 90px;\n  border-radius: 90px; }\n\n.btnSuccess---1F2D7 {\n  border: none;\n  background-color: #5cb85c; }\n\n.btnDanger---3rD7R {\n  margin-right: 12px;\n  background-color: #c53902; }\n\n.svgIconContainer---jFsoc {\n  width: 40px;\n  height: 40px;\n  margin: 22px; }\n\n.svgIconContainer---jFsoc svg path {\n    fill: white !important; }\n\n.highlight---2kkSs {\n  color: #1981c4; }\n\n.buttonClose---299Ef {\n  position: absolute;\n  right: 10%;\n  top: 0; }\n", ""]);

// exports
exports.locals = {
	"renameGroupComponent": "renameGroupComponent---1kvUJ",
	"renameGroupHeader": "renameGroupHeader---1ipXi",
	"topSpacing": "topSpacing----kuq-",
	"groupName": "groupName---33MsM",
	"actionButtonWrapper": "actionButtonWrapper---1GHc9",
	"actionButton": "actionButton---1mjvA",
	"btnSuccess": "btnSuccess---1F2D7",
	"btnDanger": "btnDanger---3rD7R",
	"svgIconContainer": "svgIconContainer---jFsoc",
	"highlight": "highlight---2kkSs",
	"buttonClose": "buttonClose---299Ef"
};

/***/ }),
/* 1177 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(4)();
// imports


// module
exports.push([module.i, ".react-grid-HeaderCell:nth-child(n+6):nth-child(-n+8) {\n  color: #1c7fc3; }\n\n.react-grid-HeaderCell:nth-child(8) {\n  min-width: 40px; }\n\n.react-grid-Cell:nth-child(8) {\n  min-width: 40px; }\n\n/**\n * Basic Breakpoint\n * url: https://responsivedesign.is/develop/getting-started-with-sass-and-breakpoint-mixin\n *\n * Usage:\n *\n * breakpoint(small-only | medium-up | medium-only | large-up | large-only) {\n * styles goes here\n * }\n*/\n\n/**\n * Fix for vw, vh, vmin, vmax on iOS 7.\n * http://caniuse.com/#feat=viewport-units\n *\n * This fix works by replacing viewport units with px values on known screen sizes.\n *\n * iPhone 6 and 6 Plus cannot run iOS 7, so are not targeted by this fix.\n * Target devices running iOS 8+ will incidentally execute the media query,\n * but this will still produce the expected result; so this is not a problem.\n *\n * As an example, replace:\n *\n *   height: 50vh;\n *   font-size: 5vmin;\n *\n * with:\n *\n *   @include viewport-unit(height, 50vh);\n *   @include viewport-unit(font-size, 5vmin);\n */\n\n.rollOverComponent---1W1zm {\n  display: -webkit-box;\n  display: -moz-flex;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-flex: 10;\n  -moz-flex: 10;\n  -ms-flex: 10;\n  flex: 10;\n  -webkit-box-direction: normal;\n  -webkit-box-orient: vertical;\n  -moz-flex-direction: column;\n  -ms-flex-direction: column;\n  flex-direction: column;\n  position: absolute;\n  color: #4e5c67;\n  font-family: Poppins, sans-serif;\n  background-color: #e7e9ea;\n  height: 100%;\n  width: 100%; }\n\n.rollOverContainer---2zpB9 {\n  height: 100%; }\n\n.rollOverFooter---1rBjS {\n  display: -webkit-box;\n  display: -moz-flex;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n  -moz-align-items: center;\n  align-items: center;\n  -webkit-box-pack: justify;\n  -ms-flex-pack: justify;\n  -moz-justify-content: space-between;\n  justify-content: space-between;\n  -webkit-box-direction: reverse;\n  -webkit-box-orient: horizontal;\n  -moz-flex-direction: row-reverse;\n  -ms-flex-direction: row-reverse;\n  flex-direction: row-reverse;\n  position: fixed;\n  bottom: 0.1px;\n  left: 0.1px;\n  width: 100%;\n  height: 77px;\n  padding-left: 40px;\n  padding-right: 40px;\n  background-color: #adb6bc; }\n\n@media screen and (max-width: 39.9375em) {\n    .rollOverFooter---1rBjS {\n      padding: 0 20px; } }\n\n.rollOverFooterLeft---7qMKJ {\n    width: auto; }\n\n.rollOverFooterRight---3G6wY {\n    -webkit-box-pack: end;\n    -ms-flex-pack: end;\n    -moz-justify-content: flex-end;\n    justify-content: flex-end;\n    width: auto; }\n\n.rollOverFooterRight---3G6wY, .rollOverFooterLeft---7qMKJ {\n    display: -webkit-box;\n    display: -moz-flex;\n    display: -ms-flexbox;\n    display: flex; }\n\n.rollOverFooterRight---3G6wY > div, .rollOverFooterLeft---7qMKJ > div {\n      margin: 0 5px; }\n\n.header---3-86O {\n  display: -webkit-box;\n  display: -moz-flex;\n  display: -ms-flexbox;\n  display: flex;\n  font-family: Poppins, sans-serif;\n  background-color: #cfd2d4;\n  padding: 0 25px;\n  font-size: 30px;\n  font-weight: 500;\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n  -moz-align-items: center;\n  align-items: center;\n  -webkit-box-pack: justify;\n  -ms-flex-pack: justify;\n  -moz-justify-content: space-between;\n  justify-content: space-between;\n  min-height: 80px; }\n\n.title---ClNmS {\n  color: #4e5c67;\n  font-size: 30px;\n  font-weight: 500;\n  -webkit-box-flex: 1;\n  -moz-flex: 1;\n  -ms-flex: 1;\n  flex: 1; }\n\n.content---3a3Xe {\n  display: -webkit-box;\n  display: -moz-flex;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-flex: none;\n  -moz-flex: none;\n  -ms-flex: none;\n  flex: none;\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n  -moz-align-items: center;\n  align-items: center;\n  -webkit-box-pack: center;\n  -ms-flex-pack: center;\n  -moz-justify-content: center;\n  justify-content: center;\n  width: calc(100% - 45px);\n  min-height: calc(100% - 120px);\n  margin: 20px 24px;\n  background-color: #fff;\n  -webkit-box-shadow: 5px 5px 1px rgba(179, 179, 179, .3);\n          box-shadow: 5px 5px 1px rgba(179, 179, 179, .3);\n  border-radius: 6px;\n  padding-bottom: 60px; }\n\n@media screen and (max-width: 39.9375em) {\n    .content---3a3Xe {\n      padding-bottom: 75px; } }\n\n.contentWrapper---3mOZy {\n  display: -webkit-box;\n  display: -moz-flex;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-direction: normal;\n  -webkit-box-orient: vertical;\n  -moz-flex-direction: column;\n  -ms-flex-direction: column;\n  flex-direction: column;\n  -webkit-box-pack: center;\n  -ms-flex-pack: center;\n  -moz-justify-content: center;\n  justify-content: center;\n  height: inherit;\n  width: inherit;\n  padding: 0;\n  text-align: center; }\n\n.contentBody---zJULK {\n  padding: 5px; }\n\n.contentLabel---3RQ-K {\n  display: -webkit-box;\n  display: -moz-flex;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n  -moz-align-items: center;\n  align-items: center;\n  -webkit-box-pack: center;\n  -ms-flex-pack: center;\n  -moz-justify-content: center;\n  justify-content: center;\n  color: #4e5c67;\n  text-align: center;\n  font-family: Poppins;\n  font-size: 16px;\n  font-weight: 500;\n  line-height: 27px;\n  padding: 25px; }\n\n@media screen and (max-width: 39.9375em) {\n    .contentLabel---3RQ-K {\n      font-size: 14px;\n      padding: 25px 0;\n      line-height: 1.2em; } }\n\n.componentContainer---28iWj {\n  height: 100%; }\n\n@media print {\n  div[class^=\"rollOverComponent-\"],\n  div[class*=\"rollOverComponent-\"] {\n    display: none !important; } }\n\n@media screen and (min-width: 40em) {\n  .rollOverInitial---1NhFz {\n    padding: 0; } }\n\n.listContainer---2l-wo {\n  width: 100%;\n  margin: 0 auto; }\n\n@media screen and (min-width: 40em) {\n    .listContainer---2l-wo {\n      width: 440px; } }\n\n.listContainer---2l-wo [type=\"checkbox\"] {\n    display: unset;\n    width: 15px;\n    height: 15px; }\n\n.listItem---1ubv9, .includeUnassigned---1zdeR, .includeBulkTransfer---OWFa1 {\n  display: -webkit-box;\n  display: -moz-flex;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n  -moz-align-items: center;\n  align-items: center;\n  text-align: left;\n  font-size: 22px;\n  line-height: 1.1em;\n  margin-bottom: 10px; }\n\n@media screen and (max-width: 39.9375em) {\n    .listItem---1ubv9, .includeUnassigned---1zdeR, .includeBulkTransfer---OWFa1 {\n      -webkit-box-align: start;\n      -ms-flex-align: start;\n      -moz-align-items: start;\n      align-items: start;\n      font-size: 18px;\n      margin-bottom: 10px; } }\n\n.listItemBullet---3K8e0 {\n  -ms-flex-negative: 0;\n  flex-shrink: 0;\n  margin-right: 10px;\n  display: inline-block;\n  width: 35px;\n  height: 35px;\n  background-color: #4e5c67;\n  color: #fff;\n  line-height: 35px;\n  text-align: center;\n  font-size: 20px;\n  border-radius: 35px; }\n\n.includeUnassigned---1zdeR {\n  font-size: 14px;\n  margin-bottom: 10px;\n  height: 10px; }\n\n.includeBulkTransfer---OWFa1 {\n  font-size: 14px;\n  margin-bottom: 60px;\n  height: 10px; }\n\n.downloadButton---UEC-f {\n  -ms-flex-negative: 0;\n  flex-shrink: 0;\n  width: 60px;\n  height: 60px; }\n\n.downloadButton---UEC-f > div {\n    height: 100%;\n    width: 100%; }\n\n.downloadButton---UEC-f svg path {\n    fill: #4e5c67 !important; }\n\n.helpButton---p7qZi {\n  -webkit-box-flex: none;\n  -moz-flex: none;\n  -ms-flex: none;\n  flex: none;\n  border: 2px solid #4e5c67;\n  border-radius: 50px;\n  width: 25px;\n  height: 25px;\n  margin: 0 10px;\n  outline: none; }\n\n.helpButtonContainer---3tBwz {\n  height: 100%;\n  width: 100%;\n  position: relative; }\n\n.helpButtonContainer---3tBwz span {\n    line-height: 23px;\n    position: absolute;\n    left: 0;\n    height: 100%;\n    width: 100%; }\n\n.selectionContainer---3dL5I {\n  display: -webkit-box;\n  display: -moz-flex;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-direction: normal;\n  -webkit-box-orient: horizontal;\n  -moz-flex-direction: row;\n  -ms-flex-direction: row;\n  flex-direction: row;\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n  -moz-align-items: center;\n  align-items: center;\n  -webkit-box-pack: center;\n  -ms-flex-pack: center;\n  -moz-justify-content: center;\n  justify-content: center; }\n\n@media screen and (max-width: 39.9375em) {\n    .selectionContainer---3dL5I {\n      -webkit-box-direction: normal;\n      -webkit-box-orient: vertical;\n      -moz-flex-direction: column;\n      -ms-flex-direction: column;\n      flex-direction: column; } }\n\n.selectionItem---3j2Mf {\n  width: 265px;\n  min-height: 320px;\n  margin: 20px 24px;\n  background-color: #fff;\n  -webkit-box-shadow: 5px 5px 1px rgba(153, 153, 153, .3);\n          box-shadow: 5px 5px 1px rgba(153, 153, 153, .3);\n  border: 1px solid rgba(102, 102, 102, .3);\n  border-radius: 6px;\n  overflow: hidden;\n  text-overflow: ellipsis; }\n\n.selectionItem---3j2Mf > div {\n    height: 100%; }\n\n@media screen and (max-width: 39.9375em) {\n    .selectionItem---3j2Mf {\n      width: 100%; } }\n\n.selectionItemContent---1rCUO {\n    height: 100%;\n    padding: 10px 20px; }\n\n.selectionItemContent---1rCUO h2 {\n      font-size: 20px;\n      padding: 20px 0;\n      letter-spacing: 0.4px;\n      margin: 0; }\n\n.selectionItemContent---1rCUO p {\n      text-align: left;\n      line-height: 1.8em; }\n\n@media screen and (max-width: 39.9375em) {\n        .selectionItemContent---1rCUO p {\n          font-size: 12px;\n          line-height: 1.8em; } }\n\n.rollOverPartialIsActive---1EgDt,\n.rollOverFullIsActive---2Mc_V {\n  -webkit-box-shadow: inset 5px 5px 5px rgba(0, 0, 0, .3);\n          box-shadow: inset 5px 5px 5px rgba(0, 0, 0, .3);\n  background-color: #415667;\n  color: #fff; }\n\n.rollOverModal---2LC0n {\n  height: 100%;\n  font-family: Poppins, sans-serif;\n  font-size: 1em;\n  color: #415667;\n  padding-top: 0; }\n\n.rollOverModal---2LC0n h2 {\n    text-transform: uppercase;\n    font-size: 1.2em;\n    padding: 15px 0;\n    margin: 0; }\n\n.rollOverModalCloseBtn---2nymd {\n    display: none; }\n\n@media screen and (max-width: 39.9375em) {\n      .rollOverModalCloseBtn---2nymd {\n        display: inline-block;\n        position: fixed;\n        right: 15px;\n        top: 15px; } }\n\n.rollOverModalContent---1Pmls {\n    height: 75vh;\n    overflow-y: auto;\n    word-wrap: break-word;\n    margin: 0 auto;\n    margin-bottom: 50px; }\n\n@media only screen and (-webkit-min-device-pixel-ratio: 1) and (device-width: 768px) and (device-height: 1024px) and (orientation: portrait) {\n      .rollOverModalContent---1Pmls {\n        height: 768px; } }\n\n@media only screen and (-webkit-min-device-pixel-ratio: 1) and (device-width: 768px) and (device-height: 1024px) and (orientation: landscape) {\n      .rollOverModalContent---1Pmls {\n        height: 576px; } }\n\n@media only screen and (-webkit-min-device-pixel-ratio: 1) and (device-width: 320px) and (device-height: 480px) and (orientation: portrait) {\n      .rollOverModalContent---1Pmls {\n        height: 360px; } }\n\n@media only screen and (-webkit-min-device-pixel-ratio: 1) and (device-width: 320px) and (device-height: 480px) and (orientation: landscape) {\n      .rollOverModalContent---1Pmls {\n        height: 240px; } }\n\n@media only screen and (-webkit-min-device-pixel-ratio: 1) and (device-width: 320px) and (device-height: 568px) and (orientation: portrait) {\n      .rollOverModalContent---1Pmls {\n        height: 426px; } }\n\n@media only screen and (-webkit-min-device-pixel-ratio: 1) and (device-width: 320px) and (device-height: 568px) and (orientation: landscape) {\n      .rollOverModalContent---1Pmls {\n        height: 240px; } }\n\n.rollOverModalFooter---3b3w3 {\n    display: -webkit-box;\n    display: -moz-flex;\n    display: -ms-flexbox;\n    display: flex;\n    position: fixed;\n    bottom: 0;\n    left: 0;\n    width: 100%;\n    padding: 20px;\n    background-color: #fff; }\n\n@media screen and (max-width: 39.9375em) {\n      .rollOverModalFooter---3b3w3 {\n        -webkit-box-direction: normal;\n        -webkit-box-orient: vertical;\n        -moz-flex-direction: column;\n        -ms-flex-direction: column;\n        flex-direction: column; } }\n\n.rollOverModalFooterLeft---2hWDM {\n      width: 70%; }\n\n.rollOverModalFooterRight---1IxRB {\n      -webkit-box-pack: end;\n      -ms-flex-pack: end;\n      -moz-justify-content: flex-end;\n      justify-content: flex-end;\n      width: 30%; }\n\n.rollOverModalFooterRight---1IxRB, .rollOverModalFooterLeft---2hWDM {\n      display: -webkit-box;\n      display: -moz-flex;\n      display: -ms-flexbox;\n      display: flex; }\n\n.rollOverModalFooterRight---1IxRB > div, .rollOverModalFooterLeft---2hWDM > div {\n        margin: 0 5px; }\n\n@media screen and (max-width: 39.9375em) {\n      .rollOverModalFooterRight---1IxRB, .rollOverModalFooterLeft---2hWDM {\n        width: 100%; }\n      .rollOverModalFooterLeft---2hWDM {\n        -webkit-box-direction: normal;\n        -webkit-box-orient: vertical;\n        -moz-flex-direction: column;\n        -ms-flex-direction: column;\n        flex-direction: column; }\n        .rollOverModalFooterLeft---2hWDM > div {\n          margin-top: 5px; }\n      .rollOverModalFooterRight---1IxRB {\n        display: none; } }\n\n.uploadFile---Qrfgu {\n  display: -webkit-box;\n  display: -moz-flex;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: center;\n  -ms-flex-pack: center;\n  -moz-justify-content: center;\n  justify-content: center;\n  width: 154px;\n  height: 45px;\n  background-color: #415667;\n  border-radius: 22px;\n  margin: auto;\n  color: #fff;\n  font-family: Poppins, sans-serif;\n  font-size: 16px;\n  font-weight: 500; }\n\n.uploadContainer---_ULZR {\n  -webkit-box-align: start;\n  -ms-flex-align: start;\n  -moz-align-items: start;\n  align-items: start;\n  height: calc(100% - 120px);\n  min-height: 420px;\n  padding-top: 15px;\n  padding-bottom: 0; }\n\n@media screen and (max-width: 39.9375em) {\n    .uploadContainer---_ULZR {\n      height: auto;\n      min-height: 0; } }\n\n.svgIconContainer---3bO1Q {\n  width: 25px;\n  height: 25px;\n  margin: 7px; }\n\n.svgIconContainer---3bO1Q svg path {\n    fill: white !important; }\n\n.svgContainer---1Jaid {\n  width: 1px;\n  height: 1px; }\n\n.svgContainer---1Jaid svg path {\n    fill: none !important; }\n\n.browseButton---HI85Y {\n  display: none !important; }\n\n.uploadContentWrapper---3G-eX {\n  display: -webkit-box;\n  display: -moz-flex;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: justify;\n  -ms-flex-pack: justify;\n  -moz-justify-content: space-between;\n  justify-content: space-between;\n  padding: 25px 20px 0.1px; }\n\n@media screen and (max-width: 39.9375em) {\n    .uploadContentWrapper---3G-eX {\n      -webkit-box-direction: normal;\n      -webkit-box-orient: vertical;\n      -moz-flex-direction: column;\n      -ms-flex-direction: column;\n      flex-direction: column; } }\n\n.uploadContentLabel---3fCwX {\n  float: left;\n  display: -webkit-inline-box;\n  display: -ms-inline-flexbox;\n  display: inline-flex;\n  width: 70%;\n  padding: 10px;\n  color: #4e5c67;\n  font-family: Poppins;\n  font-size: 16px;\n  font-weight: 500;\n  line-height: 27px; }\n\n@media screen and (max-width: 39.9375em) {\n    .uploadContentLabel---3fCwX {\n      float: none;\n      width: 100%;\n      padding: 10px 0;\n      font-size: 14px;\n      line-height: 1.2em; } }\n\n.uploadButtonContainer---2bqg_ {\n  display: -webkit-box;\n  display: -moz-flex;\n  display: -ms-flexbox;\n  display: flex;\n  vertical-align: middle; }\n\n@media screen and (max-width: 1300px) {\n  .emptyOuterContainer---3fmyo {\n    transform: scale(0.6, 0.6);\n    -ms-transform: scale(0.6, 0.6);\n    /* IE 9 */\n    -webkit-transform: scale(0.6, 0.6);\n    /* Safari and Chrome */\n    -o-transform: scale(0.6, 0.6);\n    /* Opera */\n    -moz-transform: scale(0.6, 0.6);\n    /* Firefox */\n    padding-top: 0.1px; } }\n\n.downloadStudentRoll---xQAJR {\n  width: 248px;\n  height: 45px;\n  background-color: #415667;\n  border-radius: 20px;\n  color: #fff;\n  font-family: Poppins, sans-serif;\n  font-size: 16px;\n  font-weight: 500;\n  line-height: 27px;\n  border: 1px solid #959595;\n  margin: auto; }\n\n.dataGridWrapper---3EUWa {\n  width: 100%;\n  height: 100%; }\n\n.dataGridContainer---3ax7q {\n  height: 100%;\n  padding-bottom: 60px; }\n\n@media screen and (max-width: 39.9375em) {\n    .dataGridContainer---3ax7q {\n      height: 50vh; } }\n\n@media only screen and (max-width: 39.9375em) and (-webkit-min-device-pixel-ratio: 1) and (device-width: 768px) and (device-height: 1024px) and (orientation: portrait) {\n    .dataGridContainer---3ax7q {\n      height: 512px; } }\n\n@media only screen and (max-width: 39.9375em) and (-webkit-min-device-pixel-ratio: 1) and (device-width: 768px) and (device-height: 1024px) and (orientation: landscape) {\n    .dataGridContainer---3ax7q {\n      height: 384px; } }\n\n@media only screen and (max-width: 39.9375em) and (-webkit-min-device-pixel-ratio: 1) and (device-width: 320px) and (device-height: 480px) and (orientation: portrait) {\n    .dataGridContainer---3ax7q {\n      height: 240px; } }\n\n@media only screen and (max-width: 39.9375em) and (-webkit-min-device-pixel-ratio: 1) and (device-width: 320px) and (device-height: 480px) and (orientation: landscape) {\n    .dataGridContainer---3ax7q {\n      height: 160px; } }\n\n@media only screen and (max-width: 39.9375em) and (-webkit-min-device-pixel-ratio: 1) and (device-width: 320px) and (device-height: 568px) and (orientation: portrait) {\n    .dataGridContainer---3ax7q {\n      height: 284px; } }\n\n@media only screen and (max-width: 39.9375em) and (-webkit-min-device-pixel-ratio: 1) and (device-width: 320px) and (device-height: 568px) and (orientation: landscape) {\n    .dataGridContainer---3ax7q {\n      height: 160px; } }\n\n.dataGridContainer---3ax7q > div {\n  height: 100%; }\n\n.uploadedRecordCount---3NF-- {\n  color: #32a8a7;\n  font-weight: 500; }\n\n.message---3P-Hv {\n  display: inline;\n  padding-left: 25px;\n  line-height: 27px; }\n\n.rowNumber---suV4X {\n  font-size: 14px; }\n\n.react-grid-HeaderCell {\n  color: #415667 !important; }\n\n.react-grid-HeaderCell:nth-child(6) {\n  color: #415667 !important; }\n\n.react-grid-HeaderCell:nth-child(7) {\n  color: #415667 !important; }\n\n.react-grid-HeaderCell:nth-child(8) {\n  color: #415667 !important;\n  min-width: 40px; }\n\n@media print {\n  div[class^=\"message-\"],\n  div[class*=\"message-\"] {\n    display: inline !important; } }\n\n.confirmationContainer---10xEO {\n  display: -webkit-box;\n  display: -moz-flex;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: center;\n  -ms-flex-pack: center;\n  -moz-justify-content: center;\n  justify-content: center;\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n  -moz-align-items: center;\n  align-items: center;\n  -webkit-box-direction: normal;\n  -webkit-box-orient: vertical;\n  -moz-flex-direction: column;\n  -ms-flex-direction: column;\n  flex-direction: column;\n  outline: none;\n  color: #4e5c67; }\n\n.icon---26bxu {\n  width: 60px;\n  height: 75px;\n  margin-bottom: 15px; }\n\n.okButton---3XMKT {\n  -webkit-box-shadow: none;\n          box-shadow: none;\n  border-radius: 22px;\n  margin-top: 15px;\n  background-color: #415667;\n  width: 95px;\n  height: 45px;\n  border: none;\n  color: white;\n  font-size: 16px;\n  font-weight: 500;\n  outline: none; }\n\n.cancelBtn---1DHix,\n.proceedBtn---1ORWO {\n  -webkit-box-shadow: none;\n          box-shadow: none;\n  border-radius: 22px;\n  margin-top: 15px;\n  background-color: #415667;\n  width: 95px;\n  height: 45px;\n  border: none;\n  color: white;\n  font-size: 16px;\n  font-weight: 500;\n  outline: none; }\n\n.confirmBtnContainer---3Dd_9 {\n  display: -webkit-box;\n  display: -moz-flex;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: justify;\n  -ms-flex-pack: justify;\n  -moz-justify-content: space-between;\n  justify-content: space-between;\n  width: 210px;\n  margin: 40px; }\n\n.confirmTitle---3opzw {\n  color: #4e5c67;\n  font-size: 30px;\n  font-weight: 500;\n  margin-bottom: 10px;\n  min-height: 40px;\n  -webkit-box-flex: 1;\n  -moz-flex: 1;\n  -ms-flex: 1;\n  flex: 1; }\n\n@media screen and (max-width: 39.9375em) {\n    .confirmTitle---3opzw {\n      font-size: 20px;\n      line-height: 1.2em;\n      text-align: center;\n      margin-bottom: 10px; } }\n\n.resultContainer---20NBp {\n  color: #000;\n  font-family: Poppins;\n  font-size: 14px;\n  line-height: 27px; }\n\n.resultSection---3tUoL {\n  margin: 10px 0.1px; }\n\n@media print {\n  .resultContainer---20NBp {\n    width: 100%; } }\n\n.summary---2aiAD {\n  color: #4e5c67;\n  font-family: Poppins;\n  font-size: 22px;\n  font-weight: 500;\n  line-height: 27px; }\n\n@media screen and (max-width: 39.9375em) {\n    .summary---2aiAD {\n      text-align: left;\n      padding-bottom: 15px; } }\n\n.summaryDatagrid---2fcI- {\n  height: 70vh; }\n\n@media only screen and (-webkit-min-device-pixel-ratio: 1) and (device-width: 768px) and (device-height: 1024px) and (orientation: portrait) {\n    .summaryDatagrid---2fcI- {\n      height: 716.8px; } }\n\n@media only screen and (-webkit-min-device-pixel-ratio: 1) and (device-width: 768px) and (device-height: 1024px) and (orientation: landscape) {\n    .summaryDatagrid---2fcI- {\n      height: 537.6px; } }\n\n@media only screen and (-webkit-min-device-pixel-ratio: 1) and (device-width: 320px) and (device-height: 480px) and (orientation: portrait) {\n    .summaryDatagrid---2fcI- {\n      height: 336px; } }\n\n@media only screen and (-webkit-min-device-pixel-ratio: 1) and (device-width: 320px) and (device-height: 480px) and (orientation: landscape) {\n    .summaryDatagrid---2fcI- {\n      height: 224px; } }\n\n@media only screen and (-webkit-min-device-pixel-ratio: 1) and (device-width: 320px) and (device-height: 568px) and (orientation: portrait) {\n    .summaryDatagrid---2fcI- {\n      height: 397.6px; } }\n\n@media only screen and (-webkit-min-device-pixel-ratio: 1) and (device-width: 320px) and (device-height: 568px) and (orientation: landscape) {\n    .summaryDatagrid---2fcI- {\n      height: 224px; } }\n\n.summaryContentWrapper---1dNcj {\n  -webkit-box-align: start;\n  -ms-flex-align: start;\n  -moz-align-items: start;\n  align-items: start;\n  padding-top: 20px; }\n\n.summaryWrapper---2AiUU {\n  display: -webkit-box;\n  display: -moz-flex;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: justify;\n  -ms-flex-pack: justify;\n  -moz-justify-content: space-between;\n  justify-content: space-between;\n  padding: 25px 20px 0.1px; }\n\n@media screen and (max-width: 39.9375em) {\n    .summaryWrapper---2AiUU {\n      -webkit-box-direction: normal;\n      -webkit-box-orient: vertical;\n      -moz-flex-direction: column;\n      -ms-flex-direction: column;\n      flex-direction: column; } }\n\n.dropdownBorder---3aDV7 {\n  padding: 1px;\n  border: 1px solid #cfd2d4; }\n\n.dropdownBorder---3aDV7 > div {\n    width: 100%; }\n", ""]);

// exports
exports.locals = {
	"rollOverComponent": "rollOverComponent---1W1zm",
	"rollOverContainer": "rollOverContainer---2zpB9",
	"rollOverFooter": "rollOverFooter---1rBjS",
	"rollOverFooterLeft": "rollOverFooterLeft---7qMKJ",
	"rollOverFooterRight": "rollOverFooterRight---3G6wY",
	"header": "header---3-86O",
	"title": "title---ClNmS",
	"content": "content---3a3Xe",
	"contentWrapper": "contentWrapper---3mOZy",
	"contentBody": "contentBody---zJULK",
	"contentLabel": "contentLabel---3RQ-K",
	"componentContainer": "componentContainer---28iWj",
	"rollOverInitial": "rollOverInitial---1NhFz",
	"listContainer": "listContainer---2l-wo",
	"listItem": "listItem---1ubv9",
	"includeUnassigned": "includeUnassigned---1zdeR",
	"includeBulkTransfer": "includeBulkTransfer---OWFa1",
	"listItemBullet": "listItemBullet---3K8e0",
	"downloadButton": "downloadButton---UEC-f",
	"helpButton": "helpButton---p7qZi",
	"helpButtonContainer": "helpButtonContainer---3tBwz",
	"selectionContainer": "selectionContainer---3dL5I",
	"selectionItem": "selectionItem---3j2Mf",
	"selectionItemContent": "selectionItemContent---1rCUO",
	"rollOverPartialIsActive": "rollOverPartialIsActive---1EgDt",
	"rollOverFullIsActive": "rollOverFullIsActive---2Mc_V",
	"rollOverModal": "rollOverModal---2LC0n",
	"rollOverModalCloseBtn": "rollOverModalCloseBtn---2nymd",
	"rollOverModalContent": "rollOverModalContent---1Pmls",
	"rollOverModalFooter": "rollOverModalFooter---3b3w3",
	"rollOverModalFooterLeft": "rollOverModalFooterLeft---2hWDM",
	"rollOverModalFooterRight": "rollOverModalFooterRight---1IxRB",
	"uploadFile": "uploadFile---Qrfgu",
	"uploadContainer": "uploadContainer---_ULZR",
	"svgIconContainer": "svgIconContainer---3bO1Q",
	"svgContainer": "svgContainer---1Jaid",
	"browseButton": "browseButton---HI85Y",
	"uploadContentWrapper": "uploadContentWrapper---3G-eX",
	"uploadContentLabel": "uploadContentLabel---3fCwX",
	"uploadButtonContainer": "uploadButtonContainer---2bqg_",
	"emptyOuterContainer": "emptyOuterContainer---3fmyo",
	"downloadStudentRoll": "downloadStudentRoll---xQAJR",
	"dataGridWrapper": "dataGridWrapper---3EUWa",
	"dataGridContainer": "dataGridContainer---3ax7q",
	"uploadedRecordCount": "uploadedRecordCount---3NF--",
	"message": "message---3P-Hv",
	"rowNumber": "rowNumber---suV4X",
	"confirmationContainer": "confirmationContainer---10xEO",
	"icon": "icon---26bxu",
	"okButton": "okButton---3XMKT",
	"cancelBtn": "cancelBtn---1DHix",
	"proceedBtn": "proceedBtn---1ORWO",
	"confirmBtnContainer": "confirmBtnContainer---3Dd_9",
	"confirmTitle": "confirmTitle---3opzw",
	"resultContainer": "resultContainer---20NBp",
	"resultSection": "resultSection---3tUoL",
	"summary": "summary---2aiAD",
	"summaryDatagrid": "summaryDatagrid---2fcI-",
	"summaryContentWrapper": "summaryContentWrapper---1dNcj",
	"summaryWrapper": "summaryWrapper---2AiUU",
	"dropdownBorder": "dropdownBorder---3aDV7"
};

/***/ }),
/* 1178 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(4)();
// imports


// module
exports.push([module.i, ".rootContainer---1XRuo {\n  display: -webkit-box;\n  display: -moz-flex;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-direction: normal;\n  -webkit-box-orient: vertical;\n  -moz-flex-direction: column;\n  -ms-flex-direction: column;\n  flex-direction: column;\n  height: 100%; }\n\n@media print {\n  .rootContainer---1XRuo:nth-child(2) {\n    height: 1px !important;\n    max-height: 1px !important; } }\n", ""]);

// exports
exports.locals = {
	"rootContainer": "rootContainer---1XRuo"
};

/***/ }),
/* 1179 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(4)();
// imports


// module
exports.push([module.i, ".searchBoxComponent---3n5r6 {\n  display: -webkit-box;\n  display: -moz-flex;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n  -moz-align-items: center;\n  align-items: center;\n  -webkit-box-pack: end;\n  -ms-flex-pack: end;\n  -moz-justify-content: flex-end;\n  justify-content: flex-end; }\n\n.searchButton---2FxtE {\n  height: 35px;\n  width: 35px;\n  background-color: #415667;\n  color: #fff;\n  border: 1px solid #959595; }\n\n.svgIconContainerSearchButton---1EFR- {\n  width: 25px;\n  height: 25px;\n  margin: 6px; }\n\n.svgIconContainerSearchButton---1EFR- svg path {\n    fill: white !important; }\n\n.searchTextBox---h_VSz {\n  width: 100px; }\n\n.searchTextBoxComponent---3WIzb {\n  width: 150px;\n  min-height: 33px;\n  border: 1px solid #cfd2d4;\n  float: left;\n  display: inline-block;\n  background-color: white;\n  vertical-align: middle; }\n\ninput.textBoxSearchText---1XK9B {\n  background-color: #fff;\n  border: 0;\n  width: 117px;\n  min-height: 34px;\n  padding-left: 5px;\n  outline: none; }\n\n.textBoxSearchText---1XK9B::-ms-clear {\n  display: none; }\n\n.svgIconContainerTextBoxSearch---3CGlu {\n  width: 8px;\n  height: 8px; }\n\n.svgIconContainerTextBoxSearch---3CGlu svg path {\n    fill: gray !important; }\n\n.searchClearButton---dmyWe {\n  background-color: #cfd2d4;\n  height: 20px;\n  width: 20px;\n  border-radius: 50px;\n  margin: 7px 5px;\n  float: right;\n  border: 0; }\n\n.buttonContainer---20wiD {\n  display: -webkit-box;\n  display: -moz-flex;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: center;\n  -ms-flex-pack: center;\n  -moz-justify-content: center;\n  justify-content: center;\n  height: 20px;\n  width: 20px;\n  outline: none; }\n", ""]);

// exports
exports.locals = {
	"searchBoxComponent": "searchBoxComponent---3n5r6",
	"searchButton": "searchButton---2FxtE",
	"svgIconContainerSearchButton": "svgIconContainerSearchButton---1EFR-",
	"searchTextBox": "searchTextBox---h_VSz",
	"searchTextBoxComponent": "searchTextBoxComponent---3WIzb",
	"textBoxSearchText": "textBoxSearchText---1XK9B",
	"svgIconContainerTextBoxSearch": "svgIconContainerTextBoxSearch---3CGlu",
	"searchClearButton": "searchClearButton---dmyWe",
	"buttonContainer": "buttonContainer---20wiD"
};

/***/ }),
/* 1180 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(4)();
// imports


// module
exports.push([module.i, ".confirmationMessageContainer---1_E8A {\n  display: -webkit-box;\n  display: -moz-flex;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: center;\n  -ms-flex-pack: center;\n  -moz-justify-content: center;\n  justify-content: center;\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n  -moz-align-items: center;\n  align-items: center;\n  -webkit-box-direction: normal;\n  -webkit-box-orient: vertical;\n  -moz-flex-direction: column;\n  -ms-flex-direction: column;\n  flex-direction: column;\n  outline: none;\n  color: #4e5c67;\n  background: #fff;\n  width: 550px;\n  height: 300px;\n  border-radius: 10px;\n  padding: 10px; }\n\n.title---1atm_ {\n  width: 90%;\n  height: 22px;\n  margin: 15px;\n  color: #4e5c67;\n  font-family: Poppins;\n  font-size: 28px;\n  font-weight: 500;\n  line-height: 27px; }\n\n.recordsMessage---2_UNb {\n  width: 90%;\n  color: #4e5c67;\n  font-family: Poppins;\n  font-size: 20px;\n  line-height: 27px; }\n\n.mainItem---2yqsW {\n  font-weight: bold; }\n\n.comment---s_3rD {\n  font-size: 16px; }\n\n.okButton---2uBio {\n  -webkit-box-shadow: none;\n          box-shadow: none;\n  border-radius: 22px;\n  margin-top: 15px;\n  background-color: #415667;\n  width: 95px;\n  height: 45px;\n  border: none;\n  color: white;\n  font-size: 16px;\n  font-weight: 500;\n  outline: none; }\n\n.icon---wfv4C {\n  width: 70px;\n  height: 70px;\n  margin: 7px 10px 7px 0; }\n\n.row---rxpuY {\n  display: -webkit-box;\n  display: -moz-flex;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-direction: normal;\n  -webkit-box-orient: horizontal;\n  -moz-flex-direction: row;\n  -ms-flex-direction: row;\n  flex-direction: row; }\n\n.message---1WkH2 {\n  display: -webkit-box;\n  display: -moz-flex;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: center;\n  -ms-flex-pack: center;\n  -moz-justify-content: center;\n  justify-content: center;\n  -webkit-box-direction: normal;\n  -webkit-box-orient: vertical;\n  -moz-flex-direction: column;\n  -ms-flex-direction: column;\n  flex-direction: column; }\n\n.error---32HWw {\n  margin: 20px 30px; }\n", ""]);

// exports
exports.locals = {
	"confirmationMessageContainer": "confirmationMessageContainer---1_E8A",
	"title": "title---1atm_",
	"recordsMessage": "recordsMessage---2_UNb",
	"mainItem": "mainItem---2yqsW",
	"comment": "comment---s_3rD",
	"okButton": "okButton---2uBio",
	"icon": "icon---wfv4C",
	"row": "row---rxpuY",
	"message": "message---1WkH2",
	"error": "error---32HWw"
};

/***/ }),
/* 1181 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(4)();
// imports


// module
exports.push([module.i, ".modalContent---1ddvZ {\n  display: -webkit-box;\n  display: -moz-flex;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: centre;\n  -ms-flex-align: centre;\n  -moz-align-items: centre;\n  align-items: centre;\n  -webkit-box-direction: normal;\n  -webkit-box-orient: vertical;\n  -moz-flex-direction: column;\n  -ms-flex-direction: column;\n  flex-direction: column;\n  outline: none;\n  -webkit-user-select: none;\n     -moz-user-select: none;\n      -ms-user-select: none;\n          user-select: none;\n  background: #e7e9ea;\n  width: 22%;\n  height: 300px;\n  margin: auto;\n  border-radius: 10px; }\n\n.close---1IiBt {\n  color: #aaa;\n  float: right;\n  font-size: 28px;\n  font-weight: bold; }\n\n.close---1IiBt:hover,\n.close---1IiBt:focus {\n  color: black;\n  text-decoration: none;\n  cursor: pointer;\n  outline: none; }\n\n.modalHeader---2usKS {\n  display: -webkit-box;\n  display: -moz-flex;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n  -moz-align-items: center;\n  align-items: center;\n  padding: 2px 16px;\n  background-color: #cfd2d4;\n  color: #4e5c67;\n  width: 100%;\n  border-radius: 10px 10px 1px 1px; }\n\n.modalBody---3iYwq {\n  padding: 2px 16px;\n  height: 300px; }\n\n.modalFooter---1FWMN {\n  padding: 2px 16px;\n  background-color: #cfd2d4;\n  color: white;\n  width: 100%; }\n\n.modalHeaderText----3HDG {\n  width: 95%;\n  font-family: poppins;\n  font-weight: 600; }\n\n.radio---210m0 .group---3dXLN {\n  display: none; }\n\ninput[type=\"radio\"] + label {\n  position: relative;\n  overflow: hidden;\n  width: 15px;\n  height: 15px;\n  border-radius: 10px;\n  border: 1px solid #bcbcbc;\n  margin-top: 15px;\n  margin-left: 10px;\n  -webkit-appearance: none;\n  cursor: pointer; }\n\ninput[type=\"radio\"] + label::before {\n  content: \"\";\n  display: block;\n  position: absolute;\n  margin-top: 2px;\n  margin-left: 2px;\n  height: 9px;\n  width: 9px;\n  background: white;\n  border-radius: 9px;\n  -webkit-border-radius: 9px;\n  -moz-border-radius: 9px;\n  -o-border-radius: 9px; }\n\ninput[type=\"radio\"]:checked + label::before {\n  background: #000; }\n\n.formatContainer---2aLm1 {\n  display: -webkit-box;\n  display: -moz-flex;\n  display: -ms-flexbox;\n  display: flex; }\n\n.formatName---3A977 {\n  font-family: poppins;\n  font-weight: 500;\n  padding-top: 13px;\n  padding-left: 10px; }\n\n.buttonContainer---KE7Yv {\n  display: -webkit-box;\n  display: -moz-flex;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n  -moz-align-items: center;\n  align-items: center;\n  -webkit-box-flex: 1;\n  -moz-flex: 1;\n  -ms-flex: 1;\n  flex: 1;\n  padding: 4px; }\n", ""]);

// exports
exports.locals = {
	"modalContent": "modalContent---1ddvZ",
	"close": "close---1IiBt",
	"modalHeader": "modalHeader---2usKS",
	"modalBody": "modalBody---3iYwq",
	"modalFooter": "modalFooter---1FWMN",
	"modalHeaderText": "modalHeaderText----3HDG",
	"radio": "radio---210m0",
	"group": "group---3dXLN",
	"formatContainer": "formatContainer---2aLm1",
	"formatName": "formatName---3A977",
	"buttonContainer": "buttonContainer---KE7Yv"
};

/***/ }),
/* 1182 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(4)();
// imports


// module
exports.push([module.i, ".dropDownContainer---KVMmS {\n  position: relative;\n  display: table;\n  width: 100%;\n  border-radius: 13px;\n  background: #fff; }\n  .dropDownContainer---KVMmS select:disabled,\n  .dropDownContainer---KVMmS select[disabled], .dropDownContainer---KVMmS.disabled---IZE_O {\n    opacity: 0.5; }\n  .dropDownContainer---KVMmS.large---1qQZr select {\n    font-size: 23px;\n    color: #4e5c67; }\n  .dropDownContainer---KVMmS.large---1qQZr::after {\n    margin-top: -6px; }\n  .dropDownContainer---KVMmS select {\n    line-height: 1.3;\n    width: 100%;\n    height: 50px;\n    margin: 0;\n    border: 2px solid #c2cfda;\n    border-radius: 10px;\n    outline: none;\n    padding: 0.55em 0.8em 0.45em;\n    -webkit-box-sizing: border-box;\n    box-sizing: border-box;\n    font-size: 16px;\n    font-weight: 500; }\n  .dropDownContainer---KVMmS select:focus {\n      outline: none; }\n  .dropDownContainer---KVMmS::after {\n    width: 0;\n    height: 0;\n    border-left: 8px solid transparent;\n    border-right: 8px solid transparent;\n    border-top: 10px solid #666;\n    margin-top: -1px;\n    content: \" \";\n    position: absolute;\n    top: 50%;\n    right: 1em;\n    z-index: 2;\n    pointer-events: none;\n    display: none; }\n  .dropDownContainer---KVMmS::after {\n  display: block; }\n  .dropDownContainer---KVMmS select {\n  padding-right: 3em;\n  background: none;\n  border: 2px solid #c2cfda;\n  -webkit-appearance: none;\n  -moz-appearance: none;\n  appearance: none; }\n  @media screen and (-ms-high-contrast: active), (-ms-high-contrast: none) {\n  .dropDownContainer---KVMmS select::-ms-expand {\n    display: none; }\n  .dropDownContainer---KVMmS select:focus {\n    border-color: #e7e9ea; }\n  .dropDownContainer---KVMmS select:focus::-ms-value {\n    background: transparent;\n    color: #222; }\n  .dropDownContainer---KVMmS select {\n    padding-right: 2em;\n    background: none;\n    border: 1px solid #e7e9ea; }\n  .dropDownContainer---KVMmS::after {\n    display: block; } }\n", ""]);

// exports
exports.locals = {
	"dropDownContainer": "dropDownContainer---KVMmS",
	"disabled": "disabled---IZE_O",
	"large": "large---1qQZr"
};

/***/ }),
/* 1183 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(4)();
// imports


// module
exports.push([module.i, "/**\n * Basic Breakpoint\n * url: https://responsivedesign.is/develop/getting-started-with-sass-and-breakpoint-mixin\n *\n * Usage:\n *\n * breakpoint(small-only | medium-up | medium-only | large-up | large-only) {\n * styles goes here\n * }\n*/\n.container---2COPa {\n  display: -webkit-box;\n  display: -moz-flex;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n  -moz-align-items: center;\n  align-items: center;\n  -webkit-box-pack: center;\n  -ms-flex-pack: center;\n  -moz-justify-content: center;\n  justify-content: center;\n  -webkit-box-direction: normal;\n  -webkit-box-orient: vertical;\n  -moz-flex-direction: column;\n  -ms-flex-direction: column;\n  flex-direction: column;\n  height: 100vh; }\n.header---3-W0Z {\n  display: -webkit-box;\n  display: -moz-flex;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n  -moz-align-items: center;\n  align-items: center;\n  font-family: Poppins;\n  font-size: 30px;\n  width: 100%;\n  height: 75px;\n  position: absolute;\n  top: 0.01px;\n  left: 0.01px;\n  padding-left: 35px;\n  background-color: #cfd2d4;\n  color: #4e5c67; }\n.title---21qYF {\n  display: -webkit-box;\n  display: -moz-flex;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n  -moz-align-items: center;\n  align-items: center;\n  font-family: Poppins;\n  font-size: 20px; }\n.footer---37ZEs {\n  display: -webkit-box;\n  display: -moz-flex;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n  -moz-align-items: center;\n  align-items: center;\n  -webkit-box-pack: center;\n  -ms-flex-pack: center;\n  -moz-justify-content: center;\n  justify-content: center;\n  position: fixed;\n  bottom: 0.01px;\n  left: 0.01px;\n  width: 100%;\n  height: 114px;\n  background-color: #adb6bc;\n  z-index: 9999; }\n.list---2xPFB {\n  display: -webkit-box;\n  display: -moz-flex;\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-pack: distribute;\n  -moz-justify-content: space-around;\n  justify-content: space-around;\n  -webkit-box-direction: normal;\n  -webkit-box-orient: vertical;\n  -moz-flex-direction: column;\n  -ms-flex-direction: column;\n  flex-direction: column;\n  min-width: 484px;\n  height: 270px;\n  padding-top: 40px; }\n.loader---1jYBo {\n  display: -webkit-box;\n  display: -moz-flex;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n  -moz-align-items: center;\n  align-items: center;\n  -webkit-box-pack: center;\n  -ms-flex-pack: center;\n  -moz-justify-content: center;\n  justify-content: center;\n  position: fixed;\n  z-index: 100004;\n  top: 0;\n  bottom: 0;\n  left: 0;\n  right: 0;\n  background-color: rgba(255, 255, 255, .85); }\n.emptyContainer---3yePq {\n  display: -webkit-box;\n  display: -moz-flex;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-direction: normal;\n  -webkit-box-orient: vertical;\n  -moz-flex-direction: column;\n  -ms-flex-direction: column;\n  flex-direction: column;\n  -webkit-box-pack: center;\n  -ms-flex-pack: center;\n  -moz-justify-content: center;\n  justify-content: center;\n  width: 100%;\n  padding: 10px;\n  background-color: #fff;\n  border-radius: 6px; }\n.emptyNotice---jCG-O {\n  display: -webkit-box;\n  display: -moz-flex;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-direction: normal;\n  -webkit-box-orient: vertical;\n  -moz-flex-direction: column;\n  -ms-flex-direction: column;\n  flex-direction: column;\n  -webkit-box-pack: center;\n  -ms-flex-pack: center;\n  -moz-justify-content: center;\n  justify-content: center;\n  background-color: #fff; }\n.emptyState---H7UKH {\n  display: -webkit-box;\n  display: -moz-flex;\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-pack: distribute;\n  -moz-justify-content: space-around;\n  justify-content: space-around;\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n  -moz-align-items: center;\n  align-items: center;\n  border-radius: 300px;\n  width: 300px;\n  height: 300px;\n  background: #cfd2d4;\n  margin: auto; }\n@media screen and (max-width: 39.9375em) {\n    .emptyState---H7UKH {\n      border-radius: 150px;\n      width: 150px;\n      height: 150px; } }\n.noResult---3olgD {\n  display: -webkit-box;\n  display: -moz-flex;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: center;\n  -ms-flex-pack: center;\n  -moz-justify-content: center;\n  justify-content: center;\n  color: #415667;\n  font-family: Poppins;\n  font-size: 30px;\n  font-weight: 500;\n  margin-top: 40px; }\n@media screen and (max-width: 39.9375em) {\n    .noResult---3olgD {\n      font-size: 20px; } }\n.emptyIconContainer---3oxsE {\n  width: 180px;\n  height: 180px;\n  margin-bottom: 20px; }\n@media screen and (max-width: 39.9375em) {\n    .emptyIconContainer---3oxsE {\n      width: 100px;\n      height: 100px; } }\n.emptyIconContainer---3oxsE svg path {\n    fill: #fff !important; }\n.emptyStateFooter---3lhfi {\n  display: -webkit-box;\n  display: -moz-flex;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: center;\n  -ms-flex-pack: center;\n  -moz-justify-content: center;\n  justify-content: center;\n  margin-top: 25px; }\n", ""]);

// exports
exports.locals = {
	"container": "container---2COPa",
	"header": "header---3-W0Z",
	"title": "title---21qYF",
	"footer": "footer---37ZEs",
	"list": "list---2xPFB",
	"loader": "loader---1jYBo",
	"emptyContainer": "emptyContainer---3yePq",
	"emptyNotice": "emptyNotice---jCG-O",
	"emptyState": "emptyState---H7UKH",
	"noResult": "noResult---3olgD",
	"emptyIconContainer": "emptyIconContainer---3oxsE",
	"emptyStateFooter": "emptyStateFooter---3lhfi"
};

/***/ }),
/* 1184 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(4)();
// imports


// module
exports.push([module.i, "@-webkit-keyframes spin---3e23d {\n  from {\n    -webkit-transform: rotate(0deg); }\n  to {\n    -webkit-transform: rotate(360deg); } }\n\n@keyframes spin---3e23d {\n  from {\n    -webkit-transform: rotate(0deg);\n            transform: rotate(0deg); }\n  to {\n    -webkit-transform: rotate(360deg);\n            transform: rotate(360deg); } }\n\n.loadingIcon---z4lLP {\n  height: 132px;\n  width: 132px; }\n\n.loader---2OSoq {\n  border-width: 6px;\n  border-style: solid;\n  border-color: #3498db transparent transparent;\n  -o-border-image: none;\n     border-image: none;\n  -o-border-image: initial;\n     border-image: initial;\n  border-radius: 50%;\n  width: 100%;\n  height: 100%; }\n\n.loaderSpeed---UPTKZ {\n  -webkit-animation: spin---3e23d 1.5s linear infinite;\n          animation: spin---3e23d 1.5s linear infinite; }\n", ""]);

// exports
exports.locals = {
	"loadingIcon": "loadingIcon---z4lLP",
	"loader": "loader---2OSoq",
	"loaderSpeed": "loaderSpeed---UPTKZ",
	"spin": "spin---3e23d"
};

/***/ }),
/* 1185 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(4)();
// imports


// module
exports.push([module.i, ".classDetailComponent---27t4U {\n  display: -webkit-box;\n  display: -moz-flex;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-direction: normal;\n  -webkit-box-orient: vertical;\n  -moz-flex-direction: column;\n  -ms-flex-direction: column;\n  flex-direction: column;\n  -webkit-box-shadow: 5px 5px 1px rgba(179, 179, 179, .3);\n          box-shadow: 5px 5px 1px rgba(179, 179, 179, .3);\n  min-height: 200px;\n  padding: 20px;\n  border-radius: 10px;\n  margin-bottom: 100px;\n  background-color: #fff;\n  font-family: Poppins, sans-serif;\n  font-size: 18px;\n  font-weight: 500;\n  outline: none; }\n\n.title---36IbM {\n  margin-bottom: 10px;\n  color: #32a8a7; }\n\n.assignClass---3MCq1 {\n  display: -webkit-box;\n  display: -moz-flex;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: center;\n  -ms-flex-pack: center;\n  -moz-justify-content: center;\n  justify-content: center;\n  min-width: 175px;\n  max-width: 250px;\n  height: 36px;\n  border-radius: 18px;\n  background-color: #415667;\n  color: white;\n  font-family: Poppins;\n  font-size: 14px;\n  font-weight: 500;\n  cursor: pointer;\n  -webkit-user-select: none;\n     -moz-user-select: none;\n      -ms-user-select: none;\n          user-select: none; }\n\n.icon---IHmml {\n  width: 16px;\n  height: 17px;\n  margin: 2px; }\n\n.icon---IHmml path {\n    fill: white !important; }\n\n.footer---F6vlE {\n  display: -webkit-box;\n  display: -moz-flex;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: end;\n  -ms-flex-pack: end;\n  -moz-justify-content: flex-end;\n  justify-content: flex-end;\n  padding-top: 15px;\n  border-top: 1px solid #adb6bc;\n  margin-top: 10px; }\n", ""]);

// exports
exports.locals = {
	"classDetailComponent": "classDetailComponent---27t4U",
	"title": "title---36IbM",
	"assignClass": "assignClass---3MCq1",
	"icon": "icon---IHmml",
	"footer": "footer---F6vlE"
};

/***/ }),
/* 1186 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(4)();
// imports


// module
exports.push([module.i, ".dataGridComponent---1GIFU {\n  margin: 10px; }\n\n.columns---1nLZd {\n  width: 20%;\n  min-height: 1px;\n  padding-right: 15px;\n  word-wrap: break-word; }\n\n.header---2gck5 {\n  display: -webkit-box;\n  display: -moz-flex;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n  -moz-align-items: center;\n  align-items: center;\n  -webkit-box-pack: center;\n  -ms-flex-pack: center;\n  -moz-justify-content: center;\n  justify-content: center;\n  color: #adb6bc;\n  font-family: Poppins;\n  font-size: 13px;\n  font-weight: 500;\n  margin-bottom: 24px;\n  width: calc(100% - 30px); }\n\n.list---QaUl1 {\n  display: -webkit-box;\n  display: -moz-flex;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: center;\n  -ms-flex-pack: center;\n  -moz-justify-content: center;\n  justify-content: center;\n  padding-bottom: 10px;\n  margin-bottom: 1px;\n  color: #4e5c67;\n  font-family: Poppins;\n  font-size: 13px;\n  font-weight: 500;\n  width: 100%; }\n\n.unassignClass---gg4pj {\n  display: -webkit-box;\n  display: -moz-flex;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: center;\n  -ms-flex-pack: center;\n  -moz-justify-content: center;\n  justify-content: center;\n  height: 30px;\n  width: 30px;\n  background-color: #c53902;\n  border-radius: 15px;\n  -webkit-user-select: none;\n     -moz-user-select: none;\n      -ms-user-select: none;\n          user-select: none; }\n\n.icon---xOaX- {\n  width: 16px;\n  height: 17px;\n  margin: 2px; }\n\n.icon---xOaX- path {\n    fill: white !important; }\n\n.highlight---2h8YK {\n  color: #32a8a7; }\n", ""]);

// exports
exports.locals = {
	"dataGridComponent": "dataGridComponent---1GIFU",
	"columns": "columns---1nLZd",
	"header": "header---2gck5",
	"list": "list---QaUl1",
	"unassignClass": "unassignClass---gg4pj",
	"icon": "icon---xOaX-",
	"highlight": "highlight---2h8YK"
};

/***/ }),
/* 1187 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(4)();
// imports


// module
exports.push([module.i, ".studentConfirmationContainer---LzTxr {\n  display: -webkit-box;\n  display: -moz-flex;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: center;\n  -ms-flex-pack: center;\n  -moz-justify-content: center;\n  justify-content: center;\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n  -moz-align-items: center;\n  align-items: center;\n  -webkit-box-direction: normal;\n  -webkit-box-orient: vertical;\n  -moz-flex-direction: column;\n  -ms-flex-direction: column;\n  flex-direction: column;\n  outline: none; }\n\n.icon---3e1C_ {\n  width: 80px;\n  height: 75px; }\n\n.title---3UP3r {\n  width: 90%;\n  height: 22px;\n  margin: 33px;\n  color: #4e5c67;\n  font-family: Poppins;\n  font-size: 28px;\n  font-weight: 500;\n  line-height: 27px;\n  text-align: center; }\n\n.buttonWrapper---dy-Rk {\n  display: -webkit-box;\n  display: -moz-flex;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n  -moz-align-items: center;\n  align-items: center;\n  -webkit-box-pack: center;\n  -ms-flex-pack: center;\n  -moz-justify-content: center;\n  justify-content: center;\n  -webkit-box-shadow: 3px 3px 1px #e7e9ea;\n          box-shadow: 3px 3px 1px #e7e9ea;\n  min-width: 20%;\n  height: 36px;\n  border: 1px solid #e1e1e1;\n  border-radius: 5px;\n  margin-bottom: 14px;\n  background-color: #fff;\n  color: #4e5c67;\n  font-family: Poppins;\n  font-size: 14px;\n  font-weight: 500;\n  text-align: center;\n  cursor: pointer; }\n\n.buttonContainer---3TN0_ {\n  width: 100%;\n  outline: none; }\n\n.buttonContainer---3TN0_ span {\n    width: 80%;\n    -webkit-user-select: none;\n       -moz-user-select: none;\n        -ms-user-select: none;\n            user-select: none; }\n\n.buttonContainerDisabled---3E0wX {\n  width: 100%;\n  outline: none;\n  opacity: 0.4;\n  pointer-events: none;\n  cursor: not-allowed; }\n\n.buttonContainerDisabled---3E0wX .buttonIcon---1XzSJ {\n    height: 21px;\n    width: 20px;\n    float: right;\n    margin-right: 10px; }\n\n.buttonContainerDisabled---3E0wX div {\n    display: inline; }\n\n.buttonTitle---1H3f4 {\n  width: 80%;\n  color: #4e5c67;\n  font-family: Poppins;\n  font-size: 14px;\n  font-weight: 500;\n  text-align: center; }\n\n.buttonIcon---1XzSJ {\n  width: 20px;\n  height: 21px;\n  margin-right: 10px;\n  float: right; }\n\n@media screen and (max-width: 1000px) {\n  .buttonWrapper---dy-Rk {\n    min-width: 30%; } }\n", ""]);

// exports
exports.locals = {
	"studentConfirmationContainer": "studentConfirmationContainer---LzTxr",
	"icon": "icon---3e1C_",
	"title": "title---3UP3r",
	"buttonWrapper": "buttonWrapper---dy-Rk",
	"buttonContainer": "buttonContainer---3TN0_",
	"buttonContainerDisabled": "buttonContainerDisabled---3E0wX",
	"buttonIcon": "buttonIcon---1XzSJ",
	"buttonTitle": "buttonTitle---1H3f4"
};

/***/ }),
/* 1188 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(4)();
// imports


// module
exports.push([module.i, ".container---S-ERo {\n  display: -webkit-box;\n  display: -moz-flex;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n  -moz-align-items: center;\n  align-items: center;\n  width: 45px;\n  margin: 0 auto; }\n\n.icon---1ukXg {\n  float: left;\n  width: 14px;\n  height: 15px;\n  margin-right: 2px;\n  opacity: 0.3; }\n\n.count---1-gEk {\n  color: #444;\n  font-family: Poppins;\n  font-size: 13px; }\n", ""]);

// exports
exports.locals = {
	"container": "container---S-ERo",
	"icon": "icon---1ukXg",
	"count": "count---1-gEk"
};

/***/ }),
/* 1189 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(4)();
// imports


// module
exports.push([module.i, ".dropDownContainer---3pK_L {\n  position: relative;\n  display: table;\n  width: 100%;\n  border-radius: 2px;\n  background: #fff; }\n  .dropDownContainer---3pK_L select:disabled,\n  .dropDownContainer---3pK_L select[disabled], .dropDownContainer---3pK_L.disabled---1ZOvZ {\n    opacity: 0.5; }\n  .dropDownContainer---3pK_L.large---14UYE select {\n    font-size: 23px;\n    color: #4e5c67; }\n  .dropDownContainer---3pK_L.large---14UYE::after {\n    margin-top: -6px; }\n  .dropDownContainer---3pK_L select {\n    line-height: 1.3;\n    border-radius: 0.2em;\n    width: 100%;\n    margin: 0;\n    outline: none;\n    padding: 0.55em 0.8em 0.45em;\n    -webkit-box-sizing: border-box;\n    box-sizing: border-box;\n    font-size: 16px;\n    font-weight: 500; }\n  .dropDownContainer---3pK_L select:focus {\n      outline: none; }\n  .dropDownContainer---3pK_L::after {\n    width: 0;\n    height: 0;\n    border-left: 8px solid transparent;\n    border-right: 8px solid transparent;\n    border-top: 10px solid #666;\n    margin-top: -1px;\n    content: \" \";\n    position: absolute;\n    top: 50%;\n    right: 1em;\n    z-index: 2;\n    pointer-events: none;\n    display: none; }\n  .dropDownContainer---3pK_L::after {\n  display: block; }\n  .dropDownContainer---3pK_L select {\n  padding-right: 3em;\n  background: none;\n  border: 1px solid #e7e9ea;\n  -webkit-appearance: none;\n  -moz-appearance: none;\n  appearance: none; }\n  @media screen and (-ms-high-contrast: active), (-ms-high-contrast: none) {\n  .dropDownContainer---3pK_L select::-ms-expand {\n    display: none; }\n  .dropDownContainer---3pK_L select:focus {\n    border-color: #e7e9ea; }\n  .dropDownContainer---3pK_L select:focus::-ms-value {\n    background: transparent;\n    color: #222; }\n  .dropDownContainer---3pK_L select {\n    padding-right: 2em;\n    background: none;\n    border: 1px solid #e7e9ea; }\n  .dropDownContainer---3pK_L::after {\n    display: block; } }\n", ""]);

// exports
exports.locals = {
	"dropDownContainer": "dropDownContainer---3pK_L",
	"disabled": "disabled---1ZOvZ",
	"large": "large---14UYE"
};

/***/ }),
/* 1190 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(4)();
// imports


// module
exports.push([module.i, ".component---2zion {\n  display: block; }\n\n.studentDetailHeader---37r3k {\n  height: 15px;\n  padding-top: 15px;\n  padding-left: 25px;\n  color: #32a8a7;\n  font-family: Poppins;\n  font-size: 18px;\n  font-weight: 500;\n  line-height: 27px; }\n\n.panel---1x5eB {\n  margin-top: 35px; }\n\n.spacing---3BT2D, .leftPanel---2OfAJ div, .rightPanel---7HQPz div {\n  display: -webkit-box;\n  display: -moz-flex;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  padding-top: 6px; }\n\n.leftPanel---2OfAJ {\n  float: left;\n  margin-left: 25px; }\n\n@media (max-width: 1024px) {\n    .leftPanel---2OfAJ {\n      float: none; } }\n\n.rightPanel---7HQPz {\n  float: right;\n  width: 50%; }\n\n@media (max-width: 1024px) {\n    .rightPanel---7HQPz {\n      float: none;\n      margin-left: 25px;\n      width: auto; } }\n\n@media (max-width: 768px) {\n    .rightPanel---7HQPz {\n      float: none;\n      margin-left: 25px;\n      width: 100%; } }\n\n.label---3jAWY {\n  width: 100px;\n  color: #4e5c67;\n  font-family: Poppins;\n  font-weight: 500;\n  line-height: 27px; }\n\n.inputText---38WCw {\n  height: 50px;\n  padding: 12px 22px;\n  border: 1px solid #e7e9ea;\n  border-radius: 4px;\n  font-family: Poppins;\n  font-size: 26px;\n  outline: none; }\n\n.list---3e1IO {\n  width: 375px; }\n\n.warning---xFyBV {\n  color: #F69E13;\n  font-family: Poppins;\n  font-size: 13px;\n  font-weight: 500;\n  line-height: 27px; }\n\n.downloadSignInCards---NLVAC {\n  -webkit-box-pack: center;\n  -ms-flex-pack: center;\n  -moz-justify-content: center;\n  justify-content: center;\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n  -moz-align-items: center;\n  align-items: center;\n  display: none !important;\n  height: 45px;\n  border-radius: 20px;\n  border: 1px solid #959595;\n  background-color: #415667;\n  color: #fff;\n  font-family: Poppins, sans-serif;\n  font-size: 16px;\n  font-weight: 500;\n  line-height: 27px; }\n\n.downloadSignInCards---NLVAC span {\n    padding-top: 8px; }\n\n@media (min-width: 320px) {\n    .downloadSignInCards---NLVAC {\n      display: block !important;\n      max-width: 300px; } }\n\n.iconClassName---3ZZcQ {\n  height: 20px;\n  width: 20px;\n  margin: 5px; }\n\n.iconClassName---3ZZcQ path {\n    fill: white !important; }\n\n.signCardPanel---2qewY {\n  float: right;\n  width: 37%;\n  padding-top: 6px; }\n\n@media (max-width: 1024px) {\n    .signCardPanel---2qewY {\n      width: 83%; } }\n", ""]);

// exports
exports.locals = {
	"component": "component---2zion",
	"studentDetailHeader": "studentDetailHeader---37r3k",
	"panel": "panel---1x5eB",
	"spacing": "spacing---3BT2D",
	"leftPanel": "leftPanel---2OfAJ",
	"rightPanel": "rightPanel---7HQPz",
	"label": "label---3jAWY",
	"inputText": "inputText---38WCw",
	"list": "list---3e1IO",
	"warning": "warning---xFyBV",
	"downloadSignInCards": "downloadSignInCards---NLVAC",
	"iconClassName": "iconClassName---3ZZcQ",
	"signCardPanel": "signCardPanel---2qewY"
};

/***/ }),
/* 1191 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(4)();
// imports


// module
exports.push([module.i, ".inputText---1ml6h, .disabled---2SU7v {\n  height: 38px;\n  width: 375px;\n  padding: 0 12px;\n  border: 1px solid #e7e9ea;\n  border-radius: 4px;\n  color: #4e5c67;\n  font-family: Poppins;\n  font-weight: 500;\n  line-height: 38px;\n  outline: none; }\n\n.disabled---2SU7v {\n  opacity: 0.4;\n  pointer-events: none;\n  cursor: not-allowed; }\n", ""]);

// exports
exports.locals = {
	"inputText": "inputText---1ml6h",
	"disabled": "disabled---2SU7v"
};

/***/ }),
/* 1192 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(4)();
// imports


// module
exports.push([module.i, ".studentSearchContainer---3KFOr {\n  display: -webkit-box;\n  display: -moz-flex;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n  -moz-align-items: center;\n  align-items: center;\n  -webkit-box-pack: end;\n  -ms-flex-pack: end;\n  -moz-justify-content: flex-end;\n  justify-content: flex-end;\n  margin-left: 17px;\n  padding: 8px; }\n\n.filterContainer---1r2if {\n  display: -webkit-box;\n  display: -moz-flex;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n  -moz-align-items: center;\n  align-items: center;\n  -webkit-box-pack: center;\n  -ms-flex-pack: center;\n  -moz-justify-content: center;\n  justify-content: center;\n  width: 100%;\n  min-height: 80px;\n  background-color: #cfd2d4;\n  outline: none; }\n\n.filters---2GvPx {\n  display: -webkit-box;\n  display: -moz-flex;\n  display: -ms-flexbox;\n  display: flex;\n  margin: 10px; }\n\n.lastName---Nw0MA {\n  min-width: 144px;\n  padding: 8px; }\n\n.year---2GRiV {\n  min-width: 92px;\n  padding: 8px; }\n\n.class---2jQTA {\n  min-width: 112px;\n  padding: 8px; }\n\n.clear---2T8Fi {\n  width: 77px; }\n", ""]);

// exports
exports.locals = {
	"studentSearchContainer": "studentSearchContainer---3KFOr",
	"filterContainer": "filterContainer---1r2if",
	"filters": "filters---2GvPx",
	"lastName": "lastName---Nw0MA",
	"year": "year---2GRiV",
	"class": "class---2jQTA",
	"clear": "clear---2T8Fi"
};

/***/ }),
/* 1193 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(4)();
// imports


// module
exports.push([module.i, ".studentFooterComponent---3UxcO {\n  position: fixed;\n  left: 0;\n  bottom: 0;\n  width: 100%;\n  min-height: 80px;\n  padding: 20px;\n  background-color: #adb6bc; }\n\n.buttonContainer---1Q6NJ {\n  display: -webkit-box;\n  display: -moz-flex;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n  -moz-align-items: center;\n  align-items: center;\n  -webkit-box-pack: end;\n  -ms-flex-pack: end;\n  -moz-justify-content: flex-end;\n  justify-content: flex-end;\n  -webkit-box-flex: 1;\n  -moz-flex: 1;\n  -ms-flex: 1;\n  flex: 1; }\n\n.footerButton---24vuv, .downloadSignInCards---E6UUp,\n.unassign---3MI5B,\n.bulkPasswordChange---FyQ4x,\n.deleteStudents---24Deh {\n  margin-left: 10px; }\n\n.buttonContainer---1Q6NJ > span {\n  padding-top: 10px; }\n\n.svgIconContainer---2tdOJ {\n  width: 1px;\n  height: 25px;\n  margin: 7px; }\n\n.svgIconContainer---2tdOJ svg path {\n    fill: none !important; }\n\n.highlight---3MgVe {\n  color: #32a8a7; }\n", ""]);

// exports
exports.locals = {
	"studentFooterComponent": "studentFooterComponent---3UxcO",
	"buttonContainer": "buttonContainer---1Q6NJ",
	"footerButton": "footerButton---24vuv",
	"downloadSignInCards": "downloadSignInCards---E6UUp",
	"unassign": "unassign---3MI5B",
	"bulkPasswordChange": "bulkPasswordChange---FyQ4x",
	"deleteStudents": "deleteStudents---24Deh",
	"svgIconContainer": "svgIconContainer---2tdOJ",
	"highlight": "highlight---3MgVe"
};

/***/ }),
/* 1194 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(4)();
// imports


// module
exports.push([module.i, ".studentHeaderComponent---1xzT9 {\n  display: -webkit-box;\n  display: -moz-flex;\n  display: -ms-flexbox;\n  display: flex;\n  font-family: Poppins, sans-serif;\n  min-height: 70px;\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n  -moz-align-items: center;\n  align-items: center;\n  background-color: #e7e9ea;\n  -webkit-box-pack: justify;\n  -ms-flex-pack: justify;\n  -moz-justify-content: space-between;\n  justify-content: space-between; }\n\n.buttonContainer---U9U_J {\n  display: -webkit-box;\n  display: -moz-flex;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n  -moz-align-items: center;\n  align-items: center;\n  margin-right: 25px;\n  -webkit-box-pack: end;\n  -ms-flex-pack: end;\n  -moz-justify-content: flex-end;\n  justify-content: flex-end; }\n\n/* Medium screens */\n\n@media all and (max-width: 800px) {\n  .buttonContainer---U9U_J {\n    -ms-flex-pack: distribute;\n    -moz-justify-content: space-around;\n    justify-content: space-around; } }\n\n/* Small screens */\n\n@media all and (max-width: 500px) {\n  .buttonContainer---U9U_J {\n    -webkit-box-direction: normal;\n    -webkit-box-orient: vertical;\n    -moz-flex-direction: column;\n    -ms-flex-direction: column;\n    flex-direction: column; } }\n\n.headerButton---Vbi0n, .addStudent---3cCHw,\n.downloadStudentRoll---3JWYv,\n.bulkUpload---1Yl7f {\n  margin-left: 10px; }\n\n.bulkUpload---1Yl7f {\n  display: none !important; }\n\n@media (min-width: 1025px) {\n    .bulkUpload---1Yl7f {\n      display: -webkit-inline-box !important;\n      display: -ms-inline-flexbox !important;\n      display: inline-flex !important; } }\n\n.studentsCountContainer---2__mn {\n  margin-left: 25px;\n  display: -webkit-box;\n  display: -moz-flex;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n  -moz-align-items: center;\n  align-items: center;\n  -webkit-box-pack: start;\n  -ms-flex-pack: start;\n  -moz-justify-content: flex-start;\n  justify-content: flex-start;\n  -webkit-box-direction: normal;\n  -webkit-box-orient: horizontal;\n  -moz-flex-direction: row;\n  -ms-flex-direction: row;\n  flex-direction: row;\n  -webkit-box-flex: 1;\n  -moz-flex: 1;\n  -ms-flex: 1;\n  flex: 1; }\n\n.studentsFontBase---3gU2R, .studentsCount---B5zbB, .studentsTitle---2XGQD {\n  font-family: Poppins, sans-serif;\n  color: #415667;\n  font-weight: 500; }\n\n.studentsCount---B5zbB {\n  font-size: 20px;\n  margin-left: 5px;\n  display: -webkit-box;\n  display: -moz-flex;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-flex: 1;\n  -moz-flex: 1;\n  -ms-flex: 1;\n  flex: 1; }\n\n.studentsTitle---2XGQD {\n  height: 23px;\n  width: 100%;\n  font-size: 26px;\n  line-height: 27px;\n  display: -webkit-box;\n  display: -moz-flex;\n  display: -ms-flexbox;\n  display: flex; }\n", ""]);

// exports
exports.locals = {
	"studentHeaderComponent": "studentHeaderComponent---1xzT9",
	"buttonContainer": "buttonContainer---U9U_J",
	"headerButton": "headerButton---Vbi0n",
	"addStudent": "addStudent---3cCHw",
	"downloadStudentRoll": "downloadStudentRoll---3JWYv",
	"bulkUpload": "bulkUpload---1Yl7f",
	"studentsCountContainer": "studentsCountContainer---2__mn",
	"studentsFontBase": "studentsFontBase---3gU2R",
	"studentsCount": "studentsCount---B5zbB",
	"studentsTitle": "studentsTitle---2XGQD"
};

/***/ }),
/* 1195 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(4)();
// imports


// module
exports.push([module.i, ".studentRollComponent---30mDj, .student---14U_e {\n  display: -webkit-box;\n  display: -moz-flex;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-flex: 10;\n  -moz-flex: 10;\n  -ms-flex: 10;\n  flex: 10;\n  -webkit-box-direction: normal;\n  -webkit-box-orient: vertical;\n  -moz-flex-direction: column;\n  -ms-flex-direction: column;\n  flex-direction: column;\n  background-color: #e7e9ea;\n  height: 100%; }\n\n.studentListContainer---1W6a5 {\n  display: -webkit-box;\n  display: -moz-flex;\n  display: -ms-flexbox;\n  display: flex;\n  font-family: Poppins;\n  margin: 0 25px;\n  padding: 20px 20px 100px;\n  background: #fff;\n  -webkit-box-shadow: 5px 5px 0 0 rgba(0, 0, 0, .07);\n          box-shadow: 5px 5px 0 0 rgba(0, 0, 0, .07);\n  min-height: 70vh;\n  -webkit-box-direction: normal;\n  -webkit-box-orient: vertical;\n  -moz-flex-direction: column;\n  -ms-flex-direction: column;\n  flex-direction: column;\n  -webkit-box-align: start;\n  -ms-flex-align: start;\n  -moz-align-items: flex-start;\n  align-items: flex-start;\n  -webkit-box-pack: start;\n  -ms-flex-pack: start;\n  -moz-justify-content: flex-start;\n  justify-content: flex-start;\n  -webkit-box-flex: 1;\n  -moz-flex-grow: 1;\n  -ms-flex-positive: 1;\n  flex-grow: 1; }\n\n.student---14U_e {\n  z-index: 100001; }\n\n.loadingContainer---2Pl8E {\n  height: 100%;\n  width: 100%;\n  display: -webkit-box;\n  display: -moz-flex;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: center;\n  -ms-flex-pack: center;\n  -moz-justify-content: center;\n  justify-content: center;\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n  -moz-align-items: center;\n  align-items: center;\n  -webkit-box-flex: 1;\n  -moz-flex-grow: 1;\n  -ms-flex-positive: 1;\n  flex-grow: 1; }\n\n.loader---3i5fB > div {\n  background-color: #4e5c67 !important;\n  width: 16px !important;\n  height: 16px !important;\n  margin: 4px !important; }\n", ""]);

// exports
exports.locals = {
	"studentRollComponent": "studentRollComponent---30mDj",
	"student": "student---14U_e",
	"studentListContainer": "studentListContainer---1W6a5",
	"loadingContainer": "loadingContainer---2Pl8E",
	"loader": "loader---3i5fB"
};

/***/ }),
/* 1196 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(4)();
// imports


// module
exports.push([module.i, ".confirmationMessageContainer---3CVPg {\n  display: -webkit-box;\n  display: -moz-flex;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: center;\n  -ms-flex-pack: center;\n  -moz-justify-content: center;\n  justify-content: center;\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n  -moz-align-items: center;\n  align-items: center;\n  -webkit-box-direction: normal;\n  -webkit-box-orient: vertical;\n  -moz-flex-direction: column;\n  -ms-flex-direction: column;\n  flex-direction: column;\n  outline: none;\n  -webkit-user-select: none;\n     -moz-user-select: none;\n      -ms-user-select: none;\n          user-select: none; }\n\n.icon---3jIB8 {\n  width: 60px;\n  height: 75px;\n  margin-bottom: 31px; }\n\n.title---374i5 {\n  width: 90%;\n  color: #4e5c67;\n  font-family: Poppins;\n  font-size: 28px;\n  font-weight: 500;\n  text-align: center;\n  line-height: 27px; }\n\n.message---3Ee1I {\n  width: 50%;\n  margin: 45px;\n  color: black;\n  font-family: Poppins;\n  font-size: 20px;\n  text-align: center;\n  line-height: 27px; }\n\n.highlight---2S0iV {\n  color: #32a8a7; }\n\n.confirm---8ZWu0 {\n  padding-top: 20px; }\n\n.container---16CP3 {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex; }\n\n.ok---1088m, .cancel---3X7fB {\n  position: relative;\n  display: inline-block;\n  width: 90px;\n  height: 90px;\n  border-radius: 45px;\n  margin: 10px;\n  background-color: #37c97c;\n  cursor: pointer;\n  outline: none; }\n\n.cancel---3X7fB {\n  background-color: #c53902; }\n\n.okButtonDisabled---1fsjg, .cancelButtonDisabled---3mJHn {\n  position: relative;\n  display: inline-block;\n  width: 90px;\n  height: 90px;\n  border-radius: 45px;\n  margin: 10px;\n  background-color: #37c97c;\n  cursor: not-allowed;\n  outline: none;\n  opacity: 0.4; }\n\n.okButtonDisabled---1fsjg :nth-child(3), .cancelButtonDisabled---3mJHn :nth-child(3) {\n    display: none; }\n\n.cancelButtonDisabled---3mJHn {\n  background-color: #c53902; }\n\n.iconClassName---2lzvd {\n  position: absolute;\n  top: 35%;\n  left: 35%;\n  width: 29px;\n  height: 32px; }\n\n.iconClassName---2lzvd path {\n    fill: white !important; }\n", ""]);

// exports
exports.locals = {
	"confirmationMessageContainer": "confirmationMessageContainer---3CVPg",
	"icon": "icon---3jIB8",
	"title": "title---374i5",
	"message": "message---3Ee1I",
	"highlight": "highlight---2S0iV",
	"confirm": "confirm---8ZWu0",
	"container": "container---16CP3",
	"ok": "ok---1088m",
	"cancel": "cancel---3X7fB",
	"okButtonDisabled": "okButtonDisabled---1fsjg",
	"cancelButtonDisabled": "cancelButtonDisabled---3mJHn",
	"iconClassName": "iconClassName---2lzvd"
};

/***/ }),
/* 1197 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(4)();
// imports


// module
exports.push([module.i, ".svgIconComponent---2bpZU {\n  display: inline;\n  pointer-events: none; }\n", ""]);

// exports
exports.locals = {
	"svgIconComponent": "svgIconComponent---2bpZU"
};

/***/ }),
/* 1198 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(4)();
// imports


// module
exports.push([module.i, ".tabButtonComponent---1kib8 {\n  display: -webkit-box;\n  display: -moz-flex;\n  display: -ms-flexbox;\n  display: flex;\n  height: 45px;\n  width: 111px;\n  font-family: poppins;\n  font-size: 16px;\n  font-weight: 500;\n  border: 1px solid #cfd2d4;\n  color: #444;\n  background-color: #fff;\n  outline: none;\n  -webkit-box-pack: center;\n  -ms-flex-pack: center;\n  -moz-justify-content: center;\n  justify-content: center;\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n  -moz-align-items: center;\n  align-items: center;\n  text-decoration: none !important; }\n  .tabButtonComponent---1kib8.highlight---IlreC {\n    border: 1px solid #959595;\n    background-color: #415667;\n    color: #fff; }\n", ""]);

// exports
exports.locals = {
	"tabButtonComponent": "tabButtonComponent---1kib8",
	"highlight": "highlight---IlreC"
};

/***/ }),
/* 1199 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(4)();
// imports


// module
exports.push([module.i, ".classDetailComponent---2ezPM {\n  display: -webkit-box;\n  display: -moz-flex;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-direction: normal;\n  -webkit-box-orient: vertical;\n  -moz-flex-direction: column;\n  -ms-flex-direction: column;\n  flex-direction: column;\n  -webkit-box-shadow: 5px 5px 1px rgba(179, 179, 179, .3);\n          box-shadow: 5px 5px 1px rgba(179, 179, 179, .3);\n  min-height: 200px;\n  padding: 20px;\n  border-radius: 10px;\n  margin-bottom: 100px;\n  background-color: #fff;\n  font-family: Poppins, sans-serif;\n  font-size: 18px;\n  font-weight: 500;\n  outline: none; }\n\n.title---139ID {\n  margin-bottom: 10px;\n  color: #32a8a7; }\n\n.assignClass---1yIDW {\n  display: -webkit-box;\n  display: -moz-flex;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: center;\n  -ms-flex-pack: center;\n  -moz-justify-content: center;\n  justify-content: center;\n  min-width: 175px;\n  max-width: 250px;\n  height: 36px;\n  border-radius: 18px;\n  background-color: #415667;\n  color: white;\n  font-family: Poppins;\n  font-size: 14px;\n  font-weight: 500;\n  cursor: pointer;\n  -webkit-user-select: none;\n     -moz-user-select: none;\n      -ms-user-select: none;\n          user-select: none; }\n\n.icon---3B_jm {\n  width: 16px;\n  height: 17px;\n  margin: 2px; }\n\n.icon---3B_jm path {\n    fill: white !important; }\n\n.footer---2MpaZ {\n  display: -webkit-box;\n  display: -moz-flex;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: end;\n  -ms-flex-pack: end;\n  -moz-justify-content: flex-end;\n  justify-content: flex-end;\n  padding-top: 15px;\n  border-top: 1px solid #adb6bc;\n  margin-top: 10px; }\n", ""]);

// exports
exports.locals = {
	"classDetailComponent": "classDetailComponent---2ezPM",
	"title": "title---139ID",
	"assignClass": "assignClass---1yIDW",
	"icon": "icon---3B_jm",
	"footer": "footer---2MpaZ"
};

/***/ }),
/* 1200 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(4)();
// imports


// module
exports.push([module.i, ".dataGridComponent---2PR1Y {\n  margin: 10px; }\n\n.columns---3jRP3, .classNameColumn---1ZZ0f, .courseNameColumn---2x7xH, .yearGroupColumn---2Np1h, .downloadSignInColumn---3BWHj, .unassignColumn---1iQ1S {\n  padding-right: 15px;\n  word-wrap: break-word; }\n\n.classNameColumn---1ZZ0f {\n  width: 30%; }\n\n.courseNameColumn---2x7xH {\n  width: 70%; }\n\n.yearGroupColumn---2Np1h {\n  width: 10%; }\n\n.downloadSignInColumn---3BWHj {\n  width: 40%; }\n\n.unassignColumn---1iQ1S {\n  width: 5%; }\n\n.header---2qcbr {\n  display: -webkit-box;\n  display: -moz-flex;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n  -moz-align-items: center;\n  align-items: center;\n  -webkit-box-pack: center;\n  -ms-flex-pack: center;\n  -moz-justify-content: center;\n  justify-content: center;\n  color: #adb6bc;\n  font-family: Poppins;\n  font-size: 13px;\n  font-weight: 500;\n  margin-bottom: 24px;\n  width: calc(100% - 15px); }\n\n.list---2B46U {\n  display: -webkit-box;\n  display: -moz-flex;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: center;\n  -ms-flex-pack: center;\n  -moz-justify-content: center;\n  justify-content: center;\n  padding-bottom: 10px;\n  margin-bottom: 1px;\n  color: #4e5c67;\n  font-family: Poppins;\n  font-size: 13px;\n  font-weight: 500;\n  width: 100%;\n  height: 70px; }\n\n.unassignClass---3Xb2B {\n  display: -webkit-box;\n  display: -moz-flex;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: center;\n  -ms-flex-pack: center;\n  -moz-justify-content: center;\n  justify-content: center;\n  height: 30px;\n  width: 30px;\n  background-color: #c53902;\n  border-radius: 15px;\n  -webkit-user-select: none;\n     -moz-user-select: none;\n      -ms-user-select: none;\n          user-select: none; }\n\n.icon---2DN8m {\n  width: 16px;\n  height: 17px;\n  margin: 2px; }\n\n.icon---2DN8m path {\n    fill: white !important; }\n\n.highlight---1hfy0 {\n  color: #32a8a7; }\n\n.downloadSignInCards---1EU6I {\n  -webkit-box-pack: center;\n  -ms-flex-pack: center;\n  -moz-justify-content: center;\n  justify-content: center;\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n  -moz-align-items: center;\n  align-items: center;\n  display: none !important;\n  height: 35px;\n  border-radius: 20px;\n  border: 1px solid #959595;\n  background-color: #415667;\n  color: #fff;\n  font-family: Poppins, sans-serif;\n  font-size: 13px;\n  font-weight: 500;\n  line-height: 25px; }\n\n.downloadSignInCards---1EU6I span {\n    padding-top: 5px; }\n\n@media (min-width: 320px) {\n    .downloadSignInCards---1EU6I {\n      display: block !important;\n      min-width: 210px;\n      max-width: 250px; } }\n\n.iconClassName---120_G {\n  height: 14px;\n  width: 14px;\n  margin: 5px; }\n\n.iconClassName---120_G path {\n    fill: white !important; }\n", ""]);

// exports
exports.locals = {
	"dataGridComponent": "dataGridComponent---2PR1Y",
	"columns": "columns---3jRP3",
	"classNameColumn": "classNameColumn---1ZZ0f",
	"courseNameColumn": "courseNameColumn---2x7xH",
	"yearGroupColumn": "yearGroupColumn---2Np1h",
	"downloadSignInColumn": "downloadSignInColumn---3BWHj",
	"unassignColumn": "unassignColumn---1iQ1S",
	"header": "header---2qcbr",
	"list": "list---2B46U",
	"unassignClass": "unassignClass---3Xb2B",
	"icon": "icon---2DN8m",
	"highlight": "highlight---1hfy0",
	"downloadSignInCards": "downloadSignInCards---1EU6I",
	"iconClassName": "iconClassName---120_G"
};

/***/ }),
/* 1201 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(4)();
// imports


// module
exports.push([module.i, ".teacherConfirmationContainer---3qJwG {\n  display: -webkit-box;\n  display: -moz-flex;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: center;\n  -ms-flex-pack: center;\n  -moz-justify-content: center;\n  justify-content: center;\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n  -moz-align-items: center;\n  align-items: center;\n  -webkit-box-direction: normal;\n  -webkit-box-orient: vertical;\n  -moz-flex-direction: column;\n  -ms-flex-direction: column;\n  flex-direction: column;\n  outline: none; }\n\n.icon---1viov {\n  width: 80px;\n  height: 75px; }\n\n.title---3DiM8 {\n  width: 90%;\n  height: 22px;\n  margin: 33px;\n  color: #4e5c67;\n  font-family: Poppins;\n  font-size: 28px;\n  font-weight: 500;\n  line-height: 27px;\n  text-align: center; }\n\n.buttonWrapper---2Co5P {\n  display: -webkit-box;\n  display: -moz-flex;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n  -moz-align-items: center;\n  align-items: center;\n  -webkit-box-pack: center;\n  -ms-flex-pack: center;\n  -moz-justify-content: center;\n  justify-content: center;\n  -webkit-box-shadow: 3px 3px 1px #e7e9ea;\n          box-shadow: 3px 3px 1px #e7e9ea;\n  min-width: 20%;\n  height: 36px;\n  border: 1px solid #e1e1e1;\n  border-radius: 5px;\n  margin-bottom: 14px;\n  background-color: #fff;\n  color: #4e5c67;\n  font-family: Poppins;\n  font-size: 14px;\n  font-weight: 500;\n  text-align: center;\n  cursor: pointer; }\n\n.buttonContainer---pPRAB {\n  width: 100%;\n  outline: none; }\n\n.buttonContainer---pPRAB span {\n    width: 80%;\n    -webkit-user-select: none;\n       -moz-user-select: none;\n        -ms-user-select: none;\n            user-select: none; }\n\n.buttonContainerDisabled---1M1y1 {\n  width: 100%;\n  outline: none;\n  opacity: 0.4;\n  pointer-events: none;\n  cursor: not-allowed; }\n\n.buttonContainerDisabled---1M1y1 .buttonIcon---2Nb6i {\n    height: 21px;\n    width: 20px;\n    float: right;\n    margin-right: 10px; }\n\n.buttonContainerDisabled---1M1y1 div {\n    display: inline; }\n\n.buttonTitle---137av {\n  width: 80%;\n  color: #4e5c67;\n  font-family: Poppins;\n  font-size: 14px;\n  font-weight: 500;\n  text-align: center; }\n\n.buttonIcon---2Nb6i {\n  width: 20px;\n  height: 21px;\n  margin-right: 10px;\n  float: right; }\n\n@media screen and (max-width: 1000px) {\n  .buttonWrapper---2Co5P {\n    min-width: 30%; } }\n", ""]);

// exports
exports.locals = {
	"teacherConfirmationContainer": "teacherConfirmationContainer---3qJwG",
	"icon": "icon---1viov",
	"title": "title---3DiM8",
	"buttonWrapper": "buttonWrapper---2Co5P",
	"buttonContainer": "buttonContainer---pPRAB",
	"buttonContainerDisabled": "buttonContainerDisabled---1M1y1",
	"buttonIcon": "buttonIcon---2Nb6i",
	"buttonTitle": "buttonTitle---137av"
};

/***/ }),
/* 1202 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(4)();
// imports


// module
exports.push([module.i, ".dropDownContainer---2nvtE {\n  position: relative;\n  display: table;\n  width: 100%;\n  border-radius: 2px;\n  background: #fff; }\n  .dropDownContainer---2nvtE select:disabled,\n  .dropDownContainer---2nvtE select[disabled], .dropDownContainer---2nvtE.disabled---2vw6i {\n    opacity: 0.5; }\n  .dropDownContainer---2nvtE.large---15JZF select {\n    font-size: 23px;\n    color: #4e5c67; }\n  .dropDownContainer---2nvtE.large---15JZF::after {\n    margin-top: -6px; }\n  .dropDownContainer---2nvtE select {\n    line-height: 1.3;\n    border-radius: 0.2em;\n    width: 100%;\n    margin: 0;\n    outline: none;\n    padding: 0.55em 0.8em 0.45em;\n    -webkit-box-sizing: border-box;\n    box-sizing: border-box;\n    font-size: 16px;\n    font-weight: 500; }\n  .dropDownContainer---2nvtE select:focus {\n      outline: none; }\n  .dropDownContainer---2nvtE::after {\n    width: 0;\n    height: 0;\n    border-left: 8px solid transparent;\n    border-right: 8px solid transparent;\n    border-top: 10px solid #666;\n    margin-top: -1px;\n    content: \" \";\n    position: absolute;\n    top: 50%;\n    right: 1em;\n    z-index: 2;\n    pointer-events: none;\n    display: none; }\n  .dropDownContainer---2nvtE::after {\n  display: block; }\n  .dropDownContainer---2nvtE select {\n  padding-right: 3em;\n  background: none;\n  border: 1px solid #e7e9ea;\n  -webkit-appearance: none;\n  -moz-appearance: none;\n  appearance: none; }\n  @media screen and (-ms-high-contrast: active), (-ms-high-contrast: none) {\n  .dropDownContainer---2nvtE select::-ms-expand {\n    display: none; }\n  .dropDownContainer---2nvtE select:focus {\n    border-color: #e7e9ea; }\n  .dropDownContainer---2nvtE select:focus::-ms-value {\n    background: transparent;\n    color: #222; }\n  .dropDownContainer---2nvtE select {\n    padding-right: 2em;\n    background: none;\n    border: 1px solid #e7e9ea; }\n  .dropDownContainer---2nvtE::after {\n    display: block; } }\n", ""]);

// exports
exports.locals = {
	"dropDownContainer": "dropDownContainer---2nvtE",
	"disabled": "disabled---2vw6i",
	"large": "large---15JZF"
};

/***/ }),
/* 1203 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(4)();
// imports


// module
exports.push([module.i, ".teacherDetailContainer---3Vtgt {\n  display: -webkit-box;\n  display: -moz-flex;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-direction: normal;\n  -webkit-box-orient: vertical;\n  -moz-flex-direction: column;\n  -ms-flex-direction: column;\n  flex-direction: column;\n  padding: 25px; }\n\n.teacherDetailHeader---2f7hm {\n  color: #32a8a7;\n  font-family: Poppins;\n  font-size: 18px;\n  font-weight: 500;\n  line-height: 1.5em; }\n\n.panel---1pIzm {\n  display: -webkit-box;\n  display: -moz-flex;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-direction: normal;\n  -webkit-box-orient: horizontal;\n  -moz-flex-direction: row;\n  -ms-flex-direction: row;\n  flex-direction: row;\n  -ms-flex-pack: distribute;\n  -moz-justify-content: space-around;\n  justify-content: space-around;\n  margin-top: 0; }\n\n@media (max-width: 1024px) {\n    .panel---1pIzm {\n      -ms-flex-wrap: wrap;\n      flex-wrap: wrap; } }\n\n@media (max-width: 768px) {\n    .panel---1pIzm {\n      -ms-flex-wrap: wrap;\n      flex-wrap: wrap; } }\n\n.spacing---1rUqA {\n  display: -webkit-box;\n  display: -moz-flex;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  padding-top: 6px; }\n\n.leftPanel---3uHsW {\n  display: -webkit-box;\n  display: -moz-flex;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-direction: normal;\n  -webkit-box-orient: vertical;\n  -moz-flex-direction: column;\n  -ms-flex-direction: column;\n  flex-direction: column;\n  margin-left: 0;\n  width: 50%; }\n\n.rightPanel---1lSXu {\n  display: -webkit-box;\n  display: -moz-flex;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-direction: normal;\n  -webkit-box-orient: vertical;\n  -moz-flex-direction: column;\n  -ms-flex-direction: column;\n  flex-direction: column;\n  width: 50%; }\n\n.dataItem---2Nmf4 {\n  display: -webkit-box;\n  display: -moz-flex;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-direction: normal;\n  -webkit-box-orient: horizontal;\n  -moz-flex-direction: row;\n  -ms-flex-direction: row;\n  flex-direction: row;\n  -webkit-box-pack: start;\n  -ms-flex-pack: start;\n  -moz-justify-content: flex-start;\n  justify-content: flex-start;\n  margin-right: 25px;\n  margin-top: 15px; }\n\n.dataItem---2Nmf4 > div {\n    -webkit-box-flex: 1;\n        -ms-flex: 1;\n            flex: 1; }\n\n.dataItem---2Nmf4 .label---1X13m {\n    -webkit-box-flex: initial;\n        -ms-flex: initial;\n            flex: initial; }\n\n.label---1X13m {\n  min-width: 140px;\n  max-width: 140px;\n  color: #4e5c67;\n  font-family: Poppins;\n  font-weight: 500;\n  line-height: 1.5em; }\n\n.inputText---EVY1m {\n  height: 50px;\n  padding: 12px 22px;\n  border: 1px solid #e7e9ea;\n  border-radius: 4px;\n  font-family: Poppins;\n  font-size: 26px;\n  outline: none; }\n\n.list---3529L {\n  width: 375px; }\n\n.informationMessage---3L6s6 {\n  padding-top: 5px; }\n\n.warning---18bIP {\n  color: #5cb85c;\n  font-family: Poppins;\n  font-size: 13px;\n  font-weight: 500; }\n\n.linkButton---1NvyJ {\n  -webkit-box-pack: center;\n  -ms-flex-pack: center;\n  -moz-justify-content: center;\n  justify-content: center;\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n  -moz-align-items: center;\n  align-items: center;\n  display: none !important;\n  height: 45px;\n  border-radius: 20px;\n  border: 1px solid #959595;\n  background-color: #415667;\n  color: #fff;\n  font-family: Poppins, sans-serif;\n  font-size: 14px;\n  font-weight: 500;\n  line-height: 1.5em; }\n\n.linkButton---1NvyJ span {\n    padding-top: 8px;\n    height: 45px; }\n\n@media (min-width: 320px) {\n    .linkButton---1NvyJ {\n      display: block !important;\n      width: 300px;\n      font-size: 14px; } }\n\n.iconClassName---22fTz {\n  height: 20px;\n  width: 20px;\n  margin: 5px; }\n\n.iconClassName---22fTz path {\n    fill: white !important; }\n\n.passwordLabel---3wMq0 {\n  display: -webkit-box;\n  display: -moz-flex;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n  -moz-align-items: center;\n  align-items: center;\n  color: #4e5c67;\n  font-family: Poppins;\n  font-weight: 500;\n  line-height: 1.5em; }\n\n.password---2uv5o {\n  margin: auto; }\n\n.buttonPanel---9fO0e {\n  margin-top: 15px; }\n\n.buttons---3fXmv {\n  display: -webkit-box;\n  display: -moz-flex;\n  display: -ms-flexbox;\n  display: flex; }\n\n.buttonSpacing---Ezcei {\n  padding-right: 4px; }\n\n.checkbox---V-lwC {\n  display: -webkit-inline-box;\n  display: -moz-inline-flex;\n  display: -ms-inline-flexbox;\n  display: inline-flex; }\n\n.checkbox---V-lwC .chklabel---23XMg {\n  width: 20px;\n  height: 20px;\n  border: 1px solid #cdcdcd; }\n\n.checkbox---V-lwC .name---3Enkw {\n  display: none; }\n\n.checkbox---V-lwC .className---34zJs {\n  padding-left: 10px;\n  color: #555555;\n  font-family: Poppins;\n  font-size: 14px;\n  font-weight: 500; }\n\n.name---3Enkw + label {\n  position: relative;\n  overflow: hidden;\n  border-radius: 3px;\n  -webkit-appearance: none;\n  cursor: pointer; }\n\n.name---3Enkw:checked + label::after {\n  background-color: #fff !important;\n  content: \"\\E900\";\n  color: #000 !important;\n  font: 13pt icomoon; }\n\n.links---TxElV {\n  width: 47%;\n  text-align: right;\n  margin: auto; }\n\n.passwordButtonSection---2VK4j {\n  display: -webkit-box;\n  display: -moz-flex;\n  display: -ms-flexbox;\n  display: flex;\n  width: 100%;\n  padding-top: 5px; }\n\n.linkButtonPanel---120S8 {\n  width: 73%; }\n\n.linkButtons---sQF1Z {\n  padding: 5px; }\n\n.reset---1GlG8 {\n  padding-left: 7px; }\n\n.emailUnverified---3ulgU {\n  font-weight: 600;\n  color: red; }\n", ""]);

// exports
exports.locals = {
	"teacherDetailContainer": "teacherDetailContainer---3Vtgt",
	"teacherDetailHeader": "teacherDetailHeader---2f7hm",
	"panel": "panel---1pIzm",
	"spacing": "spacing---1rUqA",
	"leftPanel": "leftPanel---3uHsW",
	"rightPanel": "rightPanel---1lSXu",
	"dataItem": "dataItem---2Nmf4",
	"label": "label---1X13m",
	"inputText": "inputText---EVY1m",
	"list": "list---3529L",
	"informationMessage": "informationMessage---3L6s6",
	"warning": "warning---18bIP",
	"linkButton": "linkButton---1NvyJ",
	"iconClassName": "iconClassName---22fTz",
	"passwordLabel": "passwordLabel---3wMq0",
	"password": "password---2uv5o",
	"buttonPanel": "buttonPanel---9fO0e",
	"buttons": "buttons---3fXmv",
	"buttonSpacing": "buttonSpacing---Ezcei",
	"checkbox": "checkbox---V-lwC",
	"chklabel": "chklabel---23XMg",
	"name": "name---3Enkw",
	"className": "className---34zJs",
	"links": "links---TxElV",
	"passwordButtonSection": "passwordButtonSection---2VK4j",
	"linkButtonPanel": "linkButtonPanel---120S8",
	"linkButtons": "linkButtons---sQF1Z",
	"reset": "reset---1GlG8",
	"emailUnverified": "emailUnverified---3ulgU"
};

/***/ }),
/* 1204 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(4)();
// imports


// module
exports.push([module.i, ".inputText---bkJoK, .disabled---jEjgj {\n  height: 38px;\n  width: 100%;\n  padding: 0 12px;\n  border: 1px solid #e7e9ea;\n  border-radius: 4px;\n  color: #4e5c67;\n  font-family: Poppins;\n  font-weight: 500;\n  line-height: 38px;\n  outline: none; }\n\n.disabled---jEjgj {\n  opacity: 0.4;\n  pointer-events: none;\n  cursor: not-allowed; }\n", ""]);

// exports
exports.locals = {
	"inputText": "inputText---bkJoK",
	"disabled": "disabled---jEjgj"
};

/***/ }),
/* 1205 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(4)();
// imports


// module
exports.push([module.i, ".teacherSearchContainer---iRcYS {\n  display: -webkit-box;\n  display: -moz-flex;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n  -moz-align-items: center;\n  align-items: center;\n  -webkit-box-pack: end;\n  -ms-flex-pack: end;\n  -moz-justify-content: flex-end;\n  justify-content: flex-end;\n  margin-left: 17px;\n  padding: 8px; }\n\n.filterContainer---2AVRR {\n  display: -webkit-box;\n  display: -moz-flex;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n  -moz-align-items: center;\n  align-items: center;\n  -webkit-box-pack: center;\n  -ms-flex-pack: center;\n  -moz-justify-content: center;\n  justify-content: center;\n  width: 100%;\n  min-height: 80px;\n  background-color: #cfd2d4;\n  outline: none; }\n\n.filters---2th3Q {\n  display: -webkit-box;\n  display: -moz-flex;\n  display: -ms-flexbox;\n  display: flex;\n  margin: 0; }\n\n.lastName---1lczG {\n  min-width: 144px;\n  padding: 8px; }\n\n.year----ExPw {\n  min-width: 92px;\n  padding: 8px; }\n\n.class---3Mq8V {\n  min-width: 112px;\n  padding: 8px; }\n\n.clear---3HlhT {\n  width: 77px; }\n", ""]);

// exports
exports.locals = {
	"teacherSearchContainer": "teacherSearchContainer---iRcYS",
	"filterContainer": "filterContainer---2AVRR",
	"filters": "filters---2th3Q",
	"lastName": "lastName---1lczG",
	"year": "year----ExPw",
	"class": "class---3Mq8V",
	"clear": "clear---3HlhT"
};

/***/ }),
/* 1206 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(4)();
// imports


// module
exports.push([module.i, ".teacherFooterComponent---3g29e {\n  position: fixed;\n  left: 0;\n  bottom: 0;\n  width: 100%;\n  min-height: 80px;\n  padding: 20px;\n  background-color: #adb6bc; }\n\n.buttonContainer---2nlEk {\n  display: -webkit-box;\n  display: -moz-flex;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n  -moz-align-items: center;\n  align-items: center;\n  -webkit-box-pack: end;\n  -ms-flex-pack: end;\n  -moz-justify-content: flex-end;\n  justify-content: flex-end;\n  -webkit-box-flex: 1;\n  -moz-flex: 1;\n  -ms-flex: 1;\n  flex: 1; }\n\n.footerButton---XCVCF, .bulkPasswordChange---2gLT8,\n.deleteTeachers---2HdCb,\n.unassign---39Y-J {\n  margin-left: 10px; }\n\n.svgIconContainer---2q-sW {\n  width: 1px;\n  height: 25px;\n  margin: 7px; }\n\n.svgIconContainer---2q-sW svg path {\n    fill: none !important; }\n\n.iconClassName---sNxLZ {\n  height: 40px;\n  width: 1px; }\n\n.iconClassName---sNxLZ path {\n    fill: none !important; }\n\n.highlight---1WYfw {\n  color: #32a8a7; }\n", ""]);

// exports
exports.locals = {
	"teacherFooterComponent": "teacherFooterComponent---3g29e",
	"buttonContainer": "buttonContainer---2nlEk",
	"footerButton": "footerButton---XCVCF",
	"bulkPasswordChange": "bulkPasswordChange---2gLT8",
	"deleteTeachers": "deleteTeachers---2HdCb",
	"unassign": "unassign---39Y-J",
	"svgIconContainer": "svgIconContainer---2q-sW",
	"iconClassName": "iconClassName---sNxLZ",
	"highlight": "highlight---1WYfw"
};

/***/ }),
/* 1207 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(4)();
// imports


// module
exports.push([module.i, ".teacherHeaderComponent---2GvB0 {\n  display: -webkit-box;\n  display: -moz-flex;\n  display: -ms-flexbox;\n  display: flex;\n  font-family: Poppins, sans-serif;\n  min-height: 70px;\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n  -moz-align-items: center;\n  align-items: center;\n  background-color: #e7e9ea;\n  -webkit-box-pack: justify;\n  -ms-flex-pack: justify;\n  -moz-justify-content: space-between;\n  justify-content: space-between; }\n\n.buttonContainer---2O7cg {\n  display: -webkit-box;\n  display: -moz-flex;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n  -moz-align-items: center;\n  align-items: center;\n  margin-right: 25px;\n  -webkit-box-pack: end;\n  -ms-flex-pack: end;\n  -moz-justify-content: flex-end;\n  justify-content: flex-end; }\n\n/* Medium screens */\n\n@media all and (max-width: 800px) {\n  .buttonContainer---2O7cg {\n    -ms-flex-pack: distribute;\n    -moz-justify-content: space-around;\n    justify-content: space-around; } }\n\n/* Small screens */\n\n@media all and (max-width: 500px) {\n  .buttonContainer---2O7cg {\n    -webkit-box-direction: normal;\n    -webkit-box-orient: vertical;\n    -moz-flex-direction: column;\n    -ms-flex-direction: column;\n    flex-direction: column; } }\n\n.svgIconContainer---2dV00 {\n  width: 25px;\n  height: 25px;\n  margin: 7px; }\n\n.svgIconContainer---2dV00 svg path {\n    fill: white !important; }\n\n.headerButton---3eVnw, .inviteTeacher---fK0Uv,\n.downloadTeacherRoll---2Zzum,\n.bulkUpload---38ZmJ {\n  margin-left: 10px; }\n\n.bulkUpload---38ZmJ {\n  display: none; }\n\n@media (min-width: 1025px) {\n    .bulkUpload---38ZmJ {\n      display: -webkit-inline-box;\n      display: -ms-inline-flexbox;\n      display: inline-flex; } }\n\n.teachersCountContainer---2k2PE {\n  margin-left: 25px;\n  display: -webkit-box;\n  display: -moz-flex;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n  -moz-align-items: center;\n  align-items: center;\n  -webkit-box-pack: start;\n  -ms-flex-pack: start;\n  -moz-justify-content: flex-start;\n  justify-content: flex-start;\n  -webkit-box-direction: normal;\n  -webkit-box-orient: horizontal;\n  -moz-flex-direction: row;\n  -ms-flex-direction: row;\n  flex-direction: row;\n  -webkit-box-flex: 1;\n  -moz-flex: 1;\n  -ms-flex: 1;\n  flex: 1; }\n\n.teachersFontBase---JwMHC, .teachersCount---2CPH1, .teachersTitle---1mvDR {\n  font-family: Poppins, sans-serif;\n  color: #415667;\n  font-weight: 500; }\n\n.teachersCount---2CPH1 {\n  font-size: 20px;\n  margin-left: 5px;\n  display: -webkit-box;\n  display: -moz-flex;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-flex: 1;\n  -moz-flex: 1;\n  -ms-flex: 1;\n  flex: 1; }\n\n.teachersTitle---1mvDR {\n  height: 23px;\n  width: 100%;\n  font-size: 26px;\n  line-height: 27px;\n  display: -webkit-box;\n  display: -moz-flex;\n  display: -ms-flexbox;\n  display: flex; }\n", ""]);

// exports
exports.locals = {
	"teacherHeaderComponent": "teacherHeaderComponent---2GvB0",
	"buttonContainer": "buttonContainer---2O7cg",
	"svgIconContainer": "svgIconContainer---2dV00",
	"headerButton": "headerButton---3eVnw",
	"inviteTeacher": "inviteTeacher---fK0Uv",
	"downloadTeacherRoll": "downloadTeacherRoll---2Zzum",
	"bulkUpload": "bulkUpload---38ZmJ",
	"teachersCountContainer": "teachersCountContainer---2k2PE",
	"teachersFontBase": "teachersFontBase---JwMHC",
	"teachersCount": "teachersCount---2CPH1",
	"teachersTitle": "teachersTitle---1mvDR"
};

/***/ }),
/* 1208 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(4)();
// imports


// module
exports.push([module.i, ".teacherRollComponent---3lewy, .teacher---28iFv {\n  display: -webkit-box;\n  display: -moz-flex;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-flex: 10;\n  -moz-flex: 10;\n  -ms-flex: 10;\n  flex: 10;\n  -webkit-box-direction: normal;\n  -webkit-box-orient: vertical;\n  -moz-flex-direction: column;\n  -ms-flex-direction: column;\n  flex-direction: column;\n  background-color: #e7e9ea;\n  height: 100%; }\n\n.teacherListContainer---I_p2b {\n  display: -webkit-box;\n  display: -moz-flex;\n  display: -ms-flexbox;\n  display: flex;\n  min-height: 70vh;\n  font-family: Poppins;\n  margin: 0 25px;\n  padding: 20px 20px 100px;\n  background: #fff;\n  -webkit-box-shadow: 5px 5px 0 0 rgba(0, 0, 0, .07);\n          box-shadow: 5px 5px 0 0 rgba(0, 0, 0, .07);\n  -webkit-box-direction: normal;\n  -webkit-box-orient: vertical;\n  -moz-flex-direction: column;\n  -ms-flex-direction: column;\n  flex-direction: column;\n  -webkit-box-align: start;\n  -ms-flex-align: start;\n  -moz-align-items: flex-start;\n  align-items: flex-start;\n  -webkit-box-pack: start;\n  -ms-flex-pack: start;\n  -moz-justify-content: flex-start;\n  justify-content: flex-start;\n  -webkit-box-flex: 1;\n  -moz-flex-grow: 1;\n  -ms-flex-positive: 1;\n  flex-grow: 1; }\n\n.teacher---28iFv {\n  z-index: 100001; }\n\n.loadingContainer---3cskU {\n  height: 100%;\n  width: 100%;\n  display: -webkit-box;\n  display: -moz-flex;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: center;\n  -ms-flex-pack: center;\n  -moz-justify-content: center;\n  justify-content: center;\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n  -moz-align-items: center;\n  align-items: center;\n  -webkit-box-flex: 1;\n  -moz-flex-grow: 1;\n  -ms-flex-positive: 1;\n  flex-grow: 1; }\n\n.loader---RoLdY > div {\n  background-color: #4e5c67 !important;\n  width: 16px !important;\n  height: 16px !important;\n  margin: 4px !important; }\n\n.react-grid-HeaderCell:nth-child(6) {\n  color: #000 !important; }\n\n.react-grid-HeaderCell:nth-child(7) {\n  color: #1c7fc3; }\n\n.react-grid-HeaderCell:nth-child(8) {\n  min-width: 40px; }\n\n.react-grid-Cell:nth-child(8) {\n  min-width: 40px; }\n", ""]);

// exports
exports.locals = {
	"teacherRollComponent": "teacherRollComponent---3lewy",
	"teacher": "teacher---28iFv",
	"teacherListContainer": "teacherListContainer---I_p2b",
	"loadingContainer": "loadingContainer---3cskU",
	"loader": "loader---RoLdY"
};

/***/ }),
/* 1209 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(4)();
// imports


// module
exports.push([module.i, ".confirmationMessageContainer---3Nw6b {\n  display: -webkit-box;\n  display: -moz-flex;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: center;\n  -ms-flex-pack: center;\n  -moz-justify-content: center;\n  justify-content: center;\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n  -moz-align-items: center;\n  align-items: center;\n  -webkit-box-direction: normal;\n  -webkit-box-orient: vertical;\n  -moz-flex-direction: column;\n  -ms-flex-direction: column;\n  flex-direction: column;\n  outline: none;\n  -webkit-user-select: none;\n     -moz-user-select: none;\n      -ms-user-select: none;\n          user-select: none; }\n\n.icon---3jPMx {\n  width: 60px;\n  height: 75px;\n  margin-bottom: 31px; }\n\n.title---3a1Ko {\n  width: 90%;\n  color: #4e5c67;\n  font-family: Poppins;\n  font-size: 28px;\n  font-weight: 500;\n  text-align: center;\n  line-height: 27px; }\n\n.message---XFeCl {\n  width: 50%;\n  margin: 45px;\n  color: black;\n  font-family: Poppins;\n  font-size: 20px;\n  text-align: center;\n  line-height: 27px; }\n\n.highlight---1GnPa {\n  color: #32a8a7; }\n\n.confirm---2ElIi {\n  padding-top: 20px; }\n\n.container---3y0L1 {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex; }\n\n.ok---2DYo0, .cancel---Cd1SM {\n  position: relative;\n  display: inline-block;\n  width: 90px;\n  height: 90px;\n  border-radius: 45px;\n  margin: 10px;\n  background-color: #37c97c;\n  cursor: pointer;\n  outline: none; }\n\n.cancel---Cd1SM {\n  background-color: #c53902; }\n\n.okButtonDisabled---3_vsw, .cancelButtonDisabled---3bgh1 {\n  position: relative;\n  display: inline-block;\n  width: 90px;\n  height: 90px;\n  border-radius: 45px;\n  margin: 10px;\n  background-color: #37c97c;\n  cursor: not-allowed;\n  outline: none;\n  opacity: 0.4; }\n\n.okButtonDisabled---3_vsw :nth-child(3), .cancelButtonDisabled---3bgh1 :nth-child(3) {\n    display: none; }\n\n.cancelButtonDisabled---3bgh1 {\n  background-color: #c53902; }\n\n.iconClassName---1oCWi {\n  position: absolute;\n  top: 35%;\n  left: 35%;\n  width: 29px;\n  height: 32px; }\n\n.iconClassName---1oCWi path {\n    fill: white !important; }\n", ""]);

// exports
exports.locals = {
	"confirmationMessageContainer": "confirmationMessageContainer---3Nw6b",
	"icon": "icon---3jPMx",
	"title": "title---3a1Ko",
	"message": "message---XFeCl",
	"highlight": "highlight---1GnPa",
	"confirm": "confirm---2ElIi",
	"container": "container---3y0L1",
	"ok": "ok---2DYo0",
	"cancel": "cancel---Cd1SM",
	"okButtonDisabled": "okButtonDisabled---3_vsw",
	"cancelButtonDisabled": "cancelButtonDisabled---3bgh1",
	"iconClassName": "iconClassName---1oCWi"
};

/***/ }),
/* 1210 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(4)();
// imports


// module
exports.push([module.i, ".container---1K9_Q {\n  display: -webkit-box;\n  display: -moz-flex;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: justify;\n  -ms-flex-pack: justify;\n  -moz-justify-content: space-between;\n  justify-content: space-between;\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n  -moz-align-items: center;\n  align-items: center;\n  -webkit-box-direction: normal;\n  -webkit-box-orient: vertical;\n  -moz-flex-direction: column;\n  -ms-flex-direction: column;\n  flex-direction: column;\n  height: 100%; }\n\n.footer---2qZnQ, .header---3Z7xN {\n  height: 75px;\n  width: 100%;\n  background-color: #dbe3e9; }\n\n.header---3Z7xN {\n  font-size: 30px;\n  font-family: Poppins;\n  padding-left: 25px;\n  padding-top: 20px;\n  color: #4e5c67; }\n\n.subHeader---luEM7 {\n  color: #4e5c67;\n  font-size: 16px;\n  font-weight: 500;\n  margin: 12px 0;\n  text-align: center; }\n\n.teachers---2ABw3 {\n  display: -webkit-box;\n  display: -moz-flex;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: justify;\n  -ms-flex-pack: justify;\n  -moz-justify-content: space-between;\n  justify-content: space-between;\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n  -moz-align-items: center;\n  align-items: center;\n  -webkit-box-direction: normal;\n  -webkit-box-orient: vertical;\n  -moz-flex-direction: column;\n  -ms-flex-direction: column;\n  flex-direction: column;\n  width: 22%;\n  height: 105px; }\n\n.teachers---2ABw3 select {\n    border: 1px solid #cfd2d4; }\n\n.teachers---2ABw3 .dark---2i63X {\n    background-color: #1981c4; }\n\n.loader---8gY8R {\n  display: -webkit-box;\n  display: -moz-flex;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n  -moz-align-items: center;\n  align-items: center;\n  -webkit-box-pack: center;\n  -ms-flex-pack: center;\n  -moz-justify-content: center;\n  justify-content: center;\n  position: fixed;\n  z-index: 100004;\n  top: 0;\n  bottom: 0;\n  left: 0;\n  right: 0;\n  background-color: rgba(255, 255, 255, .85); }\n", ""]);

// exports
exports.locals = {
	"container": "container---1K9_Q",
	"footer": "footer---2qZnQ",
	"header": "header---3Z7xN",
	"subHeader": "subHeader---luEM7",
	"teachers": "teachers---2ABw3",
	"dark": "dark---2i63X",
	"loader": "loader---8gY8R"
};

/***/ }),
/* 1211 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(4)();
// imports


// module
exports.push([module.i, ".inputTextComponent---3s4MM {\n  display: inherit; }\n\n.inputText---2eBSF, .disabled---3hV14 {\n  width: 485px;\n  height: 50px;\n  padding: 12px 22px;\n  border: 2px solid #c2cfda;\n  border-radius: 10px;\n  -webkit-box-shadow: 3px 3px 0 0 #eef2f5;\n          box-shadow: 3px 3px 0 0 #eef2f5;\n  font-family: Poppins;\n  font-size: 26px;\n  outline: none; }\n\n.inputText---2eBSF::-webkit-input-placeholder, .disabled---3hV14::-webkit-input-placeholder {\n    color: lightgray;\n    font-size: 20px; }\n\n.inputText---2eBSF:-ms-input-placeholder, .disabled---3hV14:-ms-input-placeholder {\n    color: lightgray;\n    font-size: 20px; }\n\n.disabled---3hV14 {\n  opacity: 0.4;\n  pointer-events: none;\n  cursor: not-allowed; }\n\n.clearButtonContainer---1Xs-s {\n  -webkit-align-self: center;\n  -ms-flex-item-align: center;\n  align-self: center;\n  -webkit-box-pack: center;\n  -ms-flex-pack: center;\n  -moz-justify-content: center;\n  justify-content: center;\n  -webkit-box-flex: none;\n  -moz-flex: none;\n  -ms-flex: none;\n  flex: none;\n  position: absolute;\n  right: 0;\n  top: 50%;\n  background-color: #cfd2d4;\n  height: 20px;\n  width: 20px;\n  margin: -10px 5px 5px;\n  border-radius: 100%;\n  border: 0; }\n\n.clearButtonContainer---1Xs-s > div {\n    height: 100%; }\n\n.clearButtonIcon---2clMc {\n  width: 10px;\n  height: 16px; }\n\n.clearButtonIcon---2clMc svg path {\n    fill: #415667 !important; }\n\n.hasClearText---Z9ahU {\n  position: relative; }\n\n.hasClearText---Z9ahU input::-ms-clear {\n    display: none; }\n", ""]);

// exports
exports.locals = {
	"inputTextComponent": "inputTextComponent---3s4MM",
	"inputText": "inputText---2eBSF",
	"disabled": "disabled---3hV14",
	"clearButtonContainer": "clearButtonContainer---1Xs-s",
	"clearButtonIcon": "clearButtonIcon---2clMc",
	"hasClearText": "hasClearText---Z9ahU"
};

/***/ }),
/* 1212 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(4)();
// imports


// module
exports.push([module.i, ".toast---2L2-i {\n  display: -webkit-box;\n  display: -moz-flex;\n  display: -ms-flexbox;\n  display: flex;\n  position: absolute;\n  bottom: 0;\n  left: 0;\n  width: 100%;\n  visibility: visible;\n  -webkit-box-pack: center;\n      -ms-flex-pack: center;\n          justify-content: center;\n  opacity: 0;\n  -webkit-animation: fadeIn---s7cFb 7s;\n          animation: fadeIn---s7cFb 7s;\n  font-size: 17px;\n  z-index: 2147483647; }\n  .toastContent---1Zj3X {\n    padding: 15px;\n    width: 100%; }\n  .message---2WI7- {\n  color: white; }\n  @-webkit-keyframes fadeIn---s7cFb {\n  0% {\n    opacity: 0; }\n  25% {\n    opacity: 1; }\n  75% {\n    opacity: 1; }\n  100% {\n    opacity: 0; } }\n  @keyframes fadeIn---s7cFb {\n  0% {\n    opacity: 0; }\n  25% {\n    opacity: 1; }\n  75% {\n    opacity: 1; }\n  100% {\n    opacity: 0; } }\n  @media print {\n  .empty---1za14 {\n    display: none !important;\n    height: 0.001px !important; } }\n", ""]);

// exports
exports.locals = {
	"toast": "toast---2L2-i",
	"fadeIn": "fadeIn---s7cFb",
	"toastContent": "toastContent---1Zj3X",
	"message": "message---2WI7-",
	"empty": "empty---1za14"
};

/***/ }),
/* 1213 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(4)();
// imports


// module
exports.push([module.i, "/**\n * Fix for vw, vh, vmin, vmax on iOS 7.\n * http://caniuse.com/#feat=viewport-units\n *\n * This fix works by replacing viewport units with px values on known screen sizes.\n *\n * iPhone 6 and 6 Plus cannot run iOS 7, so are not targeted by this fix.\n * Target devices running iOS 8+ will incidentally execute the media query,\n * but this will still produce the expected result; so this is not a problem.\n *\n * As an example, replace:\n *\n *   height: 50vh;\n *   font-size: 5vmin;\n *\n * with:\n *\n *   @include viewport-unit(height, 50vh);\n *   @include viewport-unit(font-size, 5vmin);\n */\n.uploadValidationContainer---KNnbk {\n  display: -webkit-box;\n  display: -moz-flex;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: center;\n  -ms-flex-pack: center;\n  -moz-justify-content: center;\n  justify-content: center;\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n  -moz-align-items: center;\n  align-items: center;\n  -webkit-box-direction: normal;\n  -webkit-box-orient: vertical;\n  -moz-flex-direction: column;\n  -ms-flex-direction: column;\n  flex-direction: column;\n  outline: none; }\n.errorMessage---29cTd {\n  color: #4e5c67;\n  font-size: 28px;\n  font-weight: 500;\n  margin-top: 10px; }\n.errorMessagesWrapper---1g4vd {\n  max-height: 50vh;\n  padding: 9px;\n  border: 1px solid #bcbcbc;\n  opacity: 0.95;\n  clear: left;\n  height: auto;\n  width: 90%;\n  margin-top: 20px;\n  margin-bottom: 20px; }\n@media only screen and (-webkit-min-device-pixel-ratio: 1) and (device-width: 768px) and (device-height: 1024px) and (orientation: portrait) {\n    .errorMessagesWrapper---1g4vd {\n      max-height: 512px; } }\n@media only screen and (-webkit-min-device-pixel-ratio: 1) and (device-width: 768px) and (device-height: 1024px) and (orientation: landscape) {\n    .errorMessagesWrapper---1g4vd {\n      max-height: 384px; } }\n@media only screen and (-webkit-min-device-pixel-ratio: 1) and (device-width: 320px) and (device-height: 480px) and (orientation: portrait) {\n    .errorMessagesWrapper---1g4vd {\n      max-height: 240px; } }\n@media only screen and (-webkit-min-device-pixel-ratio: 1) and (device-width: 320px) and (device-height: 480px) and (orientation: landscape) {\n    .errorMessagesWrapper---1g4vd {\n      max-height: 160px; } }\n@media only screen and (-webkit-min-device-pixel-ratio: 1) and (device-width: 320px) and (device-height: 568px) and (orientation: portrait) {\n    .errorMessagesWrapper---1g4vd {\n      max-height: 284px; } }\n@media only screen and (-webkit-min-device-pixel-ratio: 1) and (device-width: 320px) and (device-height: 568px) and (orientation: landscape) {\n    .errorMessagesWrapper---1g4vd {\n      max-height: 160px; } }\n.errorMessagesRow---2ipQ3 {\n  max-height: 45vh;\n  overflow-y: auto;\n  padding: 8px; }\n@media only screen and (-webkit-min-device-pixel-ratio: 1) and (device-width: 768px) and (device-height: 1024px) and (orientation: portrait) {\n    .errorMessagesRow---2ipQ3 {\n      max-height: 460.8px; } }\n@media only screen and (-webkit-min-device-pixel-ratio: 1) and (device-width: 768px) and (device-height: 1024px) and (orientation: landscape) {\n    .errorMessagesRow---2ipQ3 {\n      max-height: 345.6px; } }\n@media only screen and (-webkit-min-device-pixel-ratio: 1) and (device-width: 320px) and (device-height: 480px) and (orientation: portrait) {\n    .errorMessagesRow---2ipQ3 {\n      max-height: 216px; } }\n@media only screen and (-webkit-min-device-pixel-ratio: 1) and (device-width: 320px) and (device-height: 480px) and (orientation: landscape) {\n    .errorMessagesRow---2ipQ3 {\n      max-height: 144px; } }\n@media only screen and (-webkit-min-device-pixel-ratio: 1) and (device-width: 320px) and (device-height: 568px) and (orientation: portrait) {\n    .errorMessagesRow---2ipQ3 {\n      max-height: 255.6px; } }\n@media only screen and (-webkit-min-device-pixel-ratio: 1) and (device-width: 320px) and (device-height: 568px) and (orientation: landscape) {\n    .errorMessagesRow---2ipQ3 {\n      max-height: 144px; } }\n.errorMessagesRow---2ipQ3::-webkit-scrollbar {\n  border-radius: 3px;\n  width: 1em;\n  padding: 6px; }\n.errorMessagesRow---2ipQ3::-webkit-scrollbar-track {\n  -webkit-box-shadow: inset 0 0 0.1px; }\n.errorMessagesRow---2ipQ3::-webkit-scrollbar-thumb {\n  background-color: darkgrey;\n  outline: 1px solid slategrey;\n  border-radius: 10px; }\n.button---GwGxv, .viewSummary---1FoWM {\n  border-radius: 22px;\n  background-color: #415667;\n  -webkit-box-shadow: none;\n          box-shadow: none;\n  color: white;\n  width: 95px;\n  height: 45px;\n  border: none;\n  font-size: 16px;\n  font-weight: 500;\n  outline: none; }\n.svg---1x_b1 {\n  width: 60px; }\n.buttonPanel---27EnR {\n  width: 90%; }\n.leftPanel---2tYDh {\n  float: left; }\n.done---1Ye2X {\n  text-align: center; }\n.rightPanel---2eoo3 {\n  float: right; }\n.viewSummary---1FoWM {\n  width: 149px; }\n.hidden---1HYZV {\n  display: none; }\n@media screen and (max-height: 500px) {\n  .svg---1x_b1 {\n    width: 40px; }\n  .errorMessage---29cTd {\n    font-size: 22px;\n    margin-top: 0; }\n  .errorMessagesWrapper---1g4vd {\n    margin-top: 10px;\n    margin-bottom: 10px; } }\n@media print {\n  .svg---1x_b1, .button---GwGxv, .viewSummary---1FoWM,\n  .done---1Ye2X,\n  .buttonPanel---27EnR,\n  div[class^=\"rightPanel-\"],\n  div[class^=\"errorMessage-\"],\n  div[class*=\"errorMessage-\"] {\n    display: none !important; }\n  div[class^=\"errorMessagesWrapper-\"],\n  div[class*=\"errorMessagesWrapper-\"] {\n    border: none; }\n  div[class^=\"uploadValidationContainer-\"],\n  div[class*=\"uploadValidationContainer-\"] {\n    position: absolute;\n    max-height: 200cm !important;\n    top: 0.1px;\n    left: 0.1px; }\n  div[class^=\"errorMessagesRow-\"],\n  div[class*=\"errorMessagesRow-\"] {\n    overflow-y: unset;\n    -ms-overflow-style: none;\n    page-break-inside: avoid;\n    max-height: none; }\n  @page {\n    margin-top: 15mm;\n    margin-bottom: 10mm;\n    page-break-after: always; }\n  .buttonPanel---27EnR {\n    display: none !important; } }\n", ""]);

// exports
exports.locals = {
	"uploadValidationContainer": "uploadValidationContainer---KNnbk",
	"errorMessage": "errorMessage---29cTd",
	"errorMessagesWrapper": "errorMessagesWrapper---1g4vd",
	"errorMessagesRow": "errorMessagesRow---2ipQ3",
	"button": "button---GwGxv",
	"viewSummary": "viewSummary---1FoWM",
	"svg": "svg---1x_b1",
	"buttonPanel": "buttonPanel---27EnR",
	"leftPanel": "leftPanel---2tYDh",
	"done": "done---1Ye2X",
	"rightPanel": "rightPanel---2eoo3",
	"hidden": "hidden---1HYZV"
};

/***/ }),
/* 1214 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(4)();
// imports


// module
exports.push([module.i, ".confirmationMessageContainer---43Nuh {\n  display: -webkit-box;\n  display: -moz-flex;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: center;\n  -ms-flex-pack: center;\n  -moz-justify-content: center;\n  justify-content: center;\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n  -moz-align-items: center;\n  align-items: center;\n  -webkit-box-direction: normal;\n  -webkit-box-orient: vertical;\n  -moz-flex-direction: column;\n  -ms-flex-direction: column;\n  flex-direction: column;\n  outline: none;\n  -webkit-user-select: none;\n     -moz-user-select: none;\n      -ms-user-select: none;\n          user-select: none; }\n\n.icon---10lzj {\n  width: 60px;\n  height: 75px;\n  margin-bottom: 31px; }\n\n.title---1XISe {\n  width: 90%;\n  color: #4e5c67;\n  font-family: Poppins;\n  font-size: 28px;\n  font-weight: 500;\n  text-align: center;\n  line-height: 40px;\n  margin-top: 20px;\n  margin-bottom: 20px; }\n\n.message---3sDgu {\n  width: 60%;\n  margin-top: 10px;\n  margin-bottom: 45px;\n  color: black;\n  font-family: Poppins;\n  font-size: 20px;\n  text-align: center;\n  line-height: 27px; }\n\n.highlight---3Wf2n {\n  color: #f12800; }\n\n.confirm---2qcvv {\n  padding-top: 20px; }\n\n.container---1EJYP {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex; }\n\n.ok---1KPMW, .cancel---1Kjhx {\n  position: relative;\n  display: inline-block;\n  width: 90px;\n  height: 90px;\n  border-radius: 45px;\n  margin: 10px;\n  background-color: #37c97c;\n  cursor: pointer;\n  outline: none; }\n\n.cancel---1Kjhx {\n  background-color: #c53902; }\n\n.okButtonDisabled---1zOOw, .cancelButtonDisabled---2S7sm {\n  position: relative;\n  display: inline-block;\n  width: 90px;\n  height: 90px;\n  border-radius: 45px;\n  margin: 10px;\n  background-color: #37c97c;\n  cursor: not-allowed;\n  outline: none;\n  opacity: 0.4; }\n\n.okButtonDisabled---1zOOw :nth-child(3), .cancelButtonDisabled---2S7sm :nth-child(3) {\n    display: none; }\n\n.cancelButtonDisabled---2S7sm {\n  background-color: #c53902; }\n\n.iconClassName---2RGRk {\n  position: absolute;\n  top: 35%;\n  left: 35%;\n  width: 29px;\n  height: 32px; }\n\n.iconClassName---2RGRk path {\n    fill: white !important; }\n", ""]);

// exports
exports.locals = {
	"confirmationMessageContainer": "confirmationMessageContainer---43Nuh",
	"icon": "icon---10lzj",
	"title": "title---1XISe",
	"message": "message---3sDgu",
	"highlight": "highlight---3Wf2n",
	"confirm": "confirm---2qcvv",
	"container": "container---1EJYP",
	"ok": "ok---1KPMW",
	"cancel": "cancel---1Kjhx",
	"okButtonDisabled": "okButtonDisabled---1zOOw",
	"cancelButtonDisabled": "cancelButtonDisabled---2S7sm",
	"iconClassName": "iconClassName---2RGRk"
};

/***/ }),
/* 1215 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(4)();
// imports


// module
exports.push([module.i, ".viewCourse---177CT {\n  display: -webkit-inline-box;\n  display: -ms-inline-flexbox;\n  display: inline-flex;\n  background-color: #1981c4;\n  height: 30px;\n  width: 30px;\n  border-radius: 50%;\n  color: white;\n  margin: 0 auto;\n  border: none;\n  outline: none; }\n\n.icon---19Dk3 {\n  width: 16px;\n  margin: 6px auto; }\n\n.icon---19Dk3 svg path {\n    fill: #fff !important; }\n", ""]);

// exports
exports.locals = {
	"viewCourse": "viewCourse---177CT",
	"icon": "icon---19Dk3"
};

/***/ }),
/* 1216 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(4)();
// imports


// module
exports.push([module.i, ".loadingContainer---CbhAk {\n  display: -webkit-box;\n  display: -moz-flex;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: center;\n  -ms-flex-pack: center;\n  -moz-justify-content: center;\n  justify-content: center;\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n  -moz-align-items: center;\n  align-items: center;\n  position: fixed;\n  left: 0;\n  top: 0;\n  display: flex;\n  background: #dbe3e9;\n  z-index: 100000;\n  opacity: 0.3;\n  height: 100%;\n  width: 100%; }\n", ""]);

// exports
exports.locals = {
	"loadingContainer": "loadingContainer---CbhAk"
};

/***/ }),
/* 1217 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(4)();
// imports


// module
exports.push([module.i, ".component---2fWGN {\n  display: block; }\n\n.loader---1KBGJ {\n  display: -webkit-box;\n  display: -moz-flex;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n  -moz-align-items: center;\n  align-items: center;\n  -webkit-box-pack: center;\n  -ms-flex-pack: center;\n  -moz-justify-content: center;\n  justify-content: center;\n  position: fixed;\n  z-index: 100004;\n  top: 0;\n  bottom: 0;\n  left: 0;\n  right: 0;\n  background-color: rgba(255, 255, 255, .85);\n  padding-right: 51px; }\n", ""]);

// exports
exports.locals = {
	"component": "component---2fWGN",
	"loader": "loader---1KBGJ"
};

/***/ }),
/* 1218 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(4)();
// imports


// module
exports.push([module.i, ".quickUploadComponent---16vL5 {\n  display: block; }\n\n.uploadedRecordCount---1YNvQ {\n  color: #32a8a7;\n  font-weight: 500; }\n\n.message---1jGTT {\n  display: inline;\n  padding-left: 25px;\n  line-height: 27px; }\n\n.rowNumber---271ON {\n  font-size: 14px; }\n\n.resultContainer---30PJ6 {\n  color: #000;\n  font-family: Poppins;\n  font-size: 14px;\n  line-height: 27px; }\n\n.resultSection---4KJZ- {\n  margin: 10px 0.1px; }\n\n@media print {\n  .resultContainer---30PJ6 {\n    width: 100%; } }\n", ""]);

// exports
exports.locals = {
	"quickUploadComponent": "quickUploadComponent---16vL5",
	"uploadedRecordCount": "uploadedRecordCount---1YNvQ",
	"message": "message---1jGTT",
	"rowNumber": "rowNumber---271ON",
	"resultContainer": "resultContainer---30PJ6",
	"resultSection": "resultSection---4KJZ-"
};

/***/ }),
/* 1219 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(4)();
// imports


// module
exports.push([module.i, ".schoolRollComponent---3BNi_ {\n  display: -webkit-box;\n  display: -moz-flex;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-direction: normal;\n  -webkit-box-orient: vertical;\n  -moz-flex-direction: column;\n  -ms-flex-direction: column;\n  flex-direction: column;\n  position: fixed;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  overflow-y: scroll;\n  -webkit-overflow-scrolling: touch; }\n\n.mainContent---mxqxf {\n  -webkit-box-flex: 1;\n  -moz-flex: 1;\n  -ms-flex: 1;\n  flex: 1;\n  background-color: #e7e9ea; }\n\n.loadingContainer---14qgb {\n  height: 100%;\n  width: 100%;\n  display: -webkit-box;\n  display: -moz-flex;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: center;\n  -ms-flex-pack: center;\n  -moz-justify-content: center;\n  justify-content: center;\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n  -moz-align-items: center;\n  align-items: center; }\n\n.loader---3eD3X > div {\n  background-color: #4e5c67 !important;\n  width: 16px !important;\n  height: 16px !important;\n  margin: 4px !important; }\n", ""]);

// exports
exports.locals = {
	"schoolRollComponent": "schoolRollComponent---3BNi_",
	"mainContent": "mainContent---mxqxf",
	"loadingContainer": "loadingContainer---14qgb",
	"loader": "loader---3eD3X"
};

/***/ }),
/* 1220 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(4)();
// imports


// module
exports.push([module.i, "/* React Core CSS */\n/*! normalize.css v3.0.3 | MIT License | github.com/necolas/normalize.css */\nhtml {\n  font-family: sans-serif;\n  -ms-text-size-adjust: 100%;\n  -webkit-text-size-adjust: 100%; }\nbody {\n  margin: 0; }\narticle,\naside,\ndetails,\nfigcaption,\nfigure,\nfooter,\nheader,\nhgroup,\nmain,\nmenu,\nnav,\nsection,\nsummary {\n  display: block; }\naudio,\ncanvas,\nprogress,\nvideo {\n  display: inline-block;\n  vertical-align: baseline; }\naudio:not([controls]) {\n  display: none;\n  height: 0; }\n[hidden],\ntemplate {\n  display: none; }\na {\n  background-color: transparent; }\na:active,\na:hover {\n  outline: 0; }\nabbr[title] {\n  border-bottom: none;\n  text-decoration: underline;\n  -webkit-text-decoration: underline dotted;\n          text-decoration: underline dotted; }\nb,\nstrong {\n  font-weight: bold; }\ndfn {\n  font-style: italic; }\nh1 {\n  font-size: 2em;\n  margin: 0.67em 0; }\nmark {\n  background: #ff0;\n  color: #000; }\nsmall {\n  font-size: 80%; }\nsub,\nsup {\n  font-size: 75%;\n  line-height: 0;\n  position: relative;\n  vertical-align: baseline; }\nsup {\n  top: -0.5em; }\nsub {\n  bottom: -0.25em; }\nimg {\n  border: 0; }\nsvg:not(:root) {\n  overflow: hidden; }\nfigure {\n  margin: 1em 40px; }\nhr {\n  -webkit-box-sizing: content-box;\n          box-sizing: content-box;\n  height: 0; }\npre {\n  overflow: auto; }\ncode,\nkbd,\npre,\nsamp {\n  font-family: monospace, monospace;\n  font-size: 1em; }\nbutton,\ninput,\noptgroup,\nselect,\ntextarea {\n  color: inherit;\n  font: inherit;\n  margin: 0; }\nbutton {\n  overflow: visible; }\nbutton,\nselect {\n  text-transform: none; }\nbutton,\nhtml input[type=\"button\"],\ninput[type=\"reset\"],\ninput[type=\"submit\"] {\n  -webkit-appearance: button;\n  cursor: pointer; }\nbutton[disabled],\nhtml input[disabled] {\n  cursor: default; }\nbutton::-moz-focus-inner,\ninput::-moz-focus-inner {\n  border: 0;\n  padding: 0; }\ninput {\n  line-height: normal; }\ninput[type=\"checkbox\"],\ninput[type=\"radio\"] {\n  -webkit-box-sizing: border-box;\n          box-sizing: border-box;\n  padding: 0; }\ninput[type=\"number\"]::-webkit-inner-spin-button,\ninput[type=\"number\"]::-webkit-outer-spin-button {\n  height: auto; }\ninput[type=\"search\"] {\n  -webkit-appearance: textfield;\n  -webkit-box-sizing: content-box;\n          box-sizing: content-box; }\ninput[type=\"search\"]::-webkit-search-cancel-button,\ninput[type=\"search\"]::-webkit-search-decoration {\n  -webkit-appearance: none; }\nfieldset {\n  border: 1px solid #c0c0c0;\n  margin: 0 2px;\n  padding: 0.35em 0.625em 0.75em; }\nlegend {\n  border: 0;\n  padding: 0; }\ntextarea {\n  overflow: auto; }\noptgroup {\n  font-weight: bold; }\ntable {\n  border-collapse: collapse;\n  border-spacing: 0; }\ntd,\nth {\n  padding: 0; }\n* {\n  -webkit-box-sizing: border-box;\n  box-sizing: border-box; }\n*:before,\n*:after {\n  -webkit-box-sizing: border-box;\n  box-sizing: border-box; }\nhtml {\n  font-size: 10px;\n  -webkit-tap-highlight-color: rgba(0, 0, 0, 0); }\nbody {\n  font-family: \"Helvetica Neue\", Helvetica, Arial, sans-serif;\n  font-size: 14px;\n  line-height: 1.42857;\n  color: #333333;\n  background-color: #fff; }\ninput,\nbutton,\nselect,\ntextarea {\n  font-family: inherit;\n  font-size: inherit;\n  line-height: inherit; }\na {\n  color: #337ab7;\n  text-decoration: none; }\na:hover, a:focus {\n    color: #23527c;\n    text-decoration: underline; }\na:focus {\n    outline: 5px auto -webkit-focus-ring-color;\n    outline-offset: -2px; }\nfigure {\n  margin: 0; }\nimg {\n  vertical-align: middle; }\n.img-responsive {\n  display: block;\n  max-width: 100%;\n  height: auto; }\n.img-rounded {\n  border-radius: 6px; }\n.img-thumbnail {\n  padding: 4px;\n  line-height: 1.42857;\n  background-color: #fff;\n  border: 1px solid #ddd;\n  border-radius: 4px;\n  -webkit-transition: all 0.2s ease-in-out;\n  transition: all 0.2s ease-in-out;\n  display: inline-block;\n  max-width: 100%;\n  height: auto; }\n.img-circle {\n  border-radius: 50%; }\nhr {\n  margin-top: 20px;\n  margin-bottom: 20px;\n  border: 0;\n  border-top: 1px solid #eeeeee; }\n.sr-only {\n  position: absolute;\n  width: 1px;\n  height: 1px;\n  padding: 0;\n  margin: -1px;\n  overflow: hidden;\n  clip: rect(0, 0, 0, 0);\n  border: 0; }\n.sr-only-focusable:active, .sr-only-focusable:focus {\n  position: static;\n  width: auto;\n  height: auto;\n  margin: 0;\n  overflow: visible;\n  clip: auto; }\n[role=\"button\"] {\n  cursor: pointer; }\nh1, h2, h3, h4, h5, h6,\n.h1, .h2, .h3, .h4, .h5, .h6 {\n  font-family: inherit;\n  font-weight: 500;\n  line-height: 1.1;\n  color: inherit; }\nh1 small,\n  h1 .small, h2 small,\n  h2 .small, h3 small,\n  h3 .small, h4 small,\n  h4 .small, h5 small,\n  h5 .small, h6 small,\n  h6 .small,\n  .h1 small,\n  .h1 .small, .h2 small,\n  .h2 .small, .h3 small,\n  .h3 .small, .h4 small,\n  .h4 .small, .h5 small,\n  .h5 .small, .h6 small,\n  .h6 .small {\n    font-weight: 400;\n    line-height: 1;\n    color: #777777; }\nh1, .h1,\nh2, .h2,\nh3, .h3 {\n  margin-top: 20px;\n  margin-bottom: 10px; }\nh1 small,\n  h1 .small, .h1 small,\n  .h1 .small,\n  h2 small,\n  h2 .small, .h2 small,\n  .h2 .small,\n  h3 small,\n  h3 .small, .h3 small,\n  .h3 .small {\n    font-size: 65%; }\nh4, .h4,\nh5, .h5,\nh6, .h6 {\n  margin-top: 10px;\n  margin-bottom: 10px; }\nh4 small,\n  h4 .small, .h4 small,\n  .h4 .small,\n  h5 small,\n  h5 .small, .h5 small,\n  .h5 .small,\n  h6 small,\n  h6 .small, .h6 small,\n  .h6 .small {\n    font-size: 75%; }\nh1, .h1 {\n  font-size: 36px; }\nh2, .h2 {\n  font-size: 30px; }\nh3, .h3 {\n  font-size: 24px; }\nh4, .h4 {\n  font-size: 18px; }\nh5, .h5 {\n  font-size: 14px; }\nh6, .h6 {\n  font-size: 12px; }\np {\n  margin: 0 0 10px; }\n.lead {\n  margin-bottom: 20px;\n  font-size: 16px;\n  font-weight: 300;\n  line-height: 1.4; }\n@media (min-width: 768px) {\n    .lead {\n      font-size: 21px; } }\nsmall,\n.small {\n  font-size: 85%; }\nmark,\n.mark {\n  padding: .2em;\n  background-color: #fcf8e3; }\n.text-left {\n  text-align: left; }\n.text-right {\n  text-align: right; }\n.text-center {\n  text-align: center; }\n.text-justify {\n  text-align: justify; }\n.text-nowrap {\n  white-space: nowrap; }\n.text-lowercase {\n  text-transform: lowercase; }\n.text-uppercase, .initialism {\n  text-transform: uppercase; }\n.text-capitalize {\n  text-transform: capitalize; }\n.text-muted {\n  color: #777777; }\n.text-primary {\n  color: #337ab7; }\na.text-primary:hover,\na.text-primary:focus {\n  color: #286090; }\n.text-success {\n  color: #3c763d; }\na.text-success:hover,\na.text-success:focus {\n  color: #2b542c; }\n.text-info {\n  color: #31708f; }\na.text-info:hover,\na.text-info:focus {\n  color: #245269; }\n.text-warning {\n  color: #8a6d3b; }\na.text-warning:hover,\na.text-warning:focus {\n  color: #66512c; }\n.text-danger {\n  color: #a94442; }\na.text-danger:hover,\na.text-danger:focus {\n  color: #843534; }\n.bg-primary {\n  color: #fff; }\n.bg-primary {\n  background-color: #337ab7; }\na.bg-primary:hover,\na.bg-primary:focus {\n  background-color: #286090; }\n.bg-success {\n  background-color: #dff0d8; }\na.bg-success:hover,\na.bg-success:focus {\n  background-color: #c1e2b3; }\n.bg-info {\n  background-color: #d9edf7; }\na.bg-info:hover,\na.bg-info:focus {\n  background-color: #afd9ee; }\n.bg-warning {\n  background-color: #fcf8e3; }\na.bg-warning:hover,\na.bg-warning:focus {\n  background-color: #f7ecb5; }\n.bg-danger {\n  background-color: #f2dede; }\na.bg-danger:hover,\na.bg-danger:focus {\n  background-color: #e4b9b9; }\n.page-header {\n  padding-bottom: 9px;\n  margin: 40px 0 20px;\n  border-bottom: 1px solid #eeeeee; }\nul,\nol {\n  margin-top: 0;\n  margin-bottom: 10px; }\nul ul,\n  ul ol,\n  ol ul,\n  ol ol {\n    margin-bottom: 0; }\n.list-unstyled {\n  padding-left: 0;\n  list-style: none; }\n.list-inline {\n  padding-left: 0;\n  list-style: none;\n  margin-left: -5px; }\n.list-inline > li {\n    display: inline-block;\n    padding-right: 5px;\n    padding-left: 5px; }\ndl {\n  margin-top: 0;\n  margin-bottom: 20px; }\ndt,\ndd {\n  line-height: 1.42857; }\ndt {\n  font-weight: 700; }\ndd {\n  margin-left: 0; }\n.dl-horizontal dd:before, .dl-horizontal dd:after {\n  display: table;\n  content: \" \"; }\n.dl-horizontal dd:after {\n  clear: both; }\n@media (min-width: 768px) {\n  .dl-horizontal dt {\n    float: left;\n    width: 160px;\n    clear: left;\n    text-align: right;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap; }\n  .dl-horizontal dd {\n    margin-left: 180px; } }\nabbr[title],\nabbr[data-original-title] {\n  cursor: help; }\n.initialism {\n  font-size: 90%; }\nblockquote {\n  padding: 10px 20px;\n  margin: 0 0 20px;\n  font-size: 17.5px;\n  border-left: 5px solid #eeeeee; }\nblockquote p:last-child,\n  blockquote ul:last-child,\n  blockquote ol:last-child {\n    margin-bottom: 0; }\nblockquote footer,\n  blockquote small,\n  blockquote .small {\n    display: block;\n    font-size: 80%;\n    line-height: 1.42857;\n    color: #777777; }\nblockquote footer:before,\n    blockquote small:before,\n    blockquote .small:before {\n      content: \"\\2014   \\A0\"; }\n.blockquote-reverse,\nblockquote.pull-right {\n  padding-right: 15px;\n  padding-left: 0;\n  text-align: right;\n  border-right: 5px solid #eeeeee;\n  border-left: 0; }\n.blockquote-reverse footer:before,\n  .blockquote-reverse small:before,\n  .blockquote-reverse .small:before,\n  blockquote.pull-right footer:before,\n  blockquote.pull-right small:before,\n  blockquote.pull-right .small:before {\n    content: \"\"; }\n.blockquote-reverse footer:after,\n  .blockquote-reverse small:after,\n  .blockquote-reverse .small:after,\n  blockquote.pull-right footer:after,\n  blockquote.pull-right small:after,\n  blockquote.pull-right .small:after {\n    content: \"\\A0   \\2014\"; }\naddress {\n  margin-bottom: 20px;\n  font-style: normal;\n  line-height: 1.42857; }\ncode,\nkbd,\npre,\nsamp {\n  font-family: Menlo, Monaco, Consolas, \"Courier New\", monospace; }\ncode {\n  padding: 2px 4px;\n  font-size: 90%;\n  color: #c7254e;\n  background-color: #f9f2f4;\n  border-radius: 4px; }\nkbd {\n  padding: 2px 4px;\n  font-size: 90%;\n  color: #fff;\n  background-color: #333;\n  border-radius: 3px;\n  -webkit-box-shadow: inset 0 -1px 0 rgba(0, 0, 0, .25);\n          box-shadow: inset 0 -1px 0 rgba(0, 0, 0, .25); }\nkbd kbd {\n    padding: 0;\n    font-size: 100%;\n    font-weight: 700;\n    -webkit-box-shadow: none;\n            box-shadow: none; }\npre {\n  display: block;\n  padding: 9.5px;\n  margin: 0 0 10px;\n  font-size: 13px;\n  line-height: 1.42857;\n  color: #333333;\n  word-break: break-all;\n  word-wrap: break-word;\n  background-color: #f5f5f5;\n  border: 1px solid #ccc;\n  border-radius: 4px; }\npre code {\n    padding: 0;\n    font-size: inherit;\n    color: inherit;\n    white-space: pre-wrap;\n    background-color: transparent;\n    border-radius: 0; }\n.pre-scrollable {\n  max-height: 340px;\n  overflow-y: scroll; }\n.container {\n  padding-right: 15px;\n  padding-left: 15px;\n  margin-right: auto;\n  margin-left: auto; }\n.container:before, .container:after {\n    display: table;\n    content: \" \"; }\n.container:after {\n    clear: both; }\n@media (min-width: 768px) {\n    .container {\n      width: 750px; } }\n@media (min-width: 992px) {\n    .container {\n      width: 970px; } }\n@media (min-width: 1200px) {\n    .container {\n      width: 1170px; } }\n.container-fluid {\n  padding-right: 15px;\n  padding-left: 15px;\n  margin-right: auto;\n  margin-left: auto; }\n.container-fluid:before, .container-fluid:after {\n    display: table;\n    content: \" \"; }\n.container-fluid:after {\n    clear: both; }\n.row {\n  margin-right: -15px;\n  margin-left: -15px; }\n.row:before, .row:after {\n    display: table;\n    content: \" \"; }\n.row:after {\n    clear: both; }\n.row-no-gutters {\n  margin-right: 0;\n  margin-left: 0; }\n.row-no-gutters [class*=\"col-\"] {\n    padding-right: 0;\n    padding-left: 0; }\n.col-xs-1, .col-sm-1, .col-md-1, .col-lg-1, .col-xs-2, .col-sm-2, .col-md-2, .col-lg-2, .col-xs-3, .col-sm-3, .col-md-3, .col-lg-3, .col-xs-4, .col-sm-4, .col-md-4, .col-lg-4, .col-xs-5, .col-sm-5, .col-md-5, .col-lg-5, .col-xs-6, .col-sm-6, .col-md-6, .col-lg-6, .col-xs-7, .col-sm-7, .col-md-7, .col-lg-7, .col-xs-8, .col-sm-8, .col-md-8, .col-lg-8, .col-xs-9, .col-sm-9, .col-md-9, .col-lg-9, .col-xs-10, .col-sm-10, .col-md-10, .col-lg-10, .col-xs-11, .col-sm-11, .col-md-11, .col-lg-11, .col-xs-12, .col-sm-12, .col-md-12, .col-lg-12 {\n  position: relative;\n  min-height: 1px;\n  padding-right: 15px;\n  padding-left: 15px; }\n.col-xs-1, .col-xs-2, .col-xs-3, .col-xs-4, .col-xs-5, .col-xs-6, .col-xs-7, .col-xs-8, .col-xs-9, .col-xs-10, .col-xs-11, .col-xs-12 {\n  float: left; }\n.col-xs-1 {\n  width: 8.33333%; }\n.col-xs-2 {\n  width: 16.66667%; }\n.col-xs-3 {\n  width: 25%; }\n.col-xs-4 {\n  width: 33.33333%; }\n.col-xs-5 {\n  width: 41.66667%; }\n.col-xs-6 {\n  width: 50%; }\n.col-xs-7 {\n  width: 58.33333%; }\n.col-xs-8 {\n  width: 66.66667%; }\n.col-xs-9 {\n  width: 75%; }\n.col-xs-10 {\n  width: 83.33333%; }\n.col-xs-11 {\n  width: 91.66667%; }\n.col-xs-12 {\n  width: 100%; }\n.col-xs-pull-0 {\n  right: auto; }\n.col-xs-pull-1 {\n  right: 8.33333%; }\n.col-xs-pull-2 {\n  right: 16.66667%; }\n.col-xs-pull-3 {\n  right: 25%; }\n.col-xs-pull-4 {\n  right: 33.33333%; }\n.col-xs-pull-5 {\n  right: 41.66667%; }\n.col-xs-pull-6 {\n  right: 50%; }\n.col-xs-pull-7 {\n  right: 58.33333%; }\n.col-xs-pull-8 {\n  right: 66.66667%; }\n.col-xs-pull-9 {\n  right: 75%; }\n.col-xs-pull-10 {\n  right: 83.33333%; }\n.col-xs-pull-11 {\n  right: 91.66667%; }\n.col-xs-pull-12 {\n  right: 100%; }\n.col-xs-push-0 {\n  left: auto; }\n.col-xs-push-1 {\n  left: 8.33333%; }\n.col-xs-push-2 {\n  left: 16.66667%; }\n.col-xs-push-3 {\n  left: 25%; }\n.col-xs-push-4 {\n  left: 33.33333%; }\n.col-xs-push-5 {\n  left: 41.66667%; }\n.col-xs-push-6 {\n  left: 50%; }\n.col-xs-push-7 {\n  left: 58.33333%; }\n.col-xs-push-8 {\n  left: 66.66667%; }\n.col-xs-push-9 {\n  left: 75%; }\n.col-xs-push-10 {\n  left: 83.33333%; }\n.col-xs-push-11 {\n  left: 91.66667%; }\n.col-xs-push-12 {\n  left: 100%; }\n.col-xs-offset-0 {\n  margin-left: 0%; }\n.col-xs-offset-1 {\n  margin-left: 8.33333%; }\n.col-xs-offset-2 {\n  margin-left: 16.66667%; }\n.col-xs-offset-3 {\n  margin-left: 25%; }\n.col-xs-offset-4 {\n  margin-left: 33.33333%; }\n.col-xs-offset-5 {\n  margin-left: 41.66667%; }\n.col-xs-offset-6 {\n  margin-left: 50%; }\n.col-xs-offset-7 {\n  margin-left: 58.33333%; }\n.col-xs-offset-8 {\n  margin-left: 66.66667%; }\n.col-xs-offset-9 {\n  margin-left: 75%; }\n.col-xs-offset-10 {\n  margin-left: 83.33333%; }\n.col-xs-offset-11 {\n  margin-left: 91.66667%; }\n.col-xs-offset-12 {\n  margin-left: 100%; }\n@media (min-width: 768px) {\n  .col-sm-1, .col-sm-2, .col-sm-3, .col-sm-4, .col-sm-5, .col-sm-6, .col-sm-7, .col-sm-8, .col-sm-9, .col-sm-10, .col-sm-11, .col-sm-12 {\n    float: left; }\n  .col-sm-1 {\n    width: 8.33333%; }\n  .col-sm-2 {\n    width: 16.66667%; }\n  .col-sm-3 {\n    width: 25%; }\n  .col-sm-4 {\n    width: 33.33333%; }\n  .col-sm-5 {\n    width: 41.66667%; }\n  .col-sm-6 {\n    width: 50%; }\n  .col-sm-7 {\n    width: 58.33333%; }\n  .col-sm-8 {\n    width: 66.66667%; }\n  .col-sm-9 {\n    width: 75%; }\n  .col-sm-10 {\n    width: 83.33333%; }\n  .col-sm-11 {\n    width: 91.66667%; }\n  .col-sm-12 {\n    width: 100%; }\n  .col-sm-pull-0 {\n    right: auto; }\n  .col-sm-pull-1 {\n    right: 8.33333%; }\n  .col-sm-pull-2 {\n    right: 16.66667%; }\n  .col-sm-pull-3 {\n    right: 25%; }\n  .col-sm-pull-4 {\n    right: 33.33333%; }\n  .col-sm-pull-5 {\n    right: 41.66667%; }\n  .col-sm-pull-6 {\n    right: 50%; }\n  .col-sm-pull-7 {\n    right: 58.33333%; }\n  .col-sm-pull-8 {\n    right: 66.66667%; }\n  .col-sm-pull-9 {\n    right: 75%; }\n  .col-sm-pull-10 {\n    right: 83.33333%; }\n  .col-sm-pull-11 {\n    right: 91.66667%; }\n  .col-sm-pull-12 {\n    right: 100%; }\n  .col-sm-push-0 {\n    left: auto; }\n  .col-sm-push-1 {\n    left: 8.33333%; }\n  .col-sm-push-2 {\n    left: 16.66667%; }\n  .col-sm-push-3 {\n    left: 25%; }\n  .col-sm-push-4 {\n    left: 33.33333%; }\n  .col-sm-push-5 {\n    left: 41.66667%; }\n  .col-sm-push-6 {\n    left: 50%; }\n  .col-sm-push-7 {\n    left: 58.33333%; }\n  .col-sm-push-8 {\n    left: 66.66667%; }\n  .col-sm-push-9 {\n    left: 75%; }\n  .col-sm-push-10 {\n    left: 83.33333%; }\n  .col-sm-push-11 {\n    left: 91.66667%; }\n  .col-sm-push-12 {\n    left: 100%; }\n  .col-sm-offset-0 {\n    margin-left: 0%; }\n  .col-sm-offset-1 {\n    margin-left: 8.33333%; }\n  .col-sm-offset-2 {\n    margin-left: 16.66667%; }\n  .col-sm-offset-3 {\n    margin-left: 25%; }\n  .col-sm-offset-4 {\n    margin-left: 33.33333%; }\n  .col-sm-offset-5 {\n    margin-left: 41.66667%; }\n  .col-sm-offset-6 {\n    margin-left: 50%; }\n  .col-sm-offset-7 {\n    margin-left: 58.33333%; }\n  .col-sm-offset-8 {\n    margin-left: 66.66667%; }\n  .col-sm-offset-9 {\n    margin-left: 75%; }\n  .col-sm-offset-10 {\n    margin-left: 83.33333%; }\n  .col-sm-offset-11 {\n    margin-left: 91.66667%; }\n  .col-sm-offset-12 {\n    margin-left: 100%; } }\n@media (min-width: 992px) {\n  .col-md-1, .col-md-2, .col-md-3, .col-md-4, .col-md-5, .col-md-6, .col-md-7, .col-md-8, .col-md-9, .col-md-10, .col-md-11, .col-md-12 {\n    float: left; }\n  .col-md-1 {\n    width: 8.33333%; }\n  .col-md-2 {\n    width: 16.66667%; }\n  .col-md-3 {\n    width: 25%; }\n  .col-md-4 {\n    width: 33.33333%; }\n  .col-md-5 {\n    width: 41.66667%; }\n  .col-md-6 {\n    width: 50%; }\n  .col-md-7 {\n    width: 58.33333%; }\n  .col-md-8 {\n    width: 66.66667%; }\n  .col-md-9 {\n    width: 75%; }\n  .col-md-10 {\n    width: 83.33333%; }\n  .col-md-11 {\n    width: 91.66667%; }\n  .col-md-12 {\n    width: 100%; }\n  .col-md-pull-0 {\n    right: auto; }\n  .col-md-pull-1 {\n    right: 8.33333%; }\n  .col-md-pull-2 {\n    right: 16.66667%; }\n  .col-md-pull-3 {\n    right: 25%; }\n  .col-md-pull-4 {\n    right: 33.33333%; }\n  .col-md-pull-5 {\n    right: 41.66667%; }\n  .col-md-pull-6 {\n    right: 50%; }\n  .col-md-pull-7 {\n    right: 58.33333%; }\n  .col-md-pull-8 {\n    right: 66.66667%; }\n  .col-md-pull-9 {\n    right: 75%; }\n  .col-md-pull-10 {\n    right: 83.33333%; }\n  .col-md-pull-11 {\n    right: 91.66667%; }\n  .col-md-pull-12 {\n    right: 100%; }\n  .col-md-push-0 {\n    left: auto; }\n  .col-md-push-1 {\n    left: 8.33333%; }\n  .col-md-push-2 {\n    left: 16.66667%; }\n  .col-md-push-3 {\n    left: 25%; }\n  .col-md-push-4 {\n    left: 33.33333%; }\n  .col-md-push-5 {\n    left: 41.66667%; }\n  .col-md-push-6 {\n    left: 50%; }\n  .col-md-push-7 {\n    left: 58.33333%; }\n  .col-md-push-8 {\n    left: 66.66667%; }\n  .col-md-push-9 {\n    left: 75%; }\n  .col-md-push-10 {\n    left: 83.33333%; }\n  .col-md-push-11 {\n    left: 91.66667%; }\n  .col-md-push-12 {\n    left: 100%; }\n  .col-md-offset-0 {\n    margin-left: 0%; }\n  .col-md-offset-1 {\n    margin-left: 8.33333%; }\n  .col-md-offset-2 {\n    margin-left: 16.66667%; }\n  .col-md-offset-3 {\n    margin-left: 25%; }\n  .col-md-offset-4 {\n    margin-left: 33.33333%; }\n  .col-md-offset-5 {\n    margin-left: 41.66667%; }\n  .col-md-offset-6 {\n    margin-left: 50%; }\n  .col-md-offset-7 {\n    margin-left: 58.33333%; }\n  .col-md-offset-8 {\n    margin-left: 66.66667%; }\n  .col-md-offset-9 {\n    margin-left: 75%; }\n  .col-md-offset-10 {\n    margin-left: 83.33333%; }\n  .col-md-offset-11 {\n    margin-left: 91.66667%; }\n  .col-md-offset-12 {\n    margin-left: 100%; } }\n@media (min-width: 1200px) {\n  .col-lg-1, .col-lg-2, .col-lg-3, .col-lg-4, .col-lg-5, .col-lg-6, .col-lg-7, .col-lg-8, .col-lg-9, .col-lg-10, .col-lg-11, .col-lg-12 {\n    float: left; }\n  .col-lg-1 {\n    width: 8.33333%; }\n  .col-lg-2 {\n    width: 16.66667%; }\n  .col-lg-3 {\n    width: 25%; }\n  .col-lg-4 {\n    width: 33.33333%; }\n  .col-lg-5 {\n    width: 41.66667%; }\n  .col-lg-6 {\n    width: 50%; }\n  .col-lg-7 {\n    width: 58.33333%; }\n  .col-lg-8 {\n    width: 66.66667%; }\n  .col-lg-9 {\n    width: 75%; }\n  .col-lg-10 {\n    width: 83.33333%; }\n  .col-lg-11 {\n    width: 91.66667%; }\n  .col-lg-12 {\n    width: 100%; }\n  .col-lg-pull-0 {\n    right: auto; }\n  .col-lg-pull-1 {\n    right: 8.33333%; }\n  .col-lg-pull-2 {\n    right: 16.66667%; }\n  .col-lg-pull-3 {\n    right: 25%; }\n  .col-lg-pull-4 {\n    right: 33.33333%; }\n  .col-lg-pull-5 {\n    right: 41.66667%; }\n  .col-lg-pull-6 {\n    right: 50%; }\n  .col-lg-pull-7 {\n    right: 58.33333%; }\n  .col-lg-pull-8 {\n    right: 66.66667%; }\n  .col-lg-pull-9 {\n    right: 75%; }\n  .col-lg-pull-10 {\n    right: 83.33333%; }\n  .col-lg-pull-11 {\n    right: 91.66667%; }\n  .col-lg-pull-12 {\n    right: 100%; }\n  .col-lg-push-0 {\n    left: auto; }\n  .col-lg-push-1 {\n    left: 8.33333%; }\n  .col-lg-push-2 {\n    left: 16.66667%; }\n  .col-lg-push-3 {\n    left: 25%; }\n  .col-lg-push-4 {\n    left: 33.33333%; }\n  .col-lg-push-5 {\n    left: 41.66667%; }\n  .col-lg-push-6 {\n    left: 50%; }\n  .col-lg-push-7 {\n    left: 58.33333%; }\n  .col-lg-push-8 {\n    left: 66.66667%; }\n  .col-lg-push-9 {\n    left: 75%; }\n  .col-lg-push-10 {\n    left: 83.33333%; }\n  .col-lg-push-11 {\n    left: 91.66667%; }\n  .col-lg-push-12 {\n    left: 100%; }\n  .col-lg-offset-0 {\n    margin-left: 0%; }\n  .col-lg-offset-1 {\n    margin-left: 8.33333%; }\n  .col-lg-offset-2 {\n    margin-left: 16.66667%; }\n  .col-lg-offset-3 {\n    margin-left: 25%; }\n  .col-lg-offset-4 {\n    margin-left: 33.33333%; }\n  .col-lg-offset-5 {\n    margin-left: 41.66667%; }\n  .col-lg-offset-6 {\n    margin-left: 50%; }\n  .col-lg-offset-7 {\n    margin-left: 58.33333%; }\n  .col-lg-offset-8 {\n    margin-left: 66.66667%; }\n  .col-lg-offset-9 {\n    margin-left: 75%; }\n  .col-lg-offset-10 {\n    margin-left: 83.33333%; }\n  .col-lg-offset-11 {\n    margin-left: 91.66667%; }\n  .col-lg-offset-12 {\n    margin-left: 100%; } }\ntable {\n  background-color: transparent; }\ntable col[class*=\"col-\"] {\n    position: static;\n    display: table-column;\n    float: none; }\ntable td[class*=\"col-\"],\n  table th[class*=\"col-\"] {\n    position: static;\n    display: table-cell;\n    float: none; }\ncaption {\n  padding-top: 8px;\n  padding-bottom: 8px;\n  color: #777777;\n  text-align: left; }\nth {\n  text-align: left; }\n.table {\n  width: 100%;\n  max-width: 100%;\n  margin-bottom: 20px; }\n.table > thead > tr > th,\n  .table > thead > tr > td,\n  .table > tbody > tr > th,\n  .table > tbody > tr > td,\n  .table > tfoot > tr > th,\n  .table > tfoot > tr > td {\n    padding: 8px;\n    line-height: 1.42857;\n    vertical-align: top;\n    border-top: 1px solid #ddd; }\n.table > thead > tr > th {\n    vertical-align: bottom;\n    border-bottom: 2px solid #ddd; }\n.table > caption + thead > tr:first-child > th,\n  .table > caption + thead > tr:first-child > td,\n  .table > colgroup + thead > tr:first-child > th,\n  .table > colgroup + thead > tr:first-child > td,\n  .table > thead:first-child > tr:first-child > th,\n  .table > thead:first-child > tr:first-child > td {\n    border-top: 0; }\n.table > tbody + tbody {\n    border-top: 2px solid #ddd; }\n.table .table {\n    background-color: #fff; }\n.table-condensed > thead > tr > th,\n.table-condensed > thead > tr > td,\n.table-condensed > tbody > tr > th,\n.table-condensed > tbody > tr > td,\n.table-condensed > tfoot > tr > th,\n.table-condensed > tfoot > tr > td {\n  padding: 5px; }\n.table-bordered {\n  border: 1px solid #ddd; }\n.table-bordered > thead > tr > th,\n  .table-bordered > thead > tr > td,\n  .table-bordered > tbody > tr > th,\n  .table-bordered > tbody > tr > td,\n  .table-bordered > tfoot > tr > th,\n  .table-bordered > tfoot > tr > td {\n    border: 1px solid #ddd; }\n.table-bordered > thead > tr > th,\n  .table-bordered > thead > tr > td {\n    border-bottom-width: 2px; }\n.table-striped > tbody > tr:nth-of-type(odd) {\n  background-color: #f9f9f9; }\n.table-hover > tbody > tr:hover {\n  background-color: #f5f5f5; }\n.table > thead > tr > td.active,\n.table > thead > tr > th.active,\n.table > thead > tr.active > td,\n.table > thead > tr.active > th,\n.table > tbody > tr > td.active,\n.table > tbody > tr > th.active,\n.table > tbody > tr.active > td,\n.table > tbody > tr.active > th,\n.table > tfoot > tr > td.active,\n.table > tfoot > tr > th.active,\n.table > tfoot > tr.active > td,\n.table > tfoot > tr.active > th {\n  background-color: #f5f5f5; }\n.table-hover > tbody > tr > td.active:hover,\n.table-hover > tbody > tr > th.active:hover,\n.table-hover > tbody > tr.active:hover > td,\n.table-hover > tbody > tr:hover > .active,\n.table-hover > tbody > tr.active:hover > th {\n  background-color: #e8e8e8; }\n.table > thead > tr > td.success,\n.table > thead > tr > th.success,\n.table > thead > tr.success > td,\n.table > thead > tr.success > th,\n.table > tbody > tr > td.success,\n.table > tbody > tr > th.success,\n.table > tbody > tr.success > td,\n.table > tbody > tr.success > th,\n.table > tfoot > tr > td.success,\n.table > tfoot > tr > th.success,\n.table > tfoot > tr.success > td,\n.table > tfoot > tr.success > th {\n  background-color: #dff0d8; }\n.table-hover > tbody > tr > td.success:hover,\n.table-hover > tbody > tr > th.success:hover,\n.table-hover > tbody > tr.success:hover > td,\n.table-hover > tbody > tr:hover > .success,\n.table-hover > tbody > tr.success:hover > th {\n  background-color: #d0e9c6; }\n.table > thead > tr > td.info,\n.table > thead > tr > th.info,\n.table > thead > tr.info > td,\n.table > thead > tr.info > th,\n.table > tbody > tr > td.info,\n.table > tbody > tr > th.info,\n.table > tbody > tr.info > td,\n.table > tbody > tr.info > th,\n.table > tfoot > tr > td.info,\n.table > tfoot > tr > th.info,\n.table > tfoot > tr.info > td,\n.table > tfoot > tr.info > th {\n  background-color: #d9edf7; }\n.table-hover > tbody > tr > td.info:hover,\n.table-hover > tbody > tr > th.info:hover,\n.table-hover > tbody > tr.info:hover > td,\n.table-hover > tbody > tr:hover > .info,\n.table-hover > tbody > tr.info:hover > th {\n  background-color: #c4e3f3; }\n.table > thead > tr > td.warning,\n.table > thead > tr > th.warning,\n.table > thead > tr.warning > td,\n.table > thead > tr.warning > th,\n.table > tbody > tr > td.warning,\n.table > tbody > tr > th.warning,\n.table > tbody > tr.warning > td,\n.table > tbody > tr.warning > th,\n.table > tfoot > tr > td.warning,\n.table > tfoot > tr > th.warning,\n.table > tfoot > tr.warning > td,\n.table > tfoot > tr.warning > th {\n  background-color: #fcf8e3; }\n.table-hover > tbody > tr > td.warning:hover,\n.table-hover > tbody > tr > th.warning:hover,\n.table-hover > tbody > tr.warning:hover > td,\n.table-hover > tbody > tr:hover > .warning,\n.table-hover > tbody > tr.warning:hover > th {\n  background-color: #faf2cc; }\n.table > thead > tr > td.danger,\n.table > thead > tr > th.danger,\n.table > thead > tr.danger > td,\n.table > thead > tr.danger > th,\n.table > tbody > tr > td.danger,\n.table > tbody > tr > th.danger,\n.table > tbody > tr.danger > td,\n.table > tbody > tr.danger > th,\n.table > tfoot > tr > td.danger,\n.table > tfoot > tr > th.danger,\n.table > tfoot > tr.danger > td,\n.table > tfoot > tr.danger > th {\n  background-color: #f2dede; }\n.table-hover > tbody > tr > td.danger:hover,\n.table-hover > tbody > tr > th.danger:hover,\n.table-hover > tbody > tr.danger:hover > td,\n.table-hover > tbody > tr:hover > .danger,\n.table-hover > tbody > tr.danger:hover > th {\n  background-color: #ebcccc; }\n.table-responsive {\n  min-height: .01%;\n  overflow-x: auto; }\n@media screen and (max-width: 767px) {\n    .table-responsive {\n      width: 100%;\n      margin-bottom: 15px;\n      overflow-y: hidden;\n      -ms-overflow-style: -ms-autohiding-scrollbar;\n      border: 1px solid #ddd; }\n      .table-responsive > .table {\n        margin-bottom: 0; }\n        .table-responsive > .table > thead > tr > th,\n        .table-responsive > .table > thead > tr > td,\n        .table-responsive > .table > tbody > tr > th,\n        .table-responsive > .table > tbody > tr > td,\n        .table-responsive > .table > tfoot > tr > th,\n        .table-responsive > .table > tfoot > tr > td {\n          white-space: nowrap; }\n      .table-responsive > .table-bordered {\n        border: 0; }\n        .table-responsive > .table-bordered > thead > tr > th:first-child,\n        .table-responsive > .table-bordered > thead > tr > td:first-child,\n        .table-responsive > .table-bordered > tbody > tr > th:first-child,\n        .table-responsive > .table-bordered > tbody > tr > td:first-child,\n        .table-responsive > .table-bordered > tfoot > tr > th:first-child,\n        .table-responsive > .table-bordered > tfoot > tr > td:first-child {\n          border-left: 0; }\n        .table-responsive > .table-bordered > thead > tr > th:last-child,\n        .table-responsive > .table-bordered > thead > tr > td:last-child,\n        .table-responsive > .table-bordered > tbody > tr > th:last-child,\n        .table-responsive > .table-bordered > tbody > tr > td:last-child,\n        .table-responsive > .table-bordered > tfoot > tr > th:last-child,\n        .table-responsive > .table-bordered > tfoot > tr > td:last-child {\n          border-right: 0; }\n        .table-responsive > .table-bordered > tbody > tr:last-child > th,\n        .table-responsive > .table-bordered > tbody > tr:last-child > td,\n        .table-responsive > .table-bordered > tfoot > tr:last-child > th,\n        .table-responsive > .table-bordered > tfoot > tr:last-child > td {\n          border-bottom: 0; } }\nfieldset {\n  min-width: 0;\n  padding: 0;\n  margin: 0;\n  border: 0; }\nlegend {\n  display: block;\n  width: 100%;\n  padding: 0;\n  margin-bottom: 20px;\n  font-size: 21px;\n  line-height: inherit;\n  color: #333333;\n  border: 0;\n  border-bottom: 1px solid #e5e5e5; }\nlabel {\n  display: inline-block;\n  max-width: 100%;\n  margin-bottom: 5px;\n  font-weight: 700; }\ninput[type=\"search\"] {\n  -webkit-box-sizing: border-box;\n  box-sizing: border-box;\n  -webkit-appearance: none;\n  -moz-appearance: none;\n       appearance: none; }\ninput[type=\"radio\"],\ninput[type=\"checkbox\"] {\n  margin: 4px 0 0;\n  margin-top: 1px \\9;\n  line-height: normal; }\ninput[type=\"radio\"][disabled], input[type=\"radio\"].disabled,\n  fieldset[disabled] input[type=\"radio\"],\n  input[type=\"checkbox\"][disabled],\n  input[type=\"checkbox\"].disabled,\n  fieldset[disabled]\n  input[type=\"checkbox\"] {\n    cursor: not-allowed; }\ninput[type=\"file\"] {\n  display: block; }\ninput[type=\"range\"] {\n  display: block;\n  width: 100%; }\nselect[multiple],\nselect[size] {\n  height: auto; }\ninput[type=\"file\"]:focus,\ninput[type=\"radio\"]:focus,\ninput[type=\"checkbox\"]:focus {\n  outline: 5px auto -webkit-focus-ring-color;\n  outline-offset: -2px; }\noutput {\n  display: block;\n  padding-top: 7px;\n  font-size: 14px;\n  line-height: 1.42857;\n  color: #8b8b8b; }\n.form-control {\n  display: block;\n  width: 100%;\n  height: 34px;\n  padding: 6px 12px;\n  font-size: 14px;\n  line-height: 1.42857;\n  color: #8b8b8b;\n  background-color: #fff;\n  background-image: none;\n  border: 1px solid #ccc;\n  border-radius: 4px;\n  -webkit-box-shadow: inset 0 1px 1px rgba(0, 0, 0, .075);\n  box-shadow: inset 0 1px 1px rgba(0, 0, 0, .075);\n  -webkit-transition: border-color ease-in-out 0.15s, box-shadow ease-in-out 0.15s;\n  -webkit-transition: border-color ease-in-out 0.15s, -webkit-box-shadow ease-in-out 0.15s;\n  transition: border-color ease-in-out 0.15s, -webkit-box-shadow ease-in-out 0.15s;\n  transition: border-color ease-in-out 0.15s, box-shadow ease-in-out 0.15s;\n  transition: border-color ease-in-out 0.15s, box-shadow ease-in-out 0.15s, -webkit-box-shadow ease-in-out 0.15s; }\n.form-control:focus {\n    border-color: #66afe9;\n    outline: 0;\n    -webkit-box-shadow: inset 0 1px 1px rgba(0, 0, 0, .075), 0 0 8px rgba(102, 175, 233, .6);\n    box-shadow: inset 0 1px 1px rgba(0, 0, 0, .075), 0 0 8px rgba(102, 175, 233, .6); }\n.form-control::-moz-placeholder {\n    color: #999;\n    opacity: 1; }\n.form-control:-ms-input-placeholder {\n    color: #999; }\n.form-control::-webkit-input-placeholder {\n    color: #999; }\n.form-control::-ms-expand {\n    background-color: transparent;\n    border: 0; }\n.form-control[disabled], .form-control[readonly],\n  fieldset[disabled] .form-control {\n    background-color: #eeeeee;\n    opacity: 1; }\n.form-control[disabled],\n  fieldset[disabled] .form-control {\n    cursor: not-allowed; }\ntextarea.form-control {\n  height: auto; }\n@media screen and (-webkit-min-device-pixel-ratio: 0) {\n  input[type=\"date\"].form-control,\n  input[type=\"time\"].form-control,\n  input[type=\"datetime-local\"].form-control,\n  input[type=\"month\"].form-control {\n    line-height: 34px; }\n  input[type=\"date\"].input-sm,\n  .input-group-sm input[type=\"date\"],\n  input[type=\"time\"].input-sm,\n  .input-group-sm\n  input[type=\"time\"],\n  input[type=\"datetime-local\"].input-sm,\n  .input-group-sm\n  input[type=\"datetime-local\"],\n  input[type=\"month\"].input-sm,\n  .input-group-sm\n  input[type=\"month\"] {\n    line-height: 30px; }\n  input[type=\"date\"].input-lg,\n  .input-group-lg input[type=\"date\"],\n  input[type=\"time\"].input-lg,\n  .input-group-lg\n  input[type=\"time\"],\n  input[type=\"datetime-local\"].input-lg,\n  .input-group-lg\n  input[type=\"datetime-local\"],\n  input[type=\"month\"].input-lg,\n  .input-group-lg\n  input[type=\"month\"] {\n    line-height: 46px; } }\n.form-group {\n  margin-bottom: 15px; }\n.radio,\n.checkbox {\n  position: relative;\n  display: block;\n  margin-top: 10px;\n  margin-bottom: 10px; }\n.radio.disabled label,\n  fieldset[disabled] .radio label,\n  .checkbox.disabled label,\n  fieldset[disabled]\n  .checkbox label {\n    cursor: not-allowed; }\n.radio label,\n  .checkbox label {\n    min-height: 20px;\n    padding-left: 20px;\n    margin-bottom: 0;\n    font-weight: 400;\n    cursor: pointer; }\n.radio input[type=\"radio\"],\n.radio-inline input[type=\"radio\"],\n.checkbox input[type=\"checkbox\"],\n.checkbox-inline input[type=\"checkbox\"] {\n  position: absolute;\n  margin-top: 4px \\9;\n  margin-left: -20px; }\n.radio + .radio,\n.checkbox + .checkbox {\n  margin-top: -5px; }\n.radio-inline,\n.checkbox-inline {\n  position: relative;\n  display: inline-block;\n  padding-left: 20px;\n  margin-bottom: 0;\n  font-weight: 400;\n  vertical-align: middle;\n  cursor: pointer; }\n.radio-inline.disabled,\n  fieldset[disabled] .radio-inline,\n  .checkbox-inline.disabled,\n  fieldset[disabled]\n  .checkbox-inline {\n    cursor: not-allowed; }\n.radio-inline + .radio-inline,\n.checkbox-inline + .checkbox-inline {\n  margin-top: 0;\n  margin-left: 10px; }\n.form-control-static {\n  min-height: 34px;\n  padding-top: 7px;\n  padding-bottom: 7px;\n  margin-bottom: 0; }\n.form-control-static.input-lg, .form-control-static.input-sm {\n    padding-right: 0;\n    padding-left: 0; }\n.input-sm {\n  height: 30px;\n  padding: 5px 10px;\n  font-size: 12px;\n  line-height: 1.5;\n  border-radius: 3px; }\nselect.input-sm {\n  height: 30px;\n  line-height: 30px; }\ntextarea.input-sm,\nselect[multiple].input-sm {\n  height: auto; }\n.form-group-sm .form-control {\n  height: 30px;\n  padding: 5px 10px;\n  font-size: 12px;\n  line-height: 1.5;\n  border-radius: 3px; }\n.form-group-sm select.form-control {\n  height: 30px;\n  line-height: 30px; }\n.form-group-sm textarea.form-control,\n.form-group-sm select[multiple].form-control {\n  height: auto; }\n.form-group-sm .form-control-static {\n  height: 30px;\n  min-height: 32px;\n  padding: 6px 10px;\n  font-size: 12px;\n  line-height: 1.5; }\n.input-lg {\n  height: 46px;\n  padding: 10px 16px;\n  font-size: 18px;\n  line-height: 1.33333;\n  border-radius: 6px; }\nselect.input-lg {\n  height: 46px;\n  line-height: 46px; }\ntextarea.input-lg,\nselect[multiple].input-lg {\n  height: auto; }\n.form-group-lg .form-control {\n  height: 46px;\n  padding: 10px 16px;\n  font-size: 18px;\n  line-height: 1.33333;\n  border-radius: 6px; }\n.form-group-lg select.form-control {\n  height: 46px;\n  line-height: 46px; }\n.form-group-lg textarea.form-control,\n.form-group-lg select[multiple].form-control {\n  height: auto; }\n.form-group-lg .form-control-static {\n  height: 46px;\n  min-height: 38px;\n  padding: 11px 16px;\n  font-size: 18px;\n  line-height: 1.33333; }\n.has-feedback {\n  position: relative; }\n.has-feedback .form-control {\n    padding-right: 42.5px; }\n.form-control-feedback {\n  position: absolute;\n  top: 0;\n  right: 0;\n  z-index: 2;\n  display: block;\n  width: 34px;\n  height: 34px;\n  line-height: 34px;\n  text-align: center;\n  pointer-events: none; }\n.input-lg + .form-control-feedback,\n.input-group-lg + .form-control-feedback,\n.form-group-lg .form-control + .form-control-feedback {\n  width: 46px;\n  height: 46px;\n  line-height: 46px; }\n.input-sm + .form-control-feedback,\n.input-group-sm + .form-control-feedback,\n.form-group-sm .form-control + .form-control-feedback {\n  width: 30px;\n  height: 30px;\n  line-height: 30px; }\n.has-success .help-block,\n.has-success .control-label,\n.has-success .radio,\n.has-success .checkbox,\n.has-success .radio-inline,\n.has-success .checkbox-inline,\n.has-success.radio label,\n.has-success.checkbox label,\n.has-success.radio-inline label,\n.has-success.checkbox-inline label {\n  color: #3c763d; }\n.has-success .form-control {\n  border-color: #3c763d;\n  -webkit-box-shadow: inset 0 1px 1px rgba(0, 0, 0, .075);\n  box-shadow: inset 0 1px 1px rgba(0, 0, 0, .075); }\n.has-success .form-control:focus {\n    border-color: #2b542c;\n    -webkit-box-shadow: inset 0 1px 1px rgba(0, 0, 0, .075), 0 0 6px #67b168;\n    box-shadow: inset 0 1px 1px rgba(0, 0, 0, .075), 0 0 6px #67b168; }\n.has-success .input-group-addon {\n  color: #3c763d;\n  background-color: #dff0d8;\n  border-color: #3c763d; }\n.has-success .form-control-feedback {\n  color: #3c763d; }\n.has-warning .help-block,\n.has-warning .control-label,\n.has-warning .radio,\n.has-warning .checkbox,\n.has-warning .radio-inline,\n.has-warning .checkbox-inline,\n.has-warning.radio label,\n.has-warning.checkbox label,\n.has-warning.radio-inline label,\n.has-warning.checkbox-inline label {\n  color: #8a6d3b; }\n.has-warning .form-control {\n  border-color: #8a6d3b;\n  -webkit-box-shadow: inset 0 1px 1px rgba(0, 0, 0, .075);\n  box-shadow: inset 0 1px 1px rgba(0, 0, 0, .075); }\n.has-warning .form-control:focus {\n    border-color: #66512c;\n    -webkit-box-shadow: inset 0 1px 1px rgba(0, 0, 0, .075), 0 0 6px #c0a16b;\n    box-shadow: inset 0 1px 1px rgba(0, 0, 0, .075), 0 0 6px #c0a16b; }\n.has-warning .input-group-addon {\n  color: #8a6d3b;\n  background-color: #fcf8e3;\n  border-color: #8a6d3b; }\n.has-warning .form-control-feedback {\n  color: #8a6d3b; }\n.has-error .help-block,\n.has-error .control-label,\n.has-error .radio,\n.has-error .checkbox,\n.has-error .radio-inline,\n.has-error .checkbox-inline,\n.has-error.radio label,\n.has-error.checkbox label,\n.has-error.radio-inline label,\n.has-error.checkbox-inline label {\n  color: #a94442; }\n.has-error .form-control {\n  border-color: #a94442;\n  -webkit-box-shadow: inset 0 1px 1px rgba(0, 0, 0, .075);\n  box-shadow: inset 0 1px 1px rgba(0, 0, 0, .075); }\n.has-error .form-control:focus {\n    border-color: #843534;\n    -webkit-box-shadow: inset 0 1px 1px rgba(0, 0, 0, .075), 0 0 6px #ce8483;\n    box-shadow: inset 0 1px 1px rgba(0, 0, 0, .075), 0 0 6px #ce8483; }\n.has-error .input-group-addon {\n  color: #a94442;\n  background-color: #f2dede;\n  border-color: #a94442; }\n.has-error .form-control-feedback {\n  color: #a94442; }\n.has-feedback label ~ .form-control-feedback {\n  top: 25px; }\n.has-feedback label.sr-only ~ .form-control-feedback {\n  top: 0; }\n.help-block {\n  display: block;\n  margin-top: 5px;\n  margin-bottom: 10px;\n  color: #737373; }\n@media (min-width: 768px) {\n  .form-inline .form-group {\n    display: inline-block;\n    margin-bottom: 0;\n    vertical-align: middle; }\n  .form-inline .form-control {\n    display: inline-block;\n    width: auto;\n    vertical-align: middle; }\n  .form-inline .form-control-static {\n    display: inline-block; }\n  .form-inline .input-group {\n    display: inline-table;\n    vertical-align: middle; }\n    .form-inline .input-group .input-group-addon,\n    .form-inline .input-group .input-group-btn,\n    .form-inline .input-group .form-control {\n      width: auto; }\n  .form-inline .input-group > .form-control {\n    width: 100%; }\n  .form-inline .control-label {\n    margin-bottom: 0;\n    vertical-align: middle; }\n  .form-inline .radio,\n  .form-inline .checkbox {\n    display: inline-block;\n    margin-top: 0;\n    margin-bottom: 0;\n    vertical-align: middle; }\n    .form-inline .radio label,\n    .form-inline .checkbox label {\n      padding-left: 0; }\n  .form-inline .radio input[type=\"radio\"],\n  .form-inline .checkbox input[type=\"checkbox\"] {\n    position: relative;\n    margin-left: 0; }\n  .form-inline .has-feedback .form-control-feedback {\n    top: 0; } }\n.form-horizontal .radio,\n.form-horizontal .checkbox,\n.form-horizontal .radio-inline,\n.form-horizontal .checkbox-inline {\n  padding-top: 7px;\n  margin-top: 0;\n  margin-bottom: 0; }\n.form-horizontal .radio,\n.form-horizontal .checkbox {\n  min-height: 27px; }\n.form-horizontal .form-group {\n  margin-right: -15px;\n  margin-left: -15px; }\n.form-horizontal .form-group:before, .form-horizontal .form-group:after {\n    display: table;\n    content: \" \"; }\n.form-horizontal .form-group:after {\n    clear: both; }\n@media (min-width: 768px) {\n  .form-horizontal .control-label {\n    padding-top: 7px;\n    margin-bottom: 0;\n    text-align: right; } }\n.form-horizontal .has-feedback .form-control-feedback {\n  right: 15px; }\n@media (min-width: 768px) {\n  .form-horizontal .form-group-lg .control-label {\n    padding-top: 11px;\n    font-size: 18px; } }\n@media (min-width: 768px) {\n  .form-horizontal .form-group-sm .control-label {\n    padding-top: 6px;\n    font-size: 12px; } }\n.btn {\n  display: inline-block;\n  margin-bottom: 0;\n  font-weight: normal;\n  text-align: center;\n  white-space: nowrap;\n  vertical-align: middle;\n  -ms-touch-action: manipulation;\n      touch-action: manipulation;\n  cursor: pointer;\n  background-image: none;\n  border: 1px solid transparent;\n  padding: 6px 12px;\n  font-size: 14px;\n  line-height: 1.42857;\n  border-radius: 4px;\n  -webkit-user-select: none;\n  -moz-user-select: none;\n  -ms-user-select: none;\n  user-select: none; }\n.btn:focus, .btn.focus, .btn:active:focus, .btn:active.focus, .btn.active:focus, .btn.active.focus {\n    outline: 5px auto -webkit-focus-ring-color;\n    outline-offset: -2px; }\n.btn:hover, .btn:focus, .btn.focus {\n    color: #333;\n    text-decoration: none; }\n.btn:active, .btn.active {\n    background-image: none;\n    outline: 0;\n    -webkit-box-shadow: inset 0 3px 5px rgba(0, 0, 0, .125);\n    box-shadow: inset 0 3px 5px rgba(0, 0, 0, .125); }\n.btn.disabled, .btn[disabled],\n  fieldset[disabled] .btn {\n    cursor: not-allowed;\n    filter: alpha(opacity=65);\n    opacity: 0.65;\n    -webkit-box-shadow: none;\n    box-shadow: none; }\na.btn.disabled,\nfieldset[disabled] a.btn {\n  pointer-events: none; }\n.btn-default {\n  color: #333;\n  background-color: #fff;\n  border-color: #ccc; }\n.btn-default:focus, .btn-default.focus {\n    color: #333;\n    background-color: #e6e6e6;\n    border-color: #8c8c8c; }\n.btn-default:hover {\n    color: #333;\n    background-color: #e6e6e6;\n    border-color: #adadad; }\n.btn-default:active, .btn-default.active,\n  .open > .btn-default.dropdown-toggle {\n    color: #333;\n    background-color: #e6e6e6;\n    background-image: none;\n    border-color: #adadad; }\n.btn-default:active:hover, .btn-default:active:focus, .btn-default:active.focus, .btn-default.active:hover, .btn-default.active:focus, .btn-default.active.focus,\n    .open > .btn-default.dropdown-toggle:hover,\n    .open > .btn-default.dropdown-toggle:focus,\n    .open > .btn-default.dropdown-toggle.focus {\n      color: #333;\n      background-color: #d4d4d4;\n      border-color: #8c8c8c; }\n.btn-default.disabled:hover, .btn-default.disabled:focus, .btn-default.disabled.focus, .btn-default[disabled]:hover, .btn-default[disabled]:focus, .btn-default[disabled].focus,\n  fieldset[disabled] .btn-default:hover,\n  fieldset[disabled] .btn-default:focus,\n  fieldset[disabled] .btn-default.focus {\n    background-color: #fff;\n    border-color: #ccc; }\n.btn-default .badge {\n    color: #fff;\n    background-color: #333; }\n.btn-primary {\n  color: #fff;\n  background-color: #337ab7;\n  border-color: #2e6da4; }\n.btn-primary:focus, .btn-primary.focus {\n    color: #fff;\n    background-color: #286090;\n    border-color: #122b40; }\n.btn-primary:hover {\n    color: #fff;\n    background-color: #286090;\n    border-color: #204d74; }\n.btn-primary:active, .btn-primary.active,\n  .open > .btn-primary.dropdown-toggle {\n    color: #fff;\n    background-color: #286090;\n    background-image: none;\n    border-color: #204d74; }\n.btn-primary:active:hover, .btn-primary:active:focus, .btn-primary:active.focus, .btn-primary.active:hover, .btn-primary.active:focus, .btn-primary.active.focus,\n    .open > .btn-primary.dropdown-toggle:hover,\n    .open > .btn-primary.dropdown-toggle:focus,\n    .open > .btn-primary.dropdown-toggle.focus {\n      color: #fff;\n      background-color: #204d74;\n      border-color: #122b40; }\n.btn-primary.disabled:hover, .btn-primary.disabled:focus, .btn-primary.disabled.focus, .btn-primary[disabled]:hover, .btn-primary[disabled]:focus, .btn-primary[disabled].focus,\n  fieldset[disabled] .btn-primary:hover,\n  fieldset[disabled] .btn-primary:focus,\n  fieldset[disabled] .btn-primary.focus {\n    background-color: #337ab7;\n    border-color: #2e6da4; }\n.btn-primary .badge {\n    color: #337ab7;\n    background-color: #fff; }\n.btn-success {\n  color: #fff;\n  background-color: #5cb85c;\n  border-color: #4cae4c; }\n.btn-success:focus, .btn-success.focus {\n    color: #fff;\n    background-color: #449d44;\n    border-color: #255625; }\n.btn-success:hover {\n    color: #fff;\n    background-color: #449d44;\n    border-color: #398439; }\n.btn-success:active, .btn-success.active,\n  .open > .btn-success.dropdown-toggle {\n    color: #fff;\n    background-color: #449d44;\n    background-image: none;\n    border-color: #398439; }\n.btn-success:active:hover, .btn-success:active:focus, .btn-success:active.focus, .btn-success.active:hover, .btn-success.active:focus, .btn-success.active.focus,\n    .open > .btn-success.dropdown-toggle:hover,\n    .open > .btn-success.dropdown-toggle:focus,\n    .open > .btn-success.dropdown-toggle.focus {\n      color: #fff;\n      background-color: #398439;\n      border-color: #255625; }\n.btn-success.disabled:hover, .btn-success.disabled:focus, .btn-success.disabled.focus, .btn-success[disabled]:hover, .btn-success[disabled]:focus, .btn-success[disabled].focus,\n  fieldset[disabled] .btn-success:hover,\n  fieldset[disabled] .btn-success:focus,\n  fieldset[disabled] .btn-success.focus {\n    background-color: #5cb85c;\n    border-color: #4cae4c; }\n.btn-success .badge {\n    color: #5cb85c;\n    background-color: #fff; }\n.btn-info {\n  color: #fff;\n  background-color: #5bc0de;\n  border-color: #46b8da; }\n.btn-info:focus, .btn-info.focus {\n    color: #fff;\n    background-color: #31b0d5;\n    border-color: #1b6d85; }\n.btn-info:hover {\n    color: #fff;\n    background-color: #31b0d5;\n    border-color: #269abc; }\n.btn-info:active, .btn-info.active,\n  .open > .btn-info.dropdown-toggle {\n    color: #fff;\n    background-color: #31b0d5;\n    background-image: none;\n    border-color: #269abc; }\n.btn-info:active:hover, .btn-info:active:focus, .btn-info:active.focus, .btn-info.active:hover, .btn-info.active:focus, .btn-info.active.focus,\n    .open > .btn-info.dropdown-toggle:hover,\n    .open > .btn-info.dropdown-toggle:focus,\n    .open > .btn-info.dropdown-toggle.focus {\n      color: #fff;\n      background-color: #269abc;\n      border-color: #1b6d85; }\n.btn-info.disabled:hover, .btn-info.disabled:focus, .btn-info.disabled.focus, .btn-info[disabled]:hover, .btn-info[disabled]:focus, .btn-info[disabled].focus,\n  fieldset[disabled] .btn-info:hover,\n  fieldset[disabled] .btn-info:focus,\n  fieldset[disabled] .btn-info.focus {\n    background-color: #5bc0de;\n    border-color: #46b8da; }\n.btn-info .badge {\n    color: #5bc0de;\n    background-color: #fff; }\n.btn-warning {\n  color: #fff;\n  background-color: #f0ad4e;\n  border-color: #eea236; }\n.btn-warning:focus, .btn-warning.focus {\n    color: #fff;\n    background-color: #ec971f;\n    border-color: #985f0d; }\n.btn-warning:hover {\n    color: #fff;\n    background-color: #ec971f;\n    border-color: #d58512; }\n.btn-warning:active, .btn-warning.active,\n  .open > .btn-warning.dropdown-toggle {\n    color: #fff;\n    background-color: #ec971f;\n    background-image: none;\n    border-color: #d58512; }\n.btn-warning:active:hover, .btn-warning:active:focus, .btn-warning:active.focus, .btn-warning.active:hover, .btn-warning.active:focus, .btn-warning.active.focus,\n    .open > .btn-warning.dropdown-toggle:hover,\n    .open > .btn-warning.dropdown-toggle:focus,\n    .open > .btn-warning.dropdown-toggle.focus {\n      color: #fff;\n      background-color: #d58512;\n      border-color: #985f0d; }\n.btn-warning.disabled:hover, .btn-warning.disabled:focus, .btn-warning.disabled.focus, .btn-warning[disabled]:hover, .btn-warning[disabled]:focus, .btn-warning[disabled].focus,\n  fieldset[disabled] .btn-warning:hover,\n  fieldset[disabled] .btn-warning:focus,\n  fieldset[disabled] .btn-warning.focus {\n    background-color: #f0ad4e;\n    border-color: #eea236; }\n.btn-warning .badge {\n    color: #f0ad4e;\n    background-color: #fff; }\n.btn-danger {\n  color: #fff;\n  background-color: #d9534f;\n  border-color: #d43f3a; }\n.btn-danger:focus, .btn-danger.focus {\n    color: #fff;\n    background-color: #c9302c;\n    border-color: #761c19; }\n.btn-danger:hover {\n    color: #fff;\n    background-color: #c9302c;\n    border-color: #ac2925; }\n.btn-danger:active, .btn-danger.active,\n  .open > .btn-danger.dropdown-toggle {\n    color: #fff;\n    background-color: #c9302c;\n    background-image: none;\n    border-color: #ac2925; }\n.btn-danger:active:hover, .btn-danger:active:focus, .btn-danger:active.focus, .btn-danger.active:hover, .btn-danger.active:focus, .btn-danger.active.focus,\n    .open > .btn-danger.dropdown-toggle:hover,\n    .open > .btn-danger.dropdown-toggle:focus,\n    .open > .btn-danger.dropdown-toggle.focus {\n      color: #fff;\n      background-color: #ac2925;\n      border-color: #761c19; }\n.btn-danger.disabled:hover, .btn-danger.disabled:focus, .btn-danger.disabled.focus, .btn-danger[disabled]:hover, .btn-danger[disabled]:focus, .btn-danger[disabled].focus,\n  fieldset[disabled] .btn-danger:hover,\n  fieldset[disabled] .btn-danger:focus,\n  fieldset[disabled] .btn-danger.focus {\n    background-color: #d9534f;\n    border-color: #d43f3a; }\n.btn-danger .badge {\n    color: #d9534f;\n    background-color: #fff; }\n.btn-link {\n  font-weight: 400;\n  color: #337ab7;\n  border-radius: 0; }\n.btn-link, .btn-link:active, .btn-link.active, .btn-link[disabled],\n  fieldset[disabled] .btn-link {\n    background-color: transparent;\n    -webkit-box-shadow: none;\n    box-shadow: none; }\n.btn-link, .btn-link:hover, .btn-link:focus, .btn-link:active {\n    border-color: transparent; }\n.btn-link:hover, .btn-link:focus {\n    color: #23527c;\n    text-decoration: underline;\n    background-color: transparent; }\n.btn-link[disabled]:hover, .btn-link[disabled]:focus,\n  fieldset[disabled] .btn-link:hover,\n  fieldset[disabled] .btn-link:focus {\n    color: #777777;\n    text-decoration: none; }\n.btn-lg {\n  padding: 10px 16px;\n  font-size: 18px;\n  line-height: 1.33333;\n  border-radius: 6px; }\n.btn-sm {\n  padding: 5px 10px;\n  font-size: 12px;\n  line-height: 1.5;\n  border-radius: 3px; }\n.btn-xs {\n  padding: 1px 5px;\n  font-size: 12px;\n  line-height: 1.5;\n  border-radius: 3px; }\n.btn-block {\n  display: block;\n  width: 100%; }\n.btn-block + .btn-block {\n  margin-top: 5px; }\ninput[type=\"submit\"].btn-block,\ninput[type=\"reset\"].btn-block,\ninput[type=\"button\"].btn-block {\n  width: 100%; }\n@font-face {\n  font-family: 'Poppins';\n  src: url(\"//west.cdn.mathletics.com/html/fonts/Poppins/Poppins_400.ttf\") format(\"truetype\"); }\n@font-face {\n  font-family: 'icomoon';\n  src: url(" + __webpack_require__(449) + ");\n  src: url(" + __webpack_require__(449) + "#iefix) format(\"embedded-opentype\"), url(" + __webpack_require__(1278) + ") format(\"truetype\"), url(" + __webpack_require__(1279) + ") format(\"woff\"), url(" + __webpack_require__(1280) + "#icomoon) format(\"svg\");\n  font-weight: normal;\n  font-style: normal; }\n[class^=\"icon-\"], [class*=\" icon-\"] {\n  /* use !important to prevent issues with browser extensions that change fonts */\n  font-family: 'icomoon' !important;\n  speak: none;\n  font-style: normal;\n  font-weight: normal;\n  -webkit-font-feature-settings: normal;\n          font-feature-settings: normal;\n  font-variant: normal;\n  text-transform: none;\n  line-height: 1;\n  /* Better Font Rendering =========== */\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale; }\n.icon-icon_checkbox-checked:before {\n  content: \"\\E900\"; }\n.icon-icon_checkbox-unchecked:before {\n  content: \"\\E901\"; }\n.icon-icon_sort1:before {\n  content: \"\\E902\";\n  color: #788189; }\n.icon-icon_sort:before {\n  content: \"\\E903\";\n  color: #788189; }\nhtml,\nbody,\n.application {\n  height: 100%;\n  background-color: #e7e9ea;\n  font-family: Poppins, sans-serif; }\n.version-number {\n  position: fixed;\n  bottom: 0;\n  right: 5px;\n  z-index: 999;\n  font-size: 8px; }\n@media print {\n  .version-number {\n    display: none !important; } }\n", ""]);

// exports


/***/ }),
/* 1221 */,
/* 1222 */,
/* 1223 */,
/* 1224 */,
/* 1225 */,
/* 1226 */,
/* 1227 */,
/* 1228 */,
/* 1229 */,
/* 1230 */,
/* 1231 */,
/* 1232 */,
/* 1233 */,
/* 1234 */,
/* 1235 */,
/* 1236 */,
/* 1237 */,
/* 1238 */,
/* 1239 */,
/* 1240 */,
/* 1241 */,
/* 1242 */,
/* 1243 */,
/* 1244 */,
/* 1245 */,
/* 1246 */,
/* 1247 */,
/* 1248 */,
/* 1249 */,
/* 1250 */,
/* 1251 */,
/* 1252 */,
/* 1253 */,
/* 1254 */,
/* 1255 */,
/* 1256 */,
/* 1257 */,
/* 1258 */,
/* 1259 */,
/* 1260 */,
/* 1261 */,
/* 1262 */,
/* 1263 */,
/* 1264 */,
/* 1265 */,
/* 1266 */,
/* 1267 */,
/* 1268 */,
/* 1269 */,
/* 1270 */,
/* 1271 */,
/* 1272 */,
/* 1273 */,
/* 1274 */,
/* 1275 */,
/* 1276 */,
/* 1277 */,
/* 1278 */
/***/ (function(module, exports) {

module.exports = "https://cdn-shared.mathletics.com/teacher-modules/school-roll/393/assets/fonts/5309dec468cc53cee3b01e43c8e8d65d.ttf";

/***/ }),
/* 1279 */
/***/ (function(module, exports) {

module.exports = "https://cdn-shared.mathletics.com/teacher-modules/school-roll/393/assets/fonts/1247229c1fbc30482f89ce0992d25f61.woff";

/***/ }),
/* 1280 */
/***/ (function(module, exports) {

module.exports = "https://cdn-shared.mathletics.com/teacher-modules/school-roll/393/assets/fonts/6ebd8f1b9b5b41876ab1be2a1ee5a84d.svg";

/***/ }),
/* 1281 */,
/* 1282 */,
/* 1283 */,
/* 1284 */,
/* 1285 */,
/* 1286 */,
/* 1287 */,
/* 1288 */,
/* 1289 */,
/* 1290 */,
/* 1291 */,
/* 1292 */,
/* 1293 */,
/* 1294 */,
/* 1295 */,
/* 1296 */,
/* 1297 */,
/* 1298 */,
/* 1299 */,
/* 1300 */,
/* 1301 */,
/* 1302 */,
/* 1303 */,
/* 1304 */,
/* 1305 */,
/* 1306 */,
/* 1307 */,
/* 1308 */,
/* 1309 */,
/* 1310 */,
/* 1311 */,
/* 1312 */,
/* 1313 */,
/* 1314 */,
/* 1315 */
/***/ (function(module, exports) {

module.exports = {"app.components.AddClass.add":"Add","app.components.AddClass.addClass":"Add a {productName} class","app.components.AddClass.addClassConfirmation":"has been created","app.components.AddClass.cancel":"Cancel","app.components.AddClass.className":"Class name","app.components.AddClass.classNameLabel":"Class Name","app.components.AddClass.country":"Country","app.components.AddClass.countryDropdownLabel":"Select a country","app.components.AddClass.courseDropdownLabel":"Select a course","app.components.AddClass.courses":"Courses (Activity Mastery)","app.components.AddClass.coursesNonMaths":"Courses","app.components.AddClass.curriculumCourses":"Curriculum based courses","app.components.AddClass.customCourses":"Custom school courses","app.components.AddClass.done":"Done","app.components.AddClass.grade":"Grade","app.components.AddClass.loadingCourses":"Loading...","app.components.AddClass.mathsClass":"maths class","app.components.AddClass.newCourses":"New Courses","app.components.AddClass.noCourses":"No courses found","app.components.AddClass.noCoursesFound":"No courses found","app.components.AddClass.noTeacherDropdownLabel":"No teachers found","app.components.AddClass.none":"None","app.components.AddClass.required":"Required selection","app.components.AddClass.schoolCourses":"School courses","app.components.AddClass.select":"select","app.components.AddClass.selectDefaultCourse":"Select default course","app.components.AddClass.skillQuests":"Skill Quests","app.components.AddClass.teacher":"Teacher","app.components.AddClass.teacherDropdownLabel":"Select a {product} teacher","app.components.AddClass.useAdminSelection":"Use Admin selection","app.components.AddClass.yearDropdownLabel":"Years","app.components.AddGroup.changeCourse":"Change course","app.components.AddGroup.createdAssigned":"created and assigned to","app.components.AddGroup.done":"Done","app.components.AddGroup.inputPlaceholder":"Enter the name of the new group","app.components.AddGroup.manageStudent":"Manage student","app.components.AddGroup.maxGroupErrorLongDesc":"You are allowed with a maximum of 12 groups per class, please delete a group to proceed.","app.components.AddGroup.maxGroupErrorTitle":"This group cannot be created.","app.components.AddGroup.okBtn":"Ok","app.components.AddGroup.title":"Enter the name of the new group","app.components.AddStudent.addStudent":"Add student","app.components.AddStudent.classroomList":"Select a {0} class","app.components.AddStudent.firstName":"First name","app.components.AddStudent.groupLabel":"All groups","app.components.AddStudent.previousUsername":"Previous Username","app.components.AddStudent.surname":"Surname","app.components.AddTeacher.classroomList":"Select a {0} class","app.components.AddTeacher.emailAddress":"Email Address","app.components.AddTeacher.firstName":"First name","app.components.AddTeacher.inviteTeacher":"Invite teacher","app.components.AddTeacher.surname":"Surname","app.components.AddTeacher.title":"Title","app.components.Assign.allYears":"All years","app.components.AssignUser.assignedClasses":"Assigned classes for","app.components.AssignUser.assignedEmptyState":"No classes assigned","app.components.AssignUser.assignedTeachers":"Assigned teachers for","app.components.AssignUser.assignedTo":"assigned to","app.components.AssignUser.available":"Available","app.components.AssignUser.cancel":"Cancel","app.components.AssignUser.classes":"Classes","app.components.AssignUser.save":"Save","app.components.AssignUser.teacherEmptyState":"No teachers found","app.components.AssignUser.teachers":"Teachers","app.components.AssignUser.unassignedEmptyState":"No classes found","app.components.AssignedTeacher.assignTeacher":"Assign Teacher(s)","app.components.AssignedTeacher.assignedTeachers":"Assigned teachers","app.components.AssignedTeacherList.downloadCards":"Download sign-in card","app.components.AssignedTeacherList.downloading":"downloading","app.components.AssignedTeacherList.loseAccessToProducts":"and will lose all access to their licenced products","app.components.AssignedTeacherList.selectedTeacherWillBe":"The selected teacher(s) will be removed from the school roll.","app.components.AssignedTeacherList.teachers":"TEACHERS","app.components.AssignedTeacherList.teachersUnassigned":"Teachers have been unassigned","app.components.AssignedTeacherList.unassignTeachers":"Unassign teachers","app.components.AssignedTeacherList.unassigned":"unassigned","app.components.ClassDetails.classDetails":"Class details","app.components.ClassDetails.className":"CLASS NAME","app.components.ClassDetails.students":"STUDENTS","app.components.ClassDetails.year":"YEAR","app.components.ClassroomGroupList.activities":"ACTIVITIES","app.components.ClassroomGroupList.courses":"COURSES","app.components.ClassroomGroupList.createGroup":"Create group","app.components.ClassroomGroupList.downloadCards":"Download sign-in cards","app.components.ClassroomGroupList.downloading":"downloading","app.components.ClassroomGroupList.group":"GROUP","app.components.ClassroomGroupList.newCourses":"NEW COURSES","app.components.ClassroomGroupList.noCourseAssigned":"No course assigned","app.components.ClassroomGroupList.noCourseFound":"No course found","app.components.ClassroomGroupList.noVoluntaryCourseSet":"No voluntary course set","app.components.ClassroomGroupList.optedOut":"Opted out","app.components.ClassroomGroupList.skillQuests":"SKILL QUESTS","app.components.ClassroomGroupList.students":"STUDENTS","app.components.DefaultCourseMapper.currentDefaultCourse":"CURRENT DEFAULT COURSE","app.components.DefaultCourseMapper.newDefaultCourse":"NEW DEFAULT COURSE","app.components.DefaultCourseMapper.year":"YEAR","app.components.DefaultCourseMapperAdmin.assignToGroup":"Assign to year","app.components.DefaultCourseMapperAdmin.cancel":"Cancel","app.components.DefaultCourseMapperAdmin.changesWillNotTake":"changes will not take effect until your next scheduled rollover.","app.components.DefaultCourseMapperAdmin.courses":"Courses","app.components.DefaultCourseMapperAdmin.coursesActivityMastery":"Courses (Activity Mastery)","app.components.DefaultCourseMapperAdmin.defaultCourse":"DEFAULT COURSE","app.components.DefaultCourseMapperAdmin.dontTellMeAgain":"Don't tell me again","app.components.DefaultCourseMapperAdmin.iUnderstand":"I understand","app.components.DefaultCourseMapperAdmin.learningModule":"LEARNING MODULE","app.components.DefaultCourseMapperAdmin.newCourses":"New Courses","app.components.DefaultCourseMapperAdmin.newDefaultCourse":"NEW DEFAULT COURSE","app.components.DefaultCourseMapperAdmin.noUPFCourseSet":"No course found","app.components.DefaultCourseMapperAdmin.noVoluntaryCourseSet":"No voluntary course set","app.components.DefaultCourseMapperAdmin.optedOut":"Opted out","app.components.DefaultCourseMapperAdmin.queue":"Queue","app.components.DefaultCourseMapperAdmin.queuedForRollover":"Queued for Rollover","app.components.DefaultCourseMapperAdmin.skillQuests":"Skill Quests","app.components.DefaultCourseMapperAdmin.unconfirmed":"(Confirm by selecting queue)","app.components.DefaultCourseMapperAdmin.unsavedChanges":"Unsaved changes","app.components.DefaultCourseMapperAdmin.whileYouMightSee":"While you might see your selection displayed under","app.components.DefaultCourseMapperAdmin.year":"YEAR","app.components.DefaultCourseMapperAdmin.youMayChangeYour":"You may change your selection at any point prior to rollover.","app.components.EditClassForm.AreYouSureYouWantToDelete":"Are you sure you want to delete","app.components.EditClassForm.cancel":"Cancel","app.components.EditClassForm.changeCourse":"Change course","app.components.EditClassForm.close":"Close","app.components.EditClassForm.delete":"Delete group","app.components.EditClassForm.deleteNonEmptyGroupConfirmation":"must be empty before it can be deleted.","app.components.EditClassForm.deleting":"Deleting","app.components.EditClassForm.doYouWishTo":"Do you wish to rename the group","app.components.EditClassForm.hasBeenDeleted":", has been deleted.","app.components.EditClassForm.manageStudents":"Manage students","app.components.EditClassForm.pleaseGoTo":"Please go to","app.components.EditClassForm.questionMark":"?","app.components.EditClassForm.renameGroup":"Rename group","app.components.EditClassForm.save":"Save","app.components.EditClassForm.to":"to","app.components.EditClassForm.toMoveYourStudents":"to move your students.","app.components.EditClassForm.yourGroup":"Your group,","app.components.EditClassGroup.AreYouSureYouWantToDelete":"Are you sure you want to delete","app.components.EditClassGroup.changeCourse":"Change course","app.components.EditClassGroup.close":"Close","app.components.EditClassGroup.delete":"Delete group","app.components.EditClassGroup.deleteNonEmptyGroupConfirmation":"must be empty before it can be deleted.","app.components.EditClassGroup.deleting":"Deleting","app.components.EditClassGroup.doYouWishTo":"Do you wish to rename the group","app.components.EditClassGroup.hasBeenDeleted":", has been deleted.","app.components.EditClassGroup.manageStudents":"Manage students","app.components.EditClassGroup.pleaseGoTo":"Please go to","app.components.EditClassGroup.questionMark":"?","app.components.EditClassGroup.renameGroup":"Rename group","app.components.EditClassGroup.to":"to","app.components.EditClassGroup.toMoveYourStudents":"to move your students.","app.components.EditClassGroup.yourGroup":"Your group,","app.components.EditStudent.cancel":"Cancel","app.components.EditStudent.save":"Save","app.components.EditStudent.yearGroupList":"Year","app.components.EditTeacher.cancel":"Cancel","app.components.EditTeacher.emailRequiredMessage":"Email is required","app.components.EditTeacher.emailValidationMessage":"Invalid email","app.components.EditTeacher.passwordValidationMessage1":"New password does not meet stated rules","app.components.EditTeacher.passwordValidationMessage2":"Ensure teacher passwords match","app.components.EditTeacher.passwordValidationMessage3":"Please enter admin password","app.components.EditTeacher.passwordValidationMessage4":"Password cannot be blank","app.components.EditTeacher.save":"Save","app.components.EditTeacher.teachertTitle.none":"None","app.components.EditTeacher.teachertTitle.none.key":"none","app.components.ExtendResultTable.keepResultsHeader":"Keep results","app.components.ExtendResultTable.levelHeader":"Level","app.components.ExtendResultTable.startFreshHeader":"Start fresh","app.components.FileUploader.browse":"Browse...","app.components.FileUploader.fileUpload":"Upload file:","app.components.FileUploader.upload":"Upload","app.components.MoveCopyStudentConfirmation.cancel":"Cancel","app.components.MoveCopyStudentConfirmation.copy":"copy","app.components.MoveCopyStudentConfirmation.copyMessage":"the student(s) will be in both the original and the new class","app.components.MoveCopyStudentConfirmation.headerEndText":"the selected student(s)?","app.components.MoveCopyStudentConfirmation.headerStartText":"Do you want to","app.components.MoveCopyStudentConfirmation.move":"move","app.components.MoveCopyStudentConfirmation.moveMessage":"the student(s) will move from their current class(es) to the new class","app.components.MoveCopyStudentConfirmation.or":"or","app.components.RenameGroup.doYouWishTo":"Do you wish to rename the group","app.components.RenameGroup.groupNameLabel":"Group Name","app.components.RenameGroup.questionMark":"?","app.components.RenameGroup.renameGroup":"Rename your group","app.components.RenameGroup.renameGroupConfirmation":"Your group has been renamed.","app.components.RenameGroup.to":"to","app.components.SendEmailResult.emailAlreadyVerified":"email address already verified","app.components.SendEmailResult.emailNotSent":"email not sent","app.components.SendEmailResult.emailSent":"email successfully sent","app.components.SendEmailResult.emailsAlreadyVerified":"email addresses already verified","app.components.SendEmailResult.emailsNotSent":"emails not sent","app.components.SendEmailResult.emailsSent":"emails successfully sent","app.components.SendEmailResult.notValidOrDuplicate":"not valid or duplicate email","app.components.SendEmailResult.ok":"Ok","app.components.SendEmailResult.sendEmails":"Send verification emails","app.components.SendEmailResult.tryAgain":"Please try again later.","app.components.SendEmailResult.unableToSend":"Unable to send email at this time.","app.components.StudentClassDetail.assignClasses":"Assign Class(es)","app.components.StudentClassDetail.classDetails":"Class details","app.components.StudentClassList.class":"CLASS","app.components.StudentClassList.course":"COURSE","app.components.StudentClassList.group":"GROUP","app.components.StudentClassList.mayLoseAccessToProducts":"and may lose access to the current product.","app.components.StudentClassList.selectedStudentWillBe":"The selected student will be","app.components.StudentClassList.studentsUnassigned":"Student have been unassigned","app.components.StudentClassList.teacher":"TEACHER","app.components.StudentClassList.unassignStudents":"Unassign Student","app.components.StudentClassList.unassignedClassList":"unassigned","app.components.StudentClassList.year":"YEAR","app.components.StudentConfirmation.addAnotherStuent":"Add another student","app.components.StudentConfirmation.done":"Done","app.components.StudentConfirmation.header":"downloading...","app.components.StudentConfirmation.printSignInCard":"Print sign-in card","app.components.StudentCountFormatter.assignStudents":"Assign students","app.components.StudentDetails.downSignInCard":"Download sign-in card","app.components.StudentDetails.firstname":"FIRST NAME","app.components.StudentDetails.header":"This is the StudentDetails component !","app.components.StudentDetails.lastname":"SURNAME","app.components.StudentDetails.password":"PASSWORD","app.components.StudentDetails.studentDetails":"Student details","app.components.StudentDetails.username":"USERNAME","app.components.StudentDetails.warning":"Username and password is used across all resources","app.components.StudentDetails.year":"YEAR","app.components.Summary.ViewSummary":"View summary","app.components.Summary.back":"Back","app.components.Summary.header":"Ok","app.components.Summary.print":"Print","app.components.TeacherClassDetail.assignClasses":"Assign Class(es)","app.components.TeacherClassDetail.classDetails":"Class details","app.components.TeacherClassList.class":"CLASS","app.components.TeacherClassList.course":"COURSE","app.components.TeacherClassList.downloadSignInCard":"Download sign-in cards","app.components.TeacherClassList.group":"GROUP","app.components.TeacherClassList.loseAccessToProducts":"and will lose all access to their licenced products","app.components.TeacherClassList.selectedTeacherWillBe":"The selected teacher will be","app.components.TeacherClassList.teacher":"TEACHER","app.components.TeacherClassList.teachersUnassigned":"Teacher have been unassigned","app.components.TeacherClassList.unassignTeachers":"Unassign Teacher","app.components.TeacherClassList.unassigned":"unassigned","app.components.TeacherClassList.year":"YEAR","app.components.TeacherConfirmation.addAnotherTeacher":"Add another teacher","app.components.TeacherConfirmation.done":"Done","app.components.TeacherConfirmation.header":"downloading...","app.components.TeacherConfirmation.ok":"OK","app.components.TeacherConfirmation.printSignInCard":"Print sign-in card","app.components.TeacherDetails.adminPassword":"ADMIN PASSWORD","app.components.TeacherDetails.emailUnverified":"Email unverified","app.components.TeacherDetails.emailaddress":"EMAIL","app.components.TeacherDetails.firstname":"FIRST NAME","app.components.TeacherDetails.header":"This is the TeacherDetails component !","app.components.TeacherDetails.lastname":"SURNAME","app.components.TeacherDetails.newTeacherPassword":"NEW TEACHER PASSWORD","app.components.TeacherDetails.password":"PASSWORD","app.components.TeacherDetails.passwordWarning":"Please ensure the new teacher password is at least 8 characters long and contains both letters and numbers","app.components.TeacherDetails.repeatTeacherPassword":"CONFIRM TEACHER PASSWORD","app.components.TeacherDetails.resetTeacherPassword":"Reset teacher password","app.components.TeacherDetails.teacherDetails":"Teacher details","app.components.TeacherDetails.teacherPasswordLink":"Send teacher password link","app.components.TeacherDetails.teacherVerifyEmailLink":"Send verify email link","app.components.TeacherDetails.title":"TITLE","app.components.TeacherDetails.username":"USERNAME","app.components.TeacherDetails.warning":"Username and password is used across all resources","app.components.Toast.header":"This is the Toast component !","app.components.UploadValidationConfirmation.ok":"Ok","app.components.UserDelete.continueDelete":"Do you wish to delete the selected student(s) from school roll?","app.components.assignCourseMapper.assignedCourse":"ASSIGNED COURSE","app.components.assignCourseMapper.class":"CLASS","app.components.assignCourseMapper.group":"GROUP","app.components.assignCourseMapper.year":"YEAR","app.components.assignedClassesGroups.assignClass":"Assign Class","app.components.assignedTeacherInfo.assignTeacher":"Assign teacher","app.components.bulkPasswordChange.newPassword":"Enter New Password","app.components.changeCourse.activityUpdated":"{length} {length, plural, one {activity} other {activities}} carried across.","app.components.changeCourse.assignedTo":"has been assigned to","app.components.changeCourse.backLabel":"Back","app.components.changeCourse.confirmLabel":"Is this correct?","app.components.changeCourse.confirmWithActivitiesHeader":"You currently have {length} {length, plural, one {activity} other {activities}} assigned","app.components.changeCourse.confirmWithActivitiesSubHeader":"'Would you like to carry these over?'","app.components.changeCourse.countryLabel":"Country","app.components.changeCourse.courseLabel":"Course","app.components.changeCourse.curriculumCourses":"Curriculum based courses","app.components.changeCourse.customCourses":"Custom school courses","app.components.changeCourse.gradeLabel":"Grade","app.components.changeCourse.newCourses":"New Courses","app.components.changeCourse.noCoursesFound":"No courses found","app.components.changeCourse.noLabel":"No","app.components.changeCourse.none":"None","app.components.changeCourse.schoolCourses":"School courses","app.components.changeCourse.selectCountry":"Select country","app.components.changeCourse.selectCourse":"Select course","app.components.changeCourse.selectGrade":"Select grade","app.components.changeCourse.selectNewCourse":"Select New Course","app.components.changeCourse.selectSkillQuests":"Select Skill Quests","app.components.changeCourse.skillQuests":"Skill Quests","app.components.changeCourse.subTitle":"is currently set to","app.components.changeCourse.useAdminSelection":"Use Admin selection","app.components.changeCourse.yesLabel":"Yes","app.components.classCourses.activities":"Activities","app.components.classCourses.multipleCourses":"Multiple courses","app.components.classCourses.newCourses":"New Courses","app.components.classCourses.noCourseAssigned":"No course assigned","app.components.classCourses.noCoursesFound":"No course found","app.components.classCourses.noVoluntaryCourseSet":"No voluntary course set","app.components.classCourses.optedOut":"Opted out","app.components.classCourses.skillQuests":"Skill Quests","app.components.classFilter.allTeachers":"All teachers","app.components.classFilter.allYears":"All years","app.components.classFilter.clear":"clear","app.components.classRoll.allTeachers":"All teachers","app.components.classRoll.allYears":"All years","app.components.classRoll.class":"CLASS","app.components.classRoll.classes":"CLASSES","app.components.classRoll.course":"COURSE","app.components.classRoll.edit":"EDIT","app.components.classRoll.learningModules":"LEARNING MODULES","app.components.classRoll.noClassesAvailable":"No classes available.","app.components.classRoll.resource":"RESOURCE","app.components.classRoll.students":"STUDENTS","app.components.classRoll.teacher":"TEACHER","app.components.classRoll.year":"YEAR","app.components.components.uploading":"uploading","app.components.confirmationModal.doYouWishToContinue":"Do you wish to continue?","app.components.courseTopicsDetails.activitiesFileLabel":"ACTIVITIES","app.components.courseTopicsDetails.activitiesLabel":"Activities","app.components.courseTopicsDetails.areYouReadyLabel":"Are you ready?","app.components.courseTopicsDetails.authorLabel":"Author","app.components.courseTopicsDetails.countryLabel":"Country","app.components.courseTopicsDetails.easierActivitiesFileLabel":"SOMETHING EASIER ACTIVITIES","app.components.courseTopicsDetails.exportLabel":"Export","app.components.courseTopicsDetails.gradeLabel":"Grade","app.components.courseTopicsDetails.ok":"Ok","app.components.courseTopicsDetails.testLabel":"Test","app.components.courseTopicsDetails.topicFileLabel":"TOPIC","app.components.courseTopicsDetails.topicLabel":"Topics","app.components.datePicker.customDate":"Custom date","app.components.datePicker.lastWeek":"Last week","app.components.datePicker.thisSchoolYear":"This school year","app.components.datePicker.thisWeek":"This week","app.components.reAuthenticate.continue":"Continue","app.components.reAuthenticate.pageTitle":"Reauthenticate by entering admin password below","app.components.reAuthenticate.password":"Password","app.components.studentFilter.UnassignedStudent":"Unassigned students","app.components.studentFilter.allSurnames":"All surnames","app.components.studentFilter.allYears":"All years","app.components.studentFilter.clear":"clear","app.components.studentFilter.defaultOptionStudentClass":"All classes","app.components.studentFilter.defaultOptionStudentLastName":"All surnames","app.components.studentFilter.defaultOptionStudentYearGroup":"All years","app.components.studentRoll.addStudentConfirmation":"Student added","app.components.studentRoll.allClasses":"All classes","app.components.studentRoll.allSurnames":"All surnames","app.components.studentRoll.allYears":"All years","app.components.studentRoll.assignedStudents":"Assigned students","app.components.studentRoll.classes":"CLASSES","app.components.studentRoll.edit":"EDIT","app.components.studentRoll.firstName":"FIRST NAME","app.components.studentRoll.groups":"GROUPS","app.components.studentRoll.noStudentsAvailable":"No students available","app.components.studentRoll.password":"PASSWORD","app.components.studentRoll.surname":"SURNAME","app.components.studentRoll.teachers":"TEACHERS","app.components.studentRoll.unassignedStudents":"Unassigned students","app.components.studentRoll.username":"USERNAME","app.components.studentRoll.year":"YEAR","app.components.studentRoll.yearGroupList":"Select a year","app.components.studentUnAssign.doYouWishToContinue":"Do you wish to continue?","app.components.studentUnAssign.download":"download","app.components.studentUnAssign.downloading":"downloading","app.components.studentUnAssign.f2x5":"2x5 label","app.components.studentUnAssign.f2x7":"2x7 label","app.components.studentUnAssign.f3x8":"3x8 label","app.components.studentUnAssign.header":"Please select format for sign in cards","app.components.studentUnAssign.qr2x2":"QR codes 2x2","app.components.studentUnAssign.qr3x3":"QR codes 3x3","app.components.teacher-view.launch":"Launch","app.components.teacher-view.selectTeacher":"Select teacher","app.components.teacher-view.teacherView":"Teacher view","app.components.teacher-view.teacherView.subHeading":"Only teachers assigned to a class will appear in this list.","app.components.teacherFilter.UnassignedTeacher":"Unassigned teachers","app.components.teacherFilter.allClasses":"All classes","app.components.teacherFilter.allSurnames":"All surnames","app.components.teacherFilter.clear":"clear","app.components.teacherFilter.defaultOptionStudentClass":"All classes","app.components.teacherFilter.defaultOptionStudentLastName":"All surnames","app.components.teacherFilter.defaultOptionStudentYearGroup":"All years","app.components.teacherRoll.accountStatus":"ACCOUNT STATUS","app.components.teacherRoll.addTeacherConfirmation":"Teacher added","app.components.teacherRoll.classes":"CLASSES","app.components.teacherRoll.dr":"Dr.","app.components.teacherRoll.dr.key":"Dr","app.components.teacherRoll.edit":"EDIT","app.components.teacherRoll.emailAddress":"EMAIL ADDRESS","app.components.teacherRoll.firstName":"FIRST NAME","app.components.teacherRoll.miss":"Miss.","app.components.teacherRoll.miss.key":"Miss","app.components.teacherRoll.mr":"Mr.","app.components.teacherRoll.mr.key":"Mr","app.components.teacherRoll.mrs":"Mrs.","app.components.teacherRoll.mrs.key":"Mrs","app.components.teacherRoll.ms":"Ms.","app.components.teacherRoll.ms.key":"Ms","app.components.teacherRoll.noTeachersAvailable":"No teachers available","app.components.teacherRoll.password":"PASSWORD","app.components.teacherRoll.surname":"SURNAME","app.components.teacherRoll.title":"TITLE","app.components.teacherRoll.username":"USERNAME","app.components.teacherRoll.yearGroupList":"Year","app.components.teacherUnassign.wishToContinue":"Do you wish to continue?","app.containers.AssignCoursesUPF.assignCourseFailure":"Failed to assign the course. Please try again later","app.containers.AssignCoursesUPF.assignCourseSuccess":"The course has been successfully assigned","app.containers.AssignUser.classesFor":"Classes for","app.containers.AssignUser.confirmationMessage":"have been updated","app.containers.CourseAdmin.header":"This is CourseAdmin container !","app.containers.DefaultCourse.header":"This is DefaultCourse container !","app.containers.EditClass.header":"This is EditClass container !","app.containers.EditStudents.header":"This is EditStudents container !","app.containers.ManageAssignCourse.assignCourseSuccess":"The course has been successfully assigned","app.containers.ManageAssignCourse.header":"This is ManageAssignCourse container !","assign-course-conquest.components.assignToGroup":"Assign to group","assign-course-conquest.components.assignToYear":"Assign to year","assign-course-conquest.components.defaultOptionCountry":"Select country","assign-course-conquest.components.newCourses":"New Courses","assign-course-conquest.components.noCoursesFound":"No courses found","assign-course-conquest.components.optOutOfCourse":"Opt out of course","assign-course-conquest.components.schoolCourses":"School courses","assign-course-conquest.components.searchCourse":"Search for a course","assign-course-conquest.components.selectCourse":"Select course","assign-course-conquest.components.selectGroup":"Select grade","assign-course-conquest.components.setDefaultCourse":"Set a new default course:","assign-course-conquest.components.startCourse":"Queue new default course for rollover:","assign-course-legacy.components.assignToGroup":"Assign to group","assign-course-legacy.components.assignToYear":"Assign to year","assign-course-legacy.components.courses":"Courses","assign-course-legacy.components.coursesActivityMastery":"Courses (Activity Mastery)","assign-course-legacy.components.defaultOptionCountry":"Select country","assign-course-legacy.components.newCourses":"New Courses","assign-course-legacy.components.noCoursesFound":"No courses found","assign-course-legacy.components.schoolCourses":"School courses","assign-course-legacy.components.searchCourse":"Search for a course","assign-course-legacy.components.selectCourse":"Select course","assign-course-legacy.components.selectGrade":"Select grade","assign-course-legacy.components.startCourse":"Queue new default course for rollover","assign-course-upf.components.assignToGroup":"Assign to group","assign-course-upf.components.assignToYear":"Assign to year","assign-course-upf.components.defaultOptionCountry":"Select country","assign-course-upf.components.noCoursesFound":"No courses found","assign-course-upf.components.optOutOfCourse":"Opt out of course","assign-course-upf.components.schoolCourses":"School courses","assign-course-upf.components.searchCourse":"Search for a course","assign-course-upf.components.selectCourse":"Select course","assign-course-upf.components.selectGroup":"Select grade","assign-course-upf.components.setDefaultCourse":"Set a new default course:","assign-course-upf.components.skillQuests":"Skill Quests","assign-course-upf.components.startCourse":"Queue new default course for rollover:","assignCourseMapper.components.assignErrorMessage":"An unknown error occurred. Please select another course.","assignCourseMapper.components.assignToGroup":"Assign to group","assignCourseMapper.components.back":"Back","assignCourseMapper.components.cancel":"Cancel","assignCourseMapper.components.cancelWarningMessage":"Unsaved changes","assignCourseMapper.components.no":"No","assignCourseMapper.components.save":"Save","assignCourseMapper.components.saveErrorMessage":"An unknown error occurred. Please try saving the course again.","assignCourseMapper.components.tasksCarryForwardMessage1":"You currently have {commonTasks} activities assigned","assignCourseMapper.components.tasksCarryForwardMessage2":"Would you like to carry these over ?","assignCourseMapper.components.unsavedChanges":"Unsaved changes","assignCourseMapper.components.yes":"Yes","assignCourseMapperAdmin.components.courses":"Courses","assignCourseMapperAdmin.components.coursesActivityMastery":"Courses (Activity Mastery)","assignCourseMapperAdmin.components.currentCourse":"CURRENT DEFAULT COURSE","assignCourseMapperAdmin.components.learningModule":"LEARNING MODULE","assignCourseMapperAdmin.components.newCourses":"New Courses","assignCourseMapperAdmin.components.noCourseFound":"No course found","assignCourseMapperAdmin.components.noVoluntaryCourseSet":"No voluntary course set","assignCourseMapperAdmin.components.optedOut":"Opted out","assignCourseMapperAdmin.components.skillQuests":"Skill Quests","class-footer.components.deleteClasses":"Delete Classes","class-footer.components.deleteClassesConfirmation":"Delete Class(es) ?","class-footer.components.deleting":"deleting","class-footer.components.deletingSelectedClasses":"Deleting the selected class(es) will unassign all teachers and students. They will be unable to access the resource until assigned to another class.","class-footer.components.doYouWishToDeleteClasses":"Deleting the selected class(es) will remove this class from the School Roll. Teachers will be unassigned from this class.","class-footer.components.downloadSignInCards":"Download sign-in cards","class-footer.components.downloading":"downloading","class-footer.components.youHaveDeleted":"You have deleted {noOfSelectedClassrooms} class.","class-header.components.addClass":"Add class","class-header.components.classes":"Classes","class-header.components.downloadClassRoll":"Download class roll","class-header.components.downloading":"downloading","class-header.components.quickUpload":"Quick upload","class-roll.container.classRoll.addClassConfirmation":"has been created","class-roll.container.classRoll.classroomList":"Select a {0} class","class-roll.container.classRoll.defaultOptionTeacherClass":"All classes","class-roll.container.classRoll.defaultOptionTeachers":"All teachers","class-roll.container.classRoll.defaultOptionYearGroup":"All years","class-roll.container.classRoll.deleteClassConfirmation":"class(es) removed from the school roll","class-roll.container.classRoll.deletingNonEmptyClassError":"Only empty classes may be deleted","defaultCourse.components.assignToGroup":"Assign to year","defaultCourse.components.backButton":"Back","defaultCourse.components.cancel":"Cancel","defaultCourse.components.pageSubTitle":"MANAGE DEFAULT COURSES","defaultCourse.components.pageTitle":"Courses","defaultCourse.components.save":"Save","defaultCourse.components.unsavedChanges":"Unsaved changes","download-certificates.components.bronzeCertType":"Bronze certificates","download-certificates.components.certsAvailable":"Download {totalCount} certificates","download-certificates.components.classesDropdownLabel":"All classes","download-certificates.components.downloadBtn":"Download","download-certificates.components.goldCertType":"Gold certificates","download-certificates.components.groupsDropdownLabel":"All groups","download-certificates.components.header":"Certificates","download-certificates.components.noCertsAvailable":"No certificates available","download-certificates.components.silverCertType":"Silver certificates","download-certificates.components.startToEndDateLabel":"{startDate} to {endDate}","download-certificates.components.teachersDropdownLabel":"All teachers","email-status.components.awaitingVerificationTooltip":"Invite email has been sent to this user.","email-status.components.invalidTooltip":"Email is either invalid or duplicated, please check email, or contact support.","email-status.components.unverifiedTooltip":"Password reset link needs to be sent.","email-status.components.verifiedTooltip":"Teacher's account has been activated.","empty-state.components.noResultFound":"No results found","extend-result.components.back":"Back","extend-result.components.extendPeriodExpired":"Extend results period expired","extend-result.components.extendPeriodExpiredSummary":"The period in which your school can carry over of gold bars and results has expired","extend-result.components.failureMessage":"Please contact Tech Support so we can follow up","extend-result.components.failureTitle":"Results have not been carried over","extend-result.components.formContent1":"Note: This can only be done once in an academic year, please proceed with CAUTION","extend-result.components.formContent2":"Selecting Keep results will carry across Gold Bars. Selecting Start Fresh will not carry across Gold Bars.","extend-result.components.formContent3":"Students will always retain their credits and certificates","extend-result.components.formContinueBtn":"Continue","extend-result.components.formHeader":"Extend Result","extend-result.components.formHelpBtn":"What does this mean?","extend-result.components.label":"Label","extend-result.components.noStudentSignInCards":"There are no student sign in cards for the current selection","extend-result.components.noStudents":"No Students","extend-result.components.noStudentsAvailable":"No students available","extend-result.components.ok":"OK","extend-result.components.proceed":"Proceed","extend-result.components.resultsAlreadyExtended":"Results already extended","extend-result.components.resultsAlreadyExtendedSummary":"The gold bars and results carry over for this school has already been processed","extend-result.components.rolloverNotCompleted":"School rollover not completed","extend-result.components.rolloverNotCompletedSummary":"Please complete a school rollover before gold bars and results carry over can be processed","extend-result.components.startFresh":"Start Fresh or Keep Results from","extend-result.components.successMessage":"It may take up to 24 hours for results to be restored.","extend-result.components.successTitle":"Results have been carried over, as per selections","extend-result.components.successTitleStartedFresh":"Results have not been carried over","manage-assign-course.components.defaultOptionCountry":"Select country","manage-assign-course.components.defaultOptionYearGroup":"Select year","manage-assign-course.components.noCoursesFound":"No courses found","manage-assign-course.components.schoolCourses":"School courses","manage-assign-course.components.searchCourse":"Search for a course","manage-assign-course.components.selectCourse":"Select course","manage-assign-course.components.startCourse":"Set a new default course","manageAssignCourse.components.backButton":"Back","manageAssignCourse.components.emptyStateMessage":"No classes found","manageAssignCourse.components.pageSubTitle":"MANAGE ASSIGNED COURSES","manageAssignCourse.components.pageTitle":"Courses","manageAssignCourseAdmin.components.backButton":"Back","manageAssignCourseAdmin.components.emptyStateMessage":"No classes found","manageAssignCourseAdmin.components.pageSubTitle":"Select a learning module to begin","manageAssignCourseAdmin.components.pageTitle":"Course Admin - Manage Assigned Courses","manageCourse.components.backButton":"Back","manageCourse.components.pageSubTitle":"Select a Learning Module to begin","manageCourse.components.pageTitle":"Course Admin - Manage Default Courses for Rollover","quick-upload.components.download":"Downloading","quick-upload.components.downloadStudentRoll":"Download template","quick-upload.components.header":"Quick upload","quick-upload.containers.errorMessageBody":"Please try uploading your file again.","quick-upload.containers.errorMessageHeader":"Oops, something went wrong","quick-upload.containers.fileFormatValidationMessage":"Incorrect file format","quick-upload.containers.newClasses":"New classes","quick-upload.containers.newStudent":"New student","quick-upload.containers.newTeacher":"New teacher","quick-upload.containers.quickUploadSuccessMessage":"You have successfully uploaded","quick-upload.containers.record":"record","quick-upload.containers.row":"Row","quick-upload.containers.success":"Success!","quick-upload.containers.unassignedStudent":"Unassigned student","quick-upload.containers.upatedTeacher":"Updated teacher","quick-upload.containers.updatedClasses":"Updated classes","quick-upload.containers.updatedStudent":"Updated student","quick-upload.containers.validationMessage":"Oops, there are errors in your file","roll-over.components.aboutToProceed":"You are about to proceed with a","roll-over.components.areYouSure":"Are you sure you want to continue?","roll-over.components.assignedStudent":"ASSIGNED STUDENT","roll-over.components.assignedStudents":"ASSIGNED STUDENTS","roll-over.components.back":"Back","roll-over.components.backButton":"Back","roll-over.components.buttonIcon":"?","roll-over.components.cancel":"Cancel","roll-over.components.className":"CLASS NAME","roll-over.components.closeButton":"Close","roll-over.components.confirm":"Confirm","roll-over.components.contentLabel":"Use the template below to upload new students into","roll-over.components.done":"Done","roll-over.components.download":"Download","roll-over.components.downloadSchoolDataBtn":"Download current school list","roll-over.components.downloadStudentRoll":"Download template","roll-over.components.downloadTemplateBtn":"Download template","roll-over.components.downloading":"Downloading","roll-over.components.errorsInYourFile":"Oops, there are errors in your file","roll-over.components.exportSummary":"Export summary","roll-over.components.fileFormatValidationMessage":"Incorrect file format","roll-over.components.fileSizeMessage":"File size exceeds 1MB","roll-over.components.firstName":"FIRST NAME","roll-over.components.fullRollOver":"full rollover.","roll-over.components.fullRolloverDesc1":"This will update ALL {productName} students on your school list.","roll-over.components.fullRolloverDesc2":"Current {productName} students not listed in this rollover will be unassigned and unable to access the resource (unless reassigned).","roll-over.components.fullRolloverTitle":"Full rollover","roll-over.components.header":"Rollover","roll-over.components.includeBulkTransfer":"Include students username for Bulk Transfer","roll-over.components.includeUnassigned":"Include unassigned students in this download","roll-over.components.initialDownloadTemplate":"Click icon to download your {productName} school roll","roll-over.components.initialTitle":"Follow these steps to complete a rollover for {productName}","roll-over.components.initialUpdateSpreadsheet":"Update downloaded spreadsheet","roll-over.components.lastName":"LAST NAME","roll-over.components.newClasses":"New classes","roll-over.components.newClassroomsFile":"newClassrooms.xlsx","roll-over.components.newStudent":"New student","roll-over.components.newStudents":"New students","roll-over.components.newStudentsFile":"newStudents.xlsx","roll-over.components.newTeacher":"New teacher","roll-over.components.newTeachers":"New teachers","roll-over.components.newTeachersFile":"newTeachers.xlsx","roll-over.components.nextButton":"Next","roll-over.components.partialRollOver":"partial rollover.","roll-over.components.partialRolloverDesc1":"This will only update or add the {productName} students listed in your upload.","roll-over.components.partialRolloverDesc2":"No other students or products will be affected.","roll-over.components.partialRolloverTitle":"Partial rollover","roll-over.components.password":"PASSWORD","roll-over.components.pleaseTryAgain":"Please try again later or contact Tech Support","roll-over.components.pleaseTryUploadingAgain":"Please try uploading your file again.","roll-over.components.previousUsername":"Previous Username","roll-over.components.print":"Print","roll-over.components.proceed":"Proceed","roll-over.components.rollOverHasCompleted":"Rollover has been completed. Below is the results summary of this rollover","roll-over.components.rolloverComplete":"Rollover complete","roll-over.components.row":"Row","roll-over.components.schoolRoll":"school roll","roll-over.components.selectionTitle":"Select the type of rollover you wish to perform","roll-over.components.signInCards":"sign in cards","roll-over.components.somethingWentWrong":"Oops, something went wrong","roll-over.components.somethingWrongOnOurSide":"Something went wrong on our side and we are working on it.","roll-over.components.studentFirstName":"STUDENT FIRST NAME","roll-over.components.studentSurname":"STUDENT SURNAME","roll-over.components.summary":"Summary","roll-over.components.surname":"SURNAME","roll-over.components.teacherEmail":"TEACHER EMAIL","roll-over.components.teacherFirstName":"TEACHER FIRST NAME","roll-over.components.teacherName":"TEACHER NAME","roll-over.components.teacherSurname":"TEACHER SURNAME","roll-over.components.theNewClasses":"new classes sign in cards","roll-over.components.theNewStudent":"new student sign in cards","roll-over.components.theNewTeacher":"new teacher sign in cards","roll-over.components.theTransferredStudent":"transferred student sign in cards","roll-over.components.theUnassignedStudent":"unassigned student sign in cards","roll-over.components.theUnassignedTeacher":"unassigned teacher sign in cards","roll-over.components.theUpatedTeacher":"updated teacher sign in cards","roll-over.components.theUpdatedClasses":"updated classes sign in cards","roll-over.components.theUpdatedStudent":"updated student sign in cards","roll-over.components.title":"TITLE","roll-over.components.transferredStudent":"Transferred student","roll-over.components.transferredStudents":"Transferred students","roll-over.components.transferredStudentsFile":"transferredStudents.xlsx","roll-over.components.unassignedStudent":"Unassigned student","roll-over.components.unassignedStudents":"Unassigned students","roll-over.components.unassignedStudentsFile":"unassignedStudents.xlsx","roll-over.components.unassignedTeachers":"Unassigned Teachers","roll-over.components.upatedTeacher":"Updated teacher","roll-over.components.updatedClasses":"Updated classes","roll-over.components.updatedClassroomsFile":"updatedClassrooms.xlsx","roll-over.components.updatedStudent":"Updated student","roll-over.components.updatedStudents":"Updated students","roll-over.components.updatedStudentsFile":"updatedStudents.xlsx","roll-over.components.updatedTeachers":"Updated teachers","roll-over.components.updatedTeachersFile":"updatedTeachers.xlsx","roll-over.components.uploadFile":"Upload file","roll-over.components.uploadMessage":"Upload your excel (xlsx format) file to rollover then select 'Confirm' to proceed","roll-over.components.username":"USERNAME","roll-over.components.verifying":"verifying","roll-over.components.year":"YEAR","rollover.errorMessageBody":"Please try uploading your file again.","rollover.errorMessageHeader":"Oops, something went wrong","rollover.pleaseTryAgain":"Please try again later or contact Tech Support","rollover.somethingWentWrong":"Something went wrong on our side and we are working on it.","school-roll.container.classes":"Classes","school-roll.container.schoolRoll":"School Roll","school-roll.container.schoolRoll.classroomList":"Select a {0} class","school-roll.container.schoolRoll.defaultOptionCountry":"Country","school-roll.container.schoolRoll.expiredLicense":"Licence Expired","school-roll.container.schoolRoll.licenceSummary":"Remaining Licences","school-roll.container.student":"Student","school-roll.container.students":"Students","school-roll.container.teacher":"Teacher","school-roll.container.teachers":"Teachers","sign-in-cards.components.allClasses":"All classes","sign-in-cards.components.allTeachers":"All teachers","sign-in-cards.components.code":"code","sign-in-cards.components.download":"Download sign-in cards","sign-in-cards.components.downloading":"Downloading","sign-in-cards.components.selectClass":"Select a class to download sign-in cards","sign-in-cards.components.signInCards":"Sign-in cards","sign-in-cards.components.students":"Students","sign-in-cards.components.teachers":"Teachers","sign-in-cards.defaultOptionClassrooms":"All classes","sign-in-cards.defaultOptionTeachers":"All teachers","student-footer.components.bulkPasswordChange":"Bulk Password Change","student-footer.components.bulkPasswordChangeSucess":"Passwords have been updated","student-footer.components.deleteConfirmation":"Some students are assigned to classes in other products, please confirm to delete from School Roll entirely.","student-footer.components.deleteStudents":"Delete Students","student-footer.components.deleteStudentsTitle":"Do you wish to delete the selected student(s) from school roll?","student-footer.components.downloadSignInCards":"Download sign-in cards","student-footer.components.downloading":"downloading","student-footer.components.mayLoseAccessToProducts":"and may lose access to the current product.","student-footer.components.mayLoseAccessTselectedStudentsWillBeoProducts":"The selected student(s) will be","student-footer.components.removedFromSchool":"and removed from school roll for all classes and products","student-footer.components.selectedStudentWill":"The selected student{s} will be","student-footer.components.studentRemoveConfirmation":"The selected student(s) will be removed from the school roll","student-footer.components.studentsDeleted":"Student(s) have been deleted","student-footer.components.studentsUnassignedFooter":"Student{s} have been unassigned","student-footer.components.unassign":"Unassign","student-footer.components.unassignStudent":"Unassign Student{s}","student-footer.components.unassignedFooter":"unassigned","student-header.components.addStudent":"Add student","student-header.components.contentLabel":"Use the template below to upload new students into","student-header.components.downloadStudentRoll":"Download student roll","student-header.components.downloading":"downloading","student-header.components.quickUpload":"Quick upload","student-header.components.students":"Students","student-header.components.subTitle":"Quick upload for","student-roll.container.studentRoll.UnassignedStudent":"Unassigned students","student-roll.container.studentRoll.assignedStudents":"Assigned Students","student-roll.container.studentRoll.defaultOptionStudentClass":"All classes","student-roll.container.studentRoll.defaultOptionStudentLastName":"All surnames","student-roll.container.studentRoll.defaultOptionStudentYearGroup":"All years","student-roll.container.studentRoll.deleteStudentSuccess":"{deletedStudentsCount} student(s) removed from the school roll","student-roll.container.studentRoll.errorOnDeletingAssignedStudents":"Error - some selected students are assigned to classes and will not be deleted","student-roll.container.studentRoll.partialDeleteMessage1":"Error - some selected students are assigned to classes and will not be deleted -","student-roll.container.studentRoll.partialDeleteMessage2":"Student(s) have been removed from the school roll","teacher-footer.components.bulkPasswordChange":"Bulk Password Change","teacher-footer.components.bulkPasswordChangeSucess":"Passwords have been updated","teacher-footer.components.deleteConfirmation":"Some teachers are assigned to classes in other products, please confirm to delete from School Roll entirely.","teacher-footer.components.deleteTeachers":"Delete Teachers","teacher-footer.components.deleteTeachersTitle":"Do you wish to delete the selected teacher(s) from school roll?","teacher-footer.components.loseAccessToProducts":"and will lose all access to their licenced products","teacher-footer.components.removedFromSchool":"and removed from school roll for all classes and products","teacher-footer.components.selectedTeacherWillBe":"The selected teacher(s) will be removed from the school roll.","teacher-footer.components.sendVerificationEmails":"Send verification emails","teacher-footer.components.teachersDeleted":"Teacher(s) have been deleted","teacher-footer.components.teachersUnassigned":"Teachers have been unassigned","teacher-footer.components.unassign":"Unassign","teacher-footer.components.unassignTeachers":"Unassign teachers","teacher-footer.components.unassigned":"unassigned","teacher-footer.components.wishToDelete":"Do you wish to delete the selected teacher(s) from school roll?","teacher-header.components.downloadTeacherRoll":"Download teacher roll","teacher-header.components.downloading":"downloading","teacher-header.components.inviteTeacher":"Invite teacher","teacher-header.components.quickUpload":"Quick upload","teacher-header.components.teachers":"Teachers","teacher-roll.container.teacherRoll.UnassignedTeacher":"Unassigned teachers","teacher-roll.container.teacherRoll.classroomList":"Select a {0} class","teacher-roll.container.teacherRoll.defaultOptionTeacherClass":"All classes","teacher-roll.container.teacherRoll.defaultOptionTeacherLastName":"All surnames","teacher-roll.container.teacherRoll.deleteTeacherSuccessMessage":"{count} teachers removed from the school roll","teacher-roll.container.teacherRoll.deleteTeacherWarningMessage":"Error - some selected teachers are assigned to classes and will not be deleted. {count} teachers have been removed from the school roll","teacher-roll.container.teacherRoll.errorOnDeletingAssignedTeachers":"Error - some selected teachers are assigned to classes","teacher-roll.container.teacherView.you":"You"}

/***/ }),
/* 1316 */
/***/ (function(module, exports) {

module.exports = {"app.components.AddClass.add":"Agregar","app.components.AddClass.addClass":"Añadir una clase de {productName}","app.components.AddClass.addClassConfirmation":"fue creada","app.components.AddClass.cancel":"Cancelar","app.components.AddClass.className":"Nombre de la clase","app.components.AddClass.classNameLabel":"Nombre de la clase","app.components.AddClass.country":"País","app.components.AddClass.countryDropdownLabel":"Seleccione un país","app.components.AddClass.courseDropdownLabel":"Seleccione un curso","app.components.AddClass.courses":"Actividades de maestría","app.components.AddClass.coursesNonMaths":"Cursos","app.components.AddClass.curriculumCourses":"Cursos basados en el plan de estudios","app.components.AddClass.customCourses":"Cursos personalizados de la escuela","app.components.AddClass.done":"Listo","app.components.AddClass.grade":"Grado","app.components.AddClass.loadingCourses":"Cargando...","app.components.AddClass.mathsClass":"clase de matemáticas","app.components.AddClass.newCourses":"Cursos nuevos","app.components.AddClass.noCourses":"No se encontraron cursos","app.components.AddClass.noCoursesFound":"No se encontraron cursos","app.components.AddClass.noTeacherDropdownLabel":"No se encontraron maestros","app.components.AddClass.none":"Ninguno","app.components.AddClass.required":"Se requiere selección","app.components.AddClass.schoolCourses":"Cursos escolares","app.components.AddClass.select":"seleccionar","app.components.AddClass.selectDefaultCourse":"Seleccione el curso predeterminado","app.components.AddClass.skillQuests":"Misiones de habilidades","app.components.AddClass.teacher":"Docente","app.components.AddClass.teacherDropdownLabel":"Seleccione un profesor de {product}","app.components.AddClass.useAdminSelection":"","app.components.AddClass.yearDropdownLabel":"Seleccionar un año","app.components.AddGroup.changeCourse":"Cambiar curso","app.components.AddGroup.createdAssigned":"creado y asignado a","app.components.AddGroup.done":"Listo","app.components.AddGroup.inputPlaceholder":"Introduzca el nombre del nuevo grupo","app.components.AddGroup.manageStudent":"Gestionar estudiante","app.components.AddGroup.maxGroupErrorLongDesc":"Se le permite un máximo de 12 grupos por clase; elimine un grupo para continuar.","app.components.AddGroup.maxGroupErrorTitle":"No se puede crear este grupo.","app.components.AddGroup.okBtn":"De acuerdo","app.components.AddGroup.title":"Introduzca el nombre del nuevo grupo","app.components.AddStudent.addStudent":"Añadir estudiante","app.components.AddStudent.classroomList":"Seleccione una {0} clase","app.components.AddStudent.firstName":"Nombre","app.components.AddStudent.groupLabel":"Todos los grupos","app.components.AddStudent.previousUsername":"Usuario anterior","app.components.AddStudent.surname":"Apellido","app.components.AddTeacher.classroomList":"Seleccione una clase {product}","app.components.AddTeacher.emailAddress":"Correo electrónico","app.components.AddTeacher.firstName":"Nombre","app.components.AddTeacher.inviteTeacher":"Invitar a Maestro","app.components.AddTeacher.surname":"Apellido","app.components.AddTeacher.title":"Título","app.components.Assign.allYears":"Todos los años","app.components.AssignUser.assignedClasses":"Clases asignadas a","app.components.AssignUser.assignedEmptyState":"No hay clases asignadas","app.components.AssignUser.assignedTeachers":"Maestros asignados a","app.components.AssignUser.assignedTo":"asignado a","app.components.AssignUser.available":"Disponible","app.components.AssignUser.cancel":"Cancelar","app.components.AssignUser.classes":"Clases","app.components.AssignUser.save":"Guardar","app.components.AssignUser.teacherEmptyState":"No se encontraron maestros","app.components.AssignUser.teachers":"Maestros","app.components.AssignUser.unassignedEmptyState":"No se encontraron clases","app.components.AssignedTeacher.assignTeacher":"Asignar maestro(s)","app.components.AssignedTeacher.assignedTeachers":"Maestros asignados","app.components.AssignedTeacherList.downloadCards":"Descargar tarjeta de registro","app.components.AssignedTeacherList.downloading":"descargando","app.components.AssignedTeacherList.loseAccessToProducts":"y perderán todo acceso a sus productos con licencia","app.components.AssignedTeacherList.selectedTeacherWillBe":"Los maestros seleccionados se eliminarán de la lista de la escuela.","app.components.AssignedTeacherList.teachers":"MAESTROS","app.components.AssignedTeacherList.teachersUnassigned":"Los maestros han sido desasignados","app.components.AssignedTeacherList.unassignTeachers":"Desasignar maestros","app.components.AssignedTeacherList.unassigned":"desasignados","app.components.ClassDetails.classDetails":"Detalles de la clase","app.components.ClassDetails.className":"NOMBRE DE LA CLASE","app.components.ClassDetails.students":"ESTUDIANTES","app.components.ClassDetails.year":"AÑO","app.components.ClassroomGroupList.activities":"Actividades","app.components.ClassroomGroupList.courses":"CURSOS","app.components.ClassroomGroupList.createGroup":"Crear grupo","app.components.ClassroomGroupList.downloadCards":"Descargar tarjetas de registro","app.components.ClassroomGroupList.downloading":"descargando","app.components.ClassroomGroupList.group":"GRUPO","app.components.ClassroomGroupList.newCourses":"Cursos Nuevos","app.components.ClassroomGroupList.noCourseAssigned":"No se ha asignado ningún curso nuevo","app.components.ClassroomGroupList.noCourseFound":"No se encontró ningún curso","app.components.ClassroomGroupList.noVoluntaryCourseSet":"No hay ningún curso voluntario configurado","app.components.ClassroomGroupList.optedOut":"Optó por salir","app.components.ClassroomGroupList.skillQuests":"Misiones de habilidades","app.components.ClassroomGroupList.students":"ESTUDIANTES","app.components.DefaultCourseMapper.currentDefaultCourse":"CURSO PREDETERMINADO ACTUAL","app.components.DefaultCourseMapper.newDefaultCourse":"NUEVO CURSO PREDETERMINADO","app.components.DefaultCourseMapper.year":"AÑO","app.components.DefaultCourseMapperAdmin.assignToGroup":"Asigne a un año","app.components.DefaultCourseMapperAdmin.cancel":"Cancelar","app.components.DefaultCourseMapperAdmin.changesWillNotTake":"los cambios no tendrán efecto hasta su siguiente traspaso programado","app.components.DefaultCourseMapperAdmin.courses":"Cursos","app.components.DefaultCourseMapperAdmin.coursesActivityMastery":"Maestria de actividades","app.components.DefaultCourseMapperAdmin.defaultCourse":"CURSO PREDETERMINADO","app.components.DefaultCourseMapperAdmin.dontTellMeAgain":"No me lo digas de nuevo","app.components.DefaultCourseMapperAdmin.iUnderstand":"Entiendo","app.components.DefaultCourseMapperAdmin.learningModule":"MÓDULO DE APRENDIZAJE","app.components.DefaultCourseMapperAdmin.newCourses":"New Courses","app.components.DefaultCourseMapperAdmin.newDefaultCourse":"NUEVO CURSO PREDETERMINADO ","app.components.DefaultCourseMapperAdmin.noUPFCourseSet":"No se encontró ningún curso","app.components.DefaultCourseMapperAdmin.noVoluntaryCourseSet":"No hay ningún curso voluntario configurado","app.components.DefaultCourseMapperAdmin.optedOut":"Optó por salir","app.components.DefaultCourseMapperAdmin.queue":"Añadir curso","app.components.DefaultCourseMapperAdmin.queuedForRollover":"En cola para Traspaso","app.components.DefaultCourseMapperAdmin.skillQuests":"Misiones de habilidades","app.components.DefaultCourseMapperAdmin.unconfirmed":"(Confirme al seleccionar la cola)","app.components.DefaultCourseMapperAdmin.unsavedChanges":"No se guardaron los cambios","app.components.DefaultCourseMapperAdmin.whileYouMightSee":"Mientras pueda ver su selección en ","app.components.DefaultCourseMapperAdmin.year":"AÑO","app.components.DefaultCourseMapperAdmin.youMayChangeYour":"Puede cambiar su selección en cualquier punto antes del traspaso","app.components.EditClassForm.AreYouSureYouWantToDelete":"Está seguro de que quiere eliminar","app.components.EditClassForm.cancel":"Cancelar","app.components.EditClassForm.changeCourse":"Cambiar curso","app.components.EditClassForm.close":"Cerrar","app.components.EditClassForm.delete":"Eliminar grupo","app.components.EditClassForm.deleteNonEmptyGroupConfirmation":"debe estar vacío antes de que se pueda eliminar.","app.components.EditClassForm.deleting":"Eliminando","app.components.EditClassForm.doYouWishTo":"¿Desea cambiar el nombre del grupo","app.components.EditClassForm.hasBeenDeleted":" fue eliminado.","app.components.EditClassForm.manageStudents":"Gestionar estudiantes","app.components.EditClassForm.pleaseGoTo":"Vaya a","app.components.EditClassForm.questionMark":"?","app.components.EditClassForm.renameGroup":"Cambiar nombre del grupo","app.components.EditClassForm.save":"Guardar","app.components.EditClassForm.to":"para","app.components.EditClassForm.toMoveYourStudents":"para mover a sus alumnos","app.components.EditClassForm.yourGroup":"Su grupo,","app.components.EditClassGroup.AreYouSureYouWantToDelete":"Está seguro de que quiere eliminar","app.components.EditClassGroup.changeCourse":"Cambiar curso","app.components.EditClassGroup.close":"Cerrar","app.components.EditClassGroup.delete":"Eliminar grupo","app.components.EditClassGroup.deleteNonEmptyGroupConfirmation":"debe estar vacío antes de que se pueda eliminar.","app.components.EditClassGroup.deleting":"Eliminando","app.components.EditClassGroup.doYouWishTo":"¿Desea cambiar el nombre del grupo","app.components.EditClassGroup.hasBeenDeleted":" fue eliminado.","app.components.EditClassGroup.manageStudents":"Gestionar estudiantes","app.components.EditClassGroup.pleaseGoTo":"Vaya a","app.components.EditClassGroup.questionMark":"?","app.components.EditClassGroup.renameGroup":"Cambiar nombre del grupo","app.components.EditClassGroup.to":"para","app.components.EditClassGroup.toMoveYourStudents":"para mover a sus alumnos","app.components.EditClassGroup.yourGroup":"Su grupo,","app.components.EditStudent.cancel":"Cancelar","app.components.EditStudent.save":"Guardar","app.components.EditStudent.yearGroupList":"Año","app.components.EditTeacher.cancel":"Cancelar","app.components.EditTeacher.emailRequiredMessage":"Se requiere correo electrónico","app.components.EditTeacher.emailValidationMessage":"Correo electrónico inválido","app.components.EditTeacher.passwordValidationMessage1":"La nueva contraseña no cumple las reglas establecidas","app.components.EditTeacher.passwordValidationMessage2":"Asegúrese de que las contraseñas del docente correspondan","app.components.EditTeacher.passwordValidationMessage3":"Ingrese la contraseña de administrador","app.components.EditTeacher.passwordValidationMessage4":"La contraseña no puede estar en blanco","app.components.EditTeacher.save":"Guardar","app.components.EditTeacher.teachertTitle.none":"Ninguno","app.components.EditTeacher.teachertTitle.none.key":"none","app.components.ExtendResultTable.keepResultsHeader":"Mantener resultados","app.components.ExtendResultTable.levelHeader":"Nivel","app.components.ExtendResultTable.startFreshHeader":"Empezar de nuevo","app.components.FileUploader.browse":"Explorar...","app.components.FileUploader.fileUpload":"Cargar archivo","app.components.FileUploader.upload":"Subir","app.components.MoveCopyStudentConfirmation.cancel":"Cancelar","app.components.MoveCopyStudentConfirmation.copy":"copiar","app.components.MoveCopyStudentConfirmation.copyMessage":"el/los estudiante(s) estará(n) en la clase original y en la nueva","app.components.MoveCopyStudentConfirmation.headerEndText":"el/los estudiante(s) seleccionado(s)?","app.components.MoveCopyStudentConfirmation.headerStartText":"Quiere","app.components.MoveCopyStudentConfirmation.move":"mover","app.components.MoveCopyStudentConfirmation.moveMessage":"el/los estudiante(s) pasarán de su(s) clase(s) actual(es) a la nueva clase","app.components.MoveCopyStudentConfirmation.or":"o","app.components.RenameGroup.doYouWishTo":"¿Desea cambiar el nombre del grupo","app.components.RenameGroup.groupNameLabel":"Nombre del grupo","app.components.RenameGroup.questionMark":"?","app.components.RenameGroup.renameGroup":"Cambie el nombre de su grupo","app.components.RenameGroup.renameGroupConfirmation":"El nombre de su grupo ha cambiado.","app.components.RenameGroup.to":"para","app.components.SendEmailResult.emailAlreadyVerified":"ya se verificó la dirección de correo electrónico","app.components.SendEmailResult.emailNotSent":"no se envió el correo","app.components.SendEmailResult.emailSent":"correo enviado con éxito","app.components.SendEmailResult.emailsAlreadyVerified":"ya se verificaron las direcciones de correo electrónico","app.components.SendEmailResult.emailsNotSent":"no se enviaron los correos","app.components.SendEmailResult.emailsSent":"correos enviados con éxito","app.components.SendEmailResult.notValidOrDuplicate":"correo electrónico inválido o duplicado","app.components.SendEmailResult.ok":"Ok","app.components.SendEmailResult.sendEmails":"Enviar correos de verificación","app.components.SendEmailResult.tryAgain":"Intente de nuevo más tarde.","app.components.SendEmailResult.unableToSend":"No es posible enviar el correo en este momento.","app.components.StudentClassDetail.assignClasses":"Asignar clase(s)","app.components.StudentClassDetail.classDetails":"Detalles de la clase","app.components.StudentClassList.class":"CLASE","app.components.StudentClassList.course":"CURSO","app.components.StudentClassList.group":"GRUPO","app.components.StudentClassList.mayLoseAccessToProducts":"y puede perder el acceso al producto actual.","app.components.StudentClassList.selectedStudentWillBe":"El alumno seleccionado será","app.components.StudentClassList.studentsUnassigned":"El estudiante ha sido desasignado","app.components.StudentClassList.teacher":"MAESTRO","app.components.StudentClassList.unassignStudents":"Desasignar estudiante","app.components.StudentClassList.unassignedClassList":"desasignados","app.components.StudentClassList.year":"AÑO","app.components.StudentConfirmation.addAnotherStuent":"Añadir otro estudiante","app.components.StudentConfirmation.done":"Listo","app.components.StudentConfirmation.header":"descargando...","app.components.StudentConfirmation.printSignInCard":"Imprimir tarjeta de registro","app.components.StudentCountFormatter.assignStudents":"Asignar estudiantes","app.components.StudentDetails.downSignInCard":"Descargar tarjeta de registro","app.components.StudentDetails.firstname":"NOMBRE","app.components.StudentDetails.header":"¡Este es el componente StudentDetails!","app.components.StudentDetails.lastname":"APELLIDO","app.components.StudentDetails.password":"CONTRASEÑA","app.components.StudentDetails.studentDetails":"Datos del alumno","app.components.StudentDetails.username":"Usuario","app.components.StudentDetails.warning":"El nombre de usuario y la contraseña se utilizan en todos los recursos","app.components.StudentDetails.year":"AÑO","app.components.Summary.ViewSummary":"Ver Resumen","app.components.Summary.back":"Volver","app.components.Summary.header":"De acuerdo","app.components.Summary.print":"Imprimir","app.components.TeacherClassDetail.assignClasses":"Asignar clase(s)","app.components.TeacherClassDetail.classDetails":"Detalles de la clase","app.components.TeacherClassList.class":"CLASE","app.components.TeacherClassList.course":"CURSO","app.components.TeacherClassList.downloadSignInCard":"Descargar tarjetas de registro","app.components.TeacherClassList.group":"GRUPO","app.components.TeacherClassList.loseAccessToProducts":"y perderán todo acceso a sus productos con licencia","app.components.TeacherClassList.selectedTeacherWillBe":"Los maestros seleccionados se eliminarán de la lista de la escuela.","app.components.TeacherClassList.teacher":"MAESTRO","app.components.TeacherClassList.teachersUnassigned":"El maestro ha sido desasignado","app.components.TeacherClassList.unassignTeachers":"Desasignar maestro","app.components.TeacherClassList.unassigned":"desasignados","app.components.TeacherClassList.year":"AÑO","app.components.TeacherConfirmation.addAnotherTeacher":"Añadir otro maestro","app.components.TeacherConfirmation.done":"Listo","app.components.TeacherConfirmation.header":"descargando...","app.components.TeacherConfirmation.ok":"De acuerdo","app.components.TeacherConfirmation.printSignInCard":"Imprimir tarjeta de registro","app.components.TeacherDetails.adminPassword":"CONTRASEÑA DEL ADMINISTRADOR","app.components.TeacherDetails.emailUnverified":"Correo no verificado","app.components.TeacherDetails.emailaddress":"CORREO ELECTRÓNICO","app.components.TeacherDetails.firstname":"NOMBRE","app.components.TeacherDetails.header":"¡Este es el componente TeacherDetails!","app.components.TeacherDetails.lastname":"APELLIDO","app.components.TeacherDetails.newTeacherPassword":"NUEVA CONTRASEÑA DE DOCENTE","app.components.TeacherDetails.password":"CONTRASEÑA","app.components.TeacherDetails.passwordWarning":"Asegúrese de que la nueva contraseña de docente tenga al menos 8 caracteres y contenga letras y números","app.components.TeacherDetails.repeatTeacherPassword":"CONFIRMAR CONTRASEÑA DE DOCENTE","app.components.TeacherDetails.resetTeacherPassword":"Restablecer contraseña de Docente","app.components.TeacherDetails.teacherDetails":"Datos del maestro","app.components.TeacherDetails.teacherPasswordLink":"Enviar enlace de contraseña al docente","app.components.TeacherDetails.teacherVerifyEmailLink":"Enviar enlace de verificación de correo","app.components.TeacherDetails.title":"TÍTULO","app.components.TeacherDetails.username":"Usuario","app.components.TeacherDetails.warning":"El nombre de usuario y la contraseña se utilizan en todos los recursos","app.components.Toast.header":"¡Este es el elemento Toast!","app.components.UploadValidationConfirmation.ok":"De acuerdo","app.components.UserDelete.continueDelete":"¿Desea eliminar a el/los estudiante(s) seleccionado(s) de la lista de matriculados?","app.components.assignCourseMapper.assignedCourse":"CURSO ASIGNADO","app.components.assignCourseMapper.class":"CLASE","app.components.assignCourseMapper.group":"GRUPO","app.components.assignCourseMapper.year":"AÑO","app.components.assignedClassesGroups.assignClass":"Asignar clase","app.components.assignedTeacherInfo.assignTeacher":"Asignar maestro","app.components.bulkPasswordChange.newPassword":"Introduzca nueva contraseña","app.components.changeCourse.activityUpdated":"{length} {length, plural, one {actividad} other {actividades}} transferidas.","app.components.changeCourse.assignedTo":"ha sido asignado a","app.components.changeCourse.backLabel":"Volver","app.components.changeCourse.confirmLabel":"¿Es esto correcto?","app.components.changeCourse.confirmWithActivitiesHeader":"Actualmente tiene {length} {length, plural, one {actividad} other {actividades}} asignadas","app.components.changeCourse.confirmWithActivitiesSubHeader":"'¿Le gustaría continuar con ellas?'","app.components.changeCourse.countryLabel":"País","app.components.changeCourse.courseLabel":"Curso","app.components.changeCourse.curriculumCourses":"Cursos basados en el plan de estudios","app.components.changeCourse.customCourses":"Cursos personalizados de la escuela","app.components.changeCourse.gradeLabel":"Grado","app.components.changeCourse.newCourses":"Cursos Nuevos","app.components.changeCourse.noCoursesFound":"No se encontraron cursos","app.components.changeCourse.noLabel":"No","app.components.changeCourse.none":"Ninguno","app.components.changeCourse.schoolCourses":"Cursos escolares","app.components.changeCourse.selectCountry":"Seleccionar país","app.components.changeCourse.selectCourse":"Seleccionar curso","app.components.changeCourse.selectGrade":"Seleccionar grado","app.components.changeCourse.selectNewCourse":"Seleccione un Curso Nuevo","app.components.changeCourse.selectSkillQuests":"Seleccionar Misiones de habilidades","app.components.changeCourse.skillQuests":"Misiones de habilidades","app.components.changeCourse.subTitle":"está configurado actualmente en","app.components.changeCourse.useAdminSelection":"","app.components.changeCourse.yesLabel":"Sí","app.components.classCourses.activities":"Actividades","app.components.classCourses.multipleCourses":"Varios cursos","app.components.classCourses.newCourses":"Cursos Nuevos","app.components.classCourses.noCourseAssigned":"No se ha asignado ningún curso nuevo","app.components.classCourses.noCoursesFound":"","app.components.classCourses.noVoluntaryCourseSet":"No hay ningún curso voluntario configurado","app.components.classCourses.optedOut":"Optó por salir","app.components.classCourses.skillQuests":"Misiones de habilidades","app.components.classFilter.allTeachers":"Todos los maestros","app.components.classFilter.allYears":"Todos los años","app.components.classFilter.clear":"borrar","app.components.classRoll.allTeachers":"Todos los maestros","app.components.classRoll.allYears":"Todos los años","app.components.classRoll.class":"CLASE","app.components.classRoll.classes":"CLASES","app.components.classRoll.course":"CURSO","app.components.classRoll.edit":"EDITAR","app.components.classRoll.learningModules":"MÓDULOS DE APRENDIZAJE","app.components.classRoll.noClassesAvailable":"No hay clases disponibles.","app.components.classRoll.resource":"RECURSO","app.components.classRoll.students":"ESTUDIANTES","app.components.classRoll.teacher":"MAESTRO","app.components.classRoll.year":"AÑO","app.components.components.uploading":"subiendo","app.components.confirmationModal.doYouWishToContinue":"¿Desea continuar?","app.components.courseTopicsDetails.activitiesFileLabel":"ACTIVIDADES","app.components.courseTopicsDetails.activitiesLabel":"Actividades","app.components.courseTopicsDetails.areYouReadyLabel":"¿Está listo?","app.components.courseTopicsDetails.authorLabel":"Autor","app.components.courseTopicsDetails.countryLabel":"País","app.components.courseTopicsDetails.easierActivitiesFileLabel":"SOMETHING EASIER ACTIVITIES_es","app.components.courseTopicsDetails.exportLabel":"Exportar","app.components.courseTopicsDetails.gradeLabel":"Grado","app.components.courseTopicsDetails.ok":"De acuerdo","app.components.courseTopicsDetails.testLabel":"Prueba","app.components.courseTopicsDetails.topicFileLabel":"TEMA","app.components.courseTopicsDetails.topicLabel":"Temas","app.components.datePicker.customDate":"Fecha personalizada","app.components.datePicker.lastWeek":"Semana pasada","app.components.datePicker.thisSchoolYear":"Curso escolar actual","app.components.datePicker.thisWeek":"Esta semana","app.components.reAuthenticate.continue":"Continuar","app.components.reAuthenticate.pageTitle":"Vuelva a autenticar al ingresar la contraseña de admin siguiente","app.components.reAuthenticate.password":"Contraseña","app.components.studentFilter.UnassignedStudent":"Estudiantes sin asignar","app.components.studentFilter.allSurnames":"Todos los apellidos","app.components.studentFilter.allYears":"Todos los años","app.components.studentFilter.clear":"borrar","app.components.studentFilter.defaultOptionStudentClass":"Todas las clases","app.components.studentFilter.defaultOptionStudentLastName":"Todos los apellidos","app.components.studentFilter.defaultOptionStudentYearGroup":"Todos los años","app.components.studentRoll.addStudentConfirmation":"Estudiante añadido","app.components.studentRoll.allClasses":"Todas las clases","app.components.studentRoll.allSurnames":"Todos los apellidos","app.components.studentRoll.allYears":"Todos los años","app.components.studentRoll.assignedStudents":"Estudiantes asignados","app.components.studentRoll.classes":"CLASES","app.components.studentRoll.edit":"EDITAR","app.components.studentRoll.firstName":"NOMBRE","app.components.studentRoll.groups":"GRUPOS","app.components.studentRoll.noStudentsAvailable":"No hay estudiantes disponibles","app.components.studentRoll.password":"CONTRASEÑA","app.components.studentRoll.surname":"APELLIDO","app.components.studentRoll.teachers":"MAESTROS","app.components.studentRoll.unassignedStudents":"Estudiantes sin asignar","app.components.studentRoll.username":"Usuario","app.components.studentRoll.year":"AÑO","app.components.studentRoll.yearGroupList":"Seleccionar un año","app.components.studentUnAssign.doYouWishToContinue":"¿Desea continuar?","app.components.studentUnAssign.download":"descargar","app.components.studentUnAssign.downloading":"descargando","app.components.studentUnAssign.f2x5":"2 x 5 Etiqueta","app.components.studentUnAssign.f2x7":"2 x 7 Etiqueta","app.components.studentUnAssign.f3x8":"3 x 8 Etiqueta","app.components.studentUnAssign.header":"Seleccione un formato para las tarjetas de registro","app.components.studentUnAssign.qr2x2":"Código QR (2 x 2)","app.components.studentUnAssign.qr3x3":"Código QR (3 x 3)","app.components.teacher-view.launch":"Lanzar","app.components.teacher-view.selectTeacher":"Seleccionar maestro","app.components.teacher-view.teacherView":"Vista del docente","app.components.teacher-view.teacherView.subHeading":"Sólo los profesores asignados a una clase aparecerán en esta lista.","app.components.teacherFilter.UnassignedTeacher":"Docentes no asignados","app.components.teacherFilter.allClasses":"Todas las clases","app.components.teacherFilter.allSurnames":"Todos los apellidos","app.components.teacherFilter.clear":"borrar","app.components.teacherFilter.defaultOptionStudentClass":"Todas las clases","app.components.teacherFilter.defaultOptionStudentLastName":"Todos los apellidos","app.components.teacherFilter.defaultOptionStudentYearGroup":"Todos los años","app.components.teacherRoll.accountStatus":"Estado de la cuenta","app.components.teacherRoll.addTeacherConfirmation":"Maestro añadido","app.components.teacherRoll.classes":"CLASES","app.components.teacherRoll.dr":"Dr.","app.components.teacherRoll.dr.key":"Dr","app.components.teacherRoll.edit":"EDITAR","app.components.teacherRoll.emailAddress":"CORREO ELECTRÓNICO","app.components.teacherRoll.firstName":"NOMBRE","app.components.teacherRoll.miss":"Srta.","app.components.teacherRoll.miss.key":"Miss","app.components.teacherRoll.mr":"Sr.","app.components.teacherRoll.mr.key":"Mr","app.components.teacherRoll.mrs":"Sra.","app.components.teacherRoll.mrs.key":"Mrs","app.components.teacherRoll.ms":"Srita.","app.components.teacherRoll.ms.key":"Ms","app.components.teacherRoll.noTeachersAvailable":"No hay maestros disponibles","app.components.teacherRoll.password":"CONTRASEÑA","app.components.teacherRoll.surname":"APELLIDO","app.components.teacherRoll.title":"TÍTULO","app.components.teacherRoll.username":"Usuario","app.components.teacherRoll.yearGroupList":"Año","app.components.teacherUnassign.wishToContinue":"¿Desea continuar?","app.containers.AssignCoursesUPF.assignCourseFailure":"","app.containers.AssignCoursesUPF.assignCourseSuccess":"","app.containers.AssignUser.classesFor":"Clases para","app.containers.AssignUser.confirmationMessage":"han sido actualizadas","app.containers.CourseAdmin.header":"Éste es el contenedor de CourseAdmin","app.containers.DefaultCourse.header":"¡Este es el contenedor DefaultCourse!","app.containers.EditClass.header":"¡Este es el contenedor EditClass!","app.containers.EditStudents.header":"¡Este es el contenedor EditStudents!","app.containers.ManageAssignCourse.assignCourseSuccess":"","app.containers.ManageAssignCourse.header":"¡Este es el contenedor ManageAssignCourse!","assign-course-conquest.components.assignToGroup":"Asigne a un grupo","assign-course-conquest.components.assignToYear":"Asigne a un año","assign-course-conquest.components.defaultOptionCountry":"Seleccione el país","assign-course-conquest.components.newCourses":"New Courses","assign-course-conquest.components.noCoursesFound":"No se encontraron cursos","assign-course-conquest.components.optOutOfCourse":"Optar salir del curso","assign-course-conquest.components.schoolCourses":"Cursos de la escuela","assign-course-conquest.components.searchCourse":"Buscar un curso","assign-course-conquest.components.selectCourse":"Seleccione un curso","assign-course-conquest.components.selectGroup":"Seleccione un grado","assign-course-conquest.components.setDefaultCourse":"Establezca un nuevo curso predeterminado:","assign-course-conquest.components.startCourse":"Coloque el nuevo curso predeterminado para traspaso:","assign-course-legacy.components.assignToGroup":"Asigne a un grupo","assign-course-legacy.components.assignToYear":"Asigne a un año","assign-course-legacy.components.courses":"Cursos","assign-course-legacy.components.coursesActivityMastery":"Maestria de actividades","assign-course-legacy.components.defaultOptionCountry":"Seleccione el país","assign-course-legacy.components.newCourses":"","assign-course-legacy.components.noCoursesFound":"No se encontraron cursos","assign-course-legacy.components.schoolCourses":"Cursos de la escuela","assign-course-legacy.components.searchCourse":"Buscar un curso","assign-course-legacy.components.selectCourse":"Seleccione un curso","assign-course-legacy.components.selectGrade":"Seleccione un grado","assign-course-legacy.components.startCourse":"Coloque el nuevo curso predeterminado para traspaso","assign-course-upf.components.assignToGroup":"Asigne a un grupo","assign-course-upf.components.assignToYear":"Asigne a un año","assign-course-upf.components.defaultOptionCountry":"Seleccione el país","assign-course-upf.components.noCoursesFound":"No se encontraron cursos","assign-course-upf.components.optOutOfCourse":"Optar salir del curso","assign-course-upf.components.schoolCourses":"Cursos de la escuela","assign-course-upf.components.searchCourse":"Buscar un curso","assign-course-upf.components.selectCourse":"Seleccione un curso","assign-course-upf.components.selectGroup":"Seleccione un grado","assign-course-upf.components.setDefaultCourse":"Establezca un nuevo curso predeterminado:","assign-course-upf.components.skillQuests":"Misión de habilidades","assign-course-upf.components.startCourse":"Coloque el nuevo curso predeterminado para traspaso:","assignCourseMapper.components.assignErrorMessage":"Se produjo un error desconocido. Seleccione otro curso.","assignCourseMapper.components.assignToGroup":"Asignar al grupo","assignCourseMapper.components.back":"Volver","assignCourseMapper.components.cancel":"Cancelar","assignCourseMapper.components.cancelWarningMessage":"Cambios no guardados","assignCourseMapper.components.no":"No","assignCourseMapper.components.save":"Guardar","assignCourseMapper.components.saveErrorMessage":"Se produjo un error desconocido. Intente guardar el curso de nuevo.","assignCourseMapper.components.tasksCarryForwardMessage1":"Actualmente tiene actividades {commonTasks} asignadas","assignCourseMapper.components.tasksCarryForwardMessage2":"¿Le gustaría continuar con ellas?'","assignCourseMapper.components.unsavedChanges":"Cambios no guardados","assignCourseMapper.components.yes":"Sí","assignCourseMapperAdmin.components.courses":"Cursos","assignCourseMapperAdmin.components.coursesActivityMastery":"Maestria de actividades","assignCourseMapperAdmin.components.currentCourse":"CURSO PREDETERMINADO ACTUAL","assignCourseMapperAdmin.components.learningModule":"MÓDULOS DE APRENDIZAJE","assignCourseMapperAdmin.components.newCourses":"","assignCourseMapperAdmin.components.noCourseFound":"No se encontró ningún curso","assignCourseMapperAdmin.components.noVoluntaryCourseSet":"No hay ningún curso voluntario configurado","assignCourseMapperAdmin.components.optedOut":"Optó por salir","assignCourseMapperAdmin.components.skillQuests":"Misiones de habilidades","class-footer.components.deleteClasses":"Eliminar clases","class-footer.components.deleteClassesConfirmation":"¿Eliminar clase(s)?","class-footer.components.deleting":"eliminando","class-footer.components.deletingSelectedClasses":"Eliminar la(s) clase(s) seleccionada(s) desasignará a todos los maestros y estudiantes. No podrán acceder al recurso hasta que se les asigne a otra clase","class-footer.components.doYouWishToDeleteClasses":"Eliminar las clases seleccionadas quitará esta clase de la Lista de alumnos. Los maestros serán desasignados de esta clase.","class-footer.components.downloadSignInCards":"Descargar tarjetas de registro","class-footer.components.downloading":"descargando","class-footer.components.youHaveDeleted":"Ha eliminado {noOfSelectedClassrooms} clase(s).","class-header.components.addClass":"Añadir clase","class-header.components.classes":"Clases","class-header.components.downloadClassRoll":"Descargar lista de la clase","class-header.components.downloading":"descargando","class-header.components.quickUpload":"Carga rápida","class-roll.container.classRoll.addClassConfirmation":"fue creada","class-roll.container.classRoll.classroomList":"Selecciona una clase {0}","class-roll.container.classRoll.defaultOptionTeacherClass":"Todas las clases","class-roll.container.classRoll.defaultOptionTeachers":"Todos los maestros","class-roll.container.classRoll.defaultOptionYearGroup":"Todos los años","class-roll.container.classRoll.deleteClassConfirmation":"clase(s) eliminada(s) de la matrícula escolar","class-roll.container.classRoll.deletingNonEmptyClassError":"Sólo se pueden eliminar las clases vacías","defaultCourse.components.assignToGroup":"Asignar al año","defaultCourse.components.backButton":"Volver","defaultCourse.components.cancel":"Cancelar","defaultCourse.components.pageSubTitle":"GESTIONAR CURSOS PREDETERMINADOS","defaultCourse.components.pageTitle":"Cursos","defaultCourse.components.save":"Guardar","defaultCourse.components.unsavedChanges":"Cambios no guardados","download-certificates.components.bronzeCertType":"Certificados de bronce","download-certificates.components.certsAvailable":"Descargar {totalCount} certificados","download-certificates.components.classesDropdownLabel":"Todas las clases","download-certificates.components.downloadBtn":"Descargar","download-certificates.components.goldCertType":"Certificados de oro","download-certificates.components.groupsDropdownLabel":"Todos los grupos","download-certificates.components.header":"Certificados","download-certificates.components.noCertsAvailable":"No hay certificados disponibles","download-certificates.components.silverCertType":"Certificados de plata","download-certificates.components.startToEndDateLabel":"De {startDate} a {endDate}","download-certificates.components.teachersDropdownLabel":"Todos los maestros","email-status.components.awaitingVerificationTooltip":"Se ha enviado un correo electrónico de invitación a este usuario.","email-status.components.invalidTooltip":"Este correo electrónico es inválido o está duplicado, por favor revise la dirección de correo o contacte al departamento de soporte.","email-status.components.unverifiedTooltip":"Debemos enviar el vínculo para restablecer la contraseña.","email-status.components.verifiedTooltip":"La cuenta del docente se ha activado.","empty-state.components.noResultFound":"No se encontraron resultados","extend-result.components.back":"Volver","extend-result.components.extendPeriodExpired":"El período para ampliar los resultados ha vencido","extend-result.components.extendPeriodExpiredSummary":"El plazo para que su escuela pueda transferir lingotes de oro y resultados ha vencido","extend-result.components.failureMessage":"Póngase en contacto con Asistencia Técnica para que podamos hacer un seguimiento","extend-result.components.failureTitle":"Los resultados no han sido transferidos","extend-result.components.formContent1":"Nota: esto solo puede hacerse una vez en un año académico, proceda con PRECAUCIÓN","extend-result.components.formContent2":"Seleccionar Guardar resultados hará que los lingotes de oro se transfieran. Seleccionar Empezar de nuevo no transferirá los lingotes de oro.","extend-result.components.formContent3":"Los estudiantes siempre conservarán sus créditos y certificados","extend-result.components.formContinueBtn":"Continuar","extend-result.components.formHeader":"Ampliar el resultado","extend-result.components.formHelpBtn":"¿Qué significa esto?","extend-result.components.label":"Etiqueta","extend-result.components.noStudentSignInCards":"No hay tarjetas de registro de estudiantes para la selección actual","extend-result.components.noStudents":"No hay estudiantes","extend-result.components.noStudentsAvailable":"No hay estudiantes disponibles","extend-result.components.ok":"De acuerdo","extend-result.components.proceed":"Continuar","extend-result.components.resultsAlreadyExtended":"Los resultados ya se han ampliado","extend-result.components.resultsAlreadyExtendedSummary":"La transferencia de los lingotes de oro y los resultados de esta escuela ya se ha procesado","extend-result.components.rolloverNotCompleted":"El período para ampliar los resultados ha vencido","extend-result.components.rolloverNotCompletedSummary":"El plazo para que su escuela pueda transferir lingotes de oro y resultados ha vencido","extend-result.components.startFresh":"Empiece de nuevo o Guarde los resultados de","extend-result.components.successMessage":"La restauración de los resultados puede tardar hasta 24 horas.","extend-result.components.successTitle":"Los resultados fueron transferidos, según lo elegido","extend-result.components.successTitleStartedFresh":"Los resultados no han sido transferidos","manage-assign-course.components.defaultOptionCountry":"Seleccionar país","manage-assign-course.components.defaultOptionYearGroup":"Seleccionar año","manage-assign-course.components.noCoursesFound":"No se encontraron cursos","manage-assign-course.components.schoolCourses":"Cursos escolares","manage-assign-course.components.searchCourse":"Buscar un curso","manage-assign-course.components.selectCourse":"Seleccionar curso","manage-assign-course.components.startCourse":"Establecer un nuevo curso predeterminado","manageAssignCourse.components.backButton":"Volver","manageAssignCourse.components.emptyStateMessage":"No se encontraron clases","manageAssignCourse.components.pageSubTitle":"GESTIONAR LOS CURSOS ASIGNADOS","manageAssignCourse.components.pageTitle":"Cursos","manageAssignCourseAdmin.components.backButton":"Atrás","manageAssignCourseAdmin.components.emptyStateMessage":"No se encontraron clases","manageAssignCourseAdmin.components.pageSubTitle":"Seleccione un módulo de aprendizaje para comenzar","manageAssignCourseAdmin.components.pageTitle":"Administración de Cursos - Gestionar los cursos asignados","manageCourse.components.backButton":"Atrás","manageCourse.components.pageSubTitle":"Seleccione un Módulo de Aprendizaje para comenzar","manageCourse.components.pageTitle":"Administración de Cursos - Gestionar los cursos predeterminados","quick-upload.components.download":"Descargando","quick-upload.components.downloadStudentRoll":"Descargar plantilla","quick-upload.components.header":"Carga rápida","quick-upload.containers.errorMessageBody":"Intente subir su archivo de nuevo.","quick-upload.containers.errorMessageHeader":"¡Uy! Se produjo un error","quick-upload.containers.fileFormatValidationMessage":"Formato de archivo incorrecto","quick-upload.containers.newClasses":"clases nuevas","quick-upload.containers.newStudent":"alumnos nuevos","quick-upload.containers.newTeacher":"docentes nuevos","quick-upload.containers.quickUploadSuccessMessage":"Ha subido","quick-upload.containers.record":"registro","quick-upload.containers.row":"Fila","quick-upload.containers.success":"¡Éxito!","quick-upload.containers.unassignedStudent":"alumnos no asignados","quick-upload.containers.upatedTeacher":"docentes actualizados","quick-upload.containers.updatedClasses":"clases actualizadas","quick-upload.containers.updatedStudent":"alumnos actualizados","quick-upload.containers.validationMessage":"Vaya, su archivo contiene errores","roll-over.components.aboutToProceed":"Está a punto de realizar un ","roll-over.components.areYouSure":"¿Está seguro que desea continuar?","roll-over.components.assignedStudent":"ESTUDIANTE ASIGNADO","roll-over.components.assignedStudents":"ESTUDIANTES ASIGNADOS","roll-over.components.back":"Volver","roll-over.components.backButton":"Regresar","roll-over.components.buttonIcon":"?","roll-over.components.cancel":"Cancelar","roll-over.components.className":"NOMBRE DE LA CLASE","roll-over.components.closeButton":"Cerrar","roll-over.components.confirm":"Confirmar","roll-over.components.contentLabel":"Use la plantilla de abajo para subir nuevos estudiantes en","roll-over.components.done":"Listo","roll-over.components.download":"Descargar","roll-over.components.downloadSchoolDataBtn":"Descargar la Lista escolar actual","roll-over.components.downloadStudentRoll":"Descargar la plantilla","roll-over.components.downloadTemplateBtn":"Descargar la plantilla","roll-over.components.downloading":"Descargando","roll-over.components.errorsInYourFile":"Ups, hay algunos errores en su archivo","roll-over.components.exportSummary":"Exportar resumen","roll-over.components.fileFormatValidationMessage":"Formato de archivo incorrecto","roll-over.components.fileSizeMessage":"El tamaño del archivo es mayor de 1 MB","roll-over.components.firstName":"NOMBRE","roll-over.components.fullRollOver":"traspaso total.","roll-over.components.fullRolloverDesc1":"Esto actualizará TODOS los alumnos de {productName} en su lista escolar.","roll-over.components.fullRolloverDesc2":"En este traspaso se cancelará la asignación de los alumnos actuales de {productName} que no aparezcan en la lista, y no podrán acceder al recurso (a menos que los vuelva a asignar).","roll-over.components.fullRolloverTitle":"Traspaso completo","roll-over.components.header":"Traspasar","roll-over.components.includeBulkTransfer":"Incluir los nombres de usuario para transferencia masiva","roll-over.components.includeUnassigned":"Incluir en la descarga a los alumnos no asignados","roll-over.components.initialDownloadTemplate":"Presione el icono para descargar su matrícula escolar de {productName}","roll-over.components.initialTitle":"Siga estos pasos para completar un traspaso para {productName}","roll-over.components.initialUpdateSpreadsheet":"Actualice las hojas descargadas","roll-over.components.lastName":"APELLIDO","roll-over.components.newClasses":"clases nuevas","roll-over.components.newClassroomsFile":"ClasesNuevas.xlsx","roll-over.components.newStudent":"alumno nuevo","roll-over.components.newStudents":"alumnos nuevos","roll-over.components.newStudentsFile":"AlumnosNuevos.xlsx","roll-over.components.newTeacher":"docente nuevo","roll-over.components.newTeachers":"docentes nuevos","roll-over.components.newTeachersFile":"DocentesNuevos.xlsx","roll-over.components.nextButton":"Siguiente","roll-over.components.partialRollOver":"traspaso parcial.","roll-over.components.partialRolloverDesc1":"Esto sólo actualizará o añadirá a los alumnos de {productName} que se encuentran en la lista que subió.","roll-over.components.partialRolloverDesc2":"No se afectará ningún otro alumno o producto.","roll-over.components.partialRolloverTitle":"Traspaso parcial","roll-over.components.password":"CONTRASEÑA","roll-over.components.pleaseTryAgain":"Intenta nuevamente más tarde o ponte en contacto con el Soporte técnico","roll-over.components.pleaseTryUploadingAgain":"Intente subir su archivo de nuevo.","roll-over.components.previousUsername":"Nombre de usuario anterior","roll-over.components.print":"Imprimir","roll-over.components.proceed":"Proceder","roll-over.components.rollOverHasCompleted":"Se ha completado el traspaso. A continuación encontrará un resumen de este traspaso","roll-over.components.rolloverComplete":"Traspaso completo","roll-over.components.row":"Fila","roll-over.components.schoolRoll":"lista de matriculados","roll-over.components.selectionTitle":"Seleccione el tipo de traspaso que desea realizar","roll-over.components.signInCards":"las tarjetas de registro","roll-over.components.somethingWentWrong":"¡Uy! Se produjo un error","roll-over.components.somethingWrongOnOurSide":"Algo salió mal de nuestro lado y estamos trabajando en ello.","roll-over.components.studentFirstName":"NOMBRE DEL ESTUDIANTE","roll-over.components.studentSurname":"APELLIDO DEL ESTUDIANTE","roll-over.components.summary":"Resumen","roll-over.components.surname":"APELLIDO","roll-over.components.teacherEmail":"CORREO ELECTRÓNICO DEL MAESTRO","roll-over.components.teacherFirstName":"NOMBRE DEL MAESTRO","roll-over.components.teacherName":"NOMBRE COMPLETO DEL MAESTRO","roll-over.components.teacherSurname":"APELLIDO DEL MAESTRO","roll-over.components.theNewClasses":"las tarjetas de registro de las clases nuevas","roll-over.components.theNewStudent":"las tarjetas de registro de los alumnos nuevos","roll-over.components.theNewTeacher":"las tarjetas de registro de los docentes nuevos","roll-over.components.theTransferredStudent":"Tarjetas de registro de los alumnos transferidos","roll-over.components.theUnassignedStudent":"las tarjetas de registro de los alumnos no asignados","roll-over.components.theUnassignedTeacher":"las tarjetas de registro de los docentes no asignados","roll-over.components.theUpatedTeacher":"las tarjetas de registro de los docentes actualizados","roll-over.components.theUpdatedClasses":"las tarjetas de registro de las clases actualizadas","roll-over.components.theUpdatedStudent":"las tarjetas de registro de los alumnos actualizados","roll-over.components.title":"TÍTULO","roll-over.components.transferredStudent":"Alumno transferido","roll-over.components.transferredStudents":"Alumnos transferidos","roll-over.components.transferredStudentsFile":"AlumnosTransferidos.xlsx","roll-over.components.unassignedStudent":"alumno no asignado","roll-over.components.unassignedStudents":"alumnos no asignados","roll-over.components.unassignedStudentsFile":"AlumnosNoAsignados.xlsx","roll-over.components.unassignedTeachers":"docentes no asignados","roll-over.components.upatedTeacher":"docente actualizado","roll-over.components.updatedClasses":"clases actualizadas","roll-over.components.updatedClassroomsFile":"ClasesActualizadas.xlsx","roll-over.components.updatedStudent":"alumno actualizado","roll-over.components.updatedStudents":"alumnos actualizados","roll-over.components.updatedStudentsFile":"AlumnosActualizados.xlsx","roll-over.components.updatedTeachers":"docentes actualizados","roll-over.components.updatedTeachersFile":"DocentesActualizados.xlsx","roll-over.components.uploadFile":"Cargar archivo","roll-over.components.uploadMessage":"Suba su archivo excel (formato .xlsx) que quiere traspasar, después seleccione 'Confirmar' para proceder","roll-over.components.username":"Usuario","roll-over.components.verifying":"Verificando","roll-over.components.year":"AÑO","rollover.errorMessageBody":"","rollover.errorMessageHeader":"","rollover.pleaseTryAgain":"Intenta nuevamente más tarde o ponte en contacto con el Soporte técnico","rollover.somethingWentWrong":"Algo salió mal de nuestro lado y estamos trabajando en ello.","school-roll.container.classes":"Clases","school-roll.container.schoolRoll":"Descargar lista de la clase","school-roll.container.schoolRoll.classroomList":"Seleccione una clase {0}","school-roll.container.schoolRoll.defaultOptionCountry":"País","school-roll.container.schoolRoll.expiredLicense":"Licencia expirada","school-roll.container.schoolRoll.licenceSummary":"Licencias restantes","school-roll.container.student":"Estudiante","school-roll.container.students":"Estudiantes","school-roll.container.teacher":"Maestro","school-roll.container.teachers":"Maestros","sign-in-cards.components.allClasses":"Todas las clases","sign-in-cards.components.allTeachers":"Todos los maestros","sign-in-cards.components.code":"código","sign-in-cards.components.download":"Descargar tarjetas de registro","sign-in-cards.components.downloading":"Descargando","sign-in-cards.components.selectClass":"Selecciona una clase para descargar las tarjetas de registro","sign-in-cards.components.signInCards":"Tarjetas de registro","sign-in-cards.components.students":"Estudiantes","sign-in-cards.components.teachers":"Maestros","sign-in-cards.defaultOptionClassrooms":"Todas las clases","sign-in-cards.defaultOptionTeachers":"Todos los maestros","student-footer.components.bulkPasswordChange":"Cambio de contraseña masivo","student-footer.components.bulkPasswordChangeSucess":"Las contraseñas se han actualizado","student-footer.components.deleteConfirmation":"Algunos alumnos están asignados a clases en otros productos, por favor confirme para eliminar por completo de la Lista de la Escuela.","student-footer.components.deleteStudents":"Eliminar estudiantes","student-footer.components.deleteStudentsTitle":"¿Desea eliminar a el/los estudiante(s) seleccionado(s) de la lista de matriculados?","student-footer.components.downloadSignInCards":"Descargar tarjetas de registro","student-footer.components.downloading":"descargando","student-footer.components.mayLoseAccessToProducts":"y puede perder el acceso al producto actual.","student-footer.components.mayLoseAccessTselectedStudentsWillBeoProducts":"El/los estudiante(s) seleccionado(s) será(n)","student-footer.components.removedFromSchool":"y retirados de la lista de matriculados en todas las clases y productos","student-footer.components.selectedStudentWill":"El/los alumnos{s} seleccionado{s} será(n)","student-footer.components.studentRemoveConfirmation":"Los estudiantes seleccionados serán eliminados de la lista de la escuela","student-footer.components.studentsDeleted":"El/los estudiante(s) ha(n) sido eliminado(s)","student-footer.components.studentsUnassignedFooter":"El/los estudiante{s} ha(n) sido desasignado{s}","student-footer.components.unassign":"Desasignar","student-footer.components.unassignStudent":"Desasignar estudiante{s}","student-footer.components.unassignedFooter":"desasignados","student-header.components.addStudent":"Añadir estudiante","student-header.components.contentLabel":"Presione abajo para bajar la plantilla y añadir nuevos estudiantes en ","student-header.components.downloadStudentRoll":"Descargar la lista de estudiantes","student-header.components.downloading":"descargando","student-header.components.quickUpload":"Carga rápida","student-header.components.students":"Estudiantes","student-header.components.subTitle":"Carga rápida para","student-roll.container.studentRoll.UnassignedStudent":"Estudiantes sin asignar","student-roll.container.studentRoll.assignedStudents":"Estudiantes asignados","student-roll.container.studentRoll.defaultOptionStudentClass":"Todas las clases","student-roll.container.studentRoll.defaultOptionStudentLastName":"Todos los apellidos","student-roll.container.studentRoll.defaultOptionStudentYearGroup":"Todos los años","student-roll.container.studentRoll.deleteStudentSuccess":"{deletedStudentsCount} estudiantes retirados de la lista de matriculados","student-roll.container.studentRoll.errorOnDeletingAssignedStudents":"Error - algunos estudiantes seleccionados están asignados a clases y no se eliminarán","student-roll.container.studentRoll.partialDeleteMessage1":"Error - some selected students are assigned to classes and will not be deleted_es -","student-roll.container.studentRoll.partialDeleteMessage2":"Student(s) have been removed from the school roll_es","teacher-footer.components.bulkPasswordChange":"Cambio de contraseña masivo","teacher-footer.components.bulkPasswordChangeSucess":"Las contraseñas se han actualizado","teacher-footer.components.deleteConfirmation":"Algunos docentes están asignados a clases en otros productos, por favor confirme para eliminar por completo de la Lista de la Escuela.","teacher-footer.components.deleteTeachers":"Eliminar maestros","teacher-footer.components.deleteTeachersTitle":"¿Desea eliminar a el/los maestro(s) seleccionado(s) de la lista de matrícula?","teacher-footer.components.loseAccessToProducts":"y perderán todo acceso a sus productos con licencia","teacher-footer.components.removedFromSchool":"y retirados de la lista de matriculados en todas las clases y productos","teacher-footer.components.selectedTeacherWillBe":"Los maestros seleccionados se eliminarán de la lista de la escuela.","teacher-footer.components.sendVerificationEmails":"Intente cargar su archivo de nuevo.","teacher-footer.components.teachersDeleted":"El/los maestro(s) ha(n) sido eliminado(s)","teacher-footer.components.teachersUnassigned":"Los maestros han sido desasignados","teacher-footer.components.unassign":"Desasignar","teacher-footer.components.unassignTeachers":"Desasignar maestros","teacher-footer.components.unassigned":"desasignados","teacher-footer.components.wishToDelete":"¿Desea eliminar a el/los maestro(s) seleccionado(s) de la lista de matrícula?","teacher-header.components.downloadTeacherRoll":"Descargar la lista de maestros","teacher-header.components.downloading":"descargando","teacher-header.components.inviteTeacher":"Invitar a Maestro","teacher-header.components.quickUpload":"Carga rápida","teacher-header.components.teachers":"Maestros","teacher-roll.container.teacherRoll.UnassignedTeacher":"","teacher-roll.container.teacherRoll.classroomList":"","teacher-roll.container.teacherRoll.defaultOptionTeacherClass":"","teacher-roll.container.teacherRoll.defaultOptionTeacherLastName":"","teacher-roll.container.teacherRoll.deleteTeacherSuccessMessage":"{count} maestros retirados de la lista de matriculados","teacher-roll.container.teacherRoll.deleteTeacherWarningMessage":"Error - algunos maestros seleccionados están asignados a clases y no se eliminarán. {count} maestros retirados de la lista de matriculados","teacher-roll.container.teacherRoll.errorOnDeletingAssignedTeachers":"Error - algunos maestros seleccionados están asignados a clases","teacher-roll.container.teacherView.you":"Tú"}

/***/ }),
/* 1317 */,
/* 1318 */,
/* 1319 */,
/* 1320 */,
/* 1321 */,
/* 1322 */,
/* 1323 */,
/* 1324 */,
/* 1325 */,
/* 1326 */,
/* 1327 */,
/* 1328 */,
/* 1329 */,
/* 1330 */,
/* 1331 */,
/* 1332 */,
/* 1333 */,
/* 1334 */,
/* 1335 */,
/* 1336 */,
/* 1337 */,
/* 1338 */,
/* 1339 */,
/* 1340 */,
/* 1341 */,
/* 1342 */,
/* 1343 */,
/* 1344 */,
/* 1345 */,
/* 1346 */,
/* 1347 */,
/* 1348 */,
/* 1349 */,
/* 1350 */,
/* 1351 */,
/* 1352 */,
/* 1353 */,
/* 1354 */,
/* 1355 */,
/* 1356 */,
/* 1357 */,
/* 1358 */,
/* 1359 */,
/* 1360 */,
/* 1361 */,
/* 1362 */,
/* 1363 */,
/* 1364 */,
/* 1365 */,
/* 1366 */,
/* 1367 */,
/* 1368 */,
/* 1369 */,
/* 1370 */,
/* 1371 */,
/* 1372 */,
/* 1373 */,
/* 1374 */,
/* 1375 */,
/* 1376 */,
/* 1377 */,
/* 1378 */,
/* 1379 */,
/* 1380 */,
/* 1381 */,
/* 1382 */,
/* 1383 */,
/* 1384 */,
/* 1385 */,
/* 1386 */,
/* 1387 */,
/* 1388 */,
/* 1389 */,
/* 1390 */,
/* 1391 */,
/* 1392 */,
/* 1393 */,
/* 1394 */,
/* 1395 */,
/* 1396 */,
/* 1397 */,
/* 1398 */,
/* 1399 */,
/* 1400 */,
/* 1401 */,
/* 1402 */,
/* 1403 */,
/* 1404 */,
/* 1405 */,
/* 1406 */,
/* 1407 */,
/* 1408 */,
/* 1409 */,
/* 1410 */,
/* 1411 */,
/* 1412 */,
/* 1413 */,
/* 1414 */,
/* 1415 */,
/* 1416 */,
/* 1417 */,
/* 1418 */,
/* 1419 */,
/* 1420 */,
/* 1421 */,
/* 1422 */,
/* 1423 */,
/* 1424 */,
/* 1425 */,
/* 1426 */,
/* 1427 */,
/* 1428 */,
/* 1429 */,
/* 1430 */,
/* 1431 */,
/* 1432 */,
/* 1433 */,
/* 1434 */,
/* 1435 */,
/* 1436 */,
/* 1437 */,
/* 1438 */,
/* 1439 */,
/* 1440 */,
/* 1441 */,
/* 1442 */,
/* 1443 */,
/* 1444 */,
/* 1445 */,
/* 1446 */,
/* 1447 */,
/* 1448 */,
/* 1449 */,
/* 1450 */,
/* 1451 */,
/* 1452 */,
/* 1453 */,
/* 1454 */,
/* 1455 */,
/* 1456 */,
/* 1457 */,
/* 1458 */,
/* 1459 */,
/* 1460 */,
/* 1461 */,
/* 1462 */,
/* 1463 */,
/* 1464 */,
/* 1465 */,
/* 1466 */,
/* 1467 */,
/* 1468 */,
/* 1469 */,
/* 1470 */,
/* 1471 */,
/* 1472 */,
/* 1473 */,
/* 1474 */,
/* 1475 */,
/* 1476 */,
/* 1477 */,
/* 1478 */,
/* 1479 */,
/* 1480 */,
/* 1481 */,
/* 1482 */,
/* 1483 */,
/* 1484 */,
/* 1485 */,
/* 1486 */,
/* 1487 */,
/* 1488 */,
/* 1489 */,
/* 1490 */,
/* 1491 */,
/* 1492 */,
/* 1493 */,
/* 1494 */,
/* 1495 */,
/* 1496 */,
/* 1497 */,
/* 1498 */,
/* 1499 */,
/* 1500 */,
/* 1501 */,
/* 1502 */,
/* 1503 */,
/* 1504 */,
/* 1505 */,
/* 1506 */,
/* 1507 */,
/* 1508 */,
/* 1509 */,
/* 1510 */,
/* 1511 */,
/* 1512 */,
/* 1513 */,
/* 1514 */,
/* 1515 */,
/* 1516 */,
/* 1517 */,
/* 1518 */,
/* 1519 */,
/* 1520 */,
/* 1521 */,
/* 1522 */,
/* 1523 */,
/* 1524 */,
/* 1525 */,
/* 1526 */,
/* 1527 */,
/* 1528 */,
/* 1529 */,
/* 1530 */,
/* 1531 */,
/* 1532 */,
/* 1533 */,
/* 1534 */,
/* 1535 */,
/* 1536 */,
/* 1537 */,
/* 1538 */,
/* 1539 */,
/* 1540 */,
/* 1541 */,
/* 1542 */,
/* 1543 */,
/* 1544 */,
/* 1545 */,
/* 1546 */,
/* 1547 */,
/* 1548 */,
/* 1549 */,
/* 1550 */,
/* 1551 */,
/* 1552 */,
/* 1553 */,
/* 1554 */,
/* 1555 */,
/* 1556 */,
/* 1557 */,
/* 1558 */,
/* 1559 */,
/* 1560 */,
/* 1561 */,
/* 1562 */,
/* 1563 */,
/* 1564 */,
/* 1565 */,
/* 1566 */,
/* 1567 */,
/* 1568 */,
/* 1569 */,
/* 1570 */,
/* 1571 */,
/* 1572 */,
/* 1573 */,
/* 1574 */,
/* 1575 */,
/* 1576 */,
/* 1577 */,
/* 1578 */,
/* 1579 */,
/* 1580 */,
/* 1581 */,
/* 1582 */,
/* 1583 */,
/* 1584 */,
/* 1585 */,
/* 1586 */,
/* 1587 */,
/* 1588 */,
/* 1589 */,
/* 1590 */,
/* 1591 */,
/* 1592 */,
/* 1593 */,
/* 1594 */,
/* 1595 */,
/* 1596 */,
/* 1597 */,
/* 1598 */,
/* 1599 */,
/* 1600 */,
/* 1601 */,
/* 1602 */,
/* 1603 */,
/* 1604 */,
/* 1605 */,
/* 1606 */,
/* 1607 */,
/* 1608 */,
/* 1609 */,
/* 1610 */,
/* 1611 */,
/* 1612 */,
/* 1613 */,
/* 1614 */,
/* 1615 */,
/* 1616 */,
/* 1617 */,
/* 1618 */,
/* 1619 */,
/* 1620 */,
/* 1621 */,
/* 1622 */,
/* 1623 */,
/* 1624 */,
/* 1625 */,
/* 1626 */,
/* 1627 */,
/* 1628 */,
/* 1629 */,
/* 1630 */,
/* 1631 */,
/* 1632 */,
/* 1633 */,
/* 1634 */,
/* 1635 */,
/* 1636 */,
/* 1637 */,
/* 1638 */,
/* 1639 */,
/* 1640 */,
/* 1641 */,
/* 1642 */,
/* 1643 */,
/* 1644 */,
/* 1645 */,
/* 1646 */,
/* 1647 */,
/* 1648 */,
/* 1649 */,
/* 1650 */,
/* 1651 */,
/* 1652 */,
/* 1653 */,
/* 1654 */,
/* 1655 */,
/* 1656 */,
/* 1657 */,
/* 1658 */,
/* 1659 */,
/* 1660 */,
/* 1661 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1099);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(5)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../node_modules/css-loader/index.js?modules&localIdentName=[local]---[hash:base64:5]!../../../node_modules/postcss-loader/lib/index.js!../../../node_modules/sass-loader/index.js!./dropdown-list.scss", function() {
			var newContent = require("!!../../../node_modules/css-loader/index.js?modules&localIdentName=[local]---[hash:base64:5]!../../../node_modules/postcss-loader/lib/index.js!../../../node_modules/sass-loader/index.js!./dropdown-list.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1662 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1102);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(5)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../node_modules/css-loader/index.js?modules&localIdentName=[local]---[hash:base64:5]!../../../node_modules/postcss-loader/lib/index.js!../../../node_modules/sass-loader/index.js!./dropdown-list.scss", function() {
			var newContent = require("!!../../../node_modules/css-loader/index.js?modules&localIdentName=[local]---[hash:base64:5]!../../../node_modules/postcss-loader/lib/index.js!../../../node_modules/sass-loader/index.js!./dropdown-list.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1663 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1103);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(5)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../node_modules/css-loader/index.js?modules&localIdentName=[local]---[hash:base64:5]!../../../node_modules/postcss-loader/lib/index.js!../../../node_modules/sass-loader/index.js!./index.scss", function() {
			var newContent = require("!!../../../node_modules/css-loader/index.js?modules&localIdentName=[local]---[hash:base64:5]!../../../node_modules/postcss-loader/lib/index.js!../../../node_modules/sass-loader/index.js!./index.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1664 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1104);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(5)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../node_modules/css-loader/index.js?modules&localIdentName=[local]---[hash:base64:5]!../../../node_modules/postcss-loader/lib/index.js!../../../node_modules/sass-loader/index.js!./dropdown-list.scss", function() {
			var newContent = require("!!../../../node_modules/css-loader/index.js?modules&localIdentName=[local]---[hash:base64:5]!../../../node_modules/postcss-loader/lib/index.js!../../../node_modules/sass-loader/index.js!./dropdown-list.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1665 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1105);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(5)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../node_modules/css-loader/index.js?modules&localIdentName=[local]---[hash:base64:5]!../../../node_modules/postcss-loader/lib/index.js!../../../node_modules/sass-loader/index.js!./index.scss", function() {
			var newContent = require("!!../../../node_modules/css-loader/index.js?modules&localIdentName=[local]---[hash:base64:5]!../../../node_modules/postcss-loader/lib/index.js!../../../node_modules/sass-loader/index.js!./index.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1666 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1107);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(5)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../node_modules/css-loader/index.js?modules&localIdentName=[local]---[hash:base64:5]!../../../../node_modules/postcss-loader/lib/index.js!../../../../node_modules/sass-loader/index.js!./search.scss", function() {
			var newContent = require("!!../../../../node_modules/css-loader/index.js?modules&localIdentName=[local]---[hash:base64:5]!../../../../node_modules/postcss-loader/lib/index.js!../../../../node_modules/sass-loader/index.js!./search.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1667 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1109);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(5)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../node_modules/css-loader/index.js?modules&localIdentName=[local]---[hash:base64:5]!../../../../node_modules/postcss-loader/lib/index.js!../../../../node_modules/sass-loader/index.js!./search.scss", function() {
			var newContent = require("!!../../../../node_modules/css-loader/index.js?modules&localIdentName=[local]---[hash:base64:5]!../../../../node_modules/postcss-loader/lib/index.js!../../../../node_modules/sass-loader/index.js!./search.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1668 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1112);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(5)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../node_modules/css-loader/index.js?modules&localIdentName=[local]---[hash:base64:5]!../../../../node_modules/postcss-loader/lib/index.js!../../../../node_modules/sass-loader/index.js!./search.scss", function() {
			var newContent = require("!!../../../../node_modules/css-loader/index.js?modules&localIdentName=[local]---[hash:base64:5]!../../../../node_modules/postcss-loader/lib/index.js!../../../../node_modules/sass-loader/index.js!./search.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1669 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1113);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(5)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../node_modules/css-loader/index.js?modules&localIdentName=[local]---[hash:base64:5]!../../../node_modules/postcss-loader/lib/index.js!../../../node_modules/sass-loader/index.js!./index.scss", function() {
			var newContent = require("!!../../../node_modules/css-loader/index.js?modules&localIdentName=[local]---[hash:base64:5]!../../../node_modules/postcss-loader/lib/index.js!../../../node_modules/sass-loader/index.js!./index.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1670 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1114);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(5)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../node_modules/css-loader/index.js?modules&localIdentName=[local]---[hash:base64:5]!../../../node_modules/postcss-loader/lib/index.js!../../../node_modules/sass-loader/index.js!./index.scss", function() {
			var newContent = require("!!../../../node_modules/css-loader/index.js?modules&localIdentName=[local]---[hash:base64:5]!../../../node_modules/postcss-loader/lib/index.js!../../../node_modules/sass-loader/index.js!./index.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1671 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1115);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(5)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../node_modules/css-loader/index.js?modules&localIdentName=[local]---[hash:base64:5]!../../../node_modules/postcss-loader/lib/index.js!../../../node_modules/sass-loader/index.js!./index.scss", function() {
			var newContent = require("!!../../../node_modules/css-loader/index.js?modules&localIdentName=[local]---[hash:base64:5]!../../../node_modules/postcss-loader/lib/index.js!../../../node_modules/sass-loader/index.js!./index.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1672 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1116);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(5)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../node_modules/css-loader/index.js?modules&localIdentName=[local]---[hash:base64:5]!../../../node_modules/postcss-loader/lib/index.js!../../../node_modules/sass-loader/index.js!./index.scss", function() {
			var newContent = require("!!../../../node_modules/css-loader/index.js?modules&localIdentName=[local]---[hash:base64:5]!../../../node_modules/postcss-loader/lib/index.js!../../../node_modules/sass-loader/index.js!./index.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1673 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1117);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(5)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../node_modules/css-loader/index.js?modules&localIdentName=[local]---[hash:base64:5]!../../../node_modules/postcss-loader/lib/index.js!../../../node_modules/sass-loader/index.js!./index.scss", function() {
			var newContent = require("!!../../../node_modules/css-loader/index.js?modules&localIdentName=[local]---[hash:base64:5]!../../../node_modules/postcss-loader/lib/index.js!../../../node_modules/sass-loader/index.js!./index.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1674 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1118);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(5)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../node_modules/css-loader/index.js?modules&localIdentName=[local]---[hash:base64:5]!../../../node_modules/postcss-loader/lib/index.js!../../../node_modules/sass-loader/index.js!./index.scss", function() {
			var newContent = require("!!../../../node_modules/css-loader/index.js?modules&localIdentName=[local]---[hash:base64:5]!../../../node_modules/postcss-loader/lib/index.js!../../../node_modules/sass-loader/index.js!./index.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1675 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1119);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(5)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../node_modules/css-loader/index.js?modules&localIdentName=[local]---[hash:base64:5]!../../../node_modules/postcss-loader/lib/index.js!../../../node_modules/sass-loader/index.js!./index.scss", function() {
			var newContent = require("!!../../../node_modules/css-loader/index.js?modules&localIdentName=[local]---[hash:base64:5]!../../../node_modules/postcss-loader/lib/index.js!../../../node_modules/sass-loader/index.js!./index.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1676 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1120);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(5)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../node_modules/css-loader/index.js?modules&localIdentName=[local]---[hash:base64:5]!../../../node_modules/postcss-loader/lib/index.js!../../../node_modules/sass-loader/index.js!./index.scss", function() {
			var newContent = require("!!../../../node_modules/css-loader/index.js?modules&localIdentName=[local]---[hash:base64:5]!../../../node_modules/postcss-loader/lib/index.js!../../../node_modules/sass-loader/index.js!./index.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1677 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1121);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(5)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../node_modules/css-loader/index.js?modules&localIdentName=[local]---[hash:base64:5]!../../../node_modules/postcss-loader/lib/index.js!../../../node_modules/sass-loader/index.js!./text-input.scss", function() {
			var newContent = require("!!../../../node_modules/css-loader/index.js?modules&localIdentName=[local]---[hash:base64:5]!../../../node_modules/postcss-loader/lib/index.js!../../../node_modules/sass-loader/index.js!./text-input.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1678 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1122);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(5)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../node_modules/css-loader/index.js?modules&localIdentName=[local]---[hash:base64:5]!../../../node_modules/postcss-loader/lib/index.js!../../../node_modules/sass-loader/index.js!./index.scss", function() {
			var newContent = require("!!../../../node_modules/css-loader/index.js?modules&localIdentName=[local]---[hash:base64:5]!../../../node_modules/postcss-loader/lib/index.js!../../../node_modules/sass-loader/index.js!./index.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1679 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1123);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(5)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../node_modules/css-loader/index.js?modules&localIdentName=[local]---[hash:base64:5]!../../../node_modules/postcss-loader/lib/index.js!../../../node_modules/sass-loader/index.js!./index.scss", function() {
			var newContent = require("!!../../../node_modules/css-loader/index.js?modules&localIdentName=[local]---[hash:base64:5]!../../../node_modules/postcss-loader/lib/index.js!../../../node_modules/sass-loader/index.js!./index.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1680 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1124);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(5)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../node_modules/css-loader/index.js?modules&localIdentName=[local]---[hash:base64:5]!../../../node_modules/postcss-loader/lib/index.js!../../../node_modules/sass-loader/index.js!./box.scss", function() {
			var newContent = require("!!../../../node_modules/css-loader/index.js?modules&localIdentName=[local]---[hash:base64:5]!../../../node_modules/postcss-loader/lib/index.js!../../../node_modules/sass-loader/index.js!./box.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1681 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1125);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(5)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../node_modules/css-loader/index.js?modules&localIdentName=[local]---[hash:base64:5]!../../../node_modules/postcss-loader/lib/index.js!../../../node_modules/sass-loader/index.js!./index.scss", function() {
			var newContent = require("!!../../../node_modules/css-loader/index.js?modules&localIdentName=[local]---[hash:base64:5]!../../../node_modules/postcss-loader/lib/index.js!../../../node_modules/sass-loader/index.js!./index.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1682 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1126);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(5)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../node_modules/css-loader/index.js?modules&localIdentName=[local]---[hash:base64:5]!../../../../node_modules/postcss-loader/lib/index.js!../../../../node_modules/sass-loader/index.js!./circle-with-icon.scss", function() {
			var newContent = require("!!../../../../node_modules/css-loader/index.js?modules&localIdentName=[local]---[hash:base64:5]!../../../../node_modules/postcss-loader/lib/index.js!../../../../node_modules/sass-loader/index.js!./circle-with-icon.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1683 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1127);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(5)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../node_modules/css-loader/index.js?modules&localIdentName=[local]---[hash:base64:5]!../../../node_modules/postcss-loader/lib/index.js!../../../node_modules/sass-loader/index.js!./confirm.scss", function() {
			var newContent = require("!!../../../node_modules/css-loader/index.js?modules&localIdentName=[local]---[hash:base64:5]!../../../node_modules/postcss-loader/lib/index.js!../../../node_modules/sass-loader/index.js!./confirm.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1684 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1129);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(5)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../node_modules/css-loader/index.js?modules&localIdentName=[local]---[hash:base64:5]!../../../node_modules/postcss-loader/lib/index.js!../../../node_modules/sass-loader/index.js!./index.scss", function() {
			var newContent = require("!!../../../node_modules/css-loader/index.js?modules&localIdentName=[local]---[hash:base64:5]!../../../node_modules/postcss-loader/lib/index.js!../../../node_modules/sass-loader/index.js!./index.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1685 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1130);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(5)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../node_modules/css-loader/index.js?modules&localIdentName=[local]---[hash:base64:5]!../../../node_modules/postcss-loader/lib/index.js!../../../node_modules/sass-loader/index.js!./index.scss", function() {
			var newContent = require("!!../../../node_modules/css-loader/index.js?modules&localIdentName=[local]---[hash:base64:5]!../../../node_modules/postcss-loader/lib/index.js!../../../node_modules/sass-loader/index.js!./index.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1686 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1131);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(5)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../node_modules/css-loader/index.js?modules&localIdentName=[local]---[hash:base64:5]!../../../node_modules/postcss-loader/lib/index.js!../../../node_modules/sass-loader/index.js!./index.scss", function() {
			var newContent = require("!!../../../node_modules/css-loader/index.js?modules&localIdentName=[local]---[hash:base64:5]!../../../node_modules/postcss-loader/lib/index.js!../../../node_modules/sass-loader/index.js!./index.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1687 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1132);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(5)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../node_modules/css-loader/index.js?modules&localIdentName=[local]---[hash:base64:5]!../../../node_modules/postcss-loader/lib/index.js!../../../node_modules/sass-loader/index.js!./dropdown-list.scss", function() {
			var newContent = require("!!../../../node_modules/css-loader/index.js?modules&localIdentName=[local]---[hash:base64:5]!../../../node_modules/postcss-loader/lib/index.js!../../../node_modules/sass-loader/index.js!./dropdown-list.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1688 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1133);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(5)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../node_modules/css-loader/index.js?modules&localIdentName=[local]---[hash:base64:5]!../../../node_modules/postcss-loader/lib/index.js!../../../node_modules/sass-loader/index.js!./index.scss", function() {
			var newContent = require("!!../../../node_modules/css-loader/index.js?modules&localIdentName=[local]---[hash:base64:5]!../../../node_modules/postcss-loader/lib/index.js!../../../node_modules/sass-loader/index.js!./index.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1689 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1134);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(5)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../node_modules/css-loader/index.js?modules&localIdentName=[local]---[hash:base64:5]!../../../node_modules/postcss-loader/lib/index.js!../../../node_modules/sass-loader/index.js!./text-input.scss", function() {
			var newContent = require("!!../../../node_modules/css-loader/index.js?modules&localIdentName=[local]---[hash:base64:5]!../../../node_modules/postcss-loader/lib/index.js!../../../node_modules/sass-loader/index.js!./text-input.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1690 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1135);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(5)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../node_modules/css-loader/index.js?modules&localIdentName=[local]---[hash:base64:5]!../../../node_modules/postcss-loader/lib/index.js!../../../node_modules/sass-loader/index.js!./index.scss", function() {
			var newContent = require("!!../../../node_modules/css-loader/index.js?modules&localIdentName=[local]---[hash:base64:5]!../../../node_modules/postcss-loader/lib/index.js!../../../node_modules/sass-loader/index.js!./index.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1691 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1136);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(5)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../node_modules/css-loader/index.js?modules&localIdentName=[local]---[hash:base64:5]!../../../node_modules/postcss-loader/lib/index.js!../../../node_modules/sass-loader/index.js!./index.scss", function() {
			var newContent = require("!!../../../node_modules/css-loader/index.js?modules&localIdentName=[local]---[hash:base64:5]!../../../node_modules/postcss-loader/lib/index.js!../../../node_modules/sass-loader/index.js!./index.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1692 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1137);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(5)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../node_modules/css-loader/index.js?modules&localIdentName=[local]---[hash:base64:5]!../../../node_modules/postcss-loader/lib/index.js!../../../node_modules/sass-loader/index.js!./index.scss", function() {
			var newContent = require("!!../../../node_modules/css-loader/index.js?modules&localIdentName=[local]---[hash:base64:5]!../../../node_modules/postcss-loader/lib/index.js!../../../node_modules/sass-loader/index.js!./index.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1693 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1138);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(5)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../node_modules/css-loader/index.js?modules&localIdentName=[local]---[hash:base64:5]!../../../node_modules/postcss-loader/lib/index.js!../../../node_modules/sass-loader/index.js!./index.scss", function() {
			var newContent = require("!!../../../node_modules/css-loader/index.js?modules&localIdentName=[local]---[hash:base64:5]!../../../node_modules/postcss-loader/lib/index.js!../../../node_modules/sass-loader/index.js!./index.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1694 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1139);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(5)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../node_modules/css-loader/index.js?modules&localIdentName=[local]---[hash:base64:5]!../../../node_modules/postcss-loader/lib/index.js!../../../node_modules/sass-loader/index.js!./index.scss", function() {
			var newContent = require("!!../../../node_modules/css-loader/index.js?modules&localIdentName=[local]---[hash:base64:5]!../../../node_modules/postcss-loader/lib/index.js!../../../node_modules/sass-loader/index.js!./index.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1695 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1140);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(5)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../node_modules/css-loader/index.js?modules&localIdentName=[local]---[hash:base64:5]!../../../node_modules/postcss-loader/lib/index.js!../../../node_modules/sass-loader/index.js!./index.scss", function() {
			var newContent = require("!!../../../node_modules/css-loader/index.js?modules&localIdentName=[local]---[hash:base64:5]!../../../node_modules/postcss-loader/lib/index.js!../../../node_modules/sass-loader/index.js!./index.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1696 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1141);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(5)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../node_modules/css-loader/index.js?modules&localIdentName=[local]---[hash:base64:5]!../../../node_modules/postcss-loader/lib/index.js!../../../node_modules/sass-loader/index.js!./index.scss", function() {
			var newContent = require("!!../../../node_modules/css-loader/index.js?modules&localIdentName=[local]---[hash:base64:5]!../../../node_modules/postcss-loader/lib/index.js!../../../node_modules/sass-loader/index.js!./index.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1697 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1142);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(5)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../node_modules/css-loader/index.js?modules&localIdentName=[local]---[hash:base64:5]!../../../node_modules/postcss-loader/lib/index.js!../../../node_modules/sass-loader/index.js!./index.scss", function() {
			var newContent = require("!!../../../node_modules/css-loader/index.js?modules&localIdentName=[local]---[hash:base64:5]!../../../node_modules/postcss-loader/lib/index.js!../../../node_modules/sass-loader/index.js!./index.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1698 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1143);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(5)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../node_modules/css-loader/index.js?modules&localIdentName=[local]---[hash:base64:5]!../../../node_modules/postcss-loader/lib/index.js!../../../node_modules/sass-loader/index.js!./index.scss", function() {
			var newContent = require("!!../../../node_modules/css-loader/index.js?modules&localIdentName=[local]---[hash:base64:5]!../../../node_modules/postcss-loader/lib/index.js!../../../node_modules/sass-loader/index.js!./index.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1699 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1144);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(5)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../node_modules/css-loader/index.js?modules&localIdentName=[local]---[hash:base64:5]!../../../node_modules/postcss-loader/lib/index.js!../../../node_modules/sass-loader/index.js!./index.scss", function() {
			var newContent = require("!!../../../node_modules/css-loader/index.js?modules&localIdentName=[local]---[hash:base64:5]!../../../node_modules/postcss-loader/lib/index.js!../../../node_modules/sass-loader/index.js!./index.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1700 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1146);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(5)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../node_modules/css-loader/index.js?modules&localIdentName=[local]---[hash:base64:5]!../../../node_modules/postcss-loader/lib/index.js!../../../node_modules/sass-loader/index.js!./index.scss", function() {
			var newContent = require("!!../../../node_modules/css-loader/index.js?modules&localIdentName=[local]---[hash:base64:5]!../../../node_modules/postcss-loader/lib/index.js!../../../node_modules/sass-loader/index.js!./index.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1701 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1150);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(5)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../node_modules/css-loader/index.js?modules&localIdentName=[local]---[hash:base64:5]!../../../node_modules/postcss-loader/lib/index.js!../../../node_modules/sass-loader/index.js!./index.scss", function() {
			var newContent = require("!!../../../node_modules/css-loader/index.js?modules&localIdentName=[local]---[hash:base64:5]!../../../node_modules/postcss-loader/lib/index.js!../../../node_modules/sass-loader/index.js!./index.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1702 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1152);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(5)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../node_modules/css-loader/index.js?modules&localIdentName=[local]---[hash:base64:5]!../../../node_modules/postcss-loader/lib/index.js!../../../node_modules/sass-loader/index.js!./index.scss", function() {
			var newContent = require("!!../../../node_modules/css-loader/index.js?modules&localIdentName=[local]---[hash:base64:5]!../../../node_modules/postcss-loader/lib/index.js!../../../node_modules/sass-loader/index.js!./index.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1703 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1153);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(5)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../node_modules/css-loader/index.js?modules&localIdentName=[local]---[hash:base64:5]!../../../node_modules/postcss-loader/lib/index.js!../../../node_modules/sass-loader/index.js!./index.scss", function() {
			var newContent = require("!!../../../node_modules/css-loader/index.js?modules&localIdentName=[local]---[hash:base64:5]!../../../node_modules/postcss-loader/lib/index.js!../../../node_modules/sass-loader/index.js!./index.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1704 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1154);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(5)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../node_modules/css-loader/index.js?modules&localIdentName=[local]---[hash:base64:5]!../../../node_modules/postcss-loader/lib/index.js!../../../node_modules/sass-loader/index.js!./index.scss", function() {
			var newContent = require("!!../../../node_modules/css-loader/index.js?modules&localIdentName=[local]---[hash:base64:5]!../../../node_modules/postcss-loader/lib/index.js!../../../node_modules/sass-loader/index.js!./index.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1705 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1155);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(5)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../node_modules/css-loader/index.js?modules&localIdentName=[local]---[hash:base64:5]!../../../node_modules/postcss-loader/lib/index.js!../../../node_modules/sass-loader/index.js!./index.scss", function() {
			var newContent = require("!!../../../node_modules/css-loader/index.js?modules&localIdentName=[local]---[hash:base64:5]!../../../node_modules/postcss-loader/lib/index.js!../../../node_modules/sass-loader/index.js!./index.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1706 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1156);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(5)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../node_modules/css-loader/index.js?modules&localIdentName=[local]---[hash:base64:5]!../../../node_modules/postcss-loader/lib/index.js!../../../node_modules/sass-loader/index.js!./index.scss", function() {
			var newContent = require("!!../../../node_modules/css-loader/index.js?modules&localIdentName=[local]---[hash:base64:5]!../../../node_modules/postcss-loader/lib/index.js!../../../node_modules/sass-loader/index.js!./index.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1707 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1157);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(5)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../node_modules/css-loader/index.js?modules&localIdentName=[local]---[hash:base64:5]!../../../node_modules/postcss-loader/lib/index.js!../../../node_modules/sass-loader/index.js!./index.scss", function() {
			var newContent = require("!!../../../node_modules/css-loader/index.js?modules&localIdentName=[local]---[hash:base64:5]!../../../node_modules/postcss-loader/lib/index.js!../../../node_modules/sass-loader/index.js!./index.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1708 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1159);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(5)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../node_modules/css-loader/index.js?modules&localIdentName=[local]---[hash:base64:5]!../../../node_modules/postcss-loader/lib/index.js!../../../node_modules/sass-loader/index.js!./index.scss", function() {
			var newContent = require("!!../../../node_modules/css-loader/index.js?modules&localIdentName=[local]---[hash:base64:5]!../../../node_modules/postcss-loader/lib/index.js!../../../node_modules/sass-loader/index.js!./index.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1709 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1160);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(5)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../node_modules/css-loader/index.js?modules&localIdentName=[local]---[hash:base64:5]!../../../../node_modules/postcss-loader/lib/index.js!../../../../node_modules/sass-loader/index.js!./index.scss", function() {
			var newContent = require("!!../../../../node_modules/css-loader/index.js?modules&localIdentName=[local]---[hash:base64:5]!../../../../node_modules/postcss-loader/lib/index.js!../../../../node_modules/sass-loader/index.js!./index.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1710 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1161);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(5)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../node_modules/css-loader/index.js?modules&localIdentName=[local]---[hash:base64:5]!../../../../node_modules/postcss-loader/lib/index.js!../../../../node_modules/sass-loader/index.js!./index.scss", function() {
			var newContent = require("!!../../../../node_modules/css-loader/index.js?modules&localIdentName=[local]---[hash:base64:5]!../../../../node_modules/postcss-loader/lib/index.js!../../../../node_modules/sass-loader/index.js!./index.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1711 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1162);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(5)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../node_modules/css-loader/index.js?modules&localIdentName=[local]---[hash:base64:5]!../../../../node_modules/postcss-loader/lib/index.js!../../../../node_modules/sass-loader/index.js!./index.scss", function() {
			var newContent = require("!!../../../../node_modules/css-loader/index.js?modules&localIdentName=[local]---[hash:base64:5]!../../../../node_modules/postcss-loader/lib/index.js!../../../../node_modules/sass-loader/index.js!./index.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1712 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1163);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(5)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../node_modules/css-loader/index.js?modules&localIdentName=[local]---[hash:base64:5]!../../../../node_modules/postcss-loader/lib/index.js!../../../../node_modules/sass-loader/index.js!./index.scss", function() {
			var newContent = require("!!../../../../node_modules/css-loader/index.js?modules&localIdentName=[local]---[hash:base64:5]!../../../../node_modules/postcss-loader/lib/index.js!../../../../node_modules/sass-loader/index.js!./index.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1713 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1164);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(5)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../node_modules/css-loader/index.js?modules&localIdentName=[local]---[hash:base64:5]!../../../../node_modules/postcss-loader/lib/index.js!../../../../node_modules/sass-loader/index.js!./index.scss", function() {
			var newContent = require("!!../../../../node_modules/css-loader/index.js?modules&localIdentName=[local]---[hash:base64:5]!../../../../node_modules/postcss-loader/lib/index.js!../../../../node_modules/sass-loader/index.js!./index.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1714 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1165);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(5)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../node_modules/css-loader/index.js?modules&localIdentName=[local]---[hash:base64:5]!../../../node_modules/postcss-loader/lib/index.js!../../../node_modules/sass-loader/index.js!./index.scss", function() {
			var newContent = require("!!../../../node_modules/css-loader/index.js?modules&localIdentName=[local]---[hash:base64:5]!../../../node_modules/postcss-loader/lib/index.js!../../../node_modules/sass-loader/index.js!./index.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1715 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1166);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(5)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../node_modules/css-loader/index.js?modules&localIdentName=[local]---[hash:base64:5]!../../../node_modules/postcss-loader/lib/index.js!../../../node_modules/sass-loader/index.js!./index.scss", function() {
			var newContent = require("!!../../../node_modules/css-loader/index.js?modules&localIdentName=[local]---[hash:base64:5]!../../../node_modules/postcss-loader/lib/index.js!../../../node_modules/sass-loader/index.js!./index.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1716 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1168);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(5)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../node_modules/css-loader/index.js?modules&localIdentName=[local]---[hash:base64:5]!../../../../node_modules/postcss-loader/lib/index.js!../../../../node_modules/sass-loader/index.js!./course-topics.scss", function() {
			var newContent = require("!!../../../../node_modules/css-loader/index.js?modules&localIdentName=[local]---[hash:base64:5]!../../../../node_modules/postcss-loader/lib/index.js!../../../../node_modules/sass-loader/index.js!./course-topics.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1717 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1170);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(5)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../node_modules/css-loader/index.js?modules&localIdentName=[local]---[hash:base64:5]!../../../../node_modules/postcss-loader/lib/index.js!../../../../node_modules/sass-loader/index.js!./course-topics.scss", function() {
			var newContent = require("!!../../../../node_modules/css-loader/index.js?modules&localIdentName=[local]---[hash:base64:5]!../../../../node_modules/postcss-loader/lib/index.js!../../../../node_modules/sass-loader/index.js!./course-topics.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1718 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1171);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(5)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../node_modules/css-loader/index.js?modules&localIdentName=[local]---[hash:base64:5]!../../../node_modules/postcss-loader/lib/index.js!../../../node_modules/sass-loader/index.js!./index.scss", function() {
			var newContent = require("!!../../../node_modules/css-loader/index.js?modules&localIdentName=[local]---[hash:base64:5]!../../../node_modules/postcss-loader/lib/index.js!../../../node_modules/sass-loader/index.js!./index.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1719 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1172);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(5)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../node_modules/css-loader/index.js?modules&localIdentName=[local]---[hash:base64:5]!../../../node_modules/postcss-loader/lib/index.js!../../../node_modules/sass-loader/index.js!./index.scss", function() {
			var newContent = require("!!../../../node_modules/css-loader/index.js?modules&localIdentName=[local]---[hash:base64:5]!../../../node_modules/postcss-loader/lib/index.js!../../../node_modules/sass-loader/index.js!./index.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1720 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1173);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(5)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../node_modules/css-loader/index.js?modules&localIdentName=[local]---[hash:base64:5]!../../../node_modules/postcss-loader/lib/index.js!../../../node_modules/sass-loader/index.js!./index.scss", function() {
			var newContent = require("!!../../../node_modules/css-loader/index.js?modules&localIdentName=[local]---[hash:base64:5]!../../../node_modules/postcss-loader/lib/index.js!../../../node_modules/sass-loader/index.js!./index.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1721 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1174);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(5)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../node_modules/css-loader/index.js?modules&localIdentName=[local]---[hash:base64:5]!../../../node_modules/postcss-loader/lib/index.js!../../../node_modules/sass-loader/index.js!./index.scss", function() {
			var newContent = require("!!../../../node_modules/css-loader/index.js?modules&localIdentName=[local]---[hash:base64:5]!../../../node_modules/postcss-loader/lib/index.js!../../../node_modules/sass-loader/index.js!./index.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1722 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1175);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(5)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../node_modules/css-loader/index.js?modules&localIdentName=[local]---[hash:base64:5]!../../../node_modules/postcss-loader/lib/index.js!../../../node_modules/sass-loader/index.js!./index.scss", function() {
			var newContent = require("!!../../../node_modules/css-loader/index.js?modules&localIdentName=[local]---[hash:base64:5]!../../../node_modules/postcss-loader/lib/index.js!../../../node_modules/sass-loader/index.js!./index.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1723 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1176);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(5)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../node_modules/css-loader/index.js?modules&localIdentName=[local]---[hash:base64:5]!../../../node_modules/postcss-loader/lib/index.js!../../../node_modules/sass-loader/index.js!./index.scss", function() {
			var newContent = require("!!../../../node_modules/css-loader/index.js?modules&localIdentName=[local]---[hash:base64:5]!../../../node_modules/postcss-loader/lib/index.js!../../../node_modules/sass-loader/index.js!./index.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1724 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1178);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(5)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../node_modules/css-loader/index.js?modules&localIdentName=[local]---[hash:base64:5]!../../../node_modules/postcss-loader/lib/index.js!../../../node_modules/sass-loader/index.js!./index.scss", function() {
			var newContent = require("!!../../../node_modules/css-loader/index.js?modules&localIdentName=[local]---[hash:base64:5]!../../../node_modules/postcss-loader/lib/index.js!../../../node_modules/sass-loader/index.js!./index.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1725 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1179);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(5)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../node_modules/css-loader/index.js?modules&localIdentName=[local]---[hash:base64:5]!../../../node_modules/postcss-loader/lib/index.js!../../../node_modules/sass-loader/index.js!./index.scss", function() {
			var newContent = require("!!../../../node_modules/css-loader/index.js?modules&localIdentName=[local]---[hash:base64:5]!../../../node_modules/postcss-loader/lib/index.js!../../../node_modules/sass-loader/index.js!./index.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1726 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1180);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(5)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../node_modules/css-loader/index.js?modules&localIdentName=[local]---[hash:base64:5]!../../../node_modules/postcss-loader/lib/index.js!../../../node_modules/sass-loader/index.js!./index.scss", function() {
			var newContent = require("!!../../../node_modules/css-loader/index.js?modules&localIdentName=[local]---[hash:base64:5]!../../../node_modules/postcss-loader/lib/index.js!../../../node_modules/sass-loader/index.js!./index.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1727 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1181);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(5)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../node_modules/css-loader/index.js?modules&localIdentName=[local]---[hash:base64:5]!../../../node_modules/postcss-loader/lib/index.js!../../../node_modules/sass-loader/index.js!./index.scss", function() {
			var newContent = require("!!../../../node_modules/css-loader/index.js?modules&localIdentName=[local]---[hash:base64:5]!../../../node_modules/postcss-loader/lib/index.js!../../../node_modules/sass-loader/index.js!./index.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1728 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1182);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(5)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../node_modules/css-loader/index.js?modules&localIdentName=[local]---[hash:base64:5]!../../../node_modules/postcss-loader/lib/index.js!../../../node_modules/sass-loader/index.js!./dropdown-list.scss", function() {
			var newContent = require("!!../../../node_modules/css-loader/index.js?modules&localIdentName=[local]---[hash:base64:5]!../../../node_modules/postcss-loader/lib/index.js!../../../node_modules/sass-loader/index.js!./dropdown-list.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1729 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1184);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(5)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../node_modules/css-loader/index.js?modules&localIdentName=[local]---[hash:base64:5]!../../../node_modules/postcss-loader/lib/index.js!../../../node_modules/sass-loader/index.js!./index.scss", function() {
			var newContent = require("!!../../../node_modules/css-loader/index.js?modules&localIdentName=[local]---[hash:base64:5]!../../../node_modules/postcss-loader/lib/index.js!../../../node_modules/sass-loader/index.js!./index.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1730 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1185);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(5)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../node_modules/css-loader/index.js?modules&localIdentName=[local]---[hash:base64:5]!../../../node_modules/postcss-loader/lib/index.js!../../../node_modules/sass-loader/index.js!./index.scss", function() {
			var newContent = require("!!../../../node_modules/css-loader/index.js?modules&localIdentName=[local]---[hash:base64:5]!../../../node_modules/postcss-loader/lib/index.js!../../../node_modules/sass-loader/index.js!./index.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1731 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1186);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(5)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../node_modules/css-loader/index.js?modules&localIdentName=[local]---[hash:base64:5]!../../../node_modules/postcss-loader/lib/index.js!../../../node_modules/sass-loader/index.js!./index.scss", function() {
			var newContent = require("!!../../../node_modules/css-loader/index.js?modules&localIdentName=[local]---[hash:base64:5]!../../../node_modules/postcss-loader/lib/index.js!../../../node_modules/sass-loader/index.js!./index.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1732 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1187);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(5)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../node_modules/css-loader/index.js?modules&localIdentName=[local]---[hash:base64:5]!../../../node_modules/postcss-loader/lib/index.js!../../../node_modules/sass-loader/index.js!./index.scss", function() {
			var newContent = require("!!../../../node_modules/css-loader/index.js?modules&localIdentName=[local]---[hash:base64:5]!../../../node_modules/postcss-loader/lib/index.js!../../../node_modules/sass-loader/index.js!./index.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1733 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1188);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(5)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../node_modules/css-loader/index.js?modules&localIdentName=[local]---[hash:base64:5]!../../../node_modules/postcss-loader/lib/index.js!../../../node_modules/sass-loader/index.js!./index.scss", function() {
			var newContent = require("!!../../../node_modules/css-loader/index.js?modules&localIdentName=[local]---[hash:base64:5]!../../../node_modules/postcss-loader/lib/index.js!../../../node_modules/sass-loader/index.js!./index.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1734 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1189);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(5)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../node_modules/css-loader/index.js?modules&localIdentName=[local]---[hash:base64:5]!../../../node_modules/postcss-loader/lib/index.js!../../../node_modules/sass-loader/index.js!./dropdown-list.scss", function() {
			var newContent = require("!!../../../node_modules/css-loader/index.js?modules&localIdentName=[local]---[hash:base64:5]!../../../node_modules/postcss-loader/lib/index.js!../../../node_modules/sass-loader/index.js!./dropdown-list.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1735 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1190);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(5)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../node_modules/css-loader/index.js?modules&localIdentName=[local]---[hash:base64:5]!../../../node_modules/postcss-loader/lib/index.js!../../../node_modules/sass-loader/index.js!./index.scss", function() {
			var newContent = require("!!../../../node_modules/css-loader/index.js?modules&localIdentName=[local]---[hash:base64:5]!../../../node_modules/postcss-loader/lib/index.js!../../../node_modules/sass-loader/index.js!./index.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1736 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1191);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(5)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../node_modules/css-loader/index.js?modules&localIdentName=[local]---[hash:base64:5]!../../../node_modules/postcss-loader/lib/index.js!../../../node_modules/sass-loader/index.js!./text-input.scss", function() {
			var newContent = require("!!../../../node_modules/css-loader/index.js?modules&localIdentName=[local]---[hash:base64:5]!../../../node_modules/postcss-loader/lib/index.js!../../../node_modules/sass-loader/index.js!./text-input.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1737 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1192);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(5)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../node_modules/css-loader/index.js?modules&localIdentName=[local]---[hash:base64:5]!../../../node_modules/postcss-loader/lib/index.js!../../../node_modules/sass-loader/index.js!./index.scss", function() {
			var newContent = require("!!../../../node_modules/css-loader/index.js?modules&localIdentName=[local]---[hash:base64:5]!../../../node_modules/postcss-loader/lib/index.js!../../../node_modules/sass-loader/index.js!./index.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1738 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1193);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(5)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../node_modules/css-loader/index.js?modules&localIdentName=[local]---[hash:base64:5]!../../../node_modules/postcss-loader/lib/index.js!../../../node_modules/sass-loader/index.js!./index.scss", function() {
			var newContent = require("!!../../../node_modules/css-loader/index.js?modules&localIdentName=[local]---[hash:base64:5]!../../../node_modules/postcss-loader/lib/index.js!../../../node_modules/sass-loader/index.js!./index.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1739 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1194);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(5)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../node_modules/css-loader/index.js?modules&localIdentName=[local]---[hash:base64:5]!../../../node_modules/postcss-loader/lib/index.js!../../../node_modules/sass-loader/index.js!./index.scss", function() {
			var newContent = require("!!../../../node_modules/css-loader/index.js?modules&localIdentName=[local]---[hash:base64:5]!../../../node_modules/postcss-loader/lib/index.js!../../../node_modules/sass-loader/index.js!./index.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1740 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1195);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(5)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../node_modules/css-loader/index.js?modules&localIdentName=[local]---[hash:base64:5]!../../../node_modules/postcss-loader/lib/index.js!../../../node_modules/sass-loader/index.js!./index.scss", function() {
			var newContent = require("!!../../../node_modules/css-loader/index.js?modules&localIdentName=[local]---[hash:base64:5]!../../../node_modules/postcss-loader/lib/index.js!../../../node_modules/sass-loader/index.js!./index.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1741 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1196);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(5)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../node_modules/css-loader/index.js?modules&localIdentName=[local]---[hash:base64:5]!../../../node_modules/postcss-loader/lib/index.js!../../../node_modules/sass-loader/index.js!./index.scss", function() {
			var newContent = require("!!../../../node_modules/css-loader/index.js?modules&localIdentName=[local]---[hash:base64:5]!../../../node_modules/postcss-loader/lib/index.js!../../../node_modules/sass-loader/index.js!./index.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1742 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1197);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(5)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../node_modules/css-loader/index.js?modules&localIdentName=[local]---[hash:base64:5]!../../../node_modules/postcss-loader/lib/index.js!../../../node_modules/sass-loader/index.js!./svg-icon.scss", function() {
			var newContent = require("!!../../../node_modules/css-loader/index.js?modules&localIdentName=[local]---[hash:base64:5]!../../../node_modules/postcss-loader/lib/index.js!../../../node_modules/sass-loader/index.js!./svg-icon.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1743 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1198);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(5)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../node_modules/css-loader/index.js?modules&localIdentName=[local]---[hash:base64:5]!../../../node_modules/postcss-loader/lib/index.js!../../../node_modules/sass-loader/index.js!./index.scss", function() {
			var newContent = require("!!../../../node_modules/css-loader/index.js?modules&localIdentName=[local]---[hash:base64:5]!../../../node_modules/postcss-loader/lib/index.js!../../../node_modules/sass-loader/index.js!./index.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1744 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1199);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(5)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../node_modules/css-loader/index.js?modules&localIdentName=[local]---[hash:base64:5]!../../../node_modules/postcss-loader/lib/index.js!../../../node_modules/sass-loader/index.js!./index.scss", function() {
			var newContent = require("!!../../../node_modules/css-loader/index.js?modules&localIdentName=[local]---[hash:base64:5]!../../../node_modules/postcss-loader/lib/index.js!../../../node_modules/sass-loader/index.js!./index.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1745 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1200);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(5)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../node_modules/css-loader/index.js?modules&localIdentName=[local]---[hash:base64:5]!../../../node_modules/postcss-loader/lib/index.js!../../../node_modules/sass-loader/index.js!./index.scss", function() {
			var newContent = require("!!../../../node_modules/css-loader/index.js?modules&localIdentName=[local]---[hash:base64:5]!../../../node_modules/postcss-loader/lib/index.js!../../../node_modules/sass-loader/index.js!./index.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1746 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1201);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(5)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../node_modules/css-loader/index.js?modules&localIdentName=[local]---[hash:base64:5]!../../../node_modules/postcss-loader/lib/index.js!../../../node_modules/sass-loader/index.js!./index.scss", function() {
			var newContent = require("!!../../../node_modules/css-loader/index.js?modules&localIdentName=[local]---[hash:base64:5]!../../../node_modules/postcss-loader/lib/index.js!../../../node_modules/sass-loader/index.js!./index.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1747 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1202);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(5)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../node_modules/css-loader/index.js?modules&localIdentName=[local]---[hash:base64:5]!../../../node_modules/postcss-loader/lib/index.js!../../../node_modules/sass-loader/index.js!./dropdown-list.scss", function() {
			var newContent = require("!!../../../node_modules/css-loader/index.js?modules&localIdentName=[local]---[hash:base64:5]!../../../node_modules/postcss-loader/lib/index.js!../../../node_modules/sass-loader/index.js!./dropdown-list.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1748 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1203);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(5)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../node_modules/css-loader/index.js?modules&localIdentName=[local]---[hash:base64:5]!../../../node_modules/postcss-loader/lib/index.js!../../../node_modules/sass-loader/index.js!./index.scss", function() {
			var newContent = require("!!../../../node_modules/css-loader/index.js?modules&localIdentName=[local]---[hash:base64:5]!../../../node_modules/postcss-loader/lib/index.js!../../../node_modules/sass-loader/index.js!./index.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1749 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1204);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(5)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../node_modules/css-loader/index.js?modules&localIdentName=[local]---[hash:base64:5]!../../../node_modules/postcss-loader/lib/index.js!../../../node_modules/sass-loader/index.js!./text-input.scss", function() {
			var newContent = require("!!../../../node_modules/css-loader/index.js?modules&localIdentName=[local]---[hash:base64:5]!../../../node_modules/postcss-loader/lib/index.js!../../../node_modules/sass-loader/index.js!./text-input.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1750 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1205);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(5)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../node_modules/css-loader/index.js?modules&localIdentName=[local]---[hash:base64:5]!../../../node_modules/postcss-loader/lib/index.js!../../../node_modules/sass-loader/index.js!./index.scss", function() {
			var newContent = require("!!../../../node_modules/css-loader/index.js?modules&localIdentName=[local]---[hash:base64:5]!../../../node_modules/postcss-loader/lib/index.js!../../../node_modules/sass-loader/index.js!./index.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1751 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1206);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(5)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../node_modules/css-loader/index.js?modules&localIdentName=[local]---[hash:base64:5]!../../../node_modules/postcss-loader/lib/index.js!../../../node_modules/sass-loader/index.js!./index.scss", function() {
			var newContent = require("!!../../../node_modules/css-loader/index.js?modules&localIdentName=[local]---[hash:base64:5]!../../../node_modules/postcss-loader/lib/index.js!../../../node_modules/sass-loader/index.js!./index.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1752 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1207);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(5)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../node_modules/css-loader/index.js?modules&localIdentName=[local]---[hash:base64:5]!../../../node_modules/postcss-loader/lib/index.js!../../../node_modules/sass-loader/index.js!./index.scss", function() {
			var newContent = require("!!../../../node_modules/css-loader/index.js?modules&localIdentName=[local]---[hash:base64:5]!../../../node_modules/postcss-loader/lib/index.js!../../../node_modules/sass-loader/index.js!./index.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1753 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1208);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(5)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../node_modules/css-loader/index.js?modules&localIdentName=[local]---[hash:base64:5]!../../../node_modules/postcss-loader/lib/index.js!../../../node_modules/sass-loader/index.js!./index.scss", function() {
			var newContent = require("!!../../../node_modules/css-loader/index.js?modules&localIdentName=[local]---[hash:base64:5]!../../../node_modules/postcss-loader/lib/index.js!../../../node_modules/sass-loader/index.js!./index.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1754 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1209);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(5)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../node_modules/css-loader/index.js?modules&localIdentName=[local]---[hash:base64:5]!../../../node_modules/postcss-loader/lib/index.js!../../../node_modules/sass-loader/index.js!./index.scss", function() {
			var newContent = require("!!../../../node_modules/css-loader/index.js?modules&localIdentName=[local]---[hash:base64:5]!../../../node_modules/postcss-loader/lib/index.js!../../../node_modules/sass-loader/index.js!./index.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1755 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1210);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(5)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../node_modules/css-loader/index.js?modules&localIdentName=[local]---[hash:base64:5]!../../../node_modules/postcss-loader/lib/index.js!../../../node_modules/sass-loader/index.js!./index.scss", function() {
			var newContent = require("!!../../../node_modules/css-loader/index.js?modules&localIdentName=[local]---[hash:base64:5]!../../../node_modules/postcss-loader/lib/index.js!../../../node_modules/sass-loader/index.js!./index.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1756 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1211);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(5)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../node_modules/css-loader/index.js?modules&localIdentName=[local]---[hash:base64:5]!../../../node_modules/postcss-loader/lib/index.js!../../../node_modules/sass-loader/index.js!./index.scss", function() {
			var newContent = require("!!../../../node_modules/css-loader/index.js?modules&localIdentName=[local]---[hash:base64:5]!../../../node_modules/postcss-loader/lib/index.js!../../../node_modules/sass-loader/index.js!./index.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1757 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1212);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(5)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../node_modules/css-loader/index.js?modules&localIdentName=[local]---[hash:base64:5]!../../../node_modules/postcss-loader/lib/index.js!../../../node_modules/sass-loader/index.js!./index.scss", function() {
			var newContent = require("!!../../../node_modules/css-loader/index.js?modules&localIdentName=[local]---[hash:base64:5]!../../../node_modules/postcss-loader/lib/index.js!../../../node_modules/sass-loader/index.js!./index.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1758 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1213);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(5)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../node_modules/css-loader/index.js?modules&localIdentName=[local]---[hash:base64:5]!../../../node_modules/postcss-loader/lib/index.js!../../../node_modules/sass-loader/index.js!./index.scss", function() {
			var newContent = require("!!../../../node_modules/css-loader/index.js?modules&localIdentName=[local]---[hash:base64:5]!../../../node_modules/postcss-loader/lib/index.js!../../../node_modules/sass-loader/index.js!./index.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1759 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1214);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(5)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../node_modules/css-loader/index.js?modules&localIdentName=[local]---[hash:base64:5]!../../../node_modules/postcss-loader/lib/index.js!../../../node_modules/sass-loader/index.js!./index.scss", function() {
			var newContent = require("!!../../../node_modules/css-loader/index.js?modules&localIdentName=[local]---[hash:base64:5]!../../../node_modules/postcss-loader/lib/index.js!../../../node_modules/sass-loader/index.js!./index.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1760 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1215);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(5)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../node_modules/css-loader/index.js?modules&localIdentName=[local]---[hash:base64:5]!../../../node_modules/postcss-loader/lib/index.js!../../../node_modules/sass-loader/index.js!./index.scss", function() {
			var newContent = require("!!../../../node_modules/css-loader/index.js?modules&localIdentName=[local]---[hash:base64:5]!../../../node_modules/postcss-loader/lib/index.js!../../../node_modules/sass-loader/index.js!./index.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1761 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1216);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(5)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../node_modules/css-loader/index.js?modules&localIdentName=[local]---[hash:base64:5]!../../../node_modules/postcss-loader/lib/index.js!../../../node_modules/sass-loader/index.js!./index.scss", function() {
			var newContent = require("!!../../../node_modules/css-loader/index.js?modules&localIdentName=[local]---[hash:base64:5]!../../../node_modules/postcss-loader/lib/index.js!../../../node_modules/sass-loader/index.js!./index.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1762 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1217);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(5)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../node_modules/css-loader/index.js?modules&localIdentName=[local]---[hash:base64:5]!../../../node_modules/postcss-loader/lib/index.js!../../../node_modules/sass-loader/index.js!./index.scss", function() {
			var newContent = require("!!../../../node_modules/css-loader/index.js?modules&localIdentName=[local]---[hash:base64:5]!../../../node_modules/postcss-loader/lib/index.js!../../../node_modules/sass-loader/index.js!./index.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1763 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1218);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(5)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../node_modules/css-loader/index.js?modules&localIdentName=[local]---[hash:base64:5]!../../../node_modules/postcss-loader/lib/index.js!../../../node_modules/sass-loader/index.js!./index.scss", function() {
			var newContent = require("!!../../../node_modules/css-loader/index.js?modules&localIdentName=[local]---[hash:base64:5]!../../../node_modules/postcss-loader/lib/index.js!../../../node_modules/sass-loader/index.js!./index.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1764 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1219);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(5)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../node_modules/css-loader/index.js?modules&localIdentName=[local]---[hash:base64:5]!../../../node_modules/postcss-loader/lib/index.js!../../../node_modules/sass-loader/index.js!./index.scss", function() {
			var newContent = require("!!../../../node_modules/css-loader/index.js?modules&localIdentName=[local]---[hash:base64:5]!../../../node_modules/postcss-loader/lib/index.js!../../../node_modules/sass-loader/index.js!./index.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1765 */,
/* 1766 */,
/* 1767 */,
/* 1768 */,
/* 1769 */,
/* 1770 */,
/* 1771 */,
/* 1772 */,
/* 1773 */,
/* 1774 */,
/* 1775 */,
/* 1776 */,
/* 1777 */,
/* 1778 */,
/* 1779 */,
/* 1780 */,
/* 1781 */,
/* 1782 */,
/* 1783 */,
/* 1784 */,
/* 1785 */,
/* 1786 */,
/* 1787 */,
/* 1788 */,
/* 1789 */,
/* 1790 */,
/* 1791 */,
/* 1792 */,
/* 1793 */,
/* 1794 */,
/* 1795 */,
/* 1796 */,
/* 1797 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),
/* 1798 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),
/* 1799 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),
/* 1800 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),
/* 1801 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(601);
__webpack_require__(600);
module.exports = __webpack_require__(602);


/***/ })
],[1801]);


// WEBPACK FOOTER //
// entry-app.24589606da0697377f24.js